export const permitsKeyed = {
   "ABC License Verification ": [
      {
         "PERMITID": "ABCL03-017",
         "APN": 46745022,
         "File Number": "ABCL03-017",
         "Address": "150 E SAN CARLOS ST SAN JOSE",
         "Project Name": "ABCL03-017",
         "Application Type": "ABC License Verification ",
         "Application Date": "4/24/03 16:10",
         "Status": "Complete ",
         "Description": "Allow beer and wine sales at an existing pizzeria & ristorante.  ",
         "Planner": "John Davidson ",
         "DURATION": 7,
         "Year": 2003
      },
      {
         "PERMITID": "ABCL03-057",
         "APN": 46723100,
         "File Number": "ABCL03-057",
         "Address": "88 S 4TH ST SAN JOSE",
         "Project Name": "ABCL03-057",
         "Application Type": "ABC License Verification ",
         "Application Date": "10/8/03 14:42",
         "Status": "Complete ",
         "Description": "On-sale for catering/banquet facility on top floor of new parking garage (CP98-054) --- PLEASE ALSO NOTE OLD ADDRESS 44 N. 4TH ST. IN LETTER TO ABC",
         "Planner": "John Davidson ",
         "DURATION": 91,
         "Year": 2003
      },
      {
         "PERMITID": "ABCL03-057",
         "APN": 46723101,
         "File Number": "ABCL03-057",
         "Address": "88 S 4TH ST SAN JOSE",
         "Project Name": "ABCL03-057",
         "Application Type": "ABC License Verification ",
         "Application Date": "10/8/03 14:42",
         "Status": "Complete ",
         "Description": "On-sale for catering/banquet facility on top floor of new parking garage (CP98-054) --- PLEASE ALSO NOTE OLD ADDRESS 44 N. 4TH ST. IN LETTER TO ABC",
         "Planner": "John Davidson ",
         "DURATION": 91,
         "Year": 2003
      },
      {
         "PERMITID": "ABCL03-063",
         "APN": 46745022,
         "File Number": "ABCL03-063",
         "Address": "150 E SAN CARLOS ST SAN JOSE",
         "Project Name": "ABCL03-063",
         "Application Type": "ABC License Verification ",
         "Application Date": "11/14/03 12:02",
         "Status": "Complete ",
         "Description": "ABC Letter for a type 47 license at an existing restaurant.",
         "Planner": "John Davidson ",
         "DURATION": 26,
         "Year": 2003
      },
      {
         "PERMITID": "ABCL03-068",
         "APN": 25947030,
         "File Number": "ABCL03-068",
         "Address": "503 W SAN CARLOS ST SAN JOSE",
         "Project Name": "ABCL03-068",
         "Application Type": "ABC License Verification ",
         "Application Date": "12/15/03 15:27",
         "Status": "Complete ",
         "Description": "TYPE 41 - ON-SALE BEER AND WINE AT A LNC RESTAURANT IN LI \"MUDAI RESTAURANT\"",
         "Planner": "John Davidson ",
         "DURATION": 23,
         "Year": 2003
      },
      {
         "PERMITID": "ABCL04-030",
         "APN": 46722148,
         "File Number": "ABCL04-030",
         "Address": "78 E SANTA CLARA ST SAN JOSE",
         "Project Name": "ABCL04-030",
         "Application Type": "ABC License Verification ",
         "Application Date": "5/21/04 10:20",
         "Status": "Complete ",
         "Description": "A new License Type 48 On-sale General for Public Premises",
         "Planner": "Lesley Xavier ",
         "DURATION": 3,
         "Year": 2004
      },
      {
         "PERMITID": "ABCL04-060",
         "APN": 25947030,
         "File Number": "ABCL04-060",
         "Address": "503 W SAN CARLOS ST SAN JOSE",
         "Project Name": "ABCL04-060",
         "Application Type": "ABC License Verification ",
         "Application Date": "10/7/04 11:05",
         "Status": "Complete ",
         "Description": "Conversion of on-site beer and wine ABC license for public eating place to type 47 ABC license for on-sale general public eating place",
         "Planner": "Jean P. Lin ",
         "DURATION": 15,
         "Year": 2004
      },
      {
         "PERMITID": "ABCL04-067",
         "APN": 46745028,
         "File Number": "ABCL04-067",
         "Address": "312 S 3RD ST SAN JOSE",
         "Project Name": "ABCL04-067",
         "Application Type": "ABC License Verification ",
         "Application Date": "10/26/04 11:31",
         "Status": "Complete ",
         "Description": "This is an ABC Verification Letter application to permit the onsale of beer and wine in conjunction with a restaurant. ",
         "Planner": "Avril Baty ",
         "DURATION": 42,
         "Year": 2004
      },
      {
         "PERMITID": "ABCL04-070",
         "APN": 46746044,
         "File Number": "ABCL04-070",
         "Address": "372 S 1ST ST SAN JOSE",
         "Project Name": "ABCL04-070",
         "Application Type": "ABC License Verification ",
         "Application Date": "11/3/04 10:49",
         "Status": "Complete ",
         "Description": " ",
         "Planner": "Lesley Xavier ",
         "DURATION": 12,
         "Year": 2004
      },
      {
         "PERMITID": "ABCL05-039",
         "APN": 46719075,
         "File Number": "ABCL05-039",
         "Address": "235 E SANTA CLARA ST SAN JOSE",
         "Project Name": "ABCL05-039",
         "Application Type": "ABC License Verification ",
         "Application Date": "6/13/05 16:29",
         "Status": "Complete ",
         "Description": "ABC Verification for on-sale of alcohol incidental to a public eating establishment in Vintage Tower (Taco del Mar). ",
         "Planner": "Dipa Chundur ",
         "DURATION": 52,
         "Year": 2005
      },
      {
         "PERMITID": "ABCL05-039",
         "APN": 46757083,
         "File Number": "ABCL05-039",
         "Address": "235 E SANTA CLARA ST SAN JOSE",
         "Project Name": "ABCL05-039",
         "Application Type": "ABC License Verification ",
         "Application Date": "6/13/05 16:29",
         "Status": "Complete ",
         "Description": "ABC Verification for on-sale of alcohol incidental to a public eating establishment in Vintage Tower (Taco del Mar). ",
         "Planner": "Dipa Chundur ",
         "DURATION": 52,
         "Year": 2005
      },
      {
         "PERMITID": "ABCL05-072",
         "APN": 46721025,
         "File Number": "ABCL05-072",
         "Address": "31 E SANTA CLARA ST SAN JOSE",
         "Project Name": "ABCL05-072",
         "Application Type": "ABC License Verification ",
         "Application Date": "11/16/05 11:36",
         "Status": "Complete ",
         "Description": "Convert type 47 license (on site - rest) to type 48 license (on-sale - general (bar))",
         "Planner": "Caleb Gretton ",
         "DURATION": 13,
         "Year": 2005
      },
      {
         "PERMITID": "ABCL05-076",
         "APN": 25935020,
         "File Number": "ABCL05-076",
         "Address": "225 W SANTA CLARA ST SAN JOSE",
         "Project Name": "ABCL05-076",
         "Application Type": "ABC License Verification ",
         "Application Date": "12/15/05 11:30",
         "Status": "Complete ",
         "Description": "Zoning affidavit for ABC License Verification ",
         "Planner": "Ron Eddow ",
         "DURATION": 20,
         "Year": 2005
      },
      {
         "PERMITID": "ABCL05-077",
         "APN": 46724069,
         "File Number": "ABCL05-077",
         "Address": "304 E SANTA CLARA ST SAN JOSE",
         "Project Name": "ABCL05-077",
         "Application Type": "ABC License Verification ",
         "Application Date": "12/16/05 13:10",
         "Status": "Complete ",
         "Description": "BEER WINE W EATING PLACE LICENSE 41 - SAIGON 75 BISTRO",
         "Planner": "Jerry Yoshida ",
         "DURATION": 69,
         "Year": 2005
      },
      {
         "PERMITID": "ABCL06-001",
         "APN": 46745022,
         "File Number": "ABCL06-001",
         "Address": "150 E SAN CARLOS ST SAN JOSE",
         "Project Name": "ABCL06-001",
         "Application Type": "ABC License Verification ",
         "Application Date": "1/4/06 14:32",
         "Status": "Complete ",
         "Description": "TYPE 47, ON SALE GENERAL BONA FIDE PUBLIC EATING PLACE, ABC VERIFICATION FOR A RESTAURANT, GRANDE PIZZERIA",
         "Planner": "Juan Borrelli ",
         "DURATION": 34,
         "Year": 2006
      },
      {
         "PERMITID": "ABCL06-004",
         "APN": 25945057,
         "File Number": "ABCL06-004",
         "Address": "101 DELMAS AV SAN JOSE",
         "Project Name": "ABCL06-004",
         "Application Type": "ABC License Verification ",
         "Application Date": "1/26/06 13:07",
         "Status": "Complete ",
         "Description": "Renewal of an off-sale liquor license to an existing market ",
         "Planner": "Bill Scott ",
         "DURATION": 96,
         "Year": 2006
      },
      {
         "PERMITID": "ABCL06-029",
         "APN": 25940019,
         "File Number": "ABCL06-029",
         "Address": "167 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "ABCL06-029",
         "Application Type": "ABC License Verification ",
         "Application Date": "6/2/06 16:05",
         "Status": "Complete ",
         "Description": "ABC Zoning verification for a Type 41 - Beer & Wine for a Bona Fide Public Eating Establishment (Haveli Indian Cuisine) on 0.08 gross acres.",
         "Planner": "Allen Tai ",
         "DURATION": 38,
         "Year": 2006
      },
      {
         "PERMITID": "ABCL06-035",
         "APN": 25940086,
         "File Number": "ABCL06-035",
         "Address": "60 S MARKET ST SAN JOSE",
         "Project Name": "ABCL06-035",
         "Application Type": "ABC License Verification ",
         "Application Date": "7/19/06 10:10",
         "Status": "Complete ",
         "Description": "ABC request for Type 48 On-Sale General for Public Premises and Type 20 Off-Sale Beer and Wine at a bar/restaurant.",
         "Planner": "Bill Roth ",
         "DURATION": 1007,
         "Year": 2006
      },
      {
         "PERMITID": "ABCL06-053",
         "APN": 26429118,
         "File Number": "ABCL06-053",
         "Address": "389 S 1ST ST SAN JOSE",
         "Project Name": "ABCL06-053",
         "Application Type": "ABC License Verification ",
         "Application Date": "10/26/06 10:26",
         "Status": "Complete ",
         "Description": "liquor license for a restaurant, 89 Square.",
         "Planner": "Jerry Yoshida ",
         "DURATION": 338,
         "Year": 2006
      },
      {
         "PERMITID": "ABCL06-060",
         "APN": 46746097,
         "File Number": "ABCL06-060",
         "Address": "280 S 2ND ST SAN JOSE",
         "Project Name": "ABCL06-060",
         "Application Type": "ABC License Verification ",
         "Application Date": "12/13/06 17:06",
         "Status": "Complete ",
         "Description": "ABC letter for Comdey Sportz  ",
         "Planner": "Bill Roth ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "ABCL07-004",
         "APN": 25940045,
         "File Number": "ABCL07-004",
         "Address": "37 S 1ST ST SAN JOSE",
         "Project Name": "ABCL07-004",
         "Application Type": "ABC License Verification ",
         "Application Date": "1/22/07 16:47",
         "Status": "Complete ",
         "Description": "ABC Zoning Affidavit for cafe serving beer with food. All on-site sales, no off-site sales. ",
         "Planner": "Jerry Yoshida ",
         "DURATION": 820,
         "Year": 2007
      },
      {
         "PERMITID": "ABCL07-016",
         "APN": 46723069,
         "File Number": "ABCL07-016",
         "Address": "32 S 3RD ST SAN JOSE",
         "Project Name": "ABCL07-016",
         "Application Type": "ABC License Verification ",
         "Application Date": "4/5/07 15:37",
         "Status": "Complete ",
         "Description": "` This is an ABC License Verification Letter application to serve alcohol in a restaurant until 12:00 midnight.",
         "Planner": "Jerry Yoshida ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "ABCL07-029",
         "APN": 46724110,
         "File Number": "ABCL07-029",
         "Address": "1070 S WHITE RD SAN JOSE",
         "Project Name": "ABCL07-029",
         "Application Type": "ABC License Verification ",
         "Application Date": "5/29/07 14:44",
         "Status": "Complete ",
         "Description": "ABCL Zoning Affidavit for license type 41 in a restaurant (Sazon Taqueria) located within a grocery store. (Parking Analysis done - okay.)",
         "Planner": "Ben Corrales ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "ABCL07-030",
         "APN": 46724110,
         "File Number": "ABCL07-030",
         "Address": "272 E SANTA CLARA ST SAN JOSE",
         "Project Name": "ABCL07-030",
         "Application Type": "ABC License Verification ",
         "Application Date": "5/29/07 14:55",
         "Status": "Complete ",
         "Description": "ABC Zoning Affidavit for a type 41 for a restaurant (Sazon Taqueria) to be located within a grocery store. (Parking Analysis done - okay.)",
         "Planner": "Jeff Roche ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "ABCL07-032",
         "APN": 46757083,
         "File Number": "ABCL07-032",
         "Address": "235 E SANTA CLARA ST SAN JOSE",
         "Project Name": "ABCL07-032",
         "Application Type": "ABC License Verification ",
         "Application Date": "6/12/07 9:29",
         "Status": "Complete ",
         "Description": "ABC license verification for a bona-fide eating place, license type 41 - one-sale beer and wine.",
         "Planner": "Lesley Xavier ",
         "DURATION": 6,
         "Year": 2007
      },
      {
         "PERMITID": "ABCL07-036",
         "APN": 26429058,
         "File Number": "ABCL07-036",
         "Address": "325 S 1ST ST SAN JOSE",
         "Project Name": "ABCL07-036",
         "Application Type": "ABC License Verification ",
         "Application Date": "6/22/07 15:42",
         "Status": "Complete ",
         "Description": "ABC license verification letter for type 41 on-sale beer and wine for a bona-fide public eating place.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "ABCL07-039",
         "APN": 25940064,
         "File Number": "ABCL07-039",
         "Address": "25 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "ABCL07-039",
         "Application Type": "ABC License Verification ",
         "Application Date": "7/10/07 8:32",
         "Status": "Complete ",
         "Description": "ABCL Zoning Affidavit for License Type 41 On-Sale Beer & Wine - Public Eating Place for Mezcal, Bistro and Mezcal Bar at 25 West San Fernando Street.",
         "Planner": "Jeff Roche ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "ABCL07-058",
         "APN": 46723100,
         "File Number": "ABCL07-058",
         "Address": "88 S 4TH ST SAN JOSE",
         "Project Name": "ABCL07-058",
         "Application Type": "ABC License Verification ",
         "Application Date": "9/20/07 15:30",
         "Status": "Complete ",
         "Description": "ABC License verification for a bona-fide eating place, License Type 47 (On-Sale for Publi Eating Place.",
         "Planner": "Ben Corrales ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "ABCL07-058",
         "APN": 46723101,
         "File Number": "ABCL07-058",
         "Address": "88 S 4TH ST SAN JOSE",
         "Project Name": "ABCL07-058",
         "Application Type": "ABC License Verification ",
         "Application Date": "9/20/07 15:30",
         "Status": "Complete ",
         "Description": "ABC License verification for a bona-fide eating place, License Type 47 (On-Sale for Publi Eating Place.",
         "Planner": "Ben Corrales ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "ABCL08-012",
         "APN": 46745069,
         "File Number": "ABCL08-012",
         "Address": "345 S 4TH ST SAN JOSE",
         "Project Name": "ABCL08-012",
         "Application Type": "ABC License Verification ",
         "Application Date": "2/22/08 9:13",
         "Status": "Complete ",
         "Description": "ABC Zoning Affidavit for onsale Type 41 Beer and Wine at a Public Eating Establishment. (INDMEX Corporation/ Los Gallos de Villa)",
         "Planner": "Jeff Roche ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "ABCL08-052",
         "APN": 46722158,
         "File Number": "ABCL08-052",
         "Address": "30 E SANTA CLARA ST SAN JOSE",
         "Project Name": "ABCL08-052",
         "Application Type": "ABC License Verification ",
         "Application Date": "8/11/08 9:29",
         "Status": "Complete ",
         "Description": "ABC Zoning Affidavit for Type 41 on-sale beer and wine, for a public eating establishment, Extreme Pizza.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "ABCL08-061",
         "APN": 26429058,
         "File Number": "ABCL08-061",
         "Address": "325 S 1ST ST SAN JOSE",
         "Project Name": "ABCL08-061",
         "Application Type": "ABC License Verification ",
         "Application Date": "9/12/08 14:21",
         "Status": "Complete ",
         "Description": "Zoning Affidavit for Title 41 public eating place at Blue Chip Restaurant, LLC",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "ABCL08-080",
         "APN": 46747089,
         "File Number": "ABCL08-080",
         "Address": "420 S 1ST ST SAN JOSE",
         "Project Name": "ABCL08-080",
         "Application Type": "ABC License Verification ",
         "Application Date": "11/25/08 14:14",
         "Status": "Complete ",
         "Description": "ABC letter for existing restaurant/family entertainment establishment for a property located in the DC-Downtown Core Area. ",
         "Planner": " ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "ABCL08-083",
         "APN": 46764005,
         "File Number": "ABCL08-083",
         "Address": "100 S 2ND ST Unit C-106 SAN JOSE",
         "Project Name": "ABCL08-083",
         "Application Type": "ABC License Verification ",
         "Application Date": "12/10/08 11:48",
         "Status": "Complete ",
         "Description": "Zoning Verification for Obtaining ABC Lincence for a proposed Full Service Grocery Store ",
         "Planner": " ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "ABCL08-083",
         "APN": 46764010,
         "File Number": "ABCL08-083",
         "Address": "100 S 2ND ST Unit C-106 SAN JOSE",
         "Project Name": "ABCL08-083",
         "Application Type": "ABC License Verification ",
         "Application Date": "12/10/08 11:48",
         "Status": "Complete ",
         "Description": "Zoning Verification for Obtaining ABC Lincence for a proposed Full Service Grocery Store ",
         "Planner": " ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "ABCL09-008",
         "APN": 25935056,
         "File Number": "ABCL09-008",
         "Address": "75 N SAN PEDRO ST SAN JOSE",
         "Project Name": "The Old Wagon Saloon & Grill ABCL09-008",
         "Application Type": "ABC License Verification ",
         "Application Date": "1/21/09 12:06",
         "Status": "Complete ",
         "Description": "Zoning verification request for type 47 ABC license for a new restaurant",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "ABCL09-032",
         "APN": 46722110,
         "File Number": "ABCL09-032",
         "Address": "78 S 1ST ST SAN JOSE",
         "Project Name": "ABCL09-032",
         "Application Type": "ABC License Verification ",
         "Application Date": "5/20/09 16:29",
         "Status": "Complete ",
         "Description": "Zoning verififcation requst for Type 41 ABC license in conjunction witha restaurant \"Wow Noodle House\"",
         "Planner": "Mike Enderby ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "ABCL09-072",
         "APN": 25940019,
         "File Number": "ABCL09-072",
         "Address": "167 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "ABCL09-072",
         "Application Type": "ABC License Verification ",
         "Application Date": "12/10/09 13:36",
         "Status": "Complete ",
         "Description": "To obtain zoning affidivite to change Type 41 to Type 47 at an existing restaurant - Nazca Peruvian Cuisine.",
         "Planner": "MNAGARAJ ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "ABCL10-031",
         "APN": 46724069,
         "File Number": "ABCL10-031",
         "Address": "304 E SANTA CLARA ST SAN JOSE",
         "Project Name": "ABCL10-031",
         "Application Type": "ABC License Verification ",
         "Application Date": "4/27/10 9:26",
         "Status": "Complete ",
         "Description": "ABC Verification for on sale beer and wine in conjunction with a full service restaurant.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2010
      },
      {
         "PERMITID": "ABCL10-078",
         "APN": 46724114,
         "File Number": "ABCL10-078",
         "Address": "374 E SANTA CLARA ST SAN JOSE",
         "Project Name": "ABCL10-078",
         "Application Type": "ABC License Verification ",
         "Application Date": "10/1/10 13:10",
         "Status": "Complete ",
         "Description": "ABC VERIFICATION FOR ONSALE TYPE 20 LICENCE (RESTAURANT USE)",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2010
      },
      {
         "PERMITID": "ABCL10-093",
         "APN": 25934018,
         "File Number": "ABCL10-093",
         "Address": "81 W SANTA CLARA ST SAN JOSE",
         "Project Name": "ABCL10-093",
         "Application Type": "ABC License Verification ",
         "Application Date": "11/12/10 15:11",
         "Status": "Complete ",
         "Description": "ABC Verification for on-sale general, type 48, for a drinking establishment with late-night use, as allowed per CP08-043.",
         "Planner": "Mike Enderby ",
         "DURATION": 1,
         "Year": 2010
      },
      {
         "PERMITID": "ABCL11-006",
         "APN": 46723100,
         "File Number": "ABCL11-006",
         "Address": "88 S 4TH ST SAN JOSE",
         "Project Name": "ABCL11-006",
         "Application Type": "ABC License Verification ",
         "Application Date": "1/13/11 15:09",
         "Status": "Complete ",
         "Description": "ABC Verification letter for a Type 47 license for a public eating establishment (Flames).",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2011
      },
      {
         "PERMITID": "ABCL11-006",
         "APN": 46723101,
         "File Number": "ABCL11-006",
         "Address": "88 S 4TH ST SAN JOSE",
         "Project Name": "ABCL11-006",
         "Application Type": "ABC License Verification ",
         "Application Date": "1/13/11 15:09",
         "Status": "Complete ",
         "Description": "ABC Verification letter for a Type 47 license for a public eating establishment (Flames).",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2011
      },
      {
         "PERMITID": "ABCL11-013",
         "APN": 25956002,
         "File Number": "ABCL11-013",
         "Address": "170 S MARKET ST SAN JOSE",
         "Project Name": "ABCL11-013",
         "Application Type": "ABC License Verification ",
         "Application Date": "2/15/11 13:36",
         "Status": "Complete ",
         "Description": "ZONING VERIFICATION FOR ON-SALE BEER AND WINE AS PART OF A PUBLIC EATING ESTABLISHMENT.  ",
         "Planner": "Michael Mena ",
         "DURATION": 113,
         "Year": 2011
      },
      {
         "PERMITID": "ABCL11-017",
         "APN": 25935013,
         "File Number": "ABCL11-017",
         "Address": "87 N SAN PEDRO ST SAN JOSE",
         "Project Name": "ABCL11-017",
         "Application Type": "ABC License Verification ",
         "Application Date": "2/25/11 15:52",
         "Status": "Complete ",
         "Description": "ABC verification for a Type 41 license (beer & wine at a restaurant) with late-night use allowed until 2:00 a.m. per CPA09-054-01.",
         "Planner": "Avril Baty ",
         "DURATION": 1,
         "Year": 2011
      },
      {
         "PERMITID": "ABCL11-028",
         "APN": 46745026,
         "File Number": "ABCL11-028",
         "Address": "304 S 3RD ST SAN JOSE",
         "Project Name": "ABCL11-028",
         "Application Type": "ABC License Verification ",
         "Application Date": "4/25/11 9:20",
         "Status": "Complete ",
         "Description": "ABC Zoning Verification ",
         "Planner": "Susan Walsh ",
         "DURATION": 1,
         "Year": 2011
      },
      {
         "PERMITID": "ABCL11-044",
         "APN": 25935013,
         "File Number": "ABCL11-044",
         "Address": "87 N SAN PEDRO ST SAN JOSE",
         "Project Name": "ABCL11-044",
         "Application Type": "ABC License Verification ",
         "Application Date": "7/1/11 13:15",
         "Status": "Complete ",
         "Description": "ABC LICENSE VERIFICATION FOR TYPE 41 ON-SALE RESTAURANT",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 1,
         "Year": 2011
      },
      {
         "PERMITID": "ABCL11-054",
         "APN": 25941068,
         "File Number": "ABCL11-054",
         "Address": "185 PARK AV SAN JOSE",
         "Project Name": "ABCL11-054",
         "Application Type": "ABC License Verification ",
         "Application Date": "7/28/11 9:09",
         "Status": "Complete ",
         "Description": "ABC Verification ",
         "Planner": "Jeff Roche ",
         "DURATION": 1,
         "Year": 2011
      },
      {
         "PERMITID": "ABCL12-011",
         "APN": 25934028,
         "File Number": "ABCL12-011",
         "Address": "80 N MARKET ST SAN JOSE",
         "Project Name": "ABCL12-011",
         "Application Type": "ABC License Verification ",
         "Application Date": "2/24/12 13:56",
         "Status": "Complete ",
         "Description": "TYPE 41 \"BACK A YARD Carribean American Grill, Inc.\"",
         "Planner": "MNAGARAJ ",
         "DURATION": 1,
         "Year": 2012
      },
      {
         "PERMITID": "ABCL12-014",
         "APN": 46722007,
         "File Number": "ABCL12-014",
         "Address": "52 S 1ST ST SAN JOSE",
         "Project Name": "ABCL12-014",
         "Application Type": "ABC License Verification ",
         "Application Date": "2/28/12 11:05",
         "Status": "Complete ",
         "Description": "ABC License Verification FOR RESTAURANT \"THE TEMPLE\", TYPE 48 PUBLIC PREMISES",
         "Planner": "Suparna Saha ",
         "DURATION": 126,
         "Year": 2012
      },
      {
         "PERMITID": "ABCL12-018",
         "APN": 46722158,
         "File Number": "ABCL12-018",
         "Address": "30 E SANTA CLARA ST SAN JOSE",
         "Project Name": "ABCL12-018 - UNCLE BERNIE'S CHICKEN & FISH",
         "Application Type": "ABC License Verification ",
         "Application Date": "3/12/12 14:40",
         "Status": "Complete ",
         "Description": "ABC Verification ",
         "Planner": "Jeff Roche ",
         "DURATION": 1,
         "Year": 2012
      },
      {
         "PERMITID": "ABCL12-026",
         "APN": 46747011,
         "File Number": "ABCL12-026",
         "Address": "27 E WILLIAM ST SAN JOSE",
         "Project Name": "ABCL12-026",
         "Application Type": "ABC License Verification ",
         "Application Date": "5/16/12 10:56",
         "Status": "Complete ",
         "Description": "ABC license verification for a type 41 license (on-sale beer and wine) for a full service restaurant",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2012
      },
      {
         "PERMITID": "ABCL12-065",
         "APN": 46719075,
         "File Number": "ABCL12-065",
         "Address": "225 E SANTA CLARA ST SAN JOSE",
         "Project Name": "ABCL12-065",
         "Application Type": "ABC License Verification ",
         "Application Date": "8/29/12 15:09",
         "Status": "Complete ",
         "Description": "ABC License verification for on-sale beer and wine at a full service eating establishment ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2012
      },
      {
         "PERMITID": "ABCL13-016",
         "APN": 46745027,
         "File Number": "ABCL13-016",
         "Address": "310 S 3RD ST SAN JOSE",
         "Project Name": "ABCL13-016",
         "Application Type": "ABC License Verification ",
         "Application Date": "2/21/13 14:39",
         "Status": "Complete ",
         "Description": "ABC License verification for a Type 41 License for an existing restaurant, Hydration Cafe",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2013
      },
      {
         "PERMITID": "ABCL13-017",
         "APN": 46722006,
         "File Number": "ABCL13-017",
         "Address": "48 S 1ST ST SAN JOSE",
         "Project Name": "ABCL13-017",
         "Application Type": "ABC License Verification ",
         "Application Date": "2/25/13 11:27",
         "Status": "Complete ",
         "Description": "ABC License verification to change from a Type 41 to a Type 47 License for an existing restaurant, Koji Sake Lounge",
         "Planner": "Lori Moniz ",
         "DURATION": 2,
         "Year": 2013
      },
      {
         "PERMITID": "ABCL13-023",
         "APN": 46722110,
         "File Number": "ABCL13-023",
         "Address": "78 S 1ST ST SAN JOSE",
         "Project Name": "ABCL13-023",
         "Application Type": "ABC License Verification ",
         "Application Date": "3/27/13 10:18",
         "Status": "Complete ",
         "Description": "ABC License Verification for a Type 41 license at a restaurant",
         "Planner": "Lori Moniz ",
         "DURATION": 1,
         "Year": 2013
      },
      {
         "PERMITID": "ABCL13-037",
         "APN": 25935045,
         "File Number": "ABCL13-037",
         "Address": "170 W ST JOHN ST SAN JOSE",
         "Project Name": "ABCL13-037",
         "Application Type": "ABC License Verification ",
         "Application Date": "5/17/13 15:41",
         "Status": "Complete ",
         "Description": "ABC Letter for San Pedro Square Market \"master\" Sidewalk Cafe. ",
         "Planner": "Jan Warne ",
         "DURATION": 3,
         "Year": 2013
      },
      {
         "PERMITID": "ABCL13-058",
         "APN": 26426014,
         "File Number": "ABCL13-058",
         "Address": "387 DELMAS AV SAN JOSE",
         "Project Name": "ABCL13-058",
         "Application Type": "ABC License Verification ",
         "Application Date": "7/22/13 9:45",
         "Status": "Complete ",
         "Description": "Type 41 On-Sale Beer/Wine - Public Eating Place - CP Zoning",
         "Planner": "Lori Moniz ",
         "DURATION": 1,
         "Year": 2013
      },
      {
         "PERMITID": "ABCL13-074",
         "APN": 46722158,
         "File Number": "ABCL13-074",
         "Address": "30 E SANTA CLARA ST SAN JOSE",
         "Project Name": "ABCL13-074 - GARLIC BREAD RESTAURANT",
         "Application Type": "ABC License Verification ",
         "Application Date": "9/20/13 15:38",
         "Status": "Complete ",
         "Description": "ABC license verification for a restaurant ",
         "Planner": " ",
         "DURATION": 4,
         "Year": 2013
      },
      {
         "PERMITID": "ABCL14-015",
         "APN": 25940034,
         "File Number": "ABCL14-015",
         "Address": "84 W SANTA CLARA ST SAN JOSE",
         "Project Name": "ABCL14-015",
         "Application Type": "ABC License Verification ",
         "Application Date": "2/11/14 15:52",
         "Status": "Complete ",
         "Description": "ABC License Verification for a Type 47 - at an event center \"The Glasshouse\"",
         "Planner": " ",
         "DURATION": 14,
         "Year": 2014
      },
      {
         "PERMITID": "ABCL14-073",
         "APN": 47229095,
         "File Number": "ABCL14-073",
         "Address": "515 S 10TH ST SAN JOSE",
         "Project Name": "ABCL14-073",
         "Application Type": "ABC License Verification ",
         "Application Date": "9/30/14 15:16",
         "Status": "Complete ",
         "Description": "ABC License Type 41 for a restaurant",
         "Planner": "Pick ",
         "DURATION": 1,
         "Year": 2014
      },
      {
         "PERMITID": "ABCL14-091",
         "APN": 26429065,
         "File Number": "ABCL14-091",
         "Address": "387 S 1ST ST SAN JOSE",
         "Project Name": "ABCL14-091 - TYPE 41 - KONJOE-TEI RESTAURANT (SUITE 109)",
         "Application Type": "ABC License Verification ",
         "Application Date": "12/5/14 13:35",
         "Status": "Complete ",
         "Description": "ABC License Verification for a Type 41 - On-Sale Beer/Wine - Public Eating Place (KONJOE-TEI)",
         "Planner": "Lori Moniz ",
         "DURATION": 1,
         "Year": 2014
      },
      {
         "PERMITID": "ABCL15-003",
         "APN": 25936039,
         "File Number": "ABCL15-003",
         "Address": "320 W ST JOHN ST SAN JOSE",
         "Project Name": "ABCL15-003",
         "Application Type": "ABC License Verification ",
         "Application Date": "1/13/15 15:49",
         "Status": "Complete ",
         "Description": "ABC Zoning letter for Enoteca La Storia restaurant type 47 liquor license.",
         "Planner": "Pick ",
         "DURATION": 1,
         "Year": 2015
      },
      {
         "PERMITID": "ABCL15-011",
         "APN": 46722141,
         "File Number": "ABCL15-011",
         "Address": "150 S 1ST ST SAN JOSE",
         "Project Name": "ABCL15-011",
         "Application Type": "ABC License Verification ",
         "Application Date": "1/28/15 14:41",
         "Status": "Complete ",
         "Description": " ",
         "Planner": "Pick ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "ABCL15-020",
         "APN": 46722158,
         "File Number": "ABCL15-020",
         "Address": "30 E SANTA CLARA ST SAN JOSE",
         "Project Name": "ABCL15-020",
         "Application Type": "ABC License Verification ",
         "Application Date": "3/3/15 14:54",
         "Status": "Complete ",
         "Description": "ABC letter for Curry Pundits to have a Type 41 license",
         "Planner": "Jan Warne ",
         "DURATION": 1,
         "Year": 2015
      },
      {
         "PERMITID": "ABCL15-025",
         "APN": 46747090,
         "File Number": "ABCL15-025",
         "Address": "400 S 1ST ST SAN JOSE",
         "Project Name": "ABCL15-025",
         "Application Type": "ABC License Verification ",
         "Application Date": "3/25/15 8:43",
         "Status": "Complete ",
         "Description": " ",
         "Planner": "Lea Simvoulakis ",
         "DURATION": 1,
         "Year": 2015
      },
      {
         "PERMITID": "ABCL15-044",
         "APN": 25940084,
         "File Number": "ABCL15-044",
         "Address": "95 S MARKET ST SAN JOSE",
         "Project Name": "ABCL15-044",
         "Application Type": "ABC License Verification ",
         "Application Date": "5/21/15 10:53",
         "Status": "Complete ",
         "Description": "ABC License Verification for Type 41 for a restaurant",
         "Planner": "Pick ",
         "DURATION": 1,
         "Year": 2015
      },
      {
         "PERMITID": "ABCL15-045",
         "APN": 46718090,
         "File Number": "ABCL15-045",
         "Address": "301 E SANTA CLARA ST SAN JOSE",
         "Project Name": "ABCL15-045",
         "Application Type": "ABC License Verification ",
         "Application Date": "6/1/15 14:04",
         "Status": "Complete ",
         "Description": "ABC Verification Letter for Type 41 License (Bistro Noodle)",
         "Planner": "Pick ",
         "DURATION": 1,
         "Year": 2015
      },
      {
         "PERMITID": "ABCL15-080",
         "APN": 25935051,
         "File Number": "ABCL15-080",
         "Address": "71 N SAN PEDRO ST SAN JOSE",
         "Project Name": "ABCL15-080",
         "Application Type": "ABC License Verification ",
         "Application Date": "10/26/15 9:29",
         "Status": "Complete ",
         "Description": "ABC Type 47 at an existing restaurant",
         "Planner": "Pick ",
         "DURATION": 1,
         "Year": 2015
      },
      {
         "PERMITID": "ABCL15-085",
         "APN": 46747042,
         "File Number": "ABCL15-085",
         "Address": "404 S 2ND ST SAN JOSE",
         "Project Name": "ABCL15-085",
         "Application Type": "ABC License Verification ",
         "Application Date": "11/16/15 13:34",
         "Status": "Complete ",
         "Description": "ABC Verification Letter License Type 41 – On-Sale of Alcoholic Beverages (Beer and Wine) for an existing full-service restaurant (SA-BY Thai Cuisine), located at 404 South 2nd Street located in the DC Downtown primary Commercial zoning district.",
         "Planner": "Pick ",
         "DURATION": 1,
         "Year": 2015
      },
      {
         "PERMITID": "ABCL16-003",
         "APN": 46722141,
         "File Number": "ABCL16-003",
         "Address": "150 S 1ST ST SAN JOSE",
         "Project Name": "ABCL16-003",
         "Application Type": "ABC License Verification ",
         "Application Date": "1/8/16 14:15",
         "Status": "Complete ",
         "Description": "ABC License Verification for a Type 47 - On-Sale General for Bona Fide Public Eating Place (Elyse Restaurant) located in the DC Downtown Zoning District.",
         "Planner": "Pick ",
         "DURATION": 1,
         "Year": 2016
      },
      {
         "PERMITID": "ABCL16-071",
         "APN": 26429065,
         "File Number": "ABCL16-071",
         "Address": "387 S 1ST ST SAN JOSE",
         "Project Name": "ABCL16-071",
         "Application Type": "ABC License Verification ",
         "Application Date": "8/15/16 11:34",
         "Status": "Complete ",
         "Description": "ABC Letter for TYPE 41 License at Pizzetta 408 LLC part of SOFA building.",
         "Planner": "MNAGARAJ ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "ABCL16-097",
         "APN": 46722141,
         "File Number": "ABCL16-097",
         "Address": "150 S 1ST ST SAN JOSE",
         "Project Name": "ABCL16-097",
         "Application Type": "ABC License Verification ",
         "Application Date": "10/19/16 13:15",
         "Status": "Complete ",
         "Description": "ABC type 41 for Ipoh Garden Malaysian Delight",
         "Planner": "Jan Warne ",
         "DURATION": 1,
         "Year": 2016
      },
      {
         "PERMITID": "ABCL16-103",
         "APN": 46747089,
         "File Number": "ABCL16-103",
         "Address": "420 S 1ST ST SAN JOSE",
         "Project Name": "ABCL16-103 - Forager",
         "Application Type": "ABC License Verification ",
         "Application Date": "10/28/16 11:36",
         "Status": "Complete ",
         "Description": "(ABCL Lic Type 75 at the \"Brew Pub\") ABCL License Type was changed from Type 75 to Type 41 on 12/13/2016..",
         "Planner": "MNAGARAJ ",
         "DURATION": 1,
         "Year": 2016
      },
      {
         "PERMITID": "ABCL17-049",
         "APN": 46722141,
         "File Number": "ABCL17-049",
         "Address": "150 S 1ST ST SAN JOSE",
         "Project Name": "ABCL17-049",
         "Application Type": "ABC License Verification ",
         "Application Date": "6/16/17 15:40",
         "Status": "Complete ",
         "Description": "ABC verification letter for a restaurant ",
         "Planner": " ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "ABCL17-050",
         "APN": 25940093,
         "File Number": "ABCL17-050",
         "Address": "1 S MARKET ST SAN JOSE",
         "Project Name": "ABCL17-050",
         "Application Type": "ABC License Verification ",
         "Application Date": "6/23/17 8:42",
         "Status": "Complete ",
         "Description": "ABC License Verification Letter for Type 41 On-Sale Beer and Wine for Chipotle Mexican Grill at 1 South Market Street",
         "Planner": " ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "ABCL17-065",
         "APN": 46721025,
         "File Number": "ABCL17-065",
         "Address": "31 E SANTA CLARA ST SAN JOSE",
         "Project Name": "ABCL17-065",
         "Application Type": "ABC License Verification ",
         "Application Date": "8/4/17 16:24",
         "Status": "Complete ",
         "Description": "ABC license for a New Bar (Babylon Square)  ",
         "Planner": " ",
         "DURATION": 125,
         "Year": 2017
      },
      {
         "PERMITID": "ABCL17-110",
         "APN": 46747089,
         "File Number": "ABCL17-110",
         "Address": "420 S 1ST ST SAN JOSE",
         "Project Name": "ABCL17-110 - 420 SOUTH 1ST ST - FORAGER TYPE 47",
         "Application Type": "ABC License Verification ",
         "Application Date": "12/13/17 11:07",
         "Status": "Complete ",
         "Description": "License Type 47 – On-Sale General for a Bona Fide Public Eating Place for Forager Bar and Restaurant",
         "Planner": "Lori Moniz ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "ABCL18-003",
         "APN": 25943075,
         "File Number": "ABCL18-003",
         "Address": "333 W SAN CARLOS ST SAN JOSE",
         "Project Name": "ABCL18-003",
         "Application Type": "ABC License Verification ",
         "Application Date": "1/9/18 16:02",
         "Status": "Complete ",
         "Description": "ABC zoning letter for Type 41 for Erik's Deli Cafe",
         "Planner": " ",
         "DURATION": 1,
         "Year": 2018
      },
      {
         "PERMITID": "ABCL18-007",
         "APN": 46719075,
         "File Number": "ABCL18-007",
         "Address": "225 E SANTA CLARA ST SAN JOSE",
         "Project Name": "ABCL18-007",
         "Application Type": "ABC License Verification ",
         "Application Date": "1/22/18 16:11",
         "Status": "Complete ",
         "Description": "ABC zoning letter for type 41 for Tandoori Fusion Grill",
         "Planner": "Jan Warne ",
         "DURATION": 1,
         "Year": 2018
      },
      {
         "PERMITID": "ABCL18-056",
         "APN": 26426014,
         "File Number": "ABCL18-056",
         "Address": "387 DELMAS AV SAN JOSE",
         "Project Name": "ABCL18-056",
         "Application Type": "ABC License Verification ",
         "Application Date": "7/10/18 15:12",
         "Status": "Complete ",
         "Description": "Public Information Letter for ABC verification of zoning for a Type 41 (Onsale Beer and Wine only) with a Public Eating Establishment (iJAVA COFFEE & EATERY)",
         "Planner": " ",
         "DURATION": 1,
         "Year": 2018
      },
      {
         "PERMITID": "ABCL18-069",
         "APN": 46724009,
         "File Number": "ABCL18-069",
         "Address": "221 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "ABCL18-069",
         "Application Type": "ABC License Verification ",
         "Application Date": "8/21/18 9:28",
         "Status": "Complete ",
         "Description": "ABC zoning verification for Banh Mi Oven to serve Beer & Wine with meals, no take out - Type 41 license",
         "Planner": "Jan Warne ",
         "DURATION": 1,
         "Year": 2018
      },
      {
         "PERMITID": "ABCL18-070",
         "APN": 46757083,
         "File Number": "ABCL18-070",
         "Address": "235 E SANTA CLARA ST SAN JOSE",
         "Project Name": "ABCL18-070",
         "Application Type": "ABC License Verification ",
         "Application Date": "8/27/18 14:59",
         "Status": "Complete ",
         "Description": "ABC verification type 41 for a restaurant",
         "Planner": "Justin Daniels ",
         "DURATION": 1,
         "Year": 2018
      },
      {
         "PERMITID": "ABCL18-089",
         "APN": 25941068,
         "File Number": "ABCL18-089",
         "Address": "185 PARK AV SAN JOSE",
         "Project Name": "ABCL18-089",
         "Application Type": "ABC License Verification ",
         "Application Date": "11/9/18 13:21",
         "Status": "Complete ",
         "Description": "ABC Letter for type 47 license (full on-sale) for a public eating establishment (Peggy Sue's)",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2018
      },
      {
         "PERMITID": "ABCL18-099",
         "APN": 46745030,
         "File Number": "ABCL18-099",
         "Address": "330 S 3RD ST SAN JOSE",
         "Project Name": "ABCL18-099",
         "Application Type": "ABC License Verification ",
         "Application Date": "12/18/18 14:24",
         "Status": "Complete ",
         "Description": "ABC letter for Type 41 onsite bear and wine for Iguanas Burritozilla",
         "Planner": "Jan Warne ",
         "DURATION": 1,
         "Year": 2018
      },
      {
         "PERMITID": "ABCL18-100",
         "APN": 25947030,
         "File Number": "ABCL18-100",
         "Address": "503 W SAN CARLOS ST SAN JOSE",
         "Project Name": "ABCL18-100",
         "Application Type": "ABC License Verification ",
         "Application Date": "12/19/18 13:35",
         "Status": "Complete ",
         "Description": "ABC Zoning letter for Mudai Ethipoian Restaurant for an upgraded ABC license from a Type 41 to 47. This is an LNC use because it is zoned LI. See LNC03-041 for the LNC determination as Legal Non-conforming",
         "Planner": "Jan Warne ",
         "DURATION": 1,
         "Year": 2018
      },
      {
         "PERMITID": "ABCL19-010",
         "APN": 46724069,
         "File Number": "ABCL19-010",
         "Address": "304 E SANTA CLARA ST SAN JOSE",
         "Project Name": "ABCL19-010",
         "Application Type": "ABC License Verification ",
         "Application Date": "3/7/19 14:55",
         "Status": "Complete ",
         "Description": "ABCL for Type 41 license in conjunction with a Public Eating Establishment (TOSTADAS)",
         "Planner": " ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "ABCL19-018",
         "APN": 25934043,
         "File Number": "ABCL19-018",
         "Address": "19 N MARKET ST SAN JOSE",
         "Project Name": "ABCL19-018",
         "Application Type": "ABC License Verification ",
         "Application Date": "4/15/19 10:02",
         "Status": "Complete ",
         "Description": "ABC Letter for type 41 (on-site beer & wine for public eating establishment) for Taco Bell Cantina",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "2011 008669 PI",
         "APN": 25935013,
         "File Number": "2011 008669 PI",
         "Address": "87 N SAN PEDRO ST SAN JOSE",
         "Project Name": "87 SAN PEDRO ST",
         "Application Type": "ABC License Verification ",
         "Application Date": "2/23/11",
         "Status": "New ",
         "Description": " ",
         "Planner": "Mike Enderby ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "ABCL08-070",
         "APN": 26429058,
         "File Number": "ABCL08-070",
         "Address": "325 S 1ST ST SAN JOSE",
         "Project Name": "ABCL08-070",
         "Application Type": "ABC License Verification ",
         "Application Date": "10/31/08 9:44",
         "Status": "Under Review ",
         "Description": "Zoning Affidavit for obtaining Type 47 ABC license for a bonafide public eating place at Blue Chip Restaurant, LLC",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "ABCL11-041",
         "APN": 25956002,
         "File Number": "ABCL11-041",
         "Address": "170 S MARKET ST SAN JOSE",
         "Project Name": "ABCL11-041",
         "Application Type": "ABC License Verification ",
         "Application Date": "6/8/11 9:13",
         "Status": "Under Review ",
         "Description": "TYPE 41, FOR UNIT 110B, BAKERY",
         "Planner": "Avril Baty ",
         "DURATION": 1,
         "Year": 2011
      },
      {
         "PERMITID": "ABCL14-027",
         "APN": 25935051,
         "File Number": "ABCL14-027",
         "Address": "71 N SAN PEDRO ST SAN JOSE",
         "Project Name": "ABCL14-027",
         "Application Type": "ABC License Verification ",
         "Application Date": "3/20/14 13:37",
         "Status": "Under Review ",
         "Description": "ABC Zoning Verification Letter for a bonafide publuc eating place \"71 St. Peter Restaurant\"",
         "Planner": " ",
         "DURATION": 1,
         "Year": 2014
      },
      {
         "PERMITID": "ABCL14-086",
         "APN": 46722141,
         "File Number": "ABCL14-086",
         "Address": "150 S 1ST ST SAN JOSE",
         "Project Name": "ABCL14-086",
         "Application Type": "ABC License Verification ",
         "Application Date": "11/17/14 13:19",
         "Status": "Under Review ",
         "Description": "ABC License Verification for a Type 41 - On-Sale Beer/Wine - Public Eating Place.",
         "Planner": "Pick ",
         "DURATION": 1,
         "Year": 2014
      },
      {
         "PERMITID": "ABCL16-081",
         "APN": 26429065,
         "File Number": "ABCL16-081",
         "Address": "387 S 1ST ST SAN JOSE",
         "Project Name": "ABCL16-081",
         "Application Type": "ABC License Verification ",
         "Application Date": "8/30/16 14:48",
         "Status": "Under Review ",
         "Description": "ABC Letter for TYPE 41 License at Pizzetta 408 LLC part of SOFA building.",
         "Planner": " ",
         "DURATION": 1,
         "Year": 2016
      },
      {
         "PERMITID": "ABCL16-131",
         "APN": 47223122,
         "File Number": "ABCL16-131",
         "Address": "787 S 11TH ST SAN JOSE",
         "Project Name": "ABCL16-131",
         "Application Type": "ABC License Verification ",
         "Application Date": "12/19/16 15:13",
         "Status": "Under Review ",
         "Description": "ABC License Verification letter for a Type 21 - Off-Sale General License (7 Eleven)",
         "Planner": "Armando Lopez ",
         "DURATION": 1,
         "Year": 2016
      },
      {
         "PERMITID": "ABCL18-058",
         "APN": 25935020,
         "File Number": "ABCL18-058",
         "Address": "225 W SANTA CLARA ST SAN JOSE",
         "Project Name": "ABCL18-058",
         "Application Type": "ABC License Verification ",
         "Application Date": "7/16/18 13:12",
         "Status": "Under Review ",
         "Description": "ABC Letter for type 47 license for Opa! Authentic Greek Restaurant",
         "Planner": " ",
         "DURATION": 1,
         "Year": 2018
      },
      {
         "PERMITID": "ABCL18-086",
         "APN": 25940084,
         "File Number": "ABCL18-086",
         "Address": "95 S MARKET ST SAN JOSE",
         "Project Name": "ABCL18-086",
         "Application Type": "ABC License Verification ",
         "Application Date": "11/6/18 11:23",
         "Status": "Under Review ",
         "Description": "Zoning Verification letter for a bona fide eating establishment in Downtown for Type 47.",
         "Planner": " ",
         "DURATION": 1,
         "Year": 2018
      },
      {
         "PERMITID": "ABCL08-037",
         "APN": 25934043,
         "File Number": "ABCL08-037",
         "Address": "19 N MARKET ST SAN JOSE",
         "Project Name": "ABCL08-037 '19MARKET'",
         "Application Type": "ABC License Verification ",
         "Application Date": "6/12/08 10:44",
         "Status": "Withdrawn ",
         "Description": "Zoning affidivite for Type 47",
         "Planner": "Lee Butler ",
         "DURATION": 0,
         "Year": 2008
      }
   ],
   "Addendum / Use of Application ": [
      {
         "PERMITID": "PP03-368",
         "APN": 46701118,
         "File Number": "PP03-368",
         "Address": " ",
         "Project Name": "First Church of Christ Scientist DDA ",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "12/8/03",
         "Status": "Complete ",
         "Description": "Disposition and Development Agreement with Green Valley Corporation for sale of 1.36 acre parcel, development of up to 150 housing units, restoration of historic First Church of Christ Scientist church, and acceptance of 33433 Summary Report",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "PP05-272",
         "APN": 46722142,
         "File Number": "PP05-272",
         "Address": "8 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "PP05-272",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "11/30/05 11:37",
         "Status": "Complete ",
         "Description": "Exclusive negotiating agreement with Living Tomorrow regarding development of Block 2, San Antonio Plaza",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2005
      },
      {
         "PERMITID": "PP06-067",
         "APN": 26427082,
         "File Number": "PP06-067",
         "Address": "180 WOZ WY SAN JOSE",
         "Project Name": "PP06-067 - Children's Discovery Museum",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "4/18/06 11:58",
         "Status": "Complete ",
         "Description": "New 30,000 s.f. outdoor exibit area with a variety of children's educational activities and displays; 12,000 square foot, two-story addition to the existing CDM building, (update when more info available).",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2006
      },
      {
         "PERMITID": "PP06-067",
         "APN": 26427087,
         "File Number": "PP06-067",
         "Address": "180 WOZ WY SAN JOSE",
         "Project Name": "PP06-067 - Children's Discovery Museum",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "4/18/06 11:58",
         "Status": "Complete ",
         "Description": "New 30,000 s.f. outdoor exibit area with a variety of children's educational activities and displays; 12,000 square foot, two-story addition to the existing CDM building, (update when more info available).",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2006
      },
      {
         "PERMITID": "PP06-067",
         "APN": 26427088,
         "File Number": "PP06-067",
         "Address": "180 WOZ WY SAN JOSE",
         "Project Name": "PP06-067 - Children's Discovery Museum",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "4/18/06 11:58",
         "Status": "Complete ",
         "Description": "New 30,000 s.f. outdoor exibit area with a variety of children's educational activities and displays; 12,000 square foot, two-story addition to the existing CDM building, (update when more info available).",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2006
      },
      {
         "PERMITID": "PP06-127",
         "APN": 47233011,
         "File Number": "PP06-127",
         "Address": "0 LAND ONLY SAN JOSE",
         "Project Name": "PP06-127 Olinder Dog Park",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "7/20/06 8:45",
         "Status": "Complete ",
         "Description": "Construction of dog park to include: removal of small scrub trees, gold fines paving, installation of artificial turf, chain link fencing, aggregate base parking, lighting, landscaping and irrigation. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2006
      },
      {
         "PERMITID": "PP07-094",
         "APN": 46722142,
         "File Number": "PP07-094",
         "Address": "8 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "Exclusive Negotiating Agreement with Living Tomorrow California and Mes ",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "5/2/07 9:08",
         "Status": "Complete ",
         "Description": "PP07-094. First amendment to the amended and restated Exclusive Negotiating Agreement with Living Tomorrow California and Mesa San Jose Living for the development of Block 2, San Antonio Plaza",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-279",
         "APN": 46722158,
         "File Number": "PP07-279",
         "Address": "30 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP07-279",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "12/20/07 11:00",
         "Status": "Complete ",
         "Description": "Fourth Amendment to owner participation agreement with Fountain Alley, LLC, for the rehabilitation of buildings located at 27-37 Fountain Alley and 28-40 E.Santa Clara Street.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP08-082",
         "APN": 26427082,
         "File Number": "PP08-082",
         "Address": "180 WOZ WY SAN JOSE",
         "Project Name": "PP08-082 Children Discovery Museum",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "5/13/08 10:23",
         "Status": "Complete ",
         "Description": "Installation of a 4 feet wide by 4 feet deep by 17 feet tall dust collection unit and 2 feet wide by 6 feet deep by 4 feet tall air compressor unit in the service yard of the Children's Discovery Museum.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2008
      },
      {
         "PERMITID": "PP08-082",
         "APN": 26427087,
         "File Number": "PP08-082",
         "Address": "180 WOZ WY SAN JOSE",
         "Project Name": "PP08-082 Children Discovery Museum",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "5/13/08 10:23",
         "Status": "Complete ",
         "Description": "Installation of a 4 feet wide by 4 feet deep by 17 feet tall dust collection unit and 2 feet wide by 6 feet deep by 4 feet tall air compressor unit in the service yard of the Children's Discovery Museum.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2008
      },
      {
         "PERMITID": "PP08-082",
         "APN": 26427088,
         "File Number": "PP08-082",
         "Address": "180 WOZ WY SAN JOSE",
         "Project Name": "PP08-082 Children Discovery Museum",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "5/13/08 10:23",
         "Status": "Complete ",
         "Description": "Installation of a 4 feet wide by 4 feet deep by 17 feet tall dust collection unit and 2 feet wide by 6 feet deep by 4 feet tall air compressor unit in the service yard of the Children's Discovery Museum.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2008
      },
      {
         "PERMITID": "PP08-091",
         "APN": 46722158,
         "File Number": "PP08-091",
         "Address": "30 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP08-091",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "5/16/08 14:34",
         "Status": "Complete ",
         "Description": "Award of a contract for the renovation of Fountain Alley Pedestrian Walk located between North First and North Second Streets. This project includes but not limited to replacement of the existing pavement with a brick paver design and drain with decorative grate; replacement of the building mounted light fixtures with the Acorn (historic-type) light fixtures; replacement of existing string lights, bollards; addition of street furniture (benches and trash cans); and removal of existing but non-function steel elevator doors.  ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2008
      },
      {
         "PERMITID": "PP08-110",
         "APN": 46722142,
         "File Number": "PP08-110",
         "Address": "8 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "PP08-110",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "6/2/08 12:06",
         "Status": "Complete ",
         "Description": "Exclusive Negotiating Agreement with Mesa Building II, LLC for the proposed sale and development of Block 2 site.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2008
      },
      {
         "PERMITID": "PP08-158",
         "APN": 46723010,
         "File Number": "PP08-158",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP08-158 - NCH HVAC",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "7/24/08 11:21",
         "Status": "Complete ",
         "Description": "City Hall Emergency Chiller Installation project for the installation of a new standby emergency air cooled chiller, chilled water pumps, accessories, associated piping & 3-way butterfly valves for emergency chiller operation, a chiller structural steel platform, associated electrical connections and a roof screen enclosure.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2008
      },
      {
         "PERMITID": "PP08-158",
         "APN": 46723011,
         "File Number": "PP08-158",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP08-158 - NCH HVAC",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "7/24/08 11:21",
         "Status": "Complete ",
         "Description": "City Hall Emergency Chiller Installation project for the installation of a new standby emergency air cooled chiller, chilled water pumps, accessories, associated piping & 3-way butterfly valves for emergency chiller operation, a chiller structural steel platform, associated electrical connections and a roof screen enclosure.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2008
      },
      {
         "PERMITID": "PP08-158",
         "APN": 46723013,
         "File Number": "PP08-158",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP08-158 - NCH HVAC",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "7/24/08 11:21",
         "Status": "Complete ",
         "Description": "City Hall Emergency Chiller Installation project for the installation of a new standby emergency air cooled chiller, chilled water pumps, accessories, associated piping & 3-way butterfly valves for emergency chiller operation, a chiller structural steel platform, associated electrical connections and a roof screen enclosure.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2008
      },
      {
         "PERMITID": "PP08-158",
         "APN": 46723017,
         "File Number": "PP08-158",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP08-158 - NCH HVAC",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "7/24/08 11:21",
         "Status": "Complete ",
         "Description": "City Hall Emergency Chiller Installation project for the installation of a new standby emergency air cooled chiller, chilled water pumps, accessories, associated piping & 3-way butterfly valves for emergency chiller operation, a chiller structural steel platform, associated electrical connections and a roof screen enclosure.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2008
      },
      {
         "PERMITID": "PP08-158",
         "APN": 46723018,
         "File Number": "PP08-158",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP08-158 - NCH HVAC",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "7/24/08 11:21",
         "Status": "Complete ",
         "Description": "City Hall Emergency Chiller Installation project for the installation of a new standby emergency air cooled chiller, chilled water pumps, accessories, associated piping & 3-way butterfly valves for emergency chiller operation, a chiller structural steel platform, associated electrical connections and a roof screen enclosure.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2008
      },
      {
         "PERMITID": "PP08-158",
         "APN": 46723019,
         "File Number": "PP08-158",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP08-158 - NCH HVAC",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "7/24/08 11:21",
         "Status": "Complete ",
         "Description": "City Hall Emergency Chiller Installation project for the installation of a new standby emergency air cooled chiller, chilled water pumps, accessories, associated piping & 3-way butterfly valves for emergency chiller operation, a chiller structural steel platform, associated electrical connections and a roof screen enclosure.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2008
      },
      {
         "PERMITID": "PP08-158",
         "APN": 46723021,
         "File Number": "PP08-158",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP08-158 - NCH HVAC",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "7/24/08 11:21",
         "Status": "Complete ",
         "Description": "City Hall Emergency Chiller Installation project for the installation of a new standby emergency air cooled chiller, chilled water pumps, accessories, associated piping & 3-way butterfly valves for emergency chiller operation, a chiller structural steel platform, associated electrical connections and a roof screen enclosure.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2008
      },
      {
         "PERMITID": "PP08-158",
         "APN": 46723022,
         "File Number": "PP08-158",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP08-158 - NCH HVAC",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "7/24/08 11:21",
         "Status": "Complete ",
         "Description": "City Hall Emergency Chiller Installation project for the installation of a new standby emergency air cooled chiller, chilled water pumps, accessories, associated piping & 3-way butterfly valves for emergency chiller operation, a chiller structural steel platform, associated electrical connections and a roof screen enclosure.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2008
      },
      {
         "PERMITID": "PP08-158",
         "APN": 46723076,
         "File Number": "PP08-158",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP08-158 - NCH HVAC",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "7/24/08 11:21",
         "Status": "Complete ",
         "Description": "City Hall Emergency Chiller Installation project for the installation of a new standby emergency air cooled chiller, chilled water pumps, accessories, associated piping & 3-way butterfly valves for emergency chiller operation, a chiller structural steel platform, associated electrical connections and a roof screen enclosure.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2008
      },
      {
         "PERMITID": "PP08-158",
         "APN": 46724001,
         "File Number": "PP08-158",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP08-158 - NCH HVAC",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "7/24/08 11:21",
         "Status": "Complete ",
         "Description": "City Hall Emergency Chiller Installation project for the installation of a new standby emergency air cooled chiller, chilled water pumps, accessories, associated piping & 3-way butterfly valves for emergency chiller operation, a chiller structural steel platform, associated electrical connections and a roof screen enclosure.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2008
      },
      {
         "PERMITID": "PP08-158",
         "APN": 46724002,
         "File Number": "PP08-158",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP08-158 - NCH HVAC",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "7/24/08 11:21",
         "Status": "Complete ",
         "Description": "City Hall Emergency Chiller Installation project for the installation of a new standby emergency air cooled chiller, chilled water pumps, accessories, associated piping & 3-way butterfly valves for emergency chiller operation, a chiller structural steel platform, associated electrical connections and a roof screen enclosure.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2008
      },
      {
         "PERMITID": "PP08-158",
         "APN": 46724003,
         "File Number": "PP08-158",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP08-158 - NCH HVAC",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "7/24/08 11:21",
         "Status": "Complete ",
         "Description": "City Hall Emergency Chiller Installation project for the installation of a new standby emergency air cooled chiller, chilled water pumps, accessories, associated piping & 3-way butterfly valves for emergency chiller operation, a chiller structural steel platform, associated electrical connections and a roof screen enclosure.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2008
      },
      {
         "PERMITID": "PP08-158",
         "APN": 46724014,
         "File Number": "PP08-158",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP08-158 - NCH HVAC",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "7/24/08 11:21",
         "Status": "Complete ",
         "Description": "City Hall Emergency Chiller Installation project for the installation of a new standby emergency air cooled chiller, chilled water pumps, accessories, associated piping & 3-way butterfly valves for emergency chiller operation, a chiller structural steel platform, associated electrical connections and a roof screen enclosure.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2008
      },
      {
         "PERMITID": "PP08-158",
         "APN": 46724015,
         "File Number": "PP08-158",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP08-158 - NCH HVAC",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "7/24/08 11:21",
         "Status": "Complete ",
         "Description": "City Hall Emergency Chiller Installation project for the installation of a new standby emergency air cooled chiller, chilled water pumps, accessories, associated piping & 3-way butterfly valves for emergency chiller operation, a chiller structural steel platform, associated electrical connections and a roof screen enclosure.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2008
      },
      {
         "PERMITID": "PP08-158",
         "APN": 46724016,
         "File Number": "PP08-158",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP08-158 - NCH HVAC",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "7/24/08 11:21",
         "Status": "Complete ",
         "Description": "City Hall Emergency Chiller Installation project for the installation of a new standby emergency air cooled chiller, chilled water pumps, accessories, associated piping & 3-way butterfly valves for emergency chiller operation, a chiller structural steel platform, associated electrical connections and a roof screen enclosure.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2008
      },
      {
         "PERMITID": "PP08-158",
         "APN": 46724019,
         "File Number": "PP08-158",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP08-158 - NCH HVAC",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "7/24/08 11:21",
         "Status": "Complete ",
         "Description": "City Hall Emergency Chiller Installation project for the installation of a new standby emergency air cooled chiller, chilled water pumps, accessories, associated piping & 3-way butterfly valves for emergency chiller operation, a chiller structural steel platform, associated electrical connections and a roof screen enclosure.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2008
      },
      {
         "PERMITID": "PP08-158",
         "APN": 46724020,
         "File Number": "PP08-158",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP08-158 - NCH HVAC",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "7/24/08 11:21",
         "Status": "Complete ",
         "Description": "City Hall Emergency Chiller Installation project for the installation of a new standby emergency air cooled chiller, chilled water pumps, accessories, associated piping & 3-way butterfly valves for emergency chiller operation, a chiller structural steel platform, associated electrical connections and a roof screen enclosure.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2008
      },
      {
         "PERMITID": "PP08-158",
         "APN": 46724021,
         "File Number": "PP08-158",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP08-158 - NCH HVAC",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "7/24/08 11:21",
         "Status": "Complete ",
         "Description": "City Hall Emergency Chiller Installation project for the installation of a new standby emergency air cooled chiller, chilled water pumps, accessories, associated piping & 3-way butterfly valves for emergency chiller operation, a chiller structural steel platform, associated electrical connections and a roof screen enclosure.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2008
      },
      {
         "PERMITID": "PP08-158",
         "APN": 46724115,
         "File Number": "PP08-158",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP08-158 - NCH HVAC",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "7/24/08 11:21",
         "Status": "Complete ",
         "Description": "City Hall Emergency Chiller Installation project for the installation of a new standby emergency air cooled chiller, chilled water pumps, accessories, associated piping & 3-way butterfly valves for emergency chiller operation, a chiller structural steel platform, associated electrical connections and a roof screen enclosure.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2008
      },
      {
         "PERMITID": "PP08-158",
         "APN": 46724117,
         "File Number": "PP08-158",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP08-158 - NCH HVAC",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "7/24/08 11:21",
         "Status": "Complete ",
         "Description": "City Hall Emergency Chiller Installation project for the installation of a new standby emergency air cooled chiller, chilled water pumps, accessories, associated piping & 3-way butterfly valves for emergency chiller operation, a chiller structural steel platform, associated electrical connections and a roof screen enclosure.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2008
      },
      {
         "PERMITID": "PP09-025",
         "APN": 25940043,
         "File Number": "PP09-025",
         "Address": "27 S 1ST ST SAN JOSE",
         "Project Name": "PP09-025",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "2/9/09 10:17",
         "Status": "Complete ",
         "Description": "First amendment to the Disposition and Development Agreement with Black Sea Gallery Development. The amendment will facilitate the execution of a lease agreement for a retail store at this location. No physical improvements are proposed to the exterior of the building at this time.  ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PP09-073",
         "APN": 25940043,
         "File Number": "PP09-073",
         "Address": "27 S 1ST ST SAN JOSE",
         "Project Name": "PP09-073",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "4/2/09 16:18",
         "Status": "Complete ",
         "Description": "Owner Participation Agreement (OPA) with Black Sea Gallery Development, LLC to facilitate the occupancy of Ross Dress for Less at the above location. No physical improvements are proposed to the exterior of the building at this time. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PP09-089",
         "APN": 46723010,
         "File Number": "PP09-089",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP09-089",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "4/20/09 13:53",
         "Status": "Complete ",
         "Description": "Installation of additional radio and cellular distribution antennas on the interior of each City Hall Tower floor and in the underground garage to supplement existing antennas for the purpose of providing clear communication for public safety. Two new antennas would be added to the south west corner of the roof. The height and size would match the existing roof top antennas. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PP09-089",
         "APN": 46723011,
         "File Number": "PP09-089",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP09-089",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "4/20/09 13:53",
         "Status": "Complete ",
         "Description": "Installation of additional radio and cellular distribution antennas on the interior of each City Hall Tower floor and in the underground garage to supplement existing antennas for the purpose of providing clear communication for public safety. Two new antennas would be added to the south west corner of the roof. The height and size would match the existing roof top antennas. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PP09-089",
         "APN": 46723013,
         "File Number": "PP09-089",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP09-089",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "4/20/09 13:53",
         "Status": "Complete ",
         "Description": "Installation of additional radio and cellular distribution antennas on the interior of each City Hall Tower floor and in the underground garage to supplement existing antennas for the purpose of providing clear communication for public safety. Two new antennas would be added to the south west corner of the roof. The height and size would match the existing roof top antennas. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PP09-089",
         "APN": 46723017,
         "File Number": "PP09-089",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP09-089",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "4/20/09 13:53",
         "Status": "Complete ",
         "Description": "Installation of additional radio and cellular distribution antennas on the interior of each City Hall Tower floor and in the underground garage to supplement existing antennas for the purpose of providing clear communication for public safety. Two new antennas would be added to the south west corner of the roof. The height and size would match the existing roof top antennas. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PP09-089",
         "APN": 46723018,
         "File Number": "PP09-089",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP09-089",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "4/20/09 13:53",
         "Status": "Complete ",
         "Description": "Installation of additional radio and cellular distribution antennas on the interior of each City Hall Tower floor and in the underground garage to supplement existing antennas for the purpose of providing clear communication for public safety. Two new antennas would be added to the south west corner of the roof. The height and size would match the existing roof top antennas. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PP09-089",
         "APN": 46723019,
         "File Number": "PP09-089",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP09-089",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "4/20/09 13:53",
         "Status": "Complete ",
         "Description": "Installation of additional radio and cellular distribution antennas on the interior of each City Hall Tower floor and in the underground garage to supplement existing antennas for the purpose of providing clear communication for public safety. Two new antennas would be added to the south west corner of the roof. The height and size would match the existing roof top antennas. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PP09-089",
         "APN": 46723021,
         "File Number": "PP09-089",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP09-089",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "4/20/09 13:53",
         "Status": "Complete ",
         "Description": "Installation of additional radio and cellular distribution antennas on the interior of each City Hall Tower floor and in the underground garage to supplement existing antennas for the purpose of providing clear communication for public safety. Two new antennas would be added to the south west corner of the roof. The height and size would match the existing roof top antennas. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PP09-089",
         "APN": 46723022,
         "File Number": "PP09-089",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP09-089",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "4/20/09 13:53",
         "Status": "Complete ",
         "Description": "Installation of additional radio and cellular distribution antennas on the interior of each City Hall Tower floor and in the underground garage to supplement existing antennas for the purpose of providing clear communication for public safety. Two new antennas would be added to the south west corner of the roof. The height and size would match the existing roof top antennas. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PP09-089",
         "APN": 46723076,
         "File Number": "PP09-089",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP09-089",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "4/20/09 13:53",
         "Status": "Complete ",
         "Description": "Installation of additional radio and cellular distribution antennas on the interior of each City Hall Tower floor and in the underground garage to supplement existing antennas for the purpose of providing clear communication for public safety. Two new antennas would be added to the south west corner of the roof. The height and size would match the existing roof top antennas. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PP09-089",
         "APN": 46724001,
         "File Number": "PP09-089",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP09-089",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "4/20/09 13:53",
         "Status": "Complete ",
         "Description": "Installation of additional radio and cellular distribution antennas on the interior of each City Hall Tower floor and in the underground garage to supplement existing antennas for the purpose of providing clear communication for public safety. Two new antennas would be added to the south west corner of the roof. The height and size would match the existing roof top antennas. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PP09-089",
         "APN": 46724002,
         "File Number": "PP09-089",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP09-089",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "4/20/09 13:53",
         "Status": "Complete ",
         "Description": "Installation of additional radio and cellular distribution antennas on the interior of each City Hall Tower floor and in the underground garage to supplement existing antennas for the purpose of providing clear communication for public safety. Two new antennas would be added to the south west corner of the roof. The height and size would match the existing roof top antennas. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PP09-089",
         "APN": 46724003,
         "File Number": "PP09-089",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP09-089",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "4/20/09 13:53",
         "Status": "Complete ",
         "Description": "Installation of additional radio and cellular distribution antennas on the interior of each City Hall Tower floor and in the underground garage to supplement existing antennas for the purpose of providing clear communication for public safety. Two new antennas would be added to the south west corner of the roof. The height and size would match the existing roof top antennas. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PP09-089",
         "APN": 46724014,
         "File Number": "PP09-089",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP09-089",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "4/20/09 13:53",
         "Status": "Complete ",
         "Description": "Installation of additional radio and cellular distribution antennas on the interior of each City Hall Tower floor and in the underground garage to supplement existing antennas for the purpose of providing clear communication for public safety. Two new antennas would be added to the south west corner of the roof. The height and size would match the existing roof top antennas. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PP09-089",
         "APN": 46724015,
         "File Number": "PP09-089",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP09-089",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "4/20/09 13:53",
         "Status": "Complete ",
         "Description": "Installation of additional radio and cellular distribution antennas on the interior of each City Hall Tower floor and in the underground garage to supplement existing antennas for the purpose of providing clear communication for public safety. Two new antennas would be added to the south west corner of the roof. The height and size would match the existing roof top antennas. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PP09-089",
         "APN": 46724016,
         "File Number": "PP09-089",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP09-089",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "4/20/09 13:53",
         "Status": "Complete ",
         "Description": "Installation of additional radio and cellular distribution antennas on the interior of each City Hall Tower floor and in the underground garage to supplement existing antennas for the purpose of providing clear communication for public safety. Two new antennas would be added to the south west corner of the roof. The height and size would match the existing roof top antennas. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PP09-089",
         "APN": 46724019,
         "File Number": "PP09-089",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP09-089",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "4/20/09 13:53",
         "Status": "Complete ",
         "Description": "Installation of additional radio and cellular distribution antennas on the interior of each City Hall Tower floor and in the underground garage to supplement existing antennas for the purpose of providing clear communication for public safety. Two new antennas would be added to the south west corner of the roof. The height and size would match the existing roof top antennas. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PP09-089",
         "APN": 46724020,
         "File Number": "PP09-089",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP09-089",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "4/20/09 13:53",
         "Status": "Complete ",
         "Description": "Installation of additional radio and cellular distribution antennas on the interior of each City Hall Tower floor and in the underground garage to supplement existing antennas for the purpose of providing clear communication for public safety. Two new antennas would be added to the south west corner of the roof. The height and size would match the existing roof top antennas. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PP09-089",
         "APN": 46724021,
         "File Number": "PP09-089",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP09-089",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "4/20/09 13:53",
         "Status": "Complete ",
         "Description": "Installation of additional radio and cellular distribution antennas on the interior of each City Hall Tower floor and in the underground garage to supplement existing antennas for the purpose of providing clear communication for public safety. Two new antennas would be added to the south west corner of the roof. The height and size would match the existing roof top antennas. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PP09-089",
         "APN": 46724115,
         "File Number": "PP09-089",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP09-089",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "4/20/09 13:53",
         "Status": "Complete ",
         "Description": "Installation of additional radio and cellular distribution antennas on the interior of each City Hall Tower floor and in the underground garage to supplement existing antennas for the purpose of providing clear communication for public safety. Two new antennas would be added to the south west corner of the roof. The height and size would match the existing roof top antennas. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PP09-089",
         "APN": 46724117,
         "File Number": "PP09-089",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP09-089",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "4/20/09 13:53",
         "Status": "Complete ",
         "Description": "Installation of additional radio and cellular distribution antennas on the interior of each City Hall Tower floor and in the underground garage to supplement existing antennas for the purpose of providing clear communication for public safety. Two new antennas would be added to the south west corner of the roof. The height and size would match the existing roof top antennas. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PP09-135",
         "APN": 26427082,
         "File Number": "PP09-135",
         "Address": "180 WOZ WY SAN JOSE",
         "Project Name": "PP09-135",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "6/8/09 14:30",
         "Status": "Complete ",
         "Description": "Owner Participation Agreement (OPA) with the Children's Discovery Museum for renovation and construction of improvements to the existing museum building. Clearance is for the OPA only. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PP09-135",
         "APN": 26427087,
         "File Number": "PP09-135",
         "Address": "180 WOZ WY SAN JOSE",
         "Project Name": "PP09-135",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "6/8/09 14:30",
         "Status": "Complete ",
         "Description": "Owner Participation Agreement (OPA) with the Children's Discovery Museum for renovation and construction of improvements to the existing museum building. Clearance is for the OPA only. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PP09-135",
         "APN": 26427088,
         "File Number": "PP09-135",
         "Address": "180 WOZ WY SAN JOSE",
         "Project Name": "PP09-135",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "6/8/09 14:30",
         "Status": "Complete ",
         "Description": "Owner Participation Agreement (OPA) with the Children's Discovery Museum for renovation and construction of improvements to the existing museum building. Clearance is for the OPA only. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PP09-141",
         "APN": 25940071,
         "File Number": "PP09-141",
         "Address": "96 S ALMADEN AV SAN JOSE",
         "Project Name": "PP09-141",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "6/23/09 13:53",
         "Status": "Complete ",
         "Description": "Construction of about 320 feet of new sidewalk that includes curbs, gutter, three driveways and storm drain inlet to connect to existing manhole along Aborn Road between Towers Lane and Stallion Way.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PP09-204",
         "APN": 46720082,
         "File Number": "PP09-204",
         "Address": "179 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP09-204",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "11/17/09 13:54",
         "Status": "Complete ",
         "Description": "Green Vision Education and Demonstration Center Grant Agreement and demonstration project. This two-year Addendum expires on November 17, 2011.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PP10-006",
         "APN": 46752006,
         "File Number": "PP10-006",
         "Address": "1 WASHINGTON SQ SAN JOSE",
         "Project Name": "PP10-006 - SBWR for SJSU",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "1/19/10 16:37",
         "Status": "Complete ",
         "Description": "South Bay Water Recycling Phase 1C Improvements at San Jose State University Project for the conversion of portions of the San Jose State University campus to irrigation with recycled water, including the installation of approximately 575 linear feet of 6-inch recycled water pipeline to connect to the Student Union Building; installation of approximately 400 linear feet of 6-inch recycled water pipeline to connect to the Student Health Center building; interior modifications of the plumbing system at the Martin Luther King Jr. Library to allow for use of recycled water for indoor plumbing; installation of a 1,000 gallon recycled water storage tank/break tank on an existing concrete pad and transfer pumps in the existing Central Plant yard to serve the Central Plant for steam heating; and various minor above ground work such as replacement of existing valves and installation of minor plumbing equipment. Typical pipeline depths will be approximately four feet deep. No trees will be removed or disturbed by this project.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2010
      },
      {
         "PERMITID": "PP10-079",
         "APN": 25942023,
         "File Number": "PP10-079",
         "Address": "201 S MARKET ST SAN JOSE",
         "Project Name": "PP10-079 - Civic Auditorium",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "4/15/10 14:36",
         "Status": "Complete ",
         "Description": "Civic Auditorium Phase 2 Improvement project for structural upgrades, installation of a new ADA compliant elevator that will serve both the Civic Auditorium and Montgomery Theatre, build-out of concessions (these are existing spaces that will be outfitted with concessions equipment), and completion of other ADA improvements. The elevator will be located in the Montgomery Theatre interior area currently occupied by the existing light & sound booth, which will be relocated into existing interior space in the Montgomery Theater. All work will be carried out with respect for the traditional architecture of the facility and its context in the urban setting, with finishes and materials to match the existing building.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2010
      },
      {
         "PERMITID": "PP11-098",
         "APN": 47233011,
         "File Number": "PP11-098",
         "Address": " ",
         "Project Name": "PP11-098",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "11/14/11 11:06",
         "Status": "Complete ",
         "Description": "Citywide Large Trash Capture Device Installation Project for the installation of eight new manhole Hydro Dynamic Separators (HDS) from 20 to 30 feet in depth at various locations throughout the City within the public right-of-way or on City property. The purpose of the project is to provide a mechanical system for removing trash and debris from storm water before it enters the storm water creek drainage system. No trees or riparian vegetation will be removed or disturbed by the project. All HDS units, construction activities, materials, equipment storage and staging areas will be located at least 100 feet from the top of bank of any creek, or from the edge of the creek's riparian vegetation, whichever is greater. No erosion runoff or construction materials will be allowed to enter any creek This CEQA clearance will expire on November ??, 2016.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "2012 010075 PP",
         "APN": 46723010,
         "File Number": "2012 010075 PP",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "4/2/12",
         "Status": "New ",
         "Description": "Revisions to the City of San Jose Sign Ordinance (Title 23)",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2012
      },
      {
         "PERMITID": "2012 010075 PP",
         "APN": 46723011,
         "File Number": "2012 010075 PP",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "4/2/12",
         "Status": "New ",
         "Description": "Revisions to the City of San Jose Sign Ordinance (Title 23)",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2012
      },
      {
         "PERMITID": "2012 010075 PP",
         "APN": 46723013,
         "File Number": "2012 010075 PP",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "4/2/12",
         "Status": "New ",
         "Description": "Revisions to the City of San Jose Sign Ordinance (Title 23)",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2012
      },
      {
         "PERMITID": "2012 010075 PP",
         "APN": 46723017,
         "File Number": "2012 010075 PP",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "4/2/12",
         "Status": "New ",
         "Description": "Revisions to the City of San Jose Sign Ordinance (Title 23)",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2012
      },
      {
         "PERMITID": "2012 010075 PP",
         "APN": 46723018,
         "File Number": "2012 010075 PP",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "4/2/12",
         "Status": "New ",
         "Description": "Revisions to the City of San Jose Sign Ordinance (Title 23)",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2012
      },
      {
         "PERMITID": "2012 010075 PP",
         "APN": 46723019,
         "File Number": "2012 010075 PP",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "4/2/12",
         "Status": "New ",
         "Description": "Revisions to the City of San Jose Sign Ordinance (Title 23)",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2012
      },
      {
         "PERMITID": "2012 010075 PP",
         "APN": 46723021,
         "File Number": "2012 010075 PP",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "4/2/12",
         "Status": "New ",
         "Description": "Revisions to the City of San Jose Sign Ordinance (Title 23)",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2012
      },
      {
         "PERMITID": "2012 010075 PP",
         "APN": 46723022,
         "File Number": "2012 010075 PP",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "4/2/12",
         "Status": "New ",
         "Description": "Revisions to the City of San Jose Sign Ordinance (Title 23)",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2012
      },
      {
         "PERMITID": "2012 010075 PP",
         "APN": 46723076,
         "File Number": "2012 010075 PP",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "4/2/12",
         "Status": "New ",
         "Description": "Revisions to the City of San Jose Sign Ordinance (Title 23)",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2012
      },
      {
         "PERMITID": "2012 010075 PP",
         "APN": 46724001,
         "File Number": "2012 010075 PP",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "4/2/12",
         "Status": "New ",
         "Description": "Revisions to the City of San Jose Sign Ordinance (Title 23)",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2012
      },
      {
         "PERMITID": "2012 010075 PP",
         "APN": 46724002,
         "File Number": "2012 010075 PP",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "4/2/12",
         "Status": "New ",
         "Description": "Revisions to the City of San Jose Sign Ordinance (Title 23)",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2012
      },
      {
         "PERMITID": "2012 010075 PP",
         "APN": 46724003,
         "File Number": "2012 010075 PP",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "4/2/12",
         "Status": "New ",
         "Description": "Revisions to the City of San Jose Sign Ordinance (Title 23)",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2012
      },
      {
         "PERMITID": "2012 010075 PP",
         "APN": 46724014,
         "File Number": "2012 010075 PP",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "4/2/12",
         "Status": "New ",
         "Description": "Revisions to the City of San Jose Sign Ordinance (Title 23)",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2012
      },
      {
         "PERMITID": "2012 010075 PP",
         "APN": 46724015,
         "File Number": "2012 010075 PP",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "4/2/12",
         "Status": "New ",
         "Description": "Revisions to the City of San Jose Sign Ordinance (Title 23)",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2012
      },
      {
         "PERMITID": "2012 010075 PP",
         "APN": 46724016,
         "File Number": "2012 010075 PP",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "4/2/12",
         "Status": "New ",
         "Description": "Revisions to the City of San Jose Sign Ordinance (Title 23)",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2012
      },
      {
         "PERMITID": "2012 010075 PP",
         "APN": 46724019,
         "File Number": "2012 010075 PP",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "4/2/12",
         "Status": "New ",
         "Description": "Revisions to the City of San Jose Sign Ordinance (Title 23)",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2012
      },
      {
         "PERMITID": "2012 010075 PP",
         "APN": 46724020,
         "File Number": "2012 010075 PP",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "4/2/12",
         "Status": "New ",
         "Description": "Revisions to the City of San Jose Sign Ordinance (Title 23)",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2012
      },
      {
         "PERMITID": "2012 010075 PP",
         "APN": 46724021,
         "File Number": "2012 010075 PP",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "4/2/12",
         "Status": "New ",
         "Description": "Revisions to the City of San Jose Sign Ordinance (Title 23)",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2012
      },
      {
         "PERMITID": "2012 010075 PP",
         "APN": 46724115,
         "File Number": "2012 010075 PP",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "4/2/12",
         "Status": "New ",
         "Description": "Revisions to the City of San Jose Sign Ordinance (Title 23)",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2012
      },
      {
         "PERMITID": "2012 010075 PP",
         "APN": 46724117,
         "File Number": "2012 010075 PP",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "4/2/12",
         "Status": "New ",
         "Description": "Revisions to the City of San Jose Sign Ordinance (Title 23)",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2012
      },
      {
         "PERMITID": "PP05-198",
         "APN": 47233011,
         "File Number": "PP05-198",
         "Address": "0 LAND ONLY SAN JOSE",
         "Project Name": "VOID ",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "10/18/05 11:08",
         "Status": "Under Review ",
         "Description": "VOID ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2005
      },
      {
         "PERMITID": "PP05-204",
         "APN": 25941065,
         "File Number": "PP05-204",
         "Address": "194 S MARKET ST SAN JOSE",
         "Project Name": "PP05-204",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "10/27/05 17:59",
         "Status": "Under Review ",
         "Description": "Operation of the Downtown Ice Rink in the Circle of Palms and installation of two 125-ton chillers on the rooftop of the San Jose Museum of Art to serve the temporary ice rink operating from November 2005 to mid-January 2006.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2005
      },
      {
         "PERMITID": "PP07-234",
         "APN": 25940071,
         "File Number": "PP07-234",
         "Address": "96 S ALMADEN AV SAN JOSE",
         "Project Name": "PP07-234 - Plaza Hotel Rehabilitation",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "10/19/07 9:05",
         "Status": "Under Review ",
         "Description": "Determination of consistency with the Downtown Strategy EIR for the rehabilitation of the Plaza Hotel ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP09-164",
         "APN": 25940070,
         "File Number": "PP09-164",
         "Address": "98 S ALMADEN AV SAN JOSE",
         "Project Name": "PP09-164",
         "Application Type": "Addendum / Use of Application ",
         "Application Date": "8/14/09 16:53",
         "Status": "Under Review ",
         "Description": "Acquisition of property located at 98 South Almaden Avenue",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      }
   ],
   "Administrative Permit ": [
      {
         "PERMITID": "AP05-024",
         "APN": 24948012,
         "File Number": "AP05-024",
         "Address": "233 E JULIAN ST SAN JOSE",
         "Project Name": "AP05-024",
         "Application Type": "Administrative Permit ",
         "Application Date": "10/25/05",
         "Status": "Approved ",
         "Description": "Administrative Permit to allow a small recycling collection facility, consisting of a parked truck that would leave the premises everyday, in an existing parking lot by removing two parking stalls and reserving the area for \"recycling truck parking only\" on a 1.62 gross acre site",
         "Planner": "Dave Tymn ",
         "DURATION": 322,
         "Year": 2005
      },
      {
         "PERMITID": "AP07-017",
         "APN": 25944080,
         "File Number": "AP07-017",
         "Address": "111 ALMADEN BL SAN JOSE",
         "Project Name": "AP07-017",
         "Application Type": "Administrative Permit ",
         "Application Date": "9/12/07",
         "Status": "Approved ",
         "Description": "Administrative Permit to allow installation of a permanent 250 KW standby/back-up generator fueled by natural gas that replaces an existing 230 KW diesel standby/back-up generator on a 0.81 gross acres site",
         "Planner": "Dave Tymn ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "AP07-025",
         "APN": 24948012,
         "File Number": "AP07-025",
         "Address": "233 E JULIAN ST SAN JOSE",
         "Project Name": "AP07-025",
         "Application Type": "Administrative Permit ",
         "Application Date": "12/18/07",
         "Status": "Approved ",
         "Description": "Administrative Permit to allow a small recycling collection facility, consisting of a parked truck that would leave the premises everyday, in an existing parking lot, on a 1.62 gross acre site.",
         "Planner": "Edward Schreiner ",
         "DURATION": 386,
         "Year": 2007
      },
      {
         "PERMITID": "AP09-003",
         "APN": 25939120,
         "File Number": "AP09-003",
         "Address": "95 S ALMADEN AV SAN JOSE",
         "Project Name": "AP09-003",
         "Application Type": "Administrative Permit ",
         "Application Date": "2/26/09",
         "Status": "Approved ",
         "Description": "Administrative Permit for a standby generator on a 1.3 gross acre site",
         "Planner": "Edward Schreiner ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "AP12-004",
         "APN": 25944085,
         "File Number": "AP12-004",
         "Address": "151 ALMADEN BL SAN JOSE",
         "Project Name": "AP12-004",
         "Application Type": "Administrative Permit ",
         "Application Date": "3/9/12",
         "Status": "Approved ",
         "Description": "Administrative Permit for a 13-hp temporary stand-by or backup power generator",
         "Planner": "MNAGARAJ ",
         "DURATION": 110,
         "Year": 2012
      },
      {
         "PERMITID": "AP12-004",
         "APN": 25944089,
         "File Number": "AP12-004",
         "Address": "151 ALMADEN BL SAN JOSE",
         "Project Name": "AP12-004",
         "Application Type": "Administrative Permit ",
         "Application Date": "3/9/12",
         "Status": "Approved ",
         "Description": "Administrative Permit for a 13-hp temporary stand-by or backup power generator",
         "Planner": "MNAGARAJ ",
         "DURATION": 110,
         "Year": 2012
      },
      {
         "PERMITID": "AP14-005",
         "APN": 25940053,
         "File Number": "AP14-005",
         "Address": "40 S MARKET ST SAN JOSE",
         "Project Name": "AP14-005",
         "Application Type": "Administrative Permit ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a standby generator located atop a multi-story building in the Downtown Area.  ",
         "Planner": "Karen Huynh ",
         "DURATION": 1,
         "Year": null
      },
      {
         "PERMITID": "AP18-012",
         "APN": 46717090,
         "File Number": "AP18-012",
         "Address": "425 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AP18-012 - WIRELESS",
         "Application Type": "Administrative Permit ",
         "Application Date": "11/14/18 10:25",
         "Status": "Approved ",
         "Description": "Administrative Wireless Permit to allow three new building-mounted antennas, relocation of two existing antennas, and associated equipment. ",
         "Planner": "Michelle Flores ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "RAP01-002",
         "APN": 46721034,
         "File Number": "RAP01-002",
         "Address": " ",
         "Project Name": "RAP01-002, Temporary Generator Trailer",
         "Application Type": "Administrative Permit ",
         "Application Date": "12/14/01",
         "Status": "Approved ",
         "Description": "installation of temporary, back-up generators. ",
         "Planner": "Alex Andrade ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "RAP02-001",
         "APN": 25940091,
         "File Number": "RAP02-001",
         "Address": " ",
         "Project Name": "RAP02-001, Market-Post Tower",
         "Application Type": "Administrative Permit ",
         "Application Date": "2/4/02",
         "Status": "Approved ",
         "Description": "Installation of cooling towers ",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2002
      },
      {
         "PERMITID": "RAP99-003",
         "APN": 25934008,
         "File Number": "RAP99-003",
         "Address": " ",
         "Project Name": "RAP99-003, Hoop World",
         "Application Type": "Administrative Permit ",
         "Application Date": "5/7/99",
         "Status": "Approved ",
         "Description": "Basketball Carnival on May 15-16, 1999",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RAP99-003",
         "APN": 25934009,
         "File Number": "RAP99-003",
         "Address": " ",
         "Project Name": "RAP99-003, Hoop World",
         "Application Type": "Administrative Permit ",
         "Application Date": "5/7/99",
         "Status": "Approved ",
         "Description": "Basketball Carnival on May 15-16, 1999",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RAP99-003",
         "APN": 25934011,
         "File Number": "RAP99-003",
         "Address": " ",
         "Project Name": "RAP99-003, Hoop World",
         "Application Type": "Administrative Permit ",
         "Application Date": "5/7/99",
         "Status": "Approved ",
         "Description": "Basketball Carnival on May 15-16, 1999",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RAP99-003",
         "APN": 25934012,
         "File Number": "RAP99-003",
         "Address": " ",
         "Project Name": "RAP99-003, Hoop World",
         "Application Type": "Administrative Permit ",
         "Application Date": "5/7/99",
         "Status": "Approved ",
         "Description": "Basketball Carnival on May 15-16, 1999",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RAP99-003",
         "APN": 25934013,
         "File Number": "RAP99-003",
         "Address": " ",
         "Project Name": "RAP99-003, Hoop World",
         "Application Type": "Administrative Permit ",
         "Application Date": "5/7/99",
         "Status": "Approved ",
         "Description": "Basketball Carnival on May 15-16, 1999",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RAP99-003",
         "APN": 25934018,
         "File Number": "RAP99-003",
         "Address": " ",
         "Project Name": "RAP99-003, Hoop World",
         "Application Type": "Administrative Permit ",
         "Application Date": "5/7/99",
         "Status": "Approved ",
         "Description": "Basketball Carnival on May 15-16, 1999",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RAP99-003",
         "APN": 25934020,
         "File Number": "RAP99-003",
         "Address": " ",
         "Project Name": "RAP99-003, Hoop World",
         "Application Type": "Administrative Permit ",
         "Application Date": "5/7/99",
         "Status": "Approved ",
         "Description": "Basketball Carnival on May 15-16, 1999",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RAP99-003",
         "APN": 25934021,
         "File Number": "RAP99-003",
         "Address": " ",
         "Project Name": "RAP99-003, Hoop World",
         "Application Type": "Administrative Permit ",
         "Application Date": "5/7/99",
         "Status": "Approved ",
         "Description": "Basketball Carnival on May 15-16, 1999",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RAP99-003",
         "APN": 25934022,
         "File Number": "RAP99-003",
         "Address": " ",
         "Project Name": "RAP99-003, Hoop World",
         "Application Type": "Administrative Permit ",
         "Application Date": "5/7/99",
         "Status": "Approved ",
         "Description": "Basketball Carnival on May 15-16, 1999",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RAP99-003",
         "APN": 25934023,
         "File Number": "RAP99-003",
         "Address": " ",
         "Project Name": "RAP99-003, Hoop World",
         "Application Type": "Administrative Permit ",
         "Application Date": "5/7/99",
         "Status": "Approved ",
         "Description": "Basketball Carnival on May 15-16, 1999",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RAP99-003",
         "APN": 25934025,
         "File Number": "RAP99-003",
         "Address": " ",
         "Project Name": "RAP99-003, Hoop World",
         "Application Type": "Administrative Permit ",
         "Application Date": "5/7/99",
         "Status": "Approved ",
         "Description": "Basketball Carnival on May 15-16, 1999",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RAP99-003",
         "APN": 25934026,
         "File Number": "RAP99-003",
         "Address": " ",
         "Project Name": "RAP99-003, Hoop World",
         "Application Type": "Administrative Permit ",
         "Application Date": "5/7/99",
         "Status": "Approved ",
         "Description": "Basketball Carnival on May 15-16, 1999",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RAP99-003",
         "APN": 25934027,
         "File Number": "RAP99-003",
         "Address": " ",
         "Project Name": "RAP99-003, Hoop World",
         "Application Type": "Administrative Permit ",
         "Application Date": "5/7/99",
         "Status": "Approved ",
         "Description": "Basketball Carnival on May 15-16, 1999",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RAP99-003",
         "APN": 25934030,
         "File Number": "RAP99-003",
         "Address": " ",
         "Project Name": "RAP99-003, Hoop World",
         "Application Type": "Administrative Permit ",
         "Application Date": "5/7/99",
         "Status": "Approved ",
         "Description": "Basketball Carnival on May 15-16, 1999",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RAP99-003",
         "APN": 25934031,
         "File Number": "RAP99-003",
         "Address": " ",
         "Project Name": "RAP99-003, Hoop World",
         "Application Type": "Administrative Permit ",
         "Application Date": "5/7/99",
         "Status": "Approved ",
         "Description": "Basketball Carnival on May 15-16, 1999",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "AP19-003",
         "APN": 25931071,
         "File Number": "AP19-003",
         "Address": "255 W JULIAN ST SAN JOSE",
         "Project Name": "AP19-003",
         "Application Type": "Administrative Permit ",
         "Application Date": "4/5/19 9:35",
         "Status": "Under Review ",
         "Description": "Wireless Administrative Permit to allow the addition of three new panel antennas.  ",
         "Planner": "Michelle Flores ",
         "DURATION": 3,
         "Year": 2019
      },
      {
         "PERMITID": "AP11-032",
         "APN": 46720002,
         "File Number": "AP11-032",
         "Address": "77 N 5TH ST SAN JOSE",
         "Project Name": "AP11-032",
         "Application Type": "Administrative Permit ",
         "Application Date": "8/16/11",
         "Status": "Withdrawn ",
         "Description": "Administrative Permit to operate a donation-bin type clothing recycling facility on the site of an existing church site. ",
         "Planner": "Sylvia Do ",
         "DURATION": 16,
         "Year": 2011
      },
      {
         "PERMITID": "AP11-034",
         "APN": 46720079,
         "File Number": "AP11-034",
         "Address": "147 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AP11-034",
         "Application Type": "Administrative Permit ",
         "Application Date": "9/22/11",
         "Status": "Withdrawn ",
         "Description": "Administrative Permit for a small recycling facility, located at the rear of an existing gas station, in the DC Downtown Primary Commercial Zoning District.  ",
         "Planner": "Sylvia Do ",
         "DURATION": 8,
         "Year": 2011
      },
      {
         "PERMITID": "RAP97-003",
         "APN": 25940066,
         "File Number": "RAP97-003",
         "Address": " ",
         "Project Name": "RAP97-003, Chalkwalk - SJMoA",
         "Application Type": "Administrative Permit ",
         "Application Date": "6/18/97",
         "Status": "Withdrawn ",
         "Description": "To allow a short-term use for a chalk drawing event ",
         "Planner": "Martin Magana ",
         "DURATION": 0,
         "Year": 1997
      }
   ],
   "Basic Zoning Letter ": [
      {
         "PERMITID": "RSL16-108",
         "APN": 26429058,
         "File Number": "RSL16-108",
         "Address": "325 S 1ST ST SAN JOSE",
         "Project Name": "RSL16-108",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "7/15/16 16:15",
         "Status": "Approved ",
         "Description": "Public Information Letter for Basic Zoning of 325 South 1st Street, APN 264-29-058",
         "Planner": " ",
         "DURATION": 14,
         "Year": 2016
      },
      {
         "PERMITID": "RZL94-006",
         "APN": 25934019,
         "File Number": "RZL94-006",
         "Address": " ",
         "Project Name": "RZL94-006, Office Building",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "7/26/94",
         "Status": "Approved ",
         "Description": "Zoning request letter in case building is destroyed by fire or other disaster, it may be restored in conformance with what is allowed within the C-3 zoning section.",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1994
      },
      {
         "PERMITID": "RZL94-006",
         "APN": 25934040,
         "File Number": "RZL94-006",
         "Address": " ",
         "Project Name": "RZL94-006, Office Building",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "7/26/94",
         "Status": "Approved ",
         "Description": "Zoning request letter in case building is destroyed by fire or other disaster, it may be restored in conformance with what is allowed within the C-3 zoning section.",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1994
      },
      {
         "PERMITID": "RZL95-001",
         "APN": 25934053,
         "File Number": "RZL95-001",
         "Address": " ",
         "Project Name": "RZL95-001, Boccardo Properties",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "3/16/95",
         "Status": "Approved ",
         "Description": "Zoning response letter if buildings are destroyed by fire or other disaster, they may be restored in conformance with what is allowed in the C-3 zoning district.",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1995
      },
      {
         "PERMITID": "RZL94-003",
         "APN": 47227012,
         "File Number": "RZL94-003",
         "Address": " ",
         "Project Name": "RZL94-003, Burn Down Letter",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "5/2/92",
         "Status": "Closed ",
         "Description": "Zoning response letter if building is destroyed by fire or other disaster. ",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 1992
      },
      {
         "PERMITID": "RSL04-029",
         "APN": 46757083,
         "File Number": "RSL04-029",
         "Address": "235 E SANTA CLARA ST SAN JOSE",
         "Project Name": "RSL04-029",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "6/22/04 8:24",
         "Status": "Complete ",
         "Description": "Burndown letter request ",
         "Planner": "Ron Eddow ",
         "DURATION": 6,
         "Year": 2004
      },
      {
         "PERMITID": "RSL04-050",
         "APN": 46718087,
         "File Number": "RSL04-050",
         "Address": "345 E SANTA CLARA ST SAN JOSE",
         "Project Name": "RSL04-050",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "9/21/04 11:54",
         "Status": "Complete ",
         "Description": "700 SF ACCUPUNCTURE OFFICE USE",
         "Planner": "Jean P. Lin ",
         "DURATION": 13,
         "Year": 2004
      },
      {
         "PERMITID": "RSL07-037",
         "APN": 46701080,
         "File Number": "RSL07-037",
         "Address": "210 N 4TH ST SAN JOSE",
         "Project Name": "RSL07-037",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "6/20/07 10:37",
         "Status": "Complete ",
         "Description": "Zoning Verification letter for property located at the northeast corner of N 4th Street and St. James Strett. (applicant requested expedite process and paid the correspondent fees)",
         "Planner": "Ben Corrales ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "RSL07-067",
         "APN": 47217011,
         "File Number": "RSL07-067",
         "Address": "780 S 1ST ST SAN JOSE",
         "Project Name": "RSL07-067",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "8/10/07 14:24",
         "Status": "Complete ",
         "Description": "ZONING VERIFICATION LETTER FOR BANK.  ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "RSL07-074",
         "APN": 47226064,
         "File Number": "RSL07-074",
         "Address": "600 S 2ND ST SAN JOSE",
         "Project Name": "RSL07-074",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "9/20/07 9:59",
         "Status": "Complete ",
         "Description": " ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "RSL08-017",
         "APN": 47218017,
         "File Number": "RSL08-017",
         "Address": "856 S 3RD ST SAN JOSE",
         "Project Name": "RSL08-017",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "3/25/08 9:27",
         "Status": "Complete ",
         "Description": "Basic Zoning letter on a single family residence in the LI zone. ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "RSL10-054",
         "APN": 25930044,
         "File Number": "RSL10-054",
         "Address": "143 N ALMADEN BL SAN JOSE",
         "Project Name": "RSL10-054 - Little Italy San Jose",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "12/16/10 11:43",
         "Status": "Complete ",
         "Description": "Public Information Letter that will describe the allowed uses for APN no's: 259-30: 036, 037, 044,045, 046, 47, 48, 49 and APN no's: 259-36-036, 037, 038, 039, 067 (APNs 259-30-036 and 259-30-037 are ot coming up in the system",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 1,
         "Year": 2010
      },
      {
         "PERMITID": "RSL10-054",
         "APN": 25930046,
         "File Number": "RSL10-054",
         "Address": "143 N ALMADEN BL SAN JOSE",
         "Project Name": "RSL10-054 - Little Italy San Jose",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "12/16/10 11:43",
         "Status": "Complete ",
         "Description": "Public Information Letter that will describe the allowed uses for APN no's: 259-30: 036, 037, 044,045, 046, 47, 48, 49 and APN no's: 259-36-036, 037, 038, 039, 067 (APNs 259-30-036 and 259-30-037 are ot coming up in the system",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 1,
         "Year": 2010
      },
      {
         "PERMITID": "RSL10-054",
         "APN": 25936039,
         "File Number": "RSL10-054",
         "Address": "143 N ALMADEN BL SAN JOSE",
         "Project Name": "RSL10-054 - Little Italy San Jose",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "12/16/10 11:43",
         "Status": "Complete ",
         "Description": "Public Information Letter that will describe the allowed uses for APN no's: 259-30: 036, 037, 044,045, 046, 47, 48, 49 and APN no's: 259-36-036, 037, 038, 039, 067 (APNs 259-30-036 and 259-30-037 are ot coming up in the system",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 1,
         "Year": 2010
      },
      {
         "PERMITID": "RSL11-066",
         "APN": 46722121,
         "File Number": "RSL11-066",
         "Address": "35 S 2ND ST SAN JOSE",
         "Project Name": "RSL11-066",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "9/16/11 14:25",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter  ",
         "Planner": "Avril Baty ",
         "DURATION": 1,
         "Year": 2011
      },
      {
         "PERMITID": "RSL11-090",
         "APN": 25942082,
         "File Number": "RSL11-090",
         "Address": "200 S MARKET ST SAN JOSE",
         "Project Name": "200 S MARKET ST",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "12/14/11 14:14",
         "Status": "Complete ",
         "Description": "Zoning letter ",
         "Planner": "Susan Walsh ",
         "DURATION": 1,
         "Year": 2011
      },
      {
         "PERMITID": "RSL11-091",
         "APN": 47229095,
         "File Number": "RSL11-091",
         "Address": "515 S 10TH ST SAN JOSE",
         "Project Name": "RSL11-091",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "12/19/11 10:06",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter Verification for a resturant use in a CN Zoning district ",
         "Planner": "Suparna Saha ",
         "DURATION": 1,
         "Year": 2011
      },
      {
         "PERMITID": "RSL12-053",
         "APN": 25939115,
         "File Number": "RSL12-053",
         "Address": "99 ALMADEN BL SAN JOSE",
         "Project Name": "RSL12-053",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "7/3/12 11:43",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for professional office building. ",
         "Planner": "Susan Walsh ",
         "DURATION": 1,
         "Year": 2012
      },
      {
         "PERMITID": "RSL12-054",
         "APN": 25939119,
         "File Number": "RSL12-054",
         "Address": "1 ALMADEN BL SAN JOSE",
         "Project Name": "RSL12-054",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "7/3/12 12:06",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for a proffessional office building downtown. ",
         "Planner": "Mike Enderby ",
         "DURATION": 43,
         "Year": 2012
      },
      {
         "PERMITID": "RSL12-064",
         "APN": 26415065,
         "File Number": "RSL12-064",
         "Address": "720 W SAN CARLOS ST SAN JOSE",
         "Project Name": "RSL12-064",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "7/23/12 14:07",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter  ",
         "Planner": "Jeff Roche ",
         "DURATION": 56,
         "Year": 2012
      },
      {
         "PERMITID": "RSL12-066",
         "APN": 26415065,
         "File Number": "RSL12-066",
         "Address": "720 W SAN CARLOS ST SAN JOSE",
         "Project Name": "RSL12-066",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "7/24/12 13:50",
         "Status": "Complete ",
         "Description": " ",
         "Planner": "John Davidson ",
         "DURATION": 1,
         "Year": 2012
      },
      {
         "PERMITID": "RSL12-089",
         "APN": 25941086,
         "File Number": "RSL12-089",
         "Address": "50 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "RSL12-089",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "8/27/12 16:08",
         "Status": "Complete ",
         "Description": "Basic Zoning letter for a downtown office building, Knight Ridder Building. ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2012
      },
      {
         "PERMITID": "RSL12-089",
         "APN": 25941087,
         "File Number": "RSL12-089",
         "Address": "50 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "RSL12-089",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "8/27/12 16:08",
         "Status": "Complete ",
         "Description": "Basic Zoning letter for a downtown office building, Knight Ridder Building. ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2012
      },
      {
         "PERMITID": "RSL12-128",
         "APN": 46720068,
         "File Number": "RSL12-128",
         "Address": "96 N 3RD ST SAN JOSE",
         "Project Name": "RSL12-128",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "11/16/12 13:40",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2012
      },
      {
         "PERMITID": "RSL12-129",
         "APN": 25940087,
         "File Number": "RSL12-129",
         "Address": "160 W SANTA CLARA ST SAN JOSE",
         "Project Name": "RSL12-129",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "11/27/12 9:40",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter ",
         "Planner": "Susan Walsh ",
         "DURATION": 1,
         "Year": 2012
      },
      {
         "PERMITID": "RSL13-048",
         "APN": 25939122,
         "File Number": "RSL13-048",
         "Address": "10 ALMADEN BL SAN JOSE",
         "Project Name": "RSL13-048",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "3/28/13 13:31",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for Downtown highrise building. ",
         "Planner": "Jan Warne ",
         "DURATION": 1,
         "Year": 2013
      },
      {
         "PERMITID": "RSL13-148",
         "APN": 25935020,
         "File Number": "RSL13-148",
         "Address": "225 W SANTA CLARA ST SAN JOSE",
         "Project Name": "RSL13-148",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "8/30/13 14:42",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for 225 W. Santa Clara Street.",
         "Planner": " ",
         "DURATION": 10,
         "Year": 2013
      },
      {
         "PERMITID": "RSL13-223",
         "APN": 25935020,
         "File Number": "RSL13-223",
         "Address": "225 W SANTA CLARA ST SAN JOSE",
         "Project Name": "RSL13-223",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "11/26/13 11:13",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for 225 West Santa Clara Street.",
         "Planner": " ",
         "DURATION": 8,
         "Year": 2013
      },
      {
         "PERMITID": "RSL13-224",
         "APN": 25940086,
         "File Number": "RSL13-224",
         "Address": "60 S MARKET ST SAN JOSE",
         "Project Name": "RSL13-224",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "12/4/13 13:46",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for 60 South Market.",
         "Planner": " ",
         "DURATION": 6,
         "Year": 2013
      },
      {
         "PERMITID": "RSL13-227",
         "APN": 25934053,
         "File Number": "RSL13-227",
         "Address": "111 W ST JOHN ST Bldg 2 SAN JOSE",
         "Project Name": "RSL13-227",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "12/9/13 11:19",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for 111 W. St. John Street and 111 North Market Street.",
         "Planner": "Susan Walsh ",
         "DURATION": 10,
         "Year": 2013
      },
      {
         "PERMITID": "RSL14-025",
         "APN": 47245038,
         "File Number": "RSL14-025",
         "Address": "125 PATTERSON ST UNIT 231 SAN JOSE",
         "Project Name": "RSL14-025",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "2/3/14 10:33",
         "Status": "Complete ",
         "Description": "Cottage Food Letter ",
         "Planner": " ",
         "DURATION": 1,
         "Year": 2014
      },
      {
         "PERMITID": "RSL14-028",
         "APN": 25943074,
         "File Number": "RSL14-028",
         "Address": "300 PARK AV SAN JOSE",
         "Project Name": "RSL14-028",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "2/7/14 15:16",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for 300 Park Ave.",
         "Planner": " ",
         "DURATION": 7,
         "Year": 2014
      },
      {
         "PERMITID": "RSL14-051",
         "APN": 25939111,
         "File Number": "RSL14-051",
         "Address": "350 W SANTA CLARA ST SAN JOSE",
         "Project Name": "RSL14-051",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "3/21/14 15:16",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for 259-39-111.",
         "Planner": "Susan Walsh ",
         "DURATION": 7,
         "Year": 2014
      },
      {
         "PERMITID": "RSL14-056",
         "APN": 25934053,
         "File Number": "RSL14-056",
         "Address": "111 N MARKET ST Bldg 1 SAN JOSE",
         "Project Name": "RSL14-056",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "3/28/14 9:44",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for 111 N. Market St.",
         "Planner": " ",
         "DURATION": 1,
         "Year": 2014
      },
      {
         "PERMITID": "RSL14-094",
         "APN": 25939122,
         "File Number": "RSL14-094",
         "Address": "10 ALMADEN BL SAN JOSE",
         "Project Name": "RSL14-094",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "7/2/14 10:04",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for 10 Almaden Boulevard.",
         "Planner": " ",
         "DURATION": 7,
         "Year": 2014
      },
      {
         "PERMITID": "RSL14-095",
         "APN": 25943075,
         "File Number": "RSL14-095",
         "Address": "333 W SAN CARLOS ST SAN JOSE",
         "Project Name": "RSL14-095",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "7/2/14 10:21",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for 333 W. San Carlos St.",
         "Planner": " ",
         "DURATION": 7,
         "Year": 2014
      },
      {
         "PERMITID": "RSL14-100",
         "APN": 25941088,
         "File Number": "RSL14-100",
         "Address": "170 S MARKET ST SAN JOSE",
         "Project Name": "RSL14-100",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "7/15/14 11:51",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for 170 & 172 South Market Street.",
         "Planner": "Pick ",
         "DURATION": 1,
         "Year": 2014
      },
      {
         "PERMITID": "RSL14-131",
         "APN": 25943069,
         "File Number": "RSL14-131",
         "Address": "282 ALMADEN BL SAN JOSE",
         "Project Name": "RSL14-131",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "9/23/14 14:43",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for the property located at 282 Almaden Boulevard (APNs 259-43-069 & 259-43-077)",
         "Planner": "MNAGARAJ ",
         "DURATION": 1,
         "Year": 2014
      },
      {
         "PERMITID": "RSL14-131",
         "APN": 25943077,
         "File Number": "RSL14-131",
         "Address": "282 ALMADEN BL SAN JOSE",
         "Project Name": "RSL14-131",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "9/23/14 14:43",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for the property located at 282 Almaden Boulevard (APNs 259-43-069 & 259-43-077)",
         "Planner": "MNAGARAJ ",
         "DURATION": 1,
         "Year": 2014
      },
      {
         "PERMITID": "RSL14-177",
         "APN": 46722121,
         "File Number": "RSL14-177",
         "Address": "35 S 2ND ST SAN JOSE",
         "Project Name": "RSL14-177",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "12/5/14 13:52",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for 35 S. Second St.",
         "Planner": "Pick ",
         "DURATION": 14,
         "Year": 2014
      },
      {
         "PERMITID": "RSL14-194",
         "APN": 46757083,
         "File Number": "RSL14-194",
         "Address": "235 E SANTA CLARA ST SAN JOSE",
         "Project Name": "RSL14-194",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "12/23/14 7:59",
         "Status": "Complete ",
         "Description": "Basic Zoning Verification Letter for 235 E. Santa Clara St.",
         "Planner": "Rhonda Buss ",
         "DURATION": 35,
         "Year": 2014
      },
      {
         "PERMITID": "RSL14-200",
         "APN": 25940087,
         "File Number": "RSL14-200",
         "Address": "160 W SANTA CLARA ST SAN JOSE",
         "Project Name": "RSL14-200",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "12/23/14 14:44",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for 160 W. Santa Clara.",
         "Planner": "Rhonda Buss ",
         "DURATION": 28,
         "Year": 2014
      },
      {
         "PERMITID": "RSL15-018",
         "APN": 25942082,
         "File Number": "RSL15-018",
         "Address": "200 S MARKET ST SAN JOSE",
         "Project Name": "RSL15-018",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "2/17/15 11:17",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for 200 S. Market Street.",
         "Planner": "Pick ",
         "DURATION": 1,
         "Year": 2015
      },
      {
         "PERMITID": "RSL15-075",
         "APN": 46721011,
         "File Number": "RSL15-075",
         "Address": "70 N 2ND ST SAN JOSE",
         "Project Name": "RSL15-075",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "5/21/15 13:53",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for 70 N. 2nd Street.",
         "Planner": "Susan Walsh ",
         "DURATION": 6,
         "Year": 2015
      },
      {
         "PERMITID": "RSL15-076",
         "APN": 26429107,
         "File Number": "RSL15-076",
         "Address": "302 S MARKET ST SAN JOSE",
         "Project Name": "RSL15-076",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "5/26/15 8:24",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for 302 S. Market.",
         "Planner": "Susan Walsh ",
         "DURATION": 1,
         "Year": 2015
      },
      {
         "PERMITID": "RSL15-105",
         "APN": 46721034,
         "File Number": "RSL15-105",
         "Address": "4 N 2ND ST SAN JOSE",
         "Project Name": "RSL15-105",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "7/15/15 11:52",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for 4 North 4th Street.",
         "Planner": "Susan Walsh ",
         "DURATION": 7,
         "Year": 2015
      },
      {
         "PERMITID": "RSL15-106",
         "APN": 46721035,
         "File Number": "RSL15-106",
         "Address": "0 N 2ND ST SAN JOSE",
         "Project Name": "RSL15-106",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "7/16/15 11:22",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for 4 North 4th Street.",
         "Planner": "Susan Walsh ",
         "DURATION": 6,
         "Year": 2015
      },
      {
         "PERMITID": "RSL15-135",
         "APN": 25939115,
         "File Number": "RSL15-135",
         "Address": "99 ALMADEN BL SAN JOSE",
         "Project Name": "RSL15-135",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "8/12/15 14:28",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for 99 Almaden Boulevard.",
         "Planner": "Susan Walsh ",
         "DURATION": 16,
         "Year": 2015
      },
      {
         "PERMITID": "RSL15-136",
         "APN": 25939119,
         "File Number": "RSL15-136",
         "Address": "325 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "RSL15-136",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "8/12/15 14:36",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for 325 W. San Fernando.",
         "Planner": "Susan Walsh ",
         "DURATION": 16,
         "Year": 2015
      },
      {
         "PERMITID": "RSL15-137",
         "APN": 25939115,
         "File Number": "RSL15-137",
         "Address": "99 ALMADEN BL SAN JOSE",
         "Project Name": "RSL15-137",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "8/12/15 15:08",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for 99 Almaden Boulevard.",
         "Planner": "Susan Walsh ",
         "DURATION": 16,
         "Year": 2015
      },
      {
         "PERMITID": "RSL15-154",
         "APN": 25941086,
         "File Number": "RSL15-154",
         "Address": "50 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "RSL15-154",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "9/11/15 10:06",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for 50 West San Fernando Street",
         "Planner": "Kristinae Toomians ",
         "DURATION": 1,
         "Year": 2015
      },
      {
         "PERMITID": "RSL15-154",
         "APN": 25941087,
         "File Number": "RSL15-154",
         "Address": "50 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "RSL15-154",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "9/11/15 10:06",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for 50 West San Fernando Street",
         "Planner": "Kristinae Toomians ",
         "DURATION": 1,
         "Year": 2015
      },
      {
         "PERMITID": "RSL15-218",
         "APN": 25942082,
         "File Number": "RSL15-218",
         "Address": "200 S MARKET ST SAN JOSE",
         "Project Name": "RSL15-218",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "11/23/15 12:48",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for 200 S. Market St.",
         "Planner": "Susan Walsh ",
         "DURATION": 1,
         "Year": 2015
      },
      {
         "PERMITID": "RSL16-022",
         "APN": 25941067,
         "File Number": "RSL16-022",
         "Address": "150 ALMADEN BL SAN JOSE",
         "Project Name": "RSL16-022",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "2/11/16 14:12",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for 150 Almaden Blvd.",
         "Planner": "Pick ",
         "DURATION": 7,
         "Year": 2016
      },
      {
         "PERMITID": "RSL16-022",
         "APN": 25941070,
         "File Number": "RSL16-022",
         "Address": "150 ALMADEN BL SAN JOSE",
         "Project Name": "RSL16-022",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "2/11/16 14:12",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for 150 Almaden Blvd.",
         "Planner": "Pick ",
         "DURATION": 7,
         "Year": 2016
      },
      {
         "PERMITID": "RSL16-078",
         "APN": 25940086,
         "File Number": "RSL16-078",
         "Address": "60 S MARKET ST SAN JOSE",
         "Project Name": "RSL16-078",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "5/24/16 14:49",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for 60 S Market Street.",
         "Planner": "Lori Moniz ",
         "DURATION": 1,
         "Year": 2016
      },
      {
         "PERMITID": "RSL16-211",
         "APN": 25943077,
         "File Number": "RSL16-211",
         "Address": "282 ALMADEN BL SAN JOSE",
         "Project Name": "RSL16-211",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "12/1/16 13:28",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for APN 259-43-077 (282 South Almaden Boulevard)",
         "Planner": "Armando Lopez ",
         "DURATION": 1,
         "Year": 2016
      },
      {
         "PERMITID": "RSL16-212",
         "APN": 25943069,
         "File Number": "RSL16-212",
         "Address": "282 ALMADEN BL SAN JOSE",
         "Project Name": "RSL16-212",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "12/1/16 13:37",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for APN 259-43-069 (282 South Almaden Boulevard)",
         "Planner": " ",
         "DURATION": 1,
         "Year": 2016
      },
      {
         "PERMITID": "RSL17-056",
         "APN": 25943069,
         "File Number": "RSL17-056",
         "Address": "282 ALMADEN BL SAN JOSE",
         "Project Name": "RSL17-056",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "4/6/17 13:53",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for APN 259-43-069 & 259-43-077 (282 South Almaden Blvd)",
         "Planner": "Armando Lopez ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "RSL17-067",
         "APN": 46722007,
         "File Number": "RSL17-067",
         "Address": "52 S 1ST ST SAN JOSE",
         "Project Name": "RSL17-067",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "4/21/17 9:42",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for APN 467-22-007 (52 South 1st Street)",
         "Planner": "Armando Lopez ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "RSL17-079",
         "APN": 46701080,
         "File Number": "RSL17-079",
         "Address": "210 N 4TH ST SAN JOSE",
         "Project Name": "RSL17-079",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "5/17/17 13:24",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for APN 467-01-080 (210 North 4th Street)",
         "Planner": "Armando Lopez ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "RSL17-095",
         "APN": 26471001,
         "File Number": "RSL17-095",
         "Address": "370 S MARKET ST SAN JOSE",
         "Project Name": "RSL17-095",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "6/13/17 15:22",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for APN 264-29-117 (360 South Market Street)",
         "Planner": "Armando Lopez ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "RSL17-095",
         "APN": 26471218,
         "File Number": "RSL17-095",
         "Address": "370 S MARKET ST SAN JOSE",
         "Project Name": "RSL17-095",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "6/13/17 15:22",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for APN 264-29-117 (360 South Market Street)",
         "Planner": "Armando Lopez ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "RSL17-110",
         "APN": 25934053,
         "File Number": "RSL17-110",
         "Address": "111 N MARKET ST Bldg 1 SAN JOSE",
         "Project Name": "RSL17-110",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "6/30/17 13:34",
         "Status": "Complete ",
         "Description": "Zoning letter for outpatient counseling for substance abuse. ",
         "Planner": "Jan Warne ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "RSL17-177",
         "APN": 25943075,
         "File Number": "RSL17-177",
         "Address": "333 W SAN CARLOS ST SAN JOSE",
         "Project Name": "RSL17-177",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "10/4/17 13:52",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for APN 259-43-072 & 259-43-075 (333 West San Carlos Street)",
         "Planner": "Armando Lopez ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "RSL17-178",
         "APN": 25943074,
         "File Number": "RSL17-178",
         "Address": "300 PARK AV SAN JOSE",
         "Project Name": "RSL17-178",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "10/5/17 11:35",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for APN 259-43-074 (300 Park Avenue)",
         "Planner": "Armando Lopez ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "RSL17-183",
         "APN": 25956001,
         "File Number": "RSL17-183",
         "Address": "170 S MARKET ST SAN JOSE",
         "Project Name": "RSL17-183",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "10/17/17 13:41",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for APN 259-56-001 (170 South Market Street)",
         "Planner": "Armando Lopez ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "RSL17-209",
         "APN": 46721002,
         "File Number": "RSL17-209",
         "Address": "75 E SANTA CLARA ST SAN JOSE",
         "Project Name": "RSL17-209",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "11/13/17 10:26",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for APN 467-21-002, -033, -034 & -040 (75 East Santa Clara Street and 4 North Second Street)",
         "Planner": "Armando Lopez ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "RSL17-209",
         "APN": 46721034,
         "File Number": "RSL17-209",
         "Address": "75 E SANTA CLARA ST SAN JOSE",
         "Project Name": "RSL17-209",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "11/13/17 10:26",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for APN 467-21-002, -033, -034 & -040 (75 East Santa Clara Street and 4 North Second Street)",
         "Planner": "Armando Lopez ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "RSL17-223",
         "APN": 46722158,
         "File Number": "RSL17-223",
         "Address": "30 E SANTA CLARA ST SAN JOSE",
         "Project Name": "RSL17-223",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "12/5/17 8:31",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for APN 467-22-158 (30 East Santa Clara Street)",
         "Planner": "Armando Lopez ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "RSL18-048",
         "APN": 46722121,
         "File Number": "RSL18-048",
         "Address": "35 S 2ND ST SAN JOSE",
         "Project Name": "RSL18-048",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "3/9/18 16:09",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for APN 497-22-121 (35 South 2nd Street)",
         "Planner": "Armando Lopez ",
         "DURATION": 1,
         "Year": 2018
      },
      {
         "PERMITID": "RSL18-056",
         "APN": 25939111,
         "File Number": "RSL18-056",
         "Address": "350 W SANTA CLARA ST SAN JOSE",
         "Project Name": "RSL18-056",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "3/20/18 13:38",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for APN 259-39-111 (350 West Santa Clara Street)",
         "Planner": "Armando Lopez ",
         "DURATION": 1,
         "Year": 2018
      },
      {
         "PERMITID": "RSL18-059",
         "APN": 25940087,
         "File Number": "RSL18-059",
         "Address": "160 W SANTA CLARA ST SAN JOSE",
         "Project Name": "RSL18-059",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "3/21/18 15:00",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for APN 259-40-087 & 259-40-088 (160 West Santa Clara Street)",
         "Planner": "Armando Lopez ",
         "DURATION": 1,
         "Year": 2018
      },
      {
         "PERMITID": "RSL18-093",
         "APN": 26429057,
         "File Number": "RSL18-093",
         "Address": "301 S 1ST ST SAN JOSE",
         "Project Name": "RSL18-093",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "4/13/18 10:26",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for APN 264-29-057 (301, 311, 315, & 321 South First Street)",
         "Planner": "Armando Lopez ",
         "DURATION": 1,
         "Year": 2018
      },
      {
         "PERMITID": "RSL18-158",
         "APN": 46720084,
         "File Number": "RSL18-158",
         "Address": "152 N 3RD ST SAN JOSE",
         "Project Name": "RSL18-158",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "6/12/18 16:08",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for APN 467-20-084",
         "Planner": " ",
         "DURATION": 1,
         "Year": 2018
      },
      {
         "PERMITID": "RSL18-160",
         "APN": 46757084,
         "File Number": "RSL18-160",
         "Address": "27 N 6TH ST SAN JOSE",
         "Project Name": "RSL18-160",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "6/13/18 15:49",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for APN 467-57-084",
         "Planner": " ",
         "DURATION": 1,
         "Year": 2018
      },
      {
         "PERMITID": "RSL18-172",
         "APN": 25941057,
         "File Number": "RSL18-172",
         "Address": "177 PARK CENTER PLAZA SAN JOSE",
         "Project Name": "RSL18-172",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "6/27/18 13:07",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for APNs 259-10-066, 259-41-067, 259-41-068, 259-41-070, and 259-41-057",
         "Planner": " ",
         "DURATION": 1,
         "Year": 2018
      },
      {
         "PERMITID": "RSL18-172",
         "APN": 25941067,
         "File Number": "RSL18-172",
         "Address": "177 PARK CENTER PLAZA SAN JOSE",
         "Project Name": "RSL18-172",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "6/27/18 13:07",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for APNs 259-10-066, 259-41-067, 259-41-068, 259-41-070, and 259-41-057",
         "Planner": " ",
         "DURATION": 1,
         "Year": 2018
      },
      {
         "PERMITID": "RSL18-191",
         "APN": 26429058,
         "File Number": "RSL18-191",
         "Address": "325 S 1ST ST SAN JOSE",
         "Project Name": "RSL18-191",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "7/10/18 13:45",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for APN 264-29-058",
         "Planner": " ",
         "DURATION": 1,
         "Year": 2018
      },
      {
         "PERMITID": "RSL18-198",
         "APN": 46746080,
         "File Number": "RSL18-198",
         "Address": "345 S 2ND ST SAN JOSE",
         "Project Name": "RSL18-198",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "7/17/18 16:16",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for APNs 467-46-080, 467-46-081, & 467-46-082",
         "Planner": " ",
         "DURATION": 1,
         "Year": 2018
      },
      {
         "PERMITID": "RSL18-198",
         "APN": 46746081,
         "File Number": "RSL18-198",
         "Address": "345 S 2ND ST SAN JOSE",
         "Project Name": "RSL18-198",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "7/17/18 16:16",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for APNs 467-46-080, 467-46-081, & 467-46-082",
         "Planner": " ",
         "DURATION": 1,
         "Year": 2018
      },
      {
         "PERMITID": "RSL18-198",
         "APN": 46746082,
         "File Number": "RSL18-198",
         "Address": "345 S 2ND ST SAN JOSE",
         "Project Name": "RSL18-198",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "7/17/18 16:16",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for APNs 467-46-080, 467-46-081, & 467-46-082",
         "Planner": " ",
         "DURATION": 1,
         "Year": 2018
      },
      {
         "PERMITID": "RSL18-232",
         "APN": 25943069,
         "File Number": "RSL18-232",
         "Address": "282 ALMADEN BL SAN JOSE",
         "Project Name": "RSL18-232",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "8/29/18 8:21",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for APNs 259-43-069 and 259-43-077",
         "Planner": " ",
         "DURATION": 1,
         "Year": 2018
      },
      {
         "PERMITID": "RSL18-232",
         "APN": 25943077,
         "File Number": "RSL18-232",
         "Address": "282 ALMADEN BL SAN JOSE",
         "Project Name": "RSL18-232",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "8/29/18 8:21",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for APNs 259-43-069 and 259-43-077",
         "Planner": " ",
         "DURATION": 1,
         "Year": 2018
      },
      {
         "PERMITID": "RSL18-241",
         "APN": 46722141,
         "File Number": "RSL18-241",
         "Address": "150 S 1ST ST SAN JOSE",
         "Project Name": "RSL18-241",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "9/6/18 13:47",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for APN 46722141",
         "Planner": " ",
         "DURATION": 1,
         "Year": 2018
      },
      {
         "PERMITID": "RSL18-301",
         "APN": 25935055,
         "File Number": "RSL18-301",
         "Address": "8 N ALMADEN BL SAN JOSE",
         "Project Name": "RSL18-301",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "11/29/18 9:09",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for APN(s): 259-35-055",
         "Planner": " ",
         "DURATION": 1,
         "Year": 2018
      },
      {
         "PERMITID": "RSL19-013",
         "APN": 25943076,
         "File Number": "RSL19-013",
         "Address": "200 PARK AV SAN JOSE",
         "Project Name": "RSL19-013",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "1/14/19 10:17",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for APN: 259-43-076",
         "Planner": " ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "RSL19-014",
         "APN": 25943077,
         "File Number": "RSL19-014",
         "Address": "282 ALMADEN BL SAN JOSE",
         "Project Name": "RSL19-014",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "1/14/19 10:31",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for APN(s): 259-43-077",
         "Planner": " ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "RSL19-017",
         "APN": 25934016,
         "File Number": "RSL19-017",
         "Address": "41 W SANTA CLARA ST SAN JOSE",
         "Project Name": "RSL19-017",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "1/15/19 13:56",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for APN 259-34-016",
         "Planner": " ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "RSL19-041",
         "APN": 25939111,
         "File Number": "RSL19-041",
         "Address": "350 W SANTA CLARA ST SAN JOSE",
         "Project Name": "RSL19-041",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "2/12/19 15:05",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for APN(s): 259-39-111",
         "Planner": " ",
         "DURATION": 2,
         "Year": 2019
      },
      {
         "PERMITID": "RSL19-052",
         "APN": 25934053,
         "File Number": "RSL19-052",
         "Address": "111 N MARKET ST Bldg 1 SAN JOSE",
         "Project Name": "RSL19-052",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "2/27/19 13:47",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for APN(s): 259-34-053 and 259-34-054",
         "Planner": " ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "RSL19-055",
         "APN": 25934034,
         "File Number": "RSL19-055",
         "Address": "111 N MARKET ST Bldg 1 SAN JOSE",
         "Project Name": "RSL19-055",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "3/1/19 9:47",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for APN(s): 259-34-053, 259-34-054, and 259-34-034",
         "Planner": " ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "RSL19-055",
         "APN": 25934053,
         "File Number": "RSL19-055",
         "Address": "111 N MARKET ST Bldg 1 SAN JOSE",
         "Project Name": "RSL19-055",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "3/1/19 9:47",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for APN(s): 259-34-053, 259-34-054, and 259-34-034",
         "Planner": " ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "RSL19-063",
         "APN": 46722002,
         "File Number": "RSL19-063",
         "Address": "26 S 1ST ST SAN JOSE",
         "Project Name": "RSL19-063",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "3/18/19 10:55",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for APN(s): 467-22-002",
         "Planner": " ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "RSL19-064",
         "APN": 46722003,
         "File Number": "RSL19-064",
         "Address": "30 S 1ST ST SAN JOSE",
         "Project Name": "RSL19-064",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "3/19/19 8:43",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for APN(s): 467-22-003",
         "Planner": " ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "RSL19-066",
         "APN": 46747019,
         "File Number": "RSL19-066",
         "Address": "409 S 2ND ST SAN JOSE",
         "Project Name": "RSL19-066",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "3/19/19 16:51",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for APN(s): 467-47-097, 467-47--019, & 467-47-020",
         "Planner": " ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "RSL19-066",
         "APN": 46747020,
         "File Number": "RSL19-066",
         "Address": "409 S 2ND ST SAN JOSE",
         "Project Name": "RSL19-066",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "3/19/19 16:51",
         "Status": "Complete ",
         "Description": "Basic Zoning Letter for APN(s): 467-47-097, 467-47--019, & 467-47-020",
         "Planner": " ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "RSL06-092",
         "APN": 46757083,
         "File Number": "RSL06-092",
         "Address": "235 E SANTA CLARA ST SAN JOSE",
         "Project Name": "RSL06-092",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "11/30/06 9:51",
         "Status": "Under Review ",
         "Description": "Basic zoning letter to verify City requirements for demolition of an existing parkiing structure ",
         "Planner": "Ron Eddow ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "RSL09-009",
         "APN": 24950083,
         "File Number": "RSL09-009",
         "Address": "319 N 8TH ST SAN JOSE",
         "Project Name": "RSL09-009",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "2/20/09 15:17",
         "Status": "Under Review ",
         "Description": "Basic zoning letter for Julian Street Gardens and additional confirmation of zoning approval for California Debt Limit Allocation Committee. ",
         "Planner": "Suzanne Thomas ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "RSL15-148",
         "APN": 47217002,
         "File Number": "RSL15-148",
         "Address": "860 S 1ST ST SAN JOSE",
         "Project Name": "RSL15-148",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "9/4/15 15:26",
         "Status": "Under Review ",
         "Description": "Federal Firearm License firearm retailer ",
         "Planner": "Pick ",
         "DURATION": 1,
         "Year": 2015
      },
      {
         "PERMITID": "RSL15-153",
         "APN": 46720080,
         "File Number": "RSL15-153",
         "Address": "60 N 3RD ST SAN JOSE",
         "Project Name": "RSL15-153",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "9/11/15 9:43",
         "Status": "Under Review ",
         "Description": "Basic Zoning Letter for 60 N. Third Street",
         "Planner": "Eric Morgan ",
         "DURATION": 1,
         "Year": 2015
      },
      {
         "PERMITID": "RSL13-187",
         "APN": 47218059,
         "File Number": "RSL13-187",
         "Address": "160 E VIRGINIA ST SAN JOSE",
         "Project Name": "RSL13-187",
         "Application Type": "Basic Zoning Letter ",
         "Application Date": "9/25/13 11:54",
         "Status": "Withdrawn ",
         "Description": "The applicant withdrew this application as it was unnecessary. ",
         "Planner": " ",
         "DURATION": 1,
         "Year": 2013
      }
   ],
   "Certificate of Compliance ": [
      {
         "PERMITID": "CT91-038",
         "APN": 46745073,
         "File Number": "CT91-038",
         "Address": "200 S 3RD ST SAN JOSE",
         "Project Name": "CT91-038",
         "Application Type": "Certificate of Compliance ",
         "Application Date": "4/11/91",
         "Status": "Approved ",
         "Description": "CERTIFICATE OF COMPLIANCE; Other APNs:,-074,-075",
         "Planner": "JPRANDI ",
         "DURATION": 0,
         "Year": 1991
      }
   ],
   "Comprehensive Research Letter ": [
      {
         "PERMITID": "CRL03-042",
         "APN": 47228078,
         "File Number": "CRL03-042",
         "Address": "561 S 9TH ST SAN JOSE",
         "Project Name": "CRL03-042",
         "Application Type": "Comprehensive Research Letter ",
         "Application Date": "12/2/03 12:01",
         "Status": "Complete ",
         "Description": "Comprehensive research letter for a residential substance abuse treatment program. ",
         "Planner": "John Davidson ",
         "DURATION": 1382,
         "Year": 2003
      },
      {
         "PERMITID": "CRL04-012",
         "APN": 25941057,
         "File Number": "CRL04-012",
         "Address": "150 ALMADEN BL SAN JOSE",
         "Project Name": "CRL04-012",
         "Application Type": "Comprehensive Research Letter ",
         "Application Date": "4/28/04 16:05",
         "Status": "Complete ",
         "Description": "research for properties on 100, 170, 130 Park Center Plaza, 177 & 185 Park Avenue, 125 South Market & 150 Almaden Blvd for zoning verification, permits & building compliance; permits; setback requirements; right to rebuild, etc.",
         "Planner": "Dipa Chundur ",
         "DURATION": 97,
         "Year": 2004
      },
      {
         "PERMITID": "CRL04-012",
         "APN": 25941066,
         "File Number": "CRL04-012",
         "Address": "150 ALMADEN BL SAN JOSE",
         "Project Name": "CRL04-012",
         "Application Type": "Comprehensive Research Letter ",
         "Application Date": "4/28/04 16:05",
         "Status": "Complete ",
         "Description": "research for properties on 100, 170, 130 Park Center Plaza, 177 & 185 Park Avenue, 125 South Market & 150 Almaden Blvd for zoning verification, permits & building compliance; permits; setback requirements; right to rebuild, etc.",
         "Planner": "Dipa Chundur ",
         "DURATION": 97,
         "Year": 2004
      },
      {
         "PERMITID": "CRL04-012",
         "APN": 25941067,
         "File Number": "CRL04-012",
         "Address": "150 ALMADEN BL SAN JOSE",
         "Project Name": "CRL04-012",
         "Application Type": "Comprehensive Research Letter ",
         "Application Date": "4/28/04 16:05",
         "Status": "Complete ",
         "Description": "research for properties on 100, 170, 130 Park Center Plaza, 177 & 185 Park Avenue, 125 South Market & 150 Almaden Blvd for zoning verification, permits & building compliance; permits; setback requirements; right to rebuild, etc.",
         "Planner": "Dipa Chundur ",
         "DURATION": 97,
         "Year": 2004
      },
      {
         "PERMITID": "CRL04-012",
         "APN": 25941068,
         "File Number": "CRL04-012",
         "Address": "150 ALMADEN BL SAN JOSE",
         "Project Name": "CRL04-012",
         "Application Type": "Comprehensive Research Letter ",
         "Application Date": "4/28/04 16:05",
         "Status": "Complete ",
         "Description": "research for properties on 100, 170, 130 Park Center Plaza, 177 & 185 Park Avenue, 125 South Market & 150 Almaden Blvd for zoning verification, permits & building compliance; permits; setback requirements; right to rebuild, etc.",
         "Planner": "Dipa Chundur ",
         "DURATION": 97,
         "Year": 2004
      },
      {
         "PERMITID": "CRL04-028",
         "APN": 25940087,
         "File Number": "CRL04-028",
         "Address": "160 W SANTA CLARA ST SAN JOSE",
         "Project Name": "CRL04-028",
         "Application Type": "Comprehensive Research Letter ",
         "Application Date": "9/13/04 11:49",
         "Status": "Complete ",
         "Description": "REQUEST TO DETERMINE WHETHER THE PROJECT IS COMPLIANT WITH ALL PERMITS. ENTITLEMENTS. LEGAL USE. PENDING APPLICATIONS. PARKING REQUIREMENTS. ",
         "Planner": "Avril Baty ",
         "DURATION": 63,
         "Year": 2004
      },
      {
         "PERMITID": "CRL04-032",
         "APN": 25943074,
         "File Number": "CRL04-032",
         "Address": "300 PARK AV SAN JOSE",
         "Project Name": "CRL04-032",
         "Application Type": "Comprehensive Research Letter ",
         "Application Date": "9/29/04 11:39",
         "Status": "Complete ",
         "Description": "See Letter ",
         "Planner": "Dipa Chundur ",
         "DURATION": 19,
         "Year": 2004
      },
      {
         "PERMITID": "CRL05-039",
         "APN": 25943069,
         "File Number": "CRL05-039",
         "Address": "282 ALMADEN BL SAN JOSE",
         "Project Name": "CRL05-039",
         "Application Type": "Comprehensive Research Letter ",
         "Application Date": "7/12/05 13:55",
         "Status": "Complete ",
         "Description": "Need info of current zonin, any special, restrictive or overlay district, abutting zoning designations, any permits, violations, legal nonconforming issues. paid expediting fee. ",
         "Planner": "Jerry Yoshida ",
         "DURATION": 133,
         "Year": 2005
      },
      {
         "PERMITID": "CRL05-041",
         "APN": 25939112,
         "File Number": "CRL05-041",
         "Address": "1 ALMADEN BL SAN JOSE",
         "Project Name": "CRL05-041",
         "Application Type": "Comprehensive Research Letter ",
         "Application Date": "7/21/05 16:33",
         "Status": "Complete ",
         "Description": "Comprehensive Research Letter for 1 Almaden Blvd., 55 Almaden Blvd., and 99 Almaden Blvd. Includes APNs 259-39-112, -113, -114, -115, -119.",
         "Planner": "Michele Campos ",
         "DURATION": 7,
         "Year": 2005
      },
      {
         "PERMITID": "CRL05-041",
         "APN": 25939115,
         "File Number": "CRL05-041",
         "Address": "1 ALMADEN BL SAN JOSE",
         "Project Name": "CRL05-041",
         "Application Type": "Comprehensive Research Letter ",
         "Application Date": "7/21/05 16:33",
         "Status": "Complete ",
         "Description": "Comprehensive Research Letter for 1 Almaden Blvd., 55 Almaden Blvd., and 99 Almaden Blvd. Includes APNs 259-39-112, -113, -114, -115, -119.",
         "Planner": "Michele Campos ",
         "DURATION": 7,
         "Year": 2005
      },
      {
         "PERMITID": "CRL05-041",
         "APN": 25939119,
         "File Number": "CRL05-041",
         "Address": "1 ALMADEN BL SAN JOSE",
         "Project Name": "CRL05-041",
         "Application Type": "Comprehensive Research Letter ",
         "Application Date": "7/21/05 16:33",
         "Status": "Complete ",
         "Description": "Comprehensive Research Letter for 1 Almaden Blvd., 55 Almaden Blvd., and 99 Almaden Blvd. Includes APNs 259-39-112, -113, -114, -115, -119.",
         "Planner": "Michele Campos ",
         "DURATION": 7,
         "Year": 2005
      },
      {
         "PERMITID": "CRL05-063",
         "APN": 25940091,
         "File Number": "CRL05-063",
         "Address": "55 S MARKET ST SAN JOSE",
         "Project Name": "CRL05-063",
         "Application Type": "Comprehensive Research Letter ",
         "Application Date": "9/28/05 10:44",
         "Status": "Complete ",
         "Description": "zoning verification; code violations and any variances, special and conditional use permits, etc. ",
         "Planner": "Dipa Chundur ",
         "DURATION": 34,
         "Year": 2005
      },
      {
         "PERMITID": "CRL05-086",
         "APN": 25943069,
         "File Number": "CRL05-086",
         "Address": "282 ALMADEN BL SAN JOSE",
         "Project Name": "CRL05-086",
         "Application Type": "Comprehensive Research Letter ",
         "Application Date": "11/18/05 14:11",
         "Status": "Complete ",
         "Description": "zoning, gp, adjacent designations and uses, code violations, variances, permits, etc. ",
         "Planner": "Avril Baty ",
         "DURATION": 21,
         "Year": 2005
      },
      {
         "PERMITID": "CRL05-089",
         "APN": 25941067,
         "File Number": "CRL05-089",
         "Address": "100 PARK CENTER PLAZA SAN JOSE",
         "Project Name": "CRL05-089",
         "Application Type": "Comprehensive Research Letter ",
         "Application Date": "11/23/05 9:00",
         "Status": "Complete ",
         "Description": "info of code violations, current zoning, FAR; parking requirements; setbacks, building heights, signage, language, landscaping; permitted uses, existing permits, etc. ",
         "Planner": "Caleb Gretton ",
         "DURATION": 1,
         "Year": 2005
      },
      {
         "PERMITID": "CRL05-089",
         "APN": 25941068,
         "File Number": "CRL05-089",
         "Address": "100 PARK CENTER PLAZA SAN JOSE",
         "Project Name": "CRL05-089",
         "Application Type": "Comprehensive Research Letter ",
         "Application Date": "11/23/05 9:00",
         "Status": "Complete ",
         "Description": "info of code violations, current zoning, FAR; parking requirements; setbacks, building heights, signage, language, landscaping; permitted uses, existing permits, etc. ",
         "Planner": "Caleb Gretton ",
         "DURATION": 1,
         "Year": 2005
      },
      {
         "PERMITID": "CRL05-089",
         "APN": 25941070,
         "File Number": "CRL05-089",
         "Address": "100 PARK CENTER PLAZA SAN JOSE",
         "Project Name": "CRL05-089",
         "Application Type": "Comprehensive Research Letter ",
         "Application Date": "11/23/05 9:00",
         "Status": "Complete ",
         "Description": "info of code violations, current zoning, FAR; parking requirements; setbacks, building heights, signage, language, landscaping; permitted uses, existing permits, etc. ",
         "Planner": "Caleb Gretton ",
         "DURATION": 1,
         "Year": 2005
      },
      {
         "PERMITID": "CRL06-011",
         "APN": 25936074,
         "File Number": "CRL06-011",
         "Address": "333 W SANTA CLARA ST SAN JOSE",
         "Project Name": "CRL06-011",
         "Application Type": "Comprehensive Research Letter ",
         "Application Date": "2/16/06 16:01",
         "Status": "Complete ",
         "Description": "current zoning; overlay districts; is property a permitted use in this district; existing permits; violations; abutting zoning districts; variances or special permits, etc. ",
         "Planner": "Edward Schreiner ",
         "DURATION": 34,
         "Year": 2006
      },
      {
         "PERMITID": "CRL06-051",
         "APN": 25941086,
         "File Number": "CRL06-051",
         "Address": "50 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "CRL06-051",
         "Application Type": "Comprehensive Research Letter ",
         "Application Date": "5/9/06 10:02",
         "Status": "Complete ",
         "Description": "current zoning, abutting zoning designations, copies of Planned Development on parking, setbacks, densities & height, any variances, special exceptions or conditional uses, legal nonconforming issues, zoning or building violations, etc. ",
         "Planner": "Maggie Suson-Nale ",
         "DURATION": 162,
         "Year": 2006
      },
      {
         "PERMITID": "CRL06-051",
         "APN": 25941087,
         "File Number": "CRL06-051",
         "Address": "50 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "CRL06-051",
         "Application Type": "Comprehensive Research Letter ",
         "Application Date": "5/9/06 10:02",
         "Status": "Complete ",
         "Description": "current zoning, abutting zoning designations, copies of Planned Development on parking, setbacks, densities & height, any variances, special exceptions or conditional uses, legal nonconforming issues, zoning or building violations, etc. ",
         "Planner": "Maggie Suson-Nale ",
         "DURATION": 162,
         "Year": 2006
      },
      {
         "PERMITID": "CRL07-002",
         "APN": 25935020,
         "File Number": "CRL07-002",
         "Address": "225 W SANTA CLARA ST SAN JOSE",
         "Project Name": "CRL07-002",
         "Application Type": "Comprehensive Research Letter ",
         "Application Date": "1/5/07 14:17",
         "Status": "Complete ",
         "Description": "current zoning; any overlay districts; is property permitted uses; any site plan, copies; abutting zoning districts; code violations; existing permits; etc. ",
         "Planner": "John Kim ",
         "DURATION": 24,
         "Year": 2007
      },
      {
         "PERMITID": "CRL07-009",
         "APN": 25939122,
         "File Number": "CRL07-009",
         "Address": "10 ALMADEN BL SAN JOSE",
         "Project Name": "CRL07-009",
         "Application Type": "Comprehensive Research Letter ",
         "Application Date": "1/5/07 14:35",
         "Status": "Complete ",
         "Description": "current zoning; any overlay districts; is property permitted uses; any site plan, copies; abutting zoning districts; code violations; existing permits; etc. ",
         "Planner": "Bill Roth ",
         "DURATION": 24,
         "Year": 2007
      },
      {
         "PERMITID": "CRL07-072",
         "APN": 25941067,
         "File Number": "CRL07-072",
         "Address": "121 PARK CENTER PLAZA SAN JOSE",
         "Project Name": "CRL07-072",
         "Application Type": "Comprehensive Research Letter ",
         "Application Date": "8/13/07 16:24",
         "Status": "Complete ",
         "Description": "Comprehensive Research Letter for General Plan conformance, Zoning, code, heights/FAA restrictions, County entitlements to allow expansion of uses or structures. ",
         "Planner": "Bill Roth ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "CRL08-024",
         "APN": 25943075,
         "File Number": "CRL08-024",
         "Address": "333 W SAN CARLOS ST SAN JOSE",
         "Project Name": "CRL08-024",
         "Application Type": "Comprehensive Research Letter ",
         "Application Date": "6/23/08 15:50",
         "Status": "Complete ",
         "Description": "CRL LETTER. information on current zoning; special, overlay districts; zoning designations on abutting zoning designations, copies of permits, legal nonconforming issues, etc. ",
         "Planner": "Michele Campos ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "CRL08-031",
         "APN": 25942079,
         "File Number": "CRL08-031",
         "Address": "211 S 1ST ST SAN JOSE",
         "Project Name": "CRL08-031",
         "Application Type": "Comprehensive Research Letter ",
         "Application Date": "9/15/08 14:30",
         "Status": "Complete ",
         "Description": "CRL LETTER. information on current zoning; special, overlay districts; zoning designations on abutting zoning designations, copies of permits, legal nonconforming issues, etc. ",
         "Planner": "Suzanne Thomas ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "CRL10-004",
         "APN": 25940043,
         "File Number": "CRL10-004",
         "Address": "27 S 1ST ST SAN JOSE",
         "Project Name": "CRL10-004",
         "Application Type": "Comprehensive Research Letter ",
         "Application Date": "4/2/10 10:08",
         "Status": "Complete ",
         "Description": "Research request/ Planning consultation regarding the singage on the windows of historic building identified as Structure of Merit in Downtown ",
         "Planner": "MNAGARAJ ",
         "DURATION": 3446,
         "Year": 2010
      },
      {
         "PERMITID": "CRL10-021",
         "APN": 25940091,
         "File Number": "CRL10-021",
         "Address": "55 S MARKET ST SAN JOSE",
         "Project Name": "CRL10-021",
         "Application Type": "Comprehensive Research Letter ",
         "Application Date": "7/19/10 9:20",
         "Status": "Complete ",
         "Description": "Comprehensive Research Letter ",
         "Planner": "Mike Enderby ",
         "DURATION": 14,
         "Year": 2010
      },
      {
         "PERMITID": "CRL10-030",
         "APN": 26415065,
         "File Number": "CRL10-030",
         "Address": "720 W SAN CARLOS ST SAN JOSE",
         "Project Name": "CRL10-030",
         "Application Type": "Comprehensive Research Letter ",
         "Application Date": "9/2/10 14:14",
         "Status": "Complete ",
         "Description": "Zoning verification letter: - Copies of conditions of approval - Copies of approved site plan - Copies of entitlements ",
         "Planner": "John Davidson ",
         "DURATION": 1,
         "Year": 2010
      },
      {
         "PERMITID": "CRL11-014",
         "APN": 25941057,
         "File Number": "CRL11-014",
         "Address": "150 ALMADEN BL SAN JOSE",
         "Project Name": "CRL11-014",
         "Application Type": "Comprehensive Research Letter ",
         "Application Date": "2/17/11 15:21",
         "Status": "Complete ",
         "Description": "COMPREHENSIVE RESEARCH LETTER REQUEST . ",
         "Planner": "Jeff Roche ",
         "DURATION": 19,
         "Year": 2011
      },
      {
         "PERMITID": "CRL11-014",
         "APN": 25941067,
         "File Number": "CRL11-014",
         "Address": "150 ALMADEN BL SAN JOSE",
         "Project Name": "CRL11-014",
         "Application Type": "Comprehensive Research Letter ",
         "Application Date": "2/17/11 15:21",
         "Status": "Complete ",
         "Description": "COMPREHENSIVE RESEARCH LETTER REQUEST . ",
         "Planner": "Jeff Roche ",
         "DURATION": 19,
         "Year": 2011
      },
      {
         "PERMITID": "CRL11-029",
         "APN": 26420099,
         "File Number": "CRL11-029",
         "Address": "481 AUZERAIS AV SAN JOSE",
         "Project Name": "CRL11-029",
         "Application Type": "Comprehensive Research Letter ",
         "Application Date": "6/13/11 16:54",
         "Status": "Complete ",
         "Description": "Comprehensive Research Letter to verify zoning and use ",
         "Planner": "Sylvia Do ",
         "DURATION": 30,
         "Year": 2011
      },
      {
         "PERMITID": "CRL11-040",
         "APN": 25942079,
         "File Number": "CRL11-040",
         "Address": "211 S 1ST ST SAN JOSE",
         "Project Name": "CRL11-040",
         "Application Type": "Comprehensive Research Letter ",
         "Application Date": "9/22/11 10:14",
         "Status": "Complete ",
         "Description": "Zoning verification ",
         "Planner": "MNAGARAJ ",
         "DURATION": 19,
         "Year": 2011
      },
      {
         "PERMITID": "CRL14-004",
         "APN": 46722007,
         "File Number": "CRL14-004",
         "Address": "52 S 1ST ST SAN JOSE",
         "Project Name": "CRL14-004",
         "Application Type": "Comprehensive Research Letter ",
         "Application Date": "7/18/14",
         "Status": "Denied ",
         "Description": "Zoning verification for medical marijuana collective, San Jose Medicinals. ",
         "Planner": "Jenny Nusbaum ",
         "DURATION": 1,
         "Year": 2014
      },
      {
         "PERMITID": "CRL14-079",
         "APN": 46722007,
         "File Number": "CRL14-079",
         "Address": "52 S 1ST ST SAN JOSE",
         "Project Name": "CRL14-079",
         "Application Type": "Comprehensive Research Letter ",
         "Application Date": "11/5/14 14:02",
         "Status": "Denied ",
         "Description": "Zoning verification letter for medical marijuana collective, San Jose Medicinal #2",
         "Planner": "Pick ",
         "DURATION": 37,
         "Year": 2014
      }
   ],
   "Conditional Use Permit ": [
      {
         "PERMITID": "CP01-071",
         "APN": 26420112,
         "File Number": "CP01-071",
         "Address": "530 W SAN CARLOS ST SAN JOSE",
         "Project Name": "CP01-071",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "8/24/01 15:06",
         "Status": "Approved ",
         "Description": "Conditional Use Permit to allow pawnshop use in existing building on a 0.08 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 209,
         "Year": 2001
      },
      {
         "PERMITID": "CP01-097",
         "APN": 47218002,
         "File Number": "CP01-097",
         "Address": "792 S 3RD ST SAN JOSE",
         "Project Name": "CP01-097 Life Choice",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "11/20/01 13:08",
         "Status": "Approved ",
         "Description": "Conditional Use Permit to allow a residential service facility for 10 residents and 2 staff members in an existing single-family detached residence on a 0.11 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 1297,
         "Year": 2001
      },
      {
         "PERMITID": "CP02-009",
         "APN": 25938142,
         "File Number": "CP02-009",
         "Address": "384 W SANTA CLARA ST SAN JOSE",
         "Project Name": "CP02-009",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "2/27/02",
         "Status": "Approved ",
         "Description": "Conditional Use Permit to allow temporary use of off-street parking lot for arcade/amusement on a 4.53 gross acre site",
         "Planner": "Akoni Danielsen ",
         "DURATION": 331,
         "Year": 2002
      },
      {
         "PERMITID": "CP03-054",
         "APN": 46719059,
         "File Number": "CP03-054",
         "Address": "73 N 6TH ST SAN JOSE",
         "Project Name": "CP03-054",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "8/26/03",
         "Status": "Approved ",
         "Description": "Conditional Use Permit to legalize a 390 square feet unpermitted addition and to add an additional 130 square feet to the rear of an existing single-room-occupancy living unit on a 0.16 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 303,
         "Year": 2003
      },
      {
         "PERMITID": "CP03-061",
         "APN": 46718090,
         "File Number": "CP03-061",
         "Address": "301 E SANTA CLARA ST SAN JOSE",
         "Project Name": "CP03-061 - E SC St 24 hr use",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "10/16/03",
         "Status": "Approved ",
         "Description": "Conditional Use Permit to allow operation after midnight till 3:00 am for an existing restaurant and exterior modifications on a 0.22 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 183,
         "Year": 2003
      },
      {
         "PERMITID": "CP03-067",
         "APN": 47228078,
         "File Number": "CP03-067",
         "Address": "561 S 9TH ST SAN JOSE",
         "Project Name": "CP03-067 - 9th St Substance Abuse w/ Project 90",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "11/7/03",
         "Status": "Approved ",
         "Description": "Conditional Use Permit to allow \"Residential Substance Abuse Treatment Facility\" for up to 18 adults and up to 3 staff (non-resident) on a 0.14 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 230,
         "Year": 2003
      },
      {
         "PERMITID": "CP03-072",
         "APN": 46720087,
         "File Number": "CP03-072",
         "Address": "40 N 4TH ST SAN JOSE",
         "Project Name": "CP03-072",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "11/24/03",
         "Status": "Approved ",
         "Description": "Conditional Use Permit to allow construction of 2,000 square feet for temporary homeless shelter for teenagers on a 0.55 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 17,
         "Year": 2003
      },
      {
         "PERMITID": "CP04-013",
         "APN": 46722148,
         "File Number": "CP04-013",
         "Address": "66 E SANTA CLARA ST SAN JOSE",
         "Project Name": "CP04-013",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "2/24/04",
         "Status": "Approved ",
         "Description": "Conditional Use Permit to allow entertainment and drinking establishment which includes ( cocktail lounge, dancing, live music, pool tables, kareoke) and to operate after midnight between 12:00 - 2:00 am on a 0.41 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 121,
         "Year": 2004
      },
      {
         "PERMITID": "CP04-025",
         "APN": 25939120,
         "File Number": "CP04-025",
         "Address": "95 S ALMADEN AV SAN JOSE",
         "Project Name": "CP04-025",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "3/19/04",
         "Status": "Approved ",
         "Description": "Conditional Use Permit to allow roof top installation of a standby/backup diesel generator for an existing office use on a 1.15 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 122,
         "Year": 2004
      },
      {
         "PERMITID": "CP04-050",
         "APN": 46722110,
         "File Number": "CP04-050",
         "Address": "1 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "CP04-050 - Blue Monkey",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "5/26/04",
         "Status": "Approved ",
         "Description": "Conditional Use Permit to amend condition of the previously appoved permit RCP03-029 to allow live entertainment at an existing restaurant and night club on a 0.11 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 1142,
         "Year": 2004
      },
      {
         "PERMITID": "CP04-089",
         "APN": 46746044,
         "File Number": "CP04-089",
         "Address": "372 S 1ST ST SAN JOSE",
         "Project Name": "CP04-089",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "9/8/04",
         "Status": "Approved ",
         "Description": "Conditional Use Permit to allow on-sale of alcoholic beverages, entertainment and eating establishments, at an existing bar/lounge, previously approved RCP98-09-12 for nightclub and operation after midnight to 2:00am expired, on a 0.11-acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 51,
         "Year": 2004
      },
      {
         "PERMITID": "CP04-093",
         "APN": 46762017,
         "File Number": "CP04-093",
         "Address": "8 S 1ST ST SAN JOSE",
         "Project Name": "CP04-093",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "9/23/04",
         "Status": "Approved ",
         "Description": "Conditional Use Permit to allow entertainment, drinking establishment, and operation after midnight to 2:00am on a 0.39 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 118,
         "Year": 2004
      },
      {
         "PERMITID": "CP05-022",
         "APN": 46747090,
         "File Number": "CP05-022",
         "Address": "400 S 1ST ST SAN JOSE",
         "Project Name": "CP05-022",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "4/21/05",
         "Status": "Approved ",
         "Description": "Conditional Use Permit to allow the continuation of a nightclub and entertainment establishment use (previous permit RCP99-09-015 allowed to lapse) with hours of operation after midnight on a 0.15 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 188,
         "Year": 2005
      },
      {
         "PERMITID": "CP05-031",
         "APN": 25935045,
         "File Number": "CP05-031",
         "Address": "170 W ST JOHN ST SAN JOSE",
         "Project Name": "CP05-031",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "5/26/05",
         "Status": "Approved ",
         "Description": "Conditional Use Permit to allow incidental non-applified acoustic music and vocals in conjuction with dining on the outdoor front patio of an existing restaurant/night club on 0.19 gross acre site.",
         "Planner": "Dave Tymn ",
         "DURATION": 490,
         "Year": 2005
      },
      {
         "PERMITID": "CP05-037",
         "APN": 46746047,
         "File Number": "CP05-037",
         "Address": "396 S 1ST ST SAN JOSE",
         "Project Name": "CP05-037",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "6/23/05",
         "Status": "Approved ",
         "Description": "Conditional Use Permit to allow an existing nightclub with late night use until 2:00 a.m. on a 0.21 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 179,
         "Year": 2005
      },
      {
         "PERMITID": "CP06-045",
         "APN": 25940086,
         "File Number": "CP06-045",
         "Address": "60 S MARKET ST SAN JOSE",
         "Project Name": "CP06-045 A Perfect Finish",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "7/19/06",
         "Status": "Approved ",
         "Description": "Conditional Use Permit to allow a drinking establishment, late night use until 2:00 a.m., and off-sale of alcoholic beverages at a wine and dessert bar on a 0.14 gross acre site",
         "Planner": "Michelle Stahlhut ",
         "DURATION": 208,
         "Year": 2006
      },
      {
         "PERMITID": "CP06-050",
         "APN": 46722110,
         "File Number": "CP06-050",
         "Address": "33 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "CP06-050",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "8/7/06",
         "Status": "Approved ",
         "Description": "Conditional Use Permit to allow an existing eating and drinking establishment, outdoor patio, and late night use until 2:00 a.m.",
         "Planner": "Lesley Xavier ",
         "DURATION": 163,
         "Year": 2006
      },
      {
         "PERMITID": "CP06-050",
         "APN": 46722127,
         "File Number": "CP06-050",
         "Address": "33 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "CP06-050",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "8/7/06",
         "Status": "Approved ",
         "Description": "Conditional Use Permit to allow an existing eating and drinking establishment, outdoor patio, and late night use until 2:00 a.m.",
         "Planner": "Lesley Xavier ",
         "DURATION": 163,
         "Year": 2006
      },
      {
         "PERMITID": "CP06-051",
         "APN": 46722006,
         "File Number": "CP06-051",
         "Address": "48 S 1ST ST SAN JOSE",
         "Project Name": "CP06-051 Koji Sake Lounge",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "8/9/06",
         "Status": "Approved ",
         "Description": "Conditional Use Permit to allow an eating and drinking establishment and late night use until 2:00 a.m. on a 0.05 gross acre site in the DC Downtown Primary Commercial Zoning District",
         "Planner": "Michelle Stahlhut ",
         "DURATION": 155,
         "Year": 2006
      },
      {
         "PERMITID": "CP07-011",
         "APN": 25940049,
         "File Number": "CP07-011",
         "Address": "39 POST ST SAN JOSE",
         "Project Name": "CP07-011",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "2/8/07",
         "Status": "Approved ",
         "Description": "Conditional Use Permit to allow a drinking establishment with late night use until 2:00 a.m. including an outdoor patio at an existing building on a 0.03 gross acre site",
         "Planner": "Steven Rosen ",
         "DURATION": 293,
         "Year": 2007
      },
      {
         "PERMITID": "CP07-027",
         "APN": 46723069,
         "File Number": "CP07-027",
         "Address": "32 S 3RD ST SAN JOSE",
         "Project Name": "CP07-027 The Reserve",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "4/13/07",
         "Status": "Approved ",
         "Description": "Conditional Use Permit to convert existing office space to an art gallery, public eating, drinking, and entertainment establishment and late night use until 2:00 a.m. daily on a 0.02 gross acre site",
         "Planner": "Michelle Stahlhut ",
         "DURATION": 392,
         "Year": 2007
      },
      {
         "PERMITID": "CP07-034",
         "APN": 25935051,
         "File Number": "CP07-034",
         "Address": "69 N SAN PEDRO ST SAN JOSE",
         "Project Name": "CP07-034 Flying Martini Bros.",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "5/7/07",
         "Status": "Approved ",
         "Description": "Conditional Use Permit Renewal to allow an existing public eating, drinking, and entertainment establishment and late night use until 2:00 a.m. daily",
         "Planner": "Michelle Stahlhut ",
         "DURATION": 160,
         "Year": 2007
      },
      {
         "PERMITID": "CP07-106",
         "APN": 46722031,
         "File Number": "CP07-106",
         "Address": "83 S 2ND ST SAN JOSE",
         "Project Name": "CP07-106 - Tres Gringos",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "12/20/07",
         "Status": "Approved ",
         "Description": "Conditional Use Permit Renewal for a drinking and entertainment establishment and late night use until 2:00 a.m. on a 0.06 gross acre site",
         "Planner": "Licinia McMorrow ",
         "DURATION": 355,
         "Year": 2007
      },
      {
         "PERMITID": "CP08-016",
         "APN": 25940001,
         "File Number": "CP08-016",
         "Address": "44 S ALMADEN AV SAN JOSE",
         "Project Name": "CP08-016 The Blank Club",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "2/13/08",
         "Status": "Approved ",
         "Description": "Conditional Use Permit Renewal to a previously approved permit file no. RCP03-004 to allow a drinking and entertainment establishment and late night use until 2:00 a.m. daily",
         "Planner": "Misty Mersich ",
         "DURATION": 114,
         "Year": 2008
      },
      {
         "PERMITID": "CP08-038",
         "APN": 46721025,
         "File Number": "CP08-038",
         "Address": "31 E SANTA CLARA ST SAN JOSE",
         "Project Name": "CP08-038 JOHNNY V'S BAR",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "4/29/08",
         "Status": "Approved ",
         "Description": "Conditional Use Permit to allow a public drinking establishment and after midnight operation until 2:00a.m, on a 0.07 gross acre site.",
         "Planner": "Licinia McMorrow ",
         "DURATION": 259,
         "Year": 2008
      },
      {
         "PERMITID": "CP08-043",
         "APN": 25934018,
         "File Number": "CP08-043",
         "Address": "81 W SANTA CLARA ST SAN JOSE",
         "Project Name": "CP08-043 Vault Nightclub",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "5/15/08",
         "Status": "Approved ",
         "Description": "Conditional Use Permit RENEWAL to allow continued operation of an existing entertainment business with on-sale of alcoholic beverages and late night use until 2:00 am.",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 634,
         "Year": 2008
      },
      {
         "PERMITID": "CP08-049",
         "APN": 46722007,
         "File Number": "CP08-049",
         "Address": "52 S 1ST ST SAN JOSE",
         "Project Name": "CP08-049, THE TEMPLE BAR & LOUNGE",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "5/28/08",
         "Status": "Approved ",
         "Description": "Conditional Use Permit Renewal to allow continued operation of a public drinking and live entertainment establishment with late night use until 2 a.m. daily",
         "Planner": "Jenny Nusbaum ",
         "DURATION": 1370,
         "Year": 2008
      },
      {
         "PERMITID": "CP08-056",
         "APN": 46764005,
         "File Number": "CP08-056",
         "Address": "100 S 2ND ST Unit C-106 SAN JOSE",
         "Project Name": "CP08-056 Tower 88 Retail",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "6/18/08",
         "Status": "Approved ",
         "Description": "Conditional Use Permit to allow off-sale of alcoholic beverages in an existing commercial use on a 1.33 gross acres site",
         "Planner": "Mike Enderby ",
         "DURATION": 811,
         "Year": 2008
      },
      {
         "PERMITID": "CP08-056",
         "APN": 46764010,
         "File Number": "CP08-056",
         "Address": "100 S 2ND ST Unit C-106 SAN JOSE",
         "Project Name": "CP08-056 Tower 88 Retail",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "6/18/08",
         "Status": "Approved ",
         "Description": "Conditional Use Permit to allow off-sale of alcoholic beverages in an existing commercial use on a 1.33 gross acres site",
         "Planner": "Mike Enderby ",
         "DURATION": 811,
         "Year": 2008
      },
      {
         "PERMITID": "CP08-058",
         "APN": 25935056,
         "File Number": "CP08-058",
         "Address": "73 N SAN PEDRO ST SAN JOSE",
         "Project Name": "CP08-058 - No Name Saloon and Grille",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "6/30/08",
         "Status": "Approved ",
         "Description": "Conditional Use Permit to allow operation of a public eating/drinking establishment, and after midnight operation until 2:00 am on a 0.22-gross acre site.",
         "Planner": "Ella Samonsky ",
         "DURATION": 162,
         "Year": 2008
      },
      {
         "PERMITID": "CP08-063",
         "APN": 25940070,
         "File Number": "CP08-063",
         "Address": "98 S ALMADEN AV SAN JOSE",
         "Project Name": "CP08-063 Caravan",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "7/9/08",
         "Status": "Approved ",
         "Description": "Conditional Use Permit Renewal to allow operation of a public drinking and entertainment establishment with late night use until 2:00 am.",
         "Planner": "Licinia McMorrow ",
         "DURATION": 187,
         "Year": 2008
      },
      {
         "PERMITID": "CP08-069",
         "APN": 25940064,
         "File Number": "CP08-069",
         "Address": "25 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "CP08-069 Mezcal",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "7/28/08",
         "Status": "Approved ",
         "Description": "Conditional Use Permit to allow operation of a drinking and entertainment establishment as part of a full service restaurant with late night use until 2:00 am on a 0.22 gross acre site.",
         "Planner": "Licinia McMorrow ",
         "DURATION": 165,
         "Year": 2008
      },
      {
         "PERMITID": "CP08-070",
         "APN": 25940064,
         "File Number": "CP08-070",
         "Address": "99 S 1ST ST SAN JOSE",
         "Project Name": "CP08-070 Billy Berk's",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "8/28/08",
         "Status": "Approved ",
         "Description": "Conditional Use Permit to allow operation of a drinking and entertainment establishment as part of a full service restaurant with late night use until 2:00 am on a 0.22 gross acre site.",
         "Planner": "Licinia McMorrow ",
         "DURATION": 137,
         "Year": 2008
      },
      {
         "PERMITID": "CP08-090",
         "APN": 25934043,
         "File Number": "CP08-090",
         "Address": "19 N MARKET ST SAN JOSE",
         "Project Name": "CP08-090 - 19 N. Market",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "12/9/08",
         "Status": "Approved ",
         "Description": "Conditional Use Permit for a public drinking establishment with late night use until 2:00 a.m. and incidental live entertainment at an existing restaurant on a 0.07 gross acre site",
         "Planner": "Licinia McMorrow ",
         "DURATION": 633,
         "Year": 2008
      },
      {
         "PERMITID": "CP08-094",
         "APN": 46762016,
         "File Number": "CP08-094",
         "Address": "14 S 1ST ST SAN JOSE",
         "Project Name": "CP08-094",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "12/19/08",
         "Status": "Approved ",
         "Description": "Conditional Use Permit to allow continued operation of a pawnshop as incidental to a jewelry store on 0.4 gross acre site",
         "Planner": "Licinia McMorrow ",
         "DURATION": 0,
         "Year": 2008
      },
      {
         "PERMITID": "CP09-020",
         "APN": 46724069,
         "File Number": "CP09-020",
         "Address": "304 E SANTA CLARA ST SAN JOSE",
         "Project Name": "CP09-020, SPICE Restaurant",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "4/21/09",
         "Status": "Approved ",
         "Description": "Conditional Use Permit to allow operation after midnight until 3:00am Thursday to Saturday and 1:00am Sunday to Wednesday for the consumption of food and alcoholic drinks in an existing restaurant on a 0.05 gross acre site",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 290,
         "Year": 2009
      },
      {
         "PERMITID": "CP09-021",
         "APN": 46722148,
         "File Number": "CP09-021",
         "Address": "66 E SANTA CLARA ST SAN JOSE",
         "Project Name": "CP09-021- DIVE BAR (was CPA04-013-01)",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "3/13/09",
         "Status": "Approved ",
         "Description": "Conditional Use Permit RENEWAL to allow entertainment and drinking establishment with late night use until 2:00am at an existing commercial business on a 0.43 gross acre site",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 328,
         "Year": 2009
      },
      {
         "PERMITID": "CP09-025",
         "APN": 25935035,
         "File Number": "CP09-025",
         "Address": "163 W SANTA CLARA ST SAN JOSE",
         "Project Name": "CP09-025 - AP STUMPS",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "4/29/09",
         "Status": "Approved ",
         "Description": "Conditional Use Permit to allow use as a drinking establishment and an entertainment establishment at an existing restaurant on a 0.2 gross acre site",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 281,
         "Year": 2009
      },
      {
         "PERMITID": "CP09-033",
         "APN": 26420079,
         "File Number": "CP09-033",
         "Address": "486 W SAN CARLOS ST SAN JOSE",
         "Project Name": "CP09-033 Kidsville Preschool",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "6/30/09",
         "Status": "Approved ",
         "Description": "Conditional Use Permit to convert an existing office building to child daycare use on a 0.53 gross acre site in the CP Commercial Pedestrian Zoning District (no new construction included)",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 262,
         "Year": 2009
      },
      {
         "PERMITID": "CP09-033",
         "APN": 26420110,
         "File Number": "CP09-033",
         "Address": "486 W SAN CARLOS ST SAN JOSE",
         "Project Name": "CP09-033 Kidsville Preschool",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "6/30/09",
         "Status": "Approved ",
         "Description": "Conditional Use Permit to convert an existing office building to child daycare use on a 0.53 gross acre site in the CP Commercial Pedestrian Zoning District (no new construction included)",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 262,
         "Year": 2009
      },
      {
         "PERMITID": "CP09-033",
         "APN": 26420128,
         "File Number": "CP09-033",
         "Address": "486 W SAN CARLOS ST SAN JOSE",
         "Project Name": "CP09-033 Kidsville Preschool",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "6/30/09",
         "Status": "Approved ",
         "Description": "Conditional Use Permit to convert an existing office building to child daycare use on a 0.53 gross acre site in the CP Commercial Pedestrian Zoning District (no new construction included)",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 262,
         "Year": 2009
      },
      {
         "PERMITID": "CP10-029",
         "APN": 46724012,
         "File Number": "CP10-029",
         "Address": "80 S 5TH ST SAN JOSE",
         "Project Name": "CP10-029",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "5/20/10",
         "Status": "Approved ",
         "Description": "A Conditional Use Permit to allow for the conversion of six (6) existing school rooms located within an existing church to transitional housing units for up to 12 people (total) on a 0.72 gross acre site",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 0,
         "Year": 2010
      },
      {
         "PERMITID": "CP11-036",
         "APN": 46721031,
         "File Number": "CP11-036",
         "Address": "81 N 2ND ST SAN JOSE",
         "Project Name": "CP11-036 TRINITY CATHEDRAL OF SAN JOSE",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "5/18/11",
         "Status": "Approved ",
         "Description": "Conditional Use Permit to install a columbarium within an existing religious assembly building on a 0.61 gross acre site. No exterior changes are proposed.",
         "Planner": "Jodie Clark ",
         "DURATION": 92,
         "Year": 2011
      },
      {
         "PERMITID": "CP11-040",
         "APN": 46724111,
         "File Number": "CP11-040",
         "Address": "272 E SANTA CLARA ST SAN JOSE",
         "Project Name": "CP11-040 FRESH & EASY",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "6/9/11",
         "Status": "Approved ",
         "Description": "Conditional Use Permit to allow off-sale of beer and wine for a full-service market in a 17,587 s.f. tenant space in an approximately 24,000 s.f. building on an approximately 1.48 gross-acre site",
         "Planner": "Jenny Nusbaum ",
         "DURATION": 244,
         "Year": 2011
      },
      {
         "PERMITID": "CP12-001",
         "APN": 46718090,
         "File Number": "CP12-001",
         "Address": "301 E SANTA CLARA ST SAN JOSE",
         "Project Name": "CP12-001",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "1/9/12",
         "Status": "Approved ",
         "Description": "Conditional Use Permit for late night use until 3:00 am for a previously operating bakery and cafe for an expired permit on a 0.22-gross-acre site",
         "Planner": "Jenny Nusbaum ",
         "DURATION": 120,
         "Year": 2012
      },
      {
         "PERMITID": "CP12-015",
         "APN": 46723069,
         "File Number": "CP12-015",
         "Address": "32 S 3RD ST SAN JOSE",
         "Project Name": "CP12-015",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "4/24/12",
         "Status": "Approved ",
         "Description": "Conditional Use Permit request to allow the continued use of an eating and drinking establishment and late night use until 2:00 a.m. in the DC Downtown Primary Commercial Zoning District on an approximately 0.11 gross-acre site",
         "Planner": "Jenny Nusbaum ",
         "DURATION": 151,
         "Year": 2012
      },
      {
         "PERMITID": "CP12-039",
         "APN": 46722003,
         "File Number": "CP12-039",
         "Address": "30 S 1ST ST SAN JOSE",
         "Project Name": "CP12-039",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "9/14/12",
         "Status": "Approved ",
         "Description": "A Conditional Use Permit to allow the continued use of an existing public drinking establishment with late night use in the Downtown Zoning District on the subject 0.14 gross acre site.",
         "Planner": "Aparna Ankola ",
         "DURATION": 74,
         "Year": 2012
      },
      {
         "PERMITID": "CP12-041",
         "APN": 46720041,
         "File Number": "CP12-041",
         "Address": "115 N 4TH ST SAN JOSE",
         "Project Name": "CP12-041 - Hookah Beats",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "10/22/12",
         "Status": "Approved ",
         "Description": "Conditional Use Permit to allow after midnight use to 3 a.m. to an existing hookah lounge, Hookah Beats in the CG Commercial General Zoning District on a 0.44 gross acre site",
         "Planner": "Aparna Ankola ",
         "DURATION": 0,
         "Year": 2012
      },
      {
         "PERMITID": "CP12-043",
         "APN": 25940049,
         "File Number": "CP12-043",
         "Address": "39 POST ST SAN JOSE",
         "Project Name": "CP12-043 Mac's Club",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "10/16/12",
         "Status": "Approved ",
         "Description": "Conditional Use Permit to allow the continued operation of a drinking establishment, MAC's club, with after-midnight use in the Downtown Zoning District on .19 gross acre site",
         "Planner": "Aparna Ankola ",
         "DURATION": 31,
         "Year": 2012
      },
      {
         "PERMITID": "CP13-051",
         "APN": 46722006,
         "File Number": "CP13-051",
         "Address": "48 S 1ST ST SAN JOSE",
         "Project Name": "CP13-051",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "7/11/13",
         "Status": "Approved ",
         "Description": "Conditional Use Permit to allow late night use to 2:00 a.m. at an existing 2,021 square foot public eating and drinking establishment (Koji Sake Lounge) on a 0.05 gross acre site",
         "Planner": "Rebecca Bustos ",
         "DURATION": 78,
         "Year": 2013
      },
      {
         "PERMITID": "CP13-092",
         "APN": 25934018,
         "File Number": "CP13-092",
         "Address": "81 W SANTA CLARA ST SAN JOSE",
         "Project Name": "CP13-092",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "12/18/13",
         "Status": "Approved ",
         "Description": "Conditional Use Permit Timely RENEWAL to allow continued operation of an existing entertainment business with on-sale of alcoholic beverages and late night use until 2:00 am.",
         "Planner": "Aparna Ankola ",
         "DURATION": 145,
         "Year": 2013
      },
      {
         "PERMITID": "CP14-002",
         "APN": 26429065,
         "File Number": "CP14-002",
         "Address": "387 S 1ST ST SAN JOSE",
         "Project Name": "CP14-002",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "1/10/14",
         "Status": "Approved ",
         "Description": "Conditional Use Permit to allow a drinking establishment to operate until 12:00am on an approximately 0.22 gross acre site in the DC Downtown Primary Commercial Zoning District",
         "Planner": "Wayne Farrens ",
         "DURATION": 91,
         "Year": 2014
      },
      {
         "PERMITID": "CP14-048",
         "APN": 25936039,
         "File Number": "CP14-048",
         "Address": "320 W ST JOHN ST SAN JOSE",
         "Project Name": "CP14-048",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "8/27/14 11:37",
         "Status": "Approved ",
         "Description": "Conditional Use Permit to allow a 5,354 square foot restaurant/wine bar with off-sale of alcohol within an existing building on an approximately 0.18 gross acre site",
         "Planner": "Aparna Ankola ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "CP14-051",
         "APN": 25940034,
         "File Number": "CP14-051",
         "Address": "84 W SANTA CLARA ST SAN JOSE",
         "Project Name": "CP14-051",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "9/9/14 10:19",
         "Status": "Approved ",
         "Description": "Conditional Use Permit to allow after-midnight use until 2:00 a.m. for a public eating establishment, drinking establishment (for more than 250 people), and banquet facility, The Glass House, on 0.46 gross acre site.",
         "Planner": "Jennifer Piozet ",
         "DURATION": 1058,
         "Year": 2014
      },
      {
         "PERMITID": "CP15-004",
         "APN": 46747090,
         "File Number": "CP15-004",
         "Address": "400 S 1ST ST SAN JOSE",
         "Project Name": "CP15-004",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "1/8/15 15:10",
         "Status": "Approved ",
         "Description": "Conditional Use Permit to allow an after-midnight for a new drinking establishment, the Spectrum, in the DC Downtown Core on .15 gross acre site",
         "Planner": "Lea Simvoulakis ",
         "DURATION": 92,
         "Year": 2015
      },
      {
         "PERMITID": "CP15-013",
         "APN": 46701002,
         "File Number": "CP15-013",
         "Address": "261 N 2ND ST SAN JOSE",
         "Project Name": "CP15-013 Germania",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "2/24/15 15:16",
         "Status": "Approved ",
         "Description": "Conditional Use Permit to modify the hours of operation for an existing restaurant (Germania Verein) to be open from 7:00 a.m. to 12:00 midnight, with an outdoor patio from 7:00 a.m. to 10:00 p.m. on a 0.2-gross acre site.",
         "Planner": "Jennifer Piozet ",
         "DURATION": 345,
         "Year": 2015
      },
      {
         "PERMITID": "CP15-043",
         "APN": 25940086,
         "File Number": "CP15-043",
         "Address": "55 S 1ST ST SAN JOSE",
         "Project Name": "CP15-043 (55 South)",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "6/19/15 16:14",
         "Status": "Approved ",
         "Description": "Conditional Use Permit to allow the continued use and expansion of an existing, 2,480-sqare foot drinking establishment (55 South), including off-sale of wine, until 2:00 a.m. on a 0.08-acre site",
         "Planner": "Patrick Kelly ",
         "DURATION": 122,
         "Year": 2015
      },
      {
         "PERMITID": "CP15-049",
         "APN": 47218007,
         "File Number": "CP15-049",
         "Address": "143 E VIRGINIA ST SAN JOSE",
         "Project Name": "CP15-049",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "8/3/15",
         "Status": "Approved ",
         "Description": "Conditional Use Permit to allow a 1600-square-foot Social Service Agency (food distribution site for a voucher system) in an existing building on an approximately 1.0 gross acre site",
         "Planner": "Edward Schreiner ",
         "DURATION": 442,
         "Year": 2015
      },
      {
         "PERMITID": "CP15-050",
         "APN": 26415064,
         "File Number": "CP15-050",
         "Address": "720 W SAN CARLOS ST SAN JOSE",
         "Project Name": "CP15-050",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "9/3/15",
         "Status": "Approved ",
         "Description": "Conditional Use Permit to allow the off-sale of alcohol of a full range of alcoholic beverages at a 30,455 square foot full service grocery store (Smart & Final) on a 2.78 gross acre site",
         "Planner": "Rebecca Bustos ",
         "DURATION": 317,
         "Year": 2015
      },
      {
         "PERMITID": "CP15-050",
         "APN": 26415065,
         "File Number": "CP15-050",
         "Address": "720 W SAN CARLOS ST SAN JOSE",
         "Project Name": "CP15-050",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "9/3/15",
         "Status": "Approved ",
         "Description": "Conditional Use Permit to allow the off-sale of alcohol of a full range of alcoholic beverages at a 30,455 square foot full service grocery store (Smart & Final) on a 2.78 gross acre site",
         "Planner": "Rebecca Bustos ",
         "DURATION": 317,
         "Year": 2015
      },
      {
         "PERMITID": "CP16-046",
         "APN": 47217018,
         "File Number": "CP16-046",
         "Address": "718 S 1ST ST SAN JOSE",
         "Project Name": "CP16-046 - CAMINO BEER COMPANY",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "8/26/16 11:26",
         "Status": "Approved ",
         "Description": "Conditional Use Permit to allow a brewery, drinking establishment (tasting room), and the off-sale of alcohol (beer and wine) in an existing 4,187-square foot building on 0.13-gross acre site",
         "Planner": "Jennifer Piozet ",
         "DURATION": 279,
         "Year": 2016
      },
      {
         "PERMITID": "CP86-032",
         "APN": 26429058,
         "File Number": "CP86-032",
         "Address": "325 S 1ST ST SAN JOSE",
         "Project Name": "CP86-032",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "6/18/86",
         "Status": "Approved ",
         "Description": "MASSAGE PARLOR ",
         "Planner": "Larry Bohannan ",
         "DURATION": 0,
         "Year": 1986
      },
      {
         "PERMITID": "CP88-076",
         "APN": 46702116,
         "File Number": "CP88-076",
         "Address": "268 E JULIAN ST SAN JOSE",
         "Project Name": "CP88-076",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "12/19/88",
         "Status": "Approved ",
         "Description": "ADD. TO A CHURCH SET FOR 4/1",
         "Planner": "Larry Bohannan ",
         "DURATION": 0,
         "Year": 1988
      },
      {
         "PERMITID": "CP88-081",
         "APN": 46722003,
         "File Number": "CP88-081",
         "Address": "30 S 1ST ST SAN JOSE",
         "Project Name": "CP88-081",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "12/9/88",
         "Status": "Approved ",
         "Description": "NIGHTCLUB,PC46587=ALTERATION",
         "Planner": "Vic Mendez ",
         "DURATION": 0,
         "Year": 1988
      },
      {
         "PERMITID": "CP89-031",
         "APN": 26429058,
         "File Number": "CP89-031",
         "Address": "325 S 1ST ST SAN JOSE",
         "Project Name": "CP89-031",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "6/6/89",
         "Status": "Approved ",
         "Description": "RESTAURANT & BAR ",
         "Planner": "Vic Mendez ",
         "DURATION": 0,
         "Year": 1989
      },
      {
         "PERMITID": "CP90-008",
         "APN": 47226033,
         "File Number": "CP90-008",
         "Address": "490 S 1ST ST SAN JOSE",
         "Project Name": "CP90-008",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "2/9/90",
         "Status": "Approved ",
         "Description": "NO EXP DATE ",
         "Planner": "Vic Mendez ",
         "DURATION": 0,
         "Year": 1990
      },
      {
         "PERMITID": "CP90-009",
         "APN": 26429058,
         "File Number": "CP90-009",
         "Address": "325 S 1ST ST SAN JOSE",
         "Project Name": "CP90-009",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "2/13/90",
         "Status": "Approved ",
         "Description": "File type: *Other apns: *Gen.Use Class:*Existing Land Use:53*Specific Use:DANCE CLUB/STUDIO",
         "Planner": "Vic Mendez ",
         "DURATION": 0,
         "Year": 1990
      },
      {
         "PERMITID": "CP90-015",
         "APN": 25936039,
         "File Number": "CP90-015",
         "Address": "99 PLEASANT ST SAN JOSE",
         "Project Name": "CP90-015",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "3/5/90",
         "Status": "Approved ",
         "Description": "File type: *Other apns: *Gen.Use Class:*Existing Land Use:07*Specific Use:RESIDENTIAL CARE",
         "Planner": "LCARRILL ",
         "DURATION": 0,
         "Year": 1990
      },
      {
         "PERMITID": "CP90-020",
         "APN": 47218007,
         "File Number": "CP90-020",
         "Address": "143 E VIRGINIA ST SAN JOSE",
         "Project Name": "CP90-020",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "4/4/90",
         "Status": "Approved ",
         "Description": "File type: *Other apns: *Gen.Use Class:*Existing Land Use:59*Specific Use:HANDICAP. TRAINING",
         "Planner": "Rich Buikema ",
         "DURATION": 0,
         "Year": 1990
      },
      {
         "PERMITID": "CP90-049",
         "APN": 25935056,
         "File Number": "CP90-049",
         "Address": "73 N SAN PEDRO ST SAN JOSE",
         "Project Name": "CP90-049",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "8/24/90",
         "Status": "Approved ",
         "Description": "NO EXP DATE ",
         "Planner": "Vic Mendez ",
         "DURATION": 0,
         "Year": 1990
      },
      {
         "PERMITID": "CP91-020",
         "APN": 26420008,
         "File Number": "CP91-020",
         "Address": "358 ROYAL AV SAN JOSE",
         "Project Name": "CP91-020",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "6/19/91",
         "Status": "Approved ",
         "Description": "OFF-SALE LIQUOR, NO EXP DATE; Other APNs:,-009,-010,-021",
         "Planner": "Rich Buikema ",
         "DURATION": 0,
         "Year": 1991
      },
      {
         "PERMITID": "CP92-070",
         "APN": 24974003,
         "File Number": "CP92-070",
         "Address": "370 N 4TH ST SAN JOSE",
         "Project Name": "CP92-070",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "12/22/92",
         "Status": "Approved ",
         "Description": "PC9203033",
         "Planner": "KKOVAR ",
         "DURATION": 0,
         "Year": 1992
      },
      {
         "PERMITID": "CP92-070",
         "APN": 24974006,
         "File Number": "CP92-070",
         "Address": "370 N 4TH ST SAN JOSE",
         "Project Name": "CP92-070",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "12/22/92",
         "Status": "Approved ",
         "Description": "PC9203033",
         "Planner": "KKOVAR ",
         "DURATION": 0,
         "Year": 1992
      },
      {
         "PERMITID": "CP93-074",
         "APN": 26419067,
         "File Number": "CP93-074",
         "Address": " ",
         "Project Name": "CP93-074",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "12/9/93",
         "Status": "Approved ",
         "Description": "File type: *Other apns: *Gen.Use Class:*Existing Land Use:IND*Specific Use:DELI/BAKERY ",
         "Planner": "Jeff Roche ",
         "DURATION": 0,
         "Year": 1993
      },
      {
         "PERMITID": "CP95-039",
         "APN": 46717090,
         "File Number": "CP95-039",
         "Address": "25 N 14TH ST SAN JOSE",
         "Project Name": "CP95-039",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "7/14/95",
         "Status": "Approved ",
         "Description": "File type: *Other apns: *Gen.Use Class:*Existing Land Use:59*Specific Use:PCS UTILITY",
         "Planner": "LCARRILL ",
         "DURATION": 0,
         "Year": 1995
      },
      {
         "PERMITID": "CP95-064",
         "APN": 46717090,
         "File Number": "CP95-064",
         "Address": "425 E SANTA CLARA ST SAN JOSE",
         "Project Name": "CP95-064",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "10/24/95",
         "Status": "Approved ",
         "Description": "File type: *Other apns: *Gen.Use Class:*Existing Land Use:50*Specific Use:PCS ANTENNA",
         "Planner": "Salifu Yakubu ",
         "DURATION": 0,
         "Year": 1995
      },
      {
         "PERMITID": "CP97-012",
         "APN": 25938039,
         "File Number": "CP97-012",
         "Address": "45 DELMAS AV SAN JOSE",
         "Project Name": "CP97-012",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "3/13/97",
         "Status": "Approved ",
         "Description": "CIRCUS SITE ON 4.5 GR ACRES; Other APNs:-036 -040 -041 -042 -044 -048 -049 -050 -086 -111 -110 -109",
         "Planner": "Salifu Yakubu ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "CP98-034",
         "APN": 26420112,
         "File Number": "CP98-034",
         "Address": "530 W SAN CARLOS ST SAN JOSE",
         "Project Name": "CP98-034",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "8/6/98",
         "Status": "Approved ",
         "Description": "to allow a pawnshop on a vacant 0.083 acre parcel in an M-1 district",
         "Planner": "Akoni Danielsen ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "CP99-062",
         "APN": 25938039,
         "File Number": "CP99-062",
         "Address": "45 DELMAS AV SAN JOSE",
         "Project Name": "CP99-062",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "10/29/99",
         "Status": "Approved ",
         "Description": "Conditional Use Permit to allow a temporary circus (Cirque De Soleil) on a 4.5 gross acre site",
         "Planner": "Akoni Danielsen ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "CP99-062",
         "APN": 25938142,
         "File Number": "CP99-062",
         "Address": "45 DELMAS AV SAN JOSE",
         "Project Name": "CP99-062",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "10/29/99",
         "Status": "Approved ",
         "Description": "Conditional Use Permit to allow a temporary circus (Cirque De Soleil) on a 4.5 gross acre site",
         "Planner": "Akoni Danielsen ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RCP00-005",
         "APN": 26429118,
         "File Number": "RCP00-005",
         "Address": " ",
         "Project Name": "RCP00-005, Agenda Annex",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "10/1/01",
         "Status": "Approved ",
         "Description": "Allow construction of an approximately 8,500 sq. ft. entertainment facility with a restaurant to be open until 2:00 am daily.",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "RCP00-006",
         "APN": 25933050,
         "File Number": "RCP00-006",
         "Address": "255 N 1ST ST SAN JOSE",
         "Project Name": "RCP00-006, Teske's Germania",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "7/25/00",
         "Status": "Approved ",
         "Description": "Allow an existing restaurant/pub to operate past midnight unti 2:00 AM.",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "RCP00-007",
         "APN": 25933050,
         "File Number": "RCP00-007",
         "Address": " ",
         "Project Name": "RCP00-007, Trials Restaurant",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "7/25/00",
         "Status": "Approved ",
         "Description": "Allow an existing restaurant / pub to operate until 2:00 AM.",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "RCP00-008",
         "APN": 46722110,
         "File Number": "RCP00-008",
         "Address": "33 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "RCP00-008, Gordon Biersch",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "10/12/00",
         "Status": "Approved ",
         "Description": "Renewal of existing conditional use permit to allow an existing restaurant to operate past midnight until 2:00 am.",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "RCP00-008",
         "APN": 46722127,
         "File Number": "RCP00-008",
         "Address": "33 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "RCP00-008, Gordon Biersch",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "10/12/00",
         "Status": "Approved ",
         "Description": "Renewal of existing conditional use permit to allow an existing restaurant to operate past midnight until 2:00 am.",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "RCP00-012",
         "APN": 25939111,
         "File Number": "RCP00-012",
         "Address": " ",
         "Project Name": "RCP00-012, Marriott Courtyard",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "11/29/00",
         "Status": "Approved ",
         "Description": "Allow construction of a 221 room hotel with associate facilities and 5,500 sq. ft. of retail uses, including an off-site parking arrangement for 77 parking spaces in an adjacent garage on a 0.75 acre site.",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "RCP01-003",
         "APN": 25940070,
         "File Number": "RCP01-003",
         "Address": " ",
         "Project Name": "RCP01-003, Caravan Lounge",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "4/24/01",
         "Status": "Approved ",
         "Description": "Allow an existing bar to operate until 2:00 am, seven (7) days a week.",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "RCP01-005",
         "APN": 25940043,
         "File Number": "RCP01-005",
         "Address": " ",
         "Project Name": "RCP01-005, House of Blues",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "6/20/01",
         "Status": "Approved ",
         "Description": "Allow the operation of an entertainment establishment with food and alcohol service, live and recorded musical performances and retail sales in an existing building. ",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "RCP01-006",
         "APN": 25936074,
         "File Number": "RCP01-006",
         "Address": " ",
         "Project Name": "RCP01-006, Comerica Antennas",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "7/16/01",
         "Status": "Approved ",
         "Description": "Conditional Use Permit to allow addition of seven (7) wireless antennas of maximum ten (10) feet in height on roof top of an approximately one hundred fifty (150) foot high building.",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "RCP01-011",
         "APN": 46721005,
         "File Number": "RCP01-011",
         "Address": " ",
         "Project Name": "RCP01-011, Bella Cafe",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "12/21/01",
         "Status": "Approved ",
         "Description": "Allow the operation of public eating establishment, with sidewalk cafe, between the hours of 6 am and 2 am, daily.",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "RCP01-011",
         "APN": 46746030,
         "File Number": "RCP01-011",
         "Address": " ",
         "Project Name": "RCP01-011, Twohy Building",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "11/15/01",
         "Status": "Approved ",
         "Description": "Mixed-use project involving adaptive re-use and conversion of the City Landmark, five-story Twohy Building into 8,700 sq. ft. ground floor commercial space and 36 dwelling units on floors 2 - 5.",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "RCP02-001",
         "APN": 25935057,
         "File Number": "RCP02-001",
         "Address": " ",
         "Project Name": "RCP02-001, O'Flaherty's Pub",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "1/21/02",
         "Status": "Approved ",
         "Description": "Operation of a public eating and drinking establishment between the hours of 11:00 am and 2:00 am daily.",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2002
      },
      {
         "PERMITID": "RCP02-003",
         "APN": 46722031,
         "File Number": "RCP02-003",
         "Address": " ",
         "Project Name": "RCP02-003, San Jose Bar & Grill",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "3/25/02",
         "Status": "Approved ",
         "Description": "Operation of a public eating establishment with sidewalk cafe and entertainment between the hours of 9 am and 2 am daily, with service of alcoholic beverages ceasing at 1:30 am - includes a liquor license exception permit.",
         "Planner": "Judie Gilli/Amie Glaser ",
         "DURATION": 0,
         "Year": 2002
      },
      {
         "PERMITID": "RCP02-008",
         "APN": 46746105,
         "File Number": "RCP02-008",
         "Address": " ",
         "Project Name": "RCP02-008, Cinelux Theatre",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "6/3/02",
         "Status": "Approved ",
         "Description": "Reopening of movie theatre complex (formerly UA Theatres) with operation until 2 am daily.",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2002
      },
      {
         "PERMITID": "RCP02-009",
         "APN": 46722003,
         "File Number": "RCP02-009",
         "Address": " ",
         "Project Name": "RCP02-009, Lido Nightclub",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "7/12/02",
         "Status": "Approved ",
         "Description": "Operation of a drinking establishment with live entertainment between the hours of 12 pm and 2 am daily, with service of alcoholic beverages ceasing at 1:30 am.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2002
      },
      {
         "PERMITID": "RCP02-012",
         "APN": 46764005,
         "File Number": "RCP02-012",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "Central Place ",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "9/16/02",
         "Status": "Approved ",
         "Description": "CUP to allow commercial & residential uses, entertainment, after midnight operation ",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2002
      },
      {
         "PERMITID": "RCP02-012",
         "APN": 46764010,
         "File Number": "RCP02-012",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "Central Place ",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "9/16/02",
         "Status": "Approved ",
         "Description": "CUP to allow commercial & residential uses, entertainment, after midnight operation ",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2002
      },
      {
         "PERMITID": "RCP02-013",
         "APN": 46722121,
         "File Number": "RCP02-013",
         "Address": "35 S 2ND ST SAN JOSE",
         "Project Name": "CIM: Fountain Alley ",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "9/16/02",
         "Status": "Approved ",
         "Description": "CUP to allow residential and commercial uses on a 1.25 gross acre lot",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2002
      },
      {
         "PERMITID": "RCP02-017",
         "APN": 25940092,
         "File Number": "RCP02-017",
         "Address": "18 S ALMADEN AV SAN JOSE",
         "Project Name": "RCP02-017, Chaco's Mexican Restaurant",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "10/3/02",
         "Status": "Approved ",
         "Description": "Operation of an existing restaurant and bar between the hours of 10:00 am and 3:00 am daily, with live music and dancing until 2:00 am.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2002
      },
      {
         "PERMITID": "RCP02-018",
         "APN": 46722031,
         "File Number": "RCP02-018",
         "Address": "83 S 2ND ST SAN JOSE",
         "Project Name": "RCP02-018, Tres Gringos",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "10/4/02",
         "Status": "Approved ",
         "Description": "Operation of a public eating establishment, with sidewalk cafe and entertainment between the hours of 9 am and 2 am daily, with service of alcoholic beverages ceasing at 1:30 am.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2002
      },
      {
         "PERMITID": "RCP02-019",
         "APN": 46762016,
         "File Number": "RCP02-019",
         "Address": " ",
         "Project Name": "R&J Jewelry and Pawn ",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "11/4/02",
         "Status": "Approved ",
         "Description": "CUP to allow operation of a pawn shop as incidental to a jewelry store ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2002
      },
      {
         "PERMITID": "RCP03-001",
         "APN": 46747089,
         "File Number": "RCP03-001",
         "Address": "420 S 1ST ST SAN JOSE",
         "Project Name": "RCP03-001, South First Billiards",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "1/13/03",
         "Status": "Approved ",
         "Description": "Operation of a pool hall, public drinking establishment, entertainment establishment and cafe until 2 am daily.",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RCP03-004",
         "APN": 25940001,
         "File Number": "RCP03-004",
         "Address": " ",
         "Project Name": "RCP03-004, Blank Club",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "3/6/03",
         "Status": "Approved ",
         "Description": "Operating of a pubilc drinking establishment with live entertainment between the hours of 9 am and 2 am daily, with service of alcoholic beverages and entertainment ceasing at 1:30 am.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RCP03-005",
         "APN": 46746015,
         "File Number": "RCP03-005",
         "Address": "394 S 2ND ST SAN JOSE",
         "Project Name": "RCP03-005, Palermo's Restaurant",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "3/4/03",
         "Status": "Approved ",
         "Description": "Allow an existing restaurant to have a banquet use and live entertainment, with operation between the hours of 9 am and 2 am, daily, with service of alcoholic beverages ceasing at 1:30 am.",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RCP03-007",
         "APN": 25940017,
         "File Number": "RCP03-007",
         "Address": " ",
         "Project Name": "RCP03-007, Big Lil's Cabaret",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "4/1/03",
         "Status": "Approved ",
         "Description": "Amendment of CUP for operation of a dinner theater with alcohol service and live entertainment between the hours of 9 AM and 2 AM daily, with service of alcoholic beverages ceasing at 1:30 AM.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RCP03-008",
         "APN": 25940091,
         "File Number": "RCP03-008",
         "Address": "55 S MARKET ST SAN JOSE",
         "Project Name": "RCP03-008, Market-Post Tower",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "4/8/03",
         "Status": "Approved ",
         "Description": "Allow 117,862 sq. feet of communications service exchange space within an existing office building.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RCP03-009",
         "APN": 46721025,
         "File Number": "RCP03-009",
         "Address": " ",
         "Project Name": "RCP03-009, Johnnie V's",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "4/15/03",
         "Status": "Approved ",
         "Description": "Operation of a restaurant on the 1st & 2nd floor with live entertainment between the hours of 9 am and 2 am daily, with service of alcoholic beverages ceasing at 1:30 am. 3rd floor to be future law offices.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RCP03-012",
         "APN": 25934018,
         "File Number": "RCP03-012",
         "Address": " ",
         "Project Name": "RCP03-012, The Vault",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "4/25/03",
         "Status": "Approved ",
         "Description": "Operation of a nightclub and bar, with live entertainment, between the hours of 9 am and 2 am daily, with service of alcoholic beverages ceasing at 1:30 am",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RCP03-013",
         "APN": 26429118,
         "File Number": "RCP03-013",
         "Address": " ",
         "Project Name": "RCP03-013, The Agenda Restaurant",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "5/8/03",
         "Status": "Approved ",
         "Description": "Renewal of CUP for an existing restaurant and nightclub with banquet use from 7 am - 4 am daily, and nightclub use with live entertainment and operation from 4 pm - 2 am daily, with service of alcoholic beverages ceasing at 1:30 am.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RCP03-015",
         "APN": 46746045,
         "File Number": "RCP03-015",
         "Address": " ",
         "Project Name": "RCP03-015, B-Hive Nightclub",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "6/9/03",
         "Status": "Approved ",
         "Description": "Live entertainment and after-midnight use until 2 am daily, at a public drinking establishment.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RCP03-016",
         "APN": 46722007,
         "File Number": "RCP03-016",
         "Address": " ",
         "Project Name": "RCP03-016, Bella Mia/The Temple",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "6/17/03",
         "Status": "Approved ",
         "Description": "Live entertainment and after-midnight use until 2 am daily, at a public drinking establishment",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RCP03-019",
         "APN": 25932005,
         "File Number": "RCP03-019",
         "Address": " ",
         "Project Name": "RCP03-019, Club Wild",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "7/17/03",
         "Status": "Approved ",
         "Description": "Allow continued live entertainment and after midnight use until 2 am, daily at a public drinking establishment.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RCP03-022",
         "APN": 26429065,
         "File Number": "RCP03-022",
         "Address": " ",
         "Project Name": "RCP03-022, Hookah Nites Cafe",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "9/23/03",
         "Status": "Approved ",
         "Description": "Allow after-midnight use at a public eating establishment until 2:00 am, with alcohol service ending at 1:30 am daily - includes permit for a sidewalk cafe.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RCP03-024",
         "APN": 25935057,
         "File Number": "RCP03-024",
         "Address": " ",
         "Project Name": "RCP03-024, O'Flaherty's Pub",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "9/23/03",
         "Status": "Approved ",
         "Description": "Operation of a public drinking establishment with live entertainment and after-midnight use until 2:00 am, daily.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RCP03-025",
         "APN": 25940070,
         "File Number": "RCP03-025",
         "Address": "98 S ALMADEN AV SAN JOSE",
         "Project Name": "RCP03-025, Caravan Lounge",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "9/23/03",
         "Status": "Approved ",
         "Description": "Allow operations of a public drinking establishment until 2:00 am, with live entertainment and alcohol service terminating at 1:30 am, daily.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RCP03-029",
         "APN": 46722110,
         "File Number": "RCP03-029",
         "Address": "1 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "RCP03-029, Blue Monkey Taco Lounge",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "11/24/03",
         "Status": "Approved ",
         "Description": "Operation of a public drinking establishment with after-midnight use until 2:00 am daily.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RCP03-031",
         "APN": 25935045,
         "File Number": "RCP03-031",
         "Address": " ",
         "Project Name": "Blue Tattoo ",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "12/5/03",
         "Status": "Approved ",
         "Description": "Renewal of CUP for continued use as a restaurant/nightclub ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RCP03-032",
         "APN": 25942079,
         "File Number": "RCP03-032",
         "Address": " ",
         "Project Name": "Paragon Restaurant ",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "12/2/03",
         "Status": "Approved ",
         "Description": "Conditional Use Permit for a new restaurant inside the Hotel Montgomery ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RCP91-006",
         "APN": 47226036,
         "File Number": "RCP91-006",
         "Address": " ",
         "Project Name": "RCP91-006, Community Value Center",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "7/10/91",
         "Status": "Approved ",
         "Description": "Convert a vacant, one-story retail space with 11,602 sq. ft. to a secondhand retail use",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1991
      },
      {
         "PERMITID": "RCP92-016",
         "APN": 25935035,
         "File Number": "RCP92-016",
         "Address": " ",
         "Project Name": "RCP92-016, D.B. Cooper's Restaurant & Nightclub",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "6/19/92",
         "Status": "Approved ",
         "Description": "Continued use restaurant/nightclub with proposed expansion of 1,030 sf.",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1992
      },
      {
         "PERMITID": "RCP92-018",
         "APN": 46722003,
         "File Number": "RCP92-018",
         "Address": " ",
         "Project Name": "RCP92-018, Lido Nightclub",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "7/9/92",
         "Status": "Approved ",
         "Description": "Continue use as a restaurant/nightclub. ",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1992
      },
      {
         "PERMITID": "RCP92-022",
         "APN": 47226084,
         "File Number": "RCP92-022",
         "Address": " ",
         "Project Name": "RCP92-022, City Lights Theatre",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "12/10/92",
         "Status": "Approved ",
         "Description": "Change warehouse use to performing arts theatre ",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1992
      },
      {
         "PERMITID": "RCP92-023",
         "APN": 25932005,
         "File Number": "RCP92-023",
         "Address": " ",
         "Project Name": "RCP92-023, Paradise Beach",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "12/22/92",
         "Status": "Approved ",
         "Description": "Renewal of CUP to continue use as a nightclub. ",
         "Planner": "Ted Lorraine ",
         "DURATION": 0,
         "Year": 1992
      },
      {
         "PERMITID": "RCP93-012",
         "APN": 46722056,
         "File Number": "RCP93-012",
         "Address": " ",
         "Project Name": "RCP93-012, T.J.'s Fast Mexican Food",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "8/16/93",
         "Status": "Approved ",
         "Description": "Restaurant, outdoor patio and remaining open until 4 am.",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1993
      },
      {
         "PERMITID": "RCP93-014",
         "APN": 46746105,
         "File Number": "RCP93-014",
         "Address": " ",
         "Project Name": "RCP93-014, UA Theatre Complex",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "11/1/93",
         "Status": "Approved ",
         "Description": "Construction of a three-story building and operating an eight screen, approximately 3,900 seat cinema complex. (Only plan set and resolution in file.)",
         "Planner": " ",
         "DURATION": 0,
         "Year": 1993
      },
      {
         "PERMITID": "RCP93-015",
         "APN": 25935045,
         "File Number": "RCP93-015",
         "Address": " ",
         "Project Name": "RCP93-015, Hamburger Mary's",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "11/30/93",
         "Status": "Approved ",
         "Description": "Nightclub/restaurant reuse ",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1993
      },
      {
         "PERMITID": "RCP94-005",
         "APN": 46722008,
         "File Number": "RCP94-005",
         "Address": " ",
         "Project Name": "RCP94-005, Bella Mia Restaurant",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "11/16/94",
         "Status": "Approved ",
         "Description": "Addition of theater space in existing second floor banquet room ",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1994
      },
      {
         "PERMITID": "RCP94-011",
         "APN": 46722127,
         "File Number": "RCP94-011",
         "Address": " ",
         "Project Name": "RCP94-011, Gordon Biersch",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "3/1/94",
         "Status": "Approved ",
         "Description": "Expand existing restaurant/bar/brewery use (build raised patio in existing outdoor seating area) and allow after-midnight use until 2:00 am, daily",
         "Planner": "Dennis Korabiak ",
         "DURATION": 0,
         "Year": 1994
      },
      {
         "PERMITID": "RCP95-003",
         "APN": 25940017,
         "File Number": "RCP95-003",
         "Address": " ",
         "Project Name": "RCP95-003, Big Lil's Cabaret",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "9/22/95",
         "Status": "Approved ",
         "Description": "Continued use of an existing live drama theater (original CUP expired). ",
         "Planner": "Mark Young ",
         "DURATION": 0,
         "Year": 1995
      },
      {
         "PERMITID": "RCP96-001",
         "APN": 26429065,
         "File Number": "RCP96-001",
         "Address": " ",
         "Project Name": "RCP96-001, Cafe De Matisse",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "10/13/95",
         "Status": "Approved ",
         "Description": "After hours operation and on-sale and off-sale of alcohol in an existing art gallery. ",
         "Planner": "Dennis Korabiak ",
         "DURATION": 0,
         "Year": 1995
      },
      {
         "PERMITID": "RCP96-003",
         "APN": 25940092,
         "File Number": "RCP96-003",
         "Address": " ",
         "Project Name": "RCP96-003, Chacho's Mexican Restaurant",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "2/6/96",
         "Status": "Approved ",
         "Description": "sale of alcohol and after hours operation ",
         "Planner": "Dennis Korabiak ",
         "DURATION": 0,
         "Year": 1996
      },
      {
         "PERMITID": "RCP96-006",
         "APN": 46747019,
         "File Number": "RCP96-006",
         "Address": " ",
         "Project Name": "RCP96-006, Parking Lot",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "6/12/96",
         "Status": "Approved ",
         "Description": "Construction of a 39 space surface parking lot",
         "Planner": "Kristi Ashburn ",
         "DURATION": 0,
         "Year": 1996
      },
      {
         "PERMITID": "RCP96-007",
         "APN": 25934043,
         "File Number": "RCP96-007",
         "Address": " ",
         "Project Name": "RCP96-007, River Street Historic District Project",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "8/26/96",
         "Status": "Approved ",
         "Description": "Relocation of nine historically significant structures from River Street onto city-owned property and retail development of them. ",
         "Planner": "Kristi Ashburn ",
         "DURATION": 0,
         "Year": 1996
      },
      {
         "PERMITID": "RCP97-002",
         "APN": 46762017,
         "File Number": "RCP97-002",
         "Address": "8 S 1ST ST SAN JOSE",
         "Project Name": "RCP97-002, Banker's Club",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "3/14/97",
         "Status": "Approved ",
         "Description": "Operation of a nightclub on Friday nights only. ",
         "Planner": "Kristi Ashburn ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RCP97-004",
         "APN": 46722110,
         "File Number": "RCP97-004",
         "Address": " ",
         "Project Name": "RCP97-004, Caffe Zucco",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "4/25/97",
         "Status": "Approved ",
         "Description": "After hours operation of an existing restaurant/cafe ",
         "Planner": "Julie Schaer ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RCP97-005",
         "APN": 25940049,
         "File Number": "RCP97-005",
         "Address": " ",
         "Project Name": "RCP97-005, Mac's Club",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "7/2/97",
         "Status": "Approved ",
         "Description": "Continued operation of bar until 2 am, and denial of off-sale alcohol in an existing building.",
         "Planner": "Julie Schaer ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RCP97-007",
         "APN": 25935035,
         "File Number": "RCP97-007",
         "Address": " ",
         "Project Name": "RCP97-007, A.P. Stump's",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "7/11/97",
         "Status": "Approved ",
         "Description": "Operation of a restaurant after hours until 2 am with on-site alcohol sales terminating at 1:30 am.",
         "Planner": "Julie Schaer ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RCP97-009",
         "APN": 46722110,
         "File Number": "RCP97-009",
         "Address": " ",
         "Project Name": "RCP97-009, Flying Pig Pub",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "10/6/97",
         "Status": "Approved ",
         "Description": "Allow after hours operation of an existing restaurant in an existing building until 2 am.",
         "Planner": "Eric Keller ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RCP97-012",
         "APN": 46723039,
         "File Number": "RCP97-012",
         "Address": " ",
         "Project Name": "RCP97-012, Banh Thai Restaurant",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "10/8/97",
         "Status": "Approved ",
         "Description": "Operation after hours until 2 am with food service and on-site alcohol sales terminating at 1:30 am.",
         "Planner": "Martin Magana ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RCP98-003",
         "APN": 25932005,
         "File Number": "RCP98-003",
         "Address": " ",
         "Project Name": "RCP98-003, Club Vertigo/Club Extreme",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "2/17/98",
         "Status": "Approved ",
         "Description": "Renewal of permit to allow a nightclub from 4:00 pm to 2:00 am with an outdoor patio.",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "RCP98-007",
         "APN": 46762017,
         "File Number": "RCP98-007",
         "Address": "8 S 1ST ST SAN JOSE",
         "Project Name": "RCP98-007, Planet X/Banker's Club",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "7/15/98",
         "Status": "Approved ",
         "Description": "To change use on previous allowed use (permit RCP97-03-02) from Friday nights only to seven (7) days a week from 4:00 pm to 2:00 am. NOTE: This does not allow 18 and over.",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "RCP98-012",
         "APN": 46746044,
         "File Number": "RCP98-012",
         "Address": " ",
         "Project Name": "RCP98-012, B-Hive",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "9/30/98",
         "Status": "Approved ",
         "Description": "To allow a nightclub at an existing bar/lounge from 9:00 am to 2:00 am on the second floor of an existing building.",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "RCP98-014",
         "APN": 25935045,
         "File Number": "RCP98-014",
         "Address": " ",
         "Project Name": "RCP98-014, Club Ecco",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "10/6/98",
         "Status": "Approved ",
         "Description": "To allow a nightclub between the hours of 9:00 pm and 2:00 am in an existing building, and approving a 961 sq. ft. expansion.",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "RCP98-015",
         "APN": 46745030,
         "File Number": "RCP98-015",
         "Address": " ",
         "Project Name": "RCP98-015, Iguana's",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "11/16/98",
         "Status": "Approved ",
         "Description": "To allow the after midnight operation of a restaurant until 3:00 AM on Thursday, Friday and Saturday nights, and until 1:00 am Sunday through Wednesday.",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "RCP99-001",
         "APN": 25935051,
         "File Number": "RCP99-001",
         "Address": " ",
         "Project Name": "RCP99-001, Fanny & Alexander's",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "2/8/99",
         "Status": "Approved ",
         "Description": "Allow a late night restaurant until 1:30 am and a nightclub between the hours of 9:00 pm and 2:00 am in an existing building and approving site improvements.",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RCP99-002",
         "APN": 46745025,
         "File Number": "RCP99-002",
         "Address": " ",
         "Project Name": "RCP99-002, La Victoria Restaurant",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "3/24/99",
         "Status": "Approved ",
         "Description": "Allow after-midnight use of an existing restaurant until 2:00 am.",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RCP99-003",
         "APN": 46701002,
         "File Number": "RCP99-003",
         "Address": " ",
         "Project Name": "RCP99-003, Germania Restaurant",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "4/21/99",
         "Status": "Approved ",
         "Description": "Allow restaurant/ bar/ nightclub/ banquet facilities until 2:00 am.",
         "Planner": "Martin Magana ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RCP99-007",
         "APN": 46746016,
         "File Number": "RCP99-007",
         "Address": " ",
         "Project Name": "RCP99-007, Kako Suchi Boat",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "5/19/99",
         "Status": "Approved ",
         "Description": "Allow addition of karaoke and after-midnight use until 3:00 am.",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RCP99-012",
         "APN": 25935051,
         "File Number": "RCP99-012",
         "Address": "65 N SAN PEDRO ST SAN JOSE",
         "Project Name": "RCP99-012, Shark & Rose",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "7/16/99",
         "Status": "Approved ",
         "Description": "To allow an after-midnight restaurant until 2:00 AM",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RCP99-015",
         "APN": 46747090,
         "File Number": "RCP99-015",
         "Address": " ",
         "Project Name": "RCP99-015, The Usual",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "9/14/99",
         "Status": "Approved ",
         "Description": "Renewal of a Conditional use permit for continuation of a nightclub. ",
         "Planner": "Martin Magana ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RCP00-003",
         "APN": 25940087,
         "File Number": "RCP00-003",
         "Address": " ",
         "Project Name": "RCP00-003, Archon Phase II",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "4/13/00",
         "Status": "Closed ",
         "Description": "Construction of a new office building (approx. 380,000 sq. ft.) w/shared parking off-site",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "RCP03-002",
         "APN": 46721045,
         "File Number": "RCP03-002",
         "Address": " ",
         "Project Name": "RCP03-002, Dr. Eu Building",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "1/10/03",
         "Status": "Closed ",
         "Description": "Adaptive reuse of three-story structure for up to 6,000 sq. ft. of ground floor commercial and 14 residential units on 2nd & 3rd floors. Only repair, restoration and preservation of historic building elements are proposed.",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RCP99-011",
         "APN": 46722002,
         "File Number": "RCP99-011",
         "Address": " ",
         "Project Name": "RCP99-011, Lido Nightclub",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "7/14/99",
         "Status": "Closed ",
         "Description": "Allow a nightclub renewal with modifications to allow type 48",
         "Planner": "Martin Magana ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RCP99-014",
         "APN": 46764005,
         "File Number": "RCP99-014",
         "Address": " ",
         "Project Name": "RCP99-014, Block 3 Parking Garage",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "9/13/99",
         "Status": "Closed ",
         "Description": "Allow a parking garage with peripheral retail uses ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RCP99-014",
         "APN": 46764010,
         "File Number": "RCP99-014",
         "Address": " ",
         "Project Name": "RCP99-014, Block 3 Parking Garage",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "9/13/99",
         "Status": "Closed ",
         "Description": "Allow a parking garage with peripheral retail uses ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "CP87-042",
         "APN": 25935035,
         "File Number": "CP87-042",
         "Address": "161 W SANTA CLARA ST SAN JOSE",
         "Project Name": "CP87-042",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "6/10/87",
         "Status": "Complete ",
         "Description": "NO EXP DATE; Other APNs:049",
         "Planner": "Larry Bohannan ",
         "DURATION": 0,
         "Year": 1987
      },
      {
         "PERMITID": "CP07-107",
         "APN": 46747058,
         "File Number": "CP07-107",
         "Address": "439 S 4TH ST SAN JOSE",
         "Project Name": "CP07-107 S. Fourth & San Salvador",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "12/21/07",
         "Status": "Denied ",
         "Description": "Conditional Use Permit to allow a residential care facility for 122 residents at an existing 3-story multi-family residential building, and renovation of an existing building for staff office use on a 0.52 gross acre site located at 439 and 451 S. 4th Street",
         "Planner": "Ella Samonsky ",
         "DURATION": 991,
         "Year": 2007
      },
      {
         "PERMITID": "CP07-107",
         "APN": 46747096,
         "File Number": "CP07-107",
         "Address": "439 S 4TH ST SAN JOSE",
         "Project Name": "CP07-107 S. Fourth & San Salvador",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "12/21/07",
         "Status": "Denied ",
         "Description": "Conditional Use Permit to allow a residential care facility for 122 residents at an existing 3-story multi-family residential building, and renovation of an existing building for staff office use on a 0.52 gross acre site located at 439 and 451 S. 4th Street",
         "Planner": "Ella Samonsky ",
         "DURATION": 991,
         "Year": 2007
      },
      {
         "PERMITID": "CP08-007",
         "APN": 26420127,
         "File Number": "CP08-007",
         "Address": "394 BIRD AV SAN JOSE",
         "Project Name": "CP08-007 - Abyssinian Market",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "1/22/08",
         "Status": "Denied ",
         "Description": "Conditional Use Permit to allow off-sale of alcoholic beverages at an existing retail store on a 0.13 gross acre site",
         "Planner": "Edward Schreiner ",
         "DURATION": 959,
         "Year": 2008
      },
      {
         "PERMITID": "CP15-016",
         "APN": 46722008,
         "File Number": "CP15-016",
         "Address": "58 S 1ST ST SAN JOSE",
         "Project Name": "CP15-016",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "3/25/15",
         "Status": "Denied ",
         "Description": "Conditional Use Permit to allow a drinking establishment (for more than 250 people) and late night use until 2:00 a.m. in an existing 8,684 square foot public eating establishment in the DC Downtown Primary Commercial Zoning District on an approximately 0.15 gross acre site",
         "Planner": "Jennifer Piozet ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "CP90-064",
         "APN": 47224028,
         "File Number": "CP90-064",
         "Address": "656 S 7TH ST SAN JOSE",
         "Project Name": "CP90-064",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "11/13/90",
         "Status": "Denied ",
         "Description": "DENIED ",
         "Planner": "Vic Mendez ",
         "DURATION": 0,
         "Year": 1990
      },
      {
         "PERMITID": "RCP02-002",
         "APN": 25940018,
         "File Number": "RCP02-002",
         "Address": " ",
         "Project Name": "RCP02-002, Check Express (Expert)",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "2/15/02",
         "Status": "Denied ",
         "Description": "Allow the off-sale of alcoholic beverages at an existing convenience store between the hours of 8:00 am and 11:00 pm daily.",
         "Planner": "Judie Gilli/Amie Glaser ",
         "DURATION": 0,
         "Year": 2002
      },
      {
         "PERMITID": "CP15-061",
         "APN": 46722008,
         "File Number": "CP15-061",
         "Address": "56 S 1ST ST SAN JOSE",
         "Project Name": "CP15-061",
         "Application Type": "Conditional Use Permit ",
         "Application Date": " ",
         "Status": "Inactive ",
         "Description": "Conditional Use Permit to allow a drinking establishment (for more than 250 people) and late night use until 2:00 a.m. in an existing 8,684 square foot public eating establishment in the DC Downtown Primary Commercial Zoning District on an approximately 0.15 gross acre site",
         "Planner": "David Fong ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "2004 119975 AO",
         "APN": 46746045,
         "File Number": "2004 119975 AO",
         "Address": "380 S 1ST ST SAN JOSE",
         "Project Name": "380 S 1ST ST",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "7/19/04",
         "Status": "New ",
         "Description": " ",
         "Planner": "Lee Butler ",
         "DURATION": 0,
         "Year": 2004
      },
      {
         "PERMITID": "2012 028786 AO",
         "APN": 46720041,
         "File Number": "2012 028786 AO",
         "Address": "115 N 4TH ST SAN JOSE",
         "Project Name": "115 4TH ST",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "9/28/12",
         "Status": "New ",
         "Description": "Conditional Use Permit to allow after midnight use till 3 a.m. for an existing hookah lounge in the CG Commercial General Zoning District on .44 gross acre site",
         "Planner": "Mike Enderby ",
         "DURATION": 0,
         "Year": 2012
      },
      {
         "PERMITID": "CP18-028",
         "APN": 24952017,
         "File Number": "CP18-028",
         "Address": "445 E JULIAN ST SAN JOSE",
         "Project Name": "CP18-028 Rotten Robbie",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "7/3/18 10:10",
         "Status": "Review Letter Sent ",
         "Description": "Conditional Use Permit to allow the demolish of an existing convenience store, storage building, removal of two billboards, and allow the construction of a 3,183-square foot convenience store on a 0.39-gross acre site.",
         "Planner": "Michelle Flores ",
         "DURATION": 29,
         "Year": 2018
      },
      {
         "PERMITID": "CP19-004",
         "APN": 46746074,
         "File Number": "CP19-004",
         "Address": "386 S 1ST ST SAN JOSE",
         "Project Name": "CP19-004",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "2/22/19",
         "Status": "Review Letter Sent ",
         "Description": "Conditional Use to allow late-night use until 2 a.m. only for Friday and Saturday for a new restaurant with lounge, bar on an existing 7500 square foot building on .226 gross acre site",
         "Planner": "Angela Wang ",
         "DURATION": 31,
         "Year": 2019
      },
      {
         "PERMITID": "CP00-012",
         "APN": 26420047,
         "File Number": "CP00-012",
         "Address": "0 (LAND ONLY.) SAN JOSE",
         "Project Name": "CP00-012",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "3/20/00",
         "Status": "Withdrawn ",
         "Description": "Conditional Use Permit to allow a building under 500 feet for a satellite and broadcast reception facility on a .11 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "CP04-054",
         "APN": 46745025,
         "File Number": "CP04-054",
         "Address": "140 E SAN CARLOS ST SAN JOSE",
         "Project Name": "CP04-054, La Victoria Taqueria E San Carlos Midnight hours",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "6/8/04",
         "Status": "Withdrawn ",
         "Description": "Conditional Use Permit to allow renewal and amendment of an existing permit (permitted to operate up to 2:00 am) for a restaurant to extend the hours of operation from 2:00 am to 4:00 am on a 0.04 gross acre site",
         "Planner": "MNAGARAJ ",
         "DURATION": 1401,
         "Year": 2004
      },
      {
         "PERMITID": "CP04-058",
         "APN": 46746015,
         "File Number": "CP04-058",
         "Address": "394 S 2ND ST SAN JOSE",
         "Project Name": "CP04-058",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "6/18/04",
         "Status": "Withdrawn ",
         "Description": "Conditional Use Permit to replace file no. RCP04-006 to allow 24-hour operation for an existing restaurant on a 0.4 gross acre site",
         "Planner": "Ron Eddow ",
         "DURATION": 71,
         "Year": 2004
      },
      {
         "PERMITID": "CP04-073",
         "APN": 46746045,
         "File Number": "CP04-073",
         "Address": "380 S 1ST ST SAN JOSE",
         "Project Name": "CP04-073",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "7/28/04",
         "Status": "Withdrawn ",
         "Description": "Conditional Use Permit to allow entertainment, on-sale of alcoholic beverages, and operation after midnight at a bar / lounge on a 0.1 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 1276,
         "Year": 2004
      },
      {
         "PERMITID": "CP04-088",
         "APN": 46723039,
         "File Number": "CP04-088",
         "Address": "118 E SANTA CLARA ST SAN JOSE",
         "Project Name": "CP04-088 Payday Loans",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "9/7/04",
         "Status": "Withdrawn ",
         "Description": "Conditional Use Permit to allow check cashing use in an existing commercial commercial building on a 0.07 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 1310,
         "Year": 2004
      },
      {
         "PERMITID": "CP04-104",
         "APN": 25940044,
         "File Number": "CP04-104",
         "Address": "33 S 1ST ST SAN JOSE",
         "Project Name": "CP04-104",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "11/3/04",
         "Status": "Withdrawn ",
         "Description": "Conditional Use Permit to allow off-sale of alcoholic beverages at a retail grocery store on a 0.06 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 287,
         "Year": 2004
      },
      {
         "PERMITID": "CP05-049",
         "APN": 26420079,
         "File Number": "CP05-049",
         "Address": "498 W SAN CARLOS ST SAN JOSE",
         "Project Name": "CP05-049",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "8/11/05",
         "Status": "Withdrawn ",
         "Description": "Conditional Use Permit to demolish an existing office building and construct a four-story mixed use building containing a total of 47,847 square feet including 19 multi-family attached residential units, 6,131 square feet of ground floor commercial uses, and below-grade parking on a 0.53 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 28,
         "Year": 2005
      },
      {
         "PERMITID": "CP05-049",
         "APN": 26420110,
         "File Number": "CP05-049",
         "Address": "498 W SAN CARLOS ST SAN JOSE",
         "Project Name": "CP05-049",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "8/11/05",
         "Status": "Withdrawn ",
         "Description": "Conditional Use Permit to demolish an existing office building and construct a four-story mixed use building containing a total of 47,847 square feet including 19 multi-family attached residential units, 6,131 square feet of ground floor commercial uses, and below-grade parking on a 0.53 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 28,
         "Year": 2005
      },
      {
         "PERMITID": "CP05-049",
         "APN": 26420128,
         "File Number": "CP05-049",
         "Address": "498 W SAN CARLOS ST SAN JOSE",
         "Project Name": "CP05-049",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "8/11/05",
         "Status": "Withdrawn ",
         "Description": "Conditional Use Permit to demolish an existing office building and construct a four-story mixed use building containing a total of 47,847 square feet including 19 multi-family attached residential units, 6,131 square feet of ground floor commercial uses, and below-grade parking on a 0.53 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 28,
         "Year": 2005
      },
      {
         "PERMITID": "CP05-050",
         "APN": 47217057,
         "File Number": "CP05-050",
         "Address": "766 S 2ND ST SAN JOSE",
         "Project Name": "CP05-050",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "8/16/05",
         "Status": "Withdrawn ",
         "Description": "Conditional Use Permit to legalize an addition approximately 634 square feet in size, constructed without benefit of permit, to an existing building for church/religious assembly uses on a 0.38 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 1123,
         "Year": 2005
      },
      {
         "PERMITID": "CP06-002",
         "APN": 46745030,
         "File Number": "CP06-002",
         "Address": "330 S 3RD ST SAN JOSE",
         "Project Name": "CP06-002",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "1/11/06",
         "Status": "Withdrawn ",
         "Description": "(WITHDRAWN) Conditional Use Permit to allow after midnight operation till 3:00am for a restaurant on a 0.12 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 90,
         "Year": 2006
      },
      {
         "PERMITID": "CP06-047",
         "APN": 25936039,
         "File Number": "CP06-047",
         "Address": "320 W ST JOHN ST SAN JOSE",
         "Project Name": "CP06-047",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "7/26/06",
         "Status": "Withdrawn ",
         "Description": "Conditional Use Permit to allow a Residential Care Facility for sober living environment and counseling meetings seven days per week ",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 33,
         "Year": 2006
      },
      {
         "PERMITID": "CP08-018",
         "APN": 46745069,
         "File Number": "CP08-018",
         "Address": "345 S 4TH ST SAN JOSE",
         "Project Name": "CP08-018 - 345 4th Street",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "3/5/08",
         "Status": "Withdrawn ",
         "Description": "Conditional Use Permit to allow 24 hour use for an existing public eating establishment on a 0.29 gross acre site",
         "Planner": "Ella Samonsky ",
         "DURATION": 271,
         "Year": 2008
      },
      {
         "PERMITID": "CP09-002",
         "APN": 25933050,
         "File Number": "CP09-002",
         "Address": "263 N 1ST ST SAN JOSE",
         "Project Name": "CP09-002 - Trials",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "1/8/09",
         "Status": "Withdrawn ",
         "Description": "Conditional Use Permit to allow an eating and drinking establishment with late night use until 2:00 a.m. on a 0.11 gross acre site.",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 35,
         "Year": 2009
      },
      {
         "PERMITID": "CP09-060",
         "APN": 25940019,
         "File Number": "CP09-060",
         "Address": "167 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "CP09-060",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "11/10/09",
         "Status": "Withdrawn ",
         "Description": "Conditiional Use Permit for a Peruvian public eating restaurant, Nazca, to allow to open from 11 a.m. to 12 midnight and to change the Alcohol License from 41 to 47. Application not needed. Applicant directed to file for a zoning affidavit letter for the Dept of Alcoholic Beverage Control. See ABCL09-072. pwb",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 29,
         "Year": 2009
      },
      {
         "PERMITID": "CP10-055",
         "APN": 46746047,
         "File Number": "CP10-055",
         "Address": "396 S 1ST ST SAN JOSE",
         "Project Name": "CP10-055",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "10/7/10",
         "Status": "Withdrawn ",
         "Description": "Conditional Use Permit to allow for an existing nightclub, WET, to continue their drinking establishment and after-midnight use on a .21 gross acre site",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 499,
         "Year": 2010
      },
      {
         "PERMITID": "CP10-055",
         "APN": 46747098,
         "File Number": "CP10-055",
         "Address": "396 S 1ST ST SAN JOSE",
         "Project Name": "CP10-055",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "10/7/10",
         "Status": "Withdrawn ",
         "Description": "Conditional Use Permit to allow for an existing nightclub, WET, to continue their drinking establishment and after-midnight use on a .21 gross acre site",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 499,
         "Year": 2010
      },
      {
         "PERMITID": "CP12-021",
         "APN": 26420079,
         "File Number": "CP12-021",
         "Address": "486 W SAN CARLOS ST SAN JOSE",
         "Project Name": "CP12-021 Elan Esprit Preschool",
         "Application Type": "Conditional Use Permit ",
         "Application Date": " ",
         "Status": "Withdrawn ",
         "Description": "Conditional Use Permit to convert an existing office building to child daycare use on a 0.53 gross acre site in the CP Commercial Pedestrian Zoning District (no new construction included)",
         "Planner": "Mike Enderby ",
         "DURATION": 8,
         "Year": null
      },
      {
         "PERMITID": "CP13-082",
         "APN": 46747058,
         "File Number": "CP13-082",
         "Address": "451 S 4TH ST SAN JOSE",
         "Project Name": "CP13-082",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "11/7/13",
         "Status": "Withdrawn ",
         "Description": "Conditional Use Permit to allow a residential care facility on a 0.126 gross acre site",
         "Planner": "Rebecca Bustos ",
         "DURATION": 376,
         "Year": 2013
      },
      {
         "PERMITID": "CP13-086",
         "APN": 47228039,
         "File Number": "CP13-086",
         "Address": "580 S 6TH ST SAN JOSE",
         "Project Name": "CP13-086",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "11/25/13",
         "Status": "Withdrawn ",
         "Description": "Conditional Use Permit to allow the conversion of 6,417 square foot senior living facility to a 10-unit guesthouse for students on a 0.25 gross acre site",
         "Planner": "Emily Lipoma ",
         "DURATION": 53,
         "Year": 2013
      },
      {
         "PERMITID": "CP14-016",
         "APN": 47217014,
         "File Number": "CP14-016",
         "Address": "748 S 1ST ST SAN JOSE",
         "Project Name": "CP14-016",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "3/24/14",
         "Status": "Withdrawn ",
         "Description": "Conditional Use Permit to allow off-sale of alcohol for an existing 2,200 square foot convenience store on a 0.10 gross acre site",
         "Planner": "Wayne Farrens ",
         "DURATION": 142,
         "Year": 2014
      },
      {
         "PERMITID": "CP15-071",
         "APN": 25940086,
         "File Number": "CP15-071",
         "Address": "60 S MARKET ST SAN JOSE",
         "Project Name": "CP15-071",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "10/14/15 15:14",
         "Status": "Withdrawn ",
         "Description": "Conditional Use Permit to allow the off-sale of alcohol within an approximately 989 sq ft. existing retail space (65 S. 1st) on a 1.23 gross acre site",
         "Planner": "David Fong ",
         "DURATION": 294,
         "Year": 2015
      },
      {
         "PERMITID": "CP17-011",
         "APN": 26429058,
         "File Number": "CP17-011",
         "Address": "325 S 1ST ST SAN JOSE",
         "Project Name": "CP17-011",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "3/9/17 11:06",
         "Status": "Withdrawn ",
         "Description": "Conditional Use Permit to allow late night use for an existing restaurant (Blue Chip Sports Bar and Family Restaurant) on a 0.17 gross acre site",
         "Planner": "Robert Rivera ",
         "DURATION": 155,
         "Year": 2017
      },
      {
         "PERMITID": "CP17-031",
         "APN": 25939111,
         "File Number": "CP17-031",
         "Address": "350 W SANTA CLARA ST SAN JOSE",
         "Project Name": "CP17-031",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "7/18/17 10:42",
         "Status": "Withdrawn ",
         "Description": "Conditional Use Permit to allow late night use for an existing hotel on a 0.54 gross acre site",
         "Planner": "Robert Rivera ",
         "DURATION": 191,
         "Year": 2017
      },
      {
         "PERMITID": "CP18-023",
         "APN": 25934029,
         "File Number": "CP18-023",
         "Address": "84 N MARKET ST SAN JOSE",
         "Project Name": "CP18-023",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "6/26/18 15:23",
         "Status": "Withdrawn ",
         "Description": "Conditional Use Permit to allow late night operation of a tobacco retail establishment (Shisha Hookah Lounge) between the hours of 12:00 midnight and 3:00 a.m. within an existing building on a 0.1-gross acre site in Downtown.",
         "Planner": "Rina Shah ",
         "DURATION": 120,
         "Year": 2018
      },
      {
         "PERMITID": "CP95-022",
         "APN": 47218055,
         "File Number": "CP95-022",
         "Address": "288 E VIRGINIA ST SAN JOSE",
         "Project Name": "CP95-022",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "4/18/95",
         "Status": "Withdrawn ",
         "Description": "File type: *Other apns: *Gen.Use Class:*Existing Land Use:53*Specific Use:GAS STATION",
         "Planner": "LCARRILL ",
         "DURATION": 0,
         "Year": 1995
      },
      {
         "PERMITID": "RCP03-010",
         "APN": 25935013,
         "File Number": "RCP03-010",
         "Address": " ",
         "Project Name": "RCP03-010, Blue Tattoo",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "4/21/03",
         "Status": "Withdrawn ",
         "Description": "Continued operation of a nightclub to include restaurant use vetween the hours of 9:00 am and 2:00 am with live entertainment. An additional request for live entertainment, w/o alcohol service, for minors 14+ is included with this application.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RCP03-010",
         "APN": 25935045,
         "File Number": "RCP03-010",
         "Address": " ",
         "Project Name": "RCP03-010, Blue Tattoo",
         "Application Type": "Conditional Use Permit ",
         "Application Date": "4/21/03",
         "Status": "Withdrawn ",
         "Description": "Continued operation of a nightclub to include restaurant use vetween the hours of 9:00 am and 2:00 am with live entertainment. An additional request for live entertainment, w/o alcohol service, for minors 14+ is included with this application.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      }
   ],
   "Conditional Use Permit Amendment ": [
      {
         "PERMITID": "CPA01-097-01",
         "APN": 47218002,
         "File Number": "CPA01-097-01",
         "Address": "792 S 3RD ST SAN JOSE",
         "Project Name": "CPA01-097-01",
         "Application Type": "Conditional Use Permit Amendment ",
         "Application Date": "2/2/05",
         "Status": "Approved ",
         "Description": "Conditional Use Permit Amendment to remove the parking condition from a previously approved permit file no. CP01-097 requiring an 18' x 18' two car garage for a residential service facility on a 0.11 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 159,
         "Year": 2005
      },
      {
         "PERMITID": "CPA03-067-01",
         "APN": 47228078,
         "File Number": "CPA03-067-01",
         "Address": "561 S 9TH ST SAN JOSE",
         "Project Name": "CPA03-067-01",
         "Application Type": "Conditional Use Permit Amendment ",
         "Application Date": "5/9/05",
         "Status": "Approved ",
         "Description": "Conditional Use Permit Amendment to amend a previously approved permit to increase the allowed occupancy from ten residents and one staff to 18 residents and up to two non-resident staff at an existing Residential Care Facility on a 0.14 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 183,
         "Year": 2005
      },
      {
         "PERMITID": "CPA09-054-01",
         "APN": 25935009,
         "File Number": "CPA09-054-01",
         "Address": "180 W ST JOHN ST SAN JOSE",
         "Project Name": "CPA09-054-01 associated with ABC10-009",
         "Application Type": "Conditional Use Permit Amendment ",
         "Application Date": "8/25/10",
         "Status": "Approved ",
         "Description": "Conditional Use Permit Amendment to add after midnight use and the on- and off-sale of alcohol to a previously approved Urban Public Market use on a 1.09 gross-acre site containing a public facility (Peralta Adobe) in the DC Downtown Core Zoning District",
         "Planner": "Jenny Nusbaum ",
         "DURATION": 148,
         "Year": 2010
      },
      {
         "PERMITID": "CPA09-054-01",
         "APN": 25935035,
         "File Number": "CPA09-054-01",
         "Address": "180 W ST JOHN ST SAN JOSE",
         "Project Name": "CPA09-054-01 associated with ABC10-009",
         "Application Type": "Conditional Use Permit Amendment ",
         "Application Date": "8/25/10",
         "Status": "Approved ",
         "Description": "Conditional Use Permit Amendment to add after midnight use and the on- and off-sale of alcohol to a previously approved Urban Public Market use on a 1.09 gross-acre site containing a public facility (Peralta Adobe) in the DC Downtown Core Zoning District",
         "Planner": "Jenny Nusbaum ",
         "DURATION": 148,
         "Year": 2010
      },
      {
         "PERMITID": "CPA09-054-01",
         "APN": 25935045,
         "File Number": "CPA09-054-01",
         "Address": "180 W ST JOHN ST SAN JOSE",
         "Project Name": "CPA09-054-01 associated with ABC10-009",
         "Application Type": "Conditional Use Permit Amendment ",
         "Application Date": "8/25/10",
         "Status": "Approved ",
         "Description": "Conditional Use Permit Amendment to add after midnight use and the on- and off-sale of alcohol to a previously approved Urban Public Market use on a 1.09 gross-acre site containing a public facility (Peralta Adobe) in the DC Downtown Core Zoning District",
         "Planner": "Jenny Nusbaum ",
         "DURATION": 148,
         "Year": 2010
      },
      {
         "PERMITID": "RCPA00-01-012",
         "APN": 25939111,
         "File Number": "RCPA00-01-012",
         "Address": " ",
         "Project Name": "RCPA00-01-012, Marriot Courtyard",
         "Application Type": "Conditional Use Permit Amendment ",
         "Application Date": "2/23/01",
         "Status": "Approved ",
         "Description": "Amendment to allow construction of a 254 room hotel with associate facilties",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "RCPA91-06-006",
         "APN": 47226036,
         "File Number": "RCPA91-06-006",
         "Address": " ",
         "Project Name": "RCPA91-06-006, Community Value Center",
         "Application Type": "Conditional Use Permit Amendment ",
         "Application Date": "5/2/96",
         "Status": "Approved ",
         "Description": "Continued use of space as a secondhand retail store. ",
         "Planner": "Kristi Ashburn ",
         "DURATION": 0,
         "Year": 1996
      },
      {
         "PERMITID": "RCPA92-06-016",
         "APN": 25935035,
         "File Number": "RCPA92-06-016",
         "Address": " ",
         "Project Name": "RCPA92-06-016, Tequila Rocks",
         "Application Type": "Conditional Use Permit Amendment ",
         "Application Date": "6/28/94",
         "Status": "Approved ",
         "Description": "Amendment to original CUP to allow persons under 21 years of age during hours of food service, 7 am - 9 pm. Thereafter, from 9 pm - 2 am, only persons 21 years of age and over would be allowed on the premise. Courtyard use extended from 6 pm - 2 am.",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1994
      },
      {
         "PERMITID": "RCPA92-07-018",
         "APN": 46722003,
         "File Number": "RCPA92-07-018",
         "Address": " ",
         "Project Name": "RCPA92-07-018, Lido Nightclub",
         "Application Type": "Conditional Use Permit Amendment ",
         "Application Date": "9/3/96",
         "Status": "Approved ",
         "Description": "Renewal of CUP for continued use as a restaurant/nightclub. ",
         "Planner": "Kristi Ashburn ",
         "DURATION": 0,
         "Year": 1996
      },
      {
         "PERMITID": "RCPA94-09-004",
         "APN": 46747090,
         "File Number": "RCPA94-09-004",
         "Address": "400 S 1ST ST SAN JOSE",
         "Project Name": "RCPA94-09-04, FX Renewal",
         "Application Type": "Conditional Use Permit Amendment ",
         "Application Date": "1/1/94",
         "Status": "Approved ",
         "Description": "Nightclub Conditional Use Permit renewal ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 1994
      },
      {
         "PERMITID": "RCPA95-01-001",
         "APN": 26429058,
         "File Number": "RCPA95-01-001",
         "Address": " ",
         "Project Name": "RCPA95-01-001, Phoenix Jazz Club",
         "Application Type": "Conditional Use Permit Amendment ",
         "Application Date": "7/21/98",
         "Status": "Approved ",
         "Description": "Amendment to allow the option of operation of a non-alcoholic public dance hall for ages 18 and over at an existing nightclub",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "RCPA95-03-001",
         "APN": 26429058,
         "File Number": "RCPA95-03-001",
         "Address": " ",
         "Project Name": "RCPA95-03-001, The Phoenix Nightclub",
         "Application Type": "Conditional Use Permit Amendment ",
         "Application Date": "8/29/94",
         "Status": "Approved ",
         "Description": "Renewal of CUP to operate as a nightclub ",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1994
      },
      {
         "PERMITID": "RCPA92-04-013",
         "APN": 46746016,
         "File Number": "RCPA92-04-013",
         "Address": " ",
         "Project Name": "RCPA92-04-013, Mini Club",
         "Application Type": "Conditional Use Permit Amendment ",
         "Application Date": "3/30/95",
         "Status": "Closed ",
         "Description": "Renewal of nightclub/bar use. ",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1995
      },
      {
         "PERMITID": "CPA08-058-01",
         "APN": 25935056,
         "File Number": "CPA08-058-01",
         "Address": "73 N SAN PEDRO ST SAN JOSE",
         "Project Name": "CPA08-058-01, Old Wagon Saloon and Grille",
         "Application Type": "Conditional Use Permit Amendment ",
         "Application Date": "6/23/09",
         "Status": "Complete ",
         "Description": "Conditional Use Permit Amendment to allow an entertainment establishment for an existing public eating/drinking establishment with after midnight operation until 2:00 am on a 0.22-gross acre site. No new construction.",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 204,
         "Year": 2009
      },
      {
         "PERMITID": "CP04-072",
         "APN": 25935013,
         "File Number": "CP04-072",
         "Address": "170 W ST JOHN ST SAN JOSE",
         "Project Name": "CP04-072",
         "Application Type": "Conditional Use Permit Amendment ",
         "Application Date": "7/26/04",
         "Status": "Withdrawn ",
         "Description": "Conditional Use Permit to allow for over 18 years-old adults use at an exting night club/restaurant on a 0.38 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 44,
         "Year": 2004
      },
      {
         "PERMITID": "CP04-072",
         "APN": 25935045,
         "File Number": "CP04-072",
         "Address": "170 W ST JOHN ST SAN JOSE",
         "Project Name": "CP04-072",
         "Application Type": "Conditional Use Permit Amendment ",
         "Application Date": "7/26/04",
         "Status": "Withdrawn ",
         "Description": "Conditional Use Permit to allow for over 18 years-old adults use at an exting night club/restaurant on a 0.38 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 44,
         "Year": 2004
      },
      {
         "PERMITID": "CPA06-045-01",
         "APN": 25940086,
         "File Number": "CPA06-045-01",
         "Address": "60 S MARKET ST SAN JOSE",
         "Project Name": "CPA06-045-01",
         "Application Type": "Conditional Use Permit Amendment ",
         "Application Date": " ",
         "Status": "Withdrawn ",
         "Description": "Conditional Use Amendment Permit to allow a drinking establishment, late night use until 2:00 a.m., and off-sale of alcoholic beverages at a wine and dessert bar on a 0.14 gross acre site; amending CP06-045",
         "Planner": "Avril Baty ",
         "DURATION": 1544,
         "Year": null
      },
      {
         "PERMITID": "CPA08-043-01",
         "APN": 25934018,
         "File Number": "CPA08-043-01",
         "Address": "81 W SANTA CLARA ST SAN JOSE",
         "Project Name": "CPA08-043-01 VAULT",
         "Application Type": "Conditional Use Permit Amendment ",
         "Application Date": "10/22/12",
         "Status": "Withdrawn ",
         "Description": "Conditional Use Permit AMENDMENT to change an approved condition for all windows and doors to be closed during operation of the night club and allow the entrance door fronting unto Santa Clara Street to remain open. ",
         "Planner": "Aparna Ankola ",
         "DURATION": 144,
         "Year": 2012
      },
      {
         "PERMITID": "CPA93-047-01",
         "APN": 25938036,
         "File Number": "CPA93-047-01",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "CPA93-047-01",
         "Application Type": "Conditional Use Permit Amendment ",
         "Application Date": "4/20/99",
         "Status": "Withdrawn ",
         "Description": "Conditional Use Permit Amendment for the use of 52 off-site parking spaces for a commercial building to be located at 444 West Santa Clara Street",
         "Planner": "Akoni Danielsen ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "CPA93-047-01",
         "APN": 25938142,
         "File Number": "CPA93-047-01",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "CPA93-047-01",
         "Application Type": "Conditional Use Permit Amendment ",
         "Application Date": "4/20/99",
         "Status": "Withdrawn ",
         "Description": "Conditional Use Permit Amendment for the use of 52 off-site parking spaces for a commercial building to be located at 444 West Santa Clara Street",
         "Planner": "Akoni Danielsen ",
         "DURATION": 0,
         "Year": 1999
      }
   ],
   "Conditional Use Permit Renewal ": [
      {
         "PERMITID": "CP07-054",
         "APN": 46722003,
         "File Number": "CP07-054",
         "Address": "30 S 1ST ST SAN JOSE",
         "Project Name": "CP07-054 Lido",
         "Application Type": "Conditional Use Permit Renewal ",
         "Application Date": "7/18/07",
         "Status": "Approved ",
         "Description": "Conditional Use Permit an existing entertainment and drinking establishment and late night use until 2:00 a.m.",
         "Planner": "Michelle Stahlhut ",
         "DURATION": 303,
         "Year": 2007
      },
      {
         "PERMITID": "CP08-009",
         "APN": 46746015,
         "File Number": "CP08-009",
         "Address": "394 S 2ND ST SAN JOSE",
         "Project Name": "CP08-009 Milano Restaurant",
         "Application Type": "Conditional Use Permit Renewal ",
         "Application Date": "1/22/08",
         "Status": "Approved ",
         "Description": "Conditional Use Permit Renewal to expand the term for an existing eating, drinking, and entertainment establishment and late night use until 2:00 a.m. daily on a 0.32 acre site",
         "Planner": "Ella Samonsky ",
         "DURATION": 136,
         "Year": 2008
      },
      {
         "PERMITID": "CP09-029",
         "APN": 46762017,
         "File Number": "CP09-029",
         "Address": "8 S 1ST ST SAN JOSE",
         "Project Name": "CP09-029",
         "Application Type": "Conditional Use Permit Renewal ",
         "Application Date": "6/23/09",
         "Status": "Approved ",
         "Description": "Conditional Use Permit RENEWAL for after-midnight and live entertainment uses at an existing nightclub. ",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 275,
         "Year": 2009
      },
      {
         "PERMITID": "CP12-003",
         "APN": 26429118,
         "File Number": "CP12-003",
         "Address": "389 S 1ST ST SAN JOSE",
         "Project Name": "CP12-003",
         "Application Type": "Conditional Use Permit Renewal ",
         "Application Date": "2/1/12",
         "Status": "Approved ",
         "Description": "Conditional Use Permit for the timely renewal for a public eating, drinking and late night use till 2 a.m. in the DC Downtown Primary Commercial Zoning District on .14 gross acre site",
         "Planner": "Jenny Nusbaum ",
         "DURATION": 0,
         "Year": 2012
      },
      {
         "PERMITID": "CP13-012",
         "APN": 25940001,
         "File Number": "CP13-012",
         "Address": "44 S ALMADEN AV SAN JOSE",
         "Project Name": "CP13-012",
         "Application Type": "Conditional Use Permit Renewal ",
         "Application Date": "3/18/13",
         "Status": "Approved ",
         "Description": "Conditional Use Permit Renewal of a public drinking and entertainment establishment (The Blank Club) with late night use until 2:00 a.m. daily, in the DC Downtown Zoning District, on a 0.06 acre lot.",
         "Planner": "Kristinae Toomians ",
         "DURATION": 49,
         "Year": 2013
      },
      {
         "PERMITID": "CP13-018",
         "APN": 46722031,
         "File Number": "CP13-018",
         "Address": "83 S 2ND ST SAN JOSE",
         "Project Name": "CP13-018",
         "Application Type": "Conditional Use Permit Renewal ",
         "Application Date": "3/25/13",
         "Status": "Approved ",
         "Description": "Conditional Use Permit Renewal to allow a public eating, drinking, and entertainment establishment with late night use until 2:00 a.m. daily on a 0.19 gross acre site",
         "Planner": "Emily Lipoma ",
         "DURATION": 56,
         "Year": 2013
      },
      {
         "PERMITID": "CP13-024",
         "APN": 46721025,
         "File Number": "CP13-024",
         "Address": "31 E SANTA CLARA ST SAN JOSE",
         "Project Name": "CP13-024",
         "Application Type": "Conditional Use Permit Renewal ",
         "Application Date": "4/22/13",
         "Status": "Approved ",
         "Description": "Conditional Use Permit renewal to allow a public drinking establishment with late night use until 2:00 a.m. daily on a 0.07 gross acre site",
         "Planner": "Emily Lipoma ",
         "DURATION": 64,
         "Year": 2013
      },
      {
         "PERMITID": "CP13-030",
         "APN": 25940070,
         "File Number": "CP13-030",
         "Address": "98 S ALMADEN AV SAN JOSE",
         "Project Name": "CP13-030",
         "Application Type": "Conditional Use Permit Renewal ",
         "Application Date": "5/21/13",
         "Status": "Approved ",
         "Description": "Conditional Use Permit Renewal to allow operation of a public drinking and entertainment establishment with late night use until 2:00 am.",
         "Planner": "Emily Lipoma ",
         "DURATION": 52,
         "Year": 2013
      },
      {
         "PERMITID": "CP14-008",
         "APN": 46722148,
         "File Number": "CP14-008",
         "Address": "78 E SANTA CLARA ST SAN JOSE",
         "Project Name": "CP14-008",
         "Application Type": "Conditional Use Permit Renewal ",
         "Application Date": "2/11/14",
         "Status": "Approved ",
         "Description": "Conditional Use Permit for a Timely Renewal and continued operation of an existing public drinking establishment (Dive Bar) with late night use until 2:00 a.m., on an approximately 0.43 gross acre site in the DC Downtown Primary Commercial Zoning District on the subject 0.43 gross acre site.",
         "Planner": "Aparna Ankola ",
         "DURATION": 100,
         "Year": 2014
      },
      {
         "PERMITID": "CP14-026",
         "APN": 25935056,
         "File Number": "CP14-026",
         "Address": "73 N SAN PEDRO ST SAN JOSE",
         "Project Name": "CP14-026",
         "Application Type": "Conditional Use Permit Renewal ",
         "Application Date": "5/2/14",
         "Status": "Approved ",
         "Description": "Conditional Use Permit for a Timely Renewal and continued operation of an existing public drinking establishment (Old Wagon Saloon) with late night use until 2:00 a.m., on an approximately 0.22 gross acre site in the DC Downtown Primary Commercial Zoning District",
         "Planner": "Aparna Ankola ",
         "DURATION": 85,
         "Year": 2014
      },
      {
         "PERMITID": "CPA00-005-01",
         "APN": 26429118,
         "File Number": "CPA00-005-01",
         "Address": "389 S 1ST ST SAN JOSE",
         "Project Name": "CPA00-005-01",
         "Application Type": "Conditional Use Permit Renewal ",
         "Application Date": "1/18/07",
         "Status": "Approved ",
         "Description": "Conditional Use Permit Amendment to allow an existing public eating, drinking, and entertainment establishment and late night use until 2:00 a.m. daily",
         "Planner": "Lesley Xavier ",
         "DURATION": 148,
         "Year": 2007
      },
      {
         "PERMITID": "CPA03-061-01",
         "APN": 46718090,
         "File Number": "CPA03-061-01",
         "Address": "301 E SANTA CLARA ST SAN JOSE",
         "Project Name": "CPA03-061-01",
         "Application Type": "Conditional Use Permit Renewal ",
         "Application Date": "10/28/05",
         "Status": "Approved ",
         "Description": "Conditional Use Permit Amendment to renew a previously approved permit CP03-061 for late night use until 3:00 am for an existing bakery and cafe and exterior modifications on a 0.22 gross acre site",
         "Planner": "Dave Tymn ",
         "DURATION": 724,
         "Year": 2005
      }
   ],
   "Conforming Conventional Zoning ": [
      {
         "PERMITID": "C02-070",
         "APN": 47217012,
         "File Number": "C02-070",
         "Address": "760 S 1ST ST SAN JOSE",
         "Project Name": "C02-070",
         "Application Type": "Conforming Conventional Zoning ",
         "Application Date": "9/6/02",
         "Status": "Approved ",
         "Description": "Conforming rezoning from A(PD) Planned Development and LI Light Industrial Districts to CP Pedestrian Commercial District to allow commercial uses on 0.59 gross acres (converted from PDC02-016)",
         "Planner": "John Davidson ",
         "DURATION": 2120,
         "Year": 2002
      },
      {
         "PERMITID": "C03-080",
         "APN": 26420064,
         "File Number": "C03-080",
         "Address": "500 W SAN CARLOS ST SAN JOSE",
         "Project Name": "C03-080",
         "Application Type": "Conforming Conventional Zoning ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Conventional Rezoning from LI Light Industrial Zoning District to CP Pedestrian Commercial Zoning District to allow commercial uses on a 0.18 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 1743,
         "Year": 2003
      },
      {
         "PERMITID": "C06-115",
         "APN": 25942081,
         "File Number": "C06-115",
         "Address": "S 1ST ST SAN JOSE",
         "Project Name": "C06-115",
         "Application Type": "Conforming Conventional Zoning ",
         "Application Date": "10/24/06",
         "Status": "Approved ",
         "Description": "Conventional Rezoning from CG (PD) Planned Development Zoning District to the DC Downtown Primary Commercial Zoning District to allow multiple dwelling residential uses on 0.53 gross acre site",
         "Planner": "Hadasa Lev ",
         "DURATION": 611,
         "Year": 2006
      },
      {
         "PERMITID": "C06-115",
         "APN": 25942082,
         "File Number": "C06-115",
         "Address": "S 1ST ST SAN JOSE",
         "Project Name": "C06-115",
         "Application Type": "Conforming Conventional Zoning ",
         "Application Date": "10/24/06",
         "Status": "Approved ",
         "Description": "Conventional Rezoning from CG (PD) Planned Development Zoning District to the DC Downtown Primary Commercial Zoning District to allow multiple dwelling residential uses on 0.53 gross acre site",
         "Planner": "Hadasa Lev ",
         "DURATION": 611,
         "Year": 2006
      },
      {
         "PERMITID": "C13-047",
         "APN": 25946040,
         "File Number": "C13-047",
         "Address": "248 SONOMA ST SAN JOSE",
         "Project Name": "C13-047",
         "Application Type": "Conforming Conventional Zoning ",
         "Application Date": "11/1/13",
         "Status": "Approved ",
         "Description": "Conforming Rezoning from LI Light Industrial zoning district to DC Downtown Core zoning district on a 1.72 gross acre site",
         "Planner": "Emily Lipoma ",
         "DURATION": 158,
         "Year": 2013
      },
      {
         "PERMITID": "C13-047",
         "APN": 25946044,
         "File Number": "C13-047",
         "Address": "248 SONOMA ST SAN JOSE",
         "Project Name": "C13-047",
         "Application Type": "Conforming Conventional Zoning ",
         "Application Date": "11/1/13",
         "Status": "Approved ",
         "Description": "Conforming Rezoning from LI Light Industrial zoning district to DC Downtown Core zoning district on a 1.72 gross acre site",
         "Planner": "Emily Lipoma ",
         "DURATION": 158,
         "Year": 2013
      },
      {
         "PERMITID": "C13-047",
         "APN": 25946045,
         "File Number": "C13-047",
         "Address": "248 SONOMA ST SAN JOSE",
         "Project Name": "C13-047",
         "Application Type": "Conforming Conventional Zoning ",
         "Application Date": "11/1/13",
         "Status": "Approved ",
         "Description": "Conforming Rezoning from LI Light Industrial zoning district to DC Downtown Core zoning district on a 1.72 gross acre site",
         "Planner": "Emily Lipoma ",
         "DURATION": 158,
         "Year": 2013
      },
      {
         "PERMITID": "C13-047",
         "APN": 25946056,
         "File Number": "C13-047",
         "Address": "248 SONOMA ST SAN JOSE",
         "Project Name": "C13-047",
         "Application Type": "Conforming Conventional Zoning ",
         "Application Date": "11/1/13",
         "Status": "Approved ",
         "Description": "Conforming Rezoning from LI Light Industrial zoning district to DC Downtown Core zoning district on a 1.72 gross acre site",
         "Planner": "Emily Lipoma ",
         "DURATION": 158,
         "Year": 2013
      },
      {
         "PERMITID": "C13-047",
         "APN": 25946057,
         "File Number": "C13-047",
         "Address": "248 SONOMA ST SAN JOSE",
         "Project Name": "C13-047",
         "Application Type": "Conforming Conventional Zoning ",
         "Application Date": "11/1/13",
         "Status": "Approved ",
         "Description": "Conforming Rezoning from LI Light Industrial zoning district to DC Downtown Core zoning district on a 1.72 gross acre site",
         "Planner": "Emily Lipoma ",
         "DURATION": 158,
         "Year": 2013
      },
      {
         "PERMITID": "C13-047",
         "APN": 25946090,
         "File Number": "C13-047",
         "Address": "248 SONOMA ST SAN JOSE",
         "Project Name": "C13-047",
         "Application Type": "Conforming Conventional Zoning ",
         "Application Date": "11/1/13",
         "Status": "Approved ",
         "Description": "Conforming Rezoning from LI Light Industrial zoning district to DC Downtown Core zoning district on a 1.72 gross acre site",
         "Planner": "Emily Lipoma ",
         "DURATION": 158,
         "Year": 2013
      },
      {
         "PERMITID": "C13-047",
         "APN": 25946109,
         "File Number": "C13-047",
         "Address": "248 SONOMA ST SAN JOSE",
         "Project Name": "C13-047",
         "Application Type": "Conforming Conventional Zoning ",
         "Application Date": "11/1/13",
         "Status": "Approved ",
         "Description": "Conforming Rezoning from LI Light Industrial zoning district to DC Downtown Core zoning district on a 1.72 gross acre site",
         "Planner": "Emily Lipoma ",
         "DURATION": 158,
         "Year": 2013
      },
      {
         "PERMITID": "C14-061",
         "APN": 46718102,
         "File Number": "C14-061",
         "Address": "389 E SANTA CLARA ST SAN JOSE",
         "Project Name": "C14-061 - La Vang Church",
         "Application Type": "Conforming Conventional Zoning ",
         "Application Date": "11/5/14 9:58",
         "Status": "Approved ",
         "Description": "Rezoning from the R-M Multiple Residence and CG Commercial General Zoning Districts to PQP Public/Quasi-Public Zoning District to allow church, school, and incidental day care uses on a 2.8-gross acre site (in conjunction with SP15-004 and HP15-001).",
         "Planner": "Jennifer Piozet ",
         "DURATION": 692,
         "Year": 2014
      },
      {
         "PERMITID": "C14-061",
         "APN": 46718103,
         "File Number": "C14-061",
         "Address": "389 E SANTA CLARA ST SAN JOSE",
         "Project Name": "C14-061 - La Vang Church",
         "Application Type": "Conforming Conventional Zoning ",
         "Application Date": "11/5/14 9:58",
         "Status": "Approved ",
         "Description": "Rezoning from the R-M Multiple Residence and CG Commercial General Zoning Districts to PQP Public/Quasi-Public Zoning District to allow church, school, and incidental day care uses on a 2.8-gross acre site (in conjunction with SP15-004 and HP15-001).",
         "Planner": "Jennifer Piozet ",
         "DURATION": 692,
         "Year": 2014
      },
      {
         "PERMITID": "C15-026",
         "APN": 46747058,
         "File Number": "C15-026",
         "Address": "439 S 4TH ST SAN JOSE",
         "Project Name": "C15-026",
         "Application Type": "Conforming Conventional Zoning ",
         "Application Date": "6/23/15 13:52",
         "Status": "Approved ",
         "Description": "Conventional Zoning from the CG Commercial General Zoning District to the DC Downtown Commercial Zoning District to allow for mixed uses on 0.5-gross acre site",
         "Planner": "Jennifer Piozet ",
         "DURATION": 325,
         "Year": 2015
      },
      {
         "PERMITID": "C15-026",
         "APN": 46747096,
         "File Number": "C15-026",
         "Address": "439 S 4TH ST SAN JOSE",
         "Project Name": "C15-026",
         "Application Type": "Conforming Conventional Zoning ",
         "Application Date": "6/23/15 13:52",
         "Status": "Approved ",
         "Description": "Conventional Zoning from the CG Commercial General Zoning District to the DC Downtown Commercial Zoning District to allow for mixed uses on 0.5-gross acre site",
         "Planner": "Jennifer Piozet ",
         "DURATION": 325,
         "Year": 2015
      },
      {
         "PERMITID": "C15-039",
         "APN": 46720087,
         "File Number": "C15-039",
         "Address": "33 N 5TH ST SAN JOSE",
         "Project Name": "C15-039 MIRO",
         "Application Type": "Conforming Conventional Zoning ",
         "Application Date": "8/5/15 14:04",
         "Status": "Approved ",
         "Description": "Conventional Rezoning from the CG Commercial General and R-M Multiple Residence Zoning Districts to the DC Downtown Primary Commercial Zoning District to allow a greater mix of uses on a 1.4 gross acre site",
         "Planner": "Jennifer Piozet ",
         "DURATION": 159,
         "Year": 2015
      },
      {
         "PERMITID": "C15-042",
         "APN": 25946046,
         "File Number": "C15-042",
         "Address": "267 DELMAS AV SAN JOSE",
         "Project Name": "C15-042",
         "Application Type": "Conforming Conventional Zoning ",
         "Application Date": "8/19/15 15:05",
         "Status": "Approved ",
         "Description": "Conventional Rezoning request to rezone four properties from LI Light Industrial to the DC Downtown Primary Commercial Zoning District on an approximately 0.47 gross acre site",
         "Planner": "Elizabeth Schuller ",
         "DURATION": 112,
         "Year": 2015
      },
      {
         "PERMITID": "C15-042",
         "APN": 25946048,
         "File Number": "C15-042",
         "Address": "267 DELMAS AV SAN JOSE",
         "Project Name": "C15-042",
         "Application Type": "Conforming Conventional Zoning ",
         "Application Date": "8/19/15 15:05",
         "Status": "Approved ",
         "Description": "Conventional Rezoning request to rezone four properties from LI Light Industrial to the DC Downtown Primary Commercial Zoning District on an approximately 0.47 gross acre site",
         "Planner": "Elizabeth Schuller ",
         "DURATION": 112,
         "Year": 2015
      },
      {
         "PERMITID": "C17-009",
         "APN": 26426088,
         "File Number": "C17-009",
         "Address": "425 AUZERAIS AV SAN JOSE",
         "Project Name": "C17-009",
         "Application Type": "Conforming Conventional Zoning ",
         "Application Date": "3/20/17 14:16",
         "Status": "Approved ",
         "Description": "Conventional Rezoning to rezone a portion of a 1.05 gross acre site from the LI Light Industrial Zoning District to the DC Downtown Primary Commercial Zoning District",
         "Planner": "Tracy Tam ",
         "DURATION": 512,
         "Year": 2017
      },
      {
         "PERMITID": "C16-003",
         "APN": 26420064,
         "File Number": "C16-003",
         "Address": "500 W SAN CARLOS ST SAN JOSE",
         "Project Name": "C16-003",
         "Application Type": "Conforming Conventional Zoning ",
         "Application Date": "1/13/16 11:14",
         "Status": "Notice Sent ",
         "Description": "A Conventional Conforming Rezoning from the CP Commercial Pedestrian Zoning District to the DC Downtown Primary Commercial Zoning District ",
         "Planner": "Tracy Tam ",
         "DURATION": 1016,
         "Year": 2016
      },
      {
         "PERMITID": "C17-010",
         "APN": 25948045,
         "File Number": "C17-010",
         "Address": "461 PARK AV SAN JOSE",
         "Project Name": "C17-010",
         "Application Type": "Conforming Conventional Zoning ",
         "Application Date": "3/22/17 10:59",
         "Status": "Notice Sent ",
         "Description": "Conforming Conventional Rezoning from Light Industrial (LI) Zoning District to Downtown (DT) Zoning District on a 0.16 gross acre site",
         "Planner": "Lea Simvoulakis ",
         "DURATION": 118,
         "Year": 2017
      },
      {
         "PERMITID": "C13-015",
         "APN": 46719059,
         "File Number": "C13-015",
         "Address": "73 N 6TH ST SAN JOSE",
         "Project Name": "C13-015",
         "Application Type": "Conforming Conventional Zoning ",
         "Application Date": " ",
         "Status": "Pending ",
         "Description": "Rezoning Permit to rezone 2 lots from CG and R-M to DC for a proposed Mixed Use development on a 0.30 gross acre site",
         "Planner": "John Baty ",
         "DURATION": 1,
         "Year": null
      },
      {
         "PERMITID": "C19-005",
         "APN": 46720019,
         "File Number": "C19-005",
         "Address": "100 N 4TH ST SAN JOSE",
         "Project Name": "C19-005",
         "Application Type": "Conforming Conventional Zoning ",
         "Application Date": "1/30/19 9:56",
         "Status": "Under Review ",
         "Description": "Conventional Rezoning from the CG Commercial General Zoning District to the DC Downtown Primary Commercial Zoning District on an approximately 0.98-gross acre site.",
         "Planner": "Stefanie Farmer ",
         "DURATION": 41,
         "Year": 2019
      },
      {
         "PERMITID": "C19-005",
         "APN": 46720020,
         "File Number": "C19-005",
         "Address": "100 N 4TH ST SAN JOSE",
         "Project Name": "C19-005",
         "Application Type": "Conforming Conventional Zoning ",
         "Application Date": "1/30/19 9:56",
         "Status": "Under Review ",
         "Description": "Conventional Rezoning from the CG Commercial General Zoning District to the DC Downtown Primary Commercial Zoning District on an approximately 0.98-gross acre site.",
         "Planner": "Stefanie Farmer ",
         "DURATION": 41,
         "Year": 2019
      },
      {
         "PERMITID": "C19-005",
         "APN": 46720021,
         "File Number": "C19-005",
         "Address": "100 N 4TH ST SAN JOSE",
         "Project Name": "C19-005",
         "Application Type": "Conforming Conventional Zoning ",
         "Application Date": "1/30/19 9:56",
         "Status": "Under Review ",
         "Description": "Conventional Rezoning from the CG Commercial General Zoning District to the DC Downtown Primary Commercial Zoning District on an approximately 0.98-gross acre site.",
         "Planner": "Stefanie Farmer ",
         "DURATION": 41,
         "Year": 2019
      },
      {
         "PERMITID": "C19-005",
         "APN": 46720022,
         "File Number": "C19-005",
         "Address": "100 N 4TH ST SAN JOSE",
         "Project Name": "C19-005",
         "Application Type": "Conforming Conventional Zoning ",
         "Application Date": "1/30/19 9:56",
         "Status": "Under Review ",
         "Description": "Conventional Rezoning from the CG Commercial General Zoning District to the DC Downtown Primary Commercial Zoning District on an approximately 0.98-gross acre site.",
         "Planner": "Stefanie Farmer ",
         "DURATION": 41,
         "Year": 2019
      },
      {
         "PERMITID": "C19-005",
         "APN": 46720040,
         "File Number": "C19-005",
         "Address": "100 N 4TH ST SAN JOSE",
         "Project Name": "C19-005",
         "Application Type": "Conforming Conventional Zoning ",
         "Application Date": "1/30/19 9:56",
         "Status": "Under Review ",
         "Description": "Conventional Rezoning from the CG Commercial General Zoning District to the DC Downtown Primary Commercial Zoning District on an approximately 0.98-gross acre site.",
         "Planner": "Stefanie Farmer ",
         "DURATION": 41,
         "Year": 2019
      }
   ],
   "Conforming PD Zoning ": [
      {
         "PERMITID": "C00-033",
         "APN": 26420081,
         "File Number": "C00-033",
         "Address": "476 W SAN CARLOS ST SAN JOSE",
         "Project Name": "C00-033",
         "Application Type": "Conforming PD Zoning ",
         "Application Date": "5/15/00",
         "Status": "Approved ",
         "Description": "Rezoning from M-1 Manufacturing District to the C-2 Commercial District on a 0.465 gross acre site",
         "Planner": "Robert MERKAMP ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "C79-143",
         "APN": 25947080,
         "File Number": "C79-143",
         "Address": "282 S MONTGOMERY ST SAN JOSE",
         "Project Name": "C79-143",
         "Application Type": "Conforming PD Zoning ",
         "Application Date": "10/4/79",
         "Status": "Approved ",
         "Description": "File type: R*Other apns: *Gen.Use Class:INDUSTRIAL*Existing Land Use:53*Specific Use:WHLSL/RETAIL MOTOR",
         "Planner": "Vic Mendez ",
         "DURATION": 0,
         "Year": 1979
      },
      {
         "PERMITID": "C87-071",
         "APN": 26420008,
         "File Number": "C87-071",
         "Address": "358 ROYAL AV SAN JOSE",
         "Project Name": "C87-071",
         "Application Type": "Conforming PD Zoning ",
         "Application Date": "9/25/87",
         "Status": "Approved ",
         "Description": "Other APNs:,10,12,21,",
         "Planner": "UNKNOWN ",
         "DURATION": 0,
         "Year": 1987
      },
      {
         "PERMITID": "C95-042",
         "APN": 47217012,
         "File Number": "C95-042",
         "Address": "760 S 1ST ST SAN JOSE",
         "Project Name": "C95-042",
         "Application Type": "Conforming PD Zoning ",
         "Application Date": "8/14/95",
         "Status": "Approved ",
         "Description": "(Q83) REZONE FROM M-1 TO C-2; Other APNs:,-013",
         "Planner": "JPRANDI ",
         "DURATION": 0,
         "Year": 1995
      },
      {
         "PERMITID": "C97-085",
         "APN": 47217006,
         "File Number": "C97-085",
         "Address": "802 S 1ST ST SAN JOSE",
         "Project Name": "C97-085",
         "Application Type": "Conforming PD Zoning ",
         "Application Date": "11/26/97",
         "Status": "Approved ",
         "Description": "To rezone from M1 to C3",
         "Planner": "Akoni Danielsen ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "C98-016",
         "APN": 26420080,
         "File Number": "C98-016",
         "Address": "482 W SAN CARLOS ST SAN JOSE",
         "Project Name": "C98-016",
         "Application Type": "Conforming PD Zoning ",
         "Application Date": "2/10/98",
         "Status": "Approved ",
         "Description": "Rezone M-1 to C-2 for office/retail uses",
         "Planner": "Akoni Danielsen ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "C98-020",
         "APN": 25924035,
         "File Number": "C98-020",
         "Address": "333 W JULIAN ST SAN JOSE",
         "Project Name": "C98-020",
         "Application Type": "Conforming PD Zoning ",
         "Application Date": "2/24/98",
         "Status": "Approved ",
         "Description": "To allow rezoning from M-4 to I for office uses",
         "Planner": "BPEDROTT ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "C98-043",
         "APN": 26420112,
         "File Number": "C98-043",
         "Address": "530 W SAN CARLOS ST SAN JOSE",
         "Project Name": "C98-043",
         "Application Type": "Conforming PD Zoning ",
         "Application Date": "6/15/98",
         "Status": "Approved ",
         "Description": "To allow rezoning from M-1 to C-2 on a 0.08 gross acre site",
         "Planner": "Akoni Danielsen ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "PDC03-094",
         "APN": 47221104,
         "File Number": "PDC03-094",
         "Address": "9645 TRACT SAN JOSE",
         "Project Name": "PDC03-094 - SJ Bible College Site",
         "Application Type": "Conforming PD Zoning ",
         "Application Date": "11/10/03",
         "Status": "Approved ",
         "Description": "Planned Development Rezoning from R-1-8 Residence Zoning District, CP Commercial Pedestrian Zoning District to A(PD) Planned Development Zoning District to allow up to 55 single-family detached residences on a 8.6 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 1690,
         "Year": 2003
      },
      {
         "PERMITID": "PDC03-094",
         "APN": 47222060,
         "File Number": "PDC03-094",
         "Address": "9645 TRACT SAN JOSE",
         "Project Name": "PDC03-094 - SJ Bible College Site",
         "Application Type": "Conforming PD Zoning ",
         "Application Date": "11/10/03",
         "Status": "Approved ",
         "Description": "Planned Development Rezoning from R-1-8 Residence Zoning District, CP Commercial Pedestrian Zoning District to A(PD) Planned Development Zoning District to allow up to 55 single-family detached residences on a 8.6 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 1690,
         "Year": 2003
      },
      {
         "PERMITID": "PDC03-094",
         "APN": 47222062,
         "File Number": "PDC03-094",
         "Address": "9645 TRACT SAN JOSE",
         "Project Name": "PDC03-094 - SJ Bible College Site",
         "Application Type": "Conforming PD Zoning ",
         "Application Date": "11/10/03",
         "Status": "Approved ",
         "Description": "Planned Development Rezoning from R-1-8 Residence Zoning District, CP Commercial Pedestrian Zoning District to A(PD) Planned Development Zoning District to allow up to 55 single-family detached residences on a 8.6 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 1690,
         "Year": 2003
      },
      {
         "PERMITID": "PDC03-094",
         "APN": 47241050,
         "File Number": "PDC03-094",
         "Address": "9645 TRACT SAN JOSE",
         "Project Name": "PDC03-094 - SJ Bible College Site",
         "Application Type": "Conforming PD Zoning ",
         "Application Date": "11/10/03",
         "Status": "Approved ",
         "Description": "Planned Development Rezoning from R-1-8 Residence Zoning District, CP Commercial Pedestrian Zoning District to A(PD) Planned Development Zoning District to allow up to 55 single-family detached residences on a 8.6 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 1690,
         "Year": 2003
      },
      {
         "PERMITID": "PDC03-094",
         "APN": 47241051,
         "File Number": "PDC03-094",
         "Address": "9645 TRACT SAN JOSE",
         "Project Name": "PDC03-094 - SJ Bible College Site",
         "Application Type": "Conforming PD Zoning ",
         "Application Date": "11/10/03",
         "Status": "Approved ",
         "Description": "Planned Development Rezoning from R-1-8 Residence Zoning District, CP Commercial Pedestrian Zoning District to A(PD) Planned Development Zoning District to allow up to 55 single-family detached residences on a 8.6 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 1690,
         "Year": 2003
      },
      {
         "PERMITID": "C99-068",
         "APN": 46724012,
         "File Number": "C99-068",
         "Address": "80 S 5TH ST SAN JOSE",
         "Project Name": "C99-068",
         "Application Type": "Conforming PD Zoning ",
         "Application Date": "8/2/99",
         "Status": "Withdrawn ",
         "Description": "Conventional Rezoning from the R-4 Residence District to the C Commercial District for church use on a 0.56 gross acre site",
         "Planner": "Akoni Danielsen ",
         "DURATION": 0,
         "Year": 1999
      }
   ],
   "Conventional Parcel Map ": [
      {
         "PERMITID": "T15-003",
         "APN": 25942082,
         "File Number": "T15-003",
         "Address": "200 S MARKET ST SAN JOSE",
         "Project Name": "T15-003",
         "Application Type": "Conventional Parcel Map ",
         "Application Date": " ",
         "Status": "Withdrawn ",
         "Description": "Parcel Map to create one condominium map to allow three airspace condominium lots on .52 gross acre site",
         "Planner": "Avril Baty ",
         "DURATION": 1,
         "Year": null
      }
   ],
   "Conventional Subdivision Map ": [
      {
         "PERMITID": "T00-022",
         "APN": 25924035,
         "File Number": "T00-022",
         "Address": "333 W JULIAN ST SAN JOSE",
         "Project Name": "T00-022",
         "Application Type": "Conventional Subdivision Map ",
         "Application Date": "2/9/00",
         "Status": "Approved ",
         "Description": "Tentative Map Permit to combine 10 parcels into 4 lots",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "T00-022",
         "APN": 25924037,
         "File Number": "T00-022",
         "Address": "333 W JULIAN ST SAN JOSE",
         "Project Name": "T00-022",
         "Application Type": "Conventional Subdivision Map ",
         "Application Date": "2/9/00",
         "Status": "Approved ",
         "Description": "Tentative Map Permit to combine 10 parcels into 4 lots",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "T02-011",
         "APN": 47224111,
         "File Number": "T02-011",
         "Address": "659 S 8TH ST SAN JOSE",
         "Project Name": "T02-011 8th/Reed Condo Map",
         "Application Type": "Conventional Subdivision Map ",
         "Application Date": "1/18/02 10:56",
         "Status": "Approved ",
         "Description": "Tentative Map Permit to consolidate 2 parcels into 1 lot for multi-family residential use on a 0.26 gross acre site",
         "Planner": "Akoni Danielsen ",
         "DURATION": 316,
         "Year": 2002
      },
      {
         "PERMITID": "T13-032",
         "APN": 46757083,
         "File Number": "T13-032",
         "Address": "235 E SANTA CLARA ST SAN JOSE",
         "Project Name": "T13-032",
         "Application Type": "Conventional Subdivision Map ",
         "Application Date": "6/7/13",
         "Status": "Approved ",
         "Description": "Tentative Map to consolidate 8 parcels into 1 lot for residential uses on 1.18 gross acre site",
         "Planner": "Kristinae Toomians ",
         "DURATION": 175,
         "Year": 2013
      },
      {
         "PERMITID": "T13-032",
         "APN": 46757084,
         "File Number": "T13-032",
         "Address": "235 E SANTA CLARA ST SAN JOSE",
         "Project Name": "T13-032",
         "Application Type": "Conventional Subdivision Map ",
         "Application Date": "6/7/13",
         "Status": "Approved ",
         "Description": "Tentative Map to consolidate 8 parcels into 1 lot for residential uses on 1.18 gross acre site",
         "Planner": "Kristinae Toomians ",
         "DURATION": 175,
         "Year": 2013
      },
      {
         "PERMITID": "T14-001",
         "APN": 46721018,
         "File Number": "T14-001",
         "Address": "66 N 1ST ST SAN JOSE",
         "Project Name": "T14-001",
         "Application Type": "Conventional Subdivision Map ",
         "Application Date": "2/28/14",
         "Status": "Approved ",
         "Description": "Tentative Map to combine six parcels into one parcel on a 1.4 gross acre site",
         "Planner": "Rebecca Bustos ",
         "DURATION": 382,
         "Year": 2014
      },
      {
         "PERMITID": "T14-001",
         "APN": 46721030,
         "File Number": "T14-001",
         "Address": "66 N 1ST ST SAN JOSE",
         "Project Name": "T14-001",
         "Application Type": "Conventional Subdivision Map ",
         "Application Date": "2/28/14",
         "Status": "Approved ",
         "Description": "Tentative Map to combine six parcels into one parcel on a 1.4 gross acre site",
         "Planner": "Rebecca Bustos ",
         "DURATION": 382,
         "Year": 2014
      },
      {
         "PERMITID": "T14-001",
         "APN": 46721038,
         "File Number": "T14-001",
         "Address": "66 N 1ST ST SAN JOSE",
         "Project Name": "T14-001",
         "Application Type": "Conventional Subdivision Map ",
         "Application Date": "2/28/14",
         "Status": "Approved ",
         "Description": "Tentative Map to combine six parcels into one parcel on a 1.4 gross acre site",
         "Planner": "Rebecca Bustos ",
         "DURATION": 382,
         "Year": 2014
      },
      {
         "PERMITID": "T14-029",
         "APN": 25932040,
         "File Number": "T14-029",
         "Address": "201 W JULIAN ST SAN JOSE",
         "Project Name": "T14-029",
         "Application Type": "Conventional Subdivision Map ",
         "Application Date": "7/16/14 10:22",
         "Status": "Approved ",
         "Description": "A Tentative Map Permit to subdivide 32 parcels into 40 lots for mixed use attached residential units on 13.49 gross acre site",
         "Planner": "John Tu ",
         "DURATION": 155,
         "Year": 2014
      },
      {
         "PERMITID": "T14-029",
         "APN": 25932041,
         "File Number": "T14-029",
         "Address": "201 W JULIAN ST SAN JOSE",
         "Project Name": "T14-029",
         "Application Type": "Conventional Subdivision Map ",
         "Application Date": "7/16/14 10:22",
         "Status": "Approved ",
         "Description": "A Tentative Map Permit to subdivide 32 parcels into 40 lots for mixed use attached residential units on 13.49 gross acre site",
         "Planner": "John Tu ",
         "DURATION": 155,
         "Year": 2014
      },
      {
         "PERMITID": "T14-029",
         "APN": 25932073,
         "File Number": "T14-029",
         "Address": "201 W JULIAN ST SAN JOSE",
         "Project Name": "T14-029",
         "Application Type": "Conventional Subdivision Map ",
         "Application Date": "7/16/14 10:22",
         "Status": "Approved ",
         "Description": "A Tentative Map Permit to subdivide 32 parcels into 40 lots for mixed use attached residential units on 13.49 gross acre site",
         "Planner": "John Tu ",
         "DURATION": 155,
         "Year": 2014
      },
      {
         "PERMITID": "T14-029",
         "APN": 25932079,
         "File Number": "T14-029",
         "Address": "201 W JULIAN ST SAN JOSE",
         "Project Name": "T14-029",
         "Application Type": "Conventional Subdivision Map ",
         "Application Date": "7/16/14 10:22",
         "Status": "Approved ",
         "Description": "A Tentative Map Permit to subdivide 32 parcels into 40 lots for mixed use attached residential units on 13.49 gross acre site",
         "Planner": "John Tu ",
         "DURATION": 155,
         "Year": 2014
      },
      {
         "PERMITID": "T14-029",
         "APN": 25933067,
         "File Number": "T14-029",
         "Address": "201 W JULIAN ST SAN JOSE",
         "Project Name": "T14-029",
         "Application Type": "Conventional Subdivision Map ",
         "Application Date": "7/16/14 10:22",
         "Status": "Approved ",
         "Description": "A Tentative Map Permit to subdivide 32 parcels into 40 lots for mixed use attached residential units on 13.49 gross acre site",
         "Planner": "John Tu ",
         "DURATION": 155,
         "Year": 2014
      },
      {
         "PERMITID": "T16-008",
         "APN": 46701118,
         "File Number": "T16-008",
         "Address": "10367 TRACT SAN JOSE",
         "Project Name": "T16-008 - Parkview Tower",
         "Application Type": "Conventional Subdivision Map ",
         "Application Date": "1/26/16 10:09",
         "Status": "Approved ",
         "Description": "Tentative Map to allow for the construction of three buildings ranging from 38 feet to 201 feet with up to 220 condominiums and approximately 18,032 square feet of commercial space on a 1.52 gross acre site, in the DC Downtown Primary Commercial Zoning District, located on the northeast corner of the intersection of 1st Street and St. James Street.",
         "Planner": "Tracy Tam ",
         "DURATION": 94,
         "Year": 2016
      },
      {
         "PERMITID": "T16-048",
         "APN": 46746072,
         "File Number": "T16-048",
         "Address": "80 E SAN CARLOS ST SAN JOSE",
         "Project Name": "T16-048 The Graduate",
         "Application Type": "Conventional Subdivision Map ",
         "Application Date": "10/19/16",
         "Status": "Approved ",
         "Description": "Tentative Map to combine six parcels into one lot on a 1.45 gross acre site",
         "Planner": "Emily Lipoma ",
         "DURATION": 156,
         "Year": 2016
      },
      {
         "PERMITID": "T17-015",
         "APN": 26426013,
         "File Number": "T17-015",
         "Address": "425 AUZERAIS AV SAN JOSE",
         "Project Name": "T17-015",
         "Application Type": "Conventional Subdivision Map ",
         "Application Date": "3/21/17 14:41",
         "Status": "Approved ",
         "Description": "Tentative Map to combine three lots into one lot and to allow the creation of 130 residential condominium units on an approximately 1.05 gross acre site",
         "Planner": "Tracy Tam ",
         "DURATION": 511,
         "Year": 2017
      },
      {
         "PERMITID": "T17-015",
         "APN": 26426088,
         "File Number": "T17-015",
         "Address": "425 AUZERAIS AV SAN JOSE",
         "Project Name": "T17-015",
         "Application Type": "Conventional Subdivision Map ",
         "Application Date": "3/21/17 14:41",
         "Status": "Approved ",
         "Description": "Tentative Map to combine three lots into one lot and to allow the creation of 130 residential condominium units on an approximately 1.05 gross acre site",
         "Planner": "Tracy Tam ",
         "DURATION": 511,
         "Year": 2017
      },
      {
         "PERMITID": "T84-032",
         "APN": 25946066,
         "File Number": "T84-032",
         "Address": "443 W SAN CARLOS ST SAN JOSE",
         "Project Name": "T84-032",
         "Application Type": "Conventional Subdivision Map ",
         "Application Date": "3/3/84",
         "Status": "Approved ",
         "Description": "OFFICE; Other APNs:/067/094/095",
         "Planner": "HBAKER ",
         "DURATION": 0,
         "Year": 1984
      },
      {
         "PERMITID": "T84-062",
         "APN": 47221100,
         "File Number": "T84-062",
         "Address": "720 MARGARET ST SAN JOSE",
         "Project Name": "T84-062",
         "Application Type": "Conventional Subdivision Map ",
         "Application Date": "5/7/84",
         "Status": "Approved ",
         "Description": "RES ",
         "Planner": "HBAKER ",
         "DURATION": 0,
         "Year": 1984
      },
      {
         "PERMITID": "T92-085",
         "APN": 24974003,
         "File Number": "T92-085",
         "Address": "370 N 4TH ST SAN JOSE",
         "Project Name": "T92-085",
         "Application Type": "Conventional Subdivision Map ",
         "Application Date": "12/22/92",
         "Status": "Approved ",
         "Description": "CONDOMINIUM MAP FOR 6 SFAR UNITS",
         "Planner": "KKOVAR ",
         "DURATION": 0,
         "Year": 1992
      },
      {
         "PERMITID": "T92-085",
         "APN": 24974006,
         "File Number": "T92-085",
         "Address": "370 N 4TH ST SAN JOSE",
         "Project Name": "T92-085",
         "Application Type": "Conventional Subdivision Map ",
         "Application Date": "12/22/92",
         "Status": "Approved ",
         "Description": "CONDOMINIUM MAP FOR 6 SFAR UNITS",
         "Planner": "KKOVAR ",
         "DURATION": 0,
         "Year": 1992
      },
      {
         "PERMITID": "T19-003",
         "APN": 46720019,
         "File Number": "T19-003",
         "Address": "100 N 4TH ST SAN JOSE",
         "Project Name": "T19-003",
         "Application Type": "Conventional Subdivision Map ",
         "Application Date": "2/15/19",
         "Status": "Review Letter Sent ",
         "Description": "Vesting Tentative Map to merge five (5) lots to one (1) lot on an approximately 0.98-gross acre site",
         "Planner": "Stefanie Farmer ",
         "DURATION": 50,
         "Year": 2019
      },
      {
         "PERMITID": "T19-003",
         "APN": 46720020,
         "File Number": "T19-003",
         "Address": "100 N 4TH ST SAN JOSE",
         "Project Name": "T19-003",
         "Application Type": "Conventional Subdivision Map ",
         "Application Date": "2/15/19",
         "Status": "Review Letter Sent ",
         "Description": "Vesting Tentative Map to merge five (5) lots to one (1) lot on an approximately 0.98-gross acre site",
         "Planner": "Stefanie Farmer ",
         "DURATION": 50,
         "Year": 2019
      },
      {
         "PERMITID": "T19-003",
         "APN": 46720021,
         "File Number": "T19-003",
         "Address": "100 N 4TH ST SAN JOSE",
         "Project Name": "T19-003",
         "Application Type": "Conventional Subdivision Map ",
         "Application Date": "2/15/19",
         "Status": "Review Letter Sent ",
         "Description": "Vesting Tentative Map to merge five (5) lots to one (1) lot on an approximately 0.98-gross acre site",
         "Planner": "Stefanie Farmer ",
         "DURATION": 50,
         "Year": 2019
      },
      {
         "PERMITID": "T19-003",
         "APN": 46720022,
         "File Number": "T19-003",
         "Address": "100 N 4TH ST SAN JOSE",
         "Project Name": "T19-003",
         "Application Type": "Conventional Subdivision Map ",
         "Application Date": "2/15/19",
         "Status": "Review Letter Sent ",
         "Description": "Vesting Tentative Map to merge five (5) lots to one (1) lot on an approximately 0.98-gross acre site",
         "Planner": "Stefanie Farmer ",
         "DURATION": 50,
         "Year": 2019
      },
      {
         "PERMITID": "T19-003",
         "APN": 46720040,
         "File Number": "T19-003",
         "Address": "100 N 4TH ST SAN JOSE",
         "Project Name": "T19-003",
         "Application Type": "Conventional Subdivision Map ",
         "Application Date": "2/15/19",
         "Status": "Review Letter Sent ",
         "Description": "Vesting Tentative Map to merge five (5) lots to one (1) lot on an approximately 0.98-gross acre site",
         "Planner": "Stefanie Farmer ",
         "DURATION": 50,
         "Year": 2019
      },
      {
         "PERMITID": "T14-019",
         "APN": 25942081,
         "File Number": "T14-019",
         "Address": "240 S MARKET ST SAN JOSE",
         "Project Name": "T14-019",
         "Application Type": "Conventional Subdivision Map ",
         "Application Date": "6/5/14",
         "Status": "Withdrawn ",
         "Description": "Conventional Subdivision Map to create one condominium map to allow three airspace condominium lots ",
         "Planner": "Tania Jordanova ",
         "DURATION": 35,
         "Year": 2014
      },
      {
         "PERMITID": "T14-019",
         "APN": 25942082,
         "File Number": "T14-019",
         "Address": "240 S MARKET ST SAN JOSE",
         "Project Name": "T14-019",
         "Application Type": "Conventional Subdivision Map ",
         "Application Date": "6/5/14",
         "Status": "Withdrawn ",
         "Description": "Conventional Subdivision Map to create one condominium map to allow three airspace condominium lots ",
         "Planner": "Tania Jordanova ",
         "DURATION": 35,
         "Year": 2014
      },
      {
         "PERMITID": "T17-031",
         "APN": 46720019,
         "File Number": "T17-031",
         "Address": "100 N 4TH ST SAN JOSE",
         "Project Name": "T17-031 - 100 North 4th Street",
         "Application Type": "Conventional Subdivision Map ",
         "Application Date": "7/31/17 10:28",
         "Status": "Withdrawn ",
         "Description": "Vesting Tentative Map to reconfigure six (6) parcels to one (1) lot on 0.91 gross acre site",
         "Planner": "Rick Smeaton ",
         "DURATION": 254,
         "Year": 2017
      },
      {
         "PERMITID": "T17-031",
         "APN": 46720020,
         "File Number": "T17-031",
         "Address": "100 N 4TH ST SAN JOSE",
         "Project Name": "T17-031 - 100 North 4th Street",
         "Application Type": "Conventional Subdivision Map ",
         "Application Date": "7/31/17 10:28",
         "Status": "Withdrawn ",
         "Description": "Vesting Tentative Map to reconfigure six (6) parcels to one (1) lot on 0.91 gross acre site",
         "Planner": "Rick Smeaton ",
         "DURATION": 254,
         "Year": 2017
      },
      {
         "PERMITID": "T17-031",
         "APN": 46720021,
         "File Number": "T17-031",
         "Address": "100 N 4TH ST SAN JOSE",
         "Project Name": "T17-031 - 100 North 4th Street",
         "Application Type": "Conventional Subdivision Map ",
         "Application Date": "7/31/17 10:28",
         "Status": "Withdrawn ",
         "Description": "Vesting Tentative Map to reconfigure six (6) parcels to one (1) lot on 0.91 gross acre site",
         "Planner": "Rick Smeaton ",
         "DURATION": 254,
         "Year": 2017
      },
      {
         "PERMITID": "T17-031",
         "APN": 46720022,
         "File Number": "T17-031",
         "Address": "100 N 4TH ST SAN JOSE",
         "Project Name": "T17-031 - 100 North 4th Street",
         "Application Type": "Conventional Subdivision Map ",
         "Application Date": "7/31/17 10:28",
         "Status": "Withdrawn ",
         "Description": "Vesting Tentative Map to reconfigure six (6) parcels to one (1) lot on 0.91 gross acre site",
         "Planner": "Rick Smeaton ",
         "DURATION": 254,
         "Year": 2017
      },
      {
         "PERMITID": "T17-031",
         "APN": 46720040,
         "File Number": "T17-031",
         "Address": "100 N 4TH ST SAN JOSE",
         "Project Name": "T17-031 - 100 North 4th Street",
         "Application Type": "Conventional Subdivision Map ",
         "Application Date": "7/31/17 10:28",
         "Status": "Withdrawn ",
         "Description": "Vesting Tentative Map to reconfigure six (6) parcels to one (1) lot on 0.91 gross acre site",
         "Planner": "Rick Smeaton ",
         "DURATION": 254,
         "Year": 2017
      }
   ],
   "Conventional Zoning ": [
      {
         "PERMITID": "C04-019",
         "APN": 25945029,
         "File Number": "C04-019",
         "Address": "398 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "C04-019 Delmas 1",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District to R-2 Two-Family Residence District to allow residential uses on a 6.59 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-019",
         "APN": 25945030,
         "File Number": "C04-019",
         "Address": "398 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "C04-019 Delmas 1",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District to R-2 Two-Family Residence District to allow residential uses on a 6.59 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-019",
         "APN": 25945043,
         "File Number": "C04-019",
         "Address": "398 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "C04-019 Delmas 1",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District to R-2 Two-Family Residence District to allow residential uses on a 6.59 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-019",
         "APN": 25945044,
         "File Number": "C04-019",
         "Address": "398 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "C04-019 Delmas 1",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District to R-2 Two-Family Residence District to allow residential uses on a 6.59 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-019",
         "APN": 25945045,
         "File Number": "C04-019",
         "Address": "398 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "C04-019 Delmas 1",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District to R-2 Two-Family Residence District to allow residential uses on a 6.59 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-019",
         "APN": 25945047,
         "File Number": "C04-019",
         "Address": "398 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "C04-019 Delmas 1",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District to R-2 Two-Family Residence District to allow residential uses on a 6.59 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-019",
         "APN": 25945048,
         "File Number": "C04-019",
         "Address": "398 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "C04-019 Delmas 1",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District to R-2 Two-Family Residence District to allow residential uses on a 6.59 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-019",
         "APN": 25945049,
         "File Number": "C04-019",
         "Address": "398 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "C04-019 Delmas 1",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District to R-2 Two-Family Residence District to allow residential uses on a 6.59 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-019",
         "APN": 25945052,
         "File Number": "C04-019",
         "Address": "398 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "C04-019 Delmas 1",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District to R-2 Two-Family Residence District to allow residential uses on a 6.59 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-019",
         "APN": 25945053,
         "File Number": "C04-019",
         "Address": "398 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "C04-019 Delmas 1",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District to R-2 Two-Family Residence District to allow residential uses on a 6.59 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-019",
         "APN": 25945055,
         "File Number": "C04-019",
         "Address": "398 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "C04-019 Delmas 1",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District to R-2 Two-Family Residence District to allow residential uses on a 6.59 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-019",
         "APN": 25945057,
         "File Number": "C04-019",
         "Address": "398 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "C04-019 Delmas 1",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District to R-2 Two-Family Residence District to allow residential uses on a 6.59 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-019",
         "APN": 25945058,
         "File Number": "C04-019",
         "Address": "398 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "C04-019 Delmas 1",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District to R-2 Two-Family Residence District to allow residential uses on a 6.59 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-019",
         "APN": 25945059,
         "File Number": "C04-019",
         "Address": "398 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "C04-019 Delmas 1",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District to R-2 Two-Family Residence District to allow residential uses on a 6.59 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-019",
         "APN": 25945060,
         "File Number": "C04-019",
         "Address": "398 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "C04-019 Delmas 1",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District to R-2 Two-Family Residence District to allow residential uses on a 6.59 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-019",
         "APN": 25945061,
         "File Number": "C04-019",
         "Address": "398 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "C04-019 Delmas 1",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District to R-2 Two-Family Residence District to allow residential uses on a 6.59 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-019",
         "APN": 25945062,
         "File Number": "C04-019",
         "Address": "398 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "C04-019 Delmas 1",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District to R-2 Two-Family Residence District to allow residential uses on a 6.59 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-019",
         "APN": 25945070,
         "File Number": "C04-019",
         "Address": "398 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "C04-019 Delmas 1",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District to R-2 Two-Family Residence District to allow residential uses on a 6.59 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-019",
         "APN": 25945074,
         "File Number": "C04-019",
         "Address": "398 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "C04-019 Delmas 1",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District to R-2 Two-Family Residence District to allow residential uses on a 6.59 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-019",
         "APN": 25945075,
         "File Number": "C04-019",
         "Address": "398 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "C04-019 Delmas 1",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District to R-2 Two-Family Residence District to allow residential uses on a 6.59 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-019",
         "APN": 25945076,
         "File Number": "C04-019",
         "Address": "398 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "C04-019 Delmas 1",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District to R-2 Two-Family Residence District to allow residential uses on a 6.59 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-019",
         "APN": 25945077,
         "File Number": "C04-019",
         "Address": "398 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "C04-019 Delmas 1",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District to R-2 Two-Family Residence District to allow residential uses on a 6.59 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-019",
         "APN": 25945080,
         "File Number": "C04-019",
         "Address": "398 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "C04-019 Delmas 1",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District to R-2 Two-Family Residence District to allow residential uses on a 6.59 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-019",
         "APN": 25948018,
         "File Number": "C04-019",
         "Address": "398 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "C04-019 Delmas 1",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District to R-2 Two-Family Residence District to allow residential uses on a 6.59 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-019",
         "APN": 25948019,
         "File Number": "C04-019",
         "Address": "398 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "C04-019 Delmas 1",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District to R-2 Two-Family Residence District to allow residential uses on a 6.59 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-019",
         "APN": 25948023,
         "File Number": "C04-019",
         "Address": "398 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "C04-019 Delmas 1",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District to R-2 Two-Family Residence District to allow residential uses on a 6.59 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-019",
         "APN": 25948024,
         "File Number": "C04-019",
         "Address": "398 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "C04-019 Delmas 1",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District to R-2 Two-Family Residence District to allow residential uses on a 6.59 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-019",
         "APN": 25948025,
         "File Number": "C04-019",
         "Address": "398 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "C04-019 Delmas 1",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District to R-2 Two-Family Residence District to allow residential uses on a 6.59 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-019",
         "APN": 25948026,
         "File Number": "C04-019",
         "Address": "398 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "C04-019 Delmas 1",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District to R-2 Two-Family Residence District to allow residential uses on a 6.59 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-019",
         "APN": 25948027,
         "File Number": "C04-019",
         "Address": "398 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "C04-019 Delmas 1",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District to R-2 Two-Family Residence District to allow residential uses on a 6.59 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-019",
         "APN": 25948028,
         "File Number": "C04-019",
         "Address": "398 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "C04-019 Delmas 1",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District to R-2 Two-Family Residence District to allow residential uses on a 6.59 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-019",
         "APN": 25948029,
         "File Number": "C04-019",
         "Address": "398 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "C04-019 Delmas 1",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District to R-2 Two-Family Residence District to allow residential uses on a 6.59 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-019",
         "APN": 25948048,
         "File Number": "C04-019",
         "Address": "398 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "C04-019 Delmas 1",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District to R-2 Two-Family Residence District to allow residential uses on a 6.59 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-019",
         "APN": 25948049,
         "File Number": "C04-019",
         "Address": "398 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "C04-019 Delmas 1",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District to R-2 Two-Family Residence District to allow residential uses on a 6.59 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26419002,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26419003,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26419004,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26419005,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26419006,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26419007,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26419009,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26419035,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26419037,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26419071,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26419076,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26419078,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26420041,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26420042,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26420044,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26420045,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26420046,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26420047,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26420048,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26420049,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26420050,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26420051,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26420052,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26420053,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26420065,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26420066,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26420067,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26420069,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26420072,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26420073,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26420074,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26420086,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26420087,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26420088,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26420089,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26420090,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26420091,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26420094,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26420096,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26420097,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26420099,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26420101,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26420102,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26420104,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26420105,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26420106,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26420107,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26420108,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26420113,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26420114,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26420126,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26420127,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26421003,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26421005,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26421006,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26421007,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26421026,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26421028,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26421029,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26421030,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26421033,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26421034,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26421035,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26421036,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26421037,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26421039,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26421063,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26421064,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26421065,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26421066,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26421067,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26421068,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26421069,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26421071,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26421072,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26425095,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26425096,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26425099,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26425119,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26426017,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26426018,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26426019,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26426020,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26426022,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26426023,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26426024,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26426025,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26426028,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26426029,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-020",
         "APN": 26426088,
         "File Number": "C04-020",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "C04-020 Delmas 2",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/3/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial Zoning District and R-2 Two-Family Residence District to R-2 Two-Family Residence District and CP Pedestrian Commercial Zoning District to allow residential and commercial uses on a 13.48 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1576,
         "Year": 2004
      },
      {
         "PERMITID": "C04-035",
         "APN": 47217004,
         "File Number": "C04-035",
         "Address": "1101 S 1ST ST SAN JOSE",
         "Project Name": "C04-035 Washington/Spartan Keyes",
         "Application Type": "Conventional Zoning ",
         "Application Date": "4/9/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial, CN Neighborhood Commercial, CG General Commercial Zoning Districts to CP Pedestrian Commercial and R-M Multi-Family Residence Zoning Districts to allow commercial and multi-family residential uses on a 18.95 gross acre site",
         "Planner": "JBORELL ",
         "DURATION": 1539,
         "Year": 2004
      },
      {
         "PERMITID": "C04-035",
         "APN": 47217006,
         "File Number": "C04-035",
         "Address": "1101 S 1ST ST SAN JOSE",
         "Project Name": "C04-035 Washington/Spartan Keyes",
         "Application Type": "Conventional Zoning ",
         "Application Date": "4/9/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial, CN Neighborhood Commercial, CG General Commercial Zoning Districts to CP Pedestrian Commercial and R-M Multi-Family Residence Zoning Districts to allow commercial and multi-family residential uses on a 18.95 gross acre site",
         "Planner": "JBORELL ",
         "DURATION": 1539,
         "Year": 2004
      },
      {
         "PERMITID": "C04-035",
         "APN": 47217012,
         "File Number": "C04-035",
         "Address": "1101 S 1ST ST SAN JOSE",
         "Project Name": "C04-035 Washington/Spartan Keyes",
         "Application Type": "Conventional Zoning ",
         "Application Date": "4/9/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial, CN Neighborhood Commercial, CG General Commercial Zoning Districts to CP Pedestrian Commercial and R-M Multi-Family Residence Zoning Districts to allow commercial and multi-family residential uses on a 18.95 gross acre site",
         "Planner": "JBORELL ",
         "DURATION": 1539,
         "Year": 2004
      },
      {
         "PERMITID": "C04-035",
         "APN": 47217014,
         "File Number": "C04-035",
         "Address": "1101 S 1ST ST SAN JOSE",
         "Project Name": "C04-035 Washington/Spartan Keyes",
         "Application Type": "Conventional Zoning ",
         "Application Date": "4/9/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial, CN Neighborhood Commercial, CG General Commercial Zoning Districts to CP Pedestrian Commercial and R-M Multi-Family Residence Zoning Districts to allow commercial and multi-family residential uses on a 18.95 gross acre site",
         "Planner": "JBORELL ",
         "DURATION": 1539,
         "Year": 2004
      },
      {
         "PERMITID": "C04-035",
         "APN": 47217015,
         "File Number": "C04-035",
         "Address": "1101 S 1ST ST SAN JOSE",
         "Project Name": "C04-035 Washington/Spartan Keyes",
         "Application Type": "Conventional Zoning ",
         "Application Date": "4/9/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial, CN Neighborhood Commercial, CG General Commercial Zoning Districts to CP Pedestrian Commercial and R-M Multi-Family Residence Zoning Districts to allow commercial and multi-family residential uses on a 18.95 gross acre site",
         "Planner": "JBORELL ",
         "DURATION": 1539,
         "Year": 2004
      },
      {
         "PERMITID": "C04-035",
         "APN": 47226083,
         "File Number": "C04-035",
         "Address": "1101 S 1ST ST SAN JOSE",
         "Project Name": "C04-035 Washington/Spartan Keyes",
         "Application Type": "Conventional Zoning ",
         "Application Date": "4/9/04",
         "Status": "Approved ",
         "Description": "DIRECTOR INITIATED - Conventional Rezoning from LI Light Industrial, CN Neighborhood Commercial, CG General Commercial Zoning Districts to CP Pedestrian Commercial and R-M Multi-Family Residence Zoning Districts to allow commercial and multi-family residential uses on a 18.95 gross acre site",
         "Planner": "JBORELL ",
         "DURATION": 1539,
         "Year": 2004
      },
      {
         "PERMITID": "C04-067",
         "APN": 46701003,
         "File Number": "C04-067",
         "Address": "257 N 2ND ST SAN JOSE",
         "Project Name": "C04-067",
         "Application Type": "Conventional Zoning ",
         "Application Date": "8/5/04",
         "Status": "Approved ",
         "Description": "Rezoning from CG Commercial General Zoning District to DC Downtown Primary Commercial Zoning District to allow residential uses on a 0.09 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 1421,
         "Year": 2004
      },
      {
         "PERMITID": "C04-074",
         "APN": 26420079,
         "File Number": "C04-074",
         "Address": "498 W SAN CARLOS ST SAN JOSE",
         "Project Name": "C04-074, W San Carlos St LI to CP",
         "Application Type": "Conventional Zoning ",
         "Application Date": "8/19/04",
         "Status": "Approved ",
         "Description": "Conventional Rezoning from LI Light Industrial Zoning District to CP Commercial Pedestrian Zoning District to allow commercial uses on a 0.53 gross acre site",
         "Planner": "MNAGARAJ ",
         "DURATION": 1407,
         "Year": 2004
      },
      {
         "PERMITID": "C04-074",
         "APN": 26420110,
         "File Number": "C04-074",
         "Address": "498 W SAN CARLOS ST SAN JOSE",
         "Project Name": "C04-074, W San Carlos St LI to CP",
         "Application Type": "Conventional Zoning ",
         "Application Date": "8/19/04",
         "Status": "Approved ",
         "Description": "Conventional Rezoning from LI Light Industrial Zoning District to CP Commercial Pedestrian Zoning District to allow commercial uses on a 0.53 gross acre site",
         "Planner": "MNAGARAJ ",
         "DURATION": 1407,
         "Year": 2004
      },
      {
         "PERMITID": "C04-074",
         "APN": 26420128,
         "File Number": "C04-074",
         "Address": "498 W SAN CARLOS ST SAN JOSE",
         "Project Name": "C04-074, W San Carlos St LI to CP",
         "Application Type": "Conventional Zoning ",
         "Application Date": "8/19/04",
         "Status": "Approved ",
         "Description": "Conventional Rezoning from LI Light Industrial Zoning District to CP Commercial Pedestrian Zoning District to allow commercial uses on a 0.53 gross acre site",
         "Planner": "MNAGARAJ ",
         "DURATION": 1407,
         "Year": 2004
      },
      {
         "PERMITID": "C06-031",
         "APN": 46701028,
         "File Number": "C06-031",
         "Address": "240 N 2ND ST SAN JOSE",
         "Project Name": "C06-031",
         "Application Type": "Conventional Zoning ",
         "Application Date": "5/2/06",
         "Status": "Approved ",
         "Description": "Conventional Rezoning from CG Commercial General Zoning District to DC Downtown Commercial Zoning District to allow commercial uses within a designated City Landmark building on a 0.43 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 786,
         "Year": 2006
      },
      {
         "PERMITID": "C08-058",
         "APN": 46719057,
         "File Number": "C08-058",
         "Address": "24 N 5TH ST SAN JOSE",
         "Project Name": "C08-058",
         "Application Type": "Conventional Zoning ",
         "Application Date": "10/24/08",
         "Status": "Approved ",
         "Description": "Conventional Rezoning from the A(PD) Planned Development and R-M Multiple Residence Zoning Districts to the DC Downtown Primary Commercial Zoning District on a 1.76 gross acre site",
         "Planner": "Licinia McMorrow ",
         "DURATION": 1819,
         "Year": 2008
      },
      {
         "PERMITID": "C08-058",
         "APN": 46719075,
         "File Number": "C08-058",
         "Address": "24 N 5TH ST SAN JOSE",
         "Project Name": "C08-058",
         "Application Type": "Conventional Zoning ",
         "Application Date": "10/24/08",
         "Status": "Approved ",
         "Description": "Conventional Rezoning from the A(PD) Planned Development and R-M Multiple Residence Zoning Districts to the DC Downtown Primary Commercial Zoning District on a 1.76 gross acre site",
         "Planner": "Licinia McMorrow ",
         "DURATION": 1819,
         "Year": 2008
      },
      {
         "PERMITID": "C10-008",
         "APN": 25930094,
         "File Number": "C10-008",
         "Address": "350 W JULIAN ST SAN JOSE",
         "Project Name": "C10-008",
         "Application Type": "Conventional Zoning ",
         "Application Date": "5/6/10",
         "Status": "Approved ",
         "Description": "Conventional Rezoning from LI Light Industrial to DC Downtown Core on a 0.81 gross acre site with a General Plan designation of CIC.",
         "Planner": "Avril Baty ",
         "DURATION": 1260,
         "Year": 2010
      },
      {
         "PERMITID": "C12-027",
         "APN": 26415065,
         "File Number": "C12-027",
         "Address": "720 W SAN CARLOS ST SAN JOSE",
         "Project Name": "C12-027",
         "Application Type": "Conventional Zoning ",
         "Application Date": "12/4/12",
         "Status": "Approved ",
         "Description": "Conforming Rezoning to rezone from LI Light Industrial Zoning District to CIC Combined Industrial Commercial Zoning District on a 5.66 gross acre site",
         "Planner": "Rebecca Bustos ",
         "DURATION": 337,
         "Year": 2012
      },
      {
         "PERMITID": "C13-038",
         "APN": 25930044,
         "File Number": "C13-038",
         "Address": "143 N ALMADEN BL SAN JOSE",
         "Project Name": "C13-038 Little Italy",
         "Application Type": "Conventional Zoning ",
         "Application Date": "10/31/13",
         "Status": "Approved ",
         "Description": "Conventional Rezoning of five (5) lots from the LI-Light Industrial Zoning District to the DC-Downtown Primary Commercial Zoning District on a 0.61 gross acre site",
         "Planner": "Rebecca Bustos ",
         "DURATION": 284,
         "Year": 2013
      },
      {
         "PERMITID": "C13-038",
         "APN": 25930048,
         "File Number": "C13-038",
         "Address": "143 N ALMADEN BL SAN JOSE",
         "Project Name": "C13-038 Little Italy",
         "Application Type": "Conventional Zoning ",
         "Application Date": "10/31/13",
         "Status": "Approved ",
         "Description": "Conventional Rezoning of five (5) lots from the LI-Light Industrial Zoning District to the DC-Downtown Primary Commercial Zoning District on a 0.61 gross acre site",
         "Planner": "Rebecca Bustos ",
         "DURATION": 284,
         "Year": 2013
      },
      {
         "PERMITID": "C14-012",
         "APN": 46747098,
         "File Number": "C14-012",
         "Address": "490 S 1ST ST SAN JOSE",
         "Project Name": "C14-012",
         "Application Type": "Conventional Zoning ",
         "Application Date": "3/20/14",
         "Status": "Approved ",
         "Description": "Planning Director-Initiated Rezoning from the DC Downtown Primary Commercial Zoning District to the PQP Public/Quasi-Public Zoning District to allow publicly serving uses on a 0.44 gross acre site",
         "Planner": "David Fong ",
         "DURATION": 183,
         "Year": 2014
      },
      {
         "PERMITID": "C14-071",
         "APN": 25936036,
         "File Number": "C14-071",
         "Address": "320 W ST JOHN ST SAN JOSE",
         "Project Name": "C14-071",
         "Application Type": "Conventional Zoning ",
         "Application Date": "12/17/14 14:39",
         "Status": "Approved ",
         "Description": "Conventional Rezoning from the Commercial General (CG) and Light Industrial (LI) Zoning Districts to the Downtown Primary Commercial (DC) Zoning District at five Little Italy properties ",
         "Planner": "Elizabeth Schuller ",
         "DURATION": 148,
         "Year": 2014
      },
      {
         "PERMITID": "C14-071",
         "APN": 25936037,
         "File Number": "C14-071",
         "Address": "320 W ST JOHN ST SAN JOSE",
         "Project Name": "C14-071",
         "Application Type": "Conventional Zoning ",
         "Application Date": "12/17/14 14:39",
         "Status": "Approved ",
         "Description": "Conventional Rezoning from the Commercial General (CG) and Light Industrial (LI) Zoning Districts to the Downtown Primary Commercial (DC) Zoning District at five Little Italy properties ",
         "Planner": "Elizabeth Schuller ",
         "DURATION": 148,
         "Year": 2014
      },
      {
         "PERMITID": "C14-071",
         "APN": 25936038,
         "File Number": "C14-071",
         "Address": "320 W ST JOHN ST SAN JOSE",
         "Project Name": "C14-071",
         "Application Type": "Conventional Zoning ",
         "Application Date": "12/17/14 14:39",
         "Status": "Approved ",
         "Description": "Conventional Rezoning from the Commercial General (CG) and Light Industrial (LI) Zoning Districts to the Downtown Primary Commercial (DC) Zoning District at five Little Italy properties ",
         "Planner": "Elizabeth Schuller ",
         "DURATION": 148,
         "Year": 2014
      },
      {
         "PERMITID": "C14-071",
         "APN": 25936039,
         "File Number": "C14-071",
         "Address": "320 W ST JOHN ST SAN JOSE",
         "Project Name": "C14-071",
         "Application Type": "Conventional Zoning ",
         "Application Date": "12/17/14 14:39",
         "Status": "Approved ",
         "Description": "Conventional Rezoning from the Commercial General (CG) and Light Industrial (LI) Zoning Districts to the Downtown Primary Commercial (DC) Zoning District at five Little Italy properties ",
         "Planner": "Elizabeth Schuller ",
         "DURATION": 148,
         "Year": 2014
      },
      {
         "PERMITID": "C14-071",
         "APN": 25936067,
         "File Number": "C14-071",
         "Address": "320 W ST JOHN ST SAN JOSE",
         "Project Name": "C14-071",
         "Application Type": "Conventional Zoning ",
         "Application Date": "12/17/14 14:39",
         "Status": "Approved ",
         "Description": "Conventional Rezoning from the Commercial General (CG) and Light Industrial (LI) Zoning Districts to the Downtown Primary Commercial (DC) Zoning District at five Little Italy properties ",
         "Planner": "Elizabeth Schuller ",
         "DURATION": 148,
         "Year": 2014
      },
      {
         "PERMITID": "C15-047",
         "APN": 26426006,
         "File Number": "C15-047",
         "Address": "341 DELMAS AV SAN JOSE",
         "Project Name": "C15-047",
         "Application Type": "Conventional Zoning ",
         "Application Date": "9/9/15 13:47",
         "Status": "Approved ",
         "Description": "Conventional Rezoning from the LI Light Industrial Zoning District to the DC Downtown Primary Commercial Zoning District to allow up to 120 residences in a five story building (61 feet tall) with ground floor parking on a 0.7-gross acre site",
         "Planner": "Jennifer Piozet ",
         "DURATION": 340,
         "Year": 2015
      },
      {
         "PERMITID": "C15-047",
         "APN": 26426008,
         "File Number": "C15-047",
         "Address": "341 DELMAS AV SAN JOSE",
         "Project Name": "C15-047",
         "Application Type": "Conventional Zoning ",
         "Application Date": "9/9/15 13:47",
         "Status": "Approved ",
         "Description": "Conventional Rezoning from the LI Light Industrial Zoning District to the DC Downtown Primary Commercial Zoning District to allow up to 120 residences in a five story building (61 feet tall) with ground floor parking on a 0.7-gross acre site",
         "Planner": "Jennifer Piozet ",
         "DURATION": 340,
         "Year": 2015
      },
      {
         "PERMITID": "C15-052",
         "APN": 46720081,
         "File Number": "C15-052",
         "Address": "49 N 4TH ST SAN JOSE",
         "Project Name": "C15-052",
         "Application Type": "Conventional Zoning ",
         "Application Date": "10/5/15",
         "Status": "Approved ",
         "Description": "Conventional Rezoning from the CG Commercial General Zoning District to the DC Downtown Primary Commercial Zoning District on a 0.72-gross acre site",
         "Planner": "Rebecca Bustos ",
         "DURATION": 177,
         "Year": 2015
      },
      {
         "PERMITID": "C15-062",
         "APN": 46719056,
         "File Number": "C15-062",
         "Address": "73 N 6TH ST SAN JOSE",
         "Project Name": "C15-062",
         "Application Type": "Conventional Zoning ",
         "Application Date": "11/17/15",
         "Status": "Approved ",
         "Description": "Conventional Rezoning from the CG Commercial General Zoning District and R-M Multiple Residence Zoning District to the DC Downtown Primary Commercial Zoning District on a 0.28 gross acre site",
         "Planner": "Lea Simvoulakis ",
         "DURATION": 267,
         "Year": 2015
      },
      {
         "PERMITID": "C15-062",
         "APN": 46719057,
         "File Number": "C15-062",
         "Address": "73 N 6TH ST SAN JOSE",
         "Project Name": "C15-062",
         "Application Type": "Conventional Zoning ",
         "Application Date": "11/17/15",
         "Status": "Approved ",
         "Description": "Conventional Rezoning from the CG Commercial General Zoning District and R-M Multiple Residence Zoning District to the DC Downtown Primary Commercial Zoning District on a 0.28 gross acre site",
         "Planner": "Lea Simvoulakis ",
         "DURATION": 267,
         "Year": 2015
      },
      {
         "PERMITID": "C15-062",
         "APN": 46719059,
         "File Number": "C15-062",
         "Address": "73 N 6TH ST SAN JOSE",
         "Project Name": "C15-062",
         "Application Type": "Conventional Zoning ",
         "Application Date": "11/17/15",
         "Status": "Approved ",
         "Description": "Conventional Rezoning from the CG Commercial General Zoning District and R-M Multiple Residence Zoning District to the DC Downtown Primary Commercial Zoning District on a 0.28 gross acre site",
         "Planner": "Lea Simvoulakis ",
         "DURATION": 267,
         "Year": 2015
      },
      {
         "PERMITID": "C17-014",
         "APN": 47217024,
         "File Number": "C17-014",
         "Address": "735 S 2ND ST SAN JOSE",
         "Project Name": "C17-014",
         "Application Type": "Conventional Zoning ",
         "Application Date": "4/14/17",
         "Status": "Approved ",
         "Description": "Conventional Rezoning from the R-2 Two-Family Residence Zoning District to the R-M Multiple Residence Zoning District on a 0.15 gross acre site",
         "Planner": "Rina Shah ",
         "DURATION": 685,
         "Year": 2017
      },
      {
         "PERMITID": "C13-042",
         "APN": 25947068,
         "File Number": "C13-042",
         "Address": "565 LORRAINE AV SAN JOSE",
         "Project Name": "C13-042",
         "Application Type": "Conventional Zoning ",
         "Application Date": "10/9/13",
         "Status": "Denied ",
         "Description": "Conventional Rezoning of one lot from LI - Light Industrial to the DC - Downtown Core Zoning District on a 0.102 gross acre site",
         "Planner": "John Tu ",
         "DURATION": 398,
         "Year": 2013
      },
      {
         "PERMITID": "C17-032",
         "APN": 46720019,
         "File Number": "C17-032",
         "Address": "100 N 4TH ST SAN JOSE",
         "Project Name": "C17-032 - 100 North 4th Street",
         "Application Type": "Conventional Zoning ",
         "Application Date": "7/31/17 10:39",
         "Status": "Withdrawn ",
         "Description": "Conventional Rezoning from CG Commercial General Zoning District to the DC Downtown Primary Commercial Zoning District on 0.91 gross acre site.",
         "Planner": "Rick Smeaton ",
         "DURATION": 101,
         "Year": 2017
      },
      {
         "PERMITID": "C17-032",
         "APN": 46720020,
         "File Number": "C17-032",
         "Address": "100 N 4TH ST SAN JOSE",
         "Project Name": "C17-032 - 100 North 4th Street",
         "Application Type": "Conventional Zoning ",
         "Application Date": "7/31/17 10:39",
         "Status": "Withdrawn ",
         "Description": "Conventional Rezoning from CG Commercial General Zoning District to the DC Downtown Primary Commercial Zoning District on 0.91 gross acre site.",
         "Planner": "Rick Smeaton ",
         "DURATION": 101,
         "Year": 2017
      },
      {
         "PERMITID": "C17-032",
         "APN": 46720021,
         "File Number": "C17-032",
         "Address": "100 N 4TH ST SAN JOSE",
         "Project Name": "C17-032 - 100 North 4th Street",
         "Application Type": "Conventional Zoning ",
         "Application Date": "7/31/17 10:39",
         "Status": "Withdrawn ",
         "Description": "Conventional Rezoning from CG Commercial General Zoning District to the DC Downtown Primary Commercial Zoning District on 0.91 gross acre site.",
         "Planner": "Rick Smeaton ",
         "DURATION": 101,
         "Year": 2017
      },
      {
         "PERMITID": "C17-032",
         "APN": 46720022,
         "File Number": "C17-032",
         "Address": "100 N 4TH ST SAN JOSE",
         "Project Name": "C17-032 - 100 North 4th Street",
         "Application Type": "Conventional Zoning ",
         "Application Date": "7/31/17 10:39",
         "Status": "Withdrawn ",
         "Description": "Conventional Rezoning from CG Commercial General Zoning District to the DC Downtown Primary Commercial Zoning District on 0.91 gross acre site.",
         "Planner": "Rick Smeaton ",
         "DURATION": 101,
         "Year": 2017
      },
      {
         "PERMITID": "C17-032",
         "APN": 46720040,
         "File Number": "C17-032",
         "Address": "100 N 4TH ST SAN JOSE",
         "Project Name": "C17-032 - 100 North 4th Street",
         "Application Type": "Conventional Zoning ",
         "Application Date": "7/31/17 10:39",
         "Status": "Withdrawn ",
         "Description": "Conventional Rezoning from CG Commercial General Zoning District to the DC Downtown Primary Commercial Zoning District on 0.91 gross acre site.",
         "Planner": "Rick Smeaton ",
         "DURATION": 101,
         "Year": 2017
      }
   ],
   "Copy Fee ": [
      {
         "PERMITID": "2011 006242 PI",
         "APN": 46723010,
         "File Number": "2011 006242 PI",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Copy Fee ",
         "Application Date": "1/25/11 8:29",
         "Status": "Complete ",
         "Description": "COPY REQUEST FOR EIR DOCUMENTS RELATED TO THE HIGH SPEED RAIL SYSTEM ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "2011 006242 PI",
         "APN": 46723011,
         "File Number": "2011 006242 PI",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Copy Fee ",
         "Application Date": "1/25/11 8:29",
         "Status": "Complete ",
         "Description": "COPY REQUEST FOR EIR DOCUMENTS RELATED TO THE HIGH SPEED RAIL SYSTEM ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "2011 006242 PI",
         "APN": 46723013,
         "File Number": "2011 006242 PI",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Copy Fee ",
         "Application Date": "1/25/11 8:29",
         "Status": "Complete ",
         "Description": "COPY REQUEST FOR EIR DOCUMENTS RELATED TO THE HIGH SPEED RAIL SYSTEM ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "2011 006242 PI",
         "APN": 46723017,
         "File Number": "2011 006242 PI",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Copy Fee ",
         "Application Date": "1/25/11 8:29",
         "Status": "Complete ",
         "Description": "COPY REQUEST FOR EIR DOCUMENTS RELATED TO THE HIGH SPEED RAIL SYSTEM ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "2011 006242 PI",
         "APN": 46723018,
         "File Number": "2011 006242 PI",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Copy Fee ",
         "Application Date": "1/25/11 8:29",
         "Status": "Complete ",
         "Description": "COPY REQUEST FOR EIR DOCUMENTS RELATED TO THE HIGH SPEED RAIL SYSTEM ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "2011 006242 PI",
         "APN": 46723019,
         "File Number": "2011 006242 PI",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Copy Fee ",
         "Application Date": "1/25/11 8:29",
         "Status": "Complete ",
         "Description": "COPY REQUEST FOR EIR DOCUMENTS RELATED TO THE HIGH SPEED RAIL SYSTEM ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "2011 006242 PI",
         "APN": 46723021,
         "File Number": "2011 006242 PI",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Copy Fee ",
         "Application Date": "1/25/11 8:29",
         "Status": "Complete ",
         "Description": "COPY REQUEST FOR EIR DOCUMENTS RELATED TO THE HIGH SPEED RAIL SYSTEM ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "2011 006242 PI",
         "APN": 46723022,
         "File Number": "2011 006242 PI",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Copy Fee ",
         "Application Date": "1/25/11 8:29",
         "Status": "Complete ",
         "Description": "COPY REQUEST FOR EIR DOCUMENTS RELATED TO THE HIGH SPEED RAIL SYSTEM ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "2011 006242 PI",
         "APN": 46723076,
         "File Number": "2011 006242 PI",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Copy Fee ",
         "Application Date": "1/25/11 8:29",
         "Status": "Complete ",
         "Description": "COPY REQUEST FOR EIR DOCUMENTS RELATED TO THE HIGH SPEED RAIL SYSTEM ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "2011 006242 PI",
         "APN": 46724001,
         "File Number": "2011 006242 PI",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Copy Fee ",
         "Application Date": "1/25/11 8:29",
         "Status": "Complete ",
         "Description": "COPY REQUEST FOR EIR DOCUMENTS RELATED TO THE HIGH SPEED RAIL SYSTEM ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "2011 006242 PI",
         "APN": 46724002,
         "File Number": "2011 006242 PI",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Copy Fee ",
         "Application Date": "1/25/11 8:29",
         "Status": "Complete ",
         "Description": "COPY REQUEST FOR EIR DOCUMENTS RELATED TO THE HIGH SPEED RAIL SYSTEM ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "2011 006242 PI",
         "APN": 46724003,
         "File Number": "2011 006242 PI",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Copy Fee ",
         "Application Date": "1/25/11 8:29",
         "Status": "Complete ",
         "Description": "COPY REQUEST FOR EIR DOCUMENTS RELATED TO THE HIGH SPEED RAIL SYSTEM ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "2011 006242 PI",
         "APN": 46724014,
         "File Number": "2011 006242 PI",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Copy Fee ",
         "Application Date": "1/25/11 8:29",
         "Status": "Complete ",
         "Description": "COPY REQUEST FOR EIR DOCUMENTS RELATED TO THE HIGH SPEED RAIL SYSTEM ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "2011 006242 PI",
         "APN": 46724015,
         "File Number": "2011 006242 PI",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Copy Fee ",
         "Application Date": "1/25/11 8:29",
         "Status": "Complete ",
         "Description": "COPY REQUEST FOR EIR DOCUMENTS RELATED TO THE HIGH SPEED RAIL SYSTEM ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "2011 006242 PI",
         "APN": 46724016,
         "File Number": "2011 006242 PI",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Copy Fee ",
         "Application Date": "1/25/11 8:29",
         "Status": "Complete ",
         "Description": "COPY REQUEST FOR EIR DOCUMENTS RELATED TO THE HIGH SPEED RAIL SYSTEM ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "2011 006242 PI",
         "APN": 46724019,
         "File Number": "2011 006242 PI",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Copy Fee ",
         "Application Date": "1/25/11 8:29",
         "Status": "Complete ",
         "Description": "COPY REQUEST FOR EIR DOCUMENTS RELATED TO THE HIGH SPEED RAIL SYSTEM ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "2011 006242 PI",
         "APN": 46724020,
         "File Number": "2011 006242 PI",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Copy Fee ",
         "Application Date": "1/25/11 8:29",
         "Status": "Complete ",
         "Description": "COPY REQUEST FOR EIR DOCUMENTS RELATED TO THE HIGH SPEED RAIL SYSTEM ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "2011 006242 PI",
         "APN": 46724021,
         "File Number": "2011 006242 PI",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Copy Fee ",
         "Application Date": "1/25/11 8:29",
         "Status": "Complete ",
         "Description": "COPY REQUEST FOR EIR DOCUMENTS RELATED TO THE HIGH SPEED RAIL SYSTEM ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "2011 006242 PI",
         "APN": 46724115,
         "File Number": "2011 006242 PI",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Copy Fee ",
         "Application Date": "1/25/11 8:29",
         "Status": "Complete ",
         "Description": "COPY REQUEST FOR EIR DOCUMENTS RELATED TO THE HIGH SPEED RAIL SYSTEM ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "2011 006242 PI",
         "APN": 46724117,
         "File Number": "2011 006242 PI",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Copy Fee ",
         "Application Date": "1/25/11 8:29",
         "Status": "Complete ",
         "Description": "COPY REQUEST FOR EIR DOCUMENTS RELATED TO THE HIGH SPEED RAIL SYSTEM ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "2016 142937 PI",
         "APN": 25924035,
         "File Number": "2016 142937 PI",
         "Address": "333 W JULIAN ST SAN JOSE",
         "Project Name": "333 WEST JULIAN STREET",
         "Application Type": "Copy Fee ",
         "Application Date": "11/21/16 9:29",
         "Status": "Complete ",
         "Description": "Development Services Document Duplication Request for APN 259-24-035",
         "Planner": " ",
         "DURATION": 1,
         "Year": 2016
      },
      {
         "PERMITID": "2017 045124 PI",
         "APN": 26426003,
         "File Number": "2017 045124 PI",
         "Address": "319 DELMAS AV SAN JOSE",
         "Project Name": " ",
         "Application Type": "Copy Fee ",
         "Application Date": "11/29/17 10:06",
         "Status": "Complete ",
         "Description": "Development Services Document Duplication Request for APN 264-26-003 (319 Delmas Avenue)",
         "Planner": " ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2012 024234 PI",
         "APN": 26415065,
         "File Number": "2012 024234 PI",
         "Address": "720 W SAN CARLOS ST SAN JOSE",
         "Project Name": "720 W SAN CARLOS ST",
         "Application Type": "Copy Fee ",
         "Application Date": "8/17/12",
         "Status": "New ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2012
      },
      {
         "PERMITID": "2017 041147 PI",
         "APN": 25940043,
         "File Number": "2017 041147 PI",
         "Address": "27 S 1ST ST SAN JOSE",
         "Project Name": "27 SOUTH 1ST STREET",
         "Application Type": "Copy Fee ",
         "Application Date": "10/27/17 9:29",
         "Status": "New ",
         "Description": "PRA FILE NO. H17-027 REQUESTER: ADAMS BROADWELL JOSEPH & CARDOZO (JANET LAURAIN)",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "2012 007673 PI",
         "APN": 46747096,
         "File Number": "2012 007673 PI",
         "Address": "128 E REED ST SAN JOSE",
         "Project Name": "128 E REED ST UNIT 3",
         "Application Type": "Copy Fee ",
         "Application Date": "3/9/12 9:16",
         "Status": "Under Review ",
         "Description": "The applicant is requesting the verification of \"over-concentration of residential care homes\" on two (2) properties.",
         "Planner": " ",
         "DURATION": 1,
         "Year": 2012
      },
      {
         "PERMITID": "2017 035473 PI",
         "APN": 25941067,
         "File Number": "2017 035473 PI",
         "Address": "170 PARK CENTER PLAZA SAN JOSE",
         "Project Name": " ",
         "Application Type": "Copy Fee ",
         "Application Date": "9/18/17 13:14",
         "Status": "Under Review ",
         "Description": "PRA FILE NO. H17-050. ADAMS BROADWELL JOSEPH & CARDOZO PRA REQUEST LETTER DATED 9/7/17",
         "Planner": " ",
         "DURATION": 1,
         "Year": 2017
      }
   ],
   "Covenant of Easement ": [
      {
         "PERMITID": "ET16-003",
         "APN": 46746080,
         "File Number": "ET16-003",
         "Address": "345 S 2ND ST SAN JOSE",
         "Project Name": "ET16-003",
         "Application Type": "Covenant of Easement ",
         "Application Date": "7/20/16",
         "Status": "Pending ",
         "Description": "Covenant of Easement to create a non-exclusive easement for parking, ingress, egress, and emergency access on the property on a 2.8 gross acre site",
         "Planner": "Jennifer Piozet ",
         "DURATION": 26,
         "Year": 2016
      },
      {
         "PERMITID": "ET16-003",
         "APN": 46746081,
         "File Number": "ET16-003",
         "Address": "345 S 2ND ST SAN JOSE",
         "Project Name": "ET16-003",
         "Application Type": "Covenant of Easement ",
         "Application Date": "7/20/16",
         "Status": "Pending ",
         "Description": "Covenant of Easement to create a non-exclusive easement for parking, ingress, egress, and emergency access on the property on a 2.8 gross acre site",
         "Planner": "Jennifer Piozet ",
         "DURATION": 26,
         "Year": 2016
      },
      {
         "PERMITID": "ET16-003",
         "APN": 46746082,
         "File Number": "ET16-003",
         "Address": "345 S 2ND ST SAN JOSE",
         "Project Name": "ET16-003",
         "Application Type": "Covenant of Easement ",
         "Application Date": "7/20/16",
         "Status": "Pending ",
         "Description": "Covenant of Easement to create a non-exclusive easement for parking, ingress, egress, and emergency access on the property on a 2.8 gross acre site",
         "Planner": "Jennifer Piozet ",
         "DURATION": 26,
         "Year": 2016
      }
   ],
   "Dead Tree ": [
      {
         "PERMITID": "TR10-269",
         "APN": 47229067,
         "File Number": "TR10-269",
         "Address": "502 E WILLIAM ST SAN JOSE",
         "Project Name": "502 E WILLIAM ST",
         "Application Type": "Dead Tree ",
         "Application Date": "10/29/10",
         "Status": "Approved ",
         "Description": "Dead Tree Removal Permit to allow the removal of one (1) Oak tree, approximately 109 inches in circumference located in the front yard of a two family residence",
         "Planner": "Patrice Shaffer ",
         "DURATION": 1,
         "Year": 2010
      },
      {
         "PERMITID": "TR11-052",
         "APN": 46720080,
         "File Number": "TR11-052",
         "Address": "60 N 3RD ST SAN JOSE",
         "Project Name": "60 3RD ST",
         "Application Type": "Dead Tree ",
         "Application Date": "3/2/11",
         "Status": "Approved ",
         "Description": "Dead Tree Removal Permit to allow the removal of one dead Eucalyptus tree from an existing attached residential project only. ",
         "Planner": "Jeff Roche ",
         "DURATION": 1,
         "Year": 2011
      },
      {
         "PERMITID": "TR16-488",
         "APN": 25936039,
         "File Number": "TR16-488",
         "Address": "320 W ST JOHN ST SAN JOSE",
         "Project Name": "320 WEST ST JOHN STREET",
         "Application Type": "Dead Tree ",
         "Application Date": "10/4/16 16:09",
         "Status": "Approved ",
         "Description": "Tree Removal Permit to allow the removal of one Tree of Heaven, approximately 125 inches in circumference, located in the rear yard of a commercial property on a 3.34 acre site in the A(PD) zoning district.",
         "Planner": "Armando Lopez ",
         "DURATION": 1,
         "Year": 2016
      },
      {
         "PERMITID": "TR17-457",
         "APN": 24944016,
         "File Number": "TR17-457",
         "Address": "339 N 3RD ST SAN JOSE",
         "Project Name": "339 NORTH 3RD STREET",
         "Application Type": "Dead Tree ",
         "Application Date": "6/29/17 14:25",
         "Status": "Approved ",
         "Description": "Tree Removal of one diseased and dying Tree of Heaven on a four-plex lot ",
         "Planner": "Jan Warne ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2016 119379 TS",
         "APN": 46723010,
         "File Number": "2016 119379 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PG&E'S COMMUNITY PIPELINE SAFETY INITIATIVE ",
         "Application Type": "Dead Tree ",
         "Application Date": "5/27/16",
         "Status": "New ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "2016 119379 TS",
         "APN": 46723011,
         "File Number": "2016 119379 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PG&E'S COMMUNITY PIPELINE SAFETY INITIATIVE ",
         "Application Type": "Dead Tree ",
         "Application Date": "5/27/16",
         "Status": "New ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "2016 119379 TS",
         "APN": 46723013,
         "File Number": "2016 119379 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PG&E'S COMMUNITY PIPELINE SAFETY INITIATIVE ",
         "Application Type": "Dead Tree ",
         "Application Date": "5/27/16",
         "Status": "New ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "2016 119379 TS",
         "APN": 46723017,
         "File Number": "2016 119379 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PG&E'S COMMUNITY PIPELINE SAFETY INITIATIVE ",
         "Application Type": "Dead Tree ",
         "Application Date": "5/27/16",
         "Status": "New ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "2016 119379 TS",
         "APN": 46723018,
         "File Number": "2016 119379 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PG&E'S COMMUNITY PIPELINE SAFETY INITIATIVE ",
         "Application Type": "Dead Tree ",
         "Application Date": "5/27/16",
         "Status": "New ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "2016 119379 TS",
         "APN": 46723019,
         "File Number": "2016 119379 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PG&E'S COMMUNITY PIPELINE SAFETY INITIATIVE ",
         "Application Type": "Dead Tree ",
         "Application Date": "5/27/16",
         "Status": "New ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "2016 119379 TS",
         "APN": 46723021,
         "File Number": "2016 119379 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PG&E'S COMMUNITY PIPELINE SAFETY INITIATIVE ",
         "Application Type": "Dead Tree ",
         "Application Date": "5/27/16",
         "Status": "New ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "2016 119379 TS",
         "APN": 46723022,
         "File Number": "2016 119379 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PG&E'S COMMUNITY PIPELINE SAFETY INITIATIVE ",
         "Application Type": "Dead Tree ",
         "Application Date": "5/27/16",
         "Status": "New ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "2016 119379 TS",
         "APN": 46723076,
         "File Number": "2016 119379 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PG&E'S COMMUNITY PIPELINE SAFETY INITIATIVE ",
         "Application Type": "Dead Tree ",
         "Application Date": "5/27/16",
         "Status": "New ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "2016 119379 TS",
         "APN": 46724001,
         "File Number": "2016 119379 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PG&E'S COMMUNITY PIPELINE SAFETY INITIATIVE ",
         "Application Type": "Dead Tree ",
         "Application Date": "5/27/16",
         "Status": "New ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "2016 119379 TS",
         "APN": 46724002,
         "File Number": "2016 119379 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PG&E'S COMMUNITY PIPELINE SAFETY INITIATIVE ",
         "Application Type": "Dead Tree ",
         "Application Date": "5/27/16",
         "Status": "New ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "2016 119379 TS",
         "APN": 46724003,
         "File Number": "2016 119379 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PG&E'S COMMUNITY PIPELINE SAFETY INITIATIVE ",
         "Application Type": "Dead Tree ",
         "Application Date": "5/27/16",
         "Status": "New ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "2016 119379 TS",
         "APN": 46724014,
         "File Number": "2016 119379 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PG&E'S COMMUNITY PIPELINE SAFETY INITIATIVE ",
         "Application Type": "Dead Tree ",
         "Application Date": "5/27/16",
         "Status": "New ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "2016 119379 TS",
         "APN": 46724015,
         "File Number": "2016 119379 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PG&E'S COMMUNITY PIPELINE SAFETY INITIATIVE ",
         "Application Type": "Dead Tree ",
         "Application Date": "5/27/16",
         "Status": "New ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "2016 119379 TS",
         "APN": 46724016,
         "File Number": "2016 119379 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PG&E'S COMMUNITY PIPELINE SAFETY INITIATIVE ",
         "Application Type": "Dead Tree ",
         "Application Date": "5/27/16",
         "Status": "New ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "2016 119379 TS",
         "APN": 46724019,
         "File Number": "2016 119379 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PG&E'S COMMUNITY PIPELINE SAFETY INITIATIVE ",
         "Application Type": "Dead Tree ",
         "Application Date": "5/27/16",
         "Status": "New ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "2016 119379 TS",
         "APN": 46724020,
         "File Number": "2016 119379 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PG&E'S COMMUNITY PIPELINE SAFETY INITIATIVE ",
         "Application Type": "Dead Tree ",
         "Application Date": "5/27/16",
         "Status": "New ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "2016 119379 TS",
         "APN": 46724021,
         "File Number": "2016 119379 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PG&E'S COMMUNITY PIPELINE SAFETY INITIATIVE ",
         "Application Type": "Dead Tree ",
         "Application Date": "5/27/16",
         "Status": "New ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "2016 119379 TS",
         "APN": 46724115,
         "File Number": "2016 119379 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PG&E'S COMMUNITY PIPELINE SAFETY INITIATIVE ",
         "Application Type": "Dead Tree ",
         "Application Date": "5/27/16",
         "Status": "New ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "2016 119379 TS",
         "APN": 46724117,
         "File Number": "2016 119379 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PG&E'S COMMUNITY PIPELINE SAFETY INITIATIVE ",
         "Application Type": "Dead Tree ",
         "Application Date": "5/27/16",
         "Status": "New ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "2012 006867 TS",
         "APN": 25936074,
         "File Number": "2012 006867 TS",
         "Address": "333 W SANTA CLARA ST SAN JOSE",
         "Project Name": "333 W SANTA CLARA ST",
         "Application Type": "Dead Tree ",
         "Application Date": " ",
         "Status": "Pending ",
         "Description": "(APPLICANT NOT AWARE THERE'S FEE, PRINTED THE INVOICE AND ADVISED HIM ON THE PERMIT APPICATION) (Applicant confirmed that the tree is 36 inches in circumference, see comments 3/12/12 -- void the invoice) Dead Tree Removal Permit for removal of one Liquid Amber xx inches in circumference on a 1.76 gross acre site",
         "Planner": "Susan Walsh ",
         "DURATION": 1,
         "Year": null
      },
      {
         "PERMITID": "TR16-310",
         "APN": 47241046,
         "File Number": "TR16-310",
         "Address": "698 ORVIS AV SAN JOSE",
         "Project Name": "698 ORVIS AVENUE",
         "Application Type": "Dead Tree ",
         "Application Date": "6/30/16 9:21",
         "Status": "Recomd Approval ",
         "Description": "Dead tree removal permit to allow removal of a dead Pepper tree 82 inches in circumference from the common area of a multi-family development.",
         "Planner": "Suparna Saha ",
         "DURATION": 1,
         "Year": 2016
      },
      {
         "PERMITID": "2013 113670 TS",
         "APN": 46723010,
         "File Number": "2013 113670 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Dead Tree ",
         "Application Date": "7/8/13",
         "Status": "Rejected ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "2013 113670 TS",
         "APN": 46723011,
         "File Number": "2013 113670 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Dead Tree ",
         "Application Date": "7/8/13",
         "Status": "Rejected ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "2013 113670 TS",
         "APN": 46723013,
         "File Number": "2013 113670 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Dead Tree ",
         "Application Date": "7/8/13",
         "Status": "Rejected ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "2013 113670 TS",
         "APN": 46723017,
         "File Number": "2013 113670 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Dead Tree ",
         "Application Date": "7/8/13",
         "Status": "Rejected ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "2013 113670 TS",
         "APN": 46723018,
         "File Number": "2013 113670 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Dead Tree ",
         "Application Date": "7/8/13",
         "Status": "Rejected ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "2013 113670 TS",
         "APN": 46723019,
         "File Number": "2013 113670 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Dead Tree ",
         "Application Date": "7/8/13",
         "Status": "Rejected ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "2013 113670 TS",
         "APN": 46723021,
         "File Number": "2013 113670 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Dead Tree ",
         "Application Date": "7/8/13",
         "Status": "Rejected ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "2013 113670 TS",
         "APN": 46723022,
         "File Number": "2013 113670 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Dead Tree ",
         "Application Date": "7/8/13",
         "Status": "Rejected ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "2013 113670 TS",
         "APN": 46723076,
         "File Number": "2013 113670 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Dead Tree ",
         "Application Date": "7/8/13",
         "Status": "Rejected ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "2013 113670 TS",
         "APN": 46724001,
         "File Number": "2013 113670 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Dead Tree ",
         "Application Date": "7/8/13",
         "Status": "Rejected ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "2013 113670 TS",
         "APN": 46724002,
         "File Number": "2013 113670 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Dead Tree ",
         "Application Date": "7/8/13",
         "Status": "Rejected ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "2013 113670 TS",
         "APN": 46724003,
         "File Number": "2013 113670 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Dead Tree ",
         "Application Date": "7/8/13",
         "Status": "Rejected ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "2013 113670 TS",
         "APN": 46724014,
         "File Number": "2013 113670 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Dead Tree ",
         "Application Date": "7/8/13",
         "Status": "Rejected ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "2013 113670 TS",
         "APN": 46724015,
         "File Number": "2013 113670 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Dead Tree ",
         "Application Date": "7/8/13",
         "Status": "Rejected ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "2013 113670 TS",
         "APN": 46724016,
         "File Number": "2013 113670 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Dead Tree ",
         "Application Date": "7/8/13",
         "Status": "Rejected ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "2013 113670 TS",
         "APN": 46724019,
         "File Number": "2013 113670 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Dead Tree ",
         "Application Date": "7/8/13",
         "Status": "Rejected ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "2013 113670 TS",
         "APN": 46724020,
         "File Number": "2013 113670 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Dead Tree ",
         "Application Date": "7/8/13",
         "Status": "Rejected ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "2013 113670 TS",
         "APN": 46724021,
         "File Number": "2013 113670 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Dead Tree ",
         "Application Date": "7/8/13",
         "Status": "Rejected ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "2013 113670 TS",
         "APN": 46724115,
         "File Number": "2013 113670 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Dead Tree ",
         "Application Date": "7/8/13",
         "Status": "Rejected ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "2013 113670 TS",
         "APN": 46724117,
         "File Number": "2013 113670 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 E SANTA CLARA ST",
         "Application Type": "Dead Tree ",
         "Application Date": "7/8/13",
         "Status": "Rejected ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "2016 108645 TS",
         "APN": 46723010,
         "File Number": "2016 108645 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Dead Tree ",
         "Application Date": " ",
         "Status": "Withdrawn ",
         "Description": " ",
         "Planner": "Emily Lipoma ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "2016 108645 TS",
         "APN": 46723011,
         "File Number": "2016 108645 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Dead Tree ",
         "Application Date": " ",
         "Status": "Withdrawn ",
         "Description": " ",
         "Planner": "Emily Lipoma ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "2016 108645 TS",
         "APN": 46723013,
         "File Number": "2016 108645 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Dead Tree ",
         "Application Date": " ",
         "Status": "Withdrawn ",
         "Description": " ",
         "Planner": "Emily Lipoma ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "2016 108645 TS",
         "APN": 46723017,
         "File Number": "2016 108645 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Dead Tree ",
         "Application Date": " ",
         "Status": "Withdrawn ",
         "Description": " ",
         "Planner": "Emily Lipoma ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "2016 108645 TS",
         "APN": 46723018,
         "File Number": "2016 108645 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Dead Tree ",
         "Application Date": " ",
         "Status": "Withdrawn ",
         "Description": " ",
         "Planner": "Emily Lipoma ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "2016 108645 TS",
         "APN": 46723019,
         "File Number": "2016 108645 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Dead Tree ",
         "Application Date": " ",
         "Status": "Withdrawn ",
         "Description": " ",
         "Planner": "Emily Lipoma ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "2016 108645 TS",
         "APN": 46723021,
         "File Number": "2016 108645 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Dead Tree ",
         "Application Date": " ",
         "Status": "Withdrawn ",
         "Description": " ",
         "Planner": "Emily Lipoma ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "2016 108645 TS",
         "APN": 46723022,
         "File Number": "2016 108645 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Dead Tree ",
         "Application Date": " ",
         "Status": "Withdrawn ",
         "Description": " ",
         "Planner": "Emily Lipoma ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "2016 108645 TS",
         "APN": 46723076,
         "File Number": "2016 108645 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Dead Tree ",
         "Application Date": " ",
         "Status": "Withdrawn ",
         "Description": " ",
         "Planner": "Emily Lipoma ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "2016 108645 TS",
         "APN": 46724001,
         "File Number": "2016 108645 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Dead Tree ",
         "Application Date": " ",
         "Status": "Withdrawn ",
         "Description": " ",
         "Planner": "Emily Lipoma ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "2016 108645 TS",
         "APN": 46724002,
         "File Number": "2016 108645 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Dead Tree ",
         "Application Date": " ",
         "Status": "Withdrawn ",
         "Description": " ",
         "Planner": "Emily Lipoma ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "2016 108645 TS",
         "APN": 46724003,
         "File Number": "2016 108645 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Dead Tree ",
         "Application Date": " ",
         "Status": "Withdrawn ",
         "Description": " ",
         "Planner": "Emily Lipoma ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "2016 108645 TS",
         "APN": 46724014,
         "File Number": "2016 108645 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Dead Tree ",
         "Application Date": " ",
         "Status": "Withdrawn ",
         "Description": " ",
         "Planner": "Emily Lipoma ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "2016 108645 TS",
         "APN": 46724015,
         "File Number": "2016 108645 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Dead Tree ",
         "Application Date": " ",
         "Status": "Withdrawn ",
         "Description": " ",
         "Planner": "Emily Lipoma ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "2016 108645 TS",
         "APN": 46724016,
         "File Number": "2016 108645 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Dead Tree ",
         "Application Date": " ",
         "Status": "Withdrawn ",
         "Description": " ",
         "Planner": "Emily Lipoma ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "2016 108645 TS",
         "APN": 46724019,
         "File Number": "2016 108645 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Dead Tree ",
         "Application Date": " ",
         "Status": "Withdrawn ",
         "Description": " ",
         "Planner": "Emily Lipoma ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "2016 108645 TS",
         "APN": 46724020,
         "File Number": "2016 108645 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Dead Tree ",
         "Application Date": " ",
         "Status": "Withdrawn ",
         "Description": " ",
         "Planner": "Emily Lipoma ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "2016 108645 TS",
         "APN": 46724021,
         "File Number": "2016 108645 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Dead Tree ",
         "Application Date": " ",
         "Status": "Withdrawn ",
         "Description": " ",
         "Planner": "Emily Lipoma ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "2016 108645 TS",
         "APN": 46724115,
         "File Number": "2016 108645 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Dead Tree ",
         "Application Date": " ",
         "Status": "Withdrawn ",
         "Description": " ",
         "Planner": "Emily Lipoma ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "2016 108645 TS",
         "APN": 46724117,
         "File Number": "2016 108645 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Dead Tree ",
         "Application Date": " ",
         "Status": "Withdrawn ",
         "Description": " ",
         "Planner": "Emily Lipoma ",
         "DURATION": 0,
         "Year": null
      }
   ],
   "Development Variance ": [
      {
         "PERMITID": "V02-013",
         "APN": 24946061,
         "File Number": "V02-013",
         "Address": "153 E JULIAN ST SAN JOSE",
         "Project Name": "V02-013",
         "Application Type": "Development Variance ",
         "Application Date": "5/6/02",
         "Status": "Approved ",
         "Description": "Development Variance to allow an office building to reduce the required front, corner and interior side setbacks of 15, 12.5 and 5 feet respectively on a 0.0735 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 402,
         "Year": 2002
      },
      {
         "PERMITID": "V06-002",
         "APN": 47224076,
         "File Number": "V06-002",
         "Address": "396 MARGARET ST SAN JOSE",
         "Project Name": "V06-002",
         "Application Type": "Development Variance ",
         "Application Date": "3/13/06",
         "Status": "Approved ",
         "Description": "Development Variance to allow a rear setback of 5 feet for a new stairway and basement access to an existing single-family residence on a substandard 0.07-acre lot",
         "Planner": "Lee Butler ",
         "DURATION": 70,
         "Year": 2006
      },
      {
         "PERMITID": "V07-002",
         "APN": 26417016,
         "File Number": "V07-002",
         "Address": "652 AUZERAIS AV SAN JOSE",
         "Project Name": "V07-002",
         "Application Type": "Development Variance ",
         "Application Date": "3/13/07",
         "Status": "Approved ",
         "Description": "Development Variance to allow a reduced driveway length for a proposed 740 square foot accessory building (garage/storage) on a 0.11 gross acre site.",
         "Planner": "John Baty ",
         "DURATION": 182,
         "Year": 2007
      },
      {
         "PERMITID": "V06-001",
         "APN": 25945070,
         "File Number": "V06-001",
         "Address": "183 SONOMA ST SAN JOSE",
         "Project Name": "V06-001",
         "Application Type": "Development Variance ",
         "Application Date": "1/25/06",
         "Status": "Withdrawn ",
         "Description": "Development Variance for a proposed duplex to reduce the rear setback in the R-2 Two Family Residence District from 20 feet to 15 feet on a 0.09 gross acre site",
         "Planner": "MSTALHU ",
         "DURATION": 2822,
         "Year": 2006
      }
   ],
   "DMV Verification ": [
      {
         "PERMITID": "DMV02-015",
         "APN": 26420064,
         "File Number": "DMV02-015",
         "Address": "500 W SAN CARLOS ST SAN JOSE",
         "Project Name": "DMV02-015",
         "Application Type": "DMV Verification ",
         "Application Date": "10/7/02 16:55",
         "Status": "Complete ",
         "Description": " ",
         "Planner": "John Davidson ",
         "DURATION": 22,
         "Year": 2002
      },
      {
         "PERMITID": "DMV02-019",
         "APN": 26420064,
         "File Number": "DMV02-019",
         "Address": "500 W SAN CARLOS ST SAN JOSE",
         "Project Name": "DMV02-019",
         "Application Type": "DMV Verification ",
         "Application Date": "10/28/02 16:39",
         "Status": "Complete ",
         "Description": "Zoning verfication for vehicle dealer's licence ",
         "Planner": "John Davidson ",
         "DURATION": 85,
         "Year": 2002
      },
      {
         "PERMITID": "DMV03-009",
         "APN": 25947080,
         "File Number": "DMV03-009",
         "Address": "282 S MONTGOMERY ST SAN JOSE",
         "Project Name": "DMV03-009",
         "Application Type": "DMV Verification ",
         "Application Date": "2/11/03 15:46",
         "Status": "Complete ",
         "Description": "RETAIL MOTORCYCLE SALES NEW AND USED ",
         "Planner": "John Davidson ",
         "DURATION": 29,
         "Year": 2003
      },
      {
         "PERMITID": "DMV03-024",
         "APN": 46747038,
         "File Number": "DMV03-024",
         "Address": "456 S 2ND ST SAN JOSE",
         "Project Name": "DMV03-024",
         "Application Type": "DMV Verification ",
         "Application Date": "4/18/03 12:27",
         "Status": "Complete ",
         "Description": "driving school ",
         "Planner": "John Davidson ",
         "DURATION": 59,
         "Year": 2003
      },
      {
         "PERMITID": "DMV04-010",
         "APN": 26420064,
         "File Number": "DMV04-010",
         "Address": "500 W SAN CARLOS ST SAN JOSE",
         "Project Name": "DMV04-010",
         "Application Type": "DMV Verification ",
         "Application Date": "1/28/04 16:48",
         "Status": "Complete ",
         "Description": "DMV Verification to allow registration licensing branch and wholesale of automobiles with no on-site storage ",
         "Planner": " ",
         "DURATION": 5,
         "Year": 2004
      },
      {
         "PERMITID": "DMV04-024",
         "APN": 26420084,
         "File Number": "DMV04-024",
         "Address": "462 W SAN CARLOS ST SAN JOSE",
         "Project Name": "DMV04-024",
         "Application Type": "DMV Verification ",
         "Application Date": "4/7/04 11:18",
         "Status": "Complete ",
         "Description": "DMV verification for a car sales. ",
         "Planner": "Dipa Chundur ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "DMV05-030",
         "APN": 47226083,
         "File Number": "DMV05-030",
         "Address": "698 S 1ST ST SAN JOSE",
         "Project Name": "DMV05-030",
         "Application Type": "DMV Verification ",
         "Application Date": "6/8/05 15:18",
         "Status": "Complete ",
         "Description": "DMV Verification request for existing retail automobile dealership on 0.32 gross acre site in the CP-Commercial Pedestrian Zoning District",
         "Planner": "Michele Campos ",
         "DURATION": 5,
         "Year": 2005
      },
      {
         "PERMITID": "DMV07-036",
         "APN": 25947038,
         "File Number": "DMV07-036",
         "Address": "597 W SAN CARLOS ST SAN JOSE",
         "Project Name": "DMV07-036",
         "Application Type": "DMV Verification ",
         "Application Date": "5/7/07 12:54",
         "Status": "Complete ",
         "Description": "DMV Verification for leasing of passenger vehicles, pick-up trucks not to exceed 25 feet in length, and light trailers, and sale or lease of commercial vehicles in the CG/LI Zoning Districts, conditionally approved by Conditional Use Permit CP06-064.",
         "Planner": "John Kim ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "DMV08-065",
         "APN": 46747038,
         "File Number": "DMV08-065",
         "Address": "456 S 2ND ST SAN JOSE",
         "Project Name": "DMV08-065",
         "Application Type": "DMV Verification ",
         "Application Date": "10/1/08 14:33",
         "Status": "Complete ",
         "Description": "DMV Verification Letter Request for Operating a driving school at an existing commercial building located in the DC Downtown Commercial Zoning District. ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "DMV08-083",
         "APN": 46747038,
         "File Number": "DMV08-083",
         "Address": "456 S 2ND ST SAN JOSE",
         "Project Name": "DMV08-083",
         "Application Type": "DMV Verification ",
         "Application Date": "12/23/08 9:08",
         "Status": "Complete ",
         "Description": "DMV verification letter for continuation of an existing driving school in an existing commercial building ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "DMV09-005",
         "APN": 46724038,
         "File Number": "DMV09-005",
         "Address": "314 E SANTA CLARA ST SAN JOSE",
         "Project Name": "DMV09-005",
         "Application Type": "DMV Verification ",
         "Application Date": "1/16/09 14:04",
         "Status": "Complete ",
         "Description": "DMV Verifcation for vehicle retail sales.  ",
         "Planner": "MNAGARAJ ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "DMV10-010",
         "APN": 47218055,
         "File Number": "DMV10-010",
         "Address": "288 E VIRGINIA ST SAN JOSE",
         "Project Name": "DMV10-010",
         "Application Type": "DMV Verification ",
         "Application Date": "2/10/10 9:26",
         "Status": "Complete ",
         "Description": "FOR WHOLESALE AUTO BROKER ONLY  ",
         "Planner": "MNAGARAJ ",
         "DURATION": 0,
         "Year": 2010
      },
      {
         "PERMITID": "DMV10-021",
         "APN": 26420084,
         "File Number": "DMV10-021",
         "Address": "462 W SAN CARLOS ST SAN JOSE",
         "Project Name": "DMV10-021",
         "Application Type": "DMV Verification ",
         "Application Date": "5/3/10 14:35",
         "Status": "Complete ",
         "Description": "DMV Zoning Verification ",
         "Planner": "Jeff Roche ",
         "DURATION": 1,
         "Year": 2010
      },
      {
         "PERMITID": "DMV11-070",
         "APN": 47217008,
         "File Number": "DMV11-070",
         "Address": "798 S 1ST ST SAN JOSE",
         "Project Name": "DMV11-070",
         "Application Type": "DMV Verification ",
         "Application Date": "11/9/11 15:05",
         "Status": "Complete ",
         "Description": "USED CAR SALE BUSINESS -=- LNC APPROVED THROUGH H80-088",
         "Planner": "MNAGARAJ ",
         "DURATION": 1,
         "Year": 2011
      },
      {
         "PERMITID": "DMV11-078",
         "APN": 46718087,
         "File Number": "DMV11-078",
         "Address": "345 E SANTA CLARA ST SAN JOSE",
         "Project Name": "DMV11-078",
         "Application Type": "DMV Verification ",
         "Application Date": "12/5/11 13:52",
         "Status": "Complete ",
         "Description": "DMV verification for vehicle sales in the CG Commercial General Zoning District.  ",
         "Planner": "Avril Baty ",
         "DURATION": 1,
         "Year": 2011
      },
      {
         "PERMITID": "DMV12-001",
         "APN": 46747058,
         "File Number": "DMV12-001",
         "Address": "451 S 4TH ST SAN JOSE",
         "Project Name": "DMV12-001",
         "Application Type": "DMV Verification ",
         "Application Date": "1/4/12 14:38",
         "Status": "Complete ",
         "Description": "Wholesale dealer ",
         "Planner": "MNAGARAJ ",
         "DURATION": 1,
         "Year": 2012
      },
      {
         "PERMITID": "DMV12-018",
         "APN": 46720041,
         "File Number": "DMV12-018",
         "Address": "115 N 4TH ST SAN JOSE",
         "Project Name": "DMV12-018",
         "Application Type": "DMV Verification ",
         "Application Date": "3/13/12 14:23",
         "Status": "Complete ",
         "Description": "Zoning verification for registration services ",
         "Planner": "MNAGARAJ ",
         "DURATION": 1,
         "Year": 2012
      },
      {
         "PERMITID": "DMV12-032",
         "APN": 26420084,
         "File Number": "DMV12-032",
         "Address": "462 W SAN CARLOS ST SAN JOSE",
         "Project Name": "DMV12-032",
         "Application Type": "DMV Verification ",
         "Application Date": "4/23/12 13:07",
         "Status": "Complete ",
         "Description": "DMV Verification ",
         "Planner": "Jeff Roche ",
         "DURATION": 1,
         "Year": 2012
      },
      {
         "PERMITID": "DMV13-035",
         "APN": 26420084,
         "File Number": "DMV13-035",
         "Address": "462 W SAN CARLOS ST SAN JOSE",
         "Project Name": "DMV13-035",
         "Application Type": "DMV Verification ",
         "Application Date": "6/11/13 13:37",
         "Status": "Complete ",
         "Description": "DMV Verification ",
         "Planner": "Lori Moniz ",
         "DURATION": 1,
         "Year": 2013
      },
      {
         "PERMITID": "DMV13-038",
         "APN": 26420084,
         "File Number": "DMV13-038",
         "Address": "462 W SAN CARLOS ST SAN JOSE",
         "Project Name": "DMV13-038",
         "Application Type": "DMV Verification ",
         "Application Date": "6/20/13 14:01",
         "Status": "Complete ",
         "Description": "DMV verification for a LNC car dealership.  ",
         "Planner": "Avril Baty ",
         "DURATION": 1,
         "Year": 2013
      },
      {
         "PERMITID": "DMV13-059",
         "APN": 26420082,
         "File Number": "DMV13-059",
         "Address": "470 W SAN CARLOS ST SAN JOSE",
         "Project Name": "DMV13-059",
         "Application Type": "DMV Verification ",
         "Application Date": "9/11/13 13:30",
         "Status": "Complete ",
         "Description": "Zoning verification letter for retail sale of vehicles in the Light Industrial Zoning District. ",
         "Planner": " ",
         "DURATION": 1,
         "Year": 2013
      },
      {
         "PERMITID": "DMV14-061",
         "APN": 26420084,
         "File Number": "DMV14-061",
         "Address": "462 W SAN CARLOS ST SAN JOSE",
         "Project Name": "DMV14-061",
         "Application Type": "DMV Verification ",
         "Application Date": "6/27/14 11:31",
         "Status": "Complete ",
         "Description": "DMV Verification for a retail sales of used automobiles. Retail sales is Legal Nonconforming on the subject site ",
         "Planner": " ",
         "DURATION": 1,
         "Year": 2014
      },
      {
         "PERMITID": "DMV17-042",
         "APN": 26420084,
         "File Number": "DMV17-042",
         "Address": "462 W SAN CARLOS ST SAN JOSE",
         "Project Name": "DMV17-042",
         "Application Type": "DMV Verification ",
         "Application Date": "6/26/17 16:08",
         "Status": "Complete ",
         "Description": "DMV Verification for a retail sales of used automobiles. Retail sales is Legal Nonconforming on the subject site ",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "DMV18-013",
         "APN": 47229094,
         "File Number": "DMV18-013",
         "Address": "505 S 10TH ST SAN JOSE",
         "Project Name": "DMV18-013",
         "Application Type": "DMV Verification ",
         "Application Date": "6/25/18 15:32",
         "Status": "Complete ",
         "Description": "DMV verification letter for registration services ",
         "Planner": " ",
         "DURATION": 1,
         "Year": 2018
      },
      {
         "PERMITID": "2005 007743 PI",
         "APN": 46720059,
         "File Number": "2005 007743 PI",
         "Address": "127 N 4TH ST SAN JOSE",
         "Project Name": "DMV05-020",
         "Application Type": "DMV Verification ",
         "Application Date": "3/14/05 10:07",
         "Status": "Rejected ",
         "Description": "DMV verification letter for a used car retail sales lot. ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2005
      },
      {
         "PERMITID": "DMV09-039",
         "APN": 26420084,
         "File Number": "DMV09-039",
         "Address": "462 W SAN CARLOS ST SAN JOSE",
         "Project Name": "DMV09-039",
         "Application Type": "DMV Verification ",
         "Application Date": "6/4/09 16:36",
         "Status": "Under Review ",
         "Description": "Zoning Verififcation for Retail Sales (Legal Non-conforming) ",
         "Planner": "Mike Enderby ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "DMV14-051",
         "APN": 46747038,
         "File Number": "DMV14-051",
         "Address": "456 S 2ND ST SAN JOSE",
         "Project Name": "DMV14-051",
         "Application Type": "DMV Verification ",
         "Application Date": "6/5/14 15:01",
         "Status": "Under Review ",
         "Description": "DMV Verification for driving school office ",
         "Planner": " ",
         "DURATION": 1,
         "Year": 2014
      },
      {
         "PERMITID": "DMV15-060",
         "APN": 46720041,
         "File Number": "DMV15-060",
         "Address": "115 N 4TH ST SAN JOSE",
         "Project Name": "DMV15-060",
         "Application Type": "DMV Verification ",
         "Application Date": "8/17/15 13:39",
         "Status": "Under Review ",
         "Description": "DMV Verification for auto-broker. ",
         "Planner": "Pick ",
         "DURATION": 1,
         "Year": 2015
      },
      {
         "PERMITID": "DMV06-004",
         "APN": 26420064,
         "File Number": "DMV06-004",
         "Address": "500 W SAN CARLOS ST SAN JOSE",
         "Project Name": "DMV06-004",
         "Application Type": "DMV Verification ",
         "Application Date": "1/19/06 15:20",
         "Status": "Withdrawn ",
         "Description": "DMV Verification letter for Used auto sales at 500 W San Carlos",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "DMV16-037",
         "APN": 25934010,
         "File Number": "DMV16-037",
         "Address": "99 N 1ST ST SAN JOSE",
         "Project Name": "DMV16-037 - WITHDRAWN",
         "Application Type": "DMV Verification ",
         "Application Date": "6/29/16 13:38",
         "Status": "Withdrawn ",
         "Description": "DMV Wholesale, no on site storage ",
         "Planner": "Lori Moniz ",
         "DURATION": 1,
         "Year": 2016
      }
   ],
   "DO NOT USE - Tree Removal ": [
      {
         "PERMITID": "TR00-171",
         "APN": 24946089,
         "File Number": "TR00-171",
         "Address": "380 N 4TH ST SAN JOSE",
         "Project Name": "TR00-171",
         "Application Type": "DO NOT USE - Tree Removal ",
         "Application Date": "12/4/00",
         "Status": "Approved ",
         "Description": "Tree Removal Permit to remove 1 Walnut tree 56 inches in circumference",
         "Planner": "Akoni Danielsen ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "TR00-171",
         "APN": 24946090,
         "File Number": "TR00-171",
         "Address": "380 N 4TH ST SAN JOSE",
         "Project Name": "TR00-171",
         "Application Type": "DO NOT USE - Tree Removal ",
         "Application Date": "12/4/00",
         "Status": "Approved ",
         "Description": "Tree Removal Permit to remove 1 Walnut tree 56 inches in circumference",
         "Planner": "Akoni Danielsen ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "TR00-171",
         "APN": 24946092,
         "File Number": "TR00-171",
         "Address": "380 N 4TH ST SAN JOSE",
         "Project Name": "TR00-171",
         "Application Type": "DO NOT USE - Tree Removal ",
         "Application Date": "12/4/00",
         "Status": "Approved ",
         "Description": "Tree Removal Permit to remove 1 Walnut tree 56 inches in circumference",
         "Planner": "Akoni Danielsen ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "TR00-087",
         "APN": 47223006,
         "File Number": "TR00-087",
         "Address": "662 S 10TH ST SAN JOSE",
         "Project Name": "662 S. 10th St TR, Orf",
         "Application Type": "DO NOT USE - Tree Removal ",
         "Application Date": "6/21/00",
         "Status": "Denied ",
         "Description": "Tree Removal Permit to remove 1 Redwood 84 inches in circumference",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 112,
         "Year": 2000
      }
   ],
   "Draft EIR ": [
      {
         "PERMITID": "PP16-037",
         "APN": 46721014,
         "File Number": "PP16-037",
         "Address": "0 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP16-037 St. James Park Capital Vision and Levitt Pavilion",
         "Application Type": "Draft EIR ",
         "Application Date": "4/20/16 13:51",
         "Status": "Under Review ",
         "Description": "The project includes physical and programmatic changes to St. James Park to transform it from an underutilized public space to a vibrant, attractive, and active public park through a multi-prong revitalization strategy. Proposed improvements to the park could include the construction of a music pavilion sponsored by the Levitt Pavilion/Foundation in the northeast quadrant of the park and the implementation of elements from the 1985 and 2002 St. James Master Plans.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2016
      }
   ],
   "Environmental Review only ": [
      {
         "PERMITID": "ER13-010",
         "APN": 26137027,
         "File Number": "ER13-010",
         "Address": " ",
         "Project Name": "ER13-010 Geotesting Clearance",
         "Application Type": "Environmental Review only ",
         "Application Date": "12/13/13",
         "Status": "Complete ",
         "Description": "Geotechnical investigation consisting of four geotechnical borings (two 25’ deep and two 45’ deep truck mounted) for the future Los Gatos Creek Trail Reach 5B/C undercrossing of the Caltrain railroad bridge and San Carlos St. bridge. Boring locations will be at the top of bank along the existing Los Gatos Creek Trail and within the City of San Jose Fire Department Training Facility, both located at top of bank above and outside the low flow channel, near the proposed retaining wall locations. Two additional 5’ deep top of bank borings will be collected for pavement subgrade samples along the top of bank trail using a truck mounted rig or hand tools.",
         "Planner": "Bill Roth ",
         "DURATION": 32,
         "Year": 2013
      },
      {
         "PERMITID": "ER13-010",
         "APN": 26415034,
         "File Number": "ER13-010",
         "Address": " ",
         "Project Name": "ER13-010 Geotesting Clearance",
         "Application Type": "Environmental Review only ",
         "Application Date": "12/13/13",
         "Status": "Complete ",
         "Description": "Geotechnical investigation consisting of four geotechnical borings (two 25’ deep and two 45’ deep truck mounted) for the future Los Gatos Creek Trail Reach 5B/C undercrossing of the Caltrain railroad bridge and San Carlos St. bridge. Boring locations will be at the top of bank along the existing Los Gatos Creek Trail and within the City of San Jose Fire Department Training Facility, both located at top of bank above and outside the low flow channel, near the proposed retaining wall locations. Two additional 5’ deep top of bank borings will be collected for pavement subgrade samples along the top of bank trail using a truck mounted rig or hand tools.",
         "Planner": "Bill Roth ",
         "DURATION": 32,
         "Year": 2013
      },
      {
         "PERMITID": "ER16-015",
         "APN": 46720081,
         "File Number": "ER16-015",
         "Address": "49 N 4TH ST SAN JOSE",
         "Project Name": "ER16-015",
         "Application Type": "Environmental Review only ",
         "Application Date": "4/20/16 11:22",
         "Status": "Complete ",
         "Description": "Geotesting clearance for four 8\" diameter hollow-stem auger borings ranging from 50 to 70 feet in depth and five 2\" diameter cone penetration tests ranging from 50 to 110 feet in depth.",
         "Planner": "David Keyon ",
         "DURATION": 1,
         "Year": 2016
      },
      {
         "PERMITID": "ER17-007",
         "APN": 25932040,
         "File Number": "ER17-007",
         "Address": "188 W JULIAN ST SAN JOSE",
         "Project Name": "ER17-007 188 & 160 W. Julian St",
         "Application Type": "Environmental Review only ",
         "Application Date": "6/13/17 10:14",
         "Status": "Complete ",
         "Description": "Geotesting clearance for three 8-inch diameter hollow-stem auger boring ranging in depth from 40 to 70 feet and four 2-inch diameter cone penetration test (CPT) ranging from 50 to 120 feet.",
         "Planner": "Krinjal Mathur ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "ER17-011",
         "APN": 25931071,
         "File Number": "ER17-011",
         "Address": "255 W JULIAN ST SAN JOSE",
         "Project Name": "ER17-011",
         "Application Type": "Environmental Review only ",
         "Application Date": "8/2/17 16:58",
         "Status": "Complete ",
         "Description": "Two 8-inch diameter borings will be drilled to depths of 35 to 75 feet (or possibly to about 110 feet), and three 2-inch diameter CPTs will be advanced to a maximum of 125 feet. All explorations will be backfilled with cement grout.",
         "Planner": "Thai Chau Le ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "ER18-020",
         "APN": 46746080,
         "File Number": "ER18-020",
         "Address": "345 S 2ND ST SAN JOSE",
         "Project Name": "ER18-020",
         "Application Type": "Environmental Review only ",
         "Application Date": "11/29/18 15:13",
         "Status": "Complete ",
         "Description": "Geotesting clearance for 10 CPT explorations (2 inches in diameter) to maximum depth of 120 feet for soil profile analysis. Additionally, performing 8 exploration hollow-stem auger boring (8-inches in diameter) for geotechnical sampling of soil to depths up to the 100 feet.",
         "Planner": "Thai Chau Le ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "ER18-020",
         "APN": 46746081,
         "File Number": "ER18-020",
         "Address": "345 S 2ND ST SAN JOSE",
         "Project Name": "ER18-020",
         "Application Type": "Environmental Review only ",
         "Application Date": "11/29/18 15:13",
         "Status": "Complete ",
         "Description": "Geotesting clearance for 10 CPT explorations (2 inches in diameter) to maximum depth of 120 feet for soil profile analysis. Additionally, performing 8 exploration hollow-stem auger boring (8-inches in diameter) for geotechnical sampling of soil to depths up to the 100 feet.",
         "Planner": "Thai Chau Le ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "ER18-020",
         "APN": 46746082,
         "File Number": "ER18-020",
         "Address": "345 S 2ND ST SAN JOSE",
         "Project Name": "ER18-020",
         "Application Type": "Environmental Review only ",
         "Application Date": "11/29/18 15:13",
         "Status": "Complete ",
         "Description": "Geotesting clearance for 10 CPT explorations (2 inches in diameter) to maximum depth of 120 feet for soil profile analysis. Additionally, performing 8 exploration hollow-stem auger boring (8-inches in diameter) for geotechnical sampling of soil to depths up to the 100 feet.",
         "Planner": "Thai Chau Le ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "ER16-001",
         "APN": 46722160,
         "File Number": "ER16-001",
         "Address": "LAND ONLY SAN JOSE  ",
         "Project Name": "ER16-001 - Sobrato Block 3 Scope Review",
         "Application Type": "Environmental Review only ",
         "Application Date": "2/1/16 11:56",
         "Status": "Pending ",
         "Description": "Environmental scoping review. Tentative environmental review approach: Addendum to Downtown Strategy 2000 FEIR, GP 2040 FEIR, and the GP 2040 FSEIR (GHG).",
         "Planner": "David Keyon ",
         "DURATION": 27,
         "Year": 2016
      },
      {
         "PERMITID": "ER16-002",
         "APN": 46701120,
         "File Number": "ER16-002",
         "Address": "298 N 4TH ST SAN JOSE",
         "Project Name": "ER16-002 4th & Julian Geotesting",
         "Application Type": "Environmental Review only ",
         "Application Date": "2/1/16 14:43",
         "Status": "Pending ",
         "Description": "Proposal to conduct geotesting to satisfy mitigation measures from Mitigated Neg. Declaration for PDC14-064. Testing will consist of two 8\" diameter exploratory borings of between 20' and 40' deep and four 2\" diameter cone penetration tests (CPTs) of between 50' and 100' in depth. Site is a paved parking lot.",
         "Planner": "David Keyon ",
         "DURATION": 1,
         "Year": 2016
      },
      {
         "PERMITID": "ER16-012",
         "APN": 46746072,
         "File Number": "ER16-012",
         "Address": "330 S 2ND ST SAN JOSE",
         "Project Name": "ER16-012 S 2nd & San Carlos SJSU Student Housing Geotesting",
         "Application Type": "Environmental Review only ",
         "Application Date": "4/14/16 9:39",
         "Status": "Pending ",
         "Description": "Request for geotesting clearance consisting of four 8\" diameter hollow stem auger exploratory borings (between 40 and 70 feet deep) and four 2\" diameter cone penetration tests (50 to 110 feet deep).",
         "Planner": " ",
         "DURATION": 1,
         "Year": 2016
      },
      {
         "PERMITID": "ER17-014",
         "APN": 25947069,
         "File Number": "ER17-014",
         "Address": "543 LORRAINE AV SAN JOSE",
         "Project Name": "ER17-014",
         "Application Type": "Environmental Review only ",
         "Application Date": "11/3/17",
         "Status": "Pending ",
         "Description": "Environmental Scope Review for a 70-unit, 11-story building in the Diridon Station Area.",
         "Planner": "David Keyon ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "ER18-016",
         "APN": 46720020,
         "File Number": "ER18-016",
         "Address": "120 N 4TH ST SAN JOSE",
         "Project Name": "ER18-016",
         "Application Type": "Environmental Review only ",
         "Application Date": "11/1/18 10:18",
         "Status": "Pending ",
         "Description": "Geotesting clearance request. ",
         "Planner": "David Keyon ",
         "DURATION": 0,
         "Year": 2018
      }
   ],
   "Exempt ": [
      {
         "PERMITID": "PP04-259",
         "APN": 25941065,
         "File Number": "PP04-259",
         "Address": "194 S MARKET ST SAN JOSE",
         "Project Name": "Circle of Palms Ice Skating Rink Loan - Holiday Ice Skating ",
         "Application Type": "Exempt ",
         "Application Date": "9/8/04 19:06",
         "Status": "Complete ",
         "Description": "Loan for the purchase of a temporary (seasonal) ice skating rink, to be located in the Circle of Palms public plaza located between S. Market, S. First, W. San Carlos and Paseo De S. Antonio.  ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2004
      },
      {
         "PERMITID": "PP04-273",
         "APN": 46723100,
         "File Number": "PP04-273",
         "Address": "88 S 4TH ST SAN JOSE",
         "Project Name": "4th Street Garage Improvements, Northside",
         "Application Type": "Exempt ",
         "Application Date": "9/30/04 9:15",
         "Status": "Complete ",
         "Description": "Tenant improvements on the northside of the 4th Street garage, including interior walls, insulation, HVAC, and utilities.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2004
      },
      {
         "PERMITID": "PP04-273",
         "APN": 46723101,
         "File Number": "PP04-273",
         "Address": "88 S 4TH ST SAN JOSE",
         "Project Name": "4th Street Garage Improvements, Northside",
         "Application Type": "Exempt ",
         "Application Date": "9/30/04 9:15",
         "Status": "Complete ",
         "Description": "Tenant improvements on the northside of the 4th Street garage, including interior walls, insulation, HVAC, and utilities.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2004
      },
      {
         "PERMITID": "PP04-284",
         "APN": 25934039,
         "File Number": "PP04-284",
         "Address": " ",
         "Project Name": "PP04-284 - power washing of City-owned parking garages",
         "Application Type": "Exempt ",
         "Application Date": "10/13/04 21:38",
         "Status": "Complete ",
         "Description": "Cleaning and power washing of several City owned parking garages ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2004
      },
      {
         "PERMITID": "PP04-321",
         "APN": 25940064,
         "File Number": "PP04-321",
         "Address": " ",
         "Project Name": "PP04-321 Crescent Jewelry Site Rehab",
         "Application Type": "Exempt ",
         "Application Date": "11/24/04 10:24",
         "Status": "Complete ",
         "Description": "Disposition and Development Agreement (DDA) for rehabilitation (including seismic reinforcement, mechanical systems upgrades, ADA accessibility improvements, and facade enhancements) of two existing historical buildings and demolition of a portion of an existing building ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2004
      },
      {
         "PERMITID": "PP04-321",
         "APN": 46722127,
         "File Number": "PP04-321",
         "Address": " ",
         "Project Name": "PP04-321 Crescent Jewelry Site Rehab",
         "Application Type": "Exempt ",
         "Application Date": "11/24/04 10:24",
         "Status": "Complete ",
         "Description": "Disposition and Development Agreement (DDA) for rehabilitation (including seismic reinforcement, mechanical systems upgrades, ADA accessibility improvements, and facade enhancements) of two existing historical buildings and demolition of a portion of an existing building ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2004
      },
      {
         "PERMITID": "PP05-015",
         "APN": 46723100,
         "File Number": "PP05-015",
         "Address": "88 S 4TH ST SAN JOSE",
         "Project Name": "PP05-015 Lease with San Jose Credit Union",
         "Application Type": "Exempt ",
         "Application Date": "1/10/05 17:10",
         "Status": "Complete ",
         "Description": "Lease agreement with San Jose Credit Union for a 2,400-square-foot retail space along the street frontage of the Fourth Street Parking Garage.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2005
      },
      {
         "PERMITID": "PP05-015",
         "APN": 46723101,
         "File Number": "PP05-015",
         "Address": "88 S 4TH ST SAN JOSE",
         "Project Name": "PP05-015 Lease with San Jose Credit Union",
         "Application Type": "Exempt ",
         "Application Date": "1/10/05 17:10",
         "Status": "Complete ",
         "Description": "Lease agreement with San Jose Credit Union for a 2,400-square-foot retail space along the street frontage of the Fourth Street Parking Garage.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2005
      },
      {
         "PERMITID": "PP05-069",
         "APN": 26427082,
         "File Number": "PP05-069",
         "Address": "180 WOZ WY SAN JOSE",
         "Project Name": "PP05-069 Children's Discovery Museum fountain removal",
         "Application Type": "Exempt ",
         "Application Date": "4/12/05 11:34",
         "Status": "Complete ",
         "Description": "Remove an existing outdoor fountain and replace with a new patio and landscaping ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2005
      },
      {
         "PERMITID": "PP05-069",
         "APN": 26427087,
         "File Number": "PP05-069",
         "Address": "180 WOZ WY SAN JOSE",
         "Project Name": "PP05-069 Children's Discovery Museum fountain removal",
         "Application Type": "Exempt ",
         "Application Date": "4/12/05 11:34",
         "Status": "Complete ",
         "Description": "Remove an existing outdoor fountain and replace with a new patio and landscaping ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2005
      },
      {
         "PERMITID": "PP05-069",
         "APN": 26427088,
         "File Number": "PP05-069",
         "Address": "180 WOZ WY SAN JOSE",
         "Project Name": "PP05-069 Children's Discovery Museum fountain removal",
         "Application Type": "Exempt ",
         "Application Date": "4/12/05 11:34",
         "Status": "Complete ",
         "Description": "Remove an existing outdoor fountain and replace with a new patio and landscaping ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2005
      },
      {
         "PERMITID": "PP05-091",
         "APN": 25935029,
         "File Number": "PP05-091",
         "Address": "99 NOTRE DAME AV SAN JOSE",
         "Project Name": "PP05-091 Future RAMAC Museum",
         "Application Type": "Exempt ",
         "Application Date": "4/27/05 14:35",
         "Status": "Complete ",
         "Description": "Resolution stating the City of San Jose supports the creation of a museum at 99 Notre Dame Avenue featuring the history of the RAMAC and the City, together with the Magnetic Disk Heritage Center and others should begin to jointly collaborate to bring such a museum into realization and that the City Council hereby directs and authorizes the City Manager to begin these joint collaboration discussions.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2005
      },
      {
         "PERMITID": "PP05-109",
         "APN": 25940034,
         "File Number": "PP05-109",
         "Address": "84 W SANTA CLARA ST SAN JOSE",
         "Project Name": "PP05-109",
         "Application Type": "Exempt ",
         "Application Date": "5/18/05 11:21",
         "Status": "Complete ",
         "Description": "Lease agreement for the Small Business Administration San Jose Entrepreneur Center, 84 West Santa Clara Street.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2005
      },
      {
         "PERMITID": "PP05-192",
         "APN": 47226033,
         "File Number": "PP05-192",
         "Address": "560 S 1ST ST SAN JOSE",
         "Project Name": "PP05-192 San Jose Institute of Contemporary Art",
         "Application Type": "Exempt ",
         "Application Date": "10/12/05 16:43",
         "Status": "Complete ",
         "Description": "Adopt a resolution authorizing the Executive Director to negotiate and execute a Grant Agreement, in an amount not to exceed $500,000, with the San Jose Institute of Contemporary Art for the purpose of acquisition of property located at 560 South First Street",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2005
      },
      {
         "PERMITID": "PP05-276",
         "APN": 46746075,
         "File Number": "PP05-276",
         "Address": "366 S 1ST ST SAN JOSE",
         "Project Name": "PP05-276 Camera One",
         "Application Type": "Exempt ",
         "Application Date": "12/7/05 14:15",
         "Status": "Complete ",
         "Description": "Amendment to lease agreement to allow the Agency to construct certain building improvements. These building improvements will be approved through a Planning permit adjustment, when detailed plans are available. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2005
      },
      {
         "PERMITID": "PP06-046",
         "APN": 46746097,
         "File Number": "PP06-046",
         "Address": "280 S 2ND ST SAN JOSE",
         "Project Name": "PP06-046",
         "Application Type": "Exempt ",
         "Application Date": "3/30/06 11:25",
         "Status": "Complete ",
         "Description": "City garage seismic upgrade project which consists of strengthening of beams, columns and the addition of shear walls. All work is located within the existing building. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2006
      },
      {
         "PERMITID": "PP06-061",
         "APN": 46723010,
         "File Number": "PP06-061",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP06-061",
         "Application Type": "Exempt ",
         "Application Date": "4/12/06 9:09",
         "Status": "Complete ",
         "Description": "Washing of exterior windows at New City Hall ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2006
      },
      {
         "PERMITID": "PP06-061",
         "APN": 46723011,
         "File Number": "PP06-061",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP06-061",
         "Application Type": "Exempt ",
         "Application Date": "4/12/06 9:09",
         "Status": "Complete ",
         "Description": "Washing of exterior windows at New City Hall ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2006
      },
      {
         "PERMITID": "PP06-061",
         "APN": 46723013,
         "File Number": "PP06-061",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP06-061",
         "Application Type": "Exempt ",
         "Application Date": "4/12/06 9:09",
         "Status": "Complete ",
         "Description": "Washing of exterior windows at New City Hall ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2006
      },
      {
         "PERMITID": "PP06-061",
         "APN": 46723017,
         "File Number": "PP06-061",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP06-061",
         "Application Type": "Exempt ",
         "Application Date": "4/12/06 9:09",
         "Status": "Complete ",
         "Description": "Washing of exterior windows at New City Hall ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2006
      },
      {
         "PERMITID": "PP06-061",
         "APN": 46723018,
         "File Number": "PP06-061",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP06-061",
         "Application Type": "Exempt ",
         "Application Date": "4/12/06 9:09",
         "Status": "Complete ",
         "Description": "Washing of exterior windows at New City Hall ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2006
      },
      {
         "PERMITID": "PP06-061",
         "APN": 46723019,
         "File Number": "PP06-061",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP06-061",
         "Application Type": "Exempt ",
         "Application Date": "4/12/06 9:09",
         "Status": "Complete ",
         "Description": "Washing of exterior windows at New City Hall ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2006
      },
      {
         "PERMITID": "PP06-061",
         "APN": 46723021,
         "File Number": "PP06-061",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP06-061",
         "Application Type": "Exempt ",
         "Application Date": "4/12/06 9:09",
         "Status": "Complete ",
         "Description": "Washing of exterior windows at New City Hall ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2006
      },
      {
         "PERMITID": "PP06-061",
         "APN": 46723022,
         "File Number": "PP06-061",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP06-061",
         "Application Type": "Exempt ",
         "Application Date": "4/12/06 9:09",
         "Status": "Complete ",
         "Description": "Washing of exterior windows at New City Hall ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2006
      },
      {
         "PERMITID": "PP06-061",
         "APN": 46723076,
         "File Number": "PP06-061",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP06-061",
         "Application Type": "Exempt ",
         "Application Date": "4/12/06 9:09",
         "Status": "Complete ",
         "Description": "Washing of exterior windows at New City Hall ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2006
      },
      {
         "PERMITID": "PP06-061",
         "APN": 46724001,
         "File Number": "PP06-061",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP06-061",
         "Application Type": "Exempt ",
         "Application Date": "4/12/06 9:09",
         "Status": "Complete ",
         "Description": "Washing of exterior windows at New City Hall ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2006
      },
      {
         "PERMITID": "PP06-061",
         "APN": 46724002,
         "File Number": "PP06-061",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP06-061",
         "Application Type": "Exempt ",
         "Application Date": "4/12/06 9:09",
         "Status": "Complete ",
         "Description": "Washing of exterior windows at New City Hall ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2006
      },
      {
         "PERMITID": "PP06-061",
         "APN": 46724003,
         "File Number": "PP06-061",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP06-061",
         "Application Type": "Exempt ",
         "Application Date": "4/12/06 9:09",
         "Status": "Complete ",
         "Description": "Washing of exterior windows at New City Hall ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2006
      },
      {
         "PERMITID": "PP06-061",
         "APN": 46724014,
         "File Number": "PP06-061",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP06-061",
         "Application Type": "Exempt ",
         "Application Date": "4/12/06 9:09",
         "Status": "Complete ",
         "Description": "Washing of exterior windows at New City Hall ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2006
      },
      {
         "PERMITID": "PP06-061",
         "APN": 46724015,
         "File Number": "PP06-061",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP06-061",
         "Application Type": "Exempt ",
         "Application Date": "4/12/06 9:09",
         "Status": "Complete ",
         "Description": "Washing of exterior windows at New City Hall ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2006
      },
      {
         "PERMITID": "PP06-061",
         "APN": 46724016,
         "File Number": "PP06-061",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP06-061",
         "Application Type": "Exempt ",
         "Application Date": "4/12/06 9:09",
         "Status": "Complete ",
         "Description": "Washing of exterior windows at New City Hall ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2006
      },
      {
         "PERMITID": "PP06-061",
         "APN": 46724019,
         "File Number": "PP06-061",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP06-061",
         "Application Type": "Exempt ",
         "Application Date": "4/12/06 9:09",
         "Status": "Complete ",
         "Description": "Washing of exterior windows at New City Hall ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2006
      },
      {
         "PERMITID": "PP06-061",
         "APN": 46724020,
         "File Number": "PP06-061",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP06-061",
         "Application Type": "Exempt ",
         "Application Date": "4/12/06 9:09",
         "Status": "Complete ",
         "Description": "Washing of exterior windows at New City Hall ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2006
      },
      {
         "PERMITID": "PP06-061",
         "APN": 46724021,
         "File Number": "PP06-061",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP06-061",
         "Application Type": "Exempt ",
         "Application Date": "4/12/06 9:09",
         "Status": "Complete ",
         "Description": "Washing of exterior windows at New City Hall ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2006
      },
      {
         "PERMITID": "PP06-061",
         "APN": 46724115,
         "File Number": "PP06-061",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP06-061",
         "Application Type": "Exempt ",
         "Application Date": "4/12/06 9:09",
         "Status": "Complete ",
         "Description": "Washing of exterior windows at New City Hall ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2006
      },
      {
         "PERMITID": "PP06-061",
         "APN": 46724117,
         "File Number": "PP06-061",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP06-061",
         "Application Type": "Exempt ",
         "Application Date": "4/12/06 9:09",
         "Status": "Complete ",
         "Description": "Washing of exterior windows at New City Hall ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2006
      },
      {
         "PERMITID": "PP06-069",
         "APN": 25956003,
         "File Number": "PP06-069",
         "Address": "170 S MARKET ST SAN JOSE",
         "Project Name": "PP06-069",
         "Application Type": "Exempt ",
         "Application Date": "4/20/06 11:02",
         "Status": "Complete ",
         "Description": "Lease of 7,030 sq ft of retail space to Mesa SoFA Partners, LLC for use as a real estate sales office.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2006
      },
      {
         "PERMITID": "PP06-140",
         "APN": 25942023,
         "File Number": "PP06-140",
         "Address": "201 S MARKET ST SAN JOSE",
         "Project Name": "PP06-140",
         "Application Type": "Exempt ",
         "Application Date": "8/28/06 16:24",
         "Status": "Complete ",
         "Description": "Replacement of tiles on exterior of Tech Museum ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2006
      },
      {
         "PERMITID": "PP07-010",
         "APN": 25941065,
         "File Number": "PP07-010",
         "Address": "194 S MARKET ST SAN JOSE",
         "Project Name": "PP07-010 - Cezar Chavez Water Fountain",
         "Application Type": "Exempt ",
         "Application Date": "1/19/07 13:37",
         "Status": "Complete ",
         "Description": "Cezar Chavez Water Fountain Recirculation System Redesign/Construction. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-010",
         "APN": 25942036,
         "File Number": "PP07-010",
         "Address": "194 S MARKET ST SAN JOSE",
         "Project Name": "PP07-010 - Cezar Chavez Water Fountain",
         "Application Type": "Exempt ",
         "Application Date": "1/19/07 13:37",
         "Status": "Complete ",
         "Description": "Cezar Chavez Water Fountain Recirculation System Redesign/Construction. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-018",
         "APN": 46723038,
         "File Number": "PP07-018",
         "Address": "124 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP07-018",
         "Application Type": "Exempt ",
         "Application Date": "1/31/07 15:07",
         "Status": "Complete ",
         "Description": "Facade Improvement grant for the Building located at 124-126 E.Santa Clara St.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-021",
         "APN": 46723010,
         "File Number": "PP07-021",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Signage Modification ",
         "Application Type": "Exempt ",
         "Application Date": "2/1/07 14:56",
         "Status": "Complete ",
         "Description": "Modifications and additions to existing wayfinding signage at the City of San Jose City Hall public facility, consisting of new attached and detached signage in the interior of City Hall, as well as on the exterior grounds near public entrances. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-021",
         "APN": 46723011,
         "File Number": "PP07-021",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Signage Modification ",
         "Application Type": "Exempt ",
         "Application Date": "2/1/07 14:56",
         "Status": "Complete ",
         "Description": "Modifications and additions to existing wayfinding signage at the City of San Jose City Hall public facility, consisting of new attached and detached signage in the interior of City Hall, as well as on the exterior grounds near public entrances. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-021",
         "APN": 46723013,
         "File Number": "PP07-021",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Signage Modification ",
         "Application Type": "Exempt ",
         "Application Date": "2/1/07 14:56",
         "Status": "Complete ",
         "Description": "Modifications and additions to existing wayfinding signage at the City of San Jose City Hall public facility, consisting of new attached and detached signage in the interior of City Hall, as well as on the exterior grounds near public entrances. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-021",
         "APN": 46723017,
         "File Number": "PP07-021",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Signage Modification ",
         "Application Type": "Exempt ",
         "Application Date": "2/1/07 14:56",
         "Status": "Complete ",
         "Description": "Modifications and additions to existing wayfinding signage at the City of San Jose City Hall public facility, consisting of new attached and detached signage in the interior of City Hall, as well as on the exterior grounds near public entrances. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-021",
         "APN": 46723018,
         "File Number": "PP07-021",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Signage Modification ",
         "Application Type": "Exempt ",
         "Application Date": "2/1/07 14:56",
         "Status": "Complete ",
         "Description": "Modifications and additions to existing wayfinding signage at the City of San Jose City Hall public facility, consisting of new attached and detached signage in the interior of City Hall, as well as on the exterior grounds near public entrances. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-021",
         "APN": 46723019,
         "File Number": "PP07-021",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Signage Modification ",
         "Application Type": "Exempt ",
         "Application Date": "2/1/07 14:56",
         "Status": "Complete ",
         "Description": "Modifications and additions to existing wayfinding signage at the City of San Jose City Hall public facility, consisting of new attached and detached signage in the interior of City Hall, as well as on the exterior grounds near public entrances. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-021",
         "APN": 46723021,
         "File Number": "PP07-021",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Signage Modification ",
         "Application Type": "Exempt ",
         "Application Date": "2/1/07 14:56",
         "Status": "Complete ",
         "Description": "Modifications and additions to existing wayfinding signage at the City of San Jose City Hall public facility, consisting of new attached and detached signage in the interior of City Hall, as well as on the exterior grounds near public entrances. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-021",
         "APN": 46723022,
         "File Number": "PP07-021",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Signage Modification ",
         "Application Type": "Exempt ",
         "Application Date": "2/1/07 14:56",
         "Status": "Complete ",
         "Description": "Modifications and additions to existing wayfinding signage at the City of San Jose City Hall public facility, consisting of new attached and detached signage in the interior of City Hall, as well as on the exterior grounds near public entrances. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-021",
         "APN": 46723076,
         "File Number": "PP07-021",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Signage Modification ",
         "Application Type": "Exempt ",
         "Application Date": "2/1/07 14:56",
         "Status": "Complete ",
         "Description": "Modifications and additions to existing wayfinding signage at the City of San Jose City Hall public facility, consisting of new attached and detached signage in the interior of City Hall, as well as on the exterior grounds near public entrances. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-021",
         "APN": 46724001,
         "File Number": "PP07-021",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Signage Modification ",
         "Application Type": "Exempt ",
         "Application Date": "2/1/07 14:56",
         "Status": "Complete ",
         "Description": "Modifications and additions to existing wayfinding signage at the City of San Jose City Hall public facility, consisting of new attached and detached signage in the interior of City Hall, as well as on the exterior grounds near public entrances. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-021",
         "APN": 46724002,
         "File Number": "PP07-021",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Signage Modification ",
         "Application Type": "Exempt ",
         "Application Date": "2/1/07 14:56",
         "Status": "Complete ",
         "Description": "Modifications and additions to existing wayfinding signage at the City of San Jose City Hall public facility, consisting of new attached and detached signage in the interior of City Hall, as well as on the exterior grounds near public entrances. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-021",
         "APN": 46724003,
         "File Number": "PP07-021",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Signage Modification ",
         "Application Type": "Exempt ",
         "Application Date": "2/1/07 14:56",
         "Status": "Complete ",
         "Description": "Modifications and additions to existing wayfinding signage at the City of San Jose City Hall public facility, consisting of new attached and detached signage in the interior of City Hall, as well as on the exterior grounds near public entrances. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-021",
         "APN": 46724014,
         "File Number": "PP07-021",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Signage Modification ",
         "Application Type": "Exempt ",
         "Application Date": "2/1/07 14:56",
         "Status": "Complete ",
         "Description": "Modifications and additions to existing wayfinding signage at the City of San Jose City Hall public facility, consisting of new attached and detached signage in the interior of City Hall, as well as on the exterior grounds near public entrances. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-021",
         "APN": 46724015,
         "File Number": "PP07-021",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Signage Modification ",
         "Application Type": "Exempt ",
         "Application Date": "2/1/07 14:56",
         "Status": "Complete ",
         "Description": "Modifications and additions to existing wayfinding signage at the City of San Jose City Hall public facility, consisting of new attached and detached signage in the interior of City Hall, as well as on the exterior grounds near public entrances. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-021",
         "APN": 46724016,
         "File Number": "PP07-021",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Signage Modification ",
         "Application Type": "Exempt ",
         "Application Date": "2/1/07 14:56",
         "Status": "Complete ",
         "Description": "Modifications and additions to existing wayfinding signage at the City of San Jose City Hall public facility, consisting of new attached and detached signage in the interior of City Hall, as well as on the exterior grounds near public entrances. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-021",
         "APN": 46724019,
         "File Number": "PP07-021",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Signage Modification ",
         "Application Type": "Exempt ",
         "Application Date": "2/1/07 14:56",
         "Status": "Complete ",
         "Description": "Modifications and additions to existing wayfinding signage at the City of San Jose City Hall public facility, consisting of new attached and detached signage in the interior of City Hall, as well as on the exterior grounds near public entrances. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-021",
         "APN": 46724020,
         "File Number": "PP07-021",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Signage Modification ",
         "Application Type": "Exempt ",
         "Application Date": "2/1/07 14:56",
         "Status": "Complete ",
         "Description": "Modifications and additions to existing wayfinding signage at the City of San Jose City Hall public facility, consisting of new attached and detached signage in the interior of City Hall, as well as on the exterior grounds near public entrances. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-021",
         "APN": 46724021,
         "File Number": "PP07-021",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Signage Modification ",
         "Application Type": "Exempt ",
         "Application Date": "2/1/07 14:56",
         "Status": "Complete ",
         "Description": "Modifications and additions to existing wayfinding signage at the City of San Jose City Hall public facility, consisting of new attached and detached signage in the interior of City Hall, as well as on the exterior grounds near public entrances. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-021",
         "APN": 46724115,
         "File Number": "PP07-021",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Signage Modification ",
         "Application Type": "Exempt ",
         "Application Date": "2/1/07 14:56",
         "Status": "Complete ",
         "Description": "Modifications and additions to existing wayfinding signage at the City of San Jose City Hall public facility, consisting of new attached and detached signage in the interior of City Hall, as well as on the exterior grounds near public entrances. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-021",
         "APN": 46724117,
         "File Number": "PP07-021",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Signage Modification ",
         "Application Type": "Exempt ",
         "Application Date": "2/1/07 14:56",
         "Status": "Complete ",
         "Description": "Modifications and additions to existing wayfinding signage at the City of San Jose City Hall public facility, consisting of new attached and detached signage in the interior of City Hall, as well as on the exterior grounds near public entrances. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-033",
         "APN": 46721002,
         "File Number": "PP07-033",
         "Address": "95 N 3RD ST SAN JOSE",
         "Project Name": "PP07-033",
         "Application Type": "Exempt ",
         "Application Date": "2/22/07 15:40",
         "Status": "Complete ",
         "Description": "Adoption of a resolution authorizing the City Manager to negotiate and execute a lease agreement with Legacy Partners, Inc. for 50 parking spaces for a term of 65 months at the 3rd Street Garage at the rate established in the City's Master Parking Rate Resolution.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-042",
         "APN": 46723010,
         "File Number": "PP07-042",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Interior Improvements ",
         "Application Type": "Exempt ",
         "Application Date": "3/16/07 16:30",
         "Status": "Complete ",
         "Description": "1) Approximately 70 doors throughout the City Hall Facilities will be retro fitted with automatic opening devices. 2) Public Counter widths and staff work-surface heights will be modified in the cashering area of the Customer Service Center to address various ergonomic issues. In addition, various other minor modifications to the work spaces in this area will be done to improve ergonomics. Also a support structure will be added to this space for hanging studio lighting and backdrop curtains",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-042",
         "APN": 46723011,
         "File Number": "PP07-042",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Interior Improvements ",
         "Application Type": "Exempt ",
         "Application Date": "3/16/07 16:30",
         "Status": "Complete ",
         "Description": "1) Approximately 70 doors throughout the City Hall Facilities will be retro fitted with automatic opening devices. 2) Public Counter widths and staff work-surface heights will be modified in the cashering area of the Customer Service Center to address various ergonomic issues. In addition, various other minor modifications to the work spaces in this area will be done to improve ergonomics. Also a support structure will be added to this space for hanging studio lighting and backdrop curtains",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-042",
         "APN": 46723013,
         "File Number": "PP07-042",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Interior Improvements ",
         "Application Type": "Exempt ",
         "Application Date": "3/16/07 16:30",
         "Status": "Complete ",
         "Description": "1) Approximately 70 doors throughout the City Hall Facilities will be retro fitted with automatic opening devices. 2) Public Counter widths and staff work-surface heights will be modified in the cashering area of the Customer Service Center to address various ergonomic issues. In addition, various other minor modifications to the work spaces in this area will be done to improve ergonomics. Also a support structure will be added to this space for hanging studio lighting and backdrop curtains",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-042",
         "APN": 46723017,
         "File Number": "PP07-042",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Interior Improvements ",
         "Application Type": "Exempt ",
         "Application Date": "3/16/07 16:30",
         "Status": "Complete ",
         "Description": "1) Approximately 70 doors throughout the City Hall Facilities will be retro fitted with automatic opening devices. 2) Public Counter widths and staff work-surface heights will be modified in the cashering area of the Customer Service Center to address various ergonomic issues. In addition, various other minor modifications to the work spaces in this area will be done to improve ergonomics. Also a support structure will be added to this space for hanging studio lighting and backdrop curtains",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-042",
         "APN": 46723018,
         "File Number": "PP07-042",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Interior Improvements ",
         "Application Type": "Exempt ",
         "Application Date": "3/16/07 16:30",
         "Status": "Complete ",
         "Description": "1) Approximately 70 doors throughout the City Hall Facilities will be retro fitted with automatic opening devices. 2) Public Counter widths and staff work-surface heights will be modified in the cashering area of the Customer Service Center to address various ergonomic issues. In addition, various other minor modifications to the work spaces in this area will be done to improve ergonomics. Also a support structure will be added to this space for hanging studio lighting and backdrop curtains",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-042",
         "APN": 46723019,
         "File Number": "PP07-042",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Interior Improvements ",
         "Application Type": "Exempt ",
         "Application Date": "3/16/07 16:30",
         "Status": "Complete ",
         "Description": "1) Approximately 70 doors throughout the City Hall Facilities will be retro fitted with automatic opening devices. 2) Public Counter widths and staff work-surface heights will be modified in the cashering area of the Customer Service Center to address various ergonomic issues. In addition, various other minor modifications to the work spaces in this area will be done to improve ergonomics. Also a support structure will be added to this space for hanging studio lighting and backdrop curtains",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-042",
         "APN": 46723021,
         "File Number": "PP07-042",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Interior Improvements ",
         "Application Type": "Exempt ",
         "Application Date": "3/16/07 16:30",
         "Status": "Complete ",
         "Description": "1) Approximately 70 doors throughout the City Hall Facilities will be retro fitted with automatic opening devices. 2) Public Counter widths and staff work-surface heights will be modified in the cashering area of the Customer Service Center to address various ergonomic issues. In addition, various other minor modifications to the work spaces in this area will be done to improve ergonomics. Also a support structure will be added to this space for hanging studio lighting and backdrop curtains",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-042",
         "APN": 46723022,
         "File Number": "PP07-042",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Interior Improvements ",
         "Application Type": "Exempt ",
         "Application Date": "3/16/07 16:30",
         "Status": "Complete ",
         "Description": "1) Approximately 70 doors throughout the City Hall Facilities will be retro fitted with automatic opening devices. 2) Public Counter widths and staff work-surface heights will be modified in the cashering area of the Customer Service Center to address various ergonomic issues. In addition, various other minor modifications to the work spaces in this area will be done to improve ergonomics. Also a support structure will be added to this space for hanging studio lighting and backdrop curtains",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-042",
         "APN": 46723076,
         "File Number": "PP07-042",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Interior Improvements ",
         "Application Type": "Exempt ",
         "Application Date": "3/16/07 16:30",
         "Status": "Complete ",
         "Description": "1) Approximately 70 doors throughout the City Hall Facilities will be retro fitted with automatic opening devices. 2) Public Counter widths and staff work-surface heights will be modified in the cashering area of the Customer Service Center to address various ergonomic issues. In addition, various other minor modifications to the work spaces in this area will be done to improve ergonomics. Also a support structure will be added to this space for hanging studio lighting and backdrop curtains",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-042",
         "APN": 46724001,
         "File Number": "PP07-042",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Interior Improvements ",
         "Application Type": "Exempt ",
         "Application Date": "3/16/07 16:30",
         "Status": "Complete ",
         "Description": "1) Approximately 70 doors throughout the City Hall Facilities will be retro fitted with automatic opening devices. 2) Public Counter widths and staff work-surface heights will be modified in the cashering area of the Customer Service Center to address various ergonomic issues. In addition, various other minor modifications to the work spaces in this area will be done to improve ergonomics. Also a support structure will be added to this space for hanging studio lighting and backdrop curtains",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-042",
         "APN": 46724002,
         "File Number": "PP07-042",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Interior Improvements ",
         "Application Type": "Exempt ",
         "Application Date": "3/16/07 16:30",
         "Status": "Complete ",
         "Description": "1) Approximately 70 doors throughout the City Hall Facilities will be retro fitted with automatic opening devices. 2) Public Counter widths and staff work-surface heights will be modified in the cashering area of the Customer Service Center to address various ergonomic issues. In addition, various other minor modifications to the work spaces in this area will be done to improve ergonomics. Also a support structure will be added to this space for hanging studio lighting and backdrop curtains",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-042",
         "APN": 46724003,
         "File Number": "PP07-042",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Interior Improvements ",
         "Application Type": "Exempt ",
         "Application Date": "3/16/07 16:30",
         "Status": "Complete ",
         "Description": "1) Approximately 70 doors throughout the City Hall Facilities will be retro fitted with automatic opening devices. 2) Public Counter widths and staff work-surface heights will be modified in the cashering area of the Customer Service Center to address various ergonomic issues. In addition, various other minor modifications to the work spaces in this area will be done to improve ergonomics. Also a support structure will be added to this space for hanging studio lighting and backdrop curtains",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-042",
         "APN": 46724014,
         "File Number": "PP07-042",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Interior Improvements ",
         "Application Type": "Exempt ",
         "Application Date": "3/16/07 16:30",
         "Status": "Complete ",
         "Description": "1) Approximately 70 doors throughout the City Hall Facilities will be retro fitted with automatic opening devices. 2) Public Counter widths and staff work-surface heights will be modified in the cashering area of the Customer Service Center to address various ergonomic issues. In addition, various other minor modifications to the work spaces in this area will be done to improve ergonomics. Also a support structure will be added to this space for hanging studio lighting and backdrop curtains",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-042",
         "APN": 46724015,
         "File Number": "PP07-042",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Interior Improvements ",
         "Application Type": "Exempt ",
         "Application Date": "3/16/07 16:30",
         "Status": "Complete ",
         "Description": "1) Approximately 70 doors throughout the City Hall Facilities will be retro fitted with automatic opening devices. 2) Public Counter widths and staff work-surface heights will be modified in the cashering area of the Customer Service Center to address various ergonomic issues. In addition, various other minor modifications to the work spaces in this area will be done to improve ergonomics. Also a support structure will be added to this space for hanging studio lighting and backdrop curtains",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-042",
         "APN": 46724016,
         "File Number": "PP07-042",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Interior Improvements ",
         "Application Type": "Exempt ",
         "Application Date": "3/16/07 16:30",
         "Status": "Complete ",
         "Description": "1) Approximately 70 doors throughout the City Hall Facilities will be retro fitted with automatic opening devices. 2) Public Counter widths and staff work-surface heights will be modified in the cashering area of the Customer Service Center to address various ergonomic issues. In addition, various other minor modifications to the work spaces in this area will be done to improve ergonomics. Also a support structure will be added to this space for hanging studio lighting and backdrop curtains",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-042",
         "APN": 46724019,
         "File Number": "PP07-042",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Interior Improvements ",
         "Application Type": "Exempt ",
         "Application Date": "3/16/07 16:30",
         "Status": "Complete ",
         "Description": "1) Approximately 70 doors throughout the City Hall Facilities will be retro fitted with automatic opening devices. 2) Public Counter widths and staff work-surface heights will be modified in the cashering area of the Customer Service Center to address various ergonomic issues. In addition, various other minor modifications to the work spaces in this area will be done to improve ergonomics. Also a support structure will be added to this space for hanging studio lighting and backdrop curtains",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-042",
         "APN": 46724020,
         "File Number": "PP07-042",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Interior Improvements ",
         "Application Type": "Exempt ",
         "Application Date": "3/16/07 16:30",
         "Status": "Complete ",
         "Description": "1) Approximately 70 doors throughout the City Hall Facilities will be retro fitted with automatic opening devices. 2) Public Counter widths and staff work-surface heights will be modified in the cashering area of the Customer Service Center to address various ergonomic issues. In addition, various other minor modifications to the work spaces in this area will be done to improve ergonomics. Also a support structure will be added to this space for hanging studio lighting and backdrop curtains",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-042",
         "APN": 46724021,
         "File Number": "PP07-042",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Interior Improvements ",
         "Application Type": "Exempt ",
         "Application Date": "3/16/07 16:30",
         "Status": "Complete ",
         "Description": "1) Approximately 70 doors throughout the City Hall Facilities will be retro fitted with automatic opening devices. 2) Public Counter widths and staff work-surface heights will be modified in the cashering area of the Customer Service Center to address various ergonomic issues. In addition, various other minor modifications to the work spaces in this area will be done to improve ergonomics. Also a support structure will be added to this space for hanging studio lighting and backdrop curtains",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-042",
         "APN": 46724115,
         "File Number": "PP07-042",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Interior Improvements ",
         "Application Type": "Exempt ",
         "Application Date": "3/16/07 16:30",
         "Status": "Complete ",
         "Description": "1) Approximately 70 doors throughout the City Hall Facilities will be retro fitted with automatic opening devices. 2) Public Counter widths and staff work-surface heights will be modified in the cashering area of the Customer Service Center to address various ergonomic issues. In addition, various other minor modifications to the work spaces in this area will be done to improve ergonomics. Also a support structure will be added to this space for hanging studio lighting and backdrop curtains",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-042",
         "APN": 46724117,
         "File Number": "PP07-042",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Interior Improvements ",
         "Application Type": "Exempt ",
         "Application Date": "3/16/07 16:30",
         "Status": "Complete ",
         "Description": "1) Approximately 70 doors throughout the City Hall Facilities will be retro fitted with automatic opening devices. 2) Public Counter widths and staff work-surface heights will be modified in the cashering area of the Customer Service Center to address various ergonomic issues. In addition, various other minor modifications to the work spaces in this area will be done to improve ergonomics. Also a support structure will be added to this space for hanging studio lighting and backdrop curtains",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-060",
         "APN": 46723010,
         "File Number": "PP07-060",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Interior Improvements ",
         "Application Type": "Exempt ",
         "Application Date": "3/29/07 14:01",
         "Status": "Complete ",
         "Description": "Installation of glass panels, each approximately 4 feet 6 inches wide by 2 feet 8 inches high, onto the guardrails throughout the City Hall facility (interior and exterior)",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-060",
         "APN": 46723011,
         "File Number": "PP07-060",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Interior Improvements ",
         "Application Type": "Exempt ",
         "Application Date": "3/29/07 14:01",
         "Status": "Complete ",
         "Description": "Installation of glass panels, each approximately 4 feet 6 inches wide by 2 feet 8 inches high, onto the guardrails throughout the City Hall facility (interior and exterior)",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-060",
         "APN": 46723013,
         "File Number": "PP07-060",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Interior Improvements ",
         "Application Type": "Exempt ",
         "Application Date": "3/29/07 14:01",
         "Status": "Complete ",
         "Description": "Installation of glass panels, each approximately 4 feet 6 inches wide by 2 feet 8 inches high, onto the guardrails throughout the City Hall facility (interior and exterior)",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-060",
         "APN": 46723017,
         "File Number": "PP07-060",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Interior Improvements ",
         "Application Type": "Exempt ",
         "Application Date": "3/29/07 14:01",
         "Status": "Complete ",
         "Description": "Installation of glass panels, each approximately 4 feet 6 inches wide by 2 feet 8 inches high, onto the guardrails throughout the City Hall facility (interior and exterior)",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-060",
         "APN": 46723018,
         "File Number": "PP07-060",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Interior Improvements ",
         "Application Type": "Exempt ",
         "Application Date": "3/29/07 14:01",
         "Status": "Complete ",
         "Description": "Installation of glass panels, each approximately 4 feet 6 inches wide by 2 feet 8 inches high, onto the guardrails throughout the City Hall facility (interior and exterior)",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-060",
         "APN": 46723019,
         "File Number": "PP07-060",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Interior Improvements ",
         "Application Type": "Exempt ",
         "Application Date": "3/29/07 14:01",
         "Status": "Complete ",
         "Description": "Installation of glass panels, each approximately 4 feet 6 inches wide by 2 feet 8 inches high, onto the guardrails throughout the City Hall facility (interior and exterior)",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-060",
         "APN": 46723021,
         "File Number": "PP07-060",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Interior Improvements ",
         "Application Type": "Exempt ",
         "Application Date": "3/29/07 14:01",
         "Status": "Complete ",
         "Description": "Installation of glass panels, each approximately 4 feet 6 inches wide by 2 feet 8 inches high, onto the guardrails throughout the City Hall facility (interior and exterior)",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-060",
         "APN": 46723022,
         "File Number": "PP07-060",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Interior Improvements ",
         "Application Type": "Exempt ",
         "Application Date": "3/29/07 14:01",
         "Status": "Complete ",
         "Description": "Installation of glass panels, each approximately 4 feet 6 inches wide by 2 feet 8 inches high, onto the guardrails throughout the City Hall facility (interior and exterior)",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-060",
         "APN": 46723076,
         "File Number": "PP07-060",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Interior Improvements ",
         "Application Type": "Exempt ",
         "Application Date": "3/29/07 14:01",
         "Status": "Complete ",
         "Description": "Installation of glass panels, each approximately 4 feet 6 inches wide by 2 feet 8 inches high, onto the guardrails throughout the City Hall facility (interior and exterior)",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-060",
         "APN": 46724001,
         "File Number": "PP07-060",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Interior Improvements ",
         "Application Type": "Exempt ",
         "Application Date": "3/29/07 14:01",
         "Status": "Complete ",
         "Description": "Installation of glass panels, each approximately 4 feet 6 inches wide by 2 feet 8 inches high, onto the guardrails throughout the City Hall facility (interior and exterior)",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-060",
         "APN": 46724002,
         "File Number": "PP07-060",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Interior Improvements ",
         "Application Type": "Exempt ",
         "Application Date": "3/29/07 14:01",
         "Status": "Complete ",
         "Description": "Installation of glass panels, each approximately 4 feet 6 inches wide by 2 feet 8 inches high, onto the guardrails throughout the City Hall facility (interior and exterior)",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-060",
         "APN": 46724003,
         "File Number": "PP07-060",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Interior Improvements ",
         "Application Type": "Exempt ",
         "Application Date": "3/29/07 14:01",
         "Status": "Complete ",
         "Description": "Installation of glass panels, each approximately 4 feet 6 inches wide by 2 feet 8 inches high, onto the guardrails throughout the City Hall facility (interior and exterior)",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-060",
         "APN": 46724014,
         "File Number": "PP07-060",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Interior Improvements ",
         "Application Type": "Exempt ",
         "Application Date": "3/29/07 14:01",
         "Status": "Complete ",
         "Description": "Installation of glass panels, each approximately 4 feet 6 inches wide by 2 feet 8 inches high, onto the guardrails throughout the City Hall facility (interior and exterior)",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-060",
         "APN": 46724015,
         "File Number": "PP07-060",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Interior Improvements ",
         "Application Type": "Exempt ",
         "Application Date": "3/29/07 14:01",
         "Status": "Complete ",
         "Description": "Installation of glass panels, each approximately 4 feet 6 inches wide by 2 feet 8 inches high, onto the guardrails throughout the City Hall facility (interior and exterior)",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-060",
         "APN": 46724016,
         "File Number": "PP07-060",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Interior Improvements ",
         "Application Type": "Exempt ",
         "Application Date": "3/29/07 14:01",
         "Status": "Complete ",
         "Description": "Installation of glass panels, each approximately 4 feet 6 inches wide by 2 feet 8 inches high, onto the guardrails throughout the City Hall facility (interior and exterior)",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-060",
         "APN": 46724019,
         "File Number": "PP07-060",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Interior Improvements ",
         "Application Type": "Exempt ",
         "Application Date": "3/29/07 14:01",
         "Status": "Complete ",
         "Description": "Installation of glass panels, each approximately 4 feet 6 inches wide by 2 feet 8 inches high, onto the guardrails throughout the City Hall facility (interior and exterior)",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-060",
         "APN": 46724020,
         "File Number": "PP07-060",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Interior Improvements ",
         "Application Type": "Exempt ",
         "Application Date": "3/29/07 14:01",
         "Status": "Complete ",
         "Description": "Installation of glass panels, each approximately 4 feet 6 inches wide by 2 feet 8 inches high, onto the guardrails throughout the City Hall facility (interior and exterior)",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-060",
         "APN": 46724021,
         "File Number": "PP07-060",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Interior Improvements ",
         "Application Type": "Exempt ",
         "Application Date": "3/29/07 14:01",
         "Status": "Complete ",
         "Description": "Installation of glass panels, each approximately 4 feet 6 inches wide by 2 feet 8 inches high, onto the guardrails throughout the City Hall facility (interior and exterior)",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-060",
         "APN": 46724115,
         "File Number": "PP07-060",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Interior Improvements ",
         "Application Type": "Exempt ",
         "Application Date": "3/29/07 14:01",
         "Status": "Complete ",
         "Description": "Installation of glass panels, each approximately 4 feet 6 inches wide by 2 feet 8 inches high, onto the guardrails throughout the City Hall facility (interior and exterior)",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-060",
         "APN": 46724117,
         "File Number": "PP07-060",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "City Hall Interior Improvements ",
         "Application Type": "Exempt ",
         "Application Date": "3/29/07 14:01",
         "Status": "Complete ",
         "Description": "Installation of glass panels, each approximately 4 feet 6 inches wide by 2 feet 8 inches high, onto the guardrails throughout the City Hall facility (interior and exterior)",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-082",
         "APN": 46746097,
         "File Number": "PP07-082",
         "Address": "280 S 2ND ST SAN JOSE",
         "Project Name": "PP07-082",
         "Application Type": "Exempt ",
         "Application Date": "4/24/07 8:18",
         "Status": "Complete ",
         "Description": "Approval of a nondisturbance and consent agreement to the fourth amendment to lease for FEDEX Kinko's Office and Print Services, INC.  ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-084",
         "APN": 25934053,
         "File Number": "PP07-084",
         "Address": "111 N MARKET ST Bldg 1 SAN JOSE",
         "Project Name": "PP07-084",
         "Application Type": "Exempt ",
         "Application Date": "4/24/07 11:00",
         "Status": "Complete ",
         "Description": "Facade improvement grant for the building located at 111 N.Market and 111 W. St.John Streets.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-092",
         "APN": 46722121,
         "File Number": "PP07-092",
         "Address": "35 S 2ND ST SAN JOSE",
         "Project Name": "PP07-092",
         "Application Type": "Exempt ",
         "Application Date": "5/1/07 8:44",
         "Status": "Complete ",
         "Description": "Demolition of the kiosk, capping utilities, removal of bollards, replace paving and restriping of surface lot, installation of precast wall. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-113",
         "APN": 46723100,
         "File Number": "PP07-113",
         "Address": "88 S 4TH ST SAN JOSE",
         "Project Name": "PP07-113",
         "Application Type": "Exempt ",
         "Application Date": "5/21/07 11:58",
         "Status": "Complete ",
         "Description": "Amendment to the property use agreement with San Jose Downtown Association for the retail space at 88 South Fourth Street, Suite 130.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-113",
         "APN": 46723101,
         "File Number": "PP07-113",
         "Address": "88 S 4TH ST SAN JOSE",
         "Project Name": "PP07-113",
         "Application Type": "Exempt ",
         "Application Date": "5/21/07 11:58",
         "Status": "Complete ",
         "Description": "Amendment to the property use agreement with San Jose Downtown Association for the retail space at 88 South Fourth Street, Suite 130.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-152",
         "APN": 46747053,
         "File Number": "PP07-152",
         "Address": "487 S 4TH ST SAN JOSE",
         "Project Name": "PP07-152",
         "Application Type": "Exempt ",
         "Application Date": "7/27/07 11:47",
         "Status": "Complete ",
         "Description": "Facade improvements program agreement for buildings located at 487 South Fourth Street",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-153",
         "APN": 26429107,
         "File Number": "PP07-153",
         "Address": "302 S MARKET ST SAN JOSE",
         "Project Name": "PP07-153",
         "Application Type": "Exempt ",
         "Application Date": "7/27/07 14:05",
         "Status": "Complete ",
         "Description": "Facade Improvement Program agreement with Sainte Claire Hotel, LLC, for the Sainte Claire Hotel to allow a new marquee (replacing an existing non-historic canopy awning) and installation of exterior lighting on a City Landmark structure (Sainte Claire Hotel, HL81-018)",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-187",
         "APN": 25956002,
         "File Number": "PP07-187",
         "Address": "170 S MARKET ST SAN JOSE",
         "Project Name": "PP07-187",
         "Application Type": "Exempt ",
         "Application Date": "9/6/07 10:21",
         "Status": "Complete ",
         "Description": "Amendment to the lease agreement with Bijan Bakery Inc. for landlord and tenant improvements ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-187",
         "APN": 25956003,
         "File Number": "PP07-187",
         "Address": "170 S MARKET ST SAN JOSE",
         "Project Name": "PP07-187",
         "Application Type": "Exempt ",
         "Application Date": "9/6/07 10:21",
         "Status": "Complete ",
         "Description": "Amendment to the lease agreement with Bijan Bakery Inc. for landlord and tenant improvements ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-197",
         "APN": 25932082,
         "File Number": "PP07-197",
         "Address": "101 N SAN PEDRO ST SAN JOSE",
         "Project Name": "PP07-197",
         "Application Type": "Exempt ",
         "Application Date": "9/18/07 13:43",
         "Status": "Complete ",
         "Description": "Award a contract for Fallon House Phase II Improvements. Improvements shall conform to those approved in the Planning and Building permit numbers as indicated below. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-252",
         "APN": 25934018,
         "File Number": "PP07-252",
         "Address": "81 W SANTA CLARA ST SAN JOSE",
         "Project Name": "PP07-252",
         "Application Type": "Exempt ",
         "Application Date": "11/7/07 11:34",
         "Status": "Complete ",
         "Description": "Facade Improvement Grant for the building located at 81 West Santa Clara Street",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-274",
         "APN": 26427082,
         "File Number": "PP07-274",
         "Address": "180 WOZ WY SAN JOSE",
         "Project Name": "PP07-274 Children's Discovery Museum",
         "Application Type": "Exempt ",
         "Application Date": "12/12/07 10:25",
         "Status": "Complete ",
         "Description": "Construction Contract for the HVAC upgrades at the Children''s Discovery Museum. The project includes replacement of HVAC system / equipment in the original location on the roof, basement and outdoor service yard; removal of one air compressor in the basement and upgrading the exisiting computer management system related to the HVAC controls. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-274",
         "APN": 26427087,
         "File Number": "PP07-274",
         "Address": "180 WOZ WY SAN JOSE",
         "Project Name": "PP07-274 Children's Discovery Museum",
         "Application Type": "Exempt ",
         "Application Date": "12/12/07 10:25",
         "Status": "Complete ",
         "Description": "Construction Contract for the HVAC upgrades at the Children''s Discovery Museum. The project includes replacement of HVAC system / equipment in the original location on the roof, basement and outdoor service yard; removal of one air compressor in the basement and upgrading the exisiting computer management system related to the HVAC controls. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP07-274",
         "APN": 26427088,
         "File Number": "PP07-274",
         "Address": "180 WOZ WY SAN JOSE",
         "Project Name": "PP07-274 Children's Discovery Museum",
         "Application Type": "Exempt ",
         "Application Date": "12/12/07 10:25",
         "Status": "Complete ",
         "Description": "Construction Contract for the HVAC upgrades at the Children''s Discovery Museum. The project includes replacement of HVAC system / equipment in the original location on the roof, basement and outdoor service yard; removal of one air compressor in the basement and upgrading the exisiting computer management system related to the HVAC controls. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "PP08-039",
         "APN": 25942023,
         "File Number": "PP08-039",
         "Address": "180 PARK AV SAN JOSE",
         "Project Name": "PP08-039",
         "Application Type": "Exempt ",
         "Application Date": "3/13/08 11:03",
         "Status": "Complete ",
         "Description": "Installation of solar panels on the Parkside Hall Roof and an electrical equipment (inverter) on the Tech Museum roof deck. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2008
      },
      {
         "PERMITID": "PP08-100",
         "APN": 25941065,
         "File Number": "PP08-100",
         "Address": "194 S MARKET ST SAN JOSE",
         "Project Name": "PP08-100",
         "Application Type": "Exempt ",
         "Application Date": "5/27/08 10:24",
         "Status": "Complete ",
         "Description": "Agreement with San Jose Downtown Association for Downtown Ice Rink in the Circle of Palms through February 2011. The agreement includes construction and deconstuction of the ice rink.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2008
      },
      {
         "PERMITID": "PP08-152",
         "APN": 25942023,
         "File Number": "PP08-152",
         "Address": "201 S MARKET ST SAN JOSE",
         "Project Name": "PP08-152",
         "Application Type": "Exempt ",
         "Application Date": "7/18/08 9:43",
         "Status": "Complete ",
         "Description": "Installation of two new Variable Frequency Devices (VFD) on each of two existing McQuay 218 Ton Centrifugal Chillers model PEH063 at the Tech Museum to provide energy saving retrofit to the existing air handling units which also includes the removal and disposal of existing motors and the programming of existing MicroTech 200 software panels to eliminate manual changeover between chillers and recommissioning of each cooler and complete start up report. The VFD equipments will be surface mounted to the existing chillers and all electrical wiring shall be installed inside a rigid conduit piping and shall be surface mounted as well. No trenching or demolition of equipment is involved.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2008
      },
      {
         "PERMITID": "PP08-220",
         "APN": 26411112,
         "File Number": "PP08-220",
         "Address": "802 W HOME ST SAN JOSE",
         "Project Name": "PP08-220 - Land Acquisition",
         "Application Type": "Exempt ",
         "Application Date": "9/19/08 11:39",
         "Status": "Complete ",
         "Description": "Land acquisition of an approximately 0.9-acre parcel for future park uses. Additional CEQA review will be done when park plans are prepared.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2008
      },
      {
         "PERMITID": "PP08-238",
         "APN": 26427082,
         "File Number": "PP08-238",
         "Address": "180 WOZ WY SAN JOSE",
         "Project Name": "PP08-238",
         "Application Type": "Exempt ",
         "Application Date": "10/8/08 12:51",
         "Status": "Complete ",
         "Description": "Removal and replacement of existing hot water boiler with new energy efficient and low NOx emission boiler, and repair of existing B&G Series centrifugal pump ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2008
      },
      {
         "PERMITID": "PP08-238",
         "APN": 26427087,
         "File Number": "PP08-238",
         "Address": "180 WOZ WY SAN JOSE",
         "Project Name": "PP08-238",
         "Application Type": "Exempt ",
         "Application Date": "10/8/08 12:51",
         "Status": "Complete ",
         "Description": "Removal and replacement of existing hot water boiler with new energy efficient and low NOx emission boiler, and repair of existing B&G Series centrifugal pump ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2008
      },
      {
         "PERMITID": "PP08-238",
         "APN": 26427088,
         "File Number": "PP08-238",
         "Address": "180 WOZ WY SAN JOSE",
         "Project Name": "PP08-238",
         "Application Type": "Exempt ",
         "Application Date": "10/8/08 12:51",
         "Status": "Complete ",
         "Description": "Removal and replacement of existing hot water boiler with new energy efficient and low NOx emission boiler, and repair of existing B&G Series centrifugal pump ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2008
      },
      {
         "PERMITID": "PP08-269",
         "APN": 46722141,
         "File Number": "PP08-269",
         "Address": "150 S 1ST ST SAN JOSE",
         "Project Name": "PP08-269",
         "Application Type": "Exempt ",
         "Application Date": "11/21/08 13:31",
         "Status": "Complete ",
         "Description": "Adopt a resolution approving the Settlement Agreement and Release, which incorporates a Parking Operations Plan for the Pavilion Garage, with GIP Fairmont, LLC and 150 South First Street, LLC.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2008
      },
      {
         "PERMITID": "PP09-013",
         "APN": 25956002,
         "File Number": "PP09-013",
         "Address": "170 S MARKET ST SAN JOSE",
         "Project Name": "PP09-013",
         "Application Type": "Exempt ",
         "Application Date": "1/22/09 11:37",
         "Status": "Complete ",
         "Description": "Approval of first amendment to a lease agreement with Mesa SoFA Partners, LLC. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PP09-108",
         "APN": 46720017,
         "File Number": "PP09-108",
         "Address": "70 N 4TH ST SAN JOSE",
         "Project Name": "PP09-108",
         "Application Type": "Exempt ",
         "Application Date": "5/8/09 12:46",
         "Status": "Complete ",
         "Description": "City Council approval of a consultant agreement for design services for the Traffic incident Management Center (TiMC) and Technology Training Center, from the date of execution to June 30, 2011, in an amount not to exceed $415,000; and the build-out of tenant improvements for the currently vacant ground level commercial space in the existing City of San Jose employee parking garage building to accommodate the two Centers.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PP09-108",
         "APN": 46720085,
         "File Number": "PP09-108",
         "Address": "70 N 4TH ST SAN JOSE",
         "Project Name": "PP09-108",
         "Application Type": "Exempt ",
         "Application Date": "5/8/09 12:46",
         "Status": "Complete ",
         "Description": "City Council approval of a consultant agreement for design services for the Traffic incident Management Center (TiMC) and Technology Training Center, from the date of execution to June 30, 2011, in an amount not to exceed $415,000; and the build-out of tenant improvements for the currently vacant ground level commercial space in the existing City of San Jose employee parking garage building to accommodate the two Centers.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PP09-153",
         "APN": 46723089,
         "File Number": "PP09-153",
         "Address": "100 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP09-153",
         "Application Type": "Exempt ",
         "Application Date": "7/24/09 13:39",
         "Status": "Complete ",
         "Description": "Master lease agreement with RSTP investments, LLC to house the Software Business Cluster , Environmental Business Cluster, U.S.Market Access Center, SD Forum and San Jose Entrepreneur Center at an exisiting office building located at 100 E. Santa Clara St.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PP09-205",
         "APN": 46723010,
         "File Number": "PP09-205",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP09-205 - VOID",
         "Application Type": "Exempt ",
         "Application Date": "11/18/09 10:58",
         "Status": "Complete ",
         "Description": "Installation of mechanical equipment. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PP09-205",
         "APN": 46723011,
         "File Number": "PP09-205",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP09-205 - VOID",
         "Application Type": "Exempt ",
         "Application Date": "11/18/09 10:58",
         "Status": "Complete ",
         "Description": "Installation of mechanical equipment. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PP09-205",
         "APN": 46723013,
         "File Number": "PP09-205",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP09-205 - VOID",
         "Application Type": "Exempt ",
         "Application Date": "11/18/09 10:58",
         "Status": "Complete ",
         "Description": "Installation of mechanical equipment. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PP09-205",
         "APN": 46723017,
         "File Number": "PP09-205",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP09-205 - VOID",
         "Application Type": "Exempt ",
         "Application Date": "11/18/09 10:58",
         "Status": "Complete ",
         "Description": "Installation of mechanical equipment. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PP09-205",
         "APN": 46723018,
         "File Number": "PP09-205",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP09-205 - VOID",
         "Application Type": "Exempt ",
         "Application Date": "11/18/09 10:58",
         "Status": "Complete ",
         "Description": "Installation of mechanical equipment. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PP09-205",
         "APN": 46723019,
         "File Number": "PP09-205",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP09-205 - VOID",
         "Application Type": "Exempt ",
         "Application Date": "11/18/09 10:58",
         "Status": "Complete ",
         "Description": "Installation of mechanical equipment. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PP09-205",
         "APN": 46723021,
         "File Number": "PP09-205",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP09-205 - VOID",
         "Application Type": "Exempt ",
         "Application Date": "11/18/09 10:58",
         "Status": "Complete ",
         "Description": "Installation of mechanical equipment. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PP09-205",
         "APN": 46723022,
         "File Number": "PP09-205",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP09-205 - VOID",
         "Application Type": "Exempt ",
         "Application Date": "11/18/09 10:58",
         "Status": "Complete ",
         "Description": "Installation of mechanical equipment. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PP09-205",
         "APN": 46723076,
         "File Number": "PP09-205",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP09-205 - VOID",
         "Application Type": "Exempt ",
         "Application Date": "11/18/09 10:58",
         "Status": "Complete ",
         "Description": "Installation of mechanical equipment. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PP09-205",
         "APN": 46724001,
         "File Number": "PP09-205",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP09-205 - VOID",
         "Application Type": "Exempt ",
         "Application Date": "11/18/09 10:58",
         "Status": "Complete ",
         "Description": "Installation of mechanical equipment. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PP09-205",
         "APN": 46724002,
         "File Number": "PP09-205",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP09-205 - VOID",
         "Application Type": "Exempt ",
         "Application Date": "11/18/09 10:58",
         "Status": "Complete ",
         "Description": "Installation of mechanical equipment. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PP09-205",
         "APN": 46724003,
         "File Number": "PP09-205",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP09-205 - VOID",
         "Application Type": "Exempt ",
         "Application Date": "11/18/09 10:58",
         "Status": "Complete ",
         "Description": "Installation of mechanical equipment. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PP09-205",
         "APN": 46724014,
         "File Number": "PP09-205",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP09-205 - VOID",
         "Application Type": "Exempt ",
         "Application Date": "11/18/09 10:58",
         "Status": "Complete ",
         "Description": "Installation of mechanical equipment. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PP09-205",
         "APN": 46724015,
         "File Number": "PP09-205",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP09-205 - VOID",
         "Application Type": "Exempt ",
         "Application Date": "11/18/09 10:58",
         "Status": "Complete ",
         "Description": "Installation of mechanical equipment. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PP09-205",
         "APN": 46724016,
         "File Number": "PP09-205",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP09-205 - VOID",
         "Application Type": "Exempt ",
         "Application Date": "11/18/09 10:58",
         "Status": "Complete ",
         "Description": "Installation of mechanical equipment. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PP09-205",
         "APN": 46724019,
         "File Number": "PP09-205",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP09-205 - VOID",
         "Application Type": "Exempt ",
         "Application Date": "11/18/09 10:58",
         "Status": "Complete ",
         "Description": "Installation of mechanical equipment. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PP09-205",
         "APN": 46724020,
         "File Number": "PP09-205",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP09-205 - VOID",
         "Application Type": "Exempt ",
         "Application Date": "11/18/09 10:58",
         "Status": "Complete ",
         "Description": "Installation of mechanical equipment. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PP09-205",
         "APN": 46724021,
         "File Number": "PP09-205",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP09-205 - VOID",
         "Application Type": "Exempt ",
         "Application Date": "11/18/09 10:58",
         "Status": "Complete ",
         "Description": "Installation of mechanical equipment. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PP09-205",
         "APN": 46724115,
         "File Number": "PP09-205",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP09-205 - VOID",
         "Application Type": "Exempt ",
         "Application Date": "11/18/09 10:58",
         "Status": "Complete ",
         "Description": "Installation of mechanical equipment. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PP09-205",
         "APN": 46724117,
         "File Number": "PP09-205",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP09-205 - VOID",
         "Application Type": "Exempt ",
         "Application Date": "11/18/09 10:58",
         "Status": "Complete ",
         "Description": "Installation of mechanical equipment. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PP09-217",
         "APN": 25934039,
         "File Number": "PP09-217",
         "Address": "45 N MARKET ST SAN JOSE",
         "Project Name": "PP09-217",
         "Application Type": "Exempt ",
         "Application Date": "12/18/09 9:40",
         "Status": "Complete ",
         "Description": "Installation of up to 43 electric vehicle chargers at eight existing City-owned downtown parking garages and for a grant application to the California Energy Commission",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PP09-217",
         "APN": 46720017,
         "File Number": "PP09-217",
         "Address": "45 N MARKET ST SAN JOSE",
         "Project Name": "PP09-217",
         "Application Type": "Exempt ",
         "Application Date": "12/18/09 9:40",
         "Status": "Complete ",
         "Description": "Installation of up to 43 electric vehicle chargers at eight existing City-owned downtown parking garages and for a grant application to the California Energy Commission",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PP09-217",
         "APN": 46721002,
         "File Number": "PP09-217",
         "Address": "45 N MARKET ST SAN JOSE",
         "Project Name": "PP09-217",
         "Application Type": "Exempt ",
         "Application Date": "12/18/09 9:40",
         "Status": "Complete ",
         "Description": "Installation of up to 43 electric vehicle chargers at eight existing City-owned downtown parking garages and for a grant application to the California Energy Commission",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PP09-217",
         "APN": 46746097,
         "File Number": "PP09-217",
         "Address": "45 N MARKET ST SAN JOSE",
         "Project Name": "PP09-217",
         "Application Type": "Exempt ",
         "Application Date": "12/18/09 9:40",
         "Status": "Complete ",
         "Description": "Installation of up to 43 electric vehicle chargers at eight existing City-owned downtown parking garages and for a grant application to the California Energy Commission",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PP10-015",
         "APN": 47227106,
         "File Number": "PP10-015",
         "Address": "0 COLEMAN AV SAN JOSE",
         "Project Name": "PP10-015",
         "Application Type": "Exempt ",
         "Application Date": "2/1/10 8:49",
         "Status": "Complete ",
         "Description": "Sale of two surplus vacant City-owned remnant properties to adjacent owners or others ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2010
      },
      {
         "PERMITID": "PP10-083",
         "APN": 25934039,
         "File Number": "PP10-083",
         "Address": "45 N MARKET ST SAN JOSE",
         "Project Name": "PP10-083",
         "Application Type": "Exempt ",
         "Application Date": "4/22/10 14:30",
         "Status": "Complete ",
         "Description": "Sale of City-owned property currently used as a parking garage with approximately 1,393 parking spaces.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2010
      },
      {
         "PERMITID": "PP10-084",
         "APN": 46721002,
         "File Number": "PP10-084",
         "Address": "95 N 3RD ST SAN JOSE",
         "Project Name": "PP10-084",
         "Application Type": "Exempt ",
         "Application Date": "4/22/10 14:36",
         "Status": "Complete ",
         "Description": "Sale of City-owned property currently used as a parking garage with approximately 837 parking spaces.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2010
      },
      {
         "PERMITID": "PP10-085",
         "APN": 46746097,
         "File Number": "PP10-085",
         "Address": "280 S 2ND ST SAN JOSE",
         "Project Name": "PP10-085",
         "Application Type": "Exempt ",
         "Application Date": "4/22/10 14:42",
         "Status": "Complete ",
         "Description": "Sale of City-owned property currently used as a parking garage with approximately 544 parking spaces.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2010
      },
      {
         "PERMITID": "PP10-182",
         "APN": 47228001,
         "File Number": "PP10-182",
         "Address": "503 S 6TH ST SAN JOSE",
         "Project Name": "PP10-182",
         "Application Type": "Exempt ",
         "Application Date": "11/15/10 14:22",
         "Status": "Complete ",
         "Description": "O'Donnell Garden Park Gazebo Design Build project for the construction of a 21-foot diameter 346 SF octagonal-shaped gazebo on an existing paved area of an existing 0.62-acre park",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2010
      },
      {
         "PERMITID": "PP10-182",
         "APN": 47228002,
         "File Number": "PP10-182",
         "Address": "503 S 6TH ST SAN JOSE",
         "Project Name": "PP10-182",
         "Application Type": "Exempt ",
         "Application Date": "11/15/10 14:22",
         "Status": "Complete ",
         "Description": "O'Donnell Garden Park Gazebo Design Build project for the construction of a 21-foot diameter 346 SF octagonal-shaped gazebo on an existing paved area of an existing 0.62-acre park",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2010
      },
      {
         "PERMITID": "PP10-182",
         "APN": 47228025,
         "File Number": "PP10-182",
         "Address": "503 S 6TH ST SAN JOSE",
         "Project Name": "PP10-182",
         "Application Type": "Exempt ",
         "Application Date": "11/15/10 14:22",
         "Status": "Complete ",
         "Description": "O'Donnell Garden Park Gazebo Design Build project for the construction of a 21-foot diameter 346 SF octagonal-shaped gazebo on an existing paved area of an existing 0.62-acre park",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2010
      },
      {
         "PERMITID": "PP13-013",
         "APN": 25943064,
         "File Number": "PP13-013",
         "Address": "255 ALMADEN BL SAN JOSE",
         "Project Name": "PP13-013 - Fire Alarms and Smoke Detectors - SJ Center for Performing Arts",
         "Application Type": "Exempt ",
         "Application Date": "2/4/13 13:40",
         "Status": "Complete ",
         "Description": "Public Project Exemption to allow the repair, replacement and installation of interior smoke detectors, speaker and strobe units and fire alarms in an existing historic resource (San Jose Center for Performing Arts)  ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "PP14-031",
         "APN": 46723010,
         "File Number": "PP14-031",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP14-031 - U.S. Patent Trademark Office within City Hall",
         "Application Type": "Exempt ",
         "Application Date": "3/27/14 10:26",
         "Status": "Complete ",
         "Description": "Public Project Exemption for a contract which will facilitate the establishment of a regional satellite office of the United States Patent Trademark Office within City Hall.  ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "PP14-031",
         "APN": 46723011,
         "File Number": "PP14-031",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP14-031 - U.S. Patent Trademark Office within City Hall",
         "Application Type": "Exempt ",
         "Application Date": "3/27/14 10:26",
         "Status": "Complete ",
         "Description": "Public Project Exemption for a contract which will facilitate the establishment of a regional satellite office of the United States Patent Trademark Office within City Hall.  ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "PP14-031",
         "APN": 46723013,
         "File Number": "PP14-031",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP14-031 - U.S. Patent Trademark Office within City Hall",
         "Application Type": "Exempt ",
         "Application Date": "3/27/14 10:26",
         "Status": "Complete ",
         "Description": "Public Project Exemption for a contract which will facilitate the establishment of a regional satellite office of the United States Patent Trademark Office within City Hall.  ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "PP14-031",
         "APN": 46723017,
         "File Number": "PP14-031",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP14-031 - U.S. Patent Trademark Office within City Hall",
         "Application Type": "Exempt ",
         "Application Date": "3/27/14 10:26",
         "Status": "Complete ",
         "Description": "Public Project Exemption for a contract which will facilitate the establishment of a regional satellite office of the United States Patent Trademark Office within City Hall.  ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "PP14-031",
         "APN": 46723018,
         "File Number": "PP14-031",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP14-031 - U.S. Patent Trademark Office within City Hall",
         "Application Type": "Exempt ",
         "Application Date": "3/27/14 10:26",
         "Status": "Complete ",
         "Description": "Public Project Exemption for a contract which will facilitate the establishment of a regional satellite office of the United States Patent Trademark Office within City Hall.  ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "PP14-031",
         "APN": 46723019,
         "File Number": "PP14-031",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP14-031 - U.S. Patent Trademark Office within City Hall",
         "Application Type": "Exempt ",
         "Application Date": "3/27/14 10:26",
         "Status": "Complete ",
         "Description": "Public Project Exemption for a contract which will facilitate the establishment of a regional satellite office of the United States Patent Trademark Office within City Hall.  ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "PP14-031",
         "APN": 46723021,
         "File Number": "PP14-031",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP14-031 - U.S. Patent Trademark Office within City Hall",
         "Application Type": "Exempt ",
         "Application Date": "3/27/14 10:26",
         "Status": "Complete ",
         "Description": "Public Project Exemption for a contract which will facilitate the establishment of a regional satellite office of the United States Patent Trademark Office within City Hall.  ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "PP14-031",
         "APN": 46723022,
         "File Number": "PP14-031",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP14-031 - U.S. Patent Trademark Office within City Hall",
         "Application Type": "Exempt ",
         "Application Date": "3/27/14 10:26",
         "Status": "Complete ",
         "Description": "Public Project Exemption for a contract which will facilitate the establishment of a regional satellite office of the United States Patent Trademark Office within City Hall.  ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "PP14-031",
         "APN": 46723076,
         "File Number": "PP14-031",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP14-031 - U.S. Patent Trademark Office within City Hall",
         "Application Type": "Exempt ",
         "Application Date": "3/27/14 10:26",
         "Status": "Complete ",
         "Description": "Public Project Exemption for a contract which will facilitate the establishment of a regional satellite office of the United States Patent Trademark Office within City Hall.  ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "PP14-031",
         "APN": 46724001,
         "File Number": "PP14-031",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP14-031 - U.S. Patent Trademark Office within City Hall",
         "Application Type": "Exempt ",
         "Application Date": "3/27/14 10:26",
         "Status": "Complete ",
         "Description": "Public Project Exemption for a contract which will facilitate the establishment of a regional satellite office of the United States Patent Trademark Office within City Hall.  ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "PP14-031",
         "APN": 46724002,
         "File Number": "PP14-031",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP14-031 - U.S. Patent Trademark Office within City Hall",
         "Application Type": "Exempt ",
         "Application Date": "3/27/14 10:26",
         "Status": "Complete ",
         "Description": "Public Project Exemption for a contract which will facilitate the establishment of a regional satellite office of the United States Patent Trademark Office within City Hall.  ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "PP14-031",
         "APN": 46724003,
         "File Number": "PP14-031",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP14-031 - U.S. Patent Trademark Office within City Hall",
         "Application Type": "Exempt ",
         "Application Date": "3/27/14 10:26",
         "Status": "Complete ",
         "Description": "Public Project Exemption for a contract which will facilitate the establishment of a regional satellite office of the United States Patent Trademark Office within City Hall.  ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "PP14-031",
         "APN": 46724014,
         "File Number": "PP14-031",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP14-031 - U.S. Patent Trademark Office within City Hall",
         "Application Type": "Exempt ",
         "Application Date": "3/27/14 10:26",
         "Status": "Complete ",
         "Description": "Public Project Exemption for a contract which will facilitate the establishment of a regional satellite office of the United States Patent Trademark Office within City Hall.  ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "PP14-031",
         "APN": 46724015,
         "File Number": "PP14-031",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP14-031 - U.S. Patent Trademark Office within City Hall",
         "Application Type": "Exempt ",
         "Application Date": "3/27/14 10:26",
         "Status": "Complete ",
         "Description": "Public Project Exemption for a contract which will facilitate the establishment of a regional satellite office of the United States Patent Trademark Office within City Hall.  ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "PP14-031",
         "APN": 46724016,
         "File Number": "PP14-031",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP14-031 - U.S. Patent Trademark Office within City Hall",
         "Application Type": "Exempt ",
         "Application Date": "3/27/14 10:26",
         "Status": "Complete ",
         "Description": "Public Project Exemption for a contract which will facilitate the establishment of a regional satellite office of the United States Patent Trademark Office within City Hall.  ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "PP14-031",
         "APN": 46724019,
         "File Number": "PP14-031",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP14-031 - U.S. Patent Trademark Office within City Hall",
         "Application Type": "Exempt ",
         "Application Date": "3/27/14 10:26",
         "Status": "Complete ",
         "Description": "Public Project Exemption for a contract which will facilitate the establishment of a regional satellite office of the United States Patent Trademark Office within City Hall.  ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "PP14-031",
         "APN": 46724020,
         "File Number": "PP14-031",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP14-031 - U.S. Patent Trademark Office within City Hall",
         "Application Type": "Exempt ",
         "Application Date": "3/27/14 10:26",
         "Status": "Complete ",
         "Description": "Public Project Exemption for a contract which will facilitate the establishment of a regional satellite office of the United States Patent Trademark Office within City Hall.  ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "PP14-031",
         "APN": 46724021,
         "File Number": "PP14-031",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP14-031 - U.S. Patent Trademark Office within City Hall",
         "Application Type": "Exempt ",
         "Application Date": "3/27/14 10:26",
         "Status": "Complete ",
         "Description": "Public Project Exemption for a contract which will facilitate the establishment of a regional satellite office of the United States Patent Trademark Office within City Hall.  ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "PP14-031",
         "APN": 46724115,
         "File Number": "PP14-031",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP14-031 - U.S. Patent Trademark Office within City Hall",
         "Application Type": "Exempt ",
         "Application Date": "3/27/14 10:26",
         "Status": "Complete ",
         "Description": "Public Project Exemption for a contract which will facilitate the establishment of a regional satellite office of the United States Patent Trademark Office within City Hall.  ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "PP14-031",
         "APN": 46724117,
         "File Number": "PP14-031",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP14-031 - U.S. Patent Trademark Office within City Hall",
         "Application Type": "Exempt ",
         "Application Date": "3/27/14 10:26",
         "Status": "Complete ",
         "Description": "Public Project Exemption for a contract which will facilitate the establishment of a regional satellite office of the United States Patent Trademark Office within City Hall.  ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "PP15-028",
         "APN": 26427082,
         "File Number": "PP15-028",
         "Address": "180 WOZ WY SAN JOSE",
         "Project Name": "PP15-028: CDM chiller replacement",
         "Application Type": "Exempt ",
         "Application Date": "3/19/15 14:48",
         "Status": "Complete ",
         "Description": "Removal & replacement of existing (2) air cooled chiller and (3) chilled water pumps",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "PP15-028",
         "APN": 26427087,
         "File Number": "PP15-028",
         "Address": "180 WOZ WY SAN JOSE",
         "Project Name": "PP15-028: CDM chiller replacement",
         "Application Type": "Exempt ",
         "Application Date": "3/19/15 14:48",
         "Status": "Complete ",
         "Description": "Removal & replacement of existing (2) air cooled chiller and (3) chilled water pumps",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "PP15-028",
         "APN": 26427088,
         "File Number": "PP15-028",
         "Address": "180 WOZ WY SAN JOSE",
         "Project Name": "PP15-028: CDM chiller replacement",
         "Application Type": "Exempt ",
         "Application Date": "3/19/15 14:48",
         "Status": "Complete ",
         "Description": "Removal & replacement of existing (2) air cooled chiller and (3) chilled water pumps",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "PP15-044",
         "APN": 25943076,
         "File Number": "PP15-044",
         "Address": "200 PARK AV SAN JOSE",
         "Project Name": "PP15-044 - Park Avenue Street Vacation",
         "Application Type": "Exempt ",
         "Application Date": "4/14/15 13:15",
         "Status": "Complete ",
         "Description": "Public Project Exemption for the vacation of a portion of public-right-way [street] located along the northwest frontage of Park Avenue.  ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "PP15-067",
         "APN": 46723010,
         "File Number": "PP15-067",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP15-067 - South Plaza Planter Installation Project",
         "Application Type": "Exempt ",
         "Application Date": "7/7/15 13:51",
         "Status": "Complete ",
         "Description": "Public Project Exemption for the South Plaza Planter Installation project located in the south outdoor plaza area of City Hall. The project includes but is not limited to: the installation of fifteen concrete planters, (9) concrete benches, festoon lighting, power outlets, automatic irrigation, plants, and soil. The irrigation lines and electrical conduits for the project features will connect to existing irrigation and conduit lines..",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "PP15-067",
         "APN": 46723011,
         "File Number": "PP15-067",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP15-067 - South Plaza Planter Installation Project",
         "Application Type": "Exempt ",
         "Application Date": "7/7/15 13:51",
         "Status": "Complete ",
         "Description": "Public Project Exemption for the South Plaza Planter Installation project located in the south outdoor plaza area of City Hall. The project includes but is not limited to: the installation of fifteen concrete planters, (9) concrete benches, festoon lighting, power outlets, automatic irrigation, plants, and soil. The irrigation lines and electrical conduits for the project features will connect to existing irrigation and conduit lines..",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "PP15-067",
         "APN": 46723013,
         "File Number": "PP15-067",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP15-067 - South Plaza Planter Installation Project",
         "Application Type": "Exempt ",
         "Application Date": "7/7/15 13:51",
         "Status": "Complete ",
         "Description": "Public Project Exemption for the South Plaza Planter Installation project located in the south outdoor plaza area of City Hall. The project includes but is not limited to: the installation of fifteen concrete planters, (9) concrete benches, festoon lighting, power outlets, automatic irrigation, plants, and soil. The irrigation lines and electrical conduits for the project features will connect to existing irrigation and conduit lines..",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "PP15-067",
         "APN": 46723017,
         "File Number": "PP15-067",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP15-067 - South Plaza Planter Installation Project",
         "Application Type": "Exempt ",
         "Application Date": "7/7/15 13:51",
         "Status": "Complete ",
         "Description": "Public Project Exemption for the South Plaza Planter Installation project located in the south outdoor plaza area of City Hall. The project includes but is not limited to: the installation of fifteen concrete planters, (9) concrete benches, festoon lighting, power outlets, automatic irrigation, plants, and soil. The irrigation lines and electrical conduits for the project features will connect to existing irrigation and conduit lines..",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "PP15-067",
         "APN": 46723018,
         "File Number": "PP15-067",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP15-067 - South Plaza Planter Installation Project",
         "Application Type": "Exempt ",
         "Application Date": "7/7/15 13:51",
         "Status": "Complete ",
         "Description": "Public Project Exemption for the South Plaza Planter Installation project located in the south outdoor plaza area of City Hall. The project includes but is not limited to: the installation of fifteen concrete planters, (9) concrete benches, festoon lighting, power outlets, automatic irrigation, plants, and soil. The irrigation lines and electrical conduits for the project features will connect to existing irrigation and conduit lines..",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "PP15-067",
         "APN": 46723019,
         "File Number": "PP15-067",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP15-067 - South Plaza Planter Installation Project",
         "Application Type": "Exempt ",
         "Application Date": "7/7/15 13:51",
         "Status": "Complete ",
         "Description": "Public Project Exemption for the South Plaza Planter Installation project located in the south outdoor plaza area of City Hall. The project includes but is not limited to: the installation of fifteen concrete planters, (9) concrete benches, festoon lighting, power outlets, automatic irrigation, plants, and soil. The irrigation lines and electrical conduits for the project features will connect to existing irrigation and conduit lines..",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "PP15-067",
         "APN": 46723021,
         "File Number": "PP15-067",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP15-067 - South Plaza Planter Installation Project",
         "Application Type": "Exempt ",
         "Application Date": "7/7/15 13:51",
         "Status": "Complete ",
         "Description": "Public Project Exemption for the South Plaza Planter Installation project located in the south outdoor plaza area of City Hall. The project includes but is not limited to: the installation of fifteen concrete planters, (9) concrete benches, festoon lighting, power outlets, automatic irrigation, plants, and soil. The irrigation lines and electrical conduits for the project features will connect to existing irrigation and conduit lines..",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "PP15-067",
         "APN": 46723022,
         "File Number": "PP15-067",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP15-067 - South Plaza Planter Installation Project",
         "Application Type": "Exempt ",
         "Application Date": "7/7/15 13:51",
         "Status": "Complete ",
         "Description": "Public Project Exemption for the South Plaza Planter Installation project located in the south outdoor plaza area of City Hall. The project includes but is not limited to: the installation of fifteen concrete planters, (9) concrete benches, festoon lighting, power outlets, automatic irrigation, plants, and soil. The irrigation lines and electrical conduits for the project features will connect to existing irrigation and conduit lines..",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "PP15-067",
         "APN": 46723076,
         "File Number": "PP15-067",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP15-067 - South Plaza Planter Installation Project",
         "Application Type": "Exempt ",
         "Application Date": "7/7/15 13:51",
         "Status": "Complete ",
         "Description": "Public Project Exemption for the South Plaza Planter Installation project located in the south outdoor plaza area of City Hall. The project includes but is not limited to: the installation of fifteen concrete planters, (9) concrete benches, festoon lighting, power outlets, automatic irrigation, plants, and soil. The irrigation lines and electrical conduits for the project features will connect to existing irrigation and conduit lines..",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "PP15-067",
         "APN": 46724001,
         "File Number": "PP15-067",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP15-067 - South Plaza Planter Installation Project",
         "Application Type": "Exempt ",
         "Application Date": "7/7/15 13:51",
         "Status": "Complete ",
         "Description": "Public Project Exemption for the South Plaza Planter Installation project located in the south outdoor plaza area of City Hall. The project includes but is not limited to: the installation of fifteen concrete planters, (9) concrete benches, festoon lighting, power outlets, automatic irrigation, plants, and soil. The irrigation lines and electrical conduits for the project features will connect to existing irrigation and conduit lines..",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "PP15-067",
         "APN": 46724002,
         "File Number": "PP15-067",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP15-067 - South Plaza Planter Installation Project",
         "Application Type": "Exempt ",
         "Application Date": "7/7/15 13:51",
         "Status": "Complete ",
         "Description": "Public Project Exemption for the South Plaza Planter Installation project located in the south outdoor plaza area of City Hall. The project includes but is not limited to: the installation of fifteen concrete planters, (9) concrete benches, festoon lighting, power outlets, automatic irrigation, plants, and soil. The irrigation lines and electrical conduits for the project features will connect to existing irrigation and conduit lines..",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "PP15-067",
         "APN": 46724003,
         "File Number": "PP15-067",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP15-067 - South Plaza Planter Installation Project",
         "Application Type": "Exempt ",
         "Application Date": "7/7/15 13:51",
         "Status": "Complete ",
         "Description": "Public Project Exemption for the South Plaza Planter Installation project located in the south outdoor plaza area of City Hall. The project includes but is not limited to: the installation of fifteen concrete planters, (9) concrete benches, festoon lighting, power outlets, automatic irrigation, plants, and soil. The irrigation lines and electrical conduits for the project features will connect to existing irrigation and conduit lines..",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "PP15-067",
         "APN": 46724014,
         "File Number": "PP15-067",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP15-067 - South Plaza Planter Installation Project",
         "Application Type": "Exempt ",
         "Application Date": "7/7/15 13:51",
         "Status": "Complete ",
         "Description": "Public Project Exemption for the South Plaza Planter Installation project located in the south outdoor plaza area of City Hall. The project includes but is not limited to: the installation of fifteen concrete planters, (9) concrete benches, festoon lighting, power outlets, automatic irrigation, plants, and soil. The irrigation lines and electrical conduits for the project features will connect to existing irrigation and conduit lines..",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "PP15-067",
         "APN": 46724015,
         "File Number": "PP15-067",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP15-067 - South Plaza Planter Installation Project",
         "Application Type": "Exempt ",
         "Application Date": "7/7/15 13:51",
         "Status": "Complete ",
         "Description": "Public Project Exemption for the South Plaza Planter Installation project located in the south outdoor plaza area of City Hall. The project includes but is not limited to: the installation of fifteen concrete planters, (9) concrete benches, festoon lighting, power outlets, automatic irrigation, plants, and soil. The irrigation lines and electrical conduits for the project features will connect to existing irrigation and conduit lines..",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "PP15-067",
         "APN": 46724016,
         "File Number": "PP15-067",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP15-067 - South Plaza Planter Installation Project",
         "Application Type": "Exempt ",
         "Application Date": "7/7/15 13:51",
         "Status": "Complete ",
         "Description": "Public Project Exemption for the South Plaza Planter Installation project located in the south outdoor plaza area of City Hall. The project includes but is not limited to: the installation of fifteen concrete planters, (9) concrete benches, festoon lighting, power outlets, automatic irrigation, plants, and soil. The irrigation lines and electrical conduits for the project features will connect to existing irrigation and conduit lines..",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "PP15-067",
         "APN": 46724019,
         "File Number": "PP15-067",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP15-067 - South Plaza Planter Installation Project",
         "Application Type": "Exempt ",
         "Application Date": "7/7/15 13:51",
         "Status": "Complete ",
         "Description": "Public Project Exemption for the South Plaza Planter Installation project located in the south outdoor plaza area of City Hall. The project includes but is not limited to: the installation of fifteen concrete planters, (9) concrete benches, festoon lighting, power outlets, automatic irrigation, plants, and soil. The irrigation lines and electrical conduits for the project features will connect to existing irrigation and conduit lines..",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "PP15-067",
         "APN": 46724020,
         "File Number": "PP15-067",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP15-067 - South Plaza Planter Installation Project",
         "Application Type": "Exempt ",
         "Application Date": "7/7/15 13:51",
         "Status": "Complete ",
         "Description": "Public Project Exemption for the South Plaza Planter Installation project located in the south outdoor plaza area of City Hall. The project includes but is not limited to: the installation of fifteen concrete planters, (9) concrete benches, festoon lighting, power outlets, automatic irrigation, plants, and soil. The irrigation lines and electrical conduits for the project features will connect to existing irrigation and conduit lines..",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "PP15-067",
         "APN": 46724021,
         "File Number": "PP15-067",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP15-067 - South Plaza Planter Installation Project",
         "Application Type": "Exempt ",
         "Application Date": "7/7/15 13:51",
         "Status": "Complete ",
         "Description": "Public Project Exemption for the South Plaza Planter Installation project located in the south outdoor plaza area of City Hall. The project includes but is not limited to: the installation of fifteen concrete planters, (9) concrete benches, festoon lighting, power outlets, automatic irrigation, plants, and soil. The irrigation lines and electrical conduits for the project features will connect to existing irrigation and conduit lines..",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "PP15-067",
         "APN": 46724115,
         "File Number": "PP15-067",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP15-067 - South Plaza Planter Installation Project",
         "Application Type": "Exempt ",
         "Application Date": "7/7/15 13:51",
         "Status": "Complete ",
         "Description": "Public Project Exemption for the South Plaza Planter Installation project located in the south outdoor plaza area of City Hall. The project includes but is not limited to: the installation of fifteen concrete planters, (9) concrete benches, festoon lighting, power outlets, automatic irrigation, plants, and soil. The irrigation lines and electrical conduits for the project features will connect to existing irrigation and conduit lines..",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "PP15-067",
         "APN": 46724117,
         "File Number": "PP15-067",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP15-067 - South Plaza Planter Installation Project",
         "Application Type": "Exempt ",
         "Application Date": "7/7/15 13:51",
         "Status": "Complete ",
         "Description": "Public Project Exemption for the South Plaza Planter Installation project located in the south outdoor plaza area of City Hall. The project includes but is not limited to: the installation of fifteen concrete planters, (9) concrete benches, festoon lighting, power outlets, automatic irrigation, plants, and soil. The irrigation lines and electrical conduits for the project features will connect to existing irrigation and conduit lines..",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "PP15-078",
         "APN": 25940071,
         "File Number": "PP15-078",
         "Address": "96 S ALMADEN AV SAN JOSE",
         "Project Name": "PP15-078 - Acquisition of the Plaza Hotel for Affordable Housing",
         "Application Type": "Exempt ",
         "Application Date": "8/21/15 10:33",
         "Status": "Complete ",
         "Description": "Public Project Exemption for Acquisition and minor rehabilitation of an existing 11,470 square-foot facility (Plaza Hotel) with 49 Single Room Occupancy units for housing low-and moderate- income homeless, located on a 0.1 gross acre site",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "PP15-083",
         "APN": 25934039,
         "File Number": "PP15-083",
         "Address": "45 N MARKET ST SAN JOSE",
         "Project Name": "PP15-083 St. John Parking Garage right-of-way dedication",
         "Application Type": "Exempt ",
         "Application Date": "8/14/15 13:11",
         "Status": "Complete ",
         "Description": "City ordinance to designate the northern portion of city-owned property occupied by the St. John parking garage as public right-of-way to allow the construction of the St. John Bikeway and Pedestrian Improvement Project (CEQA clearance provided under PP14-013).",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "PP16-031",
         "APN": 25941065,
         "File Number": "PP16-031",
         "Address": "194 S MARKET ST SAN JOSE",
         "Project Name": "PP16-031 - Christmas in the Park",
         "Application Type": "Exempt ",
         "Application Date": "3/18/16 15:03",
         "Status": "Complete ",
         "Description": "Public Project Exemption for the agreement with Christmas in the Park, Inc. to manage and produce Christmas in the Park at Plaza de Cesar Chavez and to provide limited support staff and in-kind services. This event will obtain all required health, safety, and public event permits. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "PP17-040",
         "APN": 46723010,
         "File Number": "PP17-040",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP17-040",
         "Application Type": "Exempt ",
         "Application Date": "5/15/17 13:26",
         "Status": "Complete ",
         "Description": "Public Project Exemption for the City Hall Special Event Lighting Council Policy.  ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "PP17-040",
         "APN": 46723011,
         "File Number": "PP17-040",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP17-040",
         "Application Type": "Exempt ",
         "Application Date": "5/15/17 13:26",
         "Status": "Complete ",
         "Description": "Public Project Exemption for the City Hall Special Event Lighting Council Policy.  ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "PP17-040",
         "APN": 46723013,
         "File Number": "PP17-040",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP17-040",
         "Application Type": "Exempt ",
         "Application Date": "5/15/17 13:26",
         "Status": "Complete ",
         "Description": "Public Project Exemption for the City Hall Special Event Lighting Council Policy.  ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "PP17-040",
         "APN": 46723017,
         "File Number": "PP17-040",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP17-040",
         "Application Type": "Exempt ",
         "Application Date": "5/15/17 13:26",
         "Status": "Complete ",
         "Description": "Public Project Exemption for the City Hall Special Event Lighting Council Policy.  ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "PP17-040",
         "APN": 46723018,
         "File Number": "PP17-040",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP17-040",
         "Application Type": "Exempt ",
         "Application Date": "5/15/17 13:26",
         "Status": "Complete ",
         "Description": "Public Project Exemption for the City Hall Special Event Lighting Council Policy.  ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "PP17-040",
         "APN": 46723019,
         "File Number": "PP17-040",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP17-040",
         "Application Type": "Exempt ",
         "Application Date": "5/15/17 13:26",
         "Status": "Complete ",
         "Description": "Public Project Exemption for the City Hall Special Event Lighting Council Policy.  ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "PP17-040",
         "APN": 46723021,
         "File Number": "PP17-040",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP17-040",
         "Application Type": "Exempt ",
         "Application Date": "5/15/17 13:26",
         "Status": "Complete ",
         "Description": "Public Project Exemption for the City Hall Special Event Lighting Council Policy.  ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "PP17-040",
         "APN": 46723022,
         "File Number": "PP17-040",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP17-040",
         "Application Type": "Exempt ",
         "Application Date": "5/15/17 13:26",
         "Status": "Complete ",
         "Description": "Public Project Exemption for the City Hall Special Event Lighting Council Policy.  ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "PP17-040",
         "APN": 46723076,
         "File Number": "PP17-040",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP17-040",
         "Application Type": "Exempt ",
         "Application Date": "5/15/17 13:26",
         "Status": "Complete ",
         "Description": "Public Project Exemption for the City Hall Special Event Lighting Council Policy.  ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "PP17-040",
         "APN": 46724001,
         "File Number": "PP17-040",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP17-040",
         "Application Type": "Exempt ",
         "Application Date": "5/15/17 13:26",
         "Status": "Complete ",
         "Description": "Public Project Exemption for the City Hall Special Event Lighting Council Policy.  ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "PP17-040",
         "APN": 46724002,
         "File Number": "PP17-040",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP17-040",
         "Application Type": "Exempt ",
         "Application Date": "5/15/17 13:26",
         "Status": "Complete ",
         "Description": "Public Project Exemption for the City Hall Special Event Lighting Council Policy.  ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "PP17-040",
         "APN": 46724003,
         "File Number": "PP17-040",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP17-040",
         "Application Type": "Exempt ",
         "Application Date": "5/15/17 13:26",
         "Status": "Complete ",
         "Description": "Public Project Exemption for the City Hall Special Event Lighting Council Policy.  ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "PP17-040",
         "APN": 46724014,
         "File Number": "PP17-040",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP17-040",
         "Application Type": "Exempt ",
         "Application Date": "5/15/17 13:26",
         "Status": "Complete ",
         "Description": "Public Project Exemption for the City Hall Special Event Lighting Council Policy.  ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "PP17-040",
         "APN": 46724015,
         "File Number": "PP17-040",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP17-040",
         "Application Type": "Exempt ",
         "Application Date": "5/15/17 13:26",
         "Status": "Complete ",
         "Description": "Public Project Exemption for the City Hall Special Event Lighting Council Policy.  ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "PP17-040",
         "APN": 46724016,
         "File Number": "PP17-040",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP17-040",
         "Application Type": "Exempt ",
         "Application Date": "5/15/17 13:26",
         "Status": "Complete ",
         "Description": "Public Project Exemption for the City Hall Special Event Lighting Council Policy.  ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "PP17-040",
         "APN": 46724019,
         "File Number": "PP17-040",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP17-040",
         "Application Type": "Exempt ",
         "Application Date": "5/15/17 13:26",
         "Status": "Complete ",
         "Description": "Public Project Exemption for the City Hall Special Event Lighting Council Policy.  ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "PP17-040",
         "APN": 46724020,
         "File Number": "PP17-040",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP17-040",
         "Application Type": "Exempt ",
         "Application Date": "5/15/17 13:26",
         "Status": "Complete ",
         "Description": "Public Project Exemption for the City Hall Special Event Lighting Council Policy.  ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "PP17-040",
         "APN": 46724021,
         "File Number": "PP17-040",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP17-040",
         "Application Type": "Exempt ",
         "Application Date": "5/15/17 13:26",
         "Status": "Complete ",
         "Description": "Public Project Exemption for the City Hall Special Event Lighting Council Policy.  ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "PP17-040",
         "APN": 46724115,
         "File Number": "PP17-040",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP17-040",
         "Application Type": "Exempt ",
         "Application Date": "5/15/17 13:26",
         "Status": "Complete ",
         "Description": "Public Project Exemption for the City Hall Special Event Lighting Council Policy.  ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "PP17-040",
         "APN": 46724117,
         "File Number": "PP17-040",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP17-040",
         "Application Type": "Exempt ",
         "Application Date": "5/15/17 13:26",
         "Status": "Complete ",
         "Description": "Public Project Exemption for the City Hall Special Event Lighting Council Policy.  ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "PP17-077",
         "APN": 47233012,
         "File Number": "PP17-077",
         "Address": "0 E WILLIAM ST SAN JOSE",
         "Project Name": "PP17-077",
         "Application Type": "Exempt ",
         "Application Date": "11/2/17 9:46",
         "Status": "Complete ",
         "Description": "Public Project Exemption for a removal and replacement of rubber resilient surfacing in-kind for a tot and youth lot at Selma Olinder Park, youth lot at Rock Springs Park, and youth lot at Martin Park. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "PP18-051",
         "APN": 25941065,
         "File Number": "PP18-051",
         "Address": "194 S MARKET ST SAN JOSE",
         "Project Name": "PP18-051",
         "Application Type": "Exempt ",
         "Application Date": "4/23/18 14:22",
         "Status": "Complete ",
         "Description": "Public Project Exemption to install picnic tables; remove and replace trash cans and park benches; add 1,000 square feet of concrete pathway; repair the electrical system; update irrigation to accommodate the pathway expansion; increase tree maintenance; removal and replacement of trees near the stage; install park signage; install temporary stage cover; repair the fountain pump and filtration system; and replace glass fountain tiles.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "PP18-051",
         "APN": 25942036,
         "File Number": "PP18-051",
         "Address": "194 S MARKET ST SAN JOSE",
         "Project Name": "PP18-051",
         "Application Type": "Exempt ",
         "Application Date": "4/23/18 14:22",
         "Status": "Complete ",
         "Description": "Public Project Exemption to install picnic tables; remove and replace trash cans and park benches; add 1,000 square feet of concrete pathway; repair the electrical system; update irrigation to accommodate the pathway expansion; increase tree maintenance; removal and replacement of trees near the stage; install park signage; install temporary stage cover; repair the fountain pump and filtration system; and replace glass fountain tiles.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2018
      }
   ],
   "Exemption ": [
      {
         "PERMITID": "PP00-004",
         "APN": 47228001,
         "File Number": "PP00-004",
         "Address": " ",
         "Project Name": " ",
         "Application Type": "Exemption ",
         "Application Date": "1/5/00",
         "Status": "Complete ",
         "Description": "City acquisition of three vacant parcels, totalling approximately 0.5 acres, for potential future use as public parkland",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "PP00-111",
         "APN": 47233011,
         "File Number": "PP00-111",
         "Address": " ",
         "Project Name": " ",
         "Application Type": "Exemption ",
         "Application Date": "8/4/00",
         "Status": "Complete ",
         "Description": "The Coyote Creek Riparian Restoration Pilot Project (RRPP) consists of testing the Riparian Restoration Action Plan (RRAP) by installing diverse, native riparian vegetation in a 7000 square foot gap in the forest along a section of Coyote Creek.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "PP01-007",
         "APN": 25934039,
         "File Number": "PP01-007",
         "Address": " ",
         "Project Name": " ",
         "Application Type": "Exemption ",
         "Application Date": "1/16/01",
         "Status": "Complete ",
         "Description": "Installation of bird control devices on three City owned parking garages. Control devices will consist of Needle Strips, Bird Shock, Stealth Net Bird Net, and bird wire. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "PP01-007",
         "APN": 46721001,
         "File Number": "PP01-007",
         "Address": " ",
         "Project Name": " ",
         "Application Type": "Exemption ",
         "Application Date": "1/16/01",
         "Status": "Complete ",
         "Description": "Installation of bird control devices on three City owned parking garages. Control devices will consist of Needle Strips, Bird Shock, Stealth Net Bird Net, and bird wire. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "PP01-007",
         "APN": 46746097,
         "File Number": "PP01-007",
         "Address": " ",
         "Project Name": " ",
         "Application Type": "Exemption ",
         "Application Date": "1/16/01",
         "Status": "Complete ",
         "Description": "Installation of bird control devices on three City owned parking garages. Control devices will consist of Needle Strips, Bird Shock, Stealth Net Bird Net, and bird wire. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "PP01-020",
         "APN": 25934039,
         "File Number": "PP01-020",
         "Address": " ",
         "Project Name": " ",
         "Application Type": "Exemption ",
         "Application Date": "2/7/01",
         "Status": "Complete ",
         "Description": "Hiring a consultant to provide reccomendations for necessary repairs and creation of a maintenance program for the city parking garages. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "PP01-020",
         "APN": 46721002,
         "File Number": "PP01-020",
         "Address": " ",
         "Project Name": " ",
         "Application Type": "Exemption ",
         "Application Date": "2/7/01",
         "Status": "Complete ",
         "Description": "Hiring a consultant to provide reccomendations for necessary repairs and creation of a maintenance program for the city parking garages. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "PP01-020",
         "APN": 46746097,
         "File Number": "PP01-020",
         "Address": " ",
         "Project Name": " ",
         "Application Type": "Exemption ",
         "Application Date": "2/7/01",
         "Status": "Complete ",
         "Description": "Hiring a consultant to provide reccomendations for necessary repairs and creation of a maintenance program for the city parking garages. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "PP01-132",
         "APN": 25934039,
         "File Number": "PP01-132",
         "Address": " ",
         "Project Name": " ",
         "Application Type": "Exemption ",
         "Application Date": "7/23/01",
         "Status": "Complete ",
         "Description": "Maintenance activity to clean the interior and exterior of three City garages to include removal of all surface dirt, carbon build-up, grease, oil, gum, debris, excess soap, standing water, and other substances. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "PP01-132",
         "APN": 46721002,
         "File Number": "PP01-132",
         "Address": " ",
         "Project Name": " ",
         "Application Type": "Exemption ",
         "Application Date": "7/23/01",
         "Status": "Complete ",
         "Description": "Maintenance activity to clean the interior and exterior of three City garages to include removal of all surface dirt, carbon build-up, grease, oil, gum, debris, excess soap, standing water, and other substances. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "PP01-132",
         "APN": 46746097,
         "File Number": "PP01-132",
         "Address": " ",
         "Project Name": " ",
         "Application Type": "Exemption ",
         "Application Date": "7/23/01",
         "Status": "Complete ",
         "Description": "Maintenance activity to clean the interior and exterior of three City garages to include removal of all surface dirt, carbon build-up, grease, oil, gum, debris, excess soap, standing water, and other substances. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "PP01-142",
         "APN": 25934039,
         "File Number": "PP01-142",
         "Address": " ",
         "Project Name": " ",
         "Application Type": "Exemption ",
         "Application Date": "8/10/01",
         "Status": "Complete ",
         "Description": "Repainting the City's parking facilities, including the application of epoxy skid resistant coating on stair threads and landing areas. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "PP01-142",
         "APN": 46721002,
         "File Number": "PP01-142",
         "Address": " ",
         "Project Name": " ",
         "Application Type": "Exemption ",
         "Application Date": "8/10/01",
         "Status": "Complete ",
         "Description": "Repainting the City's parking facilities, including the application of epoxy skid resistant coating on stair threads and landing areas. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "PP01-142",
         "APN": 46746097,
         "File Number": "PP01-142",
         "Address": " ",
         "Project Name": " ",
         "Application Type": "Exemption ",
         "Application Date": "8/10/01",
         "Status": "Complete ",
         "Description": "Repainting the City's parking facilities, including the application of epoxy skid resistant coating on stair threads and landing areas. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "PP02-084",
         "APN": 47228001,
         "File Number": "PP02-084",
         "Address": " ",
         "Project Name": " ",
         "Application Type": "Exemption ",
         "Application Date": "4/18/02",
         "Status": "Complete ",
         "Description": "A Master Plan to develop a neighborhood park to include two play areas, patio, paved pathways, and landscaping. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2002
      },
      {
         "PERMITID": "PP02-084",
         "APN": 47228002,
         "File Number": "PP02-084",
         "Address": " ",
         "Project Name": " ",
         "Application Type": "Exemption ",
         "Application Date": "4/18/02",
         "Status": "Complete ",
         "Description": "A Master Plan to develop a neighborhood park to include two play areas, patio, paved pathways, and landscaping. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2002
      },
      {
         "PERMITID": "PP02-084",
         "APN": 47228025,
         "File Number": "PP02-084",
         "Address": " ",
         "Project Name": " ",
         "Application Type": "Exemption ",
         "Application Date": "4/18/02",
         "Status": "Complete ",
         "Description": "A Master Plan to develop a neighborhood park to include two play areas, patio, paved pathways, and landscaping. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2002
      },
      {
         "PERMITID": "PP02-108",
         "APN": 46721001,
         "File Number": "PP02-108",
         "Address": " ",
         "Project Name": " ",
         "Application Type": "Exemption ",
         "Application Date": "5/14/02",
         "Status": "Complete ",
         "Description": "St. James Square Park Master Plan Update by Royston, Hanamoto, Alley and Abey ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2002
      },
      {
         "PERMITID": "PP02-108",
         "APN": 46721014,
         "File Number": "PP02-108",
         "Address": " ",
         "Project Name": " ",
         "Application Type": "Exemption ",
         "Application Date": "5/14/02",
         "Status": "Complete ",
         "Description": "St. James Square Park Master Plan Update by Royston, Hanamoto, Alley and Abey ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2002
      },
      {
         "PERMITID": "PP02-206",
         "APN": 46721013,
         "File Number": "PP02-206",
         "Address": " ",
         "Project Name": "96, 82, & 70 N. Second Street",
         "Application Type": "Exemption ",
         "Application Date": "7/31/02",
         "Status": "Complete ",
         "Description": "Acquisition of property by the Redevelopment Agency in accordance with the St. James Park Master Plan Update. This includes property acquisition only, all subsequent development will be subject to separate environmental clearance. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2002
      },
      {
         "PERMITID": "PP02-206",
         "APN": 46721043,
         "File Number": "PP02-206",
         "Address": " ",
         "Project Name": "96, 82, & 70 N. Second Street",
         "Application Type": "Exemption ",
         "Application Date": "7/31/02",
         "Status": "Complete ",
         "Description": "Acquisition of property by the Redevelopment Agency in accordance with the St. James Park Master Plan Update. This includes property acquisition only, all subsequent development will be subject to separate environmental clearance. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2002
      },
      {
         "PERMITID": "PP03-090",
         "APN": 46757083,
         "File Number": "PP03-090",
         "Address": " ",
         "Project Name": " ",
         "Application Type": "Exemption ",
         "Application Date": "3/19/03",
         "Status": "Complete ",
         "Description": "Adoption of a resolution (1) approving a funding commitment of up to $2,300,000 to First United Methodist Church Tower Properties, L. P., or its designated affiliate, for the acquisition and rehabilitation of the Vintage Tower Apartments, a 59-unit mid-ri",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "PP03-109",
         "APN": 46723082,
         "File Number": "PP03-109",
         "Address": " ",
         "Project Name": " ",
         "Application Type": "Exemption ",
         "Application Date": "4/4/03",
         "Status": "Complete ",
         "Description": "Adoption of a resolution approving the Continuation Agreement and First Amendment to the agreement with Jeanne d?Arc Manor to extend the Term of Agreement from December 31, 2001 to June 30, 2004 in order to provide Jeanne d?Arc Manor the grant funds from",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "PP03-129",
         "APN": 46723074,
         "File Number": "PP03-129",
         "Address": " ",
         "Project Name": " ",
         "Application Type": "Exemption ",
         "Application Date": "4/21/03",
         "Status": "Complete ",
         "Description": "Amended and restated banquet facility agreement with the Rotary Club of San Jose for the use of the Fourth Street garage banquet facility. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "PP03-179",
         "APN": 25944085,
         "File Number": "PP03-179",
         "Address": " ",
         "Project Name": " ",
         "Application Type": "Exemption ",
         "Application Date": "5/22/03",
         "Status": "Complete ",
         "Description": "Artwork fence to screen the Adobe loading dock as viewed from McEnery Park, approx. 62 feet on length.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "PP03-202",
         "APN": 25941065,
         "File Number": "PP03-202",
         "Address": " ",
         "Project Name": " ",
         "Application Type": "Exemption ",
         "Application Date": "6/3/03",
         "Status": "Complete ",
         "Description": "To upgrade the main electrical vault, upgrade and repair the electrical and mechanical systems in the fountain vault, and to provide additional electrical service outlets throughout the park and in the southern median. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "PP03-248",
         "APN": 24944059,
         "File Number": "PP03-248",
         "Address": " ",
         "Project Name": " ",
         "Application Type": "Exemption ",
         "Application Date": "8/1/03",
         "Status": "Complete ",
         "Description": "City Landmark Designation for the Moody Flats Apartment Building ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "PP03-302",
         "APN": 25935056,
         "File Number": "PP03-302",
         "Address": " ",
         "Project Name": " ",
         "Application Type": "Exemption ",
         "Application Date": "9/18/03",
         "Status": "Complete ",
         "Description": "Adoption of a resolution approving an Exclusive Negotiations Agreement with Farmers Union-Cuccuza Family Partnerships for a 120-day term for the proposed sale of the Storm Property at 73-75 North San Pedro Street and its subsequent rehabilitation and use",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "PP03-318",
         "APN": 26429065,
         "File Number": "PP03-318",
         "Address": " ",
         "Project Name": " ",
         "Application Type": "Exemption ",
         "Application Date": "10/15/03",
         "Status": "Complete ",
         "Description": "Extend business hours to 2:30am, allow sidewalk cafe, beer and wine sales, and serve the water pipe (hookah) outside.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "PP03-329",
         "APN": 46721002,
         "File Number": "PP03-329",
         "Address": " ",
         "Project Name": " ",
         "Application Type": "Exemption ",
         "Application Date": "10/21/03",
         "Status": "Complete ",
         "Description": "Third Street Garage seismic upgrade ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "PP03-379",
         "APN": 46747098,
         "File Number": "PP03-379",
         "Address": " ",
         "Project Name": "Lease extension at 490 S. 1st St.",
         "Application Type": "Exemption ",
         "Application Date": "12/10/03",
         "Status": "Complete ",
         "Description": "Extension of terms of lease of building. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "PP03-390",
         "APN": 47226036,
         "File Number": "PP03-390",
         "Address": " ",
         "Project Name": "Agreement for R.E.A.L.Loan ",
         "Application Type": "Exemption ",
         "Application Date": "12/18/03",
         "Status": "Complete ",
         "Description": "REAL (Retail, Entertainment and Arts Loan) loan to partially fund interior and exterior improvements to existing building. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "PP03-396",
         "APN": 46723074,
         "File Number": "PP03-396",
         "Address": " ",
         "Project Name": "Lee's Sandwich Fourth Street Garage Lease ",
         "Application Type": "Exemption ",
         "Application Date": "12/22/03",
         "Status": "Complete ",
         "Description": "Lease of existing tenant space for restaurant. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "PP04-045",
         "APN": 46724031,
         "File Number": "PP04-045",
         "Address": " ",
         "Project Name": "84 S. Sixth Street",
         "Application Type": "Exemption ",
         "Application Date": "2/17/04",
         "Status": "Complete ",
         "Description": "Adoption of a resolution to: (a) Initiate proceedings to consider the Nevills-Campisi House (84 S. Sixth Street) a landmark of special historic, architectural, cultural, aesthetic or engineering interest or value of a historic nature, HL03-149. (b) Set a public hearing on April 27, 2004, at 1:30 p.m. (c) Refer the matter back to the Historic Landmarks Commission for its consideration at a public hearing, report and recommendation.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2004
      },
      {
         "PERMITID": "PP04-125",
         "APN": 25942023,
         "File Number": "PP04-125",
         "Address": " ",
         "Project Name": "McCabe Hall HVAC Improvements (The Tech) ",
         "Application Type": "Exemption ",
         "Application Date": "4/19/04",
         "Status": "Complete ",
         "Description": "Replacement of HVAC system / equipment in original location and size. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2004
      },
      {
         "PERMITID": "PP99-203",
         "APN": 25941078,
         "File Number": "PP99-203",
         "Address": " ",
         "Project Name": " ",
         "Application Type": "Exemption ",
         "Application Date": "10/14/99",
         "Status": "Complete ",
         "Description": "renovation of the HVAC and Control System at the Art Museum ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 1999
      }
   ],
   "Exemption Application ": [
      {
         "PERMITID": "PP08-155",
         "APN": 46721002,
         "File Number": "PP08-155",
         "Address": "95 N 3RD ST SAN JOSE",
         "Project Name": "PP08-155",
         "Application Type": "Exemption Application ",
         "Application Date": "7/22/08 9:57",
         "Status": "Complete ",
         "Description": "Third Street Garage Staircase Replacement Project for the design build replacement of two staircases and the structural/architectural renovation of a third staircase, including plumbing and electrical systems renovations to provide drainage from stair landings, the replacement of garage exit doors and the addition of guardrails and guardrail pickets. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2008
      },
      {
         "PERMITID": "PP10-156",
         "APN": 25942023,
         "File Number": "PP10-156",
         "Address": "201 S MARKET ST SAN JOSE",
         "Project Name": "PP10-156",
         "Application Type": "Exemption Application ",
         "Application Date": "9/1/10 13:18",
         "Status": "Complete ",
         "Description": "Public project exemption to replacve HVAC equipment at the Montgomery Theater / Civic Auditorium ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2010
      },
      {
         "PERMITID": "PP15-026",
         "APN": 47228001,
         "File Number": "PP15-026",
         "Address": "503 S 6TH ST SAN JOSE",
         "Project Name": "PP15-026 - O'Donnell's Garden Park Pedestrian Light Poles",
         "Application Type": "Exemption Application ",
         "Application Date": "3/18/15 14:58",
         "Status": "Complete ",
         "Description": "Public Project Exemption for the installation of two12 foot tall pedestrian light poles within an existing park (O'Donnell's Garden Park). The project includes minor excavation to construct the pedestal and trenching (not more than two and a half feet) to install electrical conduit in PVC casing. The lamps shall be illuminated with low pressure sodium bulbs.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "PP95-088",
         "APN": 46721034,
         "File Number": "PP95-088",
         "Address": "4 N 2ND ST SAN JOSE",
         "Project Name": "4 N. 2nd Street",
         "Application Type": "Exemption Application ",
         "Application Date": "5/18/95",
         "Status": "Complete ",
         "Description": "Lease Agreement for existing office space to be used by the Department of Streets and Parks ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 1995
      },
      {
         "PERMITID": "PP95-155",
         "APN": 25935029,
         "File Number": "PP95-155",
         "Address": "99 NOTRE DAME AV SAN JOSE",
         "Project Name": "99 NOTRE DAME AV",
         "Application Type": "Exemption Application ",
         "Application Date": "9/18/95",
         "Status": "Complete ",
         "Description": "Lease of office space to PRNS ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 1995
      },
      {
         "PERMITID": "2015 010568 PP",
         "APN": 47228001,
         "File Number": "2015 010568 PP",
         "Address": "503 S 6TH ST SAN JOSE",
         "Project Name": "O'Donnell's Garden Park ",
         "Application Type": "Exemption Application ",
         "Application Date": "3/18/15 10:58",
         "Status": "New ",
         "Description": "Public Project Exemption for the installation of two 12 foot tall pedestrian light poles in an existing public park (O'Donnell's Garden Park). Construction will include minor excavation to insert the footing pedestal and linear trenching (not more than two and a half feet) to install underground PVC piping to case electrical conduit and existing irrigation lines.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "PP06-145",
         "APN": 46721023,
         "File Number": "PP06-145",
         "Address": "2 N 1ST ST SAN JOSE",
         "Project Name": "PP06-145",
         "Application Type": "Exemption Application ",
         "Application Date": "9/11/06 14:57",
         "Status": "Under Review ",
         "Description": "Facade changes including new storefronts, entryways, and lighting, in conformance with the approved plans and conditions of approval for Permit Adjustment file no. AD06-132",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2006
      },
      {
         "PERMITID": "PP14-095",
         "APN": 46724012,
         "File Number": "PP14-095",
         "Address": "80 S 5TH ST SAN JOSE",
         "Project Name": "PP14-095 - Recovery Cafe",
         "Application Type": "Exemption Application ",
         "Application Date": "11/25/14 16:47",
         "Status": "Under Review ",
         "Description": "Public Project Exemption for interior changes to an existing legal nonconforming facility listed as a Structure of Merit on the City's Historic Resources Inventory. The scope of work includes: remodeling an assembly room/social hall to create a café environment (i.e. tables, chairs, food service, coffee bar, and library); the remodeling of two classrooms, renovating the existing commercial kitchen to include new electrical, plumbing, and piping; and new electrical service from the street ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "PP15-104",
         "APN": 46720080,
         "File Number": "PP15-104",
         "Address": "60 N 3RD ST SAN JOSE",
         "Project Name": "PP15-104 Town Park Towers",
         "Application Type": "Exemption Application ",
         "Application Date": "10/6/15 10:44",
         "Status": "Under Review ",
         "Description": "Public Project Exemption for the acquisition and rehabilitation of existing 216 studio and one-bedroom rental apartment apartments, located within an existing 10-story building (Town Park Towers)",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "PP15-105",
         "APN": 25942082,
         "File Number": "PP15-105",
         "Address": "200 S MARKET ST SAN JOSE",
         "Project Name": "PP15-105",
         "Application Type": "Exemption Application ",
         "Application Date": "10/13/15 13:11",
         "Status": "Under Review ",
         "Description": "Public Project Exemption request for the APPROVAL OF THE ISSUANCE OF TAX-EXEMPT MULTIFAMILY HOUSING REVENUE BONDS AND THE LOAN OF BOND PROCEEDS AND RELATED DOCUMENTS FOR CASA DEL PUEBLO APARTMENTS  ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "PP19-030",
         "APN": 46723100,
         "File Number": "PP19-030",
         "Address": "88 S 4TH ST SAN JOSE",
         "Project Name": "PP19-030",
         "Application Type": "Exemption Application ",
         "Application Date": "4/12/19 12:56",
         "Status": "Under Review ",
         "Description": "public project exemption for the financing for the construction of a full build-out of existing space within the 4th and San Fernando Garage for office space which will be occupied by the San José Community Energy Department",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2019
      },
      {
         "PERMITID": "PP19-030",
         "APN": 46723101,
         "File Number": "PP19-030",
         "Address": "88 S 4TH ST SAN JOSE",
         "Project Name": "PP19-030",
         "Application Type": "Exemption Application ",
         "Application Date": "4/12/19 12:56",
         "Status": "Under Review ",
         "Description": "public project exemption for the financing for the construction of a full build-out of existing space within the 4th and San Fernando Garage for office space which will be occupied by the San José Community Energy Department",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2019
      },
      {
         "PERMITID": "PP05-090",
         "APN": 46746075,
         "File Number": "PP05-090",
         "Address": "366 S 1ST ST SAN JOSE",
         "Project Name": "PP05-090 Lease for 366 South First",
         "Application Type": "Exemption Application ",
         "Application Date": "4/20/05 9:29",
         "Status": "Withdrawn ",
         "Description": "Lease of 366 South First Street to Brian Eder and Cherri Lakey, dba Two Fish Design Group",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2005
      }
   ],
   "GP Amendment Legacy ": [
      {
         "PERMITID": "GP00-03-05a",
         "APN": 25938142,
         "File Number": "GP00-03-05a",
         "Address": "384 W SANTA CLARA ST SAN JOSE",
         "Project Name": "GP00-03-05a",
         "Application Type": "GP Amendment Legacy ",
         "Application Date": "8/7/01 11:23",
         "Status": "Approved ",
         "Description": "change GP designation from GC to Residential Support for the Core Area (25+ DU/AC)",
         "Planner": "Jennifer Piozet ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "GP01-06-01",
         "APN": 26411102,
         "File Number": "GP01-06-01",
         "Address": "862 SAVAKER AV SAN JOSE",
         "Project Name": "GP01-06-01 (Reed and Graham)",
         "Application Type": "GP Amendment Legacy ",
         "Application Date": "5/25/01",
         "Status": "Approved ",
         "Description": "General Plan amendment to change the land use designation of the site from Heavy Industrial to Mixed Use with No Underlying Land Use Designation ",
         "Planner": "Deanna Chow ",
         "DURATION": 60,
         "Year": 2001
      },
      {
         "PERMITID": "GP01-06-01",
         "APN": 26411103,
         "File Number": "GP01-06-01",
         "Address": "862 SAVAKER AV SAN JOSE",
         "Project Name": "GP01-06-01 (Reed and Graham)",
         "Application Type": "GP Amendment Legacy ",
         "Application Date": "5/25/01",
         "Status": "Approved ",
         "Description": "General Plan amendment to change the land use designation of the site from Heavy Industrial to Mixed Use with No Underlying Land Use Designation ",
         "Planner": "Deanna Chow ",
         "DURATION": 60,
         "Year": 2001
      },
      {
         "PERMITID": "GP01-T-03",
         "APN": 25938036,
         "File Number": "GP01-T-03",
         "Address": "384 W SANTA CLARA ST SAN JOSE",
         "Project Name": "GP01-T-03",
         "Application Type": "GP Amendment Legacy ",
         "Application Date": "2/27/01",
         "Status": "Approved ",
         "Description": "modify Urban Design Policies to allow max bldg hts to be defined by airspace requirements of the SJ Airport for above property ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2001
      },
      {
         "PERMITID": "GP01-T-03",
         "APN": 25938142,
         "File Number": "GP01-T-03",
         "Address": "384 W SANTA CLARA ST SAN JOSE",
         "Project Name": "GP01-T-03",
         "Application Type": "GP Amendment Legacy ",
         "Application Date": "2/27/01",
         "Status": "Approved ",
         "Description": "modify Urban Design Policies to allow max bldg hts to be defined by airspace requirements of the SJ Airport for above property ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2001
      },
      {
         "PERMITID": "GP01-T-03",
         "APN": 25938146,
         "File Number": "GP01-T-03",
         "Address": "384 W SANTA CLARA ST SAN JOSE",
         "Project Name": "GP01-T-03",
         "Application Type": "GP Amendment Legacy ",
         "Application Date": "2/27/01",
         "Status": "Approved ",
         "Description": "modify Urban Design Policies to allow max bldg hts to be defined by airspace requirements of the SJ Airport for above property ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2001
      },
      {
         "PERMITID": "GP87-008",
         "APN": 46722002,
         "File Number": "GP87-008",
         "Address": "26 S 1ST ST SAN JOSE",
         "Project Name": "GP87-008",
         "Application Type": "GP Amendment Legacy ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "ADD RESIDENTIAL SUPPORT FOR CORE 25+ DU/AC; Other APNs:THRU 009,030,031,038 THRU 045,097,110,121",
         "Planner": "Kimberly Vacca ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "GP87-012",
         "APN": 46720072,
         "File Number": "GP87-012",
         "Address": "101 E SANTA CLARA ST SAN JOSE",
         "Project Name": "GP87-012",
         "Application Type": "GP Amendment Legacy ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "CORE AREA COM W RES SUPPORT FOR CORE 25+ OVERLAY; Other APNs:078,079",
         "Planner": "Kimberly Vacca ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "GP87-25B",
         "APN": 46724110,
         "File Number": "GP87-25B",
         "Address": "268 E SANTA CLARA ST SAN JOSE",
         "Project Name": "GP87-25B",
         "Application Type": "GP Amendment Legacy ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "NEIGHBORHOOD/COMM COMM TO GEN COMMERCIAL; Other APNs:111",
         "Planner": "Nancy Hemmen ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "GP89-002",
         "APN": 25938036,
         "File Number": "GP89-002",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "GP89-002",
         "Application Type": "GP Amendment Legacy ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "PROPOSED GEN COMM; Other APNs:039, 040, 047, 111, VARIUOS",
         "Planner": "Nancy Hemmen ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "GP89-003",
         "APN": 25938142,
         "File Number": "GP89-003",
         "Address": "384 W SANTA CLARA ST SAN JOSE",
         "Project Name": "GP89-003",
         "Application Type": "GP Amendment Legacy ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "PROPOSED GEN COMM ",
         "Planner": "Nancy Hemmen ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "GP01-3-11",
         "APN": 46720001,
         "File Number": "GP01-3-11",
         "Address": "99 N 5TH ST SAN JOSE",
         "Project Name": "GP01-11",
         "Application Type": "GP Amendment Legacy ",
         "Application Date": "5/29/01",
         "Status": "Complete ",
         "Description": "General Plan amendment to change the land use designation of the site from General Commercial to Residential Support for the Core Area (25+ DU/AC) on approximately 0.4 acres",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "GP01-3-11",
         "APN": 46720002,
         "File Number": "GP01-3-11",
         "Address": "99 N 5TH ST SAN JOSE",
         "Project Name": "GP01-11",
         "Application Type": "GP Amendment Legacy ",
         "Application Date": "5/29/01",
         "Status": "Complete ",
         "Description": "General Plan amendment to change the land use designation of the site from General Commercial to Residential Support for the Core Area (25+ DU/AC) on approximately 0.4 acres",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "GPT01-06-01",
         "APN": 26411103,
         "File Number": "GPT01-06-01",
         "Address": "862 SAVAKER AV SAN JOSE",
         "Project Name": "Reed and Graham ",
         "Application Type": "GP Amendment Legacy ",
         "Application Date": "5/25/01",
         "Status": "Complete ",
         "Description": "Amend Appendix F: Mixed Use Inventory to describe Mixed Use designation for above property and to increase the maximum building height to 220 feet for office uses.",
         "Planner": "Deanna Chow ",
         "DURATION": 60,
         "Year": 2001
      },
      {
         "PERMITID": "GP00-03-05b",
         "APN": 25938142,
         "File Number": "GP00-03-05b",
         "Address": "384 W SANTA CLARA ST SAN JOSE",
         "Project Name": "GP00-03-05b",
         "Application Type": "GP Amendment Legacy ",
         "Application Date": "3/1/01",
         "Status": "Denied ",
         "Description": "change GP desig from General Commercial to Residential Support for the Core ",
         "Planner": "Jennifer Piozet ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "GP01-T-26",
         "APN": 46720085,
         "File Number": "GP01-T-26",
         "Address": "155 E SANTA CLARA ST SAN JOSE",
         "Project Name": "GP01-T-26/GP01-03-11 - 1st Methodist Church",
         "Application Type": "GP Amendment Legacy ",
         "Application Date": "5/29/01",
         "Status": "Withdrawn ",
         "Description": "Modify the General Plan Urban Design Policies to allow maximum building heights per the Federal Aviation Administration regulations for the above property ",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2001
      }
   ],
   "GP Diagram Amendment ": [
      {
         "PERMITID": "GP03-03-09",
         "APN": 25945052,
         "File Number": "GP03-03-09",
         "Address": "398 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "GP03-03-09",
         "Application Type": "GP Diagram Amendment ",
         "Application Date": "3/18/03",
         "Status": "Approved ",
         "Description": "General Plan amendment request to change the Land Use/Transportation Diagram designation from Residential Support for the Core (25-50 DU/AC) to Medium Density Residential (8-16 DU/AC) on a 5.52 acre site. (Various, Owner/Staff, Applicant)",
         "Planner": "Patrice Shaffer ",
         "DURATION": 854,
         "Year": 2003
      },
      {
         "PERMITID": "GP03-03-09",
         "APN": 25945057,
         "File Number": "GP03-03-09",
         "Address": "398 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "GP03-03-09",
         "Application Type": "GP Diagram Amendment ",
         "Application Date": "3/18/03",
         "Status": "Approved ",
         "Description": "General Plan amendment request to change the Land Use/Transportation Diagram designation from Residential Support for the Core (25-50 DU/AC) to Medium Density Residential (8-16 DU/AC) on a 5.52 acre site. (Various, Owner/Staff, Applicant)",
         "Planner": "Patrice Shaffer ",
         "DURATION": 854,
         "Year": 2003
      },
      {
         "PERMITID": "GP03-03-09",
         "APN": 25945070,
         "File Number": "GP03-03-09",
         "Address": "398 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "GP03-03-09",
         "Application Type": "GP Diagram Amendment ",
         "Application Date": "3/18/03",
         "Status": "Approved ",
         "Description": "General Plan amendment request to change the Land Use/Transportation Diagram designation from Residential Support for the Core (25-50 DU/AC) to Medium Density Residential (8-16 DU/AC) on a 5.52 acre site. (Various, Owner/Staff, Applicant)",
         "Planner": "Patrice Shaffer ",
         "DURATION": 854,
         "Year": 2003
      },
      {
         "PERMITID": "GP03-03-09",
         "APN": 25945077,
         "File Number": "GP03-03-09",
         "Address": "398 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "GP03-03-09",
         "Application Type": "GP Diagram Amendment ",
         "Application Date": "3/18/03",
         "Status": "Approved ",
         "Description": "General Plan amendment request to change the Land Use/Transportation Diagram designation from Residential Support for the Core (25-50 DU/AC) to Medium Density Residential (8-16 DU/AC) on a 5.52 acre site. (Various, Owner/Staff, Applicant)",
         "Planner": "Patrice Shaffer ",
         "DURATION": 854,
         "Year": 2003
      },
      {
         "PERMITID": "GP03-03-10",
         "APN": 26419007,
         "File Number": "GP03-03-10",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "GP03-03-10",
         "Application Type": "GP Diagram Amendment ",
         "Application Date": "3/18/03",
         "Status": "Approved ",
         "Description": "General Plan amendment request to change the Land Use/Transportation Diagram designation from Residential Support for the Core (25-50 DU/AC) to Medium Density Residential (8-16 DU/AC) on 14.62 ac., Neighborhood/Community Commercial on 1.16 ac., Public Park / Open Space on 0.96 ac and Public/Quasi-Public on 0.4 ac. for a 17.14 ac. site, (Various, Owner/Staff, Applicant)",
         "Planner": "Patrice Shaffer ",
         "DURATION": 827,
         "Year": 2003
      },
      {
         "PERMITID": "GP03-03-10",
         "APN": 26419037,
         "File Number": "GP03-03-10",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "GP03-03-10",
         "Application Type": "GP Diagram Amendment ",
         "Application Date": "3/18/03",
         "Status": "Approved ",
         "Description": "General Plan amendment request to change the Land Use/Transportation Diagram designation from Residential Support for the Core (25-50 DU/AC) to Medium Density Residential (8-16 DU/AC) on 14.62 ac., Neighborhood/Community Commercial on 1.16 ac., Public Park / Open Space on 0.96 ac and Public/Quasi-Public on 0.4 ac. for a 17.14 ac. site, (Various, Owner/Staff, Applicant)",
         "Planner": "Patrice Shaffer ",
         "DURATION": 827,
         "Year": 2003
      },
      {
         "PERMITID": "GP03-03-10",
         "APN": 26420041,
         "File Number": "GP03-03-10",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "GP03-03-10",
         "Application Type": "GP Diagram Amendment ",
         "Application Date": "3/18/03",
         "Status": "Approved ",
         "Description": "General Plan amendment request to change the Land Use/Transportation Diagram designation from Residential Support for the Core (25-50 DU/AC) to Medium Density Residential (8-16 DU/AC) on 14.62 ac., Neighborhood/Community Commercial on 1.16 ac., Public Park / Open Space on 0.96 ac and Public/Quasi-Public on 0.4 ac. for a 17.14 ac. site, (Various, Owner/Staff, Applicant)",
         "Planner": "Patrice Shaffer ",
         "DURATION": 827,
         "Year": 2003
      },
      {
         "PERMITID": "GP03-03-10",
         "APN": 26420047,
         "File Number": "GP03-03-10",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "GP03-03-10",
         "Application Type": "GP Diagram Amendment ",
         "Application Date": "3/18/03",
         "Status": "Approved ",
         "Description": "General Plan amendment request to change the Land Use/Transportation Diagram designation from Residential Support for the Core (25-50 DU/AC) to Medium Density Residential (8-16 DU/AC) on 14.62 ac., Neighborhood/Community Commercial on 1.16 ac., Public Park / Open Space on 0.96 ac and Public/Quasi-Public on 0.4 ac. for a 17.14 ac. site, (Various, Owner/Staff, Applicant)",
         "Planner": "Patrice Shaffer ",
         "DURATION": 827,
         "Year": 2003
      },
      {
         "PERMITID": "GP03-03-10",
         "APN": 26420051,
         "File Number": "GP03-03-10",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "GP03-03-10",
         "Application Type": "GP Diagram Amendment ",
         "Application Date": "3/18/03",
         "Status": "Approved ",
         "Description": "General Plan amendment request to change the Land Use/Transportation Diagram designation from Residential Support for the Core (25-50 DU/AC) to Medium Density Residential (8-16 DU/AC) on 14.62 ac., Neighborhood/Community Commercial on 1.16 ac., Public Park / Open Space on 0.96 ac and Public/Quasi-Public on 0.4 ac. for a 17.14 ac. site, (Various, Owner/Staff, Applicant)",
         "Planner": "Patrice Shaffer ",
         "DURATION": 827,
         "Year": 2003
      },
      {
         "PERMITID": "GP03-03-10",
         "APN": 26420126,
         "File Number": "GP03-03-10",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "GP03-03-10",
         "Application Type": "GP Diagram Amendment ",
         "Application Date": "3/18/03",
         "Status": "Approved ",
         "Description": "General Plan amendment request to change the Land Use/Transportation Diagram designation from Residential Support for the Core (25-50 DU/AC) to Medium Density Residential (8-16 DU/AC) on 14.62 ac., Neighborhood/Community Commercial on 1.16 ac., Public Park / Open Space on 0.96 ac and Public/Quasi-Public on 0.4 ac. for a 17.14 ac. site, (Various, Owner/Staff, Applicant)",
         "Planner": "Patrice Shaffer ",
         "DURATION": 827,
         "Year": 2003
      },
      {
         "PERMITID": "GP03-03-10",
         "APN": 26421003,
         "File Number": "GP03-03-10",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "GP03-03-10",
         "Application Type": "GP Diagram Amendment ",
         "Application Date": "3/18/03",
         "Status": "Approved ",
         "Description": "General Plan amendment request to change the Land Use/Transportation Diagram designation from Residential Support for the Core (25-50 DU/AC) to Medium Density Residential (8-16 DU/AC) on 14.62 ac., Neighborhood/Community Commercial on 1.16 ac., Public Park / Open Space on 0.96 ac and Public/Quasi-Public on 0.4 ac. for a 17.14 ac. site, (Various, Owner/Staff, Applicant)",
         "Planner": "Patrice Shaffer ",
         "DURATION": 827,
         "Year": 2003
      },
      {
         "PERMITID": "GP03-03-10",
         "APN": 26421005,
         "File Number": "GP03-03-10",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "GP03-03-10",
         "Application Type": "GP Diagram Amendment ",
         "Application Date": "3/18/03",
         "Status": "Approved ",
         "Description": "General Plan amendment request to change the Land Use/Transportation Diagram designation from Residential Support for the Core (25-50 DU/AC) to Medium Density Residential (8-16 DU/AC) on 14.62 ac., Neighborhood/Community Commercial on 1.16 ac., Public Park / Open Space on 0.96 ac and Public/Quasi-Public on 0.4 ac. for a 17.14 ac. site, (Various, Owner/Staff, Applicant)",
         "Planner": "Patrice Shaffer ",
         "DURATION": 827,
         "Year": 2003
      },
      {
         "PERMITID": "GP03-03-10",
         "APN": 26421068,
         "File Number": "GP03-03-10",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "GP03-03-10",
         "Application Type": "GP Diagram Amendment ",
         "Application Date": "3/18/03",
         "Status": "Approved ",
         "Description": "General Plan amendment request to change the Land Use/Transportation Diagram designation from Residential Support for the Core (25-50 DU/AC) to Medium Density Residential (8-16 DU/AC) on 14.62 ac., Neighborhood/Community Commercial on 1.16 ac., Public Park / Open Space on 0.96 ac and Public/Quasi-Public on 0.4 ac. for a 17.14 ac. site, (Various, Owner/Staff, Applicant)",
         "Planner": "Patrice Shaffer ",
         "DURATION": 827,
         "Year": 2003
      },
      {
         "PERMITID": "GP03-03-10",
         "APN": 26421069,
         "File Number": "GP03-03-10",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "GP03-03-10",
         "Application Type": "GP Diagram Amendment ",
         "Application Date": "3/18/03",
         "Status": "Approved ",
         "Description": "General Plan amendment request to change the Land Use/Transportation Diagram designation from Residential Support for the Core (25-50 DU/AC) to Medium Density Residential (8-16 DU/AC) on 14.62 ac., Neighborhood/Community Commercial on 1.16 ac., Public Park / Open Space on 0.96 ac and Public/Quasi-Public on 0.4 ac. for a 17.14 ac. site, (Various, Owner/Staff, Applicant)",
         "Planner": "Patrice Shaffer ",
         "DURATION": 827,
         "Year": 2003
      },
      {
         "PERMITID": "GP03-03-10",
         "APN": 26426025,
         "File Number": "GP03-03-10",
         "Address": "445 AUZERAIS AV SAN JOSE",
         "Project Name": "GP03-03-10",
         "Application Type": "GP Diagram Amendment ",
         "Application Date": "3/18/03",
         "Status": "Approved ",
         "Description": "General Plan amendment request to change the Land Use/Transportation Diagram designation from Residential Support for the Core (25-50 DU/AC) to Medium Density Residential (8-16 DU/AC) on 14.62 ac., Neighborhood/Community Commercial on 1.16 ac., Public Park / Open Space on 0.96 ac and Public/Quasi-Public on 0.4 ac. for a 17.14 ac. site, (Various, Owner/Staff, Applicant)",
         "Planner": "Patrice Shaffer ",
         "DURATION": 827,
         "Year": 2003
      },
      {
         "PERMITID": "GP03-03-17",
         "APN": 47222060,
         "File Number": "GP03-03-17",
         "Address": "770 S 12TH ST SAN JOSE",
         "Project Name": "GP03-03-17",
         "Application Type": "GP Diagram Amendment ",
         "Application Date": "10/2/03",
         "Status": "Approved ",
         "Description": "General Plan amendment request to change the Land Use / Transportation Diagram designation from Medium Low Density Residential (8 DU/AC) on 0.9 acres and Medium High Density Residential (12-25 DU/AC) on 7.3 acres to Medium Density Residential (8-16 DU/AC) on a 8.2-acre site. (San Jose Bible College, owner / HMH, Applicant)",
         "Planner": "Susan Walton ",
         "DURATION": 3308,
         "Year": 2003
      },
      {
         "PERMITID": "GP03-03-17",
         "APN": 47222062,
         "File Number": "GP03-03-17",
         "Address": "770 S 12TH ST SAN JOSE",
         "Project Name": "GP03-03-17",
         "Application Type": "GP Diagram Amendment ",
         "Application Date": "10/2/03",
         "Status": "Approved ",
         "Description": "General Plan amendment request to change the Land Use / Transportation Diagram designation from Medium Low Density Residential (8 DU/AC) on 0.9 acres and Medium High Density Residential (12-25 DU/AC) on 7.3 acres to Medium Density Residential (8-16 DU/AC) on a 8.2-acre site. (San Jose Bible College, owner / HMH, Applicant)",
         "Planner": "Susan Walton ",
         "DURATION": 3308,
         "Year": 2003
      },
      {
         "PERMITID": "GP03-06-07",
         "APN": 26411112,
         "File Number": "GP03-06-07",
         "Address": "496 SUNOL ST SAN JOSE",
         "Project Name": "GP03-06-07 (HOS III)",
         "Application Type": "GP Diagram Amendment ",
         "Application Date": "8/20/03",
         "Status": "Approved ",
         "Description": "General Plan amendment request to change the Land Use/Transportation Diagram designation on 6.7 acres from Combined Industrial/Commercial to Public Park and Open Space (Midtown Planned Community). (Applicant: Staff)",
         "Planner": "Dionne Early ",
         "DURATION": 1743,
         "Year": 2003
      },
      {
         "PERMITID": "GP05-03-01",
         "APN": 25924035,
         "File Number": "GP05-03-01",
         "Address": "255 N AUTUMN ST SAN JOSE",
         "Project Name": "GP05-03-01 Downtown Strategy 2000 and more",
         "Application Type": "GP Diagram Amendment ",
         "Application Date": "1/26/05",
         "Status": "Approved ",
         "Description": "GENERAL PLAN AMENDMENT request to change the Land Use/Transportation Diagram designation from Combined Industrial/Commercial to General Commercial, Public/Quasi-Public, Office, Light Industrial with Mixed Industrial Overlay, and Public Park/Open Space on a 47.72-acre site. (Various, Owner/RDA-Dennis Korabiak, Applicant)",
         "Planner": "Dionne Early ",
         "DURATION": 2043,
         "Year": 2005
      },
      {
         "PERMITID": "GP05-03-01",
         "APN": 25937059,
         "File Number": "GP05-03-01",
         "Address": "255 N AUTUMN ST SAN JOSE",
         "Project Name": "GP05-03-01 Downtown Strategy 2000 and more",
         "Application Type": "GP Diagram Amendment ",
         "Application Date": "1/26/05",
         "Status": "Approved ",
         "Description": "GENERAL PLAN AMENDMENT request to change the Land Use/Transportation Diagram designation from Combined Industrial/Commercial to General Commercial, Public/Quasi-Public, Office, Light Industrial with Mixed Industrial Overlay, and Public Park/Open Space on a 47.72-acre site. (Various, Owner/RDA-Dennis Korabiak, Applicant)",
         "Planner": "Dionne Early ",
         "DURATION": 2043,
         "Year": 2005
      },
      {
         "PERMITID": "GP14-003",
         "APN": 46701069,
         "File Number": "GP14-003",
         "Address": "298 N 4TH ST SAN JOSE",
         "Project Name": "GP14-003",
         "Application Type": "GP Diagram Amendment ",
         "Application Date": "2/25/14",
         "Status": "Approved ",
         "Description": "Director-Initiated General Plan Amendment request to change the Land-Use/Transportation Diagram land use designation from Residential Neighborhood to Mixed Use Neighborhood(?) on a 0.43 gross acre site",
         "Planner": "Emily Lipoma ",
         "DURATION": 378,
         "Year": 2014
      },
      {
         "PERMITID": "GP14-003",
         "APN": 46701080,
         "File Number": "GP14-003",
         "Address": "298 N 4TH ST SAN JOSE",
         "Project Name": "GP14-003",
         "Application Type": "GP Diagram Amendment ",
         "Application Date": "2/25/14",
         "Status": "Approved ",
         "Description": "Director-Initiated General Plan Amendment request to change the Land-Use/Transportation Diagram land use designation from Residential Neighborhood to Mixed Use Neighborhood(?) on a 0.43 gross acre site",
         "Planner": "Emily Lipoma ",
         "DURATION": 378,
         "Year": 2014
      },
      {
         "PERMITID": "GP14-003",
         "APN": 46701120,
         "File Number": "GP14-003",
         "Address": "298 N 4TH ST SAN JOSE",
         "Project Name": "GP14-003",
         "Application Type": "GP Diagram Amendment ",
         "Application Date": "2/25/14",
         "Status": "Approved ",
         "Description": "Director-Initiated General Plan Amendment request to change the Land-Use/Transportation Diagram land use designation from Residential Neighborhood to Mixed Use Neighborhood(?) on a 0.43 gross acre site",
         "Planner": "Emily Lipoma ",
         "DURATION": 378,
         "Year": 2014
      },
      {
         "PERMITID": "2014 005724 AO",
         "APN": 46701120,
         "File Number": "2014 005724 AO",
         "Address": "298 N 4TH ST SAN JOSE",
         "Project Name": "77 N 4TH ST",
         "Application Type": "GP Diagram Amendment ",
         "Application Date": "2/11/14",
         "Status": "New ",
         "Description": "A General Plan Amendment request to change the Land-Use/Transportation Diagram land use designation from ..... and ........ on the subject .... gross acre site ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "GP16-013",
         "APN": 46720020,
         "File Number": "GP16-013",
         "Address": "120 N 4TH ST SAN JOSE",
         "Project Name": "GP16-013 - 100 North 4th Street",
         "Application Type": "GP Diagram Amendment ",
         "Application Date": "11/4/16 10:47",
         "Status": "Notice Sent ",
         "Description": "General Plan Amendment to change the land use designation from Residential Neighborhood and Transit Residential to Downtown, and expand the Downtown Growth Boundary on approximately 0.91 acres. All subsequent applications (Rezoning, Tentative Map, and Site Development Permit were withdrawn prior to the CC hearing)",
         "Planner": "Kimberly Vacca ",
         "DURATION": 403,
         "Year": 2016
      },
      {
         "PERMITID": "GP16-013",
         "APN": 46720021,
         "File Number": "GP16-013",
         "Address": "120 N 4TH ST SAN JOSE",
         "Project Name": "GP16-013 - 100 North 4th Street",
         "Application Type": "GP Diagram Amendment ",
         "Application Date": "11/4/16 10:47",
         "Status": "Notice Sent ",
         "Description": "General Plan Amendment to change the land use designation from Residential Neighborhood and Transit Residential to Downtown, and expand the Downtown Growth Boundary on approximately 0.91 acres. All subsequent applications (Rezoning, Tentative Map, and Site Development Permit were withdrawn prior to the CC hearing)",
         "Planner": "Kimberly Vacca ",
         "DURATION": 403,
         "Year": 2016
      },
      {
         "PERMITID": "GP16-013",
         "APN": 46720022,
         "File Number": "GP16-013",
         "Address": "120 N 4TH ST SAN JOSE",
         "Project Name": "GP16-013 - 100 North 4th Street",
         "Application Type": "GP Diagram Amendment ",
         "Application Date": "11/4/16 10:47",
         "Status": "Notice Sent ",
         "Description": "General Plan Amendment to change the land use designation from Residential Neighborhood and Transit Residential to Downtown, and expand the Downtown Growth Boundary on approximately 0.91 acres. All subsequent applications (Rezoning, Tentative Map, and Site Development Permit were withdrawn prior to the CC hearing)",
         "Planner": "Kimberly Vacca ",
         "DURATION": 403,
         "Year": 2016
      },
      {
         "PERMITID": "GP02-03-07",
         "APN": 46721021,
         "File Number": "GP02-03-07",
         "Address": "38 N 1ST ST SAN JOSE",
         "Project Name": "GP02-03-07",
         "Application Type": "GP Diagram Amendment ",
         "Application Date": "5/22/02",
         "Status": "Withdrawn ",
         "Description": "A proposed amendment to the General Plan Land Use/Transportation Diagram from Core Area to Mixed Use with No Underlying Land Use Designation.  ",
         "Planner": "Michael Mena ",
         "DURATION": 19,
         "Year": 2002
      },
      {
         "PERMITID": "GP09-03-02",
         "APN": 47228054,
         "File Number": "GP09-03-02",
         "Address": "346 E WILLIAM ST SAN JOSE",
         "Project Name": "GP09-03-02",
         "Application Type": "GP Diagram Amendment ",
         "Application Date": "5/19/09",
         "Status": "Withdrawn ",
         "Description": "General Plan Amendment request to change the Land Use/Transportation Diagram designation from High Density Residential (25-50 DU/AC) to Residential Support for the Core (25+ DU/AC) on a 0.57 gross acre site",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 353,
         "Year": 2009
      },
      {
         "PERMITID": "GP09-03-02",
         "APN": 47228055,
         "File Number": "GP09-03-02",
         "Address": "346 E WILLIAM ST SAN JOSE",
         "Project Name": "GP09-03-02",
         "Application Type": "GP Diagram Amendment ",
         "Application Date": "5/19/09",
         "Status": "Withdrawn ",
         "Description": "General Plan Amendment request to change the Land Use/Transportation Diagram designation from High Density Residential (25-50 DU/AC) to Residential Support for the Core (25+ DU/AC) on a 0.57 gross acre site",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 353,
         "Year": 2009
      },
      {
         "PERMITID": "GP09-03-02",
         "APN": 47228056,
         "File Number": "GP09-03-02",
         "Address": "346 E WILLIAM ST SAN JOSE",
         "Project Name": "GP09-03-02",
         "Application Type": "GP Diagram Amendment ",
         "Application Date": "5/19/09",
         "Status": "Withdrawn ",
         "Description": "General Plan Amendment request to change the Land Use/Transportation Diagram designation from High Density Residential (25-50 DU/AC) to Residential Support for the Core (25+ DU/AC) on a 0.57 gross acre site",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 353,
         "Year": 2009
      }
   ],
   "GP Text Amendment ": [
      {
         "PERMITID": "GPT05-03-01",
         "APN": 25924035,
         "File Number": "GPT05-03-01",
         "Address": "255 N AUTUMN ST SAN JOSE",
         "Project Name": "GPT05-03-01",
         "Application Type": "GP Text Amendment ",
         "Application Date": "4/11/05",
         "Status": "Approved ",
         "Description": "GENERAL PLAN TEXT AMENDMENT request to change the boundary of the Downtown Core Area and associated Land Use changes (see GP05-03-01). (Various, Owner/RDA, Applicant)",
         "Planner": "Dionne Early ",
         "DURATION": 1968,
         "Year": 2005
      },
      {
         "PERMITID": "GPT05-03-01",
         "APN": 25937004,
         "File Number": "GPT05-03-01",
         "Address": "255 N AUTUMN ST SAN JOSE",
         "Project Name": "GPT05-03-01",
         "Application Type": "GP Text Amendment ",
         "Application Date": "4/11/05",
         "Status": "Approved ",
         "Description": "GENERAL PLAN TEXT AMENDMENT request to change the boundary of the Downtown Core Area and associated Land Use changes (see GP05-03-01). (Various, Owner/RDA, Applicant)",
         "Planner": "Dionne Early ",
         "DURATION": 1968,
         "Year": 2005
      },
      {
         "PERMITID": "GPT05-03-01",
         "APN": 25937043,
         "File Number": "GPT05-03-01",
         "Address": "255 N AUTUMN ST SAN JOSE",
         "Project Name": "GPT05-03-01",
         "Application Type": "GP Text Amendment ",
         "Application Date": "4/11/05",
         "Status": "Approved ",
         "Description": "GENERAL PLAN TEXT AMENDMENT request to change the boundary of the Downtown Core Area and associated Land Use changes (see GP05-03-01). (Various, Owner/RDA, Applicant)",
         "Planner": "Dionne Early ",
         "DURATION": 1968,
         "Year": 2005
      },
      {
         "PERMITID": "GPT05-03-01",
         "APN": 25937059,
         "File Number": "GPT05-03-01",
         "Address": "255 N AUTUMN ST SAN JOSE",
         "Project Name": "GPT05-03-01",
         "Application Type": "GP Text Amendment ",
         "Application Date": "4/11/05",
         "Status": "Approved ",
         "Description": "GENERAL PLAN TEXT AMENDMENT request to change the boundary of the Downtown Core Area and associated Land Use changes (see GP05-03-01). (Various, Owner/RDA, Applicant)",
         "Planner": "Dionne Early ",
         "DURATION": 1968,
         "Year": 2005
      },
      {
         "PERMITID": "GPT02-03-07",
         "APN": 46721021,
         "File Number": "GPT02-03-07",
         "Address": "38 N 1ST ST SAN JOSE",
         "Project Name": "GPT02-03-07",
         "Application Type": "GP Text Amendment ",
         "Application Date": "5/22/02",
         "Status": "Dropped ",
         "Description": "General Plan Text amendment to add to the Mixed Use Inventory in Appendix F. ",
         "Planner": "Michael Mena ",
         "DURATION": 275,
         "Year": 2002
      },
      {
         "PERMITID": "GPT18-009",
         "APN": 47217005,
         "File Number": "GPT18-009",
         "Address": "838 S 1ST ST SAN JOSE",
         "Project Name": "GPT18-009 Martha Gardens SP Height",
         "Application Type": "GP Text Amendment ",
         "Application Date": "11/1/18",
         "Status": "Review Letter Sent ",
         "Description": "Privately-initiated General Plan Text Amendment to the Martha Gardens Specific Plan to increase height allowances  ",
         "Planner": "Robert Rivera ",
         "DURATION": 51,
         "Year": 2018
      },
      {
         "PERMITID": "GPT18-009",
         "APN": 47217006,
         "File Number": "GPT18-009",
         "Address": "838 S 1ST ST SAN JOSE",
         "Project Name": "GPT18-009 Martha Gardens SP Height",
         "Application Type": "GP Text Amendment ",
         "Application Date": "11/1/18",
         "Status": "Review Letter Sent ",
         "Description": "Privately-initiated General Plan Text Amendment to the Martha Gardens Specific Plan to increase height allowances  ",
         "Planner": "Robert Rivera ",
         "DURATION": 51,
         "Year": 2018
      },
      {
         "PERMITID": "GPT18-009",
         "APN": 47217034,
         "File Number": "GPT18-009",
         "Address": "838 S 1ST ST SAN JOSE",
         "Project Name": "GPT18-009 Martha Gardens SP Height",
         "Application Type": "GP Text Amendment ",
         "Application Date": "11/1/18",
         "Status": "Review Letter Sent ",
         "Description": "Privately-initiated General Plan Text Amendment to the Martha Gardens Specific Plan to increase height allowances  ",
         "Planner": "Robert Rivera ",
         "DURATION": 51,
         "Year": 2018
      },
      {
         "PERMITID": "GPT18-009",
         "APN": 47217095,
         "File Number": "GPT18-009",
         "Address": "838 S 1ST ST SAN JOSE",
         "Project Name": "GPT18-009 Martha Gardens SP Height",
         "Application Type": "GP Text Amendment ",
         "Application Date": "11/1/18",
         "Status": "Review Letter Sent ",
         "Description": "Privately-initiated General Plan Text Amendment to the Martha Gardens Specific Plan to increase height allowances  ",
         "Planner": "Robert Rivera ",
         "DURATION": 51,
         "Year": 2018
      },
      {
         "PERMITID": "GP13-017",
         "APN": 46723010,
         "File Number": "GP13-017",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "GP13-017 Citywide Text Amendment",
         "Application Type": "GP Text Amendment ",
         "Application Date": "8/29/13",
         "Status": "Withdrawn ",
         "Description": "Director-initiated General Plan Text Amendment to clean-up LU-1.1 and LU-1.2 to eliminate redundant policy and mis-numbering",
         "Planner": "Rich Buikema ",
         "DURATION": 20,
         "Year": 2013
      },
      {
         "PERMITID": "GP13-017",
         "APN": 46723011,
         "File Number": "GP13-017",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "GP13-017 Citywide Text Amendment",
         "Application Type": "GP Text Amendment ",
         "Application Date": "8/29/13",
         "Status": "Withdrawn ",
         "Description": "Director-initiated General Plan Text Amendment to clean-up LU-1.1 and LU-1.2 to eliminate redundant policy and mis-numbering",
         "Planner": "Rich Buikema ",
         "DURATION": 20,
         "Year": 2013
      },
      {
         "PERMITID": "GP13-017",
         "APN": 46723013,
         "File Number": "GP13-017",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "GP13-017 Citywide Text Amendment",
         "Application Type": "GP Text Amendment ",
         "Application Date": "8/29/13",
         "Status": "Withdrawn ",
         "Description": "Director-initiated General Plan Text Amendment to clean-up LU-1.1 and LU-1.2 to eliminate redundant policy and mis-numbering",
         "Planner": "Rich Buikema ",
         "DURATION": 20,
         "Year": 2013
      },
      {
         "PERMITID": "GP13-017",
         "APN": 46723017,
         "File Number": "GP13-017",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "GP13-017 Citywide Text Amendment",
         "Application Type": "GP Text Amendment ",
         "Application Date": "8/29/13",
         "Status": "Withdrawn ",
         "Description": "Director-initiated General Plan Text Amendment to clean-up LU-1.1 and LU-1.2 to eliminate redundant policy and mis-numbering",
         "Planner": "Rich Buikema ",
         "DURATION": 20,
         "Year": 2013
      },
      {
         "PERMITID": "GP13-017",
         "APN": 46723018,
         "File Number": "GP13-017",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "GP13-017 Citywide Text Amendment",
         "Application Type": "GP Text Amendment ",
         "Application Date": "8/29/13",
         "Status": "Withdrawn ",
         "Description": "Director-initiated General Plan Text Amendment to clean-up LU-1.1 and LU-1.2 to eliminate redundant policy and mis-numbering",
         "Planner": "Rich Buikema ",
         "DURATION": 20,
         "Year": 2013
      },
      {
         "PERMITID": "GP13-017",
         "APN": 46723019,
         "File Number": "GP13-017",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "GP13-017 Citywide Text Amendment",
         "Application Type": "GP Text Amendment ",
         "Application Date": "8/29/13",
         "Status": "Withdrawn ",
         "Description": "Director-initiated General Plan Text Amendment to clean-up LU-1.1 and LU-1.2 to eliminate redundant policy and mis-numbering",
         "Planner": "Rich Buikema ",
         "DURATION": 20,
         "Year": 2013
      },
      {
         "PERMITID": "GP13-017",
         "APN": 46723021,
         "File Number": "GP13-017",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "GP13-017 Citywide Text Amendment",
         "Application Type": "GP Text Amendment ",
         "Application Date": "8/29/13",
         "Status": "Withdrawn ",
         "Description": "Director-initiated General Plan Text Amendment to clean-up LU-1.1 and LU-1.2 to eliminate redundant policy and mis-numbering",
         "Planner": "Rich Buikema ",
         "DURATION": 20,
         "Year": 2013
      },
      {
         "PERMITID": "GP13-017",
         "APN": 46723022,
         "File Number": "GP13-017",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "GP13-017 Citywide Text Amendment",
         "Application Type": "GP Text Amendment ",
         "Application Date": "8/29/13",
         "Status": "Withdrawn ",
         "Description": "Director-initiated General Plan Text Amendment to clean-up LU-1.1 and LU-1.2 to eliminate redundant policy and mis-numbering",
         "Planner": "Rich Buikema ",
         "DURATION": 20,
         "Year": 2013
      },
      {
         "PERMITID": "GP13-017",
         "APN": 46723076,
         "File Number": "GP13-017",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "GP13-017 Citywide Text Amendment",
         "Application Type": "GP Text Amendment ",
         "Application Date": "8/29/13",
         "Status": "Withdrawn ",
         "Description": "Director-initiated General Plan Text Amendment to clean-up LU-1.1 and LU-1.2 to eliminate redundant policy and mis-numbering",
         "Planner": "Rich Buikema ",
         "DURATION": 20,
         "Year": 2013
      },
      {
         "PERMITID": "GP13-017",
         "APN": 46724001,
         "File Number": "GP13-017",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "GP13-017 Citywide Text Amendment",
         "Application Type": "GP Text Amendment ",
         "Application Date": "8/29/13",
         "Status": "Withdrawn ",
         "Description": "Director-initiated General Plan Text Amendment to clean-up LU-1.1 and LU-1.2 to eliminate redundant policy and mis-numbering",
         "Planner": "Rich Buikema ",
         "DURATION": 20,
         "Year": 2013
      },
      {
         "PERMITID": "GP13-017",
         "APN": 46724002,
         "File Number": "GP13-017",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "GP13-017 Citywide Text Amendment",
         "Application Type": "GP Text Amendment ",
         "Application Date": "8/29/13",
         "Status": "Withdrawn ",
         "Description": "Director-initiated General Plan Text Amendment to clean-up LU-1.1 and LU-1.2 to eliminate redundant policy and mis-numbering",
         "Planner": "Rich Buikema ",
         "DURATION": 20,
         "Year": 2013
      },
      {
         "PERMITID": "GP13-017",
         "APN": 46724003,
         "File Number": "GP13-017",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "GP13-017 Citywide Text Amendment",
         "Application Type": "GP Text Amendment ",
         "Application Date": "8/29/13",
         "Status": "Withdrawn ",
         "Description": "Director-initiated General Plan Text Amendment to clean-up LU-1.1 and LU-1.2 to eliminate redundant policy and mis-numbering",
         "Planner": "Rich Buikema ",
         "DURATION": 20,
         "Year": 2013
      },
      {
         "PERMITID": "GP13-017",
         "APN": 46724014,
         "File Number": "GP13-017",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "GP13-017 Citywide Text Amendment",
         "Application Type": "GP Text Amendment ",
         "Application Date": "8/29/13",
         "Status": "Withdrawn ",
         "Description": "Director-initiated General Plan Text Amendment to clean-up LU-1.1 and LU-1.2 to eliminate redundant policy and mis-numbering",
         "Planner": "Rich Buikema ",
         "DURATION": 20,
         "Year": 2013
      },
      {
         "PERMITID": "GP13-017",
         "APN": 46724015,
         "File Number": "GP13-017",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "GP13-017 Citywide Text Amendment",
         "Application Type": "GP Text Amendment ",
         "Application Date": "8/29/13",
         "Status": "Withdrawn ",
         "Description": "Director-initiated General Plan Text Amendment to clean-up LU-1.1 and LU-1.2 to eliminate redundant policy and mis-numbering",
         "Planner": "Rich Buikema ",
         "DURATION": 20,
         "Year": 2013
      },
      {
         "PERMITID": "GP13-017",
         "APN": 46724016,
         "File Number": "GP13-017",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "GP13-017 Citywide Text Amendment",
         "Application Type": "GP Text Amendment ",
         "Application Date": "8/29/13",
         "Status": "Withdrawn ",
         "Description": "Director-initiated General Plan Text Amendment to clean-up LU-1.1 and LU-1.2 to eliminate redundant policy and mis-numbering",
         "Planner": "Rich Buikema ",
         "DURATION": 20,
         "Year": 2013
      },
      {
         "PERMITID": "GP13-017",
         "APN": 46724019,
         "File Number": "GP13-017",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "GP13-017 Citywide Text Amendment",
         "Application Type": "GP Text Amendment ",
         "Application Date": "8/29/13",
         "Status": "Withdrawn ",
         "Description": "Director-initiated General Plan Text Amendment to clean-up LU-1.1 and LU-1.2 to eliminate redundant policy and mis-numbering",
         "Planner": "Rich Buikema ",
         "DURATION": 20,
         "Year": 2013
      },
      {
         "PERMITID": "GP13-017",
         "APN": 46724020,
         "File Number": "GP13-017",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "GP13-017 Citywide Text Amendment",
         "Application Type": "GP Text Amendment ",
         "Application Date": "8/29/13",
         "Status": "Withdrawn ",
         "Description": "Director-initiated General Plan Text Amendment to clean-up LU-1.1 and LU-1.2 to eliminate redundant policy and mis-numbering",
         "Planner": "Rich Buikema ",
         "DURATION": 20,
         "Year": 2013
      },
      {
         "PERMITID": "GP13-017",
         "APN": 46724021,
         "File Number": "GP13-017",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "GP13-017 Citywide Text Amendment",
         "Application Type": "GP Text Amendment ",
         "Application Date": "8/29/13",
         "Status": "Withdrawn ",
         "Description": "Director-initiated General Plan Text Amendment to clean-up LU-1.1 and LU-1.2 to eliminate redundant policy and mis-numbering",
         "Planner": "Rich Buikema ",
         "DURATION": 20,
         "Year": 2013
      },
      {
         "PERMITID": "GP13-017",
         "APN": 46724115,
         "File Number": "GP13-017",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "GP13-017 Citywide Text Amendment",
         "Application Type": "GP Text Amendment ",
         "Application Date": "8/29/13",
         "Status": "Withdrawn ",
         "Description": "Director-initiated General Plan Text Amendment to clean-up LU-1.1 and LU-1.2 to eliminate redundant policy and mis-numbering",
         "Planner": "Rich Buikema ",
         "DURATION": 20,
         "Year": 2013
      },
      {
         "PERMITID": "GP13-017",
         "APN": 46724117,
         "File Number": "GP13-017",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "GP13-017 Citywide Text Amendment",
         "Application Type": "GP Text Amendment ",
         "Application Date": "8/29/13",
         "Status": "Withdrawn ",
         "Description": "Director-initiated General Plan Text Amendment to clean-up LU-1.1 and LU-1.2 to eliminate redundant policy and mis-numbering",
         "Planner": "Rich Buikema ",
         "DURATION": 20,
         "Year": 2013
      },
      {
         "PERMITID": "GP13-018",
         "APN": 46723010,
         "File Number": "GP13-018",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "GP13-018 Citywide Text Amendment",
         "Application Type": "GP Text Amendment ",
         "Application Date": "8/29/13",
         "Status": "Withdrawn ",
         "Description": "Director-initiated General Plan Text Amendment clean-up to add the \"Planned Job Capacity and Housing Growth Areas by Horizon\" Table currently in Appendix 5 to the main body of the General Plan, Chapter 5",
         "Planner": "Rich Buikema ",
         "DURATION": 20,
         "Year": 2013
      },
      {
         "PERMITID": "GP13-018",
         "APN": 46723011,
         "File Number": "GP13-018",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "GP13-018 Citywide Text Amendment",
         "Application Type": "GP Text Amendment ",
         "Application Date": "8/29/13",
         "Status": "Withdrawn ",
         "Description": "Director-initiated General Plan Text Amendment clean-up to add the \"Planned Job Capacity and Housing Growth Areas by Horizon\" Table currently in Appendix 5 to the main body of the General Plan, Chapter 5",
         "Planner": "Rich Buikema ",
         "DURATION": 20,
         "Year": 2013
      },
      {
         "PERMITID": "GP13-018",
         "APN": 46723013,
         "File Number": "GP13-018",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "GP13-018 Citywide Text Amendment",
         "Application Type": "GP Text Amendment ",
         "Application Date": "8/29/13",
         "Status": "Withdrawn ",
         "Description": "Director-initiated General Plan Text Amendment clean-up to add the \"Planned Job Capacity and Housing Growth Areas by Horizon\" Table currently in Appendix 5 to the main body of the General Plan, Chapter 5",
         "Planner": "Rich Buikema ",
         "DURATION": 20,
         "Year": 2013
      },
      {
         "PERMITID": "GP13-018",
         "APN": 46723017,
         "File Number": "GP13-018",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "GP13-018 Citywide Text Amendment",
         "Application Type": "GP Text Amendment ",
         "Application Date": "8/29/13",
         "Status": "Withdrawn ",
         "Description": "Director-initiated General Plan Text Amendment clean-up to add the \"Planned Job Capacity and Housing Growth Areas by Horizon\" Table currently in Appendix 5 to the main body of the General Plan, Chapter 5",
         "Planner": "Rich Buikema ",
         "DURATION": 20,
         "Year": 2013
      },
      {
         "PERMITID": "GP13-018",
         "APN": 46723018,
         "File Number": "GP13-018",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "GP13-018 Citywide Text Amendment",
         "Application Type": "GP Text Amendment ",
         "Application Date": "8/29/13",
         "Status": "Withdrawn ",
         "Description": "Director-initiated General Plan Text Amendment clean-up to add the \"Planned Job Capacity and Housing Growth Areas by Horizon\" Table currently in Appendix 5 to the main body of the General Plan, Chapter 5",
         "Planner": "Rich Buikema ",
         "DURATION": 20,
         "Year": 2013
      },
      {
         "PERMITID": "GP13-018",
         "APN": 46723019,
         "File Number": "GP13-018",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "GP13-018 Citywide Text Amendment",
         "Application Type": "GP Text Amendment ",
         "Application Date": "8/29/13",
         "Status": "Withdrawn ",
         "Description": "Director-initiated General Plan Text Amendment clean-up to add the \"Planned Job Capacity and Housing Growth Areas by Horizon\" Table currently in Appendix 5 to the main body of the General Plan, Chapter 5",
         "Planner": "Rich Buikema ",
         "DURATION": 20,
         "Year": 2013
      },
      {
         "PERMITID": "GP13-018",
         "APN": 46723021,
         "File Number": "GP13-018",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "GP13-018 Citywide Text Amendment",
         "Application Type": "GP Text Amendment ",
         "Application Date": "8/29/13",
         "Status": "Withdrawn ",
         "Description": "Director-initiated General Plan Text Amendment clean-up to add the \"Planned Job Capacity and Housing Growth Areas by Horizon\" Table currently in Appendix 5 to the main body of the General Plan, Chapter 5",
         "Planner": "Rich Buikema ",
         "DURATION": 20,
         "Year": 2013
      },
      {
         "PERMITID": "GP13-018",
         "APN": 46723022,
         "File Number": "GP13-018",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "GP13-018 Citywide Text Amendment",
         "Application Type": "GP Text Amendment ",
         "Application Date": "8/29/13",
         "Status": "Withdrawn ",
         "Description": "Director-initiated General Plan Text Amendment clean-up to add the \"Planned Job Capacity and Housing Growth Areas by Horizon\" Table currently in Appendix 5 to the main body of the General Plan, Chapter 5",
         "Planner": "Rich Buikema ",
         "DURATION": 20,
         "Year": 2013
      },
      {
         "PERMITID": "GP13-018",
         "APN": 46723076,
         "File Number": "GP13-018",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "GP13-018 Citywide Text Amendment",
         "Application Type": "GP Text Amendment ",
         "Application Date": "8/29/13",
         "Status": "Withdrawn ",
         "Description": "Director-initiated General Plan Text Amendment clean-up to add the \"Planned Job Capacity and Housing Growth Areas by Horizon\" Table currently in Appendix 5 to the main body of the General Plan, Chapter 5",
         "Planner": "Rich Buikema ",
         "DURATION": 20,
         "Year": 2013
      },
      {
         "PERMITID": "GP13-018",
         "APN": 46724001,
         "File Number": "GP13-018",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "GP13-018 Citywide Text Amendment",
         "Application Type": "GP Text Amendment ",
         "Application Date": "8/29/13",
         "Status": "Withdrawn ",
         "Description": "Director-initiated General Plan Text Amendment clean-up to add the \"Planned Job Capacity and Housing Growth Areas by Horizon\" Table currently in Appendix 5 to the main body of the General Plan, Chapter 5",
         "Planner": "Rich Buikema ",
         "DURATION": 20,
         "Year": 2013
      },
      {
         "PERMITID": "GP13-018",
         "APN": 46724002,
         "File Number": "GP13-018",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "GP13-018 Citywide Text Amendment",
         "Application Type": "GP Text Amendment ",
         "Application Date": "8/29/13",
         "Status": "Withdrawn ",
         "Description": "Director-initiated General Plan Text Amendment clean-up to add the \"Planned Job Capacity and Housing Growth Areas by Horizon\" Table currently in Appendix 5 to the main body of the General Plan, Chapter 5",
         "Planner": "Rich Buikema ",
         "DURATION": 20,
         "Year": 2013
      },
      {
         "PERMITID": "GP13-018",
         "APN": 46724003,
         "File Number": "GP13-018",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "GP13-018 Citywide Text Amendment",
         "Application Type": "GP Text Amendment ",
         "Application Date": "8/29/13",
         "Status": "Withdrawn ",
         "Description": "Director-initiated General Plan Text Amendment clean-up to add the \"Planned Job Capacity and Housing Growth Areas by Horizon\" Table currently in Appendix 5 to the main body of the General Plan, Chapter 5",
         "Planner": "Rich Buikema ",
         "DURATION": 20,
         "Year": 2013
      },
      {
         "PERMITID": "GP13-018",
         "APN": 46724014,
         "File Number": "GP13-018",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "GP13-018 Citywide Text Amendment",
         "Application Type": "GP Text Amendment ",
         "Application Date": "8/29/13",
         "Status": "Withdrawn ",
         "Description": "Director-initiated General Plan Text Amendment clean-up to add the \"Planned Job Capacity and Housing Growth Areas by Horizon\" Table currently in Appendix 5 to the main body of the General Plan, Chapter 5",
         "Planner": "Rich Buikema ",
         "DURATION": 20,
         "Year": 2013
      },
      {
         "PERMITID": "GP13-018",
         "APN": 46724015,
         "File Number": "GP13-018",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "GP13-018 Citywide Text Amendment",
         "Application Type": "GP Text Amendment ",
         "Application Date": "8/29/13",
         "Status": "Withdrawn ",
         "Description": "Director-initiated General Plan Text Amendment clean-up to add the \"Planned Job Capacity and Housing Growth Areas by Horizon\" Table currently in Appendix 5 to the main body of the General Plan, Chapter 5",
         "Planner": "Rich Buikema ",
         "DURATION": 20,
         "Year": 2013
      },
      {
         "PERMITID": "GP13-018",
         "APN": 46724016,
         "File Number": "GP13-018",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "GP13-018 Citywide Text Amendment",
         "Application Type": "GP Text Amendment ",
         "Application Date": "8/29/13",
         "Status": "Withdrawn ",
         "Description": "Director-initiated General Plan Text Amendment clean-up to add the \"Planned Job Capacity and Housing Growth Areas by Horizon\" Table currently in Appendix 5 to the main body of the General Plan, Chapter 5",
         "Planner": "Rich Buikema ",
         "DURATION": 20,
         "Year": 2013
      },
      {
         "PERMITID": "GP13-018",
         "APN": 46724019,
         "File Number": "GP13-018",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "GP13-018 Citywide Text Amendment",
         "Application Type": "GP Text Amendment ",
         "Application Date": "8/29/13",
         "Status": "Withdrawn ",
         "Description": "Director-initiated General Plan Text Amendment clean-up to add the \"Planned Job Capacity and Housing Growth Areas by Horizon\" Table currently in Appendix 5 to the main body of the General Plan, Chapter 5",
         "Planner": "Rich Buikema ",
         "DURATION": 20,
         "Year": 2013
      },
      {
         "PERMITID": "GP13-018",
         "APN": 46724020,
         "File Number": "GP13-018",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "GP13-018 Citywide Text Amendment",
         "Application Type": "GP Text Amendment ",
         "Application Date": "8/29/13",
         "Status": "Withdrawn ",
         "Description": "Director-initiated General Plan Text Amendment clean-up to add the \"Planned Job Capacity and Housing Growth Areas by Horizon\" Table currently in Appendix 5 to the main body of the General Plan, Chapter 5",
         "Planner": "Rich Buikema ",
         "DURATION": 20,
         "Year": 2013
      },
      {
         "PERMITID": "GP13-018",
         "APN": 46724021,
         "File Number": "GP13-018",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "GP13-018 Citywide Text Amendment",
         "Application Type": "GP Text Amendment ",
         "Application Date": "8/29/13",
         "Status": "Withdrawn ",
         "Description": "Director-initiated General Plan Text Amendment clean-up to add the \"Planned Job Capacity and Housing Growth Areas by Horizon\" Table currently in Appendix 5 to the main body of the General Plan, Chapter 5",
         "Planner": "Rich Buikema ",
         "DURATION": 20,
         "Year": 2013
      },
      {
         "PERMITID": "GP13-018",
         "APN": 46724115,
         "File Number": "GP13-018",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "GP13-018 Citywide Text Amendment",
         "Application Type": "GP Text Amendment ",
         "Application Date": "8/29/13",
         "Status": "Withdrawn ",
         "Description": "Director-initiated General Plan Text Amendment clean-up to add the \"Planned Job Capacity and Housing Growth Areas by Horizon\" Table currently in Appendix 5 to the main body of the General Plan, Chapter 5",
         "Planner": "Rich Buikema ",
         "DURATION": 20,
         "Year": 2013
      },
      {
         "PERMITID": "GP13-018",
         "APN": 46724117,
         "File Number": "GP13-018",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "GP13-018 Citywide Text Amendment",
         "Application Type": "GP Text Amendment ",
         "Application Date": "8/29/13",
         "Status": "Withdrawn ",
         "Description": "Director-initiated General Plan Text Amendment clean-up to add the \"Planned Job Capacity and Housing Growth Areas by Horizon\" Table currently in Appendix 5 to the main body of the General Plan, Chapter 5",
         "Planner": "Rich Buikema ",
         "DURATION": 20,
         "Year": 2013
      }
   ],
   "Historic District Designation ": [
      {
         "PERMITID": "HD06-155",
         "APN": 47224019,
         "File Number": "HD06-155",
         "Address": "483 S 6TH ST SAN JOSE",
         "Project Name": "HD06-155 - Reed City Landmark Historic District (Previously HD06-001)",
         "Application Type": "Historic District Designation ",
         "Application Date": "4/21/06",
         "Status": "Approved ",
         "Description": "Historic District Designation for Reed City Landmark Historic District on an approximately 25 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 599,
         "Year": 2006
      },
      {
         "PERMITID": "HD06-155",
         "APN": 47224028,
         "File Number": "HD06-155",
         "Address": "483 S 6TH ST SAN JOSE",
         "Project Name": "HD06-155 - Reed City Landmark Historic District (Previously HD06-001)",
         "Application Type": "Historic District Designation ",
         "Application Date": "4/21/06",
         "Status": "Approved ",
         "Description": "Historic District Designation for Reed City Landmark Historic District on an approximately 25 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 599,
         "Year": 2006
      },
      {
         "PERMITID": "HD06-155",
         "APN": 47224029,
         "File Number": "HD06-155",
         "Address": "483 S 6TH ST SAN JOSE",
         "Project Name": "HD06-155 - Reed City Landmark Historic District (Previously HD06-001)",
         "Application Type": "Historic District Designation ",
         "Application Date": "4/21/06",
         "Status": "Approved ",
         "Description": "Historic District Designation for Reed City Landmark Historic District on an approximately 25 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 599,
         "Year": 2006
      },
      {
         "PERMITID": "HD06-155",
         "APN": 47224043,
         "File Number": "HD06-155",
         "Address": "483 S 6TH ST SAN JOSE",
         "Project Name": "HD06-155 - Reed City Landmark Historic District (Previously HD06-001)",
         "Application Type": "Historic District Designation ",
         "Application Date": "4/21/06",
         "Status": "Approved ",
         "Description": "Historic District Designation for Reed City Landmark Historic District on an approximately 25 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 599,
         "Year": 2006
      },
      {
         "PERMITID": "HD06-155",
         "APN": 47224076,
         "File Number": "HD06-155",
         "Address": "483 S 6TH ST SAN JOSE",
         "Project Name": "HD06-155 - Reed City Landmark Historic District (Previously HD06-001)",
         "Application Type": "Historic District Designation ",
         "Application Date": "4/21/06",
         "Status": "Approved ",
         "Description": "Historic District Designation for Reed City Landmark Historic District on an approximately 25 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 599,
         "Year": 2006
      },
      {
         "PERMITID": "HD06-155",
         "APN": 47225061,
         "File Number": "HD06-155",
         "Address": "483 S 6TH ST SAN JOSE",
         "Project Name": "HD06-155 - Reed City Landmark Historic District (Previously HD06-001)",
         "Application Type": "Historic District Designation ",
         "Application Date": "4/21/06",
         "Status": "Approved ",
         "Description": "Historic District Designation for Reed City Landmark Historic District on an approximately 25 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 599,
         "Year": 2006
      },
      {
         "PERMITID": "HD06-155",
         "APN": 47225075,
         "File Number": "HD06-155",
         "Address": "483 S 6TH ST SAN JOSE",
         "Project Name": "HD06-155 - Reed City Landmark Historic District (Previously HD06-001)",
         "Application Type": "Historic District Designation ",
         "Application Date": "4/21/06",
         "Status": "Approved ",
         "Description": "Historic District Designation for Reed City Landmark Historic District on an approximately 25 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 599,
         "Year": 2006
      },
      {
         "PERMITID": "HD06-155",
         "APN": 47225080,
         "File Number": "HD06-155",
         "Address": "483 S 6TH ST SAN JOSE",
         "Project Name": "HD06-155 - Reed City Landmark Historic District (Previously HD06-001)",
         "Application Type": "Historic District Designation ",
         "Application Date": "4/21/06",
         "Status": "Approved ",
         "Description": "Historic District Designation for Reed City Landmark Historic District on an approximately 25 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 599,
         "Year": 2006
      },
      {
         "PERMITID": "HD06-155",
         "APN": 47227020,
         "File Number": "HD06-155",
         "Address": "483 S 6TH ST SAN JOSE",
         "Project Name": "HD06-155 - Reed City Landmark Historic District (Previously HD06-001)",
         "Application Type": "Historic District Designation ",
         "Application Date": "4/21/06",
         "Status": "Approved ",
         "Description": "Historic District Designation for Reed City Landmark Historic District on an approximately 25 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 599,
         "Year": 2006
      },
      {
         "PERMITID": "HD06-155",
         "APN": 47227041,
         "File Number": "HD06-155",
         "Address": "483 S 6TH ST SAN JOSE",
         "Project Name": "HD06-155 - Reed City Landmark Historic District (Previously HD06-001)",
         "Application Type": "Historic District Designation ",
         "Application Date": "4/21/06",
         "Status": "Approved ",
         "Description": "Historic District Designation for Reed City Landmark Historic District on an approximately 25 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 599,
         "Year": 2006
      },
      {
         "PERMITID": "HD06-155",
         "APN": 47227060,
         "File Number": "HD06-155",
         "Address": "483 S 6TH ST SAN JOSE",
         "Project Name": "HD06-155 - Reed City Landmark Historic District (Previously HD06-001)",
         "Application Type": "Historic District Designation ",
         "Application Date": "4/21/06",
         "Status": "Approved ",
         "Description": "Historic District Designation for Reed City Landmark Historic District on an approximately 25 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 599,
         "Year": 2006
      },
      {
         "PERMITID": "HD06-155",
         "APN": 47228001,
         "File Number": "HD06-155",
         "Address": "483 S 6TH ST SAN JOSE",
         "Project Name": "HD06-155 - Reed City Landmark Historic District (Previously HD06-001)",
         "Application Type": "Historic District Designation ",
         "Application Date": "4/21/06",
         "Status": "Approved ",
         "Description": "Historic District Designation for Reed City Landmark Historic District on an approximately 25 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 599,
         "Year": 2006
      },
      {
         "PERMITID": "HD06-155",
         "APN": 47228002,
         "File Number": "HD06-155",
         "Address": "483 S 6TH ST SAN JOSE",
         "Project Name": "HD06-155 - Reed City Landmark Historic District (Previously HD06-001)",
         "Application Type": "Historic District Designation ",
         "Application Date": "4/21/06",
         "Status": "Approved ",
         "Description": "Historic District Designation for Reed City Landmark Historic District on an approximately 25 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 599,
         "Year": 2006
      },
      {
         "PERMITID": "HD06-155",
         "APN": 47228025,
         "File Number": "HD06-155",
         "Address": "483 S 6TH ST SAN JOSE",
         "Project Name": "HD06-155 - Reed City Landmark Historic District (Previously HD06-001)",
         "Application Type": "Historic District Designation ",
         "Application Date": "4/21/06",
         "Status": "Approved ",
         "Description": "Historic District Designation for Reed City Landmark Historic District on an approximately 25 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 599,
         "Year": 2006
      },
      {
         "PERMITID": "HD06-155",
         "APN": 47228027,
         "File Number": "HD06-155",
         "Address": "483 S 6TH ST SAN JOSE",
         "Project Name": "HD06-155 - Reed City Landmark Historic District (Previously HD06-001)",
         "Application Type": "Historic District Designation ",
         "Application Date": "4/21/06",
         "Status": "Approved ",
         "Description": "Historic District Designation for Reed City Landmark Historic District on an approximately 25 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 599,
         "Year": 2006
      },
      {
         "PERMITID": "HD06-155",
         "APN": 47228036,
         "File Number": "HD06-155",
         "Address": "483 S 6TH ST SAN JOSE",
         "Project Name": "HD06-155 - Reed City Landmark Historic District (Previously HD06-001)",
         "Application Type": "Historic District Designation ",
         "Application Date": "4/21/06",
         "Status": "Approved ",
         "Description": "Historic District Designation for Reed City Landmark Historic District on an approximately 25 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 599,
         "Year": 2006
      },
      {
         "PERMITID": "HD06-155",
         "APN": 47228040,
         "File Number": "HD06-155",
         "Address": "483 S 6TH ST SAN JOSE",
         "Project Name": "HD06-155 - Reed City Landmark Historic District (Previously HD06-001)",
         "Application Type": "Historic District Designation ",
         "Application Date": "4/21/06",
         "Status": "Approved ",
         "Description": "Historic District Designation for Reed City Landmark Historic District on an approximately 25 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 599,
         "Year": 2006
      },
      {
         "PERMITID": "HD06-155",
         "APN": 47228042,
         "File Number": "HD06-155",
         "Address": "483 S 6TH ST SAN JOSE",
         "Project Name": "HD06-155 - Reed City Landmark Historic District (Previously HD06-001)",
         "Application Type": "Historic District Designation ",
         "Application Date": "4/21/06",
         "Status": "Approved ",
         "Description": "Historic District Designation for Reed City Landmark Historic District on an approximately 25 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 599,
         "Year": 2006
      },
      {
         "PERMITID": "HD06-155",
         "APN": 47228043,
         "File Number": "HD06-155",
         "Address": "483 S 6TH ST SAN JOSE",
         "Project Name": "HD06-155 - Reed City Landmark Historic District (Previously HD06-001)",
         "Application Type": "Historic District Designation ",
         "Application Date": "4/21/06",
         "Status": "Approved ",
         "Description": "Historic District Designation for Reed City Landmark Historic District on an approximately 25 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 599,
         "Year": 2006
      },
      {
         "PERMITID": "HD06-155",
         "APN": 47228045,
         "File Number": "HD06-155",
         "Address": "483 S 6TH ST SAN JOSE",
         "Project Name": "HD06-155 - Reed City Landmark Historic District (Previously HD06-001)",
         "Application Type": "Historic District Designation ",
         "Application Date": "4/21/06",
         "Status": "Approved ",
         "Description": "Historic District Designation for Reed City Landmark Historic District on an approximately 25 gross acre site",
         "Planner": "Patrice Shaffer ",
         "DURATION": 599,
         "Year": 2006
      },
      {
         "PERMITID": "HD07-158",
         "APN": 25945029,
         "File Number": "HD07-158",
         "Address": "394 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "HD07-158 - Lake House Historic District",
         "Application Type": "Historic District Designation ",
         "Application Date": "2/15/07",
         "Status": "Approved ",
         "Description": "Historic District Designation for Lake House Historic District on an approximately 8.15 gross acres site Bounded on the north by W. San Fernando St., on the east by Hwy 87 & the VTA Light Rail right-of-way, on the west by Los Gatos Creek & on the south by the rear property lines of lots on the north side of Park Ave, & on the southeast by Sonoma St. and Lakehouse Ave",
         "Planner": "Patrice Shaffer ",
         "DURATION": 413,
         "Year": 2007
      },
      {
         "PERMITID": "HD07-158",
         "APN": 25945030,
         "File Number": "HD07-158",
         "Address": "394 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "HD07-158 - Lake House Historic District",
         "Application Type": "Historic District Designation ",
         "Application Date": "2/15/07",
         "Status": "Approved ",
         "Description": "Historic District Designation for Lake House Historic District on an approximately 8.15 gross acres site Bounded on the north by W. San Fernando St., on the east by Hwy 87 & the VTA Light Rail right-of-way, on the west by Los Gatos Creek & on the south by the rear property lines of lots on the north side of Park Ave, & on the southeast by Sonoma St. and Lakehouse Ave",
         "Planner": "Patrice Shaffer ",
         "DURATION": 413,
         "Year": 2007
      },
      {
         "PERMITID": "HD07-158",
         "APN": 25945043,
         "File Number": "HD07-158",
         "Address": "394 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "HD07-158 - Lake House Historic District",
         "Application Type": "Historic District Designation ",
         "Application Date": "2/15/07",
         "Status": "Approved ",
         "Description": "Historic District Designation for Lake House Historic District on an approximately 8.15 gross acres site Bounded on the north by W. San Fernando St., on the east by Hwy 87 & the VTA Light Rail right-of-way, on the west by Los Gatos Creek & on the south by the rear property lines of lots on the north side of Park Ave, & on the southeast by Sonoma St. and Lakehouse Ave",
         "Planner": "Patrice Shaffer ",
         "DURATION": 413,
         "Year": 2007
      },
      {
         "PERMITID": "HD07-158",
         "APN": 25945044,
         "File Number": "HD07-158",
         "Address": "394 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "HD07-158 - Lake House Historic District",
         "Application Type": "Historic District Designation ",
         "Application Date": "2/15/07",
         "Status": "Approved ",
         "Description": "Historic District Designation for Lake House Historic District on an approximately 8.15 gross acres site Bounded on the north by W. San Fernando St., on the east by Hwy 87 & the VTA Light Rail right-of-way, on the west by Los Gatos Creek & on the south by the rear property lines of lots on the north side of Park Ave, & on the southeast by Sonoma St. and Lakehouse Ave",
         "Planner": "Patrice Shaffer ",
         "DURATION": 413,
         "Year": 2007
      },
      {
         "PERMITID": "HD07-158",
         "APN": 25945045,
         "File Number": "HD07-158",
         "Address": "394 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "HD07-158 - Lake House Historic District",
         "Application Type": "Historic District Designation ",
         "Application Date": "2/15/07",
         "Status": "Approved ",
         "Description": "Historic District Designation for Lake House Historic District on an approximately 8.15 gross acres site Bounded on the north by W. San Fernando St., on the east by Hwy 87 & the VTA Light Rail right-of-way, on the west by Los Gatos Creek & on the south by the rear property lines of lots on the north side of Park Ave, & on the southeast by Sonoma St. and Lakehouse Ave",
         "Planner": "Patrice Shaffer ",
         "DURATION": 413,
         "Year": 2007
      },
      {
         "PERMITID": "HD07-158",
         "APN": 25945047,
         "File Number": "HD07-158",
         "Address": "394 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "HD07-158 - Lake House Historic District",
         "Application Type": "Historic District Designation ",
         "Application Date": "2/15/07",
         "Status": "Approved ",
         "Description": "Historic District Designation for Lake House Historic District on an approximately 8.15 gross acres site Bounded on the north by W. San Fernando St., on the east by Hwy 87 & the VTA Light Rail right-of-way, on the west by Los Gatos Creek & on the south by the rear property lines of lots on the north side of Park Ave, & on the southeast by Sonoma St. and Lakehouse Ave",
         "Planner": "Patrice Shaffer ",
         "DURATION": 413,
         "Year": 2007
      },
      {
         "PERMITID": "HD07-158",
         "APN": 25945048,
         "File Number": "HD07-158",
         "Address": "394 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "HD07-158 - Lake House Historic District",
         "Application Type": "Historic District Designation ",
         "Application Date": "2/15/07",
         "Status": "Approved ",
         "Description": "Historic District Designation for Lake House Historic District on an approximately 8.15 gross acres site Bounded on the north by W. San Fernando St., on the east by Hwy 87 & the VTA Light Rail right-of-way, on the west by Los Gatos Creek & on the south by the rear property lines of lots on the north side of Park Ave, & on the southeast by Sonoma St. and Lakehouse Ave",
         "Planner": "Patrice Shaffer ",
         "DURATION": 413,
         "Year": 2007
      },
      {
         "PERMITID": "HD07-158",
         "APN": 25945049,
         "File Number": "HD07-158",
         "Address": "394 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "HD07-158 - Lake House Historic District",
         "Application Type": "Historic District Designation ",
         "Application Date": "2/15/07",
         "Status": "Approved ",
         "Description": "Historic District Designation for Lake House Historic District on an approximately 8.15 gross acres site Bounded on the north by W. San Fernando St., on the east by Hwy 87 & the VTA Light Rail right-of-way, on the west by Los Gatos Creek & on the south by the rear property lines of lots on the north side of Park Ave, & on the southeast by Sonoma St. and Lakehouse Ave",
         "Planner": "Patrice Shaffer ",
         "DURATION": 413,
         "Year": 2007
      },
      {
         "PERMITID": "HD07-158",
         "APN": 25945052,
         "File Number": "HD07-158",
         "Address": "394 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "HD07-158 - Lake House Historic District",
         "Application Type": "Historic District Designation ",
         "Application Date": "2/15/07",
         "Status": "Approved ",
         "Description": "Historic District Designation for Lake House Historic District on an approximately 8.15 gross acres site Bounded on the north by W. San Fernando St., on the east by Hwy 87 & the VTA Light Rail right-of-way, on the west by Los Gatos Creek & on the south by the rear property lines of lots on the north side of Park Ave, & on the southeast by Sonoma St. and Lakehouse Ave",
         "Planner": "Patrice Shaffer ",
         "DURATION": 413,
         "Year": 2007
      },
      {
         "PERMITID": "HD07-158",
         "APN": 25945053,
         "File Number": "HD07-158",
         "Address": "394 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "HD07-158 - Lake House Historic District",
         "Application Type": "Historic District Designation ",
         "Application Date": "2/15/07",
         "Status": "Approved ",
         "Description": "Historic District Designation for Lake House Historic District on an approximately 8.15 gross acres site Bounded on the north by W. San Fernando St., on the east by Hwy 87 & the VTA Light Rail right-of-way, on the west by Los Gatos Creek & on the south by the rear property lines of lots on the north side of Park Ave, & on the southeast by Sonoma St. and Lakehouse Ave",
         "Planner": "Patrice Shaffer ",
         "DURATION": 413,
         "Year": 2007
      },
      {
         "PERMITID": "HD07-158",
         "APN": 25945055,
         "File Number": "HD07-158",
         "Address": "394 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "HD07-158 - Lake House Historic District",
         "Application Type": "Historic District Designation ",
         "Application Date": "2/15/07",
         "Status": "Approved ",
         "Description": "Historic District Designation for Lake House Historic District on an approximately 8.15 gross acres site Bounded on the north by W. San Fernando St., on the east by Hwy 87 & the VTA Light Rail right-of-way, on the west by Los Gatos Creek & on the south by the rear property lines of lots on the north side of Park Ave, & on the southeast by Sonoma St. and Lakehouse Ave",
         "Planner": "Patrice Shaffer ",
         "DURATION": 413,
         "Year": 2007
      },
      {
         "PERMITID": "HD07-158",
         "APN": 25945057,
         "File Number": "HD07-158",
         "Address": "394 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "HD07-158 - Lake House Historic District",
         "Application Type": "Historic District Designation ",
         "Application Date": "2/15/07",
         "Status": "Approved ",
         "Description": "Historic District Designation for Lake House Historic District on an approximately 8.15 gross acres site Bounded on the north by W. San Fernando St., on the east by Hwy 87 & the VTA Light Rail right-of-way, on the west by Los Gatos Creek & on the south by the rear property lines of lots on the north side of Park Ave, & on the southeast by Sonoma St. and Lakehouse Ave",
         "Planner": "Patrice Shaffer ",
         "DURATION": 413,
         "Year": 2007
      },
      {
         "PERMITID": "HD07-158",
         "APN": 25945058,
         "File Number": "HD07-158",
         "Address": "394 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "HD07-158 - Lake House Historic District",
         "Application Type": "Historic District Designation ",
         "Application Date": "2/15/07",
         "Status": "Approved ",
         "Description": "Historic District Designation for Lake House Historic District on an approximately 8.15 gross acres site Bounded on the north by W. San Fernando St., on the east by Hwy 87 & the VTA Light Rail right-of-way, on the west by Los Gatos Creek & on the south by the rear property lines of lots on the north side of Park Ave, & on the southeast by Sonoma St. and Lakehouse Ave",
         "Planner": "Patrice Shaffer ",
         "DURATION": 413,
         "Year": 2007
      },
      {
         "PERMITID": "HD07-158",
         "APN": 25945059,
         "File Number": "HD07-158",
         "Address": "394 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "HD07-158 - Lake House Historic District",
         "Application Type": "Historic District Designation ",
         "Application Date": "2/15/07",
         "Status": "Approved ",
         "Description": "Historic District Designation for Lake House Historic District on an approximately 8.15 gross acres site Bounded on the north by W. San Fernando St., on the east by Hwy 87 & the VTA Light Rail right-of-way, on the west by Los Gatos Creek & on the south by the rear property lines of lots on the north side of Park Ave, & on the southeast by Sonoma St. and Lakehouse Ave",
         "Planner": "Patrice Shaffer ",
         "DURATION": 413,
         "Year": 2007
      },
      {
         "PERMITID": "HD07-158",
         "APN": 25945060,
         "File Number": "HD07-158",
         "Address": "394 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "HD07-158 - Lake House Historic District",
         "Application Type": "Historic District Designation ",
         "Application Date": "2/15/07",
         "Status": "Approved ",
         "Description": "Historic District Designation for Lake House Historic District on an approximately 8.15 gross acres site Bounded on the north by W. San Fernando St., on the east by Hwy 87 & the VTA Light Rail right-of-way, on the west by Los Gatos Creek & on the south by the rear property lines of lots on the north side of Park Ave, & on the southeast by Sonoma St. and Lakehouse Ave",
         "Planner": "Patrice Shaffer ",
         "DURATION": 413,
         "Year": 2007
      },
      {
         "PERMITID": "HD07-158",
         "APN": 25945061,
         "File Number": "HD07-158",
         "Address": "394 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "HD07-158 - Lake House Historic District",
         "Application Type": "Historic District Designation ",
         "Application Date": "2/15/07",
         "Status": "Approved ",
         "Description": "Historic District Designation for Lake House Historic District on an approximately 8.15 gross acres site Bounded on the north by W. San Fernando St., on the east by Hwy 87 & the VTA Light Rail right-of-way, on the west by Los Gatos Creek & on the south by the rear property lines of lots on the north side of Park Ave, & on the southeast by Sonoma St. and Lakehouse Ave",
         "Planner": "Patrice Shaffer ",
         "DURATION": 413,
         "Year": 2007
      },
      {
         "PERMITID": "HD07-158",
         "APN": 25945062,
         "File Number": "HD07-158",
         "Address": "394 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "HD07-158 - Lake House Historic District",
         "Application Type": "Historic District Designation ",
         "Application Date": "2/15/07",
         "Status": "Approved ",
         "Description": "Historic District Designation for Lake House Historic District on an approximately 8.15 gross acres site Bounded on the north by W. San Fernando St., on the east by Hwy 87 & the VTA Light Rail right-of-way, on the west by Los Gatos Creek & on the south by the rear property lines of lots on the north side of Park Ave, & on the southeast by Sonoma St. and Lakehouse Ave",
         "Planner": "Patrice Shaffer ",
         "DURATION": 413,
         "Year": 2007
      },
      {
         "PERMITID": "HD07-158",
         "APN": 25945070,
         "File Number": "HD07-158",
         "Address": "394 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "HD07-158 - Lake House Historic District",
         "Application Type": "Historic District Designation ",
         "Application Date": "2/15/07",
         "Status": "Approved ",
         "Description": "Historic District Designation for Lake House Historic District on an approximately 8.15 gross acres site Bounded on the north by W. San Fernando St., on the east by Hwy 87 & the VTA Light Rail right-of-way, on the west by Los Gatos Creek & on the south by the rear property lines of lots on the north side of Park Ave, & on the southeast by Sonoma St. and Lakehouse Ave",
         "Planner": "Patrice Shaffer ",
         "DURATION": 413,
         "Year": 2007
      },
      {
         "PERMITID": "HD07-158",
         "APN": 25945075,
         "File Number": "HD07-158",
         "Address": "394 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "HD07-158 - Lake House Historic District",
         "Application Type": "Historic District Designation ",
         "Application Date": "2/15/07",
         "Status": "Approved ",
         "Description": "Historic District Designation for Lake House Historic District on an approximately 8.15 gross acres site Bounded on the north by W. San Fernando St., on the east by Hwy 87 & the VTA Light Rail right-of-way, on the west by Los Gatos Creek & on the south by the rear property lines of lots on the north side of Park Ave, & on the southeast by Sonoma St. and Lakehouse Ave",
         "Planner": "Patrice Shaffer ",
         "DURATION": 413,
         "Year": 2007
      },
      {
         "PERMITID": "HD07-158",
         "APN": 25945076,
         "File Number": "HD07-158",
         "Address": "394 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "HD07-158 - Lake House Historic District",
         "Application Type": "Historic District Designation ",
         "Application Date": "2/15/07",
         "Status": "Approved ",
         "Description": "Historic District Designation for Lake House Historic District on an approximately 8.15 gross acres site Bounded on the north by W. San Fernando St., on the east by Hwy 87 & the VTA Light Rail right-of-way, on the west by Los Gatos Creek & on the south by the rear property lines of lots on the north side of Park Ave, & on the southeast by Sonoma St. and Lakehouse Ave",
         "Planner": "Patrice Shaffer ",
         "DURATION": 413,
         "Year": 2007
      },
      {
         "PERMITID": "HD07-158",
         "APN": 25945077,
         "File Number": "HD07-158",
         "Address": "394 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "HD07-158 - Lake House Historic District",
         "Application Type": "Historic District Designation ",
         "Application Date": "2/15/07",
         "Status": "Approved ",
         "Description": "Historic District Designation for Lake House Historic District on an approximately 8.15 gross acres site Bounded on the north by W. San Fernando St., on the east by Hwy 87 & the VTA Light Rail right-of-way, on the west by Los Gatos Creek & on the south by the rear property lines of lots on the north side of Park Ave, & on the southeast by Sonoma St. and Lakehouse Ave",
         "Planner": "Patrice Shaffer ",
         "DURATION": 413,
         "Year": 2007
      },
      {
         "PERMITID": "HD07-158",
         "APN": 25948018,
         "File Number": "HD07-158",
         "Address": "394 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "HD07-158 - Lake House Historic District",
         "Application Type": "Historic District Designation ",
         "Application Date": "2/15/07",
         "Status": "Approved ",
         "Description": "Historic District Designation for Lake House Historic District on an approximately 8.15 gross acres site Bounded on the north by W. San Fernando St., on the east by Hwy 87 & the VTA Light Rail right-of-way, on the west by Los Gatos Creek & on the south by the rear property lines of lots on the north side of Park Ave, & on the southeast by Sonoma St. and Lakehouse Ave",
         "Planner": "Patrice Shaffer ",
         "DURATION": 413,
         "Year": 2007
      },
      {
         "PERMITID": "HD07-158",
         "APN": 25948019,
         "File Number": "HD07-158",
         "Address": "394 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "HD07-158 - Lake House Historic District",
         "Application Type": "Historic District Designation ",
         "Application Date": "2/15/07",
         "Status": "Approved ",
         "Description": "Historic District Designation for Lake House Historic District on an approximately 8.15 gross acres site Bounded on the north by W. San Fernando St., on the east by Hwy 87 & the VTA Light Rail right-of-way, on the west by Los Gatos Creek & on the south by the rear property lines of lots on the north side of Park Ave, & on the southeast by Sonoma St. and Lakehouse Ave",
         "Planner": "Patrice Shaffer ",
         "DURATION": 413,
         "Year": 2007
      },
      {
         "PERMITID": "HD07-158",
         "APN": 25948023,
         "File Number": "HD07-158",
         "Address": "394 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "HD07-158 - Lake House Historic District",
         "Application Type": "Historic District Designation ",
         "Application Date": "2/15/07",
         "Status": "Approved ",
         "Description": "Historic District Designation for Lake House Historic District on an approximately 8.15 gross acres site Bounded on the north by W. San Fernando St., on the east by Hwy 87 & the VTA Light Rail right-of-way, on the west by Los Gatos Creek & on the south by the rear property lines of lots on the north side of Park Ave, & on the southeast by Sonoma St. and Lakehouse Ave",
         "Planner": "Patrice Shaffer ",
         "DURATION": 413,
         "Year": 2007
      },
      {
         "PERMITID": "HD07-158",
         "APN": 25948024,
         "File Number": "HD07-158",
         "Address": "394 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "HD07-158 - Lake House Historic District",
         "Application Type": "Historic District Designation ",
         "Application Date": "2/15/07",
         "Status": "Approved ",
         "Description": "Historic District Designation for Lake House Historic District on an approximately 8.15 gross acres site Bounded on the north by W. San Fernando St., on the east by Hwy 87 & the VTA Light Rail right-of-way, on the west by Los Gatos Creek & on the south by the rear property lines of lots on the north side of Park Ave, & on the southeast by Sonoma St. and Lakehouse Ave",
         "Planner": "Patrice Shaffer ",
         "DURATION": 413,
         "Year": 2007
      },
      {
         "PERMITID": "HD07-158",
         "APN": 25948025,
         "File Number": "HD07-158",
         "Address": "394 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "HD07-158 - Lake House Historic District",
         "Application Type": "Historic District Designation ",
         "Application Date": "2/15/07",
         "Status": "Approved ",
         "Description": "Historic District Designation for Lake House Historic District on an approximately 8.15 gross acres site Bounded on the north by W. San Fernando St., on the east by Hwy 87 & the VTA Light Rail right-of-way, on the west by Los Gatos Creek & on the south by the rear property lines of lots on the north side of Park Ave, & on the southeast by Sonoma St. and Lakehouse Ave",
         "Planner": "Patrice Shaffer ",
         "DURATION": 413,
         "Year": 2007
      },
      {
         "PERMITID": "HD07-158",
         "APN": 25948026,
         "File Number": "HD07-158",
         "Address": "394 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "HD07-158 - Lake House Historic District",
         "Application Type": "Historic District Designation ",
         "Application Date": "2/15/07",
         "Status": "Approved ",
         "Description": "Historic District Designation for Lake House Historic District on an approximately 8.15 gross acres site Bounded on the north by W. San Fernando St., on the east by Hwy 87 & the VTA Light Rail right-of-way, on the west by Los Gatos Creek & on the south by the rear property lines of lots on the north side of Park Ave, & on the southeast by Sonoma St. and Lakehouse Ave",
         "Planner": "Patrice Shaffer ",
         "DURATION": 413,
         "Year": 2007
      },
      {
         "PERMITID": "HD07-158",
         "APN": 25948027,
         "File Number": "HD07-158",
         "Address": "394 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "HD07-158 - Lake House Historic District",
         "Application Type": "Historic District Designation ",
         "Application Date": "2/15/07",
         "Status": "Approved ",
         "Description": "Historic District Designation for Lake House Historic District on an approximately 8.15 gross acres site Bounded on the north by W. San Fernando St., on the east by Hwy 87 & the VTA Light Rail right-of-way, on the west by Los Gatos Creek & on the south by the rear property lines of lots on the north side of Park Ave, & on the southeast by Sonoma St. and Lakehouse Ave",
         "Planner": "Patrice Shaffer ",
         "DURATION": 413,
         "Year": 2007
      },
      {
         "PERMITID": "HD07-158",
         "APN": 25948028,
         "File Number": "HD07-158",
         "Address": "394 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "HD07-158 - Lake House Historic District",
         "Application Type": "Historic District Designation ",
         "Application Date": "2/15/07",
         "Status": "Approved ",
         "Description": "Historic District Designation for Lake House Historic District on an approximately 8.15 gross acres site Bounded on the north by W. San Fernando St., on the east by Hwy 87 & the VTA Light Rail right-of-way, on the west by Los Gatos Creek & on the south by the rear property lines of lots on the north side of Park Ave, & on the southeast by Sonoma St. and Lakehouse Ave",
         "Planner": "Patrice Shaffer ",
         "DURATION": 413,
         "Year": 2007
      },
      {
         "PERMITID": "HD07-158",
         "APN": 25948048,
         "File Number": "HD07-158",
         "Address": "394 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "HD07-158 - Lake House Historic District",
         "Application Type": "Historic District Designation ",
         "Application Date": "2/15/07",
         "Status": "Approved ",
         "Description": "Historic District Designation for Lake House Historic District on an approximately 8.15 gross acres site Bounded on the north by W. San Fernando St., on the east by Hwy 87 & the VTA Light Rail right-of-way, on the west by Los Gatos Creek & on the south by the rear property lines of lots on the north side of Park Ave, & on the southeast by Sonoma St. and Lakehouse Ave",
         "Planner": "Patrice Shaffer ",
         "DURATION": 413,
         "Year": 2007
      },
      {
         "PERMITID": "HD07-158",
         "APN": 25948049,
         "File Number": "HD07-158",
         "Address": "394 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "HD07-158 - Lake House Historic District",
         "Application Type": "Historic District Designation ",
         "Application Date": "2/15/07",
         "Status": "Approved ",
         "Description": "Historic District Designation for Lake House Historic District on an approximately 8.15 gross acres site Bounded on the north by W. San Fernando St., on the east by Hwy 87 & the VTA Light Rail right-of-way, on the west by Los Gatos Creek & on the south by the rear property lines of lots on the north side of Park Ave, & on the southeast by Sonoma St. and Lakehouse Ave",
         "Planner": "Patrice Shaffer ",
         "DURATION": 413,
         "Year": 2007
      },
      {
         "PERMITID": "CA07-001",
         "APN": 47217014,
         "File Number": "CA07-001",
         "Address": "918 S 3RD ST SAN JOSE",
         "Project Name": "CA07-001, Martha Gardens",
         "Application Type": "Historic District Designation ",
         "Application Date": "4/11/07",
         "Status": "Complete ",
         "Description": "Conservation Area Nomination for the Martha Gardens Conservation Area ",
         "Planner": "Patrice Shaffer ",
         "DURATION": 700,
         "Year": 2007
      },
      {
         "PERMITID": "CA07-001",
         "APN": 47217024,
         "File Number": "CA07-001",
         "Address": "918 S 3RD ST SAN JOSE",
         "Project Name": "CA07-001, Martha Gardens",
         "Application Type": "Historic District Designation ",
         "Application Date": "4/11/07",
         "Status": "Complete ",
         "Description": "Conservation Area Nomination for the Martha Gardens Conservation Area ",
         "Planner": "Patrice Shaffer ",
         "DURATION": 700,
         "Year": 2007
      },
      {
         "PERMITID": "CA07-001",
         "APN": 47217025,
         "File Number": "CA07-001",
         "Address": "918 S 3RD ST SAN JOSE",
         "Project Name": "CA07-001, Martha Gardens",
         "Application Type": "Historic District Designation ",
         "Application Date": "4/11/07",
         "Status": "Complete ",
         "Description": "Conservation Area Nomination for the Martha Gardens Conservation Area ",
         "Planner": "Patrice Shaffer ",
         "DURATION": 700,
         "Year": 2007
      },
      {
         "PERMITID": "CA07-001",
         "APN": 47217040,
         "File Number": "CA07-001",
         "Address": "918 S 3RD ST SAN JOSE",
         "Project Name": "CA07-001, Martha Gardens",
         "Application Type": "Historic District Designation ",
         "Application Date": "4/11/07",
         "Status": "Complete ",
         "Description": "Conservation Area Nomination for the Martha Gardens Conservation Area ",
         "Planner": "Patrice Shaffer ",
         "DURATION": 700,
         "Year": 2007
      },
      {
         "PERMITID": "CA07-001",
         "APN": 47217041,
         "File Number": "CA07-001",
         "Address": "918 S 3RD ST SAN JOSE",
         "Project Name": "CA07-001, Martha Gardens",
         "Application Type": "Historic District Designation ",
         "Application Date": "4/11/07",
         "Status": "Complete ",
         "Description": "Conservation Area Nomination for the Martha Gardens Conservation Area ",
         "Planner": "Patrice Shaffer ",
         "DURATION": 700,
         "Year": 2007
      },
      {
         "PERMITID": "CA07-001",
         "APN": 47217048,
         "File Number": "CA07-001",
         "Address": "918 S 3RD ST SAN JOSE",
         "Project Name": "CA07-001, Martha Gardens",
         "Application Type": "Historic District Designation ",
         "Application Date": "4/11/07",
         "Status": "Complete ",
         "Description": "Conservation Area Nomination for the Martha Gardens Conservation Area ",
         "Planner": "Patrice Shaffer ",
         "DURATION": 700,
         "Year": 2007
      },
      {
         "PERMITID": "CA07-001",
         "APN": 47217050,
         "File Number": "CA07-001",
         "Address": "918 S 3RD ST SAN JOSE",
         "Project Name": "CA07-001, Martha Gardens",
         "Application Type": "Historic District Designation ",
         "Application Date": "4/11/07",
         "Status": "Complete ",
         "Description": "Conservation Area Nomination for the Martha Gardens Conservation Area ",
         "Planner": "Patrice Shaffer ",
         "DURATION": 700,
         "Year": 2007
      },
      {
         "PERMITID": "CA07-001",
         "APN": 47217057,
         "File Number": "CA07-001",
         "Address": "918 S 3RD ST SAN JOSE",
         "Project Name": "CA07-001, Martha Gardens",
         "Application Type": "Historic District Designation ",
         "Application Date": "4/11/07",
         "Status": "Complete ",
         "Description": "Conservation Area Nomination for the Martha Gardens Conservation Area ",
         "Planner": "Patrice Shaffer ",
         "DURATION": 700,
         "Year": 2007
      },
      {
         "PERMITID": "CA07-001",
         "APN": 47217065,
         "File Number": "CA07-001",
         "Address": "918 S 3RD ST SAN JOSE",
         "Project Name": "CA07-001, Martha Gardens",
         "Application Type": "Historic District Designation ",
         "Application Date": "4/11/07",
         "Status": "Complete ",
         "Description": "Conservation Area Nomination for the Martha Gardens Conservation Area ",
         "Planner": "Patrice Shaffer ",
         "DURATION": 700,
         "Year": 2007
      },
      {
         "PERMITID": "CA07-001",
         "APN": 47217075,
         "File Number": "CA07-001",
         "Address": "918 S 3RD ST SAN JOSE",
         "Project Name": "CA07-001, Martha Gardens",
         "Application Type": "Historic District Designation ",
         "Application Date": "4/11/07",
         "Status": "Complete ",
         "Description": "Conservation Area Nomination for the Martha Gardens Conservation Area ",
         "Planner": "Patrice Shaffer ",
         "DURATION": 700,
         "Year": 2007
      },
      {
         "PERMITID": "CA07-001",
         "APN": 47217078,
         "File Number": "CA07-001",
         "Address": "918 S 3RD ST SAN JOSE",
         "Project Name": "CA07-001, Martha Gardens",
         "Application Type": "Historic District Designation ",
         "Application Date": "4/11/07",
         "Status": "Complete ",
         "Description": "Conservation Area Nomination for the Martha Gardens Conservation Area ",
         "Planner": "Patrice Shaffer ",
         "DURATION": 700,
         "Year": 2007
      },
      {
         "PERMITID": "CA07-001",
         "APN": 47217081,
         "File Number": "CA07-001",
         "Address": "918 S 3RD ST SAN JOSE",
         "Project Name": "CA07-001, Martha Gardens",
         "Application Type": "Historic District Designation ",
         "Application Date": "4/11/07",
         "Status": "Complete ",
         "Description": "Conservation Area Nomination for the Martha Gardens Conservation Area ",
         "Planner": "Patrice Shaffer ",
         "DURATION": 700,
         "Year": 2007
      },
      {
         "PERMITID": "CA07-001",
         "APN": 47217086,
         "File Number": "CA07-001",
         "Address": "918 S 3RD ST SAN JOSE",
         "Project Name": "CA07-001, Martha Gardens",
         "Application Type": "Historic District Designation ",
         "Application Date": "4/11/07",
         "Status": "Complete ",
         "Description": "Conservation Area Nomination for the Martha Gardens Conservation Area ",
         "Planner": "Patrice Shaffer ",
         "DURATION": 700,
         "Year": 2007
      },
      {
         "PERMITID": "CA07-001",
         "APN": 47217093,
         "File Number": "CA07-001",
         "Address": "918 S 3RD ST SAN JOSE",
         "Project Name": "CA07-001, Martha Gardens",
         "Application Type": "Historic District Designation ",
         "Application Date": "4/11/07",
         "Status": "Complete ",
         "Description": "Conservation Area Nomination for the Martha Gardens Conservation Area ",
         "Planner": "Patrice Shaffer ",
         "DURATION": 700,
         "Year": 2007
      },
      {
         "PERMITID": "CA07-001",
         "APN": 47218002,
         "File Number": "CA07-001",
         "Address": "918 S 3RD ST SAN JOSE",
         "Project Name": "CA07-001, Martha Gardens",
         "Application Type": "Historic District Designation ",
         "Application Date": "4/11/07",
         "Status": "Complete ",
         "Description": "Conservation Area Nomination for the Martha Gardens Conservation Area ",
         "Planner": "Patrice Shaffer ",
         "DURATION": 700,
         "Year": 2007
      },
      {
         "PERMITID": "CA07-001",
         "APN": 47218006,
         "File Number": "CA07-001",
         "Address": "918 S 3RD ST SAN JOSE",
         "Project Name": "CA07-001, Martha Gardens",
         "Application Type": "Historic District Designation ",
         "Application Date": "4/11/07",
         "Status": "Complete ",
         "Description": "Conservation Area Nomination for the Martha Gardens Conservation Area ",
         "Planner": "Patrice Shaffer ",
         "DURATION": 700,
         "Year": 2007
      },
      {
         "PERMITID": "CA07-001",
         "APN": 47218021,
         "File Number": "CA07-001",
         "Address": "918 S 3RD ST SAN JOSE",
         "Project Name": "CA07-001, Martha Gardens",
         "Application Type": "Historic District Designation ",
         "Application Date": "4/11/07",
         "Status": "Complete ",
         "Description": "Conservation Area Nomination for the Martha Gardens Conservation Area ",
         "Planner": "Patrice Shaffer ",
         "DURATION": 700,
         "Year": 2007
      },
      {
         "PERMITID": "CA07-001",
         "APN": 47218022,
         "File Number": "CA07-001",
         "Address": "918 S 3RD ST SAN JOSE",
         "Project Name": "CA07-001, Martha Gardens",
         "Application Type": "Historic District Designation ",
         "Application Date": "4/11/07",
         "Status": "Complete ",
         "Description": "Conservation Area Nomination for the Martha Gardens Conservation Area ",
         "Planner": "Patrice Shaffer ",
         "DURATION": 700,
         "Year": 2007
      },
      {
         "PERMITID": "CA07-001",
         "APN": 47218024,
         "File Number": "CA07-001",
         "Address": "918 S 3RD ST SAN JOSE",
         "Project Name": "CA07-001, Martha Gardens",
         "Application Type": "Historic District Designation ",
         "Application Date": "4/11/07",
         "Status": "Complete ",
         "Description": "Conservation Area Nomination for the Martha Gardens Conservation Area ",
         "Planner": "Patrice Shaffer ",
         "DURATION": 700,
         "Year": 2007
      },
      {
         "PERMITID": "CA07-001",
         "APN": 47227091,
         "File Number": "CA07-001",
         "Address": "918 S 3RD ST SAN JOSE",
         "Project Name": "CA07-001, Martha Gardens",
         "Application Type": "Historic District Designation ",
         "Application Date": "4/11/07",
         "Status": "Complete ",
         "Description": "Conservation Area Nomination for the Martha Gardens Conservation Area ",
         "Planner": "Patrice Shaffer ",
         "DURATION": 700,
         "Year": 2007
      }
   ],
   "Historic Landmark ": [
      {
         "PERMITID": "HL07-161",
         "APN": 24948050,
         "File Number": "HL07-161",
         "Address": "336 N 6TH ST SAN JOSE",
         "Project Name": "HL07-161 - 336 N. 6th Street: Herrington house",
         "Application Type": "Historic Landmark ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Historic Landmark Nomination for the \"Herrington House\" located on a 0.2-acre site",
         "Planner": "Darren McBain ",
         "DURATION": 359,
         "Year": 2007
      },
      {
         "PERMITID": "HL08-175",
         "APN": 47225075,
         "File Number": "HL08-175",
         "Address": "675 S 6TH ST SAN JOSE",
         "Project Name": "HL08-175 - Somers House - 675 S. 6th Street",
         "Application Type": "Historic Landmark ",
         "Application Date": "9/26/08",
         "Status": "Approved ",
         "Description": "Historical Landmark Nomination to designate a multi-family residence as the \"Somers House\" on a 0.143 gross acre site in the Reed City Landmark Historic District as a landmark of special historic, architectural, cultural, aesthetic or engineering interest, or value of a historic nature.",
         "Planner": "Lori Moniz ",
         "DURATION": 75,
         "Year": 2008
      },
      {
         "PERMITID": "HL08-177",
         "APN": 47228006,
         "File Number": "HL08-177",
         "Address": "553 S 6TH ST SAN JOSE",
         "Project Name": "HL08-177 - Lynwood Apartments - 553 S. 6th St. (w/MA08-009)",
         "Application Type": "Historic Landmark ",
         "Application Date": "9/30/08",
         "Status": "Approved ",
         "Description": "Historical Landmark Nomination to designate the \"Lynwood Apartments\" on a 0.22-acre site as a landmark of special historic, architectural, cultural, aesthetic or engineering interest, or value of a historic nature.",
         "Planner": "Lori Moniz ",
         "DURATION": 190,
         "Year": 2008
      },
      {
         "PERMITID": "HL08-179",
         "APN": 46724032,
         "File Number": "HL08-179",
         "Address": "80 S 6TH ST SAN JOSE",
         "Project Name": "HL08-179 - Rev. G. A. Miller Residence - 80 S. 6th St. (w/MA08-011)",
         "Application Type": "Historic Landmark ",
         "Application Date": "11/19/08",
         "Status": "Approved ",
         "Description": "Historical Landmark Nomination to designate the \"Rev. G. A. Miller Residence\" on a 0.136-acre site as a landmark of special historic, architectural, cultural, aesthetic or engineering interest, or value of a historic nature.",
         "Planner": "Lori Moniz ",
         "DURATION": 386,
         "Year": 2008
      },
      {
         "PERMITID": "HL10-190",
         "APN": 47228045,
         "File Number": "HL10-190",
         "Address": "530 S 6TH ST SAN JOSE",
         "Project Name": "HL10-190",
         "Application Type": "Historic Landmark ",
         "Application Date": "4/14/10",
         "Status": "Approved ",
         "Description": "Historic Landmark Designation for the Hermle-Fancher House ",
         "Planner": "Ben Nguyen ",
         "DURATION": 30,
         "Year": 2010
      },
      {
         "PERMITID": "HL11-200",
         "APN": 46702040,
         "File Number": "HL11-200",
         "Address": "285 E ST JAMES ST SAN JOSE",
         "Project Name": "HL11-200 - Stiller House - 285 E. St. James Street (w/MA11-004)",
         "Application Type": "Historic Landmark ",
         "Application Date": "10/26/11",
         "Status": "Approved ",
         "Description": "Historical Landmark Nomination to designate the \"Stiller House\" as a landmark of special historic, architectural, cultural, aesthetic or engineering interest, or value of a historic nature ",
         "Planner": "Lori Moniz ",
         "DURATION": 1,
         "Year": 2011
      },
      {
         "PERMITID": "HL11-202",
         "APN": 47225070,
         "File Number": "HL11-202",
         "Address": "641 S 6TH ST SAN JOSE",
         "Project Name": "HL11-202 - Samuel and Lila Martin House #1 - 641 S. 6th St. (w/MA11-006)",
         "Application Type": "Historic Landmark ",
         "Application Date": "11/2/11",
         "Status": "Approved ",
         "Description": "Historical Landmark Nomination to designate the \"Samuel and Lila Martin House #1\" as a landmark of special historic, architectural, cultural, aesthetic or engineering interest, or value of a historic nature",
         "Planner": "Lori Moniz ",
         "DURATION": 1,
         "Year": 2011
      },
      {
         "PERMITID": "HL12-204",
         "APN": 46701055,
         "File Number": "HL12-204",
         "Address": "255 N 5TH ST SAN JOSE",
         "Project Name": "HL12-204 - Burns House - 255 N. 5th Street",
         "Application Type": "Historic Landmark ",
         "Application Date": "6/11/12",
         "Status": "Complete ",
         "Description": "Historical Landmark Nomination to designate the \"Burns House\" as a landmark of special historic, architectural, cultural, aesthetic or engineering interest, or value of a historic nature ",
         "Planner": "Lori Moniz ",
         "DURATION": 139,
         "Year": 2012
      }
   ],
   "Historic Pres Permit Adjustment ": [
      {
         "PERMITID": "AD04-1103",
         "APN": 46745028,
         "File Number": "AD04-1103",
         "Address": "312 S 3RD ST SAN JOSE",
         "Project Name": "AD04-1103",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "10/26/04",
         "Status": "Approved ",
         "Description": " ",
         "Planner": "MNAGARAJ ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-277",
         "APN": 46721031,
         "File Number": "AD04-277",
         "Address": "81 N 2ND ST SAN JOSE",
         "Project Name": "AD04-277",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "3/30/04",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment to replace 5 windows to match existing windows.",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-286",
         "APN": 24946049,
         "File Number": "AD04-286",
         "Address": "359 N 5TH ST SAN JOSE",
         "Project Name": "AD04-286",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "4/2/04",
         "Status": "Approved ",
         "Description": "To allow demolition of existing garage and construction of new garage (HPAD04-286)",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-508",
         "APN": 25934018,
         "File Number": "AD04-508",
         "Address": "81 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD04-508",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "5/21/04",
         "Status": "Approved ",
         "Description": "DELETE EXTERIOR STAIR PROPOSED. DELETE ONE MAN DOOR EXIT. REPLACE FRONT DOOR WITH MATCHING DOORS IWTH PANIC HARDWARE, ADD ROOF ACCESS LADDER ON SIDE OF BUILDING. NO SIGNAGE. ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-624",
         "APN": 25942079,
         "File Number": "AD04-624",
         "Address": "211 S 1ST ST SAN JOSE",
         "Project Name": "AD04-624",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "6/8/04",
         "Status": "Approved ",
         "Description": "Permit to add a roof screen at a restuarant for the mechanical roof top equipment. ",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-707",
         "APN": 47226036,
         "File Number": "AD04-707",
         "Address": "520 S 1ST ST SAN JOSE",
         "Project Name": "AD04-707",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "7/12/04",
         "Status": "Approved ",
         "Description": "Minimal Facade changes to a City Landmark (Costa-Miller Building) ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD05-006",
         "APN": 25938128,
         "File Number": "AD05-006",
         "Address": "374 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD05-006",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "1/3/05",
         "Status": "Approved ",
         "Description": "Historic preservation permit adjustment to remove two fountains. ",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 1,
         "Year": 2005
      },
      {
         "PERMITID": "AD05-1102",
         "APN": 46702116,
         "File Number": "AD05-1102",
         "Address": "268 E JULIAN ST SAN JOSE",
         "Project Name": "AD05-1102",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "10/24/05",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow one free standing sign ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2005
      },
      {
         "PERMITID": "AD05-1110",
         "APN": 24948050,
         "File Number": "AD05-1110",
         "Address": "336 N 6TH ST SAN JOSE",
         "Project Name": "AD05-1110",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "10/25/05",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow minor window modification to the exterior of the existing house, add a new bath room with new window and laundary room in the basement area ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2005
      },
      {
         "PERMITID": "AD05-133",
         "APN": 46745028,
         "File Number": "AD05-133",
         "Address": "312 S 3RD ST SAN JOSE",
         "Project Name": "AD05-133",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "2/16/05",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment for the installation of a handicap lift and deck modification at a restaurant. ",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 1,
         "Year": 2005
      },
      {
         "PERMITID": "AD05-446",
         "APN": 25938128,
         "File Number": "AD05-446",
         "Address": "374 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD05-446",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "5/10/05",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment for replacement of glass on four windows on the first floor of a historic office building (San Jose Water Company). ",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 1,
         "Year": 2005
      },
      {
         "PERMITID": "AD06-1217",
         "APN": 26429065,
         "File Number": "AD06-1217",
         "Address": "387 S 1ST ST SAN JOSE",
         "Project Name": "AD06-1217",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "10/24/06",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment for the West Prussian Building, City Landmark No. HL01-130, to: (1) add two rooftop escape ladders; and (2) retrofit one existing aluminum window with a fire-rated window to meet Fire Code requirements. Escape ladders are located behind existing parapet and are not visible from public right-of-way. Retrofitted window is same size, same opening as existing window and is not visible from public right-of-way.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-1288",
         "APN": 25932082,
         "File Number": "AD06-1288",
         "Address": "175 W ST JOHN ST SAN JOSE",
         "Project Name": "AD06-1288",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "11/9/06",
         "Status": "Approved ",
         "Description": "Repair or replacement of front and rear stairs and landing of porches, including risers, steps, base of columns. Replaced elements will be \"like-for-like\" with redwood. (e) wood windows to be repaired and refurbished. Scope of work includes rebuilding of north porch, restoration of deteriorated portions of brick foundation. Historic: Thomas Fallon House. File HL77-9. Residence # 49228.",
         "Planner": "Lee Butler ",
         "DURATION": 6,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-1392",
         "APN": 46721013,
         "File Number": "AD06-1392",
         "Address": "96 N 2ND ST SAN JOSE",
         "Project Name": "AD06-1392",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "12/8/06",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment for the installation of two new windows to the second floor north elevation of the former S&H Green Stamp Redemption Building located in City Landmark District, St. James Square Historic Area. ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-318",
         "APN": 46722158,
         "File Number": "AD06-318",
         "Address": "30 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD06-318",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "4/3/06",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment for facade improvements to the existing one-story structure (formerly 37 Fountain Alley) as part of 03-004",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-531",
         "APN": 46701027,
         "File Number": "AD06-531",
         "Address": "65 E ST JAMES ST SAN JOSE",
         "Project Name": "AD06-531",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "5/24/06",
         "Status": "Approved ",
         "Description": "RECONSTRUCT AND REPAIR EXISTING SECOND STORY BALCONY and RAILING IN THE FRONT AND INSTALL PERMANENT ADA LIFT IN THE REAR. ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-734",
         "APN": 47224074,
         "File Number": "AD06-734",
         "Address": "374 MARGARET ST SAN JOSE",
         "Project Name": "AD06-734",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "7/6/06",
         "Status": "Approved ",
         "Description": "REPAIR AND REPLACE SIDING TO LAP-BOARD REDWD SIDING TO MATCH ORIGINAL HOUSE. NEW FRONT YARD PICKET FENCE, FRONT FASCIA TRIM, BACK WINDOW FRAMES AND TRIM TO MATCH EXISTING ONLY ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-854",
         "APN": 46723035,
         "File Number": "AD06-854",
         "Address": "142 E SANTA CLARA ST SAN JOSE",
         "Project Name": "HPAD06-854 - State Meat Market Sign",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "7/31/06",
         "Status": "Approved ",
         "Description": "Historic Preservation (HP) Permit Adjustment to reproduce the damaged painted sign on the c. 1913 State Meat Market building (City Landmark No. HL92-70), located in the Downtown Commercial National Register District",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-883",
         "APN": 46762001,
         "File Number": "AD06-883",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "AD06-883",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "8/8/06",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment to extend the validity of HP05-001 until September 21, 2008. One more one-year time extension is allowed with a separate Historic Preservation Permit Adjustment.",
         "Planner": "Lori Moniz ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-883",
         "APN": 46762007,
         "File Number": "AD06-883",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "AD06-883",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "8/8/06",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment to extend the validity of HP05-001 until September 21, 2008. One more one-year time extension is allowed with a separate Historic Preservation Permit Adjustment.",
         "Planner": "Lori Moniz ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-883",
         "APN": 46762008,
         "File Number": "AD06-883",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "AD06-883",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "8/8/06",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment to extend the validity of HP05-001 until September 21, 2008. One more one-year time extension is allowed with a separate Historic Preservation Permit Adjustment.",
         "Planner": "Lori Moniz ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-883",
         "APN": 46762009,
         "File Number": "AD06-883",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "AD06-883",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "8/8/06",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment to extend the validity of HP05-001 until September 21, 2008. One more one-year time extension is allowed with a separate Historic Preservation Permit Adjustment.",
         "Planner": "Lori Moniz ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-883",
         "APN": 46762011,
         "File Number": "AD06-883",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "AD06-883",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "8/8/06",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment to extend the validity of HP05-001 until September 21, 2008. One more one-year time extension is allowed with a separate Historic Preservation Permit Adjustment.",
         "Planner": "Lori Moniz ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-883",
         "APN": 46762012,
         "File Number": "AD06-883",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "AD06-883",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "8/8/06",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment to extend the validity of HP05-001 until September 21, 2008. One more one-year time extension is allowed with a separate Historic Preservation Permit Adjustment.",
         "Planner": "Lori Moniz ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-883",
         "APN": 46762014,
         "File Number": "AD06-883",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "AD06-883",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "8/8/06",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment to extend the validity of HP05-001 until September 21, 2008. One more one-year time extension is allowed with a separate Historic Preservation Permit Adjustment.",
         "Planner": "Lori Moniz ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-883",
         "APN": 46762015,
         "File Number": "AD06-883",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "AD06-883",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "8/8/06",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment to extend the validity of HP05-001 until September 21, 2008. One more one-year time extension is allowed with a separate Historic Preservation Permit Adjustment.",
         "Planner": "Lori Moniz ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-883",
         "APN": 46762016,
         "File Number": "AD06-883",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "AD06-883",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "8/8/06",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment to extend the validity of HP05-001 until September 21, 2008. One more one-year time extension is allowed with a separate Historic Preservation Permit Adjustment.",
         "Planner": "Lori Moniz ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-883",
         "APN": 46762017,
         "File Number": "AD06-883",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "AD06-883",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "8/8/06",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment to extend the validity of HP05-001 until September 21, 2008. One more one-year time extension is allowed with a separate Historic Preservation Permit Adjustment.",
         "Planner": "Lori Moniz ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-883",
         "APN": 46762019,
         "File Number": "AD06-883",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "AD06-883",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "8/8/06",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment to extend the validity of HP05-001 until September 21, 2008. One more one-year time extension is allowed with a separate Historic Preservation Permit Adjustment.",
         "Planner": "Lori Moniz ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-883",
         "APN": 46762020,
         "File Number": "AD06-883",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "AD06-883",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "8/8/06",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment to extend the validity of HP05-001 until September 21, 2008. One more one-year time extension is allowed with a separate Historic Preservation Permit Adjustment.",
         "Planner": "Lori Moniz ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-910",
         "APN": 46757083,
         "File Number": "AD06-910",
         "Address": "235 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD06-910",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "8/15/06",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment for the installation of a kitchen exhaust duct on the existing rear exit stairs to allow for re-use of ground floor as restaurant in Vintage Tower City Landmark No. HL86-39.",
         "Planner": "Lori Moniz ",
         "DURATION": 0,
         "Year": 2006
      },
      {
         "PERMITID": "AD07-130",
         "APN": 47226036,
         "File Number": "AD07-130",
         "Address": "520 S 1ST ST SAN JOSE",
         "Project Name": "AD07-130",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "2/5/07",
         "Status": "Approved ",
         "Description": "Sign Permit Adjustment to add signage on five new awnings on the City Landmark Costa/Miller Building, HL01-128. Signs read \"San Jose Museum of Quilts and Textiles\" with logo.",
         "Planner": "Darren McBain ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-133",
         "APN": 46746044,
         "File Number": "AD07-133",
         "Address": "374 S 1ST ST SAN JOSE",
         "Project Name": "AD07-133",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "2/5/07",
         "Status": "Approved ",
         "Description": "Non-structural facade improvements: replace second floor windows with casement type windows of same size, material (aluminum frame), and shape; replace canvas and steel awning with canvas and steel awning spanning the length of the frontage; install LED signage lighting under the new awning (as shown in plan set); install three 1ft10in wall lights on stucco columns below awning; and remove existing flourescent strip lighting above existing awning.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-1485",
         "APN": 25945030,
         "File Number": "AD07-1485",
         "Address": "396 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "SJIA HPAD07-1485",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "11/28/07",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow: (1) the replacement or modifications of existing doors and windows for the purpose of mitigating aircraft noise; and (2) the installation of a complete HVAC system to be located at left side of property concealed by a screen.",
         "Planner": "Sylvia Do ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-1568",
         "APN": 25933044,
         "File Number": "AD07-1568",
         "Address": "93 DEVINE ST SAN JOSE",
         "Project Name": "AD07-1568",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "12/13/07",
         "Status": "Approved ",
         "Description": "Historic Permit Adjustment for a facade improvement for buildings located at 79-93 Devine Street. The improvements are on all 4 facades of the two buildings, consisting of preservation of historic elements of the building, new paint, replacement of awnings, replacement of signage, and replacement of existing rear doors.",
         "Planner": "Darren McBain ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-1568",
         "APN": 25933045,
         "File Number": "AD07-1568",
         "Address": "93 DEVINE ST SAN JOSE",
         "Project Name": "AD07-1568",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "12/13/07",
         "Status": "Approved ",
         "Description": "Historic Permit Adjustment for a facade improvement for buildings located at 79-93 Devine Street. The improvements are on all 4 facades of the two buildings, consisting of preservation of historic elements of the building, new paint, replacement of awnings, replacement of signage, and replacement of existing rear doors.",
         "Planner": "Darren McBain ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-672",
         "APN": 47228027,
         "File Number": "AD07-672",
         "Address": "505 S 7TH ST SAN JOSE",
         "Project Name": "HPAD07-672",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "6/11/07",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment to replace non-historic rear stair and landing with new compatible construction to match existing in material and color. ",
         "Planner": "Lori Moniz ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-743",
         "APN": 25934018,
         "File Number": "AD07-743",
         "Address": "81 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD07-743 The Vault",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "6/27/07",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment to allow installation of a fire department connection on a City Landmark structure ",
         "Planner": "Lesley Xavier ",
         "DURATION": 2,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-869",
         "APN": 47228027,
         "File Number": "AD07-869",
         "Address": "505 S 7TH ST SAN JOSE",
         "Project Name": "HPAD07-869",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "7/27/07",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment for exterior alterations to a Contributing Structure in the Reed Historic District ",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-990",
         "APN": 25934018,
         "File Number": "AD07-990",
         "Address": "81 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD07-990",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "8/23/07",
         "Status": "Approved ",
         "Description": "Repair exterior terracotta on the front facade of the building, repair and repaint the existing roof mounted flagpole, repaint existing metal windows and install new glazing, repair stone along the base of the building, and install two new vertical banners signs. ",
         "Planner": "Ben Corrales ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "AD08-1071",
         "APN": 25945077,
         "File Number": "AD08-1071",
         "Address": "432 LAKEHOUSE AV SAN JOSE",
         "Project Name": "AD08-1071",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "8/29/08",
         "Status": "Approved ",
         "Description": "To make changes to an approved 4-car garage. To add a window 5'X4' and a door 3'X6'8\" on the South side and replace a 5' wide window with a 3'X6'8\" door on the North side; Change the roof pitch resulting in 14' maximum height instead of the approved 13'-2\".",
         "Planner": "Lee Butler ",
         "DURATION": 0,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-1224",
         "APN": 46720073,
         "File Number": "AD08-1224",
         "Address": "196 N 3RD ST SAN JOSE",
         "Project Name": "AD08-1224",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "10/20/08",
         "Status": "Approved ",
         "Description": "Minor alteration to the section of the building adjacent to south side of grand staircase entrance including: replacement of existing stairs leading to the basement, with stairs in kind; replacement of ramp wall with transparent railing; installation canvas awning and signage above basement stairs, and replacement of existing none original door to basement with glass door that conforms with ADA requirements.  ",
         "Planner": "Hadasa Lev ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-1381",
         "APN": 25934046,
         "File Number": "AD08-1381",
         "Address": "101 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD08-1381",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "12/9/08",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment to allow exterior remodeling including paint, lighting, window treatment, and signage ",
         "Planner": "Ella Samonsky ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-412",
         "APN": 24946053,
         "File Number": "AD08-412",
         "Address": "341 N 5TH ST SAN JOSE",
         "Project Name": "AD08-412",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "3/25/08",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment for modifications to a single-family house listed on Historic Resources inventory (C. 1905 Stammer Residence). The changes include: Removal of an existing nonhistoric window on the front façade, rehabilitation of the upstairs front deck/balcony to its original size and appearance, removal of an existing nonhistoric dormer and skylight on the north side of the building, and legalization of existing unpermitted dormers on the south side and rear of the building (see plan set and photos).",
         "Planner": "Darren McBain ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-976",
         "APN": 46721002,
         "File Number": "AD08-976",
         "Address": "95 N 3RD ST SAN JOSE",
         "Project Name": "AD08-976",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "8/1/08",
         "Status": "Approved ",
         "Description": "Third Street Garage Staircase Replacement Project for the design build replacement of two staircases and the structural/architectural renovation of a third staircase, including plumbing and electrical systems renovations to provide drainage from stair landings, the replacement of garage exit doors and the addition of guardrails and guardrail pickets. ",
         "Planner": "Lee Butler ",
         "DURATION": 0,
         "Year": 2008
      },
      {
         "PERMITID": "AD09-112",
         "APN": 25942079,
         "File Number": "AD09-112",
         "Address": "211 S 1ST ST SAN JOSE",
         "Project Name": "AD09-112",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "2/5/09",
         "Status": "Approved ",
         "Description": "Historic Preservation PEmrit request for additing two freestanding Banner Signs, that read \"MOSAIC Now Open\" of approximately 13.5 feet in height, in the landscaped strip in the front of Montgomery Hotel, a City Landmark Building",
         "Planner": "Lee Butler ",
         "DURATION": 5,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-117",
         "APN": 26429058,
         "File Number": "AD09-117",
         "Address": "325 S 1ST ST SAN JOSE",
         "Project Name": "HPAD09-117",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "2/9/09",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment for a 9.25 square foot fin sign with exposed neon \"The Blue Chip\" on a City Landmark Building.",
         "Planner": "Lee Butler ",
         "DURATION": 3,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-674",
         "APN": 25934046,
         "File Number": "AD09-674",
         "Address": "101 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD09-674",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "7/22/09",
         "Status": "Approved ",
         "Description": "Sign permit Adjustment request for one attached illuminated sign, 120 square feet in size, wrapped around the corner of a building \"Chamber of Commerce\"",
         "Planner": "Jeff Roche ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "AD10-102",
         "APN": 25942079,
         "File Number": "AD10-102",
         "Address": "211 S 1ST ST SAN JOSE",
         "Project Name": "AD10-102",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "2/12/10",
         "Status": "Approved ",
         "Description": "Historic Preservation Sign Permit Adjustment to remove and relocate an existing verticle sign to another building/site.  ",
         "Planner": "Mike Enderby ",
         "DURATION": 1,
         "Year": 2010
      },
      {
         "PERMITID": "AD10-304",
         "APN": 46721031,
         "File Number": "AD10-304",
         "Address": "81 N 2ND ST SAN JOSE",
         "Project Name": "AD10-304",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "4/27/10",
         "Status": "Approved ",
         "Description": "HISTORIC PRESERVATION PERMIT ADJUSTMENT TO ALLOW THE REPLACEMENT OF (4) FOUR WINDOWS ON AN EXISTING RELIGIOUS ASSEMBLY BUILDING ONLY.",
         "Planner": "John Davidson ",
         "DURATION": 1,
         "Year": 2010
      },
      {
         "PERMITID": "AD10-460",
         "APN": 25940043,
         "File Number": "AD10-460",
         "Address": "27 S 1ST ST SAN JOSE",
         "Project Name": "AD10-460",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "6/18/10",
         "Status": "Approved ",
         "Description": "Permit to install an attached sign and graphics on an existing commercial building listed on the City's Historic Resource Inventory.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2010
      },
      {
         "PERMITID": "AD11-559",
         "APN": 46747050,
         "File Number": "AD11-559",
         "Address": "470 S 3RD ST SAN JOSE",
         "Project Name": "AD11-559",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "7/12/11",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment to allow the relocation of existing gas and water meters from the north elevation to the south elevation, addition of a gas water heater and water softener unit on the south elevation, addition of five air conditioning units on the south elevation, installation of a 6-foot wrought iron gate, and installation of four rooftop air conditioning units.",
         "Planner": "Mike Enderby ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD12-233",
         "APN": 26429065,
         "File Number": "AD12-233",
         "Address": "371 S 1ST ST SAN JOSE",
         "Project Name": "AD12-233",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "3/6/12",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment to allow minor exterior modifications including the replacement of upper level windows on the front elevation with wood-clad windows, replace rotted wood trim, replace rear windows and restore some windows to original size, add two balconies, and add skylights to a City Landmark site/structure (W. Prussia building). ",
         "Planner": "Sylvia Do ",
         "DURATION": 1,
         "Year": 2012
      },
      {
         "PERMITID": "AD12-424",
         "APN": 26429058,
         "File Number": "AD12-424",
         "Address": "325 S 1ST ST SAN JOSE",
         "Project Name": "HPAD12-424",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "4/27/12",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment change a storefront window from a standard window to an openable window for the sale of goods (i.e. food sales through the window).  ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2012
      },
      {
         "PERMITID": "AD12-428",
         "APN": 25935050,
         "File Number": "AD12-428",
         "Address": "184 W ST JOHN ST SAN JOSE",
         "Project Name": "AD12-428",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "4/27/12",
         "Status": "Approved ",
         "Description": "HP Adjustment to approved previously modified landscape details in the Peralta Adobe courtyard, including installation of pavers, seating walls, landscaping, tables/chairs, gate modifications, and seating areas.  ",
         "Planner": "Martina Davis ",
         "DURATION": 0,
         "Year": 2012
      },
      {
         "PERMITID": "AD12-783",
         "APN": 26429065,
         "File Number": "AD12-783",
         "Address": "387 S 1ST ST SAN JOSE",
         "Project Name": "AD12-783 W. Prussia Building",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "8/3/12",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment to allow minor exterior modifications to the front and rear elevations, including the restoration and reconfiguration of storefronts and to accomodate Fire Department standpipe requirements, of a city landmark site/structure (W. Prussia Building, Historic Landmark No. HL01-130).",
         "Planner": "Sylvia Do ",
         "DURATION": 1,
         "Year": 2012
      },
      {
         "PERMITID": "AD14-081",
         "APN": 26429107,
         "File Number": "AD14-081",
         "Address": "302 S MARKET ST SAN JOSE",
         "Project Name": "AD14-081",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "1/27/14",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment to add a sign on top on an existing porte cochere, two plaques at the entry door, add a sign to the existing rooftop signage, and repair or replace the existing \"Sainte Claire\" sign at the top of the building. ",
         "Planner": "Sylvia Do ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "AD14-571",
         "APN": 24946053,
         "File Number": "AD14-571",
         "Address": "341 N 5TH ST SAN JOSE",
         "Project Name": "HPAD14-571",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "6/4/14",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment to allow revisions to an approved permit (AD08-412) which allowed modifications to a single-family house listed on Historic Resources Inventory as a Contributing Structure to the Hensley City Landmark District (C. 1905 Stammer Residence). The new scope of work consists of the removal of an existing nonhistoric window on the front façade; rehabilitation of the front, decorative balcony to its original size and appearance (wooden ornamental rail, approximately 8 by 3 feet in size). The existing dormers, permitted in 1921, are proposed to remain.",
         "Planner": "Lori Moniz ",
         "DURATION": 1,
         "Year": 2014
      },
      {
         "PERMITID": "AD14-808",
         "APN": 47224029,
         "File Number": "AD14-808",
         "Address": "648 S 7TH ST SAN JOSE",
         "Project Name": "AD14-808",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "8/4/14",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment to reroof a single-family residence in a Historic Landmark District and replace existing composition roof with new composition roof.  ",
         "Planner": "Justin Daniels ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "AD15-042",
         "APN": 24946071,
         "File Number": "AD15-042",
         "Address": "350 N 4TH ST SAN JOSE",
         "Project Name": "HPAD15-042",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "1/16/15 16:22",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment to for construction of a new accessory structure, 288 square feet in size, in the rear yard of an existing single family residence identified as a Contributing Structure in the Hensley City Landmark District on a 0.10 gross acre site",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2015
      },
      {
         "PERMITID": "AD15-074",
         "APN": 24946071,
         "File Number": "AD15-074",
         "Address": "350 N 4TH ST SAN JOSE",
         "Project Name": "HPAD15-074",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "1/27/15",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment to allow new Photo Voltaic roof panels for an existing single-family residence on a 0.11 gross acre site and located in the Hensley Historic Conservation Area.",
         "Planner": "Susan Walsh ",
         "DURATION": 1,
         "Year": 2015
      },
      {
         "PERMITID": "AD15-1348",
         "APN": 47228006,
         "File Number": "AD15-1348",
         "Address": "551 S 6TH ST SAN JOSE",
         "Project Name": "HPAD15-1348",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "12/7/15 9:15",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow the installation of an approximately 250 square foot detached trellis structure, located to the rear of and measuring approximately 6 feet from the building face of an existing multi-family development, consisting of six units, on an approximately 0.21 gross acre site in the R-M Multiple Residence zoning district. The subject property is located in the pending Reed City Landmark Historic District.",
         "Planner": "Aparna Ankola ",
         "DURATION": 1,
         "Year": 2015
      },
      {
         "PERMITID": "AD15-616",
         "APN": 25936039,
         "File Number": "AD15-616",
         "Address": "320 W ST JOHN ST SAN JOSE",
         "Project Name": "HPAD15-616",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "6/8/15 13:16",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment request to repaint building, repair eaves, relocate/clean-up utility connections, repair windows, replace entry doors and storefront, remodel gate as necessary, add a trash enclosure, and construct at 200 square foot rear addition to a site with an existing Candidate City Landmark Structure, the \"Alameda French Bakery\" in the River Street Historic District.",
         "Planner": "Elizabeth Schuller ",
         "DURATION": 1,
         "Year": 2015
      },
      {
         "PERMITID": "AD16-1155",
         "APN": 46718037,
         "File Number": "AD16-1155",
         "Address": "191 N 9TH ST SAN JOSE",
         "Project Name": "AD16-1155",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "10/17/16 14:04",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow the replacement of six (6) windows with three (3) new windows on the rear elevation of a house listed as an identified structure in the historic inventory",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2016
      },
      {
         "PERMITID": "AD16-327",
         "APN": 24944015,
         "File Number": "AD16-327",
         "Address": "345 N 3RD ST SAN JOSE",
         "Project Name": "AD16-327",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "3/17/16 14:44",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment to allow replacement of 13 windows on the first and second floor with a like-for-like architecturally styled window of the same size on a building listed on the City of San Jose Historic Resources Inventory as a Contributing Structure in the Italianate architectural style built circa 1875.",
         "Planner": "Lori Moniz ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "AD16-548",
         "APN": 46718102,
         "File Number": "AD16-548",
         "Address": "51 N 9TH ST SAN JOSE",
         "Project Name": "HPAD16-548",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "5/5/16",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment to install/reconstruct two ADA compliant access ramps; install a new transformer, switchgear, and equipment screen; install ground mounted HVAC equipment, replace two drinking fountains; and to allow replacement of windows to match the style of existing windows on a Historic Landmark, St Patrick's Parochial School (HS92-73). This permit modifies previous approval HPAD15-124.",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2016
      },
      {
         "PERMITID": "AD16-661",
         "APN": 46721001,
         "File Number": "AD16-661",
         "Address": "0 E SANTA CLARA ST SAN JOSE",
         "Project Name": "HPAD16-661- St. James Park temporary fountain stage and other improvements",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "6/9/16 16:50",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment to temporary encapsulate the existing fountain basin adjacent to N Second Street in St. James Park with a removable redwood deck, rehabilitation of benches and light poles, minor electrical work, and installation of temporary ground surfaces in areas of degraded turf or groundcover.  ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2016
      },
      {
         "PERMITID": "AD16-661",
         "APN": 46721014,
         "File Number": "AD16-661",
         "Address": "0 E SANTA CLARA ST SAN JOSE",
         "Project Name": "HPAD16-661- St. James Park temporary fountain stage and other improvements",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "6/9/16 16:50",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment to temporary encapsulate the existing fountain basin adjacent to N Second Street in St. James Park with a removable redwood deck, rehabilitation of benches and light poles, minor electrical work, and installation of temporary ground surfaces in areas of degraded turf or groundcover.  ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2016
      },
      {
         "PERMITID": "HPAD13-1023",
         "APN": 24944015,
         "File Number": "HPAD13-1023",
         "Address": "345 N 3RD ST SAN JOSE",
         "Project Name": "HPAD13-1023",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "9/20/13",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adustment to allow replacement of a first floor window with a like-for-like architectural styled window of the same size located along the side of the building, listed on the City of San Jose Historic Resources Inventory as a Contributing Structure in the Italianate architectural style built circa 1875.",
         "Planner": "Jan Warne ",
         "DURATION": 1,
         "Year": 2013
      },
      {
         "PERMITID": "HPAD13-1253",
         "APN": 25930044,
         "File Number": "HPAD13-1253",
         "Address": "143 N ALMADEN BL SAN JOSE",
         "Project Name": "HPAD13-1253",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "11/19/13",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment for restoration of an existing single family residence that is a Contributing Structure to the River Street Historic Landmark District including repalcement of windows, restoration of siding, restoration of the porch ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2013
      },
      {
         "PERMITID": "HPAD13-1254",
         "APN": 25930048,
         "File Number": "HPAD13-1254",
         "Address": "325 W ST JOHN ST SAN JOSE",
         "Project Name": "HPAD13-1254",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "11/19/13",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment for restoration of an existing single family residence that is a Contributing Structure to the River Street City Landmark District ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2013
      },
      {
         "PERMITID": "HPAD14-054",
         "APN": 24946027,
         "File Number": "HPAD14-054",
         "Address": "330 N 3RD ST SAN JOSE",
         "Project Name": "HPAD14-054",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "1/21/14",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment for maintenance of an existing multi- family residence that is a Contributing Structure to the Hensley Historic District ",
         "Planner": "John Baty ",
         "DURATION": 1,
         "Year": 2014
      },
      {
         "PERMITID": "HPAD14-096",
         "APN": 24944015,
         "File Number": "HPAD14-096",
         "Address": "345 N 3RD ST SAN JOSE",
         "Project Name": "HPAD14-096",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "1/30/14",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment to allow removing aluminum windows, installed without a permit, and replacing them with wood-framed windows matching the historic architecture of the building. ",
         "Planner": "Susan Walsh ",
         "DURATION": 1,
         "Year": 2014
      },
      {
         "PERMITID": "HPAD14-1292",
         "APN": 24948017,
         "File Number": "HPAD14-1292",
         "Address": "370 N 5TH ST SAN JOSE",
         "Project Name": "HPAD14-1292",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "12/4/14",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment to replace the existing stairs at the rear of the house. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "HPAD14-163",
         "APN": 25940094,
         "File Number": "HPAD14-163",
         "Address": "35 S MARKET ST SAN JOSE",
         "Project Name": "HPAD14-163",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "2/20/14",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment for non-structural facade change to repair the entryway tile and wood floor framing underneath the tile ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "HPAD14-737",
         "APN": 47218006,
         "File Number": "HPAD14-737",
         "Address": "754 S 3RD ST SAN JOSE",
         "Project Name": "HPAD14-737",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "7/17/14",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment to allow replacement of the electrical panel located on the side of the home. ",
         "Planner": "Jan Warne ",
         "DURATION": 1,
         "Year": 2014
      },
      {
         "PERMITID": "HPAD14-760",
         "APN": 25940094,
         "File Number": "HPAD14-760",
         "Address": "35 S MARKET ST SAN JOSE",
         "Project Name": "HPAD14-760",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "7/22/14",
         "Status": "Approved ",
         "Description": "Historic Preservcation Permit Adjustment to install one (1) sign that is 85.9 square feet with a frontage of 79 feet.",
         "Planner": "Jan Warne ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "HPAD14-805",
         "APN": 47228041,
         "File Number": "HPAD14-805",
         "Address": "562 S 6TH ST SAN JOSE",
         "Project Name": "HPAD14-805",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "8/1/14 13:13",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment Application to tear off and reroof to similar material and color. ",
         "Planner": "Kristinae Toomians ",
         "DURATION": 1,
         "Year": 2014
      },
      {
         "PERMITID": "HPAD14-930",
         "APN": 46718102,
         "File Number": "HPAD14-930",
         "Address": "51 N 9TH ST SAN JOSE",
         "Project Name": "HPAD14-930 St Patrick's School",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "10/2/14 13:26",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment to install and reconstruct two ADA compliant access ramps; install a new transformer, switchgear and equipment screen; install two ground mounted HVAC condensers; replace two drinking fountains; and replace windows with wood windows to match existing on a Historic Landmark, St Patrick's Parochial School (HS92-73).",
         "Planner": "Kristinae Toomians ",
         "DURATION": 1,
         "Year": 2014
      },
      {
         "PERMITID": "HPAD14-930",
         "APN": 46718103,
         "File Number": "HPAD14-930",
         "Address": "51 N 9TH ST SAN JOSE",
         "Project Name": "HPAD14-930 St Patrick's School",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "10/2/14 13:26",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment to install and reconstruct two ADA compliant access ramps; install a new transformer, switchgear and equipment screen; install two ground mounted HVAC condensers; replace two drinking fountains; and replace windows with wood windows to match existing on a Historic Landmark, St Patrick's Parochial School (HS92-73).",
         "Planner": "Kristinae Toomians ",
         "DURATION": 1,
         "Year": 2014
      },
      {
         "PERMITID": "HPAD15-124",
         "APN": 46718102,
         "File Number": "HPAD15-124",
         "Address": "51 N 9TH ST SAN JOSE",
         "Project Name": "HPAD15-124",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "1/9/15",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment to install and reconstruct two ADA compliant access ramps; install a new transformer, switchgear and equipment screen; install two ground mounted HVAC condensers; replace two drinking fountains; and replace windows with wood windows to match existing on a Historic Landmark, St Patrick's Parochial School (HS92-73). Change in location of mechanical equipment from previous HPAD14-930.",
         "Planner": "Kristinae Toomians ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "HPAD15-124",
         "APN": 46718103,
         "File Number": "HPAD15-124",
         "Address": "51 N 9TH ST SAN JOSE",
         "Project Name": "HPAD15-124",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "1/9/15",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment to install and reconstruct two ADA compliant access ramps; install a new transformer, switchgear and equipment screen; install two ground mounted HVAC condensers; replace two drinking fountains; and replace windows with wood windows to match existing on a Historic Landmark, St Patrick's Parochial School (HS92-73). Change in location of mechanical equipment from previous HPAD14-930.",
         "Planner": "Kristinae Toomians ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "HPAD15-1362",
         "APN": 24944018,
         "File Number": "HPAD15-1362",
         "Address": "329 N 3RD ST SAN JOSE",
         "Project Name": "HPAD15-1362",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "12/9/15 14:26",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment to: FIRST FLOOR: replace (3) non-original windows on right side of house, and one non-original window on the left side of the house, and replace water heater room door; SECOND FLOOR: Replace one non-original window on the rear left side of the house; THIRD FLOOR: Replace three non-original windows on the right, left and rear sides of the house, and add two skylights; and permit modifications to the floor plan as shown on the plans.",
         "Planner": "Kristinae Toomians ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "HPAD15-438",
         "APN": 46721018,
         "File Number": "HPAD15-438",
         "Address": "66 N 1ST ST SAN JOSE",
         "Project Name": "HPAD15-438",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "4/24/15 10:19",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment to remove a garage entry/exit on the St. John Street frontage ",
         "Planner": "Rebecca Bustos ",
         "DURATION": 1,
         "Year": 2015
      },
      {
         "PERMITID": "HPAD15-552",
         "APN": 47225061,
         "File Number": "HPAD15-552",
         "Address": "650 S 5TH ST SAN JOSE",
         "Project Name": "HPAD15-552",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "5/22/15 15:22",
         "Status": "Approved ",
         "Description": "Historic preservation permit adjustment for replacing windows and doors. ",
         "Planner": "Rebecca Bustos ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "HPAD16-277",
         "APN": 25945053,
         "File Number": "HPAD16-277",
         "Address": "426 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "HPAD16-277",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "9/28/16 14:16",
         "Status": "Approved ",
         "Description": "Historic Permit Adjustment for Lakehouse District, City Landmark District to allow replacement of exterior stairs at the rear of the building. ",
         "Planner": "Rebecca Bustos ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "HPAD17-003",
         "APN": 46720078,
         "File Number": "HPAD17-003",
         "Address": "30 N 3RD ST SAN JOSE",
         "Project Name": "HPAD17-003",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "3/16/17 10:03",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment to allow infill of double storefront doorway, replaced with a window unit; and to allow ADA upgrades to the existing single storefront entryway. ",
         "Planner": "Jan Warne ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "HPAD17-008",
         "APN": 46721014,
         "File Number": "HPAD17-008",
         "Address": "0 E SANTA CLARA ST SAN JOSE",
         "Project Name": "HPAD17-008",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "8/7/17 16:21",
         "Status": "Approved ",
         "Description": "RENEWAL Historic Preservation Permit Adjustment to temporary encapsulate the existing fountain basin adjacent to N Second Street in St. James Park with a removable redwood deck, rehabilitation of benches and light poles, minor electrical work, and installation of temporary ground surfaces in areas of degraded turf or groundcover.  ",
         "Planner": "Susan Walsh ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "HPAD17-012",
         "APN": 24946049,
         "File Number": "HPAD17-012",
         "Address": "359 N 5TH ST SAN JOSE",
         "Project Name": "HPAD17-012",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "10/11/17 15:49",
         "Status": "Approved ",
         "Description": "Historic Preservation permit Adjustment for minor modifications to a detached garage for an existing single family residence in the Hensley Historic District (CL District No. 51) on a 0.12 gross acre site in RM- Multi Family residential zoning district",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "HPAD18-004",
         "APN": 25936039,
         "File Number": "HPAD18-004",
         "Address": "320 W ST JOHN ST SAN JOSE",
         "Project Name": "HPAD18-004",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "5/30/18 15:35",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment to allow construction of a 1,460 square foot free standing patio cover over the open patio-courtyard area on the southwest corner of the building.",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "HPAD18-013",
         "APN": 46724046,
         "File Number": "HPAD18-013",
         "Address": "37 S 8TH ST SAN JOSE",
         "Project Name": "HPAD18-013",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "10/12/18 10:03",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment to allow converting Unit 1from a 2-bedroom to a 4-bedroom by changing a large bedroom into two smaller bedrooms of 7'3\" x 15'6\" each and reducing the living room by carving out an 11'5\" x 8'5\" bedroom.",
         "Planner": "Krinjal Mathur ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "HPAD18-014",
         "APN": 46718037,
         "File Number": "HPAD18-014",
         "Address": "191 N 9TH ST SAN JOSE",
         "Project Name": "HPAD18-014",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "10/12/18 13:41",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment to allow exterior stair modification from a single flight to a U shape in the rear of the property ",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2018
      },
      {
         "PERMITID": "AD06-837",
         "APN": 46757083,
         "File Number": "AD06-837",
         "Address": "235 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD06-837",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "7/26/06",
         "Status": "Denied ",
         "Description": "Historic Preservation Permit Adjustment for two 8.33 square foot attached signs reading \"Taqueria San Jose.\"",
         "Planner": "Lee Butler ",
         "DURATION": 20,
         "Year": 2006
      },
      {
         "PERMITID": "AD07-617",
         "APN": 26429107,
         "File Number": "AD07-617",
         "Address": " ",
         "Project Name": "AD07-617",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "5/30/07",
         "Status": "Pending ",
         "Description": " ",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "HPAD18-006",
         "APN": 46701055,
         "File Number": "HPAD18-006",
         "Address": "255 N 5TH ST SAN JOSE",
         "Project Name": "HPAD18-006",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "6/26/18 13:20",
         "Status": "Pending ",
         "Description": "Historic Preservation Permit Adjustment to reroof the building to presidential shingles and for new skylights. ",
         "Planner": "Justin Daniels ",
         "DURATION": 1,
         "Year": 2018
      },
      {
         "PERMITID": "HPAD18-009",
         "APN": 46721014,
         "File Number": "HPAD18-009",
         "Address": "0 E SANTA CLARA ST SAN JOSE",
         "Project Name": "HPAD18-009",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "7/3/18 9:01",
         "Status": "Pending ",
         "Description": "Historic Preservation Permit Adjustment Renewal for interim improvements to St. James Park to promote the seasonal programs and to increase public use of the park. All proposed interim improvements are temporary and seasonal. Specifically, the proposed improvements include the following projects: gateway gardens, temporary dog park, monument walk, splash pad, wayfinding signage, pavilion program preview, painting of Second Street, art installations, food truck plaza, and removable redwood deck encapsulating the existing fountain basin adjacent to N Second Street in St. James Park. ",
         "Planner": "Krinjal Mathur ",
         "DURATION": 1,
         "Year": 2018
      },
      {
         "PERMITID": "HPAD19-150",
         "APN": 46762007,
         "File Number": "HPAD19-150",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "HPAD19-150",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "4/3/19 14:19",
         "Status": "Pending ",
         "Description": "Historic Permit Permit Adjustment to HPA05-001-01, work for which has not yet commenced. See description on application cover sheet. Applicant stated intake for Juliet Arroyo, Historic Preservation Officer (Rhonda Buss is PM for HPA05-001-01.)",
         "Planner": "Juliet Arroyo ",
         "DURATION": 158,
         "Year": 2019
      },
      {
         "PERMITID": "AD06-172",
         "APN": 46722056,
         "File Number": "AD06-172",
         "Address": "69 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD06-172",
         "Application Type": "Historic Pres Permit Adjustment ",
         "Application Date": "2/21/06",
         "Status": "Rejected ",
         "Description": "FACADE IMPROVEMENTS TO A CONTRIBUTING STRUCTURE IN THE DOWNTOWN COMMERCIAL NATIONAL REGISTER DISTRICT ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      }
   ],
   "Historic Pres Permit Amendment ": [
      {
         "PERMITID": "HPA01-007-01",
         "APN": 26429107,
         "File Number": "HPA01-007-01",
         "Address": " ",
         "Project Name": "Sainte Claire Hotel canopy/awning ",
         "Application Type": "Historic Pres Permit Amendment ",
         "Application Date": "5/30/07",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Amendment for Facade improvements and external lighting to an existing hotel on a 0.6-acre site",
         "Planner": "Darren McBain ",
         "DURATION": 651,
         "Year": 2007
      },
      {
         "PERMITID": "2015 104178 AO",
         "APN": 24944018,
         "File Number": "2015 104178 AO",
         "Address": "329 N 3RD ST SAN JOSE",
         "Project Name": "329 NORTH 3RD STREET",
         "Application Type": "Historic Pres Permit Amendment ",
         "Application Date": "12/9/15 13:46",
         "Status": "New ",
         "Description": "Historical Preservation Permit Adjustment to replace some original windows and some non-original windows with windows that comply with Building requirements, and add (2) skylights to the roof for ventilation and light Building requirements.",
         "Planner": "Martina Davis ",
         "DURATION": 1369,
         "Year": 2015
      }
   ],
   "Historic Preservation Permit ": [
      {
         "PERMITID": "HP00-005",
         "APN": 24948025,
         "File Number": "HP00-005",
         "Address": "252 WASHINGTON ST SAN JOSE",
         "Project Name": "HP00-005",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "2/22/00",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit to add a third unit to an existing duplex in the Hensley Historic District (HD89-51) on a 0.25 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "HP00-007",
         "APN": 46701002,
         "File Number": "HP00-007",
         "Address": "261 N 2ND ST SAN JOSE",
         "Project Name": "HP00-007",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "5/12/00",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit to allow fire repair construction and minor additions/modifications to existing building on a 0.20-gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "HP00-009",
         "APN": 24946089,
         "File Number": "HP00-009",
         "Address": "380 N 4TH ST SAN JOSE",
         "Project Name": "HP00-009 Civic Center relocation",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "9/13/00",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit for relocation of four historical structures from 26-28, 36-38, 44, and 47 South Fifth Street (future site of new civic center) to the Hensley Historic Disrict (City Landmark No. 51)",
         "Planner": "Akoni Danielsen ",
         "DURATION": 1,
         "Year": 2000
      },
      {
         "PERMITID": "HP00-009",
         "APN": 24946090,
         "File Number": "HP00-009",
         "Address": "380 N 4TH ST SAN JOSE",
         "Project Name": "HP00-009 Civic Center relocation",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "9/13/00",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit for relocation of four historical structures from 26-28, 36-38, 44, and 47 South Fifth Street (future site of new civic center) to the Hensley Historic Disrict (City Landmark No. 51)",
         "Planner": "Akoni Danielsen ",
         "DURATION": 1,
         "Year": 2000
      },
      {
         "PERMITID": "HP00-009",
         "APN": 24946092,
         "File Number": "HP00-009",
         "Address": "380 N 4TH ST SAN JOSE",
         "Project Name": "HP00-009 Civic Center relocation",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "9/13/00",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit for relocation of four historical structures from 26-28, 36-38, 44, and 47 South Fifth Street (future site of new civic center) to the Hensley Historic Disrict (City Landmark No. 51)",
         "Planner": "Akoni Danielsen ",
         "DURATION": 1,
         "Year": 2000
      },
      {
         "PERMITID": "HP00-011",
         "APN": 46722009,
         "File Number": "HP00-011",
         "Address": "72 S 1ST ST SAN JOSE",
         "Project Name": "HP00-011 Letetia Building",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "10/20/00",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit to construct a fence/wall in the rear area of the Letetia building (Historic Landmark #92-65) on a 0.24 gross acre site",
         "Planner": "Akoni Danielsen ",
         "DURATION": 1,
         "Year": 2000
      },
      {
         "PERMITID": "HP01-007",
         "APN": 26429107,
         "File Number": "HP01-007",
         "Address": " ",
         "Project Name": "HP01-007",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "6/20/01",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit to allow interior and exterior modifications to the Hyatt Sainte Claire Hotel (City Landmark No: 735) on a 0.56 gross acre site",
         "Planner": "Susan Pineda ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "HP01-014",
         "APN": 25935057,
         "File Number": "HP01-014",
         "Address": "151 W SANTA CLARA ST SAN JOSE",
         "Project Name": "HP01-014",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "8/22/01 10:26",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit to allow facade remodel to an existing building a.k.a. Farmer's Union Building on a 0.84 gross acre site",
         "Planner": "Susan Pineda ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "HP01-017",
         "APN": 46746030,
         "File Number": "HP01-017",
         "Address": "210 S 1ST ST SAN JOSE",
         "Project Name": "Twohy Building ",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "11/21/01 15:16",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit to allow minor modifications and replacement of door and windows to Twohy Building (City Landmark No. 134 ) on a 0.20 gross acre site",
         "Planner": "Susan Pineda ",
         "DURATION": 26,
         "Year": 2001
      },
      {
         "PERMITID": "HP02-008",
         "APN": 25940038,
         "File Number": "HP02-008",
         "Address": "34 W SANTA CLARA ST SAN JOSE",
         "Project Name": "HP02-008",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "5/16/02",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit to allow exterior improvements to existing office/commercial building on a 0.12 gross acre site",
         "Planner": "Sally Notthoff ",
         "DURATION": 1065,
         "Year": 2002
      },
      {
         "PERMITID": "HP02-009",
         "APN": 25942079,
         "File Number": "HP02-009",
         "Address": "211 S 1ST ST SAN JOSE",
         "Project Name": "HP02-009",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "6/12/02",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit to allow exterior and interior modifications for hotel and restaurant uses to Montgomery Hotel (City Landmark No.1032) on a 0.59 gross acre site",
         "Planner": "Sally Notthoff ",
         "DURATION": 121,
         "Year": 2002
      },
      {
         "PERMITID": "HP02-016",
         "APN": 24946063,
         "File Number": "HP02-016",
         "Address": "324 N 4TH ST SAN JOSE",
         "Project Name": "HP02-016",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "8/1/02",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit to allow demolition of existing 2-car garage, carport and replace with new 2-car garage 649 square foot on a 0.13 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 180,
         "Year": 2002
      },
      {
         "PERMITID": "HP02-021",
         "APN": 26429107,
         "File Number": "HP02-021",
         "Address": "302 S MARKET ST SAN JOSE",
         "Project Name": "HP02-021",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "10/17/02",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit to allow installation of skylight to Saint Claire Hotel (Historic Landmark # 735) on a 0.57 gross acre site",
         "Planner": "Dave Tymn ",
         "DURATION": 120,
         "Year": 2002
      },
      {
         "PERMITID": "HP02-024",
         "APN": 25942079,
         "File Number": "HP02-024",
         "Address": "211 S 1ST ST SAN JOSE",
         "Project Name": "HP02-024",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "12/13/02",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit to allow rehabilitation of the Montgomery Hotel (City Landmark # 1032) on a 0.55 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 89,
         "Year": 2002
      },
      {
         "PERMITID": "HP03-006",
         "APN": 46757083,
         "File Number": "HP03-006",
         "Address": "235 E SANTA CLARA ST SAN JOSE",
         "Project Name": "HP03-006",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "4/8/03",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit to allow exterior modifications to an existing retail and residential building a.k.a. Vintage Tower (HL86-39) on a 0.67 gross acre site",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 168,
         "Year": 2003
      },
      {
         "PERMITID": "HP03-009",
         "APN": 25934018,
         "File Number": "HP03-009",
         "Address": "81 W SANTA CLARA ST SAN JOSE",
         "Project Name": "HP03-009",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "7/15/03",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit to allow 2 emergency exit doors to a proposed nightclub (former bank HL ID#897) on a 0.10 gross acre site",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 104,
         "Year": 2003
      },
      {
         "PERMITID": "HP04-001",
         "APN": 24948005,
         "File Number": "HP04-001",
         "Address": "379 N 6TH ST SAN JOSE",
         "Project Name": "HP04-001",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "1/23/04",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit to allow 1394 square feet basement conversion to an existing multi-family residence in the Hensley Historic District (ID# 1484) on a 0.14 gross acre site",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 152,
         "Year": 2004
      },
      {
         "PERMITID": "HP04-002",
         "APN": 24948050,
         "File Number": "HP04-002",
         "Address": "336 N 6TH ST SAN JOSE",
         "Project Name": "HP04-002",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "1/26/04",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit to allow exterior alterations of an existing single-family residence in the Hensley Historic District on a 0.19 gross acre site",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 201,
         "Year": 2004
      },
      {
         "PERMITID": "HP05-001",
         "APN": 46762001,
         "File Number": "HP05-001",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "HP05-001",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "6/10/05",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit to allow exterior modifications and repairs in anticipation of a condominium office use in existing building with office use, involving Historic Resources Inventory Number 46722097 (Bank of Italy Building), on a 0.4 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 139,
         "Year": 2005
      },
      {
         "PERMITID": "HP05-001",
         "APN": 46762007,
         "File Number": "HP05-001",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "HP05-001",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "6/10/05",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit to allow exterior modifications and repairs in anticipation of a condominium office use in existing building with office use, involving Historic Resources Inventory Number 46722097 (Bank of Italy Building), on a 0.4 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 139,
         "Year": 2005
      },
      {
         "PERMITID": "HP05-001",
         "APN": 46762008,
         "File Number": "HP05-001",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "HP05-001",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "6/10/05",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit to allow exterior modifications and repairs in anticipation of a condominium office use in existing building with office use, involving Historic Resources Inventory Number 46722097 (Bank of Italy Building), on a 0.4 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 139,
         "Year": 2005
      },
      {
         "PERMITID": "HP05-001",
         "APN": 46762009,
         "File Number": "HP05-001",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "HP05-001",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "6/10/05",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit to allow exterior modifications and repairs in anticipation of a condominium office use in existing building with office use, involving Historic Resources Inventory Number 46722097 (Bank of Italy Building), on a 0.4 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 139,
         "Year": 2005
      },
      {
         "PERMITID": "HP05-001",
         "APN": 46762011,
         "File Number": "HP05-001",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "HP05-001",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "6/10/05",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit to allow exterior modifications and repairs in anticipation of a condominium office use in existing building with office use, involving Historic Resources Inventory Number 46722097 (Bank of Italy Building), on a 0.4 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 139,
         "Year": 2005
      },
      {
         "PERMITID": "HP05-001",
         "APN": 46762012,
         "File Number": "HP05-001",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "HP05-001",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "6/10/05",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit to allow exterior modifications and repairs in anticipation of a condominium office use in existing building with office use, involving Historic Resources Inventory Number 46722097 (Bank of Italy Building), on a 0.4 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 139,
         "Year": 2005
      },
      {
         "PERMITID": "HP05-001",
         "APN": 46762014,
         "File Number": "HP05-001",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "HP05-001",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "6/10/05",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit to allow exterior modifications and repairs in anticipation of a condominium office use in existing building with office use, involving Historic Resources Inventory Number 46722097 (Bank of Italy Building), on a 0.4 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 139,
         "Year": 2005
      },
      {
         "PERMITID": "HP05-001",
         "APN": 46762015,
         "File Number": "HP05-001",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "HP05-001",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "6/10/05",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit to allow exterior modifications and repairs in anticipation of a condominium office use in existing building with office use, involving Historic Resources Inventory Number 46722097 (Bank of Italy Building), on a 0.4 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 139,
         "Year": 2005
      },
      {
         "PERMITID": "HP05-001",
         "APN": 46762016,
         "File Number": "HP05-001",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "HP05-001",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "6/10/05",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit to allow exterior modifications and repairs in anticipation of a condominium office use in existing building with office use, involving Historic Resources Inventory Number 46722097 (Bank of Italy Building), on a 0.4 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 139,
         "Year": 2005
      },
      {
         "PERMITID": "HP05-001",
         "APN": 46762017,
         "File Number": "HP05-001",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "HP05-001",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "6/10/05",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit to allow exterior modifications and repairs in anticipation of a condominium office use in existing building with office use, involving Historic Resources Inventory Number 46722097 (Bank of Italy Building), on a 0.4 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 139,
         "Year": 2005
      },
      {
         "PERMITID": "HP05-001",
         "APN": 46762019,
         "File Number": "HP05-001",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "HP05-001",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "6/10/05",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit to allow exterior modifications and repairs in anticipation of a condominium office use in existing building with office use, involving Historic Resources Inventory Number 46722097 (Bank of Italy Building), on a 0.4 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 139,
         "Year": 2005
      },
      {
         "PERMITID": "HP05-001",
         "APN": 46762020,
         "File Number": "HP05-001",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "HP05-001",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "6/10/05",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit to allow exterior modifications and repairs in anticipation of a condominium office use in existing building with office use, involving Historic Resources Inventory Number 46722097 (Bank of Italy Building), on a 0.4 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 139,
         "Year": 2005
      },
      {
         "PERMITID": "HP05-002",
         "APN": 46701118,
         "File Number": "HP05-002",
         "Address": "252 N 1ST ST SAN JOSE",
         "Project Name": "HP05-002",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "6/21/05",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit to allow construction of 194 single-family attached residences (3 of which are live/work units) and approximately 14,000 square feet of commercial uses in two high-rise towers (~153 feet tall along N. 1st St. and ~198 feet tall along Devine St.) within the St. James Square City Landmark / National Register District on a 1.1 gross acres site",
         "Planner": "Lee Butler ",
         "DURATION": 1102,
         "Year": 2005
      },
      {
         "PERMITID": "HP05-003",
         "APN": 46701118,
         "File Number": "HP05-003",
         "Address": "252 N 1ST ST SAN JOSE",
         "Project Name": "HP05-003 - First Church of Christ Scientist",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "6/21/05",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit to allow exterior and seismic rehabilitation of an existing structure (First Church of Christ Scientist) on a 1.1 gross acres site",
         "Planner": "Lee Butler ",
         "DURATION": 0,
         "Year": 2005
      },
      {
         "PERMITID": "HP05-004",
         "APN": 46723035,
         "File Number": "HP05-004",
         "Address": "142 E SANTA CLARA ST SAN JOSE",
         "Project Name": "HP05-004",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "7/12/05",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit to allow exterior modifications for an existing commercial building, involving Historic Resources Inventory Number 46723035, on a 0.14 gross acre site",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 72,
         "Year": 2005
      },
      {
         "PERMITID": "HP07-001",
         "APN": 47228045,
         "File Number": "HP07-001",
         "Address": "530 S 6TH ST SAN JOSE",
         "Project Name": "HP07-001/H07-007",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "2/13/07",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit to legalize a prebuilt approximately 940-square-foot detached garage to replace a detached garage that was demolished without permits on a 0.16-acre site in the Reed Historic District",
         "Planner": "Darren McBain ",
         "DURATION": 176,
         "Year": 2007
      },
      {
         "PERMITID": "HP07-002",
         "APN": 25932073,
         "File Number": "HP07-002",
         "Address": "183 W ST JAMES ST SAN JOSE",
         "Project Name": "HP07-002 Pellier Park",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "4/2/07",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit to facilitate restoration of Pellier Park, a 0.3-acre public park and City Landmark site located at the northeast corner of W. Saint James Street and Terraine Street",
         "Planner": "Darren McBain ",
         "DURATION": 437,
         "Year": 2007
      },
      {
         "PERMITID": "HP14-007",
         "APN": 46721018,
         "File Number": "HP14-007",
         "Address": "50 N 1ST ST SAN JOSE",
         "Project Name": "HP14-007",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "12/9/14 15:25",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit to allow the demolition of six commercial buildings and construction of a new six- to seven-story mixed-used building consisting of up to 190 residential units, 10,835 square feet of commercial, and an associated parking garage within the St. James Square Historic District on 1.4 gross acre site",
         "Planner": "Hadasa Lev ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "HP14-007",
         "APN": 46721030,
         "File Number": "HP14-007",
         "Address": "50 N 1ST ST SAN JOSE",
         "Project Name": "HP14-007",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "12/9/14 15:25",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit to allow the demolition of six commercial buildings and construction of a new six- to seven-story mixed-used building consisting of up to 190 residential units, 10,835 square feet of commercial, and an associated parking garage within the St. James Square Historic District on 1.4 gross acre site",
         "Planner": "Hadasa Lev ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "HP14-007",
         "APN": 46721038,
         "File Number": "HP14-007",
         "Address": "50 N 1ST ST SAN JOSE",
         "Project Name": "HP14-007",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "12/9/14 15:25",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit to allow the demolition of six commercial buildings and construction of a new six- to seven-story mixed-used building consisting of up to 190 residential units, 10,835 square feet of commercial, and an associated parking garage within the St. James Square Historic District on 1.4 gross acre site",
         "Planner": "Hadasa Lev ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "HP15-001",
         "APN": 46718102,
         "File Number": "HP15-001",
         "Address": "389 E SANTA CLARA ST SAN JOSE",
         "Project Name": "HP15-001",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "3/6/15 9:56",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit to allow the demolition of a fire-damaged church and rectory, removal of six ordinance sized trees, and construction of an approximately 20,000-square foot church/religious assembly building, two-story parking structure, an approximately 15,000-square foot multi-purpose building.",
         "Planner": "Jennifer Piozet ",
         "DURATION": 623,
         "Year": 2015
      },
      {
         "PERMITID": "HP15-001",
         "APN": 46718103,
         "File Number": "HP15-001",
         "Address": "389 E SANTA CLARA ST SAN JOSE",
         "Project Name": "HP15-001",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "3/6/15 9:56",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit to allow the demolition of a fire-damaged church and rectory, removal of six ordinance sized trees, and construction of an approximately 20,000-square foot church/religious assembly building, two-story parking structure, an approximately 15,000-square foot multi-purpose building.",
         "Planner": "Jennifer Piozet ",
         "DURATION": 623,
         "Year": 2015
      },
      {
         "PERMITID": "HP16-002",
         "APN": 25938128,
         "File Number": "HP16-002",
         "Address": "374 W SANTA CLARA ST SAN JOSE",
         "Project Name": "HP16-002",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "3/15/16 8:57",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit to allow the demolition of non-historic structures, relocation of the transformer house, the construction of an underground parking garage and a landscaped plaza within the Historic City Landmark (San Jose Water Works) Parcel on a 1.02 gross acre site",
         "Planner": "John Tu ",
         "DURATION": 63,
         "Year": 2016
      },
      {
         "PERMITID": "HP17-006",
         "APN": 46720073,
         "File Number": "HP17-006",
         "Address": "196 N 3RD ST SAN JOSE",
         "Project Name": "HP17-006",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "8/15/17 10:09",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit to legalize a patio addition and landscaping on a 0.92 gross acre site",
         "Planner": "Edward Schreiner ",
         "DURATION": 518,
         "Year": 2017
      },
      {
         "PERMITID": "HP92-007",
         "APN": 46722008,
         "File Number": "HP92-007",
         "Address": "56 S 1ST ST SAN JOSE",
         "Project Name": "HP92-007",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "9/25/92",
         "Status": "Approved ",
         "Description": "BALCONY ADDITION TO AN EXISTING RESTAURANT ",
         "Planner": "KKOVAR ",
         "DURATION": 0,
         "Year": 1992
      },
      {
         "PERMITID": "HP93-001",
         "APN": 24946090,
         "File Number": "HP93-001",
         "Address": "380 N 4TH ST SAN JOSE",
         "Project Name": "HP93-001",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "1/28/93",
         "Status": "Approved ",
         "Description": "HISTORIC PERMIT FOR 5 SFAR",
         "Planner": "Mike Enderby ",
         "DURATION": 0,
         "Year": 1993
      },
      {
         "PERMITID": "HP93-001",
         "APN": 24946092,
         "File Number": "HP93-001",
         "Address": "380 N 4TH ST SAN JOSE",
         "Project Name": "HP93-001",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "1/28/93",
         "Status": "Approved ",
         "Description": "HISTORIC PERMIT FOR 5 SFAR",
         "Planner": "Mike Enderby ",
         "DURATION": 0,
         "Year": 1993
      },
      {
         "PERMITID": "HP96-012",
         "APN": 46720048,
         "File Number": "HP96-012",
         "Address": "160 N 3RD ST SAN JOSE",
         "Project Name": "HP96-012",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "9/16/96",
         "Status": "Approved ",
         "Description": "File type: *Other apns: *Gen.Use Class:*Existing Land Use:70*Specific Use:CHURCH ADDTN",
         "Planner": "Salifu Yakubu ",
         "DURATION": 0,
         "Year": 1996
      },
      {
         "PERMITID": "HP97-002",
         "APN": 24948050,
         "File Number": "HP97-002",
         "Address": "336 N 6TH ST SAN JOSE",
         "Project Name": "HP97-002",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "5/8/97",
         "Status": "Approved ",
         "Description": "REMODEL BOARDING HOUSE INTO DUPLEX ",
         "Planner": "Salifu Yakubu ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "HP97-003",
         "APN": 24948025,
         "File Number": "HP97-003",
         "Address": "252 WASHINGTON ST SAN JOSE",
         "Project Name": "HP97-003",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "6/13/97",
         "Status": "Approved ",
         "Description": "(Q67-181) DUPLEX IN HENSLEY HISTORIC DISTRICT",
         "Planner": "Salifu Yakubu ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "HP97-004",
         "APN": 46721031,
         "File Number": "HP97-004",
         "Address": "81 N 2ND ST SAN JOSE",
         "Project Name": "HP97-004",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "8/15/97",
         "Status": "Approved ",
         "Description": "(Q83-206) REROOF/REPAINT/COLOMBARIUM/ACCESS RAMP/L",
         "Planner": "Akoni Danielsen ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "HP98-001",
         "APN": 25940094,
         "File Number": "HP98-001",
         "Address": "SAN JOSE  ",
         "Project Name": "HP98-001",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "1/27/98",
         "Status": "Approved ",
         "Description": "To allow rehabilitation and facade improvements of a historic structure to include retail and office uses ",
         "Planner": "Akoni Danielsen ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "HP98-003",
         "APN": 24948048,
         "File Number": "HP98-003",
         "Address": "330 N 6TH ST SAN JOSE",
         "Project Name": "HP98-003",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "3/25/98",
         "Status": "Approved ",
         "Description": "Historic Preservation permit for the conversion of a basement to living quarters in existing single family detached residence ",
         "Planner": "Akoni Danielsen ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "HP99-002",
         "APN": 46722009,
         "File Number": "HP99-002",
         "Address": "72 S 1ST ST SAN JOSE",
         "Project Name": "HP99-002",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "2/16/99",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit for construction of a stairway, and other improvements, at the rear of the Leticia Building located on a 0.235 gross acre site in the C-3 commercial zoning district",
         "Planner": "PGILLI ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "HP99-011",
         "APN": 46722009,
         "File Number": "HP99-011",
         "Address": "72 S 1ST ST SAN JOSE",
         "Project Name": "HP99-011",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "10/14/99",
         "Status": "Approved ",
         "Description": "Historical Preservation Permit for the construction of a wall to enclose the rear patio ",
         "Planner": "Lisa Ring ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "HP07-003",
         "APN": 25945070,
         "File Number": "HP07-003",
         "Address": "183 SONOMA ST SAN JOSE",
         "Project Name": "183 Sonoma Street (Lynn Barringer)",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "5/16/07",
         "Status": "Approved with Conditions ",
         "Description": "Historic Preservation Permit to allow an approximately 750-square-foot two-story addition to an existing single-family detached residence on a 0.12-acre site in the Lakehouse City Landmark Historic District",
         "Planner": "Darren McBain ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "HP08-006",
         "APN": 46721014,
         "File Number": "HP08-006",
         "Address": "0 E SANTA CLARA ST SAN JOSE",
         "Project Name": "HP08-006",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "8/13/08",
         "Status": "Approved with Conditions ",
         "Description": "Historic Preservation Permit to allow improvements to the west side of St. James Park and instalation of pedestrain lighitng at the permiter of the east side of the park on a 7 gross acre site.",
         "Planner": "Hadasa Lev ",
         "DURATION": 145,
         "Year": 2008
      },
      {
         "PERMITID": "HP09-001",
         "APN": 25945052,
         "File Number": "HP09-001",
         "Address": "436 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "HP09-001",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "1/13/09",
         "Status": "Approved with Conditions ",
         "Description": "Historic Preservation Permit to legalize an existing carport built without benefit of permits on a 0.21 gross acre site in the Lake House Historic District.",
         "Planner": "Hadasa Lev ",
         "DURATION": 141,
         "Year": 2009
      },
      {
         "PERMITID": "HP17-007",
         "APN": 46723088,
         "File Number": "HP17-007",
         "Address": "100 E SANTA CLARA ST SAN JOSE",
         "Project Name": "HP17-007_ Hotel Clariana",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "12/7/17 10:41",
         "Status": "Review Letter Sent ",
         "Description": "Historic Preservation Permit to allow the construction of a 45,783 SF addition to Hotel Clariana including 60 Hotel rooms, 3 suites and 5790 SF of commercial space for a new full service restaurant with on sale of alcohol on a 0.41 gross acre site.",
         "Planner": "Nizar Slim ",
         "DURATION": 6,
         "Year": 2017
      },
      {
         "PERMITID": "HP17-007",
         "APN": 46723089,
         "File Number": "HP17-007",
         "Address": "100 E SANTA CLARA ST SAN JOSE",
         "Project Name": "HP17-007_ Hotel Clariana",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "12/7/17 10:41",
         "Status": "Review Letter Sent ",
         "Description": "Historic Preservation Permit to allow the construction of a 45,783 SF addition to Hotel Clariana including 60 Hotel rooms, 3 suites and 5790 SF of commercial space for a new full service restaurant with on sale of alcohol on a 0.41 gross acre site.",
         "Planner": "Nizar Slim ",
         "DURATION": 6,
         "Year": 2017
      },
      {
         "PERMITID": "HP19-002",
         "APN": 47225072,
         "File Number": "HP19-002",
         "Address": "647 S 6TH ST SAN JOSE",
         "Project Name": "HP19-002",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "3/4/19 10:27",
         "Status": "Review Letter Sent ",
         "Description": "Historic Preservation Permit to allow conversion from single family residence to a duplex by converting the basement into a separate living unit on .143 gross acre site",
         "Planner": "Rina Shah ",
         "DURATION": 0,
         "Year": 2019
      },
      {
         "PERMITID": "HP17-003",
         "APN": 25942079,
         "File Number": "HP17-003",
         "Address": "211 S 1ST ST SAN JOSE",
         "Project Name": "HP17-003",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "3/28/17 9:35",
         "Status": "Under Review ",
         "Description": "Historic Preservation Permit to allow the construction of a 24-story, 279-room hotel, integrated with the Montgomery Hotel, a designated City Landmark, with off-site parking on a 0.58-gross acre site",
         "Planner": "John Tu ",
         "DURATION": 174,
         "Year": 2017
      },
      {
         "PERMITID": "HP02-010",
         "APN": 24946089,
         "File Number": "HP02-010",
         "Address": "380 N 4TH ST SAN JOSE",
         "Project Name": "HP02-010",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "6/13/02",
         "Status": "Withdrawn ",
         "Description": "Historic Preservation Permit to allow exterior modifications to 4 buildings ( 6 residential units), (City Landmark No.1265-7) on a 0.537 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 118,
         "Year": 2002
      },
      {
         "PERMITID": "HP02-010",
         "APN": 24946090,
         "File Number": "HP02-010",
         "Address": "380 N 4TH ST SAN JOSE",
         "Project Name": "HP02-010",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "6/13/02",
         "Status": "Withdrawn ",
         "Description": "Historic Preservation Permit to allow exterior modifications to 4 buildings ( 6 residential units), (City Landmark No.1265-7) on a 0.537 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 118,
         "Year": 2002
      },
      {
         "PERMITID": "HP02-010",
         "APN": 24946092,
         "File Number": "HP02-010",
         "Address": "380 N 4TH ST SAN JOSE",
         "Project Name": "HP02-010",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "6/13/02",
         "Status": "Withdrawn ",
         "Description": "Historic Preservation Permit to allow exterior modifications to 4 buildings ( 6 residential units), (City Landmark No.1265-7) on a 0.537 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 118,
         "Year": 2002
      },
      {
         "PERMITID": "HP06-004",
         "APN": 24946053,
         "File Number": "HP06-004",
         "Address": "341 N 5TH ST SAN JOSE",
         "Project Name": "HP06-004",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "11/21/06",
         "Status": "Withdrawn ",
         "Description": "Historic Preservation Permit to allow the demolition and reconstruction of a fire-damaged accessory structure on a 0.19 gross acres site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 30,
         "Year": 2006
      },
      {
         "PERMITID": "HP08-003",
         "APN": 47224043,
         "File Number": "HP08-003",
         "Address": "687 S 8TH ST SAN JOSE",
         "Project Name": "HP08-003",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "6/24/08",
         "Status": "Withdrawn ",
         "Description": "Historic Preservation Permit to legalize an addition of 138 square feet to a single-family residence, listed on the Historic Inventory # 47224043, on a 0.13-acre site in the Reed City Landmark Historic District",
         "Planner": "Hadasa Lev ",
         "DURATION": 121,
         "Year": 2008
      },
      {
         "PERMITID": "HP14-008",
         "APN": 24946071,
         "File Number": "HP14-008",
         "Address": "350 N 4TH ST SAN JOSE",
         "Project Name": "HP14-008",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "12/18/14 10:06",
         "Status": "Withdrawn ",
         "Description": "Historic Preservation Permit to allow (1) one accessory structure approximately 288 square feet on a 0.104 gross acre site",
         "Planner": "Avril Baty ",
         "DURATION": 29,
         "Year": 2014
      },
      {
         "PERMITID": "HP93-005",
         "APN": 25942023,
         "File Number": "HP93-005",
         "Address": "201 S MARKET ST SAN JOSE",
         "Project Name": "HP93-005",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "5/19/93",
         "Status": "Withdrawn ",
         "Description": "EXTERIOR ALTERATIONS TO EXIST PUBLIC FACILITIES ",
         "Planner": "LCARRILL ",
         "DURATION": 0,
         "Year": 1993
      },
      {
         "PERMITID": "HP98-008",
         "APN": 24946089,
         "File Number": "HP98-008",
         "Address": "394 N 4TH ST SAN JOSE",
         "Project Name": "HP98-008",
         "Application Type": "Historic Preservation Permit ",
         "Application Date": "12/10/98",
         "Status": "Withdrawn ",
         "Description": "Historical Preservation Permit for construction of 4 single family detached residences in the Hensley Historic District",
         "Planner": "Akoni Danielsen ",
         "DURATION": 0,
         "Year": 1998
      }
   ],
   "Historic Property Contract ": [
      {
         "PERMITID": "MA02-003",
         "APN": 25940094,
         "File Number": "MA02-003",
         "Address": "35 S MARKET ST SAN JOSE",
         "Project Name": "MA02-003",
         "Application Type": "Historic Property Contract ",
         "Application Date": "6/26/02",
         "Status": "Approved ",
         "Description": "Historic Property Contract (California Mills Act) agreement between City and property owners for preservation of City Landmark No. 736 on a 0.33 gross acre site",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 541,
         "Year": 2002
      },
      {
         "PERMITID": "MA03-002",
         "APN": 46746030,
         "File Number": "MA03-002",
         "Address": "210 S 1ST ST SAN JOSE",
         "Project Name": "MA03-002",
         "Application Type": "Historic Property Contract ",
         "Application Date": "9/15/03",
         "Status": "Approved ",
         "Description": "Historic Property Contract (California Mills Act) agreement between City and property owners for preservation of Twohy Building (City Landmark No.134) on a 0.2 gross acre site",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 92,
         "Year": 2003
      },
      {
         "PERMITID": "MA07-004",
         "APN": 24948050,
         "File Number": "MA07-004",
         "Address": "336 N 6TH ST SAN JOSE",
         "Project Name": "336 N. 6th Street Mills Act",
         "Application Type": "Historic Property Contract ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Historic Property Contract (California Mills Act) between the City of San Jose and property owners of the Herrington House (City Landmark nomination pending) located on a 0.2-acre site",
         "Planner": "Darren McBain ",
         "DURATION": 359,
         "Year": 2007
      },
      {
         "PERMITID": "MA07-005",
         "APN": 47218006,
         "File Number": "MA07-005",
         "Address": "754 S 3RD ST SAN JOSE",
         "Project Name": "MA07-005, 754 S. 3rd Street Mills Act",
         "Application Type": "Historic Property Contract ",
         "Application Date": "6/12/07",
         "Status": "Approved ",
         "Description": "Historic Property Contract (California Mills Act) between the City of San Jose and property owners of the James BrownLee House located on a 0.15-acre site",
         "Planner": "Darren McBain ",
         "DURATION": 339,
         "Year": 2007
      },
      {
         "PERMITID": "MA07-006",
         "APN": 24948047,
         "File Number": "MA07-006",
         "Address": "328 N 6TH ST SAN JOSE",
         "Project Name": "MA07-006, 328 N. 6th Street Mills Act",
         "Application Type": "Historic Property Contract ",
         "Application Date": "7/23/07",
         "Status": "Approved ",
         "Description": "Historical Property Contract (California Mills Act) between the City of San Jose and property owners of the Henry & Florence Reed House (City Landmark nomination pending) located on a 0.16 gross acres site.",
         "Planner": "Darren McBain ",
         "DURATION": 298,
         "Year": 2007
      },
      {
         "PERMITID": "MA07-011",
         "APN": 46747050,
         "File Number": "MA07-011",
         "Address": "470 S 3RD ST SAN JOSE",
         "Project Name": "MA07-011, 470 S. 3rd Street, Mojmir Apts.",
         "Application Type": "Historic Property Contract ",
         "Application Date": "9/4/07",
         "Status": "Approved ",
         "Description": "Historic Property Contract (California Mills Act) between the City of San Jose and property owners of the \"Mojmir Apartments\" (City Landmark nomination pending) on a 0.24-acre site.",
         "Planner": "Darren McBain ",
         "DURATION": 255,
         "Year": 2007
      },
      {
         "PERMITID": "MA07-012",
         "APN": 26429057,
         "File Number": "MA07-012",
         "Address": "315 S 1ST ST SAN JOSE",
         "Project Name": "MA07-012 Sainte Claire Building Mills Act",
         "Application Type": "Historic Property Contract ",
         "Application Date": "9/11/07",
         "Status": "Approved ",
         "Description": "Historic Property Contract (California Mills Act) between the City of San Jose and property owners of the Sainte Claire Building (City Landmark Number HL01-126) located on a 0.3-acre site.",
         "Planner": "Darren McBain ",
         "DURATION": 248,
         "Year": 2007
      },
      {
         "PERMITID": "MA08-007",
         "APN": 47225075,
         "File Number": "MA08-007",
         "Address": "675 S 6TH ST SAN JOSE",
         "Project Name": "MA08-007 - Somers House Historic Property Contract (w/HL08-175)",
         "Application Type": "Historic Property Contract ",
         "Application Date": "9/26/08",
         "Status": "Approved ",
         "Description": "Historical Property Contract (California Mills Act contract) between the City of San Jose and the owners of the subject property. The proposed contract, which is available to owners of designated City Landmark buildings, would facilitate a property tax reassessment and partial tax relief in return for a binding agreement to rehabilitate and maintain the historical and architectural character of the property for at least a ten-year period. (Historic Landmark Designation for the Somers House - Pending) ",
         "Planner": "Lori Moniz ",
         "DURATION": 75,
         "Year": 2008
      },
      {
         "PERMITID": "MA08-009",
         "APN": 47228006,
         "File Number": "MA08-009",
         "Address": "553 S 6TH ST SAN JOSE",
         "Project Name": "MA08-009 - Lynwood Apartments Historic Property Contract (w/HL08-177)",
         "Application Type": "Historic Property Contract ",
         "Application Date": "9/30/08",
         "Status": "Approved ",
         "Description": "Historic Property Contract for the \"Lynwood Apartments\" on a 0.22 gross acre site",
         "Planner": "Lori Moniz ",
         "DURATION": 190,
         "Year": 2008
      },
      {
         "PERMITID": "MA08-011",
         "APN": 46724032,
         "File Number": "MA08-011",
         "Address": "80 S 6TH ST SAN JOSE",
         "Project Name": "MA08-011 - Rev. G. A. Miller Residence Historic Property Contract (w/ HL08-179)",
         "Application Type": "Historic Property Contract ",
         "Application Date": "11/19/08",
         "Status": "Approved ",
         "Description": "Historic Property Contract (California Mills Act) between the City of San Jose and property owner of \"Rev. G. A. Miller Residence\" (City Landmark pending) on a 0.136-acre site.",
         "Planner": "Lori Moniz ",
         "DURATION": 386,
         "Year": 2008
      },
      {
         "PERMITID": "MA10-001",
         "APN": 47228045,
         "File Number": "MA10-001",
         "Address": "530 S 6TH ST SAN JOSE",
         "Project Name": "MA10-001",
         "Application Type": "Historic Property Contract ",
         "Application Date": "4/14/10",
         "Status": "Approved ",
         "Description": "Historic Property Contract for the Hermle-Fancher house on a 0.16 gross acre site (Historic Landmark Nomination in process)",
         "Planner": "John Davidson ",
         "DURATION": 1,
         "Year": 2010
      },
      {
         "PERMITID": "MA11-004",
         "APN": 46702040,
         "File Number": "MA11-004",
         "Address": "285 E ST JAMES ST SAN JOSE",
         "Project Name": "MA11-004 - Stiller House - 285 E. St. James Street (w/HL11-200)",
         "Application Type": "Historic Property Contract ",
         "Application Date": "10/26/11",
         "Status": "Approved ",
         "Description": "Historical Property Contract (California Mills Act contract) between the City of San Jose and the owners of the subject property. The proposed contract, which is available to owners of designated City Landmark buildings, would facilitate a property tax reassessment and partial tax relief in return for a binding agreement to rehabilitate and maintain the historical and architectural character of the property for at least a ten-year period. (Historic Landmark Designation for Stiller House - Pending) ",
         "Planner": "Lori Moniz ",
         "DURATION": 1,
         "Year": 2011
      },
      {
         "PERMITID": "MA11-006",
         "APN": 47225070,
         "File Number": "MA11-006",
         "Address": "641 S 6TH ST SAN JOSE",
         "Project Name": "MA11-006 - Samuel and Lila Martin House #1 - 641 S. 6th St. (w/HL11-202)",
         "Application Type": "Historic Property Contract ",
         "Application Date": "11/2/11",
         "Status": "Approved ",
         "Description": "Historical Property Contract (California Mills Act contract) between the City of San Jose and the owners of the subject property. The proposed contract, which is available to owners of designated City Landmark buildings, would facilitate a property tax reassessment and partial tax relief in return for a binding agreement to rehabilitate and maintain the historical and architectural character of the property for at least a ten-year period. (Historic Landmark Designation for Samuel and Lila Martin House #1 - Pending)",
         "Planner": "Lori Moniz ",
         "DURATION": 1,
         "Year": 2011
      },
      {
         "PERMITID": "MA12-002",
         "APN": 26429065,
         "File Number": "MA12-002",
         "Address": "387 S 1ST ST SAN JOSE",
         "Project Name": "MA12-002 - 387 S. 1st Street (W. Prussia Building - City Landmark HL01-130)",
         "Application Type": "Historic Property Contract ",
         "Application Date": "1/25/12",
         "Status": "Approved ",
         "Description": "Historical Property Contract (California Mills Act Contract) between the City of San Jose and the owners of the subject property. The proposed contract, which is available to owners of designated City Landmark buildings, would facilitate a property tax reassessment and partial tax relief in return for a binding agreement to rehabilitate and maintain the historical and architectural character of the property for at least a ten-year period for Historic Landmark No. HL01-130, the W. Prussia Building",
         "Planner": "Lori Moniz ",
         "DURATION": 267,
         "Year": 2012
      },
      {
         "PERMITID": "MA12-004",
         "APN": 46701055,
         "File Number": "MA12-004",
         "Address": "255 N 5TH ST SAN JOSE",
         "Project Name": "MA12-004 - Burns House - 255 N. 5th Street",
         "Application Type": "Historic Property Contract ",
         "Application Date": "6/15/12",
         "Status": "Complete ",
         "Description": "Historical Property Contract (California Mills Act contract) between the City of San Jose and the owners of the subject property. The proposed contract, which is available to owners of designated City Landmark buildings, would facilitate a property tax reassessment and partial tax relief in return for a binding agreement to rehabilitate and maintain the historical and architectural character of the property for at least a ten-year period. (Historic Landmark Designation for Burns House - Pending) ",
         "Planner": "Lori Moniz ",
         "DURATION": 126,
         "Year": 2012
      },
      {
         "PERMITID": "MA06-001",
         "APN": 46701028,
         "File Number": "MA06-001",
         "Address": "240 N 2ND ST SAN JOSE",
         "Project Name": "MA06-001",
         "Application Type": "Historic Property Contract ",
         "Application Date": "5/8/06",
         "Status": "Withdrawn ",
         "Description": "Historic Property Contract (California Mills Act) agreement between City and property owners for preservation of the National Guard Armory (City Landmark No.HL88-047) on a 0.43 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 19,
         "Year": 2006
      }
   ],
   "Initial Study Submittal ": [
      {
         "PERMITID": "PP06-112",
         "APN": 25937059,
         "File Number": "PP06-112",
         "Address": "245 S MONTGOMERY ST SAN JOSE",
         "Project Name": "Los Gatos Creek Trail Reach 5",
         "Application Type": "Initial Study Submittal ",
         "Application Date": "6/16/06 9:20",
         "Status": "Under Review ",
         "Description": "The project involves the construction of a multi-use trail along Los Gatos Creek to accommodate bicyclists and pedestrians. The trail will be located along the west side of Los Gatos Creek from Auzerais Avenue to West San Fernando Street. At West San Fernando Street, the trail will cross the creek on the existing bridge on West San Fernando Street and extend along the east side of Los Gatos Creek to Santa Clara Street. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2006
      },
      {
         "PERMITID": "PP06-112",
         "APN": 25938109,
         "File Number": "PP06-112",
         "Address": "245 S MONTGOMERY ST SAN JOSE",
         "Project Name": "Los Gatos Creek Trail Reach 5",
         "Application Type": "Initial Study Submittal ",
         "Application Date": "6/16/06 9:20",
         "Status": "Under Review ",
         "Description": "The project involves the construction of a multi-use trail along Los Gatos Creek to accommodate bicyclists and pedestrians. The trail will be located along the west side of Los Gatos Creek from Auzerais Avenue to West San Fernando Street. At West San Fernando Street, the trail will cross the creek on the existing bridge on West San Fernando Street and extend along the east side of Los Gatos Creek to Santa Clara Street. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2006
      },
      {
         "PERMITID": "PP06-112",
         "APN": 25938110,
         "File Number": "PP06-112",
         "Address": "245 S MONTGOMERY ST SAN JOSE",
         "Project Name": "Los Gatos Creek Trail Reach 5",
         "Application Type": "Initial Study Submittal ",
         "Application Date": "6/16/06 9:20",
         "Status": "Under Review ",
         "Description": "The project involves the construction of a multi-use trail along Los Gatos Creek to accommodate bicyclists and pedestrians. The trail will be located along the west side of Los Gatos Creek from Auzerais Avenue to West San Fernando Street. At West San Fernando Street, the trail will cross the creek on the existing bridge on West San Fernando Street and extend along the east side of Los Gatos Creek to Santa Clara Street. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2006
      }
   ],
   "Legacy ": [
      {
         "PERMITID": "SF00-057",
         "APN": 46718056,
         "File Number": "SF00-057",
         "Address": "307 E ST JOHN ST SAN JOSE",
         "Project Name": "SF00-057",
         "Application Type": "Legacy ",
         "Application Date": "6/7/00",
         "Status": "Approved ",
         "Description": "Single Family House Permit for an addition ",
         "Planner": "Susan Walsh ",
         "DURATION": 31,
         "Year": 2000
      }
   ],
   "Legal Non-Conforming Verification ": [
      {
         "PERMITID": "LNC03-034",
         "APN": 25948026,
         "File Number": "LNC03-034",
         "Address": "149 GIFFORD AV SAN JOSE",
         "Project Name": "LNC03-034",
         "Application Type": "Legal Non-Conforming Verification ",
         "Application Date": "9/3/03 15:28",
         "Status": "Complete ",
         "Description": "CODE CASE - Applicant would like to verify that basement unit is legal. ",
         "Planner": "John Davidson ",
         "DURATION": 184,
         "Year": 2003
      },
      {
         "PERMITID": "LNC04-017",
         "APN": 25941057,
         "File Number": "LNC04-017",
         "Address": "125 S MARKET ST SAN JOSE",
         "Project Name": "LNC04-017",
         "Application Type": "Legal Non-Conforming Verification ",
         "Application Date": "6/7/04 10:21",
         "Status": "Complete ",
         "Description": "Legal nonconforming status of building height ",
         "Planner": "Michele Campos ",
         "DURATION": 79,
         "Year": 2004
      },
      {
         "PERMITID": "LNC04-033",
         "APN": 47228055,
         "File Number": "LNC04-033",
         "Address": "515 S 8TH ST SAN JOSE",
         "Project Name": "LNC04-033",
         "Application Type": "Legal Non-Conforming Verification ",
         "Application Date": "10/15/04 11:02",
         "Status": "Complete ",
         "Description": "Legal Non Conforming Verification for an existing single family residence located on a commercially zoned property. ",
         "Planner": "Dipa Chundur ",
         "DURATION": 468,
         "Year": 2004
      },
      {
         "PERMITID": "LNC04-036",
         "APN": 46703019,
         "File Number": "LNC04-036",
         "Address": "401 E ST JAMES ST SAN JOSE",
         "Project Name": "LNC04-036",
         "Application Type": "Legal Non-Conforming Verification ",
         "Application Date": "12/8/04 12:16",
         "Status": "Complete ",
         "Description": "LNC to verify commercial uses since 1950",
         "Planner": "Avril Baty ",
         "DURATION": 110,
         "Year": 2004
      },
      {
         "PERMITID": "LNC05-004",
         "APN": 24948017,
         "File Number": "LNC05-004",
         "Address": "370 N 5TH ST SAN JOSE",
         "Project Name": "LNC05-004",
         "Application Type": "Legal Non-Conforming Verification ",
         "Application Date": "2/16/05 14:18",
         "Status": "Complete ",
         "Description": "LNC verification for an existing five-unit building ",
         "Planner": "Dipa Chundur ",
         "DURATION": 1,
         "Year": 2005
      },
      {
         "PERMITID": "LNC05-027",
         "APN": 24952036,
         "File Number": "LNC05-027",
         "Address": "398 N 9TH ST SAN JOSE",
         "Project Name": "LNC05-027",
         "Application Type": "Legal Non-Conforming Verification ",
         "Application Date": "11/4/05 10:17",
         "Status": "Complete ",
         "Description": "Legal nonconforming verification for a duplex prior to Site Development Permit Application requirements. ",
         "Planner": "Dipa Chundur ",
         "DURATION": 1,
         "Year": 2005
      },
      {
         "PERMITID": "LNC06-011",
         "APN": 47217019,
         "File Number": "LNC06-011",
         "Address": "702 S 1ST ST SAN JOSE",
         "Project Name": "LNC06-011",
         "Application Type": "Legal Non-Conforming Verification ",
         "Application Date": "8/8/06 12:07",
         "Status": "Complete ",
         "Description": "Property has been used as Commercial Mixed Use. Residential upstairs. ",
         "Planner": "Bill Roth ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "LNC06-013",
         "APN": 47224007,
         "File Number": "LNC06-013",
         "Address": "630 S 8TH ST Unit 1 SAN JOSE",
         "Project Name": "LNC06-013",
         "Application Type": "Legal Non-Conforming Verification ",
         "Application Date": "9/6/06 12:50",
         "Status": "Complete ",
         "Description": "Request to verify legal non-conforming status of an existing four unit building and rear accesssory structure used as a residence (5 residential units total).",
         "Planner": "Jeff Roche ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "LNC08-009",
         "APN": 24950017,
         "File Number": "LNC08-009",
         "Address": "301 E JULIAN ST SAN JOSE",
         "Project Name": "LNC08-009",
         "Application Type": "Legal Non-Conforming Verification ",
         "Application Date": "5/30/08 15:47",
         "Status": "Complete ",
         "Description": "PROPERTY INCLUDES 2 RESIDENTIAL AND GAS STATION. MAIN CONCERN IS GAS STATION. HAS VIOLATIONS.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "LNC09-007",
         "APN": 47217041,
         "File Number": "LNC09-007",
         "Address": "893 S 2ND ST SAN JOSE",
         "Project Name": "LNC09-007",
         "Application Type": "Legal Non-Conforming Verification ",
         "Application Date": "3/20/09 10:21",
         "Status": "Complete ",
         "Description": "Applicant want to establish that the existing structure though zoned commercial was a SFD and continues to be residential use. ",
         "Planner": "Sanhita Mallick ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "LNC09-017",
         "APN": 47228047,
         "File Number": "LNC09-017",
         "Address": "510 S 6TH ST SAN JOSE",
         "Project Name": "LNC09-017 - Ledyard Residence (6 units)",
         "Application Type": "Legal Non-Conforming Verification ",
         "Application Date": "11/6/09 10:47",
         "Status": "Complete ",
         "Description": "Legal Non-Conforming letter to determine legal non-conforming status for an attic studio apartment in an existing multi-family building listed as a Contributing Structure and as aStructure of Merit in the Reed City Landmark Historic District on a 0.13 gross acre site",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "LNC10-005",
         "APN": 46720073,
         "File Number": "LNC10-005",
         "Address": "196 N 3RD ST SAN JOSE",
         "Project Name": "LNC10-005",
         "Application Type": "Legal Non-Conforming Verification ",
         "Application Date": "4/14/10 9:07",
         "Status": "Complete ",
         "Description": "Legal Nonconforming Use Letter Application for a banquet facility. Banquet use determined to be legally established under H79-150. Outdoor patio needs separate discretionary approval.",
         "Planner": "Susan Walsh ",
         "DURATION": 16,
         "Year": 2010
      },
      {
         "PERMITID": "LNC10-007",
         "APN": 26420099,
         "File Number": "LNC10-007",
         "Address": "481 AUZERAIS AV SAN JOSE",
         "Project Name": "LNC10-007",
         "Application Type": "Legal Non-Conforming Verification ",
         "Application Date": "5/4/10 11:48",
         "Status": "Complete ",
         "Description": "Legal Non Conforming request to continue industrial uses on a properties rezoned to residential zoning district (R.2) in 2004.",
         "Planner": "Michael Mena ",
         "DURATION": 71,
         "Year": 2010
      },
      {
         "PERMITID": "LNC10-014",
         "APN": 25934029,
         "File Number": "LNC10-014",
         "Address": "84 N MARKET ST SAN JOSE",
         "Project Name": "LNC10-014",
         "Application Type": "Legal Non-Conforming Verification ",
         "Application Date": "11/30/10 11:35",
         "Status": "Complete ",
         "Description": "Legal NonConforming Verification for structure and Hotel use ",
         "Planner": "Susan Walsh ",
         "DURATION": 70,
         "Year": 2010
      },
      {
         "PERMITID": "LNC14-007",
         "APN": 26421003,
         "File Number": "LNC14-007",
         "Address": "458 AUZERAIS AV SAN JOSE",
         "Project Name": "LNC14-007",
         "Application Type": "Legal Non-Conforming Verification ",
         "Application Date": "7/3/14 9:27",
         "Status": "Under Review ",
         "Description": "Legal Non-Conforming Letter for 264-21-003.",
         "Planner": " ",
         "DURATION": 1,
         "Year": 2014
      }
   ],
   "Liquor License Exception ": [
      {
         "PERMITID": "ABC04-012",
         "APN": 46762017,
         "File Number": "ABC04-012",
         "Address": "8 S 1ST ST SAN JOSE",
         "Project Name": "ABC04-012",
         "Application Type": "Liquor License Exception ",
         "Application Date": "10/21/04",
         "Status": "Approved ",
         "Description": "Liquor License Exception to allow on-premisis-sale of alcoholic beverages at an existing nightclub on a 0.39 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 97,
         "Year": 2004
      },
      {
         "PERMITID": "ABC06-022",
         "APN": 46722006,
         "File Number": "ABC06-022",
         "Address": "48 S 1ST ST SAN JOSE",
         "Project Name": "ABC06-022",
         "Application Type": "Liquor License Exception ",
         "Application Date": "10/17/06",
         "Status": "Approved ",
         "Description": "Liquor License Exception Permit to allow drinking establishment and late night use until 2:00 a.m. on a 0.05 gross acre site in the DC Downtown Primary Commercial Zoning District)(Tied to CP06-051 Koji Sake Lounge)",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "ABC07-005",
         "APN": 46723069,
         "File Number": "ABC07-005",
         "Address": "32 S 3RD ST SAN JOSE",
         "Project Name": "ABC07-005",
         "Application Type": "Liquor License Exception ",
         "Application Date": "6/26/07",
         "Status": "Approved ",
         "Description": "Liquor License Exception Permit to allow a public eating and drinking establihsment and late night use until 2:00 a.m. on a 0.20 gross acre site in the DC Downtown Primary Commercial Zoning District (Tied to CP07-027 The Reserve Art Gallery and Lounge).",
         "Planner": "Michelle Stahlhut ",
         "DURATION": 318,
         "Year": 2007
      },
      {
         "PERMITID": "ABC08-007",
         "APN": 46764005,
         "File Number": "ABC08-007",
         "Address": "100 S 2ND ST Unit C-106 SAN JOSE",
         "Project Name": "ABC08-007",
         "Application Type": "Liquor License Exception ",
         "Application Date": "7/10/08",
         "Status": "Approved ",
         "Description": "Determination of Public Convenience or Necessity to allow off-Sale of alcoholic beverages at a grocery store on a 1.33-gross acre site.",
         "Planner": "Mike Enderby ",
         "DURATION": 57,
         "Year": 2008
      },
      {
         "PERMITID": "ABC08-007",
         "APN": 46764010,
         "File Number": "ABC08-007",
         "Address": "100 S 2ND ST Unit C-106 SAN JOSE",
         "Project Name": "ABC08-007",
         "Application Type": "Liquor License Exception ",
         "Application Date": "7/10/08",
         "Status": "Approved ",
         "Description": "Determination of Public Convenience or Necessity to allow off-Sale of alcoholic beverages at a grocery store on a 1.33-gross acre site.",
         "Planner": "Mike Enderby ",
         "DURATION": 57,
         "Year": 2008
      },
      {
         "PERMITID": "ABC14-002",
         "APN": 26429065,
         "File Number": "ABC14-002",
         "Address": "387 S 1ST ST SAN JOSE",
         "Project Name": "ABC14-002",
         "Application Type": "Liquor License Exception ",
         "Application Date": "1/10/14",
         "Status": "Approved ",
         "Description": "Public Convenience and Necessity letter application for a late night drinking establishment due to overconcentration and high crime in the DC Downtown Core Zoning District on .22 gross acre site",
         "Planner": "John Baty ",
         "DURATION": 91,
         "Year": 2014
      },
      {
         "PERMITID": "ABC15-001",
         "APN": 46747090,
         "File Number": "ABC15-001",
         "Address": "400 S 1ST ST SAN JOSE",
         "Project Name": "ABC15-001",
         "Application Type": "Liquor License Exception ",
         "Application Date": "1/30/15 15:09",
         "Status": "Approved ",
         "Description": "Determination of Public Convenience and Necessity for a late night use for a new drinking establishment, The Spectrum, in the DC Downtown Core Zoning District on .15 gross acre site",
         "Planner": "Lea Simvoulakis ",
         "DURATION": 75,
         "Year": 2015
      },
      {
         "PERMITID": "ABC15-015",
         "APN": 26415064,
         "File Number": "ABC15-015",
         "Address": "720 W SAN CARLOS ST SAN JOSE",
         "Project Name": "ABC15-015",
         "Application Type": "Liquor License Exception ",
         "Application Date": "10/9/15 13:57",
         "Status": "Approved ",
         "Description": "Determination of Public Convenience or Necessity to allow off-sale of alcohol for the proposed Smart & Final grocery store on a 2.78 gross acre site (in conjunction with CP15-050)",
         "Planner": "Rebecca Bustos ",
         "DURATION": 250,
         "Year": 2015
      },
      {
         "PERMITID": "ABC15-015",
         "APN": 26415065,
         "File Number": "ABC15-015",
         "Address": "720 W SAN CARLOS ST SAN JOSE",
         "Project Name": "ABC15-015",
         "Application Type": "Liquor License Exception ",
         "Application Date": "10/9/15 13:57",
         "Status": "Approved ",
         "Description": "Determination of Public Convenience or Necessity to allow off-sale of alcohol for the proposed Smart & Final grocery store on a 2.78 gross acre site (in conjunction with CP15-050)",
         "Planner": "Rebecca Bustos ",
         "DURATION": 250,
         "Year": 2015
      },
      {
         "PERMITID": "RABC03-001",
         "APN": 25934018,
         "File Number": "RABC03-001",
         "Address": " ",
         "Project Name": "RABC03-001, The Vault",
         "Application Type": "Liquor License Exception ",
         "Application Date": "7/2/03",
         "Status": "Approved ",
         "Description": "Liquor License Exception permit for the on-sale consumption of alcholic beverages at a public drinking establishment. ",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RABC03-002",
         "APN": 46722007,
         "File Number": "RABC03-002",
         "Address": " ",
         "Project Name": "RABC03-002, The Temple",
         "Application Type": "Liquor License Exception ",
         "Application Date": "8/1/03",
         "Status": "Approved ",
         "Description": "Liquor license exception permit ",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RABC99-002",
         "APN": 25935013,
         "File Number": "RABC99-002",
         "Address": " ",
         "Project Name": "RABC99-002, Club Ecco",
         "Application Type": "Liquor License Exception ",
         "Application Date": "7/23/99",
         "Status": "Approved ",
         "Description": "ABC exception permit to allow public convenience and neccesity for alcohol sales at an existing nightclub (allow Type 48)",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RABC99-002",
         "APN": 25935045,
         "File Number": "RABC99-002",
         "Address": "",
         "Project Name": "RABC99-002, Club Ecco",
         "Application Type": "Liquor License Exception ",
         "Application Date": "7/23/99",
         "Status": "Approved ",
         "Description": "ABC exception permit to allow public convenience and neccesity for alcohol sales at an existing nightclub (allow Type 48)",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RABC99-003",
         "APN": 25940086,
         "File Number": "RABC99-003",
         "Address": "",
         "Project Name": "RABC99-003, Vail Concepts Salon & Gifts",
         "Application Type": "Liquor License Exception ",
         "Application Date": "12/2/99",
         "Status": "Approved ",
         "Description": "Determination of public convenience and necessity for liquor license for the off-sale of alcohol at an existing gift shop (no consumption on-site, wine and champagne only). ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RCE96-001",
         "APN": 25935057,
         "File Number": "RCE96-001",
         "Address": "",
         "Project Name": "RCE96-001, Farmer's Union Coffee Roasting Co.",
         "Application Type": "Liquor License Exception ",
         "Application Date": "6/1/96",
         "Status": "Approved ",
         "Description": "Determination of public convenience and necessity for liquor license for sale of alcohol for on-site consumption. ",
         "Planner": "Dennis Korabiak ",
         "DURATION": 0,
         "Year": 1996
      },
      {
         "PERMITID": "RCE96-002",
         "APN": 25935057,
         "File Number": "RCE96-002",
         "Address": " ",
         "Project Name": "RCE96-002, Spiedo Ristorante",
         "Application Type": "Liquor License Exception ",
         "Application Date": "8/5/96",
         "Status": "Approved ",
         "Description": "Determination of public convenience and necessity for liquor license for sale of alcohol for on-site consumption. ",
         "Planner": "Dennis Korabiak ",
         "DURATION": 0,
         "Year": 1996
      },
      {
         "PERMITID": "RCE96-003",
         "APN": 46746044,
         "File Number": "RCE96-003",
         "Address": " ",
         "Project Name": "RCE96-003, B-Hive Kafe",
         "Application Type": "Liquor License Exception ",
         "Application Date": "10/3/96",
         "Status": "Approved ",
         "Description": "Determination of public convenience and necessity for a liquor license for sale of alcohol for on-site consumption. ",
         "Planner": "Kristi Ashburn ",
         "DURATION": 0,
         "Year": 1996
      },
      {
         "PERMITID": "RCE98-001",
         "APN": 25935057,
         "File Number": "RCE98-001",
         "Address": " ",
         "Project Name": "RCE98-001, San Tony Productions, Inc.",
         "Application Type": "Liquor License Exception ",
         "Application Date": "1/8/98",
         "Status": "Approved ",
         "Description": "Determination of public convenience and necessity for a liquor license for the sale of alcohol for on-site consumption. ",
         "Planner": "Martin Magana ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "ABC06-020",
         "APN": 25940086,
         "File Number": "ABC06-020",
         "Address": "60 S MARKET ST SAN JOSE",
         "Project Name": "ABC06-020",
         "Application Type": "Liquor License Exception ",
         "Application Date": "8/30/06",
         "Status": "Approved with Conditions ",
         "Description": "Liquor License Exception Permit for Determination of Public Convenience or Necessity to allow off-sale of alcohol on a 0.14 gross acre site",
         "Planner": "Michelle Stahlhut ",
         "DURATION": 201,
         "Year": 2006
      },
      {
         "PERMITID": "RABC99-001",
         "APN": 46722002,
         "File Number": "RABC99-001",
         "Address": " ",
         "Project Name": "RABC99-001, Lido Nightclub",
         "Application Type": "Liquor License Exception ",
         "Application Date": "7/7/99",
         "Status": "Closed ",
         "Description": "ABC exception permit to allow public convenience and neccesity for alcohol sales at an existing nightclub (allow Type 48)",
         "Planner": "Martin Magana ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "ABC11-008",
         "APN": 46724111,
         "File Number": "ABC11-008",
         "Address": "272 E SANTA CLARA ST SAN JOSE",
         "Project Name": "ABC11-008",
         "Application Type": "Liquor License Exception ",
         "Application Date": "6/9/11",
         "Status": "Complete ",
         "Description": "Determination of Public Convenience and Necessity to allow off-sale of beer and wine for a full-service market on an approximately 2.3 gross-acre site",
         "Planner": "Jenny Nusbaum ",
         "DURATION": 269,
         "Year": 2011
      },
      {
         "PERMITID": "ABC08-009",
         "APN": 26420127,
         "File Number": "ABC08-009",
         "Address": "394 BIRD AV SAN JOSE",
         "Project Name": "ABC08-009",
         "Application Type": "Liquor License Exception ",
         "Application Date": "8/21/08",
         "Status": "Denied ",
         "Description": "Determination of Public Convenience or Necessity to allow off-sale of alcoholic beverages at a retail store on a 0.13-gross acre.",
         "Planner": "Edward Schreiner ",
         "DURATION": 747,
         "Year": 2008
      },
      {
         "PERMITID": "2006 031718 AO",
         "APN": 26429118,
         "File Number": "2006 031718 AO",
         "Address": "389 S 1ST ST SAN JOSE",
         "Project Name": "393 1ST ST",
         "Application Type": "Liquor License Exception ",
         "Application Date": "10/26/06",
         "Status": "New ",
         "Description": " ",
         "Planner": "Lee Butler ",
         "DURATION": 0,
         "Year": 2006
      },
      {
         "PERMITID": "ABC15-016",
         "APN": 25940086,
         "File Number": "ABC15-016",
         "Address": "60 S MARKET ST SAN JOSE",
         "Project Name": "ABC15-016",
         "Application Type": "Liquor License Exception ",
         "Application Date": "10/14/15 15:30",
         "Status": "Withdrawn ",
         "Description": "Determination of Public Convenience or Necessity for off-sale of alcohol at a 989 sq. ft retail establishment on a 1.23 gross acre site",
         "Planner": "David Fong ",
         "DURATION": 294,
         "Year": 2015
      },
      {
         "PERMITID": "ABC16-001",
         "APN": 26420132,
         "File Number": "ABC16-001",
         "Address": "350 BIRD AV SAN JOSE",
         "Project Name": "ABC16-001",
         "Application Type": "Liquor License Exception ",
         "Application Date": " ",
         "Status": "Withdrawn ",
         "Description": "Determination of Public Convenience or Necessity for the off-sale of alcohol as part of the operations of an existing mini-mart on a 0.8 gross acre site",
         "Planner": "Avril Baty ",
         "DURATION": 1,
         "Year": null
      },
      {
         "PERMITID": "ABC16-004",
         "APN": 47217018,
         "File Number": "ABC16-004",
         "Address": "718 S 1ST ST SAN JOSE",
         "Project Name": "ABC16-004",
         "Application Type": "Liquor License Exception ",
         "Application Date": "8/26/16",
         "Status": "Withdrawn ",
         "Description": "Determination of Public Convenience or Necessity for the off-sale of alcohol as part of the operations of a new brewery on .126 gross acre site",
         "Planner": "Shaunn Mendrin ",
         "DURATION": 1,
         "Year": 2016
      }
   ],
   "Live Tree ": [
      {
         "PERMITID": "HA05-014-03",
         "APN": 25941067,
         "File Number": "HA05-014-03",
         "Address": "170 PARK CENTER PLAZA SAN JOSE",
         "Project Name": "HA05-014-03 Liquid Amber Trees",
         "Application Type": "Live Tree ",
         "Application Date": "11/13/07",
         "Status": "Approved ",
         "Description": "Tree Removal Permit to remove four Liquid Amber trees, 54 to 84 inches in circumference, from the landscaped area of an existing commercial office complex (Park Center Plaza)",
         "Planner": "Ella Samonsky ",
         "DURATION": 63,
         "Year": 2007
      },
      {
         "PERMITID": "HA85-269-01",
         "APN": 25935035,
         "File Number": "HA85-269-01",
         "Address": "163 W SANTA CLARA ST SAN JOSE",
         "Project Name": "HA85-269-01",
         "Application Type": "Live Tree ",
         "Application Date": "8/15/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to remove Atlas Cedar tree approximately 63 inches in circumference on a 0.2 gross acre site",
         "Planner": "Rebekah Ross ",
         "DURATION": 71,
         "Year": 2007
      },
      {
         "PERMITID": "PDA91-058-01",
         "APN": 24950083,
         "File Number": "PDA91-058-01",
         "Address": "345 E JULIAN ST SAN JOSE",
         "Project Name": "PDA91-058-01",
         "Application Type": "Live Tree ",
         "Application Date": "8/26/09",
         "Status": "Approved ",
         "Description": "Live Tree Removal Permit requesting to remove nine ordinance-sized trees from the common area within an existing multi-family complex on a 0.43 gross acre site",
         "Planner": "Avril Baty ",
         "DURATION": 36,
         "Year": 2009
      },
      {
         "PERMITID": "TR04-007",
         "APN": 46701073,
         "File Number": "TR04-007",
         "Address": "254 N 4TH ST SAN JOSE",
         "Project Name": "TR04-007",
         "Application Type": "Live Tree ",
         "Application Date": "2/4/04",
         "Status": "Approved ",
         "Description": "Tree Removal Permit to remove one palm tree 76 inches in circumference on a .18 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 64,
         "Year": 2004
      },
      {
         "PERMITID": "TR06-189",
         "APN": 24944087,
         "File Number": "TR06-189",
         "Address": "360 N 1ST ST SAN JOSE",
         "Project Name": "TR06-189",
         "Application Type": "Live Tree ",
         "Application Date": "10/18/06",
         "Status": "Approved ",
         "Description": "Tree Removal Permit to remove two Canary Island Pine tree 56 and 57 inches in circumference and three Podocarpus trees 57, 58, and 62 inches in circumference on a 1.2 acre site",
         "Planner": "Steven Rosen ",
         "DURATION": 65,
         "Year": 2006
      },
      {
         "PERMITID": "TR07-207",
         "APN": 47221100,
         "File Number": "TR07-207",
         "Address": "720 MARGARET ST SAN JOSE",
         "Project Name": "TR07-207",
         "Application Type": "Live Tree ",
         "Application Date": "7/27/07",
         "Status": "Approved ",
         "Description": "Tree Removal Permit request to remove one monterey pine tree, 77 inches in circumference, in the rear yard of a single-family residence.",
         "Planner": "John Baty ",
         "DURATION": 26,
         "Year": 2007
      },
      {
         "PERMITID": "TR08-129",
         "APN": 24952010,
         "File Number": "TR08-129",
         "Address": "347 N 10TH ST SAN JOSE",
         "Project Name": "TR08-129",
         "Application Type": "Live Tree ",
         "Application Date": "4/30/08",
         "Status": "Approved ",
         "Description": "Tree Removal Permit to allow removal of one Palm tree, 80 inches in circumference, on a 0.14 gross acre site.",
         "Planner": "Suparna Saha ",
         "DURATION": 49,
         "Year": 2008
      },
      {
         "PERMITID": "TR08-188",
         "APN": 24946039,
         "File Number": "TR08-188",
         "Address": "337 N 4TH ST SAN JOSE",
         "Project Name": "TR08-188",
         "Application Type": "Live Tree ",
         "Application Date": "6/24/08",
         "Status": "Approved ",
         "Description": "Live Tree Removal Permit to allow the removal of one Tree of Heaven, approximately 60-inches in circumference from the rear yard of an existing single-family residence.",
         "Planner": "Reena Mathew ",
         "DURATION": 58,
         "Year": 2008
      },
      {
         "PERMITID": "TR08-262",
         "APN": 25945080,
         "File Number": "TR08-262",
         "Address": "0 SAN JOSE",
         "Project Name": "TR08-262",
         "Application Type": "Live Tree ",
         "Application Date": "9/16/08",
         "Status": "Approved ",
         "Description": "Live Tree Removal Permit for the removal of one tree of heaven (greater than 100 inches in circumference) from the rear of an office building lot owned by the City of San Jose, located in the R-2 Zoning District.",
         "Planner": "Darryl Boyd ",
         "DURATION": 43,
         "Year": 2008
      },
      {
         "PERMITID": "TR10-119",
         "APN": 25935045,
         "File Number": "TR10-119",
         "Address": "170 W ST JOHN ST SAN JOSE",
         "Project Name": "TR10-119",
         "Application Type": "Live Tree ",
         "Application Date": "5/25/10",
         "Status": "Approved ",
         "Description": "Tree Removal Permit to remove two (2) ordinance size Ailanthos Altissima trees measuring approximately 84- and 62-inches in circumferance and one (1) non ordinance sized Ailanthos Altissima tree located on an existing commecial property.",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 36,
         "Year": 2010
      },
      {
         "PERMITID": "TR15-277",
         "APN": 47221091,
         "File Number": "TR15-277",
         "Address": "696 MARGARET ST SAN JOSE",
         "Project Name": "TR15-277",
         "Application Type": "Live Tree ",
         "Application Date": "7/10/15 10:04",
         "Status": "Approved ",
         "Description": "Live Tree Removal Permit to remove one Sycamore tree approximately 145 inches in circumference, which was deemed hazardous by staff, and one Willow tree approximately 120 inches in circumference located in the rear yard of a single-family detached residence on a 0.64 gross acre site",
         "Planner": "Jennifer Piozet ",
         "DURATION": 208,
         "Year": 2015
      },
      {
         "PERMITID": "TR15-318",
         "APN": 47230014,
         "File Number": "TR15-318",
         "Address": "609 S 14TH ST SAN JOSE",
         "Project Name": "TR15-318",
         "Application Type": "Live Tree ",
         "Application Date": "7/30/15 10:24",
         "Status": "Approved ",
         "Description": "Live Removal Permit to allow the removal of one Redwood tree,134 inches in circumference, located within five feed of a detached garage of a single-family residence, on an approximately 0.4-gross acre site, in the R-1-8 Single-Family Residence Zoning District",
         "Planner": "Rebecca Bustos ",
         "DURATION": 49,
         "Year": 2015
      },
      {
         "PERMITID": "TR15-512",
         "APN": 46721031,
         "File Number": "TR15-512",
         "Address": "81 N 2ND ST SAN JOSE",
         "Project Name": "TR15-512",
         "Application Type": "Live Tree ",
         "Application Date": "10/30/15 13:59",
         "Status": "Approved ",
         "Description": "Live Tree Removal Permit for the removal of one (1) Liquid Amber tree, approximately 72 inches in circumference from the front setback of an existing church property on a 0.6 gross acre site.",
         "Planner": "Tracy Tam ",
         "DURATION": 75,
         "Year": 2015
      },
      {
         "PERMITID": "TR16-259",
         "APN": 47224013,
         "File Number": "TR16-259",
         "Address": "617 S 9TH ST SAN JOSE",
         "Project Name": "TR16-259 - 617 SOUTH 9TH STREET",
         "Application Type": "Live Tree ",
         "Application Date": "5/31/16",
         "Status": "Approved ",
         "Description": "Live Tree Removal Permit to allow the removal of one (1) Avocado tree, approximately 62.8 inches in circumference, and one (1) multi-trunk Holly tree, approximately 42 inches in circumference, located in the front common area of an apartment building on a 0.15-gross acre site.",
         "Planner": "Rina Shah ",
         "DURATION": 75,
         "Year": 2016
      },
      {
         "PERMITID": "TR16-428",
         "APN": 46721031,
         "File Number": "TR16-428",
         "Address": "81 N 2ND ST SAN JOSE",
         "Project Name": "TR16-428",
         "Application Type": "Live Tree ",
         "Application Date": "9/1/16",
         "Status": "Approved ",
         "Description": "Live Tree Removal Permit to allow the removal of one (1) Coast Redwood tree, approximately 145 inches in circumference, located in the side yard of an existing church (Trinity Cathedral) at 81 North Second Street.",
         "Planner": "NTHOMAS ",
         "DURATION": 30,
         "Year": 2016
      },
      {
         "PERMITID": "TR16-601",
         "APN": 24952023,
         "File Number": "TR16-601",
         "Address": "328 N 9TH ST SAN JOSE",
         "Project Name": "TR16-601",
         "Application Type": "Live Tree ",
         "Application Date": "12/19/16 16:01",
         "Status": "Approved ",
         "Description": "Tree Removal Permit to remove one (1) Oak tree, approximately 56 inches in circumference, located in the rear yard of a single-family residence within an R-2 Two Family Zoning District, on approximately 0.15-gross acre site",
         "Planner": "Stefanie Farmer ",
         "DURATION": 88,
         "Year": 2016
      },
      {
         "PERMITID": "TR17-248",
         "APN": 25933044,
         "File Number": "TR17-248",
         "Address": "93 DEVINE ST SAN JOSE",
         "Project Name": "TR17-248",
         "Application Type": "Live Tree ",
         "Application Date": "3/7/17 14:21",
         "Status": "Approved ",
         "Description": "Live Tree Removal Permit to allow the removal of one Tree of Heaven, approximately 75 inches in circumference and one Oak tree, approximately 56 inches in circumference on an approximately 0.19 gross acre site",
         "Planner": "Tracy Tam ",
         "DURATION": 728,
         "Year": 2017
      },
      {
         "PERMITID": "TR17-366",
         "APN": 47211017,
         "File Number": "TR17-366",
         "Address": "0 SAN JOSE",
         "Project Name": "TR17-366",
         "Application Type": "Live Tree ",
         "Application Date": "5/2/17 15:23",
         "Status": "Approved ",
         "Description": "Live Tree Removal Permit to allow the removal of two (2) Walnut trees, one (1) Pine tree, and one (1) non-ordinance sized tree ranging in size from approximately 40 to 75 inches, located in the common landscape area of a water pump station on an approximately 1.7 gross-acre lot in the LI Light Industrial Zoning District",
         "Planner": "James Murphy ",
         "DURATION": 36,
         "Year": 2017
      },
      {
         "PERMITID": "TR17-378",
         "APN": 46722121,
         "File Number": "TR17-378",
         "Address": "35 S 2ND ST SAN JOSE",
         "Project Name": "TR17-378",
         "Application Type": "Live Tree ",
         "Application Date": "5/12/17 8:35",
         "Status": "Approved ",
         "Description": "Live Tree Permit to allow removal of one (1) Pine tree, approximately 60 inches in circumference, from a landscape area at the rear of a commercial use on a 1.2-gross acre site in the DC Downtown Primary Commercial Zoning District.",
         "Planner": "Rina Shah ",
         "DURATION": 110,
         "Year": 2017
      },
      {
         "PERMITID": "TR17-543",
         "APN": 46717082,
         "File Number": "TR17-543",
         "Address": "79 N 10TH ST SAN JOSE",
         "Project Name": "TR17-543",
         "Application Type": "Live Tree ",
         "Application Date": "8/23/17 13:11",
         "Status": "Approved ",
         "Description": "Live Tree Removal Permit to allow the removal of one (1) Redwood tree, 97 inches in circumference and one (1) Tree of Heaven, 92 inches in circumference, located in the rear and side yards of a multifamily development on a 0.14 gross acre site in the R-M Zoning District.",
         "Planner": "Leila Hakimizadeh ",
         "DURATION": 62,
         "Year": 2017
      },
      {
         "PERMITID": "TR18-561",
         "APN": 25939116,
         "File Number": "TR18-561",
         "Address": "333 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "333 WEST SAN FERNANDO STREET",
         "Application Type": "Live Tree ",
         "Application Date": "12/17/18 10:41",
         "Status": "Approved ",
         "Description": "Live Tree Removal to allow the removal of 36 trees of varying sizes and species, including 15 ordinance-size trees of which six are Coast Redwood trees ranging from approximately 39 to 52 inches in circumference, one America Sweetgum approximately 45 inches in circumference, two Horsetail trees approximately 44 and 89 inches in circumference, five London Plane trees ranging from approximately 39 to 77 inches in circumference, and one Mayten tree approximately 65 inches in circumference, on a commercial property.",
         "Planner": "Michelle Flores ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "PD07-086",
         "APN": 46747103,
         "File Number": "PD07-086",
         "Address": "496 S 3RD ST SAN JOSE",
         "Project Name": "PD07-086 date palm relocation",
         "Application Type": "Live Tree ",
         "Application Date": "10/9/07",
         "Status": "Approved with Conditions ",
         "Description": "Planned Development Permit to remove one Date Palm tree 99 inches in circumference on a 0.4 gross acre site",
         "Planner": "Ella Samonsky ",
         "DURATION": 110,
         "Year": 2007
      },
      {
         "PERMITID": "RHA00-001-01",
         "APN": 25930103,
         "File Number": "RHA00-001-01",
         "Address": "350 W JULIAN ST SAN JOSE",
         "Project Name": "RHA00-001-01",
         "Application Type": "Live Tree ",
         "Application Date": "11/13/09",
         "Status": "Approved with Conditions ",
         "Description": "Tree Removal Permit to allow removal of one Tree of Heaven approximately 85 inches in circumference on commercial property",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 33,
         "Year": 2009
      },
      {
         "PERMITID": "TR05-146",
         "APN": 46747103,
         "File Number": "TR05-146",
         "Address": "496 S 3RD ST SAN JOSE",
         "Project Name": "TR05-146",
         "Application Type": "Live Tree ",
         "Application Date": "10/6/05",
         "Status": "Approved with Conditions ",
         "Description": "Removal and relocation of one (1) canary date palm 117\" in circumference, and aproval of new locations for two (2) canary date palms 147\" and 142\" in circumferences that were previously relocated without a permit",
         "Planner": "Katja Irvin ",
         "DURATION": 64,
         "Year": 2005
      },
      {
         "PERMITID": "TR13-480",
         "APN": 47230047,
         "File Number": "TR13-480",
         "Address": "535 S 15TH ST SAN JOSE",
         "Project Name": "TR13-480",
         "Application Type": "Live Tree ",
         "Application Date": "11/7/13",
         "Status": "Denied ",
         "Description": "Tree Removal Permit for one (1) Acacia tree approximately 70 inches in circumference, located in the rear yard of a single-family detached residence on a 0.16 gross acre site, in the R-1-8 Single-Family Residential Zoning District.",
         "Planner": "Wayne Farrens ",
         "DURATION": 70,
         "Year": 2013
      },
      {
         "PERMITID": "TR17-622",
         "APN": 47211016,
         "File Number": "TR17-622",
         "Address": "0 SAN JOSE",
         "Project Name": "TR17-622",
         "Application Type": "Live Tree ",
         "Application Date": "10/2/17 16:27",
         "Status": "Denied ",
         "Description": "Live Tree Removal Permit to allow the removal of two (2) Pepper trees, approximately 75 and 94 inches in circumference, one (1) Tree of Heaven, approximately 57 inches in circumference, one (1) Walnut tree approximately 63 inches in circumference, and 11 non-ordinance sized trees, located on the fence line along the property of San Jose Water Co. Pump Station on a 3.6-gross acre site in the R-1-8 Single-Family Residential Zoning District",
         "Planner": "Jennifer Piozet ",
         "DURATION": 105,
         "Year": 2017
      },
      {
         "PERMITID": "2013 129359 TS",
         "APN": 47230047,
         "File Number": "2013 129359 TS",
         "Address": "535 S 15TH ST SAN JOSE",
         "Project Name": "535 S 15TH ST",
         "Application Type": "Live Tree ",
         "Application Date": "11/7/13",
         "Status": "New ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "TR18-373",
         "APN": 46722121,
         "File Number": "TR18-373",
         "Address": "35 S 2ND ST SAN JOSE",
         "Project Name": "35 SOUTH 2ND STREET",
         "Application Type": "Live Tree ",
         "Application Date": "8/10/18 14:28",
         "Status": "Newly Filed (Not Yet Assigned) ",
         "Description": "Live Tree Removal Permit to allow the removal of eleven (11) Pinus canariensis (Pine) trees of varying sizes on a 1.25 gross acre site in the DC Downtown Primary Commercial Zoning District, to be replaced with Crape Myrtle trees.",
         "Planner": "Rina Shah ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "TR04-144",
         "APN": 25935041,
         "File Number": "TR04-144",
         "Address": "51 N SAN PEDRO ST SAN JOSE",
         "Project Name": "TR04-144, 51 N SAN PEDRO ST",
         "Application Type": "Live Tree ",
         "Application Date": "12/1/04",
         "Status": "Notice Sent ",
         "Description": "Tree Removal Permit for 1 tree (multi-trunk with 5 trunks) on a commercial restaurant site on a 0.39 gross acre site.",
         "Planner": "Dave Tymn ",
         "DURATION": 54,
         "Year": 2004
      },
      {
         "PERMITID": "HA16-036-01",
         "APN": 46746072,
         "File Number": "HA16-036-01",
         "Address": "80 E SAN CARLOS ST SAN JOSE",
         "Project Name": "HA16-036-01",
         "Application Type": "Live Tree ",
         "Application Date": "12/19/16",
         "Status": "Pending ",
         "Description": "Tree Removal Permit request for removing six (6) ordinance-sized trees and 12 non-ordinance sized trees of various species from the parking lot of a commercial development, located in DC-Downtown Commercial Zoning District on 1.46 gross acre site",
         "Planner": "Sanhita Ghosal ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "HA85-037-01",
         "APN": 26416040,
         "File Number": "HA85-037-01",
         "Address": "782 AUZERAIS AV SAN JOSE",
         "Project Name": "HA85-037-01",
         "Application Type": "Live Tree ",
         "Application Date": "6/3/10",
         "Status": "Rejected ",
         "Description": "Tree removal permit to allow the removal of two (2) previously removed Pine trees approximately 32\" in circumference located in the front setback area of a commercial building. CODE CASE 201005198.",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 0,
         "Year": 2010
      },
      {
         "PERMITID": "2015 018014 TS",
         "APN": 25934053,
         "File Number": "2015 018014 TS",
         "Address": "111 N MARKET ST Bldg 1 SAN JOSE",
         "Project Name": "111 NORTH MARKET STREET",
         "Application Type": "Live Tree ",
         "Application Date": "5/14/15 13:16",
         "Status": "Withdrawn ",
         "Description": "Tree Removal Permit to allow the removal of two(2) trees from the parking lot This Folder was Cancelled during the Automatic Add phase.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "HA13-013-02",
         "APN": 25939111,
         "File Number": "HA13-013-02",
         "Address": "350 W SANTA CLARA ST SAN JOSE",
         "Project Name": "HA13-013-02",
         "Application Type": "Live Tree ",
         "Application Date": "3/10/14",
         "Status": "Withdrawn ",
         "Description": "Tree Removal permit to allow removal of 5 trees from a commercial property.",
         "Planner": "Ben Nguyen ",
         "DURATION": 1,
         "Year": 2014
      },
      {
         "PERMITID": "HA87-052-01",
         "APN": 25934034,
         "File Number": "HA87-052-01",
         "Address": "111 W ST JOHN ST Bldg 2 SAN JOSE",
         "Project Name": "HA87-052-01",
         "Application Type": "Live Tree ",
         "Application Date": "6/23/15 13:46",
         "Status": "Withdrawn ",
         "Description": "A Site Development Permit Amendment to allow for the removal of five (5) ordinance sized trees (Palm trees approximately 56 to 62 inches in circumference) and modify landscape and hardscape in the common space area, on a 1.7 gross acre site in the Downtown Core Zoning District.",
         "Planner": "John Tu ",
         "DURATION": 1509,
         "Year": 2015
      },
      {
         "PERMITID": "HA87-052-01",
         "APN": 25934053,
         "File Number": "HA87-052-01",
         "Address": "111 W ST JOHN ST Bldg 2 SAN JOSE",
         "Project Name": "HA87-052-01",
         "Application Type": "Live Tree ",
         "Application Date": "6/23/15 13:46",
         "Status": "Withdrawn ",
         "Description": "A Site Development Permit Amendment to allow for the removal of five (5) ordinance sized trees (Palm trees approximately 56 to 62 inches in circumference) and modify landscape and hardscape in the common space area, on a 1.7 gross acre site in the Downtown Core Zoning District.",
         "Planner": "John Tu ",
         "DURATION": 1509,
         "Year": 2015
      },
      {
         "PERMITID": "TR13-540",
         "APN": 46722121,
         "File Number": "TR13-540",
         "Address": "35 S 2ND ST SAN JOSE",
         "Project Name": "TR13-540",
         "Application Type": "Live Tree ",
         "Application Date": " ",
         "Status": "Withdrawn ",
         "Description": "Live Tree Removal Permit application for the removal of 10 Canary Island Pine trees, ranging in size from 66 inches to 102 inches in circumference, and two (2) non-ordinance Canary Island Pine trees from a parking lot in the DC Downtown Primary Commercial Zoning District.",
         "Planner": "Salifu Yakubu ",
         "DURATION": 1,
         "Year": null
      },
      {
         "PERMITID": "TR16-412",
         "APN": 47226002,
         "File Number": "TR16-412",
         "Address": "501 S 2ND ST SAN JOSE",
         "Project Name": "TR16-412",
         "Application Type": "Live Tree ",
         "Application Date": "8/19/16 13:46",
         "Status": "Withdrawn ",
         "Description": "Live Tree Removal Permit to allow the removal of two Podocarpus trees, approximately 60 and 64 inches in circumference, located in the front yard of a multi-family building on a 0.09 acre site in the DC zoning district.",
         "Planner": "Justin Daniels ",
         "DURATION": 45,
         "Year": 2016
      }
   ],
   "Lot Combining ": [
      {
         "PERMITID": "LCT92-007",
         "APN": 24950083,
         "File Number": "LCT92-007",
         "Address": "345 E JULIAN ST SAN JOSE",
         "Project Name": "LCT92-007",
         "Application Type": "Lot Combining ",
         "Application Date": "1/25/92",
         "Status": "Approved ",
         "Description": "COMBINE 2 PARCELS INTO 1 LOT",
         "Planner": "JPRANDI ",
         "DURATION": 0,
         "Year": 1992
      },
      {
         "PERMITID": "LCT98-022",
         "APN": 47224111,
         "File Number": "LCT98-022",
         "Address": "651 S 8TH ST SAN JOSE",
         "Project Name": "LCT98-022",
         "Application Type": "Lot Combining ",
         "Application Date": "2/3/98",
         "Status": "Expired ",
         "Description": "Lot Combination to combine two parcels into one lot to allow a 12 unit apartment building on a 0.26 acre site",
         "Planner": "Ron Eddow ",
         "DURATION": 0,
         "Year": 1998
      }
   ],
   "Lot Line Adjustment ": [
      {
         "PERMITID": "AT00-104",
         "APN": 46722142,
         "File Number": "AT00-104",
         "Address": "150 S 1ST ST SAN JOSE",
         "Project Name": "AT00-104",
         "Application Type": "Lot Line Adjustment ",
         "Application Date": "8/7/00 17:55",
         "Status": "Approved ",
         "Description": "Lot Line Adjustment between two parcels on a 3.306 gross acre site.",
         "Planner": "Akoni Danielsen ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "AT01-056",
         "APN": 47226091,
         "File Number": "AT01-056",
         "Address": "535 S 3RD ST SAN JOSE",
         "Project Name": "AT01-056",
         "Application Type": "Lot Line Adjustment ",
         "Application Date": "5/10/01",
         "Status": "Approved ",
         "Description": "Lot Line Adjustment to consolidate 3 parcels into 1 lot on a 3.05 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "AT05-002",
         "APN": 46722137,
         "File Number": "AT05-002",
         "Address": "91 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AT05-002",
         "Application Type": "Lot Line Adjustment ",
         "Application Date": "1/25/05",
         "Status": "Approved ",
         "Description": "Lot Line Adjustment between two lots on a 1.9 gross acre site",
         "Planner": "Dave Tymn ",
         "DURATION": 42,
         "Year": 2005
      },
      {
         "PERMITID": "AT07-053",
         "APN": 46719075,
         "File Number": "AT07-053",
         "Address": "225 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AT07-053",
         "Application Type": "Lot Line Adjustment ",
         "Application Date": "6/28/07",
         "Status": "Approved ",
         "Description": "Lot Line Adjustment application to relocate an existing property line between two adjoining properties to decrease the size of APN 467-19-075 and to increase the size of 467-57-081",
         "Planner": "Licinia McMorrow ",
         "DURATION": 57,
         "Year": 2007
      },
      {
         "PERMITID": "AT08-056",
         "APN": 25935056,
         "File Number": "AT08-056",
         "Address": "73 N SAN PEDRO ST SAN JOSE",
         "Project Name": "AT08-056",
         "Application Type": "Lot Line Adjustment ",
         "Application Date": "11/20/08",
         "Status": "Approved ",
         "Description": "Lot Line Adjustment between two lots an a 0.21 gross acre site",
         "Planner": "Ella Samonsky ",
         "DURATION": 281,
         "Year": 2008
      },
      {
         "PERMITID": "AT10-014",
         "APN": 25935057,
         "File Number": "AT10-014",
         "Address": "155 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AT10-014",
         "Application Type": "Lot Line Adjustment ",
         "Application Date": "7/22/10",
         "Status": "Approved ",
         "Description": "Lot Line Adjustment to adjust three existing parcels to 2 parcels on .84 gross acre site",
         "Planner": "Lori Moniz ",
         "DURATION": 559,
         "Year": 2010
      },
      {
         "PERMITID": "AT11-001",
         "APN": 46746110,
         "File Number": "AT11-001",
         "Address": "330 S 2ND ST SAN JOSE",
         "Project Name": "AT11-001",
         "Application Type": "Lot Line Adjustment ",
         "Application Date": "1/21/11",
         "Status": "Approved ",
         "Description": "Lot Line Adjustment to transfer 12,663 square feet from Parcel B to Parcel A to consolidate two parcels into one on .72 gross acre site in the DC Downtown Primary Commercial Zoning District",
         "Planner": "Lori Moniz ",
         "DURATION": 188,
         "Year": 2011
      },
      {
         "PERMITID": "AT13-015",
         "APN": 25940093,
         "File Number": "AT13-015",
         "Address": "1 S MARKET ST SAN JOSE",
         "Project Name": "AT13-015 One South Market",
         "Application Type": "Lot Line Adjustment ",
         "Application Date": "3/6/13",
         "Status": "Approved ",
         "Description": "Lot Line Adjustment to combine two lots into one parcel on an 0.97 gross acre site",
         "Planner": "Sylvia Do ",
         "DURATION": 31,
         "Year": 2013
      },
      {
         "PERMITID": "AT13-027",
         "APN": 26415015,
         "File Number": "AT13-027",
         "Address": "720 W SAN CARLOS ST SAN JOSE",
         "Project Name": "AT13-027",
         "Application Type": "Lot Line Adjustment ",
         "Application Date": "5/3/13",
         "Status": "Approved ",
         "Description": "Lot Line Adjustment to reconfigure 3 parcels in to 2 lots",
         "Planner": "Rebecca Bustos ",
         "DURATION": 155,
         "Year": 2013
      },
      {
         "PERMITID": "AT13-027",
         "APN": 26415064,
         "File Number": "AT13-027",
         "Address": "720 W SAN CARLOS ST SAN JOSE",
         "Project Name": "AT13-027",
         "Application Type": "Lot Line Adjustment ",
         "Application Date": "5/3/13",
         "Status": "Approved ",
         "Description": "Lot Line Adjustment to reconfigure 3 parcels in to 2 lots",
         "Planner": "Rebecca Bustos ",
         "DURATION": 155,
         "Year": 2013
      },
      {
         "PERMITID": "AT13-027",
         "APN": 26415065,
         "File Number": "AT13-027",
         "Address": "720 W SAN CARLOS ST SAN JOSE",
         "Project Name": "AT13-027",
         "Application Type": "Lot Line Adjustment ",
         "Application Date": "5/3/13",
         "Status": "Approved ",
         "Description": "Lot Line Adjustment to reconfigure 3 parcels in to 2 lots",
         "Planner": "Rebecca Bustos ",
         "DURATION": 155,
         "Year": 2013
      },
      {
         "PERMITID": "AT17-021",
         "APN": 26426006,
         "File Number": "AT17-021",
         "Address": "341 DELMAS AV SAN JOSE",
         "Project Name": "AT17-021",
         "Application Type": "Lot Line Adjustment ",
         "Application Date": "4/4/17 10:17",
         "Status": "Approved ",
         "Description": "Lot Line Adjustment to consolidate 4 parcels into 1 lot for residential uses on a 0.82 gross acre site",
         "Planner": "Emily Lipoma ",
         "DURATION": 42,
         "Year": 2017
      },
      {
         "PERMITID": "AT17-021",
         "APN": 26426008,
         "File Number": "AT17-021",
         "Address": "341 DELMAS AV SAN JOSE",
         "Project Name": "AT17-021",
         "Application Type": "Lot Line Adjustment ",
         "Application Date": "4/4/17 10:17",
         "Status": "Approved ",
         "Description": "Lot Line Adjustment to consolidate 4 parcels into 1 lot for residential uses on a 0.82 gross acre site",
         "Planner": "Emily Lipoma ",
         "DURATION": 42,
         "Year": 2017
      },
      {
         "PERMITID": "AT17-057",
         "APN": 25939112,
         "File Number": "AT17-057",
         "Address": "325 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "AT17-057",
         "Application Type": "Lot Line Adjustment ",
         "Application Date": "12/7/17",
         "Status": "Approved ",
         "Description": "Lot Line Adjustment to merge and reconfigure three lots into two lots on a 4.22-gross acre site.",
         "Planner": "Cassandra Van Der Zweep ",
         "DURATION": 253,
         "Year": 2017
      },
      {
         "PERMITID": "AT17-057",
         "APN": 25939116,
         "File Number": "AT17-057",
         "Address": "325 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "AT17-057",
         "Application Type": "Lot Line Adjustment ",
         "Application Date": "12/7/17",
         "Status": "Approved ",
         "Description": "Lot Line Adjustment to merge and reconfigure three lots into two lots on a 4.22-gross acre site.",
         "Planner": "Cassandra Van Der Zweep ",
         "DURATION": 253,
         "Year": 2017
      },
      {
         "PERMITID": "AT17-057",
         "APN": 25939118,
         "File Number": "AT17-057",
         "Address": "325 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "AT17-057",
         "Application Type": "Lot Line Adjustment ",
         "Application Date": "12/7/17",
         "Status": "Approved ",
         "Description": "Lot Line Adjustment to merge and reconfigure three lots into two lots on a 4.22-gross acre site.",
         "Planner": "Cassandra Van Der Zweep ",
         "DURATION": 253,
         "Year": 2017
      },
      {
         "PERMITID": "AT17-057",
         "APN": 25939119,
         "File Number": "AT17-057",
         "Address": "325 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "AT17-057",
         "Application Type": "Lot Line Adjustment ",
         "Application Date": "12/7/17",
         "Status": "Approved ",
         "Description": "Lot Line Adjustment to merge and reconfigure three lots into two lots on a 4.22-gross acre site.",
         "Planner": "Cassandra Van Der Zweep ",
         "DURATION": 253,
         "Year": 2017
      },
      {
         "PERMITID": "AT98-021",
         "APN": 26420131,
         "File Number": "AT98-021",
         "Address": "372 BIRD AV SAN JOSE",
         "Project Name": "AT98-021",
         "Application Type": "Lot Line Adjustment ",
         "Application Date": "1/30/98",
         "Status": "Approved ",
         "Description": "To combine 7 parcels into 1 lot for development of 110 unit single room occupancy facility",
         "Planner": "BPEDROTT ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "AT98-040",
         "APN": 25940094,
         "File Number": "AT98-040",
         "Address": "137 POST ST SAN JOSE",
         "Project Name": "AT98-040",
         "Application Type": "Lot Line Adjustment ",
         "Application Date": "3/16/98",
         "Status": "Approved ",
         "Description": "Lot line adjustment between five parcels to combine them into two parcels on a 1.26 acre site",
         "Planner": "Akoni Danielsen ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "LCT04-007",
         "APN": 47224111,
         "File Number": "LCT04-007",
         "Address": "659 S 8TH ST SAN JOSE",
         "Project Name": "LCT04-007",
         "Application Type": "Lot Line Adjustment ",
         "Application Date": "2/2/04",
         "Status": "Approved ",
         "Description": "Lot Combining Permit to consolidate 2 parcels into 1 lot for single-family attached residential uses on a 6.21 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 66,
         "Year": 2004
      },
      {
         "PERMITID": "AT06-003",
         "APN": 26429118,
         "File Number": "AT06-003",
         "Address": "389 S 1ST ST SAN JOSE",
         "Project Name": "AT06-003",
         "Application Type": "Lot Line Adjustment ",
         "Application Date": "1/4/06",
         "Status": "Complete ",
         "Description": "Lot Line Adjustment between two parcels on a 1.16 gross acres site",
         "Planner": "Darryl Boyd ",
         "DURATION": 534,
         "Year": 2006
      },
      {
         "PERMITID": "AT07-005",
         "APN": 47217057,
         "File Number": "AT07-005",
         "Address": "766 S 2ND ST SAN JOSE",
         "Project Name": "AT07-005",
         "Application Type": "Lot Line Adjustment ",
         "Application Date": "1/31/07",
         "Status": "Denied ",
         "Description": "Lot Line Adjustment to combine two lots (APN's 472-17-056 and 472-17-057). (Existing Code Violation on the site). Original file name AP07-001.",
         "Planner": "Lesley Xavier ",
         "DURATION": 131,
         "Year": 2007
      },
      {
         "PERMITID": "AT06-037",
         "APN": 46746045,
         "File Number": "AT06-037",
         "Address": "386 S 1ST ST SAN JOSE",
         "Project Name": "AT06-037",
         "Application Type": "Lot Line Adjustment ",
         "Application Date": "5/3/06",
         "Status": "Expired ",
         "Description": "Lot Line Adjustment to consolidate two parcels into one lot for commercial uses on 0.226 gross acre site",
         "Planner": "Darryl Boyd ",
         "DURATION": 404,
         "Year": 2006
      },
      {
         "PERMITID": "AT06-037",
         "APN": 46746074,
         "File Number": "AT06-037",
         "Address": "386 S 1ST ST SAN JOSE",
         "Project Name": "AT06-037",
         "Application Type": "Lot Line Adjustment ",
         "Application Date": "5/3/06",
         "Status": "Expired ",
         "Description": "Lot Line Adjustment to consolidate two parcels into one lot for commercial uses on 0.226 gross acre site",
         "Planner": "Darryl Boyd ",
         "DURATION": 404,
         "Year": 2006
      },
      {
         "PERMITID": "AT18-052",
         "APN": 46747058,
         "File Number": "AT18-052",
         "Address": "439 S 4TH ST SAN JOSE",
         "Project Name": "AT18-052",
         "Application Type": "Lot Line Adjustment ",
         "Application Date": "11/27/18 10:16",
         "Status": "Review Letter Sent ",
         "Description": "Lot Line Adjustment to combine 4 lots into 1 parcel",
         "Planner": "Stefanie Farmer ",
         "DURATION": 41,
         "Year": 2018
      },
      {
         "PERMITID": "AT18-052",
         "APN": 46747096,
         "File Number": "AT18-052",
         "Address": "439 S 4TH ST SAN JOSE",
         "Project Name": "AT18-052",
         "Application Type": "Lot Line Adjustment ",
         "Application Date": "11/27/18 10:16",
         "Status": "Review Letter Sent ",
         "Description": "Lot Line Adjustment to combine 4 lots into 1 parcel",
         "Planner": "Stefanie Farmer ",
         "DURATION": 41,
         "Year": 2018
      },
      {
         "PERMITID": "AT18-008",
         "APN": 25935035,
         "File Number": "AT18-008",
         "Address": "161 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AT18-008",
         "Application Type": "Lot Line Adjustment ",
         "Application Date": "2/12/18 10:19",
         "Status": "Under Review ",
         "Description": "Lot Line Adjustment to reconfigure 3 parcels into 3 lots",
         "Planner": "Cassandra Van Der Zweep ",
         "DURATION": 3,
         "Year": 2018
      },
      {
         "PERMITID": "AT18-008",
         "APN": 25935057,
         "File Number": "AT18-008",
         "Address": "161 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AT18-008",
         "Application Type": "Lot Line Adjustment ",
         "Application Date": "2/12/18 10:19",
         "Status": "Under Review ",
         "Description": "Lot Line Adjustment to reconfigure 3 parcels into 3 lots",
         "Planner": "Cassandra Van Der Zweep ",
         "DURATION": 3,
         "Year": 2018
      },
      {
         "PERMITID": "AT19-005",
         "APN": 46723088,
         "File Number": "AT19-005",
         "Address": "10 S 3RD ST SAN JOSE",
         "Project Name": "AT19-005",
         "Application Type": "Lot Line Adjustment ",
         "Application Date": "2/13/19 14:11",
         "Status": "Under Review ",
         "Description": "Lot Line Adjustment to combine three parcels into 1 lot",
         "Planner": "Rina Shah ",
         "DURATION": 30,
         "Year": 2019
      },
      {
         "PERMITID": "AT03-062",
         "APN": 46722148,
         "File Number": "AT03-062",
         "Address": "14 S 2ND ST SAN JOSE",
         "Project Name": "AT03-062",
         "Application Type": "Lot Line Adjustment ",
         "Application Date": "6/11/03",
         "Status": "Withdrawn ",
         "Description": "Lot Line Adjustment among 3 parcels for commercial use on a 0.66 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 93,
         "Year": 2003
      },
      {
         "PERMITID": "AT16-054",
         "APN": 46746072,
         "File Number": "AT16-054",
         "Address": "80 E SAN CARLOS ST SAN JOSE",
         "Project Name": "AT16-054",
         "Application Type": "Lot Line Adjustment ",
         "Application Date": "11/8/16",
         "Status": "Withdrawn ",
         "Description": "Lot Line Adjustment to consolidate six (6) lots into one lot for mixed residential and commercial uses on a 1.46 gross acre site",
         "Planner": "Emily Lipoma ",
         "DURATION": 165,
         "Year": 2016
      }
   ],
   "Major Permit Adjustment ": [
      {
         "PERMITID": "AD04-502",
         "APN": 25940043,
         "File Number": "AD04-502",
         "Address": "27 S 1ST ST SAN JOSE",
         "Project Name": "AD04-502 Black Sea Gallery",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "5/20/04",
         "Status": "Approved ",
         "Description": "Permit adjustment for facade changes to the Black Sea Gallery, excluding signs and deleting references to foam trim. Signs and lighting for banner requires future adjustement. ",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD05-560",
         "APN": 46723100,
         "File Number": "AD05-560",
         "Address": "88 S 4TH ST SAN JOSE",
         "Project Name": "AD05-560",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "6/10/05",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment for one automated teller machine ATM at a new bank. This is the first ATM at this location. ",
         "Planner": "Ron Eddow ",
         "DURATION": 1,
         "Year": 2005
      },
      {
         "PERMITID": "AD05-560",
         "APN": 46723101,
         "File Number": "AD05-560",
         "Address": "88 S 4TH ST SAN JOSE",
         "Project Name": "AD05-560",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "6/10/05",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment for one automated teller machine ATM at a new bank. This is the first ATM at this location. ",
         "Planner": "Ron Eddow ",
         "DURATION": 1,
         "Year": 2005
      },
      {
         "PERMITID": "AD06-1433",
         "APN": 46721045,
         "File Number": "AD06-1433",
         "Address": "35 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD06-1433",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "12/19/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment for exterior modifications to an existing 3-story building located in the DC Downtown Primary Commercial zoning district. Building is listed as a Structure of Merit on the Historic Resources Inventory.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-204",
         "APN": 46764005,
         "File Number": "AD06-204",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD06-204",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "3/1/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for changes required as a part of the Site Development Permit (H04-038) including, building details, parking lot details, and cross sections.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-204",
         "APN": 46764010,
         "File Number": "AD06-204",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD06-204",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "3/1/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for changes required as a part of the Site Development Permit (H04-038) including, building details, parking lot details, and cross sections.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-375",
         "APN": 46721034,
         "File Number": "AD06-375",
         "Address": "4 N 2ND ST SAN JOSE",
         "Project Name": "AD06-375",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/14/06",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow minor architectural changes (aluminum architectural feature above entry and column changes including stone base and stainless steel wrapped columns) and address signage  ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471001,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471006,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471007,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471009,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471010,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471011,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471013,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471014,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471017,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471018,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471019,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471020,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471021,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471022,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471023,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471025,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471026,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471028,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471029,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471030,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471031,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471034,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471035,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471036,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471037,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471038,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471039,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471040,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471041,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471042,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471043,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471044,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471045,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471046,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471047,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471049,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471050,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471051,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471052,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471053,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471054,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471055,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471056,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471057,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471059,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471060,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471061,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471062,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471063,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471064,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471065,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471066,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471068,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471069,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471070,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471071,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471072,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471073,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471074,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471075,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471077,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471078,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471080,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471082,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471083,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471084,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471085,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471086,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471087,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471088,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471089,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471091,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471092,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471093,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471094,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471095,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471096,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471097,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471100,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471102,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471103,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471104,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471105,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471106,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471107,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471108,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471109,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471110,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471111,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471112,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471113,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471114,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471115,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471116,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471117,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471118,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471119,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471121,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471122,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471123,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471124,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471125,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471127,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471128,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471130,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471131,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471132,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471133,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471134,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471135,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471136,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471137,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471138,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471140,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471141,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471142,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471143,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471144,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471145,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471146,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471147,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471148,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471149,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471150,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471151,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471152,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471153,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471154,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471155,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471156,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471157,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471158,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471159,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471160,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471161,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471162,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471163,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471164,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471165,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471166,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471167,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471168,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471169,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471171,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471172,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471173,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471174,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471175,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471177,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471178,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471179,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471182,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471184,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471185,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471186,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471187,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471188,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471189,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471191,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471192,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471193,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471195,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471196,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471197,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471198,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471199,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471200,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471201,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471202,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471203,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471204,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471205,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471207,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471208,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471209,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471210,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471211,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471212,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471213,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471214,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471215,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471216,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471217,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-383",
         "APN": 26471218,
         "File Number": "AD06-383",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD06-383",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/17/06",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to fulfill the conditions from approved Site Development Permit file no. H05-037. This Adjustment addresses the following: (1) colors/materials board, (2) revised elevations, (3) updated rooftop lighting, (4) movement of grease interceptors out of the right-of-way and into the interior of the site, and (5) clarification of the sidewalk widths on S. 1st St. and San Salvador Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD08-1294",
         "APN": 46764005,
         "File Number": "AD08-1294",
         "Address": "100 S 2ND ST Unit C-106 SAN JOSE",
         "Project Name": "AD08-1294 - Safeway - Tower 88",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/29/09",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment for signage and exterior modifications for Safeway Supermarket ",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD08-1294",
         "APN": 46764010,
         "File Number": "AD08-1294",
         "Address": "100 S 2ND ST Unit C-106 SAN JOSE",
         "Project Name": "AD08-1294 - Safeway - Tower 88",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/29/09",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment for signage and exterior modifications for Safeway Supermarket ",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-1015",
         "APN": 25939120,
         "File Number": "AD09-1015",
         "Address": "25 N 14TH ST SAN JOSE",
         "Project Name": "AD09-1015",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "11/16/09",
         "Status": "Approved ",
         "Description": "Install new 18\" x 24\" fiber boxes in existing T-Mobile lease areas.",
         "Planner": "John Davidson ",
         "DURATION": 9,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-1015",
         "APN": 46717090,
         "File Number": "AD09-1015",
         "Address": "25 N 14TH ST SAN JOSE",
         "Project Name": "AD09-1015",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "11/16/09",
         "Status": "Approved ",
         "Description": "Install new 18\" x 24\" fiber boxes in existing T-Mobile lease areas.",
         "Planner": "John Davidson ",
         "DURATION": 9,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-1015",
         "APN": 46720068,
         "File Number": "AD09-1015",
         "Address": "25 N 14TH ST SAN JOSE",
         "Project Name": "AD09-1015",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "11/16/09",
         "Status": "Approved ",
         "Description": "Install new 18\" x 24\" fiber boxes in existing T-Mobile lease areas.",
         "Planner": "John Davidson ",
         "DURATION": 9,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-1051",
         "APN": 25944085,
         "File Number": "AD09-1051",
         "Address": "345 PARK AV SAN JOSE",
         "Project Name": "AD09-1051",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "12/2/09",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to allow the addition of wind turbines and associated improvements as shown on the approved Permit Adjustment plans only. ",
         "Planner": "Jeff Roche ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-1091",
         "APN": 25944089,
         "File Number": "AD09-1091",
         "Address": "321 PARK AV SAN JOSE",
         "Project Name": "AD09-1091",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "12/17/09",
         "Status": "Approved ",
         "Description": "Installation of twelve (12) fuel cells on 5th floor parking deck.",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-128",
         "APN": 46702040,
         "File Number": "AD09-128",
         "Address": "285 E ST JAMES ST SAN JOSE",
         "Project Name": "AD09-128",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "2/11/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to convert a portion of an existing carrage house (3rd unit) to living space, modifications to existing floor plan of the existing duplex unit, installation of new vents on the exterior of main house (duplex), removal of exterior door/window/awning on the west elevation and installation of two new windows, and site improvements to accomodate five parking spaces.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-166",
         "APN": 47224111,
         "File Number": "AD09-166",
         "Address": "659 S 8TH ST SAN JOSE",
         "Project Name": "AD09-166",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "2/23/09",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment Request for adding a 245 square foot carport in the rear of a multi-family building, currently under construction, to meet accessible parking requirement unded ADA Act on a 0.26 acre site",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-221",
         "APN": 25939120,
         "File Number": "AD09-221",
         "Address": " ",
         "Project Name": "AD09-221 T-Mobile",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "3/11/09",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to replace existing Telco box with a new Fiber box within existing T-mobile lease area ",
         "Planner": "John Davidson ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-221",
         "APN": 46717090,
         "File Number": "AD09-221",
         "Address": " ",
         "Project Name": "AD09-221 T-Mobile",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "3/11/09",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to replace existing Telco box with a new Fiber box within existing T-mobile lease area ",
         "Planner": "John Davidson ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-221",
         "APN": 46720068,
         "File Number": "AD09-221",
         "Address": " ",
         "Project Name": "AD09-221 T-Mobile",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "3/11/09",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to replace existing Telco box with a new Fiber box within existing T-mobile lease area ",
         "Planner": "John Davidson ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-221",
         "APN": 46743091,
         "File Number": "AD09-221",
         "Address": " ",
         "Project Name": "AD09-221 T-Mobile",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "3/11/09",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to replace existing Telco box with a new Fiber box within existing T-mobile lease area ",
         "Planner": "John Davidson ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-959",
         "APN": 25940043,
         "File Number": "AD09-959",
         "Address": "27 S 1ST ST SAN JOSE",
         "Project Name": "AD09-959 Ross Dress for Less",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "10/26/09",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to allow modifications to the exterior of an existing commercial building as shown on the Permit Adjustment plans only. Major Permit Adjustment to allow modifications to the exterior of an existing commercial building as shown on the Permit Adjustment plans only.  ",
         "Planner": "Jeff Roche ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD10-1039",
         "APN": 47218059,
         "File Number": "AD10-1039",
         "Address": "160 E VIRGINIA ST SAN JOSE",
         "Project Name": "AD10-1039",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "12/17/10",
         "Status": "Approved ",
         "Description": "PERMIT ADJUSTMENT TO ALLOW THE ADDITION OF ONE (1) (N) GPS AND THREE (3) (N) LTE WIRELESS ANTENNAS BEHIND (N) ARCHITECTURALLY INTEGRATED FRP SCREEN ON AN (E) COMMERCIAL BUILDING",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 83,
         "Year": 2010
      },
      {
         "PERMITID": "AD10-321",
         "APN": 25940091,
         "File Number": "AD10-321",
         "Address": "55 S MARKET ST SAN JOSE",
         "Project Name": "AD10-321",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "5/4/10",
         "Status": "Approved ",
         "Description": "Modify location of previously approved equipment cabinets for building-mounted wireless communication facility from roof-top to inside 16th floor of building. (See AD09-929 for previous approval and conditions.)",
         "Planner": "Mike Enderby ",
         "DURATION": 1,
         "Year": 2010
      },
      {
         "PERMITID": "AD10-496",
         "APN": 25936074,
         "File Number": "AD10-496",
         "Address": "333 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD10-496",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "6/30/10",
         "Status": "Approved ",
         "Description": "INSTALLATION OF FOUR PANEL ANTENNAS AND SEVEN MICROWAVE DISHES ROOF-MOUNTED BEHIND NEW RF-FRIENDLY SCREENING, NOT TO EXCEED HEIGHT OF EXISTING ROOFTOP PENTHOUSE, WITH ROOF-LEVEL EQUIPMENT CABINETS IN EXISTING ENCLOSURE.  ",
         "Planner": "Mike Enderby ",
         "DURATION": 1,
         "Year": 2010
      },
      {
         "PERMITID": "AD10-540",
         "APN": 46721034,
         "File Number": "AD10-540",
         "Address": "4 N 2ND ST SAN JOSE",
         "Project Name": "AD10-540",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "7/16/10",
         "Status": "Approved ",
         "Description": "INSTALLATION OF THREE PANEL ANTENNAS AND EIGHT MICROWAVE DISHES BEHIND EXISTING ROOF SCREEN WITH ASSOCIATED EQUIPMENT.  ",
         "Planner": "MNAGARAJ ",
         "DURATION": 0,
         "Year": 2010
      },
      {
         "PERMITID": "AD10-653",
         "APN": 25940091,
         "File Number": "AD10-653",
         "Address": "55 S MARKET ST SAN JOSE",
         "Project Name": "AD10-653",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "8/19/10",
         "Status": "Approved ",
         "Description": "INSTALLATION OF TWO ADDITIONAL MICROWAVE DISHES (FOR A TOTAL OF 17) AT SITE ALREADY APPROVED FOR BUILDING-MOUNTED WIRELESS COMMUNICATION FACILITY BY AD09-929.",
         "Planner": "Mike Enderby ",
         "DURATION": 1,
         "Year": 2010
      },
      {
         "PERMITID": "AD10-678",
         "APN": 47218059,
         "File Number": "AD10-678",
         "Address": "160 E VIRGINIA ST SAN JOSE",
         "Project Name": "AD10-678",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "8/26/10",
         "Status": "Approved ",
         "Description": "INSTALLATION OF THREE PANEL ANTENNAS AND FIVE MICROWAVE DISHES WITH NEW ROOF-TOP SCREENING WITH ASSOCIATED EQUIPMENT.  ",
         "Planner": "Mike Enderby ",
         "DURATION": 0,
         "Year": 2010
      },
      {
         "PERMITID": "AD10-686",
         "APN": 25943069,
         "File Number": "AD10-686",
         "Address": "282 ALMADEN BL SAN JOSE",
         "Project Name": "AD10-686",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "8/31/10",
         "Status": "Approved ",
         "Description": "Permit Adjustment for the installation of 12 panel antennas, screen on roof-top of existing hotel, along with associated equipment.",
         "Planner": "Mike Enderby ",
         "DURATION": 1,
         "Year": 2010
      },
      {
         "PERMITID": "AD11-088",
         "APN": 46720018,
         "File Number": "AD11-088",
         "Address": "160 E ST JOHN ST SAN JOSE",
         "Project Name": "AD11-088",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "2/2/11",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to revised the previously approved permit, H09-004, to reduce the number of units, unit mix and parking layout in the DC Downtown Core Zoning District on 0.43 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 9,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-306",
         "APN": 25941068,
         "File Number": "AD11-306",
         "Address": "185 PARK AV SAN JOSE",
         "Project Name": "AD11-306",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/27/11",
         "Status": "Approved ",
         "Description": "MAJOR PERMIT ADJUSTMENT TO ALLOW CONSTRUCTION OF AN OUTDOOR DINING TERRACE ADDITION TO AN (E) EATING ESTABLISHMENT ON THE TOP (PARKING) LEVEL OF AN (E) COMMERCIAL BUILDING ONLY ",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-420",
         "APN": 25943069,
         "File Number": "AD11-420",
         "Address": "282 ALMADEN BL SAN JOSE",
         "Project Name": "AD11-420",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "6/2/11",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to allow for the replacement/addition of two (2) new metal and glass entry canopies at existing front and rear entries for a hotel and other improvements as shown on the approved Permit Adjustment plans only.",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-753",
         "APN": 25943069,
         "File Number": "AD11-753",
         "Address": "282 ALMADEN BL SAN JOSE",
         "Project Name": "AD11-753",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "9/14/11",
         "Status": "Approved ",
         "Description": "Minor design change to entry canopy, color selection, and modifications to glazing.  ",
         "Planner": "Jeff Roche ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-810",
         "APN": 25943069,
         "File Number": "AD11-810",
         "Address": "282 ALMADEN BL SAN JOSE",
         "Project Name": "AD11-810",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "10/5/11",
         "Status": "Approved ",
         "Description": "Major Permit Sign Adjustment to replace one monument sign (5 feet 6 1/2 inches) and three attached signs for a hotel with roofline 86 feet indicated on plans",
         "Planner": "Susan Walsh ",
         "DURATION": 1,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-955",
         "APN": 46724111,
         "File Number": "AD11-955",
         "Address": "272 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD11-955",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "11/7/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to provide a new glass and aluminium door at north elevation; remove an existing door and replace it with masonry to match building at east elevation; and to add screening for new rooftop mechanical units, to be painted to match building ",
         "Planner": "Sylvia Do ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD12-115",
         "APN": 25940064,
         "File Number": "AD12-115",
         "Address": "99 S 1ST ST SAN JOSE",
         "Project Name": "AD12-115",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "2/6/12",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to replace the patio cover with clear plastic corrugated sheets for the Wilcox Block Historical building ( identified as a Structure of Merit). The patio is shared by Billy Berks's and Mezcal restaurants. The connection elements will be of aluminum, on the existing frame.There will be no drilling on the historical walls. The plastic sheets shall be reversable.c ",
         "Planner": "Suparna Saha ",
         "DURATION": 1,
         "Year": 2012
      },
      {
         "PERMITID": "AD13-793",
         "APN": 25940093,
         "File Number": "AD13-793",
         "Address": "1 S MARKET ST SAN JOSE",
         "Project Name": "AD13-793 One South Market",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "7/23/13",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment in accordance with Condition No. 8 of the approved Site Development Permit (H12-022) addressing: (1) grease interceptor infrastructure for ground-floor uses; (2) modification of west elevation of the parking garage; (3) ground-floor signage opportunities; and (4) landscape modifications and tree replacement.",
         "Planner": "Sylvia Do ",
         "DURATION": 1,
         "Year": 2013
      },
      {
         "PERMITID": "AD13-993",
         "APN": 25940034,
         "File Number": "AD13-993",
         "Address": "84 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD13-993",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "9/16/13",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment for a new building entrance and 1,800 square foot patio on the Santa Clara street side of the property.",
         "Planner": "Rebecca Bustos ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "AD14-1076",
         "APN": 25939111,
         "File Number": "AD14-1076",
         "Address": "350 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD14-1076",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "10/9/14 11:38",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to document the offsite parking arrangement for 74 parking spaces with the adjacent parking structure to the south, new access and parking control equipment, street frontage and sidewalk improvements, and removal of nine trees with offsite mitigation payment to Our City Forrest for a previously approved hotel (AC Marriott) on a 0.54 gross acre site",
         "Planner": "Rebecca Bustos ",
         "DURATION": 1,
         "Year": 2014
      },
      {
         "PERMITID": "AD14-1076",
         "APN": 25939112,
         "File Number": "AD14-1076",
         "Address": "350 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD14-1076",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "10/9/14 11:38",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to document the offsite parking arrangement for 74 parking spaces with the adjacent parking structure to the south, new access and parking control equipment, street frontage and sidewalk improvements, and removal of nine trees with offsite mitigation payment to Our City Forrest for a previously approved hotel (AC Marriott) on a 0.54 gross acre site",
         "Planner": "Rebecca Bustos ",
         "DURATION": 1,
         "Year": 2014
      },
      {
         "PERMITID": "AD14-1076",
         "APN": 25939119,
         "File Number": "AD14-1076",
         "Address": "350 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD14-1076",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "10/9/14 11:38",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to document the offsite parking arrangement for 74 parking spaces with the adjacent parking structure to the south, new access and parking control equipment, street frontage and sidewalk improvements, and removal of nine trees with offsite mitigation payment to Our City Forrest for a previously approved hotel (AC Marriott) on a 0.54 gross acre site",
         "Planner": "Rebecca Bustos ",
         "DURATION": 1,
         "Year": 2014
      },
      {
         "PERMITID": "AD14-139",
         "APN": 25939122,
         "File Number": "AD14-139",
         "Address": "10 ALMADEN BL SAN JOSE",
         "Project Name": "AD14-139",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "2/12/14",
         "Status": "Approved ",
         "Description": "Revision of the approved Sign Program, and installation of seven attached signs totalling 156.5 square feet, on an approximately 215-foot tall office building.",
         "Planner": "Lori Moniz ",
         "DURATION": 1,
         "Year": 2014
      },
      {
         "PERMITID": "AD14-641",
         "APN": 46757083,
         "File Number": "AD14-641",
         "Address": "235 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD14-641",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "6/25/14",
         "Status": "Approved ",
         "Description": "Permit Adjustment for the inner courtyard of Vintage Towers to allow installation of a new trash enclosure including three bays of trash bins and landscaping in a planter box. Also to allow installation of a roll-up door on 6th street, and a 10' high security fence with locked gate and a CMU wall 13'4\" high located between the courtyard of Vintage Towers and the parking structure of the adjoining student housing.",
         "Planner": "Jan Warne ",
         "DURATION": 1,
         "Year": 2014
      },
      {
         "PERMITID": "AD14-644",
         "APN": 47218063,
         "File Number": "AD14-644",
         "Address": "9750 TRACT SAN JOSE",
         "Project Name": "AD14-644",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "6/25/14",
         "Status": "Approved ",
         "Description": "Minor changes to the approved elevations: converting a 920 sf two-bed room unit on the first floor into arts and crafts room. Adding a 900 sf new one-bed room unit on the third floor, while keeping the total number of residetnial units to 238 as approved per the Permit Development Amendment PDA 08-0290-01. Minor landscape changes. Outdoor lighting policy.",
         "Planner": "MNAGARAJ ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "AD15-1325",
         "APN": 25940034,
         "File Number": "AD15-1325",
         "Address": "84 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD15-1325",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "11/25/15 15:09",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to allow exterior façade modifications including new cladding at entry, new exterior lighting, accessible ramp improvements for an existing commercial building on a 0.46 gross acre site in the DC Downtown Primary Commercial zoning district.",
         "Planner": "MNAGARAJ ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "AD15-439",
         "APN": 46721018,
         "File Number": "AD15-439",
         "Address": "66 N 1ST ST SAN JOSE",
         "Project Name": "AD15-439",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/24/15 10:27",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to remove the approved garage entry/exit on St. John Street and reconfigure the ground floor to incorporate an ingress-only garage entry on North 1st Street and one ingress-only and one egress-only garage entries on North 2nd Street",
         "Planner": "Rebecca Bustos ",
         "DURATION": 7,
         "Year": 2015
      },
      {
         "PERMITID": "AD16-1115",
         "APN": 46723088,
         "File Number": "AD16-1115",
         "Address": "10 S 3RD ST SAN JOSE",
         "Project Name": "AD16-1115",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "10/3/16 16:59",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to allow to replacement of one fence, the installation of one new fence, and the restriping of a parking lot. The number of parking spaces would increase from 61 to 66.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2016
      },
      {
         "PERMITID": "AD16-1221",
         "APN": 25942082,
         "File Number": "AD16-1221",
         "Address": "200 S MARKET ST SAN JOSE",
         "Project Name": "AD16-1221",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "11/1/16 13:57",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to allow exterior lighting and cladding  ",
         "Planner": "Aparna Ankola ",
         "DURATION": 13,
         "Year": 2016
      },
      {
         "PERMITID": "AD16-1222",
         "APN": 25942081,
         "File Number": "AD16-1222",
         "Address": "240 S MARKET ST SAN JOSE",
         "Project Name": "AD16-1222",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "11/1/16 14:19",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment for exterior lighting and metal cladding ",
         "Planner": "Aparna Ankola ",
         "DURATION": 28,
         "Year": 2016
      },
      {
         "PERMITID": "AD16-132",
         "APN": 25935020,
         "File Number": "AD16-132",
         "Address": "225 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD16-132",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "2/1/16 16:09",
         "Status": "Approved ",
         "Description": "To use the terrace on the 15th floor for employees outdoor area only. Proposed terrace improvements with planters, movable seating, two new doors opening the indoor office area to the terrace, 44\" high guard railing all around the terrace/roof perimeter, outdoor pedestrian lighting, and repaving of the terrace.",
         "Planner": "Sanhita Ghosal ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "AD16-214",
         "APN": 47218063,
         "File Number": "AD16-214",
         "Address": "868 S 5TH ST SAN JOSE",
         "Project Name": "AD16-214 - 868 SOUTH 5TH STREET",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "2/19/16 10:21",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a model home/tract sales office for the development approved by PD08-029.",
         "Planner": "Lori Moniz ",
         "DURATION": 1,
         "Year": 2016
      },
      {
         "PERMITID": "AD16-542",
         "APN": 46718102,
         "File Number": "AD16-542",
         "Address": "51 N 9TH ST SAN JOSE",
         "Project Name": "AD16-542",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "5/3/16 14:52",
         "Status": "Approved ",
         "Description": "Permit adjustment to allow renovations to St. Patrick's School: including window replacement throughout the building with aluminum windows, installing a new the front door and replacing the roof on the main portion of the building. These modifications are to the non-historic building to the north of the City Landmark St. Patrick's School building.  ",
         "Planner": "Jan Warne ",
         "DURATION": 1,
         "Year": 2016
      },
      {
         "PERMITID": "AD17-1278",
         "APN": 25932079,
         "File Number": "AD17-1278",
         "Address": "0 TERRAINE ST SAN JOSE",
         "Project Name": "AD17-1278",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "12/19/17",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment for exterior architectural changes ",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-427",
         "APN": 25938039,
         "File Number": "AD17-427",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD17-427",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/21/17",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to allow façade and site improvements to the Diridon TOD project: For the Office Building: (1) Lowering the height by one feet, (2) Increasing the width of the roof top elevator shaft/equipment room, (3) Extending and wrapping the terraces in the middle section, (4) Modifying the ground floor façade and entries; For the Residential Building: (1) Lowering the height by two feet, (2) Modifying the facades on all elevations, and (3) Modifying the ground floor entries stairways on all elevations.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-427",
         "APN": 25938041,
         "File Number": "AD17-427",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD17-427",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/21/17",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to allow façade and site improvements to the Diridon TOD project: For the Office Building: (1) Lowering the height by one feet, (2) Increasing the width of the roof top elevator shaft/equipment room, (3) Extending and wrapping the terraces in the middle section, (4) Modifying the ground floor façade and entries; For the Residential Building: (1) Lowering the height by two feet, (2) Modifying the facades on all elevations, and (3) Modifying the ground floor entries stairways on all elevations.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-427",
         "APN": 25938109,
         "File Number": "AD17-427",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD17-427",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/21/17",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to allow façade and site improvements to the Diridon TOD project: For the Office Building: (1) Lowering the height by one feet, (2) Increasing the width of the roof top elevator shaft/equipment room, (3) Extending and wrapping the terraces in the middle section, (4) Modifying the ground floor façade and entries; For the Residential Building: (1) Lowering the height by two feet, (2) Modifying the facades on all elevations, and (3) Modifying the ground floor entries stairways on all elevations.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-427",
         "APN": 25938110,
         "File Number": "AD17-427",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD17-427",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/21/17",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to allow façade and site improvements to the Diridon TOD project: For the Office Building: (1) Lowering the height by one feet, (2) Increasing the width of the roof top elevator shaft/equipment room, (3) Extending and wrapping the terraces in the middle section, (4) Modifying the ground floor façade and entries; For the Residential Building: (1) Lowering the height by two feet, (2) Modifying the facades on all elevations, and (3) Modifying the ground floor entries stairways on all elevations.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-427",
         "APN": 25938128,
         "File Number": "AD17-427",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD17-427",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/21/17",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to allow façade and site improvements to the Diridon TOD project: For the Office Building: (1) Lowering the height by one feet, (2) Increasing the width of the roof top elevator shaft/equipment room, (3) Extending and wrapping the terraces in the middle section, (4) Modifying the ground floor façade and entries; For the Residential Building: (1) Lowering the height by two feet, (2) Modifying the facades on all elevations, and (3) Modifying the ground floor entries stairways on all elevations.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-427",
         "APN": 25938145,
         "File Number": "AD17-427",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD17-427",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "4/21/17",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to allow façade and site improvements to the Diridon TOD project: For the Office Building: (1) Lowering the height by one feet, (2) Increasing the width of the roof top elevator shaft/equipment room, (3) Extending and wrapping the terraces in the middle section, (4) Modifying the ground floor façade and entries; For the Residential Building: (1) Lowering the height by two feet, (2) Modifying the facades on all elevations, and (3) Modifying the ground floor entries stairways on all elevations.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "AD11-401",
         "APN": 25936074,
         "File Number": "AD11-401",
         "Address": "333 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD11-401",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "5/25/11",
         "Status": "Denied ",
         "Description": "Major Permit Adjustment to allow modifcations to wireless communications antennas on an existing building, including the relocation of three of the existing antennas and three antennas of increased size only. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD07-694",
         "APN": 46721045,
         "File Number": "AD07-694",
         "Address": "35 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD07-694",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "6/18/07",
         "Status": "Pending ",
         "Description": "**Requested photo of original front door on #37 -- cannot approve removal of historic feature, must only replace like for like per Sally. BR 3/24/08** Major Permit Adjustment for exterior modifications to an existing 3-story building listed as a Structure of Merit on the Historic Resources Inventory. DC Downtown Primary Commercial zoning district. (APN 467-21-026 and 467-21-027)",
         "Planner": "Suzanne Thomas ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD17-807",
         "APN": 25947068,
         "File Number": "AD17-807",
         "Address": "565 LORRAINE AV SAN JOSE",
         "Project Name": "AD17-807",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "8/1/17 10:49",
         "Status": "Pending ",
         "Description": "Permit Adjustment to allow architectural changes, landscaping design, shifting the building by 12 inches off to the west towards Montgomery St., accessible ramp near retail, Outdoor decorative panel to be removed, generator re-located to basement, front façade modified of residency entry.t",
         "Planner": "Suparna Saha ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "AD18-198",
         "APN": 25946046,
         "File Number": "AD18-198",
         "Address": "267 DELMAS AV SAN JOSE",
         "Project Name": "AD18-198",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "3/7/18",
         "Status": "Pending ",
         "Description": "Major Permit Adjustment to allow (1) Increase overall building height from 73 feet to 77 feet 8 inches; (2) Increase overall building square footage from 55,367 sf to 56,574 sf; (3) Decrease one-bedroom units from 25 to 19 and increase two-bedroom units from 11 to 17; (4) Increase total common open space from 3,970 sf to 4,157 sf; (5) Miscellaneous floor plan modifications shown in the plans; (6) Miscellaneous exterior façade architectural and materials changes shown in the plans; and, (7) Exterior lighting approval.",
         "Planner": "Lori Moniz ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "AD18-198",
         "APN": 25946048,
         "File Number": "AD18-198",
         "Address": "267 DELMAS AV SAN JOSE",
         "Project Name": "AD18-198",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "3/7/18",
         "Status": "Pending ",
         "Description": "Major Permit Adjustment to allow (1) Increase overall building height from 73 feet to 77 feet 8 inches; (2) Increase overall building square footage from 55,367 sf to 56,574 sf; (3) Decrease one-bedroom units from 25 to 19 and increase two-bedroom units from 11 to 17; (4) Increase total common open space from 3,970 sf to 4,157 sf; (5) Miscellaneous floor plan modifications shown in the plans; (6) Miscellaneous exterior façade architectural and materials changes shown in the plans; and, (7) Exterior lighting approval.",
         "Planner": "Lori Moniz ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "AD19-008",
         "APN": 25940041,
         "File Number": "AD19-008",
         "Address": "15 S 1ST ST SAN JOSE",
         "Project Name": "AD19-008",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "1/3/19 15:40",
         "Status": "Pending ",
         "Description": "Permit Adjustment for façade remodel of an existing commercial building ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD12-151",
         "APN": 25943069,
         "File Number": "AD12-151",
         "Address": "282 ALMADEN BL SAN JOSE",
         "Project Name": "AD12-151",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "2/14/12",
         "Status": "Withdrawn ",
         "Description": "Permit Adjustment to allow the addition of wireless communications antennas and associated improvements (including equipment enclosures) on the top of an existing hotel. ",
         "Planner": "Jeff Roche ",
         "DURATION": 1,
         "Year": 2012
      },
      {
         "PERMITID": "AD16-559",
         "APN": 25939115,
         "File Number": "AD16-559",
         "Address": "99 ALMADEN BL SAN JOSE",
         "Project Name": "AD16-559",
         "Application Type": "Major Permit Adjustment ",
         "Application Date": "5/6/16 10:34",
         "Status": "Withdrawn ",
         "Description": "Major Permit Adjustment for exterior work, façade improvements, employee amenity, seating area. hardscape, landscaping, drop-off, drive entrance from Almaden Blvd. ",
         "Planner": "David Fong ",
         "DURATION": 13,
         "Year": 2016
      }
   ],
   "Massage Letter ": [
      {
         "PERMITID": "RSL03-057",
         "APN": 46747035,
         "File Number": "RSL03-057",
         "Address": "482 S 2ND ST SAN JOSE",
         "Project Name": "RSL03-057",
         "Application Type": "Massage Letter ",
         "Application Date": "12/9/03 11:41",
         "Status": "Complete ",
         "Description": "Full-service beauty saloon with less than 15% massage area in a CG zoning district",
         "Planner": "John Davidson ",
         "DURATION": 1,
         "Year": 2003
      },
      {
         "PERMITID": "RSL05-013",
         "APN": 46718087,
         "File Number": "RSL05-013",
         "Address": "345 E SANTA CLARA ST SAN JOSE",
         "Project Name": "RSL05-013",
         "Application Type": "Massage Letter ",
         "Application Date": "2/23/05 12:43",
         "Status": "Complete ",
         "Description": "Massage letter to confirm if incidental massage as part of a beauty salon would be permitted. Beauty salon services include facials, hair styling and massage. ",
         "Planner": "Jean P. Lin ",
         "DURATION": 1,
         "Year": 2005
      },
      {
         "PERMITID": "RSL05-027",
         "APN": 46747035,
         "File Number": "RSL05-027",
         "Address": "482 S 2ND ST SAN JOSE",
         "Project Name": "RSL05-027",
         "Application Type": "Massage Letter ",
         "Application Date": "4/12/05 13:11",
         "Status": "Complete ",
         "Description": "Massage Letter needed to confirm permitted massage use, zoning, and GP. Located in an existing beauty salon. Not more than 15% of floor space will be used for massage.",
         "Planner": "Jean P. Lin ",
         "DURATION": 41,
         "Year": 2005
      },
      {
         "PERMITID": "RSL05-041",
         "APN": 46718087,
         "File Number": "RSL05-041",
         "Address": "345 E SANTA CLARA ST SAN JOSE",
         "Project Name": "RSL05-041",
         "Application Type": "Massage Letter ",
         "Application Date": "6/23/05 15:14",
         "Status": "Complete ",
         "Description": "Massage letter for a beauty salon ",
         "Planner": "Caleb Gretton ",
         "DURATION": 47,
         "Year": 2005
      },
      {
         "PERMITID": "RSL06-005",
         "APN": 46747035,
         "File Number": "RSL06-005",
         "Address": "482 S 2ND ST SAN JOSE",
         "Project Name": "RSL06-005",
         "Application Type": "Massage Letter ",
         "Application Date": "1/24/06 11:04",
         "Status": "Complete ",
         "Description": "needs updated letter for massage use because applicant is moving to 2nd flr of the same office building.",
         "Planner": "Bill Scott ",
         "DURATION": 17,
         "Year": 2006
      },
      {
         "PERMITID": "RSL06-011",
         "APN": 46747035,
         "File Number": "RSL06-011",
         "Address": "482 S 2ND ST SAN JOSE",
         "Project Name": "RSL06-011",
         "Application Type": "Massage Letter ",
         "Application Date": "2/2/06 13:10",
         "Status": "Complete ",
         "Description": "Massage Letter needed to confirm permitted massage use, zoning, and GP. Located in an existing beauty salon. Not more than 15% of floor space will be used for massage. Taking over a lease, no changes to the interior settings.",
         "Planner": "Bill Scott ",
         "DURATION": 8,
         "Year": 2006
      },
      {
         "PERMITID": "RSL12-133",
         "APN": 46725005,
         "File Number": "RSL12-133",
         "Address": "432 E SANTA CLARA ST SAN JOSE",
         "Project Name": "RSL12-133",
         "Application Type": "Massage Letter ",
         "Application Date": "12/7/12 14:56",
         "Status": "Complete ",
         "Description": "Massage letter ",
         "Planner": "Justin Daniels ",
         "DURATION": 3,
         "Year": 2012
      },
      {
         "PERMITID": "RSL18-091",
         "APN": 47246004,
         "File Number": "RSL18-091",
         "Address": "78 E VIRGINIA ST SAN JOSE",
         "Project Name": "RSL18-091",
         "Application Type": "Massage Letter ",
         "Application Date": "4/12/18 13:24",
         "Status": "Complete ",
         "Description": "Massage Letter for Certified Personal Service for Oceanic Day Spa ",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2018
      },
      {
         "PERMITID": "RSL03-016",
         "APN": 46720072,
         "File Number": "RSL03-016",
         "Address": "103 E SANTA CLARA ST SAN JOSE",
         "Project Name": "103 E SANTA CLARA ST",
         "Application Type": "Massage Letter ",
         "Application Date": "5/2/03",
         "Status": "New ",
         "Description": "BY JEAN LIN. MASSAGE PARLOR ON EXISTING BEAUTY SALON. ",
         "Planner": "Lee Butler ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RSL063-016",
         "APN": 46720072,
         "File Number": "RSL063-016",
         "Address": "103 E SANTA CLARA ST SAN JOSE",
         "Project Name": "103 E SANTA CLARA ST",
         "Application Type": "Massage Letter ",
         "Application Date": "5/2/03",
         "Status": "New ",
         "Description": "BY JEAN LIN. MASSAGE PARLOR ON EXISTING BEAUTY SALON WILL NOT TAKE MORE THAN 15% OF TOTAL SQ. FOOTAGE.",
         "Planner": "Lee Butler ",
         "DURATION": 0,
         "Year": 2003
      }
   ],
   "Multiple Permit Adjustment ": [
      {
         "PERMITID": "AD09-505",
         "APN": 25931071,
         "File Number": "AD09-505",
         "Address": "255 W JULIAN ST SAN JOSE",
         "Project Name": "AD09-505",
         "Application Type": "Multiple Permit Adjustment ",
         "Application Date": "5/29/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow addition of 3 new facade mounted antennas to existing 3 facade mounted antennas ( totalling 6) . The antennas will be painted to match existing building and facility. No new ground equipment is permitt with this permit.",
         "Planner": "Jeff Roche ",
         "DURATION": 0,
         "Year": 2009
      }
   ],
   "Negative Declaration ": [
      {
         "PERMITID": "PP00-147",
         "APN": 47233011,
         "File Number": "PP00-147",
         "Address": " ",
         "Project Name": "OLINDER PARK ",
         "Application Type": "Negative Declaration ",
         "Application Date": "10/18/00",
         "Status": "Complete ",
         "Description": "Master Plan for proposed neighborhood park with renovations to the adjacent elementary school recreation grounds. Plan includes 12 foot wide multi-use trail, renovation of 2 softball fields, 2 tennis courts, restroom building, pedestrian bridge, picnic a",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "PP00-147",
         "APN": 47233012,
         "File Number": "PP00-147",
         "Address": " ",
         "Project Name": "OLINDER PARK ",
         "Application Type": "Negative Declaration ",
         "Application Date": "10/18/00",
         "Status": "Complete ",
         "Description": "Master Plan for proposed neighborhood park with renovations to the adjacent elementary school recreation grounds. Plan includes 12 foot wide multi-use trail, renovation of 2 softball fields, 2 tennis courts, restroom building, pedestrian bridge, picnic a",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2000
      }
   ],
   "Not a Project ": [
      {
         "PERMITID": "PP04-279",
         "APN": 25943069,
         "File Number": "PP04-279",
         "Address": "282 ALMADEN BL SAN JOSE",
         "Project Name": "PP04-279 - Almaden / Woz Way Parking Lot",
         "Application Type": "Not a Project ",
         "Application Date": "10/5/04 10:48",
         "Status": "Complete ",
         "Description": "Third Amendment to a Lease Agreement between the City of San Jose and Boston Properties in the amount of $252,000 for the leasing of the property commonly referred to as Almaden/Woz Way parking lot. The proposed Third Amendment will extend the term of the Lease Agreement to December 31, 2005.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2004
      }
   ],
   "Not Specified": [
      {
         "PERMITID": "3-16866",
         "APN": 26426006,
         "File Number": "3-16866",
         "Address": "341 DELMAS AV SAN JOSE",
         "Project Name": "341 DELMAS AVENUE",
         "Application Type": "Not Specified",
         "Application Date": "7/21/17 15:18",
         "Status": "Approved ",
         "Description": "Folder for nitrogen deposition fees pursuant to the Santa Clara Valley Habitat Conservation Plan. ",
         "Planner": "Ruth Cueto ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "3-16866",
         "APN": 26426008,
         "File Number": "3-16866",
         "Address": "341 DELMAS AV SAN JOSE",
         "Project Name": "341 DELMAS AVENUE",
         "Application Type": "Not Specified",
         "Application Date": "7/21/17 15:18",
         "Status": "Approved ",
         "Description": "Folder for nitrogen deposition fees pursuant to the Santa Clara Valley Habitat Conservation Plan. ",
         "Planner": "Ruth Cueto ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "3-18824",
         "APN": 25932040,
         "File Number": "3-18824",
         "Address": "129 W JULIAN ST SAN JOSE",
         "Project Name": "TRACT NO. 10423",
         "Application Type": "Not Specified",
         "Application Date": "10/20/17",
         "Status": "Approved ",
         "Description": "HCP folder for North San Pedro Blocks A, C, and D. Fees cover the townhouse developments approved under Site Development Permits H14-002, H14-003, and H14-004.",
         "Planner": "Ruth Cueto ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "3-18824",
         "APN": 25932041,
         "File Number": "3-18824",
         "Address": "129 W JULIAN ST SAN JOSE",
         "Project Name": "TRACT NO. 10423",
         "Application Type": "Not Specified",
         "Application Date": "10/20/17",
         "Status": "Approved ",
         "Description": "HCP folder for North San Pedro Blocks A, C, and D. Fees cover the townhouse developments approved under Site Development Permits H14-002, H14-003, and H14-004.",
         "Planner": "Ruth Cueto ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "3-18824",
         "APN": 25932073,
         "File Number": "3-18824",
         "Address": "129 W JULIAN ST SAN JOSE",
         "Project Name": "TRACT NO. 10423",
         "Application Type": "Not Specified",
         "Application Date": "10/20/17",
         "Status": "Approved ",
         "Description": "HCP folder for North San Pedro Blocks A, C, and D. Fees cover the townhouse developments approved under Site Development Permits H14-002, H14-003, and H14-004.",
         "Planner": "Ruth Cueto ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "3-18824",
         "APN": 25932079,
         "File Number": "3-18824",
         "Address": "129 W JULIAN ST SAN JOSE",
         "Project Name": "TRACT NO. 10423",
         "Application Type": "Not Specified",
         "Application Date": "10/20/17",
         "Status": "Approved ",
         "Description": "HCP folder for North San Pedro Blocks A, C, and D. Fees cover the townhouse developments approved under Site Development Permits H14-002, H14-003, and H14-004.",
         "Planner": "Ruth Cueto ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "3-18824",
         "APN": 25933067,
         "File Number": "3-18824",
         "Address": "129 W JULIAN ST SAN JOSE",
         "Project Name": "TRACT NO. 10423",
         "Application Type": "Not Specified",
         "Application Date": "10/20/17",
         "Status": "Approved ",
         "Description": "HCP folder for North San Pedro Blocks A, C, and D. Fees cover the townhouse developments approved under Site Development Permits H14-002, H14-003, and H14-004.",
         "Planner": "Ruth Cueto ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "3-22145",
         "APN": 46746072,
         "File Number": "3-22145",
         "Address": "80 E SAN CARLOS ST SAN JOSE",
         "Project Name": "80 EAST SAN CARLOS STREET",
         "Application Type": "Not Specified",
         "Application Date": "7/21/17 10:16",
         "Status": "Approved ",
         "Description": "HCP folder for The Graduate - Nitrogen Deposition Fees only - D. Keyon 7/21/17 HCP fees paid 8/1/17. (D. Keyon)",
         "Planner": "Ruth Cueto ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "RAD03-015",
         "APN": 46721025,
         "File Number": "RAD03-015",
         "Address": "31 E SANTA CLARA ST SAN JOSE",
         "Project Name": "31 E SANTA CLARA ST",
         "Application Type": "Not Specified",
         "Application Date": "8/14/03",
         "Status": "Approved ",
         "Description": "Permit Adjustment ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-037",
         "APN": 25930094,
         "File Number": "RAD03-037",
         "Address": "350 W JULIAN ST BLD 1 SAN JOSE",
         "Project Name": "350 W JULIAN ST BLD 1",
         "Application Type": "Not Specified",
         "Application Date": "1/27/03",
         "Status": "Approved ",
         "Description": "Sign permit 9 signs, free standing, 2'-0\" - 3'-3\"; 6 sq.ft.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-037",
         "APN": 25930103,
         "File Number": "RAD03-037",
         "Address": "350 W JULIAN ST BLD 1 SAN JOSE",
         "Project Name": "350 W JULIAN ST BLD 1",
         "Application Type": "Not Specified",
         "Application Date": "1/27/03",
         "Status": "Approved ",
         "Description": "Sign permit 9 signs, free standing, 2'-0\" - 3'-3\"; 6 sq.ft.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "V00-006",
         "APN": 46718029,
         "File Number": "V00-006",
         "Address": "162 N 8TH ST SAN JOSE",
         "Project Name": "V00-006",
         "Application Type": "Not Specified",
         "Application Date": "1/21/00",
         "Status": "Approved ",
         "Description": "Development Exception to allow development of a single family residence on a 0.09 gross acre sub-standard lot in the R-3 Residence District",
         "Planner": "Lisa Ring ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "V00-023",
         "APN": 46702005,
         "File Number": "V00-023",
         "Address": "277 N 6TH ST SAN JOSE",
         "Project Name": "V00-023",
         "Application Type": "Not Specified",
         "Application Date": "8/9/00",
         "Status": "Approved ",
         "Description": "Variance for reduction in covered parking requirement for a single family residence on a .077 gross acre site",
         "Planner": "Akoni Danielsen ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "V86-026",
         "APN": 46747031,
         "File Number": "V86-026",
         "Address": "477 S 3RD ST SAN JOSE",
         "Project Name": "V86-026",
         "Application Type": "Not Specified",
         "Application Date": "12/23/86",
         "Status": "Approved ",
         "Description": "REDUCE DRIVEWAY WIDTH ",
         "Planner": "LCARRILL ",
         "DURATION": 0,
         "Year": 1986
      },
      {
         "PERMITID": "V91-012",
         "APN": 46702014,
         "File Number": "V91-012",
         "Address": "229 E ST JAMES ST SAN JOSE",
         "Project Name": "V91-012",
         "Application Type": "Not Specified",
         "Application Date": "8/14/91",
         "Status": "Approved ",
         "Description": "File type: *Other apns: *Gen.Use Class:*Existing Land Use:69*Specific Use:ONE S F D",
         "Planner": "LCARRILL ",
         "DURATION": 0,
         "Year": 1991
      },
      {
         "PERMITID": "V96-004",
         "APN": 24946039,
         "File Number": "V96-004",
         "Address": "337 N 4TH ST SAN JOSE",
         "Project Name": "V96-004",
         "Application Type": "Not Specified",
         "Application Date": "2/2/96",
         "Status": "Approved ",
         "Description": "(Q83) 9-FOOT REAR SETBACK FOR SFDR",
         "Planner": "Michele Campos ",
         "DURATION": 0,
         "Year": 1996
      },
      {
         "PERMITID": "V99-005",
         "APN": 46718056,
         "File Number": "V99-005",
         "Address": "307 E ST JOHN ST SAN JOSE",
         "Project Name": "V99-005",
         "Application Type": "Not Specified",
         "Application Date": "4/16/99",
         "Status": "Approved ",
         "Description": "Development Exception to allow a two story single family detached residence on a 0.06 gross acre substandard lot",
         "Planner": "Robert MERKAMP ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "2012 027660 PAS",
         "APN": 25940049,
         "File Number": "2012 027660 PAS",
         "Address": "39 POST ST SAN JOSE",
         "Project Name": "39 POST ST",
         "Application Type": "Not Specified",
         "Application Date": "9/19/12",
         "Status": "Closed ",
         "Description": "MAC'c Club's new CUP ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2012
      },
      {
         "PERMITID": "2012 027894 PAS",
         "APN": 46720041,
         "File Number": "2012 027894 PAS",
         "Address": "115 N 4TH ST SAN JOSE",
         "Project Name": "115 4TH ST",
         "Application Type": "Not Specified",
         "Application Date": "9/20/12",
         "Status": "Closed ",
         "Description": "Conditional Use Permit for after midnight use till 3 am for an existing hookah lounge",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2012
      },
      {
         "PERMITID": "2012 032914 PAS",
         "APN": 26415015,
         "File Number": "2012 032914 PAS",
         "Address": "365 ROYAL AV SAN JOSE",
         "Project Name": "365 ROYAL AV",
         "Application Type": "Not Specified",
         "Application Date": "11/7/12",
         "Status": "Closed ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2012
      },
      {
         "PERMITID": "2012 035022 PAS",
         "APN": 47222087,
         "File Number": "2012 035022 PAS",
         "Address": "681 S 13TH ST SAN JOSE",
         "Project Name": "681 S 13TH ST",
         "Application Type": "Not Specified",
         "Application Date": "11/29/12",
         "Status": "Closed ",
         "Description": "Planned Development Zoning to rezone from R-1-8 to A(PD) Zoning District to allow 2 single-family detached homes on .21 gross acre site",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2012
      },
      {
         "PERMITID": "2012 035366 PAS",
         "APN": 46746015,
         "File Number": "2012 035366 PAS",
         "Address": "394 S 2ND ST SAN JOSE",
         "Project Name": "394 S 2ND ST",
         "Application Type": "Not Specified",
         "Application Date": "12/4/12",
         "Status": "Closed ",
         "Description": "Conditional Use Permit Renewal for a timely renewal of an existing eating, drinking, and entertainment establishment and late night use until 2:00 a.m. daily on a 0.32 acre site",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2012
      },
      {
         "PERMITID": "2013 004703 PAS",
         "APN": 26415065,
         "File Number": "2013 004703 PAS",
         "Address": "720 W SAN CARLOS ST SAN JOSE",
         "Project Name": "720 W SAN CARLOS ST",
         "Application Type": "Not Specified",
         "Application Date": "2/5/13",
         "Status": "Closed ",
         "Description": "Special Use Permit to demolish a vacant single family residence ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "2013 004798 PAS",
         "APN": 26415065,
         "File Number": "2013 004798 PAS",
         "Address": "720 W SAN CARLOS ST SAN JOSE",
         "Project Name": "OSH ",
         "Application Type": "Not Specified",
         "Application Date": "2/6/13",
         "Status": "Closed ",
         "Description": "Site Development Permit for the construction of a 48,603 square foot commercial building, including a garden center, and a 3,137 square foot pad",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "2013 006284 PAS",
         "APN": 25940091,
         "File Number": "2013 006284 PAS",
         "Address": "55 S MARKET ST SAN JOSE",
         "Project Name": "55 S MARKET ST",
         "Application Type": "Not Specified",
         "Application Date": "2/20/13",
         "Status": "Closed ",
         "Description": "Tentative Map Application for 11 condos",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "2013 006860 PAS",
         "APN": 25940001,
         "File Number": "2013 006860 PAS",
         "Address": "44 S ALMADEN AV SAN JOSE",
         "Project Name": "44 S ALMADEN AV",
         "Application Type": "Not Specified",
         "Application Date": "2/26/13",
         "Status": "Closed ",
         "Description": "Conditional Use Permit (renewal ?) for CP08-016/The Blank Club",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "2013 007223 PAS",
         "APN": 25939111,
         "File Number": "2013 007223 PAS",
         "Address": "350 W SANTA CLARA ST SAN JOSE",
         "Project Name": "350 W SANTA CLARA ST SAN JOSE",
         "Application Type": "Not Specified",
         "Application Date": "3/1/13",
         "Status": "Closed ",
         "Description": "Site Development Application to allow a 98,899 square feet commercial hotel in the DC Downtown Core Zoning District on .54 gross acre site",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "2013 008656 PAS",
         "APN": 46722031,
         "File Number": "2013 008656 PAS",
         "Address": "83 S 2ND ST SAN JOSE",
         "Project Name": "83 S 2ND ST",
         "Application Type": "Not Specified",
         "Application Date": " ",
         "Status": "Closed ",
         "Description": "Conditional use permit renewal of existing restaurant and bar in Downtown ",
         "Planner": " ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "2013 101473 PAS",
         "APN": 46721025,
         "File Number": "2013 101473 PAS",
         "Address": "31 E SANTA CLARA ST SAN JOSE",
         "Project Name": "31 E SANTA CLARA ST",
         "Application Type": "Not Specified",
         "Application Date": "3/26/13",
         "Status": "Closed ",
         "Description": "Conditional Use Permit Renewal of CP08-038 to allow a public drinking establishment and after midnight operation until 2:00a.m, on a 0.07 gross acre site.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "2013 103623 PAS",
         "APN": 47228054,
         "File Number": "2013 103623 PAS",
         "Address": "346 E WILLIAM ST SAN JOSE",
         "Project Name": "346 E WILLIAM ST",
         "Application Type": "Not Specified",
         "Application Date": "4/12/13",
         "Status": "Closed ",
         "Description": "(residential) Planned Develpoment Permit to construct 28 multi-family attached residences with 1,780 square feet of ground floor retail on a 0.57 gross acre site.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "2013 104803 PAS",
         "APN": 26421068,
         "File Number": "2013 104803 PAS",
         "Address": "494 AUZERAIS AV SAN JOSE",
         "Project Name": "494 AUZERAIS AV",
         "Application Type": "Not Specified",
         "Application Date": "4/24/13",
         "Status": "Closed ",
         "Description": "(non-residential) Site Development Permit and Parking Analysis Application to pour and stripe a new 9-car parking lot for an existing neighborhood market on a 0.24 gross acre site.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "2013 105843 PAS",
         "APN": 25940070,
         "File Number": "2013 105843 PAS",
         "Address": "98 S ALMADEN AV SAN JOSE",
         "Project Name": "98 S ALMADEN AV",
         "Application Type": "Not Specified",
         "Application Date": "5/1/13",
         "Status": "Closed ",
         "Description": "Conditional Use Permit Renewal to allow operation of a public drinking and entertainment establishment with late night use until 2:00 am.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "2013 107331 PAS",
         "APN": 46719059,
         "File Number": "2013 107331 PAS",
         "Address": "73 N 6TH ST SAN JOSE",
         "Project Name": "73 N 6TH ST",
         "Application Type": "Not Specified",
         "Application Date": "5/15/13",
         "Status": "Closed ",
         "Description": "Rezoning Permit to rezone 2 lots from CG and R-M to DC for a proposed Mixed Use development on a 0.30 gross acre site",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "PP91-060",
         "APN": 46721034,
         "File Number": "PP91-060",
         "Address": "2 N 2ND ST SAN JOSE",
         "Project Name": "PP91-060",
         "Application Type": "Not Specified",
         "Application Date": "3/4/91",
         "Status": "Closed ",
         "Description": "A revocable encroachment permit to Wells Fargo Bank, N.A., National Banking Association, to maintain a facade encroachment on a portion of city-owned property. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 1991
      },
      {
         "PERMITID": "PP91-235",
         "APN": 25942023,
         "File Number": "PP91-235",
         "Address": "201 S MARKET ST SAN JOSE",
         "Project Name": "PP91-235",
         "Application Type": "Not Specified",
         "Application Date": "4/21/92",
         "Status": "Closed ",
         "Description": "Improvements including the installation of air conditioning equipment and an addition to a restroom. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 1992
      },
      {
         "PERMITID": "AC083-119",
         "APN": 46701118,
         "File Number": "AC083-119",
         "Address": "252 N 1ST ST SAN JOSE",
         "Project Name": "Park View Towers Project ",
         "Application Type": "Not Specified",
         "Application Date": "6/21/05",
         "Status": "Complete ",
         "Description": "Archaeological Resources Mitigation Plan ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2005
      },
      {
         "PERMITID": "H71-018",
         "APN": 26137029,
         "File Number": "H71-018",
         "Address": " ",
         "Project Name": " ",
         "Application Type": "Not Specified",
         "Application Date": " ",
         "Status": "Complete ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "PP10-003",
         "APN": 25934039,
         "File Number": "PP10-003",
         "Address": "45 N MARKET ST SAN JOSE",
         "Project Name": "PP10-003",
         "Application Type": "Not Specified",
         "Application Date": "1/12/10 13:48",
         "Status": "Complete ",
         "Description": "Installation of up to 43 electric vehicle chargers at eight existing City-owned downtown parking garages; installation of two vehicle chargers at two on-street parking spaces along a public right-of-way; and a grant application to the California Energy Commission for funding",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2010
      },
      {
         "PERMITID": "PP10-003",
         "APN": 46720017,
         "File Number": "PP10-003",
         "Address": "45 N MARKET ST SAN JOSE",
         "Project Name": "PP10-003",
         "Application Type": "Not Specified",
         "Application Date": "1/12/10 13:48",
         "Status": "Complete ",
         "Description": "Installation of up to 43 electric vehicle chargers at eight existing City-owned downtown parking garages; installation of two vehicle chargers at two on-street parking spaces along a public right-of-way; and a grant application to the California Energy Commission for funding",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2010
      },
      {
         "PERMITID": "PP10-003",
         "APN": 46721002,
         "File Number": "PP10-003",
         "Address": "45 N MARKET ST SAN JOSE",
         "Project Name": "PP10-003",
         "Application Type": "Not Specified",
         "Application Date": "1/12/10 13:48",
         "Status": "Complete ",
         "Description": "Installation of up to 43 electric vehicle chargers at eight existing City-owned downtown parking garages; installation of two vehicle chargers at two on-street parking spaces along a public right-of-way; and a grant application to the California Energy Commission for funding",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2010
      },
      {
         "PERMITID": "PP10-003",
         "APN": 46746097,
         "File Number": "PP10-003",
         "Address": "45 N MARKET ST SAN JOSE",
         "Project Name": "PP10-003",
         "Application Type": "Not Specified",
         "Application Date": "1/12/10 13:48",
         "Status": "Complete ",
         "Description": "Installation of up to 43 electric vehicle chargers at eight existing City-owned downtown parking garages; installation of two vehicle chargers at two on-street parking spaces along a public right-of-way; and a grant application to the California Energy Commission for funding",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2010
      },
      {
         "PERMITID": "PP11-003",
         "APN": 46723010,
         "File Number": "PP11-003",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP11-003",
         "Application Type": "Not Specified",
         "Application Date": "1/13/11 16:56",
         "Status": "Complete ",
         "Description": "Public project exemption for the repair and filling of abandonded conduit at City Hall. Work includes sawcutting concrete to access abandonded conduit, and filling abandoned conduit with waterproofing material. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "PP11-003",
         "APN": 46723011,
         "File Number": "PP11-003",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP11-003",
         "Application Type": "Not Specified",
         "Application Date": "1/13/11 16:56",
         "Status": "Complete ",
         "Description": "Public project exemption for the repair and filling of abandonded conduit at City Hall. Work includes sawcutting concrete to access abandonded conduit, and filling abandoned conduit with waterproofing material. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "PP11-003",
         "APN": 46723013,
         "File Number": "PP11-003",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP11-003",
         "Application Type": "Not Specified",
         "Application Date": "1/13/11 16:56",
         "Status": "Complete ",
         "Description": "Public project exemption for the repair and filling of abandonded conduit at City Hall. Work includes sawcutting concrete to access abandonded conduit, and filling abandoned conduit with waterproofing material. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "PP11-003",
         "APN": 46723017,
         "File Number": "PP11-003",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP11-003",
         "Application Type": "Not Specified",
         "Application Date": "1/13/11 16:56",
         "Status": "Complete ",
         "Description": "Public project exemption for the repair and filling of abandonded conduit at City Hall. Work includes sawcutting concrete to access abandonded conduit, and filling abandoned conduit with waterproofing material. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "PP11-003",
         "APN": 46723018,
         "File Number": "PP11-003",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP11-003",
         "Application Type": "Not Specified",
         "Application Date": "1/13/11 16:56",
         "Status": "Complete ",
         "Description": "Public project exemption for the repair and filling of abandonded conduit at City Hall. Work includes sawcutting concrete to access abandonded conduit, and filling abandoned conduit with waterproofing material. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "PP11-003",
         "APN": 46723019,
         "File Number": "PP11-003",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP11-003",
         "Application Type": "Not Specified",
         "Application Date": "1/13/11 16:56",
         "Status": "Complete ",
         "Description": "Public project exemption for the repair and filling of abandonded conduit at City Hall. Work includes sawcutting concrete to access abandonded conduit, and filling abandoned conduit with waterproofing material. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "PP11-003",
         "APN": 46723021,
         "File Number": "PP11-003",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP11-003",
         "Application Type": "Not Specified",
         "Application Date": "1/13/11 16:56",
         "Status": "Complete ",
         "Description": "Public project exemption for the repair and filling of abandonded conduit at City Hall. Work includes sawcutting concrete to access abandonded conduit, and filling abandoned conduit with waterproofing material. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "PP11-003",
         "APN": 46723022,
         "File Number": "PP11-003",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP11-003",
         "Application Type": "Not Specified",
         "Application Date": "1/13/11 16:56",
         "Status": "Complete ",
         "Description": "Public project exemption for the repair and filling of abandonded conduit at City Hall. Work includes sawcutting concrete to access abandonded conduit, and filling abandoned conduit with waterproofing material. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "PP11-003",
         "APN": 46723076,
         "File Number": "PP11-003",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP11-003",
         "Application Type": "Not Specified",
         "Application Date": "1/13/11 16:56",
         "Status": "Complete ",
         "Description": "Public project exemption for the repair and filling of abandonded conduit at City Hall. Work includes sawcutting concrete to access abandonded conduit, and filling abandoned conduit with waterproofing material. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "PP11-003",
         "APN": 46724001,
         "File Number": "PP11-003",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP11-003",
         "Application Type": "Not Specified",
         "Application Date": "1/13/11 16:56",
         "Status": "Complete ",
         "Description": "Public project exemption for the repair and filling of abandonded conduit at City Hall. Work includes sawcutting concrete to access abandonded conduit, and filling abandoned conduit with waterproofing material. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "PP11-003",
         "APN": 46724002,
         "File Number": "PP11-003",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP11-003",
         "Application Type": "Not Specified",
         "Application Date": "1/13/11 16:56",
         "Status": "Complete ",
         "Description": "Public project exemption for the repair and filling of abandonded conduit at City Hall. Work includes sawcutting concrete to access abandonded conduit, and filling abandoned conduit with waterproofing material. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "PP11-003",
         "APN": 46724003,
         "File Number": "PP11-003",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP11-003",
         "Application Type": "Not Specified",
         "Application Date": "1/13/11 16:56",
         "Status": "Complete ",
         "Description": "Public project exemption for the repair and filling of abandonded conduit at City Hall. Work includes sawcutting concrete to access abandonded conduit, and filling abandoned conduit with waterproofing material. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "PP11-003",
         "APN": 46724014,
         "File Number": "PP11-003",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP11-003",
         "Application Type": "Not Specified",
         "Application Date": "1/13/11 16:56",
         "Status": "Complete ",
         "Description": "Public project exemption for the repair and filling of abandonded conduit at City Hall. Work includes sawcutting concrete to access abandonded conduit, and filling abandoned conduit with waterproofing material. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "PP11-003",
         "APN": 46724015,
         "File Number": "PP11-003",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP11-003",
         "Application Type": "Not Specified",
         "Application Date": "1/13/11 16:56",
         "Status": "Complete ",
         "Description": "Public project exemption for the repair and filling of abandonded conduit at City Hall. Work includes sawcutting concrete to access abandonded conduit, and filling abandoned conduit with waterproofing material. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "PP11-003",
         "APN": 46724016,
         "File Number": "PP11-003",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP11-003",
         "Application Type": "Not Specified",
         "Application Date": "1/13/11 16:56",
         "Status": "Complete ",
         "Description": "Public project exemption for the repair and filling of abandonded conduit at City Hall. Work includes sawcutting concrete to access abandonded conduit, and filling abandoned conduit with waterproofing material. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "PP11-003",
         "APN": 46724019,
         "File Number": "PP11-003",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP11-003",
         "Application Type": "Not Specified",
         "Application Date": "1/13/11 16:56",
         "Status": "Complete ",
         "Description": "Public project exemption for the repair and filling of abandonded conduit at City Hall. Work includes sawcutting concrete to access abandonded conduit, and filling abandoned conduit with waterproofing material. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "PP11-003",
         "APN": 46724020,
         "File Number": "PP11-003",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP11-003",
         "Application Type": "Not Specified",
         "Application Date": "1/13/11 16:56",
         "Status": "Complete ",
         "Description": "Public project exemption for the repair and filling of abandonded conduit at City Hall. Work includes sawcutting concrete to access abandonded conduit, and filling abandoned conduit with waterproofing material. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "PP11-003",
         "APN": 46724021,
         "File Number": "PP11-003",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP11-003",
         "Application Type": "Not Specified",
         "Application Date": "1/13/11 16:56",
         "Status": "Complete ",
         "Description": "Public project exemption for the repair and filling of abandonded conduit at City Hall. Work includes sawcutting concrete to access abandonded conduit, and filling abandoned conduit with waterproofing material. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "PP11-003",
         "APN": 46724115,
         "File Number": "PP11-003",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP11-003",
         "Application Type": "Not Specified",
         "Application Date": "1/13/11 16:56",
         "Status": "Complete ",
         "Description": "Public project exemption for the repair and filling of abandonded conduit at City Hall. Work includes sawcutting concrete to access abandonded conduit, and filling abandoned conduit with waterproofing material. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "PP11-003",
         "APN": 46724117,
         "File Number": "PP11-003",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PP11-003",
         "Application Type": "Not Specified",
         "Application Date": "1/13/11 16:56",
         "Status": "Complete ",
         "Description": "Public project exemption for the repair and filling of abandonded conduit at City Hall. Work includes sawcutting concrete to access abandonded conduit, and filling abandoned conduit with waterproofing material. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "PP08-014",
         "APN": 47211009,
         "File Number": "PP08-014",
         "Address": "0 SAN JOSE",
         "Project Name": "Coyote Creek Trail Master Plan (Story Rd. to Selma Olinder Park) PP08-014",
         "Application Type": "Not Specified",
         "Application Date": "3/19/15",
         "Status": "New ",
         "Description": "The proposed trail work will take place within the following parcels: 472-11-09, 472-11-055, 472-11-085, 472-33-011, 472-11-003, 472-11-054, between Story Road and Selma Olinder Park in San Jose. The project is an approximately ¾ mile long segment, running along the eastern banks of Coyote Creek. The proposed trail is bounded on the south by the intersection of Story Road and Remillard Court, and runs north under Highway 280 to Selma Olinder Park.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "PP08-014",
         "APN": 47233011,
         "File Number": "PP08-014",
         "Address": "0 SAN JOSE",
         "Project Name": "Coyote Creek Trail Master Plan (Story Rd. to Selma Olinder Park) PP08-014",
         "Application Type": "Not Specified",
         "Application Date": "3/19/15",
         "Status": "New ",
         "Description": "The proposed trail work will take place within the following parcels: 472-11-09, 472-11-055, 472-11-085, 472-33-011, 472-11-003, 472-11-054, between Story Road and Selma Olinder Park in San Jose. The project is an approximately ¾ mile long segment, running along the eastern banks of Coyote Creek. The proposed trail is bounded on the south by the intersection of Story Road and Remillard Court, and runs north under Highway 280 to Selma Olinder Park.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "RCP02-003",
         "APN": 46722031,
         "File Number": "RCP02-003",
         "Address": "85 S 2ND ST SAN JOSE",
         "Project Name": "RCP02-003, San Jose Bar & Grill",
         "Application Type": "Not Specified",
         "Application Date": "12/14/06",
         "Status": "New ",
         "Description": " ",
         "Planner": "Judie Gilli/Amie Glaser ",
         "DURATION": 0,
         "Year": 2006
      },
      {
         "PERMITID": "RCP03-013",
         "APN": 26429118,
         "File Number": "RCP03-013",
         "Address": " ",
         "Project Name": "RCP03-013, The Agenda Restaurant",
         "Application Type": "Not Specified",
         "Application Date": "1/4/06",
         "Status": "New ",
         "Description": " ",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2006
      },
      {
         "PERMITID": "3-03401",
         "APN": 25939116,
         "File Number": "3-03401",
         "Address": "333 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "SJ-2019-004 Adobe North Tower",
         "Application Type": "Not Specified",
         "Application Date": "4/9/19",
         "Status": "Under Review ",
         "Description": "Habitat Plan Clearance (Nitrogen Deposition Only) for the demolition of an existing 30,659-square foot building (already demolished), and the construction of a new 1,513,941-square foot 18-story building with up to 700,000 square feet of office and retail uses on a 2.50-gross acre site. The new building would include five floors of below-grade parking, five floors of above-grade parking, 8,132 square feet of ground-floor retail, and 690,328 square feet of office on floors 6 through 18.",
         "Planner": "Ruth Cueto ",
         "DURATION": 0,
         "Year": 2019
      },
      {
         "PERMITID": "3-03401",
         "APN": 25939118,
         "File Number": "3-03401",
         "Address": "333 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "SJ-2019-004 Adobe North Tower",
         "Application Type": "Not Specified",
         "Application Date": "4/9/19",
         "Status": "Under Review ",
         "Description": "Habitat Plan Clearance (Nitrogen Deposition Only) for the demolition of an existing 30,659-square foot building (already demolished), and the construction of a new 1,513,941-square foot 18-story building with up to 700,000 square feet of office and retail uses on a 2.50-gross acre site. The new building would include five floors of below-grade parking, five floors of above-grade parking, 8,132 square feet of ground-floor retail, and 690,328 square feet of office on floors 6 through 18.",
         "Planner": "Ruth Cueto ",
         "DURATION": 0,
         "Year": 2019
      },
      {
         "PERMITID": "PP13-106",
         "APN": 26415034,
         "File Number": "PP13-106",
         "Address": " ",
         "Project Name": "PP13-106 Los Gatos Creek Trail - Reach 5",
         "Application Type": "Not Specified",
         "Application Date": "12/5/13 15:03",
         "Status": "Under Review ",
         "Description": "Proposed trail beneath bridge with active railroad commuter traffic and City street below the top of bank. CEQA/NEPA ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "V95-014",
         "APN": 46724055,
         "File Number": "V95-014",
         "Address": "347 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "V95-014",
         "Application Type": "Not Specified",
         "Application Date": "5/8/95",
         "Status": "Withdrawn ",
         "Description": "File type: *Other apns: *Gen.Use Class:*Existing Land Use:01*Specific Use:PARKING",
         "Planner": "JPRANDI ",
         "DURATION": 0,
         "Year": 1995
      }
   ],
   "Parking Analysis ": [
      {
         "PERMITID": "PA09-006",
         "APN": 46724038,
         "File Number": "PA09-006",
         "Address": "314 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PA09-006",
         "Application Type": "Parking Analysis ",
         "Application Date": "1/16/09",
         "Status": "Approved ",
         "Description": "Parking analysis for 2 display areas mandated by DMV for the issue of auto sales license to the applicant.",
         "Planner": "Lee Butler ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PA09-013",
         "APN": 47227010,
         "File Number": "PA09-013",
         "Address": "599 S 4TH ST SAN JOSE",
         "Project Name": "PA09-013",
         "Application Type": "Parking Analysis ",
         "Application Date": "2/24/09",
         "Status": "Approved ",
         "Description": "Parking Analysis for an existing retail store (812 gross square feet) to add food preparation for take-out only with five (5) off-street parking spaces.",
         "Planner": "Lee Butler ",
         "DURATION": 0,
         "Year": 2009
      }
   ],
   "PD Permit ": [
      {
         "PERMITID": "PD01-001",
         "APN": 24946089,
         "File Number": "PD01-001",
         "Address": "380 N 4TH ST SAN JOSE",
         "Project Name": "PD01-001",
         "Application Type": "PD Permit ",
         "Application Date": "1/3/01 15:35",
         "Status": "Approved ",
         "Description": "Planned Development Permit for the relocation of six historic single family detached residences on a 0.537 gross acre site.",
         "Planner": "Akoni Danielsen ",
         "DURATION": 6822,
         "Year": 2001
      },
      {
         "PERMITID": "PD01-001",
         "APN": 24946090,
         "File Number": "PD01-001",
         "Address": "380 N 4TH ST SAN JOSE",
         "Project Name": "PD01-001",
         "Application Type": "PD Permit ",
         "Application Date": "1/3/01 15:35",
         "Status": "Approved ",
         "Description": "Planned Development Permit for the relocation of six historic single family detached residences on a 0.537 gross acre site.",
         "Planner": "Akoni Danielsen ",
         "DURATION": 6822,
         "Year": 2001
      },
      {
         "PERMITID": "PD01-001",
         "APN": 24946092,
         "File Number": "PD01-001",
         "Address": "380 N 4TH ST SAN JOSE",
         "Project Name": "PD01-001",
         "Application Type": "PD Permit ",
         "Application Date": "1/3/01 15:35",
         "Status": "Approved ",
         "Description": "Planned Development Permit for the relocation of six historic single family detached residences on a 0.537 gross acre site.",
         "Planner": "Akoni Danielsen ",
         "DURATION": 6822,
         "Year": 2001
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245001,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245002,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245003,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245004,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245005,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245006,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245008,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245009,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245010,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245011,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245012,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245013,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245014,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245015,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245016,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245017,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245018,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245019,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245020,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245021,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245022,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245023,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245025,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245027,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245028,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245029,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245030,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245031,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245032,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245033,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245034,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245035,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245037,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245038,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245039,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245042,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245043,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245044,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245046,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245047,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245048,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245049,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245050,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245053,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245054,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245055,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245056,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245059,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245064,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245065,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245066,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245067,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245069,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245071,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245072,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245073,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD02-044",
         "APN": 47245074,
         "File Number": "PD02-044",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PD02-044 - The Works by Swenson",
         "Application Type": "PD Permit ",
         "Application Date": "6/21/02",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 74 single-family attached residences (condominiums) on a 1.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 223,
         "Year": 2002
      },
      {
         "PERMITID": "PD03-069",
         "APN": 26420132,
         "File Number": "PD03-069",
         "Address": "598 W SAN CARLOS ST SAN JOSE",
         "Project Name": "PD03-069",
         "Application Type": "PD Permit ",
         "Application Date": "10/22/03",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 123 multi-family attached residences and 5,500 square feet of retail and commercial space on a 0.8 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "PD04-014",
         "APN": 47223124,
         "File Number": "PD04-014",
         "Address": "671 S 11TH ST SAN JOSE",
         "Project Name": "PD04-014",
         "Application Type": "PD Permit ",
         "Application Date": "3/9/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 2 single-family attached/paired residences on a 0.14 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 173,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-014",
         "APN": 47223125,
         "File Number": "PD04-014",
         "Address": "671 S 11TH ST SAN JOSE",
         "Project Name": "PD04-014",
         "Application Type": "PD Permit ",
         "Application Date": "3/9/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to construct 2 single-family attached/paired residences on a 0.14 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 173,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-053",
         "APN": 47221104,
         "File Number": "PD04-053",
         "Address": "9645 TRACT SAN JOSE",
         "Project Name": "PD04-053",
         "Application Type": "PD Permit ",
         "Application Date": "7/15/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to demolish the structures to be removed; remove existing hardscape and landscaping; remove/replace curb, gutter, sidewalk, and road surface as needed; construct on-site utilities and off-site improvements; and grading on a 8.6 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 215,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-053",
         "APN": 47222060,
         "File Number": "PD04-053",
         "Address": "9645 TRACT SAN JOSE",
         "Project Name": "PD04-053",
         "Application Type": "PD Permit ",
         "Application Date": "7/15/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to demolish the structures to be removed; remove existing hardscape and landscaping; remove/replace curb, gutter, sidewalk, and road surface as needed; construct on-site utilities and off-site improvements; and grading on a 8.6 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 215,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-053",
         "APN": 47222062,
         "File Number": "PD04-053",
         "Address": "9645 TRACT SAN JOSE",
         "Project Name": "PD04-053",
         "Application Type": "PD Permit ",
         "Application Date": "7/15/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to demolish the structures to be removed; remove existing hardscape and landscaping; remove/replace curb, gutter, sidewalk, and road surface as needed; construct on-site utilities and off-site improvements; and grading on a 8.6 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 215,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-053",
         "APN": 47241050,
         "File Number": "PD04-053",
         "Address": "9645 TRACT SAN JOSE",
         "Project Name": "PD04-053",
         "Application Type": "PD Permit ",
         "Application Date": "7/15/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to demolish the structures to be removed; remove existing hardscape and landscaping; remove/replace curb, gutter, sidewalk, and road surface as needed; construct on-site utilities and off-site improvements; and grading on a 8.6 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 215,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-053",
         "APN": 47241051,
         "File Number": "PD04-053",
         "Address": "9645 TRACT SAN JOSE",
         "Project Name": "PD04-053",
         "Application Type": "PD Permit ",
         "Application Date": "7/15/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to demolish the structures to be removed; remove existing hardscape and landscaping; remove/replace curb, gutter, sidewalk, and road surface as needed; construct on-site utilities and off-site improvements; and grading on a 8.6 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 215,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952002,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952003,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952004,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952006,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952008,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952009,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952010,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952012,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952013,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952014,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952015,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952018,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952019,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952022,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952023,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952024,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952025,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952026,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952027,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952028,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952029,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952030,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952031,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952033,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952038,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952039,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952041,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952042,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952043,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952044,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952045,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952046,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952047,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952048,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952049,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952050,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952051,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952054,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952055,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952056,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952057,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952058,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952060,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952061,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952062,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952066,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952069,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952071,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952073,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952075,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952077,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952080,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952081,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952082,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952083,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952085,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952091,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952093,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952094,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952095,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952098,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952099,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952196,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952197,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952198,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952200,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-066",
         "APN": 25952206,
         "File Number": "PD04-066",
         "Address": "9378 TRACT SAN JOSE",
         "Project Name": "PD04-066",
         "Application Type": "PD Permit ",
         "Application Date": "9/1/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow existing 1,050 square feet of ground floor space for commercial uses on a 1.77 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 174,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-080",
         "APN": 25938039,
         "File Number": "PD04-080",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "PD04-080",
         "Application Type": "PD Permit ",
         "Application Date": "11/4/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to demolish an existing single-family house and allow for use as temporary parking lot on a 0.19 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 103,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-080",
         "APN": 25938041,
         "File Number": "PD04-080",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "PD04-080",
         "Application Type": "PD Permit ",
         "Application Date": "11/4/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to demolish an existing single-family house and allow for use as temporary parking lot on a 0.19 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 103,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-080",
         "APN": 25938042,
         "File Number": "PD04-080",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "PD04-080",
         "Application Type": "PD Permit ",
         "Application Date": "11/4/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to demolish an existing single-family house and allow for use as temporary parking lot on a 0.19 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 103,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-080",
         "APN": 25938109,
         "File Number": "PD04-080",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "PD04-080",
         "Application Type": "PD Permit ",
         "Application Date": "11/4/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to demolish an existing single-family house and allow for use as temporary parking lot on a 0.19 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 103,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-080",
         "APN": 25938110,
         "File Number": "PD04-080",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "PD04-080",
         "Application Type": "PD Permit ",
         "Application Date": "11/4/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to demolish an existing single-family house and allow for use as temporary parking lot on a 0.19 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 103,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-080",
         "APN": 25938128,
         "File Number": "PD04-080",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "PD04-080",
         "Application Type": "PD Permit ",
         "Application Date": "11/4/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to demolish an existing single-family house and allow for use as temporary parking lot on a 0.19 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 103,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-080",
         "APN": 25938145,
         "File Number": "PD04-080",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "PD04-080",
         "Application Type": "PD Permit ",
         "Application Date": "11/4/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to demolish an existing single-family house and allow for use as temporary parking lot on a 0.19 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 103,
         "Year": 2004
      },
      {
         "PERMITID": "PD04-080",
         "APN": 25938146,
         "File Number": "PD04-080",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "PD04-080",
         "Application Type": "PD Permit ",
         "Application Date": "11/4/04",
         "Status": "Approved ",
         "Description": "Planned Development Permit to demolish an existing single-family house and allow for use as temporary parking lot on a 0.19 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 103,
         "Year": 2004
      },
      {
         "PERMITID": "PD08-024",
         "APN": 46701034,
         "File Number": "PD08-024",
         "Address": "237 N 4TH ST SAN JOSE",
         "Project Name": "PD08-024 - Two Live Work Units on 4th Street",
         "Application Type": "PD Permit ",
         "Application Date": "3/19/08",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow construction of two live/work units on a 0.08 gross acre site",
         "Planner": "Licinia McMorrow ",
         "DURATION": 147,
         "Year": 2008
      },
      {
         "PERMITID": "PD09-020",
         "APN": 26420121,
         "File Number": "PD09-020",
         "Address": "395 BIRD AV SAN JOSE",
         "Project Name": "PD09-020 - Chevron",
         "Application Type": "PD Permit ",
         "Application Date": "6/3/09",
         "Status": "Approved ",
         "Description": "Planned Development Permit to demolish an existing gas station building and construct a new mini-mart, car wash and office building on a 0.6 gross acre site",
         "Planner": "Licinia McMorrow ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PD13-013",
         "APN": 47222091,
         "File Number": "PD13-013",
         "Address": "595 MARGARET ST SAN JOSE",
         "Project Name": "PD13-013",
         "Application Type": "PD Permit ",
         "Application Date": "3/19/13",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow for the construction of two detached two-story single family homes on a 0.21 acre lot in the R-1-8(PD) Planned Development District",
         "Planner": "Licinia McMorrow ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "PD13-013",
         "APN": 47222092,
         "File Number": "PD13-013",
         "Address": "595 MARGARET ST SAN JOSE",
         "Project Name": "PD13-013",
         "Application Type": "PD Permit ",
         "Application Date": "3/19/13",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow for the construction of two detached two-story single family homes on a 0.21 acre lot in the R-1-8(PD) Planned Development District",
         "Planner": "Licinia McMorrow ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "PD13-016",
         "APN": 47228054,
         "File Number": "PD13-016",
         "Address": "346 E WILLIAM ST SAN JOSE",
         "Project Name": "PD13-016",
         "Application Type": "PD Permit ",
         "Application Date": "4/23/13",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow the demolition of two single-family detached residences and a restaurant, to permit the removal of three ordinance-sized trees, and to permit the construct 28 multi-family attached residences with 1,780 square feet of ground floor retail on a 0.57 gross acre site.",
         "Planner": "Lea Simvoulakis ",
         "DURATION": 830,
         "Year": 2013
      },
      {
         "PERMITID": "PD14-052",
         "APN": 46701120,
         "File Number": "PD14-052",
         "Address": "298 N 4TH ST SAN JOSE",
         "Project Name": "PD14-052",
         "Application Type": "PD Permit ",
         "Application Date": "11/7/14 11:31",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow the construction of 12 residential units and approximately 1,403 square feet of commercial space on a 0.44 gross acre site",
         "Planner": "Lea Simvoulakis ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "PD15-042",
         "APN": 25947068,
         "File Number": "PD15-042",
         "Address": "565 LORRAINE AV SAN JOSE",
         "Project Name": "PD15-042 - Montgomery 7 Residential Apartments",
         "Application Type": "PD Permit ",
         "Application Date": "9/11/15",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow a 10-story mixed use building that includes approximately 1,856 square feet of ground floor commercial space and up to 54 residential units on an approximately 0.10 gross acre site.",
         "Planner": "Lea Simvoulakis ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "PD15-061",
         "APN": 25938039,
         "File Number": "PD15-061",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "PD15-061 - Diridon TOD/SJ Water Co./Delmas Ave",
         "Application Type": "PD Permit ",
         "Application Date": "12/4/15 11:08",
         "Status": "Approved ",
         "Description": "A Planned Development Permit to allow the construction of a mixed use development with up to 1.04 million square feet for office/retail and up to 325 multi-family attached residences on a 8.93 gross acre site.",
         "Planner": "Lea Simvoulakis ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "PD15-061",
         "APN": 25938041,
         "File Number": "PD15-061",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "PD15-061 - Diridon TOD/SJ Water Co./Delmas Ave",
         "Application Type": "PD Permit ",
         "Application Date": "12/4/15 11:08",
         "Status": "Approved ",
         "Description": "A Planned Development Permit to allow the construction of a mixed use development with up to 1.04 million square feet for office/retail and up to 325 multi-family attached residences on a 8.93 gross acre site.",
         "Planner": "Lea Simvoulakis ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "PD15-061",
         "APN": 25938109,
         "File Number": "PD15-061",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "PD15-061 - Diridon TOD/SJ Water Co./Delmas Ave",
         "Application Type": "PD Permit ",
         "Application Date": "12/4/15 11:08",
         "Status": "Approved ",
         "Description": "A Planned Development Permit to allow the construction of a mixed use development with up to 1.04 million square feet for office/retail and up to 325 multi-family attached residences on a 8.93 gross acre site.",
         "Planner": "Lea Simvoulakis ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "PD15-061",
         "APN": 25938110,
         "File Number": "PD15-061",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "PD15-061 - Diridon TOD/SJ Water Co./Delmas Ave",
         "Application Type": "PD Permit ",
         "Application Date": "12/4/15 11:08",
         "Status": "Approved ",
         "Description": "A Planned Development Permit to allow the construction of a mixed use development with up to 1.04 million square feet for office/retail and up to 325 multi-family attached residences on a 8.93 gross acre site.",
         "Planner": "Lea Simvoulakis ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "PD15-061",
         "APN": 25938128,
         "File Number": "PD15-061",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "PD15-061 - Diridon TOD/SJ Water Co./Delmas Ave",
         "Application Type": "PD Permit ",
         "Application Date": "12/4/15 11:08",
         "Status": "Approved ",
         "Description": "A Planned Development Permit to allow the construction of a mixed use development with up to 1.04 million square feet for office/retail and up to 325 multi-family attached residences on a 8.93 gross acre site.",
         "Planner": "Lea Simvoulakis ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "PD15-061",
         "APN": 25938145,
         "File Number": "PD15-061",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "PD15-061 - Diridon TOD/SJ Water Co./Delmas Ave",
         "Application Type": "PD Permit ",
         "Application Date": "12/4/15 11:08",
         "Status": "Approved ",
         "Description": "A Planned Development Permit to allow the construction of a mixed use development with up to 1.04 million square feet for office/retail and up to 325 multi-family attached residences on a 8.93 gross acre site.",
         "Planner": "Lea Simvoulakis ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "PD79-041",
         "APN": 24944057,
         "File Number": "PD79-041",
         "Address": "31 E JULIAN ST SAN JOSE",
         "Project Name": "PD79-041",
         "Application Type": "PD Permit ",
         "Application Date": "5/31/79",
         "Status": "Approved ",
         "Description": "Other APNs:/259-33-032 THRU 033",
         "Planner": "Vic Mendez ",
         "DURATION": 0,
         "Year": 1979
      },
      {
         "PERMITID": "PD80-065",
         "APN": 47220106,
         "File Number": "PD80-065",
         "Address": "868 S 10TH ST SAN JOSE",
         "Project Name": "PD80-065",
         "Application Type": "PD Permit ",
         "Application Date": "7/25/80",
         "Status": "Approved ",
         "Description": "File type: *Other apns: *Gen.Use Class:COMMERCIAL*Existing Land Use:69*Specific Use:MINI-STORAGE",
         "Planner": "Vic Mendez ",
         "DURATION": 0,
         "Year": 1980
      },
      {
         "PERMITID": "PD86-049",
         "APN": 46719075,
         "File Number": "PD86-049",
         "Address": "235 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PD86-049",
         "Application Type": "PD Permit ",
         "Application Date": "8/14/86",
         "Status": "Approved ",
         "Description": "PC40877=16DUS",
         "Planner": "Nancy Hemmen ",
         "DURATION": 0,
         "Year": 1986
      },
      {
         "PERMITID": "PD87-018",
         "APN": 24944057,
         "File Number": "PD87-018",
         "Address": "31 E JULIAN ST SAN JOSE",
         "Project Name": "PD87-018",
         "Application Type": "PD Permit ",
         "Application Date": "2/25/87",
         "Status": "Approved ",
         "Description": "REWRITE PERMIT ONLY!; Other APNs:,058",
         "Planner": "MWHITNEY ",
         "DURATION": 0,
         "Year": 1987
      },
      {
         "PERMITID": "PD87-068",
         "APN": 46724062,
         "File Number": "PD87-068",
         "Address": " ",
         "Project Name": "PD87-068",
         "Application Type": "PD Permit ",
         "Application Date": "9/16/87",
         "Status": "Approved ",
         "Description": "File type: *Other apns: *Gen.Use Class:*Existing Land Use:59*Specific Use:COMM. CTR.",
         "Planner": "MWHITNEY ",
         "DURATION": 0,
         "Year": 1987
      },
      {
         "PERMITID": "PD87-079",
         "APN": 46702125,
         "File Number": "PD87-079",
         "Address": "276 N 7TH ST SAN JOSE",
         "Project Name": "PD87-079",
         "Application Type": "PD Permit ",
         "Application Date": "11/12/87",
         "Status": "Approved ",
         "Description": "PC43630=3DUS",
         "Planner": "MWHITNEY ",
         "DURATION": 0,
         "Year": 1987
      },
      {
         "PERMITID": "PD87-079",
         "APN": 46702126,
         "File Number": "PD87-079",
         "Address": "276 N 7TH ST SAN JOSE",
         "Project Name": "PD87-079",
         "Application Type": "PD Permit ",
         "Application Date": "11/12/87",
         "Status": "Approved ",
         "Description": "PC43630=3DUS",
         "Planner": "MWHITNEY ",
         "DURATION": 0,
         "Year": 1987
      },
      {
         "PERMITID": "PD87-079",
         "APN": 46702127,
         "File Number": "PD87-079",
         "Address": "276 N 7TH ST SAN JOSE",
         "Project Name": "PD87-079",
         "Application Type": "PD Permit ",
         "Application Date": "11/12/87",
         "Status": "Approved ",
         "Description": "PC43630=3DUS",
         "Planner": "MWHITNEY ",
         "DURATION": 0,
         "Year": 1987
      },
      {
         "PERMITID": "PD87-086",
         "APN": 46719075,
         "File Number": "PD87-086",
         "Address": "235 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PD87-086",
         "Application Type": "PD Permit ",
         "Application Date": "12/11/87",
         "Status": "Approved ",
         "Description": "PC45808=16DUS",
         "Planner": "CPAINTER ",
         "DURATION": 0,
         "Year": 1987
      },
      {
         "PERMITID": "PD87-086",
         "APN": 46757083,
         "File Number": "PD87-086",
         "Address": "235 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PD87-086",
         "Application Type": "PD Permit ",
         "Application Date": "12/11/87",
         "Status": "Approved ",
         "Description": "PC45808=16DUS",
         "Planner": "CPAINTER ",
         "DURATION": 0,
         "Year": 1987
      },
      {
         "PERMITID": "PD91-058",
         "APN": 24950083,
         "File Number": "PD91-058",
         "Address": "345 E JULIAN ST SAN JOSE",
         "Project Name": "PD91-058",
         "Application Type": "PD Permit ",
         "Application Date": "12/16/91",
         "Status": "Approved ",
         "Description": "PC9201856=9DU",
         "Planner": "Jeff Roche ",
         "DURATION": 0,
         "Year": 1991
      },
      {
         "PERMITID": "PD93-002",
         "APN": 24946090,
         "File Number": "PD93-002",
         "Address": "380 N 4TH ST SAN JOSE",
         "Project Name": "PD93-002",
         "Application Type": "PD Permit ",
         "Application Date": "1/28/93",
         "Status": "Approved ",
         "Description": "File type: *Other apns: *Gen.Use Class:*Existing Land Use:69*Specific Use:5 MFA",
         "Planner": "Mike Enderby ",
         "DURATION": 0,
         "Year": 1993
      },
      {
         "PERMITID": "PD93-002",
         "APN": 24946092,
         "File Number": "PD93-002",
         "Address": "380 N 4TH ST SAN JOSE",
         "Project Name": "PD93-002",
         "Application Type": "PD Permit ",
         "Application Date": "1/28/93",
         "Status": "Approved ",
         "Description": "File type: *Other apns: *Gen.Use Class:*Existing Land Use:69*Specific Use:5 MFA",
         "Planner": "Mike Enderby ",
         "DURATION": 0,
         "Year": 1993
      },
      {
         "PERMITID": "PDA08-029-01",
         "APN": 47218063,
         "File Number": "PDA08-029-01",
         "Address": "9750 TRACT SAN JOSE",
         "Project Name": "PDA08-029-01 -Virginia Terrace",
         "Application Type": "PD Permit ",
         "Application Date": "9/13/12",
         "Status": "Approved ",
         "Description": "Planned Development Permit Amendment to allow site and architectural modifications to a previously approved Planned Devlopment Permit (File No. PD 08-029) that allowed up to 238 multi-family residential units in the A(PD) Planned Development Zoning District on 3.87 gross acre site.",
         "Planner": "Jeff Roche ",
         "DURATION": 228,
         "Year": 2012
      },
      {
         "PERMITID": "RPD01-001",
         "APN": 46722137,
         "File Number": "RPD01-001",
         "Address": " ",
         "Project Name": "RPD01-001, Improv/Jose Theater",
         "Application Type": "PD Permit ",
         "Application Date": "11/7/01",
         "Status": "Approved ",
         "Description": "Restaurant/theater/comedy showcase ",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "RPD96-002",
         "APN": 25943075,
         "File Number": "RPD96-002",
         "Address": " ",
         "Project Name": "RPD96-002, River Park Towers",
         "Application Type": "PD Permit ",
         "Application Date": "12/6/96",
         "Status": "Approved ",
         "Description": "Reconstruction of public sidewalk in front of office building. ",
         "Planner": "Kristi Ashburn ",
         "DURATION": 0,
         "Year": 1996
      },
      {
         "PERMITID": "RPD97-001",
         "APN": 46723096,
         "File Number": "RPD97-001",
         "Address": "0 LAND ONLY SAN JOSE",
         "Project Name": "RPD97-001, Paseo Villas",
         "Application Type": "PD Permit ",
         "Application Date": "5/22/97",
         "Status": "Approved ",
         "Description": "Construction of a mixed-use development including up to 104 residential condominium units, parking, and 8,780 squre feet of retail.",
         "Planner": "Julie Schaer ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RPD97-002",
         "APN": 25940017,
         "File Number": "RPD97-002",
         "Address": " ",
         "Project Name": "RPD97-002, 101 San Fernando Apts.",
         "Application Type": "PD Permit ",
         "Application Date": "11/20/97",
         "Status": "Approved ",
         "Description": "Construction of 316 multi-family units with 10,500 sq. ft. of commercial uses and two levels of below grade parking. (A subsequent permit, RPD98-12-005, was issued to add additional units to property.)",
         "Planner": "Dennis Korabiak ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RPD97-002",
         "APN": 25940018,
         "File Number": "RPD97-002",
         "Address": " ",
         "Project Name": "RPD97-002, 101 San Fernando Apts.",
         "Application Type": "PD Permit ",
         "Application Date": "11/20/97",
         "Status": "Approved ",
         "Description": "Construction of 316 multi-family units with 10,500 sq. ft. of commercial uses and two levels of below grade parking. (A subsequent permit, RPD98-12-005, was issued to add additional units to property.)",
         "Planner": "Dennis Korabiak ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RPD97-002",
         "APN": 25940019,
         "File Number": "RPD97-002",
         "Address": " ",
         "Project Name": "RPD97-002, 101 San Fernando Apts.",
         "Application Type": "PD Permit ",
         "Application Date": "11/20/97",
         "Status": "Approved ",
         "Description": "Construction of 316 multi-family units with 10,500 sq. ft. of commercial uses and two levels of below grade parking. (A subsequent permit, RPD98-12-005, was issued to add additional units to property.)",
         "Planner": "Dennis Korabiak ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RPD97-002",
         "APN": 25940071,
         "File Number": "RPD97-002",
         "Address": " ",
         "Project Name": "RPD97-002, 101 San Fernando Apts.",
         "Application Type": "PD Permit ",
         "Application Date": "11/20/97",
         "Status": "Approved ",
         "Description": "Construction of 316 multi-family units with 10,500 sq. ft. of commercial uses and two levels of below grade parking. (A subsequent permit, RPD98-12-005, was issued to add additional units to property.)",
         "Planner": "Dennis Korabiak ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RPD98-001",
         "APN": 46722137,
         "File Number": "RPD98-001",
         "Address": " ",
         "Project Name": "RPD98-001, Century Center",
         "Application Type": "PD Permit ",
         "Application Date": "1/15/98",
         "Status": "Approved ",
         "Description": "Demolition of 4 contributing structures within Downtown Commercial Historic District, rehabilitation of facade/lobby of Jose Theater city landmark, new construction of 89 residential units, approx. 16,464 sq. ft. of retail space and underground parking.",
         "Planner": "Dennis Korabiak ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "RPD98-005",
         "APN": 25940017,
         "File Number": "RPD98-005",
         "Address": " ",
         "Project Name": "RPD98-005, 101 San Fernando Apts.",
         "Application Type": "PD Permit ",
         "Application Date": "12/11/98",
         "Status": "Approved ",
         "Description": "326 Multi-family units - adding additional units to previously approved RPD97-11-02 permit - construct up to 323 multi-family attached dwelling units, 10,500 sq. ft. of commercial uses and two level below grade parking.",
         "Planner": "Dennis Korabiak ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "RPD98-005",
         "APN": 25940018,
         "File Number": "RPD98-005",
         "Address": " ",
         "Project Name": "RPD98-005, 101 San Fernando Apts.",
         "Application Type": "PD Permit ",
         "Application Date": "12/11/98",
         "Status": "Approved ",
         "Description": "326 Multi-family units - adding additional units to previously approved RPD97-11-02 permit - construct up to 323 multi-family attached dwelling units, 10,500 sq. ft. of commercial uses and two level below grade parking.",
         "Planner": "Dennis Korabiak ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "RPD98-005",
         "APN": 25940019,
         "File Number": "RPD98-005",
         "Address": " ",
         "Project Name": "RPD98-005, 101 San Fernando Apts.",
         "Application Type": "PD Permit ",
         "Application Date": "12/11/98",
         "Status": "Approved ",
         "Description": "326 Multi-family units - adding additional units to previously approved RPD97-11-02 permit - construct up to 323 multi-family attached dwelling units, 10,500 sq. ft. of commercial uses and two level below grade parking.",
         "Planner": "Dennis Korabiak ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "RPD98-005",
         "APN": 25940070,
         "File Number": "RPD98-005",
         "Address": " ",
         "Project Name": "RPD98-005, 101 San Fernando Apts.",
         "Application Type": "PD Permit ",
         "Application Date": "12/11/98",
         "Status": "Approved ",
         "Description": "326 Multi-family units - adding additional units to previously approved RPD97-11-02 permit - construct up to 323 multi-family attached dwelling units, 10,500 sq. ft. of commercial uses and two level below grade parking.",
         "Planner": "Dennis Korabiak ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "RPD98-005",
         "APN": 25940071,
         "File Number": "RPD98-005",
         "Address": " ",
         "Project Name": "RPD98-005, 101 San Fernando Apts.",
         "Application Type": "PD Permit ",
         "Application Date": "12/11/98",
         "Status": "Approved ",
         "Description": "326 Multi-family units - adding additional units to previously approved RPD97-11-02 permit - construct up to 323 multi-family attached dwelling units, 10,500 sq. ft. of commercial uses and two level below grade parking.",
         "Planner": "Dennis Korabiak ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "PD86-012",
         "APN": 24944057,
         "File Number": "PD86-012",
         "Address": "31 E JULIAN ST SAN JOSE",
         "Project Name": "PD86-012",
         "Application Type": "PD Permit ",
         "Application Date": "2/14/86",
         "Status": "Expired ",
         "Description": "PERMIT NOT ACCEPTED; Other APNs:058",
         "Planner": "MWHITNEY ",
         "DURATION": 0,
         "Year": 1986
      },
      {
         "PERMITID": "PD17-003",
         "APN": 47217042,
         "File Number": "PD17-003",
         "Address": "895 S 2ND ST SAN JOSE",
         "Project Name": "PD17-003",
         "Application Type": "PD Permit ",
         "Application Date": "2/10/17 10:11",
         "Status": "Recomd Approval ",
         "Description": "Planned Development Permit to allow the construction of three single-family attached townhomes on a 0.20 gross acre site",
         "Planner": "Avril Baty ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "PD05-059",
         "APN": 46701034,
         "File Number": "PD05-059",
         "Address": "237 N 4TH ST SAN JOSE",
         "Project Name": "PD05-059",
         "Application Type": "PD Permit ",
         "Application Date": "8/11/05",
         "Status": "Withdrawn ",
         "Description": "Planned Development Permit to relocate a Victorian house totaling approximately 1,787 sq.ft.) for office use on a 0.07 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 2989,
         "Year": 2005
      },
      {
         "PERMITID": "PD05-059",
         "APN": 46720021,
         "File Number": "PD05-059",
         "Address": "237 N 4TH ST SAN JOSE",
         "Project Name": "PD05-059",
         "Application Type": "PD Permit ",
         "Application Date": "8/11/05",
         "Status": "Withdrawn ",
         "Description": "Planned Development Permit to relocate a Victorian house totaling approximately 1,787 sq.ft.) for office use on a 0.07 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 2989,
         "Year": 2005
      },
      {
         "PERMITID": "PD16-003",
         "APN": 26420132,
         "File Number": "PD16-003",
         "Address": "350 BIRD AV SAN JOSE",
         "Project Name": "PD16-003",
         "Application Type": "PD Permit ",
         "Application Date": " ",
         "Status": "Withdrawn ",
         "Description": "Planned Development Permit to allow the off-sale of beer and wine at a For You Mini Mart, on a 0.8-gross acre site in the A(PD) Planned Development Zoning District",
         "Planner": "Avril Baty ",
         "DURATION": 1,
         "Year": null
      },
      {
         "PERMITID": "PD81-064",
         "APN": 24950083,
         "File Number": "PD81-064",
         "Address": "345 E JULIAN ST SAN JOSE",
         "Project Name": "PD81-064",
         "Application Type": "PD Permit ",
         "Application Date": "7/30/81",
         "Status": "Withdrawn ",
         "Description": "File type: *Other apns: *Gen.Use Class:*Existing Land Use:69*Specific Use:S/F ATT",
         "Planner": "CPAINTER ",
         "DURATION": 0,
         "Year": 1981
      },
      {
         "PERMITID": "PD98-037",
         "APN": 47217012,
         "File Number": "PD98-037",
         "Address": "760 S 1ST ST SAN JOSE",
         "Project Name": "PD98-037",
         "Application Type": "PD Permit ",
         "Application Date": "6/17/98",
         "Status": "Withdrawn ",
         "Description": "Planned Development Permit for a 42 unit, 24,175-square-foot motel on a 0.30 gross acre site",
         "Planner": "Akoni Danielsen ",
         "DURATION": 0,
         "Year": 1998
      }
   ],
   "PD Permit Amendment ": [
      {
         "PERMITID": "PDA03-069-01",
         "APN": 26420132,
         "File Number": "PDA03-069-01",
         "Address": "598 W SAN CARLOS ST SAN JOSE",
         "Project Name": "PDA03-069-01",
         "Application Type": "PD Permit Amendment ",
         "Application Date": "12/5/05",
         "Status": "Approved ",
         "Description": "Planned Development Permit Amendment to allow installation of a 60 hp standby/back-up generator for a multi-family residential project on a 0.8 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 78,
         "Year": 2005
      },
      {
         "PERMITID": "PDA14-052-01",
         "APN": 46701120,
         "File Number": "PDA14-052-01",
         "Address": "298 N 4TH ST SAN JOSE",
         "Project Name": "PDA14-052-01",
         "Application Type": "PD Permit Amendment ",
         "Application Date": "7/6/16 13:27",
         "Status": "Approved ",
         "Description": "Planned Development Permit to allow one (1) commercial condominium, approximately 1,403 square feet in size on a 0.43 gross acre site",
         "Planner": "David Fong ",
         "DURATION": 33,
         "Year": 2016
      },
      {
         "PERMITID": "PDA15-061-01",
         "APN": 25938039,
         "File Number": "PDA15-061-01",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "PDA15-061-01",
         "Application Type": "PD Permit Amendment ",
         "Application Date": "6/23/16",
         "Status": "Approved ",
         "Description": "Planned Development Permit Amendment to file number PD15-061 to allow up to 10 commercial condominiums on the office portion of the 8.93 gross acre site",
         "Planner": "John Tu ",
         "DURATION": 75,
         "Year": 2016
      },
      {
         "PERMITID": "PDA15-061-01",
         "APN": 25938041,
         "File Number": "PDA15-061-01",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "PDA15-061-01",
         "Application Type": "PD Permit Amendment ",
         "Application Date": "6/23/16",
         "Status": "Approved ",
         "Description": "Planned Development Permit Amendment to file number PD15-061 to allow up to 10 commercial condominiums on the office portion of the 8.93 gross acre site",
         "Planner": "John Tu ",
         "DURATION": 75,
         "Year": 2016
      },
      {
         "PERMITID": "PDA15-061-01",
         "APN": 25938109,
         "File Number": "PDA15-061-01",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "PDA15-061-01",
         "Application Type": "PD Permit Amendment ",
         "Application Date": "6/23/16",
         "Status": "Approved ",
         "Description": "Planned Development Permit Amendment to file number PD15-061 to allow up to 10 commercial condominiums on the office portion of the 8.93 gross acre site",
         "Planner": "John Tu ",
         "DURATION": 75,
         "Year": 2016
      },
      {
         "PERMITID": "PDA15-061-01",
         "APN": 25938110,
         "File Number": "PDA15-061-01",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "PDA15-061-01",
         "Application Type": "PD Permit Amendment ",
         "Application Date": "6/23/16",
         "Status": "Approved ",
         "Description": "Planned Development Permit Amendment to file number PD15-061 to allow up to 10 commercial condominiums on the office portion of the 8.93 gross acre site",
         "Planner": "John Tu ",
         "DURATION": 75,
         "Year": 2016
      },
      {
         "PERMITID": "PDA15-061-01",
         "APN": 25938128,
         "File Number": "PDA15-061-01",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "PDA15-061-01",
         "Application Type": "PD Permit Amendment ",
         "Application Date": "6/23/16",
         "Status": "Approved ",
         "Description": "Planned Development Permit Amendment to file number PD15-061 to allow up to 10 commercial condominiums on the office portion of the 8.93 gross acre site",
         "Planner": "John Tu ",
         "DURATION": 75,
         "Year": 2016
      },
      {
         "PERMITID": "PDA15-061-01",
         "APN": 25938145,
         "File Number": "PDA15-061-01",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "PDA15-061-01",
         "Application Type": "PD Permit Amendment ",
         "Application Date": "6/23/16",
         "Status": "Approved ",
         "Description": "Planned Development Permit Amendment to file number PD15-061 to allow up to 10 commercial condominiums on the office portion of the 8.93 gross acre site",
         "Planner": "John Tu ",
         "DURATION": 75,
         "Year": 2016
      },
      {
         "PERMITID": "PDA87-086-01",
         "APN": 46719075,
         "File Number": "PDA87-086-01",
         "Address": "235 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PDA87-086-01",
         "Application Type": "PD Permit Amendment ",
         "Application Date": "3/13/89",
         "Status": "Approved ",
         "Description": "MINOR CHANGES TO APPROVED RES. PROJECT ",
         "Planner": "Steve Moore ",
         "DURATION": 0,
         "Year": 1989
      },
      {
         "PERMITID": "PDA87-086-01",
         "APN": 46757083,
         "File Number": "PDA87-086-01",
         "Address": "235 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PDA87-086-01",
         "Application Type": "PD Permit Amendment ",
         "Application Date": "3/13/89",
         "Status": "Approved ",
         "Description": "MINOR CHANGES TO APPROVED RES. PROJECT ",
         "Planner": "Steve Moore ",
         "DURATION": 0,
         "Year": 1989
      },
      {
         "PERMITID": "PDA87-086-02",
         "APN": 46719075,
         "File Number": "PDA87-086-02",
         "Address": "235 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PDA87-086-02",
         "Application Type": "PD Permit Amendment ",
         "Application Date": "11/5/03",
         "Status": "Approved ",
         "Description": "Planned Development Permit Amendment to allow portion of the lot to be conveyed to future developer and allow off-site parking arrangement to an existing retail and residential building (Vintage Tower) on a 0.67 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 146,
         "Year": 2003
      },
      {
         "PERMITID": "PDA87-086-02",
         "APN": 46757083,
         "File Number": "PDA87-086-02",
         "Address": "235 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PDA87-086-02",
         "Application Type": "PD Permit Amendment ",
         "Application Date": "11/5/03",
         "Status": "Approved ",
         "Description": "Planned Development Permit Amendment to allow portion of the lot to be conveyed to future developer and allow off-site parking arrangement to an existing retail and residential building (Vintage Tower) on a 0.67 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 146,
         "Year": 2003
      },
      {
         "PERMITID": "RTR01-005",
         "APN": 47226091,
         "File Number": "RTR01-005",
         "Address": " ",
         "Project Name": "RTR01-005, Notre Dame High School",
         "Application Type": "PD Permit Amendment ",
         "Application Date": "5/14/01",
         "Status": "Approved ",
         "Description": "Tree removal permit to remove 25 trees to accommodate construction of a new classroom building at Notre Dame High School",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "RTR91-001",
         "APN": 25939115,
         "File Number": "RTR91-001",
         "Address": " ",
         "Project Name": "RTR91-001, Eucalyptus Tree Removal",
         "Application Type": "PD Permit Amendment ",
         "Application Date": "9/5/91",
         "Status": "Approved ",
         "Description": "Removal of an unsound Eucalyptus tree 59\" in circumference due to a large unstable upper branch.",
         "Planner": "Ted Lorraine ",
         "DURATION": 0,
         "Year": 1991
      },
      {
         "PERMITID": "RTR99-001",
         "APN": 25936069,
         "File Number": "RTR99-001",
         "Address": " ",
         "Project Name": "RTR99-001, Confluence Tennis Courts",
         "Application Type": "PD Permit Amendment ",
         "Application Date": "1/29/99",
         "Status": "Approved ",
         "Description": "Allow the removal of several trees on the Confluence Tennis Courts site RTR99-01-001",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RTR99-003",
         "APN": 46701118,
         "File Number": "RTR99-003",
         "Address": " ",
         "Project Name": "RTR99-003, Church of Christ Tree Removal",
         "Application Type": "PD Permit Amendment ",
         "Application Date": "10/5/99",
         "Status": "Approved ",
         "Description": "Tree Removal - Remove Tree of Heaven ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RTR99-002",
         "APN": 46722009,
         "File Number": "RTR99-002",
         "Address": " ",
         "Project Name": "RTR99-002, Letitia Building",
         "Application Type": "PD Permit Amendment ",
         "Application Date": "5/7/99",
         "Status": "Withdrawn ",
         "Description": "Remove to pine trees on the rear of the Letitia Building ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      }
   ],
   "PD Zoning ": [
      {
         "PERMITID": "PDC00-090",
         "APN": 24946089,
         "File Number": "PDC00-090",
         "Address": "380 N 4TH ST SAN JOSE",
         "Project Name": "PDC00-090",
         "Application Type": "PD Zoning ",
         "Application Date": "9/13/00 16:26",
         "Status": "Approved ",
         "Description": "Planned Development Rezoning from A(PD) Planned Development District to A(PD) Planned Development District to allow relocation of 4 historic buildings on a .537 gross acre site",
         "Planner": "Akoni Danielsen ",
         "DURATION": 6933,
         "Year": 2000
      },
      {
         "PERMITID": "PDC00-090",
         "APN": 24946090,
         "File Number": "PDC00-090",
         "Address": "380 N 4TH ST SAN JOSE",
         "Project Name": "PDC00-090",
         "Application Type": "PD Zoning ",
         "Application Date": "9/13/00 16:26",
         "Status": "Approved ",
         "Description": "Planned Development Rezoning from A(PD) Planned Development District to A(PD) Planned Development District to allow relocation of 4 historic buildings on a .537 gross acre site",
         "Planner": "Akoni Danielsen ",
         "DURATION": 6933,
         "Year": 2000
      },
      {
         "PERMITID": "PDC00-090",
         "APN": 24946092,
         "File Number": "PDC00-090",
         "Address": "380 N 4TH ST SAN JOSE",
         "Project Name": "PDC00-090",
         "Application Type": "PD Zoning ",
         "Application Date": "9/13/00 16:26",
         "Status": "Approved ",
         "Description": "Planned Development Rezoning from A(PD) Planned Development District to A(PD) Planned Development District to allow relocation of 4 historic buildings on a .537 gross acre site",
         "Planner": "Akoni Danielsen ",
         "DURATION": 6933,
         "Year": 2000
      },
      {
         "PERMITID": "PDC02-046",
         "APN": 25938039,
         "File Number": "PDC02-046",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "PDC02-046 - SJ Water Co",
         "Application Type": "PD Zoning ",
         "Application Date": "5/9/02",
         "Status": "Approved ",
         "Description": "Planned Development Rezoning from CN Commercial District to A(PD) Planned Development District to allow mixed use (1.04 million square feet for office/retail and 325 multi-family attached residences) on a 8.93 gross acre site",
         "Planner": "Akoni Danielsen ",
         "DURATION": 1206,
         "Year": 2002
      },
      {
         "PERMITID": "PDC02-046",
         "APN": 25938041,
         "File Number": "PDC02-046",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "PDC02-046 - SJ Water Co",
         "Application Type": "PD Zoning ",
         "Application Date": "5/9/02",
         "Status": "Approved ",
         "Description": "Planned Development Rezoning from CN Commercial District to A(PD) Planned Development District to allow mixed use (1.04 million square feet for office/retail and 325 multi-family attached residences) on a 8.93 gross acre site",
         "Planner": "Akoni Danielsen ",
         "DURATION": 1206,
         "Year": 2002
      },
      {
         "PERMITID": "PDC02-046",
         "APN": 25938042,
         "File Number": "PDC02-046",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "PDC02-046 - SJ Water Co",
         "Application Type": "PD Zoning ",
         "Application Date": "5/9/02",
         "Status": "Approved ",
         "Description": "Planned Development Rezoning from CN Commercial District to A(PD) Planned Development District to allow mixed use (1.04 million square feet for office/retail and 325 multi-family attached residences) on a 8.93 gross acre site",
         "Planner": "Akoni Danielsen ",
         "DURATION": 1206,
         "Year": 2002
      },
      {
         "PERMITID": "PDC02-046",
         "APN": 25938109,
         "File Number": "PDC02-046",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "PDC02-046 - SJ Water Co",
         "Application Type": "PD Zoning ",
         "Application Date": "5/9/02",
         "Status": "Approved ",
         "Description": "Planned Development Rezoning from CN Commercial District to A(PD) Planned Development District to allow mixed use (1.04 million square feet for office/retail and 325 multi-family attached residences) on a 8.93 gross acre site",
         "Planner": "Akoni Danielsen ",
         "DURATION": 1206,
         "Year": 2002
      },
      {
         "PERMITID": "PDC02-046",
         "APN": 25938110,
         "File Number": "PDC02-046",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "PDC02-046 - SJ Water Co",
         "Application Type": "PD Zoning ",
         "Application Date": "5/9/02",
         "Status": "Approved ",
         "Description": "Planned Development Rezoning from CN Commercial District to A(PD) Planned Development District to allow mixed use (1.04 million square feet for office/retail and 325 multi-family attached residences) on a 8.93 gross acre site",
         "Planner": "Akoni Danielsen ",
         "DURATION": 1206,
         "Year": 2002
      },
      {
         "PERMITID": "PDC02-046",
         "APN": 25938145,
         "File Number": "PDC02-046",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "PDC02-046 - SJ Water Co",
         "Application Type": "PD Zoning ",
         "Application Date": "5/9/02",
         "Status": "Approved ",
         "Description": "Planned Development Rezoning from CN Commercial District to A(PD) Planned Development District to allow mixed use (1.04 million square feet for office/retail and 325 multi-family attached residences) on a 8.93 gross acre site",
         "Planner": "Akoni Danielsen ",
         "DURATION": 1206,
         "Year": 2002
      },
      {
         "PERMITID": "PDC02-046",
         "APN": 25938146,
         "File Number": "PDC02-046",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "PDC02-046 - SJ Water Co",
         "Application Type": "PD Zoning ",
         "Application Date": "5/9/02",
         "Status": "Approved ",
         "Description": "Planned Development Rezoning from CN Commercial District to A(PD) Planned Development District to allow mixed use (1.04 million square feet for office/retail and 325 multi-family attached residences) on a 8.93 gross acre site",
         "Planner": "Akoni Danielsen ",
         "DURATION": 1206,
         "Year": 2002
      },
      {
         "PERMITID": "PDC09-019",
         "APN": 47228054,
         "File Number": "PDC09-019",
         "Address": "346 E WILLIAM ST SAN JOSE",
         "Project Name": "PDC09-019 - 8th & William Street Condominiums",
         "Application Type": "PD Zoning ",
         "Application Date": "5/19/09",
         "Status": "Approved ",
         "Description": "A Planned Development Rezoning to allow for the development of a four-story, mixed use project with (1) up to 28 attached residential units, (2) 1,780 square feet of ground floor commercial space, (3) two levels of parking, and (4) the conversion of one single-family residence to a private community center, on a 0.57 gross acre site",
         "Planner": "Darryl Boyd ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PDC09-019",
         "APN": 47228055,
         "File Number": "PDC09-019",
         "Address": "346 E WILLIAM ST SAN JOSE",
         "Project Name": "PDC09-019 - 8th & William Street Condominiums",
         "Application Type": "PD Zoning ",
         "Application Date": "5/19/09",
         "Status": "Approved ",
         "Description": "A Planned Development Rezoning to allow for the development of a four-story, mixed use project with (1) up to 28 attached residential units, (2) 1,780 square feet of ground floor commercial space, (3) two levels of parking, and (4) the conversion of one single-family residence to a private community center, on a 0.57 gross acre site",
         "Planner": "Darryl Boyd ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PDC09-019",
         "APN": 47228056,
         "File Number": "PDC09-019",
         "Address": "346 E WILLIAM ST SAN JOSE",
         "Project Name": "PDC09-019 - 8th & William Street Condominiums",
         "Application Type": "PD Zoning ",
         "Application Date": "5/19/09",
         "Status": "Approved ",
         "Description": "A Planned Development Rezoning to allow for the development of a four-story, mixed use project with (1) up to 28 attached residential units, (2) 1,780 square feet of ground floor commercial space, (3) two levels of parking, and (4) the conversion of one single-family residence to a private community center, on a 0.57 gross acre site",
         "Planner": "Darryl Boyd ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PDC09-023",
         "APN": 26420121,
         "File Number": "PDC09-023",
         "Address": "395 BIRD AV SAN JOSE",
         "Project Name": "PDC09-023 - Gas Station, Food Mart & Carwash on Bird Avenue",
         "Application Type": "PD Zoning ",
         "Application Date": "6/3/09",
         "Status": "Approved ",
         "Description": "Planned Development Rezoning from LI Light Industrial to A(PD) Planned Development to demolish an existing gas station and construct a new gas station/mini-mart/car wash on a 0.6 gross acre site",
         "Planner": "Jodie Clark ",
         "DURATION": 1597,
         "Year": 2009
      },
      {
         "PERMITID": "PDC13-002",
         "APN": 47222091,
         "File Number": "PDC13-002",
         "Address": "595 MARGARET ST SAN JOSE",
         "Project Name": "PDC13-002 - Two homes South 13th Street",
         "Application Type": "PD Zoning ",
         "Application Date": "1/18/13",
         "Status": "Approved ",
         "Description": "Planned Development Rezoning from R-1-8 to R-1-8(PD) Planned Development Zoning District to allow up to two single-family homes in a 0.21 gross arces.",
         "Planner": "Kristinae Toomians ",
         "DURATION": 136,
         "Year": 2013
      },
      {
         "PERMITID": "PDC13-002",
         "APN": 47222092,
         "File Number": "PDC13-002",
         "Address": "595 MARGARET ST SAN JOSE",
         "Project Name": "PDC13-002 - Two homes South 13th Street",
         "Application Type": "PD Zoning ",
         "Application Date": "1/18/13",
         "Status": "Approved ",
         "Description": "Planned Development Rezoning from R-1-8 to R-1-8(PD) Planned Development Zoning District to allow up to two single-family homes in a 0.21 gross arces.",
         "Planner": "Kristinae Toomians ",
         "DURATION": 136,
         "Year": 2013
      },
      {
         "PERMITID": "PDC14-064",
         "APN": 46701120,
         "File Number": "PDC14-064",
         "Address": "298 N 4TH ST SAN JOSE",
         "Project Name": "PDC14-064",
         "Application Type": "PD Zoning ",
         "Application Date": "11/7/14 11:16",
         "Status": "Approved ",
         "Description": "Planned Development Zoning to rezone from CG Commercial General to RM (PD) Planned Development Zoning District to allow live/work and residential uses on an approximately 0.44 gross acre site (in conjunction with PD14-052)",
         "Planner": "David Fong ",
         "DURATION": 486,
         "Year": 2014
      },
      {
         "PERMITID": "PDC15-032",
         "APN": 47226086,
         "File Number": "PDC15-032",
         "Address": "596 S 2ND ST SAN JOSE",
         "Project Name": "PDC15-032 Notre Dame",
         "Application Type": "PD Zoning ",
         "Application Date": "6/30/15 11:09",
         "Status": "Approved ",
         "Description": "Planned Development Rezoning from the CG Commercial General Zoning District and R-M Multiple Residence Zoning District to the DC(PD) Planned Development Zoning District to allow the phased redevelopment and expansion of an existing private school (Notre Dame High School) with up to four new buildings and other site improvement to accommodate a total of 635 students on a 3.43-gross acre site.",
         "Planner": "David Fong ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "PDC15-038",
         "APN": 25947068,
         "File Number": "PDC15-038",
         "Address": "282 S MONTGOMERY ST SAN JOSE",
         "Project Name": "PDC15-038 - Montgomery 7",
         "Application Type": "PD Zoning ",
         "Application Date": "8/3/15",
         "Status": "Approved ",
         "Description": "Planned Development Rezoning request to change the zoning designation from LI – Light Industrial to DC(PD) – Planned Development to allow a ten-story mixed use building that includes approximately 1,856 square feet of ground floor commercial space and up to 54 residential units on a approximately 0.103 gross acre site located within the Downtown and Diridon Urban Village Plan growth areas.",
         "Planner": "John Tu ",
         "DURATION": 364,
         "Year": 2015
      },
      {
         "PERMITID": "PDC15-038",
         "APN": 25947080,
         "File Number": "PDC15-038",
         "Address": "282 S MONTGOMERY ST SAN JOSE",
         "Project Name": "PDC15-038 - Montgomery 7",
         "Application Type": "PD Zoning ",
         "Application Date": "8/3/15",
         "Status": "Approved ",
         "Description": "Planned Development Rezoning request to change the zoning designation from LI – Light Industrial to DC(PD) – Planned Development to allow a ten-story mixed use building that includes approximately 1,856 square feet of ground floor commercial space and up to 54 residential units on a approximately 0.103 gross acre site located within the Downtown and Diridon Urban Village Plan growth areas.",
         "Planner": "John Tu ",
         "DURATION": 364,
         "Year": 2015
      },
      {
         "PERMITID": "PDC15-051",
         "APN": 25938039,
         "File Number": "PDC15-051",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "PDC15-051 - DIRIDON TOD/SJ Water Co./Delmas Ave",
         "Application Type": "PD Zoning ",
         "Application Date": "9/24/15 13:26",
         "Status": "Approved ",
         "Description": "A Conforming Planned Development Rezoning from A(PD) Planned Development Zoning District to A(PD) Planned Development Zoning District to allow for a reduced Guadalupe River flood channel setback, and four floors of underground parking for a mixed use development with up to 1.04 million square feet for office/retail and up to 325 multi-family attached residences on a 8.93 gross acre site.",
         "Planner": "John Tu ",
         "DURATION": 279,
         "Year": 2015
      },
      {
         "PERMITID": "PDC15-051",
         "APN": 25938041,
         "File Number": "PDC15-051",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "PDC15-051 - DIRIDON TOD/SJ Water Co./Delmas Ave",
         "Application Type": "PD Zoning ",
         "Application Date": "9/24/15 13:26",
         "Status": "Approved ",
         "Description": "A Conforming Planned Development Rezoning from A(PD) Planned Development Zoning District to A(PD) Planned Development Zoning District to allow for a reduced Guadalupe River flood channel setback, and four floors of underground parking for a mixed use development with up to 1.04 million square feet for office/retail and up to 325 multi-family attached residences on a 8.93 gross acre site.",
         "Planner": "John Tu ",
         "DURATION": 279,
         "Year": 2015
      },
      {
         "PERMITID": "PDC15-051",
         "APN": 25938109,
         "File Number": "PDC15-051",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "PDC15-051 - DIRIDON TOD/SJ Water Co./Delmas Ave",
         "Application Type": "PD Zoning ",
         "Application Date": "9/24/15 13:26",
         "Status": "Approved ",
         "Description": "A Conforming Planned Development Rezoning from A(PD) Planned Development Zoning District to A(PD) Planned Development Zoning District to allow for a reduced Guadalupe River flood channel setback, and four floors of underground parking for a mixed use development with up to 1.04 million square feet for office/retail and up to 325 multi-family attached residences on a 8.93 gross acre site.",
         "Planner": "John Tu ",
         "DURATION": 279,
         "Year": 2015
      },
      {
         "PERMITID": "PDC15-051",
         "APN": 25938110,
         "File Number": "PDC15-051",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "PDC15-051 - DIRIDON TOD/SJ Water Co./Delmas Ave",
         "Application Type": "PD Zoning ",
         "Application Date": "9/24/15 13:26",
         "Status": "Approved ",
         "Description": "A Conforming Planned Development Rezoning from A(PD) Planned Development Zoning District to A(PD) Planned Development Zoning District to allow for a reduced Guadalupe River flood channel setback, and four floors of underground parking for a mixed use development with up to 1.04 million square feet for office/retail and up to 325 multi-family attached residences on a 8.93 gross acre site.",
         "Planner": "John Tu ",
         "DURATION": 279,
         "Year": 2015
      },
      {
         "PERMITID": "PDC15-051",
         "APN": 25938128,
         "File Number": "PDC15-051",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "PDC15-051 - DIRIDON TOD/SJ Water Co./Delmas Ave",
         "Application Type": "PD Zoning ",
         "Application Date": "9/24/15 13:26",
         "Status": "Approved ",
         "Description": "A Conforming Planned Development Rezoning from A(PD) Planned Development Zoning District to A(PD) Planned Development Zoning District to allow for a reduced Guadalupe River flood channel setback, and four floors of underground parking for a mixed use development with up to 1.04 million square feet for office/retail and up to 325 multi-family attached residences on a 8.93 gross acre site.",
         "Planner": "John Tu ",
         "DURATION": 279,
         "Year": 2015
      },
      {
         "PERMITID": "PDC15-051",
         "APN": 25938145,
         "File Number": "PDC15-051",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "PDC15-051 - DIRIDON TOD/SJ Water Co./Delmas Ave",
         "Application Type": "PD Zoning ",
         "Application Date": "9/24/15 13:26",
         "Status": "Approved ",
         "Description": "A Conforming Planned Development Rezoning from A(PD) Planned Development Zoning District to A(PD) Planned Development Zoning District to allow for a reduced Guadalupe River flood channel setback, and four floors of underground parking for a mixed use development with up to 1.04 million square feet for office/retail and up to 325 multi-family attached residences on a 8.93 gross acre site.",
         "Planner": "John Tu ",
         "DURATION": 279,
         "Year": 2015
      },
      {
         "PERMITID": "PDC17-005",
         "APN": 47217042,
         "File Number": "PDC17-005",
         "Address": "895 S 2ND ST SAN JOSE",
         "Project Name": "PDC17-005",
         "Application Type": "PD Zoning ",
         "Application Date": "2/10/17 10:04",
         "Status": "Approved ",
         "Description": "Planned Development Zoning to rezone from the CN Commercial Neighborhood Zoning District to the R-M (PD) Planned Development Zoning District to allow up to three single family attached residences on three lots on a 0.2-gross acre site",
         "Planner": "Rina Shah ",
         "DURATION": 579,
         "Year": 2017
      },
      {
         "PERMITID": "PDC80-039",
         "APN": 46723082,
         "File Number": "PDC80-039",
         "Address": " ",
         "Project Name": "PDC80-039",
         "Application Type": "PD Zoning ",
         "Application Date": "2/5/80",
         "Status": "Approved ",
         "Description": "Other APNs:/467-23-026",
         "Planner": "Vic Mendez ",
         "DURATION": 0,
         "Year": 1980
      },
      {
         "PERMITID": "PDC80-039",
         "APN": 46723083,
         "File Number": "PDC80-039",
         "Address": " ",
         "Project Name": "PDC80-039",
         "Application Type": "PD Zoning ",
         "Application Date": "2/5/80",
         "Status": "Approved ",
         "Description": "Other APNs:/467-23-026",
         "Planner": "Vic Mendez ",
         "DURATION": 0,
         "Year": 1980
      },
      {
         "PERMITID": "PDC85-040",
         "APN": 46719075,
         "File Number": "PDC85-040",
         "Address": "235 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PDC85-040",
         "Application Type": "PD Zoning ",
         "Application Date": "5/1/85",
         "Status": "Approved ",
         "Description": "SFA ",
         "Planner": "Vic Mendez ",
         "DURATION": 0,
         "Year": 1985
      },
      {
         "PERMITID": "PDC85-096",
         "APN": 24944057,
         "File Number": "PDC85-096",
         "Address": "31 E JULIAN ST SAN JOSE",
         "Project Name": "PDC85-096",
         "Application Type": "PD Zoning ",
         "Application Date": "10/16/85",
         "Status": "Approved ",
         "Description": "PC33546=1010SF ALTERATION; Other APNs:058",
         "Planner": "MWHITNEY ",
         "DURATION": 0,
         "Year": 1985
      },
      {
         "PERMITID": "PDC85-097",
         "APN": 46702125,
         "File Number": "PDC85-097",
         "Address": "276 N 7TH ST SAN JOSE",
         "Project Name": "PDC85-097",
         "Application Type": "PD Zoning ",
         "Application Date": "10/17/85",
         "Status": "Approved ",
         "Description": "File type: *Other apns: *Gen.Use Class:*Existing Land Use:69*Specific Use:SFA",
         "Planner": "MWHITNEY ",
         "DURATION": 0,
         "Year": 1985
      },
      {
         "PERMITID": "PDC85-097",
         "APN": 46702126,
         "File Number": "PDC85-097",
         "Address": "276 N 7TH ST SAN JOSE",
         "Project Name": "PDC85-097",
         "Application Type": "PD Zoning ",
         "Application Date": "10/17/85",
         "Status": "Approved ",
         "Description": "File type: *Other apns: *Gen.Use Class:*Existing Land Use:69*Specific Use:SFA",
         "Planner": "MWHITNEY ",
         "DURATION": 0,
         "Year": 1985
      },
      {
         "PERMITID": "PDC85-097",
         "APN": 46702127,
         "File Number": "PDC85-097",
         "Address": "276 N 7TH ST SAN JOSE",
         "Project Name": "PDC85-097",
         "Application Type": "PD Zoning ",
         "Application Date": "10/17/85",
         "Status": "Approved ",
         "Description": "File type: *Other apns: *Gen.Use Class:*Existing Land Use:69*Specific Use:SFA",
         "Planner": "MWHITNEY ",
         "DURATION": 0,
         "Year": 1985
      },
      {
         "PERMITID": "PDC90-112",
         "APN": 24950083,
         "File Number": "PDC90-112",
         "Address": "345 E JULIAN ST SAN JOSE",
         "Project Name": "PDC90-112",
         "Application Type": "PD Zoning ",
         "Application Date": "11/15/90",
         "Status": "Approved ",
         "Description": "File type: SH*Other apns: *Gen.Use Class:*Existing Land Use:69*Specific Use:9 SFA",
         "Planner": "Jeff Roche ",
         "DURATION": 0,
         "Year": 1990
      },
      {
         "PERMITID": "PDC98-014",
         "APN": 24946089,
         "File Number": "PDC98-014",
         "Address": " ",
         "Project Name": "PDC98-014",
         "Application Type": "PD Zoning ",
         "Application Date": "2/6/98",
         "Status": "Approved ",
         "Description": "Rezoning from M-1 to A(PD) to allow four single family attached units on a 0.25 gross acre site",
         "Planner": "Akoni Danielsen ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "PDC98-046",
         "APN": 47217012,
         "File Number": "PDC98-046",
         "Address": "760 S 1ST ST SAN JOSE",
         "Project Name": "PDC98-046",
         "Application Type": "PD Zoning ",
         "Application Date": "6/17/98",
         "Status": "Approved ",
         "Description": "Rezoning from C-2 to A(PD) to allow a 42 unit, 3 story motel on a 0.30 gross acre site",
         "Planner": "Akoni Danielsen ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "PDC08-018",
         "APN": 46701034,
         "File Number": "PDC08-018",
         "Address": "237 N 4TH ST SAN JOSE",
         "Project Name": "PDC08-018 - Two Live Work Units on 4th Street",
         "Application Type": "PD Zoning ",
         "Application Date": "3/19/08",
         "Status": "Complete ",
         "Description": "Planned Development Rezoning from CG Commercial General Zoning District to A(PD) Planned Development Zoning District for construction of two live/work units on a 0.08 gross acre site",
         "Planner": "Darryl Boyd ",
         "DURATION": 343,
         "Year": 2008
      },
      {
         "PERMITID": "PDC17-022",
         "APN": 47217005,
         "File Number": "PDC17-022",
         "Address": "802 S 1ST ST SAN JOSE",
         "Project Name": "PDC17-022 1st & Virginia",
         "Application Type": "PD Zoning ",
         "Application Date": "6/27/17",
         "Status": "Under Review ",
         "Description": "Planned Development Zoning to rezone from CP Commercial Pedestrian and CN Commercial Neighborhood Zoning District to the A(PD) Planned Development Zoning District to allow a 3-story mixed use building consisting of approximately 5,981-square feet of commercial uses, up to 21 multi-family residential units, and approximately 26,179 square feet of ministorage, with structured and shared parking and re-alignment of existing public driveway alley on 1.93 gross acre site",
         "Planner": "Robert Rivera ",
         "DURATION": 95,
         "Year": 2017
      },
      {
         "PERMITID": "PDC17-022",
         "APN": 47217006,
         "File Number": "PDC17-022",
         "Address": "802 S 1ST ST SAN JOSE",
         "Project Name": "PDC17-022 1st & Virginia",
         "Application Type": "PD Zoning ",
         "Application Date": "6/27/17",
         "Status": "Under Review ",
         "Description": "Planned Development Zoning to rezone from CP Commercial Pedestrian and CN Commercial Neighborhood Zoning District to the A(PD) Planned Development Zoning District to allow a 3-story mixed use building consisting of approximately 5,981-square feet of commercial uses, up to 21 multi-family residential units, and approximately 26,179 square feet of ministorage, with structured and shared parking and re-alignment of existing public driveway alley on 1.93 gross acre site",
         "Planner": "Robert Rivera ",
         "DURATION": 95,
         "Year": 2017
      },
      {
         "PERMITID": "PDC17-022",
         "APN": 47217034,
         "File Number": "PDC17-022",
         "Address": "802 S 1ST ST SAN JOSE",
         "Project Name": "PDC17-022 1st & Virginia",
         "Application Type": "PD Zoning ",
         "Application Date": "6/27/17",
         "Status": "Under Review ",
         "Description": "Planned Development Zoning to rezone from CP Commercial Pedestrian and CN Commercial Neighborhood Zoning District to the A(PD) Planned Development Zoning District to allow a 3-story mixed use building consisting of approximately 5,981-square feet of commercial uses, up to 21 multi-family residential units, and approximately 26,179 square feet of ministorage, with structured and shared parking and re-alignment of existing public driveway alley on 1.93 gross acre site",
         "Planner": "Robert Rivera ",
         "DURATION": 95,
         "Year": 2017
      },
      {
         "PERMITID": "PDC17-022",
         "APN": 47217095,
         "File Number": "PDC17-022",
         "Address": "802 S 1ST ST SAN JOSE",
         "Project Name": "PDC17-022 1st & Virginia",
         "Application Type": "PD Zoning ",
         "Application Date": "6/27/17",
         "Status": "Under Review ",
         "Description": "Planned Development Zoning to rezone from CP Commercial Pedestrian and CN Commercial Neighborhood Zoning District to the A(PD) Planned Development Zoning District to allow a 3-story mixed use building consisting of approximately 5,981-square feet of commercial uses, up to 21 multi-family residential units, and approximately 26,179 square feet of ministorage, with structured and shared parking and re-alignment of existing public driveway alley on 1.93 gross acre site",
         "Planner": "Robert Rivera ",
         "DURATION": 95,
         "Year": 2017
      },
      {
         "PERMITID": "PDC01-091",
         "APN": 46746030,
         "File Number": "PDC01-091",
         "Address": "210 S 1ST ST SAN JOSE",
         "Project Name": "Twohy Bldg Lofts ",
         "Application Type": "PD Zoning ",
         "Application Date": "9/20/01",
         "Status": "Withdrawn ",
         "Description": "Planned Development Rezoning from CG General Commercial District to A(PD) Planned Development District to allow mixed use of 8,676 square foot of existing retail and 36 new multi-family attached loft apartments on a 0.20 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "PDC02-016",
         "APN": 47217012,
         "File Number": "PDC02-016",
         "Address": "760 S 1ST ST SAN JOSE",
         "Project Name": "PDC02-016",
         "Application Type": "PD Zoning ",
         "Application Date": "2/15/02",
         "Status": "Withdrawn ",
         "Description": "Planned Development Rezoning from A(PD) Planned Development and LI Light Industrial Districts to A(PD) Planned Development District to allow 84 unit hotel for a total of 44,065.03 square feet on a 0.59 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 4263,
         "Year": 2002
      },
      {
         "PERMITID": "PDC05-083",
         "APN": 46701034,
         "File Number": "PDC05-083",
         "Address": "237 N 4TH ST SAN JOSE",
         "Project Name": "PDC05-083",
         "Application Type": "PD Zoning ",
         "Application Date": "8/11/05",
         "Status": "Withdrawn ",
         "Description": "Planned Development Rezoning from CG Commercial General Zoning District to A(PD) Planned Development Zoning District to allow relocation of a Victorian house for office use on a 0.07 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 2989,
         "Year": 2005
      },
      {
         "PERMITID": "PDC05-083",
         "APN": 46720021,
         "File Number": "PDC05-083",
         "Address": "237 N 4TH ST SAN JOSE",
         "Project Name": "PDC05-083",
         "Application Type": "PD Zoning ",
         "Application Date": "8/11/05",
         "Status": "Withdrawn ",
         "Description": "Planned Development Rezoning from CG Commercial General Zoning District to A(PD) Planned Development Zoning District to allow relocation of a Victorian house for office use on a 0.07 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 2989,
         "Year": 2005
      },
      {
         "PERMITID": "PDC06-014",
         "APN": 24946036,
         "File Number": "PDC06-014",
         "Address": "329 N 4TH ST SAN JOSE",
         "Project Name": "PDC06-014",
         "Application Type": "PD Zoning ",
         "Application Date": "3/1/06",
         "Status": "Withdrawn ",
         "Description": "Planned Development Rezoning from R-M Multiple Residence Zoning District to A(PD) Planned Development Zoning District to remove an existing single-family residence and construct up to 7 single-family detached residences on 0.37 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2787,
         "Year": 2006
      },
      {
         "PERMITID": "PDC06-014",
         "APN": 24946083,
         "File Number": "PDC06-014",
         "Address": "329 N 4TH ST SAN JOSE",
         "Project Name": "PDC06-014",
         "Application Type": "PD Zoning ",
         "Application Date": "3/1/06",
         "Status": "Withdrawn ",
         "Description": "Planned Development Rezoning from R-M Multiple Residence Zoning District to A(PD) Planned Development Zoning District to remove an existing single-family residence and construct up to 7 single-family detached residences on 0.37 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2787,
         "Year": 2006
      },
      {
         "PERMITID": "PDC06-117",
         "APN": 25943074,
         "File Number": "PDC06-117",
         "Address": "333 W SAN CARLOS ST SAN JOSE",
         "Project Name": "PDC06-117 River Park",
         "Application Type": "PD Zoning ",
         "Application Date": "11/5/06",
         "Status": "Withdrawn ",
         "Description": "Planned Development Rezoning from CG(PD) Commercial General Planned Development Zoning District to A(PD) Planned Development Zoning District to allow up to 99 single-family attached residences and one additional level of parking on top of an existing parking structure on a 1.06 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2543,
         "Year": 2006
      },
      {
         "PERMITID": "PDC06-117",
         "APN": 25943075,
         "File Number": "PDC06-117",
         "Address": "333 W SAN CARLOS ST SAN JOSE",
         "Project Name": "PDC06-117 River Park",
         "Application Type": "PD Zoning ",
         "Application Date": "11/5/06",
         "Status": "Withdrawn ",
         "Description": "Planned Development Rezoning from CG(PD) Commercial General Planned Development Zoning District to A(PD) Planned Development Zoning District to allow up to 99 single-family attached residences and one additional level of parking on top of an existing parking structure on a 1.06 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2543,
         "Year": 2006
      },
      {
         "PERMITID": "PDC06-125",
         "APN": 26426006,
         "File Number": "PDC06-125",
         "Address": "341 DELMAS AV SAN JOSE",
         "Project Name": "PDC06-125 Delmas Ave.",
         "Application Type": "PD Zoning ",
         "Application Date": "11/4/06",
         "Status": "Withdrawn ",
         "Description": "Planned Development Rezoning from the LI Industrial Zoning District to A(PD) Planned Development Zoning District to allow up to 164 multiple dwelling units in two buildings up to 130 feet in height on a 0.87 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2529,
         "Year": 2006
      },
      {
         "PERMITID": "PDC06-125",
         "APN": 26426008,
         "File Number": "PDC06-125",
         "Address": "341 DELMAS AV SAN JOSE",
         "Project Name": "PDC06-125 Delmas Ave.",
         "Application Type": "PD Zoning ",
         "Application Date": "11/4/06",
         "Status": "Withdrawn ",
         "Description": "Planned Development Rezoning from the LI Industrial Zoning District to A(PD) Planned Development Zoning District to allow up to 164 multiple dwelling units in two buildings up to 130 feet in height on a 0.87 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2529,
         "Year": 2006
      },
      {
         "PERMITID": "PDC15-042",
         "APN": 26426006,
         "File Number": "PDC15-042",
         "Address": "341 DELMAS AV SAN JOSE",
         "Project Name": "PDC15-042 - 363 Delmas Avenue",
         "Application Type": "PD Zoning ",
         "Application Date": "8/27/15 10:08",
         "Status": "Withdrawn ",
         "Description": "Planned Development Rezoning from the LI - Light Industrial zoning district to the DC(PD) Planned Development zoning district to allow up to 120 residences in a five story building (61 feet tall) with ground floor parking on a 0.7-gross acre site",
         "Planner": "Jennifer Piozet ",
         "DURATION": 71,
         "Year": 2015
      },
      {
         "PERMITID": "PDC15-042",
         "APN": 26426008,
         "File Number": "PDC15-042",
         "Address": "341 DELMAS AV SAN JOSE",
         "Project Name": "PDC15-042 - 363 Delmas Avenue",
         "Application Type": "PD Zoning ",
         "Application Date": "8/27/15 10:08",
         "Status": "Withdrawn ",
         "Description": "Planned Development Rezoning from the LI - Light Industrial zoning district to the DC(PD) Planned Development zoning district to allow up to 120 residences in a five story building (61 feet tall) with ground floor parking on a 0.7-gross acre site",
         "Planner": "Jennifer Piozet ",
         "DURATION": 71,
         "Year": 2015
      }
   ],
   "Permit Adjustment ": [
      {
         "PERMITID": "2002 134177 RA",
         "APN": 47226091,
         "File Number": "2002 134177 RA",
         "Address": "31 N MARKET ST SAN JOSE",
         "Project Name": "RAD02-02-003, Sonoma Chicken Coop",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/22/02",
         "Status": "Approved ",
         "Description": "Facade improvement including signage, paint, landscaping, new doors and creation of another entrance on the San Pedro St. side of building. ",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2002
      },
      {
         "PERMITID": "AD00-309",
         "APN": 25940094,
         "File Number": "AD00-309",
         "Address": " ",
         "Project Name": "AD00-309",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/17/00",
         "Status": "Approved ",
         "Description": "N/S POST ST BETWEEN SOUTH PEDRO AND SOUTH MARKET STREETS TWO YEAR EXTENSION OF HP PERMIT TO COMPLETE BUILDING PERMIT PROCESS ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "AD00-704",
         "APN": 24944087,
         "File Number": "AD00-704",
         "Address": "360 N 1ST ST SAN JOSE",
         "Project Name": "AD00-704",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/12/00",
         "Status": "Approved ",
         "Description": "Wireless - SANTA CLARA COUNTY LAW LIBRARY INSTALL NEW PERSONAL TELECOMMUNICATION SYSTEM FACILITY CONSISTING OF 3 ROOF/BLDG MOUNTED PANEL ANTENNAS AND ROOF MOUNTED RADIO EQUIP CABINETS REF: CP00-05-033 (WITHDRAWN)",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "AD01-1009",
         "APN": 25945077,
         "File Number": "AD01-1009",
         "Address": "432 LAKEHOUSE AV SAN JOSE",
         "Project Name": "AD01-1009",
         "Application Type": "Permit Adjustment ",
         "Application Date": "8/23/01",
         "Status": "Approved ",
         "Description": "changed the exterior siding to match the origional exterior; need to accurately reflect changes made to building 2nd floor addition, new windows, basement windows",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "AD01-1202-A",
         "APN": 46718090,
         "File Number": "AD01-1202-A",
         "Address": "301 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD01-1202-A",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/10/01",
         "Status": "Approved ",
         "Description": "new windows, glazing at corner only ",
         "Planner": "Akoni Danielsen ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "AD01-1315",
         "APN": 47227097,
         "File Number": "AD01-1315",
         "Address": "502 S 4TH ST SAN JOSE",
         "Project Name": "AD01-1315",
         "Application Type": "Permit Adjustment ",
         "Application Date": "11/14/01",
         "Status": "Approved ",
         "Description": "replace treads, stringers & posts, railing change to metal ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "AD01-1383",
         "APN": 46723083,
         "File Number": "AD01-1383",
         "Address": "195 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD01-1383",
         "Application Type": "Permit Adjustment ",
         "Application Date": "11/30/01",
         "Status": "Approved ",
         "Description": "addition of air conditioning to existing building (roof mounted) ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "AD01-1387",
         "APN": 47229043,
         "File Number": "AD01-1387",
         "Address": "520 S 10TH ST SAN JOSE",
         "Project Name": "AD01-1387",
         "Application Type": "Permit Adjustment ",
         "Application Date": "11/30/01",
         "Status": "Approved ",
         "Description": "minor relocation of existing trash enclosure & minor re-striping of parking area. Also minor storefront door relocation along 10th st. side",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "AD01-291",
         "APN": 26137029,
         "File Number": "AD01-291",
         "Address": "655 W SAN CARLOS ST SAN JOSE",
         "Project Name": "AD01-291",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/1/01",
         "Status": "Approved ",
         "Description": "ADDITION OF METAL AND CANVAS CANOPY FOR WAITING AREA - TO MATCH EXISTING STYLE OF WASH AND EXISTING CANOPY ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "AD01-742",
         "APN": 47229043,
         "File Number": "AD01-742",
         "Address": "520 S 10TH ST SAN JOSE",
         "Project Name": "AD01-742",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/13/01",
         "Status": "Approved ",
         "Description": "MINOR REVISION OF PARAPET CONFIGURATION PREVIOUSLY NUMBERED AD01-06-719 (DUPLICATE) AND CHANGED TO NEW FILE NO.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "AD01-742",
         "APN": 47229044,
         "File Number": "AD01-742",
         "Address": "520 S 10TH ST SAN JOSE",
         "Project Name": "AD01-742",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/13/01",
         "Status": "Approved ",
         "Description": "MINOR REVISION OF PARAPET CONFIGURATION PREVIOUSLY NUMBERED AD01-06-719 (DUPLICATE) AND CHANGED TO NEW FILE NO.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "AD01-983",
         "APN": 46717090,
         "File Number": "AD01-983",
         "Address": "425 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD01-983",
         "Application Type": "Permit Adjustment ",
         "Application Date": "8/16/01",
         "Status": "Approved ",
         "Description": "Wireless comm.; 2- 18\" \"whip\" antennas mounted to side of building; 200 sq. ft. equip. shelter inside building",
         "Planner": "John Davidson ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "AD02-1364",
         "APN": 47229043,
         "File Number": "AD02-1364",
         "Address": "520 S 10TH ST SAN JOSE",
         "Project Name": "AD02-1364",
         "Application Type": "Permit Adjustment ",
         "Application Date": "12/18/02",
         "Status": "Approved ",
         "Description": "Adjustment is for facade improvements at existing commercial properties.  ",
         "Planner": "John Davidson ",
         "DURATION": 1,
         "Year": 2002
      },
      {
         "PERMITID": "AD02-213",
         "APN": 46701002,
         "File Number": "AD02-213",
         "Address": "261 N 2ND ST SAN JOSE",
         "Project Name": "AD02-213",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/28/02",
         "Status": "Approved ",
         "Description": "400 AMP ELEC PANEL AT SIDE FRONT, PIPING, AND WALL FOR HC LIFT",
         "Planner": "John Davidson ",
         "DURATION": 1,
         "Year": 2002
      },
      {
         "PERMITID": "AD02-459",
         "APN": 25938142,
         "File Number": "AD02-459",
         "Address": "384 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD02-459",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/6/02",
         "Status": "Approved ",
         "Description": " ",
         "Planner": "Akoni Danielsen ",
         "DURATION": 1,
         "Year": 2002
      },
      {
         "PERMITID": "AD02-917",
         "APN": 25938036,
         "File Number": "AD02-917",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD02-917",
         "Application Type": "Permit Adjustment ",
         "Application Date": "8/20/02",
         "Status": "Approved ",
         "Description": " ",
         "Planner": "Akoni Danielsen ",
         "DURATION": 1,
         "Year": 2002
      },
      {
         "PERMITID": "AD03-1153",
         "APN": 47224111,
         "File Number": "AD03-1153",
         "Address": "659 S 8TH ST SAN JOSE",
         "Project Name": "AD03-1153",
         "Application Type": "Permit Adjustment ",
         "Application Date": "11/19/03",
         "Status": "Approved ",
         "Description": "Permit adjustment to remove garage level common area (kitchen, office) and convert to 2 additional parking spaces and storage units.",
         "Planner": "Akoni Danielsen ",
         "DURATION": 1,
         "Year": 2003
      },
      {
         "PERMITID": "AD03-163",
         "APN": 26419007,
         "File Number": "AD03-163",
         "Address": "502 AUZERAIS AV SAN JOSE",
         "Project Name": "AD03-163",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/14/03",
         "Status": "Approved ",
         "Description": "Permit adjustment for exterior renovation ",
         "Planner": "Akoni Danielsen ",
         "DURATION": 1,
         "Year": 2003
      },
      {
         "PERMITID": "AD03-931",
         "APN": 46719075,
         "File Number": "AD03-931",
         "Address": "235 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD03-931",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/15/03",
         "Status": "Approved ",
         "Description": "PERMIT ADJUSTMENT FOR EXTERIOR REMODEL REQUIRED BY CONDIT. 5 OF HP03-006",
         "Planner": "John Davidson ",
         "DURATION": 1,
         "Year": 2003
      },
      {
         "PERMITID": "AD03-931",
         "APN": 46757083,
         "File Number": "AD03-931",
         "Address": "235 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD03-931",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/15/03",
         "Status": "Approved ",
         "Description": "PERMIT ADJUSTMENT FOR EXTERIOR REMODEL REQUIRED BY CONDIT. 5 OF HP03-006",
         "Planner": "John Davidson ",
         "DURATION": 1,
         "Year": 2003
      },
      {
         "PERMITID": "AD04-012",
         "APN": 47218055,
         "File Number": "AD04-012",
         "Address": "288 E VIRGINIA ST SAN JOSE",
         "Project Name": "AD04-012",
         "Application Type": "Permit Adjustment ",
         "Application Date": "1/9/04",
         "Status": "Approved ",
         "Description": "NEW 499 GALLON PROPANE TANK AT EXISTING SERVICE STATION",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-071",
         "APN": 46701073,
         "File Number": "AD04-071",
         "Address": "254 N 4TH ST SAN JOSE",
         "Project Name": "AD04-071",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/4/04",
         "Status": "Approved ",
         "Description": "PERMIT ADJUSTMT TO REPLACE DILAPIDATED CARPORTS WITH 2 CARPORTS (5 PARKING SPACES) & LANDSCAPING. NOTE: TREE REMOVAL PERMIT REQUIRED TO REMOVE ORDINANCE SIZE PALM TREE",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-1066",
         "APN": 24948050,
         "File Number": "AD04-1066",
         "Address": "336 N 6TH ST SAN JOSE",
         "Project Name": "AD04-1066",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/14/04",
         "Status": "Approved ",
         "Description": "Addding exterior electrical outlets for gate opener ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-1113",
         "APN": 24948050,
         "File Number": "AD04-1113",
         "Address": "336 N 6TH ST SAN JOSE",
         "Project Name": "AD04-1113",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/29/04",
         "Status": "Approved ",
         "Description": "Replace roofing with comp 30yr and replacing two skylight (like for like)",
         "Planner": "Caleb Gretton ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-114",
         "APN": 46723100,
         "File Number": "AD04-114",
         "Address": "88 S 4TH ST SAN JOSE",
         "Project Name": "(N) DOORS ",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/23/04",
         "Status": "Approved ",
         "Description": "ADDING NEW AND RELOCATING EXISTING EXTERIOR STOREFRONT DOORS ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-114",
         "APN": 46723101,
         "File Number": "AD04-114",
         "Address": "88 S 4TH ST SAN JOSE",
         "Project Name": "(N) DOORS ",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/23/04",
         "Status": "Approved ",
         "Description": "ADDING NEW AND RELOCATING EXISTING EXTERIOR STOREFRONT DOORS ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-1153",
         "APN": 47224111,
         "File Number": "AD04-1153",
         "Address": "659 S 8TH ST SAN JOSE",
         "Project Name": "AD04-1153",
         "Application Type": "Permit Adjustment ",
         "Application Date": "11/12/04",
         "Status": "Approved ",
         "Description": "To allow a one year time extension to an approved Site Development Permit.  ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-1184",
         "APN": 46724110,
         "File Number": "AD04-1184",
         "Address": "268 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD04-1184",
         "Application Type": "Permit Adjustment ",
         "Application Date": "11/19/04",
         "Status": "Approved ",
         "Description": "Permit adjustment for modifications to building facade, including repainting, parapet extension, and changes to storefront windows. ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-1255",
         "APN": 46721034,
         "File Number": "AD04-1255",
         "Address": "4 N 2ND ST SAN JOSE",
         "Project Name": "AD04-1255",
         "Application Type": "Permit Adjustment ",
         "Application Date": "12/16/04",
         "Status": "Approved ",
         "Description": "STOREFRONT MODIFICATIONS, NEW DOORS AND WINDOWS TO REPLACE EXISTING ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-1271",
         "APN": 46724026,
         "File Number": "AD04-1271",
         "Address": "295 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD04-1271",
         "Application Type": "Permit Adjustment ",
         "Application Date": "12/22/04",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow one new attached sign for Beta Theta Pi fraternity and trash enclosure at the subject site. (details of trash enclosure were required as part of the approved CUP (CP04-068).",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-232",
         "APN": 25941057,
         "File Number": "AD04-232",
         "Address": "125 S MARKET ST SAN JOSE",
         "Project Name": "(N) ROOF SCREEN ",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/18/04",
         "Status": "Approved ",
         "Description": "ADD CONDENSER UNITS TO ROOFTOP AND EQUIPMENT SCREEN ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-401",
         "APN": 24950058,
         "File Number": "AD04-401",
         "Address": "320 N 8TH ST SAN JOSE",
         "Project Name": "AD04-401",
         "Application Type": "Permit Adjustment ",
         "Application Date": "4/30/04",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove concrete pad in front setback area and replace with landscape. ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-407",
         "APN": 25940043,
         "File Number": "AD04-407",
         "Address": "27 S 1ST ST SAN JOSE",
         "Project Name": "AD04-407",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/3/04",
         "Status": "Approved ",
         "Description": "Permit Adjustment for facade changes. Singage requires later approval. PARENT FILE: RCP01-005",
         "Planner": "Ron Eddow ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-450",
         "APN": 46723100,
         "File Number": "AD04-450",
         "Address": "88 S 4TH ST SAN JOSE",
         "Project Name": "AD04-450 - Rotary International on 4th St. Garage",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/7/04",
         "Status": "Approved ",
         "Description": "Skyline sign for the 4th Street parking garage",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-450",
         "APN": 46723101,
         "File Number": "AD04-450",
         "Address": "88 S 4TH ST SAN JOSE",
         "Project Name": "AD04-450 - Rotary International on 4th St. Garage",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/7/04",
         "Status": "Approved ",
         "Description": "Skyline sign for the 4th Street parking garage",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-496",
         "APN": 47217040,
         "File Number": "AD04-496",
         "Address": "891 S 2ND ST SAN JOSE",
         "Project Name": "AD04-496",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/19/04",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove accesory structure, bay window, and reconstruct back stairs to provide the proper size landing.  ",
         "Planner": "Ron Eddow ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-511",
         "APN": 46722148,
         "File Number": "AD04-511",
         "Address": "78 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD04-511",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/21/04",
         "Status": "Approved ",
         "Description": "New air conditioning unit on roof top of single story element.  ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-563",
         "APN": 26427082,
         "File Number": "AD04-563",
         "Address": "180 WOZ WY SAN JOSE",
         "Project Name": "PLAZA IMPROVEMENTS ",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/3/04",
         "Status": "Approved ",
         "Description": "DEMO OF TILE PAVERS IN FRONT PLAZA, TO BE REPLACED WITH CONCRETE; REPLACEMENTS OF SOME EXISITING LIGHT AND ADDING NEW LIGHT FIXTURES AND SECURITY GATES ",
         "Planner": "Lee Butler ",
         "DURATION": 13,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-563",
         "APN": 26427087,
         "File Number": "AD04-563",
         "Address": "180 WOZ WY SAN JOSE",
         "Project Name": "PLAZA IMPROVEMENTS ",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/3/04",
         "Status": "Approved ",
         "Description": "DEMO OF TILE PAVERS IN FRONT PLAZA, TO BE REPLACED WITH CONCRETE; REPLACEMENTS OF SOME EXISITING LIGHT AND ADDING NEW LIGHT FIXTURES AND SECURITY GATES ",
         "Planner": "Lee Butler ",
         "DURATION": 13,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-563",
         "APN": 26427088,
         "File Number": "AD04-563",
         "Address": "180 WOZ WY SAN JOSE",
         "Project Name": "PLAZA IMPROVEMENTS ",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/3/04",
         "Status": "Approved ",
         "Description": "DEMO OF TILE PAVERS IN FRONT PLAZA, TO BE REPLACED WITH CONCRETE; REPLACEMENTS OF SOME EXISITING LIGHT AND ADDING NEW LIGHT FIXTURES AND SECURITY GATES ",
         "Planner": "Lee Butler ",
         "DURATION": 13,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-564",
         "APN": 46761001,
         "File Number": "AD04-564",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "AD04-564",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/4/04",
         "Status": "Approved ",
         "Description": "for an addition to an existing gate on an existing residential building ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-564",
         "APN": 46761002,
         "File Number": "AD04-564",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "AD04-564",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/4/04",
         "Status": "Approved ",
         "Description": "for an addition to an existing gate on an existing residential building ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-564",
         "APN": 46761003,
         "File Number": "AD04-564",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "AD04-564",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/4/04",
         "Status": "Approved ",
         "Description": "for an addition to an existing gate on an existing residential building ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-564",
         "APN": 46761004,
         "File Number": "AD04-564",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "AD04-564",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/4/04",
         "Status": "Approved ",
         "Description": "for an addition to an existing gate on an existing residential building ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-564",
         "APN": 46761005,
         "File Number": "AD04-564",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "AD04-564",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/4/04",
         "Status": "Approved ",
         "Description": "for an addition to an existing gate on an existing residential building ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-564",
         "APN": 46761006,
         "File Number": "AD04-564",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "AD04-564",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/4/04",
         "Status": "Approved ",
         "Description": "for an addition to an existing gate on an existing residential building ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-564",
         "APN": 46761007,
         "File Number": "AD04-564",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "AD04-564",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/4/04",
         "Status": "Approved ",
         "Description": "for an addition to an existing gate on an existing residential building ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-564",
         "APN": 46761008,
         "File Number": "AD04-564",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "AD04-564",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/4/04",
         "Status": "Approved ",
         "Description": "for an addition to an existing gate on an existing residential building ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-564",
         "APN": 46761009,
         "File Number": "AD04-564",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "AD04-564",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/4/04",
         "Status": "Approved ",
         "Description": "for an addition to an existing gate on an existing residential building ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-564",
         "APN": 46761010,
         "File Number": "AD04-564",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "AD04-564",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/4/04",
         "Status": "Approved ",
         "Description": "for an addition to an existing gate on an existing residential building ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-564",
         "APN": 46761011,
         "File Number": "AD04-564",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "AD04-564",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/4/04",
         "Status": "Approved ",
         "Description": "for an addition to an existing gate on an existing residential building ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-564",
         "APN": 46761012,
         "File Number": "AD04-564",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "AD04-564",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/4/04",
         "Status": "Approved ",
         "Description": "for an addition to an existing gate on an existing residential building ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-564",
         "APN": 46761013,
         "File Number": "AD04-564",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "AD04-564",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/4/04",
         "Status": "Approved ",
         "Description": "for an addition to an existing gate on an existing residential building ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-564",
         "APN": 46761014,
         "File Number": "AD04-564",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "AD04-564",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/4/04",
         "Status": "Approved ",
         "Description": "for an addition to an existing gate on an existing residential building ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-564",
         "APN": 46761015,
         "File Number": "AD04-564",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "AD04-564",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/4/04",
         "Status": "Approved ",
         "Description": "for an addition to an existing gate on an existing residential building ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-564",
         "APN": 46761017,
         "File Number": "AD04-564",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "AD04-564",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/4/04",
         "Status": "Approved ",
         "Description": "for an addition to an existing gate on an existing residential building ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-564",
         "APN": 46761018,
         "File Number": "AD04-564",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "AD04-564",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/4/04",
         "Status": "Approved ",
         "Description": "for an addition to an existing gate on an existing residential building ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-564",
         "APN": 46761019,
         "File Number": "AD04-564",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "AD04-564",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/4/04",
         "Status": "Approved ",
         "Description": "for an addition to an existing gate on an existing residential building ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-564",
         "APN": 46761020,
         "File Number": "AD04-564",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "AD04-564",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/4/04",
         "Status": "Approved ",
         "Description": "for an addition to an existing gate on an existing residential building ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-564",
         "APN": 46761021,
         "File Number": "AD04-564",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "AD04-564",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/4/04",
         "Status": "Approved ",
         "Description": "for an addition to an existing gate on an existing residential building ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-564",
         "APN": 46761022,
         "File Number": "AD04-564",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "AD04-564",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/4/04",
         "Status": "Approved ",
         "Description": "for an addition to an existing gate on an existing residential building ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-564",
         "APN": 46761023,
         "File Number": "AD04-564",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "AD04-564",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/4/04",
         "Status": "Approved ",
         "Description": "for an addition to an existing gate on an existing residential building ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-564",
         "APN": 46761024,
         "File Number": "AD04-564",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "AD04-564",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/4/04",
         "Status": "Approved ",
         "Description": "for an addition to an existing gate on an existing residential building ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-564",
         "APN": 46761025,
         "File Number": "AD04-564",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "AD04-564",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/4/04",
         "Status": "Approved ",
         "Description": "for an addition to an existing gate on an existing residential building ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-564",
         "APN": 46761026,
         "File Number": "AD04-564",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "AD04-564",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/4/04",
         "Status": "Approved ",
         "Description": "for an addition to an existing gate on an existing residential building ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-564",
         "APN": 46761027,
         "File Number": "AD04-564",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "AD04-564",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/4/04",
         "Status": "Approved ",
         "Description": "for an addition to an existing gate on an existing residential building ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-564",
         "APN": 46761028,
         "File Number": "AD04-564",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "AD04-564",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/4/04",
         "Status": "Approved ",
         "Description": "for an addition to an existing gate on an existing residential building ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-564",
         "APN": 46761029,
         "File Number": "AD04-564",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "AD04-564",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/4/04",
         "Status": "Approved ",
         "Description": "for an addition to an existing gate on an existing residential building ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-564",
         "APN": 46761030,
         "File Number": "AD04-564",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "AD04-564",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/4/04",
         "Status": "Approved ",
         "Description": "for an addition to an existing gate on an existing residential building ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-564",
         "APN": 46761032,
         "File Number": "AD04-564",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "AD04-564",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/4/04",
         "Status": "Approved ",
         "Description": "for an addition to an existing gate on an existing residential building ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-564",
         "APN": 46761033,
         "File Number": "AD04-564",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "AD04-564",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/4/04",
         "Status": "Approved ",
         "Description": "for an addition to an existing gate on an existing residential building ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-564",
         "APN": 46761035,
         "File Number": "AD04-564",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "AD04-564",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/4/04",
         "Status": "Approved ",
         "Description": "for an addition to an existing gate on an existing residential building ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-564",
         "APN": 46761037,
         "File Number": "AD04-564",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "AD04-564",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/4/04",
         "Status": "Approved ",
         "Description": "for an addition to an existing gate on an existing residential building ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-564",
         "APN": 46761038,
         "File Number": "AD04-564",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "AD04-564",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/4/04",
         "Status": "Approved ",
         "Description": "for an addition to an existing gate on an existing residential building ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-564",
         "APN": 46761040,
         "File Number": "AD04-564",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "AD04-564",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/4/04",
         "Status": "Approved ",
         "Description": "for an addition to an existing gate on an existing residential building ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-564",
         "APN": 46761041,
         "File Number": "AD04-564",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "AD04-564",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/4/04",
         "Status": "Approved ",
         "Description": "for an addition to an existing gate on an existing residential building ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-564",
         "APN": 46761042,
         "File Number": "AD04-564",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "AD04-564",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/4/04",
         "Status": "Approved ",
         "Description": "for an addition to an existing gate on an existing residential building ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-564",
         "APN": 46761043,
         "File Number": "AD04-564",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "AD04-564",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/4/04",
         "Status": "Approved ",
         "Description": "for an addition to an existing gate on an existing residential building ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-564",
         "APN": 46761044,
         "File Number": "AD04-564",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "AD04-564",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/4/04",
         "Status": "Approved ",
         "Description": "for an addition to an existing gate on an existing residential building ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-564",
         "APN": 46761045,
         "File Number": "AD04-564",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "AD04-564",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/4/04",
         "Status": "Approved ",
         "Description": "for an addition to an existing gate on an existing residential building ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-564",
         "APN": 46761046,
         "File Number": "AD04-564",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "AD04-564",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/4/04",
         "Status": "Approved ",
         "Description": "for an addition to an existing gate on an existing residential building ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-564",
         "APN": 46761048,
         "File Number": "AD04-564",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "AD04-564",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/4/04",
         "Status": "Approved ",
         "Description": "for an addition to an existing gate on an existing residential building ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-564",
         "APN": 46761049,
         "File Number": "AD04-564",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "AD04-564",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/4/04",
         "Status": "Approved ",
         "Description": "for an addition to an existing gate on an existing residential building ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-564",
         "APN": 46761051,
         "File Number": "AD04-564",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "AD04-564",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/4/04",
         "Status": "Approved ",
         "Description": "for an addition to an existing gate on an existing residential building ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-564",
         "APN": 46761052,
         "File Number": "AD04-564",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "AD04-564",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/4/04",
         "Status": "Approved ",
         "Description": "for an addition to an existing gate on an existing residential building ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-564",
         "APN": 46761055,
         "File Number": "AD04-564",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "AD04-564",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/4/04",
         "Status": "Approved ",
         "Description": "for an addition to an existing gate on an existing residential building ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-564",
         "APN": 46761056,
         "File Number": "AD04-564",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "AD04-564",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/4/04",
         "Status": "Approved ",
         "Description": "for an addition to an existing gate on an existing residential building ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-623",
         "APN": 25942079,
         "File Number": "AD04-623",
         "Address": "211 S 1ST ST SAN JOSE",
         "Project Name": "AD04-623",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/17/04",
         "Status": "Approved ",
         "Description": "Permit Adjustment to add roof screen to mechanical roof top equipment at existing restaurant. ",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-708",
         "APN": 47226036,
         "File Number": "AD04-708",
         "Address": "520 S 1ST ST SAN JOSE",
         "Project Name": "AD04-708",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/12/04",
         "Status": "Approved ",
         "Description": "[Second Adjustment] Facade changes, to a City Landmark (Costa-Miller Building) ",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-754",
         "APN": 46718076,
         "File Number": "AD04-754",
         "Address": "157 N 8TH ST SAN JOSE",
         "Project Name": "AD04-754",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/26/04",
         "Status": "Approved ",
         "Description": "Permit adjustment to add partial basement (240 sf) at a duplex.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-804",
         "APN": 25935013,
         "File Number": "AD04-804",
         "Address": "87 N SAN PEDRO ST SAN JOSE",
         "Project Name": "AD04-804",
         "Application Type": "Permit Adjustment ",
         "Application Date": "8/9/04",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow replacement of fence, landscaping, and patio area ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-804",
         "APN": 25935045,
         "File Number": "AD04-804",
         "Address": "87 N SAN PEDRO ST SAN JOSE",
         "Project Name": "AD04-804",
         "Application Type": "Permit Adjustment ",
         "Application Date": "8/9/04",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow replacement of fence, landscaping, and patio area ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-813",
         "APN": 47245001,
         "File Number": "AD04-813",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "AD04-813",
         "Application Type": "Permit Adjustment ",
         "Application Date": "8/10/04",
         "Status": "Approved ",
         "Description": "Permit adjustment for landscape changes to the courtyard. ",
         "Planner": "John Davidson ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-838",
         "APN": 26420132,
         "File Number": "AD04-838",
         "Address": "598 W SAN CARLOS ST SAN JOSE",
         "Project Name": "AD04-838",
         "Application Type": "Permit Adjustment ",
         "Application Date": "8/17/04",
         "Status": "Approved ",
         "Description": "Permit adjustment for exterior alterations, including 1) delete balconies on Columbia St. elevation, 2) delete popouts on San Carlos and Bird, and 3) change podium community room to covered lanai.",
         "Planner": "Ron Eddow ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-887",
         "APN": 47218059,
         "File Number": "AD04-887",
         "Address": "160 E VIRGINIA ST SAN JOSE",
         "Project Name": "AD04-887",
         "Application Type": "Permit Adjustment ",
         "Application Date": "8/31/04",
         "Status": "Approved ",
         "Description": "Twelve 4' nextell antenna panels, parapet/pipe mount to parapet, 11'-6\"x 20' x 10' tall equipment shelter, 26 ps, coax roof mounted",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD05-056",
         "APN": 25930088,
         "File Number": "AD05-056",
         "Address": "150 N ALMADEN BL SAN JOSE",
         "Project Name": "AD05-056",
         "Application Type": "Permit Adjustment ",
         "Application Date": "1/20/05",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow Architectural Changes to the approed RDA permit RH99-001",
         "Planner": "Ron Eddow ",
         "DURATION": 1,
         "Year": 2005
      },
      {
         "PERMITID": "AD05-075",
         "APN": 46724069,
         "File Number": "AD05-075",
         "Address": "304 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD05-075 (N) ROOF EQUIPMENT",
         "Application Type": "Permit Adjustment ",
         "Application Date": "1/28/05",
         "Status": "Approved ",
         "Description": "REPLACE (E) H.V.A.C UNIT WITH TWO (2) SMALLER UNITS",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2005
      },
      {
         "PERMITID": "AD05-087",
         "APN": 46721018,
         "File Number": "AD05-087",
         "Address": "66 N 1ST ST SAN JOSE",
         "Project Name": "AD05-087",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/2/05",
         "Status": "Approved ",
         "Description": "NEW AC ROOFTOP AT 4.5 FT FROM EDGE",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2005
      },
      {
         "PERMITID": "AD05-1003",
         "APN": 46764005,
         "File Number": "AD05-1003",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD05-1003",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/28/05",
         "Status": "Approved ",
         "Description": "Relocation of driveway and reconfiguration of surface parking lot for Phase II of the Block 3 site",
         "Planner": "Ron Eddow ",
         "DURATION": 7,
         "Year": 2005
      },
      {
         "PERMITID": "AD05-1003",
         "APN": 46764010,
         "File Number": "AD05-1003",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD05-1003",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/28/05",
         "Status": "Approved ",
         "Description": "Relocation of driveway and reconfiguration of surface parking lot for Phase II of the Block 3 site",
         "Planner": "Ron Eddow ",
         "DURATION": 7,
         "Year": 2005
      },
      {
         "PERMITID": "AD05-1030",
         "APN": 46747038,
         "File Number": "AD05-1030",
         "Address": "458 S 2ND ST SAN JOSE",
         "Project Name": "AD05-1030",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/4/05",
         "Status": "Approved ",
         "Description": "FACADE IMPROVEMENT: (N) WINDOWS, DOOR REPLACEMENT, ONE (1) NEW ATTACHED SIGN, (N) TILE WORK, (N) STUCCO",
         "Planner": "Ron Eddow ",
         "DURATION": 0,
         "Year": 2005
      },
      {
         "PERMITID": "AD05-1104",
         "APN": 47217015,
         "File Number": "AD05-1104",
         "Address": "734 S 1ST ST SAN JOSE",
         "Project Name": "AD05-1104",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/24/05",
         "Status": "Approved ",
         "Description": "RDA FIP Facade Improvement for 734 and 736 S. 1st Street.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2005
      },
      {
         "PERMITID": "AD05-1125",
         "APN": 25935056,
         "File Number": "AD05-1125",
         "Address": "73 N SAN PEDRO ST SAN JOSE",
         "Project Name": "AD05-1125",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/27/05",
         "Status": "Approved ",
         "Description": "METAL AND GLASS AWNING,STOREFRONT REDESIGN, LIGHTING AND LANDSCAPING REDESIGN. ",
         "Planner": "Lee Butler ",
         "DURATION": 6,
         "Year": 2005
      },
      {
         "PERMITID": "AD05-194",
         "APN": 25945077,
         "File Number": "AD05-194",
         "Address": "432 LAKEHOUSE AV SAN JOSE",
         "Project Name": "AD05-194",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/3/05",
         "Status": "Approved ",
         "Description": "EXTERIOR MAINTENANCE WORK TO REPLACE ONLY THE FOLLOWING: COMPOSITE SHINGLE TILE TO MATCH, DAMAGED SIDING, FRONT STAIRS, THRESHOLD, BROKEN WINDOW PANES, DAMAGED WOOD GRILL W/WOOD GRILL, AND REPAINT TO MATCH AS NEEDED. ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2005
      },
      {
         "PERMITID": "AD05-331",
         "APN": 46724069,
         "File Number": "AD05-331",
         "Address": "304 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD05-331 (N) ROOF UNIT",
         "Application Type": "Permit Adjustment ",
         "Application Date": "4/7/05",
         "Status": "Approved ",
         "Description": "(N) HVAC UNIT ON ROOF TO REPLACE EXISTING ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2005
      },
      {
         "PERMITID": "AD05-390",
         "APN": 47226027,
         "File Number": "AD05-390",
         "Address": "630 S 1ST ST SAN JOSE",
         "Project Name": "AD05-390",
         "Application Type": "Permit Adjustment ",
         "Application Date": "4/21/05",
         "Status": "Approved ",
         "Description": "PERMIT ADJUSTMENT FOR FACADE IMPROVEMENTS AND A NEW SIGN FOR A PROPERTY ON THE HISTORIC INVENTORY. THIS PERMIT INCLUDES A NEW STOREFRONT, NEW PAINT, AND ONE NEW SIGN ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2005
      },
      {
         "PERMITID": "AD05-466",
         "APN": 46723100,
         "File Number": "AD05-466",
         "Address": "88 S 4TH ST SAN JOSE",
         "Project Name": "AD05-466",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/16/05",
         "Status": "Approved ",
         "Description": "Adding to new storefront doors to an existing tenant space under the 4th st garage for Flames restaurant",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2005
      },
      {
         "PERMITID": "AD05-466",
         "APN": 46723101,
         "File Number": "AD05-466",
         "Address": "88 S 4TH ST SAN JOSE",
         "Project Name": "AD05-466",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/16/05",
         "Status": "Approved ",
         "Description": "Adding to new storefront doors to an existing tenant space under the 4th st garage for Flames restaurant",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2005
      },
      {
         "PERMITID": "AD05-490",
         "APN": 46717090,
         "File Number": "AD05-490",
         "Address": "425 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD05-490 WIRELESS SCREEN",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/23/05",
         "Status": "Approved ",
         "Description": "ROOFTOP SCREEN FOR NEW WIRELESS PHONE ANTENNA EQUIPMENT. (CINGLULAR WIRELESS) ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2005
      },
      {
         "PERMITID": "AD05-499",
         "APN": 46747090,
         "File Number": "AD05-499",
         "Address": "400 S 1ST ST SAN JOSE",
         "Project Name": "AD05-499",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/25/05",
         "Status": "Approved ",
         "Description": "ONE (N) ATTACHED SIGN AND FACADE IMPROVEMENTS ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2005
      },
      {
         "PERMITID": "AD05-515",
         "APN": 46718090,
         "File Number": "AD05-515",
         "Address": "301 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD05-515",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/31/05",
         "Status": "Approved ",
         "Description": "ADDING LIGHTING ",
         "Planner": "Lee Butler ",
         "DURATION": 9,
         "Year": 2005
      },
      {
         "PERMITID": "AD05-650",
         "APN": 46719076,
         "File Number": "AD05-650",
         "Address": "72 N 5TH ST SAN JOSE",
         "Project Name": "AD05-650",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/29/05",
         "Status": "Approved ",
         "Description": "(N) TRANSFORMER AND ELECTRICAL PANEL FOR UTILITIES BEING MOVED UNDERGROUND ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2005
      },
      {
         "PERMITID": "AD05-670",
         "APN": 25930088,
         "File Number": "AD05-670",
         "Address": "150 N ALMADEN BL SAN JOSE",
         "Project Name": "AD05-670",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/1/05",
         "Status": "Approved ",
         "Description": "Permit adjustment for architectural modifications and exterior building colors to an office building. No signs proposed. ",
         "Planner": "Ron Eddow ",
         "DURATION": 1,
         "Year": 2005
      },
      {
         "PERMITID": "AD05-711",
         "APN": 47226010,
         "File Number": "AD05-711",
         "Address": "45 E REED ST SAN JOSE",
         "Project Name": "AD05-711",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/19/05",
         "Status": "Approved ",
         "Description": "REPLACE EXISTING SECOND FLOOR BALCONY TO MATCH EXISTING (ORIGINAL) ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2005
      },
      {
         "PERMITID": "AD05-717",
         "APN": 46717090,
         "File Number": "AD05-717",
         "Address": "425 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD05-717",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/20/05",
         "Status": "Approved ",
         "Description": "BULDING MOUNTED ANTENNA. THIS PERMIT IS TO REPLACE THE APPROVED AD05-490 WHICH APPROVED A DIFFERENT DESIGN",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2005
      },
      {
         "PERMITID": "AD05-745",
         "APN": 25935020,
         "File Number": "AD05-745",
         "Address": "225 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD05-745",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/28/05",
         "Status": "Approved ",
         "Description": "Permit Adjustment for facade modifications to allow an additional exit door and new exhaust vent.  ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2005
      },
      {
         "PERMITID": "AD05-829",
         "APN": 25936074,
         "File Number": "AD05-829",
         "Address": "333 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD05-829",
         "Application Type": "Permit Adjustment ",
         "Application Date": "8/22/05",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow replacement of 9 existing antennas and installation of 3 new equipment cabinets and new cables",
         "Planner": "Lee Butler ",
         "DURATION": 0,
         "Year": 2005
      },
      {
         "PERMITID": "AD05-968",
         "APN": 46746075,
         "File Number": "AD05-968",
         "Address": "366 S 1ST ST SAN JOSE",
         "Project Name": "AD05-968",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/22/05",
         "Status": "Approved ",
         "Description": "To change out one exterior door from 2-foot 6-inch to a single entry 36-inch door and one 24-inch inoperable panel.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2005
      },
      {
         "PERMITID": "AD06-081",
         "APN": 46722056,
         "File Number": "AD06-081",
         "Address": "69 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD06-081",
         "Application Type": "Permit Adjustment ",
         "Application Date": "1/23/06",
         "Status": "Approved ",
         "Description": "Facade improvements to The Lawrence Hotel building listed on the City of San Jose's Historic Resources Inventory as a Contributing Structure within the Downtown Commercial National Register District. ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-108",
         "APN": 46721034,
         "File Number": "AD06-108",
         "Address": "4 N 2ND ST SAN JOSE",
         "Project Name": "AD06-108",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/2/06",
         "Status": "Approved ",
         "Description": "Remove existing arched, black anodized alum. storefronts and one wood panel in two arched openings and replace with new brushed alum. and glass storefronts. ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-1096",
         "APN": 46747053,
         "File Number": "AD06-1096",
         "Address": "487 S 4TH ST SAN JOSE",
         "Project Name": "AD06-1096",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Permit Adjustment for facade improvements including new storefront windows and throughout the building, pedestrian gate, fence, awning, signage, and other exterior modifications per submitted plan sets. ",
         "Planner": "Lee Butler ",
         "DURATION": 0,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-1132",
         "APN": 46721023,
         "File Number": "AD06-1132",
         "Address": "2 N 1ST ST SAN JOSE",
         "Project Name": "AD06-1132",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/4/06",
         "Status": "Approved ",
         "Description": "Permit Adjustment for ground floor facade changes to an existing building including, replacing six doors and the addition of a metal screen over the electrical closet. ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-1234",
         "APN": 25939122,
         "File Number": "AD06-1234",
         "Address": "10 ALMADEN BL SAN JOSE",
         "Project Name": "AD06-1234",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/27/06",
         "Status": "Approved ",
         "Description": "Permit Adjustment to replace one existing storefront double door with new storefront window on south elevation. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-1266",
         "APN": 47226033,
         "File Number": "AD06-1266",
         "Address": "560 S 1ST ST SAN JOSE",
         "Project Name": "AD06-1266",
         "Application Type": "Permit Adjustment ",
         "Application Date": "11/2/06",
         "Status": "Approved ",
         "Description": "PROPOSED RENOVATION TO CHANGEOUT NEW DOOR, WINDOW REPLACEMENTS WITH CLEAR ANNODIZED ALUMINUM FRAMES ONLY ",
         "Planner": "Lee Butler ",
         "DURATION": 0,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-1270",
         "APN": 25940091,
         "File Number": "AD06-1270",
         "Address": "55 S MARKET ST SAN JOSE",
         "Project Name": "AD06-1270",
         "Application Type": "Permit Adjustment ",
         "Application Date": "11/3/06",
         "Status": "Approved ",
         "Description": "Add four cooling units (approximately 6'8\" ht x 3'0 wd) to roof on existing steel structure, behind existing roof screen only.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-1374",
         "APN": 47229042,
         "File Number": "AD06-1374",
         "Address": "528 S 10TH ST SAN JOSE",
         "Project Name": "AD06-1374",
         "Application Type": "Permit Adjustment ",
         "Application Date": "12/5/06",
         "Status": "Approved ",
         "Description": "Permit Adjustment to replace existing circuit breaker modules and meters with new. Modules and meters are located at the same location on left side elevation. Property is listed on the City of San Jose Historic Resources Inventory as a structure of merit. ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-1393",
         "APN": 46721013,
         "File Number": "AD06-1393",
         "Address": "96 N 2ND ST SAN JOSE",
         "Project Name": "AD06-1393",
         "Application Type": "Permit Adjustment ",
         "Application Date": "12/8/06",
         "Status": "Approved ",
         "Description": "Permit Adjustment for the installation of two new windows to the second floor north elevation of the former S&H Green Stamp Redemption Building located in City Landmark District, St. James Square Historic Area. ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-195",
         "APN": 25939120,
         "File Number": "AD06-195",
         "Address": "95 S ALMADEN AV SAN JOSE",
         "Project Name": "AD06-195",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/27/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for the addition of a BTS cabinet to existing cel site below parapet ",
         "Planner": "Lee Butler ",
         "DURATION": 0,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-317",
         "APN": 26420132,
         "File Number": "AD06-317",
         "Address": "350 BIRD AV SAN JOSE",
         "Project Name": "AD06-317",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/30/06",
         "Status": "Approved ",
         "Description": "Planned Development Permit Adjustment to change the paint color and to increase the height of the elevator structure on the roof from 5-feet 8-inches to 9-foot 2-inches above the rooftop to meet new state elevator requirements on a 0.12 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-478",
         "APN": 25939115,
         "File Number": "AD06-478",
         "Address": "1 ALMADEN BL SAN JOSE",
         "Project Name": "AD06-478",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/12/06",
         "Status": "Approved ",
         "Description": "Addition of new front entrance at 1 Almaden Boulevard, and remodel with new storefront five existing entrances at 55 and 99 Almaden Boulevard",
         "Planner": "Ron Eddow ",
         "DURATION": 6,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-513",
         "APN": 46701003,
         "File Number": "AD06-513",
         "Address": "257 N 2ND ST SAN JOSE",
         "Project Name": "AD06-513",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/22/06",
         "Status": "Approved ",
         "Description": "Permit Adjustment to satisfy Condition No. 14.b of Site Development Permit file no. H04-037 regarding construction and landscape details",
         "Planner": "Lee Butler ",
         "DURATION": 0,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-536",
         "APN": 47228047,
         "File Number": "AD06-536",
         "Address": "510 S 6TH ST SAN JOSE",
         "Project Name": "AD06-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/25/06",
         "Status": "Approved ",
         "Description": "Install electric gate on primary driveway adjoining south side of building ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-613",
         "APN": 47226033,
         "File Number": "AD06-613",
         "Address": "560 S 1ST ST SAN JOSE",
         "Project Name": "AD06-613",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/12/06",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove an exist entry stroefront system and replace with new Vistawall anodozed alum. storefront system on 0.17 gross acres.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763001,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763002,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763004,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763005,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763006,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763007,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763008,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763010,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763011,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763014,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763015,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763016,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763017,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763018,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763019,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763020,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763024,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763025,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763026,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763027,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763028,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763029,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763030,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763032,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763033,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763034,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763036,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763037,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763038,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763039,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763040,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763041,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763042,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763043,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763047,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763049,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763050,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763051,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763052,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763053,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763054,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763055,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763056,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763057,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763058,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763059,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763060,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763061,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763063,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763064,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763067,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763068,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763070,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763071,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763072,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763074,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763075,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763076,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-720",
         "APN": 46763077,
         "File Number": "AD06-720",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD06-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Propposal to increase the roof parapet height by 3 feet and new mechanical room at the roof level.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-721",
         "APN": 25940066,
         "File Number": "AD06-721",
         "Address": "110 S MARKET ST SAN JOSE",
         "Project Name": "AD06-721",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/06",
         "Status": "Approved ",
         "Description": "Proposal to allow installation of 8 temporary cargo containers with skirting for the Zero One event from August 1 to 15, 2006.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-911",
         "APN": 46757083,
         "File Number": "AD06-911",
         "Address": "235 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD06-911",
         "Application Type": "Permit Adjustment ",
         "Application Date": "8/15/06",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment for the installation of a kitchen exhaust duct on the existing rear exit stairs to allow for re-use of ground floor as restaurant in Vintage Tower City Landmark No. HL86-39.",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-918",
         "APN": 25934040,
         "File Number": "AD06-918",
         "Address": "2 N MARKET ST SAN JOSE",
         "Project Name": "AD06-918",
         "Application Type": "Permit Adjustment ",
         "Application Date": "8/16/06",
         "Status": "Approved ",
         "Description": "Permit adjustment to add 32 square feet of storefront, replace five existing storefront windows with doors, and remove existing planters located in front of proposed door locations.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-976",
         "APN": 46720072,
         "File Number": "AD06-976",
         "Address": "101 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD06-976",
         "Application Type": "Permit Adjustment ",
         "Application Date": "8/31/06",
         "Status": "Approved ",
         "Description": "Permit adjustment to remodel the facade of the Alliance Building (remove awnings, changes windows, doors, etc.)  ",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245001,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245002,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245003,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245004,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245005,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245006,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245008,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245009,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245010,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245011,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245012,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245013,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245014,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245015,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245016,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245017,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245018,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245019,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245020,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245021,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245022,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245023,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245025,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245027,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245028,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245029,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245030,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245031,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245032,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245033,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245034,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245035,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245037,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245038,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245039,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245042,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245043,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245044,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245046,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245047,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245048,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245049,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245050,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245053,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245054,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245055,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245056,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245059,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245064,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245065,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245066,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245067,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245069,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245071,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245072,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245073,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-984",
         "APN": 47245074,
         "File Number": "AD06-984",
         "Address": "125 PATTERSON ST UNIT 103 SAN JOSE",
         "Project Name": "AD06-984 The Works",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for The Works tract sales office with ADA wheelchair lift, on-street ADA ramp, and on-street parking. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-988",
         "APN": 46723096,
         "File Number": "AD06-988",
         "Address": "140 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD06-988",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment to: (1) remove existing storefront and install stucco wall with ATM on north elevation; (2) replace existing storefront double doors with new fixed glass storefront on north elevation; and (3) remove exterior storefront door and replace with new storefront door to match on west elevation.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-988",
         "APN": 46759110,
         "File Number": "AD06-988",
         "Address": "140 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD06-988",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/5/06",
         "Status": "Approved ",
         "Description": "Permit adjustment to: (1) remove existing storefront and install stucco wall with ATM on north elevation; (2) replace existing storefront double doors with new fixed glass storefront on north elevation; and (3) remove exterior storefront door and replace with new storefront door to match on west elevation.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD07-1063",
         "APN": 46747103,
         "File Number": "AD07-1063",
         "Address": "496 S 3RD ST SAN JOSE",
         "Project Name": "AD07-1063",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/4/07",
         "Status": "Approved ",
         "Description": "Planned Development Permit Adjustment to revise the landscape plan along the northern property line to plant four 24\"-box Tilia Cordata \"Little Leaf Linden\" trees between the property line and a new wheel chair ramp approximately 5' 1\" in width on an 0.38 gross acre site",
         "Planner": "Ron Eddow ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-1096",
         "APN": 26415015,
         "File Number": "AD07-1096",
         "Address": "720 W SAN CARLOS ST SAN JOSE",
         "Project Name": "AD07-1096",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/10/07",
         "Status": "Approved ",
         "Description": "Permit Adjustment for restriping to remove three parking spaces and replace with loading area in front of store. (Site Development Permit H94-068 shows 170 parking spaces required for the store/warehouse and 212 parking spaces provided.)",
         "Planner": "Rebekah Ross ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-1096",
         "APN": 26415017,
         "File Number": "AD07-1096",
         "Address": "720 W SAN CARLOS ST SAN JOSE",
         "Project Name": "AD07-1096",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/10/07",
         "Status": "Approved ",
         "Description": "Permit Adjustment for restriping to remove three parking spaces and replace with loading area in front of store. (Site Development Permit H94-068 shows 170 parking spaces required for the store/warehouse and 212 parking spaces provided.)",
         "Planner": "Rebekah Ross ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-1096",
         "APN": 26415065,
         "File Number": "AD07-1096",
         "Address": "720 W SAN CARLOS ST SAN JOSE",
         "Project Name": "AD07-1096",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/10/07",
         "Status": "Approved ",
         "Description": "Permit Adjustment for restriping to remove three parking spaces and replace with loading area in front of store. (Site Development Permit H94-068 shows 170 parking spaces required for the store/warehouse and 212 parking spaces provided.)",
         "Planner": "Rebekah Ross ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-1097",
         "APN": 46721045,
         "File Number": "AD07-1097",
         "Address": "35 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD07-1097",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/10/07",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow the installation of roof mounted Air Conditioning equipment. ",
         "Planner": "Ben Corrales ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-1358",
         "APN": 46746047,
         "File Number": "AD07-1358",
         "Address": "396 S 1ST ST SAN JOSE",
         "Project Name": "AD07-1358",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/31/07",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow the replacement of existing green tiles with blue glass tile on front and right side elevations, and painting the right side elevation from a green color scheme to a blue color scheme. ",
         "Planner": "Sylvia Do ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-1362",
         "APN": 46745069,
         "File Number": "AD07-1362",
         "Address": "345 S 4TH ST SAN JOSE",
         "Project Name": "AD07-1362",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/31/07",
         "Status": "Approved ",
         "Description": "Permit Adjustment for the relocation of a double storefront door in the place of glazing within the existing frame, for a restaurant in a commercial retail building. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-1518",
         "APN": 46702040,
         "File Number": "AD07-1518",
         "Address": "285 E ST JAMES ST SAN JOSE",
         "Project Name": "AD07-1518",
         "Application Type": "Permit Adjustment ",
         "Application Date": "12/6/07",
         "Status": "Approved ",
         "Description": "Permit Adjustment for six skylights, one plumbing stack vent on roof, three bathroom vents on roof, removal of one rear door and replacement with wood siding flush to existing wood siding on same elevation, reopening of one rear window, replacement of one wood basement window with wood window, and one new wood basement window.  ",
         "Planner": "Lesley Xavier ",
         "DURATION": 5,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-1567",
         "APN": 25933044,
         "File Number": "AD07-1567",
         "Address": "93 DEVINE ST SAN JOSE",
         "Project Name": "AD07-1567",
         "Application Type": "Permit Adjustment ",
         "Application Date": "12/13/07",
         "Status": "Approved ",
         "Description": "Facade Improvement Grant for buildings located at 79-93 Devine Street. The improvements are on all 4 facades of the two buildings, consisting of preservation of historic elements of the building, new paint, replacement of awnings, replacement of signage, and replacement of existing rear doors.",
         "Planner": "Dipa Chundur ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-1567",
         "APN": 25933045,
         "File Number": "AD07-1567",
         "Address": "93 DEVINE ST SAN JOSE",
         "Project Name": "AD07-1567",
         "Application Type": "Permit Adjustment ",
         "Application Date": "12/13/07",
         "Status": "Approved ",
         "Description": "Facade Improvement Grant for buildings located at 79-93 Devine Street. The improvements are on all 4 facades of the two buildings, consisting of preservation of historic elements of the building, new paint, replacement of awnings, replacement of signage, and replacement of existing rear doors.",
         "Planner": "Dipa Chundur ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-1584",
         "APN": 46745026,
         "File Number": "AD07-1584",
         "Address": "304 S 3RD ST SAN JOSE",
         "Project Name": "AD07-1584",
         "Application Type": "Permit Adjustment ",
         "Application Date": "12/17/07",
         "Status": "Approved ",
         "Description": "Permit Adjustment for installation of a roof-mounted ventilation stack with screening and a ladder (at side of building). ",
         "Planner": "Darren McBain ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-458",
         "APN": 25940053,
         "File Number": "AD07-458",
         "Address": "40 S MARKET ST SAN JOSE",
         "Project Name": "AD07-458",
         "Application Type": "Permit Adjustment ",
         "Application Date": "4/23/07",
         "Status": "Approved ",
         "Description": "Permit Adjustment for the removal of existing double storefront doors and infill with new tempered glass glazing on the south elevation of a commercial building. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-511",
         "APN": 46747103,
         "File Number": "AD07-511",
         "Address": "496 S 3RD ST SAN JOSE",
         "Project Name": "AD07-511",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/4/07",
         "Status": "Approved ",
         "Description": "Intake (FWD to PM REDDOW) for Permit Adjustment for exterior changes to the Grenninger House moved to this location ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-668",
         "APN": 25940017,
         "File Number": "AD07-668",
         "Address": "155 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD07-668",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/11/07",
         "Status": "Approved ",
         "Description": "Store front remodeling that includes removing existing windows to be replaced with aluminum and glass garage glass doors, existing awnings to be removed, replace infill framing and header to be removed and replaced with Desert Sunset Tile. SEE PLAN SET FOR DETAILS OF IMPROVEMENTS. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-681",
         "APN": 46724110,
         "File Number": "AD07-681",
         "Address": "272 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD07-681 Mercados Suvianda",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/14/07",
         "Status": "Approved ",
         "Description": "Permit Adjustment for exterior modifications and installation of equipment. ",
         "Planner": "Lori Moniz ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-760",
         "APN": 46745069,
         "File Number": "AD07-760",
         "Address": "345 S 4TH ST SAN JOSE",
         "Project Name": "AD07-760",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/2/07",
         "Status": "Approved ",
         "Description": "Permit Adjustment to replace one single door on right, southeast elevation, with a double door. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-783",
         "APN": 26429107,
         "File Number": "AD07-783",
         "Address": "302 S MARKET ST SAN JOSE",
         "Project Name": "HPAD07-783",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/9/07",
         "Status": "Approved ",
         "Description": "Permit Adjustment to replace two existing rooftop HVAC cooling units with two new units for the Hyatt Sainte Claire Hotel, City Historic Landmark No. 735.",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-828",
         "APN": 25943074,
         "File Number": "AD07-828",
         "Address": "300 PARK AV SAN JOSE",
         "Project Name": "AD07-828",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/18/07",
         "Status": "Approved ",
         "Description": "Permit Adjustment for minor architectural modifications to roll-up door at west elevation, and east elevation of link building; and updated landscape plan in accordance with Santa Clara Valley Water District riparian mitigations, for River Park Tower Phase II. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-874",
         "APN": 25940064,
         "File Number": "AD07-874",
         "Address": "25 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD07-874",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/30/07",
         "Status": "Approved ",
         "Description": "Permit Adjustment request to allow for changes to the approved storefront elevations for one tenant space.  ",
         "Planner": "Ron Eddow ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-881",
         "APN": 46702040,
         "File Number": "AD07-881",
         "Address": "285 E ST JAMES ST SAN JOSE",
         "Project Name": "AD07-881",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/31/07",
         "Status": "Approved ",
         "Description": "Permit Adjustment request to replace windows on the 3rd rear unit (carriage house), replace the basement door with a new door and siding, and remove deck under exterior stair and replace with lattice.",
         "Planner": "Lesley Xavier ",
         "DURATION": 24,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-939",
         "APN": 46747103,
         "File Number": "AD07-939",
         "Address": "496 S 3RD ST SAN JOSE",
         "Project Name": "AD07-939",
         "Application Type": "Permit Adjustment ",
         "Application Date": "8/14/07",
         "Status": "Approved ",
         "Description": "Permit Adjustment request to make changes to the approved landscape plan, transformer enclosure and removal of porch steps.  ",
         "Planner": "Ella Samonsky ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-963",
         "APN": 47218002,
         "File Number": "AD07-963",
         "Address": "792 S 3RD ST SAN JOSE",
         "Project Name": "AD07-963",
         "Application Type": "Permit Adjustment ",
         "Application Date": "8/20/07",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remoe water damage wood materials on entry stairs, porch and balaustrade to replicate with new materials to meet code requirements and maintain the Victorian architectural style of the property located in the R-M zoning district. ",
         "Planner": "Ben Corrales ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-991",
         "APN": 25934018,
         "File Number": "AD07-991",
         "Address": "81 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD07-991",
         "Application Type": "Permit Adjustment ",
         "Application Date": "8/23/07",
         "Status": "Approved ",
         "Description": "Repair exterior terracotta on the front facade of the building, repair and repaint the existing roof mounted flagpole, repaint existing metal windows and install new glazing, repair stone along the base of the building, and install two new vertical banners signs. ",
         "Planner": "Darren McBain ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD08-1062",
         "APN": 46718039,
         "File Number": "AD08-1062",
         "Address": "179 N 9TH ST SAN JOSE",
         "Project Name": "AD08-1062",
         "Application Type": "Permit Adjustment ",
         "Application Date": "8/28/08",
         "Status": "Approved ",
         "Description": "Permit adjustment to allow an existing unpermitted exterior staircase to remain on the rear of a multifamily building. ",
         "Planner": "Lee Butler ",
         "DURATION": 7,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-1127",
         "APN": 46762001,
         "File Number": "AD08-1127",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "AD08-1127",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/18/08",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment to allow a 1-year time extension to a previously approved Historic Preservation Permit. This Permit has already been extended once (see File No. AD 06-883).",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-1127",
         "APN": 46762007,
         "File Number": "AD08-1127",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "AD08-1127",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/18/08",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment to allow a 1-year time extension to a previously approved Historic Preservation Permit. This Permit has already been extended once (see File No. AD 06-883).",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-1127",
         "APN": 46762008,
         "File Number": "AD08-1127",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "AD08-1127",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/18/08",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment to allow a 1-year time extension to a previously approved Historic Preservation Permit. This Permit has already been extended once (see File No. AD 06-883).",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-1127",
         "APN": 46762009,
         "File Number": "AD08-1127",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "AD08-1127",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/18/08",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment to allow a 1-year time extension to a previously approved Historic Preservation Permit. This Permit has already been extended once (see File No. AD 06-883).",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-1127",
         "APN": 46762011,
         "File Number": "AD08-1127",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "AD08-1127",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/18/08",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment to allow a 1-year time extension to a previously approved Historic Preservation Permit. This Permit has already been extended once (see File No. AD 06-883).",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-1127",
         "APN": 46762012,
         "File Number": "AD08-1127",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "AD08-1127",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/18/08",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment to allow a 1-year time extension to a previously approved Historic Preservation Permit. This Permit has already been extended once (see File No. AD 06-883).",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-1127",
         "APN": 46762014,
         "File Number": "AD08-1127",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "AD08-1127",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/18/08",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment to allow a 1-year time extension to a previously approved Historic Preservation Permit. This Permit has already been extended once (see File No. AD 06-883).",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-1127",
         "APN": 46762015,
         "File Number": "AD08-1127",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "AD08-1127",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/18/08",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment to allow a 1-year time extension to a previously approved Historic Preservation Permit. This Permit has already been extended once (see File No. AD 06-883).",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-1127",
         "APN": 46762016,
         "File Number": "AD08-1127",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "AD08-1127",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/18/08",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment to allow a 1-year time extension to a previously approved Historic Preservation Permit. This Permit has already been extended once (see File No. AD 06-883).",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-1127",
         "APN": 46762017,
         "File Number": "AD08-1127",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "AD08-1127",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/18/08",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment to allow a 1-year time extension to a previously approved Historic Preservation Permit. This Permit has already been extended once (see File No. AD 06-883).",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-1127",
         "APN": 46762019,
         "File Number": "AD08-1127",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "AD08-1127",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/18/08",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment to allow a 1-year time extension to a previously approved Historic Preservation Permit. This Permit has already been extended once (see File No. AD 06-883).",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-1127",
         "APN": 46762020,
         "File Number": "AD08-1127",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "AD08-1127",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/18/08",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment to allow a 1-year time extension to a previously approved Historic Preservation Permit. This Permit has already been extended once (see File No. AD 06-883).",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-1136",
         "APN": 46745069,
         "File Number": "AD08-1136",
         "Address": "345 S 4TH ST SAN JOSE",
         "Project Name": "AD08-1136",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/19/08",
         "Status": "Approved ",
         "Description": "Permit Adjustment to legalize the addition of approximately 272 square feet added withouth the benefit of a permit. This permit also includes outdoor seating area in the side and front entrance of a building located in the DC - Downtwon Core Zoning District.",
         "Planner": "Lee Butler ",
         "DURATION": 0,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-1149",
         "APN": 25939120,
         "File Number": "AD08-1149",
         "Address": "95 S ALMADEN AV SAN JOSE",
         "Project Name": "AD08-1149",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/25/08",
         "Status": "Approved ",
         "Description": "Permit Adjustment for the installation of a new transformer within an existing equipment enclosure; and a new double swing metal gate, for an existing AT&T switching facility site. ",
         "Planner": "Lee Butler ",
         "DURATION": 8,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-1264",
         "APN": 46720078,
         "File Number": "AD08-1264",
         "Address": "30 N 3RD ST SAN JOSE",
         "Project Name": "AD08-1264",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/30/08",
         "Status": "Approved ",
         "Description": "Permit Adjustment to install roof equipment (three condensing units) in a building located in the DC - Downtown Core Zoning District. ",
         "Planner": "Ben Corrales ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-1401",
         "APN": 26420121,
         "File Number": "AD08-1401",
         "Address": "395 BIRD AV SAN JOSE",
         "Project Name": "AD08-1401",
         "Application Type": "Permit Adjustment ",
         "Application Date": "12/12/08",
         "Status": "Approved ",
         "Description": "Pemit Adjsutment request for installing Healy Vapor Recovery system at an existing Gasoline station ",
         "Planner": "Ella Samonsky ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-1427",
         "APN": 25941068,
         "File Number": "AD08-1427",
         "Address": "185 PARK AV SAN JOSE",
         "Project Name": "AD08-1427",
         "Application Type": "Permit Adjustment ",
         "Application Date": "12/18/08",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow facade remodel including storefront windows and doors; removal of existing fabric awnings to be replaced with metal louvered awnings ",
         "Planner": "Darren McBain ",
         "DURATION": 0,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-1433",
         "APN": 46764005,
         "File Number": "AD08-1433",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD08-1433",
         "Application Type": "Permit Adjustment ",
         "Application Date": "12/19/08",
         "Status": "Approved ",
         "Description": "Permit Adjustment to reduce the overall public parking spaces by a total of 6 spaces to accommodate new elevator.",
         "Planner": "Darren McBain ",
         "DURATION": 0,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-1433",
         "APN": 46764010,
         "File Number": "AD08-1433",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD08-1433",
         "Application Type": "Permit Adjustment ",
         "Application Date": "12/19/08",
         "Status": "Approved ",
         "Description": "Permit Adjustment to reduce the overall public parking spaces by a total of 6 spaces to accommodate new elevator.",
         "Planner": "Darren McBain ",
         "DURATION": 0,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-1438",
         "APN": 25944080,
         "File Number": "AD08-1438",
         "Address": "111 ALMADEN BL SAN JOSE",
         "Project Name": "AD08-1438",
         "Application Type": "Permit Adjustment ",
         "Application Date": "12/22/08",
         "Status": "Approved ",
         "Description": "Permit Adjustment request for installtion of a 5 ton rooftop AC equipment, 36 inches tall, mounted on a 14 inches tall mounting platform, on top of 10 feet tall penthouse, with surrounding parapet 10 feet tall, per approved plans, only.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-1439",
         "APN": 25939115,
         "File Number": "AD08-1439",
         "Address": "99 ALMADEN BL SAN JOSE",
         "Project Name": "AD08-1439",
         "Application Type": "Permit Adjustment ",
         "Application Date": "12/22/08",
         "Status": "Approved ",
         "Description": "Permit Adjustment request for replacing existing window on the north-east side of the banwith a 3 ft wide doorway for an existing commercial building",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-1442",
         "APN": 25935056,
         "File Number": "AD08-1442",
         "Address": "73 N SAN PEDRO ST SAN JOSE",
         "Project Name": "AD08-1442",
         "Application Type": "Permit Adjustment ",
         "Application Date": "12/23/08",
         "Status": "Approved ",
         "Description": "Separation barriers between the restaurant outdoor seating and pedestrian right-of-way and also pedestrian walkway connecting North San Pedro Street to the Peralta Adobe Site. ",
         "Planner": "Suzanne Thomas ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-198",
         "APN": 47217074,
         "File Number": "AD08-198",
         "Address": "759 S 3RD ST SAN JOSE",
         "Project Name": "AD08-198",
         "Application Type": "Permit Adjustment ",
         "Application Date": "1/22/08",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow landscape changes including the addition of approximately 312 square feet of concrete and additional landscaping with irrigation on the north side of the existing apartment building and the replacement of the existing fences with new wood fences.",
         "Planner": "Lori Moniz ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-201",
         "APN": 46720072,
         "File Number": "AD08-201",
         "Address": "101 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD08-201(The Alliance Building)",
         "Application Type": "Permit Adjustment ",
         "Application Date": "1/23/08",
         "Status": "Approved ",
         "Description": "Permit Adjustment request to modify the entrance to an existing storefront. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-215",
         "APN": 47217012,
         "File Number": "AD08-215",
         "Address": "760 S 1ST ST SAN JOSE",
         "Project Name": "AD08-215",
         "Application Type": "Permit Adjustment ",
         "Application Date": "1/28/08",
         "Status": "Approved ",
         "Description": "Permit Adjustment to make minor modifications to the approved SP07-001 for a property located in the CP - Commercial Pedestrian Zoning District.",
         "Planner": "Ben Corrales ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-536",
         "APN": 26420125,
         "File Number": "AD08-536",
         "Address": "602 W SAN CARLOS ST SAN JOSE",
         "Project Name": "AD08-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "4/28/08",
         "Status": "Approved ",
         "Description": "Permit Adjustment for the installation of a Healy clean air separator tank with metal enclosure and bollards, at the rear of an existing gasoline service station. ",
         "Planner": "Rebekah Ross ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-557",
         "APN": 25939120,
         "File Number": "AD08-557",
         "Address": "95 S ALMADEN AV SAN JOSE",
         "Project Name": "AD08-557",
         "Application Type": "Permit Adjustment ",
         "Application Date": "4/29/08",
         "Status": "Approved ",
         "Description": "Permit Adjustment for the removal and replacement of six panel antennas at an existing wireless site, and the addition of one equipment cabinet, on top of an existing nine-story building, for T-Mobile. ",
         "Planner": "John Kim ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471001,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471006,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471007,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471009,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471010,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471011,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471013,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471014,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471017,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471018,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471019,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471020,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471021,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471022,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471023,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471025,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471026,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471028,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471029,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471030,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471031,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471034,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471035,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471036,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471037,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471038,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471039,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471040,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471041,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471042,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471043,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471044,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471045,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471046,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471047,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471049,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471050,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471051,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471052,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471053,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471054,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471055,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471056,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471057,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471059,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471060,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471061,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471062,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471063,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471064,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471065,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471066,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471068,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471069,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471070,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471071,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471072,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471073,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471074,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471075,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471077,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471078,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471080,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471082,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471083,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471084,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471085,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471086,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471087,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471088,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471089,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471091,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471092,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471093,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471094,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471095,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471096,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471097,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471100,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471102,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471103,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471104,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471105,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471106,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471107,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471108,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471109,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471110,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471111,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471112,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471113,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471114,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471115,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471116,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471117,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471118,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471119,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471121,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471122,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471123,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471124,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471125,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471127,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471128,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471130,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471131,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471132,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471133,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471134,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471135,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471136,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471137,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471138,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471140,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471141,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471142,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471143,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471144,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471145,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471146,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471147,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471148,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471149,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471150,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471151,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471152,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471153,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471154,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471155,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471156,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471157,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471158,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471159,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471160,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471161,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471162,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471163,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471164,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471165,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471166,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471167,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471168,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471169,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471171,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471172,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471173,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471174,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471175,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471177,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471178,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471179,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471182,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471184,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471185,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471186,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471187,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471188,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471189,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471191,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471192,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471193,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471195,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471196,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471197,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471198,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471199,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471200,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471201,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471202,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471203,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471204,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471205,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471207,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471208,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471209,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471210,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471211,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471212,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471213,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471214,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471215,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471216,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471217,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-632",
         "APN": 26471218,
         "File Number": "AD08-632",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD08-632",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/08",
         "Status": "Approved ",
         "Description": "Temporary extension of construction hours on 6/14 and 6/15/08 per condition 10.j. in the original site permit. Hours of construction will be 8 a.m. to 5 p.m. both days.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-668",
         "APN": 25940066,
         "File Number": "AD08-668",
         "Address": "110 S MARKET ST SAN JOSE",
         "Project Name": "AD08-668",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/23/08",
         "Status": "Approved ",
         "Description": "TO ALLOW INSTALLATION OF AN ATTACHED ART FRAME STRUCTURE FOR AN ART EXHIBIT ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-684",
         "APN": 25941057,
         "File Number": "AD08-684",
         "Address": "125 S MARKET ST SAN JOSE",
         "Project Name": "AD08-684",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/30/08",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow the replacement of existing entry canopies, awnings, storefront, handrails, lighting and concrete and the addition of new planters, benches and trash cans. ",
         "Planner": "Lori Moniz ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-684",
         "APN": 25941067,
         "File Number": "AD08-684",
         "Address": "125 S MARKET ST SAN JOSE",
         "Project Name": "AD08-684",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/30/08",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow the replacement of existing entry canopies, awnings, storefront, handrails, lighting and concrete and the addition of new planters, benches and trash cans. ",
         "Planner": "Lori Moniz ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-685",
         "APN": 25941057,
         "File Number": "AD08-685",
         "Address": "100 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD08-685",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/30/08",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow the replacement of existing entry canopies, awnings and new hand railings and the addition of two (2) new light fixtures.",
         "Planner": "Lori Moniz ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-685",
         "APN": 25941067,
         "File Number": "AD08-685",
         "Address": "100 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD08-685",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/30/08",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow the replacement of existing entry canopies, awnings and new hand railings and the addition of two (2) new light fixtures.",
         "Planner": "Lori Moniz ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-686",
         "APN": 25941057,
         "File Number": "AD08-686",
         "Address": "177 PARK CENTER PLAZA SAN JOSE",
         "Project Name": "AD08-686",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/30/08",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow the addition of and entry canopy, awnings and storefront.. ",
         "Planner": "Lori Moniz ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-686",
         "APN": 25941067,
         "File Number": "AD08-686",
         "Address": "177 PARK CENTER PLAZA SAN JOSE",
         "Project Name": "AD08-686",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/30/08",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow the addition of and entry canopy, awnings and storefront.. ",
         "Planner": "Lori Moniz ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-740",
         "APN": 46721034,
         "File Number": "AD08-740",
         "Address": "4 N 2ND ST SAN JOSE",
         "Project Name": "AD08-740",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/10/08",
         "Status": "Approved ",
         "Description": "Permit Adjustment for a new trash enclosure ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-771",
         "APN": 47227091,
         "File Number": "AD08-771",
         "Address": "740 S 3RD ST SAN JOSE",
         "Project Name": "AD08-771",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/16/08",
         "Status": "Approved ",
         "Description": "Permit Adjustment requset for exterior elevation changes to an existing duplex that is listed on the Historic Resaources Inventory as a Contributing Structure in a City Conservation Area.  ",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-826",
         "APN": 26137029,
         "File Number": "AD08-826",
         "Address": "655 W SAN CARLOS ST SAN JOSE",
         "Project Name": "AD08-826",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/30/08",
         "Status": "Approved ",
         "Description": "Permit Adjustment request to add two (2) enclosures for storage and vacuum equipment purposes at an existing car wash.",
         "Planner": "John Davidson ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-827",
         "APN": 25924035,
         "File Number": "AD08-827",
         "Address": "333 W JULIAN ST SAN JOSE",
         "Project Name": "AD08-827",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/30/08",
         "Status": "Approved ",
         "Description": "Permit Adjustment request to add two (2) new ADA accessible parking spaces, which includes restriping and the addition of two accessible ramps.",
         "Planner": "John Davidson ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-882",
         "APN": 25939116,
         "File Number": "AD08-882",
         "Address": "333 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD08-882",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/11/08",
         "Status": "Approved ",
         "Description": "Permit Adjustment request to close vehicle access at an existing driveway and add a new driveway for an exsting surface parking lot.  ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-950",
         "APN": 47226064,
         "File Number": "AD08-950",
         "Address": "600 S 2ND ST SAN JOSE",
         "Project Name": "AD08-950",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/28/08",
         "Status": "Approved ",
         "Description": "Permit Adjustment request for constructing a Redwood fence, replacing an existing chain-link fence, height varying from 6 feet to 8 feet, along the south-east property line of the funeral home/mortuary property",
         "Planner": "Lee Butler ",
         "DURATION": 2,
         "Year": 2008
      },
      {
         "PERMITID": "AD09-057",
         "APN": 47218055,
         "File Number": "AD09-057",
         "Address": "288 E VIRGINIA ST SAN JOSE",
         "Project Name": "AD09-057",
         "Application Type": "Permit Adjustment ",
         "Application Date": "1/20/09",
         "Status": "Approved ",
         "Description": "Proposed intallation of Phase II Enhanced Vapor Recovery (EVR) System upgrade using carbon canister and associated improvements by Veeder-Root, installed at an existing gasoline service station as shown on the approved Permit Adjustment plans. The proposed system shall be located away from the South 7th Street over the roof on the brick wall at the rear.",
         "Planner": "Darren McBain ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-070",
         "APN": 46701043,
         "File Number": "AD09-070",
         "Address": "250 N 3RD ST SAN JOSE",
         "Project Name": "AD09-070",
         "Application Type": "Permit Adjustment ",
         "Application Date": "1/23/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment request to allow window retrofiting and new frames in approximately one hundred and ten (110) windows in a multi-family residential building located in the CO - Commercial Office and CG - Commercial General Zoning District.",
         "Planner": "Ben Corrales ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-1063",
         "APN": 25940043,
         "File Number": "AD09-1063",
         "Address": "27 S 1ST ST SAN JOSE",
         "Project Name": "AD09-1063",
         "Application Type": "Permit Adjustment ",
         "Application Date": "12/9/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to: 1) replace storefront windows on the N. 1st Street elevation with slider doors; 2) add a new entryway/door on N. 1st Street; 3) remove storefront entries at the rear of the building and fill in with matching building materials; 4) modify an existing and add a second, new, delivery/roll-up door at the rear; and 5) remove existing signage.",
         "Planner": "Jeff Roche ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-135",
         "APN": 25941057,
         "File Number": "AD09-135",
         "Address": "125 S MARKET ST SAN JOSE",
         "Project Name": "AD09-135",
         "Application Type": "Permit Adjustment ",
         "Application Date": "1/30/09",
         "Status": "Approved ",
         "Description": "Major Permit Adjustment to allow the following: 1) New entry door in place of an existing fixed window; 2) New accessible ramp from the southeast corner of the property and associated improvements; 3) New main entrance stairway from South Market Street. (All proposed work in the public right of way shall conform to the approved Downtown Streetscape Master Plan -- H05-014 Condition No. 32.); and 4) Three (3) New atm's and associated vestibule improvements as shown on the approved Permit Adjustment plans only.",
         "Planner": "Lee Butler ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-261",
         "APN": 46746015,
         "File Number": "AD09-261",
         "Address": "394 S 2ND ST SAN JOSE",
         "Project Name": "Milano Restaurant: AD09-261",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/20/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment request for external modifications to an existing restaurant/bar \"Milano Restaurant\" for allowing (1) the top portion of the front wall to make it vertical, (2) add three new windows and new awnings on top of all opentnings to the front facade, (3)replacement of an existing gate and 7 feet tall CMU wall with decortaive pre-fabricated metal gate for the side patio area.",
         "Planner": "John Davidson ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-298",
         "APN": 46720079,
         "File Number": "AD09-298",
         "Address": "147 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD09-298",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/26/09",
         "Status": "Approved ",
         "Description": "Proposed intallation of Phase II Enhanced Vapor Recovery (EVR) System upgrade using carbon canister and associated improvements by Veeder-Root installed at an existing gasoline service station as shown on the approved Permit Adjustment plans only. The proposed system shall be located along the rear property line and setback at 5' from the property line.",
         "Planner": "MNAGARAJ ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-337",
         "APN": 25940087,
         "File Number": "AD09-337",
         "Address": "160 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD09-337",
         "Application Type": "Permit Adjustment ",
         "Application Date": "4/6/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow an outdoor ATM and a new awning on an existing commercial building ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-363",
         "APN": 25941057,
         "File Number": "AD09-363",
         "Address": "125 S MARKET ST SAN JOSE",
         "Project Name": "AD09-363",
         "Application Type": "Permit Adjustment ",
         "Application Date": "4/13/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow the addition of a canopy to an existing financial institution building as shown on the approved Permit Adjustment plans only. ",
         "Planner": "Jeff Roche ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-391",
         "APN": 25940041,
         "File Number": "AD09-391",
         "Address": "15 S 1ST ST SAN JOSE",
         "Project Name": "AD09-391",
         "Application Type": "Permit Adjustment ",
         "Application Date": "4/22/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow repainting of an existing commercial building and adding new roof equipment as shown on the approved Permit Adjustment plans only. ",
         "Planner": "Jeff Roche ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764001,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764002,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764004,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764005,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764006,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764008,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764010,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764019,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764020,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764021,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764022,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764024,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764025,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764026,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764027,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764028,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764029,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764030,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764031,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764032,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764033,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764036,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764037,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764039,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764040,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764042,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764043,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764045,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764046,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764047,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764049,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764050,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764051,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764052,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764053,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764054,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764055,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764057,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764058,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764060,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764061,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764062,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764063,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764065,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764066,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764068,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764070,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764071,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764072,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764073,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764075,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764078,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764079,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764080,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764081,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764082,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764083,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764084,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764085,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764086,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764088,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764089,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764090,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764092,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764094,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764096,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764097,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764098,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764099,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764100,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764101,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764102,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764104,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764106,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764108,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764109,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764110,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764111,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764113,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764114,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764115,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764116,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764117,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764118,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764119,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764120,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764121,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764123,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764124,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764125,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764126,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764127,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764128,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764129,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764130,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764131,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764132,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764133,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764134,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764135,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764136,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764137,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764138,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764139,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764140,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764141,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764142,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764143,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764144,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764145,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764146,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764147,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764148,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764149,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764152,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764153,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764154,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764155,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764156,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764157,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764158,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764159,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764160,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764161,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764162,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764163,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764164,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764165,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764167,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764168,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764169,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764170,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764171,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764173,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764174,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764175,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764176,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764178,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764179,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764180,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764181,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764182,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764184,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764185,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764186,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764187,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764188,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764189,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764190,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764191,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764192,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764193,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764194,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764195,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764196,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764197,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764198,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764199,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764201,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-536",
         "APN": 46764205,
         "File Number": "AD09-536",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-536",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove one window and replace with louver/vent on the southern elevation of the building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-552",
         "APN": 24950047,
         "File Number": "AD09-552",
         "Address": "339 N 9TH ST SAN JOSE",
         "Project Name": "AD09-552",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/12/09",
         "Status": "Approved ",
         "Description": "Minor Permit Adjustment to 1) change approved hip roof to gable roof on the front facade and 2) add new composition shingle roof at the rear elevation.",
         "Planner": "Mike Enderby ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-556",
         "APN": 25943074,
         "File Number": "AD09-556",
         "Address": "300 PARK AV SAN JOSE",
         "Project Name": "AD09-556",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/16/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a pre-fabricated stair for access to the fire air fill station at the northwest corner of the building ",
         "Planner": "Mike Enderby ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-587",
         "APN": 46720080,
         "File Number": "AD09-587",
         "Address": "60 N 3RD ST SAN JOSE",
         "Project Name": "AD09-587",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/25/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow installation of window washing equipment (tie backs) and 42 inches tall metal railings on the roof top of an existing apartment complex.",
         "Planner": "Suparna Saha ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-798",
         "APN": 26420121,
         "File Number": "AD09-798",
         "Address": "395 BIRD AV SAN JOSE",
         "Project Name": "AD09-798",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/2/09",
         "Status": "Approved ",
         "Description": "To replace an existing shingle covered gas station canopy with a new extended metal canopy. The new canopy extends by 9' to the north and south and 1'6\" to the east and west directions.",
         "Planner": "MNAGARAJ ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-847",
         "APN": 46718087,
         "File Number": "AD09-847",
         "Address": "345 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD09-847",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/21/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior facade improvements including but not limited to awnings, replacement of windows, downspouts and other details to a building in the historical resource inventory AND 6 attached tenant signs, two in the front facade 24.33 sq.ft each in size, 4 in the rear of building ,Tenant #2, 10 sq.ft, Tenants #'s 1,3 &4, 18 sq.ft. each in size.",
         "Planner": "Mike Enderby ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-929",
         "APN": 25940091,
         "File Number": "AD09-929",
         "Address": "55 S MARKET ST SAN JOSE",
         "Project Name": "AD09-929",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/14/09",
         "Status": "Approved ",
         "Description": "INSTALLATION OF 15 BUILDING MOUNTED MICROWAVE DISHES AND THREE PANEL ANTENNAS WITH ASSOCIATED EQUIPMENT CABINETS.",
         "Planner": "Mike Enderby ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "AD10-009",
         "APN": 26420121,
         "File Number": "AD10-009",
         "Address": "395 BIRD AV SAN JOSE",
         "Project Name": "AD10-009",
         "Application Type": "Permit Adjustment ",
         "Application Date": "1/7/10",
         "Status": "Approved ",
         "Description": "Proposed 4 attached signs on a previously approved service station canopy.",
         "Planner": "Mike Enderby ",
         "DURATION": 0,
         "Year": 2010
      },
      {
         "PERMITID": "AD10-1038",
         "APN": 46745025,
         "File Number": "AD10-1038",
         "Address": "140 E SAN CARLOS ST SAN JOSE",
         "Project Name": "AD10-1038",
         "Application Type": "Permit Adjustment ",
         "Application Date": "12/17/10",
         "Status": "Approved ",
         "Description": "Permit to install a accessible lift for an existing restaurant and recorded easement. ",
         "Planner": "Mike Enderby ",
         "DURATION": 0,
         "Year": 2010
      },
      {
         "PERMITID": "AD10-140",
         "APN": 25946040,
         "File Number": "AD10-140",
         "Address": "201 DELMAS AV SAN JOSE",
         "Project Name": "AD10-140",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/26/10",
         "Status": "Approved ",
         "Description": "Retroactive Permit Extension for previously approved SP08-055.",
         "Planner": "Mike Enderby ",
         "DURATION": 1,
         "Year": 2010
      },
      {
         "PERMITID": "AD10-140",
         "APN": 25946044,
         "File Number": "AD10-140",
         "Address": "201 DELMAS AV SAN JOSE",
         "Project Name": "AD10-140",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/26/10",
         "Status": "Approved ",
         "Description": "Retroactive Permit Extension for previously approved SP08-055.",
         "Planner": "Mike Enderby ",
         "DURATION": 1,
         "Year": 2010
      },
      {
         "PERMITID": "AD10-140",
         "APN": 25946045,
         "File Number": "AD10-140",
         "Address": "201 DELMAS AV SAN JOSE",
         "Project Name": "AD10-140",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/26/10",
         "Status": "Approved ",
         "Description": "Retroactive Permit Extension for previously approved SP08-055.",
         "Planner": "Mike Enderby ",
         "DURATION": 1,
         "Year": 2010
      },
      {
         "PERMITID": "AD10-140",
         "APN": 25946056,
         "File Number": "AD10-140",
         "Address": "201 DELMAS AV SAN JOSE",
         "Project Name": "AD10-140",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/26/10",
         "Status": "Approved ",
         "Description": "Retroactive Permit Extension for previously approved SP08-055.",
         "Planner": "Mike Enderby ",
         "DURATION": 1,
         "Year": 2010
      },
      {
         "PERMITID": "AD10-140",
         "APN": 25946057,
         "File Number": "AD10-140",
         "Address": "201 DELMAS AV SAN JOSE",
         "Project Name": "AD10-140",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/26/10",
         "Status": "Approved ",
         "Description": "Retroactive Permit Extension for previously approved SP08-055.",
         "Planner": "Mike Enderby ",
         "DURATION": 1,
         "Year": 2010
      },
      {
         "PERMITID": "AD10-140",
         "APN": 25946090,
         "File Number": "AD10-140",
         "Address": "201 DELMAS AV SAN JOSE",
         "Project Name": "AD10-140",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/26/10",
         "Status": "Approved ",
         "Description": "Retroactive Permit Extension for previously approved SP08-055.",
         "Planner": "Mike Enderby ",
         "DURATION": 1,
         "Year": 2010
      },
      {
         "PERMITID": "AD10-439",
         "APN": 25940084,
         "File Number": "AD10-439",
         "Address": "95 S MARKET ST SAN JOSE",
         "Project Name": "AD10-439",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/10/10",
         "Status": "Approved ",
         "Description": "To add a new exit door on the storefront and new concrete pavement in place of existing planter position; and add new store window in place of an existing door. ",
         "Planner": "MNAGARAJ ",
         "DURATION": 0,
         "Year": 2010
      },
      {
         "PERMITID": "AD10-482",
         "APN": 25935056,
         "File Number": "AD10-482",
         "Address": "73 N SAN PEDRO ST SAN JOSE",
         "Project Name": "AD10-482",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/24/10",
         "Status": "Approved ",
         "Description": "Permit Adjustment to attach a trellis to existing building.  ",
         "Planner": "Michael Mena ",
         "DURATION": 0,
         "Year": 2010
      },
      {
         "PERMITID": "AD10-507",
         "APN": 26429118,
         "File Number": "AD10-507",
         "Address": "389 S 1ST ST SAN JOSE",
         "Project Name": "AD10-507",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/1/10",
         "Status": "Approved ",
         "Description": "Proposed facade improvement and new non illuminated architectural letters sign 1'8\" high, approximately 15sf sign area to replace an existing smaller sign.",
         "Planner": "MNAGARAJ ",
         "DURATION": 0,
         "Year": 2010
      },
      {
         "PERMITID": "AD10-583",
         "APN": 25935013,
         "File Number": "AD10-583",
         "Address": "87 N SAN PEDRO ST SAN JOSE",
         "Project Name": "AD10-583",
         "Application Type": "Permit Adjustment ",
         "Application Date": "8/2/10",
         "Status": "Approved ",
         "Description": "Permit to modify the storefront and elevations of an Urban Public Market (El Dorado Bulding) on a 1.09 gross acre site containing a public facility (Peralta Adobe) in the DC Downtown Commercial zoning district",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2010
      },
      {
         "PERMITID": "AD10-625",
         "APN": 25939120,
         "File Number": "AD10-625",
         "Address": "95 S ALMADEN AV SAN JOSE",
         "Project Name": "AD10-625",
         "Application Type": "Permit Adjustment ",
         "Application Date": "8/16/10",
         "Status": "Approved ",
         "Description": "Permit to construct a equipment enclosure measuring approximately 40 square feet as shown on the approved plans.",
         "Planner": "Michael Mena ",
         "DURATION": 0,
         "Year": 2010
      },
      {
         "PERMITID": "AD10-680",
         "APN": 47218021,
         "File Number": "AD10-680",
         "Address": "826 S 3RD ST SAN JOSE",
         "Project Name": "AD10-680",
         "Application Type": "Permit Adjustment ",
         "Application Date": "8/27/10",
         "Status": "Approved ",
         "Description": "Permit Adjustment to reactivate Site Development Permit H08-028 and extend term for a period of two (2) years from its expiration date of August 22, 2010",
         "Planner": "John Davidson ",
         "DURATION": 1,
         "Year": 2010
      },
      {
         "PERMITID": "AD10-702",
         "APN": 25935045,
         "File Number": "AD10-702",
         "Address": "170 W ST JOHN ST SAN JOSE",
         "Project Name": "AD10-702",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/7/10",
         "Status": "Approved ",
         "Description": "Permit to modify the architecture of a proposed retail/market building from a \"butterfly\" roof to a shed roof, modify the location/dimensions of an extended perimeter canopy, in addition to minor changes to doors and windows. ",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2010
      },
      {
         "PERMITID": "AD10-799",
         "APN": 25935045,
         "File Number": "AD10-799",
         "Address": "170 W ST JOHN ST SAN JOSE",
         "Project Name": "AD10-799",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/7/10",
         "Status": "Approved ",
         "Description": "Permit to relocate a trash enclosure and expand the cool storage area for a new urban market (Perazzo Building).  ",
         "Planner": "Michael Mena ",
         "DURATION": 0,
         "Year": 2010
      },
      {
         "PERMITID": "AD10-883",
         "APN": 25935056,
         "File Number": "AD10-883",
         "Address": "73 N SAN PEDRO ST SAN JOSE",
         "Project Name": "AD10-883",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/29/10",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow use of patio on north side of building (previosly open-air arbor) as dining area per Condition No. 10 of CPA08-058-01.",
         "Planner": "Michael Mena ",
         "DURATION": 0,
         "Year": 2010
      },
      {
         "PERMITID": "AD10-932",
         "APN": 25936074,
         "File Number": "AD10-932",
         "Address": "333 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD10-932",
         "Application Type": "Permit Adjustment ",
         "Application Date": "11/15/10",
         "Status": "Approved ",
         "Description": "INSTALLATION OF THREE PANEL ANTENNAS AND TWO MICROWAVE DISHES WITH ASSOCIATED ROOFTOP EQUIPMENT CABINET.  ",
         "Planner": "Michael Mena ",
         "DURATION": 0,
         "Year": 2010
      },
      {
         "PERMITID": "AD10-997",
         "APN": 46717090,
         "File Number": "AD10-997",
         "Address": "425 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD10-997",
         "Application Type": "Permit Adjustment ",
         "Application Date": "12/3/10",
         "Status": "Approved ",
         "Description": "Permit to install wireless communication antenna within a new faux chimney and the installation of associated rooftop equipment. ",
         "Planner": "Michael Mena ",
         "DURATION": 0,
         "Year": 2010
      },
      {
         "PERMITID": "AD11-066",
         "APN": 26411103,
         "File Number": "AD11-066",
         "Address": "550 SUNOL ST SAN JOSE",
         "Project Name": "AD11-066",
         "Application Type": "Permit Adjustment ",
         "Application Date": "1/31/11",
         "Status": "Approved ",
         "Description": "Installation of three new panel antennas onto existing monople, along with associated equipment.  ",
         "Planner": "Michael Mena ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-150",
         "APN": 47218063,
         "File Number": "AD11-150",
         "Address": "9750 TRACT SAN JOSE",
         "Project Name": "AD11-150",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/1/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a (1) one-year time extension of a previously approved Planned Development Permit only.",
         "Planner": "Jeff Roche ",
         "DURATION": 1,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-309",
         "APN": 25934057,
         "File Number": "AD11-309",
         "Address": "8 N SAN PEDRO ST SAN JOSE",
         "Project Name": "AD11-309",
         "Application Type": "Permit Adjustment ",
         "Application Date": "4/28/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a special two-year term extension for Site Development Permit file no. H08-027 from May 21, 20011 to May 21, 2013.",
         "Planner": "Susan Walsh ",
         "DURATION": 1,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-324",
         "APN": 26420121,
         "File Number": "AD11-324",
         "Address": "395 BIRD AV SAN JOSE",
         "Project Name": "AD11-324",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/3/11",
         "Status": "Approved ",
         "Description": "Installation of additional site lighting, using LED fixtures instead of low-pressure sodium.  ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471001,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471006,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471007,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471009,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471010,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471011,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471013,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471014,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471017,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471018,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471019,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471020,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471021,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471022,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471023,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471025,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471026,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471028,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471029,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471030,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471031,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471034,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471035,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471036,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471037,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471038,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471039,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471040,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471041,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471042,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471043,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471044,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471045,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471046,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471047,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471049,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471050,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471051,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471052,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471053,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471054,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471055,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471056,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471057,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471059,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471060,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471061,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471062,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471063,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471064,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471065,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471066,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471068,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471069,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471070,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471071,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471072,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471073,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471074,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471075,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471077,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471078,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471080,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471082,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471083,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471084,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471085,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471086,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471087,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471088,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471089,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471091,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471092,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471093,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471094,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471095,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471096,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471097,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471100,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471102,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471103,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471104,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471105,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471106,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471107,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471108,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471109,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471110,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471111,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471112,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471113,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471114,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471115,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471116,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471117,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471118,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471119,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471121,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471122,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471123,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471124,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471125,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471127,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471128,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471130,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471131,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471132,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471133,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471134,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471135,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471136,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471137,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471138,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471140,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471141,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471142,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471143,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471144,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471145,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471146,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471147,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471148,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471149,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471150,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471151,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471152,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471153,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471154,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471155,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471156,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471157,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471158,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471159,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471160,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471161,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471162,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471163,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471164,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471165,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471166,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471167,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471168,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471169,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471171,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471172,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471173,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471174,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471175,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471177,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471178,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471179,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471182,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471184,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471185,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471186,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471187,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471188,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471189,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471191,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471192,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471193,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471195,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471196,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471197,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471198,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471199,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471200,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471201,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471202,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471203,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471204,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471205,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471207,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471208,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471209,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471210,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471211,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471212,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471213,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471214,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471215,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471216,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471217,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-484",
         "APN": 26471218,
         "File Number": "AD11-484",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD11-484",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a BBQ structure on the fifth floor courtyard area. ",
         "Planner": "Susan Walsh ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-589",
         "APN": 25941086,
         "File Number": "AD11-589",
         "Address": "50 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD11-589",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/20/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to replace existing 3'-6\" glass guardrail with new 6'-6\" glass guardrail with windscreen on 17th floor.",
         "Planner": "Lee Butler ",
         "DURATION": 2,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-589",
         "APN": 25941087,
         "File Number": "AD11-589",
         "Address": "50 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD11-589",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/20/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to replace existing 3'-6\" glass guardrail with new 6'-6\" glass guardrail with windscreen on 17th floor.",
         "Planner": "Lee Butler ",
         "DURATION": 2,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-618",
         "APN": 24948031,
         "File Number": "AD11-618",
         "Address": "377 N 7TH ST SAN JOSE",
         "Project Name": "AD11-618",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/27/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications, including replacing existing plywood siding to stucco, replacing aluminum framed windows with vinyl framed windows, and reroofing composition shingles roof. ",
         "Planner": "Lee Butler ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-657",
         "APN": 46722003,
         "File Number": "AD11-657",
         "Address": "30 S 1ST ST SAN JOSE",
         "Project Name": "AD11-657",
         "Application Type": "Permit Adjustment ",
         "Application Date": "8/9/11",
         "Status": "Approved ",
         "Description": "Remove existing windows and door on right side of facade and replace with windows and door to match existing storefront on left side. All new windows and door will be wood framed.  ",
         "Planner": "Lee Butler ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-786",
         "APN": 25935013,
         "File Number": "AD11-786",
         "Address": "87 N SAN PEDRO ST SAN JOSE",
         "Project Name": "AD11-786",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/23/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment to add four rooftop exhaust fans. ",
         "Planner": "Jeff Roche ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-789",
         "APN": 47217090,
         "File Number": "AD11-789",
         "Address": "829 S 3RD ST SAN JOSE",
         "Project Name": "AD11-789",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/27/11",
         "Status": "Approved ",
         "Description": "To remove an illegal deck at the rear of an existing multifamily building and to replace an existing post, like for like only.  ",
         "Planner": "Jeff Roche ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-835",
         "APN": 46701023,
         "File Number": "AD11-835",
         "Address": "247 N 3RD ST SAN JOSE",
         "Project Name": "AD11-835",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/12/11",
         "Status": "Approved ",
         "Description": "Installation of an ADA lift at rear of existing office building, listed on the Historic Resources Inventory.  ",
         "Planner": "Avril Baty ",
         "DURATION": 1,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-845",
         "APN": 46746072,
         "File Number": "AD11-845",
         "Address": "90 E SAN CARLOS ST SAN JOSE",
         "Project Name": "AD11-845",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/14/11",
         "Status": "Approved ",
         "Description": "Demolish and replace exisiting planters with new 8- inch high concrete planters in the same location.",
         "Planner": "Mike Enderby ",
         "DURATION": 2886,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-858",
         "APN": 26415021,
         "File Number": "AD11-858",
         "Address": "791 AUZERAIS AV SAN JOSE",
         "Project Name": "AD11-858",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/17/11",
         "Status": "Approved ",
         "Description": "Permit Adjustment for installation of a wireless telecommunications fiber modem box inside an existing equipment enclosure. ",
         "Planner": "Sylvia Do ",
         "DURATION": 1,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-869",
         "APN": 46722121,
         "File Number": "AD11-869",
         "Address": "35 S 2ND ST SAN JOSE",
         "Project Name": "FOUNTAIN ALLEY PAY STN (PC) TI ",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/18/11",
         "Status": "Approved ",
         "Description": "To relocate existing parking lot cashier booth 15 feet to the northwest of the exisitng booth; install prefabrictaed shelter with pay station on concrete slab, ticket spitter, ticket exit column and relocate handicapped space.",
         "Planner": "Sylvia Do ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD12-028",
         "APN": 46701003,
         "File Number": "AD12-028",
         "Address": "257 N 2ND ST SAN JOSE",
         "Project Name": "AD12-028",
         "Application Type": "Permit Adjustment ",
         "Application Date": "1/10/12",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow three air conditioning condenser alcoves above three doors on the rear elevation and installation of three condenser units in the alcoves behind new iron screening gates. ",
         "Planner": "Avril Baty ",
         "DURATION": 0,
         "Year": 2012
      },
      {
         "PERMITID": "AD12-1007",
         "APN": 46746081,
         "File Number": "AD12-1007",
         "Address": "300 S 1ST ST SAN JOSE",
         "Project Name": "AD12-1007",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/5/12",
         "Status": "Approved ",
         "Description": "Installation of a freestanding temporary public art piece with a maximum dimension of 41'in legnth x 15'6 3/4\"in width x 12' in height on south side of building. (beginning September 10, 2012 for of period no longer than 180 days).",
         "Planner": "Susan Walsh ",
         "DURATION": 1,
         "Year": 2012
      },
      {
         "PERMITID": "AD12-1044",
         "APN": 25940091,
         "File Number": "AD12-1044",
         "Address": "55 S MARKET ST SAN JOSE",
         "Project Name": "55 S MARKET ST",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/18/12",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow architectural modifications to an existing commercial building as shown on the approved Permit Adjustment plans only. ",
         "Planner": "Mike Enderby ",
         "DURATION": 0,
         "Year": 2012
      },
      {
         "PERMITID": "AD12-1172",
         "APN": 25956002,
         "File Number": "AD12-1172",
         "Address": "170 S MARKET ST SAN JOSE",
         "Project Name": "AD12-1172",
         "Application Type": "Permit Adjustment ",
         "Application Date": "11/19/12",
         "Status": "Approved ",
         "Description": "Permit Adjustment for storefront modifications including new metal entry canopies and three (3) attached signs for \"Muji\"",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2012
      },
      {
         "PERMITID": "AD12-1250",
         "APN": 46717090,
         "File Number": "AD12-1250",
         "Address": "425 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD12-1250",
         "Application Type": "Permit Adjustment ",
         "Application Date": "12/11/12",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow modification to an existing facility, by adding three (3) TMS's six (6) co-axial and one (1) cable port and three (RRUS).",
         "Planner": "Martina Davis ",
         "DURATION": 0,
         "Year": 2012
      },
      {
         "PERMITID": "AD12-186",
         "APN": 25944085,
         "File Number": "AD12-186",
         "Address": "151 ALMADEN BL SAN JOSE",
         "Project Name": "AD12-186",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/9/12",
         "Status": "Approved ",
         "Description": "Permit Adjustment to partially replace an existing trash area with a private electrical power generation facility consisting of micro grid engines and fuel distillation columns which feeds on trash generated onsite reducing the need for the existing trash area. Eighteen (18) portable, temporary backup generators are positioned inside of a steel container eliminates one existing parking stall.",
         "Planner": "MNAGARAJ ",
         "DURATION": 0,
         "Year": 2012
      },
      {
         "PERMITID": "AD12-186",
         "APN": 25944088,
         "File Number": "AD12-186",
         "Address": "151 ALMADEN BL SAN JOSE",
         "Project Name": "AD12-186",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/9/12",
         "Status": "Approved ",
         "Description": "Permit Adjustment to partially replace an existing trash area with a private electrical power generation facility consisting of micro grid engines and fuel distillation columns which feeds on trash generated onsite reducing the need for the existing trash area. Eighteen (18) portable, temporary backup generators are positioned inside of a steel container eliminates one existing parking stall.",
         "Planner": "MNAGARAJ ",
         "DURATION": 0,
         "Year": 2012
      },
      {
         "PERMITID": "AD12-186",
         "APN": 25944089,
         "File Number": "AD12-186",
         "Address": "151 ALMADEN BL SAN JOSE",
         "Project Name": "AD12-186",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/9/12",
         "Status": "Approved ",
         "Description": "Permit Adjustment to partially replace an existing trash area with a private electrical power generation facility consisting of micro grid engines and fuel distillation columns which feeds on trash generated onsite reducing the need for the existing trash area. Eighteen (18) portable, temporary backup generators are positioned inside of a steel container eliminates one existing parking stall.",
         "Planner": "MNAGARAJ ",
         "DURATION": 0,
         "Year": 2012
      },
      {
         "PERMITID": "AD12-220",
         "APN": 46719078,
         "File Number": "AD12-220",
         "Address": "24 N 5TH ST SAN JOSE",
         "Project Name": "AD12-220",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/29/12",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow for the removal of the 3rd floor of the building and associated architectural modifications to a previously approved Site Development Permit (File No. H 10-018).",
         "Planner": "MNAGARAJ ",
         "DURATION": 0,
         "Year": 2012
      },
      {
         "PERMITID": "AD12-232",
         "APN": 46720079,
         "File Number": "AD12-232",
         "Address": "147 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD12-232",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/5/12",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow (2) two new exterior doors on an existing commercial building as shown on the approved Permit Adjustment plans only.",
         "Planner": "Jeff Roche ",
         "DURATION": 1,
         "Year": 2012
      },
      {
         "PERMITID": "AD12-269",
         "APN": 25935013,
         "File Number": "AD12-269",
         "Address": "87 N SAN PEDRO ST SAN JOSE",
         "Project Name": "AD12-269",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/15/12",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow rooftop equipment and exhaust fans for a public eating establishment.  ",
         "Planner": "Suparna Saha ",
         "DURATION": 1,
         "Year": 2012
      },
      {
         "PERMITID": "AD12-270",
         "APN": 25934028,
         "File Number": "AD12-270",
         "Address": "80 N MARKET ST SAN JOSE",
         "Project Name": "AD12-270",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/15/12",
         "Status": "Approved ",
         "Description": "To extend the rear of an existing restaurant to locate a walk-in cooler 11'X11' in area.",
         "Planner": "Suparna Saha ",
         "DURATION": 0,
         "Year": 2012
      },
      {
         "PERMITID": "AD12-292",
         "APN": 25936074,
         "File Number": "AD12-292",
         "Address": "333 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD12-292",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/21/12",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow the removal of one a dead, Liquid Amber tree, approximately 36-inches in circumference located in a landscaped area on a commercial site as shown on the approved Permit Adjustment plans only.",
         "Planner": "Jeff Roche ",
         "DURATION": 1,
         "Year": 2012
      },
      {
         "PERMITID": "AD12-374",
         "APN": 47218063,
         "File Number": "AD12-374",
         "Address": "9750 TRACT SAN JOSE",
         "Project Name": "AD12-374",
         "Application Type": "Permit Adjustment ",
         "Application Date": "4/13/12",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a (1) one-year time extension of a previously approved Planned Development Permit only.",
         "Planner": "MNAGARAJ ",
         "DURATION": 0,
         "Year": 2012
      },
      {
         "PERMITID": "AD12-415",
         "APN": 25941068,
         "File Number": "AD12-415",
         "Address": "185 PARK AV SAN JOSE",
         "Project Name": "AD12-415",
         "Application Type": "Permit Adjustment ",
         "Application Date": "4/25/12",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow expansion of existing bank to occupy adjacent suite, remove entry door ( of 2nd unit) to place external ATM, replace side glass with stucco wall. Two new exterior wall mounted lighting on either side of ATM.",
         "Planner": "MNAGARAJ ",
         "DURATION": 0,
         "Year": 2012
      },
      {
         "PERMITID": "AD12-638",
         "APN": 46717090,
         "File Number": "AD12-638",
         "Address": "425 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD12-638",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/29/12",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow modifications to an existing wireless communications antenna facility as shown on the apporved Permit Adjustment plans only. ",
         "Planner": "Jeff Roche ",
         "DURATION": 1,
         "Year": 2012
      },
      {
         "PERMITID": "AD12-713",
         "APN": 46721023,
         "File Number": "AD12-713",
         "Address": "2 N 1ST ST SAN JOSE",
         "Project Name": "AD12-713",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/20/12",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow modifications to an existing AT&T wireless communication facility including: to install three (3) remote radio units and to remove and replace three (3) antennas and three (3) surge supressors.",
         "Planner": "Jan Warne ",
         "DURATION": 1,
         "Year": 2012
      },
      {
         "PERMITID": "AD12-854",
         "APN": 46719078,
         "File Number": "AD12-854",
         "Address": "24 N 5TH ST SAN JOSE",
         "Project Name": "AD12-854",
         "Application Type": "Permit Adjustment ",
         "Application Date": "8/23/12",
         "Status": "Approved ",
         "Description": "A permit adjustment for construction staging.  ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2012
      },
      {
         "PERMITID": "AD12-934",
         "APN": 25935020,
         "File Number": "AD12-934",
         "Address": "225 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD12-934",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/18/12",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow replacement of one (1), bay of storefront glass with panels incorporating ATM and Night Depository facility for an office/commercial building.",
         "Planner": "Suparna Saha ",
         "DURATION": 9,
         "Year": 2012
      },
      {
         "PERMITID": "AD12-953",
         "APN": 25945045,
         "File Number": "AD12-953",
         "Address": "429 LAKEHOUSE AV SAN JOSE",
         "Project Name": "AD12-953",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/21/12",
         "Status": "Approved ",
         "Description": "Permit Adjustment to create a permit for work already done: re-roofing of an historic home in the Lakehouse Area.  ",
         "Planner": "Suparna Saha ",
         "DURATION": 0,
         "Year": 2012
      },
      {
         "PERMITID": "AD12-954",
         "APN": 25945076,
         "File Number": "AD12-954",
         "Address": "436 LAKEHOUSE AV SAN JOSE",
         "Project Name": "AD12-954",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/21/12",
         "Status": "Approved ",
         "Description": "Permit Adjustment to create a permit for work already done: re-roofing of an historic home in the Lakehouse Area. ",
         "Planner": "Suparna Saha ",
         "DURATION": 0,
         "Year": 2012
      },
      {
         "PERMITID": "AD12-955",
         "APN": 25948023,
         "File Number": "AD12-955",
         "Address": "131 GIFFORD AV SAN JOSE",
         "Project Name": "AD12-955",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/21/12",
         "Status": "Approved ",
         "Description": "Permit Adjustment to create a permit for work already done: re-roofing of an historic home in the Lakehouse Area. ",
         "Planner": "Suparna Saha ",
         "DURATION": 0,
         "Year": 2012
      },
      {
         "PERMITID": "AD13-1105",
         "APN": 25931071,
         "File Number": "AD13-1105",
         "Address": "255 W JULIAN ST SAN JOSE",
         "Project Name": "AD13-1105",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/10/13",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow the removal of three (3) existing antennas with three (3) new antennas and the installation of the proposed accessory equipment.",
         "Planner": "Suparna Saha ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "AD13-1174",
         "APN": 26415065,
         "File Number": "AD13-1174",
         "Address": "720 W SAN CARLOS ST SAN JOSE",
         "Project Name": "AD13-1174",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/29/13",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow temporary outdoor use of parking lot, using seven parking spaces for Christmas tree display between 11/25/2013 through 12/26/2013.",
         "Planner": "Suparna Saha ",
         "DURATION": 1,
         "Year": 2013
      },
      {
         "PERMITID": "AD13-1227",
         "APN": 25940086,
         "File Number": "AD13-1227",
         "Address": "60 S MARKET ST SAN JOSE",
         "Project Name": "AD13-1227",
         "Application Type": "Permit Adjustment ",
         "Application Date": "11/13/13",
         "Status": "Approved ",
         "Description": "Permit adjustment to allow one (1) LED illuminated attached channel letters sign 56 sq. feet in sign area, facing Market Street.",
         "Planner": "MNAGARAJ ",
         "DURATION": 1,
         "Year": 2013
      },
      {
         "PERMITID": "AD13-1254",
         "APN": 26411112,
         "File Number": "AD13-1254",
         "Address": "802 W HOME ST SAN JOSE",
         "Project Name": "AD13-1254",
         "Application Type": "Permit Adjustment ",
         "Application Date": "11/19/13",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow the modification of an existing, unmanned telecommunication facility consisting of the removal of three (3) panel antennas and the installation of six (6) new antennas, three (3) antenna mounts, three (3) new TMA's, three (3) new hybrid cables (3 x 6 configuration), and six (6) new 7/8 inch coax cables on an existing PG&E lattice tower for MetroPCS.",
         "Planner": "MNAGARAJ ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "AD13-1262",
         "APN": 25940093,
         "File Number": "AD13-1262",
         "Address": "1 S MARKET ST SAN JOSE",
         "Project Name": "AD13-1262 One South Market",
         "Application Type": "Permit Adjustment ",
         "Application Date": "11/20/13",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow extended construction hours between 4:00 a.m. to 7:00 a.m. on November 21, 2013 for concrete pour for tower structural slab.",
         "Planner": "Sylvia Do ",
         "DURATION": 1,
         "Year": 2013
      },
      {
         "PERMITID": "AD13-1289",
         "APN": 26420125,
         "File Number": "AD13-1289",
         "Address": "602 W SAN CARLOS ST SAN JOSE",
         "Project Name": "AD13-1289",
         "Application Type": "Permit Adjustment ",
         "Application Date": "11/27/13",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow one 499 gallon above ground propane tank on a pad, protected by six bollards and located on the 76 Station property.",
         "Planner": "Sylvia Do ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "AD13-1301",
         "APN": 46718090,
         "File Number": "AD13-1301",
         "Address": "301 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD13-1301",
         "Application Type": "Permit Adjustment ",
         "Application Date": "12/3/13",
         "Status": "Approved ",
         "Description": "Permit Adjustment to extend the validity of SP09-010 for one year pursuant to Section 20.100.500(A)(1). The permit expired March 5th, 2014. This extends the validity one year to expire March 5th, 2015.",
         "Planner": "Sylvia Do ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "AD13-1316",
         "APN": 47218014,
         "File Number": "AD13-1316",
         "Address": "100 LEWIS ST SAN JOSE",
         "Project Name": "AD13-1316",
         "Application Type": "Permit Adjustment ",
         "Application Date": "12/5/13",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a 1080 square feet pre-fabricated metal storage structure, open on one side located in the rear yard of Cade Corporation and including an ADA lift for the ADA parking spot because of raised level of entrance.",
         "Planner": "Lori Moniz ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "AD13-1323",
         "APN": 25935056,
         "File Number": "AD13-1323",
         "Address": "73 N SAN PEDRO ST SAN JOSE",
         "Project Name": "AD13-1323",
         "Application Type": "Permit Adjustment ",
         "Application Date": "12/6/13",
         "Status": "Approved ",
         "Description": "Permit adjustment to allow an awning measuring 17 feet by 60 feet over the existing permitted patio.",
         "Planner": "Lori Moniz ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "AD13-252",
         "APN": 46719078,
         "File Number": "AD13-252",
         "Address": "24 N 5TH ST SAN JOSE",
         "Project Name": "AD13-252",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/5/13",
         "Status": "Approved ",
         "Description": "To replace an apporved four panel entrance door with a three panel door and to delete an approved smaller door towards the street corner facing E Santa Clara Street and to relocate an approved two panel door 2' away from the approved location and to locate a mail box slot facing North 5th Street.",
         "Planner": "MNAGARAJ ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "AD13-273",
         "APN": 25934027,
         "File Number": "AD13-273",
         "Address": "66 N MARKET ST SAN JOSE",
         "Project Name": "AD13-273",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/8/13",
         "Status": "Approved ",
         "Description": "Installation of gates and bollards at existing parking lot attendant booth.  ",
         "Planner": "MNAGARAJ ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "AD13-291",
         "APN": 26417043,
         "File Number": "AD13-291",
         "Address": "630 AUZERAIS AV SAN JOSE",
         "Project Name": "AD13-291 - Sprint",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/13/13",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow modifications to an existing antenna. A Sprint MMBS cabinet, a battery cabinet, three (3) hybrid cables for fiber & DC power, a GPS antenna, a ciena unit, a UAM unit, a FTP box, six (6) RRU's and three (3) FRP screens. Also three (3) Sprint antennas will be replaced. All modifications will be under the parapet. One (1) GPS antenna will be slightly visible.",
         "Planner": "MNAGARAJ ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "AD13-301",
         "APN": 46745027,
         "File Number": "AD13-301",
         "Address": "310 S 3RD ST SAN JOSE",
         "Project Name": "AD13-301",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/15/13",
         "Status": "Approved ",
         "Description": "Permit Adjustment to legalize outdoor dining on the existing porch and the front yard patio of an existing home converted to a commercial building in the downtown zoning district.  ",
         "Planner": "Jan Warne ",
         "DURATION": 1,
         "Year": 2013
      },
      {
         "PERMITID": "AD13-328",
         "APN": 46720023,
         "File Number": "AD13-328",
         "Address": "160 N 4TH ST SAN JOSE",
         "Project Name": "AD13-328",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/22/13",
         "Status": "Approved ",
         "Description": "Permit Adjustment to SUP 12-032 to add 500 sq. ft. to existing 1,512 sq. ft. main house and demolish existing cottage.",
         "Planner": "Aparna Ankola ",
         "DURATION": 33,
         "Year": 2013
      },
      {
         "PERMITID": "AD13-421",
         "APN": 46747095,
         "File Number": "AD13-421",
         "Address": "455 S 2ND ST SAN JOSE",
         "Project Name": "AD13-421",
         "Application Type": "Permit Adjustment ",
         "Application Date": "4/17/13",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow the addition of a security gate at the base of an existing stairwell. ",
         "Planner": "Aparna Ankola ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "AD13-570",
         "APN": 25939120,
         "File Number": "AD13-570",
         "Address": "95 S ALMADEN AV SAN JOSE",
         "Project Name": "AD13-570",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/29/13",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow replacement of 6 (E) antennas with 3 (N) antennas on the rooftop, addition of 6 (N) RRU's, remove 3 (E) equipment cabinets with 2 (N) equipments cabinets within existing Sprint lease area.",
         "Planner": "Suparna Saha ",
         "DURATION": 1,
         "Year": 2013
      },
      {
         "PERMITID": "AD13-669",
         "APN": 25941054,
         "File Number": "AD13-669",
         "Address": "121 S MARKET ST SAN JOSE",
         "Project Name": "AD13-669",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/24/13",
         "Status": "Approved ",
         "Description": "Installation of twelve screened wireless antennas with associated equipment all indoors.  ",
         "Planner": "Suparna Saha ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "AD13-707",
         "APN": 25935013,
         "File Number": "AD13-707",
         "Address": "180 W ST JOHN ST SAN JOSE",
         "Project Name": "AD13-707",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/1/13",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment to allow lighting in the eaves of the Peralta Adobe. ",
         "Planner": "Suparna Saha ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "AD13-707",
         "APN": 25935045,
         "File Number": "AD13-707",
         "Address": "180 W ST JOHN ST SAN JOSE",
         "Project Name": "AD13-707",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/1/13",
         "Status": "Approved ",
         "Description": "Historic Preservation Permit Adjustment to allow lighting in the eaves of the Peralta Adobe. ",
         "Planner": "Suparna Saha ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "AD13-916",
         "APN": 26415065,
         "File Number": "AD13-916",
         "Address": "720 W SAN CARLOS ST SAN JOSE",
         "Project Name": "AD13-916",
         "Application Type": "Permit Adjustment ",
         "Application Date": "8/23/13",
         "Status": "Approved ",
         "Description": "Addition of a roof screen. ",
         "Planner": "Rebecca Bustos ",
         "DURATION": 1,
         "Year": 2013
      },
      {
         "PERMITID": "AD13-975",
         "APN": 25941057,
         "File Number": "AD13-975",
         "Address": "125 S MARKET ST SAN JOSE",
         "Project Name": "AD13-975",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/11/13",
         "Status": "Approved ",
         "Description": "Proposal to remove landscaping in front of the existing window facing the plaza and cut open the existing widnow sill and install a pair of 3' wide doors as shown.",
         "Planner": "Rebecca Bustos ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "AD14-049",
         "APN": 25940093,
         "File Number": "AD14-049",
         "Address": "1 S MARKET ST SAN JOSE",
         "Project Name": "AD14-049 One South Market",
         "Application Type": "Permit Adjustment ",
         "Application Date": "1/17/14",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow extended construction hours for Saturday, January 18, 2014 between 9:00 a.m. to 12:00 noon, and Saturdays beginning January 25, 2014 through March 8, 2014 from 9:00 a.m. to 6:00 p.m. to allow for construction work including stressing the cables in the concrete floor slabs and excavating and lagging below grade parking garage structure, and other activities do not generate significant noise.",
         "Planner": "Sylvia Do ",
         "DURATION": 1,
         "Year": 2014
      },
      {
         "PERMITID": "AD14-059",
         "APN": 25939112,
         "File Number": "AD14-059",
         "Address": "99 ALMADEN BL SAN JOSE",
         "Project Name": "AD14-059",
         "Application Type": "Permit Adjustment ",
         "Application Date": "1/22/14",
         "Status": "Approved ",
         "Description": "To allow a 75 KVA new transformer, approximately 30\" high to be located adjacent to the parking structure behind an office building to support 3 electric vehicle chargers to be installed inside the garge building.",
         "Planner": "Sylvia Do ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "AD14-059",
         "APN": 25939119,
         "File Number": "AD14-059",
         "Address": "99 ALMADEN BL SAN JOSE",
         "Project Name": "AD14-059",
         "Application Type": "Permit Adjustment ",
         "Application Date": "1/22/14",
         "Status": "Approved ",
         "Description": "To allow a 75 KVA new transformer, approximately 30\" high to be located adjacent to the parking structure behind an office building to support 3 electric vehicle chargers to be installed inside the garge building.",
         "Planner": "Sylvia Do ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "AD14-1033",
         "APN": 46759112,
         "File Number": "AD14-1033",
         "Address": "100 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD14-1033",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/1/14 14:28",
         "Status": "Approved ",
         "Description": "Storefront modifications including relocation of existing doors to new location and replace old doors with matching storefront, introduction of white security film on existing glazing to hide back of house operations. ",
         "Planner": "Lori Moniz ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "AD14-1063",
         "APN": 26420125,
         "File Number": "AD14-1063",
         "Address": "602 W SAN CARLOS ST SAN JOSE",
         "Project Name": "AD14-1063",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/7/14",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow one (1) new 499 gallon above-ground propane tank and dispenser on a concrete pad, and new bollards around the pad, for an existing gas station (76 Station), on an approximately 0.47 gross acre site.",
         "Planner": "Aparna Ankola ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "AD14-1132",
         "APN": 46746045,
         "File Number": "AD14-1132",
         "Address": "380 S 1ST ST SAN JOSE",
         "Project Name": "AD14-1132",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/23/14 9:19",
         "Status": "Approved ",
         "Description": "Permit Adjustment for Front Façade and Rear Wall Raised 6 feet",
         "Planner": "Rebecca Bustos ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "AD14-1144",
         "APN": 46745025,
         "File Number": "AD14-1144",
         "Address": "140 E SAN CARLOS ST SAN JOSE",
         "Project Name": "AD14-1144",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/27/14",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow the installation of accessible lift in the front of an existing commercial building (La Victoria Taqueria) listed as an Identified Structure on the City's Historic Resources Inventory. ",
         "Planner": "John Tu ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "AD14-1145",
         "APN": 47228061,
         "File Number": "AD14-1145",
         "Address": "581 S 8TH ST SAN JOSE",
         "Project Name": "AD14-1145",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/27/14",
         "Status": "Approved ",
         "Description": "Permit Adjustment to replace single-glazed window with double glazed windows, replace existing balcony with new trellis, add screen extension to garden walls (lattice), add a security gate to the building, and to remove existing doors on the east elevation and to add windows in their place. ",
         "Planner": "John Tu ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "AD14-1159",
         "APN": 46718082,
         "File Number": "AD14-1159",
         "Address": "81 N 8TH ST SAN JOSE",
         "Project Name": "AD14-1159",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/31/14 9:38",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications, including a new pre-fabricated metal ramp, approximately 4- foot wide and 64-foot long, and a new 3- foot wide door, for an existing religious assembly use (Church of Christ) on a 0.19 gross acre site in the R-M Multiple Residence zoning district.",
         "Planner": "John Tu ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "AD14-1327",
         "APN": 25940034,
         "File Number": "AD14-1327",
         "Address": "84 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD14-1327",
         "Application Type": "Permit Adjustment ",
         "Application Date": "12/17/14",
         "Status": "Approved ",
         "Description": "Permit Adjustment to provide new exterior handrails and regrade flat work for accessibility requirements. ",
         "Planner": "Justin Daniels ",
         "DURATION": 1,
         "Year": 2014
      },
      {
         "PERMITID": "AD14-167",
         "APN": 26426088,
         "File Number": "AD14-167",
         "Address": "425 AUZERAIS AV SAN JOSE",
         "Project Name": "AD14-167",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/21/14",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow parking lot reconfiguration to an approved development permit. ",
         "Planner": "Lori Moniz ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "AD14-176",
         "APN": 46718078,
         "File Number": "AD14-176",
         "Address": "143 N 8TH ST SAN JOSE",
         "Project Name": "AD14-176",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/25/14",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow revising a front fence from 6 feet to 3 feet.",
         "Planner": "Jan Warne ",
         "DURATION": 1,
         "Year": 2014
      },
      {
         "PERMITID": "AD14-201",
         "APN": 26417043,
         "File Number": "AD14-201",
         "Address": "630 AUZERAIS AV SAN JOSE",
         "Project Name": "AD14-201",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/28/14",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow the modification to an existing, unmanned telecommunication facility consisting of the removal of three (3) panel antennas and the installation of three (3) new panel antennas, three (3) new RRU's, a new BBU kit, and associated cabling and equipment on an existing industrial building.",
         "Planner": "Jan Warne ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "AD14-225",
         "APN": 46746045,
         "File Number": "AD14-225",
         "Address": "380 S 1ST ST SAN JOSE",
         "Project Name": "AD14-225",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/6/14",
         "Status": "Approved ",
         "Description": "Exterior modifications to rear of commercial building, new skylights, and new rooftop units below line of sight.  ",
         "Planner": "Avril Baty ",
         "DURATION": 1,
         "Year": 2014
      },
      {
         "PERMITID": "AD14-235",
         "APN": 25940093,
         "File Number": "AD14-235",
         "Address": "1 S MARKET ST SAN JOSE",
         "Project Name": "AD14-235",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow extended construction hours for Saturdays beginning March 15, 2014 through April 26, 2014 from 9:00 a.m. to 6:00 p.m. to allow for construction work including stressing the cables in the concrete floor slabs and excavating and lagging below grade parking garage structure, and other activities do not generate significant noise.",
         "Planner": "Sylvia Do ",
         "DURATION": 4,
         "Year": null
      },
      {
         "PERMITID": "AD14-309",
         "APN": 25940093,
         "File Number": "AD14-309",
         "Address": "1 S MARKET ST SAN JOSE",
         "Project Name": "AD14-309",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/27/14",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow extended construction hours between 1:00 a.m. to 7:00 p.m. on Saturday, March 29, 2014 for concrete pour for the parking garage mat slab.",
         "Planner": "Sylvia Do ",
         "DURATION": 1,
         "Year": 2014
      },
      {
         "PERMITID": "AD14-327",
         "APN": 25940093,
         "File Number": "AD14-327",
         "Address": "1 S MARKET ST SAN JOSE",
         "Project Name": "AD14-327",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow modifications to the stormwater control plan. ",
         "Planner": "Sylvia Do ",
         "DURATION": 14,
         "Year": null
      },
      {
         "PERMITID": "AD14-332",
         "APN": 25939120,
         "File Number": "AD14-332",
         "Address": "95 S ALMADEN AV SAN JOSE",
         "Project Name": "AD14-332",
         "Application Type": "Permit Adjustment ",
         "Application Date": "4/3/14",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow increase in size of exterior air hood, for air handler on the 8th floor of the building.",
         "Planner": "Sylvia Do ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "AD14-678",
         "APN": 25940086,
         "File Number": "AD14-678",
         "Address": "60 S MARKET ST SAN JOSE",
         "Project Name": "AD14-678",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/3/14",
         "Status": "Approved ",
         "Description": "Exterior upgrade of street entrance, with new portal entry and facade modifications ",
         "Planner": "Avril Baty ",
         "DURATION": 1,
         "Year": 2014
      },
      {
         "PERMITID": "AD14-714",
         "APN": 46724012,
         "File Number": "AD14-714",
         "Address": "80 S 5TH ST SAN JOSE",
         "Project Name": "AD14-714",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/11/14",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow re-roofing to an existing (contibuting structure) church building, The existing roof is shingles and will be re-roofed with same type of shingles and color. ",
         "Planner": "Avril Baty ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "AD14-731",
         "APN": 47227091,
         "File Number": "AD14-731",
         "Address": "740 S 3RD ST SAN JOSE",
         "Project Name": "AD14-731",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/16/14",
         "Status": "Approved ",
         "Description": "Permit Adjustment to add a new exit landing at the backdoor of an existing duplex that is listed on the Historic Resaources Inventory as a Contributing Structure in a City Conservation Area.  ",
         "Planner": "Justin Daniels ",
         "DURATION": 1,
         "Year": 2014
      },
      {
         "PERMITID": "AD14-824",
         "APN": 25940087,
         "File Number": "AD14-824",
         "Address": "160 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD14-824",
         "Application Type": "Permit Adjustment ",
         "Application Date": "8/6/14",
         "Status": "Approved ",
         "Description": "Permit Adjustment to install two illuminated attached wall signs measuring 335.4 square feet.",
         "Planner": "Justin Daniels ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "AD14-826",
         "APN": 25941086,
         "File Number": "AD14-826",
         "Address": "50 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD14-826",
         "Application Type": "Permit Adjustment ",
         "Application Date": "8/6/14",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow for parkng accessiblity (including harship exceptions) the total number of stalls has been reduced by one (1).",
         "Planner": "Susan Walsh ",
         "DURATION": 8,
         "Year": 2014
      },
      {
         "PERMITID": "AD14-826",
         "APN": 25941087,
         "File Number": "AD14-826",
         "Address": "50 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD14-826",
         "Application Type": "Permit Adjustment ",
         "Application Date": "8/6/14",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow for parkng accessiblity (including harship exceptions) the total number of stalls has been reduced by one (1).",
         "Planner": "Susan Walsh ",
         "DURATION": 8,
         "Year": 2014
      },
      {
         "PERMITID": "AD14-833",
         "APN": 25939122,
         "File Number": "AD14-833",
         "Address": "10 ALMADEN BL SAN JOSE",
         "Project Name": "AD14-833",
         "Application Type": "Permit Adjustment ",
         "Application Date": "8/7/14",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow the application of Vinyl Gradient (3M Controltac Graphic Film) to exterior windows for an approximate total perimeter length of 135 feet and height of 5 feet along the North and East facades of an existing tenant space (Citibank).",
         "Planner": "Aparna Ankola ",
         "DURATION": 1,
         "Year": 2014
      },
      {
         "PERMITID": "AD14-840",
         "APN": 46701080,
         "File Number": "AD14-840",
         "Address": "210 N 4TH ST SAN JOSE",
         "Project Name": "AD14-840",
         "Application Type": "Permit Adjustment ",
         "Application Date": "8/8/14",
         "Status": "Approved ",
         "Description": "Permit adjustment to allow new building mounted antennas mounted on the outside of the existing screen with new screening installed around the new antennas. ",
         "Planner": "Aparna Ankola ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "AD14-852",
         "APN": 24950047,
         "File Number": "AD14-852",
         "Address": "339 N 9TH ST SAN JOSE",
         "Project Name": "AD14-852",
         "Application Type": "Permit Adjustment ",
         "Application Date": "8/12/14",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow repair and removation of (E), foundation of an (E), legal-npn-conforming, rear unit used for habitation. ",
         "Planner": "Aparna Ankola ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "AD14-888",
         "APN": 46720018,
         "File Number": "AD14-888",
         "Address": "156 E ST JOHN ST SAN JOSE",
         "Project Name": "AD14-888",
         "Application Type": "Permit Adjustment ",
         "Application Date": "8/20/14",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow the second one (1) year general time extensions for H09-004. H09-004 was valid for 24 months from 10/7/2009 to 10/7/2011. AD11-279 approved a special two-year extension from 10/7/2011 to 10/7/2013. AD13-004 approved the first of two available one-year general extensions from 10/7/2013 to 10/7/2014.",
         "Planner": "Lori Moniz ",
         "DURATION": 1,
         "Year": 2014
      },
      {
         "PERMITID": "AD14-944",
         "APN": 46718039,
         "File Number": "AD14-944",
         "Address": "179 N 9TH ST SAN JOSE",
         "Project Name": "AD14-944",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/4/14",
         "Status": "Approved ",
         "Description": "Permit Adjustment to build new exterior stairs at the rear of the property with a storage unit underneath and to retrofit all existing windows with vinyl windows. ",
         "Planner": "Lori Moniz ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "AD14-989",
         "APN": 46759112,
         "File Number": "AD14-989",
         "Address": "100 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD14-989",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/18/14 14:07",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow two attached signs measuring 47.3 square feet on the two frontages of T-Mobile and one hanging arcade sign in the arcade walkway measuring 5 square feet.",
         "Planner": "Jan Warne ",
         "DURATION": 1,
         "Year": 2014
      },
      {
         "PERMITID": "AD14-998",
         "APN": 25939122,
         "File Number": "AD14-998",
         "Address": "10 ALMADEN BL SAN JOSE",
         "Project Name": "AD14-998",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/22/14",
         "Status": "Approved ",
         "Description": "To replace existing ADA ramp railing with new higher railings and replace the existing ADA ramp with a new ramp at a different slope.  ",
         "Planner": "MNAGARAJ ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "AD15-061",
         "APN": 25942082,
         "File Number": "AD15-061",
         "Address": "200 S MARKET ST SAN JOSE",
         "Project Name": "AD15-061",
         "Application Type": "Permit Adjustment ",
         "Application Date": "1/26/15 9:54",
         "Status": "Approved ",
         "Description": "Permit Adjustment for exterior upgrades of 12 story mixed use building, with a union office on the ground floor and affordable housing units on the upper floors.",
         "Planner": "Martina Davis ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "AD15-089",
         "APN": 46725001,
         "File Number": "AD15-089",
         "Address": "400 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD15-089",
         "Application Type": "Permit Adjustment ",
         "Application Date": "1/30/15",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow removal of exterior door (E), and infill opening, and remove existing mezzanine floor for a commercial space. ",
         "Planner": "Suparna Saha ",
         "DURATION": 1,
         "Year": 2015
      },
      {
         "PERMITID": "AD15-1051",
         "APN": 46701073,
         "File Number": "AD15-1051",
         "Address": "254 N 4TH ST SAN JOSE",
         "Project Name": "AD15-1051",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/23/15 15:40",
         "Status": "Approved ",
         "Description": "Permit Adjustment to add a new bathroom window to an apartment building. ",
         "Planner": "Suparna Saha ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "AD15-1150",
         "APN": 47218014,
         "File Number": "AD15-1150",
         "Address": "100 LEWIS ST SAN JOSE",
         "Project Name": "AD15-1150",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/19/15 10:16",
         "Status": "Approved ",
         "Description": "Permit adjustment to allow a 12 kW back up generator with a propane fuel source installed in a factory enclosure with interior sound absorbing foam.",
         "Planner": "Suparna Saha ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "AD15-1161",
         "APN": 46721023,
         "File Number": "AD15-1161",
         "Address": "2 N 1ST ST SAN JOSE",
         "Project Name": "AD15-1161",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/20/15 15:41",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow the addition of three (3) new antennas on pipe mounts, 3 RRU's, and located at the penthouse level of an existing office development on a 0.19 gross acre site in the DC Downtown Primary Commercial zoning district.",
         "Planner": "Suparna Saha ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "AD15-122",
         "APN": 25940093,
         "File Number": "AD15-122",
         "Address": "1 S MARKET ST SAN JOSE",
         "Project Name": "AD15-122",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/9/15",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow four deck umbrellas 11 feet tall measured from the deck floor w/ a span of 10.5 feet in the pool area of a high-rise residential development.",
         "Planner": "Suparna Saha ",
         "DURATION": 1,
         "Year": 2015
      },
      {
         "PERMITID": "AD15-1294",
         "APN": 46717082,
         "File Number": "AD15-1294",
         "Address": "79 N 10TH ST SAN JOSE",
         "Project Name": "AD15-1294",
         "Application Type": "Permit Adjustment ",
         "Application Date": "11/18/15 15:33",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow the removal of an existing stairway and installation of new wood stairway and landing, measuring 3 feet in width and approximately 21 feet in length, and located to the rear of an existing multi-family development on a 0.15 gross acre site in the R-M Multiple Residence zoning district.",
         "Planner": "Aparna Ankola ",
         "DURATION": 1,
         "Year": 2015
      },
      {
         "PERMITID": "AD15-1306",
         "APN": 46746106,
         "File Number": "AD15-1306",
         "Address": "350 S 2ND ST SAN JOSE",
         "Project Name": "AD15-1306",
         "Application Type": "Permit Adjustment ",
         "Application Date": "11/23/15 9:47",
         "Status": "Approved ",
         "Description": "To open up the existing wall of a day care center on the ground floor to add new exterior door only. ",
         "Planner": "MNAGARAJ ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "AD15-1360",
         "APN": 25939122,
         "File Number": "AD15-1360",
         "Address": "10 ALMADEN BL SAN JOSE",
         "Project Name": "AD15-1360",
         "Application Type": "Permit Adjustment ",
         "Application Date": "12/9/15 11:13",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a) 4th floor parking structure, rooftop pool closure, approximately 2,750 sq. feet in area, b) converting pool area to patio for outdoor use, c) landscaping, turf area, planter beds, d) anchoring 3 outdoor umbrellas, e) outdoor lighting with no uplights..",
         "Planner": "Aparna Ankola ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "AD15-1366",
         "APN": 26429065,
         "File Number": "AD15-1366",
         "Address": "387 S 1ST ST SAN JOSE",
         "Project Name": "AD15-1366",
         "Application Type": "Permit Adjustment ",
         "Application Date": "12/10/15 10:33",
         "Status": "Approved ",
         "Description": "Permit Adjustment to add a 50 square foot Fin Sign on a approx. 92' frontage in a downtown zoned parcel.",
         "Planner": "Aparna Ankola ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "AD15-1378",
         "APN": 46746108,
         "File Number": "AD15-1378",
         "Address": "375 S 3RD ST SAN JOSE",
         "Project Name": "AD15-1378",
         "Application Type": "Permit Adjustment ",
         "Application Date": "12/14/15 14:08",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow removal of a non-ordinance size Pear tree 32 inches in circumference in the parking lot of YWCA",
         "Planner": "Suparna Saha ",
         "DURATION": 1,
         "Year": 2015
      },
      {
         "PERMITID": "AD15-1454",
         "APN": 47218063,
         "File Number": "AD15-1454",
         "Address": "9750 TRACT SAN JOSE",
         "Project Name": "AD15-1454",
         "Application Type": "Permit Adjustment ",
         "Application Date": "12/28/15 16:28",
         "Status": "Approved ",
         "Description": "Proposed changes to landscaping and fence around the pool, Deletion of the water fountain feature and other minor changes to the site improvement. Addition of stone sculpture in place of the deleted water fountains.  ",
         "Planner": "Suparna Saha ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "AD15-188",
         "APN": 25944089,
         "File Number": "AD15-188",
         "Address": "321 PARK AV SAN JOSE",
         "Project Name": "AD15-188 Outdoor employee cafe area",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/24/15 11:15",
         "Status": "Approved ",
         "Description": "Permit Adjustment to add a fenced outdoor employee dining area at Park Avenue and Almaden Boulevard, and replace exterior door to outdoor dining area. ",
         "Planner": "Lori Moniz ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "AD15-190",
         "APN": 25944088,
         "File Number": "AD15-190",
         "Address": "151 ALMADEN BL SAN JOSE",
         "Project Name": "AD15-190",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/24/15 14:24",
         "Status": "Approved ",
         "Description": "To remove an existing entrance door located facing the corner of Park Avenue and Almaden Boulevard intersection and replace it with fixed glass. ",
         "Planner": "MNAGARAJ ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "AD15-237",
         "APN": 46721018,
         "File Number": "AD15-237",
         "Address": " ",
         "Project Name": "AD15-237",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/6/15 13:48",
         "Status": "Approved ",
         "Description": "Permit Adjustment to Site Development Permit H14-010 for the removal of the garage entrance on St. John Street and inclusion of an in-only driveway on North 1st Street, one in-only and one out-only driveway garage entrances on North 2ndStreet, the modifications to adjust the ground floor cafe/building frontage along the St. John frontage and material changes on the St. John Street elevation to limestone materials. A subsequent Permit Adjustment will be required for final review and approval of revised architectural plans incorporating project modifications as noted above.",
         "Planner": "Avril Baty ",
         "DURATION": 1,
         "Year": 2015
      },
      {
         "PERMITID": "AD15-278",
         "APN": 46723082,
         "File Number": "AD15-278",
         "Address": "85 S 5TH ST SAN JOSE",
         "Project Name": "AD15-278",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/17/15 14:10",
         "Status": "Approved ",
         "Description": "Permit adjustment to approve exterior remodeling of Jeanne D'Arc Manor including replacing 42 like-for-like steel framed windows: 30 windows on the West elevation and 6 windows each on the north and south elevations; and to allow replacing three doors on the West elevation facing the patio: two sliding glass storefront-type doors and one swing door.",
         "Planner": "Jan Warne ",
         "DURATION": 1,
         "Year": 2015
      },
      {
         "PERMITID": "AD15-301",
         "APN": 46720080,
         "File Number": "AD15-301",
         "Address": "60 N 3RD ST SAN JOSE",
         "Project Name": "AD15-301",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/23/15",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modification to Unit #1020 on the 10th floor of a multi-family development consisting of repair of existing balcony railing, and balcony slider door and interio upgrades.",
         "Planner": "Jan Warne ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "AD15-341",
         "APN": 46720080,
         "File Number": "AD15-341",
         "Address": "60 N 3RD ST SAN JOSE",
         "Project Name": "AD15-341",
         "Application Type": "Permit Adjustment ",
         "Application Date": "4/1/15",
         "Status": "Approved ",
         "Description": "Permit Adjustment to replace window and doors, new exterior paint, new mechanical units, repair existing balcony railings, and to replace concrete walks at east side of building. ",
         "Planner": "Justin Daniels ",
         "DURATION": 1,
         "Year": 2015
      },
      {
         "PERMITID": "AD15-475",
         "APN": 46720068,
         "File Number": "AD15-475",
         "Address": "96 N 3RD ST SAN JOSE",
         "Project Name": "AD15-475",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/1/15",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow modification of (E) wireless telecommunication facility on the roof top, includes removing six antennas with six new antennas and install FRP screening in front of the antennas to conceal from view. ",
         "Planner": "Suparna Saha ",
         "DURATION": 1,
         "Year": 2015
      },
      {
         "PERMITID": "AD15-519",
         "APN": 25934053,
         "File Number": "AD15-519",
         "Address": "111 N MARKET ST Bldg 1 SAN JOSE",
         "Project Name": "AD15-519",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/14/15 13:20",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow the removal of two(2) trees from the parking lot of a commercial development on a 0.87 gross acre site in the DC Downtown Primary Commercial zoning district.",
         "Planner": "Aparna Ankola ",
         "DURATION": 15,
         "Year": 2015
      },
      {
         "PERMITID": "AD15-560",
         "APN": 46721023,
         "File Number": "AD15-560",
         "Address": "2 N 1ST ST SAN JOSE",
         "Project Name": "AD15-560",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/27/15 9:44",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow modifications to include the removal and replacement of three (3) port panel antennas, three (3) RRU’s, six (6) diplexer units and associated equipment at an existing wireless communication facility (AT&T), located at the roof level of an existing office development on an approximately 0.19 gross acre site in the DC Downtown Primary Commercial zoning district.",
         "Planner": "Aparna Ankola ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "AD15-604",
         "APN": 25931071,
         "File Number": "AD15-604",
         "Address": "255 W JULIAN ST SAN JOSE",
         "Project Name": "AD15-604",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/4/15 11:11",
         "Status": "Approved ",
         "Description": "To replace nine (9) existing building mounted antennas with new antennas for Verizon Wireless.",
         "Planner": "Aparna Ankola ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "AD15-722",
         "APN": 46721011,
         "File Number": "AD15-722",
         "Address": "70 N 2ND ST SAN JOSE",
         "Project Name": "AD15-722",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/30/15 11:30",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow storefront façade modification, which includes storefront double door, bringing forward the (E) curvilinear façade recessed, forward to match with the building frontage of an office building. Remove (E) exterior veneer including ceramic tile and (E) metal column.  ",
         "Planner": "Elizabeth Schuller ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "AD15-830",
         "APN": 46747091,
         "File Number": "AD15-830",
         "Address": "475 S 2ND ST SAN JOSE",
         "Project Name": "AD15-830",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/28/15 13:41",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow to removal and re-installation of approximately 120 windows in a total of 120 units in a motel building in Downtown.",
         "Planner": "Elizabeth Schuller ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "AD15-842",
         "APN": 25939120,
         "File Number": "AD15-842",
         "Address": "95 S ALMADEN AV SAN JOSE",
         "Project Name": "AD15-842",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/31/15 14:50",
         "Status": "Approved ",
         "Description": "Permit Adjustment to add 3 new antennas and 3 new RRUs within existing Sprint lease area.",
         "Planner": "Elizabeth Schuller ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "AD15-849",
         "APN": 25939120,
         "File Number": "AD15-849",
         "Address": "95 S ALMADEN AV SAN JOSE",
         "Project Name": "AD15-849",
         "Application Type": "Permit Adjustment ",
         "Application Date": "8/4/15 9:44",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior façade modifications, including window alterations associated with the installation of a new air handler unit at the 6th floor level for a new tenant, located within an existing office building on a 1.3 gross acre site, within the DC Downtown Primary Commercial zoning district.",
         "Planner": "Aparna Ankola ",
         "DURATION": 17,
         "Year": 2015
      },
      {
         "PERMITID": "AD15-892",
         "APN": 25944088,
         "File Number": "AD15-892",
         "Address": "151 ALMADEN BL SAN JOSE",
         "Project Name": "AD15-892",
         "Application Type": "Permit Adjustment ",
         "Application Date": "8/12/15 13:53",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow addition of trellis for (E) outdoor dining on the 6th floor podium for \"ADOBE\"",
         "Planner": "Kristinae Toomians ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "AD15-894",
         "APN": 47227035,
         "File Number": "AD15-894",
         "Address": "550 S 4TH ST SAN JOSE",
         "Project Name": "AD15-894",
         "Application Type": "Permit Adjustment ",
         "Application Date": "8/12/15 14:36",
         "Status": "Approved ",
         "Description": "Permit Adjustment to replace three bathroom windows and replace four living room windows with sliding windows of the same size for egress. ",
         "Planner": "Kristinae Toomians ",
         "DURATION": 1,
         "Year": 2015
      },
      {
         "PERMITID": "AD15-912",
         "APN": 25941057,
         "File Number": "AD15-912",
         "Address": "125 S MARKET ST SAN JOSE",
         "Project Name": "AD15-912",
         "Application Type": "Permit Adjustment ",
         "Application Date": "8/17/15 12:32",
         "Status": "Approved ",
         "Description": "Permit Adjustment to modify a portion of a roof to a 1,908-square foot outdoor patio, as incidental to an existing office building, on a 0.89-gross acre site (Formerly HA05-014-04).",
         "Planner": "Kristinae Toomians ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "AD15-955",
         "APN": 46701074,
         "File Number": "AD15-955",
         "Address": "262 N 4TH ST SAN JOSE",
         "Project Name": "AD15-955",
         "Application Type": "Permit Adjustment ",
         "Application Date": "8/31/15 10:15",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove exterior rear stairs, remove partially enclosed porch, install two windows on the side to match existing, one double-door at the rear of the ground floor to laundry room, and new wooden fence. ",
         "Planner": "Kristinae Toomians ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "AD15-962",
         "APN": 46757084,
         "File Number": "AD15-962",
         "Address": "27 N 6TH ST SAN JOSE",
         "Project Name": "AD15-962",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/1/15 14:33",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow reduction of height for wall along southwest property line from 10ft to 6ft, reconfigure exit door for gym on 5th St to be inset, removal of spandrel windows on 5th street due to Fire requirements, removal of parking garage grills on east and west side of parking garage, and reconfigure 6th St doors to swing inward.",
         "Planner": "Kristinae Toomians ",
         "DURATION": 1,
         "Year": 2015
      },
      {
         "PERMITID": "AD16-050",
         "APN": 25939120,
         "File Number": "AD16-050",
         "Address": "95 S ALMADEN AV SAN JOSE",
         "Project Name": "AD16-050",
         "Application Type": "Permit Adjustment ",
         "Application Date": "1/13/16 15:03",
         "Status": "Approved ",
         "Description": "Install (4) new Bloom Energy Servers (Model ES5) total of 1,000kW",
         "Planner": "Kristinae Toomians ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "AD16-1010",
         "APN": 26415015,
         "File Number": "AD16-1010",
         "Address": "365 ROYAL AV SAN JOSE",
         "Project Name": "AD16-1010",
         "Application Type": "Permit Adjustment ",
         "Application Date": "8/31/16 15:22",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow modifications to the previously approved building facades and floor plan at an existing approximately 37,165-square foot commercial building on a 2.78-gross acre site",
         "Planner": "Rebecca Bustos ",
         "DURATION": 1,
         "Year": 2016
      },
      {
         "PERMITID": "AD16-1010",
         "APN": 26415065,
         "File Number": "AD16-1010",
         "Address": "365 ROYAL AV SAN JOSE",
         "Project Name": "AD16-1010",
         "Application Type": "Permit Adjustment ",
         "Application Date": "8/31/16 15:22",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow modifications to the previously approved building facades and floor plan at an existing approximately 37,165-square foot commercial building on a 2.78-gross acre site",
         "Planner": "Rebecca Bustos ",
         "DURATION": 1,
         "Year": 2016
      },
      {
         "PERMITID": "AD16-1013",
         "APN": 25935041,
         "File Number": "AD16-1013",
         "Address": "51 N SAN PEDRO ST SAN JOSE",
         "Project Name": "AD16-1013",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/1/16 11:05",
         "Status": "Approved ",
         "Description": "Permit Adjustment Request for improvements in the rear parking lot and the south side alley, including a ramp handrail detached from the building, for a historic resource identified as Structure of Merit and Eligible for California and State Register (Old Spaghetti Factory) ",
         "Planner": "Rebecca Bustos ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "AD16-1049",
         "APN": 46717090,
         "File Number": "AD16-1049",
         "Address": "425 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD16-1049",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/13/16 15:13",
         "Status": "Approved ",
         "Description": "Replace (6) 4 foot existing antennas with (6) 4 foot new panel antennas, add (3) radios, add (6) diplexors along with associated cabling. All new antennas to be installed within existing FRP screening.",
         "Planner": "Armando Lopez ",
         "DURATION": 1,
         "Year": 2016
      },
      {
         "PERMITID": "AD16-1082",
         "APN": 47223010,
         "File Number": "AD16-1082",
         "Address": "628 S 10TH ST SAN JOSE",
         "Project Name": "AD16-1082",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/22/16 11:21",
         "Status": "Approved ",
         "Description": "Permit adjustment to allow replacement of metal railings on an apartment complex of 13 units.",
         "Planner": "Armando Lopez ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "AD16-1097",
         "APN": 46721023,
         "File Number": "AD16-1097",
         "Address": "2 N 1ST ST SAN JOSE",
         "Project Name": "AD16-1097",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/27/16 14:08",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow add four (4) louvers on the 1st and 2nd floor windows of a commercial building.",
         "Planner": "Armando Lopez ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "AD16-1128",
         "APN": 46720068,
         "File Number": "AD16-1128",
         "Address": "96 N 3RD ST SAN JOSE",
         "Project Name": "AD16-1128",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/11/16 9:42",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow the addition of three (3) new antennas to three existing sectors, fully screened, presently consisting of a total of 6 existing antennas, and associated equipment for a wireless communications facility (T-Mobile-SF04916A), proposed to match existing and located along the roof parapet of an existing commercial development on an approximately 0.58 gross acre site in the CG Commercial General zoning district.",
         "Planner": "David Fong ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "AD16-1136",
         "APN": 25936074,
         "File Number": "AD16-1136",
         "Address": "333 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD16-1136 - 333 W SANTA CLARA ST - AT&T ANTENNA REPLACEMENT",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/11/16 15:25",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow the replacement of nine (9), roof-mounted, AT&T panel antennas and three (3) RRUs in the same location and the addition of six (6) new RRUs to be placed behind the replaced antennas at an existing telecommunication facility.",
         "Planner": "David Fong ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "AD16-1144",
         "APN": 25939115,
         "File Number": "AD16-1144",
         "Address": "99 ALMADEN BL SAN JOSE",
         "Project Name": "AD16-1144",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/13/16",
         "Status": "Approved ",
         "Description": "Permit Adjustment to replace two exterior double doors on the first floor with one glass roll-up door and one personnel door. ",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2016
      },
      {
         "PERMITID": "AD16-1152",
         "APN": 26415064,
         "File Number": "AD16-1152",
         "Address": "377 ROYAL AV SAN JOSE",
         "Project Name": "AD16-1152 - 2016 CHRISTMAS TREE LOT AT OSH",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/17/16 9:27",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow seasonal outdoor Christmas tree sales, in accordance with Section 20.80.1200 of the San Jose Municipal Code, including the temporary removal of up to 20 parking stalls and the addition of temporary fencing at an existing parking lot (OSH).",
         "Planner": "Lori Moniz ",
         "DURATION": 1,
         "Year": 2016
      },
      {
         "PERMITID": "AD16-1332",
         "APN": 47228061,
         "File Number": "AD16-1332",
         "Address": "581 S 8TH ST SAN JOSE",
         "Project Name": "AD16-1332",
         "Application Type": "Permit Adjustment ",
         "Application Date": "12/2/16 11:01",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow an approximately 20 square foot addition to an existing carport for a laundry room at multi-family residence",
         "Planner": "Sanhita Ghosal ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "AD16-1382",
         "APN": 46757084,
         "File Number": "AD16-1382",
         "Address": "27 N 6TH ST SAN JOSE",
         "Project Name": "AD16-1382",
         "Application Type": "Permit Adjustment ",
         "Application Date": "12/13/16 18:43",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow the addition of a new 6 feet double leaf metal security gate at the podium level near the top of Stair 5, in order to restrict public access to the private residential units, for a previously approved multi-family development (San Jose Student Housing) on a 1.09 gross acre site.",
         "Planner": "Aparna Ankola ",
         "DURATION": 1,
         "Year": 2016
      },
      {
         "PERMITID": "AD16-1389",
         "APN": 25952002,
         "File Number": "AD16-1389",
         "Address": "46 W JULIAN ST UNIT 201 SAN JOSE",
         "Project Name": "AD16-1389",
         "Application Type": "Permit Adjustment ",
         "Application Date": "12/15/16 10:47",
         "Status": "Approved ",
         "Description": "Permit adjustment for a change to the exterior of Park Townsend Condos to new paint scheme of light gray, dark gray and dark marine blue for a complex including 97 living units, a gym, office and recreation room.",
         "Planner": "Jan Warne ",
         "DURATION": 1,
         "Year": 2016
      },
      {
         "PERMITID": "AD16-1389",
         "APN": 25952196,
         "File Number": "AD16-1389",
         "Address": "46 W JULIAN ST UNIT 201 SAN JOSE",
         "Project Name": "AD16-1389",
         "Application Type": "Permit Adjustment ",
         "Application Date": "12/15/16 10:47",
         "Status": "Approved ",
         "Description": "Permit adjustment for a change to the exterior of Park Townsend Condos to new paint scheme of light gray, dark gray and dark marine blue for a complex including 97 living units, a gym, office and recreation room.",
         "Planner": "Jan Warne ",
         "DURATION": 1,
         "Year": 2016
      },
      {
         "PERMITID": "AD16-1389",
         "APN": 25952197,
         "File Number": "AD16-1389",
         "Address": "46 W JULIAN ST UNIT 201 SAN JOSE",
         "Project Name": "AD16-1389",
         "Application Type": "Permit Adjustment ",
         "Application Date": "12/15/16 10:47",
         "Status": "Approved ",
         "Description": "Permit adjustment for a change to the exterior of Park Townsend Condos to new paint scheme of light gray, dark gray and dark marine blue for a complex including 97 living units, a gym, office and recreation room.",
         "Planner": "Jan Warne ",
         "DURATION": 1,
         "Year": 2016
      },
      {
         "PERMITID": "AD16-1389",
         "APN": 25952198,
         "File Number": "AD16-1389",
         "Address": "46 W JULIAN ST UNIT 201 SAN JOSE",
         "Project Name": "AD16-1389",
         "Application Type": "Permit Adjustment ",
         "Application Date": "12/15/16 10:47",
         "Status": "Approved ",
         "Description": "Permit adjustment for a change to the exterior of Park Townsend Condos to new paint scheme of light gray, dark gray and dark marine blue for a complex including 97 living units, a gym, office and recreation room.",
         "Planner": "Jan Warne ",
         "DURATION": 1,
         "Year": 2016
      },
      {
         "PERMITID": "AD16-1389",
         "APN": 25952200,
         "File Number": "AD16-1389",
         "Address": "46 W JULIAN ST UNIT 201 SAN JOSE",
         "Project Name": "AD16-1389",
         "Application Type": "Permit Adjustment ",
         "Application Date": "12/15/16 10:47",
         "Status": "Approved ",
         "Description": "Permit adjustment for a change to the exterior of Park Townsend Condos to new paint scheme of light gray, dark gray and dark marine blue for a complex including 97 living units, a gym, office and recreation room.",
         "Planner": "Jan Warne ",
         "DURATION": 1,
         "Year": 2016
      },
      {
         "PERMITID": "AD16-355",
         "APN": 25936074,
         "File Number": "AD16-355",
         "Address": "333 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD16-355",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/24/16",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow the removal of the existing canvas awnings and the addition of demountable metal and wood resin panel awnings with new light fixtures underneath, new louvers, and new aluminum panel cladding over existing concrete planters at an existing office building.  ",
         "Planner": "Lori Moniz ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "AD16-355",
         "APN": 25939115,
         "File Number": "AD16-355",
         "Address": "333 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD16-355",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/24/16",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow the removal of the existing canvas awnings and the addition of demountable metal and wood resin panel awnings with new light fixtures underneath, new louvers, and new aluminum panel cladding over existing concrete planters at an existing office building.  ",
         "Planner": "Lori Moniz ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "AD16-496",
         "APN": 25942081,
         "File Number": "AD16-496",
         "Address": "240 S MARKET ST SAN JOSE",
         "Project Name": "AD16-496 240 S Market Street Facade Change",
         "Application Type": "Permit Adjustment ",
         "Application Date": "4/21/16 9:34",
         "Status": "Approved ",
         "Description": "Permit Adjustment request to modify the west façade of the first floor of the building facing S Market St, including replacing the existing stucco brick cladding walls and clerestory windows with the following: (a) new aluminum storefront with tempered glazing, (b) new metal sunscreen and (c) new engineered stone cladding under storefront glazing (d) and new engineered stone panels, as shown on the approved planset ",
         "Planner": " ",
         "DURATION": 1,
         "Year": 2016
      },
      {
         "PERMITID": "AD16-514",
         "APN": 47227010,
         "File Number": "AD16-514",
         "Address": "599 S 4TH ST SAN JOSE",
         "Project Name": "AD16-514",
         "Application Type": "Permit Adjustment ",
         "Application Date": "4/26/16 15:00",
         "Status": "Approved ",
         "Description": "Permit adjustment to allow removal of a roll up door and replacement with French doors for an office building on commercial property. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "AD16-554",
         "APN": 47217069,
         "File Number": "AD16-554",
         "Address": "741 S 3RD ST SAN JOSE",
         "Project Name": "AD16-554",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/5/16 15:34",
         "Status": "Approved ",
         "Description": "Permit adjustment to allow installation of eight (8) PG&E gas meters along the front façade of the historic multi-family building. Meters to be screened by fast growing landscaping (bushes) tall enough to screen the meters.",
         "Planner": "Martina Davis ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "AD16-578",
         "APN": 47227035,
         "File Number": "AD16-578",
         "Address": "550 S 4TH ST SAN JOSE",
         "Project Name": "AD16-578",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/12/16 15:16",
         "Status": "Approved ",
         "Description": "Permit adjustment request to construct one 45 square feet laundry facility, to be accessed from a proposed concrete walkway in the side alley, on the first floor of the rear building, and a light fixture near the proposed doorway, in a multi-family residential complex in R-M multifamily zoning district",
         "Planner": "Sanhita Ghosal ",
         "DURATION": 1,
         "Year": 2016
      },
      {
         "PERMITID": "AD16-611",
         "APN": 47226027,
         "File Number": "AD16-611",
         "Address": "630 S 1ST ST SAN JOSE",
         "Project Name": "AD16-611",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/20/16 14:27",
         "Status": "Approved ",
         "Description": "To install windows on the North side exterior wall; security lights and security cameras on the East side exterior wall; and install four (4) roof top units.",
         "Planner": "Jan Warne ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "AD16-620",
         "APN": 47223010,
         "File Number": "AD16-620",
         "Address": "628 S 10TH ST SAN JOSE",
         "Project Name": "AD16-620",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/26/16 11:19",
         "Status": "Approved ",
         "Description": "Permit adjustment to allow exterior modifications including upgrading seven (7) windows to double pane for unit 1 and replacing rock stone wainscot with ledger stone, adding decorative metal siding and repair and paint stucco and fascia boards.",
         "Planner": "Jan Warne ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "AD16-665",
         "APN": 46717090,
         "File Number": "AD16-665",
         "Address": "425 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD16-665",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/10/16 11:47",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow the removal and replacement of three (3) 6' panel antennas, three (3) 4' antennas and installation of three (3) RRU's.",
         "Planner": "Rhonda Buss ",
         "DURATION": 1,
         "Year": 2016
      },
      {
         "PERMITID": "AD16-851",
         "APN": 47217017,
         "File Number": "AD16-851",
         "Address": "718 S 1ST ST SAN JOSE",
         "Project Name": "AD16-851",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/22/16 9:14",
         "Status": "Approved ",
         "Description": "Permit Adjustment to replace a vehicle ingress/egress roll-up door with a pedestrian ingress/egress double door, as well as modify the building façade to create a main entry store front. ",
         "Planner": "Rhonda Buss ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "AD16-934",
         "APN": 25939115,
         "File Number": "AD16-934",
         "Address": "99 ALMADEN BL SAN JOSE",
         "Project Name": "AD16-934",
         "Application Type": "Permit Adjustment ",
         "Application Date": "8/11/16 15:20",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow new glass exterior doors on the first floor.  ",
         "Planner": "Rhonda Buss ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "AD16-935",
         "APN": 46724012,
         "File Number": "AD16-935",
         "Address": "80 S 5TH ST SAN JOSE",
         "Project Name": "AD16-935 - 80 S 5TH ST, FIRST CHRISTIAN CHURCH EXT LIGHTING",
         "Application Type": "Permit Adjustment ",
         "Application Date": "8/17/16",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow replacement of two (2) existing High Pressure Sodium flood lights with nine (9) new LED daylight spectrum outdoor flood lights, consisting of four (4) on the parking lot side, one (1) above the door, and four (4) on the front of an existing church building.",
         "Planner": "Rhonda Buss ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "AD16-935",
         "APN": 46724013,
         "File Number": "AD16-935",
         "Address": "80 S 5TH ST SAN JOSE",
         "Project Name": "AD16-935 - 80 S 5TH ST, FIRST CHRISTIAN CHURCH EXT LIGHTING",
         "Application Type": "Permit Adjustment ",
         "Application Date": "8/17/16",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow replacement of two (2) existing High Pressure Sodium flood lights with nine (9) new LED daylight spectrum outdoor flood lights, consisting of four (4) on the parking lot side, one (1) above the door, and four (4) on the front of an existing church building.",
         "Planner": "Rhonda Buss ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "AD16-936",
         "APN": 47218059,
         "File Number": "AD16-936",
         "Address": "160 E VIRGINIA ST SAN JOSE",
         "Project Name": "AD16-936",
         "Application Type": "Permit Adjustment ",
         "Application Date": "8/11/16 15:50",
         "Status": "Approved ",
         "Description": "Permit Adjustment to increase overall building height from 54'-6\" to 63'-0\" by adding an 11'-3\" by 9'-8\" Radio Frequency screening enclosure on top of the roof of the building at the northeast corner, removing nine (9) wireless antennae mounted on the exterior of the building, adding nine (9) new wireless antennae within the new Radio Frequency screening enclosure, adding six (6) new radios within the Radio Frequency screening enclosure, and miscellaneous ground equipment within an enclosed equipment room inside the building. (AT&T Wireless)",
         "Planner": "Rhonda Buss ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "AD16-980",
         "APN": 25939120,
         "File Number": "AD16-980",
         "Address": "95 S ALMADEN AV SAN JOSE",
         "Project Name": "AD16-980",
         "Application Type": "Permit Adjustment ",
         "Application Date": "8/23/16 14:35",
         "Status": "Approved ",
         "Description": "To swap three (3) existing T-Mobile wireless panel antennas at roof pipe mounts on a building with three (3) new T-Mobile wireless panel antennas, three (3) new RRU units and three (3) Duplexers to side of the RBS cabinet.",
         "Planner": "MNAGARAJ ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "AD17-005",
         "APN": 46724012,
         "File Number": "AD17-005",
         "Address": "80 S 5TH ST SAN JOSE",
         "Project Name": "AD17-005",
         "Application Type": "Permit Adjustment ",
         "Application Date": "1/4/17 9:36",
         "Status": "Approved ",
         "Description": "Permit Adjustment for ADA upgrades to a site containing an existing church to include restriping an ADA parking stall with no loss in parking spaces, replacing a ramp with stairs within the front setback, installing a new access ramp, replacing one set of doors with doors in the same opening as existing, and replacing four windows with new aluminum windows on the south façade of the building in the same openings as existing.  ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-016",
         "APN": 46703024,
         "File Number": "AD17-016",
         "Address": "250 N 9TH ST SAN JOSE",
         "Project Name": "AD17-016",
         "Application Type": "Permit Adjustment ",
         "Application Date": "1/5/17 13:48",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications, including the replacement of 11 metal windows to vinyl windows; and addition of a new 90 square foot deck, approximately 21 feet in length, and ranging between 3 feet and 5 feet in width, located along the south side wall of an existing duplex on a 0.15 gross acre site, within the R-2 Two-Family Residence zoning district.",
         "Planner": "Aparna Ankola ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-080",
         "APN": 25940093,
         "File Number": "AD17-080",
         "Address": "1 S MARKET ST SAN JOSE",
         "Project Name": "AD17-080",
         "Application Type": "Permit Adjustment ",
         "Application Date": "1/23/17 9:39",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow patio seating within the property lines and to replace the existing door on the San Pedro Street side with glazing. ",
         "Planner": "Justin Daniels ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-1018",
         "APN": 46721030,
         "File Number": "AD17-1018",
         "Address": "98 N 1ST ST SAN JOSE",
         "Project Name": "AD17-1018",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/29/17",
         "Status": "Approved ",
         "Description": "Permit adjustment for finalizing the planting species and other landscape details for a multi-family residential project ",
         "Planner": "Sanhita Ghosal ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-1018",
         "APN": 46721038,
         "File Number": "AD17-1018",
         "Address": "98 N 1ST ST SAN JOSE",
         "Project Name": "AD17-1018",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/29/17",
         "Status": "Approved ",
         "Description": "Permit adjustment for finalizing the planting species and other landscape details for a multi-family residential project ",
         "Planner": "Sanhita Ghosal ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-102",
         "APN": 26415065,
         "File Number": "AD17-102",
         "Address": "720 W SAN CARLOS ST SAN JOSE",
         "Project Name": "AD17-102",
         "Application Type": "Permit Adjustment ",
         "Application Date": "1/27/17 13:23",
         "Status": "Approved ",
         "Description": "Permit Adjustment to modify the elevation of the former OSH building ",
         "Planner": "NTHOMAS ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-1033",
         "APN": 25924035,
         "File Number": "AD17-1033",
         "Address": "333 W JULIAN ST SAN JOSE",
         "Project Name": "AD17-1033",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/3/17 13:54",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow the demolition/removal of a 480 square feet metal shed building and a 180 square feet tank (used for holding groundwater ) and replace with a gravel surface for a industrial campus located in IP Industrial Park zoning District",
         "Planner": "Sanhita Ghosal ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-1145",
         "APN": 46702038,
         "File Number": "AD17-1145",
         "Address": "235 N 7TH ST SAN JOSE",
         "Project Name": "AD17-1145",
         "Application Type": "Permit Adjustment ",
         "Application Date": "11/8/17 10:17",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow the retention of an existing shed (6’x9’x7’) and the construction of a new shed (6’x8’x8’) in the rear yard on an existing paved area and to allow the retention of a wall mounted HVAC unit at an existing 4-plex.",
         "Planner": "Lori Moniz ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-1148",
         "APN": 46724093,
         "File Number": "AD17-1148",
         "Address": "357 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD17-1148",
         "Application Type": "Permit Adjustment ",
         "Application Date": "11/9/17 9:24",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow wrought iron gates for underground parking, for an apartment building. ",
         "Planner": "Suparna Saha ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-1191",
         "APN": 47229096,
         "File Number": "AD17-1191",
         "Address": "524 S 9TH ST SAN JOSE",
         "Project Name": "AD17-1191",
         "Application Type": "Permit Adjustment ",
         "Application Date": "11/22/17 15:35",
         "Status": "Approved ",
         "Description": "Permit adjustment to allow a pedestrian and vehicle gate in the driveway and security bars on the first floor windows. ",
         "Planner": "Eric Morgan ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-1230",
         "APN": 47211016,
         "File Number": "AD17-1230",
         "Address": "0 (LAND ONLY) SAN JOSE",
         "Project Name": "AD17-1230",
         "Application Type": "Permit Adjustment ",
         "Application Date": "12/7/17 14:46",
         "Status": "Approved ",
         "Description": "Permit Adjustment to install a seven foot chain linked fence and a seven foot chochrane fence around the property (San Jose Water Company). ",
         "Planner": "Justin Daniels ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-154",
         "APN": 46721023,
         "File Number": "AD17-154",
         "Address": "2 N 1ST ST SAN JOSE",
         "Project Name": "AD17-154",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/8/17 14:57",
         "Status": "Approved ",
         "Description": "Permit Adjustment to install three (3) new RRUs, remove four (4) TMAs, remove pole mast, and install a 19\" rack within the existing shelter.",
         "Planner": "Justin Daniels ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-161",
         "APN": 26420083,
         "File Number": "AD17-161",
         "Address": "466 W SAN CARLOS ST SAN JOSE",
         "Project Name": "AD17-161",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/9/17 14:14",
         "Status": "Approved ",
         "Description": "Construct a greenhouse 20x40 sq. feet, behind the front setback, with an height of approximately 11 feet. Additionally, construct a series of two foot by twelve foot by two foot high raised planter beds. The parcel has an approved Urban Agriculture Incentive Zone (UAIZ) contract (see File 16-003 aka 2016-146360-AO). Parcel works in tandem with the other approved adjacent UAIZ contract parcel at 321 Gifford Avenue. This Permit Adjustment is issued in accordance with Section 20.100.500 (7)(9)(11).",
         "Planner": "AHENRIQU ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-161",
         "APN": 26420085,
         "File Number": "AD17-161",
         "Address": "466 W SAN CARLOS ST SAN JOSE",
         "Project Name": "AD17-161",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/9/17 14:14",
         "Status": "Approved ",
         "Description": "Construct a greenhouse 20x40 sq. feet, behind the front setback, with an height of approximately 11 feet. Additionally, construct a series of two foot by twelve foot by two foot high raised planter beds. The parcel has an approved Urban Agriculture Incentive Zone (UAIZ) contract (see File 16-003 aka 2016-146360-AO). Parcel works in tandem with the other approved adjacent UAIZ contract parcel at 321 Gifford Avenue. This Permit Adjustment is issued in accordance with Section 20.100.500 (7)(9)(11).",
         "Planner": "AHENRIQU ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-172",
         "APN": 46720080,
         "File Number": "AD17-172",
         "Address": "60 N 3RD ST SAN JOSE",
         "Project Name": "AD17-172",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/13/17 13:52",
         "Status": "Approved ",
         "Description": "Permit adjustment for various site modifications for an existing multifamily complex, located in CG- Commercial General zoning district :(1) new landscaping in the front and rear of the building, (2) relocation of concrete pathway in the front of the building, (3)replacement of existing wood fence with iron picket fence to match exiting along east side of the building and (4) replace existing equipment enclosure fence with new fence",
         "Planner": "Sanhita Ghosal ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-181",
         "APN": 25941086,
         "File Number": "AD17-181",
         "Address": "50 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD17-181",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/15/17 13:37",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remodel the ground floor facade ",
         "Planner": "Arthur Chow ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-181",
         "APN": 25941087,
         "File Number": "AD17-181",
         "Address": "50 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD17-181",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/15/17 13:37",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remodel the ground floor facade ",
         "Planner": "Arthur Chow ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-193",
         "APN": 25935009,
         "File Number": "AD17-193",
         "Address": "180 W ST JOHN ST SAN JOSE",
         "Project Name": "AD17-193",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/17/17",
         "Status": "Approved ",
         "Description": "Permit Adjustment for replacing one roll up door with storefront system for an existing commercial building in DC Downtown zoning district ",
         "Planner": "Sanhita Ghosal ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-193",
         "APN": 25935035,
         "File Number": "AD17-193",
         "Address": "180 W ST JOHN ST SAN JOSE",
         "Project Name": "AD17-193",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/17/17",
         "Status": "Approved ",
         "Description": "Permit Adjustment for replacing one roll up door with storefront system for an existing commercial building in DC Downtown zoning district ",
         "Planner": "Sanhita Ghosal ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-193",
         "APN": 25935045,
         "File Number": "AD17-193",
         "Address": "180 W ST JOHN ST SAN JOSE",
         "Project Name": "AD17-193",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/17/17",
         "Status": "Approved ",
         "Description": "Permit Adjustment for replacing one roll up door with storefront system for an existing commercial building in DC Downtown zoning district ",
         "Planner": "Sanhita Ghosal ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-205",
         "APN": 46721011,
         "File Number": "AD17-205",
         "Address": "70 N 2ND ST SAN JOSE",
         "Project Name": "AD17-205",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/22/17 16:07",
         "Status": "Approved ",
         "Description": "Proposed correction to approved Permit File No. AD15-722 to relocate the main entry doors setting it back by 3'0\" from the front façade of the building to avoid the doors opening into the Public Right Of Way.",
         "Planner": "MNAGARAJ ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-220",
         "APN": 47229096,
         "File Number": "AD17-220",
         "Address": "524 S 9TH ST SAN JOSE",
         "Project Name": "AD17-220",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/28/17 9:51",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow the replacement of 52 in-wall heating units with 52 new in-wall HVAC units at an existing apartment complex.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-238",
         "APN": 47223122,
         "File Number": "AD17-238",
         "Address": "787 S 11TH ST SAN JOSE",
         "Project Name": "AD17-238",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/3/17 14:29",
         "Status": "Approved ",
         "Description": "Permit Adjustment to replace existing landscaping at the northwest corner with ornamental boulders, shrubs, and ornamental landscaping gravel. ",
         "Planner": "Eric Morgan ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-472",
         "APN": 25940093,
         "File Number": "AD17-472",
         "Address": "1 S MARKET ST SAN JOSE",
         "Project Name": "AD17-472",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/2/17 10:27",
         "Status": "Approved ",
         "Description": "Permit adjustment to allow a new exterior door; and two large planters 23' wide by 20\" high on either side of the door to mitigate the door swinging into the public right-of-way.",
         "Planner": "Jan Warne ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-519",
         "APN": 46717090,
         "File Number": "AD17-519",
         "Address": "425 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD17-519",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/9/17 15:08",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow removal and replacement of 6 existing antennas with 6 new antennas roof mounted og a commercial building. No increase in height is proposed under this permit.",
         "Planner": "Suparna Saha ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-572",
         "APN": 25943074,
         "File Number": "AD17-572",
         "Address": "333 W SAN CARLOS ST SAN JOSE",
         "Project Name": "AD17-572",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/23/17",
         "Status": "Approved ",
         "Description": "Permit Adjustment to enclose an approximately 1,350 square foot balcony space to be used as office space",
         "Planner": "Dipa Chundur ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-572",
         "APN": 25943075,
         "File Number": "AD17-572",
         "Address": "333 W SAN CARLOS ST SAN JOSE",
         "Project Name": "AD17-572",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/23/17",
         "Status": "Approved ",
         "Description": "Permit Adjustment to enclose an approximately 1,350 square foot balcony space to be used as office space",
         "Planner": "Dipa Chundur ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-574",
         "APN": 25941086,
         "File Number": "AD17-574",
         "Address": "50 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD17-574",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/24/17",
         "Status": "Approved ",
         "Description": "Permit Adjustment to modify the north and south elevations of 50 W San Fernando to demolish existing \"art deco\" features above windows and door and construct new cladding elements",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-574",
         "APN": 25941087,
         "File Number": "AD17-574",
         "Address": "50 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD17-574",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/24/17",
         "Status": "Approved ",
         "Description": "Permit Adjustment to modify the north and south elevations of 50 W San Fernando to demolish existing \"art deco\" features above windows and door and construct new cladding elements",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-634",
         "APN": 47218059,
         "File Number": "AD17-634",
         "Address": "160 E VIRGINIA ST SAN JOSE",
         "Project Name": "AD17-634",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/8/17 13:41",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow the replacement of three (3) building mounted panel antennas and the addition of six (6) RRUs at an existing wireless communications facility",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-654",
         "APN": 46764008,
         "File Number": "AD17-654",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD17-654",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/19/17",
         "Status": "Approved ",
         "Description": "Permit Adjustment to modify a single-door entry into a double-door entry on the east elevation  ",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-759",
         "APN": 25934053,
         "File Number": "AD17-759",
         "Address": "111 N MARKET ST Bldg 1 SAN JOSE",
         "Project Name": "AD17-759",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/19/17 11:39",
         "Status": "Approved ",
         "Description": "Permit Adjustment to change an exterior window to a new exterior door. ",
         "Planner": "Justin Daniels ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-770",
         "APN": 25941086,
         "File Number": "AD17-770",
         "Address": "50 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD17-770",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/20/17",
         "Status": "Approved ",
         "Description": "Permit Adjustment for removal of existing decorative medallions and construction of new windows in the existing openings on the eighteenth floor of an existing office building ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-770",
         "APN": 25941087,
         "File Number": "AD17-770",
         "Address": "50 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD17-770",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/20/17",
         "Status": "Approved ",
         "Description": "Permit Adjustment for removal of existing decorative medallions and construction of new windows in the existing openings on the eighteenth floor of an existing office building ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-776",
         "APN": 47217018,
         "File Number": "AD17-776",
         "Address": "718 S 1ST ST SAN JOSE",
         "Project Name": "AD17-776 (STI) (PC) SRP BEER MANUFACTURING",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/24/17 9:30",
         "Status": "Approved ",
         "Description": "Installation of two compressors, one of them with a shed roof cover at 7' eave height, located at the rear of the building and installation of an exhaust fan at the rear wall of the building. Proposed wood screening around the compressors.",
         "Planner": "MNAGARAJ ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-786",
         "APN": 46746072,
         "File Number": "AD17-786",
         "Address": "88 E SAN CARLOS ST SAN JOSE",
         "Project Name": "AD17-786",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/26/17 19:17",
         "Status": "Approved ",
         "Description": "Permit Adjustment to incorporate permit conditions from FAA Determination of No Hazard. ",
         "Planner": "Emily Lipoma ",
         "DURATION": 42,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-791",
         "APN": 47218059,
         "File Number": "AD17-791",
         "Address": "160 E VIRGINIA ST SAN JOSE",
         "Project Name": "AD17-791",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/27/17 13:56",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow replacement of six (6) building mounted existing antennas and the addition of twelve (12) RRUs at an existing wireless facility for SPRINT.",
         "Planner": "Suparna Saha ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-827",
         "APN": 47226070,
         "File Number": "AD17-827",
         "Address": "605 S 2ND ST SAN JOSE",
         "Project Name": "AD17-827 - 605 SOUTH 2ND STREET - CONSTRUCTION TRAILER",
         "Application Type": "Permit Adjustment ",
         "Application Date": "8/7/17 14:00",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a temporary construction trailer, approximately 24 by 60 feet, to be located on a vacant lot across the street from the construction site (5 East Reed Street).",
         "Planner": "Suparna Saha ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-895",
         "APN": 25931071,
         "File Number": "AD17-895",
         "Address": "255 W JULIAN ST SAN JOSE",
         "Project Name": "AD17-895",
         "Application Type": "Permit Adjustment ",
         "Application Date": "8/24/17",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow landscape changes to an existing office building site including the removal of four (4) nonordinance-sized tree",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-949",
         "APN": 46721025,
         "File Number": "AD17-949",
         "Address": "31 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD17-949",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/12/17 13:58",
         "Status": "Approved ",
         "Description": "Permit Adjustment to update the Operations Plan for a drinking establishment with live music per Conditions of the CUP (Babylon Square). ",
         "Planner": "Sanhita Ghosal ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-963",
         "APN": 46702035,
         "File Number": "AD17-963",
         "Address": "269 N 7TH ST SAN JOSE",
         "Project Name": "AD17-963",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/14/17 15:07",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow an addition of an Accessible entrance deck, ramp, and stairs along the east and north side of the building serving each of the four units. ",
         "Planner": "Sanhita Ghosal ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-992",
         "APN": 25943069,
         "File Number": "AD17-992",
         "Address": "282 ALMADEN BL SAN JOSE",
         "Project Name": "AD17-992",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/21/17 10:00",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow removal of planter to accommodate ADA path of travel from garage, and minor upgrades to parking area on the site.  ",
         "Planner": "Sanhita Ghosal ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "AD18-032",
         "APN": 46747091,
         "File Number": "AD18-032",
         "Address": "475 S 2ND ST SAN JOSE",
         "Project Name": "AD18-032",
         "Application Type": "Permit Adjustment ",
         "Application Date": "1/12/18 15:15",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow conversion of one manager's unit to a guest room, stripe accessible parking and path of travel, replace a doubled-door with a single door on the south facade, fill-in five (5) windows on the east façade ground level, add wood trim elements to all windows, add a wrought iron pedestrian gate and screen wall above on the east façade, replace the tile pattern plaster with smooth plaster on all four facades, and add stone veneer cladding to the ground floor of a portion of the south façade and all of the east façade frontage.",
         "Planner": "Sanhita Ghosal ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "AD18-035",
         "APN": 25934057,
         "File Number": "AD18-035",
         "Address": "8 N SAN PEDRO ST SAN JOSE",
         "Project Name": "AD18-035",
         "Application Type": "Permit Adjustment ",
         "Application Date": "1/16/18 14:05",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow change to entry door size and shape and an addition of a faux door and balcony and white brick exterior to the elevator tower. ",
         "Planner": "Patrick Kelly ",
         "DURATION": 1,
         "Year": 2018
      },
      {
         "PERMITID": "AD18-1009",
         "APN": 47228037,
         "File Number": "AD18-1009",
         "Address": "283 E REED ST SAN JOSE",
         "Project Name": "AD18-1009",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/18/18 10:41",
         "Status": "Approved ",
         "Description": "Permit adjustment to allow three exterior lights on the South and West facades.. ",
         "Planner": "Jan Warne ",
         "DURATION": 1,
         "Year": 2018
      },
      {
         "PERMITID": "AD18-1055",
         "APN": 46757083,
         "File Number": "AD18-1055",
         "Address": "235 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD18-1055",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/31/18 13:23",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow replacement of existing fabric awnings with new fabric awnings on the front and side facades of an historic building. ",
         "Planner": "David Fong ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "AD18-1092",
         "APN": 46721023,
         "File Number": "AD18-1092",
         "Address": "2 N 1ST ST SAN JOSE",
         "Project Name": "AD18-1092",
         "Application Type": "Permit Adjustment ",
         "Application Date": "11/14/18 9:38",
         "Status": "Approved ",
         "Description": "Permit Adjustment to install three new antennas, installation of radio equipment, and the installation of fiber and power cables. ",
         "Planner": "Justin Daniels ",
         "DURATION": 1,
         "Year": 2018
      },
      {
         "PERMITID": "AD18-111",
         "APN": 25934053,
         "File Number": "AD18-111",
         "Address": "111 N MARKET ST Bldg 1 SAN JOSE",
         "Project Name": "AD18-111",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/7/18 10:16",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow minor exterior building façade changes to the proportions and locations of materials, and adjustment of the location of some doors as required by Building. ",
         "Planner": "Eric Morgan ",
         "DURATION": 1,
         "Year": 2018
      },
      {
         "PERMITID": "AD18-1152",
         "APN": 25939120,
         "File Number": "AD18-1152",
         "Address": "95 S ALMADEN AV SAN JOSE",
         "Project Name": "AD18-1152",
         "Application Type": "Permit Adjustment ",
         "Application Date": "12/10/18 13:42",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow removal of (3) wireless antennae and replacement with (3) wireless antennae in the same location at the same height, along with miscellaneous ground equipment hidden behind the roof parapet.",
         "Planner": "Eric Morgan ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "AD18-1182",
         "APN": 46745030,
         "File Number": "AD18-1182",
         "Address": "330 S 3RD ST SAN JOSE",
         "Project Name": "AD18-1182",
         "Application Type": "Permit Adjustment ",
         "Application Date": "12/18/18 14:10",
         "Status": "Approved ",
         "Description": "Permit Adjustment for an outdoor patio. ",
         "Planner": "Justin Daniels ",
         "DURATION": 1,
         "Year": 2018
      },
      {
         "PERMITID": "AD18-191",
         "APN": 26137029,
         "File Number": "AD18-191",
         "Address": "655 W SAN CARLOS ST SAN JOSE",
         "Project Name": "AD18-191",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/5/18 14:51",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow nine (9), new vaccum equipment stations for self service vaccum cleaning, removal of two (2) storage sheds, and general site improvements for an existing car wash.",
         "Planner": "Lori Moniz ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "AD18-208",
         "APN": 25939120,
         "File Number": "AD18-208",
         "Address": "95 S ALMADEN AV SAN JOSE",
         "Project Name": "AD18-208",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/8/18 11:01",
         "Status": "Approved ",
         "Description": "To construct a soffit on the second floor balcony over the balcony door to house the intake installation of the air handler unit. ",
         "Planner": "Lori Moniz ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "AD18-228",
         "APN": 25943069,
         "File Number": "AD18-228",
         "Address": "282 ALMADEN BL SAN JOSE",
         "Project Name": "AD18-228",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/15/18 10:13",
         "Status": "Approved ",
         "Description": "Permit Adjustment to all the conversion of four hotel suites into eight studio suites. ",
         "Planner": "Lori Moniz ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "AD18-251",
         "APN": 25940041,
         "File Number": "AD18-251",
         "Address": "15 S 1ST ST SAN JOSE",
         "Project Name": "AD18-251",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/21/18 10:09",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove the second floor stucco and tile roofed awning and replace with new stucco and a cloth awning ",
         "Planner": "Lori Moniz ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "AD18-370",
         "APN": 25936074,
         "File Number": "AD18-370",
         "Address": "333 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD18-370 - 333 WEST SANTA CLARA STREET - SPRINT",
         "Application Type": "Permit Adjustment ",
         "Application Date": "4/25/18 14:43",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow the replacement of five (5), façade mounted, panel antennas and three (3) RRUs and with nine (9) antennas and nine (9) RRUs on the façade of the penthouse of an existing office building.",
         "Planner": "Justin Daniels ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "AD18-375",
         "APN": 46721023,
         "File Number": "AD18-375",
         "Address": "2 N 1ST ST SAN JOSE",
         "Project Name": "AD18-375",
         "Application Type": "Permit Adjustment ",
         "Application Date": "4/26/18 13:04",
         "Status": "Approved ",
         "Description": "Permit Adjustment to remove and replace seven (7) antennas, install nine (9) new RRUS, install one (1) new battery cabinet with one (1) battery string.",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2018
      },
      {
         "PERMITID": "AD18-498",
         "APN": 47229096,
         "File Number": "AD18-498",
         "Address": "524 S 9TH ST SAN JOSE",
         "Project Name": "AD18-498",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/23/18 14:42",
         "Status": "Approved ",
         "Description": "Permit Adjustment to modify the roof of an existing carport from a flat roof to a slanted roof. ",
         "Planner": "Eric Morgan ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "AD18-516",
         "APN": 25936074,
         "File Number": "AD18-516",
         "Address": "333 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD18-516",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/25/18 13:55",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow the replacement of three (3), façade mounted, panel antennas and three (3) RRUs, remove and replace equipment in the equipment shelter and new concealment walls for existing equipment on the penthouse of an existing office building.",
         "Planner": "Eric Morgan ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "AD18-579",
         "APN": 46717090,
         "File Number": "AD18-579",
         "Address": "425 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD18-579",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/13/18",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow the replacement of three (3) panel antennas, installation of three (3) additional panel antennas, replacement of three (3) RRUs, installation of twelve (12) additional RRUs, and installation of associated equipment behind an expanded rooftop screen for an existing building mounted wireless facility. (AT&T)",
         "Planner": "Eric Morgan ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "AD18-586",
         "APN": 47218006,
         "File Number": "AD18-586",
         "Address": "754 S 3RD ST SAN JOSE",
         "Project Name": "AD18-586",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/15/18 9:42",
         "Status": "Approved ",
         "Description": "Permit Adjustment for the removal of five (5) Trees of Heaven , ranging from 25 to 37 inches in circumference, located between the garage and the property line on a 0.17 gross acre site located in RM multi-family zoning district",
         "Planner": "Sanhita Ghosal ",
         "DURATION": 1,
         "Year": 2018
      },
      {
         "PERMITID": "AD18-607",
         "APN": 25932079,
         "File Number": "AD18-607",
         "Address": "0 TERRAINE ST SAN JOSE",
         "Project Name": "AD18-607",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/20/18",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow the first one (1) year General Extension to Site Development Permit H14-004 extending the expiration date of the permit from July 18, 2018 to July 18, 2019.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2018
      },
      {
         "PERMITID": "AD18-613",
         "APN": 25939115,
         "File Number": "AD18-613",
         "Address": "99 ALMADEN BL SAN JOSE",
         "Project Name": "AD18-613",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/21/18",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow the removal of 3,307 square feet of landscaping to provide four (4) accessible parking spaces with associated ramps and walkways.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2018
      },
      {
         "PERMITID": "AD18-654",
         "APN": 25939120,
         "File Number": "AD18-654",
         "Address": "95 S ALMADEN AV SAN JOSE",
         "Project Name": "AD18-654",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/5/18 12:01",
         "Status": "Approved ",
         "Description": "Permit adjustment to allow modification to an existing T-Mobile telecommunications site on the rooftop of the ATT&T building including adding three antennas, cabling and to remove unused equipment. ",
         "Planner": "Jan Warne ",
         "DURATION": 1,
         "Year": 2018
      },
      {
         "PERMITID": "AD18-725",
         "APN": 46720068,
         "File Number": "AD18-725",
         "Address": "96 N 3RD ST SAN JOSE",
         "Project Name": "AD18-725",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/25/18 13:44",
         "Status": "Approved ",
         "Description": "Permit adjustment to allow modification to an existing telecommunications site located on the roof behind screening including addition of three antennas. ",
         "Planner": "Jan Warne ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "AD18-745",
         "APN": 25941088,
         "File Number": "AD18-745",
         "Address": "172 S MARKET ST SAN JOSE",
         "Project Name": "AD18-745",
         "Application Type": "Permit Adjustment ",
         "Application Date": "8/1/18",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow a façade update including relocation of the main entry and new layout for the sidewalk café. (The Grill on the Alley) ",
         "Planner": "Jan Warne ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "AD18-780",
         "APN": 46722121,
         "File Number": "AD18-780",
         "Address": "35 S 2ND ST SAN JOSE",
         "Project Name": "AD18-780",
         "Application Type": "Permit Adjustment ",
         "Application Date": "8/10/18 13:59",
         "Status": "Approved ",
         "Description": "Permit adjustment to allow removal of three non-ordinance Cypress trees, to be replaced by three Crape Myrtle trees. ",
         "Planner": "Jan Warne ",
         "DURATION": 1,
         "Year": 2018
      },
      {
         "PERMITID": "AD18-899",
         "APN": 47226062,
         "File Number": "AD18-899",
         "Address": "640 S 2ND ST SAN JOSE",
         "Project Name": "AD18-899",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/14/18 8:35",
         "Status": "Approved ",
         "Description": "Permit Adjustment to replace all the windows on the building like for like within the existing wood trimand to remove and replace the existing porch railing within new wood railings.  ",
         "Planner": "Jan Warne ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "AD18-958",
         "APN": 46746108,
         "File Number": "AD18-958",
         "Address": "375 S 3RD ST SAN JOSE",
         "Project Name": "AD18-958",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/1/18 8:46",
         "Status": "Approved ",
         "Description": "Permit Adjustment for the addition of a new door to provide access between the toddler room and the outdoor play yard at an existing day care facility (YWCA). ",
         "Planner": "Lori Moniz ",
         "DURATION": 1,
         "Year": 2018
      },
      {
         "PERMITID": "AD18-959",
         "APN": 47229012,
         "File Number": "AD18-959",
         "Address": "598 S 9TH ST SAN JOSE",
         "Project Name": "AD18-959",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/1/18 10:26",
         "Status": "Approved ",
         "Description": "Permit adjustment to allow exterior façade remodel including changing the front entrance and replacing the front entrance patio cover and removing stone façade to replace with wood paneling. Also adding landscaping and outdoor seating to the patio including stucco finished planters with bamboo. ",
         "Planner": "Jan Warne ",
         "DURATION": 1,
         "Year": 2018
      },
      {
         "PERMITID": "AD18-971",
         "APN": 25934043,
         "File Number": "AD18-971",
         "Address": "19 N MARKET ST SAN JOSE",
         "Project Name": "AD18-971",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/3/18",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow façade changes for Taco Bell - San Jose Cantina ",
         "Planner": "Jan Warne ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "AD19-147",
         "APN": 25940074,
         "File Number": "AD19-147",
         "Address": "2 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD19-147",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/14/19 9:24",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow 1) new planter boxes on ground level 1st Street façade, 2) new storefront, including replacing canopy, doors, and windows, on ground level West Santa Clara Street façade, 3) adding opaque window glazing to restroom windows on multiple floors on the southeast and southwest facades, 4) new rooftop handrails on all facades, 5) new vertical aluminum trim extensions along roof parapet on 1st Street and West Santa Clara Street facades, 6) new rooftop terrace with canopy, tables, seating, shelving, lighting, and landscaping on 5th floor roof east façade, 7) new wall pack integral motion/photo sensor lighting on 5th floor roof east façade, 8) new exterior building accent LED wall light illuminating the 6th through 9th floors on the west façade, 9) new \"vision glass\" at stairwell windows on multiple floors on the southwest façade, and 10) new rooftop mechanical equipment.",
         "Planner": "David Fong ",
         "DURATION": 0,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-168",
         "APN": 46717090,
         "File Number": "AD19-168",
         "Address": "425 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD19-168",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/20/19 11:13",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow removal of 6 existing panel antennas with 6 new antennas ( the total count remaining same),These antennas are on rooftop, within an equipment enclosure. This permit modifies the approved AD18-579",
         "Planner": "David Fong ",
         "DURATION": 0,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471001,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471006,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471007,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471009,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471010,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471011,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471013,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471014,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471017,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471018,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471019,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471020,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471021,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471022,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471023,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471025,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471026,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471028,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471029,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471030,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471031,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471034,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471035,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471036,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471037,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471038,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471039,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471040,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471041,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471042,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471043,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471044,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471045,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471046,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471047,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471049,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471050,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471051,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471052,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471053,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471054,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471055,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471056,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471057,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471059,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471060,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471061,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471062,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471063,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471064,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471065,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471066,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471068,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471069,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471070,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471071,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471072,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471073,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471074,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471075,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471077,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471078,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471080,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471082,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471083,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471084,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471085,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471086,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471087,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471088,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471089,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471091,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471092,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471093,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471094,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471095,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471096,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471097,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471100,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471102,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471103,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471104,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471105,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471106,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471107,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471108,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471109,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471110,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471111,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471112,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471113,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471114,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471115,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471116,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471117,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471118,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471119,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471121,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471122,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471123,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471124,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471125,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471127,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471128,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471130,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471131,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471132,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471133,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471134,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471135,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471136,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471137,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471138,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471140,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471141,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471142,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471143,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471144,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471145,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471146,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471147,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471148,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471149,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471150,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471151,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471152,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471153,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471154,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471155,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471156,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471157,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471158,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471159,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471160,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471161,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471162,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471163,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471164,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471165,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471166,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471167,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471168,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471169,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471171,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471172,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471173,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471174,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471175,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471177,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471178,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471179,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471182,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471184,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471185,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471186,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471187,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471188,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471189,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471191,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471192,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471193,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471195,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471196,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471197,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471198,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471199,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471200,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471201,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471202,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471203,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471204,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471205,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471207,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471208,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471209,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471210,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471211,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471212,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471213,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471214,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471215,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471216,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471217,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-206",
         "APN": 26471218,
         "File Number": "AD19-206",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "AD19-206",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow exterior modifications to the 5th floor outdoor amenity area including the construction of a 375 square foot trellis, new glass railing, string lighting, and removal of artificial lawn.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-288",
         "APN": 25940012,
         "File Number": "AD19-288",
         "Address": "70 S ALMADEN AV SAN JOSE",
         "Project Name": "AD19-288",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/28/19 14:44",
         "Status": "Approved ",
         "Description": "Permit adjustment to extend for one (1) year the Special Use Permit SP16-021, currently expiring May 23, 2019, thereby extending SP16-021 for one year.",
         "Planner": "Jan Warne ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-302",
         "APN": 25940087,
         "File Number": "AD19-302",
         "Address": "160 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD19-302",
         "Application Type": "Permit Adjustment ",
         "Application Date": "4/2/19 11:37",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow entry architectural embellishments by LED lighting, the entry entrance. to building located at 160 West Santa Clara Street. (The address is not approved under this permit.) The lights shall be dimmed after 11:00:pm to 5:00 AM",
         "Planner": "Jan Warne ",
         "DURATION": 0,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-318",
         "APN": 47229012,
         "File Number": "AD19-318",
         "Address": "598 S 9TH ST SAN JOSE",
         "Project Name": "AD19-318",
         "Application Type": "Permit Adjustment ",
         "Application Date": "4/5/19 11:42",
         "Status": "Approved ",
         "Description": "Permit adjustment to allow changes to the entryway including the door and awning for Grand Hall apartment complex. ",
         "Planner": "Jan Warne ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-347",
         "APN": 25935020,
         "File Number": "AD19-347",
         "Address": "225 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD19-347",
         "Application Type": "Permit Adjustment ",
         "Application Date": "4/12/19 14:20",
         "Status": "Approved ",
         "Description": "Permit adjustment to allow replacing single door and window with a double door entry on the 16th floor patio.",
         "Planner": "Jan Warne ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-360",
         "APN": 26420121,
         "File Number": "AD19-360",
         "Address": "395 BIRD AV SAN JOSE",
         "Project Name": "AD19-360",
         "Application Type": "Permit Adjustment ",
         "Application Date": "4/17/19",
         "Status": "Approved ",
         "Description": "Permit Adjustment to install a 6.5-foot tall fence along the Royal Avenue property line",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD86-381",
         "APN": 26429057,
         "File Number": "AD86-381",
         "Address": "301 S 1ST ST SAN JOSE",
         "Project Name": "AD86-381",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:30OCT86 NEW AWNING AND ATTACHED SIGN",
         "Planner": "Mel Flores ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD87-153",
         "APN": 46720080,
         "File Number": "AD87-153",
         "Address": "60 N 3RD ST SAN JOSE",
         "Project Name": "AD87-153",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:24APR87 FENCE MODIFICATION, ROOF SHED",
         "Planner": "Jerry Yoshida ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD87-266",
         "APN": 47217014,
         "File Number": "AD87-266",
         "Address": "748 S 1ST ST SAN JOSE",
         "Project Name": "AD87-266",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:21JUL87",
         "Planner": "Jerry Yoshida ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD87-460",
         "APN": 46745030,
         "File Number": "AD87-460",
         "Address": "330 S 3RD ST SAN JOSE",
         "Project Name": "AD87-460",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:02DEC87 NO SIGNS APPROVED W/THIS PERMIT",
         "Planner": "Jerry Yoshida ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD87-530",
         "APN": 25933050,
         "File Number": "AD87-530",
         "Address": "263 N 1ST ST SAN JOSE",
         "Project Name": "AD87-530",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:14DEC87",
         "Planner": "Mike Enderby ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD88-019",
         "APN": 46721025,
         "File Number": "AD88-019",
         "Address": "29 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD88-019",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:26FEB88 FACADE IMPROVEMENTS-RELOCATE DOORS/WINDO",
         "Planner": "Jerry Yoshida ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD88-047",
         "APN": 25934043,
         "File Number": "AD88-047",
         "Address": "19 N MARKET ST SAN JOSE",
         "Project Name": "AD88-047",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:09MAR88 2 WINDOWS, BRICK FACADE, 3 AWNINGS W/SIG",
         "Planner": "Jerry Yoshida ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD88-113",
         "APN": 46723034,
         "File Number": "AD88-113",
         "Address": "17 S 4TH ST SAN JOSE",
         "Project Name": "AD88-113",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:22JUL88 INSTALLATION OF MAKE UP AIR SHAFTS ONLY",
         "Planner": "Vic Mendez ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD88-258",
         "APN": 25940050,
         "File Number": "AD88-258",
         "Address": "43 POST ST SAN JOSE",
         "Project Name": "AD88-258",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:16JUN88 FACADE IMPROVEMENTS",
         "Planner": "Mike Enderby ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD88-259",
         "APN": 25940063,
         "File Number": "AD88-259",
         "Address": "89 S 1ST ST SAN JOSE",
         "Project Name": "AD88-259",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:16JUN88 FACADE IMPROVEMENTS",
         "Planner": "Mike Enderby ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD88-260",
         "APN": 25940061,
         "File Number": "AD88-260",
         "Address": "71 S 1ST ST SAN JOSE",
         "Project Name": "AD88-260",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:16JUN88 FACADE IMPROVEMENTS",
         "Planner": "Mike Enderby ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD88-262",
         "APN": 25940041,
         "File Number": "AD88-262",
         "Address": "15 S 1ST ST SAN JOSE",
         "Project Name": "AD88-262",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:16JUN88 FACADE IMPROVEMENTS, SIGN",
         "Planner": "Mike Enderby ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD88-303",
         "APN": 46724012,
         "File Number": "AD88-303",
         "Address": "80 S 5TH ST SAN JOSE",
         "Project Name": "AD88-303",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:01JUL88 RELOCATE MAINTENANCE SHED",
         "Planner": "Steve Moore ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD88-370",
         "APN": 46701073,
         "File Number": "AD88-370",
         "Address": "254 N 4TH ST SAN JOSE",
         "Project Name": "AD88-370",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:06SEP88 INSTALL FUES OVER 3 ENTRYWAYS",
         "Planner": "MPAVAN ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD88-504",
         "APN": 47218045,
         "File Number": "AD88-504",
         "Address": "850 S 6TH ST SAN JOSE",
         "Project Name": "AD88-504",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:19OCT88 2 WINDOWS,ADD BALCONY/FRENCH DOORS",
         "Planner": "MPAVAN ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD88-531",
         "APN": 24944088,
         "File Number": "AD88-531",
         "Address": "380 N 1ST ST SAN JOSE",
         "Project Name": "AD88-531",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:30SEP88 1 FLAGPOLE",
         "Planner": "ISHIEKH ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD88-806",
         "APN": 46720072,
         "File Number": "AD88-806",
         "Address": "101 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD88-806",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:29DEC88 ADDING OUTSIDE DOORWAY",
         "Planner": "Jerry Yoshida ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD89-069",
         "APN": 46725006,
         "File Number": "AD89-069",
         "Address": "11 S 10TH ST SAN JOSE",
         "Project Name": "AD89-069",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:06FEB89 STOREFRONT & SIGN IMPROVEMENTS",
         "Planner": "Jerry Yoshida ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD89-071",
         "APN": 46717090,
         "File Number": "AD89-071",
         "Address": "425 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD89-071",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:06FEB89 FACADE/STOREFRONT IMPROVEMENTS",
         "Planner": "Jerry Yoshida ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD89-203",
         "APN": 46718090,
         "File Number": "AD89-203",
         "Address": "301 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD89-203",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:23MAY89 ADD 2 DOORS,CANOPY,SIGNAGE,CHNG WNDW SIZ",
         "Planner": "Jerry Yoshida ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD89-274",
         "APN": 46720072,
         "File Number": "AD89-274",
         "Address": "101 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD89-274",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:01MAY89 NEW DOOR & WINDOW ONLY",
         "Planner": "Jerry Yoshida ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD89-393",
         "APN": 46719075,
         "File Number": "AD89-393",
         "Address": "235 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD89-393",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": " ",
         "Planner": "UNKNOWN ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD89-393",
         "APN": 46757083,
         "File Number": "AD89-393",
         "Address": "235 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD89-393",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": " ",
         "Planner": "UNKNOWN ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD89-394",
         "APN": 46719075,
         "File Number": "AD89-394",
         "Address": "235 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD89-394",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": " ",
         "Planner": "UNKNOWN ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD89-394",
         "APN": 46757083,
         "File Number": "AD89-394",
         "Address": "235 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD89-394",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": " ",
         "Planner": "UNKNOWN ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD89-482",
         "APN": 46702125,
         "File Number": "AD89-482",
         "Address": "276 N 7TH ST SAN JOSE",
         "Project Name": "AD89-482",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": " ",
         "Planner": "UNKNOWN ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD89-482",
         "APN": 46702126,
         "File Number": "AD89-482",
         "Address": "276 N 7TH ST SAN JOSE",
         "Project Name": "AD89-482",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": " ",
         "Planner": "UNKNOWN ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD89-482",
         "APN": 46702127,
         "File Number": "AD89-482",
         "Address": "276 N 7TH ST SAN JOSE",
         "Project Name": "AD89-482",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": " ",
         "Planner": "UNKNOWN ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD89-590",
         "APN": 46720072,
         "File Number": "AD89-590",
         "Address": "101 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD89-590",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:17AUG89 SIGN,AWNING,PAINT,DOOR WIND CHANGES,ENTR",
         "Planner": "Jerry Yoshida ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD89-619",
         "APN": 26420125,
         "File Number": "AD89-619",
         "Address": "602 W SAN CARLOS ST SAN JOSE",
         "Project Name": "AD89-619",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:21SEP89 RAISE 2 EXISTING CANOPIES ABOVE DRIVE",
         "Planner": "RHASHIMO ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD89-717",
         "APN": 46723089,
         "File Number": "AD89-717",
         "Address": "100 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD89-717",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:1-DEC",
         "Planner": "Jerry Yoshida ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD89-720",
         "APN": 46746044,
         "File Number": "AD89-720",
         "Address": "374 S 1ST ST SAN JOSE",
         "Project Name": "AD89-720",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:17OCT89 FACADE IMPROVEMENTS",
         "Planner": "Rich Buikema ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD89-721",
         "APN": 46747090,
         "File Number": "AD89-721",
         "Address": "400 S 1ST ST SAN JOSE",
         "Project Name": "AD89-721",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:17OCT89 FACADE IMPROVEMENTS",
         "Planner": "Rich Buikema ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD89-722",
         "APN": 46746074,
         "File Number": "AD89-722",
         "Address": "386 S 1ST ST SAN JOSE",
         "Project Name": "AD89-722",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:18OCT89 FACADE IMPROVEMENTS",
         "Planner": "Rich Buikema ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD89-723",
         "APN": 46747095,
         "File Number": "AD89-723",
         "Address": "455 S 2ND ST SAN JOSE",
         "Project Name": "AD89-723",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:17OCT89 FACADE IMPROVEMENTS",
         "Planner": "Rich Buikema ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD89-724",
         "APN": 46747003,
         "File Number": "AD89-724",
         "Address": "434 S 1ST ST SAN JOSE",
         "Project Name": "AD89-724",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:17OCT89 FACADE IMPROVEMENTS",
         "Planner": "Rich Buikema ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD89-725",
         "APN": 26429065,
         "File Number": "AD89-725",
         "Address": "371 S 1ST ST SAN JOSE",
         "Project Name": "AD89-725",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:18OCT89 FACADE IMPROVEMENTS",
         "Planner": "Rich Buikema ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD89-742",
         "APN": 25940037,
         "File Number": "AD89-742",
         "Address": "46 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD89-742",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:24OCT89 FACADE IMPROVEMENTS",
         "Planner": "RHASHIMO ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD89-797",
         "APN": 46722041,
         "File Number": "AD89-797",
         "Address": "17 S 2ND ST SAN JOSE",
         "Project Name": "AD89-797",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:15NOV89 ALSO 48 E. SANTA CLARA ST, FACADE IMPROV",
         "Planner": "Vic Mendez ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD89-831",
         "APN": 25937004,
         "File Number": "AD89-831",
         "Address": "395 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD89-831",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:05DEC89 FRONT AWNING W/ ONE SIGN",
         "Planner": "Vic Mendez ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD89-849",
         "APN": 46757083,
         "File Number": "AD89-849",
         "Address": "227 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD89-849",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Replace existing tile with black tile. ",
         "Planner": "UNKNOWN ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD90-033",
         "APN": 46725006,
         "File Number": "AD90-033",
         "Address": "11 S 10TH ST SAN JOSE",
         "Project Name": "AD90-033",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:22JAN90 FACADE IMPROVEMENTS & SIGNAGE",
         "Planner": "RHASHIMO ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD90-1011",
         "APN": 46725003,
         "File Number": "AD90-1011",
         "Address": "420 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD90-1011",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:26DEC90 FACADE IMPROVEMENTS",
         "Planner": "RHASHIMO ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD90-1014",
         "APN": 46719075,
         "File Number": "AD90-1014",
         "Address": "225 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD90-1014",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:12-21 REDEVEL.",
         "Planner": "Steve Moore ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD90-1078",
         "APN": 46717090,
         "File Number": "AD90-1078",
         "Address": "425 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD90-1078",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:26DEC90 FACADE CHANGES",
         "Planner": "RHASHIMO ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD90-138",
         "APN": 47229043,
         "File Number": "AD90-138",
         "Address": "520 S 10TH ST SAN JOSE",
         "Project Name": "AD90-138",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:18FEB90 LAUNDRY, ELECTRICAL EQUIP, PAINT...",
         "Planner": "LCARRILL ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD90-191",
         "APN": 25934053,
         "File Number": "AD90-191",
         "Address": "111 N MARKET ST Bldg 1 SAN JOSE",
         "Project Name": "AD90-191",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": " ",
         "Planner": "Rich Buikema ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD90-285",
         "APN": 46720084,
         "File Number": "AD90-285",
         "Address": "152 N 3RD ST SAN JOSE",
         "Project Name": "AD90-285",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:12APR90 WROUGHT IRON FENCE ENCLOSURE",
         "Planner": "RHASHIMO ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD90-307",
         "APN": 46720079,
         "File Number": "AD90-307",
         "Address": "147 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD90-307",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:01MAY90 WATER TREATMENT CLEAN-UP SYSTEM",
         "Planner": "Vic Mendez ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD90-314",
         "APN": 46722006,
         "File Number": "AD90-314",
         "Address": "48 S 1ST ST SAN JOSE",
         "Project Name": "AD90-314",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:16APR90",
         "Planner": "RHASHIMO ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD90-360",
         "APN": 46718090,
         "File Number": "AD90-360",
         "Address": "301 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD90-360",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:23MAY90 ADD 1 WINDOW/BRICK VENEER/2 ROLL-UP DOOR",
         "Planner": "Vic Mendez ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD90-380",
         "APN": 25934028,
         "File Number": "AD90-380",
         "Address": "80 N MARKET ST SAN JOSE",
         "Project Name": "AD90-380",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:21MAY90 FACADE CHANGE",
         "Planner": "Tracy Tam ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD90-435",
         "APN": 26429058,
         "File Number": "AD90-435",
         "Address": "325 S 1ST ST SAN JOSE",
         "Project Name": "AD90-435",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:30MAY90 NEW CANOPY, SIGN",
         "Planner": "RHASHIMO ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD90-440",
         "APN": 26429057,
         "File Number": "AD90-440",
         "Address": "301 S 1ST ST SAN JOSE",
         "Project Name": "AD90-440",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:22JUN90 FACADE IMPROVEMENTS",
         "Planner": "RHASHIMO ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD90-445",
         "APN": 46747089,
         "File Number": "AD90-445",
         "Address": "410 S 1ST ST SAN JOSE",
         "Project Name": "AD90-445",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:28JUN90 FACADE IMPROVEMENTS",
         "Planner": "RHASHIMO ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD90-449",
         "APN": 25940036,
         "File Number": "AD90-449",
         "Address": "66 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD90-449",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:28JUN90 FACADE IMPROVEMENTS, AWNINGS",
         "Planner": "RHASHIMO ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD90-450",
         "APN": 25940034,
         "File Number": "AD90-450",
         "Address": "84 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD90-450",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:20JUN90 FIG PROGRAM",
         "Planner": "Tracy Tam ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD90-538",
         "APN": 46724101,
         "File Number": "AD90-538",
         "Address": "36 S 8TH ST SAN JOSE",
         "Project Name": "AD90-538",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:23JUL90 NEW SKYLIGHTS & WINDOWS ONLY (HISTORIC)",
         "Planner": "Rich Buikema ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD90-549",
         "APN": 46720053,
         "File Number": "AD90-549",
         "Address": "190 N 3RD ST SAN JOSE",
         "Project Name": "AD90-549",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:18JUL90 DOOR, STAIRWAY, WINDOWS (3)",
         "Planner": "LCARRILL ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD90-682",
         "APN": 46747091,
         "File Number": "AD90-682",
         "Address": "475 S 2ND ST SAN JOSE",
         "Project Name": "AD90-682",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:17AUG9",
         "Planner": "LCARRILL ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD90-803",
         "APN": 46746047,
         "File Number": "AD90-803",
         "Address": "396 S 1ST ST SAN JOSE",
         "Project Name": "AD90-803",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:21NOV90 FOX THEATER FACADE IMPROVEMENTS",
         "Planner": "Vic Mendez ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD91-112",
         "APN": 24944059,
         "File Number": "AD91-112",
         "Address": "311 N 2ND ST SAN JOSE",
         "Project Name": "AD91-112",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:21FEB91 DOOR **HISTORIC**",
         "Planner": "LCARRILL ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD91-539",
         "APN": 46720081,
         "File Number": "AD91-539",
         "Address": "49 N 4TH ST SAN JOSE",
         "Project Name": "AD91-539",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:05AUG91 FENCE",
         "Planner": "Vic Mendez ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD91-850",
         "APN": 24944059,
         "File Number": "AD91-850",
         "Address": "311 N 2ND ST SAN JOSE",
         "Project Name": "AD91-850",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:31OCT91 EXT STAIRS",
         "Planner": "RHASHIMO ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD92-1033",
         "APN": 46747040,
         "File Number": "AD92-1033",
         "Address": "430 S 2ND ST SAN JOSE",
         "Project Name": "AD92-1033",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:11/18/92 ADD PATIO COVER",
         "Planner": "Vic Mendez ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD92-279",
         "APN": 24946061,
         "File Number": "AD92-279",
         "Address": "153 E JULIAN ST SAN JOSE",
         "Project Name": "AD92-279",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:31MAR92 REDWOOD FENCE",
         "Planner": "Julie Caporgno ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD92-984",
         "APN": 46724038,
         "File Number": "AD92-984",
         "Address": "314 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD92-984",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:11/2/92 DOORS/WINDOWS CHANGE",
         "Planner": "Vic Mendez ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD93-069",
         "APN": 46724104,
         "File Number": "AD93-069",
         "Address": "18 S 8TH ST SAN JOSE",
         "Project Name": "AD93-069",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:2/16/93 REPLACE DOORS",
         "Planner": "Vic Mendez ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD93-490",
         "APN": 46717090,
         "File Number": "AD93-490",
         "Address": "425 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD93-490",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:9/21/93 REDO STOREFRONT",
         "Planner": "Michele Campos ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD93-549",
         "APN": 47228054,
         "File Number": "AD93-549",
         "Address": "346 E WILLIAM ST SAN JOSE",
         "Project Name": "AD93-549",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:10/15/93 ADD HANDICAP RM",
         "Planner": "Patrice Shaffer ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD93-568",
         "APN": 47217095,
         "File Number": "AD93-568",
         "Address": "831 S 2ND ST UNIT A SAN JOSE",
         "Project Name": "AD93-568",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:10/28/93 REDO DOOR W/ WINDOW",
         "Planner": "Vic Mendez ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD93-634",
         "APN": 47218007,
         "File Number": "AD93-634",
         "Address": "143 E VIRGINIA ST SAN JOSE",
         "Project Name": "AD93-634",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:11/30/93 REDO STOREFRONT",
         "Planner": "Vic Mendez ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD94-157",
         "APN": 24950083,
         "File Number": "AD94-157",
         "Address": "345 E JULIAN ST SAN JOSE",
         "Project Name": "AD94-157",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:3-18",
         "Planner": "Larry Bohannan ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD94-166",
         "APN": 47211016,
         "File Number": "AD94-166",
         "Address": " ",
         "Project Name": "AD94-166",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:3-21 EMERGENCY GENERATOR & CONCRETE PAD",
         "Planner": "Vic Mendez ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD94-242",
         "APN": 25938142,
         "File Number": "AD94-242",
         "Address": "384 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD94-242",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:4-17 WELL",
         "Planner": "Vic Mendez ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD94-248",
         "APN": 25938146,
         "File Number": "AD94-248",
         "Address": "419 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD94-248",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:4-21",
         "Planner": "Vic Mendez ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD94-288",
         "APN": 46724047,
         "File Number": "AD94-288",
         "Address": "41 S 8TH ST SAN JOSE",
         "Project Name": "AD94-288",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:5-11",
         "Planner": "UNKNOWN ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD94-334",
         "APN": 47220025,
         "File Number": "AD94-334",
         "Address": "899 S 10TH ST SAN JOSE",
         "Project Name": "AD94-334",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:5-27",
         "Planner": "UNKNOWN ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD94-472",
         "APN": 26415065,
         "File Number": "AD94-472",
         "Address": "720 W SAN CARLOS ST SAN JOSE",
         "Project Name": "AD94-472",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:7/20/94 MOVING BLDG",
         "Planner": "Vic Mendez ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD94-539",
         "APN": 25938142,
         "File Number": "AD94-539",
         "Address": "384 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD94-539",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:8/8/94 WIDEN ENTRANCE GATE",
         "Planner": "JPRANDI ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD94-627",
         "APN": 46724110,
         "File Number": "AD94-627",
         "Address": "268 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD94-627",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:9-12-94 2 AWNINGS/FENCE",
         "Planner": "RHASHIMO ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD94-688",
         "APN": 47217006,
         "File Number": "AD94-688",
         "Address": "802 S 1ST ST SAN JOSE",
         "Project Name": "AD94-688",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:10-11-94 9 FABRIC AWNINGS",
         "Planner": "Bill Scott ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD94-747",
         "APN": 25934014,
         "File Number": "AD94-747",
         "Address": "45 N 1ST ST SAN JOSE",
         "Project Name": "AD94-747",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:01NOV94 15' LIGHT POLE IN PARKING AREA",
         "Planner": "Vic Mendez ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD95-190",
         "APN": 26415065,
         "File Number": "AD95-190",
         "Address": "720 W SAN CARLOS ST SAN JOSE",
         "Project Name": "AD95-190",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:13APR95 INFILL CANOPY @ SHED RAMP",
         "Planner": "Larry Bohannan ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD95-222",
         "APN": 46701043,
         "File Number": "AD95-222",
         "Address": "250 N 3RD ST SAN JOSE",
         "Project Name": "AD95-222",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:1MAY95 REPLACE 2 WINDOWS",
         "Planner": "Vic Mendez ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD95-307",
         "APN": 46718011,
         "File Number": "AD95-307",
         "Address": "90 N 8TH ST SAN JOSE",
         "Project Name": "AD95-307",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:7JUN95 ENCLOSED PATIO AREA",
         "Planner": "Vic Mendez ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD95-329",
         "APN": 46724069,
         "File Number": "AD95-329",
         "Address": "304 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD95-329",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:15JUN95 RELOCATE WINDOW & ENTRY DOOR",
         "Planner": "Vic Mendez ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD95-349",
         "APN": 25945052,
         "File Number": "AD95-349",
         "Address": "436 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD95-349",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:22JUN95 REROOF WITH 25 YEAR COMPOSITION",
         "Planner": "Vic Mendez ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD95-712",
         "APN": 47223120,
         "File Number": "AD95-712",
         "Address": "702 S 10TH ST SAN JOSE",
         "Project Name": "AD95-712",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:7NOV95 NEW BUILDING ADDITION",
         "Planner": "Vic Mendez ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD96-317",
         "APN": 25938142,
         "File Number": "AD96-317",
         "Address": "384 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD96-317",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:01MAY96 EMERGENCY STAND-BY GENERATOR INSTALLATIO",
         "Planner": "Vic Mendez ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD96-353",
         "APN": 24948012,
         "File Number": "AD96-353",
         "Address": "235 E JULIAN ST SAN JOSE",
         "Project Name": "AD96-353",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:10MAY96 INSTALL 2 DOORS/2 WINDOWS ETC.",
         "Planner": "Susan Walton ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD96-359",
         "APN": 46702040,
         "File Number": "AD96-359",
         "Address": "285 E ST JAMES ST SAN JOSE",
         "Project Name": "AD96-359",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:13MAY96 1 YEAR EXTENTION OF SITE DEV PERMIT",
         "Planner": "Jeff Roche ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD96-421",
         "APN": 47218045,
         "File Number": "AD96-421",
         "Address": "850 S 6TH ST SAN JOSE",
         "Project Name": "AD96-421",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:03JUN96 REDO LOADING DOCK/ADD RAMP,CANOPY ETC..",
         "Planner": "Larry Bohannan ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD96-552",
         "APN": 47229095,
         "File Number": "AD96-552",
         "Address": "515 S 10TH ST SAN JOSE",
         "Project Name": "AD96-552",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:23JUL96 2 NEW GLASS DOORS",
         "Planner": "Michele Campos ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD96-690A",
         "APN": 46719029,
         "File Number": "AD96-690A",
         "Address": "188 N 6TH ST SAN JOSE",
         "Project Name": "AD96-690A",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:16SEP96 REPLACE/INSTALL LIGHTING",
         "Planner": "Michele Campos ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD96-705",
         "APN": 24948012,
         "File Number": "AD96-705",
         "Address": "235 E JULIAN ST SAN JOSE",
         "Project Name": "AD96-705",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:19SEP96 ADD STOREFRONT TO EXISTING PATIO",
         "Planner": "Jerry Yoshida ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD96-755",
         "APN": 47223122,
         "File Number": "AD96-755",
         "Address": "787 S 11TH ST SAN JOSE",
         "Project Name": "AD96-755",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:03OCT96 REPLACE/INSTALL LIGHTING",
         "Planner": "Michele Campos ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD97-045",
         "APN": 26415065,
         "File Number": "AD97-045",
         "Address": "720 W SAN CARLOS ST SAN JOSE",
         "Project Name": "AD97-045",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:16JAN97 ADD EMERGENCY GENERATOR AT BACK OF STORE",
         "Planner": "Michele Campos ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD97-1094",
         "APN": 47218059,
         "File Number": "AD97-1094",
         "Address": "160 E VIRGINIA ST SAN JOSE",
         "Project Name": "AD97-1094",
         "Application Type": "Permit Adjustment ",
         "Application Date": "11/17/97",
         "Status": "Approved ",
         "Description": "Action date:17NOV97 3 ANTENNAS / ETC..",
         "Planner": "Akoni Danielsen ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "AD97-193",
         "APN": 47217069,
         "File Number": "AD97-193",
         "Address": "741 S 3RD ST SAN JOSE",
         "Project Name": "AD97-193",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:05MAR97 REROOF 6 PLEX",
         "Planner": "Jerry Yoshida ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD97-941",
         "APN": 46718090,
         "File Number": "AD97-941",
         "Address": "301 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD97-941",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:19NOV97 NEW AWNINGS/PAINT/TRIM/MOVE SIGNS/ETC...",
         "Planner": "Akoni Danielsen ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD98-1095",
         "APN": 47218024,
         "File Number": "AD98-1095",
         "Address": "140 E VIRGINIA ST SAN JOSE",
         "Project Name": "AD98-1095",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:16NOV98 WINDOWS, DOORS ON WESTERN ELEVATION",
         "Planner": "Jerry Yoshida ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD98-116",
         "APN": 46719078,
         "File Number": "AD98-116",
         "Address": "24 N 5TH ST SAN JOSE",
         "Project Name": "AD98-116",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:3FEB98 REROOF",
         "Planner": "Vic Mendez ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD98-1169",
         "APN": 46702095,
         "File Number": "AD98-1169",
         "Address": "235 N 9TH ST SAN JOSE",
         "Project Name": "AD98-1169",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:08DEC98 80 SQ FT ADDITION AT REAR",
         "Planner": "Vic Mendez ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD98-125",
         "APN": 47217006,
         "File Number": "AD98-125",
         "Address": "802 S 1ST ST SAN JOSE",
         "Project Name": "AD98-125",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:4FEB98 CHANGE EXISTING ROLLUP DOORS TO WINDOWS",
         "Planner": "BPEDROTT ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD98-128",
         "APN": 47218059,
         "File Number": "AD98-128",
         "Address": "160 E VIRGINIA ST SAN JOSE",
         "Project Name": "AD98-128",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/6/98",
         "Status": "Approved ",
         "Description": "Wireless - Action date:06FEB98 INSTALL CELLULAR FACILITY, 3 ANTENNAS",
         "Planner": "Jerry Yoshida ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "AD98-146",
         "APN": 46718087,
         "File Number": "AD98-146",
         "Address": "345 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD98-146",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/12/98",
         "Status": "Approved ",
         "Description": "Action date:27MAR98 PAINTING,SIGNAGE,AWNING,LIGHTS",
         "Planner": "Akoni Danielsen ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "AD98-239",
         "APN": 47218059,
         "File Number": "AD98-239",
         "Address": "160 E VIRGINIA ST SAN JOSE",
         "Project Name": "AD98-239",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/18/98",
         "Status": "Approved ",
         "Description": "Action date:18MAR98 WAREHOUSE TO OFFICE CONVERSION",
         "Planner": "Jerry Yoshida ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "AD98-337",
         "APN": 47218059,
         "File Number": "AD98-337",
         "Address": "160 E VIRGINIA ST SAN JOSE",
         "Project Name": "AD98-337",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:22APR98 ROOF EQUIPMENT",
         "Planner": "Jerry Yoshida ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD98-848",
         "APN": 24948012,
         "File Number": "AD98-848",
         "Address": "235 E JULIAN ST SAN JOSE",
         "Project Name": "AD98-848",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:02SEP98 TRELLIS",
         "Planner": "Ron Eddow ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD99-1234",
         "APN": 47218024,
         "File Number": "AD99-1234",
         "Address": "140 E VIRGINIA ST SAN JOSE",
         "Project Name": "AD99-1234",
         "Application Type": "Permit Adjustment ",
         "Application Date": "12/13/99",
         "Status": "Approved ",
         "Description": "EXTERIOR LIGHTING (LPS) PAINT FIXTURE TO DARK BRONZE AND KEEP LIGHT HEADS LEVEL ALSO APN -025",
         "Planner": " ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "AD99-178",
         "APN": 46724012,
         "File Number": "AD99-178",
         "Address": "80 S 5TH ST SAN JOSE",
         "Project Name": "AD99-178",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/2/99",
         "Status": "Approved ",
         "Description": "Wireless - Action date:03MAR99 12\" DISH ANTENNA ON BUILDING",
         "Planner": "Andrew Crabtree ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "AD99-179",
         "APN": 46724012,
         "File Number": "AD99-179",
         "Address": "80 S 5TH ST SAN JOSE",
         "Project Name": "AD99-179",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/2/99",
         "Status": "Approved ",
         "Description": "Wireless - Action date:03MAR99 12\" DISH ANTENNA ON BUILDING",
         "Planner": "Andrew Crabtree ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "AD99-542",
         "APN": 24948050,
         "File Number": "AD99-542",
         "Address": "336 N 6TH ST SAN JOSE",
         "Project Name": "AD99-542",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:21JUN99 EXTENSION OF H97-03-015",
         "Planner": "Nancy Hemmen ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD99-563",
         "APN": 24948050,
         "File Number": "AD99-563",
         "Address": "336 N 6TH ST SAN JOSE",
         "Project Name": "AD99-563",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:21JUN99 EXTENSION OF HISTORIC PERMIT HP97-05-002",
         "Planner": "Nancy Hemmen ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "RA89-004",
         "APN": 25941070,
         "File Number": "RA89-004",
         "Address": " ",
         "Project Name": "RA89-004, O! Deli Corporation",
         "Application Type": "Permit Adjustment ",
         "Application Date": "1/25/89",
         "Status": "Approved ",
         "Description": "Exterior alteration - addition of an exterior door ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 1989
      },
      {
         "PERMITID": "RA90-001",
         "APN": 25941070,
         "File Number": "RA90-001",
         "Address": " ",
         "Project Name": "RA90-001, Valley Credit Union",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/1/90",
         "Status": "Approved ",
         "Description": "Installation of an ATM ",
         "Planner": "Diana Whitecar ",
         "DURATION": 0,
         "Year": 1990
      },
      {
         "PERMITID": "RA90-005",
         "APN": 25935022,
         "File Number": "RA90-005",
         "Address": " ",
         "Project Name": "RA90-005, Hotel De Anza",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/26/90",
         "Status": "Approved ",
         "Description": "Conditional administrative permit for a hotel and hotel-related uses, including a restaurant, catering, banquets, receptions, entertainment, dancing and on-premises alcohol beverage sales, service and consumption. ",
         "Planner": "Diana Whitecar ",
         "DURATION": 0,
         "Year": 1990
      },
      {
         "PERMITID": "RAD00-003",
         "APN": 46722009,
         "File Number": "RAD00-003",
         "Address": " ",
         "Project Name": "RAD00-003, Letitia Building",
         "Application Type": "Permit Adjustment ",
         "Application Date": "1/28/00",
         "Status": "Approved ",
         "Description": "Add fire escape & rear wall to historic building ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "RAD00-005",
         "APN": 25940087,
         "File Number": "RAD00-005",
         "Address": " ",
         "Project Name": "RAD00-005, Trammel Crow Parking Garage",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/2/00",
         "Status": "Approved ",
         "Description": "Add an Awning above the top of stairway @ the third story parking structure. The awning is approx. 12' x 10'",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "RAD00-012",
         "APN": 25935051,
         "File Number": "RAD00-012",
         "Address": "72 N ALMADEN AV SAN JOSE",
         "Project Name": "RAD00-012, Fanny & Alexanders",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/1/00",
         "Status": "Approved ",
         "Description": "FIP improvements to Almaden Avenue side - Landscaping, fence, lighting ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "RAD00-016",
         "APN": 25940091,
         "File Number": "RAD00-016",
         "Address": "55 S MARKET ST SAN JOSE",
         "Project Name": "RAD00-016, Market-Post Tower",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/2/00",
         "Status": "Approved ",
         "Description": "Install a 34\" x 22\" wire mesh antenna on the roof.",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "RAD00-017",
         "APN": 25941070,
         "File Number": "RAD00-017",
         "Address": "100 PARK CENTER PLAZA SAN JOSE",
         "Project Name": "RAD00-017, Packet Switch",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/22/00",
         "Status": "Approved ",
         "Description": "Install one 39\" x 22\" wire mesh antenna on roof, and then one satellite dish.",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "RAD00-018",
         "APN": 25941068,
         "File Number": "RAD00-018",
         "Address": " ",
         "Project Name": "RAD00-018, GTE Wireless",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/27/00",
         "Status": "Approved ",
         "Description": "Replace two (2) 8' panels with two (2) 4' panels on roof, relocate two (2) 8' panels and two (2) 4' panels north 15'.",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "RAD00-024",
         "APN": 25936074,
         "File Number": "RAD00-024",
         "Address": " ",
         "Project Name": "RAD00-024, Nextel PCS",
         "Application Type": "Permit Adjustment ",
         "Application Date": "4/14/00",
         "Status": "Approved ",
         "Description": "Install twelve (12) wireless antennas on building facade, below roofline, and install equipment shelter on lower roof behind existing parapet.",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "RAD00-025",
         "APN": 25924035,
         "File Number": "RAD00-025",
         "Address": " ",
         "Project Name": "RAD00-025, River Corporate Center (Sobrato/FMC)",
         "Application Type": "Permit Adjustment ",
         "Application Date": "4/19/00",
         "Status": "Approved ",
         "Description": "Minor changes to site plans: Relocate buildings (Phase II & III), change footprint and location of the parking garage. ",
         "Planner": "Dennis Korabiak ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "RAD00-026",
         "APN": 25939122,
         "File Number": "RAD00-026",
         "Address": " ",
         "Project Name": "RAD00-026, WFI - Advance Radio Telecom",
         "Application Type": "Permit Adjustment ",
         "Application Date": "4/20/00",
         "Status": "Approved ",
         "Description": "Installation of up to seven (7) telecommunciation antennas measuring approx. 14\" in diameter. Antennas to be mounted on side of existing penthouse walls and/or tripod. Radio equipment to be located in existing electrical roo.",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "RAD00-029",
         "APN": 25941070,
         "File Number": "RAD00-029",
         "Address": " ",
         "Project Name": "RAD00-029, Park Center Plaza",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/2/00",
         "Status": "Approved ",
         "Description": "Install trash compactor at loading dock on San Fernando Street. ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "RAD00-030",
         "APN": 46747089,
         "File Number": "RAD00-030",
         "Address": " ",
         "Project Name": "RAD00-030, South First Street Billiards",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/8/00",
         "Status": "Approved ",
         "Description": "Change awning, paint facade. ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "RAD00-031",
         "APN": 25924035,
         "File Number": "RAD00-031",
         "Address": " ",
         "Project Name": "RAD00-031, Metricom Antennas",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/10/00",
         "Status": "Approved ",
         "Description": "Install antenna for wireless internet connection. ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "RAD00-033",
         "APN": 25940045,
         "File Number": "RAD00-033",
         "Address": " ",
         "Project Name": "RAD00-033, Two Virgins",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/25/00",
         "Status": "Approved ",
         "Description": "Add operable windows to second floor balcony. ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "RAD00-034",
         "APN": 46747041,
         "File Number": "RAD00-034",
         "Address": " ",
         "Project Name": "RAD00-034, Dai Thanh Supermarket",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/31/00",
         "Status": "Approved ",
         "Description": "Remove existing trash dumpster and build new trash enclosure. ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "RAD00-039",
         "APN": 46722009,
         "File Number": "RAD00-039",
         "Address": "66 S 1ST ST SAN JOSE",
         "Project Name": "RAD00-039, Letitia Building",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/00",
         "Status": "Approved ",
         "Description": "Minor modification to rear fencing;add tubular steel framing, replace brick to avoid disturbance of existing trees. ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "RAD00-042",
         "APN": 25939119,
         "File Number": "RAD00-042",
         "Address": "325 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "RAD00-042, QWest Communications",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/14/00",
         "Status": "Approved ",
         "Description": "Instal back-up generators for computer equipment in ground floor of parking garage. ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "RAD00-044",
         "APN": 25924035,
         "File Number": "RAD00-044",
         "Address": "333 W JULIAN ST SAN JOSE",
         "Project Name": "RAD00-044, River Corporate Center - Sobrato/FMC",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/24/00",
         "Status": "Approved ",
         "Description": "Landscaping between the River Park Trail & the parking garage, generator, pump house & tank. The location and size of the enclosures for the generator, pump house and tank has been finalized. ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "RAD00-049",
         "APN": 46701002,
         "File Number": "RAD00-049",
         "Address": " ",
         "Project Name": "RAD00-049, Germania Hall",
         "Application Type": "Permit Adjustment ",
         "Application Date": "8/16/00",
         "Status": "Approved ",
         "Description": "Add dormers and windows to southern facade of historic German club - Fire repair construction. ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "RAD00-055",
         "APN": 25934016,
         "File Number": "RAD00-055",
         "Address": " ",
         "Project Name": "RAD00-055, Washington Mutual",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/14/00",
         "Status": "Approved ",
         "Description": "Install additional ATM machine ",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "RAD00-066",
         "APN": 25924037,
         "File Number": "RAD00-066",
         "Address": " ",
         "Project Name": "RAD00-066, Metricom",
         "Application Type": "Permit Adjustment ",
         "Application Date": "11/1/00",
         "Status": "Approved ",
         "Description": "Add exit door to exterior of building, add pallet storage enclosure ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "RAD00-067",
         "APN": 25924037,
         "File Number": "RAD00-067",
         "Address": " ",
         "Project Name": "RAD00-067, Metricom",
         "Application Type": "Permit Adjustment ",
         "Application Date": "11/1/00",
         "Status": "Approved ",
         "Description": "Add exit door to exterior of the building for cafeteria. ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "RAD00-068",
         "APN": 46722110,
         "File Number": "RAD00-068",
         "Address": " ",
         "Project Name": "RAD00-068, The Security Building",
         "Application Type": "Permit Adjustment ",
         "Application Date": "11/2/00",
         "Status": "Approved ",
         "Description": "Replace fabric on (e) awnings w/black fabric; Make minor changes to (e) main entry canopy; Replace (e) banners at light fixtures and repaint; Repaint base of building w/new color. ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "RAD00-071",
         "APN": 25939112,
         "File Number": "RAD00-071",
         "Address": " ",
         "Project Name": "RAD00-071, WFI - Advanced Radio Telecom",
         "Application Type": "Permit Adjustment ",
         "Application Date": "11/8/00",
         "Status": "Approved ",
         "Description": "2 broadband antennas mounted on rooftop, equipment cabinet in existing hvac room, Antennas measure 15\"x15\"; equipment cabinet measures 42\"x27\"x15\"",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "RAD00-071",
         "APN": 25939115,
         "File Number": "RAD00-071",
         "Address": " ",
         "Project Name": "RAD00-071, WFI - Advanced Radio Telecom",
         "Application Type": "Permit Adjustment ",
         "Application Date": "11/8/00",
         "Status": "Approved ",
         "Description": "2 broadband antennas mounted on rooftop, equipment cabinet in existing hvac room, Antennas measure 15\"x15\"; equipment cabinet measures 42\"x27\"x15\"",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "RAD00-074",
         "APN": 25940091,
         "File Number": "RAD00-074",
         "Address": " ",
         "Project Name": "RAD00-074, Market-Post Tower",
         "Application Type": "Permit Adjustment ",
         "Application Date": "12/15/00",
         "Status": "Approved ",
         "Description": "Add a generator to the roof of the building. ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "RAD01-001",
         "APN": 25936074,
         "File Number": "RAD01-001",
         "Address": " ",
         "Project Name": "RAD01-001, WFI - Advanced Radio Telecom",
         "Application Type": "Permit Adjustment ",
         "Application Date": "1/26/01",
         "Status": "Approved ",
         "Description": "Install two (2) broadband antennas (15\"x15\") mounted on rooftop with small equipment cabinet installed in Telco room.",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "RAD01-004",
         "APN": 46746016,
         "File Number": "RAD01-004",
         "Address": " ",
         "Project Name": "RAD01-004, SJSU Language Institute",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/8/01",
         "Status": "Approved ",
         "Description": "Upgrading facade, new sign ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "RAD01-005",
         "APN": 25940037,
         "File Number": "RAD01-005",
         "Address": " ",
         "Project Name": "RAD01-005, Timothy Gill Law Offices",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/15/01",
         "Status": "Approved ",
         "Description": "Facade Improvement for law offices, City Bagels, hair salon and Fuji Sushi restaurant ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "RAD01-006",
         "APN": 46721029,
         "File Number": "RAD01-006",
         "Address": " ",
         "Project Name": "RAD01-006, WFI - Advanced Radio Telecom",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/23/01",
         "Status": "Approved ",
         "Description": "Install two (2) broadband antennas (15\"x15\") on rooftop, and equipment cabinet in equipment room on ground floor.",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "RAD01-011",
         "APN": 25935029,
         "File Number": "RAD01-011",
         "Address": " ",
         "Project Name": "RAD01-011, Superior Court - Family Court",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/28/01",
         "Status": "Approved ",
         "Description": "New storefront and exit doors at main entrance; close existing openings and add new exit openings. ",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "RAD01-013",
         "APN": 25936074,
         "File Number": "RAD01-013",
         "Address": " ",
         "Project Name": "RAD01-013, XM Satellite Radio",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/29/01",
         "Status": "Approved ",
         "Description": "Install one panel, one satellite dish antenna, and related equipment cabinet. ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "RAD01-019",
         "APN": 25940074,
         "File Number": "RAD01-019",
         "Address": " ",
         "Project Name": "RAD01-019, Walgreen's Building",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/3/01",
         "Status": "Approved ",
         "Description": "Store front improvements. ",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "RAD01-020",
         "APN": 46747090,
         "File Number": "RAD01-020",
         "Address": " ",
         "Project Name": "RAD01-020, The Usual",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/15/01",
         "Status": "Approved ",
         "Description": "Facade improvement. ",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "RAD01-021",
         "APN": 25940094,
         "File Number": "RAD01-021",
         "Address": " ",
         "Project Name": "RAD01-021, The Metropole",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/25/01",
         "Status": "Approved ",
         "Description": "Adjustment permit for reduction of size/shape of previously approved dumpster/trash enclosure due to change in transformer pad location. ",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "RAD01-023",
         "APN": 25931071,
         "File Number": "RAD01-023",
         "Address": " ",
         "Project Name": "RAD01-023, GTE/Verizon Wireless",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/11/01",
         "Status": "Approved ",
         "Description": "Renewal of time conditioned CUP for facade mounted wireless communication facility currently in operation. ",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "RAD01-025",
         "APN": 25934019,
         "File Number": "RAD01-025",
         "Address": " ",
         "Project Name": "RAD01-025, Nextel antennas",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/15/01",
         "Status": "Approved ",
         "Description": "Install wireless communication - two (2) 18\" whip antennas mounted to SW corner of building & 200 sq. ft. equipment shelter mounted on roof.",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "RAD01-025",
         "APN": 25934040,
         "File Number": "RAD01-025",
         "Address": " ",
         "Project Name": "RAD01-025, Nextel antennas",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/15/01",
         "Status": "Approved ",
         "Description": "Install wireless communication - two (2) 18\" whip antennas mounted to SW corner of building & 200 sq. ft. equipment shelter mounted on roof.",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "RAD01-027",
         "APN": 25935029,
         "File Number": "RAD01-027",
         "Address": " ",
         "Project Name": "RAD01-027, Superior Court Parking Lot",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/31/01",
         "Status": "Approved ",
         "Description": "Restripe parking lot, close off 2 existing 1-way driveways and add a new 2-way driveway, and add a new trash enclosure.",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "RAD01-027",
         "APN": 25935030,
         "File Number": "RAD01-027",
         "Address": " ",
         "Project Name": "RAD01-027, Superior Court Parking Lot",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/31/01",
         "Status": "Approved ",
         "Description": "Restripe parking lot, close off 2 existing 1-way driveways and add a new 2-way driveway, and add a new trash enclosure.",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "RAD01-027",
         "APN": 46720068,
         "File Number": "RAD01-027",
         "Address": " ",
         "Project Name": "RAD01-027, Cingular Wireless",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/27/01",
         "Status": "Approved ",
         "Description": "Install six (6) wireless phone antennas on face of existing penthouse. Antennas will be flush mounted, painted to match, and will not extend above the top of structure",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "RAD01-027",
         "APN": 46720068,
         "File Number": "RAD01-027",
         "Address": " ",
         "Project Name": "RAD01-027, Superior Court Parking Lot",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/31/01",
         "Status": "Approved ",
         "Description": "Restripe parking lot, close off 2 existing 1-way driveways and add a new 2-way driveway, and add a new trash enclosure.",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "RAD01-029",
         "APN": 25940019,
         "File Number": "RAD01-029",
         "Address": " ",
         "Project Name": "RAD01-029, Shalimar Indian Cuisine",
         "Application Type": "Permit Adjustment ",
         "Application Date": "12/10/01",
         "Status": "Approved ",
         "Description": "Install canvas awning on 50' frontage with 47'-6\" coverage",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "RAD01-029",
         "APN": 26429058,
         "File Number": "RAD01-029",
         "Address": " ",
         "Project Name": "RAD01-029, Dohrmann Building",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/18/01",
         "Status": "Approved ",
         "Description": "Removal of fire escape at rear of building, patch + paint ",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "RAD01-031",
         "APN": 46722137,
         "File Number": "RAD01-031",
         "Address": " ",
         "Project Name": "RAD01-031, Jose Theater",
         "Application Type": "Permit Adjustment ",
         "Application Date": "8/28/01",
         "Status": "Approved ",
         "Description": "Modify the storefront to create a new door where a window was originally approved. This modification will render the facade of the Jose Theater symmetrical with another door at opposite side of storefront. ",
         "Planner": "Luke Connolly ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "RAD01-032",
         "APN": 26429107,
         "File Number": "RAD01-032",
         "Address": " ",
         "Project Name": "RAD01-032, Hyatt Sainte Claire Courtyard",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/11/01",
         "Status": "Approved ",
         "Description": "Alternate materials or methods application for dedicated egress easement; infill existing stair; remove existing window and replace wtith new 42\" exit door; remove adjacent window and replace to match width.",
         "Planner": "Luke Connolly ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "RAD01-034",
         "APN": 46723088,
         "File Number": "RAD01-034",
         "Address": " ",
         "Project Name": "RAD01-034, Nextel antennas",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/14/01",
         "Status": "Approved ",
         "Description": "Install wireless communication (18\" whip antennas) with equipment in the basement.",
         "Planner": "Luke Connolly ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "RAD01-034",
         "APN": 46723089,
         "File Number": "RAD01-034",
         "Address": " ",
         "Project Name": "RAD01-034, Nextel antennas",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/14/01",
         "Status": "Approved ",
         "Description": "Install wireless communication (18\" whip antennas) with equipment in the basement.",
         "Planner": "Luke Connolly ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "RAD01-036",
         "APN": 25935057,
         "File Number": "RAD01-036",
         "Address": " ",
         "Project Name": "RAD01-036, O'Flaherty's Irish Pub",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/18/01",
         "Status": "Approved ",
         "Description": "Demolition of existing glass enclosed facade and construction of new wood storefront. ",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "RAD02-001",
         "APN": 46721023,
         "File Number": "RAD02-001",
         "Address": " ",
         "Project Name": "RAD02-001, Abovenet - AT&T Wireless",
         "Application Type": "Permit Adjustment ",
         "Application Date": "1/11/02",
         "Status": "Approved ",
         "Description": "Installation of nine (9) 4' roof antennas attached to the existing penthouse on roof. Radio equipment will be located in the basement of building.",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2002
      },
      {
         "PERMITID": "RAD02-006",
         "APN": 46722056,
         "File Number": "RAD02-006",
         "Address": "71 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "RAD02-006, Stratta Grill & Bar",
         "Application Type": "Permit Adjustment ",
         "Application Date": "4/19/02",
         "Status": "Approved ",
         "Description": "Facade improvement - replace doors on both sides, replace neon, replace awning, demo & remove security gate, and paint storefront. ",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2002
      },
      {
         "PERMITID": "RAD02-023",
         "APN": 25940091,
         "File Number": "RAD02-023",
         "Address": " ",
         "Project Name": "RAD02-023, Market-Post Tower",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/23/02",
         "Status": "Approved ",
         "Description": "installation of 500 KW Generator",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2002
      },
      {
         "PERMITID": "RAD02-026",
         "APN": 25940038,
         "File Number": "RAD02-026",
         "Address": " ",
         "Project Name": "RAD02-026, Clayton & Co. Building",
         "Application Type": "Permit Adjustment ",
         "Application Date": "8/14/02",
         "Status": "Approved ",
         "Description": "Facade improvement - cleaning existing facade, painting, minor repairs, lighting and replacement of existing awnings. ",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2002
      },
      {
         "PERMITID": "RAD02-028",
         "APN": 47226091,
         "File Number": "RAD02-028",
         "Address": " ",
         "Project Name": "RAD02-028, Notre Dame - Julie Billiart Hall",
         "Application Type": "Permit Adjustment ",
         "Application Date": "8/27/02",
         "Status": "Approved ",
         "Description": "New rooftop HVAC unit ",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2002
      },
      {
         "PERMITID": "RAD02-031",
         "APN": 46721005,
         "File Number": "RAD02-031",
         "Address": " ",
         "Project Name": "RAD02-031, La Bella Cafe & Dominican Communciations FIP",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/17/02",
         "Status": "Approved ",
         "Description": "Facade improvement program through SJRA - includes signage. ",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2002
      },
      {
         "PERMITID": "RAD02-034",
         "APN": 46723069,
         "File Number": "RAD02-034",
         "Address": " ",
         "Project Name": "RAD02-034, L& R Building",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/7/02",
         "Status": "Approved ",
         "Description": "Facade improvement - new storefront entry system, new stone tile base, new clear tempered glass with mullions, new curved metal awning, cement plaster system (stucco), sconce lighting and signage. ",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2002
      },
      {
         "PERMITID": "RAD02-039",
         "APN": 46745022,
         "File Number": "RAD02-039",
         "Address": " ",
         "Project Name": "RAD02-039, Grande Pizzeria",
         "Application Type": "Permit Adjustment ",
         "Application Date": "11/4/02",
         "Status": "Approved ",
         "Description": "Facade Improvement - new windows, doors, tile bulkhead, awnings, paint, stucco work, landscaping and exterior lighting. ",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2002
      },
      {
         "PERMITID": "RAD02-040",
         "APN": 25939120,
         "File Number": "RAD02-040",
         "Address": "95 S ALMADEN AV SAN JOSE",
         "Project Name": "RAD02-040 Pacific Bell",
         "Application Type": "Permit Adjustment ",
         "Application Date": "11/26/02",
         "Status": "Approved ",
         "Description": "Replace louver with air hoods. ",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2002
      },
      {
         "PERMITID": "RAD03-001",
         "APN": 26429119,
         "File Number": "RAD03-001",
         "Address": " ",
         "Project Name": "RAD03-001, Seismic Retrofit",
         "Application Type": "Permit Adjustment ",
         "Application Date": "1/22/03",
         "Status": "Approved ",
         "Description": "Structural rehabilitation of unreinforced masonry building ",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-002",
         "APN": 26429107,
         "File Number": "RAD03-002",
         "Address": " ",
         "Project Name": "RAD03-002, Hyatt Sainte Claire",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/14/03",
         "Status": "Approved ",
         "Description": "Installation of a skylight structure and replacement of outdoor flooring in the outdoor courtyard. ",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-003",
         "APN": 25940091,
         "File Number": "RAD03-003",
         "Address": " ",
         "Project Name": "RAD03-003, Market-Post Tower",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/25/03",
         "Status": "Approved ",
         "Description": "Installation of security bollards and glass wall at ground floor lobby level to increase security and restrict unauthorized access into building. ",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-011",
         "APN": 25939120,
         "File Number": "RAD03-011",
         "Address": " ",
         "Project Name": "RAD03-011, SBC (Pacific Bell)",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/29/03",
         "Status": "Approved ",
         "Description": "Replacement of existing cooling tower on roof with new one. ",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-022",
         "APN": 25940013,
         "File Number": "RAD03-022",
         "Address": " ",
         "Project Name": "RAD03-022, Post St. Restaurant",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/11/03",
         "Status": "Approved ",
         "Description": "Interior/exterior improvements - New ADA compliant entry, new ADA compliant restrooms, new exterior stucco wall finish, new aluminum clad wood windows, new sidewalks, new 6'0\" stucco courtyard wall with new redwood trellis",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-024",
         "APN": 26427082,
         "File Number": "RAD03-024",
         "Address": "180 WOZ WY SAN JOSE",
         "Project Name": "RAD03-024, Children's Discovery Museum",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/17/03",
         "Status": "Approved ",
         "Description": "Ampitheater improvements to surfaces, landscaping, security wall lighting, shade structure and addition of outdoor restrooms. (Modifications within footprint of building.) ",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-024",
         "APN": 26427087,
         "File Number": "RAD03-024",
         "Address": "180 WOZ WY SAN JOSE",
         "Project Name": "RAD03-024, Children's Discovery Museum",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/17/03",
         "Status": "Approved ",
         "Description": "Ampitheater improvements to surfaces, landscaping, security wall lighting, shade structure and addition of outdoor restrooms. (Modifications within footprint of building.) ",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-024",
         "APN": 26427088,
         "File Number": "RAD03-024",
         "Address": "180 WOZ WY SAN JOSE",
         "Project Name": "RAD03-024, Children's Discovery Museum",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/17/03",
         "Status": "Approved ",
         "Description": "Ampitheater improvements to surfaces, landscaping, security wall lighting, shade structure and addition of outdoor restrooms. (Modifications within footprint of building.) ",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD91-006",
         "APN": 46722008,
         "File Number": "RAD91-006",
         "Address": " ",
         "Project Name": "RAD91-006, Delta-Wye Electric",
         "Application Type": "Permit Adjustment ",
         "Application Date": "4/3/91",
         "Status": "Approved ",
         "Description": "Installation of light fixtures on facde of building ",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1991
      },
      {
         "PERMITID": "RAD91-010",
         "APN": 25940084,
         "File Number": "RAD91-010",
         "Address": " ",
         "Project Name": "RAD91-010, Bellino's Inc.",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/7/91",
         "Status": "Approved ",
         "Description": "Facade improvement & signs ",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1991
      },
      {
         "PERMITID": "RAD91-012",
         "APN": 25939115,
         "File Number": "RAD91-012",
         "Address": " ",
         "Project Name": "RAD91-012, Union Bank Bldg. Emergency generator",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/16/91",
         "Status": "Approved ",
         "Description": "Install 300 gal. above ground diesel storage tank to provide fuel for standby generator for emergency electrical to bldg.",
         "Planner": "Ted Lorraine ",
         "DURATION": 0,
         "Year": 1991
      },
      {
         "PERMITID": "RAD91-017",
         "APN": 25940084,
         "File Number": "RAD91-017",
         "Address": " ",
         "Project Name": "RAD91-017, Bellino's",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/18/91",
         "Status": "Approved ",
         "Description": "Interior and exterior fire code alterations ",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1991
      },
      {
         "PERMITID": "RAD91-018",
         "APN": 46747095,
         "File Number": "RAD91-018",
         "Address": "545 S 2ND ST SAN JOSE",
         "Project Name": "RAD91-018, Emile's Restaurant",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/27/91",
         "Status": "Approved ",
         "Description": "Facade improvements ",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1991
      },
      {
         "PERMITID": "RAD91-021",
         "APN": 47226033,
         "File Number": "RAD91-021",
         "Address": " ",
         "Project Name": "RAD91-021, Poor Scotty's",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/28/91",
         "Status": "Approved ",
         "Description": "Facade improvement program ",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1991
      },
      {
         "PERMITID": "RAD91-023",
         "APN": 47226036,
         "File Number": "RAD91-023",
         "Address": " ",
         "Project Name": "RAD91-023, Antique Emporium",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/28/91",
         "Status": "Approved ",
         "Description": "Facade improvement program ",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1991
      },
      {
         "PERMITID": "RAD91-036",
         "APN": 25934018,
         "File Number": "RAD91-036",
         "Address": " ",
         "Project Name": "RAD91-036, Coast Funding Corp.",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/9/91",
         "Status": "Approved ",
         "Description": "Downtown Storefront Program ",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1991
      },
      {
         "PERMITID": "RAD91-039",
         "APN": 25940046,
         "File Number": "RAD91-039",
         "Address": " ",
         "Project Name": "RAD91-039, Post/First St. Commercial Building",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/16/91",
         "Status": "Approved ",
         "Description": "Existing canopy to remain, proposed signage and storefront awnings to be as shown on revised elevation dated 10/10/91",
         "Planner": "Ted Lorraine ",
         "DURATION": 0,
         "Year": 1991
      },
      {
         "PERMITID": "RAD92-001",
         "APN": 26429107,
         "File Number": "RAD92-001",
         "Address": " ",
         "Project Name": "RAD92-001, Hotel Sainte Claire",
         "Application Type": "Permit Adjustment ",
         "Application Date": "1/6/92",
         "Status": "Approved ",
         "Description": "Terra cotta repair, new windows to match original historical character, raise elevator machine room roof, restore roof and wall signs to original historical character. ",
         "Planner": "Ted Lorraine ",
         "DURATION": 0,
         "Year": 1992
      },
      {
         "PERMITID": "RAD92-005",
         "APN": 25944080,
         "File Number": "RAD92-005",
         "Address": " ",
         "Project Name": "RAD92-005, PG&E Emergency Generator",
         "Application Type": "Permit Adjustment ",
         "Application Date": "1/24/92",
         "Status": "Approved ",
         "Description": "Install an emergency generator for new fire protection system. Install 7'-0\" high security fence around generator and plant vines for screening.",
         "Planner": "Ted Lorraine ",
         "DURATION": 0,
         "Year": 1992
      },
      {
         "PERMITID": "RAD92-008",
         "APN": 25939122,
         "File Number": "RAD92-008",
         "Address": " ",
         "Project Name": "RAD92-008, Almaden Tower",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/7/92",
         "Status": "Approved ",
         "Description": "Installation of new entrance ",
         "Planner": "Ted Lorraine ",
         "DURATION": 0,
         "Year": 1992
      },
      {
         "PERMITID": "RAD92-009",
         "APN": 25939115,
         "File Number": "RAD92-009",
         "Address": " ",
         "Project Name": "RAD92-009, Pacific Bell Pump House",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/14/92",
         "Status": "Approved ",
         "Description": "Relocate existing pump house 80'-100' north to facilitate necessary modifications to existing emergency services.",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1992
      },
      {
         "PERMITID": "RAD92-010",
         "APN": 25934053,
         "File Number": "RAD92-010",
         "Address": " ",
         "Project Name": "RAD92-010, Community Plaza",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/27/92",
         "Status": "Approved ",
         "Description": "Expansion of concrete block wall to house fire sprinkler pump in utility room location on N. San Pedro ",
         "Planner": "Ted Lorraine ",
         "DURATION": 0,
         "Year": 1992
      },
      {
         "PERMITID": "RAD92-012",
         "APN": 47226034,
         "File Number": "RAD92-012",
         "Address": " ",
         "Project Name": "RAD92-012, Western Mountaineering",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/12/92",
         "Status": "Approved ",
         "Description": "Replacement of 2 HVAC units on roof.",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1992
      },
      {
         "PERMITID": "RAD92-025",
         "APN": 25943075,
         "File Number": "RAD92-025",
         "Address": " ",
         "Project Name": "RAD92-025, Paolo's Restaurant",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/29/92",
         "Status": "Approved ",
         "Description": "Outdoor restaurant service w/tables, chairs, umbrellas, planter and/or ropes/poles on ground level and mezzanine (2nd floor) level.",
         "Planner": "Ted Lorraine ",
         "DURATION": 0,
         "Year": 1992
      },
      {
         "PERMITID": "RAD92-029",
         "APN": 46747041,
         "File Number": "RAD92-029",
         "Address": " ",
         "Project Name": "RAD92-029, Dia Thanh Supermarket",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/31/92",
         "Status": "Approved ",
         "Description": "Replacement of freezer/cooler unit per County Health Dept. Includes (2) condensing units and installation of 11' fire wall; replace perimeter fence.",
         "Planner": "Ted Lorraine ",
         "DURATION": 0,
         "Year": 1992
      },
      {
         "PERMITID": "RAD92-030",
         "APN": 46701002,
         "File Number": "RAD92-030",
         "Address": " ",
         "Project Name": "RAD92-030, Germania Hall",
         "Application Type": "Permit Adjustment ",
         "Application Date": "8/6/92",
         "Status": "Approved ",
         "Description": "Minor addition to existing Germania Hall ",
         "Planner": "Ted Lorraine ",
         "DURATION": 0,
         "Year": 1992
      },
      {
         "PERMITID": "RAD92-039",
         "APN": 46721034,
         "File Number": "RAD92-039",
         "Address": "2 N 2ND ST SAN JOSE",
         "Project Name": "RAD92-039, Horizon Center Emergency Generator fuel tank",
         "Application Type": "Permit Adjustment ",
         "Application Date": "11/9/02",
         "Status": "Approved ",
         "Description": "removal of underground fuel storage tank and replacement w/above ground diesel storage tank for emergency generator ",
         "Planner": "Ted Lorraine ",
         "DURATION": 0,
         "Year": 2002
      },
      {
         "PERMITID": "RAD92-041",
         "APN": 25940084,
         "File Number": "RAD92-041",
         "Address": " ",
         "Project Name": "RAD92-041, Parking Garage Door",
         "Application Type": "Permit Adjustment ",
         "Application Date": "12/1/92",
         "Status": "Approved ",
         "Description": "Installation of parking garage automated entry system including two (2) roll-up doors with motor operators, card reader, exit and safety loops, bollard posts, and approx. 500 sq. ft. of tube steel fencing.",
         "Planner": "Ted Lorraine ",
         "DURATION": 0,
         "Year": 1992
      },
      {
         "PERMITID": "RAD93-002",
         "APN": 46746015,
         "File Number": "RAD93-002",
         "Address": " ",
         "Project Name": "RAD93-002, Palermo Restaurant",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/11/93",
         "Status": "Approved ",
         "Description": "Facade improvement to South and East elevations ",
         "Planner": "Ted Lorraine ",
         "DURATION": 0,
         "Year": 1993
      },
      {
         "PERMITID": "RAD93-021",
         "APN": 46721034,
         "File Number": "RAD93-021",
         "Address": " ",
         "Project Name": "RAD93-021, Horizon Building",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/29/93",
         "Status": "Approved ",
         "Description": "Remove existing exterior glass storefront and doors; provide new recessed entry; remove existing tenant exterior glass doors; provide new glass storefront windows to match existing. ",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1993
      },
      {
         "PERMITID": "RAD93-027",
         "APN": 46722008,
         "File Number": "RAD93-027",
         "Address": " ",
         "Project Name": "RAD93-027, Bella Mia Restaurant",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/1/93",
         "Status": "Approved ",
         "Description": "Addition of a steel canopy at the front entry; sign program for building to include: front - 3 sets individual letter on prop. canopy, rear - 1 painted wall sign on building wall and one (1) 15 sq. brass/acrylic plaque on wall facing parking lot.",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1993
      },
      {
         "PERMITID": "RAD93-028",
         "APN": 25935035,
         "File Number": "RAD93-028",
         "Address": " ",
         "Project Name": "RAD93-028, D. B. Cooper's",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/13/93",
         "Status": "Approved ",
         "Description": "Change windows to doors - 1st window to left of Peggy Sue's entrance.",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1993
      },
      {
         "PERMITID": "RAD93-029",
         "APN": 46720079,
         "File Number": "RAD93-029",
         "Address": " ",
         "Project Name": "RAD93-029, Chevron Station",
         "Application Type": "Permit Adjustment ",
         "Application Date": "11/15/93",
         "Status": "Approved ",
         "Description": "Remove & replace existing fuel dispensers. Install new yard lights. Partial interior building remodel. New signage ",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1993
      },
      {
         "PERMITID": "RAD93-031",
         "APN": 46722003,
         "File Number": "RAD93-031",
         "Address": " ",
         "Project Name": "RAD93-031, Lido Nightclub & Grant's Jewelry - FIP",
         "Application Type": "Permit Adjustment ",
         "Application Date": "11/16/93",
         "Status": "Approved ",
         "Description": "Downtown storefront facade improvement program ",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1993
      },
      {
         "PERMITID": "RAD93-033",
         "APN": 46722056,
         "File Number": "RAD93-033",
         "Address": " ",
         "Project Name": "RAD93-033, Cinebar, Twice Read Books, Mandrake's Shoe Repair",
         "Application Type": "Permit Adjustment ",
         "Application Date": "11/16/93",
         "Status": "Approved ",
         "Description": "Downtown storefront facade improvement program ",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1993
      },
      {
         "PERMITID": "RAD93-040",
         "APN": 25935035,
         "File Number": "RAD93-040",
         "Address": " ",
         "Project Name": "RAD93-040, San Pedro Square",
         "Application Type": "Permit Adjustment ",
         "Application Date": "12/22/93",
         "Status": "Approved ",
         "Description": "San Pedro Square facade improvement program ",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1993
      },
      {
         "PERMITID": "RAD93-040",
         "APN": 25935057,
         "File Number": "RAD93-040",
         "Address": " ",
         "Project Name": "RAD93-040, San Pedro Square",
         "Application Type": "Permit Adjustment ",
         "Application Date": "12/22/93",
         "Status": "Approved ",
         "Description": "San Pedro Square facade improvement program ",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1993
      },
      {
         "PERMITID": "RAD94-007",
         "APN": 46722042,
         "File Number": "RAD94-007",
         "Address": " ",
         "Project Name": "RAD94-007, Moderne Drug",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/28/94",
         "Status": "Approved ",
         "Description": "Downtown Facade improvement program ",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1994
      },
      {
         "PERMITID": "RAD94-010",
         "APN": 25940092,
         "File Number": "RAD94-010",
         "Address": "18 S ALMADEN AV SAN JOSE",
         "Project Name": "RAD94-010, Yee Building",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/94",
         "Status": "Approved ",
         "Description": "Request for two (2) year extension for site development permit (RH91-01-001)",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1994
      },
      {
         "PERMITID": "RAD94-011",
         "APN": 46746015,
         "File Number": "RAD94-011",
         "Address": " ",
         "Project Name": "RAD94-011, Palermo Restaurant FIP",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/4/94",
         "Status": "Approved ",
         "Description": "Facade trimwork is proposed to be changed in style to be finished with stucco and a complimentary paint color ",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1994
      },
      {
         "PERMITID": "RAD94-018",
         "APN": 25939111,
         "File Number": "RAD94-018",
         "Address": "350 W SANTA CLARA ST SAN JOSE",
         "Project Name": "RAD94-018, Vacant Lot Concrete Wall",
         "Application Type": "Permit Adjustment ",
         "Application Date": "4/15/94",
         "Status": "Approved ",
         "Description": "Install concrete screen wall at perimeter of vacant lot. Pave vacant lot with 3/4\" base rock and oil.",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1994
      },
      {
         "PERMITID": "RAD94-023",
         "APN": 46747042,
         "File Number": "RAD94-023",
         "Address": " ",
         "Project Name": "RAD94-023, Dai Thanh Plaza II",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/6/94",
         "Status": "Approved ",
         "Description": "Addition of approximately 253 sf to existing building",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1994
      },
      {
         "PERMITID": "RAD94-025",
         "APN": 25940084,
         "File Number": "RAD94-025",
         "Address": " ",
         "Project Name": "RAD94-025, Teleport Communications",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/14/94",
         "Status": "Approved ",
         "Description": "Add additional mechanical equipment to second floor roof. ",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1994
      },
      {
         "PERMITID": "RAD94-029",
         "APN": 46721034,
         "File Number": "RAD94-029",
         "Address": " ",
         "Project Name": "RAD94-029, Horizon Center Courtyard",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/19/94",
         "Status": "Approved ",
         "Description": "Renovation and remodel of an existing multi-level landscaped courtyard. Removal of several landscape features; replacement of steps with ramps; new landscaped retaining walls and irrigation; new pedestrian lighting standards and railings. ",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1994
      },
      {
         "PERMITID": "RAD94-030",
         "APN": 25934016,
         "File Number": "RAD94-030",
         "Address": " ",
         "Project Name": "RAD94-030, American Savings",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/26/94",
         "Status": "Approved ",
         "Description": "Locate new HVAC equipment on roof. Existing roof mounted cooling tower & condenser to be removed. ",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1994
      },
      {
         "PERMITID": "RAD94-031",
         "APN": 46746015,
         "File Number": "RAD94-031",
         "Address": " ",
         "Project Name": "RAD94-031, Palermo's Restaurant",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/5/94",
         "Status": "Approved ",
         "Description": "Installation of an outdoor patio cover. ",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1994
      },
      {
         "PERMITID": "RAD94-035",
         "APN": 46721030,
         "File Number": "RAD94-035",
         "Address": " ",
         "Project Name": "RAD94-035, Trinity Center Office Building",
         "Application Type": "Permit Adjustment ",
         "Application Date": "12/12/94",
         "Status": "Approved ",
         "Description": "Extension of site development permit until 12/31/96",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1994
      },
      {
         "PERMITID": "RAD95-001",
         "APN": 25944080,
         "File Number": "RAD95-001",
         "Address": " ",
         "Project Name": "RAD95-001, PG&E",
         "Application Type": "Permit Adjustment ",
         "Application Date": "11/1/95",
         "Status": "Approved ",
         "Description": "Relocation of garbage enclosure. ",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1995
      },
      {
         "PERMITID": "RAD95-001",
         "APN": 46721034,
         "File Number": "RAD95-001",
         "Address": " ",
         "Project Name": "RAD95-001, Summa Financial",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/23/95",
         "Status": "Approved ",
         "Description": "Interior/exterior improvements ",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1995
      },
      {
         "PERMITID": "RAD95-002",
         "APN": 26429107,
         "File Number": "RAD95-002",
         "Address": " ",
         "Project Name": "RAD95-002, Hyatt Sainte Claire Hotel",
         "Application Type": "Permit Adjustment ",
         "Application Date": "1/25/95",
         "Status": "Approved ",
         "Description": "Addition of 3 new canopys above main entrance doors at corner of Market St. and San Carlos.",
         "Planner": "Mark Young ",
         "DURATION": 0,
         "Year": 1995
      },
      {
         "PERMITID": "RAD95-009",
         "APN": 25935051,
         "File Number": "RAD95-009",
         "Address": " ",
         "Project Name": "RAD95-009, The Tied House",
         "Application Type": "Permit Adjustment ",
         "Application Date": "4/17/95",
         "Status": "Approved ",
         "Description": "Facade Improvements - Olde Fox bldg. ",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1995
      },
      {
         "PERMITID": "RAD95-022",
         "APN": 46747090,
         "File Number": "RAD95-022",
         "Address": " ",
         "Project Name": "RAD95-022, The Usual Nightclub",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/19/95",
         "Status": "Approved ",
         "Description": "Change of exterior paint color; add wrought iron in front of building; add wrought iron lamps to side of building; change marquee to new finish and neon signage. ",
         "Planner": "Mark Young ",
         "DURATION": 0,
         "Year": 1995
      },
      {
         "PERMITID": "RAD96-009",
         "APN": 46746105,
         "File Number": "RAD96-009",
         "Address": " ",
         "Project Name": "RAD96-009, United Artists antenna",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/13/96",
         "Status": "Approved ",
         "Description": "Roof top antenna on top of Pavilion theaters ",
         "Planner": "Dennis Korabiak ",
         "DURATION": 0,
         "Year": 1996
      },
      {
         "PERMITID": "RAD96-020",
         "APN": 46747089,
         "File Number": "RAD96-020",
         "Address": " ",
         "Project Name": "RAD96-020, Image Network",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/6/96",
         "Status": "Approved ",
         "Description": "remove existing store front and replace with new store front ",
         "Planner": "Dennis Korabiak ",
         "DURATION": 0,
         "Year": 1996
      },
      {
         "PERMITID": "RAD96-022",
         "APN": 46747090,
         "File Number": "RAD96-022",
         "Address": " ",
         "Project Name": "RAD96-022, The Usual",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/19/96",
         "Status": "Approved ",
         "Description": "paint exterior of building ",
         "Planner": "Kristi Ashburn ",
         "DURATION": 0,
         "Year": 1996
      },
      {
         "PERMITID": "RAD96-028",
         "APN": 25934053,
         "File Number": "RAD96-028",
         "Address": " ",
         "Project Name": "RAD96-028, Community Towers",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/17/96",
         "Status": "Approved ",
         "Description": "Demolish (6) tile arches & restore to original. Furnish & install new 2'x2' tile around base of building. Install new signage at (4) entries, install (6) awnings in parking area. Rework fountain facing.",
         "Planner": "Kristi Ashburn ",
         "DURATION": 0,
         "Year": 1996
      },
      {
         "PERMITID": "RAD96-032",
         "APN": 25939111,
         "File Number": "RAD96-032",
         "Address": " ",
         "Project Name": "RAD96-032, North Block Lighting",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/29/96",
         "Status": "Approved ",
         "Description": "Install additional lighting along walkway from garage to Santa Clara Street to accommodate patrons of San Jose Arena ",
         "Planner": "Kristi Ashburn ",
         "DURATION": 0,
         "Year": 1996
      },
      {
         "PERMITID": "RAD97-001",
         "APN": 46723039,
         "File Number": "RAD97-001",
         "Address": " ",
         "Project Name": "RAD97-001, Banh Thai Restaurant",
         "Application Type": "Permit Adjustment ",
         "Application Date": "1/23/97",
         "Status": "Approved ",
         "Description": "Minor storefront reconfiguration to accommodate ADA requirements ",
         "Planner": "Kristi Ashburn ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RAD97-005",
         "APN": 46722110,
         "File Number": "RAD97-005",
         "Address": " ",
         "Project Name": "RAD97-005, Speedsters",
         "Application Type": "Permit Adjustment ",
         "Application Date": "1/31/97",
         "Status": "Approved ",
         "Description": "Addition of glass storefront and entry as part of tenant improvement work ",
         "Planner": "Dennis Korabiak ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RAD97-006",
         "APN": 25940084,
         "File Number": "RAD97-006",
         "Address": " ",
         "Project Name": "RAD97-006, Le Boulanger",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/10/97",
         "Status": "Approved ",
         "Description": "New storefront, removal of planters - replace with patio ",
         "Planner": "Kristi Ashburn ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RAD97-007",
         "APN": 25940037,
         "File Number": "RAD97-007",
         "Address": " ",
         "Project Name": "RAD97-007, Marina Bakery",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/10/97",
         "Status": "Approved ",
         "Description": "Installation of roof mounted exhaust fans in conjunction with interior improvements ",
         "Planner": "Kristi Ashburn ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RAD97-009",
         "APN": 46720078,
         "File Number": "RAD97-009",
         "Address": " ",
         "Project Name": "RAD97-009, The Works - San Jose",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/19/97",
         "Status": "Approved ",
         "Description": "New exterior storefront for exit requirement, 4 doors & interior renovation",
         "Planner": "Kristi Ashburn ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RAD97-012",
         "APN": 46721034,
         "File Number": "RAD97-012",
         "Address": " ",
         "Project Name": "RAD97-012, AT&T Wireless Antenna",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/12/97",
         "Status": "Approved ",
         "Description": "Installation of wireless communications facitlity on roof of existing building ",
         "Planner": "Kristi Ashburn ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RAD97-015",
         "APN": 25941069,
         "File Number": "RAD97-015",
         "Address": " ",
         "Project Name": "RAD97-015, Alta Broadcasting Co.",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/27/97",
         "Status": "Approved ",
         "Description": "Modification of existing mechanical roof screen, moving out Easterly 17'-6\". Extended screen will be same color and material.",
         "Planner": "Julie Schaer ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RAD97-017",
         "APN": 25935035,
         "File Number": "RAD97-017",
         "Address": " ",
         "Project Name": "RAD97-017, Masson Apartments",
         "Application Type": "Permit Adjustment ",
         "Application Date": "4/1/97",
         "Status": "Approved ",
         "Description": "Remodel & seismic upgrade of 15 residential apartment units on the 2nd & 3rd floors.",
         "Planner": "Dennis Korabiak ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RAD97-020",
         "APN": 25941069,
         "File Number": "RAD97-020",
         "Address": " ",
         "Project Name": "RAD97-020, Alta Broadcasting Co.",
         "Application Type": "Permit Adjustment ",
         "Application Date": "4/7/97",
         "Status": "Approved ",
         "Description": "27'-2\" x 16'-3\" enclosure for an emergency generator that is approximately 13' above finish grade. Attached to enclosure is an 8'-10\" x 7'-6\" recessed area enclosure for new transformer.",
         "Planner": "Julie Schaer ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RAD97-022",
         "APN": 25940037,
         "File Number": "RAD97-022",
         "Address": " ",
         "Project Name": "RAD97-022, Bay View Bank",
         "Application Type": "Permit Adjustment ",
         "Application Date": "4/17/97",
         "Status": "Approved ",
         "Description": "Facade improvement ",
         "Planner": "Julie Schaer ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RAD97-024",
         "APN": 46722110,
         "File Number": "RAD97-024",
         "Address": " ",
         "Project Name": "RAD97-024, Gordon Biersch",
         "Application Type": "Permit Adjustment ",
         "Application Date": "4/25/97",
         "Status": "Approved ",
         "Description": "Add HVAC to banquet room - 2 condenser units for AC on roof",
         "Planner": "Julie Schaer ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RAD97-024",
         "APN": 46722127,
         "File Number": "RAD97-024",
         "Address": " ",
         "Project Name": "RAD97-024, Gordon Biersch",
         "Application Type": "Permit Adjustment ",
         "Application Date": "4/25/97",
         "Status": "Approved ",
         "Description": "Add HVAC to banquet room - 2 condenser units for AC on roof",
         "Planner": "Julie Schaer ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RAD97-025",
         "APN": 46722127,
         "File Number": "RAD97-025",
         "Address": " ",
         "Project Name": "RAD97-025, Gordon Biersch",
         "Application Type": "Permit Adjustment ",
         "Application Date": "4/25/97",
         "Status": "Approved ",
         "Description": "Add air conditioner to prep room ",
         "Planner": "Julie Schaer ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RAD97-027",
         "APN": 46722110,
         "File Number": "RAD97-027",
         "Address": " ",
         "Project Name": "RAD97-027, Speedsters",
         "Application Type": "Permit Adjustment ",
         "Application Date": "4/25/97",
         "Status": "Approved ",
         "Description": "Installation of duct to roof on rear elevation of building ",
         "Planner": "Julie Schaer ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RAD97-028",
         "APN": 46746105,
         "File Number": "RAD97-028",
         "Address": " ",
         "Project Name": "RAD97-028, Happy Juice",
         "Application Type": "Permit Adjustment ",
         "Application Date": "4/22/97",
         "Status": "Approved ",
         "Description": "Change entry from single door to double doors ",
         "Planner": "Eric Keller ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RAD97-033",
         "APN": 25941069,
         "File Number": "RAD97-033",
         "Address": " ",
         "Project Name": "RAD97-033, San Jose Administrative Offices",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/22/97",
         "Status": "Approved ",
         "Description": "South door move of 4'-0\" to accommodate an interior corridor",
         "Planner": "Eric Keller ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RAD97-035",
         "APN": 25935035,
         "File Number": "RAD97-035",
         "Address": " ",
         "Project Name": "RAD97-035, A.P. Stumps",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/28/97",
         "Status": "Approved ",
         "Description": "15,000 sq. ft. tenant improvements - exterior modifications, front & rear",
         "Planner": "Eric Keller ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RAD97-044",
         "APN": 25935051,
         "File Number": "RAD97-044",
         "Address": " ",
         "Project Name": "RAD97-044, 71 St. Peter Restaurant",
         "Application Type": "Permit Adjustment ",
         "Application Date": "8/12/97",
         "Status": "Approved ",
         "Description": "Install collapsing (bi-fold) doors in front of restaurant ",
         "Planner": "Eric Keller ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RAD97-048",
         "APN": 25934029,
         "File Number": "RAD97-048",
         "Address": " ",
         "Project Name": "RAD97-048, The Old Clamhouse Restaurant",
         "Application Type": "Permit Adjustment ",
         "Application Date": "8/26/97",
         "Status": "Approved ",
         "Description": "Install new stub wall w/redwood siding at entry. ",
         "Planner": "Eric Keller ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RAD97-049",
         "APN": 46721023,
         "File Number": "RAD97-049",
         "Address": " ",
         "Project Name": "RAD97-049, Valley Transportation Authority",
         "Application Type": "Permit Adjustment ",
         "Application Date": "8/22/97",
         "Status": "Approved ",
         "Description": "Change sign band & cable supports for canopy ",
         "Planner": "Martin Magana ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RAD97-053",
         "APN": 46722121,
         "File Number": "RAD97-053",
         "Address": " ",
         "Project Name": "RAD97-053, Fountain Alley Parking Lot",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/25/97",
         "Status": "Approved ",
         "Description": "Install trash enclosures ",
         "Planner": "Martin Magana ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RAD97-054",
         "APN": 26429057,
         "File Number": "RAD97-054",
         "Address": " ",
         "Project Name": "RAD97-054, The Kindred Spirit",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/23/97",
         "Status": "Approved ",
         "Description": "Addition of lighted sign, fix awning, door, paint, wrought iron and glass ",
         "Planner": "Eric Keller ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RAD97-055",
         "APN": 25935057,
         "File Number": "RAD97-055",
         "Address": " ",
         "Project Name": "RAD97-055, Sottozero - Italian Ice Cream",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/29/97",
         "Status": "Approved ",
         "Description": "Change color of awning, new signage & paint of storefront, patio access ",
         "Planner": "Eric Keller ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RAD97-058",
         "APN": 25940049,
         "File Number": "RAD97-058",
         "Address": " ",
         "Project Name": "RAD97-058, Mac's Club",
         "Application Type": "Permit Adjustment ",
         "Application Date": "11/24/97",
         "Status": "Approved ",
         "Description": "Facade improvements & repair ",
         "Planner": "Martin Magana ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RAD97-063",
         "APN": 25935022,
         "File Number": "RAD97-063",
         "Address": " ",
         "Project Name": "RAD97-063, Hotel DeAnza",
         "Application Type": "Permit Adjustment ",
         "Application Date": "12/18/97",
         "Status": "Approved ",
         "Description": "Addition of a tensel fabric structure over hotel patio - total plan area to be covered is 3,158 sq. ft.",
         "Planner": "Martin Magana ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RAD97-064",
         "APN": 46722031,
         "File Number": "RAD97-064",
         "Address": " ",
         "Project Name": "RAD97-064, Mongo's",
         "Application Type": "Permit Adjustment ",
         "Application Date": "12/31/97",
         "Status": "Approved ",
         "Description": "FIP, including new paint, entry for #83, windows and signs",
         "Planner": "Dennis Korabiak ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RAD98-002",
         "APN": 46722003,
         "File Number": "RAD98-002",
         "Address": " ",
         "Project Name": "RAD98-002, Lido Nightclub",
         "Application Type": "Permit Adjustment ",
         "Application Date": "1/7/98",
         "Status": "Approved ",
         "Description": "Modify front facade to include required exit door ",
         "Planner": "Martin Magana ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "RAD98-004",
         "APN": 46721031,
         "File Number": "RAD98-004",
         "Address": " ",
         "Project Name": "RAD98-004, Trinity Episcopal Cathedral",
         "Application Type": "Permit Adjustment ",
         "Application Date": "1/20/98",
         "Status": "Approved ",
         "Description": "Add handicap ramp; repaint to match existing building; replace roofing material with historically corect shingles. ",
         "Planner": "Eric Keller ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "RAD98-008",
         "APN": 25940034,
         "File Number": "RAD98-008",
         "Address": " ",
         "Project Name": "RAD98-008, Sumitomo Bank",
         "Application Type": "Permit Adjustment ",
         "Application Date": "1/22/98",
         "Status": "Approved ",
         "Description": "Remove & replace ATM with ADA retrofit ATM ",
         "Planner": "Martin Magana ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "RAD98-017",
         "APN": 46747004,
         "File Number": "RAD98-017",
         "Address": " ",
         "Project Name": "RAD98-017, Banducci Architects",
         "Application Type": "Permit Adjustment ",
         "Application Date": "4/10/98",
         "Status": "Approved ",
         "Description": "Exterior facade improvements for use as office space, with two separate tenant suites. ",
         "Planner": "Martin Magana ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "RAD98-026",
         "APN": 25936074,
         "File Number": "RAD98-026",
         "Address": " ",
         "Project Name": "RAD98-026, Teligent Antennas",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/18/98",
         "Status": "Approved ",
         "Description": "Installation of two (2) 14\" parabolic antennas mounted on lower roof of ComericA building.",
         "Planner": "Martin Magana ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "RAD98-027",
         "APN": 25939112,
         "File Number": "RAD98-027",
         "Address": " ",
         "Project Name": "RAD98-027, Teligent Antennas",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/18/98",
         "Status": "Approved ",
         "Description": "Installation of two (2) 14\" parabolic antennas mounted on SE side of existing penthouse screen wall on separate pipe mounts. (Union Bank building)",
         "Planner": "Martin Magana ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "RAD98-033",
         "APN": 46746097,
         "File Number": "RAD98-033",
         "Address": " ",
         "Project Name": "RAD98-033, Kinko's",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/2/98",
         "Status": "Approved ",
         "Description": "Relocate exterior glass doors ",
         "Planner": "Martin Magana ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "RAD98-034",
         "APN": 47226033,
         "File Number": "RAD98-034",
         "Address": " ",
         "Project Name": "RAD98-034, The Metro",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/2/98",
         "Status": "Approved ",
         "Description": "New exit door (per fire code), new storefront and windows ",
         "Planner": "Martin Magana ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "RAD98-037",
         "APN": 25940071,
         "File Number": "RAD98-037",
         "Address": " ",
         "Project Name": "RAD98-037, Plaza Hotel",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/17/98",
         "Status": "Approved ",
         "Description": "Downtown Storefront Facade Program - painting of building with Agency approved color scheme. ",
         "Planner": "Martin Magana ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "RAD98-039",
         "APN": 46722009,
         "File Number": "RAD98-039",
         "Address": " ",
         "Project Name": "RAD98-039, Letitia Building",
         "Application Type": "Permit Adjustment ",
         "Application Date": "8/4/98",
         "Status": "Approved ",
         "Description": "Facade improvement ",
         "Planner": "Martin Magana ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "RAD98-043",
         "APN": 46722008,
         "File Number": "RAD98-043",
         "Address": " ",
         "Project Name": "RAD98-043, Bella Mia",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/15/98",
         "Status": "Approved ",
         "Description": "Restoration of building facade on First St. and removal of 1-story addition on rear of building. Complete interior reconstruction.",
         "Planner": "Martin Magana ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "RAD98-059",
         "APN": 46720080,
         "File Number": "RAD98-059",
         "Address": " ",
         "Project Name": "RAD98-059, First Presbyterian Church",
         "Application Type": "Permit Adjustment ",
         "Application Date": "12/8/98",
         "Status": "Approved ",
         "Description": "Add small 100 square foot shed on southern boundary of property at an existing church",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "RAD98-059",
         "APN": 46720081,
         "File Number": "RAD98-059",
         "Address": " ",
         "Project Name": "RAD98-059, First Presbyterian Church",
         "Application Type": "Permit Adjustment ",
         "Application Date": "12/8/98",
         "Status": "Approved ",
         "Description": "Add small 100 square foot shed on southern boundary of property at an existing church",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "RAD98-060",
         "APN": 25942023,
         "File Number": "RAD98-060",
         "Address": " ",
         "Project Name": "RAD98-060, Tech Museum PCS",
         "Application Type": "Permit Adjustment ",
         "Application Date": "12/18/98",
         "Status": "Approved ",
         "Description": "Cellular One antennas on roof of Tech Museum over loading dock. Not visible from street. ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "RAD99-002",
         "APN": 25933050,
         "File Number": "RAD99-002",
         "Address": " ",
         "Project Name": "RAD99-002, Tognozzi Building",
         "Application Type": "Permit Adjustment ",
         "Application Date": "1/8/99",
         "Status": "Approved ",
         "Description": "Allow repair to north wall of an existing building. ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RAD99-007",
         "APN": 46722009,
         "File Number": "RAD99-007",
         "Address": " ",
         "Project Name": "RAD99-007, Letitia Building",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/8/99",
         "Status": "Approved ",
         "Description": "Rear fire exit stairway ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RAD99-008",
         "APN": 25940092,
         "File Number": "RAD99-008",
         "Address": " ",
         "Project Name": "RAD99-008, Chacho's/Print It",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/7/99",
         "Status": "Approved ",
         "Description": "Facade Improvement of restaurant and print shop ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RAD99-014",
         "APN": 26429107,
         "File Number": "RAD99-014",
         "Address": " ",
         "Project Name": "RAD99-014, Hotel Sainte Claire/Il Fornaio",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/16/99",
         "Status": "Approved ",
         "Description": "Installation of 15 new blank canvas striped awnings with Il Fornaio logo and lighting on north face of hotel.",
         "Planner": "Martin Magana ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RAD99-015",
         "APN": 25935051,
         "File Number": "RAD99-015",
         "Address": " ",
         "Project Name": "RAD99-015, Fanny & Alexanders",
         "Application Type": "Permit Adjustment ",
         "Application Date": "3/24/99",
         "Status": "Approved ",
         "Description": "Reroof with composition shingle ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RAD99-018",
         "APN": 25941068,
         "File Number": "RAD99-018",
         "Address": " ",
         "Project Name": "RAD99-018, Pen Planning & Engineering",
         "Application Type": "Permit Adjustment ",
         "Application Date": "4/9/99",
         "Status": "Approved ",
         "Description": "Installation of twelve (12) panel type antennas attached to Heritage Bank building rooftop penthouse walls and railling and connected to power cabinet as detailed on development plans.",
         "Planner": "Martin Magana ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RAD99-021",
         "APN": 46721023,
         "File Number": "RAD99-021",
         "Address": " ",
         "Project Name": "RAD99-021, VTA Building",
         "Application Type": "Permit Adjustment ",
         "Application Date": "4/16/99",
         "Status": "Approved ",
         "Description": "Add two (2) new condensors and new emergency generator to top of building for internet telecom facility",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RAD99-023",
         "APN": 25941068,
         "File Number": "RAD99-023",
         "Address": " ",
         "Project Name": "RAD99-023, Infonet, Inc.",
         "Application Type": "Permit Adjustment ",
         "Application Date": "4/29/99",
         "Status": "Approved ",
         "Description": "Installation of an Emergency Generator w/enclosure ",
         "Planner": "Martin Magana ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RAD99-026",
         "APN": 25936074,
         "File Number": "RAD99-026",
         "Address": " ",
         "Project Name": "RAD99-026, Winstar PCS",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/3/99",
         "Status": "Approved ",
         "Description": "Add node antenneas to top of existing building for wireless internet services ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RAD99-027",
         "APN": 46723039,
         "File Number": "RAD99-027",
         "Address": " ",
         "Project Name": "RAD99-027, Eduardo Martinez Architects",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/12/99",
         "Status": "Approved ",
         "Description": "Tenant interior improvements; roof deck HVAC ",
         "Planner": "Martin Magana ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RAD99-028",
         "APN": 46747040,
         "File Number": "RAD99-028",
         "Address": " ",
         "Project Name": "RAD99-028, Vu Ngoc Tuyen",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/15/99",
         "Status": "Approved ",
         "Description": "Install new double entry glass doors and build one (1) handicap restroom indoors",
         "Planner": "Martin Magana ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RAD99-029",
         "APN": 25941057,
         "File Number": "RAD99-029",
         "Address": " ",
         "Project Name": "RAD99-029, Bank of America",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/16/99",
         "Status": "Approved ",
         "Description": "Lobby improvements ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RAD99-030",
         "APN": 46722110,
         "File Number": "RAD99-030",
         "Address": " ",
         "Project Name": "RAD99-030, E & O Trading Company",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/19/99",
         "Status": "Approved ",
         "Description": "Facade improvements ",
         "Planner": "Martin Magana ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RAD99-033",
         "APN": 25940037,
         "File Number": "RAD99-033",
         "Address": " ",
         "Project Name": "RAD99-033, 17 West Salon and Beauty Supply",
         "Application Type": "Permit Adjustment ",
         "Application Date": "7/27/99",
         "Status": "Approved ",
         "Description": "Relocate front door and window; minor interior improvements ",
         "Planner": "Martin Magana ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RAD99-036",
         "APN": 25941086,
         "File Number": "RAD99-036",
         "Address": " ",
         "Project Name": "RAD99-036, Above Net PCS tower",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/2/99",
         "Status": "Approved ",
         "Description": "4 new towers on each corner of the penthouse that allows the installation of PCS equipment for Above Net",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RAD99-036",
         "APN": 25941087,
         "File Number": "RAD99-036",
         "Address": " ",
         "Project Name": "RAD99-036, Above Net PCS tower",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/2/99",
         "Status": "Approved ",
         "Description": "4 new towers on each corner of the penthouse that allows the installation of PCS equipment for Above Net",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RAD99-038",
         "APN": 25940092,
         "File Number": "RAD99-038",
         "Address": " ",
         "Project Name": "RAD99-038, Dac Phuc Restaurant",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/13/99",
         "Status": "Approved ",
         "Description": "Allow facade improvements to an existing restaurant ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RAD99-039",
         "APN": 25941086,
         "File Number": "RAD99-039",
         "Address": " ",
         "Project Name": "RAD99-039, GST Telecom",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/17/99",
         "Status": "Approved ",
         "Description": "Allow condensors and generators for an internet telecom exchange facility ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RAD99-039",
         "APN": 25941087,
         "File Number": "RAD99-039",
         "Address": " ",
         "Project Name": "RAD99-039, GST Telecom",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/17/99",
         "Status": "Approved ",
         "Description": "Allow condensors and generators for an internet telecom exchange facility ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RAD99-042",
         "APN": 25939115,
         "File Number": "RAD99-042",
         "Address": " ",
         "Project Name": "RAD99-042, Union Bank",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/23/99",
         "Status": "Approved ",
         "Description": "Add ATM to exterior of existing building; minor walkway improvement ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RAD99-043",
         "APN": 25941057,
         "File Number": "RAD99-043",
         "Address": " ",
         "Project Name": "RAD99-043, Starbucks",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/30/99",
         "Status": "Approved ",
         "Description": "Modifications to building exterior to allow Starbucks, including signage ",
         "Planner": "Dennis Korabiak ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RAD99-046",
         "APN": 46721023,
         "File Number": "RAD99-046",
         "Address": " ",
         "Project Name": "RAD99-046, IXC Executive Building",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/12/99",
         "Status": "Approved ",
         "Description": "Add generator to rooftop ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RAD99-047",
         "APN": 25940084,
         "File Number": "RAD99-047",
         "Address": " ",
         "Project Name": "RAD99-047, Aampco Parking",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/20/99",
         "Status": "Approved ",
         "Description": "Add window, minor square footage addition to mezzanine floor of existing building. ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RAD99-053",
         "APN": 46722110,
         "File Number": "RAD99-053",
         "Address": " ",
         "Project Name": "RAD99-053, Plum Spa",
         "Application Type": "Permit Adjustment ",
         "Application Date": "11/22/99",
         "Status": "Approved ",
         "Description": "Change retail frontage from sliding doors to double doors and windows ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RAD99-054",
         "APN": 46747041,
         "File Number": "RAD99-054",
         "Address": " ",
         "Project Name": "RAD99-054, Dai Thanh Supermarket",
         "Application Type": "Permit Adjustment ",
         "Application Date": "12/3/99",
         "Status": "Approved ",
         "Description": "New canvas awning/canopy on right side of supermarket ",
         "Planner": "Martin Magana ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RAD99-056",
         "APN": 46723069,
         "File Number": "RAD99-056",
         "Address": " ",
         "Project Name": "RAD99-056, Hank Coca's",
         "Application Type": "Permit Adjustment ",
         "Application Date": "12/13/99",
         "Status": "Approved ",
         "Description": "Indstall HVAC equipment on roof and inside to air condition first floor of building ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RAD99-058",
         "APN": 46722110,
         "File Number": "RAD99-058",
         "Address": "33 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "RAD99-058, Gordon Biersch",
         "Application Type": "Permit Adjustment ",
         "Application Date": "12/21/99",
         "Status": "Approved ",
         "Description": "Temporary tent in patio area. ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RAD00-032",
         "APN": 46746047,
         "File Number": "RAD00-032",
         "Address": " ",
         "Project Name": "RAD00-032, Pollyesthers",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/19/00",
         "Status": "Closed ",
         "Description": "Facade improvement of theatre - propose replacement of tile, paint, awnings & lighting, infill existing windows, change doors on storefront. ",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "AD13-671",
         "APN": 46717090,
         "File Number": "AD13-671",
         "Address": "425 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD13-671",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/24/13",
         "Status": "Denied ",
         "Description": "Permit Adjustment for three roof mouted antennas with the expansion of an existing FRP roof screening  ",
         "Planner": "Suparna Saha ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "AD87-042",
         "APN": 46720072,
         "File Number": "AD87-042",
         "Address": "101 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD87-042",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Denied ",
         "Description": "Action date:31MAY87 OUTSIDE DOOR-TOO LONG W/OUT REVISION",
         "Planner": "Jerry Yoshida ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD87-317",
         "APN": 25939120,
         "File Number": "AD87-317",
         "Address": "95 S ALMADEN AV SAN JOSE",
         "Project Name": "AD87-317",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Denied ",
         "Description": "Action date:31MAY88 ADD DOORS, ENCLOSE ENTERANCE",
         "Planner": "Jerry Yoshida ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD89-039",
         "APN": 46724069,
         "File Number": "AD89-039",
         "Address": "304 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD89-039",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Denied ",
         "Description": "Action date:06JUN89",
         "Planner": "Jerry Yoshida ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD89-614",
         "APN": 47229043,
         "File Number": "AD89-614",
         "Address": "520 S 10TH ST SAN JOSE",
         "Project Name": "AD89-614",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Denied ",
         "Description": "Action date:29SEP89 REPLACE STOREFRONT,ADD LAUNDRY EQUIP,CEI",
         "Planner": "Darryl Boyd ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD89-891",
         "APN": 24944018,
         "File Number": "AD89-891",
         "Address": "329 N 3RD ST SAN JOSE",
         "Project Name": "AD89-891",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Denied ",
         "Description": "Action date:26FEB90 ADD PATIO COVER AWNING TO FRONT OF HOUSE",
         "Planner": "Larry Bohannan ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD90-571",
         "APN": 46718090,
         "File Number": "AD90-571",
         "Address": "301 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD90-571",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Denied ",
         "Description": "Action date:20AUG90 DOORS, WINDOWS, DECK, SIGNS",
         "Planner": "LCARRILL ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD92-359",
         "APN": 46724110,
         "File Number": "AD92-359",
         "Address": "268 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD92-359",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Denied ",
         "Description": "Action date:04MAY92 NEW AWNING",
         "Planner": "LCARRILL ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "RAD98-042",
         "APN": 46722127,
         "File Number": "RAD98-042",
         "Address": " ",
         "Project Name": "RAD98-042, Gordon Biersch",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/9/98",
         "Status": "Denied ",
         "Description": "To allow temporary tenting of the patio area during winter ",
         "Planner": "Martin Magana ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "2004 135698 CO",
         "APN": 46721034,
         "File Number": "2004 135698 CO",
         "Address": "4 N 2ND ST SAN JOSE",
         "Project Name": "4 2ND ST",
         "Application Type": "Permit Adjustment ",
         "Application Date": "12/16/04",
         "Status": "New ",
         "Description": "MODIFIACTION OF STOREFRONT ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2004
      },
      {
         "PERMITID": "2005 054646 CO",
         "APN": 46764005,
         "File Number": "2005 054646 CO",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "100 S 2ND ST",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/28/05",
         "Status": "New ",
         "Description": "Relocation of driveway and reconfigured parking lot for Phase II of Block 3 site",
         "Planner": "Lee Butler ",
         "DURATION": 0,
         "Year": 2005
      },
      {
         "PERMITID": "2005 054646 CO",
         "APN": 46764010,
         "File Number": "2005 054646 CO",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "100 S 2ND ST",
         "Application Type": "Permit Adjustment ",
         "Application Date": "9/28/05",
         "Status": "New ",
         "Description": "Relocation of driveway and reconfigured parking lot for Phase II of Block 3 site",
         "Planner": "Lee Butler ",
         "DURATION": 0,
         "Year": 2005
      },
      {
         "PERMITID": "2006 024013 CO",
         "APN": 46757083,
         "File Number": "2006 024013 CO",
         "Address": "235 E SANTA CLARA ST SAN JOSE",
         "Project Name": "235 E SANTA CLARA ST",
         "Application Type": "Permit Adjustment ",
         "Application Date": "8/15/06",
         "Status": "New ",
         "Description": "Kitchen Hood equipment for the Vintage Towers ",
         "Planner": "Lee Butler ",
         "DURATION": 0,
         "Year": 2006
      },
      {
         "PERMITID": "2008 026807 CO",
         "APN": 26137029,
         "File Number": "2008 026807 CO",
         "Address": "655 W SAN CARLOS ST SAN JOSE",
         "Project Name": "655 W SAN CARLOS ST",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/30/08",
         "Status": "New ",
         "Description": " ",
         "Planner": "John Davidson ",
         "DURATION": 0,
         "Year": 2008
      },
      {
         "PERMITID": "2008 067187 CO",
         "APN": 25941068,
         "File Number": "2008 067187 CO",
         "Address": "150 ALMADEN BL SAN JOSE",
         "Project Name": "150 ALMADEN BL",
         "Application Type": "Permit Adjustment ",
         "Application Date": "12/18/08",
         "Status": "New ",
         "Description": " ",
         "Planner": "Darren McBain ",
         "DURATION": 0,
         "Year": 2008
      },
      {
         "PERMITID": "2010 027077 CO",
         "APN": 46745025,
         "File Number": "2010 027077 CO",
         "Address": "140 E SAN CARLOS ST SAN JOSE",
         "Project Name": "140 SAN CARLOS ST",
         "Application Type": "Permit Adjustment ",
         "Application Date": "10/18/10",
         "Status": "New ",
         "Description": " ",
         "Planner": "Mike Enderby ",
         "DURATION": 0,
         "Year": 2010
      },
      {
         "PERMITID": "AD07-719",
         "APN": 25941086,
         "File Number": "AD07-719",
         "Address": "50 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD07-719",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/07",
         "Status": "Pending ",
         "Description": "Permit Adjustment to allow the addition of a barrier and a barbecue to a previously approved Sidewalk Cafe Permit (File No. RSC 92-09-003).",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-719",
         "APN": 25941087,
         "File Number": "AD07-719",
         "Address": "50 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD07-719",
         "Application Type": "Permit Adjustment ",
         "Application Date": "6/22/07",
         "Status": "Pending ",
         "Description": "Permit Adjustment to allow the addition of a barrier and a barbecue to a previously approved Sidewalk Cafe Permit (File No. RSC 92-09-003).",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD16-207",
         "APN": 25940093,
         "File Number": "AD16-207",
         "Address": "1 S MARKET ST SAN JOSE",
         "Project Name": "AD16-207",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/17/16 17:07",
         "Status": "Pending ",
         "Description": "Permit Adjustment to allow minor changes to exterior lighting on pool deck and 18th floor amenity deck.",
         "Planner": "Kristinae Toomians ",
         "DURATION": 1,
         "Year": 2016
      },
      {
         "PERMITID": "AD16-579",
         "APN": 47224031,
         "File Number": "AD16-579",
         "Address": "620 S 7TH ST SAN JOSE",
         "Project Name": "AD16-579",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/12/16 15:33",
         "Status": "Pending ",
         "Description": "Permit adjustment to allow a metal gate in the rear of the property located 4 feet from the rear property line.",
         "Planner": "Jan Warne ",
         "DURATION": 1,
         "Year": 2016
      },
      {
         "PERMITID": "AD17-166",
         "APN": 46721011,
         "File Number": "AD17-166",
         "Address": "70 N 2ND ST SAN JOSE",
         "Project Name": "AD17-166",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/10/17 13:27",
         "Status": "Pending ",
         "Description": "Permit Adjustment for exterior changes. ",
         "Planner": "Justin Daniels ",
         "DURATION": 940,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-355",
         "APN": 26426006,
         "File Number": "AD17-355",
         "Address": "341 DELMAS AV SAN JOSE",
         "Project Name": "AD17-355",
         "Application Type": "Permit Adjustment ",
         "Application Date": "4/5/17",
         "Status": "Pending ",
         "Description": "Permit Adjustment for various minor modifications to Permit H15-046 for a proposed five-story multi-family residential building project.",
         "Planner": "NTHOMAS ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-355",
         "APN": 26426008,
         "File Number": "AD17-355",
         "Address": "341 DELMAS AV SAN JOSE",
         "Project Name": "AD17-355",
         "Application Type": "Permit Adjustment ",
         "Application Date": "4/5/17",
         "Status": "Pending ",
         "Description": "Permit Adjustment for various minor modifications to Permit H15-046 for a proposed five-story multi-family residential building project.",
         "Planner": "NTHOMAS ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "AD18-515",
         "APN": 25936039,
         "File Number": "AD18-515",
         "Address": "320 W ST JOHN ST SAN JOSE",
         "Project Name": "AD18-515",
         "Application Type": "Permit Adjustment ",
         "Application Date": "5/25/18 11:43",
         "Status": "Pending ",
         "Description": "Permit Adjustment to allow the addition of a patio cover over the existing outdoor patio area located at the rear of the building. ",
         "Planner": "Eric Morgan ",
         "DURATION": 472,
         "Year": 2018
      },
      {
         "PERMITID": "AD16-1252",
         "APN": 25941086,
         "File Number": "AD16-1252",
         "Address": "50 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD16-1252",
         "Application Type": "Permit Adjustment ",
         "Application Date": "11/8/16 10:04",
         "Status": "Rejected ",
         "Description": "Permit Adjustment to modify the north and south elevations of 50 W San Fernando THIS IS ACTUALLY APPROVED, UNABLE TO CHANGE STATUS AT THIS TIME",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2016
      },
      {
         "PERMITID": "AD16-1252",
         "APN": 25941087,
         "File Number": "AD16-1252",
         "Address": "50 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD16-1252",
         "Application Type": "Permit Adjustment ",
         "Application Date": "11/8/16 10:04",
         "Status": "Rejected ",
         "Description": "Permit Adjustment to modify the north and south elevations of 50 W San Fernando THIS IS ACTUALLY APPROVED, UNABLE TO CHANGE STATUS AT THIS TIME",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2016
      },
      {
         "PERMITID": "AD12-168",
         "APN": 25939122,
         "File Number": "AD12-168",
         "Address": "10 ALMADEN BL SAN JOSE",
         "Project Name": "AD12-168",
         "Application Type": "Permit Adjustment ",
         "Application Date": "2/16/12",
         "Status": "Withdrawn ",
         "Description": "Permit Adjustment to allow installation of roof equipment including 32-inch omni antenna, one GPS antenna, once 33\"x24\"x20\" equipment cabinet, and one 7/8-inch coaxial cable atop existing building",
         "Planner": "MNAGARAJ ",
         "DURATION": 1,
         "Year": 2012
      },
      {
         "PERMITID": "AD87-256",
         "APN": 26419067,
         "File Number": "AD87-256",
         "Address": " ",
         "Project Name": "AD87-256",
         "Application Type": "Permit Adjustment ",
         "Application Date": " ",
         "Status": "Withdrawn ",
         "Description": "Action date:21JUL87 NEEDS A SITE DEVELOPMENT PERMIT",
         "Planner": "Mel Flores ",
         "DURATION": 0,
         "Year": null
      }
   ],
   "Planning Consultation ": [
      {
         "PERMITID": "2012 003175 CO",
         "APN": 26419067,
         "File Number": "2012 003175 CO",
         "Address": "404 BIRD AV SAN JOSE",
         "Project Name": "404 BIRD AV",
         "Application Type": "Planning Consultation ",
         "Application Date": "1/24/12",
         "Status": "Approved ",
         "Description": "Temporary real estate off site sign; code case #2011 12818; Spoke to Kevin Smith- Code Inspector. Existing temporary sign, 50sf free standing temporary sign area (max allowed 32sft) at a setback less than 10' from the property line. Sign not in conformance with the Sign Ord Section: 23.04.340 C.",
         "Planner": "MNAGARAJ ",
         "DURATION": 0,
         "Year": 2012
      },
      {
         "PERMITID": "2013 107698 CO",
         "APN": 25930044,
         "File Number": "2013 107698 CO",
         "Address": "323 W ST JOHN ST SAN JOSE",
         "Project Name": "323 W ST JOHN ST",
         "Application Type": "Planning Consultation ",
         "Application Date": "5/17/13",
         "Status": "Approved ",
         "Description": "Planning consultation to learn about process to demolish buildings, build new residential or mixed use project on several properties ",
         "Planner": "John Davidson ",
         "DURATION": 1,
         "Year": 2013
      },
      {
         "PERMITID": "2013 107698 CO",
         "APN": 25930048,
         "File Number": "2013 107698 CO",
         "Address": "323 W ST JOHN ST SAN JOSE",
         "Project Name": "323 W ST JOHN ST",
         "Application Type": "Planning Consultation ",
         "Application Date": "5/17/13",
         "Status": "Approved ",
         "Description": "Planning consultation to learn about process to demolish buildings, build new residential or mixed use project on several properties ",
         "Planner": "John Davidson ",
         "DURATION": 1,
         "Year": 2013
      },
      {
         "PERMITID": "AD11-494",
         "APN": 46745025,
         "File Number": "AD11-494",
         "Address": "140 E SAN CARLOS ST SAN JOSE",
         "Project Name": "AD11-494",
         "Application Type": "Planning Consultation ",
         "Application Date": "6/23/11",
         "Status": "Approved ",
         "Description": "Planning Consultation regarding accessibility design for front entry of structure of merit ",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 1,
         "Year": 2011
      },
      {
         "PERMITID": "AD18-324",
         "APN": 46721034,
         "File Number": "AD18-324",
         "Address": "4 N 2ND ST SAN JOSE",
         "Project Name": "Planning Consultation - Towers at Second ",
         "Application Type": "Planning Consultation ",
         "Application Date": "4/12/18 13:31",
         "Status": "Approved ",
         "Description": "Planning consultation meeting to discuss proposed site improvements to the areas between the two tower buildings (new outdoor basketball half-court, re-vamped outdoor seating area). ",
         "Planner": "Justin Daniels ",
         "DURATION": 14,
         "Year": 2018
      },
      {
         "PERMITID": "16-003",
         "APN": 26420083,
         "File Number": "16-003",
         "Address": "466 W SAN CARLOS ST SAN JOSE",
         "Project Name": "16-003",
         "Application Type": "Planning Consultation ",
         "Application Date": "12/16/16",
         "Status": "Approved with Conditions ",
         "Description": "Two Urban Agriculture Incentive Zone Contracts, one each for the two respective properties approved under authority of the City's UAIZ Ordinance, Municipal Code Section 4.88.",
         "Planner": "AHENRIQU ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "16-003",
         "APN": 26420085,
         "File Number": "16-003",
         "Address": "466 W SAN CARLOS ST SAN JOSE",
         "Project Name": "16-003",
         "Application Type": "Planning Consultation ",
         "Application Date": "12/16/16",
         "Status": "Approved with Conditions ",
         "Description": "Two Urban Agriculture Incentive Zone Contracts, one each for the two respective properties approved under authority of the City's UAIZ Ordinance, Municipal Code Section 4.88.",
         "Planner": "AHENRIQU ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "2011 012067 CO",
         "APN": 46723010,
         "File Number": "2011 012067 CO",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 SANTA CLARA ST",
         "Application Type": "Planning Consultation ",
         "Application Date": "4/5/11",
         "Status": "New ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "2011 012067 CO",
         "APN": 46723011,
         "File Number": "2011 012067 CO",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 SANTA CLARA ST",
         "Application Type": "Planning Consultation ",
         "Application Date": "4/5/11",
         "Status": "New ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "2011 012067 CO",
         "APN": 46723013,
         "File Number": "2011 012067 CO",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 SANTA CLARA ST",
         "Application Type": "Planning Consultation ",
         "Application Date": "4/5/11",
         "Status": "New ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "2011 012067 CO",
         "APN": 46723017,
         "File Number": "2011 012067 CO",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 SANTA CLARA ST",
         "Application Type": "Planning Consultation ",
         "Application Date": "4/5/11",
         "Status": "New ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "2011 012067 CO",
         "APN": 46723018,
         "File Number": "2011 012067 CO",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 SANTA CLARA ST",
         "Application Type": "Planning Consultation ",
         "Application Date": "4/5/11",
         "Status": "New ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "2011 012067 CO",
         "APN": 46723019,
         "File Number": "2011 012067 CO",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 SANTA CLARA ST",
         "Application Type": "Planning Consultation ",
         "Application Date": "4/5/11",
         "Status": "New ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "2011 012067 CO",
         "APN": 46723021,
         "File Number": "2011 012067 CO",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 SANTA CLARA ST",
         "Application Type": "Planning Consultation ",
         "Application Date": "4/5/11",
         "Status": "New ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "2011 012067 CO",
         "APN": 46723022,
         "File Number": "2011 012067 CO",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 SANTA CLARA ST",
         "Application Type": "Planning Consultation ",
         "Application Date": "4/5/11",
         "Status": "New ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "2011 012067 CO",
         "APN": 46723076,
         "File Number": "2011 012067 CO",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 SANTA CLARA ST",
         "Application Type": "Planning Consultation ",
         "Application Date": "4/5/11",
         "Status": "New ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "2011 012067 CO",
         "APN": 46724001,
         "File Number": "2011 012067 CO",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 SANTA CLARA ST",
         "Application Type": "Planning Consultation ",
         "Application Date": "4/5/11",
         "Status": "New ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "2011 012067 CO",
         "APN": 46724002,
         "File Number": "2011 012067 CO",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 SANTA CLARA ST",
         "Application Type": "Planning Consultation ",
         "Application Date": "4/5/11",
         "Status": "New ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "2011 012067 CO",
         "APN": 46724003,
         "File Number": "2011 012067 CO",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 SANTA CLARA ST",
         "Application Type": "Planning Consultation ",
         "Application Date": "4/5/11",
         "Status": "New ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "2011 012067 CO",
         "APN": 46724014,
         "File Number": "2011 012067 CO",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 SANTA CLARA ST",
         "Application Type": "Planning Consultation ",
         "Application Date": "4/5/11",
         "Status": "New ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "2011 012067 CO",
         "APN": 46724015,
         "File Number": "2011 012067 CO",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 SANTA CLARA ST",
         "Application Type": "Planning Consultation ",
         "Application Date": "4/5/11",
         "Status": "New ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "2011 012067 CO",
         "APN": 46724016,
         "File Number": "2011 012067 CO",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 SANTA CLARA ST",
         "Application Type": "Planning Consultation ",
         "Application Date": "4/5/11",
         "Status": "New ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "2011 012067 CO",
         "APN": 46724019,
         "File Number": "2011 012067 CO",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 SANTA CLARA ST",
         "Application Type": "Planning Consultation ",
         "Application Date": "4/5/11",
         "Status": "New ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "2011 012067 CO",
         "APN": 46724020,
         "File Number": "2011 012067 CO",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 SANTA CLARA ST",
         "Application Type": "Planning Consultation ",
         "Application Date": "4/5/11",
         "Status": "New ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "2011 012067 CO",
         "APN": 46724021,
         "File Number": "2011 012067 CO",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 SANTA CLARA ST",
         "Application Type": "Planning Consultation ",
         "Application Date": "4/5/11",
         "Status": "New ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "2011 012067 CO",
         "APN": 46724115,
         "File Number": "2011 012067 CO",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 SANTA CLARA ST",
         "Application Type": "Planning Consultation ",
         "Application Date": "4/5/11",
         "Status": "New ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "2011 012067 CO",
         "APN": 46724117,
         "File Number": "2011 012067 CO",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 SANTA CLARA ST",
         "Application Type": "Planning Consultation ",
         "Application Date": "4/5/11",
         "Status": "New ",
         "Description": " ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "2018 123496 CO",
         "APN": 47217073,
         "File Number": "2018 123496 CO",
         "Address": "757 S 3RD ST SAN JOSE",
         "Project Name": "Planning Consultation Only ",
         "Application Type": "Planning Consultation ",
         "Application Date": "6/25/18 16:37",
         "Status": "New ",
         "Description": " ",
         "Planner": "Ruth Cueto ",
         "DURATION": 1,
         "Year": 2018
      },
      {
         "PERMITID": "AD14-1317",
         "APN": 25946046,
         "File Number": "AD14-1317",
         "Address": "267 DELMAS AV SAN JOSE",
         "Project Name": "AD14-1317",
         "Application Type": "Planning Consultation ",
         "Application Date": "12/12/14 14:51",
         "Status": "Pending ",
         "Description": " ",
         "Planner": "Emily Lipoma ",
         "DURATION": 1,
         "Year": 2014
      },
      {
         "PERMITID": "2013 133950 CO",
         "APN": 46720074,
         "File Number": "2013 133950 CO",
         "Address": "117 N 5TH ST SAN JOSE",
         "Project Name": "117 N 5TH ST CONSUTLATION ONLY",
         "Application Type": "Planning Consultation ",
         "Application Date": "12/17/13",
         "Status": "Rejected ",
         "Description": "Proposal to build 30 units on a 10,500 sf site located in R-M Zoning District. It has a General Plan landuse designation of Transit Residential.",
         "Planner": "Rich Buikema ",
         "DURATION": 0,
         "Year": 2013
      }
   ],
   "Prelim - Comprehensive (Full) ": [
      {
         "PERMITID": "PRE03-187",
         "APN": 26420121,
         "File Number": "PRE03-187",
         "Address": "395 BIRD AV SAN JOSE",
         "Project Name": "PRE03-187 - Bird Chevron",
         "Application Type": "Prelim - Comprehensive (Full) ",
         "Application Date": "6/4/03",
         "Status": "Complete ",
         "Description": "To demolish the existing gas station, and replace it with a new station. Applicant would like to keep 4 of the 5 existing driveways.",
         "Planner": "Erin Morris ",
         "DURATION": 1399,
         "Year": 2003
      },
      {
         "PERMITID": "PRE03-300",
         "APN": 26420079,
         "File Number": "PRE03-300",
         "Address": "498 W SAN CARLOS ST SAN JOSE",
         "Project Name": "PRE03-300",
         "Application Type": "Prelim - Comprehensive (Full) ",
         "Application Date": "9/4/03",
         "Status": "Complete ",
         "Description": "Mixed-use, ground floor commercial with six (6) 2-bedroom units above",
         "Planner": "John Davidson ",
         "DURATION": 37,
         "Year": 2003
      },
      {
         "PERMITID": "PRE03-300",
         "APN": 26420110,
         "File Number": "PRE03-300",
         "Address": "498 W SAN CARLOS ST SAN JOSE",
         "Project Name": "PRE03-300",
         "Application Type": "Prelim - Comprehensive (Full) ",
         "Application Date": "9/4/03",
         "Status": "Complete ",
         "Description": "Mixed-use, ground floor commercial with six (6) 2-bedroom units above",
         "Planner": "John Davidson ",
         "DURATION": 37,
         "Year": 2003
      },
      {
         "PERMITID": "PRE03-300",
         "APN": 26420128,
         "File Number": "PRE03-300",
         "Address": "498 W SAN CARLOS ST SAN JOSE",
         "Project Name": "PRE03-300",
         "Application Type": "Prelim - Comprehensive (Full) ",
         "Application Date": "9/4/03",
         "Status": "Complete ",
         "Description": "Mixed-use, ground floor commercial with six (6) 2-bedroom units above",
         "Planner": "John Davidson ",
         "DURATION": 37,
         "Year": 2003
      },
      {
         "PERMITID": "PRE04-022",
         "APN": 46701118,
         "File Number": "PRE04-022",
         "Address": "252 N 1ST ST SAN JOSE",
         "Project Name": "PRE04-022",
         "Application Type": "Prelim - Comprehensive (Full) ",
         "Application Date": "1/16/04",
         "Status": "Complete ",
         "Description": "Comprehsive Preliminary Review of a 3 building residential condominium project with 150 to 180 units, 4 to 18 stories on a 1.54 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 26,
         "Year": 2004
      },
      {
         "PERMITID": "PRE04-183",
         "APN": 47226036,
         "File Number": "PRE04-183",
         "Address": "520 S 1ST ST SAN JOSE",
         "Project Name": "PRE04-183",
         "Application Type": "Prelim - Comprehensive (Full) ",
         "Application Date": "5/3/04",
         "Status": "Complete ",
         "Description": "San Jose Museum of Quilts and Textiles - tenant improvements, what are the permit requirements?  ",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 26,
         "Year": 2004
      },
      {
         "PERMITID": "PRE04-414",
         "APN": 46762001,
         "File Number": "PRE04-414",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "PRE04-414",
         "Application Type": "Prelim - Comprehensive (Full) ",
         "Application Date": "9/17/04",
         "Status": "Complete ",
         "Description": "create office condominiums in existing office building ",
         "Planner": "Lesley Xavier ",
         "DURATION": 32,
         "Year": 2004
      },
      {
         "PERMITID": "PRE04-414",
         "APN": 46762007,
         "File Number": "PRE04-414",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "PRE04-414",
         "Application Type": "Prelim - Comprehensive (Full) ",
         "Application Date": "9/17/04",
         "Status": "Complete ",
         "Description": "create office condominiums in existing office building ",
         "Planner": "Lesley Xavier ",
         "DURATION": 32,
         "Year": 2004
      },
      {
         "PERMITID": "PRE04-414",
         "APN": 46762008,
         "File Number": "PRE04-414",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "PRE04-414",
         "Application Type": "Prelim - Comprehensive (Full) ",
         "Application Date": "9/17/04",
         "Status": "Complete ",
         "Description": "create office condominiums in existing office building ",
         "Planner": "Lesley Xavier ",
         "DURATION": 32,
         "Year": 2004
      },
      {
         "PERMITID": "PRE04-414",
         "APN": 46762009,
         "File Number": "PRE04-414",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "PRE04-414",
         "Application Type": "Prelim - Comprehensive (Full) ",
         "Application Date": "9/17/04",
         "Status": "Complete ",
         "Description": "create office condominiums in existing office building ",
         "Planner": "Lesley Xavier ",
         "DURATION": 32,
         "Year": 2004
      },
      {
         "PERMITID": "PRE04-414",
         "APN": 46762011,
         "File Number": "PRE04-414",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "PRE04-414",
         "Application Type": "Prelim - Comprehensive (Full) ",
         "Application Date": "9/17/04",
         "Status": "Complete ",
         "Description": "create office condominiums in existing office building ",
         "Planner": "Lesley Xavier ",
         "DURATION": 32,
         "Year": 2004
      },
      {
         "PERMITID": "PRE04-414",
         "APN": 46762012,
         "File Number": "PRE04-414",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "PRE04-414",
         "Application Type": "Prelim - Comprehensive (Full) ",
         "Application Date": "9/17/04",
         "Status": "Complete ",
         "Description": "create office condominiums in existing office building ",
         "Planner": "Lesley Xavier ",
         "DURATION": 32,
         "Year": 2004
      },
      {
         "PERMITID": "PRE04-414",
         "APN": 46762014,
         "File Number": "PRE04-414",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "PRE04-414",
         "Application Type": "Prelim - Comprehensive (Full) ",
         "Application Date": "9/17/04",
         "Status": "Complete ",
         "Description": "create office condominiums in existing office building ",
         "Planner": "Lesley Xavier ",
         "DURATION": 32,
         "Year": 2004
      },
      {
         "PERMITID": "PRE04-414",
         "APN": 46762015,
         "File Number": "PRE04-414",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "PRE04-414",
         "Application Type": "Prelim - Comprehensive (Full) ",
         "Application Date": "9/17/04",
         "Status": "Complete ",
         "Description": "create office condominiums in existing office building ",
         "Planner": "Lesley Xavier ",
         "DURATION": 32,
         "Year": 2004
      },
      {
         "PERMITID": "PRE04-414",
         "APN": 46762016,
         "File Number": "PRE04-414",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "PRE04-414",
         "Application Type": "Prelim - Comprehensive (Full) ",
         "Application Date": "9/17/04",
         "Status": "Complete ",
         "Description": "create office condominiums in existing office building ",
         "Planner": "Lesley Xavier ",
         "DURATION": 32,
         "Year": 2004
      },
      {
         "PERMITID": "PRE04-414",
         "APN": 46762017,
         "File Number": "PRE04-414",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "PRE04-414",
         "Application Type": "Prelim - Comprehensive (Full) ",
         "Application Date": "9/17/04",
         "Status": "Complete ",
         "Description": "create office condominiums in existing office building ",
         "Planner": "Lesley Xavier ",
         "DURATION": 32,
         "Year": 2004
      },
      {
         "PERMITID": "PRE04-414",
         "APN": 46762019,
         "File Number": "PRE04-414",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "PRE04-414",
         "Application Type": "Prelim - Comprehensive (Full) ",
         "Application Date": "9/17/04",
         "Status": "Complete ",
         "Description": "create office condominiums in existing office building ",
         "Planner": "Lesley Xavier ",
         "DURATION": 32,
         "Year": 2004
      },
      {
         "PERMITID": "PRE04-414",
         "APN": 46762020,
         "File Number": "PRE04-414",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "PRE04-414",
         "Application Type": "Prelim - Comprehensive (Full) ",
         "Application Date": "9/17/04",
         "Status": "Complete ",
         "Description": "create office condominiums in existing office building ",
         "Planner": "Lesley Xavier ",
         "DURATION": 32,
         "Year": 2004
      },
      {
         "PERMITID": "PRE04-530",
         "APN": 46722121,
         "File Number": "PRE04-530",
         "Address": "35 S 2ND ST SAN JOSE",
         "Project Name": "PRE04-530",
         "Application Type": "Prelim - Comprehensive (Full) ",
         "Application Date": "12/10/04",
         "Status": "Complete ",
         "Description": "Comprehensive Preliminary Review for a mixed use project consisting of a 15 to 22-story tower with approximately 187 units and 21,000 sq.ft. of retail.",
         "Planner": "Lesley Xavier ",
         "DURATION": 35,
         "Year": 2004
      },
      {
         "PERMITID": "PRE05-192",
         "APN": 26426006,
         "File Number": "PRE05-192",
         "Address": "341 DELMAS AV SAN JOSE",
         "Project Name": "PRE05-192",
         "Application Type": "Prelim - Comprehensive (Full) ",
         "Application Date": "4/22/05",
         "Status": "Complete ",
         "Description": "Comprehensive Preliminary Review for 48 single-family attached (condos) units on a 0.63 gross acre site.",
         "Planner": "Lesley Xavier ",
         "DURATION": 34,
         "Year": 2005
      },
      {
         "PERMITID": "PRE05-192",
         "APN": 26426008,
         "File Number": "PRE05-192",
         "Address": "341 DELMAS AV SAN JOSE",
         "Project Name": "PRE05-192",
         "Application Type": "Prelim - Comprehensive (Full) ",
         "Application Date": "4/22/05",
         "Status": "Complete ",
         "Description": "Comprehensive Preliminary Review for 48 single-family attached (condos) units on a 0.63 gross acre site.",
         "Planner": "Lesley Xavier ",
         "DURATION": 34,
         "Year": 2005
      },
      {
         "PERMITID": "PRE05-355",
         "APN": 25942080,
         "File Number": "PRE05-355",
         "Address": "S 1ST ST SAN JOSE",
         "Project Name": "PRE05-355",
         "Application Type": "Prelim - Comprehensive (Full) ",
         "Application Date": "8/2/05",
         "Status": "Complete ",
         "Description": "Comprehensive Prelim for 3 tower residential community with a shared base, including retail, lobby commons and parking on 2.02 gross acre site. The plans do not specify the total number of units for this proposal.",
         "Planner": "Hadasa Lev ",
         "DURATION": 112,
         "Year": 2005
      },
      {
         "PERMITID": "PRE05-355",
         "APN": 25942081,
         "File Number": "PRE05-355",
         "Address": "S 1ST ST SAN JOSE",
         "Project Name": "PRE05-355",
         "Application Type": "Prelim - Comprehensive (Full) ",
         "Application Date": "8/2/05",
         "Status": "Complete ",
         "Description": "Comprehensive Prelim for 3 tower residential community with a shared base, including retail, lobby commons and parking on 2.02 gross acre site. The plans do not specify the total number of units for this proposal.",
         "Planner": "Hadasa Lev ",
         "DURATION": 112,
         "Year": 2005
      },
      {
         "PERMITID": "PRE05-355",
         "APN": 25942082,
         "File Number": "PRE05-355",
         "Address": "S 1ST ST SAN JOSE",
         "Project Name": "PRE05-355",
         "Application Type": "Prelim - Comprehensive (Full) ",
         "Application Date": "8/2/05",
         "Status": "Complete ",
         "Description": "Comprehensive Prelim for 3 tower residential community with a shared base, including retail, lobby commons and parking on 2.02 gross acre site. The plans do not specify the total number of units for this proposal.",
         "Planner": "Hadasa Lev ",
         "DURATION": 112,
         "Year": 2005
      },
      {
         "PERMITID": "PRE05-425",
         "APN": 47217012,
         "File Number": "PRE05-425",
         "Address": "760 S 1ST ST SAN JOSE",
         "Project Name": "PRE05-425",
         "Application Type": "Prelim - Comprehensive (Full) ",
         "Application Date": "10/4/05",
         "Status": "Complete ",
         "Description": "Proposal to demolish an existing building and construct 4000 square feet commercial building and parking lot for 19 cars (see SP05-048)",
         "Planner": "Lee Butler ",
         "DURATION": 23,
         "Year": 2005
      },
      {
         "PERMITID": "PRE06-118",
         "APN": 46747098,
         "File Number": "PRE06-118",
         "Address": "490 S 1ST ST SAN JOSE",
         "Project Name": "PRE06-118",
         "Application Type": "Prelim - Comprehensive (Full) ",
         "Application Date": "3/23/06",
         "Status": "Complete ",
         "Description": "Meetings with Summerhill to prepare for submission of comprehensive pre-lim for 490-500 S. 1st Street",
         "Planner": "Michelle Stahlhut ",
         "DURATION": 656,
         "Year": 2006
      },
      {
         "PERMITID": "PRE06-394",
         "APN": 46722142,
         "File Number": "PRE06-394",
         "Address": "8 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "PRE06-394",
         "Application Type": "Prelim - Comprehensive (Full) ",
         "Application Date": "12/15/06",
         "Status": "Complete ",
         "Description": "Comprehensive Preliminary Review for mixed use project in a 22-story building containing 258 multiple dwelling units; 1,380 square feet of retail space; 40,000 square feet Living Tomorrow, and 221 structured parking spaces on a 1.02 gross acre site",
         "Planner": "Michelle Stahlhut ",
         "DURATION": 2418,
         "Year": 2006
      },
      {
         "PERMITID": "PRE07-130",
         "APN": 46746020,
         "File Number": "PRE07-130",
         "Address": "80 E SAN CARLOS ST SAN JOSE",
         "Project Name": "PRE07-130",
         "Application Type": "Prelim - Comprehensive (Full) ",
         "Application Date": "4/11/07",
         "Status": "Complete ",
         "Description": "Comprehensive Preliminary Review for a 26-story building containing 18,530 square feet of ground-floor retail and office space, 236 hotel suites, associated hotel amenities, 346 residential units, and 700 parking spaces on 1.78 gross acre site.",
         "Planner": "Licinia McMorrow ",
         "DURATION": 583,
         "Year": 2007
      },
      {
         "PERMITID": "PRE07-130",
         "APN": 46746072,
         "File Number": "PRE07-130",
         "Address": "80 E SAN CARLOS ST SAN JOSE",
         "Project Name": "PRE07-130",
         "Application Type": "Prelim - Comprehensive (Full) ",
         "Application Date": "4/11/07",
         "Status": "Complete ",
         "Description": "Comprehensive Preliminary Review for a 26-story building containing 18,530 square feet of ground-floor retail and office space, 236 hotel suites, associated hotel amenities, 346 residential units, and 700 parking spaces on 1.78 gross acre site.",
         "Planner": "Licinia McMorrow ",
         "DURATION": 583,
         "Year": 2007
      },
      {
         "PERMITID": "PRE07-285",
         "APN": 46721018,
         "File Number": "PRE07-285",
         "Address": "65 N 2ND ST SAN JOSE",
         "Project Name": "PRE07-285",
         "Application Type": "Prelim - Comprehensive (Full) ",
         "Application Date": "9/26/07",
         "Status": "Complete ",
         "Description": "Comprehensive Preliminary Review for a residential mixed-use project containing 386 multiple dwelling units, approximately 14,000 square feet of ground floor retail, and six levels of parking on a 1.0 gross acre site",
         "Planner": "Licinia McMorrow ",
         "DURATION": 218,
         "Year": 2007
      },
      {
         "PERMITID": "PRE07-285",
         "APN": 46721030,
         "File Number": "PRE07-285",
         "Address": "65 N 2ND ST SAN JOSE",
         "Project Name": "PRE07-285",
         "Application Type": "Prelim - Comprehensive (Full) ",
         "Application Date": "9/26/07",
         "Status": "Complete ",
         "Description": "Comprehensive Preliminary Review for a residential mixed-use project containing 386 multiple dwelling units, approximately 14,000 square feet of ground floor retail, and six levels of parking on a 1.0 gross acre site",
         "Planner": "Licinia McMorrow ",
         "DURATION": 218,
         "Year": 2007
      },
      {
         "PERMITID": "PRE07-285",
         "APN": 46721038,
         "File Number": "PRE07-285",
         "Address": "65 N 2ND ST SAN JOSE",
         "Project Name": "PRE07-285",
         "Application Type": "Prelim - Comprehensive (Full) ",
         "Application Date": "9/26/07",
         "Status": "Complete ",
         "Description": "Comprehensive Preliminary Review for a residential mixed-use project containing 386 multiple dwelling units, approximately 14,000 square feet of ground floor retail, and six levels of parking on a 1.0 gross acre site",
         "Planner": "Licinia McMorrow ",
         "DURATION": 218,
         "Year": 2007
      },
      {
         "PERMITID": "PRE08-170",
         "APN": 25935028,
         "File Number": "PRE08-170",
         "Address": "92 N ALMADEN BL SAN JOSE",
         "Project Name": "PRE08-170",
         "Application Type": "Prelim - Comprehensive (Full) ",
         "Application Date": "9/3/08",
         "Status": "Complete ",
         "Description": "Comprehensive prelim to convert an existing building into a theater (performing arts) ",
         "Planner": "Licinia McMorrow ",
         "DURATION": 35,
         "Year": 2008
      },
      {
         "PERMITID": "PRE08-193",
         "APN": 26420121,
         "File Number": "PRE08-193",
         "Address": "395 BIRD AV SAN JOSE",
         "Project Name": "PRE08-193 - Bird Avenue Car wash",
         "Application Type": "Prelim - Comprehensive (Full) ",
         "Application Date": "10/20/08",
         "Status": "Complete ",
         "Description": "Preliminary review for demo of an existing gas station and addition of a mini-mart and car wash on a 0.55 gross acre site",
         "Planner": "Sylvia Do ",
         "DURATION": 109,
         "Year": 2008
      },
      {
         "PERMITID": "PRE08-205",
         "APN": 25940061,
         "File Number": "PRE08-205",
         "Address": "71 S 1ST ST SAN JOSE",
         "Project Name": "PRE08-205 - Porter Stock Building",
         "Application Type": "Prelim - Comprehensive (Full) ",
         "Application Date": "11/25/08",
         "Status": "Complete ",
         "Description": "Comprehensive Prelim for a new 6-story hotel with ground floor parking garage and retail space, and 1-level below grade parking",
         "Planner": "Ella Samonsky ",
         "DURATION": 41,
         "Year": 2008
      },
      {
         "PERMITID": "PRE08-205",
         "APN": 25940063,
         "File Number": "PRE08-205",
         "Address": "71 S 1ST ST SAN JOSE",
         "Project Name": "PRE08-205 - Porter Stock Building",
         "Application Type": "Prelim - Comprehensive (Full) ",
         "Application Date": "11/25/08",
         "Status": "Complete ",
         "Description": "Comprehensive Prelim for a new 6-story hotel with ground floor parking garage and retail space, and 1-level below grade parking",
         "Planner": "Ella Samonsky ",
         "DURATION": 41,
         "Year": 2008
      },
      {
         "PERMITID": "PRE12-098",
         "APN": 26415065,
         "File Number": "PRE12-098",
         "Address": "720 W SAN CARLOS ST SAN JOSE",
         "Project Name": "PRE12-098",
         "Application Type": "Prelim - Comprehensive (Full) ",
         "Application Date": "9/24/12 11:12",
         "Status": "Complete ",
         "Description": "Comprehensive Preliminary Review proposing the contruction of a new 35,000 sq. ft. Orchard Supply store with a 12,000 sq. ft. Garden Center on the South side of Site. This will also include constructing of a portion of the new Parking Lot which will be in front of the new building. Existing store to remain open to Public during construction of new store. Once new store has been completed the existing store and parking lot is to be demolished.",
         "Planner": "Rich Buikema ",
         "DURATION": 134,
         "Year": 2012
      },
      {
         "PERMITID": "PRE13-200",
         "APN": 46718102,
         "File Number": "PRE13-200",
         "Address": "389 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PRE13-200",
         "Application Type": "Prelim - Comprehensive (Full) ",
         "Application Date": "10/18/13",
         "Status": "Complete ",
         "Description": "Preliminary Review for demolition of an existing church structure, construction of a new church and multi-purpose building, remodel of existing remaining buildings on-site ",
         "Planner": "Kristinae Toomians ",
         "DURATION": 109,
         "Year": 2013
      },
      {
         "PERMITID": "PRE13-200",
         "APN": 46718103,
         "File Number": "PRE13-200",
         "Address": "389 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PRE13-200",
         "Application Type": "Prelim - Comprehensive (Full) ",
         "Application Date": "10/18/13",
         "Status": "Complete ",
         "Description": "Preliminary Review for demolition of an existing church structure, construction of a new church and multi-purpose building, remodel of existing remaining buildings on-site ",
         "Planner": "Kristinae Toomians ",
         "DURATION": 109,
         "Year": 2013
      },
      {
         "PERMITID": "PRE14-128",
         "APN": 25943076,
         "File Number": "PRE14-128",
         "Address": "200 PARK AV SAN JOSE",
         "Project Name": "PRE14-128",
         "Application Type": "Prelim - Comprehensive (Full) ",
         "Application Date": "9/11/14 14:05",
         "Status": "Complete ",
         "Description": "Comprehensive Preliminary Review for general conformance review of vacant bank building to allow retail on 1st floor, offices on 2nd, 3rd and 4th floors and amenity space on the 5th floor.",
         "Planner": "Wayne Farrens ",
         "DURATION": 36,
         "Year": 2014
      },
      {
         "PERMITID": "PRE15-037",
         "APN": 25941067,
         "File Number": "PRE15-037",
         "Address": "170 PARK CENTER PLAZA SAN JOSE",
         "Project Name": "PRE15-037",
         "Application Type": "Prelim - Comprehensive (Full) ",
         "Application Date": "3/11/15",
         "Status": "Complete ",
         "Description": "Comprehesive Preliminary Review to demolish an existing building (Sumitomo Bank Building) and construct a mixed-use development. consisting of up to 264 residential units and ground floor retail within a 24-story high rise, and a 5-level parking garage (three levels below grade), on a 0.6 acre site.",
         "Planner": "John Tu ",
         "DURATION": 119,
         "Year": 2015
      },
      {
         "PERMITID": "PRE15-115",
         "APN": 46720020,
         "File Number": "PRE15-115",
         "Address": "100 N 4TH ST SAN JOSE",
         "Project Name": "PRE15-115 - 4th & St. John",
         "Application Type": "Prelim - Comprehensive (Full) ",
         "Application Date": "6/26/15 13:06",
         "Status": "Complete ",
         "Description": "Comprehensive Preliminary Review for the construction of a 23-story building for senior housing (first floor commercial, basement and 2nd thru 4th floors parking garage, 5th thru 23rd floors senior apartments) with a total height 259 feet in the CG Commercial General Zoning District (GP is Transit Res for southern portion of site, the rest is Res Neighborhood)",
         "Planner": "Jennifer Piozet ",
         "DURATION": 45,
         "Year": 2015
      },
      {
         "PERMITID": "PRE15-115",
         "APN": 46720021,
         "File Number": "PRE15-115",
         "Address": "100 N 4TH ST SAN JOSE",
         "Project Name": "PRE15-115 - 4th & St. John",
         "Application Type": "Prelim - Comprehensive (Full) ",
         "Application Date": "6/26/15 13:06",
         "Status": "Complete ",
         "Description": "Comprehensive Preliminary Review for the construction of a 23-story building for senior housing (first floor commercial, basement and 2nd thru 4th floors parking garage, 5th thru 23rd floors senior apartments) with a total height 259 feet in the CG Commercial General Zoning District (GP is Transit Res for southern portion of site, the rest is Res Neighborhood)",
         "Planner": "Jennifer Piozet ",
         "DURATION": 45,
         "Year": 2015
      },
      {
         "PERMITID": "PRE15-138",
         "APN": 26415065,
         "File Number": "PRE15-138",
         "Address": "720 W SAN CARLOS ST SAN JOSE",
         "Project Name": "MIDTOWN CENTER ",
         "Application Type": "Prelim - Comprehensive (Full) ",
         "Application Date": "8/3/15 15:14",
         "Status": "Complete ",
         "Description": "Comprehensive Preliminary Review for the renovation of an existing 36,596-square foot vacant building to incorporate three new tenant spaces, a parking lot reconfiguration and addition of new loading dock, located on a 2.78-gross acre site in the CIC Combined Industrial/Commercial Zoning District",
         "Planner": "Rebecca Bustos ",
         "DURATION": 31,
         "Year": 2015
      },
      {
         "PERMITID": "PRE15-186",
         "APN": 46720082,
         "File Number": "PRE15-186",
         "Address": "33 N 5TH ST SAN JOSE",
         "Project Name": "PRE15-186 - MIRO",
         "Application Type": "Prelim - Comprehensive (Full) ",
         "Application Date": "10/16/15 9:48",
         "Status": "Complete ",
         "Description": "Comprehensive Preliminary Review to construct 350,000 square feet of office space, 350 residential condominiums, and 20,000 square feet of ground-floor commercial space on an approximately 1.4 gross acre site",
         "Planner": "Emily Lipoma ",
         "DURATION": 67,
         "Year": 2015
      },
      {
         "PERMITID": "PRE15-186",
         "APN": 46720087,
         "File Number": "PRE15-186",
         "Address": "33 N 5TH ST SAN JOSE",
         "Project Name": "PRE15-186 - MIRO",
         "Application Type": "Prelim - Comprehensive (Full) ",
         "Application Date": "10/16/15 9:48",
         "Status": "Complete ",
         "Description": "Comprehensive Preliminary Review to construct 350,000 square feet of office space, 350 residential condominiums, and 20,000 square feet of ground-floor commercial space on an approximately 1.4 gross acre site",
         "Planner": "Emily Lipoma ",
         "DURATION": 67,
         "Year": 2015
      },
      {
         "PERMITID": "PRE15-190",
         "APN": 25946046,
         "File Number": "PRE15-190",
         "Address": "405 W SAN CARLOS ST SAN JOSE",
         "Project Name": "PRE15-190",
         "Application Type": "Prelim - Comprehensive (Full) ",
         "Application Date": "10/26/15 15:07",
         "Status": "Complete ",
         "Description": "Comprehensive Preliminary Review for a mixed-use project with 36 multi-residential units and one commercial/retail unit including 47 on-site parking spaces on a 0.47 gross acre site",
         "Planner": "Elizabeth Schuller ",
         "DURATION": 43,
         "Year": 2015
      },
      {
         "PERMITID": "PRE15-190",
         "APN": 25946048,
         "File Number": "PRE15-190",
         "Address": "405 W SAN CARLOS ST SAN JOSE",
         "Project Name": "PRE15-190",
         "Application Type": "Prelim - Comprehensive (Full) ",
         "Application Date": "10/26/15 15:07",
         "Status": "Complete ",
         "Description": "Comprehensive Preliminary Review for a mixed-use project with 36 multi-residential units and one commercial/retail unit including 47 on-site parking spaces on a 0.47 gross acre site",
         "Planner": "Elizabeth Schuller ",
         "DURATION": 43,
         "Year": 2015
      },
      {
         "PERMITID": "PRE15-205",
         "APN": 26419067,
         "File Number": "PRE15-205",
         "Address": "404 BIRD AV SAN JOSE",
         "Project Name": "PRE15-205",
         "Application Type": "Prelim - Comprehensive (Full) ",
         "Application Date": "11/13/15",
         "Status": "Complete ",
         "Description": "Comprehensive Preliminary Review for a 4 story mixed-use project with 33 units (possibly an SRO hotel) and 4,184 square feet of ground floor commercial on a 0.4 gross acre site",
         "Planner": "Jennifer Piozet ",
         "DURATION": 60,
         "Year": 2015
      },
      {
         "PERMITID": "PRE15-216",
         "APN": 25940012,
         "File Number": "PRE15-216",
         "Address": "70 S ALMADEN AV SAN JOSE",
         "Project Name": "PRE15-216 Greyhound",
         "Application Type": "Prelim - Comprehensive (Full) ",
         "Application Date": "12/2/15 14:58",
         "Status": "Complete ",
         "Description": "Comprehensive Preliminary Review for 708 residential units in two towers, Tower 1 with 23 stories and Tower 2 with 24 stories (294 units in tower 1, 414 in tower 2) with ground floor commercial and attached parking structure (2 levels below, 2 levels above grade) on a 1.63 gross acre site",
         "Planner": "Lea Simvoulakis ",
         "DURATION": 384,
         "Year": 2015
      },
      {
         "PERMITID": "PRE16-017",
         "APN": 25948045,
         "File Number": "PRE16-017",
         "Address": "461 PARK AV SAN JOSE",
         "Project Name": "PRE16-017",
         "Application Type": "Prelim - Comprehensive (Full) ",
         "Application Date": "2/2/16 13:33",
         "Status": "Complete ",
         "Description": "Comprehensive Preliminary Review for a rezoning/ new multi-family development, consisting of 9909 square feet and a total of 9 units, on a 0.11 gross acre site presently zoned LI Light Industrial. The proposal also includes the demolition of an existing 2-story office building.",
         "Planner": "Lea Simvoulakis ",
         "DURATION": 43,
         "Year": 2016
      },
      {
         "PERMITID": "PRE16-077",
         "APN": 25931071,
         "File Number": "PRE16-077",
         "Address": "255 W JULIAN ST SAN JOSE",
         "Project Name": "PRE16-077",
         "Application Type": "Prelim - Comprehensive (Full) ",
         "Application Date": "5/2/16 14:25",
         "Status": "Complete ",
         "Description": "PRELIM TO RESEARCH A DOWNTOWN BLOCK FOR 910 UNITS PLUS RETAIL",
         "Planner": "Justin Daniels ",
         "DURATION": 58,
         "Year": 2016
      },
      {
         "PERMITID": "PRE16-119",
         "APN": 46746072,
         "File Number": "PRE16-119",
         "Address": "80 E SAN CARLOS ST SAN JOSE",
         "Project Name": "PRE16-119",
         "Application Type": "Prelim - Comprehensive (Full) ",
         "Application Date": "7/19/16 9:45",
         "Status": "Complete ",
         "Description": "Comprehensive Preliminary Review to determine the feasibility of a 19-story, mixed use tower with 260 residential units for student housing, ground floor retail, and parking structure on a 1.45 gross acre site",
         "Planner": "Justin Daniels ",
         "DURATION": 50,
         "Year": 2016
      },
      {
         "PERMITID": "PRE15-187",
         "APN": 46722160,
         "File Number": "PRE15-187",
         "Address": "LAND ONLY SAN JOSE  ",
         "Project Name": "PRE15-187 - Sobrato Block 3 at 150 So. 2nd St.",
         "Application Type": "Prelim - Comprehensive (Full) ",
         "Application Date": "10/16/15 13:18",
         "Status": "Review Letter Sent ",
         "Description": "Preliminary review request for a 23-story high rise, mixed use building with 399 residential units and ground floor commercial space on a 1.33 gross acre site.",
         "Planner": "Leila Hakimizadeh ",
         "DURATION": 293,
         "Year": 2015
      }
   ],
   "Prelim - Enhanced ": [
      {
         "PERMITID": "PRE07-109",
         "APN": 47222091,
         "File Number": "PRE07-109",
         "Address": "595 MARGARET ST SAN JOSE",
         "Project Name": "PRE07-109",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "3/22/07",
         "Status": "Complete ",
         "Description": "Enhanced Preliminary Review to subdivide an existing 0.22 gross acre parcel into two lots for single-family detached residential uses",
         "Planner": "Sam Knutson ",
         "DURATION": 25,
         "Year": 2007
      },
      {
         "PERMITID": "PRE07-323",
         "APN": 46747096,
         "File Number": "PRE07-323",
         "Address": "439 S 4TH ST SAN JOSE",
         "Project Name": "PRE07-323",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "10/30/07",
         "Status": "Complete ",
         "Description": "Enhanced Preliminary Review to convert an existing apartment complex to a residential care facility.  ",
         "Planner": "Ella Samonsky ",
         "DURATION": 20,
         "Year": 2007
      },
      {
         "PERMITID": "PRE08-031",
         "APN": 46717083,
         "File Number": "PRE08-031",
         "Address": "69 N 10TH ST SAN JOSE",
         "Project Name": "PRE08-031",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "2/21/08",
         "Status": "Complete ",
         "Description": "Preliminary Review to develop a vacant lot in the RM Multi-Family Zoning District with eight podium cluster units ",
         "Planner": "Ella Samonsky ",
         "DURATION": 14,
         "Year": 2008
      },
      {
         "PERMITID": "PRE08-036",
         "APN": 46718090,
         "File Number": "PRE08-036",
         "Address": "301 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PRE08-036",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "2/27/08",
         "Status": "Complete ",
         "Description": "Preliminary Review request for a project that includes the addition of a second story for residential uses to an existing building and a facade remodel to a portion of the existing building. The corner tenant, City Bakery & Cafe, was recently done and the applicant would like to do the same to the rest of the tenant spaces.  ",
         "Planner": "Ella Samonsky ",
         "DURATION": 20,
         "Year": 2008
      },
      {
         "PERMITID": "PRE08-055",
         "APN": 46717083,
         "File Number": "PRE08-055",
         "Address": "69 N 10TH ST SAN JOSE",
         "Project Name": "PRE08-055",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "3/21/08",
         "Status": "Complete ",
         "Description": "Preliminary Review to develop a vacant lot in the RM Multi-Family Zoning District with seven (7) unit podium building.",
         "Planner": "Ella Samonsky ",
         "DURATION": 11,
         "Year": 2008
      },
      {
         "PERMITID": "PRE08-089",
         "APN": 25939120,
         "File Number": "PRE08-089",
         "Address": "95 S ALMADEN AV SAN JOSE",
         "Project Name": "PRE08-089",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "5/5/08",
         "Status": "Complete ",
         "Description": "Enhanced Preliminary Review request for new standby, back-up generator at an existing public utility facility. ",
         "Planner": "Ella Samonsky ",
         "DURATION": 16,
         "Year": 2008
      },
      {
         "PERMITID": "PRE08-109",
         "APN": 47217042,
         "File Number": "PRE08-109",
         "Address": "895 S 2ND ST SAN JOSE",
         "Project Name": "PRE08-109",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "5/28/08",
         "Status": "Complete ",
         "Description": "Proposal for four townhouses in the Martha Gardens Conservation Area ",
         "Planner": "Ella Samonsky ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "PRE08-123",
         "APN": 46717083,
         "File Number": "PRE08-123",
         "Address": "69 N 10TH ST SAN JOSE",
         "Project Name": "PRE08-123",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "6/18/08",
         "Status": "Complete ",
         "Description": "Preliminary Review for a revised plan to develop a vacant lot (structures have been removed) in the RM Multi-Family Zoning District with 2 attached and 2 detached units. PRE08-031 is proposing 8 unit podium and PRE08-055 is proposing 7 unit podium.",
         "Planner": "Licinia McMorrow ",
         "DURATION": 15,
         "Year": 2008
      },
      {
         "PERMITID": "PRE08-140",
         "APN": 46701023,
         "File Number": "PRE08-140",
         "Address": "247 N 3RD ST SAN JOSE",
         "Project Name": "PRE08-140",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "7/16/08",
         "Status": "Complete ",
         "Description": "Enhanced review to relocate and refurbish an existing multi-family residence and basement for office use with upper floor 264 sq ft addition, replace a detached garage and backyard with surface parking lot",
         "Planner": "Ella Samonsky ",
         "DURATION": 13,
         "Year": 2008
      },
      {
         "PERMITID": "PRE09-011",
         "APN": 47217075,
         "File Number": "PRE09-011",
         "Address": "787 S 3RD ST SAN JOSE",
         "Project Name": "PRE09-011",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "1/27/09",
         "Status": "Complete ",
         "Description": "Enhanced Basic prelim for the conversion of the 2nd floor and attic of an existing, abandoned duplex to a 3rd residential unit on a 0.138 gross acre site in the R-M zoning district",
         "Planner": "Lee Butler ",
         "DURATION": 21,
         "Year": 2009
      },
      {
         "PERMITID": "PRE10-036",
         "APN": 47218055,
         "File Number": "PRE10-036",
         "Address": "288 E VIRGINIA ST SAN JOSE",
         "Project Name": "PRE10-036",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "3/26/10",
         "Status": "Complete ",
         "Description": "Enhanced Basic Prelim for the addition of retail auto sales of up to 2 cars at an existing legal, non-conforming gas station on a 0.4 gross acre site in the CP commercial zoning district",
         "Planner": "Avril Baty ",
         "DURATION": 34,
         "Year": 2010
      },
      {
         "PERMITID": "PRE10-125",
         "APN": 46720018,
         "File Number": "PRE10-125",
         "Address": "160 E ST JOHN ST SAN JOSE",
         "Project Name": "PRE10-125",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "10/21/10",
         "Status": "Complete ",
         "Description": "Preliminary Review - Enhanced to allow the contruction of 100+ residential apartment unit on .43 gross acre site",
         "Planner": "Jodie Clark ",
         "DURATION": 385,
         "Year": 2010
      },
      {
         "PERMITID": "PRE11-047",
         "APN": 25940091,
         "File Number": "PRE11-047",
         "Address": "55 S MARKET ST SAN JOSE",
         "Project Name": "PRE11-047",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "5/18/11",
         "Status": "Complete ",
         "Description": "Enhanced Preliminary Review proposing to enclose 4,500 square feet of existing ground-floor plaza and add 1,500 square feet to existing second floor for new office space at an existing 15-story office building.",
         "Planner": "Jenny Nusbaum ",
         "DURATION": 30,
         "Year": 2011
      },
      {
         "PERMITID": "PRE11-097",
         "APN": 47218063,
         "File Number": "PRE11-097",
         "Address": "9750 TRACT SAN JOSE",
         "Project Name": "PRE11-097",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "11/28/11",
         "Status": "Complete ",
         "Description": "Preliminary Review for new site plan for an already zoned and permitted project bounded by Virginia, Martha, 5th, and 6th Streets. Proposal included up to 258 multi-family units in 4 story building with a linear park along 6th Street and the parking in above ground garage accessed off Virginia Stree and wrapped with units along 6th and 5th Street.",
         "Planner": "Mike Enderby ",
         "DURATION": 65,
         "Year": 2011
      },
      {
         "PERMITID": "PRE12-080",
         "APN": 47222091,
         "File Number": "PRE12-080",
         "Address": "595 MARGARET ST SAN JOSE",
         "Project Name": "PRE12-080",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "8/3/12",
         "Status": "Complete ",
         "Description": "Enhanced Preliminary Review of a vacant R-1-8 lot for construction of two 2-story single-family homes.",
         "Planner": "Mike Enderby ",
         "DURATION": 47,
         "Year": 2012
      },
      {
         "PERMITID": "PRE13-025",
         "APN": 47229090,
         "File Number": "PRE13-025",
         "Address": "0 S 11TH ST SAN JOSE",
         "Project Name": "PRE13-025",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "2/14/13",
         "Status": "Complete ",
         "Description": "Preliminary Review for a new two story mixed use building with ground floor retail and 5 residential units on a vacant lot",
         "Planner": "Aparna Ankola ",
         "DURATION": 50,
         "Year": 2013
      },
      {
         "PERMITID": "PRE13-034",
         "APN": 26420128,
         "File Number": "PRE13-034",
         "Address": "498 W SAN CARLOS ST SAN JOSE",
         "Project Name": "PRE13-034",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "3/1/13",
         "Status": "Complete ",
         "Description": "Preliminary Review if pre-school and day-care would be allowed on subject site. ",
         "Planner": "Emily Lipoma ",
         "DURATION": 21,
         "Year": 2013
      },
      {
         "PERMITID": "PRE13-109",
         "APN": 46724064,
         "File Number": "PRE13-109",
         "Address": "40 S 7TH ST SAN JOSE",
         "Project Name": "PRE13-109",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "6/13/13",
         "Status": "Complete ",
         "Description": "Preliminary Enhanced Review to build 15 apartments and 1 store space.",
         "Planner": "Emily Lipoma ",
         "DURATION": 15,
         "Year": 2013
      },
      {
         "PERMITID": "PRE13-166",
         "APN": 46721018,
         "File Number": "PRE13-166",
         "Address": "65 N 2ND ST SAN JOSE",
         "Project Name": "PRE13-166",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "9/4/13",
         "Status": "Complete ",
         "Description": "Enhanced Preliminary Review to construct a five story 200 multi-family attached residences with interior parking on a 1.40 gross acre site",
         "Planner": "Rebecca Bustos ",
         "DURATION": 20,
         "Year": 2013
      },
      {
         "PERMITID": "PRE13-166",
         "APN": 46721030,
         "File Number": "PRE13-166",
         "Address": "65 N 2ND ST SAN JOSE",
         "Project Name": "PRE13-166",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "9/4/13",
         "Status": "Complete ",
         "Description": "Enhanced Preliminary Review to construct a five story 200 multi-family attached residences with interior parking on a 1.40 gross acre site",
         "Planner": "Rebecca Bustos ",
         "DURATION": 20,
         "Year": 2013
      },
      {
         "PERMITID": "PRE13-166",
         "APN": 46721038,
         "File Number": "PRE13-166",
         "Address": "65 N 2ND ST SAN JOSE",
         "Project Name": "PRE13-166",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "9/4/13",
         "Status": "Complete ",
         "Description": "Enhanced Preliminary Review to construct a five story 200 multi-family attached residences with interior parking on a 1.40 gross acre site",
         "Planner": "Rebecca Bustos ",
         "DURATION": 20,
         "Year": 2013
      },
      {
         "PERMITID": "PRE13-177",
         "APN": 25946040,
         "File Number": "PRE13-177",
         "Address": "201 DELMAS AV SAN JOSE",
         "Project Name": "PRE13-177",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "9/12/13",
         "Status": "Complete ",
         "Description": "Enhanced Preliminary Review to construct 107 multi-family attached residences in the Delmas Park neighbor on a 1.72 gross acre site",
         "Planner": "Emily Lipoma ",
         "DURATION": 27,
         "Year": 2013
      },
      {
         "PERMITID": "PRE13-205",
         "APN": 26417011,
         "File Number": "PRE13-205",
         "Address": "450 DRAKE ST SAN JOSE",
         "Project Name": "PRE13-205",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "11/5/13",
         "Status": "Complete ",
         "Description": "To construct an Industrial Building adjacent to residential R-2 w/ less than 25-foot setback proposed. Applicant wants to know if a variance could be granted for the setback, being surrounded by LI zoning district.",
         "Planner": "Wayne Farrens ",
         "DURATION": 29,
         "Year": 2013
      },
      {
         "PERMITID": "PRE14-014",
         "APN": 46720074,
         "File Number": "PRE14-014",
         "Address": "117 N 5TH ST SAN JOSE",
         "Project Name": "PRE14-014",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "2/6/14",
         "Status": "Complete ",
         "Description": "Enhanced Preliminary Review for comments on the plans for a proposed four (4) story, 24 unit (8 units per floor) apartment building.",
         "Planner": "Audrey Knight ",
         "DURATION": 103,
         "Year": 2014
      },
      {
         "PERMITID": "PRE14-015",
         "APN": 46719059,
         "File Number": "PRE14-015",
         "Address": "73 N 6TH ST SAN JOSE",
         "Project Name": "PRE14-015",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "2/12/14",
         "Status": "Complete ",
         "Description": "Enhanced Preliminary Review to combine 2 parcels, rezone to DC, and construct a new 26 unit apartment building for student housing with 26 parking spaces. The proposal includes removal of the existing buildings. The applicant would like to know the minimum amount of public and private open space that would be required.",
         "Planner": "Emily Lipoma ",
         "DURATION": 22,
         "Year": 2014
      },
      {
         "PERMITID": "PRE14-166",
         "APN": 47226070,
         "File Number": "PRE14-166",
         "Address": "605 S 2ND ST SAN JOSE",
         "Project Name": "PRE14-166",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "11/14/14 16:04",
         "Status": "Complete ",
         "Description": "Enhanced Preliminary Review of a proposed six-story, 78-room hotel with two above-grade levels of parking and guest rooms on the third to sixth floors",
         "Planner": "Elizabeth Schuller ",
         "DURATION": 27,
         "Year": 2014
      },
      {
         "PERMITID": "PRE15-046",
         "APN": 46747058,
         "File Number": "PRE15-046",
         "Address": "451 S 4TH ST SAN JOSE",
         "Project Name": "PRE15-046",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "3/23/15 11:50",
         "Status": "Complete ",
         "Description": "Preliminary Review for proposed 14-story high rise of 168 multi-family residential units with commercial on the first floor on a 0.50 gross acre site",
         "Planner": "Emily Lipoma ",
         "DURATION": 23,
         "Year": 2015
      },
      {
         "PERMITID": "PRE15-052",
         "APN": 26426006,
         "File Number": "PRE15-052",
         "Address": "341 DELMAS AV SAN JOSE",
         "Project Name": "PRE15-052",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "3/27/15",
         "Status": "Complete ",
         "Description": "Enhanced Preliminary Review for 5-story multi-family residential development of approximately 128 units",
         "Planner": "Elizabeth Schuller ",
         "DURATION": 32,
         "Year": 2015
      },
      {
         "PERMITID": "PRE15-139",
         "APN": 26420064,
         "File Number": "PRE15-139",
         "Address": "500 W SAN CARLOS ST SAN JOSE",
         "Project Name": "PRE15-139",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "8/7/15 15:27",
         "Status": "Complete ",
         "Description": "Enhanced Preliminary Review for a new five-story mixed use development (APN 264-20-064), including 3,197 square feet of ground-floor retail on the first floor, and 19 residential units in a five-story development on an approximately 0.31 gross acre site in the CP Commercial Pedestrian Zoning District. Applicant would like to utilize the adjacent site under the same ownership (APN 264-20-065) zoned R-2, for parking purposes.",
         "Planner": "Elizabeth Schuller ",
         "DURATION": 26,
         "Year": 2015
      },
      {
         "PERMITID": "PRE15-180",
         "APN": 25946066,
         "File Number": "PRE15-180",
         "Address": "443 W SAN CARLOS ST SAN JOSE",
         "Project Name": "PRE15-180",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "10/9/15 9:18",
         "Status": "Complete ",
         "Description": "Residential and retail mixed use development with 94 apartments and 3,000 st ground level retail on seven stories, including two story podium parking.",
         "Planner": "Justin Daniels ",
         "DURATION": 1,
         "Year": 2015
      },
      {
         "PERMITID": "PRE15-180",
         "APN": 25946107,
         "File Number": "PRE15-180",
         "Address": "443 W SAN CARLOS ST SAN JOSE",
         "Project Name": "PRE15-180",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "10/9/15 9:18",
         "Status": "Complete ",
         "Description": "Residential and retail mixed use development with 94 apartments and 3,000 st ground level retail on seven stories, including two story podium parking.",
         "Planner": "Justin Daniels ",
         "DURATION": 1,
         "Year": 2015
      },
      {
         "PERMITID": "PRE15-221",
         "APN": 26420082,
         "File Number": "PRE15-221",
         "Address": "470 W SAN CARLOS ST SAN JOSE",
         "Project Name": "PRE15-221",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "12/15/15 14:49",
         "Status": "Complete ",
         "Description": "Enhanced Preliminary Review for a mixed-use development consisting of two (2) buildings (6-story tall), comprising of 143 residential units and two (2) levels of below grade parking for 176 parking stalls on a 0.9-gross acre site",
         "Planner": "Justin Daniels ",
         "DURATION": 29,
         "Year": 2015
      },
      {
         "PERMITID": "PRE15-221",
         "APN": 26420084,
         "File Number": "PRE15-221",
         "Address": "470 W SAN CARLOS ST SAN JOSE",
         "Project Name": "PRE15-221",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "12/15/15 14:49",
         "Status": "Complete ",
         "Description": "Enhanced Preliminary Review for a mixed-use development consisting of two (2) buildings (6-story tall), comprising of 143 residential units and two (2) levels of below grade parking for 176 parking stalls on a 0.9-gross acre site",
         "Planner": "Justin Daniels ",
         "DURATION": 29,
         "Year": 2015
      },
      {
         "PERMITID": "PRE15-221",
         "APN": 26420085,
         "File Number": "PRE15-221",
         "Address": "470 W SAN CARLOS ST SAN JOSE",
         "Project Name": "PRE15-221",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "12/15/15 14:49",
         "Status": "Complete ",
         "Description": "Enhanced Preliminary Review for a mixed-use development consisting of two (2) buildings (6-story tall), comprising of 143 residential units and two (2) levels of below grade parking for 176 parking stalls on a 0.9-gross acre site",
         "Planner": "Justin Daniels ",
         "DURATION": 29,
         "Year": 2015
      },
      {
         "PERMITID": "PRE15-221",
         "APN": 26426094,
         "File Number": "PRE15-221",
         "Address": "470 W SAN CARLOS ST SAN JOSE",
         "Project Name": "PRE15-221",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "12/15/15 14:49",
         "Status": "Complete ",
         "Description": "Enhanced Preliminary Review for a mixed-use development consisting of two (2) buildings (6-story tall), comprising of 143 residential units and two (2) levels of below grade parking for 176 parking stalls on a 0.9-gross acre site",
         "Planner": "Justin Daniels ",
         "DURATION": 29,
         "Year": 2015
      },
      {
         "PERMITID": "PRE16-052",
         "APN": 47217042,
         "File Number": "PRE16-052",
         "Address": "895 S 2ND ST SAN JOSE",
         "Project Name": "PRE16-052",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "3/23/16 16:00",
         "Status": "Complete ",
         "Description": "Enhanced Preliminary Review for a new three-story mixed-use development, consisting of 4 townhomes (5,472 square feet) and first floor office space(1,192 square feet) on a 0.19 gross acre vacant lot, located within the CN Commercial Neighborhood zoning district",
         "Planner": "Lea Simvoulakis ",
         "DURATION": 33,
         "Year": 2016
      },
      {
         "PERMITID": "PRE16-062",
         "APN": 25942079,
         "File Number": "PRE16-062",
         "Address": "211 S 1ST ST SAN JOSE",
         "Project Name": "PRE16-062",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "4/18/16 10:21",
         "Status": "Complete ",
         "Description": "Comprehensive Preliminary Review to allow a 21-story 176,000 square-foot hotel adjacent to a historic resource (Montgomery Hotel) on a 0.58-gross acre site",
         "Planner": "Rebecca Bustos ",
         "DURATION": 39,
         "Year": 2016
      },
      {
         "PERMITID": "PRE16-090",
         "APN": 25940043,
         "File Number": "PRE16-090",
         "Address": "27 S 1ST ST SAN JOSE",
         "Project Name": "PRE16-090",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "5/18/16 15:42",
         "Status": "Complete ",
         "Description": "Enhanced Preliminary Review for a new 24 story multi-family residential tower including 5,000 square foot retail along the street level, with 4 levels of basement parking and 5 levels above grade parking located on a 0.55-gross acre site in the DC Downtown Primary Commercial zoning district.",
         "Planner": "Jennifer Piozet ",
         "DURATION": 21,
         "Year": 2016
      },
      {
         "PERMITID": "PRE16-108",
         "APN": 26429118,
         "File Number": "PRE16-108",
         "Address": "389 S 1ST ST SAN JOSE",
         "Project Name": "PRE16-108",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "6/27/16 8:46",
         "Status": "Complete ",
         "Description": "Enhanced Preliminary Review for renovations and addition of mezzanine and third floor over the courtyard of an existing restaurant. Proposed second-floor mezzanine will include two new stairways (ADA access may also be required). Proposed third floor has two options for use of the new space: 1) private dining room (commercial) with restroom, stairs, and elevator; or 2) residential living space (penthouse) with rooftop garden.",
         "Planner": "Jennifer Piozet ",
         "DURATION": 43,
         "Year": 2016
      },
      {
         "PERMITID": "PRE16-115",
         "APN": 47217012,
         "File Number": "PRE16-115",
         "Address": "736 S 1ST ST SAN JOSE",
         "Project Name": "PRE16-115",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "7/13/16 15:17",
         "Status": "Complete ",
         "Description": "Enhanced Preliminary Review for an 84 room hotel, on a 0.59-gross acre site, in the CP Commercial Pedestrian Zoning District",
         "Planner": "Jennifer Piozet ",
         "DURATION": 28,
         "Year": 2016
      },
      {
         "PERMITID": "PRE16-115",
         "APN": 47217014,
         "File Number": "PRE16-115",
         "Address": "736 S 1ST ST SAN JOSE",
         "Project Name": "PRE16-115",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "7/13/16 15:17",
         "Status": "Complete ",
         "Description": "Enhanced Preliminary Review for an 84 room hotel, on a 0.59-gross acre site, in the CP Commercial Pedestrian Zoning District",
         "Planner": "Jennifer Piozet ",
         "DURATION": 28,
         "Year": 2016
      },
      {
         "PERMITID": "PRE16-124",
         "APN": 47217005,
         "File Number": "PRE16-124",
         "Address": "838 S 1ST ST SAN JOSE",
         "Project Name": "PRE16-124",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "7/22/16 15:36",
         "Status": "Complete ",
         "Description": "Enhanced Preliminary Review to inquire about replacing the existing buildings with mixed use project consisting of neighborhood serving retail fronting S. 1st Street, a self storage facility on the 2nd floor and middle of the site, and residential care taker units fronting S. 2nd Street on a site in the Martha Garden's Specific Plan area.",
         "Planner": "Justin Daniels ",
         "DURATION": 39,
         "Year": 2016
      },
      {
         "PERMITID": "PRE16-124",
         "APN": 47217006,
         "File Number": "PRE16-124",
         "Address": "838 S 1ST ST SAN JOSE",
         "Project Name": "PRE16-124",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "7/22/16 15:36",
         "Status": "Complete ",
         "Description": "Enhanced Preliminary Review to inquire about replacing the existing buildings with mixed use project consisting of neighborhood serving retail fronting S. 1st Street, a self storage facility on the 2nd floor and middle of the site, and residential care taker units fronting S. 2nd Street on a site in the Martha Garden's Specific Plan area.",
         "Planner": "Justin Daniels ",
         "DURATION": 39,
         "Year": 2016
      },
      {
         "PERMITID": "PRE16-124",
         "APN": 47217034,
         "File Number": "PRE16-124",
         "Address": "838 S 1ST ST SAN JOSE",
         "Project Name": "PRE16-124",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "7/22/16 15:36",
         "Status": "Complete ",
         "Description": "Enhanced Preliminary Review to inquire about replacing the existing buildings with mixed use project consisting of neighborhood serving retail fronting S. 1st Street, a self storage facility on the 2nd floor and middle of the site, and residential care taker units fronting S. 2nd Street on a site in the Martha Garden's Specific Plan area.",
         "Planner": "Justin Daniels ",
         "DURATION": 39,
         "Year": 2016
      },
      {
         "PERMITID": "PRE16-124",
         "APN": 47217095,
         "File Number": "PRE16-124",
         "Address": "838 S 1ST ST SAN JOSE",
         "Project Name": "PRE16-124",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "7/22/16 15:36",
         "Status": "Complete ",
         "Description": "Enhanced Preliminary Review to inquire about replacing the existing buildings with mixed use project consisting of neighborhood serving retail fronting S. 1st Street, a self storage facility on the 2nd floor and middle of the site, and residential care taker units fronting S. 2nd Street on a site in the Martha Garden's Specific Plan area.",
         "Planner": "Justin Daniels ",
         "DURATION": 39,
         "Year": 2016
      },
      {
         "PERMITID": "PRE16-140",
         "APN": 26426088,
         "File Number": "PRE16-140",
         "Address": "425 AUZERAIS AV SAN JOSE",
         "Project Name": "PRE16-140",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "8/22/16 14:51",
         "Status": "Complete ",
         "Description": "Enhanced Preliminary Review Application for the development of three lots zoned Light Industrial and R-2 Two-Family for a multi family residential project, on a 1.02-gross acre site.",
         "Planner": "Jennifer Piozet ",
         "DURATION": 32,
         "Year": 2016
      },
      {
         "PERMITID": "PRE16-168",
         "APN": 26419067,
         "File Number": "PRE16-168",
         "Address": "404 BIRD AV SAN JOSE",
         "Project Name": "PRE16-168",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "9/28/16 15:24",
         "Status": "Complete ",
         "Description": "A 93 Unit Transit oriented Extended stay Hotel. 5 stories of wood construction over a podium that is above two layers of parking; one at grade and one below. The grade level will include +/- 1700 SF or commercial and +/- 1800 SF of hotel wifi lounge and fitness area.",
         "Planner": "Jennifer Piozet ",
         "DURATION": 43,
         "Year": 2016
      },
      {
         "PERMITID": "PRE18-004",
         "APN": 26429118,
         "File Number": "PRE18-004",
         "Address": "389 S 1ST ST SAN JOSE",
         "Project Name": "PRE18-004",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "1/8/18 10:03",
         "Status": "Complete ",
         "Description": "Enhanced Preliminary Review for remodeling a building for a nightclub use ",
         "Planner": "David Fong ",
         "DURATION": 91,
         "Year": 2018
      },
      {
         "PERMITID": "PRE18-025",
         "APN": 47226070,
         "File Number": "PRE18-025",
         "Address": "605 S 2ND ST SAN JOSE",
         "Project Name": "PRE18-025",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "2/13/18 14:26",
         "Status": "Complete ",
         "Description": "Enhanced Preliminary Review request (including Enhanced Public Works Review, Fire and Building Review, Environmental Clearance Review, and Inter-departmental Meeting) for a new seven story hotel with 110 guest rooms and two levels of underground parking which is located in the Downtown General Plan Land Use/Transportation Diagram designation.",
         "Planner": "Cassandra Van Der Zweep ",
         "DURATION": 286,
         "Year": 2018
      },
      {
         "PERMITID": "PRE18-053",
         "APN": 47217073,
         "File Number": "PRE18-053",
         "Address": "757 S 3RD ST SAN JOSE",
         "Project Name": "PRE18-053",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "3/20/18 11:50",
         "Status": "Complete ",
         "Description": "Enhanced Preliminary Review request for a 5-plex with five 2-bedrooms and parking in rear with an alleyway of an historic home in Martha Gardens which is located in the Mixed Use Neighborhood General Plan Land Use designation.",
         "Planner": "Ruth Cueto ",
         "DURATION": 311,
         "Year": 2018
      },
      {
         "PERMITID": "PRE18-081",
         "APN": 25935026,
         "File Number": "PRE18-081",
         "Address": "0 LAND ONLY SAN JOSE",
         "Project Name": "PRE18-081",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "4/27/18 9:21",
         "Status": "Complete ",
         "Description": "Enhanced Preliminary Review request with architectural plan(s) (including an Enhanced Public Works Review and Environmental Clearance Scoping/Review) for a mixed-use project with 4,900 square feet of commercial space, 69,450 square feet of office space, and 220 residential units which is located in the Downtown General Plan Land Use designation.",
         "Planner": "Stefanie Farmer ",
         "DURATION": 28,
         "Year": 2018
      },
      {
         "PERMITID": "PRE18-081",
         "APN": 25935027,
         "File Number": "PRE18-081",
         "Address": "0 LAND ONLY SAN JOSE",
         "Project Name": "PRE18-081",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "4/27/18 9:21",
         "Status": "Complete ",
         "Description": "Enhanced Preliminary Review request with architectural plan(s) (including an Enhanced Public Works Review and Environmental Clearance Scoping/Review) for a mixed-use project with 4,900 square feet of commercial space, 69,450 square feet of office space, and 220 residential units which is located in the Downtown General Plan Land Use designation.",
         "Planner": "Stefanie Farmer ",
         "DURATION": 28,
         "Year": 2018
      },
      {
         "PERMITID": "PRE18-081",
         "APN": 25935032,
         "File Number": "PRE18-081",
         "Address": "0 LAND ONLY SAN JOSE",
         "Project Name": "PRE18-081",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "4/27/18 9:21",
         "Status": "Complete ",
         "Description": "Enhanced Preliminary Review request with architectural plan(s) (including an Enhanced Public Works Review and Environmental Clearance Scoping/Review) for a mixed-use project with 4,900 square feet of commercial space, 69,450 square feet of office space, and 220 residential units which is located in the Downtown General Plan Land Use designation.",
         "Planner": "Stefanie Farmer ",
         "DURATION": 28,
         "Year": 2018
      },
      {
         "PERMITID": "PRE18-081",
         "APN": 25935033,
         "File Number": "PRE18-081",
         "Address": "0 LAND ONLY SAN JOSE",
         "Project Name": "PRE18-081",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "4/27/18 9:21",
         "Status": "Complete ",
         "Description": "Enhanced Preliminary Review request with architectural plan(s) (including an Enhanced Public Works Review and Environmental Clearance Scoping/Review) for a mixed-use project with 4,900 square feet of commercial space, 69,450 square feet of office space, and 220 residential units which is located in the Downtown General Plan Land Use designation.",
         "Planner": "Stefanie Farmer ",
         "DURATION": 28,
         "Year": 2018
      },
      {
         "PERMITID": "PRE18-089",
         "APN": 24944088,
         "File Number": "PRE18-089",
         "Address": "380 N 1ST ST SAN JOSE",
         "Project Name": "PRE18-089",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "5/11/18 10:45",
         "Status": "Complete ",
         "Description": "Enhanced Preliminary Review request with architectural plan(s) (including a Inter-Departmental Meeting, Enhanced Public Works Review, and Fire and Building Review) for a \"Signature Project\" comprised of a 8-story mixed-use project with 32,240 square foot of commercial/office space, 2 levels of underground parking, and 71 residential units which is located in the Neighborhood/Community Commercial General Plan Land Use designation.",
         "Planner": "Kieulan Pham ",
         "DURATION": 46,
         "Year": 2018
      },
      {
         "PERMITID": "PRE18-119",
         "APN": 25943076,
         "File Number": "PRE18-119",
         "Address": "200 PARK AV SAN JOSE",
         "Project Name": "PRE18-119",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "6/6/18 11:13",
         "Status": "Complete ",
         "Description": "Enhanced Preliminary Review for demolition of a commercial building and a parking garage, vacation of right-of-way, and construction of a 20-story, 740,000 square-foot office tower located in DC Downtown Primary Commercial Zoning District on an approximately 1.7 acre lot (includes Enhanced PW Review, Environmental scoping and Interdepartmental meeting)",
         "Planner": "Ruth Cueto ",
         "DURATION": 62,
         "Year": 2018
      },
      {
         "PERMITID": "PRE18-119",
         "APN": 25943077,
         "File Number": "PRE18-119",
         "Address": "200 PARK AV SAN JOSE",
         "Project Name": "PRE18-119",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "6/6/18 11:13",
         "Status": "Complete ",
         "Description": "Enhanced Preliminary Review for demolition of a commercial building and a parking garage, vacation of right-of-way, and construction of a 20-story, 740,000 square-foot office tower located in DC Downtown Primary Commercial Zoning District on an approximately 1.7 acre lot (includes Enhanced PW Review, Environmental scoping and Interdepartmental meeting)",
         "Planner": "Ruth Cueto ",
         "DURATION": 62,
         "Year": 2018
      },
      {
         "PERMITID": "PRE18-156",
         "APN": 47219104,
         "File Number": "PRE18-156",
         "Address": "812 S 7TH ST SAN JOSE",
         "Project Name": "PRE18-156",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "7/27/18 11:14",
         "Status": "Complete ",
         "Description": "Enhanced Preliminary Review request with architectural plan(s) to research possibility of day care located on this 16,673 square foot lot zoned both R-2 and CP which is located in the Residential Neighborhood General Plan Land Use designation.",
         "Planner": "Michelle Flores ",
         "DURATION": 47,
         "Year": 2018
      },
      {
         "PERMITID": "PRE18-193",
         "APN": 46747039,
         "File Number": "PRE18-193",
         "Address": "446 S 2ND ST SAN JOSE",
         "Project Name": "PRE18-193",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "10/10/18 10:05",
         "Status": "Complete ",
         "Description": "Enhanced Preliminary Review request with architectural plan(s) for remodeling of two historic multi-family residential buildings (446 and 450 S. 2nd Street) as one site, and site work in the rear for parking. Located in the Downtown General Plan Land Use designation.",
         "Planner": "Juliet Arroyo ",
         "DURATION": 57,
         "Year": 2018
      },
      {
         "PERMITID": "PRE18-196",
         "APN": 46722160,
         "File Number": "PRE18-196",
         "Address": "LAND ONLY SAN JOSE  ",
         "Project Name": "PRE18-196 Sobrato Block 3",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "10/11/18 13:13",
         "Status": "Complete ",
         "Description": "Enhanced Preliminary Review request with architectural plan(s) (including a meeting with the Project Manager, Dept. of Transportation Review, Public Works Focused Review, Initial Environmental Scoping, and Urban Design Review) for an eight (8) level +/- 368,00 square foot supportive parking structure with approx. 1,038 parking stalls, and 12,000 square feet of commercial space. Located in DC Zoning with Downtpwn General Plan Land Use designation.",
         "Planner": "Stefanie Farmer ",
         "DURATION": 151,
         "Year": 2018
      },
      {
         "PERMITID": "PRE18-197",
         "APN": 25942080,
         "File Number": "PRE18-197",
         "Address": "S 1ST ST SAN JOSE",
         "Project Name": "PRE18-197 Sobrato Block 8",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "10/11/18 13:37",
         "Status": "Complete ",
         "Description": "Enhanced/Focused Preliminary Review request with architectural plan(s) (including a meeting with the Project Manager, Dept. of Transportation Review, Public Works Focused Review, Initial Environmental Scoping, and Urban Design Review) for 600 parking stalls, 20,00 square feet of retail space, and 550,000 square feet of retail space. Located in DC Zoning with Downtown General Plan Land Use designation.",
         "Planner": "Stefanie Farmer ",
         "DURATION": 151,
         "Year": 2018
      },
      {
         "PERMITID": "PRE18-140",
         "APN": 25939116,
         "File Number": "PRE18-140",
         "Address": "333 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "PRE18-140",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": " ",
         "Status": "Under Review ",
         "Description": "Enhanced Preliminary Review: to allow the construction of an 18-story, approximately 1,064,500 square foot office building on 2.493 gross acre site",
         "Planner": "John Tu ",
         "DURATION": 27,
         "Year": null
      },
      {
         "PERMITID": "PRE19-021",
         "APN": 46746080,
         "File Number": "PRE19-021",
         "Address": "300 S 1ST ST SAN JOSE",
         "Project Name": "PRE19-021",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "2/11/19 13:30",
         "Status": "Under Review ",
         "Description": "Enhanced Preliminary Review to demolish a office building and construct a mixed use project with 1,200,000 square feet of office space, 50,000 square feet of commercial, 332 unit of corporate housing, and 645 parking spaces on a 2.84 gross acre site located in the Downtown General Plan Land Use designation.",
         "Planner": "Stefanie Farmer ",
         "DURATION": 39,
         "Year": 2019
      },
      {
         "PERMITID": "PRE19-021",
         "APN": 46746081,
         "File Number": "PRE19-021",
         "Address": "300 S 1ST ST SAN JOSE",
         "Project Name": "PRE19-021",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "2/11/19 13:30",
         "Status": "Under Review ",
         "Description": "Enhanced Preliminary Review to demolish a office building and construct a mixed use project with 1,200,000 square feet of office space, 50,000 square feet of commercial, 332 unit of corporate housing, and 645 parking spaces on a 2.84 gross acre site located in the Downtown General Plan Land Use designation.",
         "Planner": "Stefanie Farmer ",
         "DURATION": 39,
         "Year": 2019
      },
      {
         "PERMITID": "PRE19-021",
         "APN": 46746082,
         "File Number": "PRE19-021",
         "Address": "300 S 1ST ST SAN JOSE",
         "Project Name": "PRE19-021",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "2/11/19 13:30",
         "Status": "Under Review ",
         "Description": "Enhanced Preliminary Review to demolish a office building and construct a mixed use project with 1,200,000 square feet of office space, 50,000 square feet of commercial, 332 unit of corporate housing, and 645 parking spaces on a 2.84 gross acre site located in the Downtown General Plan Land Use designation.",
         "Planner": "Stefanie Farmer ",
         "DURATION": 39,
         "Year": 2019
      },
      {
         "PERMITID": "PRE19-059",
         "APN": 46722002,
         "File Number": "PRE19-059",
         "Address": "26 S 1ST ST SAN JOSE",
         "Project Name": "PRE19-059",
         "Application Type": "Prelim - Enhanced ",
         "Application Date": "3/29/19 10:07",
         "Status": "Under Review ",
         "Description": "Enhanced Preliminary Review request with architectural plan(s) (including a meeting with the Project Manager, Building Review, Fire Review, Meeting with Fire, Parks Department Review, Housing Department Review, Public Works Enhanced Review, Department of Transportation Review, Initial Environmental Scoping, and Urban Design Review) to demolish surface parking, lot, the Lido Nightclub building, with a 6-story commercial and retail building, the historical building will be renovated as a lobby entrance building which is located in the Downtown General Plan Land Use designation.",
         "Planner": "Maira Blanco ",
         "DURATION": 13,
         "Year": 2019
      }
   ],
   "Prelim - Focused (Policy Review, No Plans) ": [
      {
         "PERMITID": "09-001",
         "APN": 25940043,
         "File Number": "09-001",
         "Address": "27 S 1ST ST SAN JOSE",
         "Project Name": "09-001",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "7/30/09",
         "Status": "Complete ",
         "Description": "To review proposed signs \"ROSS DRESS FOR LESS\" for a future retail store in Downtown area. (Note: This Prelim was created only for the purpose of sign consultation to collect fees for staff time spent. Initially it was under the Planning Consultation 'Sub' and later changed to Prelim 'Sub' per Mike Mena.) ",
         "Planner": "MNAGARAJ ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "PRE00-080",
         "APN": 26420047,
         "File Number": "PRE00-080",
         "Address": "0 (LAND ONLY.) SAN JOSE",
         "Project Name": "PRE00-080",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "1/25/00",
         "Status": "Complete ",
         "Description": "Construct 4 unit apartment building",
         "Planner": "Lisa Ring ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "PRE00-095",
         "APN": 46702062,
         "File Number": "PRE00-095",
         "Address": "285 N 8TH ST SAN JOSE",
         "Project Name": "PRE00-095",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "2/11/00",
         "Status": "Complete ",
         "Description": "Proposed 2nd unit",
         "Planner": "Lisa Ring ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "PRE00-263",
         "APN": 26420079,
         "File Number": "PRE00-263",
         "Address": "486 W SAN CARLOS ST SAN JOSE",
         "Project Name": "PRE00-263",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "4/13/00",
         "Status": "Complete ",
         "Description": "Demo existing building and construct a 13,500 building for office/industrial uses.",
         "Planner": "Akoni Danielsen ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "PRE00-263",
         "APN": 26420110,
         "File Number": "PRE00-263",
         "Address": "486 W SAN CARLOS ST SAN JOSE",
         "Project Name": "PRE00-263",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "4/13/00",
         "Status": "Complete ",
         "Description": "Demo existing building and construct a 13,500 building for office/industrial uses.",
         "Planner": "Akoni Danielsen ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "PRE00-343",
         "APN": 24944031,
         "File Number": "PRE00-343",
         "Address": "336 N 2ND ST SAN JOSE",
         "Project Name": "PRE00-343",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "5/19/00",
         "Status": "Complete ",
         "Description": "Rezone to C-1 for office use.",
         "Planner": "Akoni Danielsen ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "PRE00-370",
         "APN": 47228027,
         "File Number": "PRE00-370",
         "Address": "505 S 7TH ST SAN JOSE",
         "Project Name": "PRE00-370",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "6/20/00",
         "Status": "Complete ",
         "Description": "2 unit addition at duplex site. (See PRE99-11--720)",
         "Planner": "Akoni Danielsen ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "PRE00-381",
         "APN": 24950017,
         "File Number": "PRE00-381",
         "Address": "301 E JULIAN ST SAN JOSE",
         "Project Name": "PRE00-381",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "7/5/00",
         "Status": "Complete ",
         "Description": "Will staff support CUP request to sell used tires at what appears to be a former service station (converted ?) ",
         "Planner": "Akoni Danielsen ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "PRE00-430",
         "APN": 46702116,
         "File Number": "PRE00-430",
         "Address": "268 E JULIAN ST SAN JOSE",
         "Project Name": "PRE00-430",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "9/5/00",
         "Status": "Complete ",
         "Description": "Demolition Permit request to remove 2 residential buildings",
         "Planner": "Robert MERKAMP ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "PRE01-125",
         "APN": 26420079,
         "File Number": "PRE01-125",
         "Address": "498 W SAN CARLOS ST SAN JOSE",
         "Project Name": "PRE01-125",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "5/10/01",
         "Status": "Complete ",
         "Description": "Wants to rezone from LI to CN to allow mixed-use (Light Manufacturing/Office/Residence) on a 0.49 gross acre site.",
         "Planner": "John Davidson ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "PRE01-125",
         "APN": 26420110,
         "File Number": "PRE01-125",
         "Address": "498 W SAN CARLOS ST SAN JOSE",
         "Project Name": "PRE01-125",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "5/10/01",
         "Status": "Complete ",
         "Description": "Wants to rezone from LI to CN to allow mixed-use (Light Manufacturing/Office/Residence) on a 0.49 gross acre site.",
         "Planner": "John Davidson ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "PRE01-125",
         "APN": 26420128,
         "File Number": "PRE01-125",
         "Address": "498 W SAN CARLOS ST SAN JOSE",
         "Project Name": "PRE01-125",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "5/10/01",
         "Status": "Complete ",
         "Description": "Wants to rezone from LI to CN to allow mixed-use (Light Manufacturing/Office/Residence) on a 0.49 gross acre site.",
         "Planner": "John Davidson ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "PRE01-140",
         "APN": 47223059,
         "File Number": "PRE01-140",
         "Address": "755 S 10TH ST SAN JOSE",
         "Project Name": "PRE01-140",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "5/28/01",
         "Status": "Complete ",
         "Description": "Applicant is proposing 2-story addition to rear of single family home.",
         "Planner": "John Davidson ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "PRE01-283",
         "APN": 47218002,
         "File Number": "PRE01-283",
         "Address": "792 S 3RD ST SAN JOSE",
         "Project Name": "PRE01-283",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "9/21/01",
         "Status": "Complete ",
         "Description": "Get \"as built\" approved for accessory structure / separate unit habitable. Applicant is willing to compromise to get accessory structure legalized. ",
         "Planner": "John Davidson ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "PRE01-325",
         "APN": 47211009,
         "File Number": "PRE01-325",
         "Address": " ",
         "Project Name": "PRE01-325",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "11/2/01",
         "Status": "Complete ",
         "Description": "City's surplus properties. See property for development or combination with adjacent parcel. ",
         "Planner": "Carol Hamilton ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "PRE02-128",
         "APN": 26419037,
         "File Number": "PRE02-128",
         "Address": "409 ILLINOIS AV SAN JOSE",
         "Project Name": "PRE02-128",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "4/29/02",
         "Status": "Complete ",
         "Description": "Preliminary review for proposed mixed-use project to include 14 units and approximately 15,400 square feet of retail.",
         "Planner": "John Davidson ",
         "DURATION": 32,
         "Year": 2002
      },
      {
         "PERMITID": "PRE02-183",
         "APN": 47218055,
         "File Number": "PRE02-183",
         "Address": "288 E VIRGINIA ST SAN JOSE",
         "Project Name": "PRE02-183",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "6/19/02",
         "Status": "Complete ",
         "Description": "Applicant proposes to close down gas station and convert building for retail uses. ",
         "Planner": "Akoni Danielsen ",
         "DURATION": 37,
         "Year": 2002
      },
      {
         "PERMITID": "PRE02-318",
         "APN": 47218059,
         "File Number": "PRE02-318",
         "Address": "160 E VIRGINIA ST SAN JOSE",
         "Project Name": "PRE02-318",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "12/3/02",
         "Status": "Complete ",
         "Description": "Preliminary Review to assess feasibility of a conditional use permit to allow a WIC voucher redemption center in an existing industrial building. ",
         "Planner": "Dave Tymn ",
         "DURATION": 1,
         "Year": 2002
      },
      {
         "PERMITID": "PRE03-019",
         "APN": 46702048,
         "File Number": "PRE03-019",
         "Address": "236 N 6TH ST SAN JOSE",
         "Project Name": "PRE03-019",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "1/16/03",
         "Status": "Complete ",
         "Description": "2 separate residential on the site.",
         "Planner": "Akoni Danielsen ",
         "DURATION": 18,
         "Year": 2003
      },
      {
         "PERMITID": "PRE03-073",
         "APN": 46724032,
         "File Number": "PRE03-073",
         "Address": "80 S 6TH ST SAN JOSE",
         "Project Name": "PRE03-073",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "2/27/03",
         "Status": "Complete ",
         "Description": "To convert basement into second unit and add habitable space in third floor attic area to an existing single family residential unit in R-M Zoning District.  ",
         "Planner": "Lee Butler ",
         "DURATION": 14,
         "Year": 2003
      },
      {
         "PERMITID": "PRE03-169",
         "APN": 46718090,
         "File Number": "PRE03-169",
         "Address": "301 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PRE03-169",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "5/19/03",
         "Status": "Complete ",
         "Description": "For operation of an existing restaurant until 3 a.m. Also proposes new windows. Building is historic.",
         "Planner": "Lee Butler ",
         "DURATION": 18,
         "Year": 2003
      },
      {
         "PERMITID": "PRE03-243",
         "APN": 26420064,
         "File Number": "PRE03-243",
         "Address": "500 W SAN CARLOS ST SAN JOSE",
         "Project Name": "PRE03-243",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "7/8/03",
         "Status": "Complete ",
         "Description": "To evaluate the rezoning of the property from LI to commercial use to allow the used car lot by right. ",
         "Planner": "Lee Butler ",
         "DURATION": 13,
         "Year": 2003
      },
      {
         "PERMITID": "PRE03-346",
         "APN": 46724088,
         "File Number": "PRE03-346",
         "Address": "99 S 9TH ST SAN JOSE",
         "Project Name": "PRE03-346",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "9/30/03",
         "Status": "Complete ",
         "Description": "To convert a rooming house into a window food service business (no seating) at this location. ",
         "Planner": "John Davidson ",
         "DURATION": 10,
         "Year": 2003
      },
      {
         "PERMITID": "PRE03-366",
         "APN": 24948005,
         "File Number": "PRE03-366",
         "Address": "379 N 6TH ST SAN JOSE",
         "Project Name": "PRE03-366",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "10/14/03",
         "Status": "Complete ",
         "Description": "To add a 1,413 sq. ft. basement to an existing duplex in the Hensley Historic District.",
         "Planner": "John Davidson ",
         "DURATION": 7,
         "Year": 2003
      },
      {
         "PERMITID": "PRE03-428",
         "APN": 47217014,
         "File Number": "PRE03-428",
         "Address": "748 S 1ST ST SAN JOSE",
         "Project Name": "PRE03-428",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "12/10/03",
         "Status": "Complete ",
         "Description": "Produce market with an off-site parking arrangement on a 0.2 gross acre site.",
         "Planner": "Lesley Xavier ",
         "DURATION": 12,
         "Year": 2003
      },
      {
         "PERMITID": "PRE04-074",
         "APN": 47217040,
         "File Number": "PRE04-074",
         "Address": "891 S 2ND ST SAN JOSE",
         "Project Name": "PRE04-074",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "2/24/04",
         "Status": "Complete ",
         "Description": "CODE CASE, Existing Duplex, request demo of illegal accessory structure. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 31,
         "Year": 2004
      },
      {
         "PERMITID": "PRE04-121",
         "APN": 46720081,
         "File Number": "PRE04-121",
         "Address": "49 N 4TH ST SAN JOSE",
         "Project Name": "PRE04-121",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "3/25/04",
         "Status": "Complete ",
         "Description": "To demolish an existing chruch and construct a new 10,000 sq. ft. church, combine parcels 467-20-060, 079, 080, 81, construct 400 new residential units in 4 new towers, and incorporate ground floor commercial uses.",
         "Planner": "Lee Butler ",
         "DURATION": 19,
         "Year": 2004
      },
      {
         "PERMITID": "PRE04-171",
         "APN": 26429119,
         "File Number": "PRE04-171",
         "Address": "347 S 1ST ST SAN JOSE",
         "Project Name": "PRE04-171",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "4/26/04",
         "Status": "Complete ",
         "Description": "Preliminary review for a new bar and lounge, operation until 2 a.m., and entertainment uses at one of two possible sites (the two sites are across the street from each other). 380 S. 1st St. is approximately 3800 sf 347 S. 1st St. is approximately 3600 sf",
         "Planner": "Lesley Xavier ",
         "DURATION": 17,
         "Year": 2004
      },
      {
         "PERMITID": "PRE04-171",
         "APN": 46746045,
         "File Number": "PRE04-171",
         "Address": "347 S 1ST ST SAN JOSE",
         "Project Name": "PRE04-171",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "4/26/04",
         "Status": "Complete ",
         "Description": "Preliminary review for a new bar and lounge, operation until 2 a.m., and entertainment uses at one of two possible sites (the two sites are across the street from each other). 380 S. 1st St. is approximately 3800 sf 347 S. 1st St. is approximately 3600 sf",
         "Planner": "Lesley Xavier ",
         "DURATION": 17,
         "Year": 2004
      },
      {
         "PERMITID": "PRE04-206",
         "APN": 47223011,
         "File Number": "PRE04-206",
         "Address": "612 S 10TH ST SAN JOSE",
         "Project Name": "PRE04-206",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "5/19/04",
         "Status": "Complete ",
         "Description": "Convert an existing single-family property into a duplex ",
         "Planner": "Lee Butler ",
         "DURATION": 19,
         "Year": 2004
      },
      {
         "PERMITID": "PRE04-223",
         "APN": 24946083,
         "File Number": "PRE04-223",
         "Address": "329 N 4TH ST SAN JOSE",
         "Project Name": "PRE04-223, Sadri N 4TH Lot line adj",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "5/28/04",
         "Status": "Complete ",
         "Description": "Preliminary Review to determine possibility of doing a lot line adjustment for a new multifamily development ",
         "Planner": "MNAGARAJ ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "PRE04-267",
         "APN": 46762016,
         "File Number": "PRE04-267",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "PRE04-267",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "6/24/04",
         "Status": "Complete ",
         "Description": "1. Convert the BofA building into office condos, 2. demolish an existing commercial building adjacent to the BofA building and construct a new commercial building",
         "Planner": "Lee Butler ",
         "DURATION": 29,
         "Year": 2004
      },
      {
         "PERMITID": "PRE04-267",
         "APN": 46762017,
         "File Number": "PRE04-267",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "PRE04-267",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "6/24/04",
         "Status": "Complete ",
         "Description": "1. Convert the BofA building into office condos, 2. demolish an existing commercial building adjacent to the BofA building and construct a new commercial building",
         "Planner": "Lee Butler ",
         "DURATION": 29,
         "Year": 2004
      },
      {
         "PERMITID": "PRE04-292",
         "APN": 47226070,
         "File Number": "PRE04-292",
         "Address": "605 S 2ND ST SAN JOSE",
         "Project Name": "PRE04-292, SAIC S 2ND PARKING",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "7/6/04",
         "Status": "Complete ",
         "Description": "Preliminary Review to allow temporary parking on a vacant site in Downtown Core Commercial zoning district, to allow the completion of an underground remediation system at a former gas station site situated across the street from the vacant site. ",
         "Planner": "MNAGARAJ ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "PRE04-485",
         "APN": 47229095,
         "File Number": "PRE04-485",
         "Address": "515 S 10TH ST SAN JOSE",
         "Project Name": "PRE04-485",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "11/1/04",
         "Status": "Complete ",
         "Description": "Preliminary Review for existing restaurant. Proposal is to extend hours of operation to 3:00 a.m. on Friday and Saturday,",
         "Planner": "Lee Butler ",
         "DURATION": 44,
         "Year": 2004
      },
      {
         "PERMITID": "PRE04-506",
         "APN": 24946083,
         "File Number": "PRE04-506",
         "Address": "329 N 4TH ST SAN JOSE",
         "Project Name": "PRE04-506",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "11/22/04",
         "Status": "Complete ",
         "Description": "Build 7 single-family homes on a .386 acre parcel",
         "Planner": "Lee Butler ",
         "DURATION": 51,
         "Year": 2004
      },
      {
         "PERMITID": "PRE04-528",
         "APN": 26420101,
         "File Number": "PRE04-528",
         "Address": "491 AUZERAIS AV SAN JOSE",
         "Project Name": "PRE04-528",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "12/9/04",
         "Status": "Complete ",
         "Description": "Duplex on two levels with parking in the basement. ",
         "Planner": "Dave Tymn ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "PRE05-002",
         "APN": 47217012,
         "File Number": "PRE05-002",
         "Address": "760 S 1ST ST SAN JOSE",
         "Project Name": "PRE05-002",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "1/4/05",
         "Status": "Complete ",
         "Description": "Basic Prelim to determine feasibility of demolishing an existing dilapidated building and convert land to a parking lot that would serve surrounding commercial uses.  ",
         "Planner": "Lesley Xavier ",
         "DURATION": 27,
         "Year": 2005
      },
      {
         "PERMITID": "PRE05-065",
         "APN": 25945070,
         "File Number": "PRE05-065",
         "Address": "183 SONOMA ST SAN JOSE",
         "Project Name": "PRE05-065",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "2/14/05",
         "Status": "Complete ",
         "Description": "Remove an existing house, basement and outbuilding in order to construct a 2-story duplex unit.",
         "Planner": "Dave Tymn ",
         "DURATION": 16,
         "Year": 2005
      },
      {
         "PERMITID": "PRE05-098",
         "APN": 46720021,
         "File Number": "PRE05-098",
         "Address": "237 N 4TH ST SAN JOSE",
         "Project Name": "PRE05-098",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "3/9/05",
         "Status": "Complete ",
         "Description": "Applicant would like to relocate and preserve (E) Victorian-era residence from 146 N. 4th to vacant lot at 237 N. 4th for residential or commercial use, staff can choose whichever use/plan is best.",
         "Planner": "Lesley Xavier ",
         "DURATION": 29,
         "Year": 2005
      },
      {
         "PERMITID": "PRE05-161",
         "APN": 25940064,
         "File Number": "PRE05-161",
         "Address": "93 S 1ST ST SAN JOSE",
         "Project Name": "PRE05-161",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "4/11/05",
         "Status": "Complete ",
         "Description": "RETROFIT SINGLE & TWO STORY BUILDINGS. REHABILITATION OF EXTERIOR ELEVATIONS, & BUILDINGS TO SHELL CONDITION ",
         "Planner": "Ron Eddow ",
         "DURATION": 23,
         "Year": 2005
      },
      {
         "PERMITID": "PRE05-219",
         "APN": 25945077,
         "File Number": "PRE05-219",
         "Address": "432 LAKEHOUSE AV SAN JOSE",
         "Project Name": "PRE05-219",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "5/11/05",
         "Status": "Complete ",
         "Description": "Preliminary review to rebuild garage for an existing legal nonconforming 4-plex. Applicant has 2 proposals: 1) build new garage and expand driveway, or 2) rebuild existing garage.",
         "Planner": "Lesley Xavier ",
         "DURATION": 43,
         "Year": 2005
      },
      {
         "PERMITID": "PRE05-460",
         "APN": 26420064,
         "File Number": "PRE05-460",
         "Address": "500 W SAN CARLOS ST SAN JOSE",
         "Project Name": "PRE05-460",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "10/28/05",
         "Status": "Complete ",
         "Description": "Preliminary Review for a mixed use  ",
         "Planner": "Dave Tymn ",
         "DURATION": 26,
         "Year": 2005
      },
      {
         "PERMITID": "PRE05-497",
         "APN": 46701034,
         "File Number": "PRE05-497",
         "Address": "237 N 4TH ST SAN JOSE",
         "Project Name": "PRE05-497",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "12/2/05",
         "Status": "Complete ",
         "Description": "Preliminary review to determine if staff will support a rezoning, in order to construct a detached SFD residence on a vacant lot currently zoned CG. Lot is 37.5' x 90', so would reduced setbacks be allowed? Is basement allowed or submerged garage?",
         "Planner": "Lee Butler ",
         "DURATION": 14,
         "Year": 2005
      },
      {
         "PERMITID": "PRE06-009",
         "APN": 46746045,
         "File Number": "PRE06-009",
         "Address": "386 S 1ST ST SAN JOSE",
         "Project Name": "PRE06-009",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "1/10/06",
         "Status": "Complete ",
         "Description": "Complete renovation of existing facility for a new restaurant. Siesmic report/structural upgrades/new facade and ADA improvements. ",
         "Planner": "Lee Butler ",
         "DURATION": 23,
         "Year": 2006
      },
      {
         "PERMITID": "PRE06-076",
         "APN": 47218007,
         "File Number": "PRE06-076",
         "Address": "143 E VIRGINIA ST SAN JOSE",
         "Project Name": "PRE06-076",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "2/21/06",
         "Status": "Complete ",
         "Description": "Preliminary review for 70 condominium on a site with existing buildings currently used for storage/warehouse uses",
         "Planner": "Lesley Xavier ",
         "DURATION": 35,
         "Year": 2006
      },
      {
         "PERMITID": "PRE06-106",
         "APN": 47221044,
         "File Number": "PRE06-106",
         "Address": "620 ORVIS AV SAN JOSE",
         "Project Name": "PRE06-106",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "3/17/06",
         "Status": "Complete ",
         "Description": "Preliminary review questionaire to determine whether 3 single family units on a 0.24 acre lot would be appropriate",
         "Planner": "Lee Butler ",
         "DURATION": 13,
         "Year": 2006
      },
      {
         "PERMITID": "PRE06-277",
         "APN": 46721034,
         "File Number": "PRE06-277",
         "Address": "4 N 2ND ST SAN JOSE",
         "Project Name": "PRE06-277",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "8/30/06",
         "Status": "Complete ",
         "Description": "Preliminary review for proposed 6-story residential infill approximately facing N. 3rd Street.",
         "Planner": "Lee Butler ",
         "DURATION": 30,
         "Year": 2006
      },
      {
         "PERMITID": "PRE06-294",
         "APN": 46719075,
         "File Number": "PRE06-294",
         "Address": "225 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PRE06-294",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "9/12/06",
         "Status": "Complete ",
         "Description": "This is a Basic Preliminary Review application to evaluate the future submittal of a conditional use permit to permit hours of operation be expanded to 2 a.m. for Satrurday and Sunday for a restaurant.",
         "Planner": "Steven Rosen ",
         "DURATION": 17,
         "Year": 2006
      },
      {
         "PERMITID": "PRE07-010",
         "APN": 26411103,
         "File Number": "PRE07-010",
         "Address": "862 SAVAKER AV SAN JOSE",
         "Project Name": "PRE07-010",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "1/11/07",
         "Status": "Complete ",
         "Description": "Prelim Meeting with PM only. Applicant may submit a preliminary review under this folder at a later date. See Allen Tai or Jenny Nusbaum. ",
         "Planner": "Allen Tai ",
         "DURATION": 29,
         "Year": 2007
      },
      {
         "PERMITID": "PRE07-063",
         "APN": 46701034,
         "File Number": "PRE07-063",
         "Address": "237 N 4TH ST SAN JOSE",
         "Project Name": "PRE07-063",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "2/14/07",
         "Status": "Complete ",
         "Description": "FOCUSED PRELIM: CURRENTLY PROPERTY IS VACANT. APPLICANT WANTS TO BUILD A 2-STORY LIVE/WORK LOFT WITH 1375 SQ FT RESIDENTIAL UPSTAIRS AND 500 SQ FT GROUND FLOOR OFFICE.. DUE TO SIZE OF LOT - INPUT ON CONFORMANCE TO GENERAL PLAN AND DEVELOPMENT CODE. SEEKING SUPPORT FROM PLANNING STAFF TO DEVELOP SITE IN SITE IN AMANNER FEASIBLE TO THE OWNER AND CITY STAFF.",
         "Planner": "Steven Rosen ",
         "DURATION": 27,
         "Year": 2007
      },
      {
         "PERMITID": "PRE07-064",
         "APN": 46723069,
         "File Number": "PRE07-064",
         "Address": "32 S 3RD ST SAN JOSE",
         "Project Name": "PRE07-064",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "2/14/07",
         "Status": "Complete ",
         "Description": "Focused preliminary review for art gallery and restaurant with separate drinking area. Extended hours to 2am.",
         "Planner": "Steven Rosen ",
         "DURATION": 19,
         "Year": 2007
      },
      {
         "PERMITID": "PRE07-085",
         "APN": 47218014,
         "File Number": "PRE07-085",
         "Address": "1001 S 5TH ST SAN JOSE",
         "Project Name": "PRE07-085",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "3/5/07",
         "Status": "Complete ",
         "Description": "Enhanced Basic Preliminary Review application for a mixed-use development project on a 7.89 gross acre site",
         "Planner": "Licinia McMorrow ",
         "DURATION": 15,
         "Year": 2007
      },
      {
         "PERMITID": "PRE07-138",
         "APN": 25934026,
         "File Number": "PRE07-138",
         "Address": "66 N MARKET ST SAN JOSE",
         "Project Name": "PRE07-138",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "4/17/07",
         "Status": "Complete ",
         "Description": "Preliminary Review for meeting with project manager to determine applicable land use policy for the Mitchell Block ",
         "Planner": "Ron Eddow ",
         "DURATION": 365,
         "Year": 2007
      },
      {
         "PERMITID": "PRE07-238",
         "APN": 25932035,
         "File Number": "PRE07-238",
         "Address": "201 BASSETT ST SAN JOSE",
         "Project Name": "PRE07-238",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "7/27/07",
         "Status": "Complete ",
         "Description": "Preliminary Review meeting with the project manager for a single-family attached residential project on the North San Pedro housing sites ",
         "Planner": "Ron Eddow ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "PRE07-238",
         "APN": 25932073,
         "File Number": "PRE07-238",
         "Address": "201 BASSETT ST SAN JOSE",
         "Project Name": "PRE07-238",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "7/27/07",
         "Status": "Complete ",
         "Description": "Preliminary Review meeting with the project manager for a single-family attached residential project on the North San Pedro housing sites ",
         "Planner": "Ron Eddow ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "PRE07-327",
         "APN": 46746045,
         "File Number": "PRE07-327",
         "Address": "380 S 1ST ST SAN JOSE",
         "Project Name": "PRE07-327",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "11/5/07",
         "Status": "Complete ",
         "Description": "Focused Preliminary Review for a beauty salon with a public eating and drinking establishment and late night use from 10:00 a.m. to 1:30 a.m.",
         "Planner": "Ron Eddow ",
         "DURATION": 21,
         "Year": 2007
      },
      {
         "PERMITID": "PRE08-011",
         "APN": 46701034,
         "File Number": "PRE08-011",
         "Address": "237 N 4TH ST SAN JOSE",
         "Project Name": "PRE08-011",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "1/30/08",
         "Status": "Complete ",
         "Description": "Preliminary review meeting with applicant to discuss Special Use Permit/Variance process for new two live/work units on a substandard lot ",
         "Planner": "Ron Eddow ",
         "DURATION": 77,
         "Year": 2008
      },
      {
         "PERMITID": "PRE08-040",
         "APN": 46720079,
         "File Number": "PRE08-040",
         "Address": "147 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PRE08-040",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "3/4/08",
         "Status": "Complete ",
         "Description": "Preliminary review meeting with applicant to discuss a mixed use project on the subject site ",
         "Planner": "Ron Eddow ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "PRE08-126",
         "APN": 25932005,
         "File Number": "PRE08-126",
         "Address": "175 N SAN PEDRO ST SAN JOSE",
         "Project Name": "PRE08-126",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "6/25/08",
         "Status": "Complete ",
         "Description": "Basic Prelim to demolish existing 1-story vacant building and to pave the lot with surface parking. Request to meet with the project manager.",
         "Planner": "Ella Samonsky ",
         "DURATION": 14,
         "Year": 2008
      },
      {
         "PERMITID": "PRE08-144",
         "APN": 46720079,
         "File Number": "PRE08-144",
         "Address": "147 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PRE08-144",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "7/31/08",
         "Status": "Complete ",
         "Description": "Focused Prelim Review to expand existing mini-mart with converstion of 3-bay garage to a retail store, appoximately 2,000 sq. ft., and to allow off-sale of alcohol at an existing gas services station. Wants to know about permits, time frame and cost. Any grants available.",
         "Planner": "Ella Samonsky ",
         "DURATION": 14,
         "Year": 2008
      },
      {
         "PERMITID": "PRE09-012",
         "APN": 46747090,
         "File Number": "PRE09-012",
         "Address": "400 S 1ST ST SAN JOSE",
         "Project Name": "PRE09-012",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "2/3/09",
         "Status": "Complete ",
         "Description": "Basic Prelim - to renew a previously approved permit (CP05-022) for late night use and entertainment establishment for a restaurant/lounge that has been closed since Nov. 1st, 2007. Paid for the meeting with project manager.",
         "Planner": "Lee Butler ",
         "DURATION": 35,
         "Year": 2009
      },
      {
         "PERMITID": "PRE09-048",
         "APN": 47217012,
         "File Number": "PRE09-048",
         "Address": "760 S 1ST ST SAN JOSE",
         "Project Name": "PRE09-048",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "5/27/09",
         "Status": "Complete ",
         "Description": "Preliminary review for a proposed hotel ",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 58,
         "Year": 2009
      },
      {
         "PERMITID": "PRE09-048",
         "APN": 47217014,
         "File Number": "PRE09-048",
         "Address": "760 S 1ST ST SAN JOSE",
         "Project Name": "PRE09-048",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "5/27/09",
         "Status": "Complete ",
         "Description": "Preliminary review for a proposed hotel ",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 58,
         "Year": 2009
      },
      {
         "PERMITID": "PRE09-048",
         "APN": 47217015,
         "File Number": "PRE09-048",
         "Address": "760 S 1ST ST SAN JOSE",
         "Project Name": "PRE09-048",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "5/27/09",
         "Status": "Complete ",
         "Description": "Preliminary review for a proposed hotel ",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 58,
         "Year": 2009
      },
      {
         "PERMITID": "PRE09-051",
         "APN": 47229064,
         "File Number": "PRE09-051",
         "Address": "526 S 11TH ST SAN JOSE",
         "Project Name": "PRE09-051",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "6/1/09",
         "Status": "Complete ",
         "Description": "Basic Prelim to allow conversion from 2-unit dwelling to 3-unit dwelling at the R-M zoing district. Applicant indicated that there are 1-car garage and 2 on-site parking spaces (one is located right next to the garage and the other in front the garage).",
         "Planner": "Edward Schreiner ",
         "DURATION": 3,
         "Year": 2009
      },
      {
         "PERMITID": "PRE10-114",
         "APN": 25934029,
         "File Number": "PRE10-114",
         "Address": "84 N MARKET ST SAN JOSE",
         "Project Name": "PRE10-114",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "8/26/10",
         "Status": "Complete ",
         "Description": "Basic Prelm to add 5 rooms to an existing 7-room single room occupancy hotel, emergency rear exit, and additional furnace on a 0.107 gross acre site in the DC downtown commercial zoning district",
         "Planner": "Lesley Xavier ",
         "DURATION": 8,
         "Year": 2010
      },
      {
         "PERMITID": "PRE11-022",
         "APN": 25941068,
         "File Number": "PRE11-022",
         "Address": "185 PARK AV SAN JOSE",
         "Project Name": "PRE11-022",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "3/3/11",
         "Status": "Complete ",
         "Description": "Outdoor dining area for an existing restaurant ",
         "Planner": "Jenny Nusbaum ",
         "DURATION": 19,
         "Year": 2011
      },
      {
         "PERMITID": "PRE11-044",
         "APN": 47217008,
         "File Number": "PRE11-044",
         "Address": "798 S 1ST ST SAN JOSE",
         "Project Name": "PRE11-044",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "5/5/11",
         "Status": "Complete ",
         "Description": "Basic Prelim to remodel an existing vacant building and operate a beauty salon on a 0.29 gross acre site",
         "Planner": "Lori Moniz ",
         "DURATION": 64,
         "Year": 2011
      },
      {
         "PERMITID": "PRE11-070",
         "APN": 46720021,
         "File Number": "PRE11-070",
         "Address": "146 N 4TH ST SAN JOSE",
         "Project Name": "PRE11-070",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "8/29/11",
         "Status": "Complete ",
         "Description": "Demolish an existing single-family residence (~100 years old) to expand an existing parking lot.",
         "Planner": "LPREVETTI ",
         "DURATION": 46,
         "Year": 2011
      },
      {
         "PERMITID": "PRE12-041",
         "APN": 26429058,
         "File Number": "PRE12-041",
         "Address": "325 S 1ST ST SAN JOSE",
         "Project Name": "PRE12-041",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "5/18/12",
         "Status": "Complete ",
         "Description": "Preliminary review to assess support for a CUP for a restaurant (take out hotdog shop) to be open until 2 or 3 am. Applicant wants to know specifics of permit process (timing, etc), and identification of potential issues that may arise as part of CUP",
         "Planner": "JHORWEDEL ",
         "DURATION": 62,
         "Year": 2012
      },
      {
         "PERMITID": "PRE12-063",
         "APN": 46747096,
         "File Number": "PRE12-063",
         "Address": "439 S 4TH ST SAN JOSE",
         "Project Name": "PRE12-063",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "7/3/12",
         "Status": "Complete ",
         "Description": "Basic Preliminary Review to investigate converting a 3-bay car garage to storage with facilities.",
         "Planner": "Mike Enderby ",
         "DURATION": 99,
         "Year": 2012
      },
      {
         "PERMITID": "PRE12-077",
         "APN": 25940091,
         "File Number": "PRE12-077",
         "Address": "55 S MARKET ST SAN JOSE",
         "Project Name": "PRE12-077",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "7/30/12",
         "Status": "Complete ",
         "Description": "Basic Preliminary Review on a Downtown property with proposal to create data center space condominiums within a 15-story building.",
         "Planner": "Salifu Yakubu ",
         "DURATION": 22,
         "Year": 2012
      },
      {
         "PERMITID": "PRE13-121",
         "APN": 46721025,
         "File Number": "PRE13-121",
         "Address": "29 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PRE13-121",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "7/5/13",
         "Status": "Complete ",
         "Description": "Preliminary review to convert an existing second story vacant commercial space to four living units with an off-site parking arrangement where nearby off-site parking would be leased ",
         "Planner": "Salifu Yakubu ",
         "DURATION": 60,
         "Year": 2013
      },
      {
         "PERMITID": "PRE13-158",
         "APN": 46747058,
         "File Number": "PRE13-158",
         "Address": "451 S 4TH ST SAN JOSE",
         "Project Name": "PRE13-158",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "8/19/13",
         "Status": "Complete ",
         "Description": "Preliminary Review Basic to allow the conversion of an existing building to an adult care / home care facility ",
         "Planner": "Rebecca Bustos ",
         "DURATION": 1,
         "Year": 2013
      },
      {
         "PERMITID": "PRE13-192",
         "APN": 25947081,
         "File Number": "PRE13-192",
         "Address": "525 LORRAINE AV SAN JOSE",
         "Project Name": "PRE13-192",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "10/9/13",
         "Status": "Complete ",
         "Description": "Prelim for outdoor storage and storage industrial ",
         "Planner": "Patrick Kelly ",
         "DURATION": 272,
         "Year": 2013
      },
      {
         "PERMITID": "PRE14-010",
         "APN": 24946053,
         "File Number": "PRE14-010",
         "Address": "341 N 5TH ST SAN JOSE",
         "Project Name": "PRE14-010",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "1/24/14",
         "Status": "Complete ",
         "Description": "Preliminary Review - Code Case ",
         "Planner": "Salifu Yakubu ",
         "DURATION": 17,
         "Year": 2014
      },
      {
         "PERMITID": "PRE14-114",
         "APN": 46722121,
         "File Number": "PRE14-114",
         "Address": "35 S 2ND ST SAN JOSE",
         "Project Name": "PRE14-114",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "8/21/14 8:15",
         "Status": "Complete ",
         "Description": "Preliminary Review Application for a proposed multi-story, mixed-use development with underground parking, ground floor retail, and multi-family residential units ",
         "Planner": "Jason Rogers ",
         "DURATION": 29,
         "Year": 2014
      },
      {
         "PERMITID": "PRE14-140",
         "APN": 46719059,
         "File Number": "PRE14-140",
         "Address": "73 N 6TH ST SAN JOSE",
         "Project Name": "PRE14-140",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "9/26/14 13:28",
         "Status": "Complete ",
         "Description": "Preliminary Review Focused to review a 65-unit apartment proposal including setbacks, height, density and parking",
         "Planner": "Lea Simvoulakis ",
         "DURATION": 19,
         "Year": 2014
      },
      {
         "PERMITID": "PRE15-079",
         "APN": 25936038,
         "File Number": "PRE15-079",
         "Address": "324 W ST JOHN ST SAN JOSE",
         "Project Name": "PRE15-079 - Little Italy",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "4/30/15",
         "Status": "Complete ",
         "Description": "Focused Preliminary Review to determine if three existing residences can be demolished and combined with a vacant parcel of land to develop a multi-story Italian themed mixed used development in the Littile Italy/River Street Historic district ",
         "Planner": "Lea Simvoulakis ",
         "DURATION": 399,
         "Year": 2015
      },
      {
         "PERMITID": "PRE15-107",
         "APN": 47218007,
         "File Number": "PRE15-107",
         "Address": "143 E VIRGINIA ST SAN JOSE",
         "Project Name": "PRE15-107 - Baby Nutrution (WIC Program Services)",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "6/12/15 14:00",
         "Status": "Complete ",
         "Description": "Focused Preliminary Review to determine if a business that provides services to qualified candidates of the Woman, Infant, and Children (WIC) program can operate within a Transit Residential GP area and LI - Light Industrial zoning district.  ",
         "Planner": "Jennifer Piozet ",
         "DURATION": 31,
         "Year": 2015
      },
      {
         "PERMITID": "PRE15-191",
         "APN": 46724064,
         "File Number": "PRE15-191",
         "Address": "40 S 7TH ST SAN JOSE",
         "Project Name": "PRE15-191",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "10/27/15 9:20",
         "Status": "Complete ",
         "Description": "Basic Preliminary Review to build a duplex on a vacant lot. ",
         "Planner": "Emily Lipoma ",
         "DURATION": 28,
         "Year": 2015
      },
      {
         "PERMITID": "PRE16-117",
         "APN": 46723088,
         "File Number": "PRE16-117",
         "Address": "10 S 3RD ST SAN JOSE",
         "Project Name": "PRE16-117",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "7/18/16 13:35",
         "Status": "Complete ",
         "Description": "Basic Preliminary Review to inquire about expanding an existing hotel by 42 rooms and suites for a total of 86 rooms and suites.",
         "Planner": "Lea Simvoulakis ",
         "DURATION": 30,
         "Year": 2016
      },
      {
         "PERMITID": "PRE16-128",
         "APN": 26420132,
         "File Number": "PRE16-128",
         "Address": "350 BIRD AV SAN JOSE",
         "Project Name": "PRE16-128",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "8/3/16 10:16",
         "Status": "Complete ",
         "Description": "Focused Preliminary Review request for off-sale of alcoholic beverages (beer and wine) at a retail store located on the ground floor of a mixed use building (Delmas Park) on a 0.8-gross acre site in the A(PD) Planned Development Zoning District",
         "Planner": "Rebecca Bustos ",
         "DURATION": 30,
         "Year": 2016
      },
      {
         "PERMITID": "PRE16-187",
         "APN": 46720074,
         "File Number": "PRE16-187",
         "Address": "117 N 5TH ST SAN JOSE",
         "Project Name": "PRE16-187",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "11/1/16 11:04",
         "Status": "Complete ",
         "Description": "Proposing a multi-family project with one (1) bedroom units totaling 24 units. This is a three (3) storied building over the podium total of four (4) floors.",
         "Planner": "Lea Simvoulakis ",
         "DURATION": 30,
         "Year": 2016
      },
      {
         "PERMITID": "PRE17-054",
         "APN": 25948045,
         "File Number": "PRE17-054",
         "Address": "461 PARK AV SAN JOSE",
         "Project Name": "PRE17-054 - 461 PARK AVENUE",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "3/16/17",
         "Status": "Complete ",
         "Description": "Basic Preliminary Review and Meeting with Project Manager to inquire about demolishing the existing building and constructing a 4-story, 20 unit apartment complex on a .11 acre site.",
         "Planner": "Lea Simvoulakis ",
         "DURATION": 29,
         "Year": 2017
      },
      {
         "PERMITID": "PRE17-183",
         "APN": 24946033,
         "File Number": "PRE17-183",
         "Address": "129 E JULIAN ST SAN JOSE",
         "Project Name": "PRE17-183",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "10/24/17 14:55",
         "Status": "Complete ",
         "Description": "Preliminary Review , Historic landmark and historic district. Code Case. Seems it was four units w/ two kitchens and four meters. Applicant would like to re-instate the four units, with interior modifications. Also applicant wants to explore the possibility of SRO, student housing, leasing room by room. Currently there is no parking. ",
         "Planner": "Cassandra Van Der Zweep ",
         "DURATION": 43,
         "Year": 2017
      },
      {
         "PERMITID": "PRE18-220",
         "APN": 47229096,
         "File Number": "PRE18-220",
         "Address": "524 S 9TH ST SAN JOSE",
         "Project Name": "PRE18-220",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "11/20/18 13:20",
         "Status": "Complete ",
         "Description": "Focused Preliminary Review to convert unconditioned space to conditioned space. This portion had never been used for living. Ultra small space 395 sq. ft. no parking. Located in the Mixed Use Commercial General Plan Land Use designation.",
         "Planner": "Rina Shah ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "PRE18-235",
         "APN": 47218024,
         "File Number": "PRE18-235",
         "Address": "140 E VIRGINIA ST SAN JOSE",
         "Project Name": "PRE18-235",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "12/10/18 13:11",
         "Status": "Complete ",
         "Description": "Focused Preliminary Review to receive staff in-put into subdividing an existing LI zoned lot with both a commercial and SFR onsite. Applicant would like to lot line adjust move the line to create the smallest possible property for the SFR, obtain approval of a 2nd driveway to serve the SFR. (Applicant would probably need to rezone to a R-1 designation.). Located in the Light Industrial General Plan Land Use designation.",
         "Planner": "Rhonda Buss ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "PRE19-016",
         "APN": 25940084,
         "File Number": "PRE19-016",
         "Address": "95 S MARKET ST SAN JOSE",
         "Project Name": "PRE19-016",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "2/1/19 9:26",
         "Status": "Complete ",
         "Description": "Focused Preliminary Review request to allow existing restaurant to stay open till 2:00 AM. The building is a mixed use building with office on the upper floors, the restaurant is located in the 1st floor. which is located in the Downtown General Plan Land Use designation. Applicant is aware that a CUP will be required.",
         "Planner": "Michelle Flores ",
         "DURATION": 33,
         "Year": 2019
      },
      {
         "PERMITID": "PRE97-036",
         "APN": 47217012,
         "File Number": "PRE97-036",
         "Address": "760 S 1ST ST SAN JOSE",
         "Project Name": "PRE97-036",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "1/8/97",
         "Status": "Complete ",
         "Description": "Demo bldg and build 30 unit motel.",
         "Planner": "Salifu Yakubu ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "PRE97-329",
         "APN": 24948025,
         "File Number": "PRE97-329",
         "Address": "252 WASHINGTON ST SAN JOSE",
         "Project Name": "PRE97-329",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "4/14/97",
         "Status": "Complete ",
         "Description": "New duplex for vacant site. ",
         "Planner": "Teresa Estrada ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "PRE97-503",
         "APN": 47218014,
         "File Number": "PRE97-503",
         "Address": "828 S 3RD ST SAN JOSE",
         "Project Name": "PRE97-503",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "6/23/97",
         "Status": "Complete ",
         "Description": "Proposed lot line adjustments. Abandoned RR ROW. No use specified. ",
         "Planner": "Salifu Yakubu ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "PRE97-589",
         "APN": 26419067,
         "File Number": "PRE97-589",
         "Address": " ",
         "Project Name": "PRE97-589",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "7/25/97",
         "Status": "Complete ",
         "Description": "Change GP to office, demo ex bldg and build architect's office (2 different flavors).",
         "Planner": "Akoni Danielsen ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "PRE97-607",
         "APN": 46718029,
         "File Number": "PRE97-607",
         "Address": "162 N 8TH ST SAN JOSE",
         "Project Name": "PRE97-607",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "8/1/97",
         "Status": "Complete ",
         "Description": "SFD on 4,100 sq ft lot. Development Exception OK? See previous prelim PRE97-03-278.",
         "Planner": "Akoni Danielsen ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "PRE97-609",
         "APN": 26419067,
         "File Number": "PRE97-609",
         "Address": " ",
         "Project Name": "PRE97-609",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "8/4/97",
         "Status": "Complete ",
         "Description": "Auto repair, smog pros, and storage. (prelim last week was for Architect's office on same site) ",
         "Planner": "Salifu Yakubu ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "PRE97-891",
         "APN": 47217012,
         "File Number": "PRE97-891",
         "Address": "760 S 1ST ST SAN JOSE",
         "Project Name": "PRE97-891",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "11/14/97",
         "Status": "Complete ",
         "Description": "Proposed 30 unit motel.",
         "Planner": "Akoni Danielsen ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "PRE98-135",
         "APN": 26419067,
         "File Number": "PRE98-135",
         "Address": " ",
         "Project Name": "PRE98-135",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "2/5/98",
         "Status": "Complete ",
         "Description": "Mixed uses, keep old building that everyone else wants to demo. See previous prelims. ",
         "Planner": "Akoni Danielsen ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "PRE98-423",
         "APN": 46722009,
         "File Number": "PRE98-423",
         "Address": "72 S 1ST ST SAN JOSE",
         "Project Name": "PRE98-423",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "5/27/98",
         "Status": "Complete ",
         "Description": "New signage at Hank Coca's furniture (Agency already had Adj for this??) ",
         "Planner": "Akoni Danielsen ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "PRE98-528",
         "APN": 47228001,
         "File Number": "PRE98-528",
         "Address": "503 S 6TH ST SAN JOSE",
         "Project Name": "PRE98-528",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "7/13/98",
         "Status": "Complete ",
         "Description": "472-28-001, 002, 098 Corner of S. 6th and E. William Streets. Below-grade parking, grade-level retail and parking, and 3 stories of SRO.",
         "Planner": "Akoni Danielsen ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "PRE98-583",
         "APN": 26420079,
         "File Number": "PRE98-583",
         "Address": "486 W SAN CARLOS ST SAN JOSE",
         "Project Name": "PRE98-583",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "8/8/98",
         "Status": "Complete ",
         "Description": "Sign making, retail, offices. ",
         "Planner": "Akoni Danielsen ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "PRE99-171",
         "APN": 47222066,
         "File Number": "PRE99-171",
         "Address": "772 S 11TH ST SAN JOSE",
         "Project Name": "PRE99-171",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "3/11/99",
         "Status": "Complete ",
         "Description": "Will we support expansion of SFD? ",
         "Planner": "PGILLI ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PRE99-177",
         "APN": 26416018,
         "File Number": "PRE99-177",
         "Address": "461 GREGORY ST SAN JOSE",
         "Project Name": "PRE99-177",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "3/19/99",
         "Status": "Complete ",
         "Description": "Wants to convert SFD to duplex- ",
         "Planner": "PNAMENY ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PRE99-337",
         "APN": 47223120,
         "File Number": "PRE99-337",
         "Address": "702 S 10TH ST SAN JOSE",
         "Project Name": "PRE99-337",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "5/19/99",
         "Status": "Complete ",
         "Description": "Need info. on fencing in private open space- ",
         "Planner": "PGILLI ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PRE99-525",
         "APN": 47229043,
         "File Number": "PRE99-525",
         "Address": "520 S 10TH ST SAN JOSE",
         "Project Name": "PRE99-525",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "8/19/99",
         "Status": "Complete ",
         "Description": "Improve building facade ",
         "Planner": "Akoni Danielsen ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PRE99-602",
         "APN": 47224111,
         "File Number": "PRE99-602",
         "Address": "651 S 8TH ST SAN JOSE",
         "Project Name": "PRE99-602",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "10/1/99",
         "Status": "Complete ",
         "Description": "Wants to combine 2 parcels",
         "Planner": "Akoni Danielsen ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PRE99-606",
         "APN": 26420051,
         "File Number": "PRE99-606",
         "Address": "577 AUZERAIS AV SAN JOSE",
         "Project Name": "PRE99-606",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "10/8/99",
         "Status": "Complete ",
         "Description": "SUP for expansion of SFD in M-1? Code case.",
         "Planner": "Lisa Ring ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PRE99-642",
         "APN": 24948025,
         "File Number": "PRE99-642",
         "Address": "252 WASHINGTON ST SAN JOSE",
         "Project Name": "PRE99-642",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "10/21/99",
         "Status": "Complete ",
         "Description": "Would like to add 3rd living unit- Hensley Historic District",
         "Planner": "Lisa Ring ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PRE99-663",
         "APN": 46718029,
         "File Number": "PRE99-663",
         "Address": "162 N 8TH ST SAN JOSE",
         "Project Name": "PRE99-663",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "11/5/99",
         "Status": "Complete ",
         "Description": "Proposes one house on sub-standard lot ",
         "Planner": "Lisa Ring ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PRE17-152",
         "APN": 25939116,
         "File Number": "PRE17-152",
         "Address": "333 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "PRE17-152",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "9/13/17 13:30",
         "Status": "Pending ",
         "Description": "Focused Preliminary Review - environmental scoping review ",
         "Planner": "Meenaxi Panakkal ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "PRE19-010",
         "APN": 25939120,
         "File Number": "PRE19-010",
         "Address": "95 S ALMADEN AV SAN JOSE",
         "Project Name": "PRE19-010",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "1/24/19 10:25",
         "Status": "Review Letter Sent ",
         "Description": "Focused Preliminary Review request to determined that 44 parking stalls is required for an AT&T switching facility. Located in the Downtown General Plan Land Use designation.",
         "Planner": "Rina Shah ",
         "DURATION": 0,
         "Year": 2019
      },
      {
         "PERMITID": "PRE17-023",
         "APN": 47217024,
         "File Number": "PRE17-023",
         "Address": "735 S 2ND ST SAN JOSE",
         "Project Name": "PRE17-023",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "1/27/17 15:18",
         "Status": "Under Review ",
         "Description": "Preliminary Review (Focused) to explore rezoning R-2 property CN, subdividing it into four lots, and constructing a three-story single-family attached (townhome) live/work unit on each lot.",
         "Planner": "Lea Simvoulakis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "PRE18-165",
         "APN": 26420065,
         "File Number": "PRE18-165",
         "Address": "323 JOSEFA ST SAN JOSE",
         "Project Name": "PRE18-165",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "8/20/18 15:55",
         "Status": "Under Review ",
         "Description": "Focused preliminary review for development to build 6-12, multi-unit on subject property, possibility of re-zoning to R-M, Applicant is also owner of adjacent property, 500 West San Carlos, possible lot line adjustment which is located in the Residential Neighborhood General Plan Land Use designation.",
         "Planner": "Angela Wang ",
         "DURATION": 43,
         "Year": 2018
      },
      {
         "PERMITID": "PRE19-039",
         "APN": 26426013,
         "File Number": "PRE19-039",
         "Address": "425 AUZERAIS AV SAN JOSE",
         "Project Name": "PRE19-039",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "2/27/19",
         "Status": "Under Review ",
         "Description": "Focused Preliminary Review to modify an approved Special Use Permit (SP17-016) to allow further parking reduction to 39 total stalls, elimination of one-story, and elevation changes. Located in the Downtown General Plan Land Use designation.",
         "Planner": "Ruth Cueto ",
         "DURATION": 0,
         "Year": 2019
      },
      {
         "PERMITID": "PRE19-039",
         "APN": 26426088,
         "File Number": "PRE19-039",
         "Address": "425 AUZERAIS AV SAN JOSE",
         "Project Name": "PRE19-039",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "2/27/19",
         "Status": "Under Review ",
         "Description": "Focused Preliminary Review to modify an approved Special Use Permit (SP17-016) to allow further parking reduction to 39 total stalls, elimination of one-story, and elevation changes. Located in the Downtown General Plan Land Use designation.",
         "Planner": "Ruth Cueto ",
         "DURATION": 0,
         "Year": 2019
      },
      {
         "PERMITID": "PRE19-052",
         "APN": 47219104,
         "File Number": "PRE19-052",
         "Address": "812 S 7TH ST SAN JOSE",
         "Project Name": "PRE19-052",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "3/25/19 15:13",
         "Status": "Under Review ",
         "Description": "Focused Preliminary Review to receive staff feedback regarding (3) options for developing/redeveloping a property that is currently occupied by (1) SFR which is located in the Residential Neighborhood General Plan Land Use Designation.",
         "Planner": "Michelle Flores ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "PRE07-093",
         "APN": 46701059,
         "File Number": "PRE07-093",
         "Address": "207 N 5TH ST SAN JOSE",
         "Project Name": "PRE07-093",
         "Application Type": "Prelim - Focused (Policy Review, No Plans) ",
         "Application Date": "3/7/07",
         "Status": "Withdrawn ",
         "Description": "Focused Review. SFDR in CG zone. Rezone to conform with GP designation of MDR. Increase square footage of existing nonconforming residence.  ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      }
   ],
   "Prelim - Focused (Single-Family) ": [
      {
         "PERMITID": "PRE03-062",
         "APN": 46724032,
         "File Number": "PRE03-062",
         "Address": "80 S 6TH ST SAN JOSE",
         "Project Name": "PRE03-062",
         "Application Type": "Prelim - Focused (Single-Family) ",
         "Application Date": "2/18/03",
         "Status": "Complete ",
         "Description": "To construct 2,281 sqft addition to an existing single family residential unit to convert to two units (duplex) in R-M Zoning District.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2003
      },
      {
         "PERMITID": "PRE05-189",
         "APN": 24946060,
         "File Number": "PRE05-189",
         "Address": "161 E JULIAN ST SAN JOSE",
         "Project Name": "PRE05-189",
         "Application Type": "Prelim - Focused (Single-Family) ",
         "Application Date": "4/22/05",
         "Status": "Complete ",
         "Description": "Proposed 2nd floor addition to an existing single-family house in the Hensley Historic District on a 3,049 square foot site in the CO Commercial Office zoning district. Would like to know what permits are required besides of SUP and HP, and to know how to modify the house facade to fit into the neighborhood.",
         "Planner": "Lesley Xavier ",
         "DURATION": 32,
         "Year": 2005
      },
      {
         "PERMITID": "PRE06-195",
         "APN": 25945070,
         "File Number": "PRE06-195",
         "Address": "183 SONOMA ST SAN JOSE",
         "Project Name": "PRE06-195",
         "Application Type": "Prelim - Focused (Single-Family) ",
         "Application Date": "6/1/06",
         "Status": "Complete ",
         "Description": "Preliminary Review for construction of a new single--family residence on an irregularly shaped parcel. The applicant wants to know front, side, and rear setbacks; maximum rear yard coverage for a detached two-car garage; and recommendations on the building design ",
         "Planner": "Michelle Stahlhut ",
         "DURATION": 54,
         "Year": 2006
      },
      {
         "PERMITID": "PRE06-253",
         "APN": 47224015,
         "File Number": "PRE06-253",
         "Address": "637 S 9TH ST SAN JOSE",
         "Project Name": "PRE06-253",
         "Application Type": "Prelim - Focused (Single-Family) ",
         "Application Date": "8/10/06",
         "Status": "Complete ",
         "Description": "Proposal to tear down existing single car garage and replace with two car garage. The house is on the Historic Resources Inventory (but is not a historic landmark). A Historic Resources Checklist was completed for this project - The House is a contributing structure, the accessory structure is not. Please see \"Comments\" for further information.  ",
         "Planner": "Lee Butler ",
         "DURATION": 75,
         "Year": 2006
      },
      {
         "PERMITID": "PRE15-149",
         "APN": 47231001,
         "File Number": "PRE15-149",
         "Address": "501 S 16TH ST SAN JOSE",
         "Project Name": "PRE15-149",
         "Application Type": "Prelim - Focused (Single-Family) ",
         "Application Date": "8/14/15 10:44",
         "Status": "Complete ",
         "Description": "Basic Preliminary Review of a historic single-family residence for a variance to increase the height, because natural grade dips towards the street. ",
         "Planner": "Rina Shah ",
         "DURATION": 42,
         "Year": 2015
      }
   ],
   "Private ": [
      {
         "PERMITID": "3-18792",
         "APN": 25940087,
         "File Number": "3-18792",
         "Address": "171 POST ST SAN JOSE",
         "Project Name": "HA14-023-01",
         "Application Type": "Private ",
         "Application Date": "4/29/15",
         "Status": "Implementation Phase ",
         "Description": "Site Development Permit for a high rise building with 182 residential units, 7,767sqaure feet of retail space, and a four-story parking garage connected to the adjacent existing garage in the DC zoning district on a 0.47 gross acre site",
         "Planner": "Ruth Cueto ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "H14-009",
         "APN": 46701118,
         "File Number": "H14-009",
         "Address": "10367 TRACT SAN JOSE",
         "Project Name": "3-06679",
         "Application Type": "Private ",
         "Application Date": "2/26/14",
         "Status": "Implementation Phase ",
         "Description": "Site Development Permit to allow an 18-story, 216 residential unit and 18,537 square feet of commercial use on 1.52 gross acre site",
         "Planner": "John Tu ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H17-027",
         "APN": 25940043,
         "File Number": "H17-027",
         "Address": "27 S 1ST ST SAN JOSE",
         "Project Name": "H17-027",
         "Application Type": "Private ",
         "Application Date": "6/15/17",
         "Status": "Implementation Phase ",
         "Description": "Site Development Permit to construct 414,067 SF, 22 story mixed use building including 342 residential units, retail and 17,628 commercial SF uses on a 0.57 gross acre site.",
         "Planner": "Rina Shah ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "HA14-009-02",
         "APN": 46701118,
         "File Number": "HA14-009-02",
         "Address": "252 N 1ST ST SAN JOSE",
         "Project Name": "HA14-009-02 - Parkview Towers",
         "Application Type": "Private ",
         "Application Date": "1/17/19 14:51",
         "Status": "Implementation Phase ",
         "Description": "Site Development Permit Amendment to allow one 19-story high rise tower with 154 units, one 12-story high rise tower with 62 units, 5 townhouses, up to 18,000 square feet of commercial, and rehabilitation of a vacant church through Historic Preservation Permit with all amenities and below grade parking and Saturday construction hours from 8:00 a.m. to 5:00 p.m. and up to six occurrences of 24-hour construction staging and concrete pouring on a 1.52 gross acre site",
         "Planner": "Emily Lipoma ",
         "DURATION": 0,
         "Year": 2019
      },
      {
         "PERMITID": "SP11-021",
         "APN": 25932005,
         "File Number": "SP11-021",
         "Address": "175 N SAN PEDRO ST SAN JOSE",
         "Project Name": "3-07662",
         "Application Type": "Private ",
         "Application Date": "5/8/12",
         "Status": "Implementation Phase ",
         "Description": "Special Use Permit to allow the demolition of an existing nightclub and the construction of a surface parking lot in the DC Downtown Commercial Zoning District on a 0.20 gross acre site",
         "Planner": "Jenny Nusbaum ",
         "DURATION": 0,
         "Year": 2012
      },
      {
         "PERMITID": "3-16866",
         "APN": 26426006,
         "File Number": "3-16866",
         "Address": "341 DELMAS AV SAN JOSE",
         "Project Name": "H15-046",
         "Application Type": "Private ",
         "Application Date": "3/22/16",
         "Status": "Planning Phase ",
         "Description": "Site Development Permit to allow the demolition of three single-family residences and associated accessory buildings, the removal of five ordinance sized trees, and the construction of a five-story multi-family residential building with 120 units on a 0.8-gross acre site",
         "Planner": "Ruth Cueto ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "3-16866",
         "APN": 26426008,
         "File Number": "3-16866",
         "Address": "341 DELMAS AV SAN JOSE",
         "Project Name": "H15-046",
         "Application Type": "Private ",
         "Application Date": "3/22/16",
         "Status": "Planning Phase ",
         "Description": "Site Development Permit to allow the demolition of three single-family residences and associated accessory buildings, the removal of five ordinance sized trees, and the construction of a five-story multi-family residential building with 120 units on a 0.8-gross acre site",
         "Planner": "Ruth Cueto ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "3-18300",
         "APN": 46721018,
         "File Number": "3-18300",
         "Address": "66 N 1ST ST SAN JOSE",
         "Project Name": "H14-010",
         "Application Type": "Private ",
         "Application Date": "1/15/15",
         "Status": "Planning Phase ",
         "Description": "Site Development Permit to allow the demolition of six commercial buildings, removal of one ordinance-size tree, and the construction of a six- to seven-story mixed-used building consisting of up to 190 residential units, 10,835 square feet of commercial, and an associated parking garage on a 1.4 gross acre site",
         "Planner": "Ruth Cueto ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "3-18300",
         "APN": 46721030,
         "File Number": "3-18300",
         "Address": "66 N 1ST ST SAN JOSE",
         "Project Name": "H14-010",
         "Application Type": "Private ",
         "Application Date": "1/15/15",
         "Status": "Planning Phase ",
         "Description": "Site Development Permit to allow the demolition of six commercial buildings, removal of one ordinance-size tree, and the construction of a six- to seven-story mixed-used building consisting of up to 190 residential units, 10,835 square feet of commercial, and an associated parking garage on a 1.4 gross acre site",
         "Planner": "Ruth Cueto ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "3-18300",
         "APN": 46721038,
         "File Number": "3-18300",
         "Address": "66 N 1ST ST SAN JOSE",
         "Project Name": "H14-010",
         "Application Type": "Private ",
         "Application Date": "1/15/15",
         "Status": "Planning Phase ",
         "Description": "Site Development Permit to allow the demolition of six commercial buildings, removal of one ordinance-size tree, and the construction of a six- to seven-story mixed-used building consisting of up to 190 residential units, 10,835 square feet of commercial, and an associated parking garage on a 1.4 gross acre site",
         "Planner": "Ruth Cueto ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "3-18826",
         "APN": 25932079,
         "File Number": "3-18826",
         "Address": "0 TERRAINE ST SAN JOSE",
         "Project Name": "H14-004",
         "Application Type": "Private ",
         "Application Date": "1/14/14",
         "Status": "Planning Phase ",
         "Description": "Site Development Permit to construct 14 attached single-family residences on a 0.33 gross acre site.",
         "Planner": "Ruth Cueto ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "3-22145",
         "APN": 46746072,
         "File Number": "3-22145",
         "Address": "88 E SAN CARLOS ST SAN JOSE",
         "Project Name": "H16-036",
         "Application Type": "Private ",
         "Application Date": "6/8/17",
         "Status": "Planning Phase ",
         "Description": "Site Development Permit to construct a 19-story mixed-use development with 260 multi-family residences and 14,800 square feet of commercial uses on a 1.45 gross acre site",
         "Planner": "Ruth Cueto ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "H15-049",
         "APN": 26415015,
         "File Number": "H15-049",
         "Address": "365 ROYAL AV SAN JOSE",
         "Project Name": "3-06533",
         "Application Type": "Private ",
         "Application Date": "7/7/16",
         "Status": "Planning Phase ",
         "Description": "Site Development Permit to allow minor modifications to an existing building, including replacement of the façade, construction of a rear loading dock, removal of an existing parking lot, and the installation of new pavers, landscaping and other improvements on a 2.785-gross acre site",
         "Planner": "Tracy Tam ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "H15-055",
         "APN": 46719056,
         "File Number": "H15-055",
         "Address": "73 N 6TH ST SAN JOSE",
         "Project Name": "3-18980",
         "Application Type": "Private ",
         "Application Date": "7/6/16",
         "Status": "Planning Phase ",
         "Description": "Site Development Permit to allow the demolition of all existing buildings and a portion of an existing parking lot and the construction of a ten-story building, 197 residential unit mixed use building with 2,366 square feet of commercial space on a 0.28-gross acre site.",
         "Planner": "Tracy Tam ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "H15-055",
         "APN": 46719057,
         "File Number": "H15-055",
         "Address": "73 N 6TH ST SAN JOSE",
         "Project Name": "3-18980",
         "Application Type": "Private ",
         "Application Date": "7/6/16",
         "Status": "Planning Phase ",
         "Description": "Site Development Permit to allow the demolition of all existing buildings and a portion of an existing parking lot and the construction of a ten-story building, 197 residential unit mixed use building with 2,366 square feet of commercial space on a 0.28-gross acre site.",
         "Planner": "Tracy Tam ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "H15-055",
         "APN": 46719059,
         "File Number": "H15-055",
         "Address": "73 N 6TH ST SAN JOSE",
         "Project Name": "3-18980",
         "Application Type": "Private ",
         "Application Date": "7/6/16",
         "Status": "Planning Phase ",
         "Description": "Site Development Permit to allow the demolition of all existing buildings and a portion of an existing parking lot and the construction of a ten-story building, 197 residential unit mixed use building with 2,366 square feet of commercial space on a 0.28-gross acre site.",
         "Planner": "Tracy Tam ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "H16-018",
         "APN": 25939116,
         "File Number": "H16-018",
         "Address": "333 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "3-03401",
         "Application Type": "Private ",
         "Application Date": "10/21/16",
         "Status": "Planning Phase ",
         "Description": "Site Development Permit to allow the demolition of an existing 30,659-square foot building, the construction of a new 1,513,941-square foot 18-story building with up to 700,000 square feet of office and retail uses, and the removal of three ordinance-size trees and eleven street trees on a 2.50-gross acre site",
         "Planner": "Tracy Tam ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "H16-018",
         "APN": 25939118,
         "File Number": "H16-018",
         "Address": "333 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "3-03401",
         "Application Type": "Private ",
         "Application Date": "10/21/16",
         "Status": "Planning Phase ",
         "Description": "Site Development Permit to allow the demolition of an existing 30,659-square foot building, the construction of a new 1,513,941-square foot 18-story building with up to 700,000 square feet of office and retail uses, and the removal of three ordinance-size trees and eleven street trees on a 2.50-gross acre site",
         "Planner": "Tracy Tam ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "H17-004",
         "APN": 46747058,
         "File Number": "H17-004",
         "Address": "439 S 4TH ST SAN JOSE",
         "Project Name": "3-18334",
         "Application Type": "Private ",
         "Application Date": "4/4/17",
         "Status": "Planning Phase ",
         "Description": "Site Development Permit to allow the demolition of an existing residence and a three-story apartment building for the construction of an 11-story mixed use building consisting of 101 residential units, approximately 4,305 square feet of commercial use and approximately 7,261 square feet of office space on a 0.50 gross acre site.",
         "Planner": "Emily Lipoma ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "H17-004",
         "APN": 46747096,
         "File Number": "H17-004",
         "Address": "439 S 4TH ST SAN JOSE",
         "Project Name": "3-18334",
         "Application Type": "Private ",
         "Application Date": "4/4/17",
         "Status": "Planning Phase ",
         "Description": "Site Development Permit to allow the demolition of an existing residence and a three-story apartment building for the construction of an 11-story mixed use building consisting of 101 residential units, approximately 4,305 square feet of commercial use and approximately 7,261 square feet of office space on a 0.50 gross acre site.",
         "Planner": "Emily Lipoma ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "H18-025",
         "APN": 25935026,
         "File Number": "H18-025",
         "Address": "51 NOTRE DAME AV SAN JOSE",
         "Project Name": " ",
         "Application Type": "Private ",
         "Application Date": "6/7/18",
         "Status": "Planning Phase ",
         "Description": "Site Development Permit to allow demolition of an existing building and construct a new 18 story 70,000 square foot office space. 220 residential units and approximately 4,000 square feet street level commercial space on a 0.68 gross acre site",
         "Planner": "Ruth Cueto ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "H18-025",
         "APN": 25935027,
         "File Number": "H18-025",
         "Address": "51 NOTRE DAME AV SAN JOSE",
         "Project Name": " ",
         "Application Type": "Private ",
         "Application Date": "6/7/18",
         "Status": "Planning Phase ",
         "Description": "Site Development Permit to allow demolition of an existing building and construct a new 18 story 70,000 square foot office space. 220 residential units and approximately 4,000 square feet street level commercial space on a 0.68 gross acre site",
         "Planner": "Ruth Cueto ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "H18-025",
         "APN": 25935032,
         "File Number": "H18-025",
         "Address": "51 NOTRE DAME AV SAN JOSE",
         "Project Name": " ",
         "Application Type": "Private ",
         "Application Date": "6/7/18",
         "Status": "Planning Phase ",
         "Description": "Site Development Permit to allow demolition of an existing building and construct a new 18 story 70,000 square foot office space. 220 residential units and approximately 4,000 square feet street level commercial space on a 0.68 gross acre site",
         "Planner": "Ruth Cueto ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "H18-025",
         "APN": 25935033,
         "File Number": "H18-025",
         "Address": "51 NOTRE DAME AV SAN JOSE",
         "Project Name": " ",
         "Application Type": "Private ",
         "Application Date": "6/7/18",
         "Status": "Planning Phase ",
         "Description": "Site Development Permit to allow demolition of an existing building and construct a new 18 story 70,000 square foot office space. 220 residential units and approximately 4,000 square feet street level commercial space on a 0.68 gross acre site",
         "Planner": "Ruth Cueto ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "H18-030",
         "APN": 47226002,
         "File Number": "H18-030",
         "Address": "40 E WILLIAM ST SAN JOSE",
         "Project Name": " ",
         "Application Type": "Private ",
         "Application Date": "6/28/18",
         "Status": "Planning Phase ",
         "Description": "Site Development Permit to demolish existing buildings and construct a new 41,500 square foot mixed-use building with 3 towers (26 stories, 25 stories, and 24 stories) with a total of 667 residential units, performing art space and 4 levels of below grade parking on a 1.632-gross acre site",
         "Planner": "Ruth Cueto ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "H18-030",
         "APN": 47226003,
         "File Number": "H18-030",
         "Address": "40 E WILLIAM ST SAN JOSE",
         "Project Name": " ",
         "Application Type": "Private ",
         "Application Date": "6/28/18",
         "Status": "Planning Phase ",
         "Description": "Site Development Permit to demolish existing buildings and construct a new 41,500 square foot mixed-use building with 3 towers (26 stories, 25 stories, and 24 stories) with a total of 667 residential units, performing art space and 4 levels of below grade parking on a 1.632-gross acre site",
         "Planner": "Ruth Cueto ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "H18-030",
         "APN": 47226004,
         "File Number": "H18-030",
         "Address": "40 E WILLIAM ST SAN JOSE",
         "Project Name": " ",
         "Application Type": "Private ",
         "Application Date": "6/28/18",
         "Status": "Planning Phase ",
         "Description": "Site Development Permit to demolish existing buildings and construct a new 41,500 square foot mixed-use building with 3 towers (26 stories, 25 stories, and 24 stories) with a total of 667 residential units, performing art space and 4 levels of below grade parking on a 1.632-gross acre site",
         "Planner": "Ruth Cueto ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "H18-030",
         "APN": 47226007,
         "File Number": "H18-030",
         "Address": "40 E WILLIAM ST SAN JOSE",
         "Project Name": " ",
         "Application Type": "Private ",
         "Application Date": "6/28/18",
         "Status": "Planning Phase ",
         "Description": "Site Development Permit to demolish existing buildings and construct a new 41,500 square foot mixed-use building with 3 towers (26 stories, 25 stories, and 24 stories) with a total of 667 residential units, performing art space and 4 levels of below grade parking on a 1.632-gross acre site",
         "Planner": "Ruth Cueto ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "H18-030",
         "APN": 47226034,
         "File Number": "H18-030",
         "Address": "40 E WILLIAM ST SAN JOSE",
         "Project Name": " ",
         "Application Type": "Private ",
         "Application Date": "6/28/18",
         "Status": "Planning Phase ",
         "Description": "Site Development Permit to demolish existing buildings and construct a new 41,500 square foot mixed-use building with 3 towers (26 stories, 25 stories, and 24 stories) with a total of 667 residential units, performing art space and 4 levels of below grade parking on a 1.632-gross acre site",
         "Planner": "Ruth Cueto ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "H18-030",
         "APN": 47226035,
         "File Number": "H18-030",
         "Address": "40 E WILLIAM ST SAN JOSE",
         "Project Name": " ",
         "Application Type": "Private ",
         "Application Date": "6/28/18",
         "Status": "Planning Phase ",
         "Description": "Site Development Permit to demolish existing buildings and construct a new 41,500 square foot mixed-use building with 3 towers (26 stories, 25 stories, and 24 stories) with a total of 667 residential units, performing art space and 4 levels of below grade parking on a 1.632-gross acre site",
         "Planner": "Ruth Cueto ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "H18-030",
         "APN": 47226085,
         "File Number": "H18-030",
         "Address": "40 E WILLIAM ST SAN JOSE",
         "Project Name": " ",
         "Application Type": "Private ",
         "Application Date": "6/28/18",
         "Status": "Planning Phase ",
         "Description": "Site Development Permit to demolish existing buildings and construct a new 41,500 square foot mixed-use building with 3 towers (26 stories, 25 stories, and 24 stories) with a total of 667 residential units, performing art space and 4 levels of below grade parking on a 1.632-gross acre site",
         "Planner": "Ruth Cueto ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "H18-033",
         "APN": 47226070,
         "File Number": "H18-033",
         "Address": "605 S 2ND ST SAN JOSE",
         "Project Name": "605 SOUTH 2ND STREET",
         "Application Type": "Private ",
         "Application Date": "7/30/18",
         "Status": "Planning Phase ",
         "Description": "Site Development Permit to allow the construction of a 7-story hotel with 106 guest rooms and two levels of below grade parking (39 parking spaces) on a 0.3-gross acre site",
         "Planner": "Ruth Cueto ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "PD09-020",
         "APN": 26420121,
         "File Number": "PD09-020",
         "Address": "395 BIRD AV SAN JOSE",
         "Project Name": "3-15696",
         "Application Type": "Private ",
         "Application Date": "2/8/11",
         "Status": "Planning Phase ",
         "Description": "Planned Development Permit to demolish an existing gas station building and construct a new mini-mart, car wash and office building on a 0.6 gross acre site",
         "Planner": "Licinia McMorrow ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "PD14-052",
         "APN": 46701120,
         "File Number": "PD14-052",
         "Address": "298 N 4TH ST SAN JOSE",
         "Project Name": " ",
         "Application Type": "Private ",
         "Application Date": "11/25/14",
         "Status": "Planning Phase ",
         "Description": "Planned Development Permit to allow a 13-unit mixed-use residential units on .44 gross acre site",
         "Planner": "Lea Simvoulakis ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "PD15-061",
         "APN": 25938039,
         "File Number": "PD15-061",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "3-10952",
         "Application Type": "Private ",
         "Application Date": "4/29/16",
         "Status": "Planning Phase ",
         "Description": "A Planned Development Permit to allow the construction of a mixed use development with up to 1.04 million square feet for office/retail and up to 325 multi-family attached residences on a 8.93 gross acre site.",
         "Planner": "Lea Simvoulakis ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "PD15-061",
         "APN": 25938041,
         "File Number": "PD15-061",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "3-10952",
         "Application Type": "Private ",
         "Application Date": "4/29/16",
         "Status": "Planning Phase ",
         "Description": "A Planned Development Permit to allow the construction of a mixed use development with up to 1.04 million square feet for office/retail and up to 325 multi-family attached residences on a 8.93 gross acre site.",
         "Planner": "Lea Simvoulakis ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "PD15-061",
         "APN": 25938109,
         "File Number": "PD15-061",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "3-10952",
         "Application Type": "Private ",
         "Application Date": "4/29/16",
         "Status": "Planning Phase ",
         "Description": "A Planned Development Permit to allow the construction of a mixed use development with up to 1.04 million square feet for office/retail and up to 325 multi-family attached residences on a 8.93 gross acre site.",
         "Planner": "Lea Simvoulakis ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "PD15-061",
         "APN": 25938110,
         "File Number": "PD15-061",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "3-10952",
         "Application Type": "Private ",
         "Application Date": "4/29/16",
         "Status": "Planning Phase ",
         "Description": "A Planned Development Permit to allow the construction of a mixed use development with up to 1.04 million square feet for office/retail and up to 325 multi-family attached residences on a 8.93 gross acre site.",
         "Planner": "Lea Simvoulakis ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "PD15-061",
         "APN": 25938128,
         "File Number": "PD15-061",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "3-10952",
         "Application Type": "Private ",
         "Application Date": "4/29/16",
         "Status": "Planning Phase ",
         "Description": "A Planned Development Permit to allow the construction of a mixed use development with up to 1.04 million square feet for office/retail and up to 325 multi-family attached residences on a 8.93 gross acre site.",
         "Planner": "Lea Simvoulakis ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "PD15-061",
         "APN": 25938145,
         "File Number": "PD15-061",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "3-10952",
         "Application Type": "Private ",
         "Application Date": "4/29/16",
         "Status": "Planning Phase ",
         "Description": "A Planned Development Permit to allow the construction of a mixed use development with up to 1.04 million square feet for office/retail and up to 325 multi-family attached residences on a 8.93 gross acre site.",
         "Planner": "Lea Simvoulakis ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "PD17-003",
         "APN": 47217042,
         "File Number": "PD17-003",
         "Address": "895 S 2ND ST SAN JOSE",
         "Project Name": "3-18394",
         "Application Type": "Private ",
         "Application Date": "4/4/17",
         "Status": "Planning Phase ",
         "Description": "Planned Development Permit to allow the construction of 3 single family townhomes on a 0.20 gross acre site",
         "Planner": "Avril Baty ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "PDC09-019",
         "APN": 47228054,
         "File Number": "PDC09-019",
         "Address": "346 E WILLIAM ST SAN JOSE",
         "Project Name": "3-09441",
         "Application Type": "Private ",
         "Application Date": "2/4/13",
         "Status": "Planning Phase ",
         "Description": "A Planned Development Rezoning to allow for the development of a four-story, mixed use project with (1) up to 28 attached residential units, (2) 1,780 square feet of ground floor commercial space, (3) two levels of parking, and (4) the conversion of one single-family residence to a private community center, on a 0.57 gross acre site",
         "Planner": "Darryl Boyd ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "PDC09-019",
         "APN": 47228055,
         "File Number": "PDC09-019",
         "Address": "346 E WILLIAM ST SAN JOSE",
         "Project Name": "3-09441",
         "Application Type": "Private ",
         "Application Date": "2/4/13",
         "Status": "Planning Phase ",
         "Description": "A Planned Development Rezoning to allow for the development of a four-story, mixed use project with (1) up to 28 attached residential units, (2) 1,780 square feet of ground floor commercial space, (3) two levels of parking, and (4) the conversion of one single-family residence to a private community center, on a 0.57 gross acre site",
         "Planner": "Darryl Boyd ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "PDC09-019",
         "APN": 47228056,
         "File Number": "PDC09-019",
         "Address": "346 E WILLIAM ST SAN JOSE",
         "Project Name": "3-09441",
         "Application Type": "Private ",
         "Application Date": "2/4/13",
         "Status": "Planning Phase ",
         "Description": "A Planned Development Rezoning to allow for the development of a four-story, mixed use project with (1) up to 28 attached residential units, (2) 1,780 square feet of ground floor commercial space, (3) two levels of parking, and (4) the conversion of one single-family residence to a private community center, on a 0.57 gross acre site",
         "Planner": "Darryl Boyd ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "PDC15-032",
         "APN": 47226086,
         "File Number": "PDC15-032",
         "Address": "596 S 2ND ST SAN JOSE",
         "Project Name": "3-07558",
         "Application Type": "Private ",
         "Application Date": "7/16/15",
         "Status": "Planning Phase ",
         "Description": "Planned Development Rezoning from the CG Commercial General Zoning District and R-M Multiple Residence Zoning District to the CG(PD) Planned Development Zoning District to allow the expansion of an existing private school (Notre Dame High School) with up to four new buildings to accommodate a total of ___ students on a 3.43-gross acre site",
         "Planner": "David Fong ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "SP16-010",
         "APN": 25946046,
         "File Number": "SP16-010",
         "Address": "267 DELMAS AV SAN JOSE",
         "Project Name": "3-22034",
         "Application Type": "Private ",
         "Application Date": "7/6/16",
         "Status": "Planning Phase ",
         "Description": "Special Use Permit to allow demolition of an approximately 1,550 square feet commercial structure, the removal of two ordinance-sized trees, the construction of a 5-story mixed-use development with 36 residential units, and approximately 1,600 square feet commercial condominium an approximately 0.47 gross acre site",
         "Planner": "Tracy Tam ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "SP16-010",
         "APN": 25946048,
         "File Number": "SP16-010",
         "Address": "267 DELMAS AV SAN JOSE",
         "Project Name": "3-22034",
         "Application Type": "Private ",
         "Application Date": "7/6/16",
         "Status": "Planning Phase ",
         "Description": "Special Use Permit to allow demolition of an approximately 1,550 square feet commercial structure, the removal of two ordinance-sized trees, the construction of a 5-story mixed-use development with 36 residential units, and approximately 1,600 square feet commercial condominium an approximately 0.47 gross acre site",
         "Planner": "Tracy Tam ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "SP16-016",
         "APN": 25946040,
         "File Number": "SP16-016",
         "Address": "201 DELMAS AV SAN JOSE",
         "Project Name": "3-16962",
         "Application Type": "Private ",
         "Application Date": "5/5/16",
         "Status": "Planning Phase ",
         "Description": "Special Use Permit to allow the demolition of an existing 3,700-square foot office building, the removal of six ordinance-sized trees, and the construction of a 4-and-5-story development with up to 123 residential units, one level of underground parking, and approximately 1,000 square feet of ground-floor commercial space on a 1.75 gross acre site",
         "Planner": "Tracy Tam ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "SP16-016",
         "APN": 25946044,
         "File Number": "SP16-016",
         "Address": "201 DELMAS AV SAN JOSE",
         "Project Name": "3-16962",
         "Application Type": "Private ",
         "Application Date": "5/5/16",
         "Status": "Planning Phase ",
         "Description": "Special Use Permit to allow the demolition of an existing 3,700-square foot office building, the removal of six ordinance-sized trees, and the construction of a 4-and-5-story development with up to 123 residential units, one level of underground parking, and approximately 1,000 square feet of ground-floor commercial space on a 1.75 gross acre site",
         "Planner": "Tracy Tam ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "SP16-016",
         "APN": 25946045,
         "File Number": "SP16-016",
         "Address": "201 DELMAS AV SAN JOSE",
         "Project Name": "3-16962",
         "Application Type": "Private ",
         "Application Date": "5/5/16",
         "Status": "Planning Phase ",
         "Description": "Special Use Permit to allow the demolition of an existing 3,700-square foot office building, the removal of six ordinance-sized trees, and the construction of a 4-and-5-story development with up to 123 residential units, one level of underground parking, and approximately 1,000 square feet of ground-floor commercial space on a 1.75 gross acre site",
         "Planner": "Tracy Tam ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "SP16-016",
         "APN": 25946056,
         "File Number": "SP16-016",
         "Address": "201 DELMAS AV SAN JOSE",
         "Project Name": "3-16962",
         "Application Type": "Private ",
         "Application Date": "5/5/16",
         "Status": "Planning Phase ",
         "Description": "Special Use Permit to allow the demolition of an existing 3,700-square foot office building, the removal of six ordinance-sized trees, and the construction of a 4-and-5-story development with up to 123 residential units, one level of underground parking, and approximately 1,000 square feet of ground-floor commercial space on a 1.75 gross acre site",
         "Planner": "Tracy Tam ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "SP16-016",
         "APN": 25946057,
         "File Number": "SP16-016",
         "Address": "201 DELMAS AV SAN JOSE",
         "Project Name": "3-16962",
         "Application Type": "Private ",
         "Application Date": "5/5/16",
         "Status": "Planning Phase ",
         "Description": "Special Use Permit to allow the demolition of an existing 3,700-square foot office building, the removal of six ordinance-sized trees, and the construction of a 4-and-5-story development with up to 123 residential units, one level of underground parking, and approximately 1,000 square feet of ground-floor commercial space on a 1.75 gross acre site",
         "Planner": "Tracy Tam ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "SP16-016",
         "APN": 25946058,
         "File Number": "SP16-016",
         "Address": "201 DELMAS AV SAN JOSE",
         "Project Name": "3-16962",
         "Application Type": "Private ",
         "Application Date": "5/5/16",
         "Status": "Planning Phase ",
         "Description": "Special Use Permit to allow the demolition of an existing 3,700-square foot office building, the removal of six ordinance-sized trees, and the construction of a 4-and-5-story development with up to 123 residential units, one level of underground parking, and approximately 1,000 square feet of ground-floor commercial space on a 1.75 gross acre site",
         "Planner": "Tracy Tam ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "SP16-016",
         "APN": 25946090,
         "File Number": "SP16-016",
         "Address": "201 DELMAS AV SAN JOSE",
         "Project Name": "3-16962",
         "Application Type": "Private ",
         "Application Date": "5/5/16",
         "Status": "Planning Phase ",
         "Description": "Special Use Permit to allow the demolition of an existing 3,700-square foot office building, the removal of six ordinance-sized trees, and the construction of a 4-and-5-story development with up to 123 residential units, one level of underground parking, and approximately 1,000 square feet of ground-floor commercial space on a 1.75 gross acre site",
         "Planner": "Tracy Tam ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "SP16-016",
         "APN": 25946109,
         "File Number": "SP16-016",
         "Address": "201 DELMAS AV SAN JOSE",
         "Project Name": "3-16962",
         "Application Type": "Private ",
         "Application Date": "5/5/16",
         "Status": "Planning Phase ",
         "Description": "Special Use Permit to allow the demolition of an existing 3,700-square foot office building, the removal of six ordinance-sized trees, and the construction of a 4-and-5-story development with up to 123 residential units, one level of underground parking, and approximately 1,000 square feet of ground-floor commercial space on a 1.75 gross acre site",
         "Planner": "Tracy Tam ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "SP16-021",
         "APN": 25940012,
         "File Number": "SP16-021",
         "Address": "70 S ALMADEN AV SAN JOSE",
         "Project Name": "SP16-021",
         "Application Type": "Private ",
         "Application Date": "6/20/17",
         "Status": "Planning Phase ",
         "Description": "Special Use Permit to allow the construction of 781 residential units with 20,000 square feet of ground floor retail in two (2) high rise towers with 23 to 24 stories including four (4) levels of below-grade parking on a 1.63 gross acre site",
         "Planner": "Jennifer Piozet ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "SP16-021",
         "APN": 25940014,
         "File Number": "SP16-021",
         "Address": "70 S ALMADEN AV SAN JOSE",
         "Project Name": "SP16-021",
         "Application Type": "Private ",
         "Application Date": "6/20/17",
         "Status": "Planning Phase ",
         "Description": "Special Use Permit to allow the construction of 781 residential units with 20,000 square feet of ground floor retail in two (2) high rise towers with 23 to 24 stories including four (4) levels of below-grade parking on a 1.63 gross acre site",
         "Planner": "Jennifer Piozet ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "SP16-021",
         "APN": 25940015,
         "File Number": "SP16-021",
         "Address": "70 S ALMADEN AV SAN JOSE",
         "Project Name": "SP16-021",
         "Application Type": "Private ",
         "Application Date": "6/20/17",
         "Status": "Planning Phase ",
         "Description": "Special Use Permit to allow the construction of 781 residential units with 20,000 square feet of ground floor retail in two (2) high rise towers with 23 to 24 stories including four (4) levels of below-grade parking on a 1.63 gross acre site",
         "Planner": "Jennifer Piozet ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "SP16-021",
         "APN": 25940016,
         "File Number": "SP16-021",
         "Address": "70 S ALMADEN AV SAN JOSE",
         "Project Name": "SP16-021",
         "Application Type": "Private ",
         "Application Date": "6/20/17",
         "Status": "Planning Phase ",
         "Description": "Special Use Permit to allow the construction of 781 residential units with 20,000 square feet of ground floor retail in two (2) high rise towers with 23 to 24 stories including four (4) levels of below-grade parking on a 1.63 gross acre site",
         "Planner": "Jennifer Piozet ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "SP17-015",
         "APN": 46720074,
         "File Number": "SP17-015",
         "Address": "117 N 5TH ST SAN JOSE",
         "Project Name": "3-04091",
         "Application Type": "Private ",
         "Application Date": "9/13/17",
         "Status": "Planning Phase ",
         "Description": "Special Use Permit to construct a 4-story, 28-unit multi-family residential building on a 0.24 gross acre site",
         "Planner": "Emily Lipoma ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "SP17-016",
         "APN": 26426013,
         "File Number": "SP17-016",
         "Address": "425 AUZERAIS AV SAN JOSE",
         "Project Name": "3-24032",
         "Application Type": "Private ",
         "Application Date": "4/25/18",
         "Status": "Planning Phase ",
         "Description": "Special Use Permit to allow demolition of seven existing structures totaling approximately 8,193 square feet, the removal of two ordinance sized trees, the construction of a six-story podium building with 130 residential units, totaling approximately 135,599 square feet, the utilization of Transportation Demand Management (TDM) measures to reduce the parking requirements by 50%, and an alternative parking design (carlifts) on an approximately 1.02 gross acre site",
         "Planner": "Emily Lipoma ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "SP17-016",
         "APN": 26426088,
         "File Number": "SP17-016",
         "Address": "425 AUZERAIS AV SAN JOSE",
         "Project Name": "3-24032",
         "Application Type": "Private ",
         "Application Date": "4/25/18",
         "Status": "Planning Phase ",
         "Description": "Special Use Permit to allow demolition of seven existing structures totaling approximately 8,193 square feet, the removal of two ordinance sized trees, the construction of a six-story podium building with 130 residential units, totaling approximately 135,599 square feet, the utilization of Transportation Demand Management (TDM) measures to reduce the parking requirements by 50%, and an alternative parking design (carlifts) on an approximately 1.02 gross acre site",
         "Planner": "Emily Lipoma ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "SP18-016",
         "APN": 25940043,
         "File Number": "SP18-016",
         "Address": "27 S 1ST ST SAN JOSE",
         "Project Name": "27 SOUTH 1ST STREET",
         "Application Type": "Private ",
         "Application Date": "3/29/19 17:01",
         "Status": "Planning Phase ",
         "Description": " ",
         "Planner": "Ruth Cueto ",
         "DURATION": 0,
         "Year": 2019
      },
      {
         "PERMITID": "3-10875",
         "APN": 46719078,
         "File Number": "3-10875",
         "Address": "24 N 5TH ST SAN JOSE",
         "Project Name": "H10-018",
         "Application Type": "Private ",
         "Application Date": "10/1/10",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to allow the construction of a 26,067 square foot church, community center, child care center, classrooms and offices on a 0.40 gross acre site.",
         "Planner": "Ruth Cueto ",
         "DURATION": 0,
         "Year": 2010
      },
      {
         "PERMITID": "3-14915",
         "APN": 25939111,
         "File Number": "3-14915",
         "Address": "350 W SANTA CLARA ST SAN JOSE",
         "Project Name": "H13-013",
         "Application Type": "Private ",
         "Application Date": "3/22/13",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Application to allow a 98,899 square feet commercial hotel in the DC Downtown Core Zoning District on .54 gross acre site.",
         "Planner": "Ruth Cueto ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "3-18739",
         "APN": 46757084,
         "File Number": "3-18739",
         "Address": "51 N 6TH ST SAN JOSE",
         "Project Name": "H13-023",
         "Application Type": "Private ",
         "Application Date": "1/15/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to allow the demolition of an existing parking structure for Vintage Tower and construction of 119 multi-family apartment units (intended for students) in five residential stories above two stories of at-grade parking on a 1.09 gross acre site. The proposed building will accommodate the required parking for the new residents and replacement parking for Vintage Tower.",
         "Planner": "Ruth Cueto ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471001,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471006,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471007,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471009,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471010,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471011,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471013,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471014,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471017,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471018,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471019,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471020,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471021,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471022,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471023,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471025,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471026,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471028,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471029,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471030,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471031,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471034,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471035,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471036,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471037,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471038,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471039,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471040,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471041,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471042,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471043,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471044,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471045,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471046,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471047,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471049,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471050,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471051,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471052,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471053,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471054,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471055,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471056,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471057,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471059,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471060,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471061,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471062,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471063,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471064,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471065,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471066,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471068,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471069,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471070,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471071,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471072,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471073,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471074,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471075,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471077,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471078,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471080,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471082,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471083,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471084,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471085,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471086,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471087,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471088,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471089,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471091,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471092,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471093,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471094,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471095,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471096,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471097,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471100,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471102,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471103,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471104,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471105,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471106,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471107,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471108,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471109,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471110,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471111,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471112,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471113,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471114,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471115,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471116,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471117,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471118,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471119,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471121,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471122,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471123,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471124,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471125,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471127,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471128,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471130,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471131,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471132,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471133,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471134,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471135,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471136,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471137,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471138,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471140,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471141,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471142,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471143,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471144,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471145,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471146,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471147,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471148,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471149,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471150,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471151,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471152,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471153,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471154,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471155,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471156,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471157,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471158,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471159,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471160,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471161,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471162,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471163,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471164,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471165,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471166,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471167,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471168,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471169,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471171,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471172,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471173,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471174,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471175,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471177,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471178,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471179,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471182,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471184,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471185,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471186,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471187,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471188,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471189,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471191,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471192,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471193,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471195,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471196,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471197,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471198,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471199,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471200,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471201,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471202,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471203,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471204,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471205,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471207,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471208,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471209,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471210,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471211,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471212,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471213,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471214,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471215,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471216,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471217,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H05-037",
         "APN": 26471218,
         "File Number": "3-06653",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "H05-037",
         "Application Type": "Private ",
         "Application Date": "10/2/14",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to construct a residential and commercial building for a total of approximately 505,000 square feet, which includes approximately 203 attached residential units and 11,180 square feet of commercial uses in a 23-story high-rise structure, on a 1.02 gross acre site. (APN in Win2data and MapInfo is 264-29-117 as of 10/25/06-DE)",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H12-022",
         "APN": 25940093,
         "File Number": "3-06182",
         "Address": "1 S MARKET ST SAN JOSE",
         "Project Name": "H12-022",
         "Application Type": "Private ",
         "Application Date": "4/17/13",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to allow a 23-story mixed-use building consisting of up to 312 residential units, 6,000 square feet of ground-floor retail, and an associated parking garage on a 0.97 gross acre site",
         "Planner": "Ben Corrales ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "H13-008",
         "APN": 26415065,
         "File Number": "H13-008",
         "Address": "720 W SAN CARLOS ST SAN JOSE",
         "Project Name": "3-06533",
         "Application Type": "Private ",
         "Application Date": "6/12/13",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit to allow construction of an approximately 49,000 square foot commercial building, and demolition of an existing 29,013 square foot metal storage building in the CIC Combined Industrial /Commercial Zoning District",
         "Planner": "Ben Corrales ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "HA05-051-01",
         "APN": 25939115,
         "File Number": "HA05-051-01",
         "Address": "99 ALMADEN BL SAN JOSE",
         "Project Name": "3-03402",
         "Application Type": "Private ",
         "Application Date": "3/13/17",
         "Status": "Post-Construction Phase ",
         "Description": "Site Development Permit Amendment to allow the installation of a drive aisle and eight (8) loading spaces for customer drop-off and pick up; and improvement of two outdoor amenity spaces which includes the construction of shade structures, hardscape furniture, outdoor amenities, and landscaping",
         "Planner": "Darryl Boyd ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "H17-042",
         "APN": 46720019,
         "File Number": "H17-042",
         "Address": "100 N 4TH ST SAN JOSE",
         "Project Name": "100 NORTH 4TH STREET",
         "Application Type": "Private ",
         "Application Date": "8/3/17",
         "Status": "Withdrawn ",
         "Description": "Site Development Permit to construct a 554,783 SF mixed use residential and commercial building with 8,409 SF Commercial and 400 units of student housing in a 26 story building with one level of underground parking on a 0.98 gross acre site.",
         "Planner": "Rina Shah ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "H17-042",
         "APN": 46720020,
         "File Number": "H17-042",
         "Address": "100 N 4TH ST SAN JOSE",
         "Project Name": "100 NORTH 4TH STREET",
         "Application Type": "Private ",
         "Application Date": "8/3/17",
         "Status": "Withdrawn ",
         "Description": "Site Development Permit to construct a 554,783 SF mixed use residential and commercial building with 8,409 SF Commercial and 400 units of student housing in a 26 story building with one level of underground parking on a 0.98 gross acre site.",
         "Planner": "Rina Shah ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "H17-042",
         "APN": 46720021,
         "File Number": "H17-042",
         "Address": "100 N 4TH ST SAN JOSE",
         "Project Name": "100 NORTH 4TH STREET",
         "Application Type": "Private ",
         "Application Date": "8/3/17",
         "Status": "Withdrawn ",
         "Description": "Site Development Permit to construct a 554,783 SF mixed use residential and commercial building with 8,409 SF Commercial and 400 units of student housing in a 26 story building with one level of underground parking on a 0.98 gross acre site.",
         "Planner": "Rina Shah ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "H17-042",
         "APN": 46720022,
         "File Number": "H17-042",
         "Address": "100 N 4TH ST SAN JOSE",
         "Project Name": "100 NORTH 4TH STREET",
         "Application Type": "Private ",
         "Application Date": "8/3/17",
         "Status": "Withdrawn ",
         "Description": "Site Development Permit to construct a 554,783 SF mixed use residential and commercial building with 8,409 SF Commercial and 400 units of student housing in a 26 story building with one level of underground parking on a 0.98 gross acre site.",
         "Planner": "Rina Shah ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "H17-042",
         "APN": 46720040,
         "File Number": "H17-042",
         "Address": "100 N 4TH ST SAN JOSE",
         "Project Name": "100 NORTH 4TH STREET",
         "Application Type": "Private ",
         "Application Date": "8/3/17",
         "Status": "Withdrawn ",
         "Description": "Site Development Permit to construct a 554,783 SF mixed use residential and commercial building with 8,409 SF Commercial and 400 units of student housing in a 26 story building with one level of underground parking on a 0.98 gross acre site.",
         "Planner": "Rina Shah ",
         "DURATION": 0,
         "Year": 2017
      }
   ],
   "PT Subdivision Map ": [
      {
         "PERMITID": "PT01-003",
         "APN": 24946089,
         "File Number": "PT01-003",
         "Address": "380 N 4TH ST SAN JOSE",
         "Project Name": "4th/Washington",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "1/3/01 15:57",
         "Status": "Approved ",
         "Description": "Tentative Map Permit to subdivide 3 lots into 4 lots for residential uses on 0.537 gross acres.",
         "Planner": "Akoni Danielsen ",
         "DURATION": 6822,
         "Year": 2001
      },
      {
         "PERMITID": "PT01-003",
         "APN": 24946090,
         "File Number": "PT01-003",
         "Address": "380 N 4TH ST SAN JOSE",
         "Project Name": "4th/Washington",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "1/3/01 15:57",
         "Status": "Approved ",
         "Description": "Tentative Map Permit to subdivide 3 lots into 4 lots for residential uses on 0.537 gross acres.",
         "Planner": "Akoni Danielsen ",
         "DURATION": 6822,
         "Year": 2001
      },
      {
         "PERMITID": "PT01-003",
         "APN": 24946092,
         "File Number": "PT01-003",
         "Address": "380 N 4TH ST SAN JOSE",
         "Project Name": "4th/Washington",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "1/3/01 15:57",
         "Status": "Approved ",
         "Description": "Tentative Map Permit to subdivide 3 lots into 4 lots for residential uses on 0.537 gross acres.",
         "Planner": "Akoni Danielsen ",
         "DURATION": 6822,
         "Year": 2001
      },
      {
         "PERMITID": "PT04-068",
         "APN": 47221104,
         "File Number": "PT04-068",
         "Address": "9645 TRACT SAN JOSE",
         "Project Name": "PT04-068",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "7/15/04",
         "Status": "Approved ",
         "Description": "Planned Tentative Map Permit to subdivide 12 parcels into 55 lots for single-family detached residential uses on a 8.6 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 214,
         "Year": 2004
      },
      {
         "PERMITID": "PT04-068",
         "APN": 47222060,
         "File Number": "PT04-068",
         "Address": "9645 TRACT SAN JOSE",
         "Project Name": "PT04-068",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "7/15/04",
         "Status": "Approved ",
         "Description": "Planned Tentative Map Permit to subdivide 12 parcels into 55 lots for single-family detached residential uses on a 8.6 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 214,
         "Year": 2004
      },
      {
         "PERMITID": "PT04-068",
         "APN": 47222062,
         "File Number": "PT04-068",
         "Address": "9645 TRACT SAN JOSE",
         "Project Name": "PT04-068",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "7/15/04",
         "Status": "Approved ",
         "Description": "Planned Tentative Map Permit to subdivide 12 parcels into 55 lots for single-family detached residential uses on a 8.6 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 214,
         "Year": 2004
      },
      {
         "PERMITID": "PT04-068",
         "APN": 47241050,
         "File Number": "PT04-068",
         "Address": "9645 TRACT SAN JOSE",
         "Project Name": "PT04-068",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "7/15/04",
         "Status": "Approved ",
         "Description": "Planned Tentative Map Permit to subdivide 12 parcels into 55 lots for single-family detached residential uses on a 8.6 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 214,
         "Year": 2004
      },
      {
         "PERMITID": "PT04-068",
         "APN": 47241051,
         "File Number": "PT04-068",
         "Address": "9645 TRACT SAN JOSE",
         "Project Name": "PT04-068",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "7/15/04",
         "Status": "Approved ",
         "Description": "Planned Tentative Map Permit to subdivide 12 parcels into 55 lots for single-family detached residential uses on a 8.6 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 214,
         "Year": 2004
      },
      {
         "PERMITID": "PT08-016",
         "APN": 46701034,
         "File Number": "PT08-016",
         "Address": "237 N 4TH ST SAN JOSE",
         "Project Name": "PT08-016",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "3/19/08",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Map to subdivide one parcel into two lots for live/work purposes on a 0.08 gross acre site",
         "Planner": "Carmen Stanley 3",
         "DURATION": 222,
         "Year": 2008
      },
      {
         "PERMITID": "PT16-012",
         "APN": 25938039,
         "File Number": "PT16-012",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "PT16-012 - Diridon TOD",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "2/24/16 15:09",
         "Status": "Approved ",
         "Description": "Tentative Map to consolidate 19 parcels into one (1) parcel for subdivision into two (2) parcels, and up to 10 commercial condominiums on a 8.93 gross acre site",
         "Planner": "John Tu ",
         "DURATION": 195,
         "Year": 2016
      },
      {
         "PERMITID": "PT16-012",
         "APN": 25938041,
         "File Number": "PT16-012",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "PT16-012 - Diridon TOD",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "2/24/16 15:09",
         "Status": "Approved ",
         "Description": "Tentative Map to consolidate 19 parcels into one (1) parcel for subdivision into two (2) parcels, and up to 10 commercial condominiums on a 8.93 gross acre site",
         "Planner": "John Tu ",
         "DURATION": 195,
         "Year": 2016
      },
      {
         "PERMITID": "PT16-012",
         "APN": 25938109,
         "File Number": "PT16-012",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "PT16-012 - Diridon TOD",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "2/24/16 15:09",
         "Status": "Approved ",
         "Description": "Tentative Map to consolidate 19 parcels into one (1) parcel for subdivision into two (2) parcels, and up to 10 commercial condominiums on a 8.93 gross acre site",
         "Planner": "John Tu ",
         "DURATION": 195,
         "Year": 2016
      },
      {
         "PERMITID": "PT16-012",
         "APN": 25938110,
         "File Number": "PT16-012",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "PT16-012 - Diridon TOD",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "2/24/16 15:09",
         "Status": "Approved ",
         "Description": "Tentative Map to consolidate 19 parcels into one (1) parcel for subdivision into two (2) parcels, and up to 10 commercial condominiums on a 8.93 gross acre site",
         "Planner": "John Tu ",
         "DURATION": 195,
         "Year": 2016
      },
      {
         "PERMITID": "PT16-012",
         "APN": 25938128,
         "File Number": "PT16-012",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "PT16-012 - Diridon TOD",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "2/24/16 15:09",
         "Status": "Approved ",
         "Description": "Tentative Map to consolidate 19 parcels into one (1) parcel for subdivision into two (2) parcels, and up to 10 commercial condominiums on a 8.93 gross acre site",
         "Planner": "John Tu ",
         "DURATION": 195,
         "Year": 2016
      },
      {
         "PERMITID": "PT16-012",
         "APN": 25938142,
         "File Number": "PT16-012",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "PT16-012 - Diridon TOD",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "2/24/16 15:09",
         "Status": "Approved ",
         "Description": "Tentative Map to consolidate 19 parcels into one (1) parcel for subdivision into two (2) parcels, and up to 10 commercial condominiums on a 8.93 gross acre site",
         "Planner": "John Tu ",
         "DURATION": 195,
         "Year": 2016
      },
      {
         "PERMITID": "PT16-012",
         "APN": 25938145,
         "File Number": "PT16-012",
         "Address": "402 W SANTA CLARA ST SAN JOSE",
         "Project Name": "PT16-012 - Diridon TOD",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "2/24/16 15:09",
         "Status": "Approved ",
         "Description": "Tentative Map to consolidate 19 parcels into one (1) parcel for subdivision into two (2) parcels, and up to 10 commercial condominiums on a 8.93 gross acre site",
         "Planner": "John Tu ",
         "DURATION": 195,
         "Year": 2016
      },
      {
         "PERMITID": "PT16-015",
         "APN": 46701120,
         "File Number": "PT16-015",
         "Address": "298 N 4TH ST SAN JOSE",
         "Project Name": "PT16-015",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "3/16/16 10:06",
         "Status": "Approved ",
         "Description": "Vesting Tentative Map to combine three (3) lots into one (1) lot and the creation of twelve (12) condominium units for residential use and one (1) condominium unit for commercial use on a 0.44 gross acre site",
         "Planner": "David Fong ",
         "DURATION": 121,
         "Year": 2016
      },
      {
         "PERMITID": "PT81-057",
         "APN": 46723082,
         "File Number": "PT81-057",
         "Address": " ",
         "Project Name": "PT81-057",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "4/6/81",
         "Status": "Approved ",
         "Description": "Other APNs:THRU 027/467-23-071",
         "Planner": "UNKNOWN ",
         "DURATION": 0,
         "Year": 1981
      },
      {
         "PERMITID": "PT81-057",
         "APN": 46723083,
         "File Number": "PT81-057",
         "Address": " ",
         "Project Name": "PT81-057",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "4/6/81",
         "Status": "Approved ",
         "Description": "Other APNs:THRU 027/467-23-071",
         "Planner": "UNKNOWN ",
         "DURATION": 0,
         "Year": 1981
      },
      {
         "PERMITID": "PT87-052",
         "APN": 46719075,
         "File Number": "PT87-052",
         "Address": "235 E SANTA CLARA ST SAN JOSE",
         "Project Name": "PT87-052",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "6/22/87",
         "Status": "Approved ",
         "Description": "File type: *Other apns: *Gen.Use Class:*Existing Land Use:5390*Specific Use:2 SFA",
         "Planner": "LMUCHOW ",
         "DURATION": 0,
         "Year": 1987
      },
      {
         "PERMITID": "PT88-127",
         "APN": 46702125,
         "File Number": "PT88-127",
         "Address": "276 N 7TH ST SAN JOSE",
         "Project Name": "PT88-127",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "11/7/88",
         "Status": "Approved ",
         "Description": "SIGNED ",
         "Planner": "Michele Campos ",
         "DURATION": 0,
         "Year": 1988
      },
      {
         "PERMITID": "PT88-127",
         "APN": 46702126,
         "File Number": "PT88-127",
         "Address": "276 N 7TH ST SAN JOSE",
         "Project Name": "PT88-127",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "11/7/88",
         "Status": "Approved ",
         "Description": "SIGNED ",
         "Planner": "Michele Campos ",
         "DURATION": 0,
         "Year": 1988
      },
      {
         "PERMITID": "PT88-127",
         "APN": 46702127,
         "File Number": "PT88-127",
         "Address": "276 N 7TH ST SAN JOSE",
         "Project Name": "PT88-127",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "11/7/88",
         "Status": "Approved ",
         "Description": "SIGNED ",
         "Planner": "Michele Campos ",
         "DURATION": 0,
         "Year": 1988
      },
      {
         "PERMITID": "PT99-064",
         "APN": 46761001,
         "File Number": "PT99-064",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "PT99-064",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "6/10/99",
         "Status": "Approved ",
         "Description": "Tentative Map Permit to reconfigure 2 parcels into 1 for residential use on 0.87 gross acres",
         "Planner": "PGILLI ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PT99-064",
         "APN": 46761002,
         "File Number": "PT99-064",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "PT99-064",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "6/10/99",
         "Status": "Approved ",
         "Description": "Tentative Map Permit to reconfigure 2 parcels into 1 for residential use on 0.87 gross acres",
         "Planner": "PGILLI ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PT99-064",
         "APN": 46761003,
         "File Number": "PT99-064",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "PT99-064",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "6/10/99",
         "Status": "Approved ",
         "Description": "Tentative Map Permit to reconfigure 2 parcels into 1 for residential use on 0.87 gross acres",
         "Planner": "PGILLI ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PT99-064",
         "APN": 46761004,
         "File Number": "PT99-064",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "PT99-064",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "6/10/99",
         "Status": "Approved ",
         "Description": "Tentative Map Permit to reconfigure 2 parcels into 1 for residential use on 0.87 gross acres",
         "Planner": "PGILLI ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PT99-064",
         "APN": 46761005,
         "File Number": "PT99-064",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "PT99-064",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "6/10/99",
         "Status": "Approved ",
         "Description": "Tentative Map Permit to reconfigure 2 parcels into 1 for residential use on 0.87 gross acres",
         "Planner": "PGILLI ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PT99-064",
         "APN": 46761006,
         "File Number": "PT99-064",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "PT99-064",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "6/10/99",
         "Status": "Approved ",
         "Description": "Tentative Map Permit to reconfigure 2 parcels into 1 for residential use on 0.87 gross acres",
         "Planner": "PGILLI ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PT99-064",
         "APN": 46761007,
         "File Number": "PT99-064",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "PT99-064",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "6/10/99",
         "Status": "Approved ",
         "Description": "Tentative Map Permit to reconfigure 2 parcels into 1 for residential use on 0.87 gross acres",
         "Planner": "PGILLI ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PT99-064",
         "APN": 46761008,
         "File Number": "PT99-064",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "PT99-064",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "6/10/99",
         "Status": "Approved ",
         "Description": "Tentative Map Permit to reconfigure 2 parcels into 1 for residential use on 0.87 gross acres",
         "Planner": "PGILLI ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PT99-064",
         "APN": 46761009,
         "File Number": "PT99-064",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "PT99-064",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "6/10/99",
         "Status": "Approved ",
         "Description": "Tentative Map Permit to reconfigure 2 parcels into 1 for residential use on 0.87 gross acres",
         "Planner": "PGILLI ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PT99-064",
         "APN": 46761010,
         "File Number": "PT99-064",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "PT99-064",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "6/10/99",
         "Status": "Approved ",
         "Description": "Tentative Map Permit to reconfigure 2 parcels into 1 for residential use on 0.87 gross acres",
         "Planner": "PGILLI ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PT99-064",
         "APN": 46761011,
         "File Number": "PT99-064",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "PT99-064",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "6/10/99",
         "Status": "Approved ",
         "Description": "Tentative Map Permit to reconfigure 2 parcels into 1 for residential use on 0.87 gross acres",
         "Planner": "PGILLI ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PT99-064",
         "APN": 46761012,
         "File Number": "PT99-064",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "PT99-064",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "6/10/99",
         "Status": "Approved ",
         "Description": "Tentative Map Permit to reconfigure 2 parcels into 1 for residential use on 0.87 gross acres",
         "Planner": "PGILLI ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PT99-064",
         "APN": 46761013,
         "File Number": "PT99-064",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "PT99-064",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "6/10/99",
         "Status": "Approved ",
         "Description": "Tentative Map Permit to reconfigure 2 parcels into 1 for residential use on 0.87 gross acres",
         "Planner": "PGILLI ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PT99-064",
         "APN": 46761014,
         "File Number": "PT99-064",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "PT99-064",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "6/10/99",
         "Status": "Approved ",
         "Description": "Tentative Map Permit to reconfigure 2 parcels into 1 for residential use on 0.87 gross acres",
         "Planner": "PGILLI ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PT99-064",
         "APN": 46761015,
         "File Number": "PT99-064",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "PT99-064",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "6/10/99",
         "Status": "Approved ",
         "Description": "Tentative Map Permit to reconfigure 2 parcels into 1 for residential use on 0.87 gross acres",
         "Planner": "PGILLI ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PT99-064",
         "APN": 46761017,
         "File Number": "PT99-064",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "PT99-064",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "6/10/99",
         "Status": "Approved ",
         "Description": "Tentative Map Permit to reconfigure 2 parcels into 1 for residential use on 0.87 gross acres",
         "Planner": "PGILLI ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PT99-064",
         "APN": 46761018,
         "File Number": "PT99-064",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "PT99-064",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "6/10/99",
         "Status": "Approved ",
         "Description": "Tentative Map Permit to reconfigure 2 parcels into 1 for residential use on 0.87 gross acres",
         "Planner": "PGILLI ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PT99-064",
         "APN": 46761019,
         "File Number": "PT99-064",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "PT99-064",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "6/10/99",
         "Status": "Approved ",
         "Description": "Tentative Map Permit to reconfigure 2 parcels into 1 for residential use on 0.87 gross acres",
         "Planner": "PGILLI ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PT99-064",
         "APN": 46761020,
         "File Number": "PT99-064",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "PT99-064",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "6/10/99",
         "Status": "Approved ",
         "Description": "Tentative Map Permit to reconfigure 2 parcels into 1 for residential use on 0.87 gross acres",
         "Planner": "PGILLI ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PT99-064",
         "APN": 46761021,
         "File Number": "PT99-064",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "PT99-064",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "6/10/99",
         "Status": "Approved ",
         "Description": "Tentative Map Permit to reconfigure 2 parcels into 1 for residential use on 0.87 gross acres",
         "Planner": "PGILLI ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PT99-064",
         "APN": 46761022,
         "File Number": "PT99-064",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "PT99-064",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "6/10/99",
         "Status": "Approved ",
         "Description": "Tentative Map Permit to reconfigure 2 parcels into 1 for residential use on 0.87 gross acres",
         "Planner": "PGILLI ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PT99-064",
         "APN": 46761023,
         "File Number": "PT99-064",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "PT99-064",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "6/10/99",
         "Status": "Approved ",
         "Description": "Tentative Map Permit to reconfigure 2 parcels into 1 for residential use on 0.87 gross acres",
         "Planner": "PGILLI ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PT99-064",
         "APN": 46761024,
         "File Number": "PT99-064",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "PT99-064",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "6/10/99",
         "Status": "Approved ",
         "Description": "Tentative Map Permit to reconfigure 2 parcels into 1 for residential use on 0.87 gross acres",
         "Planner": "PGILLI ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PT99-064",
         "APN": 46761025,
         "File Number": "PT99-064",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "PT99-064",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "6/10/99",
         "Status": "Approved ",
         "Description": "Tentative Map Permit to reconfigure 2 parcels into 1 for residential use on 0.87 gross acres",
         "Planner": "PGILLI ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PT99-064",
         "APN": 46761026,
         "File Number": "PT99-064",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "PT99-064",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "6/10/99",
         "Status": "Approved ",
         "Description": "Tentative Map Permit to reconfigure 2 parcels into 1 for residential use on 0.87 gross acres",
         "Planner": "PGILLI ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PT99-064",
         "APN": 46761027,
         "File Number": "PT99-064",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "PT99-064",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "6/10/99",
         "Status": "Approved ",
         "Description": "Tentative Map Permit to reconfigure 2 parcels into 1 for residential use on 0.87 gross acres",
         "Planner": "PGILLI ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PT99-064",
         "APN": 46761028,
         "File Number": "PT99-064",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "PT99-064",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "6/10/99",
         "Status": "Approved ",
         "Description": "Tentative Map Permit to reconfigure 2 parcels into 1 for residential use on 0.87 gross acres",
         "Planner": "PGILLI ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PT99-064",
         "APN": 46761029,
         "File Number": "PT99-064",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "PT99-064",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "6/10/99",
         "Status": "Approved ",
         "Description": "Tentative Map Permit to reconfigure 2 parcels into 1 for residential use on 0.87 gross acres",
         "Planner": "PGILLI ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PT99-064",
         "APN": 46761030,
         "File Number": "PT99-064",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "PT99-064",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "6/10/99",
         "Status": "Approved ",
         "Description": "Tentative Map Permit to reconfigure 2 parcels into 1 for residential use on 0.87 gross acres",
         "Planner": "PGILLI ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PT99-064",
         "APN": 46761032,
         "File Number": "PT99-064",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "PT99-064",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "6/10/99",
         "Status": "Approved ",
         "Description": "Tentative Map Permit to reconfigure 2 parcels into 1 for residential use on 0.87 gross acres",
         "Planner": "PGILLI ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PT99-064",
         "APN": 46761033,
         "File Number": "PT99-064",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "PT99-064",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "6/10/99",
         "Status": "Approved ",
         "Description": "Tentative Map Permit to reconfigure 2 parcels into 1 for residential use on 0.87 gross acres",
         "Planner": "PGILLI ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PT99-064",
         "APN": 46761035,
         "File Number": "PT99-064",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "PT99-064",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "6/10/99",
         "Status": "Approved ",
         "Description": "Tentative Map Permit to reconfigure 2 parcels into 1 for residential use on 0.87 gross acres",
         "Planner": "PGILLI ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PT99-064",
         "APN": 46761037,
         "File Number": "PT99-064",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "PT99-064",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "6/10/99",
         "Status": "Approved ",
         "Description": "Tentative Map Permit to reconfigure 2 parcels into 1 for residential use on 0.87 gross acres",
         "Planner": "PGILLI ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PT99-064",
         "APN": 46761038,
         "File Number": "PT99-064",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "PT99-064",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "6/10/99",
         "Status": "Approved ",
         "Description": "Tentative Map Permit to reconfigure 2 parcels into 1 for residential use on 0.87 gross acres",
         "Planner": "PGILLI ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PT99-064",
         "APN": 46761040,
         "File Number": "PT99-064",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "PT99-064",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "6/10/99",
         "Status": "Approved ",
         "Description": "Tentative Map Permit to reconfigure 2 parcels into 1 for residential use on 0.87 gross acres",
         "Planner": "PGILLI ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PT99-064",
         "APN": 46761041,
         "File Number": "PT99-064",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "PT99-064",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "6/10/99",
         "Status": "Approved ",
         "Description": "Tentative Map Permit to reconfigure 2 parcels into 1 for residential use on 0.87 gross acres",
         "Planner": "PGILLI ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PT99-064",
         "APN": 46761042,
         "File Number": "PT99-064",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "PT99-064",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "6/10/99",
         "Status": "Approved ",
         "Description": "Tentative Map Permit to reconfigure 2 parcels into 1 for residential use on 0.87 gross acres",
         "Planner": "PGILLI ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PT99-064",
         "APN": 46761043,
         "File Number": "PT99-064",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "PT99-064",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "6/10/99",
         "Status": "Approved ",
         "Description": "Tentative Map Permit to reconfigure 2 parcels into 1 for residential use on 0.87 gross acres",
         "Planner": "PGILLI ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PT99-064",
         "APN": 46761044,
         "File Number": "PT99-064",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "PT99-064",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "6/10/99",
         "Status": "Approved ",
         "Description": "Tentative Map Permit to reconfigure 2 parcels into 1 for residential use on 0.87 gross acres",
         "Planner": "PGILLI ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PT99-064",
         "APN": 46761045,
         "File Number": "PT99-064",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "PT99-064",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "6/10/99",
         "Status": "Approved ",
         "Description": "Tentative Map Permit to reconfigure 2 parcels into 1 for residential use on 0.87 gross acres",
         "Planner": "PGILLI ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PT99-064",
         "APN": 46761046,
         "File Number": "PT99-064",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "PT99-064",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "6/10/99",
         "Status": "Approved ",
         "Description": "Tentative Map Permit to reconfigure 2 parcels into 1 for residential use on 0.87 gross acres",
         "Planner": "PGILLI ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PT99-064",
         "APN": 46761048,
         "File Number": "PT99-064",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "PT99-064",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "6/10/99",
         "Status": "Approved ",
         "Description": "Tentative Map Permit to reconfigure 2 parcels into 1 for residential use on 0.87 gross acres",
         "Planner": "PGILLI ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PT99-064",
         "APN": 46761049,
         "File Number": "PT99-064",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "PT99-064",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "6/10/99",
         "Status": "Approved ",
         "Description": "Tentative Map Permit to reconfigure 2 parcels into 1 for residential use on 0.87 gross acres",
         "Planner": "PGILLI ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PT99-064",
         "APN": 46761051,
         "File Number": "PT99-064",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "PT99-064",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "6/10/99",
         "Status": "Approved ",
         "Description": "Tentative Map Permit to reconfigure 2 parcels into 1 for residential use on 0.87 gross acres",
         "Planner": "PGILLI ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PT99-064",
         "APN": 46761052,
         "File Number": "PT99-064",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "PT99-064",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "6/10/99",
         "Status": "Approved ",
         "Description": "Tentative Map Permit to reconfigure 2 parcels into 1 for residential use on 0.87 gross acres",
         "Planner": "PGILLI ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PT99-064",
         "APN": 46761055,
         "File Number": "PT99-064",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "PT99-064",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "6/10/99",
         "Status": "Approved ",
         "Description": "Tentative Map Permit to reconfigure 2 parcels into 1 for residential use on 0.87 gross acres",
         "Planner": "PGILLI ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PT99-064",
         "APN": 46761056,
         "File Number": "PT99-064",
         "Address": "277 N 2ND ST SAN JOSE",
         "Project Name": "PT99-064",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "6/10/99",
         "Status": "Approved ",
         "Description": "Tentative Map Permit to reconfigure 2 parcels into 1 for residential use on 0.87 gross acres",
         "Planner": "PGILLI ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PT19-012",
         "APN": 47217042,
         "File Number": "PT19-012",
         "Address": "895 S 2ND ST SAN JOSE",
         "Project Name": "PT19-012",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "3/14/19 10:22",
         "Status": "Review Letter Sent ",
         "Description": "Tentative map to subdivide one parcel into three lots in the R-M(PD) Planned Development Zoning District ",
         "Planner": "Rina Shah ",
         "DURATION": 12,
         "Year": 2019
      },
      {
         "PERMITID": "PT04-073",
         "APN": 26420132,
         "File Number": "PT04-073",
         "Address": "598 W SAN CARLOS ST SAN JOSE",
         "Project Name": "PT04-073, San Carlos St Teachers' Academy Multi-family",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "7/21/04",
         "Status": "Withdrawn ",
         "Description": "Vesting Planned Tentative Map Permit to consolidate eight parcels into one lot for multi-family attached residential uses on a 0.8 gross acre site",
         "Planner": "MNAGARAJ ",
         "DURATION": 1358,
         "Year": 2004
      },
      {
         "PERMITID": "PT04-101",
         "APN": 25947083,
         "File Number": "PT04-101",
         "Address": "475 W SAN CARLOS ST Bldg 1 SAN JOSE",
         "Project Name": "PT04-101",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "10/22/04",
         "Status": "Withdrawn ",
         "Description": "Planned Development Tentative Map Permit to subdivide one parcel into 117 lots for condominium uses on a 3.45 gross acres site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 31,
         "Year": 2004
      },
      {
         "PERMITID": "PT99-078",
         "APN": 24946089,
         "File Number": "PT99-078",
         "Address": " ",
         "Project Name": "PT99-078",
         "Application Type": "PT Subdivision Map ",
         "Application Date": "7/7/99",
         "Status": "Withdrawn ",
         "Description": "Tentative Map for the subdivision of two lots into four for residential uses on a .25 gross acre site",
         "Planner": "Akoni Danielsen ",
         "DURATION": 7354,
         "Year": 1999
      }
   ],
   "Reasonable Accommodation ": [
      {
         "PERMITID": "RA99-003",
         "APN": 47225061,
         "File Number": "RA99-003",
         "Address": "650 S 5TH ST SAN JOSE",
         "Project Name": "RA99-003",
         "Application Type": "Reasonable Accommodation ",
         "Application Date": "10/22/98",
         "Status": "Approved ",
         "Description": "Reasonable Accommodation Permit to allow a 22 bed residence service facility to operate on a 0.14 gross acre parcel",
         "Planner": "Akoni Danielsen ",
         "DURATION": 0,
         "Year": 1998
      }
   ],
   "Reconst of LNC ": [
      {
         "PERMITID": "RSL03-002",
         "APN": 46703024,
         "File Number": "RSL03-002",
         "Address": "250 N 9TH ST SAN JOSE",
         "Project Name": "250 N 9TH ST",
         "Application Type": "Reconst of LNC ",
         "Application Date": "2/5/03",
         "Status": "Complete ",
         "Description": "REBUILD LETTER ",
         "Planner": "Lee Butler ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RSL06-076",
         "APN": 46703019,
         "File Number": "RSL06-076",
         "Address": "401 E ST JAMES ST SAN JOSE",
         "Project Name": "RSL06-076",
         "Application Type": "Reconst of LNC ",
         "Application Date": "10/17/06 9:57",
         "Status": "Complete ",
         "Description": "Reconstruction letter. ",
         "Planner": "Lee Butler ",
         "DURATION": 22,
         "Year": 2006
      },
      {
         "PERMITID": "RSL10-044",
         "APN": 46723082,
         "File Number": "RSL10-044",
         "Address": "85 S 5TH ST SAN JOSE",
         "Project Name": "RSL10-044",
         "Application Type": "Reconst of LNC ",
         "Application Date": "11/5/10 14:46",
         "Status": "Complete ",
         "Description": "Reconstruction Letter for apartments (Jeanne d'arc Manor) ",
         "Planner": "Mike Enderby ",
         "DURATION": 1,
         "Year": 2010
      },
      {
         "PERMITID": "RSL11-033",
         "APN": 46723082,
         "File Number": "RSL11-033",
         "Address": "85 S 5TH ST SAN JOSE",
         "Project Name": "RSL11-033",
         "Application Type": "Reconst of LNC ",
         "Application Date": "5/19/11 14:27",
         "Status": "Complete ",
         "Description": "REBUILD LETTER ",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 1,
         "Year": 2011
      }
   ],
   "SF Permit - Type 1": [
      {
         "PERMITID": "SF03-013",
         "APN": 47224043,
         "File Number": "SF03-013",
         "Address": "687 S 8TH ST SAN JOSE",
         "Project Name": "SF03-013",
         "Application Type": "SF Permit - Type 1",
         "Application Date": "6/16/03",
         "Status": "Approved ",
         "Description": "Single Family House Permit to legalize an existing 16.5' x 8.5' porch/deck enclosure at the rear of an existing single family residence on 0.13 a gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 100,
         "Year": 2003
      },
      {
         "PERMITID": "SF06-003",
         "APN": 24952010,
         "File Number": "SF06-003",
         "Address": "347 N 10TH ST SAN JOSE",
         "Project Name": "SF06-003",
         "Application Type": "SF Permit - Type 1",
         "Application Date": "1/27/06",
         "Status": "Approved ",
         "Description": "Single-Family House Permit to allow: (1) the removal of a 252-square foot pre-built shed, (2) legalizing a pre-built 635-square foot one-story addition (Code Enforcement Case No. 04-34547), (3) construction of a 338-square foot addition that attaches the pre-built addtition to the existing 1,206-square foot one-story single-family detached residence listed on the City's Historic Inventory, and (4) construction of a new 162-square foot detached one-car carport measuring 11-feet 4-inches tall on 0.14 gross acres.",
         "Planner": "Juan Borrelli ",
         "DURATION": 248,
         "Year": 2006
      },
      {
         "PERMITID": "SF06-014",
         "APN": 47224076,
         "File Number": "SF06-014",
         "Address": "396 MARGARET ST SAN JOSE",
         "Project Name": "SF06-014",
         "Application Type": "SF Permit - Type 1",
         "Application Date": "3/13/06",
         "Status": "Approved ",
         "Description": "Single Family House Permit to allow additions to the front porch and rear entry for access to basement living area and an existing single-family residence on a 0.07 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 50,
         "Year": 2006
      },
      {
         "PERMITID": "SF10-003",
         "APN": 46702041,
         "File Number": "SF10-003",
         "Address": "283 E ST JAMES ST SAN JOSE",
         "Project Name": "SF10-003",
         "Application Type": "SF Permit - Type 1",
         "Application Date": "2/9/10",
         "Status": "Approved ",
         "Description": "Single Family House Permit to construct a 248 square foot addition to an existing residence and a 266 square foot addition to a rear accessory structure/garage.",
         "Planner": "MNAGARAJ ",
         "DURATION": 27,
         "Year": 2010
      },
      {
         "PERMITID": "SF10-016",
         "APN": 47225072,
         "File Number": "SF10-016",
         "Address": "647 S 6TH ST SAN JOSE",
         "Project Name": "SF10-016",
         "Application Type": "SF Permit - Type 1",
         "Application Date": "6/7/10",
         "Status": "Approved ",
         "Description": "Single Family Permit to allow repair and replacement of an existing, second floor porch/deck and to allow the rebuilding of the associated stairs and railings on the rear of an existing residence as shown on the approved SFHP Plans only. ",
         "Planner": "MNAGARAJ ",
         "DURATION": 0,
         "Year": 2010
      },
      {
         "PERMITID": "SF12-024",
         "APN": 24944031,
         "File Number": "SF12-024",
         "Address": "336 N 2ND ST SAN JOSE",
         "Project Name": "SF12-024",
         "Application Type": "SF Permit - Type 1",
         "Application Date": "12/17/12",
         "Status": "Approved ",
         "Description": "Single Family House Permit to allow the replacement of the foundation to the rear house on the property. ",
         "Planner": "Justin Daniels ",
         "DURATION": 25,
         "Year": 2012
      },
      {
         "PERMITID": "SF18-022",
         "APN": 47229013,
         "File Number": "SF18-022",
         "Address": "580 S 9TH ST SAN JOSE",
         "Project Name": "SF18-022",
         "Application Type": "SF Permit - Type 1",
         "Application Date": "5/10/18 14:28",
         "Status": "Approved ",
         "Description": "Single-Family House Permit Type 1 (Historic) to add one new window to the first floor, two windows to the basement, replacement of second floor door to a new window, replace all existing windows on residence to new double pane windows, and to replace the old foundation with a new foundation.",
         "Planner": "Martina Davis ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "SF14-018",
         "APN": 47231004,
         "File Number": "SF14-018",
         "Address": "545 S 16TH ST SAN JOSE",
         "Project Name": "SF14-018",
         "Application Type": "SF Permit - Type 1",
         "Application Date": "6/18/14",
         "Status": "Approved with Conditions ",
         "Description": "Single Family House Permit, Historic Type I, to replace an existing glass block window with a new wood framed opaque glass window in the same opening as the existing window at the rear of a single family residence that is an Identified Structure on the Historic Resources Inventory ",
         "Planner": "Martina Davis ",
         "DURATION": 14,
         "Year": 2014
      },
      {
         "PERMITID": "SF11-017",
         "APN": 47229013,
         "File Number": "SF11-017",
         "Address": "580 S 9TH ST SAN JOSE",
         "Project Name": "SF11-017",
         "Application Type": "SF Permit - Type 1",
         "Application Date": "7/7/11",
         "Status": "Denied ",
         "Description": "Category 1 Historic Single Family House Permit to allow minor exterior changes (including new doors and windows, and a minor addition) and the addition of a new, detached garage for a single-family house listed on the City's Historic Resource Inventory.",
         "Planner": "Jeff Roche ",
         "DURATION": 98,
         "Year": 2011
      },
      {
         "PERMITID": "SF17-028",
         "APN": 47229013,
         "File Number": "SF17-028",
         "Address": "580 S 9TH ST SAN JOSE",
         "Project Name": "SF17-028",
         "Application Type": "SF Permit - Type 1",
         "Application Date": "6/27/17 15:51",
         "Status": "Pending ",
         "Description": "SFD to allow replacement of four exterior basement windows ",
         "Planner": "Martina Davis ",
         "DURATION": 27,
         "Year": 2017
      },
      {
         "PERMITID": "SF18-043",
         "APN": 46702097,
         "File Number": "SF18-043",
         "Address": "221 N 9TH ST SAN JOSE",
         "Project Name": "SF18-043 - 221 NORTH 9TH STREET - HISTORIC",
         "Application Type": "SF Permit - Type 1",
         "Application Date": "12/17/18 11:09",
         "Status": "Recomd Approval ",
         "Description": "Historic - Single-Family House Permit to allow window and siding modifications to a fire damaged historical building. ",
         "Planner": "Martina Davis ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "2006 006775 AO",
         "APN": 47224076,
         "File Number": "2006 006775 AO",
         "Address": "396 MARGARET ST SAN JOSE",
         "Project Name": "396 MARGARET ST",
         "Application Type": "SF Permit - Type 1",
         "Application Date": "2/24/06",
         "Status": "Rejected ",
         "Description": "PRE SUBMITTAL REVIEW OF SFHP FOR PORCH ADDITION W REAR ADDN AND BASEMENT EXPANSION. SITUS IS IN CREDENZA FILE ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "HP17-004",
         "APN": 47229013,
         "File Number": "HP17-004",
         "Address": "580 S 9TH ST SAN JOSE",
         "Project Name": "HP17-004",
         "Application Type": "SF Permit - Type 1",
         "Application Date": "6/27/17 15:36",
         "Status": "Withdrawn ",
         "Description": "Single-Family house permit to allow replacement of 4 exterior windows in the basement. PLEASE CANCEL THIS",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "SF07-051",
         "APN": 26420101,
         "File Number": "SF07-051",
         "Address": "491 AUZERAIS AV SAN JOSE",
         "Project Name": "SF07-051",
         "Application Type": "SF Permit - Type 1",
         "Application Date": "8/23/07",
         "Status": "Withdrawn ",
         "Description": "Converting 398 sq ft of an existing garage into a beauty saloon under home occupation in an existing single family residence of 2,389 sq ft area",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2007
      }
   ],
   "SF Permit - Type 2": [
      {
         "PERMITID": "SF04-032",
         "APN": 24948050,
         "File Number": "SF04-032",
         "Address": "336 N 6TH ST SAN JOSE",
         "Project Name": "SF04-032",
         "Application Type": "SF Permit - Type 2",
         "Application Date": "7/14/04",
         "Status": "Approved ",
         "Description": "Single Family House Permit to allow an addition to a residence with a .48 Floor Area Ratio listed on the Historic Resources Inventory as a Contributing Structure to the Hensley Historic District on a 0.2 gross acre site",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 46,
         "Year": 2004
      },
      {
         "PERMITID": "SF14-024",
         "APN": 46717083,
         "File Number": "SF14-024",
         "Address": "69 N 10TH ST SAN JOSE",
         "Project Name": "SF14-024",
         "Application Type": "SF Permit - Type 2",
         "Application Date": "8/27/14",
         "Status": "Approved ",
         "Description": "Single-Family House Permit (Type 2) to allow the construction of a new 4,788-square foot single-family residence with a proposed floor area ratio (FAR) of 0.65 and 640-square foot detached garage on an approximately 0.25 gross acre site.",
         "Planner": "Martina Davis ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "SF01-039",
         "APN": 46702090,
         "File Number": "SF01-039",
         "Address": "271 N 9TH ST SAN JOSE",
         "Project Name": "SF01-039",
         "Application Type": "SF Permit - Type 2",
         "Application Date": "6/12/01",
         "Status": "Withdrawn ",
         "Description": "Single Family House Permit to allow second floor addition of 1313 square foot on a 0.1 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 0,
         "Year": 2001
      }
   ],
   "SF Permit - Type 3": [
      {
         "PERMITID": "SF03-007",
         "APN": 46724032,
         "File Number": "SF03-007",
         "Address": "80 S 6TH ST SAN JOSE",
         "Project Name": "SF03-007",
         "Application Type": "SF Permit - Type 3",
         "Application Date": "4/1/03",
         "Status": "Approved ",
         "Description": "Single Family House Permit to convert 482 square feet of attic to living space and 1902 square feet of basement into living space in an existing single family residence on a 0.14 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 0,
         "Year": 2003
      }
   ],
   "Sidewalk Cafe ": [
      {
         "PERMITID": "RSC01-001",
         "APN": 25934029,
         "File Number": "RSC01-001",
         "Address": " ",
         "Project Name": "RSC01-001, Taqueria La Mordida",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "7/30/01",
         "Status": "Approved ",
         "Description": "Allow for the consumption of food and beverages in the public right-of-way in the form of a sidewalk cafe. ",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "RSC02-001",
         "APN": 25940036,
         "File Number": "RSC02-001",
         "Address": " ",
         "Project Name": "RSC02-001, Picasso's",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "4/19/02",
         "Status": "Approved ",
         "Description": "Allow for the consumption of food and alcoholic beverages in the public right-of-way in the form of a sidewalk cafe. ",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2002
      },
      {
         "PERMITID": "RSC03-003",
         "APN": 46762016,
         "File Number": "RSC03-003",
         "Address": "14 S 1ST ST SAN JOSE",
         "Project Name": "RSC03-003, Magic Carpet Ride Cafe",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "5/1/03",
         "Status": "Approved ",
         "Description": "Allow for the consumption of food and beverages in the public right-of-way in the form of a sidewalk cafe at an existing restaurant and bar. ",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RSC93-007",
         "APN": 25935057,
         "File Number": "RSC93-007",
         "Address": " ",
         "Project Name": "RSC93-007, Fred's Coffee Roasting Co.",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "6/30/93",
         "Status": "Approved ",
         "Description": "Allow for the consumption of food and beverages in the public right-of-way in the form of a sidewalk cafe. ",
         "Planner": "Mary Stokes ",
         "DURATION": 0,
         "Year": 1993
      },
      {
         "PERMITID": "RSC93-008",
         "APN": 46747007,
         "File Number": "RSC93-008",
         "Address": " ",
         "Project Name": "RSC93-008, Pasquale's Restaurant",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "6/30/93",
         "Status": "Approved ",
         "Description": "Allow for the consumption of food and beverages in the public right-of-way in the form of a sidewalk cafe. ",
         "Planner": "Mary Stokes ",
         "DURATION": 0,
         "Year": 1993
      },
      {
         "PERMITID": "RSC93-010",
         "APN": 25935035,
         "File Number": "RSC93-010",
         "Address": " ",
         "Project Name": "RSC93-010, Peggy Sue's",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "12/17/93",
         "Status": "Approved ",
         "Description": "Allow for the consumption of food and alcoholic beverages in the public right-of-way in the form of a sidewalk cafe. ",
         "Planner": "Mark Young ",
         "DURATION": 0,
         "Year": 1993
      },
      {
         "PERMITID": "RSC95-001",
         "APN": 46722110,
         "File Number": "RSC95-001",
         "Address": " ",
         "Project Name": "RSC95-001, Flying Pig Pub",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "6/22/95",
         "Status": "Approved ",
         "Description": "Allow for the consumption of food and alcoholic beverages in the public right-of-way in the form of a sidewalk cafe. ",
         "Planner": "Kristi Ashburn ",
         "DURATION": 0,
         "Year": 1995
      },
      {
         "PERMITID": "RSC95-003",
         "APN": 46746097,
         "File Number": "RSC95-003",
         "Address": " ",
         "Project Name": "RSC95-003, Camera 3 Cinemas",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "11/15/95",
         "Status": "Approved ",
         "Description": "Allow for the consumption of food and alcoholic beverages in the public right-of-way in the form of a sidewalk cafe. ",
         "Planner": "Mark Young ",
         "DURATION": 0,
         "Year": 1995
      },
      {
         "PERMITID": "RSC96-005",
         "APN": 46746030,
         "File Number": "RSC96-005",
         "Address": " ",
         "Project Name": "RSC96-005, Double Rainbow",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "9/8/96",
         "Status": "Approved ",
         "Description": "Allow for the consumption of food and beverages in the public right-of-way in the form of a sidewalk cafe. ",
         "Planner": "Martin Magana ",
         "DURATION": 0,
         "Year": 1996
      },
      {
         "PERMITID": "RSC97-003",
         "APN": 46722110,
         "File Number": "RSC97-003",
         "Address": " ",
         "Project Name": "RSC97-003, Cafe Zucco",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "4/29/97",
         "Status": "Approved ",
         "Description": "Allow for the consumption of food and alcoholic beverages in the public right-of-way in the form of a sidewalk cafe. ",
         "Planner": "Eric Keller ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RSC97-004",
         "APN": 46747003,
         "File Number": "RSC97-004",
         "Address": " ",
         "Project Name": "RSC97-004, Kismet The Gallery",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "4/30/97",
         "Status": "Approved ",
         "Description": "Allow for the consumption of food and beverages in the public right-of-way in the form of a sidewalk cafe. ",
         "Planner": "Eric Keller ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RSC97-007",
         "APN": 46722110,
         "File Number": "RSC97-007",
         "Address": " ",
         "Project Name": "RSC97-007, Speedsters",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "8/20/97",
         "Status": "Approved ",
         "Description": "Allow for the consumption of food and beverages in the public right-of-way in the form of a sidewalk cafe. ",
         "Planner": "Eric Keller ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RSC97-008",
         "APN": 25935051,
         "File Number": "RSC97-008",
         "Address": " ",
         "Project Name": "RSC97-008, Tied House",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "8/28/97",
         "Status": "Approved ",
         "Description": "Allow for the consumption of food and alcoholic beverages in the public right-of-way in the form of a sidewalk cafe. ",
         "Planner": "Eric Keller ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RSC97-009",
         "APN": 25935057,
         "File Number": "RSC97-009",
         "Address": " ",
         "Project Name": "RSC97-009, Spiedo's Restaurant",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "8/20/97",
         "Status": "Approved ",
         "Description": "Allow for the consumption of food and alcoholic beverages in the public right-of-way in the form of a sidewalk cafe. ",
         "Planner": "Martin Magana ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RSC97-011",
         "APN": 25935051,
         "File Number": "RSC97-011",
         "Address": " ",
         "Project Name": "RSC97-011, 71 Saint Peter Restaurant",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "9/3/97",
         "Status": "Approved ",
         "Description": "Allow for the consumption of food and alcoholic beverages in the public right-of-way in the form of a sidewalk cafe. ",
         "Planner": "Eric Keller ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RSC97-012",
         "APN": 25935057,
         "File Number": "RSC97-012",
         "Address": " ",
         "Project Name": "RSC97-012, Peggy Sue's",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "9/10/97",
         "Status": "Approved ",
         "Description": "Allow for the consumption of food and alcoholic beverages in the public right-of-way in the form of a sidewalk cafe. ",
         "Planner": "Eric Keller ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RSC97-013",
         "APN": 25934043,
         "File Number": "RSC97-013",
         "Address": " ",
         "Project Name": "RSC97-013, Rue de Paris",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "9/3/97",
         "Status": "Approved ",
         "Description": "Allow for the consumption of food and alcoholic beverages in the public right-of-way in the form of a sidewalk cafe. ",
         "Planner": "Eric Keller ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RSC97-014",
         "APN": 25935041,
         "File Number": "RSC97-014",
         "Address": " ",
         "Project Name": "RSC97-014, Old Spaghetti Factory",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "9/15/97",
         "Status": "Approved ",
         "Description": "Allow for the consumption of food and alcoholic beverages in the public right-of-way in the form of a sidewalk cafe. ",
         "Planner": "Martin Magana ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RSC97-015",
         "APN": 25935051,
         "File Number": "RSC97-015",
         "Address": " ",
         "Project Name": "RSC97-015, Shark & Rose Restaurant",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "8/25/97",
         "Status": "Approved ",
         "Description": "Allow for the consumption of food and alcoholic beverages in the public right-of-way in the form of a sidewalk cafe. ",
         "Planner": "Martin Magana ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RSC98-002",
         "APN": 25930046,
         "File Number": "RSC98-002",
         "Address": " ",
         "Project Name": "RSC98-002, Henry's Hi-Life",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "6/25/98",
         "Status": "Approved ",
         "Description": "Allow for the consumption of food and alcoholic beverages in the public right-of-way in the form of a sidewalk cafe. ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "RSC99-001",
         "APN": 25941086,
         "File Number": "RSC99-001",
         "Address": " ",
         "Project Name": "RSC99-001, Cafe 1850",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "2/8/99",
         "Status": "Approved ",
         "Description": "Allow for the consumption of food and alcoholic beverages in the public right-of-way in the form of a sidewalk cafe. ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RSC99-001",
         "APN": 25941087,
         "File Number": "RSC99-001",
         "Address": " ",
         "Project Name": "RSC99-001, Cafe 1850",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "2/8/99",
         "Status": "Approved ",
         "Description": "Allow for the consumption of food and alcoholic beverages in the public right-of-way in the form of a sidewalk cafe. ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RSC99-003",
         "APN": 46721005,
         "File Number": "RSC99-003",
         "Address": " ",
         "Project Name": "RSC99-003, LaBella Cafe",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "6/30/99",
         "Status": "Approved ",
         "Description": "Allow for the consumption of food and beverages in the public right-of-way in the form of a sidewalk cafe. ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RSC99-004",
         "APN": 25933050,
         "File Number": "RSC99-004",
         "Address": " ",
         "Project Name": "RSC99-004, Trials Pub",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "6/21/99",
         "Status": "Approved ",
         "Description": "Allow for the consumption of food and alcoholic beverages in the public right-of-way in the form of a sidewalk cafe. ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RSC99-006",
         "APN": 26429058,
         "File Number": "RSC99-006",
         "Address": " ",
         "Project Name": "RSC99-006, Phoenix Cafe",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "9/27/99",
         "Status": "Approved ",
         "Description": "Allow for the consumption of food and beverages in the public right-of-way in the form of a sidewalk cafe. ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "SC04-001",
         "APN": 46746105,
         "File Number": "SC04-001",
         "Address": "201 S 2ND ST SAN JOSE",
         "Project Name": "SC04-001, Camera Pavilion S 2nd St",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "6/17/04",
         "Status": "Approved ",
         "Description": "Sidewalk Cafe Permit to allow outdoor seating for an existing cafe (Camera Cafe) on a 0.9 gross acre site",
         "Planner": "MNAGARAJ ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "SC05-001",
         "APN": 25934043,
         "File Number": "SC05-001",
         "Address": "19 N MARKET ST SAN JOSE",
         "Project Name": "SC05-001",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "3/24/05",
         "Status": "Approved ",
         "Description": "Sidewalk Cafe Permit Application to install a 185 square foot sidewalk cafe",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 61,
         "Year": 2005
      },
      {
         "PERMITID": "SC05-003",
         "APN": 25940050,
         "File Number": "SC05-003",
         "Address": "43 POST ST SAN JOSE",
         "Project Name": "SC05-003",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "8/16/05",
         "Status": "Approved ",
         "Description": "Sidewalk Cafe Permit to allow up to 3 tables with 9 seats on an existing restaurant front sidewalk on a 0.03 gross acre site",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 41,
         "Year": 2005
      },
      {
         "PERMITID": "SC05-004",
         "APN": 46722127,
         "File Number": "SC05-004",
         "Address": "97 S 2ND ST SAN JOSE",
         "Project Name": "SC05-004",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "10/25/05",
         "Status": "Approved ",
         "Description": "Sidewalk Cafe Permit to allow up to 5 tables (about 184 sq.ft.) on the sidewalk in front of an existing coffee shop on a 0.26 gross acre site",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 51,
         "Year": 2005
      },
      {
         "PERMITID": "SC06-003",
         "APN": 25935020,
         "File Number": "SC06-003",
         "Address": "225 W SANTA CLARA ST SAN JOSE",
         "Project Name": "SC06-003 Amici's Pizzeria",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "5/16/06",
         "Status": "Approved ",
         "Description": "Sidewalk Cafe Permit to allow approximately 600 sq. ft. of outdoor seating at a restaurant on a 1.34 gross acre site",
         "Planner": "Michelle Stahlhut ",
         "DURATION": 22,
         "Year": 2006
      },
      {
         "PERMITID": "SC06-005",
         "APN": 46722008,
         "File Number": "SC06-005",
         "Address": "56 S 1ST ST SAN JOSE",
         "Project Name": "SC06-005 Bella Mia",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "7/6/06",
         "Status": "Approved ",
         "Description": "Sidewalk Cafe Permit to allow approximately 300 square feet of outdoor seating at an existing restaurant on a 0.14 gross acre site",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 18,
         "Year": 2006
      },
      {
         "PERMITID": "SC06-007",
         "APN": 46723035,
         "File Number": "SC06-007",
         "Address": "142 E SANTA CLARA ST SAN JOSE",
         "Project Name": "SC06-007 4th St Pizza",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "8/18/06",
         "Status": "Approved ",
         "Description": "Sidewalk Cafe Permit to allow 5 tables with 10 seats in the public right-of-way in front of an existing eating establishment from 11:00 a.m. to 12:00 midnight daily on a 0.13 gross acre site",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 115,
         "Year": 2006
      },
      {
         "PERMITID": "SC06-008",
         "APN": 25940066,
         "File Number": "SC06-008",
         "Address": "110 S MARKET ST SAN JOSE",
         "Project Name": "SC06-008 Cafe Too",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "9/14/06",
         "Status": "Approved ",
         "Description": "Sidewalk Cafe Permit to allow removable barriers to enclose an existing outdoor seating area on a 0.28 gross acre site",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 35,
         "Year": 2006
      },
      {
         "PERMITID": "SC06-009",
         "APN": 46762017,
         "File Number": "SC06-009",
         "Address": "8 S 1ST ST SAN JOSE",
         "Project Name": "SC06-009 Studio 8/Vivid Nightclub",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "9/14/06",
         "Status": "Approved ",
         "Description": "Sidewalk Cafe Permit to allow approximately 780 sq. ft. outdoor seating area on a 0.39 gross acre site",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 139,
         "Year": 2006
      },
      {
         "PERMITID": "SC06-014",
         "APN": 25940086,
         "File Number": "SC06-014",
         "Address": "60 S MARKET ST SAN JOSE",
         "Project Name": "SC06-014 A Perfect Finish",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "12/8/06",
         "Status": "Approved ",
         "Description": "Sidewalk Cafe Permit to allow consumption of food and beverages in the public right-of-way from 11:00 AM to 2:00 AM seven days per week on a 0.14 gross acre site",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 105,
         "Year": 2006
      },
      {
         "PERMITID": "SC07-001",
         "APN": 46722110,
         "File Number": "SC07-001",
         "Address": "78 S 1ST ST SAN JOSE",
         "Project Name": "SC07-001 Maui Wowi",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "2/15/07",
         "Status": "Approved ",
         "Description": "Sidewalk Cafe Permit for Maui Wowi ",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 40,
         "Year": 2007
      },
      {
         "PERMITID": "SC07-002",
         "APN": 25940045,
         "File Number": "SC07-002",
         "Address": "37 S 1ST ST SAN JOSE",
         "Project Name": "SC07-002 Good Karma",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "2/15/07",
         "Status": "Approved ",
         "Description": "Sidewalk Cafe Permit for Good Karma ",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 130,
         "Year": 2007
      },
      {
         "PERMITID": "SC07-006",
         "APN": 46724069,
         "File Number": "SC07-006",
         "Address": "304 E SANTA CLARA ST SAN JOSE",
         "Project Name": "SC07-006 Saigon 75",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "4/20/07",
         "Status": "Approved ",
         "Description": "Sidewalk Cafe Permit to allow outdoor seating for an existing restaurant ",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 74,
         "Year": 2007
      },
      {
         "PERMITID": "SC07-011",
         "APN": 46724069,
         "File Number": "SC07-011",
         "Address": "304 E SANTA CLARA ST SAN JOSE",
         "Project Name": "SC07-011 Hawaiian Drive-in",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "9/21/07",
         "Status": "Approved ",
         "Description": "Sidewalk Cafe Permit to add two tables on the sidewalk in front of an existing restaurant ",
         "Planner": "Ella Samonsky ",
         "DURATION": 89,
         "Year": 2007
      },
      {
         "PERMITID": "SC08-003",
         "APN": 46747089,
         "File Number": "SC08-003",
         "Address": "420 S 1ST ST SAN JOSE",
         "Project Name": "SC08-003 - South First Billiards",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "5/20/08",
         "Status": "Approved ",
         "Description": "Sidewalk Cafe Permit to allow outdoor seating for the consumption of food and alcoholic drinks in the public right-of-way along South 1st Street.",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 112,
         "Year": 2008
      },
      {
         "PERMITID": "SC08-006",
         "APN": 46722158,
         "File Number": "SC08-006",
         "Address": "30 E SANTA CLARA ST SAN JOSE",
         "Project Name": "SC08-006 - Popeyes Chicken & Biscuits",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "6/10/08",
         "Status": "Approved ",
         "Description": "Sidewalk Cafe Permit to allow outdoor seating for the consumption of food and non-alcoholic drinks in the public right-of-way along Santa Clara Street ",
         "Planner": "Ella Samonsky ",
         "DURATION": 148,
         "Year": 2008
      },
      {
         "PERMITID": "SC08-007",
         "APN": 25941068,
         "File Number": "SC08-007",
         "Address": "185 PARK AV SAN JOSE",
         "Project Name": "SC08-007 - Swirls Frozen Dairy & Juice Bar",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "6/24/08",
         "Status": "Approved ",
         "Description": "Sidewalk Cafe Permit to allow outdoor seating for the consumption of food and non-alcoholic drinks in the public right-of-way along Park Avenue ",
         "Planner": "Ella Samonsky ",
         "DURATION": 134,
         "Year": 2008
      },
      {
         "PERMITID": "SC09-002",
         "APN": 46722141,
         "File Number": "SC09-002",
         "Address": "150 S 1ST ST SAN JOSE",
         "Project Name": "SC09-002 - Johnny Rockets",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "2/10/09",
         "Status": "Approved ",
         "Description": "Sidewalk Cafe Permit to allow outdoor seating for the consumption of food and non-alcoholic drinks in the public right-of-way along Paseo de San Antonio ",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "SC09-003",
         "APN": 46722141,
         "File Number": "SC09-003",
         "Address": "150 S 1ST ST SAN JOSE",
         "Project Name": "SC09-003 - Baja Fresh",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "2/10/09",
         "Status": "Approved ",
         "Description": "Sidewalk Cafe Permit to allow outdoor seating for the consumption of food and non-alcoholic drinks in the public right-of-way along Paseo de San Antonio ",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 70,
         "Year": 2009
      },
      {
         "PERMITID": "SC09-004",
         "APN": 46722141,
         "File Number": "SC09-004",
         "Address": "150 S 1ST ST SAN JOSE",
         "Project Name": "SC09-004 - Sandella's",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "2/10/09",
         "Status": "Approved ",
         "Description": "Sidewalk Cafe Permit to allow outdoor seating for the consumption of food and non-alcoholic drinks in the public right-of-way along Paseo de San Antonio ",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 71,
         "Year": 2009
      },
      {
         "PERMITID": "SC09-005",
         "APN": 25935056,
         "File Number": "SC09-005",
         "Address": "73 N SAN PEDRO ST SAN JOSE",
         "Project Name": "SC09-005 - The Old Wagon Saloon & Grill",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "2/25/09",
         "Status": "Approved ",
         "Description": "Sidewalk Cafe Permit to allow outdoor seating for the consumption of food and alcoholic drinks in the public right-of-way along North San Pedro Street ",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 55,
         "Year": 2009
      },
      {
         "PERMITID": "SC09-011",
         "APN": 25934028,
         "File Number": "SC09-011",
         "Address": "80 N MARKET ST SAN JOSE",
         "Project Name": "SC09-011 - Gumbo Jumbo",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "5/29/09",
         "Status": "Approved ",
         "Description": "Sidewalk Cafe Permit to allow outdoor seating for the consumption of food and alcoholic drinks in the public right-of-way along North Market Street ",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 357,
         "Year": 2009
      },
      {
         "PERMITID": "SC09-013",
         "APN": 46762017,
         "File Number": "SC09-013",
         "Address": "8 S 1ST ST SAN JOSE",
         "Project Name": "SC09-013 - Studio 8 Nightclub",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "6/23/09",
         "Status": "Approved ",
         "Description": "Sidewalk Cafe Permit RENEWAL (see CP09-029) for an existing nightclub.",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 217,
         "Year": 2009
      },
      {
         "PERMITID": "SC10-001",
         "APN": 46722141,
         "File Number": "SC10-001",
         "Address": "150 S 1ST ST SAN JOSE",
         "Project Name": "SC10-001 - IceBee Yogurt",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "2/25/10",
         "Status": "Approved ",
         "Description": "Sidewalk Cafe permit to allow a 12-seating for IceBee Yogurt on 2.47 gross acre",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 15,
         "Year": 2010
      },
      {
         "PERMITID": "SC11-002",
         "APN": 25935009,
         "File Number": "SC11-002",
         "Address": "87 N SAN PEDRO ST SAN JOSE",
         "Project Name": "SC11-002 - Market at San Pedro Square (Multiple Tenants)",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "5/6/11",
         "Status": "Approved ",
         "Description": "Sidewalk Cafe will be in conjunction with the restaurant tenants and related uses for service of food, non-alcoholic and alcoholic beverages during the all hours of the San Pedro Square Market  ",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 125,
         "Year": 2011
      },
      {
         "PERMITID": "SC11-002",
         "APN": 25935013,
         "File Number": "SC11-002",
         "Address": "87 N SAN PEDRO ST SAN JOSE",
         "Project Name": "SC11-002 - Market at San Pedro Square (Multiple Tenants)",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "5/6/11",
         "Status": "Approved ",
         "Description": "Sidewalk Cafe will be in conjunction with the restaurant tenants and related uses for service of food, non-alcoholic and alcoholic beverages during the all hours of the San Pedro Square Market  ",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 125,
         "Year": 2011
      },
      {
         "PERMITID": "SC11-002",
         "APN": 25935045,
         "File Number": "SC11-002",
         "Address": "87 N SAN PEDRO ST SAN JOSE",
         "Project Name": "SC11-002 - Market at San Pedro Square (Multiple Tenants)",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "5/6/11",
         "Status": "Approved ",
         "Description": "Sidewalk Cafe will be in conjunction with the restaurant tenants and related uses for service of food, non-alcoholic and alcoholic beverages during the all hours of the San Pedro Square Market  ",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 125,
         "Year": 2011
      },
      {
         "PERMITID": "SC11-002",
         "APN": 25935050,
         "File Number": "SC11-002",
         "Address": "87 N SAN PEDRO ST SAN JOSE",
         "Project Name": "SC11-002 - Market at San Pedro Square (Multiple Tenants)",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "5/6/11",
         "Status": "Approved ",
         "Description": "Sidewalk Cafe will be in conjunction with the restaurant tenants and related uses for service of food, non-alcoholic and alcoholic beverages during the all hours of the San Pedro Square Market  ",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 125,
         "Year": 2011
      },
      {
         "PERMITID": "SC11-004",
         "APN": 25935013,
         "File Number": "SC11-004",
         "Address": "87 N SAN PEDRO ST SAN JOSE",
         "Project Name": "SC11-004 - Wine Bar on San Pedro St.",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "5/11/11",
         "Status": "Approved ",
         "Description": "Sidewalk Cafe to allow 12-seating for an existing restaurant, Wine Bar, in the DC Downtown Zoning District",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 89,
         "Year": 2011
      },
      {
         "PERMITID": "SC13-004",
         "APN": 25935013,
         "File Number": "SC13-004",
         "Address": "87 N SAN PEDRO ST SAN JOSE",
         "Project Name": "SC13-004 - Vino Vino",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "5/14/13",
         "Status": "Approved ",
         "Description": "Sidewalk Cafe to allow 12-seating for an existing restaurant, Vino Vino, in the DC Downtown Zoning District",
         "Planner": "Kristinae Toomians ",
         "DURATION": 52,
         "Year": 2013
      },
      {
         "PERMITID": "SC14-003",
         "APN": 46722158,
         "File Number": "SC14-003",
         "Address": "30 E SANTA CLARA ST SAN JOSE",
         "Project Name": "SC14-003",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "5/20/14",
         "Status": "Approved ",
         "Description": "Sidewalk Cafe Permit for 1 building with 6 tenant spaces fronting E. Santa Clara St. and Fountain Alley",
         "Planner": "Jennifer Piozet ",
         "DURATION": 627,
         "Year": 2014
      },
      {
         "PERMITID": "SC14-011",
         "APN": 46746045,
         "File Number": "SC14-011",
         "Address": "380 S 1ST ST SAN JOSE",
         "Project Name": "SC14-011",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "10/29/14 11:23",
         "Status": "Approved ",
         "Description": "Sidewalk Café for Metro Newspaper ",
         "Planner": "John Tu ",
         "DURATION": 86,
         "Year": 2014
      },
      {
         "PERMITID": "SC16-002",
         "APN": 25930046,
         "File Number": "SC16-002",
         "Address": "301 W ST JOHN ST SAN JOSE",
         "Project Name": "SC16-002",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "2/9/16 14:41",
         "Status": "Approved ",
         "Description": "Sidewalk Café Permit to allow outdoor seating for an existing full-service restaurant (Henry's Hi-Life) on a 0.22 gross acre site in the Light Industrial Zoning District",
         "Planner": "David Fong ",
         "DURATION": 129,
         "Year": 2016
      },
      {
         "PERMITID": "SC18-010",
         "APN": 25941088,
         "File Number": "SC18-010",
         "Address": "172 S MARKET ST SAN JOSE",
         "Project Name": "SC18-010",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "12/12/18 10:56",
         "Status": "Approved ",
         "Description": "Sidewalk Cafe Permit to allow a sidewalk café for an existing restaurant in the public right-of-way ",
         "Planner": "Rina Shah ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "SC08-001",
         "APN": 46722158,
         "File Number": "SC08-001",
         "Address": "30 E SANTA CLARA ST SAN JOSE",
         "Project Name": "SC08-001 - Penguin Cafe",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "4/15/08",
         "Status": "Approved with Conditions ",
         "Description": "Sidewalk Cafe Permit to allow outdoor seating for the consumption of food and non-alcoholic drinks in the public right-of-way for Penguin Cafe. ",
         "Planner": "Darryl Boyd ",
         "DURATION": 114,
         "Year": 2008
      },
      {
         "PERMITID": "SC15-005",
         "APN": 46722158,
         "File Number": "SC15-005",
         "Address": "30 E SANTA CLARA ST SAN JOSE",
         "Project Name": "SC15-005",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "8/20/15 10:47",
         "Status": "Approved with Conditions ",
         "Description": "Sidewalk Cafe Permit for outdoor seating at an existing full-service restaurant, Curry Pundits, in the DC Downtown Commercial Zoning District. ",
         "Planner": "Jennifer Piozet ",
         "DURATION": 1,
         "Year": 2015
      },
      {
         "PERMITID": "SC15-006",
         "APN": 46722158,
         "File Number": "SC15-006",
         "Address": "30 E SANTA CLARA ST SAN JOSE",
         "Project Name": "SC15-006",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "8/20/15 10:54",
         "Status": "Approved with Conditions ",
         "Description": "Sidewalk Cafe Permit for outdoor seating at an existing full-service restaurant, City Fish Corp, in the DC Downtown Commercial Zoning District. ",
         "Planner": "Jennifer Piozet ",
         "DURATION": 1,
         "Year": 2015
      },
      {
         "PERMITID": "SC15-007",
         "APN": 46722158,
         "File Number": "SC15-007",
         "Address": "30 E SANTA CLARA ST SAN JOSE",
         "Project Name": "SC15-007",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "8/20/15 11:01",
         "Status": "Approved with Conditions ",
         "Description": "Sidewalk Cafe Permit for outdoor seating at an existing full-service restaurant, Garlic Bread, in the DC Downtown Commercial Zoning District. ",
         "Planner": "Jennifer Piozet ",
         "DURATION": 1,
         "Year": 2015
      },
      {
         "PERMITID": "SC08-005",
         "APN": 46722031,
         "File Number": "SC08-005",
         "Address": "83 S 2ND ST SAN JOSE",
         "Project Name": "SC08-005 - Tres Gringos",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "6/2/08",
         "Status": "Complete ",
         "Description": "Sidewalk Cafe Permit to allow outdoor seating for the consumption of food and drinks in the public right-of-way along South 2nd Street.",
         "Planner": "Darryl Boyd ",
         "DURATION": 30,
         "Year": 2008
      },
      {
         "PERMITID": "SC08-009",
         "APN": 25940064,
         "File Number": "SC08-009",
         "Address": "99 S 1ST ST SAN JOSE",
         "Project Name": "SC08-009 - Billy Berk's",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "8/6/08",
         "Status": "Complete ",
         "Description": "Sidewalk Cafe Permit to allow outdoor seating for the consumption of food and alcoholic drinks for a bar/restaurant in the public right-of-way along South 1st Street",
         "Planner": "Darryl Boyd ",
         "DURATION": 57,
         "Year": 2008
      },
      {
         "PERMITID": "SC08-014",
         "APN": 46722158,
         "File Number": "SC08-014",
         "Address": "30 E SANTA CLARA ST SAN JOSE",
         "Project Name": "SC08-014 - Extreme Pizza",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "10/31/08",
         "Status": "Complete ",
         "Description": "Sidewalk Cafe Permit to allow outdoor seating for the consumption of food and alcoholic drinks in the public right-of-way along Santa Clara Street ",
         "Planner": "Ella Samonsky ",
         "DURATION": 87,
         "Year": 2008
      },
      {
         "PERMITID": "SC08-015",
         "APN": 46764005,
         "File Number": "SC08-015",
         "Address": "100 S 2ND ST Unit C-106 SAN JOSE",
         "Project Name": "SC08-015 - Safeway @ The 88",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "11/7/08",
         "Status": "Complete ",
         "Description": "Sidewalk Cafe Permit to allow outdoor seating for the consumption of food and non-alcoholic drinks in the public right-of-way along South 2nd Street",
         "Planner": "Ella Samonsky ",
         "DURATION": 281,
         "Year": 2008
      },
      {
         "PERMITID": "SC08-015",
         "APN": 46764010,
         "File Number": "SC08-015",
         "Address": "100 S 2ND ST Unit C-106 SAN JOSE",
         "Project Name": "SC08-015 - Safeway @ The 88",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "11/7/08",
         "Status": "Complete ",
         "Description": "Sidewalk Cafe Permit to allow outdoor seating for the consumption of food and non-alcoholic drinks in the public right-of-way along South 2nd Street",
         "Planner": "Ella Samonsky ",
         "DURATION": 281,
         "Year": 2008
      },
      {
         "PERMITID": "SC08-016",
         "APN": 46723100,
         "File Number": "SC08-016",
         "Address": "88 S 4TH ST SAN JOSE",
         "Project Name": "SC08-016 - Flames Eatery & Bar",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "11/12/08",
         "Status": "Complete ",
         "Description": "(FEE NOT PAID) Sidewalk Cafe Permit to allow outdoor seating for the consumption of food and alcoholic drinks in the public right-of-way along East San Fernando Street ",
         "Planner": "Darryl Boyd ",
         "DURATION": 19,
         "Year": 2008
      },
      {
         "PERMITID": "SC08-016",
         "APN": 46723101,
         "File Number": "SC08-016",
         "Address": "88 S 4TH ST SAN JOSE",
         "Project Name": "SC08-016 - Flames Eatery & Bar",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "11/12/08",
         "Status": "Complete ",
         "Description": "(FEE NOT PAID) Sidewalk Cafe Permit to allow outdoor seating for the consumption of food and alcoholic drinks in the public right-of-way along East San Fernando Street ",
         "Planner": "Darryl Boyd ",
         "DURATION": 19,
         "Year": 2008
      },
      {
         "PERMITID": "SC09-006",
         "APN": 26429057,
         "File Number": "SC09-006",
         "Address": "315 S 1ST ST SAN JOSE",
         "Project Name": "SC09-006 - Original Joe's",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "3/20/09",
         "Status": "Complete ",
         "Description": "Sidewalk Cafe Permit to allow outdoor seating for the consumption of food and alcoholic drinks in the public right-of-way along South 1st Street",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 391,
         "Year": 2009
      },
      {
         "PERMITID": "SC15-008",
         "APN": 46722158,
         "File Number": "SC15-008",
         "Address": "30 E SANTA CLARA ST SAN JOSE",
         "Project Name": "SC15-008",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "8/20/15 11:08",
         "Status": "Inactive ",
         "Description": "Sidewalk Cafe Permit for outdoor seating at an existing full-service restaurant, Red Rose Restaurant & Catering, in the DC Downtown Commercial Zoning District. ",
         "Planner": "Jennifer Piozet ",
         "DURATION": 69,
         "Year": 2015
      },
      {
         "PERMITID": "SC15-009",
         "APN": 46722158,
         "File Number": "SC15-009",
         "Address": "30 E SANTA CLARA ST SAN JOSE",
         "Project Name": "SC15-009",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "8/20/15 11:19",
         "Status": "Inactive ",
         "Description": "Sidewalk Cafe Permit for outdoor seating at an existing full-service restaurant, Destiny's Attic, in the DC Downtown Commercial Zoning District. ",
         "Planner": "Jennifer Piozet ",
         "DURATION": 147,
         "Year": 2015
      },
      {
         "PERMITID": "SC13-012",
         "APN": 46723069,
         "File Number": "SC13-012",
         "Address": "32 S 3RD ST SAN JOSE",
         "Project Name": "SC13-012 Liquid",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "12/17/13",
         "Status": "Recomd Approval ",
         "Description": "Sidewalk Cafe Permit to allow outdoor seating for the consumption of food and non-alcoholic drinks in the public right-of-way along S. 3rd Street",
         "Planner": "Lea Simvoulakis ",
         "DURATION": 874,
         "Year": 2013
      },
      {
         "PERMITID": "SC18-001",
         "APN": 25934039,
         "File Number": "SC18-001",
         "Address": "45 N MARKET ST SAN JOSE",
         "Project Name": "SC18-001",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "3/20/18 14:07",
         "Status": "Recomd Approval ",
         "Description": "Sidewalk Café Permit to allow a parklet for retail establishments ",
         "Planner": "Stefanie Farmer ",
         "DURATION": 92,
         "Year": 2018
      },
      {
         "PERMITID": "SC18-003",
         "APN": 25940064,
         "File Number": "SC18-003",
         "Address": "25 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "SC18-003 - Mezcal",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "5/7/18 10:10",
         "Status": "Recomd Approval ",
         "Description": "Sidewalk Café to allow a sidewalk café for an existing restaurant, Mezcal Restaurant LLC, in the DC Zoning District  ",
         "Planner": "Stefanie Farmer ",
         "DURATION": 120,
         "Year": 2018
      },
      {
         "PERMITID": "SC18-006",
         "APN": 46747089,
         "File Number": "SC18-006",
         "Address": "420 S 1ST ST SAN JOSE",
         "Project Name": "SC18-006 - Forager",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "6/21/18 10:09",
         "Status": "Recomd Approval ",
         "Description": "Sidewalk Café to allow alcohol use on an existing parklet for an existing restaurant, Forager LLC, in the DC Downtown Primary Commercial Zoning District ",
         "Planner": "Ruth Cueto ",
         "DURATION": 56,
         "Year": 2018
      },
      {
         "PERMITID": "SC18-009",
         "APN": 25934043,
         "File Number": "SC18-009",
         "Address": "19 N MARKET ST SAN JOSE",
         "Project Name": "SC18-009 - Taco Bell",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "11/8/18 10:04",
         "Status": "Recomd Approval ",
         "Description": "Sidewalk Café to allow a sidewalk café for a future fast food, Taco Bell Cantina, in the DC Zoning District  ",
         "Planner": "Rina Shah ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "SC17-002",
         "APN": 25940093,
         "File Number": "SC17-002",
         "Address": "1 S MARKET ST SAN JOSE",
         "Project Name": "SC17-002",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "9/27/17",
         "Status": "Review Letter Sent ",
         "Description": "Sidewalk Café Permit to allow outdoor seating for a public eating establishment (Earl of Sandwich) on the ground floor of a residential building on a 0.97-gross acre site",
         "Planner": "Jennifer Piozet ",
         "DURATION": 39,
         "Year": 2017
      },
      {
         "PERMITID": "SC18-007",
         "APN": 46719075,
         "File Number": "SC18-007",
         "Address": "225 E SANTA CLARA ST SAN JOSE",
         "Project Name": "SC18-007 - Tandori Fusion Grill",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "7/20/18",
         "Status": "Review Letter Sent ",
         "Description": "Sidewalk Café Permit to allow a sidewalk café for a restaurant (Tandori Fusion Grill), on a 0.04 gross acre lot located in the DC Downtown Primary Commercial Zoning District.",
         "Planner": "Rhonda Buss ",
         "DURATION": 22,
         "Year": 2018
      },
      {
         "PERMITID": "SC14-008",
         "APN": 46721023,
         "File Number": "SC14-008",
         "Address": "2 N 1ST ST SAN JOSE",
         "Project Name": "SC14-008 - CAFE EDEN",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "7/30/14 10:08",
         "Status": "Under Review ",
         "Description": "Sidewalk Café for Café Eden ",
         "Planner": "Edward Schreiner ",
         "DURATION": 34,
         "Year": 2014
      },
      {
         "PERMITID": "RSC97-005",
         "APN": 25935035,
         "File Number": "RSC97-005",
         "Address": " ",
         "Project Name": "RSC97-005, A.P. Stumps",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "5/28/97",
         "Status": "Withdrawn ",
         "Description": "Allow for the consumption of food and beverages in the public right-of-way in the form of a sidewalk cafe. ",
         "Planner": "Eric Keller ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "SC03-001",
         "APN": 46724069,
         "File Number": "SC03-001",
         "Address": "304 E SANTA CLARA ST SAN JOSE",
         "Project Name": "SC03-001",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "8/6/03",
         "Status": "Withdrawn ",
         "Description": "Sidewalk Cafe Permit to allow outdoor seating at an existing restaurant (ASIAN GARDEN) on a 0.2 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 1708,
         "Year": 2003
      },
      {
         "PERMITID": "SC04-002",
         "APN": 46722137,
         "File Number": "SC04-002",
         "Address": "99 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "SC04-002",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "8/3/04",
         "Status": "Withdrawn ",
         "Description": "Sidewalk Cafe Permit to allow outdoor seating at a new restaurant on a 1.07 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2004
      },
      {
         "PERMITID": "SC07-004",
         "APN": 46722007,
         "File Number": "SC07-004",
         "Address": "52 S 1ST ST SAN JOSE",
         "Project Name": "SC07-004, The Temple Bar",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "3/16/07",
         "Status": "Withdrawn ",
         "Description": "Sidewalk Cafe Permit ",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "SC08-017",
         "APN": 46724069,
         "File Number": "SC08-017",
         "Address": "304 E SANTA CLARA ST SAN JOSE",
         "Project Name": "SC08-017 - Hawaiian Drive-In",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "12/9/08",
         "Status": "Withdrawn ",
         "Description": "Sidewalk Cafe Permit to allow outdoor seating for the consumption of food in the public right-of-way along South 7th Street",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "SC09-009",
         "APN": 46722110,
         "File Number": "SC09-009",
         "Address": "78 S 1ST ST SAN JOSE",
         "Project Name": "SC09-009",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "5/4/09",
         "Status": "Withdrawn ",
         "Description": "Sidewalk Cafe Permit to allow outdoor seating for the consumption of food and non-alcoholic drinks in the public right-of-way along South 1st Street",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 8,
         "Year": 2009
      },
      {
         "PERMITID": "SC13-010",
         "APN": 46722141,
         "File Number": "SC13-010",
         "Address": "150 S 1ST ST SAN JOSE",
         "Project Name": "SC13-010 - Thirst Tea",
         "Application Type": "Sidewalk Cafe ",
         "Application Date": "11/7/13",
         "Status": "Withdrawn ",
         "Description": "Sidewalk Cafe Permit to allow outdoor seating for the consumption of food and non-alcoholic drinks in the public right-of-way along Paseo de San Antonio ",
         "Planner": "Jennifer Piozet ",
         "DURATION": 25,
         "Year": 2013
      }
   ],
   "Sign Permit ": [
      {
         "PERMITID": "AD02-514",
         "APN": 46724069,
         "File Number": "AD02-514",
         "Address": "304 E SANTA CLARA ST SAN JOSE",
         "Project Name": "304 E SANTA CLARA ST",
         "Application Type": "Sign Permit ",
         "Application Date": "5/16/02",
         "Status": "Approved ",
         "Description": "Facade Upgrades and Sign Permis for 304-332 E. Santa Clara Street",
         "Planner": "John Davidson ",
         "DURATION": 2666,
         "Year": 2002
      },
      {
         "PERMITID": "AD02-691",
         "APN": 26420080,
         "File Number": "AD02-691",
         "Address": "482 W SAN CARLOS ST SAN JOSE",
         "Project Name": "AD02-691",
         "Application Type": "Sign Permit ",
         "Application Date": "6/26/02",
         "Status": "Approved ",
         "Description": " ",
         "Planner": "John Davidson ",
         "DURATION": 1,
         "Year": 2002
      },
      {
         "PERMITID": "AD03-019",
         "APN": 46724069,
         "File Number": "AD03-019",
         "Address": "304 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD03-019",
         "Application Type": "Sign Permit ",
         "Application Date": "1/12/03",
         "Status": "Approved ",
         "Description": "To allow two (2) attached signs - Asian Garden Restaurant Associated with AD02-514 for facade improvements",
         "Planner": "Akoni Danielsen ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "AD03-020",
         "APN": 46724038,
         "File Number": "AD03-020",
         "Address": "314 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD03-020",
         "Application Type": "Sign Permit ",
         "Application Date": "1/13/03",
         "Status": "Approved ",
         "Description": "314 UNIT A To allow one attached sign - Western Union Associated with AD02-514 for facade improvements",
         "Planner": "John Davidson ",
         "DURATION": 1,
         "Year": 2003
      },
      {
         "PERMITID": "AD03-036",
         "APN": 46724038,
         "File Number": "AD03-036",
         "Address": "314 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD03-036",
         "Application Type": "Sign Permit ",
         "Application Date": "1/14/03",
         "Status": "Approved ",
         "Description": "314 B East Santa Clara Street Refurbish existing fin sign. Associated with AD-02-514",
         "Planner": "John Davidson ",
         "DURATION": 1,
         "Year": 2003
      },
      {
         "PERMITID": "AD03-041",
         "APN": 46724038,
         "File Number": "AD03-041",
         "Address": "314 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD03-041",
         "Application Type": "Sign Permit ",
         "Application Date": "1/15/03",
         "Status": "Approved ",
         "Description": "314 B Santa Clara Street To allow one attached sign - HONG TAILOR & CLEANERS Associated with AD02-514",
         "Planner": "John Davidson ",
         "DURATION": 1,
         "Year": 2003
      },
      {
         "PERMITID": "AD03-042",
         "APN": 46724069,
         "File Number": "AD03-042",
         "Address": "304 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD03-042",
         "Application Type": "Sign Permit ",
         "Application Date": "1/15/03",
         "Status": "Approved ",
         "Description": "304 B East Santa Clara Street To allow one attached sign - CALI BAKERY & SANDWICHES Associated with AD02-514",
         "Planner": "John Davidson ",
         "DURATION": 1,
         "Year": 2003
      },
      {
         "PERMITID": "AD03-044",
         "APN": 46724069,
         "File Number": "AD03-044",
         "Address": "304 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD03-044",
         "Application Type": "Sign Permit ",
         "Application Date": "1/15/03",
         "Status": "Approved ",
         "Description": "304 C EAST SANTA CLARA STREET To allow one attached sign - Blank face Associated with AD02-514",
         "Planner": "John Davidson ",
         "DURATION": 1,
         "Year": 2003
      },
      {
         "PERMITID": "AD03-045",
         "APN": 46724069,
         "File Number": "AD03-045",
         "Address": "304 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD03-045",
         "Application Type": "Sign Permit ",
         "Application Date": "1/15/03",
         "Status": "Approved ",
         "Description": "304 D East Santa Clara Street but faces on S. 7th Street To allow one Attached sign - JOYERIA DEIRA Associated with AD02-514",
         "Planner": "John Davidson ",
         "DURATION": 1,
         "Year": 2003
      },
      {
         "PERMITID": "AD03-046",
         "APN": 46724069,
         "File Number": "AD03-046",
         "Address": "304 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD03-046",
         "Application Type": "Sign Permit ",
         "Application Date": "1/15/03",
         "Status": "Approved ",
         "Description": "304 E. SANTA CLARA ST. / SITE FACES S. 7TH ST. To allow one sign - DISCOTECA EXITOS DE AMERICA Associated with AD02-514",
         "Planner": "John Davidson ",
         "DURATION": 1,
         "Year": 2003
      },
      {
         "PERMITID": "AD03-1160",
         "APN": 46723100,
         "File Number": "AD03-1160",
         "Address": "88 S 4TH ST SAN JOSE",
         "Project Name": "AD03-1160",
         "Application Type": "Sign Permit ",
         "Application Date": "11/21/03",
         "Status": "Approved ",
         "Description": "SIGN PERMIT FOR NEW ATTACHED CABINET SIGN ",
         "Planner": "John Davidson ",
         "DURATION": 1,
         "Year": 2003
      },
      {
         "PERMITID": "AD03-1160",
         "APN": 46723101,
         "File Number": "AD03-1160",
         "Address": "88 S 4TH ST SAN JOSE",
         "Project Name": "AD03-1160",
         "Application Type": "Sign Permit ",
         "Application Date": "11/21/03",
         "Status": "Approved ",
         "Description": "SIGN PERMIT FOR NEW ATTACHED CABINET SIGN ",
         "Planner": "John Davidson ",
         "DURATION": 1,
         "Year": 2003
      },
      {
         "PERMITID": "AD04-1102",
         "APN": 46745028,
         "File Number": "AD04-1102",
         "Address": "312 S 3RD ST SAN JOSE",
         "Project Name": "AD04-1102",
         "Application Type": "Sign Permit ",
         "Application Date": "10/26/04",
         "Status": "Approved ",
         "Description": "One 2X3 feet sign attached to metal posts.",
         "Planner": "MNAGARAJ ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-1204",
         "APN": 25934053,
         "File Number": "AD04-1204",
         "Address": "111 N MARKET ST Bldg 1 SAN JOSE",
         "Project Name": "AD04-1204",
         "Application Type": "Sign Permit ",
         "Application Date": "11/29/04",
         "Status": "Approved ",
         "Description": "Sign permit for one attached channel letter sign for \"Baytek Mortgage Inc.\" ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-1268",
         "APN": 47217014,
         "File Number": "AD04-1268",
         "Address": "748 S 1ST ST SAN JOSE",
         "Project Name": "AD04-1268",
         "Application Type": "Sign Permit ",
         "Application Date": "12/22/04",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow one attached sign ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-498",
         "APN": 25934029,
         "File Number": "AD04-498",
         "Address": "84 N MARKET ST SAN JOSE",
         "Project Name": "AD04-498",
         "Application Type": "Sign Permit ",
         "Application Date": "5/20/04",
         "Status": "Approved ",
         "Description": "One attached 10sf sign on existing awning.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-525",
         "APN": 25942079,
         "File Number": "AD04-525",
         "Address": "211 S 1ST ST SAN JOSE",
         "Project Name": "(N) FIN AND WINDOW SIGNS ",
         "Application Type": "Sign Permit ",
         "Application Date": "5/25/04",
         "Status": "Approved ",
         "Description": "INSTALLATION OF ONE 1'-6\"x3'-0\" SINGLE-FACE PROJECTING SIGN PER ATTACHED PLANS; INSTALLATION OF EIGHTEEN SETS OF WINDOW VINYL GRAPHICS PER ATTACHED PLANS",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD04-974",
         "APN": 25935020,
         "File Number": "AD04-974",
         "Address": "225 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD04-974",
         "Application Type": "Sign Permit ",
         "Application Date": "9/27/04",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow one attached sign for \"CBRE CB RICHARD ELLIS\" on the west (Notre Dame) elevation of the Opus Bldg. (tenant occupies front half of 10th floor).",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2004
      },
      {
         "PERMITID": "AD05-1084",
         "APN": 26429107,
         "File Number": "AD05-1084",
         "Address": "302 S MARKET ST SAN JOSE",
         "Project Name": "AD05-1084",
         "Application Type": "Sign Permit ",
         "Application Date": "10/20/05",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow minor changes to a Legal Non-Conforming Sign located on the roof top of Sainte Claire.  ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2005
      },
      {
         "PERMITID": "AD05-1242",
         "APN": 46718090,
         "File Number": "AD05-1242",
         "Address": "301 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD05-1242",
         "Application Type": "Sign Permit ",
         "Application Date": "12/2/05",
         "Status": "Approved ",
         "Description": "3 attached signs for City Bakery and Cafe and new awnings",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2005
      },
      {
         "PERMITID": "AD05-258",
         "APN": 25940087,
         "File Number": "AD05-258",
         "Address": "160 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD05-258 Kinkos",
         "Application Type": "Sign Permit ",
         "Application Date": "3/21/05",
         "Status": "Approved ",
         "Description": "TWO NEW ATTACHED SIGNS 20 SQ FT IN TOTAL SIZE EACH",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2005
      },
      {
         "PERMITID": "AD05-651",
         "APN": 25940012,
         "File Number": "AD05-651",
         "Address": "70 S ALMADEN AV SAN JOSE",
         "Project Name": "AD05-651",
         "Application Type": "Sign Permit ",
         "Application Date": "6/29/05",
         "Status": "Approved ",
         "Description": "TWO NEW ATTACHED SIGNS FOR THE GREYHOUND STATION. OVERALL PROJECT INCLUDES A NUMBER OF DIRECTIONAL SIGNS, AND THE RESURFACE OF A NUMBER OF SIGNS.  ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2005
      },
      {
         "PERMITID": "AD05-973",
         "APN": 47226036,
         "File Number": "AD05-973",
         "Address": "520 S 1ST ST SAN JOSE",
         "Project Name": "AD05-973",
         "Application Type": "Sign Permit ",
         "Application Date": "9/22/05",
         "Status": "Approved ",
         "Description": "ONW NEW ATTACHED SIGN APPROX. 55 SQ FT IN SIZE ON THE FRONT FACADE OF A HISTORIC BUILDING.",
         "Planner": "Lee Butler ",
         "DURATION": 55,
         "Year": 2005
      },
      {
         "PERMITID": "AD06-1060",
         "APN": 25941068,
         "File Number": "AD06-1060",
         "Address": "185 PARK AV SAN JOSE",
         "Project Name": "AD06-1060 Manpower",
         "Application Type": "Sign Permit ",
         "Application Date": "9/20/06",
         "Status": "Approved ",
         "Description": "Sign permit adjustment to: (1) replace an existing attached sign with a 2'x14'-1\" attached illuminated channel letter sign reading \"Manpower\" with logo; and (2) replace an existing attached neon tube lighting logo with a 3'x3'-4\" non-illuminated flat mounted logo sign.",
         "Planner": "Lee Butler ",
         "DURATION": 0,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-1067",
         "APN": 25939115,
         "File Number": "AD06-1067",
         "Address": "99 ALMADEN BL SAN JOSE",
         "Project Name": "AD06-1067",
         "Application Type": "Sign Permit ",
         "Application Date": "9/22/06",
         "Status": "Approved ",
         "Description": "Install one double faced illuminated monument sign (18SQT Almaden frontage), one non-illuminated address monument sign (38.44SQFT Almaden frontage), two non-illuminated address signs (9.27SQFT and 9.27SQFT on Bldg99 over Private Walkway), and one non-illuminated directional sign (5.42SQFT at off-street entrance to Parking Lot) only.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-1140",
         "APN": 46722110,
         "File Number": "AD06-1140",
         "Address": "78 S 1ST ST SAN JOSE",
         "Project Name": "AD06-1140",
         "Application Type": "Sign Permit ",
         "Application Date": "10/6/06",
         "Status": "Approved ",
         "Description": "(N)27.53 SQFT attached LED channel letter sign mounted on raceway above awning.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-1221",
         "APN": 46745084,
         "File Number": "AD06-1221",
         "Address": "112 PASEO DE SAN ANTONIO SAN JOSE",
         "Project Name": "AD06-1221",
         "Application Type": "Sign Permit ",
         "Application Date": "10/25/06",
         "Status": "Approved ",
         "Description": "Sign Permit to allow three (3) awnings and two (2) awning signs for \"Family Life Chiropractic.\"",
         "Planner": "Lori Moniz ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-1245",
         "APN": 46723039,
         "File Number": "AD06-1245",
         "Address": "118 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD06-1245 Sprint",
         "Application Type": "Sign Permit ",
         "Application Date": "10/30/06",
         "Status": "Approved ",
         "Description": "Permit Adjustment for one 2.5'x8.51' attached sign reading \"Sprint\" with logo.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-1252",
         "APN": 25947030,
         "File Number": "AD06-1252",
         "Address": "503 W SAN CARLOS ST SAN JOSE",
         "Project Name": "AD06-1252",
         "Application Type": "Sign Permit ",
         "Application Date": "10/31/06",
         "Status": "Approved ",
         "Description": "SIgn permit and permit adjustment for a facade modifcation for exitsing Mudai Ethiopian Restaurant. Changes include new signs and new awnings and other minor modifications. ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-1357",
         "APN": 25939115,
         "File Number": "AD06-1357",
         "Address": "99 ALMADEN BL SAN JOSE",
         "Project Name": "AD06-1357",
         "Application Type": "Sign Permit ",
         "Application Date": "11/29/06",
         "Status": "Approved ",
         "Description": "Sign permit adjustment to install one 51 square foot detached address parking sign for the Almaden Financial Plaza",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-1431",
         "APN": 25940087,
         "File Number": "AD06-1431",
         "Address": "160 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD06-1431 LandAmerica",
         "Application Type": "Sign Permit ",
         "Application Date": "12/19/06",
         "Status": "Approved ",
         "Description": "Sign Permit Adjustment for one 33.75 square foot attached sign reading \"LandAmerica Commonwealth\" with logo. Individual halo illuminated letters and logo.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-181",
         "APN": 25940091,
         "File Number": "AD06-181",
         "Address": "55 S MARKET ST SAN JOSE",
         "Project Name": "AD06-181",
         "Application Type": "Sign Permit ",
         "Application Date": "2/23/06",
         "Status": "Approved ",
         "Description": "Sign permit adjustment for two signs (one illuminated attached, one fin) for Rokko Japanese Cuisine at ground floor of Market Post Tower ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-190",
         "APN": 25939120,
         "File Number": "AD06-190",
         "Address": "95 S ALMADEN AV SAN JOSE",
         "Project Name": "AD06-190",
         "Application Type": "Sign Permit ",
         "Application Date": "2/24/06",
         "Status": "Approved ",
         "Description": "ONE TEN SQUARE-FOOT ATTACHED SIGN  ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-296",
         "APN": 25935045,
         "File Number": "AD06-296",
         "Address": "170 W ST JOHN ST SAN JOSE",
         "Project Name": "AD06-296",
         "Application Type": "Sign Permit ",
         "Application Date": "3/28/06",
         "Status": "Approved ",
         "Description": "Sign permit adjustment for two attached exterior illuminated signs (30 & 20 SF) for Taste Ultra Lounge",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-426",
         "APN": 25941086,
         "File Number": "AD06-426",
         "Address": "50 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD06-426",
         "Application Type": "Sign Permit ",
         "Application Date": "4/27/06",
         "Status": "Approved ",
         "Description": "Two attached 10- sq. ft. signs on two seperate 24 linear foot and 14 linear foot occupancy frontages as shown on plan set.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-426",
         "APN": 25941087,
         "File Number": "AD06-426",
         "Address": "50 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD06-426",
         "Application Type": "Sign Permit ",
         "Application Date": "4/27/06",
         "Status": "Approved ",
         "Description": "Two attached 10- sq. ft. signs on two seperate 24 linear foot and 14 linear foot occupancy frontages as shown on plan set.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-509",
         "APN": 46746106,
         "File Number": "AD06-509",
         "Address": "350 S 2ND ST SAN JOSE",
         "Project Name": "AD06-509",
         "Application Type": "Sign Permit ",
         "Application Date": "5/19/06",
         "Status": "Approved ",
         "Description": "Sign Permit to allow four attached new reverse LED-illuminated channel letter signs and non-illuminated aluminum letters to read \"YWCA of Silicon Valley\" measuring 35.34 square-feet, \"YWCA Childcare Center\" measuring 9.5 square feet, \"YWCA Childcare Center\" measuring 12 square feet, and \"YWCA Childcare Center\" measuring 10 square feet on 0.82 gross acres.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-543",
         "APN": 25935020,
         "File Number": "AD06-543",
         "Address": "225 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD06-543",
         "Application Type": "Sign Permit ",
         "Application Date": "5/26/06",
         "Status": "Approved ",
         "Description": "Three attached signs including two 2.8 square-foot signs over entry doors and one 77 square foot vertical fin sign as shown on plans.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-591",
         "APN": 46723100,
         "File Number": "AD06-591",
         "Address": "88 S 4TH ST SAN JOSE",
         "Project Name": "AD06-591",
         "Application Type": "Sign Permit ",
         "Application Date": "6/7/06",
         "Status": "Approved ",
         "Description": "To allow one attached sign for the \"San Jose Credit Union\" ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-591",
         "APN": 46723101,
         "File Number": "AD06-591",
         "Address": "88 S 4TH ST SAN JOSE",
         "Project Name": "AD06-591",
         "Application Type": "Sign Permit ",
         "Application Date": "6/7/06",
         "Status": "Approved ",
         "Description": "To allow one attached sign for the \"San Jose Credit Union\" ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-644",
         "APN": 26420125,
         "File Number": "AD06-644",
         "Address": "602 W SAN CARLOS ST SAN JOSE",
         "Project Name": "AD06-644",
         "Application Type": "Sign Permit ",
         "Application Date": "6/16/06",
         "Status": "Approved ",
         "Description": "Sign Permit Adjustment for the installation of signs (four new canopy signs, one new freestanding monument sign, one new secondary price sign, and replacement of two attached building signs), replace dispenser graphics, repaint building stripes and add a new fascia to the existing canopies. ",
         "Planner": "Lee Butler ",
         "DURATION": 0,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-659",
         "APN": 25934053,
         "File Number": "AD06-659",
         "Address": "111 N MARKET ST Bldg 1 SAN JOSE",
         "Project Name": "AD06-659",
         "Application Type": "Sign Permit ",
         "Application Date": "6/20/06",
         "Status": "Approved ",
         "Description": "One attached halo-lit channel sign for \"America's Realty,\" with face-lit pan channel logo with solid aluminum back to prevent light into windows. ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-766",
         "APN": 46723100,
         "File Number": "AD06-766",
         "Address": "88 S 4TH ST SAN JOSE",
         "Project Name": "AD06-766",
         "Application Type": "Sign Permit ",
         "Application Date": "7/10/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for one (1) single-face internally illuminated sign cabinet attached to existing soffit frame. (San Jose Credit Union)",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-766",
         "APN": 46723101,
         "File Number": "AD06-766",
         "Address": "88 S 4TH ST SAN JOSE",
         "Project Name": "AD06-766",
         "Application Type": "Sign Permit ",
         "Application Date": "7/10/06",
         "Status": "Approved ",
         "Description": "Permit adjustment for one (1) single-face internally illuminated sign cabinet attached to existing soffit frame. (San Jose Credit Union)",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "AD06-933",
         "APN": 46747004,
         "File Number": "AD06-933",
         "Address": "452 S 1ST ST SAN JOSE",
         "Project Name": "AD06-933",
         "Application Type": "Sign Permit ",
         "Application Date": "8/18/06",
         "Status": "Approved ",
         "Description": "Sign Permit Adjustment for one 1'-2\"x10'-9\" attached sign reading \"SanJose.com.\" Painted bubble mural above attached sign is not considered a sign.",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2006
      },
      {
         "PERMITID": "AD07-016",
         "APN": 25944080,
         "File Number": "AD07-016",
         "Address": "111 ALMADEN BL SAN JOSE",
         "Project Name": "AD07-016",
         "Application Type": "Sign Permit ",
         "Application Date": "1/8/07",
         "Status": "Approved ",
         "Description": "Sign Permit Adjustment to replace one existing attached sign with one new 48 square foot attached sign reading \"Pacific Gas and Electric Company Customer Center\" with logo. Illuminated box sign.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-030",
         "APN": 25939122,
         "File Number": "AD07-030",
         "Address": "10 ALMADEN BL SAN JOSE",
         "Project Name": "AD07-030",
         "Application Type": "Sign Permit ",
         "Application Date": "1/10/07",
         "Status": "Approved ",
         "Description": "Installation of one 4ft x 1.83ft stainless steel non illuminated attached sign on Almaden frontage and one 4ft x 1.83ft stainless steel non illuminated attached sign on Post frontage.",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-039",
         "APN": 25936074,
         "File Number": "AD07-039",
         "Address": "333 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD07-039",
         "Application Type": "Sign Permit ",
         "Application Date": "1/12/07",
         "Status": "Approved ",
         "Description": "Sign Permit to allow one (1) fin sign for Comerica Bank.",
         "Planner": "Lori Moniz ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-1038",
         "APN": 25941086,
         "File Number": "AD07-1038",
         "Address": "50 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD07-1038",
         "Application Type": "Sign Permit ",
         "Application Date": "8/28/07",
         "Status": "Approved ",
         "Description": "Sign Permit to allow one (1), attached,16 square-foot, non-illuminated, channel letter sign for \"Accenture.\"",
         "Planner": "Lori Moniz ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-1038",
         "APN": 25941087,
         "File Number": "AD07-1038",
         "Address": "50 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD07-1038",
         "Application Type": "Sign Permit ",
         "Application Date": "8/28/07",
         "Status": "Approved ",
         "Description": "Sign Permit to allow one (1), attached,16 square-foot, non-illuminated, channel letter sign for \"Accenture.\"",
         "Planner": "Lori Moniz ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-1041",
         "APN": 46723039,
         "File Number": "AD07-1041",
         "Address": "118 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD07-1041 California Check Cashing",
         "Application Type": "Sign Permit ",
         "Application Date": "8/29/07",
         "Status": "Approved ",
         "Description": "Sign Permit Adjustment for one individual internally illuminated sign of 20 square feet attached on a raceway above storefront, for California Check Cashing.",
         "Planner": "Lori Moniz ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-106",
         "APN": 46723096,
         "File Number": "AD07-106",
         "Address": "140 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD07-106",
         "Application Type": "Sign Permit ",
         "Application Date": "1/29/07",
         "Status": "Approved ",
         "Description": "Installation of two attached, illuminated 31 square foot signs (one on north elevation and one on east elevation at corner) and one non illuminated 4.83 square foot under canopy sign.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-106",
         "APN": 46759110,
         "File Number": "AD07-106",
         "Address": "140 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD07-106",
         "Application Type": "Sign Permit ",
         "Application Date": "1/29/07",
         "Status": "Approved ",
         "Description": "Installation of two attached, illuminated 31 square foot signs (one on north elevation and one on east elevation at corner) and one non illuminated 4.83 square foot under canopy sign.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-1081",
         "APN": 46746109,
         "File Number": "AD07-1081",
         "Address": "98 PASEO DE SAN ANTONIO SAN JOSE",
         "Project Name": "AD07-1081 Rosies & Posies",
         "Application Type": "Sign Permit ",
         "Application Date": "9/7/07",
         "Status": "Approved ",
         "Description": "Sign Permit Adjustment for one aluminum panel sign with individual halo-illuminated letters attached above main storefront entry, for Rosies & Posies Downtown Florist. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-129",
         "APN": 47226036,
         "File Number": "AD07-129",
         "Address": "520 S 1ST ST SAN JOSE",
         "Project Name": "AD07-129",
         "Application Type": "Sign Permit ",
         "Application Date": "2/5/07",
         "Status": "Approved ",
         "Description": "Sign Permit Adjustment to add signage on five new awnings on the City Landmark Costa/Miller Building, HL01-128. Signs read \"San Jose Museum of Quilts and Textiles\" with logo.",
         "Planner": "Darren McBain ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-1352",
         "APN": 46720072,
         "File Number": "AD07-1352",
         "Address": "103 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD07-1352",
         "Application Type": "Sign Permit ",
         "Application Date": "10/29/07",
         "Status": "Approved ",
         "Description": "One attached sign for Subways. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-1373",
         "APN": 25939115,
         "File Number": "AD07-1373",
         "Address": "99 ALMADEN BL SAN JOSE",
         "Project Name": "AD07-1373",
         "Application Type": "Sign Permit ",
         "Application Date": "11/2/07",
         "Status": "Approved ",
         "Description": "Sign Permit Adjustment to allow one 229 square foot internally illuminated channel letter skyline sign on northwest building elevation.",
         "Planner": "Sylvia Do ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-1374",
         "APN": 26420132,
         "File Number": "AD07-1374",
         "Address": "350 BIRD AV SAN JOSE",
         "Project Name": "AD07-1374",
         "Application Type": "Sign Permit ",
         "Application Date": "11/5/07",
         "Status": "Approved ",
         "Description": "Sign Permit Adjustment to allow two signs, one reverse pan channel aluminum letter attached sign with neon (interior letter) illuminated of approximately 22.75 square feet that reads \"Moda Italia, Fine Men's Wear; one fin brushed aluminum sign of approximately 3.66 square feet, that read \"Moda Italia Fine Men's Wear\" and projects approximately 2' 9\" from the wall and is located 8' 6\" feet above grade.",
         "Planner": "Sylvia Do ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-1378",
         "APN": 25941090,
         "File Number": "AD07-1378",
         "Address": "170 S MARKET ST SAN JOSE",
         "Project Name": "AD07-1378",
         "Application Type": "Sign Permit ",
         "Application Date": "11/6/07",
         "Status": "Approved ",
         "Description": "Sign Permit Adjustment to allow one 23.12 square foot fin sign and one 80.8 square foot internally illuminated channel letters and canopy sign reading \"Bijan Bakery & Cafe European Pastries.\"",
         "Planner": "Sylvia Do ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-1378",
         "APN": 25956001,
         "File Number": "AD07-1378",
         "Address": "170 S MARKET ST SAN JOSE",
         "Project Name": "AD07-1378",
         "Application Type": "Sign Permit ",
         "Application Date": "11/6/07",
         "Status": "Approved ",
         "Description": "Sign Permit Adjustment to allow one 23.12 square foot fin sign and one 80.8 square foot internally illuminated channel letters and canopy sign reading \"Bijan Bakery & Cafe European Pastries.\"",
         "Planner": "Sylvia Do ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-1378",
         "APN": 25956002,
         "File Number": "AD07-1378",
         "Address": "170 S MARKET ST SAN JOSE",
         "Project Name": "AD07-1378",
         "Application Type": "Sign Permit ",
         "Application Date": "11/6/07",
         "Status": "Approved ",
         "Description": "Sign Permit Adjustment to allow one 23.12 square foot fin sign and one 80.8 square foot internally illuminated channel letters and canopy sign reading \"Bijan Bakery & Cafe European Pastries.\"",
         "Planner": "Sylvia Do ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-1378",
         "APN": 25956003,
         "File Number": "AD07-1378",
         "Address": "170 S MARKET ST SAN JOSE",
         "Project Name": "AD07-1378",
         "Application Type": "Sign Permit ",
         "Application Date": "11/6/07",
         "Status": "Approved ",
         "Description": "Sign Permit Adjustment to allow one 23.12 square foot fin sign and one 80.8 square foot internally illuminated channel letters and canopy sign reading \"Bijan Bakery & Cafe European Pastries.\"",
         "Planner": "Sylvia Do ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-1468",
         "APN": 46722142,
         "File Number": "AD07-1468",
         "Address": "8 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD07-1468",
         "Application Type": "Sign Permit ",
         "Application Date": "11/26/07",
         "Status": "Approved ",
         "Description": "Sign Permit Adjustment to allow one projected light sign ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-187",
         "APN": 25935020,
         "File Number": "AD07-187",
         "Address": "225 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD07-187",
         "Application Type": "Sign Permit ",
         "Application Date": "2/20/07",
         "Status": "Approved ",
         "Description": "Permit adjustment for one 80 square foot interior illuminated cabinet sign for Deloitte on an existing office building in the DC zoning district",
         "Planner": "Darren McBain ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-227",
         "APN": 25943075,
         "File Number": "AD07-227",
         "Address": "333 W SAN CARLOS ST SAN JOSE",
         "Project Name": "AD07-227 Acer",
         "Application Type": "Sign Permit ",
         "Application Date": "3/2/07",
         "Status": "Approved ",
         "Description": "Sign Permit Adjustment to allow one skyline sign (64 square feet) consisting of individual internally illuminated pan channel letters for Acer.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763001,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763002,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763004,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763005,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763006,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763007,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763008,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763010,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763011,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763014,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763015,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763016,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763017,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763018,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763019,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763020,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763024,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763025,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763026,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763027,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763028,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763029,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763030,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763032,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763033,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763034,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763036,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763037,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763038,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763039,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763040,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763041,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763042,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763043,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763047,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763049,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763050,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763051,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763052,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763053,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763054,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763055,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763056,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763057,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763058,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763059,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763060,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763061,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763063,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763064,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763067,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763068,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763070,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763071,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763072,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763074,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763075,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763076,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-285",
         "APN": 46763077,
         "File Number": "AD07-285",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "AD07-285",
         "Application Type": "Sign Permit ",
         "Application Date": "3/19/07",
         "Status": "Approved ",
         "Description": "Proposal to allow two attached signs ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-312",
         "APN": 26420080,
         "File Number": "AD07-312",
         "Address": "482 W SAN CARLOS ST SAN JOSE",
         "Project Name": "AD07-312 - Chapman Properties",
         "Application Type": "Sign Permit ",
         "Application Date": "3/23/07",
         "Status": "Approved ",
         "Description": "Sign Permit for two (2), attached, metal, stud-mounted, non-illuminated, signs for \"Chapman Properties.\"",
         "Planner": "Lori Moniz ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-343",
         "APN": 25930088,
         "File Number": "AD07-343",
         "Address": "200 N ALMADEN BL SAN JOSE",
         "Project Name": "AD07-343 Mortgage Outlet",
         "Application Type": "Sign Permit ",
         "Application Date": "4/2/07",
         "Status": "Approved ",
         "Description": "Sign Permit Adjustment to allow one 45.6 square foot internally illuminated channel letter sign reading \"TMO THE MORTGAGE OUTLET\" located on the building elevation at the corner of W. Julian Street and N. Almaden Boulevard.",
         "Planner": "Lori Moniz ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-392",
         "APN": 46722148,
         "File Number": "AD07-392",
         "Address": "78 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD07-392",
         "Application Type": "Sign Permit ",
         "Application Date": "4/11/07",
         "Status": "Approved ",
         "Description": "Sign Permit for one attached fin sign. ",
         "Planner": "Lori Moniz ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-455",
         "APN": 47226033,
         "File Number": "AD07-455",
         "Address": "560 S 1ST ST SAN JOSE",
         "Project Name": "AD07-455",
         "Application Type": "Sign Permit ",
         "Application Date": "4/23/07",
         "Status": "Approved ",
         "Description": "Sign Permit for one attached sign (\"San Jose Institute of Contemporary Art\") and one fin sign (\"ICA\"). ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-463",
         "APN": 24946061,
         "File Number": "AD07-463",
         "Address": "153 E JULIAN ST SAN JOSE",
         "Project Name": "AD07-463",
         "Application Type": "Sign Permit ",
         "Application Date": "4/24/07",
         "Status": "Approved ",
         "Description": "Sign Permit to allow two (2), attached, non-illuminated, aluminum signs for \"Vu Bail Bonds.\"",
         "Planner": "Lori Moniz ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-513",
         "APN": 25947013,
         "File Number": "AD07-513",
         "Address": "491 W SAN CARLOS ST SAN JOSE",
         "Project Name": "AD07-513",
         "Application Type": "Sign Permit ",
         "Application Date": "5/7/07",
         "Status": "Approved ",
         "Description": "Sign permit for one fin sign. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-636",
         "APN": 25930088,
         "File Number": "AD07-636",
         "Address": "200 N ALMADEN BL SAN JOSE",
         "Project Name": "AD07-636",
         "Application Type": "Sign Permit ",
         "Application Date": "6/4/07",
         "Status": "Approved ",
         "Description": "Sign Permit for one attached, individually illuminated channel letter sign for \"The Mortgage Outlet.\" The sign (indicated as \"B1\" on the approved plan set) is attached to the building''s northwest elevation, facing West Julian Street.",
         "Planner": "Lesley Xavier ",
         "DURATION": 24,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-762",
         "APN": 26429118,
         "File Number": "AD07-762",
         "Address": "389 S 1ST ST SAN JOSE",
         "Project Name": "AD07-762 Motif",
         "Application Type": "Sign Permit ",
         "Application Date": "7/3/07",
         "Status": "Approved ",
         "Description": "Sign Permit Adjustment for two attached signs and one fin sign using exposed neon, for Motif. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "AD07-948",
         "APN": 25940094,
         "File Number": "AD07-948",
         "Address": "35 S MARKET ST SAN JOSE",
         "Project Name": "AD07-948 Xactly",
         "Application Type": "Sign Permit ",
         "Application Date": "8/15/07",
         "Status": "Approved ",
         "Description": "Sign Permit Adjustment for two aluminum fabricated signs attached to a metal beam at two occupancy frontages of a historic Downtown Commercial building located in the DC Downtown Core Zoning District, for Xactly. ",
         "Planner": "John Kim ",
         "DURATION": 1,
         "Year": 2007
      },
      {
         "PERMITID": "AD08-1181",
         "APN": 25940019,
         "File Number": "AD08-1181",
         "Address": "167 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD08-1181",
         "Application Type": "Sign Permit ",
         "Application Date": "10/6/08",
         "Status": "Approved ",
         "Description": "Sign permit Adjustment Request to install (1)one attached illuminated flat mounted sign 27 square feet and (2) one fin sign 4.5 square feet in area for a proposed restaurant",
         "Planner": "Lee Butler ",
         "DURATION": 0,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-1184",
         "APN": 46722158,
         "File Number": "AD08-1184",
         "Address": "30 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD08-1184",
         "Application Type": "Sign Permit ",
         "Application Date": "10/7/08",
         "Status": "Approved ",
         "Description": "Sign permit Adjustment Request to install (1) one attached illuminated attached sign 15.6 square feet and (2) one fin sign 3.14 square feet in area for a proposed restaurant, POPEYES LOUISIANA KITCHEN.",
         "Planner": "Lee Butler ",
         "DURATION": 0,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-1277",
         "APN": 46722141,
         "File Number": "AD08-1277",
         "Address": "150 S 1ST ST SAN JOSE",
         "Project Name": "AD08-1277",
         "Application Type": "Sign Permit ",
         "Application Date": "11/3/08",
         "Status": "Approved ",
         "Description": "Sign Permit Adjustment to allow one attached, internally sign (approximately 40.5 square feet in area) on an existing commercial building as shown on the approved Permit Adjustment Plans only.",
         "Planner": "Jeff Roche ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-1314",
         "APN": 25940064,
         "File Number": "AD08-1314",
         "Address": "25 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD08-1314",
         "Application Type": "Sign Permit ",
         "Application Date": "11/14/08",
         "Status": "Approved ",
         "Description": "Sign Permit Adjustment to allow two attached signs only (The first sign is a fin/ blade sign that is approximately 2.25 square feet in area. The second sign is an internally illuminated sign that is approximately 24.8 square feet in area.)",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 0,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-1344",
         "APN": 46722158,
         "File Number": "AD08-1344",
         "Address": "30 E SANTA CLARA ST SAN JOSE",
         "Project Name": "Extreme Pizza Downtown ",
         "Application Type": "Sign Permit ",
         "Application Date": "11/24/08",
         "Status": "Approved ",
         "Description": "Sign permit Adjustment request to install (1) one attached illuminated attached sign 19'6\" square feet and (2) one fin sign 6.3 square feet in area for an existing take-out/east-in restaurant, Extreme Pizza",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-1347",
         "APN": 25931071,
         "File Number": "AD08-1347",
         "Address": "255 W JULIAN ST SAN JOSE",
         "Project Name": "AD08-1347",
         "Application Type": "Sign Permit ",
         "Application Date": "11/25/08",
         "Status": "Approved ",
         "Description": "One (1) set of Skyline sign \"CreaTV San Jose\" 88.3sqft in area, facing West Julian Street.",
         "Planner": "Lee Butler ",
         "DURATION": 0,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-1372",
         "APN": 25943074,
         "File Number": "AD08-1372",
         "Address": "300 PARK AV SAN JOSE",
         "Project Name": "AD08-1372",
         "Application Type": "Sign Permit ",
         "Application Date": "12/4/08",
         "Status": "Approved ",
         "Description": "Concrete pavement with scoring pattern to replace the approved stone pavement; and to move the utilities from its approved location to consolidate it in an area below the planter grade within the planter area at the north west corner of the property.  ",
         "Planner": "MNAGARAJ ",
         "DURATION": 0,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-230",
         "APN": 46720084,
         "File Number": "AD08-230",
         "Address": "152 N 3RD ST SAN JOSE",
         "Project Name": "AD08-230",
         "Application Type": "Sign Permit ",
         "Application Date": "1/31/08",
         "Status": "Approved ",
         "Description": "Sign Permit Adjustment request for 2 new detached signs, one on each occupancy frontage.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-247",
         "APN": 25934028,
         "File Number": "AD08-247",
         "Address": "80 N MARKET ST SAN JOSE",
         "Project Name": "AD08-247 Gumbo Jumbo",
         "Application Type": "Sign Permit ",
         "Application Date": "2/6/08",
         "Status": "Approved ",
         "Description": "Sign Permit Adjustment for one individual internally illuminated channel letter sign mounted on a raceway and one logo sign, attached above the storefront, for Gumbo Jumbo Cajun Fusion. ",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-305",
         "APN": 25941068,
         "File Number": "AD08-305",
         "Address": "185 PARK AV SAN JOSE",
         "Project Name": "AD08-305 Swirls",
         "Application Type": "Sign Permit ",
         "Application Date": "2/27/08",
         "Status": "Approved ",
         "Description": "Sign Permit Adjustment for one internally illuminated fin sign of approximately 15 square feet, attached above storefront, for Swirls juice bar.",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-352",
         "APN": 46747053,
         "File Number": "AD08-352",
         "Address": "487 S 4TH ST SAN JOSE",
         "Project Name": "AD08-352",
         "Application Type": "Sign Permit ",
         "Application Date": "3/11/08",
         "Status": "Approved ",
         "Description": "Sign Permit to allow a 24.75-square-foot, internally-illuminated, fin sign for \"Spartan Barber.\"",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-443",
         "APN": 25941088,
         "File Number": "AD08-443",
         "Address": "172 S MARKET ST SAN JOSE",
         "Project Name": "AD08-443 - Fin sign for The Grill",
         "Application Type": "Sign Permit ",
         "Application Date": "4/4/08",
         "Status": "Approved ",
         "Description": "Sign Permit to allow the replacement of the existing fin sign with a new 12 square foot fin sign in the same location and to allow the addition of neon striping on the existing awning for \"The Grill\".",
         "Planner": "Lori Moniz ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-714",
         "APN": 25941067,
         "File Number": "AD08-714",
         "Address": "170 PARK CENTER PLAZA SAN JOSE",
         "Project Name": "AD08-714",
         "Application Type": "Sign Permit ",
         "Application Date": "6/5/08",
         "Status": "Approved ",
         "Description": "This Sign Permit Adjustment is to allow 9 monument signs and 3 directory signs changing Park Center Plaza to Cityview Plaza, only",
         "Planner": "Lesley Xavier ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-785",
         "APN": 46747103,
         "File Number": "AD08-785",
         "Address": "496 S 3RD ST SAN JOSE",
         "Project Name": "AD08-785",
         "Application Type": "Sign Permit ",
         "Application Date": "6/18/08",
         "Status": "Approved ",
         "Description": "Sign Permit Adjustment to allow one detached non-illuminated sign, approximately 23.85 square feet in area on a low wall at an existing attached residential project only.",
         "Planner": "Jeff Roche ",
         "DURATION": 1,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-846",
         "APN": 46722158,
         "File Number": "AD08-846",
         "Address": "30 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD08-846 (Penguin Froyo)",
         "Application Type": "Sign Permit ",
         "Application Date": "7/3/08",
         "Status": "Approved ",
         "Description": "Sign permit to allow one attached sign approx. 16 sq ft",
         "Planner": "John Davidson ",
         "DURATION": 0,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-883",
         "APN": 46759111,
         "File Number": "AD08-883",
         "Address": "110 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD08-883 Cafe Yolicious",
         "Application Type": "Sign Permit ",
         "Application Date": "7/11/08",
         "Status": "Approved ",
         "Description": "Sign Permit Adjustment for one individual internally illuminated channel letter sign of approximately 26 square feet attached above a storefront on a raceway; and refacing of an existing arcade sign, for Cafe Yolicious.",
         "Planner": "Lee Butler ",
         "DURATION": 0,
         "Year": 2008
      },
      {
         "PERMITID": "AD08-991",
         "APN": 46721023,
         "File Number": "AD08-991",
         "Address": "2 N 1ST ST SAN JOSE",
         "Project Name": "AD08-991",
         "Application Type": "Sign Permit ",
         "Application Date": "8/6/08",
         "Status": "Approved ",
         "Description": "Sign Permit Adjustment request for one (1) new, internally illuminated, channel letter, attached sign.",
         "Planner": "Lee Butler ",
         "DURATION": 0,
         "Year": 2008
      },
      {
         "PERMITID": "AD09-020",
         "APN": 46723100,
         "File Number": "AD09-020",
         "Address": "88 S 4TH ST SAN JOSE",
         "Project Name": "AD09-020",
         "Application Type": "Sign Permit ",
         "Application Date": "1/9/09",
         "Status": "Approved ",
         "Description": "Attached light box sign (45 SF; 3' x 15') for FLAMES facing 4th Street.",
         "Planner": "Suzanne Thomas ",
         "DURATION": 11,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-020",
         "APN": 46723101,
         "File Number": "AD09-020",
         "Address": "88 S 4TH ST SAN JOSE",
         "Project Name": "AD09-020",
         "Application Type": "Sign Permit ",
         "Application Date": "1/9/09",
         "Status": "Approved ",
         "Description": "Attached light box sign (45 SF; 3' x 15') for FLAMES facing 4th Street.",
         "Planner": "Suzanne Thomas ",
         "DURATION": 11,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-031",
         "APN": 25940087,
         "File Number": "AD09-031",
         "Address": "160 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD09-031",
         "Application Type": "Sign Permit ",
         "Application Date": "1/13/09",
         "Status": "Approved ",
         "Description": "Sign Permit Adjustment request for two attached signs, (1)one 63 sqft sign with halo-lit channel letters on top of existing cabinet/raceway located on the north-west facade (Santa Clara St) and (2)one 18 sqft sign with halo-lit channel letters, and a raceway cabinet box 9'-3\"x3'1.75\"x9.5\" to match the architectural panels on the north east facade (S San Pedro St.) for Fremont Bank, per approved plans only.",
         "Planner": "Suzanne Thomas ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-078",
         "APN": 25935056,
         "File Number": "AD09-078",
         "Address": "73 N SAN PEDRO ST SAN JOSE",
         "Project Name": "AD09-078",
         "Application Type": "Sign Permit ",
         "Application Date": "1/27/09",
         "Status": "Approved ",
         "Description": "One fin sign 'OLD WAGON SALOON AND GRILL' made out of wood and rough iron 6-0' in diameter at a height of 11-0' from the side walk and an attached sign of a waggon iron cut silhouette 5.5' X 3.0' in size.",
         "Planner": "MNAGARAJ ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-1021",
         "APN": 46723100,
         "File Number": "AD09-1021",
         "Address": "88 S 4TH ST SAN JOSE",
         "Project Name": "AD09-1021",
         "Application Type": "Sign Permit ",
         "Application Date": "11/18/09",
         "Status": "Approved ",
         "Description": "PROPOSED EXTERIOR SIGN \"FLAMES RESTAURANT\" ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-1021",
         "APN": 46723101,
         "File Number": "AD09-1021",
         "Address": "88 S 4TH ST SAN JOSE",
         "Project Name": "AD09-1021",
         "Application Type": "Sign Permit ",
         "Application Date": "11/18/09",
         "Status": "Approved ",
         "Description": "PROPOSED EXTERIOR SIGN \"FLAMES RESTAURANT\" ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-1055",
         "APN": 46722141,
         "File Number": "AD09-1055",
         "Address": "150 S 1ST ST SAN JOSE",
         "Project Name": "AD09-1055",
         "Application Type": "Sign Permit ",
         "Application Date": "12/3/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment for one attached sign (IceBee Yogurt) approx. 44.63 square feet in size and one fin sign measuring apprx. 30 square feet in size.",
         "Planner": "Jeff Roche ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-181",
         "APN": 25943074,
         "File Number": "AD09-181",
         "Address": "300 PARK AV SAN JOSE",
         "Project Name": "AD09-181",
         "Application Type": "Sign Permit ",
         "Application Date": "2/25/09",
         "Status": "Approved ",
         "Description": "Sign program for Riverpark Towers ",
         "Planner": "John Davidson ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-181",
         "APN": 25943075,
         "File Number": "AD09-181",
         "Address": "300 PARK AV SAN JOSE",
         "Project Name": "AD09-181",
         "Application Type": "Sign Permit ",
         "Application Date": "2/25/09",
         "Status": "Approved ",
         "Description": "Sign program for Riverpark Towers ",
         "Planner": "John Davidson ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-343",
         "APN": 25940041,
         "File Number": "AD09-343",
         "Address": "15 S 1ST ST SAN JOSE",
         "Project Name": "AD09-343",
         "Application Type": "Sign Permit ",
         "Application Date": "4/8/09",
         "Status": "Approved ",
         "Description": "Sign Permit to allow one attached wall sign and one fin sign for \"Carl's Jr.\" in the downtown sign zone ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-378",
         "APN": 25941086,
         "File Number": "AD09-378",
         "Address": "50 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-378",
         "Application Type": "Sign Permit ",
         "Application Date": "4/17/09",
         "Status": "Approved ",
         "Description": "Sign Permit Adjustment to allow two attached signs, one palque sign 5 .9 sq. ft, and one attached sign 5.9 sq.ft. in the Downtown Area",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-378",
         "APN": 25941087,
         "File Number": "AD09-378",
         "Address": "50 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-378",
         "Application Type": "Sign Permit ",
         "Application Date": "4/17/09",
         "Status": "Approved ",
         "Description": "Sign Permit Adjustment to allow two attached signs, one palque sign 5 .9 sq. ft, and one attached sign 5.9 sq.ft. in the Downtown Area",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-450",
         "APN": 25939115,
         "File Number": "AD09-450",
         "Address": "99 ALMADEN BL SAN JOSE",
         "Project Name": "AD09-450",
         "Application Type": "Sign Permit ",
         "Application Date": "5/8/09",
         "Status": "Approved ",
         "Description": "Sign Permit Adjustment to allow replament of two existing attached signs with two new (2) attached cabinets, ilumminated signs approximately 248 and 115 sq. ft in sizes for a commercial building in the DC Zoning District.",
         "Planner": "Jeff Roche ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-610",
         "APN": 46764005,
         "File Number": "AD09-610",
         "Address": "100 S 2ND ST Unit C-106 SAN JOSE",
         "Project Name": "AD09-610, Safeway - Tower 88",
         "Application Type": "Sign Permit ",
         "Application Date": "6/30/09",
         "Status": "Approved ",
         "Description": "Nine (9) sets of attached, illuminated channel letter signs.",
         "Planner": "Mike Enderby ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-610",
         "APN": 46764010,
         "File Number": "AD09-610",
         "Address": "100 S 2ND ST Unit C-106 SAN JOSE",
         "Project Name": "AD09-610, Safeway - Tower 88",
         "Application Type": "Sign Permit ",
         "Application Date": "6/30/09",
         "Status": "Approved ",
         "Description": "Nine (9) sets of attached, illuminated channel letter signs.",
         "Planner": "Mike Enderby ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-662",
         "APN": 25941086,
         "File Number": "AD09-662",
         "Address": "50 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-662",
         "Application Type": "Sign Permit ",
         "Application Date": "7/21/09",
         "Status": "Approved ",
         "Description": "Sign Permit Adjustment to allow the removal of existing attached signage and the installation of (4) new, attached signs (each illuminated and approximately 28-square feet in size) as shown on the approved Permit Adjustment plans only.",
         "Planner": "Jeff Roche ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-662",
         "APN": 25941087,
         "File Number": "AD09-662",
         "Address": "50 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD09-662",
         "Application Type": "Sign Permit ",
         "Application Date": "7/21/09",
         "Status": "Approved ",
         "Description": "Sign Permit Adjustment to allow the removal of existing attached signage and the installation of (4) new, attached signs (each illuminated and approximately 28-square feet in size) as shown on the approved Permit Adjustment plans only.",
         "Planner": "Jeff Roche ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-683",
         "APN": 25941057,
         "File Number": "AD09-683",
         "Address": "125 S MARKET ST SAN JOSE",
         "Project Name": "AD09-683",
         "Application Type": "Sign Permit ",
         "Application Date": "7/23/09",
         "Status": "Approved ",
         "Description": "Sign Permit to allow three attached cabinet wall signs (one on each of three occupancy frontages) for an existing commercial building  ",
         "Planner": "Lee Butler ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-891",
         "APN": 25940043,
         "File Number": "AD09-891",
         "Address": "27 S 1ST ST SAN JOSE",
         "Project Name": "AD09-891 Ross Dress for Less",
         "Application Type": "Sign Permit ",
         "Application Date": "10/5/09",
         "Status": "Approved ",
         "Description": "Proposed signs six (6) signs: three internally illuminated Porte-cochere signs 17.2 sqft; Two (2) fin signs facing South1st Street 10.5 sqft each; and one (1) Flat attached sign facing Lightstone Alley 130 sqft in area.",
         "Planner": "Mike Enderby ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-922",
         "APN": 25935020,
         "File Number": "AD09-922",
         "Address": "225 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD09-922 - Deloitte Skyline Sign",
         "Application Type": "Sign Permit ",
         "Application Date": "10/14/09",
         "Status": "Approved ",
         "Description": "Sign Permit Adjustment to allow the installation of one internally illuminated channel letter sign on the fascia on top of an existing building on a 1.26 gross acre site",
         "Planner": "Mike Enderby ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-982",
         "APN": 46722141,
         "File Number": "AD09-982",
         "Address": "150 S 1ST ST SAN JOSE",
         "Project Name": "AD09-982",
         "Application Type": "Sign Permit ",
         "Application Date": "11/2/09",
         "Status": "Approved ",
         "Description": "Sign Permit to allow two (2) sets of attached interior, illuminated, individual channel lettered signs 36.3 square feet each in the Downtown (Pavilion) as shown on the plans only.",
         "Planner": "Suparna Saha ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD09-997",
         "APN": 25941068,
         "File Number": "AD09-997",
         "Address": "185 PARK AV SAN JOSE",
         "Project Name": "AD09-997",
         "Application Type": "Sign Permit ",
         "Application Date": "11/6/09",
         "Status": "Approved ",
         "Description": "Permit Adjustment for one (1) attached sign (Silk Road).",
         "Planner": "Mike Enderby ",
         "DURATION": 1,
         "Year": 2009
      },
      {
         "PERMITID": "AD10-004",
         "APN": 46745069,
         "File Number": "AD10-004",
         "Address": "345 S 4TH ST SAN JOSE",
         "Project Name": "AD10-004",
         "Application Type": "Sign Permit ",
         "Application Date": "1/4/10",
         "Status": "Approved ",
         "Description": "Permit for two (2) attached signs measuring 36 square feet and 16 square in size.",
         "Planner": "Mike Enderby ",
         "DURATION": 1,
         "Year": 2010
      },
      {
         "PERMITID": "AD10-021",
         "APN": 46722158,
         "File Number": "AD10-021",
         "Address": "30 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD10-021",
         "Application Type": "Sign Permit ",
         "Application Date": "1/13/10",
         "Status": "Approved ",
         "Description": "Sign Permit Adjustment to allow an attached (approximately 17-square feet in size) internally illuminated sign on an existing commercial building as shown on the approved Permit Adjustment plans only.",
         "Planner": "Jeff Roche ",
         "DURATION": 1,
         "Year": 2010
      },
      {
         "PERMITID": "AD10-090",
         "APN": 25941068,
         "File Number": "AD10-090",
         "Address": "185 PARK AV SAN JOSE",
         "Project Name": "AD10-090",
         "Application Type": "Sign Permit ",
         "Application Date": "2/9/10",
         "Status": "Approved ",
         "Description": "SIGN PERMIT ADJUSTMENT TO ALLOW ONE ATTACHED INTERNALLY ILLUMINATED SIGN, APPROXIMATELY 28 SQUARE FEET IN SIZE ON AN EXISTING COMMERCIAL BUILDING AS SHOWN ON THE APPROVED PERMIT ADJUSTMENT PLANS ONLY.",
         "Planner": "Jeff Roche ",
         "DURATION": 0,
         "Year": 2010
      },
      {
         "PERMITID": "AD10-097",
         "APN": 46723089,
         "File Number": "AD10-097",
         "Address": "100 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD10-097",
         "Application Type": "Sign Permit ",
         "Application Date": "2/11/10",
         "Status": "Approved ",
         "Description": "Sign Permit to install a new canopy with signage and a new blade/vertical sign (Innovation Center).  ",
         "Planner": "Jeff Roche ",
         "DURATION": 0,
         "Year": 2010
      },
      {
         "PERMITID": "AD10-310",
         "APN": 25942079,
         "File Number": "AD10-310",
         "Address": "211 S 1ST ST SAN JOSE",
         "Project Name": "AD10-310",
         "Application Type": "Sign Permit ",
         "Application Date": "4/29/10",
         "Status": "Approved ",
         "Description": "Permit to install eight (8) attached and detached signs and three (3) flag poles for an existing hotel (Four Points by Sheraton).",
         "Planner": "John Davidson ",
         "DURATION": 0,
         "Year": 2010
      },
      {
         "PERMITID": "AD10-355",
         "APN": 25947083,
         "File Number": "AD10-355",
         "Address": "475 W SAN CARLOS ST Bldg 1 SAN JOSE",
         "Project Name": "AD10-355",
         "Application Type": "Sign Permit ",
         "Application Date": "5/13/10",
         "Status": "Approved ",
         "Description": "Permit to install two (2) approximately 30 square foot attached/canopy signs for a residential development of 117 residential attached units.",
         "Planner": "Michael Mena ",
         "DURATION": 1,
         "Year": 2010
      },
      {
         "PERMITID": "AD10-849",
         "APN": 25939122,
         "File Number": "AD10-849",
         "Address": "10 ALMADEN BL SAN JOSE",
         "Project Name": "AD10-849",
         "Application Type": "Sign Permit ",
         "Application Date": "10/20/10",
         "Status": "Approved ",
         "Description": "Creation of a Master Sign Program and installation of seven attached signs, totalling 156.5 square feet., on an approximately 160-foot tall office building.",
         "Planner": "Michael Mena ",
         "DURATION": 0,
         "Year": 2010
      },
      {
         "PERMITID": "AD10-900",
         "APN": 26420132,
         "File Number": "AD10-900",
         "Address": "350 BIRD AV SAN JOSE",
         "Project Name": "AD10-900",
         "Application Type": "Sign Permit ",
         "Application Date": "11/5/10",
         "Status": "Approved ",
         "Description": "Sign Permit Adjusment to allow installation of 12 sf attached illuminated sign on 12' - 5.5\" occupancy frontage",
         "Planner": "Michael Mena ",
         "DURATION": 0,
         "Year": 2010
      },
      {
         "PERMITID": "AD11-1035",
         "APN": 46719075,
         "File Number": "AD11-1035",
         "Address": "225 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD11-1035",
         "Application Type": "Sign Permit ",
         "Application Date": "11/30/11",
         "Status": "Approved ",
         "Description": "Sign Permit Adjustment to allow one 28 square foot illuminated channel letter sign.",
         "Planner": "Sylvia Do ",
         "DURATION": 1,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-117",
         "APN": 25935045,
         "File Number": "AD11-117",
         "Address": "170 W ST JOHN ST SAN JOSE",
         "Project Name": "AD11-117",
         "Application Type": "Sign Permit ",
         "Application Date": "2/15/11",
         "Status": "Approved ",
         "Description": "Sign for the San Pedro Square Market atop roof of building at 170 W. St. John",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 1,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-249",
         "APN": 25935020,
         "File Number": "AD11-249",
         "Address": "225 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD11-249",
         "Application Type": "Sign Permit ",
         "Application Date": "4/8/11",
         "Status": "Approved ",
         "Description": "SIGN PERMIT ADJUSTMENT TO ALLOW INSTALLATION OF ONE (1) ILLUMINATED SKYLINE SIGN ON NOTRE DAME AVENUE ON A BUILDING APP. 211 FT IN HEIGHT AND ONE (1) FLAT MOUNTED SIGN ON ALMADEN AVENUE WITH APP. 360 LF OF STREET FRONTAGE",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 1,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-508",
         "APN": 25943074,
         "File Number": "AD11-508",
         "Address": "333 W SAN CARLOS ST SAN JOSE",
         "Project Name": "AD11-508",
         "Application Type": "Sign Permit ",
         "Application Date": "6/28/11",
         "Status": "Approved ",
         "Description": "Sign Permit Adjustment to replace existing skyline sign with new 61.33 square foot skyline sign. (ACER)",
         "Planner": "Mike Enderby ",
         "DURATION": 1,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-508",
         "APN": 25943075,
         "File Number": "AD11-508",
         "Address": "333 W SAN CARLOS ST SAN JOSE",
         "Project Name": "AD11-508",
         "Application Type": "Sign Permit ",
         "Application Date": "6/28/11",
         "Status": "Approved ",
         "Description": "Sign Permit Adjustment to replace existing skyline sign with new 61.33 square foot skyline sign. (ACER)",
         "Planner": "Mike Enderby ",
         "DURATION": 1,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-721",
         "APN": 46722141,
         "File Number": "AD11-721",
         "Address": "150 S 1ST ST SAN JOSE",
         "Project Name": "AD11-721",
         "Application Type": "Sign Permit ",
         "Application Date": "8/31/11",
         "Status": "Approved ",
         "Description": "Sign Permit Adjustment to allow two (2) attached, internally illuminated signs (one flush with the wall and the second sign, a fin sign) as shown on the approved Permit Adjustment plans only.",
         "Planner": "Jeff Roche ",
         "DURATION": 1,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-744",
         "APN": 25935020,
         "File Number": "AD11-744",
         "Address": "225 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD11-744",
         "Application Type": "Sign Permit ",
         "Application Date": "9/9/11",
         "Status": "Approved ",
         "Description": "Installation of one new attached sign of 30.3 square feet on an existing office building in the DC Downtown Primary Commercial Zoning District. Cumulatively with existing signs, below the 1:2.5 ratio for allowed signage in Downtown.",
         "Planner": "Jeff Roche ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-838",
         "APN": 26420121,
         "File Number": "AD11-838",
         "Address": "395 BIRD AV SAN JOSE",
         "Project Name": "AD11-838",
         "Application Type": "Sign Permit ",
         "Application Date": "10/13/11",
         "Status": "Approved ",
         "Description": "Sign Permit Adjustment to allow modification of one existing monumnet sign and three attached signs to a detached car wash and food mart building for a gasoline service station ",
         "Planner": "Avril Baty ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-988",
         "APN": 46764005,
         "File Number": "AD11-988",
         "Address": "100 S 2ND ST Unit C-106 SAN JOSE",
         "Project Name": "AD11-988",
         "Application Type": "Sign Permit ",
         "Application Date": "11/15/11",
         "Status": "Approved ",
         "Description": "Replacement of one blade sign, replacement of three flat-mounted attached signs with blade signs, and reface of existing blade sign, and two new free-standing signs (on existing planter boxes), for a total of 118 square feet, 44 square feet, and 26.5 square feet on 169-foot, 178-foot, and 66-foot occupancy frontages (respectively).",
         "Planner": "Avril Baty ",
         "DURATION": 1,
         "Year": 2011
      },
      {
         "PERMITID": "AD11-988",
         "APN": 46764010,
         "File Number": "AD11-988",
         "Address": "100 S 2ND ST Unit C-106 SAN JOSE",
         "Project Name": "AD11-988",
         "Application Type": "Sign Permit ",
         "Application Date": "11/15/11",
         "Status": "Approved ",
         "Description": "Replacement of one blade sign, replacement of three flat-mounted attached signs with blade signs, and reface of existing blade sign, and two new free-standing signs (on existing planter boxes), for a total of 118 square feet, 44 square feet, and 26.5 square feet on 169-foot, 178-foot, and 66-foot occupancy frontages (respectively).",
         "Planner": "Avril Baty ",
         "DURATION": 1,
         "Year": 2011
      },
      {
         "PERMITID": "AD12-106",
         "APN": 25940087,
         "File Number": "AD12-106",
         "Address": "160 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD12-106",
         "Application Type": "Sign Permit ",
         "Application Date": "2/2/12",
         "Status": "Approved ",
         "Description": "Sign Permit to allow one (1) attached sign 48.22 sq. ft in size, internally illuminated channel letters for a business/ office.",
         "Planner": "Suparna Saha ",
         "DURATION": 1,
         "Year": 2012
      },
      {
         "PERMITID": "AD12-1202",
         "APN": 25939122,
         "File Number": "AD12-1202",
         "Address": "10 ALMADEN BL SAN JOSE",
         "Project Name": "AD12-1202",
         "Application Type": "Sign Permit ",
         "Application Date": "11/29/12",
         "Status": "Approved ",
         "Description": "Sign Permit for 1 attached 24.25 square foot sign.",
         "Planner": "Martina Davis ",
         "DURATION": 0,
         "Year": 2012
      },
      {
         "PERMITID": "AD12-1252",
         "APN": 25941090,
         "File Number": "AD12-1252",
         "Address": "170 S MARKET ST SAN JOSE",
         "Project Name": "AD12-1252",
         "Application Type": "Sign Permit ",
         "Application Date": "12/11/12",
         "Status": "Approved ",
         "Description": "Sign permit for one attached sign, 31.6 square feet in size, for a tenant at the Fairmont Hotel",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2012
      },
      {
         "PERMITID": "AD12-177",
         "APN": 46722127,
         "File Number": "AD12-177",
         "Address": "97 S 2ND ST SAN JOSE",
         "Project Name": "AD12-177 Pinger",
         "Application Type": "Sign Permit ",
         "Application Date": "2/21/12",
         "Status": "Approved ",
         "Description": "Sign Permit Adjustment to allow a 54\"x48\" fin sign located 18 feet above grade at the corner of S. Second Street and E. San Fernando Street.",
         "Planner": "MNAGARAJ ",
         "DURATION": 0,
         "Year": 2012
      },
      {
         "PERMITID": "AD12-236",
         "APN": 46722158,
         "File Number": "AD12-236",
         "Address": "30 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD12-236",
         "Application Type": "Sign Permit ",
         "Application Date": "3/7/12",
         "Status": "Approved ",
         "Description": "Sign permit Adjustment request to install (1) one attached sign GARLIC BREAD, BBQ & FRESH DAILY FOOD CHOICES, 16'9\" square feet for a restaurant",
         "Planner": "Helen Maddox ",
         "DURATION": 1,
         "Year": 2012
      },
      {
         "PERMITID": "AD12-278",
         "APN": 25941086,
         "File Number": "AD12-278",
         "Address": "50 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD12-278",
         "Application Type": "Sign Permit ",
         "Application Date": "3/16/12",
         "Status": "Approved ",
         "Description": "Sign Permit Adjustment to allow (2) two attached, non-illuminated signs (each ~ 11.8 square feet in size) on an existing commercial building as shown on the approved Permit Adjustment plans only.",
         "Planner": "Jeff Roche ",
         "DURATION": 1,
         "Year": 2012
      },
      {
         "PERMITID": "AD12-278",
         "APN": 25941087,
         "File Number": "AD12-278",
         "Address": "50 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD12-278",
         "Application Type": "Sign Permit ",
         "Application Date": "3/16/12",
         "Status": "Approved ",
         "Description": "Sign Permit Adjustment to allow (2) two attached, non-illuminated signs (each ~ 11.8 square feet in size) on an existing commercial building as shown on the approved Permit Adjustment plans only.",
         "Planner": "Jeff Roche ",
         "DURATION": 1,
         "Year": 2012
      },
      {
         "PERMITID": "AD12-289",
         "APN": 46745069,
         "File Number": "AD12-289",
         "Address": "345 S 4TH ST SAN JOSE",
         "Project Name": "AD12-289",
         "Application Type": "Sign Permit ",
         "Application Date": "3/20/12",
         "Status": "Approved ",
         "Description": "Two (2) attached illuminated flat letters signs, measuring 36sf and 16 sf in sign area only. Refacing of an existing monument sign \"Dosa & Curry Cafe\"",
         "Planner": "MNAGARAJ ",
         "DURATION": 0,
         "Year": 2012
      },
      {
         "PERMITID": "AD12-315",
         "APN": 25934028,
         "File Number": "AD12-315",
         "Address": "80 N MARKET ST SAN JOSE",
         "Project Name": "AD12-315",
         "Application Type": "Sign Permit ",
         "Application Date": "3/27/12",
         "Status": "Approved ",
         "Description": "Sign Permit Adjustment to allow one painted sign 15'10\" x 4'6\" (72.24 square feet) for a restaurant with occupancy frontage of 33 feet in the Downtown Primary Commercial Zoning District.",
         "Planner": "Helen Maddox ",
         "DURATION": 1,
         "Year": 2012
      },
      {
         "PERMITID": "AD12-420",
         "APN": 25941054,
         "File Number": "AD12-420",
         "Address": "121 S MARKET ST SAN JOSE",
         "Project Name": "AD12-420",
         "Application Type": "Sign Permit ",
         "Application Date": "4/26/12",
         "Status": "Approved ",
         "Description": "Sign Permit Adjustment to allow modifications to existing attached (3) and detached (1) signs as shown on the approved Permit Adjustment plans only.",
         "Planner": "MNAGARAJ ",
         "DURATION": 0,
         "Year": 2012
      },
      {
         "PERMITID": "AD12-587",
         "APN": 25941057,
         "File Number": "AD12-587",
         "Address": "125 S MARKET ST SAN JOSE",
         "Project Name": "AD12-587",
         "Application Type": "Sign Permit ",
         "Application Date": "6/14/12",
         "Status": "Approved ",
         "Description": "Attached flat letters sign \"UNIVERSITY OF SAN FRANCISCO\" 40 inches high, 50 sf in sign area only.",
         "Planner": "Martina Davis ",
         "DURATION": 0,
         "Year": 2012
      },
      {
         "PERMITID": "AD12-695",
         "APN": 25936074,
         "File Number": "AD12-695",
         "Address": "333 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD12-695",
         "Application Type": "Sign Permit ",
         "Application Date": "7/17/12",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow removal of four (4 ) signs and installation of (4) like signs individual channel letters internally illuminated and located in the Downtown Core in the Civic Center redevelopment Area. Signs A & B are attached oat street level and measure 3' x 24' 7\". Signs C & D are located on the roof and measure 6'8\" x 54'6\" and 3'5\" x 28'7\".",
         "Planner": "Jeff Roche ",
         "DURATION": 0,
         "Year": 2012
      },
      {
         "PERMITID": "AD12-868",
         "APN": 25934053,
         "File Number": "AD12-868",
         "Address": "111 N MARKET ST Bldg 1 SAN JOSE",
         "Project Name": "AD12-868",
         "Application Type": "Sign Permit ",
         "Application Date": "8/28/12",
         "Status": "Approved ",
         "Description": "One (1) LED illuminated channel letters Skyline sign, 160 sf in sign area and 5' high.",
         "Planner": "MNAGARAJ ",
         "DURATION": 0,
         "Year": 2012
      },
      {
         "PERMITID": "AD12-984",
         "APN": 25941057,
         "File Number": "AD12-984",
         "Address": "125 S MARKET ST SAN JOSE",
         "Project Name": "AD12-984",
         "Application Type": "Sign Permit ",
         "Application Date": "9/27/12",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow one singled-faced aluminum freestanding identification sign 4 ft tall by 1 ft wide and non-illuminated.",
         "Planner": "Jan Warne ",
         "DURATION": 1,
         "Year": 2012
      },
      {
         "PERMITID": "AD13-010",
         "APN": 25935020,
         "File Number": "AD13-010",
         "Address": "225 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD13-010",
         "Application Type": "Sign Permit ",
         "Application Date": "1/4/13",
         "Status": "Approved ",
         "Description": "Permit adjustment to allow 1 logo attached sign that is 32 square feet, 1attached sign \"Umpqua Bank\" that is 14.8 square feet, and 1 arcade sign that is 4.03 square feet which is 9' 4\" above grade.",
         "Planner": "Jan Warne ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "AD13-052",
         "APN": 46722110,
         "File Number": "AD13-052",
         "Address": "78 S 1ST ST SAN JOSE",
         "Project Name": "AD13-052",
         "Application Type": "Sign Permit ",
         "Application Date": "1/15/13",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow one aluminum channel letter internally illuminated sign with a total of 17 square feet placed on a building storefront with 17 feet frontage.",
         "Planner": "Jan Warne ",
         "DURATION": 1,
         "Year": 2013
      },
      {
         "PERMITID": "AD13-099",
         "APN": 25942023,
         "File Number": "AD13-099",
         "Address": "201 S MARKET ST SAN JOSE",
         "Project Name": "AD13-099",
         "Application Type": "Sign Permit ",
         "Application Date": "1/25/13",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow two (2) internally lit LED attached signs. Sign #1 located at the entrance is 69.4 square feet and Sign #2 located at the north corner is 32 square feet, for a total of 101.4 square feet.",
         "Planner": "Jan Warne ",
         "DURATION": 1,
         "Year": 2013
      },
      {
         "PERMITID": "AD13-1003",
         "APN": 46722141,
         "File Number": "AD13-1003",
         "Address": "150 S 1ST ST SAN JOSE",
         "Project Name": "AD13-1003",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/13",
         "Status": "Approved ",
         "Description": "Sign Permit Adjustment to allow one attached internally -illuminated, channel letter sign \" THIRST TEA\", 40.5 sq.ft in area.",
         "Planner": "Suparna Saha ",
         "DURATION": 1,
         "Year": 2013
      },
      {
         "PERMITID": "AD13-1056",
         "APN": 46722003,
         "File Number": "AD13-1056",
         "Address": "30 S 1ST ST SAN JOSE",
         "Project Name": "AD13-1056",
         "Application Type": "Sign Permit ",
         "Application Date": "9/30/13",
         "Status": "Approved ",
         "Description": "Sign Permit to allow one (1) 52.3 square foot, attached, internally illuminated, channel letter sign for \"Lido\" on a 35 foot frontage.",
         "Planner": "Suparna Saha ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "AD13-1146",
         "APN": 25940034,
         "File Number": "AD13-1146",
         "Address": "84 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD13-1146",
         "Application Type": "Sign Permit ",
         "Application Date": "10/22/13",
         "Status": "Approved ",
         "Description": "Installation of three attached signs; two attached signs both 51 square feet and one programmable electronic sign of 35 square feet (allowed per 23.04.120.J.2), on 80-foot and 153-foot occupancy frontages in the DC Downtown Zoning District.",
         "Planner": "Suparna Saha ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "AD13-1151",
         "APN": 25935020,
         "File Number": "AD13-1151",
         "Address": "225 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD13-1151",
         "Application Type": "Sign Permit ",
         "Application Date": "10/22/13",
         "Status": "Approved ",
         "Description": "Sign permit for one skyline sign, 240 square feet in size, on the west side of an existing building.",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2013
      },
      {
         "PERMITID": "AD13-1159",
         "APN": 25939122,
         "File Number": "AD13-1159",
         "Address": "10 ALMADEN BL SAN JOSE",
         "Project Name": "AD13-1159",
         "Application Type": "Sign Permit ",
         "Application Date": "10/25/13",
         "Status": "Approved ",
         "Description": "Sign Permit to allow one (1) attached (hanging sign), between columns 63 sq.ft structure area and 24 sq.ft singage area. Internally illuminated, LED \" apigee\".",
         "Planner": "Martina Davis ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "AD13-1302",
         "APN": 25934043,
         "File Number": "AD13-1302",
         "Address": "19 N MARKET ST SAN JOSE",
         "Project Name": "AD13-1302",
         "Application Type": "Sign Permit ",
         "Application Date": "12/3/13",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow the replacement of the canvas on an existing awning and the replacement of the plastic sheeting on the fin sign for \"Louisiana Bistro, Taste of N'awlins.\" ",
         "Planner": "Lori Moniz ",
         "DURATION": 2,
         "Year": 2013
      },
      {
         "PERMITID": "AD13-1354",
         "APN": 46722158,
         "File Number": "AD13-1354",
         "Address": "30 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD13-1354",
         "Application Type": "Sign Permit ",
         "Application Date": "12/16/13",
         "Status": "Approved ",
         "Description": "Sign Permit to allow one (1) 26.5 square foot, attached, internally illuminated, channel letter sign for \"Curry Pundits\" on a 18 foot frontage.",
         "Planner": "Lori Moniz ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "AD13-152",
         "APN": 25956002,
         "File Number": "AD13-152",
         "Address": "170 S MARKET ST SAN JOSE",
         "Project Name": "(BE100%)",
         "Application Type": "Sign Permit ",
         "Application Date": "2/6/13",
         "Status": "Approved ",
         "Description": "Sign Permit to replace two existing awning signs with two new awning signs and change copy on one attached sign from \"Seafood Restaurant\" to \"Seafood and Steaks\". Total signage for occupancy frontage counting existing and proposed signs is 247.48 square on 124 linear feet of frontage",
         "Planner": "Lori Moniz ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "AD13-199",
         "APN": 25956003,
         "File Number": "AD13-199",
         "Address": "170 S MARKET ST SAN JOSE",
         "Project Name": "AD13-199",
         "Application Type": "Sign Permit ",
         "Application Date": "2/19/13",
         "Status": "Approved ",
         "Description": "Install (2) internally-illuminated signs over store entrances, attached to building, 19 SF each.",
         "Planner": "Mike Enderby ",
         "DURATION": 1,
         "Year": 2013
      },
      {
         "PERMITID": "AD13-642",
         "APN": 46722141,
         "File Number": "AD13-642",
         "Address": "150 S 1ST ST SAN JOSE",
         "Project Name": "AD13-642 - DISCOVER SAN JOSE",
         "Application Type": "Sign Permit ",
         "Application Date": "6/14/13",
         "Status": "Approved ",
         "Description": "Sign Permit Adjustment to allow one attached sign 18 sq.ft and one fin sign 8.12 sq.ft illuminated, LED for retail/commercial building.",
         "Planner": "Suparna Saha ",
         "DURATION": 1,
         "Year": 2013
      },
      {
         "PERMITID": "AD13-846",
         "APN": 25941068,
         "File Number": "AD13-846",
         "Address": "185 PARK AV SAN JOSE",
         "Project Name": "AD13-846",
         "Application Type": "Sign Permit ",
         "Application Date": "8/5/13",
         "Status": "Approved ",
         "Description": "Installation of attached sign of 13.6 square feet on a 26.5-foot occupancy frontage in the DC Downtown Primary Commercial Zoning District for \"Randstad.\"",
         "Planner": "Avril Baty ",
         "DURATION": 1,
         "Year": 2013
      },
      {
         "PERMITID": "AD14-082",
         "APN": 26415065,
         "File Number": "AD14-082",
         "Address": "720 W SAN CARLOS ST SAN JOSE",
         "Project Name": "AD14-082",
         "Application Type": "Sign Permit ",
         "Application Date": "1/28/14",
         "Status": "Approved ",
         "Description": "Three (3) illuminated channel letters signs for Orchard supplies, 132.13 sf and 20.03 sf in sign areas facing East side and 102.11 sf in sign area facing South side.",
         "Planner": "Sylvia Do ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "AD14-1001",
         "APN": 25941057,
         "File Number": "AD14-1001",
         "Address": "125 S MARKET ST SAN JOSE",
         "Project Name": "AD14-1001",
         "Application Type": "Sign Permit ",
         "Application Date": "9/23/14",
         "Status": "Approved ",
         "Description": " ",
         "Planner": "Sylvia Do ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "AD14-1003",
         "APN": 25941068,
         "File Number": "AD14-1003",
         "Address": "185 PARK AV SAN JOSE",
         "Project Name": "AD14-1003",
         "Application Type": "Sign Permit ",
         "Application Date": "9/23/14",
         "Status": "Approved ",
         "Description": "Sign Permit Adjustment to allow one (1), attached sign, facade mounted (31' X 2'), 25 sq.ft , with a 31 linear feet store frontage for \"GLODEN1 CREDIT UNION\"",
         "Planner": "Sylvia Do ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "AD14-1005",
         "APN": 25941068,
         "File Number": "AD14-1005",
         "Address": "185 PARK AV SAN JOSE",
         "Project Name": "AD14-1005",
         "Application Type": "Sign Permit ",
         "Application Date": "9/24/14",
         "Status": "Approved ",
         "Description": " ",
         "Planner": "Lori Moniz ",
         "DURATION": 1,
         "Year": 2014
      },
      {
         "PERMITID": "AD14-1046",
         "APN": 25939122,
         "File Number": "AD14-1046",
         "Address": "10 ALMADEN BL SAN JOSE",
         "Project Name": "AD14-1046",
         "Application Type": "Sign Permit ",
         "Application Date": "10/3/14",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow one(1) 200 square foot skyline sign for an existing office building on an approximately 1.66 gross acres site in the DC Downtown Primary Commercial zoning district",
         "Planner": "Aparna Ankola ",
         "DURATION": 1,
         "Year": 2014
      },
      {
         "PERMITID": "AD14-1061",
         "APN": 47226034,
         "File Number": "AD14-1061",
         "Address": "550 S 1ST ST SAN JOSE",
         "Project Name": "AD14-1061",
         "Application Type": "Sign Permit ",
         "Application Date": "10/7/14",
         "Status": "Approved ",
         "Description": "Sign permit to allow one (1) attached wall sign for a new tenant (Third Space Fitness) located in an existing retail building on an approximately 0.14 gross acre site.",
         "Planner": "Aparna Ankola ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "AD14-1098",
         "APN": 25941057,
         "File Number": "AD14-1098",
         "Address": "125 S MARKET ST SAN JOSE",
         "Project Name": "AD14-1098",
         "Application Type": "Sign Permit ",
         "Application Date": "10/15/14",
         "Status": "Approved ",
         "Description": "Sign Permit Adjustment to allow one flat mounted sign, iluuminated 11 sq.ft in size, \"STIENBERG\".",
         "Planner": "Rebecca Bustos ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "AD14-1133",
         "APN": 46746045,
         "File Number": "AD14-1133",
         "Address": "380 S 1ST ST SAN JOSE",
         "Project Name": "AD14-1133",
         "Application Type": "Sign Permit ",
         "Application Date": "10/23/14 10:30",
         "Status": "Approved ",
         "Description": "Sign Permit for a 15 square foot sign on a 30 foot street frontage",
         "Planner": "John Tu ",
         "DURATION": 1,
         "Year": 2014
      },
      {
         "PERMITID": "AD14-1308",
         "APN": 25936074,
         "File Number": "AD14-1308",
         "Address": "333 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD14-1308 - WFG National Title",
         "Application Type": "Sign Permit ",
         "Application Date": "12/11/14",
         "Status": "Approved ",
         "Description": "Sign Permit to allow one (1) attached, 90 square foot, internally illuminated, channel letter sign for \"WFG National Title\" on a 100 linear foot occupancy frontage.",
         "Planner": "John Tu ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "AD14-937",
         "APN": 46721034,
         "File Number": "AD14-937",
         "Address": "4 N 2ND ST SAN JOSE",
         "Project Name": "AD14-937",
         "Application Type": "Sign Permit ",
         "Application Date": "9/3/14",
         "Status": "Approved ",
         "Description": "Sign Permit for one (1) skyline sign (The Mercury News) that is 380 square feet with a building height of 160 feet.",
         "Planner": "Lori Moniz ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "AD15-1067",
         "APN": 25939111,
         "File Number": "AD15-1067",
         "Address": "350 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD15-1067",
         "Application Type": "Sign Permit ",
         "Application Date": "9/28/15 10:28",
         "Status": "Approved ",
         "Description": "Sign Permit Adjustment to allow the installation of nine signs, including one fin sign, six attached signs, and two skyline signs totaling approximately 461 square feet (skyline signs do not count toward overall signage) on a total of 496 square feet of occupancy frontages",
         "Planner": "Suparna Saha ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "AD15-1261",
         "APN": 25941086,
         "File Number": "AD15-1261",
         "Address": "50 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD15-1261",
         "Application Type": "Sign Permit ",
         "Application Date": "11/10/15 11:11",
         "Status": "Approved ",
         "Description": "Sign Permit to allow the face and copy of two (2) attached, 1,248 square foot, internally illuminated, channel letter signs to be refaced for \"KQED” on an existing office building.",
         "Planner": "Suparna Saha ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "AD15-1261",
         "APN": 25941087,
         "File Number": "AD15-1261",
         "Address": "50 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD15-1261",
         "Application Type": "Sign Permit ",
         "Application Date": "11/10/15 11:11",
         "Status": "Approved ",
         "Description": "Sign Permit to allow the face and copy of two (2) attached, 1,248 square foot, internally illuminated, channel letter signs to be refaced for \"KQED” on an existing office building.",
         "Planner": "Suparna Saha ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "AD15-164",
         "APN": 25943074,
         "File Number": "AD15-164",
         "Address": "300 PARK AV SAN JOSE",
         "Project Name": "AD15-164",
         "Application Type": "Sign Permit ",
         "Application Date": "2/17/15",
         "Status": "Approved ",
         "Description": "Sign Permit to allow one (1) 63 square foot, internally illuminated, channel letter signs for \"Intacct\" on a 150 linear foot occupancy frontage to be located 106'-3\" above grade.",
         "Planner": "Lori Moniz ",
         "DURATION": 1,
         "Year": 2015
      },
      {
         "PERMITID": "AD15-164",
         "APN": 25943075,
         "File Number": "AD15-164",
         "Address": "300 PARK AV SAN JOSE",
         "Project Name": "AD15-164",
         "Application Type": "Sign Permit ",
         "Application Date": "2/17/15",
         "Status": "Approved ",
         "Description": "Sign Permit to allow one (1) 63 square foot, internally illuminated, channel letter signs for \"Intacct\" on a 150 linear foot occupancy frontage to be located 106'-3\" above grade.",
         "Planner": "Lori Moniz ",
         "DURATION": 1,
         "Year": 2015
      },
      {
         "PERMITID": "AD15-232",
         "APN": 25940093,
         "File Number": "AD15-232",
         "Address": "1 S MARKET ST SAN JOSE",
         "Project Name": "AD15-232",
         "Application Type": "Sign Permit ",
         "Application Date": "3/4/15",
         "Status": "Approved ",
         "Description": "Sign Permit to allow two (2) attached, 120 square foot, internally illuminated, face-lit, channel letter skyline signs on on an existing 321.5 foot high building; and one (1) attached, 22.5 square foot, non-illuminated, channel letter sign on a 200 foot occupancy frontage for \"One South.\"",
         "Planner": "MNAGARAJ ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "AD15-535",
         "APN": 25940093,
         "File Number": "AD15-535",
         "Address": "1 S MARKET ST SAN JOSE",
         "Project Name": "AD15-535",
         "Application Type": "Sign Permit ",
         "Application Date": "5/19/15 9:52",
         "Status": "Approved ",
         "Description": "Sign Permit to allow two (2) attached, 120 square foot, internally illuminated, face-lit, channel letter skyline signs on an existing 321.5 foot high building; and one (1) attached, 22.5 square foot, non-illuminated, channel letter sign on a 200 foot occupancy frontage, for an existing mixed-use development (One South) on an approximately 0.96 gross acre site in the DC Downtown Primary Commercial zoning district.",
         "Planner": "Aparna Ankola ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "AD15-606",
         "APN": 46722141,
         "File Number": "AD15-606",
         "Address": "150 S 1ST ST SAN JOSE",
         "Project Name": "AD15-606",
         "Application Type": "Sign Permit ",
         "Application Date": "6/4/15 11:43",
         "Status": "Approved ",
         "Description": "Permit Adjustment for 3 signs (2 attached, 1 fin), street frontage of 35 feet. 1 attached is 5.28 square feet, 1 attached is 24.2 square feet, and 1 fin is 9 square feet.",
         "Planner": "Aparna Ankola ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "AD15-686",
         "APN": 46719078,
         "File Number": "AD15-686",
         "Address": "24 N 5TH ST SAN JOSE",
         "Project Name": "AD15-686",
         "Application Type": "Sign Permit ",
         "Application Date": "6/23/15",
         "Status": "Approved ",
         "Description": "Sign Permit to allow one (1) 13 square foot, non-illuminated, aluminum panel sign on a 119 linear foot occupancy frontage; one (1) 16.25 square foot, non-illuminated, flat cut aluminum letter sign on a 134 linear foot occupancy frontage for “San Jose First Methodist Church” at an existing building.",
         "Planner": "Elizabeth Schuller ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "AD15-885",
         "APN": 25940036,
         "File Number": "AD15-885",
         "Address": "64 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD15-885",
         "Application Type": "Sign Permit ",
         "Application Date": "8/11/15 13:08",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow two attached signs, 18.66sf each, for a corner tenant (Campbell Warburton Law Firm).",
         "Planner": "Kristinae Toomians ",
         "DURATION": 1,
         "Year": 2015
      },
      {
         "PERMITID": "AD16-1238",
         "APN": 46721005,
         "File Number": "AD16-1238",
         "Address": "91 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD16-1238",
         "Application Type": "Sign Permit ",
         "Application Date": "11/3/16 13:07",
         "Status": "Approved ",
         "Description": "Sign Permit request for one lighted channel letters sign \"metroPCS\" for a retail business ",
         "Planner": "Aparna Ankola ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "AD16-1294",
         "APN": 46757084,
         "File Number": "AD16-1294",
         "Address": "27 N 6TH ST SAN JOSE",
         "Project Name": "AD16-1294",
         "Application Type": "Sign Permit ",
         "Application Date": "11/21/16 9:30",
         "Status": "Approved ",
         "Description": "Sign Permit request for two attached signs for a multi-family residential building located in DC Downtown Commercial zoning district - (a)One (1) attached sign along the eastern façade \"27NORTH\", 42.4 square feet, painted aluminum letters, and (b) one (1) attached sign, 6.75 square feet, a logo, painted aluminum.",
         "Planner": "Sanhita Ghosal ",
         "DURATION": 1,
         "Year": 2016
      },
      {
         "PERMITID": "AD16-139",
         "APN": 25943069,
         "File Number": "AD16-139",
         "Address": "282 ALMADEN BL SAN JOSE",
         "Project Name": "AD16-139 - 282 ALMADEN BOULEVARD",
         "Application Type": "Sign Permit ",
         "Application Date": "2/3/16",
         "Status": "Approved ",
         "Description": "Sign Permit to allow two (2) illuminated, channel letter signs with logos (51 and 23 square feet) for “Hyatt Place” at a hotel.",
         "Planner": "Jan Warne ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "AD16-204",
         "APN": 25941068,
         "File Number": "AD16-204",
         "Address": "185 PARK AV SAN JOSE",
         "Project Name": "AD16-204",
         "Application Type": "Sign Permit ",
         "Application Date": "2/17/16 13:49",
         "Status": "Approved ",
         "Description": "Sign Permit Adjustment to allow one attached LED halo-illuminated 31.5x114 (25 sq. ft) for \"OUR HOUSE\"",
         "Planner": "Suparna Saha ",
         "DURATION": 1,
         "Year": 2016
      },
      {
         "PERMITID": "AD16-363",
         "APN": 46722141,
         "File Number": "AD16-363",
         "Address": "150 S 1ST ST SAN JOSE",
         "Project Name": "AD16-363",
         "Application Type": "Sign Permit ",
         "Application Date": "3/28/16 8:34",
         "Status": "Approved ",
         "Description": "Permit adjustment to allow 2 attached internally illuminated signs measuring12 and 23 square feet for Ipoh Garden downtown.",
         "Planner": "Jan Warne ",
         "DURATION": 1,
         "Year": 2016
      },
      {
         "PERMITID": "AD16-375",
         "APN": 46723100,
         "File Number": "AD16-375",
         "Address": "88 S 4TH ST SAN JOSE",
         "Project Name": "AD16-375",
         "Application Type": "Sign Permit ",
         "Application Date": "3/29/16 15:35",
         "Status": "Approved ",
         "Description": "Permit Adjustment to add (1) fin sign 4 feet by 4.5 feet attached to the 4th Street façade of the building, the bottom of the sign located 12 feet above the grade.",
         "Planner": "Jan Warne ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "AD16-375",
         "APN": 46723101,
         "File Number": "AD16-375",
         "Address": "88 S 4TH ST SAN JOSE",
         "Project Name": "AD16-375",
         "Application Type": "Sign Permit ",
         "Application Date": "3/29/16 15:35",
         "Status": "Approved ",
         "Description": "Permit Adjustment to add (1) fin sign 4 feet by 4.5 feet attached to the 4th Street façade of the building, the bottom of the sign located 12 feet above the grade.",
         "Planner": "Jan Warne ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "AD16-434",
         "APN": 46722141,
         "File Number": "AD16-434",
         "Address": "150 S 1ST ST SAN JOSE",
         "Project Name": "AD16-434",
         "Application Type": "Sign Permit ",
         "Application Date": "4/12/16 13:14",
         "Status": "Approved ",
         "Description": "One(1) attached illuminated channel letters sign, \"fitness evolution HEALTH CLUBS\" 25 square feet in sign area",
         "Planner": "Jan Warne ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "AD16-972",
         "APN": 25939122,
         "File Number": "AD16-972",
         "Address": "10 ALMADEN BL SAN JOSE",
         "Project Name": "AD16-972",
         "Application Type": "Sign Permit ",
         "Application Date": "8/23/16 9:57",
         "Status": "Approved ",
         "Description": "Sign Permit to allow one (1) attached internally illuminated suspended wall sign along the colonnaded west façade at street level, measuring 18.5 square feet along a frontage width of 225 feet for an existing office tenant (Berlinger Cohen LLP) occupying the 11th floor within an office development on a 1.66 gross acre site in the DC Downtown Primary Commercial zoning district.",
         "Planner": "Aparna Ankola ",
         "DURATION": 1,
         "Year": 2016
      },
      {
         "PERMITID": "AD16-982",
         "APN": 25943074,
         "File Number": "AD16-982",
         "Address": "300 PARK AV SAN JOSE",
         "Project Name": "AD16-982",
         "Application Type": "Sign Permit ",
         "Application Date": "8/24/16 15:05",
         "Status": "Approved ",
         "Description": "Permit adjustment to allow one internally illuminated channel letter skyline sign measuring 246 square feet for Xactly.",
         "Planner": "MNAGARAJ ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "AD17-1144",
         "APN": 46722141,
         "File Number": "AD17-1144",
         "Address": "150 S 1ST ST SAN JOSE",
         "Project Name": "AD17-1144",
         "Application Type": "Sign Permit ",
         "Application Date": "11/8/17 10:12",
         "Status": "Approved ",
         "Description": "Sign Permit to allow one attached sign approximately 15.5 sq. ft in area with a 33 ft linear occupancy store front and a fin sign, double faces 4' x 4' from face of wall, located minimum 7 feet from grade, and non-illuminated.",
         "Planner": "Sanhita Ghosal ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-1166",
         "APN": 25940093,
         "File Number": "AD17-1166",
         "Address": "1 S MARKET ST SAN JOSE",
         "Project Name": "AD17-1166",
         "Application Type": "Sign Permit ",
         "Application Date": "11/17/17 8:30",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow installation of one attached sign 2' by 10' (20 sf) over the front primary entryway. (BISHOPS CUTS/COLOR)",
         "Planner": "Eric Morgan ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-1192",
         "APN": 47217018,
         "File Number": "AD17-1192",
         "Address": "718 S 1ST ST SAN JOSE",
         "Project Name": "AD17-1192",
         "Application Type": "Sign Permit ",
         "Application Date": "11/22/17 15:47",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow two signs, one painted sign 42 square feet in size, and one fin sign, 9 square in size, for \"Camino Brewery\"",
         "Planner": "Eric Morgan ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-173",
         "APN": 25931071,
         "File Number": "AD17-173",
         "Address": "255 W JULIAN ST SAN JOSE",
         "Project Name": "AD17-173",
         "Application Type": "Sign Permit ",
         "Application Date": "2/13/17 14:10",
         "Status": "Approved ",
         "Description": "One (1) set of Skyline sign \"ACFN\" 74 sq. ft. in area, facing West Julian Street.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-179",
         "APN": 25936074,
         "File Number": "AD17-179",
         "Address": "333 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD17-179",
         "Application Type": "Sign Permit ",
         "Application Date": "2/15/17",
         "Status": "Approved ",
         "Description": "Sign permit adjustment for three (3) attached signs, internally illuminated, channel letters - \"COMERICA BANK\" (Signs B & C) and \"\"WFC NATIONAL TITLE\" (Sign A) for an existing commercial building, at a height of 33.5 feet above grade. Signs are being relocated from the existing locations previously permitted to the proposed location",
         "Planner": "Sanhita Ghosal ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-282",
         "APN": 25943074,
         "File Number": "AD17-282",
         "Address": "300 PARK AV SAN JOSE",
         "Project Name": "AD17-282",
         "Application Type": "Sign Permit ",
         "Application Date": "3/16/17 13:43",
         "Status": "Approved ",
         "Description": "Sign Permit to allow one (1) internally illuminated channel letter skyline sign measuring approximately 224 square feet in size for \"Intacct\". This is the second skyline sign for 300 Park Ave with the total square footage of skyline signs now at 470 square feet.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-392",
         "APN": 46720080,
         "File Number": "AD17-392",
         "Address": "60 N 3RD ST SAN JOSE",
         "Project Name": "AD17-392",
         "Application Type": "Sign Permit ",
         "Application Date": "4/13/17 10:28",
         "Status": "Approved ",
         "Description": "Sign Permit for one (1) monument sign with a frontage of 240 feet.",
         "Planner": "Justin Daniels ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-446",
         "APN": 25940087,
         "File Number": "AD17-446",
         "Address": "160 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD17-446",
         "Application Type": "Sign Permit ",
         "Application Date": "4/26/17 10:36",
         "Status": "Approved ",
         "Description": "Sign Permit Adjustment to allow a replacement of an existing sign with a new sign approximately 64'.8' in area with an occupancy frontage of 84 linear feet for \"KBM HOGUE\"",
         "Planner": "David Fong ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-473",
         "APN": 25940093,
         "File Number": "AD17-473",
         "Address": "1 S MARKET ST SAN JOSE",
         "Project Name": "AD17-473",
         "Application Type": "Sign Permit ",
         "Application Date": "5/2/17 10:55",
         "Status": "Approved ",
         "Description": "Sign permit to allow one attached internally illuminated sign measuring 15 square feet for The Proper Cup.",
         "Planner": "Jan Warne ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-503",
         "APN": 25939122,
         "File Number": "AD17-503",
         "Address": "10 ALMADEN BL SAN JOSE",
         "Project Name": "AD17-503",
         "Application Type": "Sign Permit ",
         "Application Date": "5/8/17 9:13",
         "Status": "Approved ",
         "Description": "Sign Permit for one (1) attached sign \"Grant Thornton\" that is 63 square feet with a frontage of 197 feet.",
         "Planner": "Justin Daniels ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-558",
         "APN": 25939120,
         "File Number": "AD17-558",
         "Address": "95 S ALMADEN AV SAN JOSE",
         "Project Name": "AD17-558",
         "Application Type": "Sign Permit ",
         "Application Date": "5/19/17 8:35",
         "Status": "Approved ",
         "Description": "Sign Permit to allow one (1) internally illuminated skyline sign measuring approximately 225 square feet in size and one attached sign on the ground floor measuring approximately 22 square feet in size for AT&T. This is the first skyline sign for 95 Almaden Ave.",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-573",
         "APN": 25941086,
         "File Number": "AD17-573",
         "Address": "50 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD17-573",
         "Application Type": "Sign Permit ",
         "Application Date": "5/24/17",
         "Status": "Approved ",
         "Description": "Sign Permit to allow two 55 square foot signs for \"50 West\", one sign on the South First Street frontage of 132 linear feet and one sign on the West San Fernando frontage of 132 linear feet. Aggregate sign area on each frontage including existing signs will be 83 square feet",
         "Planner": "Dipa Chundur ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-573",
         "APN": 25941087,
         "File Number": "AD17-573",
         "Address": "50 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD17-573",
         "Application Type": "Sign Permit ",
         "Application Date": "5/24/17",
         "Status": "Approved ",
         "Description": "Sign Permit to allow two 55 square foot signs for \"50 West\", one sign on the South First Street frontage of 132 linear feet and one sign on the West San Fernando frontage of 132 linear feet. Aggregate sign area on each frontage including existing signs will be 83 square feet",
         "Planner": "Dipa Chundur ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-641",
         "APN": 25942081,
         "File Number": "AD17-641",
         "Address": "240 S MARKET ST SAN JOSE",
         "Project Name": "AD17-641",
         "Application Type": "Sign Permit ",
         "Application Date": "6/13/17 14:22",
         "Status": "Approved ",
         "Description": "Sign Permit for one attached sign \"United Food & Commercial Workers Local 5\" that is 52 square feet with a frontage of 102 feet.",
         "Planner": "Justin Daniels ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-692",
         "APN": 46725001,
         "File Number": "AD17-692",
         "Address": "400 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD17-692",
         "Application Type": "Sign Permit ",
         "Application Date": "6/28/17 13:49",
         "Status": "Approved ",
         "Description": "Permit adjustment to allow two attached internally illuminated signs measuring 26 square feet each and placed one on each of two storefronts.",
         "Planner": "Jan Warne ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-714",
         "APN": 46764008,
         "File Number": "AD17-714",
         "Address": "96 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD17-714",
         "Application Type": "Sign Permit ",
         "Application Date": "7/7/17",
         "Status": "Approved ",
         "Description": "Sign Permit to allow one (1) arcade-style attached sign 'Amazon', approximately 22.75 square feet in size, on a 45-foot wide northern frontage. This sign is reviewed as an attached sign and not an arcade sign as this is the main sign for this tenant.",
         "Planner": "Jan Warne ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-736",
         "APN": 25940093,
         "File Number": "AD17-736",
         "Address": "1 S MARKET ST SAN JOSE",
         "Project Name": "AD17-736",
         "Application Type": "Sign Permit ",
         "Application Date": "7/13/17 14:42",
         "Status": "Approved ",
         "Description": "Sign permit to allow three signs for \"Chipotle\", two attached signs of 28.4 square feet each and one fin sign of 3.1 square feet",
         "Planner": "Jan Warne ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-745",
         "APN": 25940093,
         "File Number": "AD17-745",
         "Address": "1 S MARKET ST SAN JOSE",
         "Project Name": "AD17-745 - 1 SOUTH MARKET ST - EARL OF SANDWICH",
         "Application Type": "Sign Permit ",
         "Application Date": "7/17/17 9:44",
         "Status": "Approved ",
         "Description": "Sign Permit to allow one (1) 27.75 square foot, internally-illuminated, channel letter sign on a 50 linear foot occupancy frontage; and one (1) 3.75 square foot blade sign for “Earl of Sandwich” at an existing commercial building.",
         "Planner": "Jan Warne ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "AD17-832",
         "APN": 46722141,
         "File Number": "AD17-832",
         "Address": "150 S 1ST ST SAN JOSE",
         "Project Name": "AD17-832",
         "Application Type": "Sign Permit ",
         "Application Date": "8/8/17 14:06",
         "Status": "Approved ",
         "Description": "Sign Permit to allow a 17 square foot attached sign \"Taco Mania\" on a 30-foot wide frontage",
         "Planner": "Suparna Saha ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "AD18-001",
         "APN": 25940093,
         "File Number": "AD18-001",
         "Address": "1 S MARKET ST SAN JOSE",
         "Project Name": "AD18-001",
         "Application Type": "Sign Permit ",
         "Application Date": "1/3/18",
         "Status": "Approved ",
         "Description": "Sign Permit to allow one approximately four square foot fin sign \"B CUTS/COLOR\" on the 24-foot wide Market Street frontage",
         "Planner": "Sanhita Ghosal ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "AD18-1045",
         "APN": 25935020,
         "File Number": "AD18-1045",
         "Address": "225 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD18-1045",
         "Application Type": "Sign Permit ",
         "Application Date": "10/29/18",
         "Status": "Approved ",
         "Description": "Sign Permit to allow a 23.3 square foot internally illuminated channel letter double sided fin sign, on a 60-foot wide southerly façade for Opa! Authentic Greek Cuisine",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2018
      },
      {
         "PERMITID": "AD18-150",
         "APN": 25934053,
         "File Number": "AD18-150",
         "Address": "111 N MARKET ST Bldg 1 SAN JOSE",
         "Project Name": "AD18-150 - 111 NORTH MARKET STREET - BERGESON, LLP",
         "Application Type": "Sign Permit ",
         "Application Date": "2/20/18 13:33",
         "Status": "Approved ",
         "Description": "Sign Permit to allow one (1) 196.9 square foot, non-illuminated skyline sign at an existing office tower.",
         "Planner": "Lori Moniz ",
         "DURATION": 1,
         "Year": 2018
      },
      {
         "PERMITID": "AD18-186",
         "APN": 46723096,
         "File Number": "AD18-186",
         "Address": "110 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD18-186",
         "Application Type": "Sign Permit ",
         "Application Date": "3/5/18",
         "Status": "Approved ",
         "Description": "Sign Permit to allow a 27.7 square foot attached sign (Breaktime) on the 30-foot wide northerly frontage along East San Fernando Street",
         "Planner": "Lori Moniz ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "AD18-186",
         "APN": 46759111,
         "File Number": "AD18-186",
         "Address": "110 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD18-186",
         "Application Type": "Sign Permit ",
         "Application Date": "3/5/18",
         "Status": "Approved ",
         "Description": "Sign Permit to allow a 27.7 square foot attached sign (Breaktime) on the 30-foot wide northerly frontage along East San Fernando Street",
         "Planner": "Lori Moniz ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "AD18-325",
         "APN": 47218055,
         "File Number": "AD18-325",
         "Address": "288 E VIRGINIA ST SAN JOSE",
         "Project Name": "AD18-325",
         "Application Type": "Sign Permit ",
         "Application Date": "4/12/18 14:43",
         "Status": "Approved ",
         "Description": "Sign Permit for one attached sign that is approximately 15.3 square feet with a frontage of 50 feet, one new monument sign, and for two service station canopy signs.",
         "Planner": "Justin Daniels ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "AD18-418",
         "APN": 25934039,
         "File Number": "AD18-418",
         "Address": "45 N MARKET ST SAN JOSE",
         "Project Name": "AD18-418",
         "Application Type": "Sign Permit ",
         "Application Date": "5/3/18 16:07",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow installation of six (6) 53.5\" by 53.5\" (119 sf) of signage along the southwest building façade facing San Pedro Street. (MOMENT)",
         "Planner": "Eric Morgan ",
         "DURATION": 1,
         "Year": 2018
      },
      {
         "PERMITID": "AD18-631",
         "APN": 26420125,
         "File Number": "AD18-631",
         "Address": "602 W SAN CARLOS ST SAN JOSE",
         "Project Name": "AD18-631",
         "Application Type": "Sign Permit ",
         "Application Date": "6/27/18 9:46",
         "Status": "Approved ",
         "Description": "Sign permit adjustment to re-surface canopy, monument and price signs, re-facing decal pumps for \"76\" gas station.",
         "Planner": "Suparna Saha ",
         "DURATION": 1,
         "Year": 2018
      },
      {
         "PERMITID": "AD18-953",
         "APN": 46722158,
         "File Number": "AD18-953",
         "Address": "30 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD18-953",
         "Application Type": "Sign Permit ",
         "Application Date": "9/28/18",
         "Status": "Approved ",
         "Description": "Sign Permit to allow one (1) 18.4 square foot internally illuminated attached sign on the 18.7-foot wide southerly frontage on Fountain Alley. (MakiBQ)",
         "Planner": "Jan Warne ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "AD18-974",
         "APN": 25940034,
         "File Number": "AD18-974",
         "Address": "84 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD18-974",
         "Application Type": "Sign Permit ",
         "Application Date": "10/4/18",
         "Status": "Approved ",
         "Description": "Sign Permit to allow a 1.02 square foot identification sign on the 81-foot wide northerly façade for HGA",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2018
      },
      {
         "PERMITID": "AD18-985",
         "APN": 25943075,
         "File Number": "AD18-985",
         "Address": "333 W SAN CARLOS ST SAN JOSE",
         "Project Name": "AD18-985",
         "Application Type": "Sign Permit ",
         "Application Date": "10/10/18 11:40",
         "Status": "Approved ",
         "Description": "Permit Adjustment to allow installation of one (1) attached and illuminate skyline sign 4'-7\" by 14'-4\" (65.69 sf). VIASAT",
         "Planner": "David Fong ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "AD19-105",
         "APN": 25940017,
         "File Number": "AD19-105",
         "Address": "155 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "AD19-105",
         "Application Type": "Sign Permit ",
         "Application Date": "2/5/19",
         "Status": "Approved ",
         "Description": "Sign Permit to allow two (2) 30.8 square foot internally-illuminated channel letter signs on the 40-foot wide southern façade and the 72-foot wide eastern façade for Tony Di Maggio's Pizza",
         "Planner": "David Fong ",
         "DURATION": 1,
         "Year": 2019
      },
      {
         "PERMITID": "AD19-128",
         "APN": 25943074,
         "File Number": "AD19-128",
         "Address": "300 PARK AV SAN JOSE",
         "Project Name": "AD19-128",
         "Application Type": "Sign Permit ",
         "Application Date": "2/8/19 11:54",
         "Status": "Approved ",
         "Description": "Sign Permit to allow the replacement of one (1) skyline sign \"Xactly\", measuring approximately 246 square feet with one (1) skyline sign \"COHESITY\", measuring approximately 196 square feet . The total square footage of skyline signs on this building is now at 468 square feet.",
         "Planner": "David Fong ",
         "DURATION": 0,
         "Year": 2019
      },
      {
         "PERMITID": "AD85-017",
         "APN": 46747004,
         "File Number": "AD85-017",
         "Address": "452 S 1ST ST SAN JOSE",
         "Project Name": "AD85-017",
         "Application Type": "Sign Permit ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:10-25-85 NEW WALL SIGN",
         "Planner": "UNKNOWN ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD85-087",
         "APN": 46725004,
         "File Number": "AD85-087",
         "Address": "424 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD85-087",
         "Application Type": "Sign Permit ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:12-10-85",
         "Planner": "Mel Flores ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD86-380",
         "APN": 25940084,
         "File Number": "AD86-380",
         "Address": "95 S MARKET ST SAN JOSE",
         "Project Name": "AD86-380",
         "Application Type": "Sign Permit ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:12NOV86 1 ATTACHED SIGN FOR \"THE VALET PLACE\"",
         "Planner": "Mike Enderby ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD86-385",
         "APN": 46720081,
         "File Number": "AD86-385",
         "Address": "49 N 4TH ST SAN JOSE",
         "Project Name": "AD86-385",
         "Application Type": "Sign Permit ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:21OCT86 REPLACING 1 DETACHED SIGN \"FIRST METH...",
         "Planner": "Mike Enderby ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD86-390",
         "APN": 46747038,
         "File Number": "AD86-390",
         "Address": "458 S 2ND ST SAN JOSE",
         "Project Name": "AD86-390",
         "Application Type": "Sign Permit ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:21OCT86 APPROVAL FOR 1 ATTACHED SIGN (3 DENIED)",
         "Planner": "Mike Enderby ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD86-422",
         "APN": 25940087,
         "File Number": "AD86-422",
         "Address": "160 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD86-422",
         "Application Type": "Sign Permit ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:01DEC86 1 ATTACHED SIGN FOR \"WIENERSCHNITZEL\"",
         "Planner": "Mike Enderby ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD87-415",
         "APN": 26415015,
         "File Number": "AD87-415",
         "Address": "365 ROYAL AV SAN JOSE",
         "Project Name": "AD87-415",
         "Application Type": "Sign Permit ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:16SEP87 1 ATTACHED SIGN \"ORCHARD SUPPLY HARDW...",
         "Planner": "Mike Enderby ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD88-157",
         "APN": 46722127,
         "File Number": "AD88-157",
         "Address": "97 S 2ND ST SAN JOSE",
         "Project Name": "AD88-157",
         "Application Type": "Sign Permit ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:26AUG88 AWNING,DOOR,WINDOW WALL SIGN",
         "Planner": "Jerry Yoshida ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD88-261",
         "APN": 46722004,
         "File Number": "AD88-261",
         "Address": "36 S 1ST ST SAN JOSE",
         "Project Name": "AD88-261",
         "Application Type": "Sign Permit ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:16JUN88",
         "Planner": "Mike Enderby ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD88-300",
         "APN": 25940043,
         "File Number": "AD88-300",
         "Address": "27 S 1ST ST SAN JOSE",
         "Project Name": "AD88-300",
         "Application Type": "Sign Permit ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:29JUN88 1 ATTACHED SIGN \"WOOLWORTH\"",
         "Planner": "Mike Enderby ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD88-317",
         "APN": 25933067,
         "File Number": "AD88-317",
         "Address": "142 W JULIAN ST SAN JOSE",
         "Project Name": "AD88-317",
         "Application Type": "Sign Permit ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:02AUG88 1 ATTACHED SIGN FOR \"PENINSULA BLUEPR...",
         "Planner": "GREICHER ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD88-469",
         "APN": 25940042,
         "File Number": "AD88-469",
         "Address": "19 S 1ST ST SAN JOSE",
         "Project Name": "AD88-469",
         "Application Type": "Sign Permit ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:31AUG88 SIGN & COLORS",
         "Planner": "Jerry Yoshida ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD88-496",
         "APN": 46723088,
         "File Number": "AD88-496",
         "Address": "10 S 3RD ST SAN JOSE",
         "Project Name": "AD88-496",
         "Application Type": "Sign Permit ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:16SEP88 1 ATTACHED SIGN \"BANK OF TRADE LIPPO ...",
         "Planner": "ISHIEKH ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD88-555",
         "APN": 25934053,
         "File Number": "AD88-555",
         "Address": "111 N MARKET ST Bldg 1 SAN JOSE",
         "Project Name": "AD88-555",
         "Application Type": "Sign Permit ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:14OCT88 3 ATTACHED SIGNS \"CALIFORNIA COMMERCE...",
         "Planner": "ISHIEKH ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD89-102",
         "APN": 25936074,
         "File Number": "AD89-102",
         "Address": "333 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD89-102",
         "Application Type": "Sign Permit ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:23FEB89 1 ATTACHED SIGN \"SHEARSON LEHMAN HUTTON\"",
         "Planner": "ISHIEKH ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD89-509",
         "APN": 46720060,
         "File Number": "AD89-509",
         "Address": "77 N 4TH ST SAN JOSE",
         "Project Name": "AD89-509",
         "Application Type": "Sign Permit ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:31-JUL",
         "Planner": "UNKNOWN ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD89-685",
         "APN": 46719075,
         "File Number": "AD89-685",
         "Address": "235 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD89-685",
         "Application Type": "Sign Permit ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:10- REDEVEL.",
         "Planner": "UNKNOWN ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD89-685",
         "APN": 46757083,
         "File Number": "AD89-685",
         "Address": "235 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD89-685",
         "Application Type": "Sign Permit ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:10- REDEVEL.",
         "Planner": "UNKNOWN ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD89-881",
         "APN": 46724040,
         "File Number": "AD89-881",
         "Address": "332 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD89-881",
         "Application Type": "Sign Permit ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:10JAN90 2 ATTACHED SIGNS \"WASH AMERICA\"",
         "Planner": "Larry Bohannan ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD90-023",
         "APN": 46723089,
         "File Number": "AD90-023",
         "Address": "100 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD90-023",
         "Application Type": "Sign Permit ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:22JAN90 ATTACHED SIGN INDIVIDUAL CHANNEL LETTERS",
         "Planner": "CGOLDBLA ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD90-026",
         "APN": 46723088,
         "File Number": "AD90-026",
         "Address": "10 S 3RD ST SAN JOSE",
         "Project Name": "AD90-026",
         "Application Type": "Sign Permit ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:24JAN90 NON-ILLUMINATING ATTACHED SIGN",
         "Planner": "CGOLDBLA ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD90-079",
         "APN": 25934053,
         "File Number": "AD90-079",
         "Address": "111 N MARKET ST Bldg 1 SAN JOSE",
         "Project Name": "AD90-079",
         "Application Type": "Sign Permit ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:01FEB90 LETTERING ON AWNING",
         "Planner": "CGOLDBLA ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD90-486",
         "APN": 25934016,
         "File Number": "AD90-486",
         "Address": "41 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD90-486",
         "Application Type": "Sign Permit ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:29JUN90 1 ATTACHED, 1 DETACHED SIGN \"AMERICAN...",
         "Planner": "CGOLDBLA ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD90-691",
         "APN": 46720072,
         "File Number": "AD90-691",
         "Address": "101 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD90-691",
         "Application Type": "Sign Permit ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:13SEP90 1 ATTACHED SIGN \"AB-CD EXCHANGE\"",
         "Planner": "CGOLDBLA ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD90-975",
         "APN": 26420121,
         "File Number": "AD90-975",
         "Address": "395 BIRD AV SAN JOSE",
         "Project Name": "AD90-975",
         "Application Type": "Sign Permit ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:04APR91 INSTALL MONUMENT SIGN & SPANNER W/HAL...",
         "Planner": "Rich Buikema ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD91-289",
         "APN": 26420008,
         "File Number": "AD91-289",
         "Address": "358 ROYAL AV SAN JOSE",
         "Project Name": "AD91-289",
         "Application Type": "Sign Permit ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:10MAY91 FASCIA SIGNS",
         "Planner": "Rich Buikema ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD91-492",
         "APN": 46718087,
         "File Number": "AD91-492",
         "Address": "345 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD91-492",
         "Application Type": "Sign Permit ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:17SEP91 SIGNS & AWNINGS",
         "Planner": "Rich Buikema ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD92-007",
         "APN": 46724110,
         "File Number": "AD92-007",
         "Address": "268 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD92-007",
         "Application Type": "Sign Permit ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:05FEB92 MON SIGN",
         "Planner": "RHASHIMO ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD92-911",
         "APN": 26416039,
         "File Number": "AD92-911",
         "Address": "710 DRAKE ST SAN JOSE",
         "Project Name": "AD92-911",
         "Application Type": "Sign Permit ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:9/24/92 SIGN",
         "Planner": "ISHIEKH ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD93-429",
         "APN": 26420121,
         "File Number": "AD93-429",
         "Address": "395 BIRD AV SAN JOSE",
         "Project Name": "AD93-429",
         "Application Type": "Sign Permit ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:8/11/93 1 ATTACHED SIGN",
         "Planner": "Vic Mendez ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD93-602",
         "APN": 46724110,
         "File Number": "AD93-602",
         "Address": "268 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD93-602",
         "Application Type": "Sign Permit ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:11/17/93 3 ATTACHED",
         "Planner": "Michele Campos ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD94-749",
         "APN": 46747042,
         "File Number": "AD94-749",
         "Address": "404 S 2ND ST SAN JOSE",
         "Project Name": "AD94-749",
         "Application Type": "Sign Permit ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:11-01-94 2 ATTACHED SIGNS \"HUNG WON B.B.Q.\"",
         "Planner": "Bill Scott ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD95-113",
         "APN": 47229044,
         "File Number": "AD95-113",
         "Address": "508 S 10TH ST SAN JOSE",
         "Project Name": "AD95-113",
         "Application Type": "Sign Permit ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:13MAR95 REDESIGN DETACHED SIGN & ADD DOOR",
         "Planner": "Vic Mendez ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD96-086",
         "APN": 46724110,
         "File Number": "AD96-086",
         "Address": "264 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD96-086",
         "Application Type": "Sign Permit ",
         "Application Date": "2/6/96",
         "Status": "Approved ",
         "Description": "1 ATTACHED \"MISKARIE HAIR SALON\"",
         "Planner": "Susan Walton ",
         "DURATION": 0,
         "Year": 1996
      },
      {
         "PERMITID": "AD98-392",
         "APN": 25945074,
         "File Number": "AD98-392",
         "Address": "459 PARK AV SAN JOSE",
         "Project Name": "AD98-392",
         "Application Type": "Sign Permit ",
         "Application Date": " ",
         "Status": "Approved ",
         "Description": "Action date:15APR98 ONE SET OF 24\" CHANNEL LETTERS",
         "Planner": "Vic Mendez ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD99-1076",
         "APN": 46724111,
         "File Number": "AD99-1076",
         "Address": "278 E SANTA CLARA ST SAN JOSE",
         "Project Name": "AD99-1076",
         "Application Type": "Sign Permit ",
         "Application Date": "10/26/99",
         "Status": "Approved ",
         "Description": "ATTACHED ALBERTSONS SIGN ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RA87-017",
         "APN": 25940084,
         "File Number": "RA87-017",
         "Address": " ",
         "Project Name": "RA87-017, Wienerschnitzel Sign",
         "Application Type": "Sign Permit ",
         "Application Date": "6/22/87",
         "Status": "Approved ",
         "Description": "Exterior awning sign ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 1987
      },
      {
         "PERMITID": "RA87-023",
         "APN": 25941070,
         "File Number": "RA87-023",
         "Address": " ",
         "Project Name": "RA87-023, Signature Custom Clothiers",
         "Application Type": "Sign Permit ",
         "Application Date": "9/8/87",
         "Status": "Approved ",
         "Description": "Sign ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1987
      },
      {
         "PERMITID": "RA87-034",
         "APN": 25940034,
         "File Number": "RA87-034",
         "Address": " ",
         "Project Name": "RA87-034, Sumitomo Bank of California",
         "Application Type": "Sign Permit ",
         "Application Date": "5/4/87",
         "Status": "Approved ",
         "Description": "Replacement of old signage with new signage. ",
         "Planner": "Walter Cohen ",
         "DURATION": 0,
         "Year": 1987
      },
      {
         "PERMITID": "RA89-028",
         "APN": 25944080,
         "File Number": "RA89-028",
         "Address": " ",
         "Project Name": "RA89-028, PG&E",
         "Application Type": "Sign Permit ",
         "Application Date": "9/12/89",
         "Status": "Approved ",
         "Description": "Temporary banners on top and bottom of building advertising new Saturday business hours for 2 months.",
         "Planner": "Ted Lorraine ",
         "DURATION": 0,
         "Year": 1989
      },
      {
         "PERMITID": "RA89-030A",
         "APN": 25939122,
         "File Number": "RA89-030A",
         "Address": " ",
         "Project Name": "RA89-030, Citibank",
         "Application Type": "Sign Permit ",
         "Application Date": "2/2/90",
         "Status": "Approved ",
         "Description": "Revises permit #RA89-30 to add temporary signs",
         "Planner": "Ted Lorraine ",
         "DURATION": 0,
         "Year": 1990
      },
      {
         "PERMITID": "RA90-008",
         "APN": 25940018,
         "File Number": "RA90-008",
         "Address": " ",
         "Project Name": "RA90-008, Western Union",
         "Application Type": "Sign Permit ",
         "Application Date": "4/3/90",
         "Status": "Approved ",
         "Description": "Installation of fascia and fin signs for 'Western Union/Check Cashing' business. ",
         "Planner": "Diane Whitecar ",
         "DURATION": 0,
         "Year": 1990
      },
      {
         "PERMITID": "RA90-015",
         "APN": 25941070,
         "File Number": "RA90-015",
         "Address": " ",
         "Project Name": "RA90-015, Park Center Plaza Signs",
         "Application Type": "Sign Permit ",
         "Application Date": "7/2/90",
         "Status": "Approved ",
         "Description": "Retail signage program and main entry lettering for garage entrances. ",
         "Planner": "Ted Lorraine ",
         "DURATION": 0,
         "Year": 1990
      },
      {
         "PERMITID": "RA90-016",
         "APN": 25941078,
         "File Number": "RA90-016",
         "Address": " ",
         "Project Name": "RA90-016, San Jose Museum of Art",
         "Application Type": "Sign Permit ",
         "Application Date": "6/28/90",
         "Status": "Approved ",
         "Description": "Installation and display of a temporary banner publicizing the July-August-September 1990 Exhibition.",
         "Planner": "Ted Lorraine ",
         "DURATION": 0,
         "Year": 1990
      },
      {
         "PERMITID": "RAD00-001",
         "APN": 25941057,
         "File Number": "RAD00-001",
         "Address": " ",
         "Project Name": "RAD00-001, Bank of America",
         "Application Type": "Sign Permit ",
         "Application Date": "1/18/00",
         "Status": "Approved ",
         "Description": "Change out existing Bank of America signs to new logos ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "RAD00-014",
         "APN": 25941068,
         "File Number": "RAD00-014",
         "Address": "185 PARK AV SAN JOSE",
         "Project Name": "RAD00-014, Sir Speedy Printing",
         "Application Type": "Sign Permit ",
         "Application Date": "3/10/00",
         "Status": "Approved ",
         "Description": "Remove old sign and install one (1)new illuminated storefront sign.",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "RAD00-022",
         "APN": 25934053,
         "File Number": "RAD00-022",
         "Address": " ",
         "Project Name": "RAD00-022, CRP Sign",
         "Application Type": "Sign Permit ",
         "Application Date": "4/17/00",
         "Status": "Approved ",
         "Description": "Installation of new stainless steel signage on front of building. ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "RAD00-043",
         "APN": 46723096,
         "File Number": "RAD00-043",
         "Address": "101 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "RAD00-043, Bank of America Sign",
         "Application Type": "Sign Permit ",
         "Application Date": "7/14/00",
         "Status": "Approved ",
         "Description": "Install three (3) wall-mounted sign and one (1) projecting sign.",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "RAD00-045",
         "APN": 25941066,
         "File Number": "RAD00-045",
         "Address": "177 PARK CENTER PLAZA SAN JOSE",
         "Project Name": "RAD00-045, Scott's Seafood",
         "Application Type": "Sign Permit ",
         "Application Date": "7/25/00",
         "Status": "Approved ",
         "Description": "Installation of three (3) wall mounted signs (including 1 skyline sign)",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "RAD00-047",
         "APN": 25940074,
         "File Number": "RAD00-047",
         "Address": " ",
         "Project Name": "RAD00-047, Walgreen's",
         "Application Type": "Sign Permit ",
         "Application Date": "8/10/00",
         "Status": "Approved ",
         "Description": "Install one (1) \"Walgreens\" script sign, one (1) \"Pharmacy\" cabinet sign, one (1) \"1-Hour Photo\"cabinet, one (1) \"Walgreens\" box sign, one (1) neon \"Pharmacy\" window sign, and one (1) neon \"1-Hour Photo\" window sign.",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "RAD00-048",
         "APN": 46746081,
         "File Number": "RAD00-048",
         "Address": " ",
         "Project Name": "RAD00-048, Chamber of Commerce",
         "Application Type": "Sign Permit ",
         "Application Date": "8/15/00",
         "Status": "Approved ",
         "Description": "Remove 3 existing signs, replace with two (2) sets of exterior illuminated channel letters plus logo on a module with vinyl graphics overlay.",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "RAD00-051",
         "APN": 46746081,
         "File Number": "RAD00-051",
         "Address": " ",
         "Project Name": "RAD00-051, Silicon Valley Business iNK",
         "Application Type": "Sign Permit ",
         "Application Date": "8/22/00",
         "Status": "Approved ",
         "Description": "Install 1 set of individual 'non-illuminated' letters to read 'Silicon Valley BUSINESS iNK.'",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "RAD00-052",
         "APN": 46746081,
         "File Number": "RAD00-052",
         "Address": " ",
         "Project Name": "RAD00-052, KBM Workspace",
         "Application Type": "Sign Permit ",
         "Application Date": "8/22/00",
         "Status": "Approved ",
         "Description": "Install one set of individual letters reading 'KBM Workspace', letters are 'halo' illuminated with neon. ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "RAD00-053",
         "APN": 25940034,
         "File Number": "RAD00-053",
         "Address": " ",
         "Project Name": "RAD00-053, Entrepreneur Center",
         "Application Type": "Sign Permit ",
         "Application Date": "8/22/00",
         "Status": "Approved ",
         "Description": "Change out message of existing signs, including legal non-conforming skyline sign. ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "RAD00-057",
         "APN": 25924035,
         "File Number": "RAD00-057",
         "Address": " ",
         "Project Name": "RAD00-057, Ricochet/Metricom, Inc.",
         "Application Type": "Sign Permit ",
         "Application Date": "9/25/00",
         "Status": "Approved ",
         "Description": "skyline signage, illuminated wall sign ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "RAD00-059",
         "APN": 25940044,
         "File Number": "RAD00-059",
         "Address": " ",
         "Project Name": "RAD00-059, George's Jeweler's",
         "Application Type": "Sign Permit ",
         "Application Date": "10/4/00",
         "Status": "Approved ",
         "Description": "Refurbish sign, new paint on facade. ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "RAD00-063",
         "APN": 25940053,
         "File Number": "RAD00-063",
         "Address": " ",
         "Project Name": "RAD00-063, Ten Squares",
         "Application Type": "Sign Permit ",
         "Application Date": "10/19/00",
         "Status": "Approved ",
         "Description": "Remove existing signage, replace with 2 single face, non-illuminated signs.",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "RAD00-064",
         "APN": 46723096,
         "File Number": "RAD00-064",
         "Address": " ",
         "Project Name": "RAD00-064, 101 San Fernando Apartments",
         "Application Type": "Sign Permit ",
         "Application Date": "10/25/00",
         "Status": "Approved ",
         "Description": "Installation of new signage. ",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "RAD00-072",
         "APN": 46721002,
         "File Number": "RAD00-072",
         "Address": " ",
         "Project Name": "RAD00-072, Earthlink",
         "Application Type": "Sign Permit ",
         "Application Date": "11/14/00",
         "Status": "Approved ",
         "Description": "Install new signage where old signage was on top of roof on false windbreak. ",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "RAD00-072",
         "APN": 46721035,
         "File Number": "RAD00-072",
         "Address": " ",
         "Project Name": "RAD00-072, Earthlink",
         "Application Type": "Sign Permit ",
         "Application Date": "11/14/00",
         "Status": "Approved ",
         "Description": "Install new signage where old signage was on top of roof on false windbreak. ",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "RAD00-073",
         "APN": 25940036,
         "File Number": "RAD00-073",
         "Address": " ",
         "Project Name": "RAD00-073, Elite Wireless",
         "Application Type": "Sign Permit ",
         "Application Date": "12/1/00",
         "Status": "Approved ",
         "Description": "Change out sign from \"GTE Wireless\" to \"Verizon Wireless\" ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "RAD01-002",
         "APN": 25934039,
         "File Number": "RAD01-002",
         "Address": " ",
         "Project Name": "RAD01-002, Downtown Free Parking Signage",
         "Application Type": "Sign Permit ",
         "Application Date": "1/29/01",
         "Status": "Approved ",
         "Description": "Installation of signage to promote the free parking program at city facilities ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "RAD01-002",
         "APN": 46746097,
         "File Number": "RAD01-002",
         "Address": " ",
         "Project Name": "RAD01-002, Downtown Free Parking Signage",
         "Application Type": "Sign Permit ",
         "Application Date": "1/29/01",
         "Status": "Approved ",
         "Description": "Installation of signage to promote the free parking program at city facilities ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "RAD01-015",
         "APN": 25932005,
         "File Number": "RAD01-015",
         "Address": " ",
         "Project Name": "RAD01-015, Club Wild",
         "Application Type": "Sign Permit ",
         "Application Date": "4/6/01",
         "Status": "Approved ",
         "Description": "Install one (1) neon 'Club Wild' sign totaling 60 square feet.",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "RAD01-022",
         "APN": 25940045,
         "File Number": "RAD01-022",
         "Address": " ",
         "Project Name": "RAD01-022, Hip Pop",
         "Application Type": "Sign Permit ",
         "Application Date": "10/10/01",
         "Status": "Approved ",
         "Description": "Installation of two (2) neon signs - one on facade, one in window.",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "RAD01-022",
         "APN": 46723096,
         "File Number": "RAD01-022",
         "Address": " ",
         "Project Name": "RAD01-022, 101 San Fernando Apts.",
         "Application Type": "Sign Permit ",
         "Application Date": "5/31/01",
         "Status": "Approved ",
         "Description": "Install illuminated main ID marquee. ",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "RAD01-023",
         "APN": 46746016,
         "File Number": "RAD01-023",
         "Address": "384 S 2ND ST SAN JOSE",
         "Project Name": "RAD01-10-023, San Jose State University Language Center",
         "Application Type": "Sign Permit ",
         "Application Date": "10/10/01",
         "Status": "Approved ",
         "Description": "Installation of two (2) signs: one sign is to have metal sign elements (letters & symbols) individually mounted on wall and set 1\" - 2\" from wall; second sign will be mounted perpendicular to the wall and will be a graphic symbol only.",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "RAD01-025",
         "APN": 25940094,
         "File Number": "RAD01-025",
         "Address": " ",
         "Project Name": "RAD01-025, Knight-Ridder Digital",
         "Application Type": "Sign Permit ",
         "Application Date": "6/28/01",
         "Status": "Approved ",
         "Description": "Installation of sign consisting of 15\" x 16\" letters on a 10\" aluminum rail across the front of the Metropole Building.",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "RAD01-026",
         "APN": 25939112,
         "File Number": "RAD01-026",
         "Address": " ",
         "Project Name": "RAD01-026, Robert Half International, Inc.",
         "Application Type": "Sign Permit ",
         "Application Date": "7/10/01",
         "Status": "Approved ",
         "Description": "Install one 9) new illuminated wall sign.",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "RAD01-026",
         "APN": 47226091,
         "File Number": "RAD01-026",
         "Address": " ",
         "Project Name": "RAD01-026, Robert Half International, Inc.",
         "Application Type": "Sign Permit ",
         "Application Date": "7/10/01",
         "Status": "Approved ",
         "Description": "Install one 9) new illuminated wall sign.",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "RAD01-028",
         "APN": 46746097,
         "File Number": "RAD01-028",
         "Address": " ",
         "Project Name": "RAD01-028, Golden Bay Federal Credit Union Sign",
         "Application Type": "Sign Permit ",
         "Application Date": "7/17/01",
         "Status": "Approved ",
         "Description": "Addition of two electrical signs/ two sets of internally illuminated channel letters ",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "RAD02-005",
         "APN": 25940036,
         "File Number": "RAD02-005",
         "Address": "66 W SANTA CLARA ST SAN JOSE",
         "Project Name": "RAD02-005, Elite Wireless - T-Mobile",
         "Application Type": "Sign Permit ",
         "Application Date": "8/12/02",
         "Status": "Approved ",
         "Description": "Install one (1) set of illuminated wall letters with module cabinet. Install one (1) set of window vinyl.",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2002
      },
      {
         "PERMITID": "RAD02-008",
         "APN": 46747095,
         "File Number": "RAD02-008",
         "Address": " ",
         "Project Name": "RAD02-008, Ramada Limited",
         "Application Type": "Sign Permit ",
         "Application Date": "4/25/02",
         "Status": "Approved ",
         "Description": "Installation of two (2) new signs - one facing 1st Street and one facing E. San Salvador.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2002
      },
      {
         "PERMITID": "RAD02-013",
         "APN": 47226084,
         "File Number": "RAD02-013",
         "Address": " ",
         "Project Name": "RAD02-013, City Lights Theater",
         "Application Type": "Sign Permit ",
         "Application Date": "5/14/02",
         "Status": "Approved ",
         "Description": "Install Marquee sign - 18.6' x 7.6'",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2002
      },
      {
         "PERMITID": "RAD02-016",
         "APN": 25940087,
         "File Number": "RAD02-016",
         "Address": " ",
         "Project Name": "RAD02-016, Kinko's",
         "Application Type": "Sign Permit ",
         "Application Date": "6/3/02",
         "Status": "Approved ",
         "Description": "Install three (3) sets of internally illuminated channel letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2002
      },
      {
         "PERMITID": "RAD02-018",
         "APN": 46722031,
         "File Number": "RAD02-018",
         "Address": " ",
         "Project Name": "RAD02-018, San Jose Bar & Grill",
         "Application Type": "Sign Permit ",
         "Application Date": "6/18/02",
         "Status": "Approved ",
         "Description": "Add fin projection street signage, add an awning, move double doors from center to right side of building and add recessed sliding window wall. ",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2002
      },
      {
         "PERMITID": "RAD02-027",
         "APN": 25942079,
         "File Number": "RAD02-027",
         "Address": " ",
         "Project Name": "RAD02-027, Hotel Montgomery",
         "Application Type": "Sign Permit ",
         "Application Date": "8/19/02",
         "Status": "Approved ",
         "Description": "Signage for hotel/restaurant - vertical blade sign, ADA sign, restaurant plaque, marquee sign, and restaurant menu cabinet. ",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2002
      },
      {
         "PERMITID": "RAD02-030",
         "APN": 46759111,
         "File Number": "RAD02-030",
         "Address": " ",
         "Project Name": "RAD02-030, Cafe Boba",
         "Application Type": "Sign Permit ",
         "Application Date": "9/17/02",
         "Status": "Approved ",
         "Description": "Fabricate and install one (1) building fascia mounted, internally illuminated channel design logo and one (1) set of 1/2\" thick flat, cut-out acrylic letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2002
      },
      {
         "PERMITID": "RAD02-032",
         "APN": 46722056,
         "File Number": "RAD02-032",
         "Address": "71 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "RAD02-032, Stratta Grill & Bar",
         "Application Type": "Sign Permit ",
         "Application Date": "10/7/02",
         "Status": "Approved ",
         "Description": "Replace tile entry to read 'Stratta Grill and Bar\". Original tile creating slipping hazard when wet per Stratta owner. ",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2002
      },
      {
         "PERMITID": "RAD03-007",
         "APN": 46759110,
         "File Number": "RAD03-007",
         "Address": " ",
         "Project Name": "RAD03-007, Copy Club",
         "Application Type": "Sign Permit ",
         "Application Date": "1/29/03",
         "Status": "Approved ",
         "Description": "Fabricate and install 2 raceway mounted individually exposed neon pan channel letter signs on each street frontage",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-013",
         "APN": 25935020,
         "File Number": "RAD03-013",
         "Address": " ",
         "Project Name": "RAD03-013, Opus West Office Building",
         "Application Type": "Sign Permit ",
         "Application Date": "6/13/03",
         "Status": "Approved ",
         "Description": "New wall-mounted exterior tenant directory with changeable tenant panels. Overall size is 11 sq. ft.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-018",
         "APN": 25944089,
         "File Number": "RAD03-018",
         "Address": " ",
         "Project Name": "RAD03-018, Adobe Systems, Tower II",
         "Application Type": "Sign Permit ",
         "Application Date": "8/18/03",
         "Status": "Approved ",
         "Description": "Two (2) skyline signs on new tower - north and west elevations",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-020",
         "APN": 46722031,
         "File Number": "RAD03-020",
         "Address": " ",
         "Project Name": "RAD03-020, Tres Gringos",
         "Application Type": "Sign Permit ",
         "Application Date": "9/2/03",
         "Status": "Approved ",
         "Description": "Installation of a double-face flag mount illuminated sign. ",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952002,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952003,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952004,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952006,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952008,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952009,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952010,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952012,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952013,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952014,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952015,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952018,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952019,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952022,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952023,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952024,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952025,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952026,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952027,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952028,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952029,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952030,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952031,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952033,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952038,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952039,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952041,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952042,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952043,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952044,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952045,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952046,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952047,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952048,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952049,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952050,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952051,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952054,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952055,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952056,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952057,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952058,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952060,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952061,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952062,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952066,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952069,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952071,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952073,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952075,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952077,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952080,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952081,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952082,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952083,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952085,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952091,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952093,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952094,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952095,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952098,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952099,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952196,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952197,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952198,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952200,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD03-033",
         "APN": 25952206,
         "File Number": "RAD03-033",
         "Address": " ",
         "Project Name": "RAD03-033, Park Townsend",
         "Application Type": "Sign Permit ",
         "Application Date": "9/18/03",
         "Status": "Approved ",
         "Description": "Installation of signage on Julian St. - 12\" H letters punched in 18 GA aluminum sheet, attached to front of canopy and illuminated from behind, and First St. entrance - 12\" H aluminum, 3D letters.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RAD91-004",
         "APN": 25934019,
         "File Number": "RAD91-004",
         "Address": " ",
         "Project Name": "RAD91-004, Alpha Graphics Signage",
         "Application Type": "Sign Permit ",
         "Application Date": "3/12/91",
         "Status": "Approved ",
         "Description": "Installation of signage ",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1991
      },
      {
         "PERMITID": "RAD91-004",
         "APN": 25934040,
         "File Number": "RAD91-004",
         "Address": " ",
         "Project Name": "RAD91-004, Alpha Graphics Signage",
         "Application Type": "Sign Permit ",
         "Application Date": "3/12/91",
         "Status": "Approved ",
         "Description": "Installation of signage ",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1991
      },
      {
         "PERMITID": "RAD91-015",
         "APN": 25939122,
         "File Number": "RAD91-015",
         "Address": " ",
         "Project Name": "RAD91-015, 10 Almaden Bldg. Signage",
         "Application Type": "Sign Permit ",
         "Application Date": "5/28/91",
         "Status": "Approved ",
         "Description": "Two (2) sets stainless steel non-illuminated letter wall signs",
         "Planner": "Ted Lorraine ",
         "DURATION": 0,
         "Year": 1991
      },
      {
         "PERMITID": "RAD91-030",
         "APN": 46746030,
         "File Number": "RAD91-030",
         "Address": " ",
         "Project Name": "RAD91-030, San Jose Trolley Cafe",
         "Application Type": "Sign Permit ",
         "Application Date": "7/29/91",
         "Status": "Approved ",
         "Description": "One new wall mounted cabinet sign illuminated internally ",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1991
      },
      {
         "PERMITID": "RAD91-041",
         "APN": 47226036,
         "File Number": "RAD91-041",
         "Address": " ",
         "Project Name": "RAD91-041, Community Value Center",
         "Application Type": "Sign Permit ",
         "Application Date": "12/2/91",
         "Status": "Approved ",
         "Description": "Installation of new signage ",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1991
      },
      {
         "PERMITID": "RAD91-043",
         "APN": 46746097,
         "File Number": "RAD91-043",
         "Address": " ",
         "Project Name": "RAD91-043, Kinko's Copies",
         "Application Type": "Sign Permit ",
         "Application Date": "12/16/91",
         "Status": "Approved ",
         "Description": "Installation of new signage ",
         "Planner": "Ted Lorraine ",
         "DURATION": 0,
         "Year": 1991
      },
      {
         "PERMITID": "RAD92-011",
         "APN": 46720068,
         "File Number": "RAD92-011",
         "Address": " ",
         "Project Name": "RAD92-011, The Business Journal",
         "Application Type": "Sign Permit ",
         "Application Date": "3/9/92",
         "Status": "Approved ",
         "Description": "Installation of new signage made of unlit letters in Plexiglass & brushed aluminum - face: brass color ",
         "Planner": "Ted Lorraine ",
         "DURATION": 0,
         "Year": 1992
      },
      {
         "PERMITID": "RAD92-022",
         "APN": 46723089,
         "File Number": "RAD92-022",
         "Address": " ",
         "Project Name": "RAD92-022, The Hoffman Agency",
         "Application Type": "Sign Permit ",
         "Application Date": "5/6/92",
         "Status": "Approved ",
         "Description": "Addition of exterior signage (raised metal letters) ",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1992
      },
      {
         "PERMITID": "RAD92-031",
         "APN": 25939122,
         "File Number": "RAD92-031",
         "Address": " ",
         "Project Name": "RAD92-031, Cellular One Sign",
         "Application Type": "Sign Permit ",
         "Application Date": "8/20/92",
         "Status": "Approved ",
         "Description": "Install one (1) internally illuminated individual letter building sign",
         "Planner": "Ted Lorraine ",
         "DURATION": 0,
         "Year": 1992
      },
      {
         "PERMITID": "RAD92-043",
         "APN": 46746106,
         "File Number": "RAD92-043",
         "Address": " ",
         "Project Name": "RAD92-043, Signage for YWCA Villa Nueva",
         "Application Type": "Sign Permit ",
         "Application Date": "12/3/92",
         "Status": "Approved ",
         "Description": "Install (2) sets 18\" illuminated letters - (1) on East elevation and (1) on West elevation",
         "Planner": "Ted Lorraine ",
         "DURATION": 0,
         "Year": 1992
      },
      {
         "PERMITID": "RAD93-001",
         "APN": 46745073,
         "File Number": "RAD93-001",
         "Address": " ",
         "Project Name": "RAD93-001, Ben & Jerry's Ice Cream",
         "Application Type": "Sign Permit ",
         "Application Date": "8/9/93",
         "Status": "Approved ",
         "Description": "New sign in existing sign band ",
         "Planner": "Ted Lorraine ",
         "DURATION": 0,
         "Year": 1993
      },
      {
         "PERMITID": "RAD93-007",
         "APN": 25939122,
         "File Number": "RAD93-007",
         "Address": " ",
         "Project Name": "RAD93-007, Cellular One Sign",
         "Application Type": "Sign Permit ",
         "Application Date": "5/21/93",
         "Status": "Approved ",
         "Description": "Install one (1) set internally illuminated individual letter building sign",
         "Planner": "Ted Lorraine ",
         "DURATION": 0,
         "Year": 1993
      },
      {
         "PERMITID": "RAD93-013",
         "APN": 25935035,
         "File Number": "RAD93-013",
         "Address": "163 W SANTA CLARA ST SAN JOSE",
         "Project Name": "RAD93-013, Togo's",
         "Application Type": "Sign Permit ",
         "Application Date": "6/7/93",
         "Status": "Approved ",
         "Description": "One (1) D/F neon sign 30\" x 6' center of store over doorway",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1993
      },
      {
         "PERMITID": "RAD93-025",
         "APN": 46746072,
         "File Number": "RAD93-025",
         "Address": " ",
         "Project Name": "RAD93-025, McDonalds",
         "Application Type": "Sign Permit ",
         "Application Date": "8/25/93",
         "Status": "Approved ",
         "Description": "Canopy & monument sign ",
         "Planner": "Mary Stokes ",
         "DURATION": 0,
         "Year": 1993
      },
      {
         "PERMITID": "RAD93-030",
         "APN": 46747089,
         "File Number": "RAD93-030",
         "Address": " ",
         "Project Name": "RAD93-030, SOFA Billiards",
         "Application Type": "Sign Permit ",
         "Application Date": "10/13/93",
         "Status": "Approved ",
         "Description": "Signage/ FIP ",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1993
      },
      {
         "PERMITID": "RAD93-036",
         "APN": 25943075,
         "File Number": "RAD93-036",
         "Address": " ",
         "Project Name": "RAD93-036, Paolo's Restaurant",
         "Application Type": "Sign Permit ",
         "Application Date": "11/23/93",
         "Status": "Approved ",
         "Description": "Addition of signage ",
         "Planner": "Mary Stokes ",
         "DURATION": 0,
         "Year": 1993
      },
      {
         "PERMITID": "RAD94-002",
         "APN": 25935045,
         "File Number": "RAD94-002",
         "Address": " ",
         "Project Name": "RAD94-002, Hamburger Mary's",
         "Application Type": "Sign Permit ",
         "Application Date": "1/19/94",
         "Status": "Approved ",
         "Description": "One (1) monument sign reading \"Hamburger Mary's\"",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1994
      },
      {
         "PERMITID": "RAD94-020",
         "APN": 25934016,
         "File Number": "RAD94-020",
         "Address": " ",
         "Project Name": "RAD94-020, American Savings sign",
         "Application Type": "Sign Permit ",
         "Application Date": "5/13/94",
         "Status": "Approved ",
         "Description": "1 set of 18\" channel letters with 3'-4\" logo interior illumination",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1994
      },
      {
         "PERMITID": "RAD94-022",
         "APN": 46747042,
         "File Number": "RAD94-022",
         "Address": " ",
         "Project Name": "RAD94-022, Dai Thanh signage",
         "Application Type": "Sign Permit ",
         "Application Date": "5/20/94",
         "Status": "Approved ",
         "Description": "Add recessed sign over tenant structures ",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1994
      },
      {
         "PERMITID": "RAD94-024",
         "APN": 25936074,
         "File Number": "RAD94-024",
         "Address": " ",
         "Project Name": "RAD94-024, Coamerica Bank",
         "Application Type": "Sign Permit ",
         "Application Date": "6/13/94",
         "Status": "Approved ",
         "Description": "Removal of 2 sets of 30\" 'Pacific Western Bank' signs and installation of 2 sets of 30\" 'Coamerica Bank' halogen lit signs (individual letters).",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1994
      },
      {
         "PERMITID": "RAD94-026",
         "APN": 25936074,
         "File Number": "RAD94-026",
         "Address": " ",
         "Project Name": "RAD94-026, Comerica Bank",
         "Application Type": "Sign Permit ",
         "Application Date": "7/5/94",
         "Status": "Approved ",
         "Description": "Remove 2 existing 'Pacific Western Bank' logos and install new 'Coamerica Bank' logos.",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1994
      },
      {
         "PERMITID": "RAD95-016",
         "APN": 25940084,
         "File Number": "RAD95-016",
         "Address": " ",
         "Project Name": "RAD95-016, McWhorter's Stationary",
         "Application Type": "Sign Permit ",
         "Application Date": "9/7/95",
         "Status": "Approved ",
         "Description": "Installation of signage facing Market St. and San Fernando. 2 banners with flag mounted fabric 2'-0\" W x 6'-0\" H. Modifying entry @ corner of Market & San Fernando and adding exit only door off San Fernando.",
         "Planner": "Jan Onstead ",
         "DURATION": 0,
         "Year": 1995
      },
      {
         "PERMITID": "RAD95-023",
         "APN": 46746105,
         "File Number": "RAD95-023",
         "Address": " ",
         "Project Name": "RAD95-023, United Artists Cinema",
         "Application Type": "Sign Permit ",
         "Application Date": "11/3/95",
         "Status": "Approved ",
         "Description": "Installation of signage ",
         "Planner": "Mary Stokes ",
         "DURATION": 0,
         "Year": 1995
      },
      {
         "PERMITID": "RAD96-001",
         "APN": 25944075,
         "File Number": "RAD96-001",
         "Address": "345 PARK AV SAN JOSE",
         "Project Name": "RAD96-001, Adobe Systems, Inc.",
         "Application Type": "Sign Permit ",
         "Application Date": "1/25/96",
         "Status": "Approved ",
         "Description": "Install two logographic signs on the south and north elevations of building. ",
         "Planner": "Martin Magana ",
         "DURATION": 0,
         "Year": 1996
      },
      {
         "PERMITID": "RAD96-001",
         "APN": 25944085,
         "File Number": "RAD96-001",
         "Address": "345 PARK AV SAN JOSE",
         "Project Name": "RAD96-001, Adobe Systems, Inc.",
         "Application Type": "Sign Permit ",
         "Application Date": "1/25/96",
         "Status": "Approved ",
         "Description": "Install two logographic signs on the south and north elevations of building. ",
         "Planner": "Martin Magana ",
         "DURATION": 0,
         "Year": 1996
      },
      {
         "PERMITID": "RAD96-004",
         "APN": 25940087,
         "File Number": "RAD96-004",
         "Address": " ",
         "Project Name": "RAD96-004, Copy Concepts",
         "Application Type": "Sign Permit ",
         "Application Date": "3/25/96",
         "Status": "Approved ",
         "Description": "Install 2 sets of 17\" and 12\" illuminated pan channel letters per drawing",
         "Planner": "Dennis Korabiak ",
         "DURATION": 0,
         "Year": 1996
      },
      {
         "PERMITID": "RAD96-006",
         "APN": 47226034,
         "File Number": "RAD96-006",
         "Address": " ",
         "Project Name": "RAD96-006, Metro Signage",
         "Application Type": "Sign Permit ",
         "Application Date": "3/28/96",
         "Status": "Approved ",
         "Description": "33 sq. ft. attached sign - painted steel and aluminum logo w/3 or 4 gooseneck lamps to light sign from above",
         "Planner": "Dennis Korabiak ",
         "DURATION": 0,
         "Year": 1996
      },
      {
         "PERMITID": "RAD96-011",
         "APN": 25940053,
         "File Number": "RAD96-011",
         "Address": "40 S MARKET ST SAN JOSE",
         "Project Name": "RAD96-011, Innetex Sign",
         "Application Type": "Sign Permit ",
         "Application Date": "6/20/96",
         "Status": "Approved ",
         "Description": "Install (1) non-illuminated sign",
         "Planner": "Kristi Ashburn ",
         "DURATION": 0,
         "Year": 1996
      },
      {
         "PERMITID": "RAD96-015",
         "APN": 47226084,
         "File Number": "RAD96-015",
         "Address": " ",
         "Project Name": "RAD96-015, City Lights Theater sign",
         "Application Type": "Sign Permit ",
         "Application Date": "7/16/96",
         "Status": "Approved ",
         "Description": "New sign ",
         "Planner": "Kristi Ashburn ",
         "DURATION": 0,
         "Year": 1996
      },
      {
         "PERMITID": "RAD96-016",
         "APN": 25939115,
         "File Number": "RAD96-016",
         "Address": " ",
         "Project Name": "RAD96-016, Union Bank of CA sign",
         "Application Type": "Sign Permit ",
         "Application Date": "7/23/96",
         "Status": "Approved ",
         "Description": "Replace existing raceway mounted letters ",
         "Planner": "Kristi Ashburn ",
         "DURATION": 0,
         "Year": 1996
      },
      {
         "PERMITID": "RAD96-017",
         "APN": 25940053,
         "File Number": "RAD96-017",
         "Address": " ",
         "Project Name": "RAD96-017, Waterhouse Investor Services sign",
         "Application Type": "Sign Permit ",
         "Application Date": "8/12/96",
         "Status": "Approved ",
         "Description": "fabrication/mounting of (2) non-illuminated metal signs on S. Market and Post St. sides of building",
         "Planner": "Kristi Ashburn ",
         "DURATION": 0,
         "Year": 1996
      },
      {
         "PERMITID": "RAD96-018",
         "APN": 25944075,
         "File Number": "RAD96-018",
         "Address": " ",
         "Project Name": "RAD96-018, Adobe Systems, Inc.",
         "Application Type": "Sign Permit ",
         "Application Date": "8/23/96",
         "Status": "Approved ",
         "Description": "Installation of a parking garage sign ",
         "Planner": "Dennis Korabiak ",
         "DURATION": 0,
         "Year": 1996
      },
      {
         "PERMITID": "RAD96-018",
         "APN": 25944085,
         "File Number": "RAD96-018",
         "Address": " ",
         "Project Name": "RAD96-018, Adobe Systems, Inc.",
         "Application Type": "Sign Permit ",
         "Application Date": "8/23/96",
         "Status": "Approved ",
         "Description": "Installation of a parking garage sign ",
         "Planner": "Dennis Korabiak ",
         "DURATION": 0,
         "Year": 1996
      },
      {
         "PERMITID": "RAD96-025",
         "APN": 46746105,
         "File Number": "RAD96-025",
         "Address": " ",
         "Project Name": "RAD96-025, United Artists Starport signage",
         "Application Type": "Sign Permit ",
         "Application Date": "10/16/96",
         "Status": "Approved ",
         "Description": "Installation of internally illuminated channel letters mounted directly to the exterior sign band area. ",
         "Planner": "Kristi Ashburn ",
         "DURATION": 0,
         "Year": 1996
      },
      {
         "PERMITID": "RAD96-027",
         "APN": 25941068,
         "File Number": "RAD96-027",
         "Address": " ",
         "Project Name": "RAD96-027, Federal Express",
         "Application Type": "Sign Permit ",
         "Application Date": "10/17/96",
         "Status": "Approved ",
         "Description": "replacement of tenant sign ",
         "Planner": "Kristi Ashburn ",
         "DURATION": 0,
         "Year": 1996
      },
      {
         "PERMITID": "RAD96-029",
         "APN": 25935057,
         "File Number": "RAD96-029",
         "Address": " ",
         "Project Name": "RAD96-029, Spiedo Restaurant",
         "Application Type": "Sign Permit ",
         "Application Date": "10/18/96",
         "Status": "Approved ",
         "Description": "Change sign wording. Remove marquee box sign & replace with new sign. Installation of new exit door on San Pedro street frontage. ",
         "Planner": "Kristi Ashburn ",
         "DURATION": 0,
         "Year": 1996
      },
      {
         "PERMITID": "RAD96-031",
         "APN": 25939122,
         "File Number": "RAD96-031",
         "Address": " ",
         "Project Name": "RAD96-031, Manufacturers Bank",
         "Application Type": "Sign Permit ",
         "Application Date": "10/24/96",
         "Status": "Approved ",
         "Description": "Sign change - letters, remove Silicon Valley Bank and change to Manufacturer's Bank ",
         "Planner": "Kristi Ashburn ",
         "DURATION": 0,
         "Year": 1996
      },
      {
         "PERMITID": "RAD96-034",
         "APN": 25940087,
         "File Number": "RAD96-034",
         "Address": " ",
         "Project Name": "RAD96-034, Saratoga National Bank",
         "Application Type": "Sign Permit ",
         "Application Date": "11/4/96",
         "Status": "Approved ",
         "Description": "Replace existing sign on front of building w/new sign on West side of building ",
         "Planner": "Kristi Ashburn ",
         "DURATION": 0,
         "Year": 1996
      },
      {
         "PERMITID": "RAD96-035",
         "APN": 25940017,
         "File Number": "RAD96-035",
         "Address": " ",
         "Project Name": "RAD96-035, Pizza Chicago",
         "Application Type": "Sign Permit ",
         "Application Date": "11/24/96",
         "Status": "Approved ",
         "Description": "New sign ",
         "Planner": "Dennis Korabiak ",
         "DURATION": 0,
         "Year": 1996
      },
      {
         "PERMITID": "RAD97-003",
         "APN": 25935057,
         "File Number": "RAD97-003",
         "Address": " ",
         "Project Name": "RAD97-003, Spiedo Restaurant",
         "Application Type": "Sign Permit ",
         "Application Date": "1/24/97",
         "Status": "Approved ",
         "Description": "Installation of two (2) sets of individual letters and face change",
         "Planner": "Kristi Ashburn ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RAD97-004",
         "APN": 25941068,
         "File Number": "RAD97-004",
         "Address": " ",
         "Project Name": "RAD97-004, Heritage Bank",
         "Application Type": "Sign Permit ",
         "Application Date": "1/27/97",
         "Status": "Approved ",
         "Description": "Use existing signage found at previous building to use at kiosk building at both front and back elevation. Bronze case iron signage mounted to face of building. ",
         "Planner": "Kristi Ashburn ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RAD97-010",
         "APN": 46720080,
         "File Number": "RAD97-010",
         "Address": " ",
         "Project Name": "RAD97-010, Town Park Towers",
         "Application Type": "Sign Permit ",
         "Application Date": "2/27/97",
         "Status": "Approved ",
         "Description": "Remove existing concrete monument sign and replace with L-shape aluminum monument sign ",
         "Planner": "Kristi Ashburn ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RAD97-014",
         "APN": 46721002,
         "File Number": "RAD97-014",
         "Address": " ",
         "Project Name": "RAD97-014, Netcom Signage",
         "Application Type": "Sign Permit ",
         "Application Date": "3/1/97",
         "Status": "Approved ",
         "Description": "Add one (1) set of channel letters to existing rooftop windshield",
         "Planner": "Dennis Korabiak ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RAD97-034",
         "APN": 46747090,
         "File Number": "RAD97-034",
         "Address": " ",
         "Project Name": "RAD97-034, The Usual",
         "Application Type": "Sign Permit ",
         "Application Date": "5/28/97",
         "Status": "Approved ",
         "Description": "Replace broken marquee sign ",
         "Planner": "Dennis Korabiak ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RAD97-042",
         "APN": 25940036,
         "File Number": "RAD97-042",
         "Address": " ",
         "Project Name": "RAD97-042, Elite Cellular",
         "Application Type": "Sign Permit ",
         "Application Date": "7/22/97",
         "Status": "Approved ",
         "Description": "Installation of new sign to exterior of building ",
         "Planner": "Julie Schaer ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RAD97-046",
         "APN": 46720078,
         "File Number": "RAD97-046",
         "Address": " ",
         "Project Name": "RAD97-046, The Works",
         "Application Type": "Sign Permit ",
         "Application Date": "8/15/97",
         "Status": "Approved ",
         "Description": "Paint name of business on front wall of building - lettering to be 25' long and varies in height from 1' - 4' high due to irregular architectural features.",
         "Planner": "Martin Magana ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RAD97-050",
         "APN": 25940037,
         "File Number": "RAD97-050",
         "Address": " ",
         "Project Name": "RAD97-050, Bayview Bank",
         "Application Type": "Sign Permit ",
         "Application Date": "8/29/97",
         "Status": "Approved ",
         "Description": "Install one (1) double-faced, internally illuminated 3'-6\" x 5'-1\" sign.",
         "Planner": "Eric Keller ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RAD97-061",
         "APN": 46745084,
         "File Number": "RAD97-061",
         "Address": "111 PASEO DE SAN ANTONIO SAN JOSE",
         "Project Name": "RAD97-061, Happy Juice",
         "Application Type": "Sign Permit ",
         "Application Date": "12/15/97",
         "Status": "Approved ",
         "Description": "Installation of new signage ",
         "Planner": "Eric Keller ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RAD97-061",
         "APN": 46745097,
         "File Number": "RAD97-061",
         "Address": "111 PASEO DE SAN ANTONIO SAN JOSE",
         "Project Name": "RAD97-061, Happy Juice",
         "Application Type": "Sign Permit ",
         "Application Date": "12/15/97",
         "Status": "Approved ",
         "Description": "Installation of new signage ",
         "Planner": "Eric Keller ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RAD98-005",
         "APN": 25941054,
         "File Number": "RAD98-005",
         "Address": " ",
         "Project Name": "RAD98-005, Wells Fargo Bank",
         "Application Type": "Sign Permit ",
         "Application Date": "1/21/98",
         "Status": "Approved ",
         "Description": "Remove existing three (3) box signs and one (1) monument sign; install three (3) internally illuminated cabinet signs and one (1) internally illuminated monument sign.",
         "Planner": "Eric Keller ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "RAD98-006",
         "APN": 25940034,
         "File Number": "RAD98-006",
         "Address": " ",
         "Project Name": "RAD98-006, Sumitomo Bank",
         "Application Type": "Sign Permit ",
         "Application Date": "1/22/98",
         "Status": "Approved ",
         "Description": "Install one (1) double-sided freestanding directional sign",
         "Planner": "Martin Magana ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "RAD98-007",
         "APN": 25935051,
         "File Number": "RAD98-007",
         "Address": " ",
         "Project Name": "RAD98-007, 71 St. Peter Restaurant",
         "Application Type": "Sign Permit ",
         "Application Date": "1/22/98",
         "Status": "Approved ",
         "Description": "Install neon signage to front of building ",
         "Planner": "Eric Keller ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "RAD98-010",
         "APN": 25943069,
         "File Number": "RAD98-010",
         "Address": " ",
         "Project Name": "RAD98-010, Crowne Plaza Hotel",
         "Application Type": "Sign Permit ",
         "Application Date": "2/17/98",
         "Status": "Approved ",
         "Description": "Remove all Holiday Inn signs and install Crowne Plaza signs ",
         "Planner": "Martin Magana ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "RAD98-016",
         "APN": 25934053,
         "File Number": "RAD98-016",
         "Address": " ",
         "Project Name": "RAD98-016, Next Print",
         "Application Type": "Sign Permit ",
         "Application Date": "4/6/98",
         "Status": "Approved ",
         "Description": "Add 18\" H brushed stainless dimensional letters to belly band of building above office entrance.",
         "Planner": "Martin Magana ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "RAD98-019",
         "APN": 25941070,
         "File Number": "RAD98-019",
         "Address": " ",
         "Project Name": "RAD98-019, Park Center Plaza #25",
         "Application Type": "Sign Permit ",
         "Application Date": "4/14/98",
         "Status": "Approved ",
         "Description": "Installation of non-illuminated wall sign for Vavrinek, Trine, Day & CO., LLP - CPA's ",
         "Planner": "Martin Magana ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "RAD98-022",
         "APN": 46721023,
         "File Number": "RAD98-022",
         "Address": " ",
         "Project Name": "RAD98-022, Blue Cross of California",
         "Application Type": "Sign Permit ",
         "Application Date": "5/6/98",
         "Status": "Approved ",
         "Description": "Install illuminated sign ",
         "Planner": "Martin Magana ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "RAD98-023",
         "APN": 25935035,
         "File Number": "RAD98-023",
         "Address": " ",
         "Project Name": "RAD98-023, A.P. Stumps",
         "Application Type": "Sign Permit ",
         "Application Date": "6/10/98",
         "Status": "Approved ",
         "Description": "New signage on new awnings formerly approved. Signs A, B, C, D on drawings and 3 copper leaf signs on windows",
         "Planner": "Martin Magana ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "RAD98-025",
         "APN": 25941054,
         "File Number": "RAD98-025",
         "Address": " ",
         "Project Name": "RAD98-025, Wells Fargo Bank",
         "Application Type": "Sign Permit ",
         "Application Date": "6/10/98",
         "Status": "Approved ",
         "Description": "Replace four (4) existing cabinet signs; install one (1) new set of 5'0\" channel letters (skyline sign)",
         "Planner": "Martin Magana ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "RAD98-029",
         "APN": 25939122,
         "File Number": "RAD98-029",
         "Address": " ",
         "Project Name": "RAD98-029, Olsten Staffing",
         "Application Type": "Sign Permit ",
         "Application Date": "6/24/98",
         "Status": "Approved ",
         "Description": "Install two (2) individual channel letter signs on building facias",
         "Planner": "Martin Magana ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "RAD98-032",
         "APN": 25934016,
         "File Number": "RAD98-032",
         "Address": " ",
         "Project Name": "RAD98-032, Washington Mutual",
         "Application Type": "Sign Permit ",
         "Application Date": "7/2/98",
         "Status": "Approved ",
         "Description": "Reface existing roof sign, replace existing logo & channel letter sign, reface existing cabinet sign on rear of buildiing. ",
         "Planner": "Martin Magana ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "RAD98-038",
         "APN": 46745073,
         "File Number": "RAD98-038",
         "Address": " ",
         "Project Name": "RAD98-038, San Jose Museum of Quilts & Textiles",
         "Application Type": "Sign Permit ",
         "Application Date": "7/22/98",
         "Status": "Approved ",
         "Description": "Installation of blade sign & window signs ",
         "Planner": "Martin Magana ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "RAD98-051",
         "APN": 25944089,
         "File Number": "RAD98-051",
         "Address": "321 PARK AV SAN JOSE",
         "Project Name": "RAD98-051, Adobe Systems, Inc.",
         "Application Type": "Sign Permit ",
         "Application Date": "10/16/98",
         "Status": "Approved ",
         "Description": "Installation of one (1) wall sign on East elevation - 9'-1 1/2\" x 12'-10 3/4\"",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "RAD98-052",
         "APN": 46747007,
         "File Number": "RAD98-052",
         "Address": " ",
         "Project Name": "RAD98-052, DeCarolis Design",
         "Application Type": "Sign Permit ",
         "Application Date": "10/19/98",
         "Status": "Approved ",
         "Description": "Facade improvement, including signage. ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "RAD99-004",
         "APN": 25941086,
         "File Number": "RAD99-004",
         "Address": "50 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "RAD99-004, Knight Ridder Sign",
         "Application Type": "Sign Permit ",
         "Application Date": "1/26/99",
         "Status": "Approved ",
         "Description": "Allow skyline signs atop Fairmont Plaza office tower. ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RAD99-004",
         "APN": 25941087,
         "File Number": "RAD99-004",
         "Address": "50 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "RAD99-004, Knight Ridder Sign",
         "Application Type": "Sign Permit ",
         "Application Date": "1/26/99",
         "Status": "Approved ",
         "Description": "Allow skyline signs atop Fairmont Plaza office tower. ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RAD99-011",
         "APN": 25943075,
         "File Number": "RAD99-011",
         "Address": " ",
         "Project Name": "RAD99-011, Morgan Stanley/Dean Whitter",
         "Application Type": "Sign Permit ",
         "Application Date": "2/19/99",
         "Status": "Approved ",
         "Description": "Install two (2) non-illuminated, FCO letter set and five (5) brass panels.",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RAD99-017",
         "APN": 46722110,
         "File Number": "RAD99-017",
         "Address": " ",
         "Project Name": "RAD99-017, Gordon Biersch Sign",
         "Application Type": "Sign Permit ",
         "Application Date": "4/5/99",
         "Status": "Approved ",
         "Description": "New Neon sign for Gordon Biersch. Move existing sign to face Fountain Alley area. ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RAD99-017",
         "APN": 46722127,
         "File Number": "RAD99-017",
         "Address": " ",
         "Project Name": "RAD99-017, Gordon Biersch Sign",
         "Application Type": "Sign Permit ",
         "Application Date": "4/5/99",
         "Status": "Approved ",
         "Description": "New Neon sign for Gordon Biersch. Move existing sign to face Fountain Alley area. ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RAD99-025",
         "APN": 25941086,
         "File Number": "RAD99-025",
         "Address": " ",
         "Project Name": "RAD99-025, Calpine",
         "Application Type": "Sign Permit ",
         "Application Date": "5/17/99",
         "Status": "Approved ",
         "Description": "Add \"Calpine\" sign to north and south frontages. ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RAD99-025",
         "APN": 25941087,
         "File Number": "RAD99-025",
         "Address": " ",
         "Project Name": "RAD99-025, Calpine",
         "Application Type": "Sign Permit ",
         "Application Date": "5/17/99",
         "Status": "Approved ",
         "Description": "Add \"Calpine\" sign to north and south frontages. ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RAD99-048",
         "APN": 46722008,
         "File Number": "RAD99-048",
         "Address": " ",
         "Project Name": "RAD99-048, Bella Mia",
         "Application Type": "Sign Permit ",
         "Application Date": "10/22/99",
         "Status": "Approved ",
         "Description": "Sign for Bella Mia expansion on existing canopy - oval 5'6\" x 42\" with brass letters",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RAD99-058",
         "APN": 46723069,
         "File Number": "RAD99-058",
         "Address": " ",
         "Project Name": "RAD99-058, Bank of America",
         "Application Type": "Sign Permit ",
         "Application Date": "12/17/99",
         "Status": "Approved ",
         "Description": "Remove one (1) existing sign with individual letters and replace it with new B of A logo.",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RA88-002",
         "APN": 25941070,
         "File Number": "RA88-002",
         "Address": " ",
         "Project Name": "RA88-002, Park Center Plaza",
         "Application Type": "Sign Permit ",
         "Application Date": "3/2/88",
         "Status": "Closed ",
         "Description": "Signage for garage ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 1988
      },
      {
         "PERMITID": "RAD99-035",
         "APN": 25941086,
         "File Number": "RAD99-035",
         "Address": " ",
         "Project Name": "RAD99-035, Knight Ridder Sign",
         "Application Type": "Sign Permit ",
         "Application Date": "9/27/99",
         "Status": "Closed ",
         "Description": "Modify Knight Ridder sign to allow catwalk on the back of the sign ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RAD99-035",
         "APN": 25941087,
         "File Number": "RAD99-035",
         "Address": " ",
         "Project Name": "RAD99-035, Knight Ridder Sign",
         "Application Type": "Sign Permit ",
         "Application Date": "9/27/99",
         "Status": "Closed ",
         "Description": "Modify Knight Ridder sign to allow catwalk on the back of the sign ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "AD12-855",
         "APN": 46720078,
         "File Number": "AD12-855",
         "Address": "30 N 3RD ST SAN JOSE",
         "Project Name": "AD12-855",
         "Application Type": "Sign Permit ",
         "Application Date": "8/23/12",
         "Status": "Denied ",
         "Description": "Sign Permit Adjustment to allow one (1) fin sign (~ 6-square feet in size) on an existing commercial building as shown on the approved Permit Adjustment plans only.",
         "Planner": "Jeff Roche ",
         "DURATION": 34,
         "Year": 2012
      },
      {
         "PERMITID": "AD86-461",
         "APN": 26420081,
         "File Number": "AD86-461",
         "Address": "476 W SAN CARLOS ST SAN JOSE",
         "Project Name": "AD86-461",
         "Application Type": "Sign Permit ",
         "Application Date": " ",
         "Status": "Denied ",
         "Description": "Action date:12DEC86 1 ATTACHED SIGN FOR \"HARLEY DAVIDSON\"",
         "Planner": "Mike Enderby ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD87-165",
         "APN": 46720087,
         "File Number": "AD87-165",
         "Address": "40 N 4TH ST SAN JOSE",
         "Project Name": "AD87-165",
         "Application Type": "Sign Permit ",
         "Application Date": " ",
         "Status": "Denied ",
         "Description": "Action date:11MAY87 1 ATTACHED SIGN \"VIETNAM INTERNATIONA...",
         "Planner": "Mike Enderby ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD91-749",
         "APN": 47218055,
         "File Number": "AD91-749",
         "Address": "288 E VIRGINIA ST SAN JOSE",
         "Project Name": "AD91-749",
         "Application Type": "Sign Permit ",
         "Application Date": " ",
         "Status": "Denied ",
         "Description": "Action date:27DEC91 PRICE SIGN",
         "Planner": "Rich Buikema ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "2017 019237 CO",
         "APN": 25940093,
         "File Number": "2017 019237 CO",
         "Address": "1 S MARKET ST SAN JOSE",
         "Project Name": "1 SOUTH MARKET STREET",
         "Application Type": "Sign Permit ",
         "Application Date": "5/18/17 12:18",
         "Status": "New ",
         "Description": "Permit Adjustment for a Sign Permit to allow one (1) attached sign 18'-6\" by 1'-6\" (27.75 sf), one (1) blade sign 2'-6\" by 1'-6\" (3.75 sf), and one (1) window vinyl logo.",
         "Planner": "Eric Morgan ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "AD18-655",
         "APN": 25943074,
         "File Number": "AD18-655",
         "Address": "300 PARK AV SAN JOSE",
         "Project Name": "AD18-655",
         "Application Type": "Sign Permit ",
         "Application Date": "7/5/18",
         "Status": "Pending ",
         "Description": "Sign Permit to allow the replacement of one (1) skyline sign \"Intacct\", measuring approximately 224 square feet with one (1) skyline sign \"sage Intacct\", measuring approximately 272 square feet . The total square footage of skyline signs on this building is now at 518 square feet.",
         "Planner": "Jan Warne ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "AD18-655",
         "APN": 25943075,
         "File Number": "AD18-655",
         "Address": "300 PARK AV SAN JOSE",
         "Project Name": "AD18-655",
         "Application Type": "Sign Permit ",
         "Application Date": "7/5/18",
         "Status": "Pending ",
         "Description": "Sign Permit to allow the replacement of one (1) skyline sign \"Intacct\", measuring approximately 224 square feet with one (1) skyline sign \"sage Intacct\", measuring approximately 272 square feet . The total square footage of skyline signs on this building is now at 518 square feet.",
         "Planner": "Jan Warne ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "AD08-1365",
         "APN": 46722141,
         "File Number": "AD08-1365",
         "Address": "150 S 1ST ST SAN JOSE",
         "Project Name": "AD08-1365",
         "Application Type": "Sign Permit ",
         "Application Date": "12/3/08",
         "Status": "Rejected ",
         "Description": "One set of attached channel letters sign, 40sqft only. *** Customer issued bad check for $314.00. Need to pay finance including return check fee of $33.00. Please see Jeanette for details. 01/09/09.jm ****",
         "Planner": "Michele Campos ",
         "DURATION": 0,
         "Year": 2008
      },
      {
         "PERMITID": "AD87-083",
         "APN": 25940094,
         "File Number": "AD87-083",
         "Address": "35 S MARKET ST SAN JOSE",
         "Project Name": "AD87-083",
         "Application Type": "Sign Permit ",
         "Application Date": " ",
         "Status": "Withdrawn ",
         "Description": "Action date:24MAR87 SINGLE FACED INTERIOR ILLUMINTED PARKING",
         "Planner": "Mike Enderby ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD88-045",
         "APN": 25940094,
         "File Number": "AD88-045",
         "Address": "35 S MARKET ST SAN JOSE",
         "Project Name": "AD88-045",
         "Application Type": "Sign Permit ",
         "Application Date": " ",
         "Status": "Withdrawn ",
         "Description": "Action date: REPLACE EXISTING SIGNS (NOW REMOVED) ",
         "Planner": "LCARRILL ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "AD89-306",
         "APN": 25940087,
         "File Number": "AD89-306",
         "Address": "160 W SANTA CLARA ST SAN JOSE",
         "Project Name": "AD89-306",
         "Application Type": "Sign Permit ",
         "Application Date": " ",
         "Status": "Withdrawn ",
         "Description": "Action date:17MAY89 2 ATTACHED SIGNS-REDEVELOPMENT AREA",
         "Planner": "ISHIEKH ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "RAD00-075",
         "APN": 25940034,
         "File Number": "RAD00-075",
         "Address": " ",
         "Project Name": "RAD00-075, Entrepreneur Center",
         "Application Type": "Sign Permit ",
         "Application Date": "11/29/00",
         "Status": "Withdrawn ",
         "Description": "Replace temporary sign w/ permanent lighted sign. ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 2000
      }
   ],
   "Sign Variance ": [
      {
         "PERMITID": "RV03-001",
         "APN": 25942079,
         "File Number": "RV03-001",
         "Address": " ",
         "Project Name": "RV03-001, Montgomery Hotel",
         "Application Type": "Sign Variance ",
         "Application Date": "7/15/03",
         "Status": "Approved ",
         "Description": "Sign variance to allow a painted wall sign on a building that is less than 80 feet in height.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "V14-007",
         "APN": 25943074,
         "File Number": "V14-007",
         "Address": "300 PARK AV SAN JOSE",
         "Project Name": "V14-007",
         "Application Type": "Sign Variance ",
         "Application Date": "11/12/14 16:19",
         "Status": "Approved ",
         "Description": "Sign Variance to allow four attached, flat-mounted signs, each approximately 58 square feet, located at approximately 106 feet above grade, in excess of the maximum allowable height, on an existing 16-story office building",
         "Planner": "Jennifer Piozet ",
         "DURATION": 30,
         "Year": 2014
      },
      {
         "PERMITID": "V14-007",
         "APN": 25943075,
         "File Number": "V14-007",
         "Address": "300 PARK AV SAN JOSE",
         "Project Name": "V14-007",
         "Application Type": "Sign Variance ",
         "Application Date": "11/12/14 16:19",
         "Status": "Approved ",
         "Description": "Sign Variance to allow four attached, flat-mounted signs, each approximately 58 square feet, located at approximately 106 feet above grade, in excess of the maximum allowable height, on an existing 16-story office building",
         "Planner": "Jennifer Piozet ",
         "DURATION": 30,
         "Year": 2014
      },
      {
         "PERMITID": "V18-004",
         "APN": 25943075,
         "File Number": "V18-004",
         "Address": "333 W SAN CARLOS ST SAN JOSE",
         "Project Name": "V18-004",
         "Application Type": "Sign Variance ",
         "Application Date": "6/6/18 11:10",
         "Status": "Approved ",
         "Description": "Sign Variance to allow two (2) flat-mounted signs, each approximately 58 square feet, located approximately 106 feet above grade, in excess of the maximum allowable height, on an existing 16-story office building on a 0.78-gross acre site.",
         "Planner": "Michelle Flores ",
         "DURATION": 185,
         "Year": 2018
      },
      {
         "PERMITID": "V09-001",
         "APN": 46764005,
         "File Number": "V09-001",
         "Address": "100 S 2ND ST Unit C-106 SAN JOSE",
         "Project Name": "V09-001",
         "Application Type": "Sign Variance ",
         "Application Date": "7/7/09",
         "Status": "Withdrawn ",
         "Description": "Sign Variance Permit to allow window signs for a supermarket ",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 1563,
         "Year": 2009
      },
      {
         "PERMITID": "V09-001",
         "APN": 46764010,
         "File Number": "V09-001",
         "Address": "100 S 2ND ST Unit C-106 SAN JOSE",
         "Project Name": "V09-001",
         "Application Type": "Sign Variance ",
         "Application Date": "7/7/09",
         "Status": "Withdrawn ",
         "Description": "Sign Variance Permit to allow window signs for a supermarket ",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 1563,
         "Year": 2009
      },
      {
         "PERMITID": "V15-001",
         "APN": 25939111,
         "File Number": "V15-001",
         "Address": "350 W SANTA CLARA ST SAN JOSE",
         "Project Name": "V15-001",
         "Application Type": "Sign Variance ",
         "Application Date": "3/3/15 10:21",
         "Status": "Withdrawn ",
         "Description": "Sign Variance to allow the construction of two (2) additional skyline signs beyond what Title 23 allows on a 0.54 gross acre site",
         "Planner": "Rebecca Bustos ",
         "DURATION": 108,
         "Year": 2015
      },
      {
         "PERMITID": "V15-004",
         "APN": 25943075,
         "File Number": "V15-004",
         "Address": "333 W SAN CARLOS ST SAN JOSE",
         "Project Name": "V15-004",
         "Application Type": "Sign Variance ",
         "Application Date": "6/3/15 10:10",
         "Status": "Withdrawn ",
         "Description": "Sign Variance to allow two attached, flat-mounted signs, each approximately 58 square feet, located at approximately 106 feet above grade, in excess of the maximum allowable height, on an existing 16-story office building.",
         "Planner": "Jennifer Piozet ",
         "DURATION": 602,
         "Year": 2015
      }
   ],
   "Site Permit ": [
      {
         "PERMITID": "H01-041",
         "APN": 47228085,
         "File Number": "H01-041",
         "Address": "544 S 8TH ST SAN JOSE",
         "Project Name": "H01-041",
         "Application Type": "Site Permit ",
         "Application Date": "5/15/01",
         "Status": "Approved ",
         "Description": "Site Development Permit for the conversion of a single-family residence to a duplex with second story addition of 1574 square foot on a 0.15 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 315,
         "Year": 2001
      },
      {
         "PERMITID": "H01-047",
         "APN": 46718076,
         "File Number": "H01-047",
         "Address": "157 N 8TH ST SAN JOSE",
         "Project Name": "H01-047",
         "Application Type": "Site Permit ",
         "Application Date": "6/19/01 10:47",
         "Status": "Approved ",
         "Description": "Site Development Permit to allow the relocation of two historic houses as part of the Civic Plaza redevelopment plan on to a 0.32 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "H01-048",
         "APN": 24946061,
         "File Number": "H01-048",
         "Address": "153 E JULIAN ST SAN JOSE",
         "Project Name": "H01-048",
         "Application Type": "Site Permit ",
         "Application Date": "6/21/01 14:36",
         "Status": "Approved ",
         "Description": "Site Development Permit to demolish an existing residential structure and construct a 2,318 square foot office building on a .09 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 684,
         "Year": 2001
      },
      {
         "PERMITID": "H02-038",
         "APN": 47223059,
         "File Number": "H02-038",
         "Address": "755 S 10TH ST SAN JOSE",
         "Project Name": "H02-038",
         "Application Type": "Site Permit ",
         "Application Date": "7/11/02",
         "Status": "Approved ",
         "Description": "Site Development Permit to convert an existing single family residence to a duplex and construct a two-story addition of 1,199 square feet on a 0.16 gross acre site",
         "Planner": "Akoni Danielsen ",
         "DURATION": 697,
         "Year": 2002
      },
      {
         "PERMITID": "H02-043",
         "APN": 24946063,
         "File Number": "H02-043",
         "Address": "324 N 4TH ST SAN JOSE",
         "Project Name": "H02-043",
         "Application Type": "Site Permit ",
         "Application Date": "8/8/02",
         "Status": "Approved ",
         "Description": "Site Development Permit to allow in the Hensely Historic District to demolish existing garage and carport, replace with 649 square foot garage on a 0.13 gross acre site.",
         "Planner": "John Davidson ",
         "DURATION": 172,
         "Year": 2002
      },
      {
         "PERMITID": "H03-012",
         "APN": 46702048,
         "File Number": "H03-012",
         "Address": "236 N 6TH ST SAN JOSE",
         "Project Name": "H03-012",
         "Application Type": "Site Permit ",
         "Application Date": "2/27/03",
         "Status": "Approved ",
         "Description": "Site Development Permit to demolish an existing single-family detached residence and construct a duplex of 2,987 square feet on a 0.14 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 286,
         "Year": 2003
      },
      {
         "PERMITID": "H03-025",
         "APN": 47218021,
         "File Number": "H03-025",
         "Address": "826 S 3RD ST SAN JOSE",
         "Project Name": "H03-025",
         "Application Type": "Site Permit ",
         "Application Date": "4/30/03",
         "Status": "Approved ",
         "Description": "Site Development Permit to (1) legalize a rear addition for water heaters, (2) establish legal status for 4 multi-family residential units at the site, (3) revert an unpermitted second story porch enclosure back to common open space, and (4) revert an unpermitted first floor unit to storage on a 0.14 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 1094,
         "Year": 2003
      },
      {
         "PERMITID": "H04-005",
         "APN": 24948005,
         "File Number": "H04-005",
         "Address": "379 N 6TH ST SAN JOSE",
         "Project Name": "H04-005",
         "Application Type": "Site Permit ",
         "Application Date": "1/23/04",
         "Status": "Approved ",
         "Description": "Site Development Permit to allow the conversion of the 1,394 square foot basement to living space in an existing multi-family residence (duplex) in the Hensley District (ID# 1484) on a 0.14 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 192,
         "Year": 2004
      },
      {
         "PERMITID": "H04-031",
         "APN": 47223011,
         "File Number": "H04-031",
         "Address": "612 S 10TH ST SAN JOSE",
         "Project Name": "H04-031",
         "Application Type": "Site Permit ",
         "Application Date": "7/6/04",
         "Status": "Approved ",
         "Description": "Site Development Permit to construct 1,521 square foot 2-story addition to an existing single family house and allow conversion to a duplex on a 0.15 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 67,
         "Year": 2004
      },
      {
         "PERMITID": "H04-037",
         "APN": 46701003,
         "File Number": "H04-037",
         "Address": "257 N 2ND ST SAN JOSE",
         "Project Name": "H04-037 2nd & Devine St.",
         "Application Type": "Site Permit ",
         "Application Date": "8/5/04",
         "Status": "Approved ",
         "Description": "Site Development Permit to allow construction of a one-story commercial building containing approximately 2,900 gross square feet on a 0.09 gross acre site",
         "Planner": "Ron Eddow ",
         "DURATION": 1478,
         "Year": 2004
      },
      {
         "PERMITID": "H04-038",
         "APN": 46764005,
         "File Number": "H04-038",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "H04-038 (CIM) (Central Place)",
         "Application Type": "Site Permit ",
         "Application Date": "8/11/04",
         "Status": "Approved ",
         "Description": "Site Development Permit to construct 1,073,361 square feet of floor area for residential and commercial uses including (1) 335 single-family attached residences, (2) 68,267 square feet of ground-floor retail, and (3) above-and-below grade parking garages on a 2.99 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 317,
         "Year": 2004
      },
      {
         "PERMITID": "H04-038",
         "APN": 46764010,
         "File Number": "H04-038",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "H04-038 (CIM) (Central Place)",
         "Application Type": "Site Permit ",
         "Application Date": "8/11/04",
         "Status": "Approved ",
         "Description": "Site Development Permit to construct 1,073,361 square feet of floor area for residential and commercial uses including (1) 335 single-family attached residences, (2) 68,267 square feet of ground-floor retail, and (3) above-and-below grade parking garages on a 2.99 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 317,
         "Year": 2004
      },
      {
         "PERMITID": "H05-029",
         "APN": 46701118,
         "File Number": "H05-029",
         "Address": "252 N 1ST ST SAN JOSE",
         "Project Name": "H05-029 - Park View Towers",
         "Application Type": "Site Permit ",
         "Application Date": "6/21/05",
         "Status": "Approved ",
         "Description": "Site Development Permit to construct up to 194 single-family attached residences (3 of which are live/work units) and approximately 14,000 square feet of ground floor commercial uses in two high-rise towers (~153 feet tall along N. 1st St. and ~198 feet tall along Devine St.) on a 1.51 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2005
      },
      {
         "PERMITID": "H05-051",
         "APN": 25939115,
         "File Number": "H05-051",
         "Address": "99 ALMADEN BL SAN JOSE",
         "Project Name": "H05-051",
         "Application Type": "Site Permit ",
         "Application Date": "10/26/05",
         "Status": "Approved ",
         "Description": "Site Development Permit to allow exterior modifications and site improvements for an existing office use on a 5.67 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 107,
         "Year": 2005
      },
      {
         "PERMITID": "H06-025",
         "APN": 25940064,
         "File Number": "H06-025",
         "Address": "93 S 1ST ST SAN JOSE",
         "Project Name": "H06-025",
         "Application Type": "Site Permit ",
         "Application Date": "4/28/06",
         "Status": "Approved ",
         "Description": "Site Development Permit for seismic upgrade, core, and shell renovation of the existing Wilcox Block building containing 10,807 square feet for commercial uses on a 5.28 gross acres site",
         "Planner": "Ron Eddow ",
         "DURATION": 119,
         "Year": 2006
      },
      {
         "PERMITID": "H07-002",
         "APN": 47228085,
         "File Number": "H07-002",
         "Address": "544 S 8TH ST SAN JOSE",
         "Project Name": "H07-002",
         "Application Type": "Site Permit ",
         "Application Date": "1/18/07",
         "Status": "Approved ",
         "Description": "Site Development Permit to convert an existing single-family residence to a two-family residence on a 0.15 gross acre site",
         "Planner": "Licinia McMorrow ",
         "DURATION": 0,
         "Year": 2007
      },
      {
         "PERMITID": "H07-007",
         "APN": 47228045,
         "File Number": "H07-007",
         "Address": "530 S 6TH ST SAN JOSE",
         "Project Name": "H07-007/HP07-001",
         "Application Type": "Site Permit ",
         "Application Date": "2/13/07",
         "Status": "Approved ",
         "Description": "Site Development Permit to legalize a prebuilt approximately 940-square-foot detached garage to replace a detached garage that was demolished without permits on a 0.16-acre site in the Reed Historic District",
         "Planner": "Steven Rosen ",
         "DURATION": 458,
         "Year": 2007
      },
      {
         "PERMITID": "H08-028",
         "APN": 47218021,
         "File Number": "H08-028",
         "Address": "826 S 3RD ST SAN JOSE",
         "Project Name": "H08-028",
         "Application Type": "Site Permit ",
         "Application Date": "6/27/08",
         "Status": "Approved ",
         "Description": "Site Development Permit to legalize an existing rear, second-story addition of approximately 266 square feet for use as laundry, storage, and common area for an existing 5-unit residential structure on a 0.2 arce site.",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 0,
         "Year": 2008
      },
      {
         "PERMITID": "H10-013",
         "APN": 47217081,
         "File Number": "H10-013",
         "Address": "847 S 3RD ST SAN JOSE",
         "Project Name": "H10-013",
         "Application Type": "Site Permit ",
         "Application Date": "7/16/10",
         "Status": "Approved ",
         "Description": "Site Development Permit to allow the conversion of a single-family residence to duplex use on a 0.217 gross acre site in the R-M residential zoning district",
         "Planner": "Lori Moniz ",
         "DURATION": 109,
         "Year": 2010
      },
      {
         "PERMITID": "H10-017",
         "APN": 25940084,
         "File Number": "H10-017",
         "Address": "95 S MARKET ST SAN JOSE",
         "Project Name": "H10-017",
         "Application Type": "Site Permit ",
         "Application Date": "8/26/10",
         "Status": "Approved ",
         "Description": "Site Development to allow for the installation of two (2) automatic parking gates in an existing parking gargage for a commercial building on a 0.83 gross acre site.",
         "Planner": "Lesley Xavier ",
         "DURATION": 188,
         "Year": 2010
      },
      {
         "PERMITID": "H11-007",
         "APN": 25942080,
         "File Number": "H11-007",
         "Address": "S 1ST ST SAN JOSE",
         "Project Name": "H11-007",
         "Application Type": "Site Permit ",
         "Application Date": "4/22/11",
         "Status": "Approved ",
         "Description": "Site Development for parking lot improvements including toll booth and ticket paystation in the DC Downtown Zoning District on 1.48 gross acre site",
         "Planner": "Ben Corrales ",
         "DURATION": 49,
         "Year": 2011
      },
      {
         "PERMITID": "H13-008",
         "APN": 26415065,
         "File Number": "H13-008",
         "Address": "720 W SAN CARLOS ST SAN JOSE",
         "Project Name": "H13-008 OSH",
         "Application Type": "Site Permit ",
         "Application Date": "2/20/13",
         "Status": "Approved ",
         "Description": "Site Development Permit to allow construction of an approximately 49,000 square foot commercial building, and demolition of an existing 29,013 square foot metal storage building in the CIC Combined Industrial /Commercial Zoning District",
         "Planner": "Ben Corrales ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "H13-013",
         "APN": 25939111,
         "File Number": "H13-013",
         "Address": "350 W SANTA CLARA ST SAN JOSE",
         "Project Name": "H13-013 AC Hotel",
         "Application Type": "Site Permit ",
         "Application Date": "3/20/13",
         "Status": "Approved ",
         "Description": "Site Development Permit to allow the construction of an up to 200-room, eight story hotel (Hampton Inn), including approximately 5,940 square feet of ground floor retail space on an approximately 0.54 gross acre parcel with parking provided in an existing adjacent parking garage.",
         "Planner": "John Baty ",
         "DURATION": 89,
         "Year": 2013
      },
      {
         "PERMITID": "H13-023",
         "APN": 46719075,
         "File Number": "H13-023",
         "Address": "51 N 6TH ST SAN JOSE",
         "Project Name": "H13-023 - SJSU Student Housing at 51 North 6th Street",
         "Application Type": "Site Permit ",
         "Application Date": "6/7/13",
         "Status": "Approved ",
         "Description": "Site Development Permit to allow the demolition of an existing parking structure for Vintage Tower and construction of 119 multi-family apartment units (intended for students) in five residential stories above two stories of at-grade parking on a 1.09 gross acre site. The proposed building will accommodate the required parking for the new residents and replacement parking for Vintage Tower.",
         "Planner": "John Baty ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "H13-023",
         "APN": 46757083,
         "File Number": "H13-023",
         "Address": "51 N 6TH ST SAN JOSE",
         "Project Name": "H13-023 - SJSU Student Housing at 51 North 6th Street",
         "Application Type": "Site Permit ",
         "Application Date": "6/7/13",
         "Status": "Approved ",
         "Description": "Site Development Permit to allow the demolition of an existing parking structure for Vintage Tower and construction of 119 multi-family apartment units (intended for students) in five residential stories above two stories of at-grade parking on a 1.09 gross acre site. The proposed building will accommodate the required parking for the new residents and replacement parking for Vintage Tower.",
         "Planner": "John Baty ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "H14-005",
         "APN": 24946027,
         "File Number": "H14-005",
         "Address": "330 N 3RD ST SAN JOSE",
         "Project Name": "H14-005",
         "Application Type": "Site Permit ",
         "Application Date": "1/21/14",
         "Status": "Approved ",
         "Description": "Site Development Permit to allow the conversion of a 9-unit apartment complex to a 4-unit apartment complex in 2 existing buildings consisting of 4,360 square feet on a 0.25 gross acre site",
         "Planner": "John Tu ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H14-009",
         "APN": 46701118,
         "File Number": "H14-009",
         "Address": "10367 TRACT SAN JOSE",
         "Project Name": "H14-009 Parkview Tower",
         "Application Type": "Site Permit ",
         "Application Date": "2/18/14",
         "Status": "Approved ",
         "Description": "Site Development Permit to allow an 19-story, 220 residential unit and 18,537 square feet of commercial use on 1.52 gross acre site",
         "Planner": "John Tu ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H14-010",
         "APN": 46721018,
         "File Number": "H14-010",
         "Address": "66 N 1ST ST SAN JOSE",
         "Project Name": "H14-010 Marshall Squares",
         "Application Type": "Site Permit ",
         "Application Date": "2/28/14",
         "Status": "Approved ",
         "Description": "Site Development Permit to allow the demolition of six commercial buildings, removal of one ordinance-size tree, and the construction of a six- to seven-story mixed-used building consisting of up to 190 residential units, 10,835 square feet of commercial, and an associated parking garage on a 1.4 gross acre site",
         "Planner": "John Tu ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H14-010",
         "APN": 46721030,
         "File Number": "H14-010",
         "Address": "66 N 1ST ST SAN JOSE",
         "Project Name": "H14-010 Marshall Squares",
         "Application Type": "Site Permit ",
         "Application Date": "2/28/14",
         "Status": "Approved ",
         "Description": "Site Development Permit to allow the demolition of six commercial buildings, removal of one ordinance-size tree, and the construction of a six- to seven-story mixed-used building consisting of up to 190 residential units, 10,835 square feet of commercial, and an associated parking garage on a 1.4 gross acre site",
         "Planner": "John Tu ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H14-010",
         "APN": 46721038,
         "File Number": "H14-010",
         "Address": "66 N 1ST ST SAN JOSE",
         "Project Name": "H14-010 Marshall Squares",
         "Application Type": "Site Permit ",
         "Application Date": "2/28/14",
         "Status": "Approved ",
         "Description": "Site Development Permit to allow the demolition of six commercial buildings, removal of one ordinance-size tree, and the construction of a six- to seven-story mixed-used building consisting of up to 190 residential units, 10,835 square feet of commercial, and an associated parking garage on a 1.4 gross acre site",
         "Planner": "John Tu ",
         "DURATION": 0,
         "Year": 2014
      },
      {
         "PERMITID": "H14-023",
         "APN": 25940087,
         "File Number": "H14-023",
         "Address": "171 POST ST SAN JOSE",
         "Project Name": "H14-023 Post/San Pedro Tower",
         "Application Type": "Site Permit ",
         "Application Date": "6/9/14",
         "Status": "Approved ",
         "Description": "Site Development Permit for a high rise building with 182 residential units, 7,767sqaure feet of retail space, and a four-story parking garage connected to the adjacent existing garage in the DC zoning district on a 1.28 gross acre site",
         "Planner": "Emily Lipoma ",
         "DURATION": 142,
         "Year": 2014
      },
      {
         "PERMITID": "H15-046",
         "APN": 26426006,
         "File Number": "H15-046",
         "Address": "341 DELMAS AV SAN JOSE",
         "Project Name": "H15-046 - 363 Delmas Avenue",
         "Application Type": "Site Permit ",
         "Application Date": "9/25/15 9:48",
         "Status": "Approved ",
         "Description": "Site Development Permit to allow the demolition of three single-family residences and associated accessory buildings, the removal of five ordinance sized trees, the construction of a five-story multi-family residential building with up to120 units, an alternating use parking arrangement, and Transportation Demand Management (TDM) measures to reduce parking requirements.",
         "Planner": "Tracy Tam ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "H15-046",
         "APN": 26426008,
         "File Number": "H15-046",
         "Address": "341 DELMAS AV SAN JOSE",
         "Project Name": "H15-046 - 363 Delmas Avenue",
         "Application Type": "Site Permit ",
         "Application Date": "9/25/15 9:48",
         "Status": "Approved ",
         "Description": "Site Development Permit to allow the demolition of three single-family residences and associated accessory buildings, the removal of five ordinance sized trees, the construction of a five-story multi-family residential building with up to120 units, an alternating use parking arrangement, and Transportation Demand Management (TDM) measures to reduce parking requirements.",
         "Planner": "Tracy Tam ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "H15-049",
         "APN": 26415015,
         "File Number": "H15-049",
         "Address": "365 ROYAL AV SAN JOSE",
         "Project Name": "H15-049 Midtown Ctr.",
         "Application Type": "Site Permit ",
         "Application Date": "10/22/15 14:12",
         "Status": "Approved ",
         "Description": "Site Development Permit to allow minor modifications to an existing building, including replacement of the façade, construction of a rear loading dock, removal of an existing parking lot, and the installation of new pavers, landscaping and other improvements on a 2.785-gross acre site",
         "Planner": "Tracy Tam ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "H15-055",
         "APN": 46719057,
         "File Number": "H15-055",
         "Address": "73 N 6TH ST SAN JOSE",
         "Project Name": "H15-055 - 6th Street Project",
         "Application Type": "Site Permit ",
         "Application Date": "11/17/15",
         "Status": "Approved ",
         "Description": "Site Development Permit to allow the demolition of all existing buildings and a portion of an existing parking lot and the construction of a ten-story building, 197 residential unit mixed use building with 2,366 square feet of commercial space on a 0.28-gross acre site.",
         "Planner": "Tracy Tam ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "H15-055",
         "APN": 46719059,
         "File Number": "H15-055",
         "Address": "73 N 6TH ST SAN JOSE",
         "Project Name": "H15-055 - 6th Street Project",
         "Application Type": "Site Permit ",
         "Application Date": "11/17/15",
         "Status": "Approved ",
         "Description": "Site Development Permit to allow the demolition of all existing buildings and a portion of an existing parking lot and the construction of a ten-story building, 197 residential unit mixed use building with 2,366 square feet of commercial space on a 0.28-gross acre site.",
         "Planner": "Tracy Tam ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "H16-018",
         "APN": 25939116,
         "File Number": "H16-018",
         "Address": "333 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "H16-018",
         "Application Type": "Site Permit ",
         "Application Date": "4/27/16 14:43",
         "Status": "Approved ",
         "Description": "Site Development Permit to allow the demolition of an existing 30,659-square foot building, the construction of a new 1,513,941-square foot 18-story building with up to 700,000 square feet of office and retail uses, and the removal of three ordinance-size trees and eleven street trees on a 2.50-gross acre site",
         "Planner": "Tracy Tam ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "H16-018",
         "APN": 25939118,
         "File Number": "H16-018",
         "Address": "333 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "H16-018",
         "Application Type": "Site Permit ",
         "Application Date": "4/27/16 14:43",
         "Status": "Approved ",
         "Description": "Site Development Permit to allow the demolition of an existing 30,659-square foot building, the construction of a new 1,513,941-square foot 18-story building with up to 700,000 square feet of office and retail uses, and the removal of three ordinance-size trees and eleven street trees on a 2.50-gross acre site",
         "Planner": "Tracy Tam ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "H16-036",
         "APN": 46746072,
         "File Number": "H16-036",
         "Address": "80 E SAN CARLOS ST SAN JOSE",
         "Project Name": "H16-036 The Graduate",
         "Application Type": "Site Permit ",
         "Application Date": "10/4/16",
         "Status": "Approved ",
         "Description": "Site Development Permit to construct a 19-story mixed-use development with 260 multi-family residences and 14,800 square feet of commercial uses on a 1.45 gross acre site",
         "Planner": "Leila Hakimizadeh ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "H16-045",
         "APN": 25934039,
         "File Number": "H16-045",
         "Address": "45 N MARKET ST SAN JOSE",
         "Project Name": "H16-045",
         "Application Type": "Site Permit ",
         "Application Date": "11/14/16 13:52",
         "Status": "Approved ",
         "Description": "Site Development Permit to allow a 2,000 square foot interior modification for retail use in an existing City parking garage on 2.21 gross acre site",
         "Planner": "Emily Lipoma ",
         "DURATION": 25,
         "Year": 2016
      },
      {
         "PERMITID": "H17-020",
         "APN": 47217024,
         "File Number": "H17-020",
         "Address": "735 S 2ND ST SAN JOSE",
         "Project Name": "H17-020",
         "Application Type": "Site Permit ",
         "Application Date": "4/14/17",
         "Status": "Approved ",
         "Description": "Site Development Permit to allow the construction of four residential condominium units, with tandem parking, on a 0.15-gross acre site in the R-M Multiple Residence Zoning District",
         "Planner": "Rina Shah ",
         "DURATION": 722,
         "Year": 2017
      },
      {
         "PERMITID": "H81-158",
         "APN": 46721023,
         "File Number": "H81-158",
         "Address": "15 E SANTA CLARA ST SAN JOSE",
         "Project Name": "H81-158",
         "Application Type": "Site Permit ",
         "Application Date": "6/29/81",
         "Status": "Approved ",
         "Description": "File type: *Other apns: *Gen.Use Class:*Existing Land Use:50*Specific Use:OFFICE",
         "Planner": "CPARADA ",
         "DURATION": 0,
         "Year": 1981
      },
      {
         "PERMITID": "H84-292",
         "APN": 47228079,
         "File Number": "H84-292",
         "Address": "563 S 9TH ST SAN JOSE",
         "Project Name": "H84-292",
         "Application Type": "Site Permit ",
         "Application Date": "10/17/84",
         "Status": "Approved ",
         "Description": "File type: *Other apns: *Gen.Use Class:*Existing Land Use:02*Specific Use:ADD. TO 4-PLEX",
         "Planner": "JSLAVIT ",
         "DURATION": 0,
         "Year": 1984
      },
      {
         "PERMITID": "H85-269",
         "APN": 25935035,
         "File Number": "H85-269",
         "Address": "161 W SANTA CLARA ST SAN JOSE",
         "Project Name": "H85-269",
         "Application Type": "Site Permit ",
         "Application Date": "12/12/85",
         "Status": "Approved ",
         "Description": "REMODEL RESTAURANT ",
         "Planner": "Jerry Yoshida ",
         "DURATION": 0,
         "Year": 1985
      },
      {
         "PERMITID": "H85-281",
         "APN": 25940034,
         "File Number": "H85-281",
         "Address": "84 W SANTA CLARA ST SAN JOSE",
         "Project Name": "H85-281",
         "Application Type": "Site Permit ",
         "Application Date": "12/30/85",
         "Status": "Approved ",
         "Description": "ATM FOR BANK ",
         "Planner": "Vic Mendez ",
         "DURATION": 0,
         "Year": 1985
      },
      {
         "PERMITID": "H86-065",
         "APN": 46721023,
         "File Number": "H86-065",
         "Address": "15 E SANTA CLARA ST SAN JOSE",
         "Project Name": "H86-065",
         "Application Type": "Site Permit ",
         "Application Date": "4/7/86",
         "Status": "Approved ",
         "Description": "REMODEL OFFICE BLDG/PC35051=REMODEL",
         "Planner": "Mel Flores ",
         "DURATION": 0,
         "Year": 1986
      },
      {
         "PERMITID": "H87-053",
         "APN": 46747040,
         "File Number": "H87-053",
         "Address": "430 S 2ND ST SAN JOSE",
         "Project Name": "H87-053",
         "Application Type": "Site Permit ",
         "Application Date": "4/3/87",
         "Status": "Approved ",
         "Description": "REMOD.RETAIL BLDGS. ",
         "Planner": "Jerry Yoshida ",
         "DURATION": 0,
         "Year": 1987
      },
      {
         "PERMITID": "H87-109",
         "APN": 46720079,
         "File Number": "H87-109",
         "Address": "147 E SANTA CLARA ST SAN JOSE",
         "Project Name": "H87-109",
         "Application Type": "Site Permit ",
         "Application Date": "8/20/87",
         "Status": "Approved ",
         "Description": "SIGNS ",
         "Planner": "Mike Enderby ",
         "DURATION": 0,
         "Year": 1987
      },
      {
         "PERMITID": "H88-056",
         "APN": 26420008,
         "File Number": "H88-056",
         "Address": "358 ROYAL AV SAN JOSE",
         "Project Name": "H88-056",
         "Application Type": "Site Permit ",
         "Application Date": "3/28/88",
         "Status": "Approved ",
         "Description": "AUTO SERVICE BLDG,PC44869=5380SF; Other APNs:009",
         "Planner": "LCARRILL ",
         "DURATION": 0,
         "Year": 1988
      },
      {
         "PERMITID": "H89-119",
         "APN": 46724110,
         "File Number": "H89-119",
         "Address": "268 E SANTA CLARA ST SAN JOSE",
         "Project Name": "H89-119",
         "Application Type": "Site Permit ",
         "Application Date": "10/26/89",
         "Status": "Approved ",
         "Description": "PC50277=1000SF ADDN",
         "Planner": "Rich Buikema ",
         "DURATION": 0,
         "Year": 1989
      },
      {
         "PERMITID": "H90-008",
         "APN": 46721034,
         "File Number": "H90-008",
         "Address": "2 N 2ND ST SAN JOSE",
         "Project Name": "H90-008",
         "Application Type": "Site Permit ",
         "Application Date": "1/19/90",
         "Status": "Approved ",
         "Description": "File type: *Other apns: *Gen.Use Class:*Existing Land Use:59*Specific Use:ATM INSTALLATION",
         "Planner": "Larry Bohannan ",
         "DURATION": 0,
         "Year": 1990
      },
      {
         "PERMITID": "H90-037",
         "APN": 46723089,
         "File Number": "H90-037",
         "Address": "100 E SANTA CLARA ST SAN JOSE",
         "Project Name": "H90-037",
         "Application Type": "Site Permit ",
         "Application Date": "3/2/90",
         "Status": "Approved ",
         "Description": "File type: *Other apns: *Gen.Use Class:*Existing Land Use:59*Specific Use:AUTO TELLER",
         "Planner": "Vic Mendez ",
         "DURATION": 0,
         "Year": 1990
      },
      {
         "PERMITID": "H90-135",
         "APN": 47229103,
         "File Number": "H90-135",
         "Address": "550 S 12TH ST SAN JOSE",
         "Project Name": "H90-135",
         "Application Type": "Site Permit ",
         "Application Date": "12/11/90",
         "Status": "Approved ",
         "Description": "File type: *Other apns: *Gen.Use Class:*Existing Land Use:69*Specific Use:S F D MOVE-ON",
         "Planner": "LCARRILL ",
         "DURATION": 0,
         "Year": 1990
      },
      {
         "PERMITID": "H92-034",
         "APN": 24974003,
         "File Number": "H92-034",
         "Address": "370 N 4TH ST SAN JOSE",
         "Project Name": "H92-034",
         "Application Type": "Site Permit ",
         "Application Date": "6/10/92",
         "Status": "Approved ",
         "Description": "PC9203033",
         "Planner": "JCAMERON ",
         "DURATION": 0,
         "Year": 1992
      },
      {
         "PERMITID": "H92-034",
         "APN": 24974006,
         "File Number": "H92-034",
         "Address": "370 N 4TH ST SAN JOSE",
         "Project Name": "H92-034",
         "Application Type": "Site Permit ",
         "Application Date": "6/10/92",
         "Status": "Approved ",
         "Description": "PC9203033",
         "Planner": "JCAMERON ",
         "DURATION": 0,
         "Year": 1992
      },
      {
         "PERMITID": "H93-032",
         "APN": 47228054,
         "File Number": "H93-032",
         "Address": "346 E WILLIAM ST SAN JOSE",
         "Project Name": "H93-032",
         "Application Type": "Site Permit ",
         "Application Date": "5/26/93",
         "Status": "Approved ",
         "Description": "File type: *Other apns: *Gen.Use Class:*Existing Land Use:53*Specific Use:FAST FOOD ADDITION",
         "Planner": "JPRANDI ",
         "DURATION": 0,
         "Year": 1993
      },
      {
         "PERMITID": "H95-058",
         "APN": 24948005,
         "File Number": "H95-058",
         "Address": "379 N 6TH ST SAN JOSE",
         "Project Name": "H95-058",
         "Application Type": "Site Permit ",
         "Application Date": "8/18/95",
         "Status": "Approved ",
         "Description": "File type: *Other apns: *Gen.Use Class:*Existing Land Use:01*Specific Use:NEW GARAGE",
         "Planner": "Cesario Rodriguez ",
         "DURATION": 0,
         "Year": 1995
      },
      {
         "PERMITID": "H97-046",
         "APN": 24948025,
         "File Number": "H97-046",
         "Address": "252 WASHINGTON ST SAN JOSE",
         "Project Name": "H97-046",
         "Application Type": "Site Permit ",
         "Application Date": "5/28/97",
         "Status": "Approved ",
         "Description": "2 SFAR (DUPLEX) ON 0.239 GROSS ACRES",
         "Planner": "Salifu Yakubu ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "H98-101",
         "APN": 26420080,
         "File Number": "H98-101",
         "Address": "482 W SAN CARLOS ST SAN JOSE",
         "Project Name": "H98-101",
         "Application Type": "Site Permit ",
         "Application Date": "11/17/98",
         "Status": "Approved ",
         "Description": "Site Development Permit for construction of a 9,956 square foot building on a .38 gross acre site for commercial use",
         "Planner": "Akoni Danielsen ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "H99-079",
         "APN": 47229043,
         "File Number": "H99-079",
         "Address": "520 S 10TH ST SAN JOSE",
         "Project Name": "H99-079",
         "Application Type": "Site Permit ",
         "Application Date": "10/12/99",
         "Status": "Approved ",
         "Description": "Site Development Permit for building facade improvements on a 0.86 gross acre site",
         "Planner": "Akoni Danielsen ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RH00-001",
         "APN": 25930103,
         "File Number": "RH00-001",
         "Address": "350 W JULIAN ST SAN JOSE",
         "Project Name": "RH00-001, River Street Historic District Houses",
         "Application Type": "Site Permit ",
         "Application Date": "1/6/00",
         "Status": "Approved ",
         "Description": "Rehabilitation of nine (9)relocated historic buildings with site improvements.",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "RH01-001",
         "APN": 25944075,
         "File Number": "RH01-001",
         "Address": " ",
         "Project Name": "RH01-001, Adobe Systems - Tower 2",
         "Application Type": "Site Permit ",
         "Application Date": "1/17/01",
         "Status": "Approved ",
         "Description": "Addition of a multi-story office tower and parking for Adobe ",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "RH03-001",
         "APN": 25939111,
         "File Number": "RH03-001",
         "Address": " ",
         "Project Name": "RH03-001, Marriott Courtyard",
         "Application Type": "Site Permit ",
         "Application Date": "2/27/03",
         "Status": "Approved ",
         "Description": "Construction of a 254 room hotel and related site improvements.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RH91-005",
         "APN": 25935051,
         "File Number": "RH91-005",
         "Address": " ",
         "Project Name": "RH91-005, The Olde Fox",
         "Application Type": "Site Permit ",
         "Application Date": "8/5/91",
         "Status": "Approved ",
         "Description": "Site Development permit to allow the conversion of a vacant one-story building to a restaurant/bar ",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1991
      },
      {
         "PERMITID": "RH91-010",
         "APN": 25924035,
         "File Number": "RH91-010",
         "Address": " ",
         "Project Name": "RH91-010, FMC Corporation",
         "Application Type": "Site Permit ",
         "Application Date": "11/26/91",
         "Status": "Approved ",
         "Description": "Construction of a groundwater extraction & treatment system, including 660 linear feet of underground trench, a 21' x 23' water treatment equipment shelter building, 9,200 gallon water tank, and landscaping. (Julian St. Facility & Guadalupe Parkway)",
         "Planner": "Ted Lorraine ",
         "DURATION": 0,
         "Year": 1991
      },
      {
         "PERMITID": "RH92-004",
         "APN": 25934018,
         "File Number": "RH92-004",
         "Address": " ",
         "Project Name": "RH92-004, Mitchell Parking Lot",
         "Application Type": "Site Permit ",
         "Application Date": "4/22/92",
         "Status": "Approved ",
         "Description": "Expansion of existing private parking lot ",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1992
      },
      {
         "PERMITID": "RH92-006",
         "APN": 25935020,
         "File Number": "RH92-006",
         "Address": " ",
         "Project Name": "RH92-006, Hackett Parking Lot",
         "Application Type": "Site Permit ",
         "Application Date": "1/17/92",
         "Status": "Approved ",
         "Description": "Improvement of an existing parking lot with 68,711 sq. ft.",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1992
      },
      {
         "PERMITID": "RH92-008",
         "APN": 46722008,
         "File Number": "RH92-008",
         "Address": " ",
         "Project Name": "RH92-008, Bella Mia Restaurant",
         "Application Type": "Site Permit ",
         "Application Date": "9/21/92",
         "Status": "Approved ",
         "Description": "Addition of a balcony on second floor of an existing building of approx. 400 additional sq. ft.",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1992
      },
      {
         "PERMITID": "RH93-003",
         "APN": 46747042,
         "File Number": "RH93-003",
         "Address": " ",
         "Project Name": "RH93-003, Dai Thanh Plaza",
         "Application Type": "Site Permit ",
         "Application Date": "6/25/93",
         "Status": "Approved ",
         "Description": "Addition of 3,680 sq. ft. to an existing single-story commercial building",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1993
      },
      {
         "PERMITID": "RH93-004",
         "APN": 25934016,
         "File Number": "RH93-004",
         "Address": " ",
         "Project Name": "RH93-004, American Savings Bank",
         "Application Type": "Site Permit ",
         "Application Date": "8/9/93",
         "Status": "Approved ",
         "Description": "Exterior facade alterations and signage on existing single-story commercial building ",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1993
      },
      {
         "PERMITID": "RH93-005",
         "APN": 47226085,
         "File Number": "RH93-005",
         "Address": " ",
         "Project Name": "RH93-005, Emile's Restaurant",
         "Application Type": "Site Permit ",
         "Application Date": "8/27/93",
         "Status": "Approved ",
         "Description": "Addition of banquet room, cooking school and office to existing restaurant ",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1993
      },
      {
         "PERMITID": "RH94-001",
         "APN": 46747042,
         "File Number": "RH94-001",
         "Address": " ",
         "Project Name": "RH94-001, Dai Thanh Plaza",
         "Application Type": "Site Permit ",
         "Application Date": "2/1/04",
         "Status": "Approved ",
         "Description": "Renovation of a single-story building with on-site parking ",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 2004
      },
      {
         "PERMITID": "RH94-002",
         "APN": 46747041,
         "File Number": "RH94-002",
         "Address": " ",
         "Project Name": "RH94-002, Dai Thanh Supermarket",
         "Application Type": "Site Permit ",
         "Application Date": "6/10/94",
         "Status": "Approved ",
         "Description": "Add a 224 sq. ft. room to a supermarket for retail/commercial use",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1994
      },
      {
         "PERMITID": "RH94-003",
         "APN": 25944085,
         "File Number": "RH94-003",
         "Address": " ",
         "Project Name": "RH94-003, Adobe Systems, Inc.",
         "Application Type": "Site Permit ",
         "Application Date": "7/1/94",
         "Status": "Approved ",
         "Description": "Construction of an 18-story corporate office building with 387,357 sq. ft. gross office area with 374,994 sq. ft. gross parking area (6 levels) with 950 parking stalls.",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1994
      },
      {
         "PERMITID": "RH94-003",
         "APN": 25944089,
         "File Number": "RH94-003",
         "Address": " ",
         "Project Name": "RH94-003, Adobe Systems, Inc.",
         "Application Type": "Site Permit ",
         "Application Date": "7/1/94",
         "Status": "Approved ",
         "Description": "Construction of an 18-story corporate office building with 387,357 sq. ft. gross office area with 374,994 sq. ft. gross parking area (6 levels) with 950 parking stalls.",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1994
      },
      {
         "PERMITID": "RH96-002",
         "APN": 25944085,
         "File Number": "RH96-002",
         "Address": "1212 ALMADEN AV SAN JOSE",
         "Project Name": "RH96-002, Adobe Systems, Inc.",
         "Application Type": "Site Permit ",
         "Application Date": "5/1/96",
         "Status": "Approved ",
         "Description": "Height and bulk waiver. Reference file #'s RAD95-09-015 & RHSH94-07-003",
         "Planner": "Dennis Korabiak ",
         "DURATION": 0,
         "Year": 1996
      },
      {
         "PERMITID": "RH96-002",
         "APN": 25944089,
         "File Number": "RH96-002",
         "Address": "1212 ALMADEN AV SAN JOSE",
         "Project Name": "RH96-002, Adobe Systems, Inc.",
         "Application Type": "Site Permit ",
         "Application Date": "5/1/96",
         "Status": "Approved ",
         "Description": "Height and bulk waiver. Reference file #'s RAD95-09-015 & RHSH94-07-003",
         "Planner": "Dennis Korabiak ",
         "DURATION": 0,
         "Year": 1996
      },
      {
         "PERMITID": "RH97-002",
         "APN": 25935041,
         "File Number": "RH97-002",
         "Address": "51 N SAN PEDRO ST SAN JOSE",
         "Project Name": "RH97-002, Old Spaghetti Factory",
         "Application Type": "Site Permit ",
         "Application Date": "3/13/97",
         "Status": "Approved ",
         "Description": "Construction of a 956 sq. ft. addition to an existing restaurant.",
         "Planner": "Kristi Ashburn ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RH97-003",
         "APN": 46721045,
         "File Number": "RH97-003",
         "Address": " ",
         "Project Name": "RH97-003, Dr. Eu Building",
         "Application Type": "Site Permit ",
         "Application Date": "7/9/97",
         "Status": "Approved ",
         "Description": "Rehabilitate an existing, vacant, three-story building 17,201 sq. ft. and install 1,827 cubic feet of engineered fill.",
         "Planner": "Eric Keller ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RH97-005",
         "APN": 25943069,
         "File Number": "RH97-005",
         "Address": " ",
         "Project Name": "RH97-005, Crown Plaza Hotel",
         "Application Type": "Site Permit ",
         "Application Date": "9/10/97",
         "Status": "Approved ",
         "Description": "Rehabilitate existing nine-story hotel that includes removal of a swimming pool and removal and relocation of several mechanical appurtenances as well as construction of a new sidewalk, portico and trellises with exterior modifications ",
         "Planner": "Eric Keller ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RH98-002",
         "APN": 25935020,
         "File Number": "RH98-002",
         "Address": " ",
         "Project Name": "RH98-002, Opus West Office Tower",
         "Application Type": "Site Permit ",
         "Application Date": "1/1/98",
         "Status": "Approved ",
         "Description": "340,000 square feet of office space, 15,000 square feet of retail space.",
         "Planner": "Martin Magana ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "RH98-003",
         "APN": 25924035,
         "File Number": "RH98-003",
         "Address": " ",
         "Project Name": "RH98-003, Sobrato FMC (River Park)",
         "Application Type": "Site Permit ",
         "Application Date": "6/1/98",
         "Status": "Approved ",
         "Description": "460,000 square feet of commercial office uses in three phases; also includes a demolition permit with the same number to allow demolition of two structures (267 & 299 W. Julian St.) to accommodate this construction.",
         "Planner": "Martin Magana ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "RH98-003",
         "APN": 25924037,
         "File Number": "RH98-003",
         "Address": " ",
         "Project Name": "RH98-003, Sobrato FMC (River Park)",
         "Application Type": "Site Permit ",
         "Application Date": "6/1/98",
         "Status": "Approved ",
         "Description": "460,000 square feet of commercial office uses in three phases; also includes a demolition permit with the same number to allow demolition of two structures (267 & 299 W. Julian St.) to accommodate this construction.",
         "Planner": "Martin Magana ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "RH99-007",
         "APN": 26429118,
         "File Number": "RH99-007",
         "Address": " ",
         "Project Name": "RH99-007, The Agenda Garden",
         "Application Type": "Site Permit ",
         "Application Date": "4/13/99",
         "Status": "Approved ",
         "Description": "Allow site improvements to a vacant lot and building to allow the construction of a 1,207 sq. ft. outdoor patio for an existing restaurant with new landscaping, gates and new access doorway to Agenda Restaurant.",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RH99-009",
         "APN": 46722142,
         "File Number": "RH99-009",
         "Address": " ",
         "Project Name": "RH99-009, Block 2/Above Net",
         "Application Type": "Site Permit ",
         "Application Date": "1/18/01",
         "Status": "Approved ",
         "Description": "Construction of a 17-story, 325,200 sq. ft. office tower w/603 space parking garage and 16,600 sq. ft. of ground floor retail space.",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "RH99-015",
         "APN": 25942079,
         "File Number": "RH99-015",
         "Address": "211 S 1ST ST SAN JOSE",
         "Project Name": "RH99-015, Montgomery Hotel Relocation",
         "Application Type": "Site Permit ",
         "Application Date": "7/20/99",
         "Status": "Approved ",
         "Description": "Relocate the existing Montgomery Hotel to the south to allow the Fairmont Hotel Expansion ",
         "Planner": "Martin Magana ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "RH99-017",
         "APN": 25940091,
         "File Number": "RH99-017",
         "Address": " ",
         "Project Name": "RH99-017, Market-Post Tower",
         "Application Type": "Site Permit ",
         "Application Date": "11/17/99",
         "Status": "Approved ",
         "Description": "Development Wiaver for existing building - legalize height of existing Market-Post Tower. ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "H05-014",
         "APN": 25941057,
         "File Number": "H05-014",
         "Address": "104 PARK CENTER PLAZA SAN JOSE",
         "Project Name": "H05-014 - Park Center Plaza",
         "Application Type": "Site Permit ",
         "Application Date": "3/16/05",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit to construct a 2,544-square- foot addition to an existing 6,411 square foot building; remove three small existing buildings; and allow related waterproofing and landscaping on a 6.9 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2005
      },
      {
         "PERMITID": "H05-014",
         "APN": 25941067,
         "File Number": "H05-014",
         "Address": "104 PARK CENTER PLAZA SAN JOSE",
         "Project Name": "H05-014 - Park Center Plaza",
         "Application Type": "Site Permit ",
         "Application Date": "3/16/05",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit to construct a 2,544-square- foot addition to an existing 6,411 square foot building; remove three small existing buildings; and allow related waterproofing and landscaping on a 6.9 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2005
      },
      {
         "PERMITID": "RH92-001",
         "APN": 25935020,
         "File Number": "RH92-001",
         "Address": " ",
         "Project Name": "RH92-001, Hackett Parking Lot",
         "Application Type": "Site Permit ",
         "Application Date": "1/17/92",
         "Status": "Closed ",
         "Description": "Improvement of an existing parking lot with 68,711 sq. ft.",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1992
      },
      {
         "PERMITID": "RH98-005",
         "APN": 46747095,
         "File Number": "RH98-005",
         "Address": " ",
         "Project Name": "RH98-005, Best Western/Ramada Inn",
         "Application Type": "Site Permit ",
         "Application Date": "10/15/98",
         "Status": "Closed ",
         "Description": "To allow a 2,500 square foot meeting room and lobby expansion and site improvements to an existing motel",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "H74-237",
         "APN": 47229095,
         "File Number": "H74-237",
         "Address": "515 S 10TH ST SAN JOSE",
         "Project Name": "H74-237",
         "Application Type": "Site Permit ",
         "Application Date": " ",
         "Status": "Complete ",
         "Description": "Remodel of a Restaurant ",
         "Planner": " ",
         "DURATION": 0,
         "Year": null
      },
      {
         "PERMITID": "RH94-003",
         "APN": 25944089,
         "File Number": "RH94-003",
         "Address": " ",
         "Project Name": "RH94-003",
         "Application Type": "Site Permit ",
         "Application Date": "1/1/94",
         "Status": "Complete ",
         "Description": " ",
         "Planner": "Sandra Escobar ",
         "DURATION": 0,
         "Year": 1994
      },
      {
         "PERMITID": "H06-083",
         "APN": 46721034,
         "File Number": "H06-083",
         "Address": "4 N 2ND ST SAN JOSE",
         "Project Name": "H06-083",
         "Application Type": "Site Permit ",
         "Application Date": "11/5/06",
         "Status": "Denied ",
         "Description": "Site Development Permit to construct 19 multiple dwelling units on a 0.13 gross acre site",
         "Planner": "Licinia McMorrow ",
         "DURATION": 862,
         "Year": 2006
      },
      {
         "PERMITID": "H87-110",
         "APN": 26419067,
         "File Number": "H87-110",
         "Address": " ",
         "Project Name": "H87-110",
         "Application Type": "Site Permit ",
         "Application Date": "8/21/87",
         "Status": "Denied ",
         "Description": "ADD. TO GROCERY STORE ",
         "Planner": "LCARRILL ",
         "DURATION": 0,
         "Year": 1987
      },
      {
         "PERMITID": "H86-211",
         "APN": 47224028,
         "File Number": "H86-211",
         "Address": "656 S 7TH ST SAN JOSE",
         "Project Name": "H86-211",
         "Application Type": "Site Permit ",
         "Application Date": "12/30/86",
         "Status": "Expired ",
         "Description": "PC39058=6UNIT APARTMENT",
         "Planner": "LCARRILL ",
         "DURATION": 0,
         "Year": 1986
      },
      {
         "PERMITID": "H18-039",
         "APN": 25956002,
         "File Number": "H18-039",
         "Address": "170 S MARKET ST SAN JOSE",
         "Project Name": "H18-039",
         "Application Type": "Site Permit ",
         "Application Date": "10/19/18",
         "Status": "Pending ",
         "Description": "Site Development to allow the installation of a Supergraphic Sign (approx. 14,100 sf), no more than one sign, attached flush to a building façade",
         "Planner": "Lea Simvoulakis ",
         "DURATION": 1,
         "Year": 2018
      },
      {
         "PERMITID": "H18-042",
         "APN": 25941086,
         "File Number": "H18-042",
         "Address": "50 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "H18-042",
         "Application Type": "Site Permit ",
         "Application Date": " ",
         "Status": "Pending ",
         "Description": "Site Development to allow the installation of a Supergraphic Sign, no more than one sign, attached flush to a building façade  ",
         "Planner": " ",
         "DURATION": 1,
         "Year": null
      },
      {
         "PERMITID": "H18-042",
         "APN": 25941087,
         "File Number": "H18-042",
         "Address": "50 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "H18-042",
         "Application Type": "Site Permit ",
         "Application Date": " ",
         "Status": "Pending ",
         "Description": "Site Development to allow the installation of a Supergraphic Sign, no more than one sign, attached flush to a building façade  ",
         "Planner": " ",
         "DURATION": 1,
         "Year": null
      },
      {
         "PERMITID": "H18-043",
         "APN": 25943075,
         "File Number": "H18-043",
         "Address": "333 W SAN CARLOS ST SAN JOSE",
         "Project Name": "H18-043",
         "Application Type": "Site Permit ",
         "Application Date": " ",
         "Status": "Pending ",
         "Description": "Site Development to allow the installation of a Supergraphic Sign (approx. 7,500 sf), no more than one sign, attached flush to a building façade",
         "Planner": " ",
         "DURATION": 1,
         "Year": null
      },
      {
         "PERMITID": "H17-004",
         "APN": 46747058,
         "File Number": "H17-004",
         "Address": "439 S 4TH ST SAN JOSE",
         "Project Name": "H17-004 - 439 South 4th Street",
         "Application Type": "Site Permit ",
         "Application Date": "1/18/17",
         "Status": "Review Letter Sent ",
         "Description": "Site Development Permit to allow the demolition of an existing residence and a three-story apartment building and the construction of an 18-story mixed use building consisting of 218 residential units, approximately 1,345 square feet of commercial use and approximately 12,381 square feet of a public eating establishment on a 0.52-gross acre site.",
         "Planner": "Emily Lipoma ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "H17-004",
         "APN": 46747096,
         "File Number": "H17-004",
         "Address": "439 S 4TH ST SAN JOSE",
         "Project Name": "H17-004 - 439 South 4th Street",
         "Application Type": "Site Permit ",
         "Application Date": "1/18/17",
         "Status": "Review Letter Sent ",
         "Description": "Site Development Permit to allow the demolition of an existing residence and a three-story apartment building and the construction of an 18-story mixed use building consisting of 218 residential units, approximately 1,345 square feet of commercial use and approximately 12,381 square feet of a public eating establishment on a 0.52-gross acre site.",
         "Planner": "Emily Lipoma ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "H17-059",
         "APN": 46723088,
         "File Number": "H17-059",
         "Address": "10 S 3RD ST SAN JOSE",
         "Project Name": "H17-059__Hotel Clariana",
         "Application Type": "Site Permit ",
         "Application Date": "10/25/17 11:18",
         "Status": "Review Letter Sent ",
         "Description": "Site Development Permit to allow the construction of an 45,783 square foot addition to an existing hotel (Hotel Clariana), including 60 hotel rooms, for a total of 104 rooms, and 3 residential suites, with 5,790 square foot public eating establishment on a 0.41 gross acre site in Downtown.",
         "Planner": "Rina Shah ",
         "DURATION": 14,
         "Year": 2017
      },
      {
         "PERMITID": "H17-059",
         "APN": 46723089,
         "File Number": "H17-059",
         "Address": "10 S 3RD ST SAN JOSE",
         "Project Name": "H17-059__Hotel Clariana",
         "Application Type": "Site Permit ",
         "Application Date": "10/25/17 11:18",
         "Status": "Review Letter Sent ",
         "Description": "Site Development Permit to allow the construction of an 45,783 square foot addition to an existing hotel (Hotel Clariana), including 60 hotel rooms, for a total of 104 rooms, and 3 residential suites, with 5,790 square foot public eating establishment on a 0.41 gross acre site in Downtown.",
         "Planner": "Rina Shah ",
         "DURATION": 14,
         "Year": 2017
      },
      {
         "PERMITID": "H18-025",
         "APN": 25935026,
         "File Number": "H18-025",
         "Address": "51 NOTRE DAME AV SAN JOSE",
         "Project Name": "H18-025",
         "Application Type": "Site Permit ",
         "Application Date": "6/5/18 15:09",
         "Status": "Review Letter Sent ",
         "Description": "Site Development Permit to allow demolition of an existing building and construct a new 18 story 70,000 square foot office space. 220 residential units and approximately 4,000 square feet street level commercial space on a 0.68 gross acre site",
         "Planner": "Ruth Cueto ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "H18-025",
         "APN": 25935027,
         "File Number": "H18-025",
         "Address": "51 NOTRE DAME AV SAN JOSE",
         "Project Name": "H18-025",
         "Application Type": "Site Permit ",
         "Application Date": "6/5/18 15:09",
         "Status": "Review Letter Sent ",
         "Description": "Site Development Permit to allow demolition of an existing building and construct a new 18 story 70,000 square foot office space. 220 residential units and approximately 4,000 square feet street level commercial space on a 0.68 gross acre site",
         "Planner": "Ruth Cueto ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "H18-025",
         "APN": 25935032,
         "File Number": "H18-025",
         "Address": "51 NOTRE DAME AV SAN JOSE",
         "Project Name": "H18-025",
         "Application Type": "Site Permit ",
         "Application Date": "6/5/18 15:09",
         "Status": "Review Letter Sent ",
         "Description": "Site Development Permit to allow demolition of an existing building and construct a new 18 story 70,000 square foot office space. 220 residential units and approximately 4,000 square feet street level commercial space on a 0.68 gross acre site",
         "Planner": "Ruth Cueto ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "H18-025",
         "APN": 25935033,
         "File Number": "H18-025",
         "Address": "51 NOTRE DAME AV SAN JOSE",
         "Project Name": "H18-025",
         "Application Type": "Site Permit ",
         "Application Date": "6/5/18 15:09",
         "Status": "Review Letter Sent ",
         "Description": "Site Development Permit to allow demolition of an existing building and construct a new 18 story 70,000 square foot office space. 220 residential units and approximately 4,000 square feet street level commercial space on a 0.68 gross acre site",
         "Planner": "Ruth Cueto ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "H18-033",
         "APN": 47226070,
         "File Number": "H18-033",
         "Address": "605 S 2ND ST SAN JOSE",
         "Project Name": "H18-033",
         "Application Type": "Site Permit ",
         "Application Date": "7/24/18 14:26",
         "Status": "Review Letter Sent ",
         "Description": "Site Development Permit to allow the construction of a seven-story hotel with 106 guest rooms, a drinking establishment interior to a full-service hotel, and an on-site backup generator on an approximately 0.3-gross acre site.",
         "Planner": "Ruth Cueto ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "H18-037",
         "APN": 25939116,
         "File Number": "H18-037",
         "Address": "333 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "H18-037",
         "Application Type": "Site Permit ",
         "Application Date": "8/16/18 10:16",
         "Status": "Review Letter Sent ",
         "Description": "Site Development Permit to allow the development of a new approximately 1,315,000-square-foot building (18-story, 690,328 square feet of research and development and office use, 8,132 square feet of retail use, a private pedestrian bridge connecting to existing office buildings to the south, extended weekday and Saturday construction hours, and limited number of 24-hour workdays on an approximately 2.49-gross-acre site.",
         "Planner": "Ruth Cueto ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "H18-037",
         "APN": 25939118,
         "File Number": "H18-037",
         "Address": "333 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "H18-037",
         "Application Type": "Site Permit ",
         "Application Date": "8/16/18 10:16",
         "Status": "Review Letter Sent ",
         "Description": "Site Development Permit to allow the development of a new approximately 1,315,000-square-foot building (18-story, 690,328 square feet of research and development and office use, 8,132 square feet of retail use, a private pedestrian bridge connecting to existing office buildings to the south, extended weekday and Saturday construction hours, and limited number of 24-hour workdays on an approximately 2.49-gross-acre site.",
         "Planner": "Ruth Cueto ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "H18-038",
         "APN": 25935055,
         "File Number": "H18-038",
         "Address": "8 N ALMADEN BL SAN JOSE",
         "Project Name": "H18-038_Almaden 8_HOTEL",
         "Application Type": "Site Permit ",
         "Application Date": "8/28/18 14:05",
         "Status": "Review Letter Sent ",
         "Description": "Site Development to allow the construction of a 19-story, 225-foot high rise hotel with 272 guest rooms with amenities including restaurant with on-sale of alcohol, fitness center and off-site parking arrangement on .20 gross acre site",
         "Planner": "Patrick Kelly ",
         "DURATION": 141,
         "Year": 2018
      },
      {
         "PERMITID": "H18-045",
         "APN": 25943076,
         "File Number": "H18-045",
         "Address": "200 PARK AV SAN JOSE",
         "Project Name": "H18-045",
         "Application Type": "Site Permit ",
         "Application Date": "9/27/18 11:16",
         "Status": "Review Letter Sent ",
         "Description": "Site Development Permit to allow for demolition of a commercial building and a parking garage, and construction of a 19-story, 717,246 square-foot office tower, and replacement parking for the adjacent Hyatt Hotel, located in DC Downtown Primary Commercial Zoning District on an approximately 1.7-acre lot.",
         "Planner": "Cassandra Van Der Zweep ",
         "DURATION": 124,
         "Year": 2018
      },
      {
         "PERMITID": "H18-045",
         "APN": 25943077,
         "File Number": "H18-045",
         "Address": "200 PARK AV SAN JOSE",
         "Project Name": "H18-045",
         "Application Type": "Site Permit ",
         "Application Date": "9/27/18 11:16",
         "Status": "Review Letter Sent ",
         "Description": "Site Development Permit to allow for demolition of a commercial building and a parking garage, and construction of a 19-story, 717,246 square-foot office tower, and replacement parking for the adjacent Hyatt Hotel, located in DC Downtown Primary Commercial Zoning District on an approximately 1.7-acre lot.",
         "Planner": "Cassandra Van Der Zweep ",
         "DURATION": 124,
         "Year": 2018
      },
      {
         "PERMITID": "H19-003",
         "APN": 46720019,
         "File Number": "H19-003",
         "Address": "100 N 4TH ST SAN JOSE",
         "Project Name": "H19-003",
         "Application Type": "Site Permit ",
         "Application Date": "1/30/19 10:28",
         "Status": "Review Letter Sent ",
         "Description": "Site Development Permit to allow the demolition of two (2) existing single-family dwellings, remove six (6) ordinance-sized trees and construction a mixed-use residential and commercial building with approximately 10,733 square feet of commercial and 316 units of housing (student) in a 23-story tall building with above grade parking on an approximately 0.98-gross acre site.",
         "Planner": "Stefanie Farmer ",
         "DURATION": 41,
         "Year": 2019
      },
      {
         "PERMITID": "H19-003",
         "APN": 46720020,
         "File Number": "H19-003",
         "Address": "100 N 4TH ST SAN JOSE",
         "Project Name": "H19-003",
         "Application Type": "Site Permit ",
         "Application Date": "1/30/19 10:28",
         "Status": "Review Letter Sent ",
         "Description": "Site Development Permit to allow the demolition of two (2) existing single-family dwellings, remove six (6) ordinance-sized trees and construction a mixed-use residential and commercial building with approximately 10,733 square feet of commercial and 316 units of housing (student) in a 23-story tall building with above grade parking on an approximately 0.98-gross acre site.",
         "Planner": "Stefanie Farmer ",
         "DURATION": 41,
         "Year": 2019
      },
      {
         "PERMITID": "H19-003",
         "APN": 46720021,
         "File Number": "H19-003",
         "Address": "100 N 4TH ST SAN JOSE",
         "Project Name": "H19-003",
         "Application Type": "Site Permit ",
         "Application Date": "1/30/19 10:28",
         "Status": "Review Letter Sent ",
         "Description": "Site Development Permit to allow the demolition of two (2) existing single-family dwellings, remove six (6) ordinance-sized trees and construction a mixed-use residential and commercial building with approximately 10,733 square feet of commercial and 316 units of housing (student) in a 23-story tall building with above grade parking on an approximately 0.98-gross acre site.",
         "Planner": "Stefanie Farmer ",
         "DURATION": 41,
         "Year": 2019
      },
      {
         "PERMITID": "H19-003",
         "APN": 46720022,
         "File Number": "H19-003",
         "Address": "100 N 4TH ST SAN JOSE",
         "Project Name": "H19-003",
         "Application Type": "Site Permit ",
         "Application Date": "1/30/19 10:28",
         "Status": "Review Letter Sent ",
         "Description": "Site Development Permit to allow the demolition of two (2) existing single-family dwellings, remove six (6) ordinance-sized trees and construction a mixed-use residential and commercial building with approximately 10,733 square feet of commercial and 316 units of housing (student) in a 23-story tall building with above grade parking on an approximately 0.98-gross acre site.",
         "Planner": "Stefanie Farmer ",
         "DURATION": 41,
         "Year": 2019
      },
      {
         "PERMITID": "H19-003",
         "APN": 46720040,
         "File Number": "H19-003",
         "Address": "100 N 4TH ST SAN JOSE",
         "Project Name": "H19-003",
         "Application Type": "Site Permit ",
         "Application Date": "1/30/19 10:28",
         "Status": "Review Letter Sent ",
         "Description": "Site Development Permit to allow the demolition of two (2) existing single-family dwellings, remove six (6) ordinance-sized trees and construction a mixed-use residential and commercial building with approximately 10,733 square feet of commercial and 316 units of housing (student) in a 23-story tall building with above grade parking on an approximately 0.98-gross acre site.",
         "Planner": "Stefanie Farmer ",
         "DURATION": 41,
         "Year": 2019
      },
      {
         "PERMITID": "H16-042",
         "APN": 25942079,
         "File Number": "H16-042",
         "Address": "211 S 1ST ST SAN JOSE",
         "Project Name": "H16-042 Tribute Hotel",
         "Application Type": "Site Permit ",
         "Application Date": "10/18/16 14:46",
         "Status": "Under Review ",
         "Description": "Site Development Permit to allow the construction of a 24-story, 274-room hotel, integrated with the Montgomery Hotel, a designated City Landmark, with off-site parking on a 0.58-gross acre site",
         "Planner": "John Tu ",
         "DURATION": 902,
         "Year": 2016
      },
      {
         "PERMITID": "H17-022",
         "APN": 26426013,
         "File Number": "H17-022",
         "Address": "433 AUZERAIS AV SAN JOSE",
         "Project Name": "H17-022 - 425 Auzerais Ave",
         "Application Type": "Site Permit ",
         "Application Date": "4/24/17 14:35",
         "Status": "Under Review ",
         "Description": "Site Development Permit to allow demolition of existing buildings and construct a 6-story building including podium and up to 130 attached residential units on 1.05 gross acre site",
         "Planner": "Rina Shah ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "H17-022",
         "APN": 26426088,
         "File Number": "H17-022",
         "Address": "433 AUZERAIS AV SAN JOSE",
         "Project Name": "H17-022 - 425 Auzerais Ave",
         "Application Type": "Site Permit ",
         "Application Date": "4/24/17 14:35",
         "Status": "Under Review ",
         "Description": "Site Development Permit to allow demolition of existing buildings and construct a 6-story building including podium and up to 130 attached residential units on 1.05 gross acre site",
         "Planner": "Rina Shah ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "H17-027",
         "APN": 25940043,
         "File Number": "H17-027",
         "Address": "27 S 1ST ST SAN JOSE",
         "Project Name": "H17-027_ 27 S. 1ST ST.",
         "Application Type": "Site Permit ",
         "Application Date": "6/5/17 10:02",
         "Status": "Under Review ",
         "Description": "Site Development Permit to allow the demolition of an existing commercial structure and the construction of a 22 story, 248 foot high mixed-use building consisting of 255 residential units and approximately 10,000 square feet of retail use on a 0.57 gross acre site.",
         "Planner": "Rina Shah ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "H17-050",
         "APN": 25941067,
         "File Number": "H17-050",
         "Address": "170 PARK CENTER PLAZA SAN JOSE",
         "Project Name": "H17-050 - City View Plaza",
         "Application Type": "Site Permit ",
         "Application Date": "8/29/17 10:06",
         "Status": "Under Review ",
         "Description": "Site Development Permit to demolish an existing 29,703-square foot commercial building and candidate City Landmark (formerly occupied by the Family Court and Bank of California) and to construct an approximately 462,000-square foot, 24-story mixed-use building with two levels of below-grade parking, up to 255 residential units, and approximately 4,960 square feet of ground floor commercial uses on an approximately 0.60-gross acre site.",
         "Planner": "Cassandra Van Der Zweep ",
         "DURATION": 198,
         "Year": 2017
      },
      {
         "PERMITID": "H19-009",
         "APN": 47225072,
         "File Number": "H19-009",
         "Address": "647 S 6TH ST SAN JOSE",
         "Project Name": "H19-009",
         "Application Type": "Site Permit ",
         "Application Date": "3/6/19 15:02",
         "Status": "Under Review ",
         "Description": "Site Development Permit to allow the conversion from single-family residence to a duplex in the Reed City Landmark District and in the R-M Multiple Residence Zoning District on a 0.14-gross acre site",
         "Planner": "Rina Shah ",
         "DURATION": 29,
         "Year": 2019
      },
      {
         "PERMITID": "H00-021",
         "APN": 24948025,
         "File Number": "H00-021",
         "Address": "252 WASHINGTON ST SAN JOSE",
         "Project Name": "H00-021",
         "Application Type": "Site Permit ",
         "Application Date": "3/27/00",
         "Status": "Withdrawn ",
         "Description": "Site Development Permit for a 1300 square foot addition to a triplex",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "H06-005",
         "APN": 46722121,
         "File Number": "H06-005",
         "Address": "35 S 2ND ST SAN JOSE",
         "Project Name": "H06-005 Fountain Alley",
         "Application Type": "Site Permit ",
         "Application Date": "1/20/06",
         "Status": "Withdrawn ",
         "Description": "Site Development Permit for a high-rise mixed-use project containing a total of 425,904 square feet, consisting of 161 residential units and 213,013 square feet for commercial uses and parking structure on a 1.24 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 2827,
         "Year": 2006
      },
      {
         "PERMITID": "H06-011",
         "APN": 46721018,
         "File Number": "H06-011",
         "Address": "52 N 1ST ST SAN JOSE",
         "Project Name": "H06-011(Marshall Squares)",
         "Application Type": "Site Permit ",
         "Application Date": "2/14/06",
         "Status": "Withdrawn ",
         "Description": "Site Development Permit to construct 171 multiple dwelling units and 10,213 square feet of ground floor retail space on a 1.41 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 2802,
         "Year": 2006
      },
      {
         "PERMITID": "H06-011",
         "APN": 46721030,
         "File Number": "H06-011",
         "Address": "52 N 1ST ST SAN JOSE",
         "Project Name": "H06-011(Marshall Squares)",
         "Application Type": "Site Permit ",
         "Application Date": "2/14/06",
         "Status": "Withdrawn ",
         "Description": "Site Development Permit to construct 171 multiple dwelling units and 10,213 square feet of ground floor retail space on a 1.41 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 2802,
         "Year": 2006
      },
      {
         "PERMITID": "H06-011",
         "APN": 46721038,
         "File Number": "H06-011",
         "Address": "52 N 1ST ST SAN JOSE",
         "Project Name": "H06-011(Marshall Squares)",
         "Application Type": "Site Permit ",
         "Application Date": "2/14/06",
         "Status": "Withdrawn ",
         "Description": "Site Development Permit to construct 171 multiple dwelling units and 10,213 square feet of ground floor retail space on a 1.41 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 2802,
         "Year": 2006
      },
      {
         "PERMITID": "H06-040",
         "APN": 25942080,
         "File Number": "H06-040",
         "Address": "200 S MARKET ST SAN JOSE",
         "Project Name": "H06-040",
         "Application Type": "Site Permit ",
         "Application Date": "8/29/06",
         "Status": "Withdrawn ",
         "Description": "Site Development Permit to construct three residential towers, including 414 condominiums and 245 senior and affordable rental units, over a shared retail base, 34,000 square feet in size, including a podium over three levels of parking on a 2.02 gross acre site.",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "H06-040",
         "APN": 25942081,
         "File Number": "H06-040",
         "Address": "200 S MARKET ST SAN JOSE",
         "Project Name": "H06-040",
         "Application Type": "Site Permit ",
         "Application Date": "8/29/06",
         "Status": "Withdrawn ",
         "Description": "Site Development Permit to construct three residential towers, including 414 condominiums and 245 senior and affordable rental units, over a shared retail base, 34,000 square feet in size, including a podium over three levels of parking on a 2.02 gross acre site.",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "H06-040",
         "APN": 25942082,
         "File Number": "H06-040",
         "Address": "200 S MARKET ST SAN JOSE",
         "Project Name": "H06-040",
         "Application Type": "Site Permit ",
         "Application Date": "8/29/06",
         "Status": "Withdrawn ",
         "Description": "Site Development Permit to construct three residential towers, including 414 condominiums and 245 senior and affordable rental units, over a shared retail base, 34,000 square feet in size, including a podium over three levels of parking on a 2.02 gross acre site.",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 1,
         "Year": 2006
      },
      {
         "PERMITID": "H07-037",
         "APN": 47212072,
         "File Number": "H07-037",
         "Address": "868 S 11TH ST SAN JOSE",
         "Project Name": "H07-037 - 4-units on 11th St.",
         "Application Type": "Site Permit ",
         "Application Date": "9/17/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Permit to allow the demolition of a duplex residence and the construction of a 4-unit residential condominium on a 0.15 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2222,
         "Year": 2007
      },
      {
         "PERMITID": "H10-015",
         "APN": 25943076,
         "File Number": "H10-015",
         "Address": "200 PARK AV SAN JOSE",
         "Project Name": "H10-015",
         "Application Type": "Site Permit ",
         "Application Date": "8/20/10",
         "Status": "Withdrawn ",
         "Description": "Site Development Permit to allow a 1,871 square-foot office building expansion, facade improvements, and parking repaving on a 0.64 gross acre site in the DC downtown commercial zoning district",
         "Planner": "John Baty ",
         "DURATION": 1579,
         "Year": 2010
      },
      {
         "PERMITID": "H13-043",
         "APN": 25947068,
         "File Number": "H13-043",
         "Address": "565 LORRAINE AV SAN JOSE",
         "Project Name": "H13-043",
         "Application Type": "Site Permit ",
         "Application Date": "11/14/13",
         "Status": "Withdrawn ",
         "Description": "Site Development Permit to demolish an existing single-family building and construct a 30-unit multi-family attached residential building with 2,507 square feet of groundfloor commercial space on a 0.103 gross acre site",
         "Planner": "John Tu ",
         "DURATION": 978,
         "Year": 2013
      },
      {
         "PERMITID": "H14-024",
         "APN": 46720074,
         "File Number": "H14-024",
         "Address": "117 N 5TH ST SAN JOSE",
         "Project Name": "H14-024",
         "Application Type": "Site Permit ",
         "Application Date": " ",
         "Status": "Withdrawn ",
         "Description": "Site Development to allow a new 4-story, 24-apartment unit residence with ground parking in the RM Residential Zoning District on a 0.24 gross acre site",
         "Planner": "Leila Hakimizadeh ",
         "DURATION": 29,
         "Year": null
      },
      {
         "PERMITID": "H15-021",
         "APN": 47226070,
         "File Number": "H15-021",
         "Address": "605 S 2ND ST SAN JOSE",
         "Project Name": "H15-021",
         "Application Type": "Site Permit ",
         "Application Date": "5/11/15",
         "Status": "Withdrawn ",
         "Description": "Site Development Permit to allow the construction of a 88,138 square foot, 91 room, six-story hotel with ground level retail on a 0.298 gross acre site",
         "Planner": "Tracy Tam ",
         "DURATION": 1055,
         "Year": 2015
      },
      {
         "PERMITID": "H15-030",
         "APN": 25946040,
         "File Number": "H15-030",
         "Address": "201 DELMAS AV SAN JOSE",
         "Project Name": "H15-030 - Park/Delmas (201 Delmas)",
         "Application Type": "Site Permit ",
         "Application Date": "6/10/15 11:14",
         "Status": "Withdrawn ",
         "Description": "Site Development Permit to allow the demolition of an existing 3,700-square foot office building, the removal of six ordinance-sized trees, and the construction of a 4-and-5-story development with up to 117 residential units, one level of underground parking, and approximately 1,000 square feet of ground-floor commercial space on a 1.75 gross acre site",
         "Planner": "Tracy Tam ",
         "DURATION": 48,
         "Year": 2015
      },
      {
         "PERMITID": "H15-030",
         "APN": 25946044,
         "File Number": "H15-030",
         "Address": "201 DELMAS AV SAN JOSE",
         "Project Name": "H15-030 - Park/Delmas (201 Delmas)",
         "Application Type": "Site Permit ",
         "Application Date": "6/10/15 11:14",
         "Status": "Withdrawn ",
         "Description": "Site Development Permit to allow the demolition of an existing 3,700-square foot office building, the removal of six ordinance-sized trees, and the construction of a 4-and-5-story development with up to 117 residential units, one level of underground parking, and approximately 1,000 square feet of ground-floor commercial space on a 1.75 gross acre site",
         "Planner": "Tracy Tam ",
         "DURATION": 48,
         "Year": 2015
      },
      {
         "PERMITID": "H15-030",
         "APN": 25946045,
         "File Number": "H15-030",
         "Address": "201 DELMAS AV SAN JOSE",
         "Project Name": "H15-030 - Park/Delmas (201 Delmas)",
         "Application Type": "Site Permit ",
         "Application Date": "6/10/15 11:14",
         "Status": "Withdrawn ",
         "Description": "Site Development Permit to allow the demolition of an existing 3,700-square foot office building, the removal of six ordinance-sized trees, and the construction of a 4-and-5-story development with up to 117 residential units, one level of underground parking, and approximately 1,000 square feet of ground-floor commercial space on a 1.75 gross acre site",
         "Planner": "Tracy Tam ",
         "DURATION": 48,
         "Year": 2015
      },
      {
         "PERMITID": "H15-030",
         "APN": 25946056,
         "File Number": "H15-030",
         "Address": "201 DELMAS AV SAN JOSE",
         "Project Name": "H15-030 - Park/Delmas (201 Delmas)",
         "Application Type": "Site Permit ",
         "Application Date": "6/10/15 11:14",
         "Status": "Withdrawn ",
         "Description": "Site Development Permit to allow the demolition of an existing 3,700-square foot office building, the removal of six ordinance-sized trees, and the construction of a 4-and-5-story development with up to 117 residential units, one level of underground parking, and approximately 1,000 square feet of ground-floor commercial space on a 1.75 gross acre site",
         "Planner": "Tracy Tam ",
         "DURATION": 48,
         "Year": 2015
      },
      {
         "PERMITID": "H15-030",
         "APN": 25946057,
         "File Number": "H15-030",
         "Address": "201 DELMAS AV SAN JOSE",
         "Project Name": "H15-030 - Park/Delmas (201 Delmas)",
         "Application Type": "Site Permit ",
         "Application Date": "6/10/15 11:14",
         "Status": "Withdrawn ",
         "Description": "Site Development Permit to allow the demolition of an existing 3,700-square foot office building, the removal of six ordinance-sized trees, and the construction of a 4-and-5-story development with up to 117 residential units, one level of underground parking, and approximately 1,000 square feet of ground-floor commercial space on a 1.75 gross acre site",
         "Planner": "Tracy Tam ",
         "DURATION": 48,
         "Year": 2015
      },
      {
         "PERMITID": "H15-030",
         "APN": 25946058,
         "File Number": "H15-030",
         "Address": "201 DELMAS AV SAN JOSE",
         "Project Name": "H15-030 - Park/Delmas (201 Delmas)",
         "Application Type": "Site Permit ",
         "Application Date": "6/10/15 11:14",
         "Status": "Withdrawn ",
         "Description": "Site Development Permit to allow the demolition of an existing 3,700-square foot office building, the removal of six ordinance-sized trees, and the construction of a 4-and-5-story development with up to 117 residential units, one level of underground parking, and approximately 1,000 square feet of ground-floor commercial space on a 1.75 gross acre site",
         "Planner": "Tracy Tam ",
         "DURATION": 48,
         "Year": 2015
      },
      {
         "PERMITID": "H15-030",
         "APN": 25946090,
         "File Number": "H15-030",
         "Address": "201 DELMAS AV SAN JOSE",
         "Project Name": "H15-030 - Park/Delmas (201 Delmas)",
         "Application Type": "Site Permit ",
         "Application Date": "6/10/15 11:14",
         "Status": "Withdrawn ",
         "Description": "Site Development Permit to allow the demolition of an existing 3,700-square foot office building, the removal of six ordinance-sized trees, and the construction of a 4-and-5-story development with up to 117 residential units, one level of underground parking, and approximately 1,000 square feet of ground-floor commercial space on a 1.75 gross acre site",
         "Planner": "Tracy Tam ",
         "DURATION": 48,
         "Year": 2015
      },
      {
         "PERMITID": "H15-030",
         "APN": 25946109,
         "File Number": "H15-030",
         "Address": "201 DELMAS AV SAN JOSE",
         "Project Name": "H15-030 - Park/Delmas (201 Delmas)",
         "Application Type": "Site Permit ",
         "Application Date": "6/10/15 11:14",
         "Status": "Withdrawn ",
         "Description": "Site Development Permit to allow the demolition of an existing 3,700-square foot office building, the removal of six ordinance-sized trees, and the construction of a 4-and-5-story development with up to 117 residential units, one level of underground parking, and approximately 1,000 square feet of ground-floor commercial space on a 1.75 gross acre site",
         "Planner": "Tracy Tam ",
         "DURATION": 48,
         "Year": 2015
      },
      {
         "PERMITID": "H15-062",
         "APN": 46720087,
         "File Number": "H15-062",
         "Address": "39 N 5TH ST SAN JOSE",
         "Project Name": "H15-062 - MIRO",
         "Application Type": "Site Permit ",
         "Application Date": "12/22/15 11:46",
         "Status": "Withdrawn ",
         "Description": "Site Development Permit to allow the demolition of an approximately 5,574 square foot existing building, and the construction of two 28-story residential towers to include 298 residential units in the west tower and 312 residential units in the east tower with three levels of underground parking and four levels of above ground parking, to allow 6 commercial condominiums which includes approximately 14,381 square feet of ground floor commercial uses and up to 24,693 square feet of flex/office space, to allow up to 179 tandem parking spaces and to allow for the removal of nine trees, four of which are ordinance sized ranging from 59 to 78 inches in circumference on an approximately 1.4 gross acre site.",
         "Planner": "Tracy Tam ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "H16-002",
         "APN": 26420064,
         "File Number": "H16-002",
         "Address": "500 W SAN CARLOS ST SAN JOSE",
         "Project Name": "H16-002 - Josefa Plaza",
         "Application Type": "Site Permit ",
         "Application Date": "1/13/16 11:33",
         "Status": "Withdrawn ",
         "Description": "Site Development Permit to allow the demolition of a former car lot, and to construct a mixed-use project that includes 3,408 square feet of commercial space and 19 studio and one bedroom residential units on a 0.18 gross acre site.",
         "Planner": "Tracy Tam ",
         "DURATION": 785,
         "Year": 2016
      },
      {
         "PERMITID": "H16-033",
         "APN": 46722160,
         "File Number": "H16-033",
         "Address": "LAND ONLY SAN JOSE  ",
         "Project Name": "H16-033- Block 3 at 150 South Second Street",
         "Application Type": "Site Permit ",
         "Application Date": "9/13/16 10:32",
         "Status": "Withdrawn ",
         "Description": "Site Development Permit to allow the construction of a 24-story, mixed-use tower with ground floor retail (approx. 6,943 square feet) and 393 residential units on a 1.34 gross acre site",
         "Planner": "Leila Hakimizadeh ",
         "DURATION": 297,
         "Year": 2016
      },
      {
         "PERMITID": "H17-042",
         "APN": 46720019,
         "File Number": "H17-042",
         "Address": "100 N 4TH ST SAN JOSE",
         "Project Name": "H17-042 - 100 North 4th Street",
         "Application Type": "Site Permit ",
         "Application Date": "7/31/17 10:55",
         "Status": "Withdrawn ",
         "Description": "Site Development Permit to demo two (2) existing single family dwellings, remove six (6) trees and construct a mixed use residential and commercial building with 8,409 SF Commercial and 400 units of student housing in a 26 story building with one level of underground parking on a 0.91 gross acre site.",
         "Planner": "Rina Shah ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "H17-042",
         "APN": 46720020,
         "File Number": "H17-042",
         "Address": "100 N 4TH ST SAN JOSE",
         "Project Name": "H17-042 - 100 North 4th Street",
         "Application Type": "Site Permit ",
         "Application Date": "7/31/17 10:55",
         "Status": "Withdrawn ",
         "Description": "Site Development Permit to demo two (2) existing single family dwellings, remove six (6) trees and construct a mixed use residential and commercial building with 8,409 SF Commercial and 400 units of student housing in a 26 story building with one level of underground parking on a 0.91 gross acre site.",
         "Planner": "Rina Shah ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "H17-042",
         "APN": 46720021,
         "File Number": "H17-042",
         "Address": "100 N 4TH ST SAN JOSE",
         "Project Name": "H17-042 - 100 North 4th Street",
         "Application Type": "Site Permit ",
         "Application Date": "7/31/17 10:55",
         "Status": "Withdrawn ",
         "Description": "Site Development Permit to demo two (2) existing single family dwellings, remove six (6) trees and construct a mixed use residential and commercial building with 8,409 SF Commercial and 400 units of student housing in a 26 story building with one level of underground parking on a 0.91 gross acre site.",
         "Planner": "Rina Shah ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "H17-042",
         "APN": 46720022,
         "File Number": "H17-042",
         "Address": "100 N 4TH ST SAN JOSE",
         "Project Name": "H17-042 - 100 North 4th Street",
         "Application Type": "Site Permit ",
         "Application Date": "7/31/17 10:55",
         "Status": "Withdrawn ",
         "Description": "Site Development Permit to demo two (2) existing single family dwellings, remove six (6) trees and construct a mixed use residential and commercial building with 8,409 SF Commercial and 400 units of student housing in a 26 story building with one level of underground parking on a 0.91 gross acre site.",
         "Planner": "Rina Shah ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "H17-042",
         "APN": 46720040,
         "File Number": "H17-042",
         "Address": "100 N 4TH ST SAN JOSE",
         "Project Name": "H17-042 - 100 North 4th Street",
         "Application Type": "Site Permit ",
         "Application Date": "7/31/17 10:55",
         "Status": "Withdrawn ",
         "Description": "Site Development Permit to demo two (2) existing single family dwellings, remove six (6) trees and construct a mixed use residential and commercial building with 8,409 SF Commercial and 400 units of student housing in a 26 story building with one level of underground parking on a 0.91 gross acre site.",
         "Planner": "Rina Shah ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "H18-005",
         "APN": 25931071,
         "File Number": "H18-005",
         "Address": "255 W JULIAN ST SAN JOSE",
         "Project Name": "H18-005 Davidson Plaza Towers - See SP18-009",
         "Application Type": "Site Permit ",
         "Application Date": "1/31/18",
         "Status": "Withdrawn ",
         "Description": "Special Use Permit to demolish an existing 56,400 square foot office building and surface parking, allow 653 residential units in two 17-story buildings and 10,254 square feet of ground floor commercial space and a Vesting Tentative Map for residential and commercial condominiums on a 1.78-gross acre site in the DC Downtown Primary Commercial Zoning District.",
         "Planner": "Ruth Cueto ",
         "DURATION": 161,
         "Year": 2018
      },
      {
         "PERMITID": "H18-030",
         "APN": 47226002,
         "File Number": "H18-030",
         "Address": "40 E WILLIAM ST SAN JOSE",
         "Project Name": "H18-030 - Invicta Towers",
         "Application Type": "Site Permit ",
         "Application Date": "6/27/18 11:10",
         "Status": "Withdrawn ",
         "Description": "Site Development Permit to demolish existing buildings and construct a new 41,500 square foot mixed-use building with 3 towers (26 stories, 25 stories, and 24 stories) with a total of 667 residential units, performing art space and 4 levels of below grade parking on a 1.632-gross acre site",
         "Planner": "Ruth Cueto ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "H18-030",
         "APN": 47226007,
         "File Number": "H18-030",
         "Address": "40 E WILLIAM ST SAN JOSE",
         "Project Name": "H18-030 - Invicta Towers",
         "Application Type": "Site Permit ",
         "Application Date": "6/27/18 11:10",
         "Status": "Withdrawn ",
         "Description": "Site Development Permit to demolish existing buildings and construct a new 41,500 square foot mixed-use building with 3 towers (26 stories, 25 stories, and 24 stories) with a total of 667 residential units, performing art space and 4 levels of below grade parking on a 1.632-gross acre site",
         "Planner": "Ruth Cueto ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "H18-030",
         "APN": 47226034,
         "File Number": "H18-030",
         "Address": "40 E WILLIAM ST SAN JOSE",
         "Project Name": "H18-030 - Invicta Towers",
         "Application Type": "Site Permit ",
         "Application Date": "6/27/18 11:10",
         "Status": "Withdrawn ",
         "Description": "Site Development Permit to demolish existing buildings and construct a new 41,500 square foot mixed-use building with 3 towers (26 stories, 25 stories, and 24 stories) with a total of 667 residential units, performing art space and 4 levels of below grade parking on a 1.632-gross acre site",
         "Planner": "Ruth Cueto ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "H18-030",
         "APN": 47226085,
         "File Number": "H18-030",
         "Address": "40 E WILLIAM ST SAN JOSE",
         "Project Name": "H18-030 - Invicta Towers",
         "Application Type": "Site Permit ",
         "Application Date": "6/27/18 11:10",
         "Status": "Withdrawn ",
         "Description": "Site Development Permit to demolish existing buildings and construct a new 41,500 square foot mixed-use building with 3 towers (26 stories, 25 stories, and 24 stories) with a total of 667 residential units, performing art space and 4 levels of below grade parking on a 1.632-gross acre site",
         "Planner": "Ruth Cueto ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "H84-154",
         "APN": 47229095,
         "File Number": "H84-154",
         "Address": "515 S 10TH ST SAN JOSE",
         "Project Name": "H84-154",
         "Application Type": "Site Permit ",
         "Application Date": "5/15/84",
         "Status": "Withdrawn ",
         "Description": "FROM REST TO REST/OFC/RETAIL ",
         "Planner": "CPARADA ",
         "DURATION": 0,
         "Year": 1984
      },
      {
         "PERMITID": "H84-309",
         "APN": 46720041,
         "File Number": "H84-309",
         "Address": "115 N 4TH ST SAN JOSE",
         "Project Name": "H84-309",
         "Application Type": "Site Permit ",
         "Application Date": "11/9/84",
         "Status": "Withdrawn ",
         "Description": "OFFICES ",
         "Planner": "CPARADA ",
         "DURATION": 0,
         "Year": 1984
      },
      {
         "PERMITID": "H86-085",
         "APN": 46747040,
         "File Number": "H86-085",
         "Address": "430 S 2ND ST SAN JOSE",
         "Project Name": "H86-085",
         "Application Type": "Site Permit ",
         "Application Date": "5/7/86",
         "Status": "Withdrawn ",
         "Description": "ADD. TO RETAIL BLDG.; Other APNs:041",
         "Planner": "Jerry Yoshida ",
         "DURATION": 0,
         "Year": 1986
      },
      {
         "PERMITID": "H88-171",
         "APN": 26420008,
         "File Number": "H88-171",
         "Address": "358 ROYAL AV SAN JOSE",
         "Project Name": "H88-171",
         "Application Type": "Site Permit ",
         "Application Date": "10/19/88",
         "Status": "Withdrawn ",
         "Description": "NEW RETAIL BUILDING ",
         "Planner": "LCARRILL ",
         "DURATION": 0,
         "Year": 1988
      },
      {
         "PERMITID": "H90-045",
         "APN": 47217024,
         "File Number": "H90-045",
         "Address": "735 S 2ND ST SAN JOSE",
         "Project Name": "H90-045",
         "Application Type": "Site Permit ",
         "Application Date": "3/28/90",
         "Status": "Withdrawn ",
         "Description": "File type: *Other apns: *Gen.Use Class:*Existing Land Use:69*Specific Use:MOVE ON DUPLEX",
         "Planner": "LCARRILL ",
         "DURATION": 0,
         "Year": 1990
      },
      {
         "PERMITID": "H97-037",
         "APN": 47229059,
         "File Number": "H97-037",
         "Address": "568 S 11TH ST SAN JOSE",
         "Project Name": "H97-037",
         "Application Type": "Site Permit ",
         "Application Date": "5/15/97",
         "Status": "Withdrawn ",
         "Description": "To allow a 1,700 square foot duplex on 0.126 gross acres",
         "Planner": "Salifu Yakubu ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "RH99-012",
         "APN": 46722009,
         "File Number": "RH99-012",
         "Address": " ",
         "Project Name": "RH99-012, Letitia Building",
         "Application Type": "Site Permit ",
         "Application Date": "6/16/99",
         "Status": "Withdrawn ",
         "Description": "Allow site improvements to the historic Letita Building (remove trees, add basement extension, add wall at rear property line) ",
         "Planner": "Jason Burton ",
         "DURATION": 0,
         "Year": 1999
      }
   ],
   "Site Permit Amendment ": [
      {
         "PERMITID": "HA01-047-01",
         "APN": 46718076,
         "File Number": "HA01-047-01",
         "Address": "157 N 8TH ST SAN JOSE",
         "Project Name": "HA01-047-01 (Habitat for Humanity)",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/26/02",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow construction on Saturdays and Sundays 8:00 am - 4:00 pm, on a 0.16 gross acre site.",
         "Planner": "Dave Tymn ",
         "DURATION": 76,
         "Year": 2002
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763001,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763002,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763004,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763005,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763006,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763007,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763008,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763010,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763011,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763014,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763015,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763016,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763017,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763018,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763019,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763020,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763024,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763025,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763026,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763027,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763028,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763029,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763030,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763032,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763033,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763034,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763036,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763037,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763038,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763039,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763040,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763041,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763042,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763043,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763047,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763049,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763050,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763051,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763052,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763053,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763054,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763055,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763056,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763057,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763058,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763059,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763060,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763061,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763063,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763064,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763067,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763068,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763070,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763071,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763072,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763074,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763075,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763076,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA03-002-01",
         "APN": 46763077,
         "File Number": "HA03-002-01",
         "Address": "25 S 3RD ST SAN JOSE",
         "Project Name": "HA03-002-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "2/8/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to (1) increase the number of multiple dwelling units from 74 to 76, (2) increase the amount of commercial space from 17,000 to 18,000 square feet, (3) increase the number of parking spaces from 172 to 176, and (4) allow associated exterior modifications on a 1.05 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 111,
         "Year": 2006
      },
      {
         "PERMITID": "HA04-038-01",
         "APN": 46764005,
         "File Number": "HA04-038-01",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "7/18/05",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow (1) a reduction in building height from 305 to 240 feet, (2) an increase in the number of residential units from 335 to 401 units, (3) a change in the access to the below grade public parking from S. 2nd Street to the new Central Place Street, and (4) associated elevation changes on a 2.99 gross acre site in the DC Downtown Primary Commercial Zoning District",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2005
      },
      {
         "PERMITID": "HA04-038-01",
         "APN": 46764010,
         "File Number": "HA04-038-01",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "7/18/05",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow (1) a reduction in building height from 305 to 240 feet, (2) an increase in the number of residential units from 335 to 401 units, (3) a change in the access to the below grade public parking from S. 2nd Street to the new Central Place Street, and (4) associated elevation changes on a 2.99 gross acre site in the DC Downtown Primary Commercial Zoning District",
         "Planner": "Lesley Xavier ",
         "DURATION": 0,
         "Year": 2005
      },
      {
         "PERMITID": "HA04-038-02",
         "APN": 46764005,
         "File Number": "HA04-038-02",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/24/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow after-hours and weekend construction on a 2.99 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 93,
         "Year": 2006
      },
      {
         "PERMITID": "HA04-038-02",
         "APN": 46764010,
         "File Number": "HA04-038-02",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/24/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow after-hours and weekend construction on a 2.99 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 93,
         "Year": 2006
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764001,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764002,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764005,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764008,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764010,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764019,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764020,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764021,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764022,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764024,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764025,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764026,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764027,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764028,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764029,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764030,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764031,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764032,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764033,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764036,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764037,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764039,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764040,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764042,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764043,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764045,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764046,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764047,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764049,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764050,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764051,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764052,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764053,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764054,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764055,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764057,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764058,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764060,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764061,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764062,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764063,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764065,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764066,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764068,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764070,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764071,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764072,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764073,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764075,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764078,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764079,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764080,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764081,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764082,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764083,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764084,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764085,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764086,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764088,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764089,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764090,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764092,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764094,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764096,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764097,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764098,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764099,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764100,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764101,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764102,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764104,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764106,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764108,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764109,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764110,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764111,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764113,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764114,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764115,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764116,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764117,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764118,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764119,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764120,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764121,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764123,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764124,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764125,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764126,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764127,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764128,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764129,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764130,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764131,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764132,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764133,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764134,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764135,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764136,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764137,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764138,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764139,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764140,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764141,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764142,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764143,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764144,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764145,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764146,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764147,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764148,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764149,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764152,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764153,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764154,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764155,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764156,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764157,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764158,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764159,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764160,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764161,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764162,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764163,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764164,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764165,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764167,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764168,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764169,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764170,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764171,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764173,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764174,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764175,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764176,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764178,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764179,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764180,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764181,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764182,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764184,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764185,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764186,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764187,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764188,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764189,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764190,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764191,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764192,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764193,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764194,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764195,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764196,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764197,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764198,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764199,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764201,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-03",
         "APN": 46764205,
         "File Number": "HA04-038-03",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "5/23/07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to modify the permit condition for construction hours (1) from 7:00 a.m. to 7:00 p.m. Monday through Friday, and 8:00 a.m. to 7:00 p.m. on Saturday for interior work, (2) to 7:00 a.m. to 9:00 p.m. Monday through Friday, and 8:00 a.m. to 9:00 p.m. on Saturday",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 175,
         "Year": 2007
      },
      {
         "PERMITID": "HA05-014-01",
         "APN": 25941057,
         "File Number": "HA05-014-01",
         "Address": "104 PARK CENTER PLAZA SAN JOSE",
         "Project Name": "HA05-014-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "12/2/05",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to revise the previously approved architectural design, reduce the previously approved building addition from 3,506 square feet to 480 square feet, and modify the footprint of an existing building (#104) on a 6.9 gross acres site in the DC Downtown Primary Commercial Zoning District",
         "Planner": "Lee Butler ",
         "DURATION": 91,
         "Year": 2005
      },
      {
         "PERMITID": "HA05-014-01",
         "APN": 25941067,
         "File Number": "HA05-014-01",
         "Address": "104 PARK CENTER PLAZA SAN JOSE",
         "Project Name": "HA05-014-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "12/2/05",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to revise the previously approved architectural design, reduce the previously approved building addition from 3,506 square feet to 480 square feet, and modify the footprint of an existing building (#104) on a 6.9 gross acres site in the DC Downtown Primary Commercial Zoning District",
         "Planner": "Lee Butler ",
         "DURATION": 91,
         "Year": 2005
      },
      {
         "PERMITID": "HA05-014-02",
         "APN": 25941057,
         "File Number": "HA05-014-02",
         "Address": "104 PARK CENTER PLAZA SAN JOSE",
         "Project Name": "HA05-014-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "6/22/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to renovate and expand an existing Building 104 by 430 square feet; renovate the existing podium slab and associated landscape planters; and remove Buildings 102, 106, 108, and 109 on a 6.9 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 190,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-014-02",
         "APN": 25941067,
         "File Number": "HA05-014-02",
         "Address": "104 PARK CENTER PLAZA SAN JOSE",
         "Project Name": "HA05-014-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "6/22/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to renovate and expand an existing Building 104 by 430 square feet; renovate the existing podium slab and associated landscape planters; and remove Buildings 102, 106, 108, and 109 on a 6.9 gross acres site",
         "Planner": "Lesley Xavier ",
         "DURATION": 190,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471001,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471006,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471007,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471009,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471010,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471011,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471013,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471014,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471017,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471018,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471019,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471020,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471021,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471022,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471023,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471025,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471026,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471028,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471029,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471030,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471031,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471034,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471035,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471036,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471037,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471038,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471039,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471040,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471041,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471042,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471043,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471044,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471045,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471046,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471047,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471049,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471050,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471051,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471052,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471053,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471054,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471055,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471056,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471057,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471059,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471060,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471061,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471062,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471063,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471064,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471065,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471066,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471068,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471069,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471070,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471071,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471072,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471073,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471074,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471075,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471077,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471078,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471080,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471082,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471083,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471084,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471085,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471086,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471087,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471088,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471089,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471091,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471092,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471093,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471094,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471095,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471096,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471097,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471100,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471102,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471103,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471104,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471105,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471106,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471107,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471108,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471109,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471110,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471111,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471112,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471113,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471114,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471115,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471116,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471117,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471118,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471119,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471121,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471122,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471123,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471124,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471125,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471127,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471128,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471130,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471131,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471132,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471133,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471134,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471135,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471136,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471137,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471138,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471140,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471141,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471142,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471143,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471144,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471145,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471146,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471147,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471148,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471149,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471150,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471151,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471152,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471153,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471154,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471155,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471156,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471157,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471158,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471159,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471160,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471161,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471162,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471163,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471164,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471165,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471166,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471167,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471168,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471169,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471171,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471172,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471173,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471174,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471175,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471177,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471178,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471179,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471182,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471184,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471185,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471186,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471187,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471188,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471189,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471191,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471192,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471193,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471195,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471196,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471197,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471198,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471199,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471200,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471201,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471202,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471203,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471204,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471205,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471207,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471208,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471209,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471210,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471211,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471212,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471213,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471214,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471215,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471216,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471217,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-037-01",
         "APN": 26471218,
         "File Number": "HA05-037-01",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/27/06",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to a previously approved Site Development Permit File No. H05-037 to (1) increase the number of residential condominium units 203 to 213; (2) decrease the square footage of retail space from 11,570 to 11,223 square feet; and (3) reduce the number of parking spaces from 274 to 242; (4) increase the number of floors from 23 to 24; and (5) increase total building height from 267 feet to 269.6 feet on a 1.02 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 92,
         "Year": 2006
      },
      {
         "PERMITID": "HA05-051-01",
         "APN": 25939115,
         "File Number": "HA05-051-01",
         "Address": "99 ALMADEN BL SAN JOSE",
         "Project Name": "HA05-051-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "7/1/16",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow the installation of a drive aisle and eight (8) loading spaces for customer drop-off and pick up; and improvement of two outdoor amenity spaces which includes the construction of shade structures, hardscape furniture, outdoor amenities, and landscaping",
         "Planner": "Darryl Boyd ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "HA12-022-01",
         "APN": 25940093,
         "File Number": "HA12-022-01",
         "Address": "1 S MARKET ST SAN JOSE",
         "Project Name": "HA12-022-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "3/6/14",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to revise conditions to the previously approved permit, H12-022, to extend construction hours to include Saturdays from 9 a.m. to 6 p.m. on .97 gross acre site",
         "Planner": "Kristinae Toomians ",
         "DURATION": 34,
         "Year": 2014
      },
      {
         "PERMITID": "HA13-013-01",
         "APN": 25939111,
         "File Number": "HA13-013-01",
         "Address": "350 W SANTA CLARA ST SAN JOSE",
         "Project Name": "HA13-013-01 AC Hotel",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "12/6/13",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow modifications to the previously approved 197-room, eight story hotel including allowing up to 210 rooms within the previously approved building envelope, reducing the height to seven stories, architectural modifications, and the removal of two street trees on an approximately 0.54 gross acre site",
         "Planner": "Kristinae Toomians ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "HA14-009-01",
         "APN": 46701118,
         "File Number": "HA14-009-01",
         "Address": "10367 TRACT SAN JOSE",
         "Project Name": "HA14-009-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/18/16",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to amend conditions of approval for permit H14-009",
         "Planner": "Emily Lipoma ",
         "DURATION": 21,
         "Year": 2016
      },
      {
         "PERMITID": "HA14-009-02",
         "APN": 46701118,
         "File Number": "HA14-009-02",
         "Address": "252 N 1ST ST SAN JOSE",
         "Project Name": "HA14-009-02 - Parkview Towers",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "6/5/18",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow one 19-story high rise tower with 154 units, one 12-story high rise tower with 62 units, 5 townhouses, up to 18,000 square feet of commercial, and rehabilitation of a vacant church through Historic Preservation Permit with all amenities and below grade parking and Saturday construction hours from 8:00 a.m. to 5:00 p.m. and up to six occurrences of 24-hour construction staging and concrete pouring on a 1.52 gross acre site",
         "Planner": "Emily Lipoma ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "HA14-023-01",
         "APN": 25940087,
         "File Number": "HA14-023-01",
         "Address": "171 POST ST SAN JOSE",
         "Project Name": "HA14-023-01 Post/San Pedro Tower",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "7/21/15 11:07",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow a 21-story high rise building with 202 residential units with approximately 10,900 square feet of commercial uses, and a four-story parking garage connected to the adjacent existing garage in the DC zoning district on a 0.47 gross acre site",
         "Planner": "Emily Lipoma ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "HA16-036-02",
         "APN": 46746110,
         "File Number": "HA16-036-02",
         "Address": "330 S 2ND ST SAN JOSE",
         "Project Name": "HA16-036-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/14/17",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to revise conditions to the previously approved permit, H16-036, to extend construction hours to include Saturdays from 8:00 A.M. to 6:00 P.M. on 1.45 gross acre site.",
         "Planner": "Emily Lipoma ",
         "DURATION": 208,
         "Year": 2017
      },
      {
         "PERMITID": "HA83-200-01",
         "APN": 25940091,
         "File Number": "HA83-200-01",
         "Address": "55 S MARKET ST SAN JOSE",
         "Project Name": "HA83-200-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "7/11/11",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to enclose 4,500 square feet of existing ground-floor plaza and add 1,500 square feet to existing second floor for new office space at an existing 15-story office building.",
         "Planner": "Emily Lipoma ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "HA83-200-02",
         "APN": 25940091,
         "File Number": "HA83-200-02",
         "Address": "55 S MARKET ST SAN JOSE",
         "Project Name": "HA83-200-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "12/9/11",
         "Status": "Approved ",
         "Description": "Site Development Amendment to expand construction hours to 24 hours/7 days a week.",
         "Planner": "Jenny Nusbaum ",
         "DURATION": 679,
         "Year": 2011
      },
      {
         "PERMITID": "HA85-087-04",
         "APN": 46722004,
         "File Number": "HA85-087-04",
         "Address": "36 S 1ST ST SAN JOSE",
         "Project Name": "HA85-087-04",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "9/1/88",
         "Status": "Approved ",
         "Description": "REHAB. OF 3 STORY HIST. BLDG. DIRECTOR'S HEARING 28TH SEPT.",
         "Planner": "MWHITNEY ",
         "DURATION": 0,
         "Year": 1988
      },
      {
         "PERMITID": "HA86-127-07",
         "APN": 46746072,
         "File Number": "HA86-127-07",
         "Address": "90 E SAN CARLOS ST SAN JOSE",
         "Project Name": "HA86-127-07",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "3/30/87",
         "Status": "Approved ",
         "Description": "UNDERGROUND.UTIL. ",
         "Planner": "LCARRILL ",
         "DURATION": 0,
         "Year": 1987
      },
      {
         "PERMITID": "HA87-052-02",
         "APN": 25934034,
         "File Number": "HA87-052-02",
         "Address": "0 (LAND ONLY.) SAN JOSE",
         "Project Name": "HA87-052-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "8/12/15 17:08",
         "Status": "Approved ",
         "Description": "Site Development Permit Amendment to allow for the removal of five (5) ordinance sized trees (Palm trees approximately 56 to 62 inches in circumference) and modify landscape and hardscape in the common space area, on a 1.7 gross acre site in the Downtown Core Zoning District.",
         "Planner": "John Tu ",
         "DURATION": 69,
         "Year": 2015
      },
      {
         "PERMITID": "HA87-052-03",
         "APN": 25934034,
         "File Number": "HA87-052-03",
         "Address": "111 N MARKET ST Bldg 1 SAN JOSE",
         "Project Name": "HA87-052-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "3/21/17",
         "Status": "Approved ",
         "Description": "Site Development Amendment to allow exterior façade renovations and modifications to landscape and hardscape in the common space area on a 1.65 gross acre site",
         "Planner": "John Tu ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "HA87-052-03",
         "APN": 25934053,
         "File Number": "HA87-052-03",
         "Address": "111 N MARKET ST Bldg 1 SAN JOSE",
         "Project Name": "HA87-052-03",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "3/21/17",
         "Status": "Approved ",
         "Description": "Site Development Amendment to allow exterior façade renovations and modifications to landscape and hardscape in the common space area on a 1.65 gross acre site",
         "Planner": "John Tu ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471001,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471006,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471007,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471009,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471010,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471011,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471013,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471014,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471017,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471018,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471019,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471020,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471021,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471022,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471023,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471025,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471026,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471028,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471029,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471030,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471031,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471034,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471035,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471036,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471037,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471038,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471039,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471040,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471041,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471042,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471043,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471044,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471045,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471046,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471047,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471049,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471050,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471051,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471052,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471053,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471054,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471055,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471056,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471057,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471059,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471060,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471061,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471062,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471063,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471064,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471065,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471066,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471068,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471069,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471070,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471071,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471072,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471073,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471074,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471075,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471077,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471078,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471080,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471082,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471083,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471084,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471085,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471086,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471087,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471088,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471089,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471091,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471092,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471093,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471094,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471095,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471096,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471097,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471100,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471102,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471103,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471104,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471105,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471106,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471107,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471108,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471109,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471110,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471111,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471112,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471113,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471114,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471115,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471116,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471117,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471118,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471119,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471121,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471122,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471123,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471124,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471125,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471127,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471128,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471130,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471131,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471132,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471133,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471134,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471135,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471136,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471137,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471138,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471140,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471141,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471142,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471143,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471144,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471145,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471146,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471147,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471148,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471149,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471150,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471151,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471152,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471153,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471154,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471155,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471156,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471157,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471158,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471159,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471160,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471161,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471162,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471163,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471164,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471165,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471166,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471167,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471168,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471169,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471171,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471172,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471173,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471174,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471175,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471177,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471178,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471179,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471182,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471184,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471185,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471186,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471187,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471188,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471189,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471191,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471192,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471193,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471195,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471196,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471197,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471198,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471199,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471200,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471201,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471202,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471203,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471204,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471205,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471207,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471208,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471209,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471210,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471211,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471212,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471213,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471214,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471215,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471216,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471217,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA05-037-02",
         "APN": 26471218,
         "File Number": "HA05-037-02",
         "Address": "360 S MARKET ST SAN JOSE",
         "Project Name": "HA05-037-02",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "4/9/08",
         "Status": "Approved with Conditions ",
         "Description": "Site Development Permit Amendment to extend construction hours to 9:00 PM",
         "Planner": "Darryl Boyd ",
         "DURATION": 351,
         "Year": 2008
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764001,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764002,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764005,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764008,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764010,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764019,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764020,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764021,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764022,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764024,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764025,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764026,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764027,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764028,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764029,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764030,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764031,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764032,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764033,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764036,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764037,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764039,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764040,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764042,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764043,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764045,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764046,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764047,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764049,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764050,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764051,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764052,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764053,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764054,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764055,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764057,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764058,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764060,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764061,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764062,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764063,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764065,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764066,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764068,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764070,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764071,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764072,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764073,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764075,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764078,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764079,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764080,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764081,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764082,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764083,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764084,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764085,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764086,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764088,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764089,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764090,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764092,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764094,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764096,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764097,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764098,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764099,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764100,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764101,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764102,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764104,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764106,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764108,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764109,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764110,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764111,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764113,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764114,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764115,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764116,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764117,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764118,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764119,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764120,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764121,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764123,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764124,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764125,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764126,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764127,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764128,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764129,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764130,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764131,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764132,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764133,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764134,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764135,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764136,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764137,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764138,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764139,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764140,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764141,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764142,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764143,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764144,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764145,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764146,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764147,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764148,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764149,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764152,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764153,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764154,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764155,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764156,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764157,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764158,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764159,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764160,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764161,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764162,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764163,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764164,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764165,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764167,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764168,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764169,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764170,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764171,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764173,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764174,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764175,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764176,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764178,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764179,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764180,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764181,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764182,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764184,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764185,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764186,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764187,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764188,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764189,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764190,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764191,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764192,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764193,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764194,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764195,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764196,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764197,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764198,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764199,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764201,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA04-038-04",
         "APN": 46764205,
         "File Number": "HA04-038-04",
         "Address": "88 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "HA04-038-04 Central Place Phase II",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "11/21/07",
         "Status": "Withdrawn ",
         "Description": "Site Development Amendment to modify the design of the Central Place Phase II tower containing (1) 204 multiple dwelling units in a 23-story residential tower, (2) 27,000 square feet of retail commercial, and (3) 312 residential parking spaces in an integrated podium parking structure on a 1.66 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2157,
         "Year": 2007
      },
      {
         "PERMITID": "HA05-014-04",
         "APN": 25941057,
         "File Number": "HA05-014-04",
         "Address": "125 S MARKET ST SAN JOSE",
         "Project Name": "HA05-014-04",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "7/8/15 11:10",
         "Status": "Withdrawn ",
         "Description": "Site Development Permit Amendment to modify a portion of a roof to a 1,908-square foot outdoor patio, as incidental to an existing office building, on a 0.89-gross acre site",
         "Planner": "Lea Simvoulakis ",
         "DURATION": 40,
         "Year": 2015
      },
      {
         "PERMITID": "HA14-004-01",
         "APN": 25932079,
         "File Number": "HA14-004-01",
         "Address": "0 TERRAINE ST SAN JOSE",
         "Project Name": "HA14-004-01",
         "Application Type": "Site Permit Amendment ",
         "Application Date": "6/27/17 15:06",
         "Status": "Withdrawn ",
         "Description": "Site Development Permit Amendment to allow optional reduced garage parking in-lieu of additional living space on a 0.29 gross acre site.",
         "Planner": "Lea Simvoulakis ",
         "DURATION": 191,
         "Year": 2017
      }
   ],
   "Special Use Permit ": [
      {
         "PERMITID": "SP18-016",
         "APN": 25940043,
         "File Number": "SP18-016",
         "Address": "27 S 1ST ST SAN JOSE",
         "Project Name": "SP18-016_ 27 WEST",
         "Application Type": "Special Use Permit ",
         "Application Date": "3/29/18",
         "Status": "Appealed ",
         "Description": "Special Use Permit to allow the demolition of an existing commercial building and the construction of a 22-story, 242 foot-tall mixed-use building consisting of 374 residential units and approximately 35,712 square feet of retail space, with an alternative parking arrangement (parking stackers) and reduce parking on a 0.57-gross acre site in the DC Downtown Core Zoning District.",
         "Planner": "Ruth Cueto ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "RSP01-005",
         "APN": 47226091,
         "File Number": "RSP01-005",
         "Address": " ",
         "Project Name": "RSP01-005, Notre Dame High School",
         "Application Type": "Special Use Permit ",
         "Application Date": "5/16/01",
         "Status": "Approved ",
         "Description": "Special Use Permit to demolish O'Connor Mansion (596 S 2nd St) and a single family dwelling (533 S 3rd St) to allow construction of a 34,000 sq ft classroom building",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "RSP01-006",
         "APN": 25940091,
         "File Number": "RSP01-006",
         "Address": " ",
         "Project Name": "RSP01-006, Market-Post Tower - Diesel Generator",
         "Application Type": "Special Use Permit ",
         "Application Date": "8/22/01",
         "Status": "Approved ",
         "Description": "Installation of a 500KW, 755-hp standby diesel generator in the below grade parking garage.",
         "Planner": "Alex Andrade ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "RSP01-008",
         "APN": 25940045,
         "File Number": "RSP01-008",
         "Address": " ",
         "Project Name": "RSP01-008, Hip Pop Live/Work",
         "Application Type": "Special Use Permit ",
         "Application Date": "10/25/01",
         "Status": "Approved ",
         "Description": "Allow one live/work unito n the second floor of an existing two-story commercial building. ",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "RSP01-009",
         "APN": 25932043,
         "File Number": "RSP01-009",
         "Address": " ",
         "Project Name": "RSP01-009, Brandenburg Demo #2",
         "Application Type": "Special Use Permit ",
         "Application Date": "10/31/01",
         "Status": "Approved ",
         "Description": "Demolition of one (1) vacant building",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2001
      },
      {
         "PERMITID": "RSP02-005",
         "APN": 47226027,
         "File Number": "RSP02-005",
         "Address": " ",
         "Project Name": "RSP02-005, Delia's Furniture",
         "Application Type": "Special Use Permit ",
         "Application Date": "11/19/02",
         "Status": "Approved ",
         "Description": "Construct 6,465 sq. ft. of new floor area within the existing shell of a 7,625 sq. ft. building.",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2002
      },
      {
         "PERMITID": "RSP03-001",
         "APN": 25941070,
         "File Number": "RSP03-001",
         "Address": " ",
         "Project Name": "RSP03-001, Real Energy Incorporated",
         "Application Type": "Special Use Permit ",
         "Application Date": "2/18/03",
         "Status": "Approved ",
         "Description": "Allow location of 200 Kw co-generation units (four natural gas fired reciprocating engines and associated equipment) at an existing buildings underground garage.",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "RSP03-002",
         "APN": 25940091,
         "File Number": "RSP03-002",
         "Address": " ",
         "Project Name": "RSP03-002, Market-Post Tower",
         "Application Type": "Special Use Permit ",
         "Application Date": "9/18/02",
         "Status": "Approved ",
         "Description": "Allow two standby/back-up generators in the ground floor of an existing commercial building. ",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2002
      },
      {
         "PERMITID": "RSP03-003",
         "APN": 25942079,
         "File Number": "RSP03-003",
         "Address": " ",
         "Project Name": "RSP03-003, Montgomery Hotel",
         "Application Type": "Special Use Permit ",
         "Application Date": "4/7/03",
         "Status": "Approved ",
         "Description": "Installation of a standby/back-up power generator on the roof. ",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "SP01-070",
         "APN": 47225075,
         "File Number": "SP01-070",
         "Address": "675 S 6TH ST SAN JOSE",
         "Project Name": "SP01-070",
         "Application Type": "Special Use Permit ",
         "Application Date": "12/18/01",
         "Status": "Approved ",
         "Description": "Special Use Permit to allow a 130 square foot addition to an existing residential unit over a garage to a legal non-conforming single-family residence on a 0.11 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 27,
         "Year": 2001
      },
      {
         "PERMITID": "SP03-042",
         "APN": 25945077,
         "File Number": "SP03-042",
         "Address": "432 LAKEHOUSE AV SAN JOSE",
         "Project Name": "SP03-042",
         "Application Type": "Special Use Permit ",
         "Application Date": "10/17/03",
         "Status": "Approved ",
         "Description": "Special Use Permit to legalize an unpermitted 188 square foot second story porch enclosure to an existing legal non-conforming fourplex on a 0.16 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 144,
         "Year": 2003
      },
      {
         "PERMITID": "SP04-004",
         "APN": 24946061,
         "File Number": "SP04-004",
         "Address": "153 E JULIAN ST SAN JOSE",
         "Project Name": "SP04-004",
         "Application Type": "Special Use Permit ",
         "Application Date": "1/21/04",
         "Status": "Approved ",
         "Description": "Special Use Permit to allow the addition of 1,123 square feet of office space to an existing office in a residential building, and a reduction in the required parking from 4 parking spaces to 3 parking spaces on a 0.09 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 221,
         "Year": 2004
      },
      {
         "PERMITID": "SP04-018",
         "APN": 26420042,
         "File Number": "SP04-018",
         "Address": "517 AUZERAIS AV SAN JOSE",
         "Project Name": "SP04-018",
         "Application Type": "Special Use Permit ",
         "Application Date": "3/29/04",
         "Status": "Approved ",
         "Description": "Special Use Permit to allow restoration of a legal non-conforming single-family detached residence on a 0.11 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 225,
         "Year": 2004
      },
      {
         "PERMITID": "SP04-022",
         "APN": 24946049,
         "File Number": "SP04-022",
         "Address": "359 N 5TH ST SAN JOSE",
         "Project Name": "SP04-022",
         "Application Type": "Special Use Permit ",
         "Application Date": "4/14/04",
         "Status": "Approved ",
         "Description": "Special Use Permit to replace a 260-square-foot detached one-car garage with a 316- square-foot detached one-car garage and storage for an existing single-family detached residence in the Hensley Historic District on a 0.11 gross acre site",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 111,
         "Year": 2004
      },
      {
         "PERMITID": "SP04-040",
         "APN": 46745025,
         "File Number": "SP04-040",
         "Address": "140 E SAN CARLOS ST SAN JOSE",
         "Project Name": "SP04-040, La Victoria Taqueria E San Carlos Midnight hours",
         "Application Type": "Special Use Permit ",
         "Application Date": "7/23/04",
         "Status": "Approved ",
         "Description": "Special Use Permit to amend a land use permit for an existing restaurant without alcohol in the DC Downtown Primary Commercial zoning district to extend its hours of operation from 2:00 a. m. to 4:00 a.m. seven days per week on a 0.04 gross acre site",
         "Planner": "MNAGARAJ ",
         "DURATION": 99,
         "Year": 2004
      },
      {
         "PERMITID": "SP04-063",
         "APN": 46723039,
         "File Number": "SP04-063",
         "Address": "118 E SANTA CLARA ST SAN JOSE",
         "Project Name": "SP04-063",
         "Application Type": "Special Use Permit ",
         "Application Date": "11/2/04",
         "Status": "Approved ",
         "Description": "(FILE CHANGED FROM CP04-088) Special Use Permit to add check cashing service to an existing financial service business (check cashing).",
         "Planner": "Lesley Xavier ",
         "DURATION": 105,
         "Year": 2004
      },
      {
         "PERMITID": "SP05-008",
         "APN": 46701060,
         "File Number": "SP05-008",
         "Address": "205 N 5TH ST SAN JOSE",
         "Project Name": "SP05-008",
         "Application Type": "Special Use Permit ",
         "Application Date": "3/14/05",
         "Status": "Approved ",
         "Description": "Special Use Permit to raise an existing legal non-conforming single-family residence by one foot and convert basement into living space on a 0.06 gross acre site.",
         "Planner": "Lee Butler ",
         "DURATION": 238,
         "Year": 2005
      },
      {
         "PERMITID": "SP05-027",
         "APN": 46719038,
         "File Number": "SP05-027",
         "Address": "229 E ST JOHN ST SAN JOSE",
         "Project Name": "SP05-027",
         "Application Type": "Special Use Permit ",
         "Application Date": "6/27/05",
         "Status": "Approved ",
         "Description": "Special Use Permit to construct a 915 square foot addition to the rear of a legal non-conforming single-family detached residence and remodel of an existing detached garage on a 0.14 gross acre site.",
         "Planner": "Avril Baty ",
         "DURATION": 989,
         "Year": 2005
      },
      {
         "PERMITID": "SP05-033",
         "APN": 25940061,
         "File Number": "SP05-033",
         "Address": "71 S 1ST ST SAN JOSE",
         "Project Name": "SP05-033",
         "Application Type": "Special Use Permit ",
         "Application Date": "7/12/05",
         "Status": "Approved ",
         "Description": "Special Use Permit for demolition of one commercial building (John Stock and Sons/Monomania) and Construction of a fence on a 0.21 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 286,
         "Year": 2005
      },
      {
         "PERMITID": "SP06-004",
         "APN": 46745030,
         "File Number": "SP06-004",
         "Address": "330 S 3RD ST SAN JOSE",
         "Project Name": "SP06-004",
         "Application Type": "Special Use Permit ",
         "Application Date": "1/18/06",
         "Status": "Approved ",
         "Description": "Special Use Permit to allow late night use until 3:00 a.m. for an existing restaurant on a 0.12 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 125,
         "Year": 2006
      },
      {
         "PERMITID": "SP06-038",
         "APN": 47217040,
         "File Number": "SP06-038",
         "Address": "891 S 2ND ST SAN JOSE",
         "Project Name": "SP06-038",
         "Application Type": "Special Use Permit ",
         "Application Date": "5/19/06",
         "Status": "Approved ",
         "Description": "Special Use Permit to allow an existing accessory structure containing 381 square feet for a legal non-conforming single-family residence on a 0.09 gross acre site in the CN Commercial Neighborhood Zoning District",
         "Planner": "Lesley Xavier ",
         "DURATION": 229,
         "Year": 2006
      },
      {
         "PERMITID": "SP06-056",
         "APN": 46745025,
         "File Number": "SP06-056",
         "Address": "140 E SAN CARLOS ST SAN JOSE",
         "Project Name": "SP06-056",
         "Application Type": "Special Use Permit ",
         "Application Date": "7/14/06",
         "Status": "Approved ",
         "Description": "Special Use Permit for late night use until 3:00 a.m. daily at an existing restaurant on a 0.1 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 168,
         "Year": 2006
      },
      {
         "PERMITID": "SP07-001",
         "APN": 47217012,
         "File Number": "SP07-001",
         "Address": "760 S 1ST ST SAN JOSE",
         "Project Name": "SP07-001",
         "Application Type": "Special Use Permit ",
         "Application Date": "1/8/07",
         "Status": "Approved ",
         "Description": "Special Use Permit to demolish a portion of an existing commercial building for a surface parking lot, and rehabilitation of an adjoining building for retail commercial uses on a 0.20 gross acre site",
         "Planner": "Steven Rosen ",
         "DURATION": 494,
         "Year": 2007
      },
      {
         "PERMITID": "SP07-079",
         "APN": 25930088,
         "File Number": "SP07-079",
         "Address": "200 N ALMADEN BL SAN JOSE",
         "Project Name": "SP07-079",
         "Application Type": "Special Use Permit ",
         "Application Date": "11/14/07",
         "Status": "Approved ",
         "Description": "Special Use Permit to allow an off-site alternating parking arrangement at an existing office parking lot on a 0.43 gross acre site for evening, weekend, and holiday events HP Pavilion",
         "Planner": "Licinia McMorrow ",
         "DURATION": 320,
         "Year": 2007
      },
      {
         "PERMITID": "SP08-040",
         "APN": 46745026,
         "File Number": "SP08-040",
         "Address": "304 S 3RD ST SAN JOSE",
         "Project Name": "SP08-040 - Hoagie Steak Out",
         "Application Type": "Special Use Permit ",
         "Application Date": "8/5/08",
         "Status": "Approved ",
         "Description": "Special Use Permit for late night use to an existing restaurant on a 0.09 gross acre site",
         "Planner": "Ella Samonsky ",
         "DURATION": 154,
         "Year": 2008
      },
      {
         "PERMITID": "SP08-041",
         "APN": 46745069,
         "File Number": "SP08-041",
         "Address": "345 S 4TH ST SAN JOSE",
         "Project Name": "SP08-041",
         "Application Type": "Special Use Permit ",
         "Application Date": "7/28/08",
         "Status": "Approved ",
         "Description": "Special Use Permit for 24 hour use for an existing restaurant on a 0.29 gross acre site.",
         "Planner": "Ella Samonsky ",
         "DURATION": 165,
         "Year": 2008
      },
      {
         "PERMITID": "SP08-050",
         "APN": 24948012,
         "File Number": "SP08-050",
         "Address": "235 E JULIAN ST SAN JOSE",
         "Project Name": "SP08-050 Mi Pueblo Food Center",
         "Application Type": "Special Use Permit ",
         "Application Date": "9/9/08",
         "Status": "Approved ",
         "Description": "Special Use Permit to allow outdoor use within 150 feet of residentially zoned property, which is a barbeque trailer located at outside of the front entrance of an existing supermarket on a 1.62 gross acre site. No new construction is being proposed.",
         "Planner": "Mike Enderby ",
         "DURATION": 1864,
         "Year": 2008
      },
      {
         "PERMITID": "SP08-056",
         "APN": 25945052,
         "File Number": "SP08-056",
         "Address": "436 W SAN FERNANDO ST SAN JOSE",
         "Project Name": "SP08-056 Zanotto Garage",
         "Application Type": "Special Use Permit ",
         "Application Date": "10/14/08",
         "Status": "Approved ",
         "Description": "Special Use Permit to legalize a carport constructed without benefit of permits on a 0.21 gross acre site",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 279,
         "Year": 2008
      },
      {
         "PERMITID": "SP09-003",
         "APN": 46701023,
         "File Number": "SP09-003",
         "Address": "247 N 3RD ST SAN JOSE",
         "Project Name": "SP09-003",
         "Application Type": "Special Use Permit ",
         "Application Date": "1/8/09",
         "Status": "Approved ",
         "Description": "Special Use Permit to convert an existing residential building to office use, including an addition of 264 sq ft and replacement of a detached garage with surface parking on a 0.21 gross acre site.",
         "Planner": "Jodie Clark ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "SP09-006",
         "APN": 46723088,
         "File Number": "SP09-006",
         "Address": "10 S 3RD ST SAN JOSE",
         "Project Name": "SP09-006",
         "Application Type": "Special Use Permit ",
         "Application Date": "1/29/09",
         "Status": "Approved ",
         "Description": "Special Use Permit to allow 53 units for Single Room Occupancy (SRO) residential use in an existing commercial building on a 0.13 gross acre site (office space on 2nd, 3rd, 4th, and 5th floors of the building would be converted from office to SRO units)",
         "Planner": "Mike Enderby ",
         "DURATION": 189,
         "Year": 2009
      },
      {
         "PERMITID": "SP09-006",
         "APN": 46723089,
         "File Number": "SP09-006",
         "Address": "10 S 3RD ST SAN JOSE",
         "Project Name": "SP09-006",
         "Application Type": "Special Use Permit ",
         "Application Date": "1/29/09",
         "Status": "Approved ",
         "Description": "Special Use Permit to allow 53 units for Single Room Occupancy (SRO) residential use in an existing commercial building on a 0.13 gross acre site (office space on 2nd, 3rd, 4th, and 5th floors of the building would be converted from office to SRO units)",
         "Planner": "Mike Enderby ",
         "DURATION": 189,
         "Year": 2009
      },
      {
         "PERMITID": "SP09-010",
         "APN": 46718090,
         "File Number": "SP09-010",
         "Address": "301 E SANTA CLARA ST SAN JOSE",
         "Project Name": "SP09-010",
         "Application Type": "Special Use Permit ",
         "Application Date": "2/4/09",
         "Status": "Approved ",
         "Description": "Special Use Permit to allow one live and work unit on the 2nd floor of an existing commercial building and allow facade changes along North 7th Street on a 0.22 gross acre site",
         "Planner": "Mike Enderby ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "SP09-036",
         "APN": 46722110,
         "File Number": "SP09-036",
         "Address": "78 S 1ST ST SAN JOSE",
         "Project Name": "SP09-036, WOW NOODLES HOUSE",
         "Application Type": "Special Use Permit ",
         "Application Date": "6/17/09",
         "Status": "Approved ",
         "Description": "Special Use Permit for late night use to an existing restaurant on a 0.63 gross acre site.",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 1583,
         "Year": 2009
      },
      {
         "PERMITID": "SP09-046",
         "APN": 47231004,
         "File Number": "SP09-046",
         "Address": "545 S 16TH ST SAN JOSE",
         "Project Name": "SP09-046",
         "Application Type": "Special Use Permit ",
         "Application Date": "7/7/09",
         "Status": "Approved ",
         "Description": "Special Use Permit to allow demolition of a 90 s.f. accessory structure and allow construction of a 198 s.f. accessory structure attached to an existing garage on a 0.24 gross acre site",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 0,
         "Year": 2009
      },
      {
         "PERMITID": "SP10-004",
         "APN": 46722158,
         "File Number": "SP10-004",
         "Address": "30 E SANTA CLARA ST SAN JOSE",
         "Project Name": "SP10-004",
         "Application Type": "Special Use Permit ",
         "Application Date": "1/28/10",
         "Status": "Approved ",
         "Description": "Special Use Permit to allow late night operation of a tobacco retail establishment between the hours of 12:00 midnight and 3:00 a.m. within an existing building on a 0.22 gross acre site",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 286,
         "Year": 2010
      },
      {
         "PERMITID": "SP10-052",
         "APN": 25930094,
         "File Number": "SP10-052",
         "Address": "350 W JULIAN ST SAN JOSE",
         "Project Name": "SP10-052",
         "Application Type": "Special Use Permit ",
         "Application Date": "11/4/10",
         "Status": "Approved ",
         "Description": "Special Use Permit to allow the conversion of a commercial building to a single-family residence in the DC Downtown Core Zoning District on .63 gross acre site.",
         "Planner": "Lori Moniz ",
         "DURATION": 1079,
         "Year": 2010
      },
      {
         "PERMITID": "SP10-058",
         "APN": 46720079,
         "File Number": "SP10-058",
         "Address": "147 E SANTA CLARA ST SAN JOSE",
         "Project Name": "SP10-058",
         "Application Type": "Special Use Permit ",
         "Application Date": "12/16/10",
         "Status": "Approved ",
         "Description": "Special Use Permit to convert approximately 1,945 sq. ft. of an existing retail gas service station to a convenience store in the DC Downtown Primary Commercial Zoning District on an approximately .71 gross-acre site",
         "Planner": "Lori Moniz ",
         "DURATION": 0,
         "Year": 2010
      },
      {
         "PERMITID": "SP11-010",
         "APN": 46745028,
         "File Number": "SP11-010",
         "Address": "312 S 3RD ST SAN JOSE",
         "Project Name": "SP11-010",
         "Application Type": "Special Use Permit ",
         "Application Date": "3/8/11",
         "Status": "Approved ",
         "Description": "Special Use Permit to allow late night use for an existing restaurant in the DC Downtown Primary Commercial Zoning District on .14 gross-acre site",
         "Planner": "Jenny Nusbaum ",
         "DURATION": 316,
         "Year": 2011
      },
      {
         "PERMITID": "SP11-012",
         "APN": 46721024,
         "File Number": "SP11-012",
         "Address": "17 E SANTA CLARA ST SAN JOSE",
         "Project Name": "SP11-012",
         "Application Type": "Special Use Permit ",
         "Application Date": "3/8/11",
         "Status": "Approved ",
         "Description": "Special Use Permit to allow after-midnight use for an existing mini-mart in the DC Downtown Pirmary Commercial Zoning District on a .11 gross-acre site",
         "Planner": "Jenny Nusbaum ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "SP11-021",
         "APN": 25932005,
         "File Number": "SP11-021",
         "Address": "175 N SAN PEDRO ST SAN JOSE",
         "Project Name": "SP11-021 North San Pedro Street",
         "Application Type": "Special Use Permit ",
         "Application Date": "5/20/11",
         "Status": "Approved ",
         "Description": "Special Use Permit to allow the demolition of an existing approximately 8,550 square foot nightclub building and development it with approximately 31 parking spaces in conjuction with the re-striping of an existing surface parking lot, a new approximately 144 square foot new attendant booth, a bioretention area, a new three foot tall perimeter screen wall, and various improvements along San Pedro Street in the DC Downtown Commercial Zoning District on a 1.8 gross acre site.",
         "Planner": "Jenny Nusbaum ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "SP11-041",
         "APN": 26429065,
         "File Number": "SP11-041",
         "Address": "371 S 1ST ST SAN JOSE",
         "Project Name": "SP11-041 SOFA offices",
         "Application Type": "Special Use Permit ",
         "Application Date": "10/31/11",
         "Status": "Approved ",
         "Description": "Special Use Permit to convert 18 residential units on the third floor to approximately 8,500 square feet of office uses and add approximately 2,000 square feet to the second floor interior of an existing mixed-use building on a 0.22 gross acre site",
         "Planner": "Jenny Nusbaum ",
         "DURATION": 0,
         "Year": 2011
      },
      {
         "PERMITID": "SP12-017",
         "APN": 26426003,
         "File Number": "SP12-017",
         "Address": "319 DELMAS AV SAN JOSE",
         "Project Name": "SP12-017",
         "Application Type": "Special Use Permit ",
         "Application Date": "5/1/12",
         "Status": "Approved ",
         "Description": "Special Use Permit for the 850 feet square foot expansion of a legal nonconforming single family residence in the LI Light Industrial Zoning District on .11 gross acre site",
         "Planner": "Lori Moniz ",
         "DURATION": 203,
         "Year": 2012
      },
      {
         "PERMITID": "SP12-032",
         "APN": 46720023,
         "File Number": "SP12-032",
         "Address": "160 N 4TH ST SAN JOSE",
         "Project Name": "SP12-032",
         "Application Type": "Special Use Permit ",
         "Application Date": "11/8/12",
         "Status": "Approved ",
         "Description": "Special Use Permit for the reconstruction of legal nonconforming house (fire damaged) and addition in the CG Commercial General Zoning District on .1004 gross acre site",
         "Planner": "Aparna Ankola ",
         "DURATION": 88,
         "Year": 2012
      },
      {
         "PERMITID": "SP13-008",
         "APN": 46718102,
         "File Number": "SP13-008",
         "Address": "389 E SANTA CLARA ST SAN JOSE",
         "Project Name": "SP13-008",
         "Application Type": "Special Use Permit ",
         "Application Date": "2/15/13",
         "Status": "Approved ",
         "Description": "Special Use Permit to install 3 trailers and restroom facility trailer to temporarily replace meeting rooms/space damaged by fire within the sanctuary structure. The portable structures will be used as assembly/meeting space for classrooms, meeting space for local organizations/clubs, and church choirs.",
         "Planner": "Kristinae Toomians ",
         "DURATION": 266,
         "Year": 2013
      },
      {
         "PERMITID": "SP13-010",
         "APN": 26415015,
         "File Number": "SP13-010",
         "Address": "655 AUZERAIS AV SAN JOSE",
         "Project Name": "SP13-010",
         "Application Type": "Special Use Permit ",
         "Application Date": "2/20/13",
         "Status": "Approved ",
         "Description": "Special Use Permit to allow the demolition of an existing two-story vacant single-family residence on a 0.1 acre site",
         "Planner": "Kristinae Toomians ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "SP13-010",
         "APN": 26415017,
         "File Number": "SP13-010",
         "Address": "655 AUZERAIS AV SAN JOSE",
         "Project Name": "SP13-010",
         "Application Type": "Special Use Permit ",
         "Application Date": "2/20/13",
         "Status": "Approved ",
         "Description": "Special Use Permit to allow the demolition of an existing two-story vacant single-family residence on a 0.1 acre site",
         "Planner": "Kristinae Toomians ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "SP13-010",
         "APN": 26415018,
         "File Number": "SP13-010",
         "Address": "655 AUZERAIS AV SAN JOSE",
         "Project Name": "SP13-010",
         "Application Type": "Special Use Permit ",
         "Application Date": "2/20/13",
         "Status": "Approved ",
         "Description": "Special Use Permit to allow the demolition of an existing two-story vacant single-family residence on a 0.1 acre site",
         "Planner": "Kristinae Toomians ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "SP13-010",
         "APN": 26415019,
         "File Number": "SP13-010",
         "Address": "655 AUZERAIS AV SAN JOSE",
         "Project Name": "SP13-010",
         "Application Type": "Special Use Permit ",
         "Application Date": "2/20/13",
         "Status": "Approved ",
         "Description": "Special Use Permit to allow the demolition of an existing two-story vacant single-family residence on a 0.1 acre site",
         "Planner": "Kristinae Toomians ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "SP13-010",
         "APN": 26415065,
         "File Number": "SP13-010",
         "Address": "655 AUZERAIS AV SAN JOSE",
         "Project Name": "SP13-010",
         "Application Type": "Special Use Permit ",
         "Application Date": "2/20/13",
         "Status": "Approved ",
         "Description": "Special Use Permit to allow the demolition of an existing two-story vacant single-family residence on a 0.1 acre site",
         "Planner": "Kristinae Toomians ",
         "DURATION": 0,
         "Year": 2013
      },
      {
         "PERMITID": "SP13-041",
         "APN": 25940091,
         "File Number": "SP13-041",
         "Address": "55 S MARKET ST SAN JOSE",
         "Project Name": "SP13-041",
         "Application Type": "Special Use Permit ",
         "Application Date": "8/12/13",
         "Status": "Approved ",
         "Description": "Special Use Permit to allow the subdivision of an existing 15-story commercial building into 11 commercial condominium units on a 0.71 gross acre site",
         "Planner": "Kristinae Toomians ",
         "DURATION": 213,
         "Year": 2013
      },
      {
         "PERMITID": "SP13-066",
         "APN": 26426088,
         "File Number": "SP13-066",
         "Address": "425 AUZERAIS AV SAN JOSE",
         "Project Name": "SP13-066",
         "Application Type": "Special Use Permit ",
         "Application Date": "10/30/13",
         "Status": "Approved ",
         "Description": "Special Use Permit to allow a nonconforming use involving an industrial art workshop in a residential zone on a 0.1 gross acre site",
         "Planner": "Wayne Farrens ",
         "DURATION": 86,
         "Year": 2013
      },
      {
         "PERMITID": "SP14-033",
         "APN": 25942081,
         "File Number": "SP14-033",
         "Address": "240 S MARKET ST SAN JOSE",
         "Project Name": "SP14-033",
         "Application Type": "Special Use Permit ",
         "Application Date": "6/30/14 12:54",
         "Status": "Approved ",
         "Description": "Special Use Permit to allow two commercial condominium air spaces and one residential condominium air space (the remaining space) at an existing mixed use development ",
         "Planner": "Tania Jordanova ",
         "DURATION": 77,
         "Year": 2014
      },
      {
         "PERMITID": "SP14-033",
         "APN": 25942082,
         "File Number": "SP14-033",
         "Address": "240 S MARKET ST SAN JOSE",
         "Project Name": "SP14-033",
         "Application Type": "Special Use Permit ",
         "Application Date": "6/30/14 12:54",
         "Status": "Approved ",
         "Description": "Special Use Permit to allow two commercial condominium air spaces and one residential condominium air space (the remaining space) at an existing mixed use development ",
         "Planner": "Tania Jordanova ",
         "DURATION": 77,
         "Year": 2014
      },
      {
         "PERMITID": "SP15-004",
         "APN": 46718102,
         "File Number": "SP15-004",
         "Address": "389 E SANTA CLARA ST SAN JOSE",
         "Project Name": "SP15-004 Our Lady of La Vang",
         "Application Type": "Special Use Permit ",
         "Application Date": "1/16/15 11:10",
         "Status": "Approved ",
         "Description": "Special Use Permit to allow the demolition of a fire-damaged church, administration building (former rectory) and removal of six ordinance sized trees, and allow the construction of an approximately 20,000-square foot church/religious assembly building, two-story parking structure, an approximately 15,000-square foot multi-purpose building, expansion of an existing private school (St. Patrick School) without enrollment increase, an off-site parking arrangement for up to 75 spaces, and incidental uses including daycare, private instruction (night classes), caterer, church offices, and funeral services on a 2.7-gross acre site.",
         "Planner": "David Fong ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "SP15-004",
         "APN": 46718103,
         "File Number": "SP15-004",
         "Address": "389 E SANTA CLARA ST SAN JOSE",
         "Project Name": "SP15-004 Our Lady of La Vang",
         "Application Type": "Special Use Permit ",
         "Application Date": "1/16/15 11:10",
         "Status": "Approved ",
         "Description": "Special Use Permit to allow the demolition of a fire-damaged church, administration building (former rectory) and removal of six ordinance sized trees, and allow the construction of an approximately 20,000-square foot church/religious assembly building, two-story parking structure, an approximately 15,000-square foot multi-purpose building, expansion of an existing private school (St. Patrick School) without enrollment increase, an off-site parking arrangement for up to 75 spaces, and incidental uses including daycare, private instruction (night classes), caterer, church offices, and funeral services on a 2.7-gross acre site.",
         "Planner": "David Fong ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "SP15-009",
         "APN": 47217046,
         "File Number": "SP15-009",
         "Address": "872 S 2ND ST SAN JOSE",
         "Project Name": "SP15-009",
         "Application Type": "Special Use Permit ",
         "Application Date": "2/27/15 11:19",
         "Status": "Approved ",
         "Description": "Special Use Permit to allow construction of a 648-square foot detached garage for a legal non-conforming single-family residence located on a 0.11 gross acre site, in the CN Commercial Neighborhood Zoning District.",
         "Planner": "David Fong ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "SP15-051",
         "APN": 46746081,
         "File Number": "SP15-051",
         "Address": "300 S 1ST ST SAN JOSE",
         "Project Name": "SP15-051",
         "Application Type": "Special Use Permit ",
         "Application Date": "1/26/16",
         "Status": "Approved ",
         "Description": "Special Use Permit to allow for Outdoor Art and a Lighting Display (digital mural) to be projected onto an existing building-mounted screen and the installation of a pole, projector, and speakers in a parking lot (resulting in the removal of one parking space), on a 0.65-gross acre site",
         "Planner": "Jennifer Piozet ",
         "DURATION": 150,
         "Year": 2016
      },
      {
         "PERMITID": "SP15-052",
         "APN": 46746080,
         "File Number": "SP15-052",
         "Address": "345 S 2ND ST SAN JOSE",
         "Project Name": "SP15-052",
         "Application Type": "Special Use Permit ",
         "Application Date": "10/30/15",
         "Status": "Approved ",
         "Description": "Special Use Permit to allow the construction of two Art Display Structures, one approximately 24 feet wide and 8 feet tall (192 square feet) and one 20 feet wide and 8 feet tall (160 square feet), elevated 10 feet above grade, located on an existing parking lot, on a 3.0-gross acre site",
         "Planner": "Jennifer Piozet ",
         "DURATION": 0,
         "Year": 2015
      },
      {
         "PERMITID": "SP16-008",
         "APN": 25940034,
         "File Number": "SP16-008",
         "Address": "84 W SANTA CLARA ST SAN JOSE",
         "Project Name": "SP16-008",
         "Application Type": "Special Use Permit ",
         "Application Date": "1/22/16 11:09",
         "Status": "Approved ",
         "Description": "Special Use Permit to allow an allow an outdoor coffee cart with use of restroom, trash and recycling facilities from the existing commercial building and operation hours concurrent with building operation hours, on a 0.46 gross acre site",
         "Planner": "Tracy Tam ",
         "DURATION": 84,
         "Year": 2016
      },
      {
         "PERMITID": "SP16-010",
         "APN": 25946046,
         "File Number": "SP16-010",
         "Address": "267 DELMAS AV SAN JOSE",
         "Project Name": "SP16-010 267 Delmas Avenue (Filice) Project",
         "Application Type": "Special Use Permit ",
         "Application Date": "1/28/16 16:09",
         "Status": "Approved ",
         "Description": "Special Use Permit to allow demolition of an approximately 1,550 square feet commercial structure, the removal of two ordinance-sized trees, the construction of a 5-story mixed-use development with 36 residential units, and approximately 1,600 square feet commercial condominium an approximately 0.47 gross acre site",
         "Planner": "Tracy Tam ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "SP16-010",
         "APN": 25946048,
         "File Number": "SP16-010",
         "Address": "267 DELMAS AV SAN JOSE",
         "Project Name": "SP16-010 267 Delmas Avenue (Filice) Project",
         "Application Type": "Special Use Permit ",
         "Application Date": "1/28/16 16:09",
         "Status": "Approved ",
         "Description": "Special Use Permit to allow demolition of an approximately 1,550 square feet commercial structure, the removal of two ordinance-sized trees, the construction of a 5-story mixed-use development with 36 residential units, and approximately 1,600 square feet commercial condominium an approximately 0.47 gross acre site",
         "Planner": "Tracy Tam ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "SP16-016",
         "APN": 25946040,
         "File Number": "SP16-016",
         "Address": "201 DELMAS AV SAN JOSE",
         "Project Name": "SP16-016",
         "Application Type": "Special Use Permit ",
         "Application Date": "3/8/16 9:39",
         "Status": "Approved ",
         "Description": "Special Use Permit to allow the demolition of an existing 4,150-square foot office building, the removal of six ordinance-sized trees, and the construction of a 4-and-5-story development with up to 123 residential units, one level of underground parking, and approximately 1,000 square feet of ground-floor commercial space on a 1.75 gross acre site",
         "Planner": "Tracy Tam ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "SP16-016",
         "APN": 25946044,
         "File Number": "SP16-016",
         "Address": "201 DELMAS AV SAN JOSE",
         "Project Name": "SP16-016",
         "Application Type": "Special Use Permit ",
         "Application Date": "3/8/16 9:39",
         "Status": "Approved ",
         "Description": "Special Use Permit to allow the demolition of an existing 4,150-square foot office building, the removal of six ordinance-sized trees, and the construction of a 4-and-5-story development with up to 123 residential units, one level of underground parking, and approximately 1,000 square feet of ground-floor commercial space on a 1.75 gross acre site",
         "Planner": "Tracy Tam ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "SP16-016",
         "APN": 25946045,
         "File Number": "SP16-016",
         "Address": "201 DELMAS AV SAN JOSE",
         "Project Name": "SP16-016",
         "Application Type": "Special Use Permit ",
         "Application Date": "3/8/16 9:39",
         "Status": "Approved ",
         "Description": "Special Use Permit to allow the demolition of an existing 4,150-square foot office building, the removal of six ordinance-sized trees, and the construction of a 4-and-5-story development with up to 123 residential units, one level of underground parking, and approximately 1,000 square feet of ground-floor commercial space on a 1.75 gross acre site",
         "Planner": "Tracy Tam ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "SP16-016",
         "APN": 25946056,
         "File Number": "SP16-016",
         "Address": "201 DELMAS AV SAN JOSE",
         "Project Name": "SP16-016",
         "Application Type": "Special Use Permit ",
         "Application Date": "3/8/16 9:39",
         "Status": "Approved ",
         "Description": "Special Use Permit to allow the demolition of an existing 4,150-square foot office building, the removal of six ordinance-sized trees, and the construction of a 4-and-5-story development with up to 123 residential units, one level of underground parking, and approximately 1,000 square feet of ground-floor commercial space on a 1.75 gross acre site",
         "Planner": "Tracy Tam ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "SP16-016",
         "APN": 25946057,
         "File Number": "SP16-016",
         "Address": "201 DELMAS AV SAN JOSE",
         "Project Name": "SP16-016",
         "Application Type": "Special Use Permit ",
         "Application Date": "3/8/16 9:39",
         "Status": "Approved ",
         "Description": "Special Use Permit to allow the demolition of an existing 4,150-square foot office building, the removal of six ordinance-sized trees, and the construction of a 4-and-5-story development with up to 123 residential units, one level of underground parking, and approximately 1,000 square feet of ground-floor commercial space on a 1.75 gross acre site",
         "Planner": "Tracy Tam ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "SP16-016",
         "APN": 25946058,
         "File Number": "SP16-016",
         "Address": "201 DELMAS AV SAN JOSE",
         "Project Name": "SP16-016",
         "Application Type": "Special Use Permit ",
         "Application Date": "3/8/16 9:39",
         "Status": "Approved ",
         "Description": "Special Use Permit to allow the demolition of an existing 4,150-square foot office building, the removal of six ordinance-sized trees, and the construction of a 4-and-5-story development with up to 123 residential units, one level of underground parking, and approximately 1,000 square feet of ground-floor commercial space on a 1.75 gross acre site",
         "Planner": "Tracy Tam ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "SP16-016",
         "APN": 25946090,
         "File Number": "SP16-016",
         "Address": "201 DELMAS AV SAN JOSE",
         "Project Name": "SP16-016",
         "Application Type": "Special Use Permit ",
         "Application Date": "3/8/16 9:39",
         "Status": "Approved ",
         "Description": "Special Use Permit to allow the demolition of an existing 4,150-square foot office building, the removal of six ordinance-sized trees, and the construction of a 4-and-5-story development with up to 123 residential units, one level of underground parking, and approximately 1,000 square feet of ground-floor commercial space on a 1.75 gross acre site",
         "Planner": "Tracy Tam ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "SP16-016",
         "APN": 25946109,
         "File Number": "SP16-016",
         "Address": "201 DELMAS AV SAN JOSE",
         "Project Name": "SP16-016",
         "Application Type": "Special Use Permit ",
         "Application Date": "3/8/16 9:39",
         "Status": "Approved ",
         "Description": "Special Use Permit to allow the demolition of an existing 4,150-square foot office building, the removal of six ordinance-sized trees, and the construction of a 4-and-5-story development with up to 123 residential units, one level of underground parking, and approximately 1,000 square feet of ground-floor commercial space on a 1.75 gross acre site",
         "Planner": "Tracy Tam ",
         "DURATION": 0,
         "Year": 2016
      },
      {
         "PERMITID": "SP16-018",
         "APN": 46746080,
         "File Number": "SP16-018",
         "Address": "300 S 1ST ST SAN JOSE",
         "Project Name": "SP16-018",
         "Application Type": "Special Use Permit ",
         "Application Date": "3/18/16",
         "Status": "Approved ",
         "Description": "Special Use Permit to allow an Outdoor Vending Facility and site improvements in the DC Downtown Primary Commercial Zoning District on 2.8-gross acre site",
         "Planner": "Jennifer Piozet ",
         "DURATION": 154,
         "Year": 2016
      },
      {
         "PERMITID": "SP16-018",
         "APN": 46746081,
         "File Number": "SP16-018",
         "Address": "300 S 1ST ST SAN JOSE",
         "Project Name": "SP16-018",
         "Application Type": "Special Use Permit ",
         "Application Date": "3/18/16",
         "Status": "Approved ",
         "Description": "Special Use Permit to allow an Outdoor Vending Facility and site improvements in the DC Downtown Primary Commercial Zoning District on 2.8-gross acre site",
         "Planner": "Jennifer Piozet ",
         "DURATION": 154,
         "Year": 2016
      },
      {
         "PERMITID": "SP16-054",
         "APN": 46746072,
         "File Number": "SP16-054",
         "Address": "80 E SAN CARLOS ST SAN JOSE",
         "Project Name": "SP16-054",
         "Application Type": "Special Use Permit ",
         "Application Date": "11/7/16",
         "Status": "Approved ",
         "Description": "Special Use Permit to allow the demolition of two buildings totaling approximately 21,570 square feet on a 1.46 gross acre site",
         "Planner": "Emily Lipoma ",
         "DURATION": 284,
         "Year": 2016
      },
      {
         "PERMITID": "SP17-009",
         "APN": 46720087,
         "File Number": "SP17-009",
         "Address": "39 N 5TH ST SAN JOSE",
         "Project Name": "SP17-009 - MIRO",
         "Application Type": "Special Use Permit ",
         "Application Date": "2/22/17 17:29",
         "Status": "Approved ",
         "Description": "Special Use Permit to allow the demolition of an approximately 5,574 square foot existing building, and the construction of two 28-story residential towers to include 298 residential units in the west tower and 312 residential units in the east tower with three levels of underground parking and four levels of above ground parking, to allow 6 commercial condominiums which includes approximately 14,381 square feet of ground floor commercial uses and up to 24,693 square feet of flex/office space and to allow for the removal of nine trees, four of which are ordinance sized ranging from 59 to 78 inches in circumference on an approximately 1.4 gross acre site.",
         "Planner": "Emily Lipoma ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "SP17-015",
         "APN": 46720074,
         "File Number": "SP17-015",
         "Address": "117 N 5TH ST SAN JOSE",
         "Project Name": "SP17-015",
         "Application Type": "Special Use Permit ",
         "Application Date": "3/20/17 10:09",
         "Status": "Approved ",
         "Description": "Special Use Permit to construct a five-story, 28-unit multi-family residential building with alternative parking arrangement(mechanical lift) on a 0.24-gross acre site at the west side of N. 5th street, approximately 100 feet northerly of East St. John Street",
         "Planner": "Emily Lipoma ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "SP17-016",
         "APN": 26426013,
         "File Number": "SP17-016",
         "Address": "425 AUZERAIS AV SAN JOSE",
         "Project Name": "SP17-016 - 425 Auzerais Ave",
         "Application Type": "Special Use Permit ",
         "Application Date": "3/20/17 15:49",
         "Status": "Approved ",
         "Description": "Special Use Permit to allow demolition of seven existing structures totaling approximately 8,193 square feet, the removal of two ordinance sized trees, the construction of a six-story podium building with 130 residential units, totaling approximately 135,599 square feet, the utilization of Transportation Demand Management (TDM) measures to reduce the parking requirements by 50%, and an alternative parking design (carlifts) on an approximately 1.02 gross acre site",
         "Planner": "Emily Lipoma ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "SP17-016",
         "APN": 26426088,
         "File Number": "SP17-016",
         "Address": "425 AUZERAIS AV SAN JOSE",
         "Project Name": "SP17-016 - 425 Auzerais Ave",
         "Application Type": "Special Use Permit ",
         "Application Date": "3/20/17 15:49",
         "Status": "Approved ",
         "Description": "Special Use Permit to allow demolition of seven existing structures totaling approximately 8,193 square feet, the removal of two ordinance sized trees, the construction of a six-story podium building with 130 residential units, totaling approximately 135,599 square feet, the utilization of Transportation Demand Management (TDM) measures to reduce the parking requirements by 50%, and an alternative parking design (carlifts) on an approximately 1.02 gross acre site",
         "Planner": "Emily Lipoma ",
         "DURATION": 0,
         "Year": 2017
      },
      {
         "PERMITID": "SP17-024",
         "APN": 26429058,
         "File Number": "SP17-024",
         "Address": "325 S 1ST ST SAN JOSE",
         "Project Name": "SP17-024",
         "Application Type": "Special Use Permit ",
         "Application Date": "5/22/17",
         "Status": "Approved ",
         "Description": "Special Use Permit to allow late night use for an existing restaurant on a 0.17 gross acre site",
         "Planner": "Robert Rivera ",
         "DURATION": 56,
         "Year": 2017
      },
      {
         "PERMITID": "SP17-050",
         "APN": 25939111,
         "File Number": "SP17-050",
         "Address": "350 W SANTA CLARA ST SAN JOSE",
         "Project Name": "SP17-050",
         "Application Type": "Special Use Permit ",
         "Application Date": "11/8/17 9:10",
         "Status": "Approved ",
         "Description": "Special Use Permit to allow late night use for an existing hotel on a 0.54 gross acre site.",
         "Planner": "Robert Rivera ",
         "DURATION": 70,
         "Year": 2017
      },
      {
         "PERMITID": "SP18-042",
         "APN": 25934029,
         "File Number": "SP18-042",
         "Address": "84 N MARKET ST SAN JOSE",
         "Project Name": "SP18-042",
         "Application Type": "Special Use Permit ",
         "Application Date": "8/27/18 15:21",
         "Status": "Approved ",
         "Description": "Special Use Permit to allow late night use (open until 3:00 a.m. Monday to Sunday) for an existing retail hookah lounge (Shisha Hookah Lounge) on a 0.1-gross acre site in Downtown. No alcohol service.",
         "Planner": "Rina Shah ",
         "DURATION": 105,
         "Year": 2018
      },
      {
         "PERMITID": "SP93-026",
         "APN": 46702116,
         "File Number": "SP93-026",
         "Address": "268 E JULIAN ST SAN JOSE",
         "Project Name": "SP93-026",
         "Application Type": "Special Use Permit ",
         "Application Date": "7/19/93",
         "Status": "Approved ",
         "Description": "File type: *Other apns: *Gen.Use Class:*Existing Land Use:70*Specific Use:OVERNIGHT SHELTER",
         "Planner": "LCARRILL ",
         "DURATION": 0,
         "Year": 1993
      },
      {
         "PERMITID": "SP94-006",
         "APN": 46702116,
         "File Number": "SP94-006",
         "Address": "268 E JULIAN ST SAN JOSE",
         "Project Name": "SP94-006",
         "Application Type": "Special Use Permit ",
         "Application Date": "2/24/94",
         "Status": "Approved ",
         "Description": "(Q67/83) TEMPORARY OVERNIGHT SHELTER",
         "Planner": "Jeff Roche ",
         "DURATION": 0,
         "Year": 1994
      },
      {
         "PERMITID": "SP98-055",
         "APN": 46719048,
         "File Number": "SP98-055",
         "Address": "272 E ST JOHN ST SAN JOSE",
         "Project Name": "SP98-055",
         "Application Type": "Special Use Permit ",
         "Application Date": "9/29/98",
         "Status": "Approved ",
         "Description": "Special Use Permit for demolition and reconstruction of legal nonconforming accessory structure on residential site ",
         "Planner": "Akoni Danielsen ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "SP99-047",
         "APN": 47230050,
         "File Number": "SP99-047",
         "Address": "575 S 15TH ST SAN JOSE",
         "Project Name": "SP99-047",
         "Application Type": "Special Use Permit ",
         "Application Date": "6/30/99",
         "Status": "Approved ",
         "Description": "Special Use Permit to allow a 960 square foot accessory structure on a 0.25 gross acre residential property",
         "Planner": "PGILLI ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "SP08-009",
         "APN": 46720018,
         "File Number": "SP08-009",
         "Address": "156 E ST JOHN ST SAN JOSE",
         "Project Name": "SP08-009",
         "Application Type": "Special Use Permit ",
         "Application Date": "2/20/08",
         "Status": "Denied ",
         "Description": "Special Use Permit to allow demolition of a four-unit, circa-1919 residential building (158-160 E. St. John Street) on a 0.4-acre site",
         "Planner": "Ella Samonsky ",
         "DURATION": 2066,
         "Year": 2008
      },
      {
         "PERMITID": "RSP02-002",
         "APN": 25939116,
         "File Number": "RSP02-002",
         "Address": " ",
         "Project Name": "RSP02-002, Downtown College Prep",
         "Application Type": "Special Use Permit ",
         "Application Date": "8/8/02",
         "Status": "Expired ",
         "Description": "Reduction of on-site parking for a senior high school from 69 to 49 spaces.",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2002
      },
      {
         "PERMITID": "RSP02-002",
         "APN": 25939119,
         "File Number": "RSP02-002",
         "Address": " ",
         "Project Name": "RSP02-002, Downtown College Prep",
         "Application Type": "Special Use Permit ",
         "Application Date": "8/8/02",
         "Status": "Expired ",
         "Description": "Reduction of on-site parking for a senior high school from 69 to 49 spaces.",
         "Planner": "Judie Gilli ",
         "DURATION": 0,
         "Year": 2002
      },
      {
         "PERMITID": "SP18-053",
         "APN": 26420064,
         "File Number": "SP18-053",
         "Address": "500 W SAN CARLOS ST SAN JOSE",
         "Project Name": "SP18-053 Josefa Plaza",
         "Application Type": "Special Use Permit ",
         "Application Date": "9/23/18 10:52",
         "Status": "Notice Sent ",
         "Description": "Special Use Permit to allow the demolition of an approximately 1,000 square foot building, the construction of a mixed-use project consisting of approximately 3,095 square feet of ground floor commercial, and up to 18 residential rental units, and to utilize an alternative parking arrangement (i.e. carlifts) on an approximately 0.18 gross acre site",
         "Planner": "Tracy Tam ",
         "DURATION": 32,
         "Year": 2018
      },
      {
         "PERMITID": "SP19-005",
         "APN": 47225072,
         "File Number": "SP19-005",
         "Address": "647 S 6TH ST SAN JOSE",
         "Project Name": "SP19-005",
         "Application Type": "Special Use Permit ",
         "Application Date": " ",
         "Status": "Pending ",
         "Description": "Special Use Permit to allow the conversion from single family house to duplex in the R-M Zoning District on .143 gross acre site converted to H19-009",
         "Planner": "Rina Shah ",
         "DURATION": 1,
         "Year": null
      },
      {
         "PERMITID": "SP18-009",
         "APN": 25931071,
         "File Number": "SP18-009",
         "Address": "255 W JULIAN ST SAN JOSE",
         "Project Name": "SP18-009 - Davidson Plaza Towers",
         "Application Type": "Special Use Permit ",
         "Application Date": "2/7/18 15:34",
         "Status": "Review Letter Sent ",
         "Description": "Special Use Permit to demolish an existing 56,400 square foot office building and surface parking, allow 653 residential units in two 17-story buildings and 10,254 square feet of ground floor commercial space, on a 1.78-gross acre site in the DC Downtown Primary Commercial Zoning District.",
         "Planner": "Ruth Cueto ",
         "DURATION": 8,
         "Year": 2018
      },
      {
         "PERMITID": "SP18-057",
         "APN": 25947069,
         "File Number": "SP18-057",
         "Address": "543 LORRAINE AV SAN JOSE",
         "Project Name": "SP18-057 - Montgomery Phase - 2 apartments",
         "Application Type": "Special Use Permit ",
         "Application Date": "12/14/17 14:02",
         "Status": "Under Review ",
         "Description": "Site Development Permit to allow the demolition of the existing buildings and removal of trees on-site and the construction of a mixed-use building including up to 70 residential units and approximately 2,200 square feet of commercial uses on a 9.7-gross acre site.",
         "Planner": "Cassandra Van Der Zweep ",
         "DURATION": 42,
         "Year": 2017
      },
      {
         "PERMITID": "SP18-057",
         "APN": 25947070,
         "File Number": "SP18-057",
         "Address": "543 LORRAINE AV SAN JOSE",
         "Project Name": "SP18-057 - Montgomery Phase - 2 apartments",
         "Application Type": "Special Use Permit ",
         "Application Date": "12/14/17 14:02",
         "Status": "Under Review ",
         "Description": "Site Development Permit to allow the demolition of the existing buildings and removal of trees on-site and the construction of a mixed-use building including up to 70 residential units and approximately 2,200 square feet of commercial uses on a 9.7-gross acre site.",
         "Planner": "Cassandra Van Der Zweep ",
         "DURATION": 42,
         "Year": 2017
      },
      {
         "PERMITID": "RSP98-001",
         "APN": 25924035,
         "File Number": "RSP98-001",
         "Address": " ",
         "Project Name": "RSP98-001, Fermin Construction Co.",
         "Application Type": "Special Use Permit ",
         "Application Date": "5/1/98",
         "Status": "Withdrawn ",
         "Description": "To allow a temporary construction staging area ",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "RSP98-001",
         "APN": 25924037,
         "File Number": "RSP98-001",
         "Address": " ",
         "Project Name": "RSP98-001, Fermin Construction Co.",
         "Application Type": "Special Use Permit ",
         "Application Date": "5/1/98",
         "Status": "Withdrawn ",
         "Description": "To allow a temporary construction staging area ",
         "Planner": "Amie Glaser ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "SP00-002",
         "APN": 47230062,
         "File Number": "SP00-002",
         "Address": "665 S 15TH ST SAN JOSE",
         "Project Name": "665 S.15th St SUP",
         "Application Type": "Special Use Permit ",
         "Application Date": "1/14/00",
         "Status": "Withdrawn ",
         "Description": "Special Use Permit to legalize a detached garage being used as a study/bedroom on a .16 gross acre site",
         "Planner": "Akoni Danielsen ",
         "DURATION": 4250,
         "Year": 2000
      },
      {
         "PERMITID": "SP00-008",
         "APN": 25947050,
         "File Number": "SP00-008",
         "Address": "502 PARK AV SAN JOSE",
         "Project Name": "SP00-008",
         "Application Type": "Special Use Permit ",
         "Application Date": "3/15/00",
         "Status": "Withdrawn ",
         "Description": "Special Use Permit to construct a 378 square foot garage for a LNC residence",
         "Planner": "Robert MERKAMP ",
         "DURATION": 0,
         "Year": 2000
      },
      {
         "PERMITID": "SP01-036",
         "APN": 26415017,
         "File Number": "SP01-036",
         "Address": "655 AUZERAIS AV SAN JOSE",
         "Project Name": "SP01-036 Orchard Supply",
         "Application Type": "Special Use Permit ",
         "Application Date": "7/31/01",
         "Status": "Withdrawn ",
         "Description": "Special Use Permit for the demolition of a single-family residence for the extension of parking lot on a 0.13 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 4225,
         "Year": 2001
      },
      {
         "PERMITID": "SP01-055",
         "APN": 46702103,
         "File Number": "SP01-055",
         "Address": "351 E ST JAMES ST SAN JOSE",
         "Project Name": "SP01-055",
         "Application Type": "Special Use Permit ",
         "Application Date": "10/11/01 14:59",
         "Status": "Withdrawn ",
         "Description": "Special Use Permit to allow construction of an approximate 300 square foot detached accessory structure in excess of the 200 square foot allowed on a 0.15 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 4250,
         "Year": 2001
      },
      {
         "PERMITID": "SP03-002",
         "APN": 46719059,
         "File Number": "SP03-002",
         "Address": "73 N 6TH ST SAN JOSE",
         "Project Name": "SP03-002",
         "Application Type": "Special Use Permit ",
         "Application Date": "1/9/03",
         "Status": "Withdrawn ",
         "Description": "Special Use Permit to legalize 60 foot linear alteration on foundation to a legal non-conforming single family residence on a 0.15 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 3935,
         "Year": 2003
      },
      {
         "PERMITID": "SP05-048",
         "APN": 47217012,
         "File Number": "SP05-048",
         "Address": "760 S 1ST ST SAN JOSE",
         "Project Name": "SP05-048,",
         "Application Type": "Special Use Permit ",
         "Application Date": "9/28/05",
         "Status": "Withdrawn ",
         "Description": "**CODE CASE** Special Use Permit for the demolition of one burned out commercial building on a 0.2 gross acre site",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 2941,
         "Year": 2005
      },
      {
         "PERMITID": "SP08-071",
         "APN": 25932005,
         "File Number": "SP08-071",
         "Address": "175 N SAN PEDRO ST SAN JOSE",
         "Project Name": "SP08-071 - 175 North San Pedro Street",
         "Application Type": "Special Use Permit ",
         "Application Date": "12/1/08",
         "Status": "Withdrawn ",
         "Description": "Special Use Permit to allow the demolition of an existing nightclub and the construction of a surface parking lot in the DC Downtown Commercial Zoning District on a 0.20 gross acre site",
         "Planner": "Jodie Clark ",
         "DURATION": 1781,
         "Year": 2008
      },
      {
         "PERMITID": "SP09-051",
         "APN": 46724069,
         "File Number": "SP09-051",
         "Address": "304 E SANTA CLARA ST SAN JOSE",
         "Project Name": "SP09-051",
         "Application Type": "Special Use Permit ",
         "Application Date": "7/29/09",
         "Status": "Withdrawn ",
         "Description": "Special Use Permit to allow operation after midnight until 3:00am Thursday to Saturday and 1:00am Sunday to Wednesday for the consumption of food and alcoholic drinks in an existing restaurant on a 0.05 gross acre site",
         "Planner": "Sally Zarnowitz ",
         "DURATION": 1541,
         "Year": 2009
      },
      {
         "PERMITID": "SP11-019",
         "APN": 25934029,
         "File Number": "SP11-019",
         "Address": "84 N MARKET ST SAN JOSE",
         "Project Name": "SP11-019",
         "Application Type": "Special Use Permit ",
         "Application Date": "5/16/11",
         "Status": "Withdrawn ",
         "Description": "Special Use Permit to establish a SRO (Single Room Occupancy) Hotel and associated minor site improvements in the DC Downtown Core Zoning District on .101 gross acre site",
         "Planner": "Jenny Nusbaum ",
         "DURATION": 1918,
         "Year": 2011
      },
      {
         "PERMITID": "SP14-055",
         "APN": 46717083,
         "File Number": "SP14-055",
         "Address": "69 N 10TH ST SAN JOSE",
         "Project Name": "SP14-055",
         "Application Type": "Special Use Permit ",
         "Application Date": "11/14/14 13:36",
         "Status": "Withdrawn ",
         "Description": "Special Use Permit to allow a single family residence with detached garage (new rectory) on a 0.22 gross acre site",
         "Planner": "Wayne Farrens ",
         "DURATION": 52,
         "Year": 2014
      },
      {
         "PERMITID": "SP14-062",
         "APN": 25943069,
         "File Number": "SP14-062",
         "Address": "282 ALMADEN BL SAN JOSE",
         "Project Name": "SP14-062",
         "Application Type": "Special Use Permit ",
         "Application Date": "12/18/14 14:30",
         "Status": "Withdrawn ",
         "Description": "Special Use Permit to install twelve (12) wireless communication antennas and one generator on an existing building rooftop on an approximately 1.09 gross acre site",
         "Planner": "David Fong ",
         "DURATION": 608,
         "Year": 2014
      },
      {
         "PERMITID": "SP16-032",
         "APN": 46701120,
         "File Number": "SP16-032",
         "Address": "298 N 4TH ST SAN JOSE",
         "Project Name": "SP16-032",
         "Application Type": "Special Use Permit ",
         "Application Date": "6/8/16 16:59",
         "Status": "Withdrawn ",
         "Description": "Special Use Permit to allow one (1) commercial condominium, approximately 1,403 square feet in size on a 0.43 gross acre site",
         "Planner": "David Fong ",
         "DURATION": 35,
         "Year": 2016
      },
      {
         "PERMITID": "SP17-055",
         "APN": 46702103,
         "File Number": "SP17-055",
         "Address": "351 E ST JAMES ST SAN JOSE",
         "Project Name": "SP17-055",
         "Application Type": "Special Use Permit ",
         "Application Date": "12/18/17",
         "Status": "Withdrawn ",
         "Description": "Special Use Permit to allow the legalization of a previously built accessory building on a 0.149 gross acre site",
         "Planner": "Edward Schreiner ",
         "DURATION": 378,
         "Year": 2017
      },
      {
         "PERMITID": "SP18-043",
         "APN": 47217024,
         "File Number": "SP18-043",
         "Address": "735 S 2ND ST SAN JOSE",
         "Project Name": "SP18-043",
         "Application Type": "Special Use Permit ",
         "Application Date": "8/28/18 17:08",
         "Status": "Withdrawn ",
         "Description": "Special Use Permit to allow construction of four multi-family residential units (townhomes) on a 0.15-gross acre site in the R-M Multiple Residence Zoning District This folder was converted from H17-020",
         "Planner": "Rina Shah ",
         "DURATION": 44,
         "Year": 2018
      },
      {
         "PERMITID": "SP18-050",
         "APN": 25935055,
         "File Number": "SP18-050",
         "Address": "8 N ALMADEN BL SAN JOSE",
         "Project Name": "USE H18-038",
         "Application Type": "Special Use Permit ",
         "Application Date": "9/7/18 15:26",
         "Status": "Withdrawn ",
         "Description": "Special Use Permit to allow the construction of a 19-story high rise hotel with 272 guest rooms with amenities including restaurant with on-sale of alcohol, fitness center and off-site or alternate parking arrangements on .20 gross acre site converted from H18-038->> BACK TO H18-038 - PLEASE UPDATE H18-038 - NOT THIS FOLDER",
         "Planner": "Nizar Slim ",
         "DURATION": 1,
         "Year": 2018
      },
      {
         "PERMITID": "SP97-019",
         "APN": 24948025,
         "File Number": "SP97-019",
         "Address": "252 WASHINGTON ST SAN JOSE",
         "Project Name": "SP97-019",
         "Application Type": "Special Use Permit ",
         "Application Date": "5/9/97",
         "Status": "Withdrawn ",
         "Description": "DUPLEX ON .239 GROSS ACRES",
         "Planner": "Salifu Yakubu ",
         "DURATION": 0,
         "Year": 1997
      },
      {
         "PERMITID": "SP98-015",
         "APN": 24946089,
         "File Number": "SP98-015",
         "Address": " ",
         "Project Name": "SP98-015",
         "Application Type": "Special Use Permit ",
         "Application Date": "3/3/98",
         "Status": "Withdrawn ",
         "Description": "Special Use Permit to allow demolition of a single family detahced residence on a 0.14 gross acre site",
         "Planner": "Akoni Danielsen ",
         "DURATION": 0,
         "Year": 1998
      },
      {
         "PERMITID": "SP99-094",
         "APN": 24950017,
         "File Number": "SP99-094",
         "Address": "301 E JULIAN ST SAN JOSE",
         "Project Name": "SP99-094",
         "Application Type": "Special Use Permit ",
         "Application Date": "11/10/99",
         "Status": "Withdrawn ",
         "Description": "Special Use Permit for the conversion of a gas station to an automobile tire dealer on a .22 gross acre site",
         "Planner": "Akoni Danielsen ",
         "DURATION": 0,
         "Year": 1999
      }
   ],
   "Special Use Permit Amendment ": [
      {
         "PERMITID": "SPA03-042-01",
         "APN": 25945077,
         "File Number": "SPA03-042-01",
         "Address": "432 LAKEHOUSE AV SAN JOSE",
         "Project Name": "SPA03-042-01",
         "Application Type": "Special Use Permit Amendment ",
         "Application Date": "7/6/05",
         "Status": "Approved ",
         "Description": "Special Use Permit Amendment to demolish and replace a four-car garage for an existing legal non-conforming four-plex on a 0.16 gross acre site",
         "Planner": "Lesley Xavier ",
         "DURATION": 151,
         "Year": 2005
      }
   ],
   "State Dept. Letter ": [
      {
         "PERMITID": "SDL13-010",
         "APN": 46747058,
         "File Number": "SDL13-010",
         "Address": "451 S 4TH ST SAN JOSE",
         "Project Name": "SDL13-010",
         "Application Type": "State Dept. Letter ",
         "Application Date": "8/29/13 8:22",
         "Status": "Complete ",
         "Description": "State Department of Social Services letter for Community Care Licensing Division. ",
         "Planner": " ",
         "DURATION": 11,
         "Year": 2013
      },
      {
         "PERMITID": "SDL14-011",
         "APN": 46724089,
         "File Number": "SDL14-011",
         "Address": "393 E SAN FERNANDO ST SAN JOSE",
         "Project Name": "SDL14-011",
         "Application Type": "State Dept. Letter ",
         "Application Date": "8/20/14 15:40",
         "Status": "Complete ",
         "Description": "State Department of Social Services letter for Community Care Licensing Division. ",
         "Planner": "Pick ",
         "DURATION": 14,
         "Year": 2014
      },
      {
         "PERMITID": "SDL15-006",
         "APN": 47225061,
         "File Number": "SDL15-006",
         "Address": "650 S 5TH ST SAN JOSE",
         "Project Name": "SDL15-006",
         "Application Type": "State Dept. Letter ",
         "Application Date": "7/30/15 15:26",
         "Status": "Complete ",
         "Description": "State Department of Social Services letter for Community Care Licensing Division. ",
         "Planner": "Susan Walsh ",
         "DURATION": 1,
         "Year": 2015
      }
   ],
   "Tentative Condominium Map ": [
      {
         "PERMITID": "PT02-111",
         "APN": 47245001,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245002,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245003,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245004,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245005,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245006,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245008,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245009,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245010,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245011,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245012,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245013,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245014,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245015,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245016,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245017,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245018,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245019,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245020,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245021,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245022,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245023,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245025,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245027,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245028,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245029,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245030,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245031,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245032,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245033,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245034,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245035,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245037,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245038,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245039,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245042,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245043,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245044,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245046,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245047,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245048,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245049,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245050,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245053,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245054,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245055,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245056,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245059,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245064,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245065,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245066,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245067,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245069,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245071,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245072,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245073,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "PT02-111",
         "APN": 47245074,
         "File Number": "PT02-111",
         "Address": "9539 TRACT SAN JOSE",
         "Project Name": "PT02-111",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "9/19/02",
         "Status": "Approved ",
         "Description": "Planned Development Tentative Condominium Map Permit to reconfigure 1 parcel into 1 lot for 74 single-family attached residences on a 1.2 gross acre site",
         "Planner": "John Davidson ",
         "DURATION": 84,
         "Year": 2002
      },
      {
         "PERMITID": "T05-056",
         "APN": 46762001,
         "File Number": "T05-056",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "T05-056",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "6/10/05",
         "Status": "Approved ",
         "Description": "Tentative Map to allow condominium/office uses in an existing office building on a 0.40 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 318,
         "Year": 2005
      },
      {
         "PERMITID": "T05-056",
         "APN": 46762007,
         "File Number": "T05-056",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "T05-056",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "6/10/05",
         "Status": "Approved ",
         "Description": "Tentative Map to allow condominium/office uses in an existing office building on a 0.40 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 318,
         "Year": 2005
      },
      {
         "PERMITID": "T05-056",
         "APN": 46762008,
         "File Number": "T05-056",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "T05-056",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "6/10/05",
         "Status": "Approved ",
         "Description": "Tentative Map to allow condominium/office uses in an existing office building on a 0.40 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 318,
         "Year": 2005
      },
      {
         "PERMITID": "T05-056",
         "APN": 46762009,
         "File Number": "T05-056",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "T05-056",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "6/10/05",
         "Status": "Approved ",
         "Description": "Tentative Map to allow condominium/office uses in an existing office building on a 0.40 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 318,
         "Year": 2005
      },
      {
         "PERMITID": "T05-056",
         "APN": 46762011,
         "File Number": "T05-056",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "T05-056",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "6/10/05",
         "Status": "Approved ",
         "Description": "Tentative Map to allow condominium/office uses in an existing office building on a 0.40 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 318,
         "Year": 2005
      },
      {
         "PERMITID": "T05-056",
         "APN": 46762012,
         "File Number": "T05-056",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "T05-056",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "6/10/05",
         "Status": "Approved ",
         "Description": "Tentative Map to allow condominium/office uses in an existing office building on a 0.40 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 318,
         "Year": 2005
      },
      {
         "PERMITID": "T05-056",
         "APN": 46762014,
         "File Number": "T05-056",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "T05-056",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "6/10/05",
         "Status": "Approved ",
         "Description": "Tentative Map to allow condominium/office uses in an existing office building on a 0.40 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 318,
         "Year": 2005
      },
      {
         "PERMITID": "T05-056",
         "APN": 46762015,
         "File Number": "T05-056",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "T05-056",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "6/10/05",
         "Status": "Approved ",
         "Description": "Tentative Map to allow condominium/office uses in an existing office building on a 0.40 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 318,
         "Year": 2005
      },
      {
         "PERMITID": "T05-056",
         "APN": 46762016,
         "File Number": "T05-056",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "T05-056",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "6/10/05",
         "Status": "Approved ",
         "Description": "Tentative Map to allow condominium/office uses in an existing office building on a 0.40 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 318,
         "Year": 2005
      },
      {
         "PERMITID": "T05-056",
         "APN": 46762017,
         "File Number": "T05-056",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "T05-056",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "6/10/05",
         "Status": "Approved ",
         "Description": "Tentative Map to allow condominium/office uses in an existing office building on a 0.40 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 318,
         "Year": 2005
      },
      {
         "PERMITID": "T05-056",
         "APN": 46762019,
         "File Number": "T05-056",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "T05-056",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "6/10/05",
         "Status": "Approved ",
         "Description": "Tentative Map to allow condominium/office uses in an existing office building on a 0.40 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 318,
         "Year": 2005
      },
      {
         "PERMITID": "T05-056",
         "APN": 46762020,
         "File Number": "T05-056",
         "Address": "12 S 1ST ST SAN JOSE",
         "Project Name": "T05-056",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "6/10/05",
         "Status": "Approved ",
         "Description": "Tentative Map to allow condominium/office uses in an existing office building on a 0.40 gross acre site",
         "Planner": "Lee Butler ",
         "DURATION": 318,
         "Year": 2005
      },
      {
         "PERMITID": "T07-049",
         "APN": 46701118,
         "File Number": "T07-049",
         "Address": "252 N 1ST ST SAN JOSE",
         "Project Name": "T07-049",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "6/5/07",
         "Status": "Approved ",
         "Description": "Vesting Tentative Condominium Map Permit to reconfigure 2 parcels into 3 lots for 191-unit residential/commercial condominium uses on a 1.52 gross acres site",
         "Planner": "Jeannie Hamilton ",
         "DURATION": 506,
         "Year": 2007
      },
      {
         "PERMITID": "T13-025",
         "APN": 25940093,
         "File Number": "T13-025",
         "Address": "1 S MARKET ST SAN JOSE",
         "Project Name": "T13-025 One South Market",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "5/10/13",
         "Status": "Approved ",
         "Description": "Vesting Tentative Map to subdivide one parcel into one lot for condominium purposes to allow for the development of 312 residential units with 6,000 square feet of ground-floor commercial uses on a 0.97 gross acre site",
         "Planner": "Sylvia Do ",
         "DURATION": 134,
         "Year": 2013
      },
      {
         "PERMITID": "T15-032",
         "APN": 25946040,
         "File Number": "T15-032",
         "Address": "201 DELMAS AV SAN JOSE",
         "Project Name": "T15-032",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "6/10/15 11:31",
         "Status": "Approved ",
         "Description": "Vesting Condominium Tentative Map to merge 11 parcels into 1 parcel for residential condominium and commercial purposes on a 1.75 gross acre site",
         "Planner": "Tracy Tam ",
         "DURATION": 386,
         "Year": 2015
      },
      {
         "PERMITID": "T15-032",
         "APN": 25946044,
         "File Number": "T15-032",
         "Address": "201 DELMAS AV SAN JOSE",
         "Project Name": "T15-032",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "6/10/15 11:31",
         "Status": "Approved ",
         "Description": "Vesting Condominium Tentative Map to merge 11 parcels into 1 parcel for residential condominium and commercial purposes on a 1.75 gross acre site",
         "Planner": "Tracy Tam ",
         "DURATION": 386,
         "Year": 2015
      },
      {
         "PERMITID": "T15-032",
         "APN": 25946045,
         "File Number": "T15-032",
         "Address": "201 DELMAS AV SAN JOSE",
         "Project Name": "T15-032",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "6/10/15 11:31",
         "Status": "Approved ",
         "Description": "Vesting Condominium Tentative Map to merge 11 parcels into 1 parcel for residential condominium and commercial purposes on a 1.75 gross acre site",
         "Planner": "Tracy Tam ",
         "DURATION": 386,
         "Year": 2015
      },
      {
         "PERMITID": "T15-032",
         "APN": 25946056,
         "File Number": "T15-032",
         "Address": "201 DELMAS AV SAN JOSE",
         "Project Name": "T15-032",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "6/10/15 11:31",
         "Status": "Approved ",
         "Description": "Vesting Condominium Tentative Map to merge 11 parcels into 1 parcel for residential condominium and commercial purposes on a 1.75 gross acre site",
         "Planner": "Tracy Tam ",
         "DURATION": 386,
         "Year": 2015
      },
      {
         "PERMITID": "T15-032",
         "APN": 25946057,
         "File Number": "T15-032",
         "Address": "201 DELMAS AV SAN JOSE",
         "Project Name": "T15-032",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "6/10/15 11:31",
         "Status": "Approved ",
         "Description": "Vesting Condominium Tentative Map to merge 11 parcels into 1 parcel for residential condominium and commercial purposes on a 1.75 gross acre site",
         "Planner": "Tracy Tam ",
         "DURATION": 386,
         "Year": 2015
      },
      {
         "PERMITID": "T15-032",
         "APN": 25946058,
         "File Number": "T15-032",
         "Address": "201 DELMAS AV SAN JOSE",
         "Project Name": "T15-032",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "6/10/15 11:31",
         "Status": "Approved ",
         "Description": "Vesting Condominium Tentative Map to merge 11 parcels into 1 parcel for residential condominium and commercial purposes on a 1.75 gross acre site",
         "Planner": "Tracy Tam ",
         "DURATION": 386,
         "Year": 2015
      },
      {
         "PERMITID": "T15-032",
         "APN": 25946090,
         "File Number": "T15-032",
         "Address": "201 DELMAS AV SAN JOSE",
         "Project Name": "T15-032",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "6/10/15 11:31",
         "Status": "Approved ",
         "Description": "Vesting Condominium Tentative Map to merge 11 parcels into 1 parcel for residential condominium and commercial purposes on a 1.75 gross acre site",
         "Planner": "Tracy Tam ",
         "DURATION": 386,
         "Year": 2015
      },
      {
         "PERMITID": "T15-032",
         "APN": 25946109,
         "File Number": "T15-032",
         "Address": "201 DELMAS AV SAN JOSE",
         "Project Name": "T15-032",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "6/10/15 11:31",
         "Status": "Approved ",
         "Description": "Vesting Condominium Tentative Map to merge 11 parcels into 1 parcel for residential condominium and commercial purposes on a 1.75 gross acre site",
         "Planner": "Tracy Tam ",
         "DURATION": 386,
         "Year": 2015
      },
      {
         "PERMITID": "T15-044",
         "APN": 25940087,
         "File Number": "T15-044",
         "Address": "171 POST ST SAN JOSE",
         "Project Name": "T15-044",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "8/26/15 9:27",
         "Status": "Approved ",
         "Description": "Tentative Condominium Map to reconfigure one (1) lot into one (1) lot for 202 residential condominiums on a 0.46 gross acre site",
         "Planner": "Emily Lipoma ",
         "DURATION": 112,
         "Year": 2015
      },
      {
         "PERMITID": "T15-058",
         "APN": 26426006,
         "File Number": "T15-058",
         "Address": "341 DELMAS AV SAN JOSE",
         "Project Name": "T15-058 - 341 - 365 Delmas Ave",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "11/17/15",
         "Status": "Approved ",
         "Description": "Vesting Condominium Tentative Map to consolidate four lots into one lot, and allow the creation of 120 residential condominium units on a 0.8-gross acre site",
         "Planner": "Jennifer Piozet ",
         "DURATION": 293,
         "Year": 2015
      },
      {
         "PERMITID": "T15-058",
         "APN": 26426008,
         "File Number": "T15-058",
         "Address": "341 DELMAS AV SAN JOSE",
         "Project Name": "T15-058 - 341 - 365 Delmas Ave",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "11/17/15",
         "Status": "Approved ",
         "Description": "Vesting Condominium Tentative Map to consolidate four lots into one lot, and allow the creation of 120 residential condominium units on a 0.8-gross acre site",
         "Planner": "Jennifer Piozet ",
         "DURATION": 293,
         "Year": 2015
      },
      {
         "PERMITID": "T16-009",
         "APN": 25946046,
         "File Number": "T16-009",
         "Address": "267 DELMAS AV SAN JOSE",
         "Project Name": "T16-009",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "1/28/16 16:21",
         "Status": "Approved ",
         "Description": "Vesting Tentative Map to merge four lots into one lot and create 36 residential condominium units and 1 commercial condominium unit on a 0.47 gross acre site",
         "Planner": "John Tu ",
         "DURATION": 154,
         "Year": 2016
      },
      {
         "PERMITID": "T16-017",
         "APN": 25940012,
         "File Number": "T16-017",
         "Address": "70 S ALMADEN AV SAN JOSE",
         "Project Name": "T16-017 Greyhound",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "4/11/16",
         "Status": "Approved ",
         "Description": "Vesting Condominium Tentative Map to consolidate 4 lots into 1 lot, and allow the creation of 708 residential units and 10 commercial units on a 1.63-gross acre site",
         "Planner": "Lea Simvoulakis ",
         "DURATION": 503,
         "Year": 2016
      },
      {
         "PERMITID": "T16-017",
         "APN": 25940014,
         "File Number": "T16-017",
         "Address": "70 S ALMADEN AV SAN JOSE",
         "Project Name": "T16-017 Greyhound",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "4/11/16",
         "Status": "Approved ",
         "Description": "Vesting Condominium Tentative Map to consolidate 4 lots into 1 lot, and allow the creation of 708 residential units and 10 commercial units on a 1.63-gross acre site",
         "Planner": "Lea Simvoulakis ",
         "DURATION": 503,
         "Year": 2016
      },
      {
         "PERMITID": "T16-017",
         "APN": 25940015,
         "File Number": "T16-017",
         "Address": "70 S ALMADEN AV SAN JOSE",
         "Project Name": "T16-017 Greyhound",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "4/11/16",
         "Status": "Approved ",
         "Description": "Vesting Condominium Tentative Map to consolidate 4 lots into 1 lot, and allow the creation of 708 residential units and 10 commercial units on a 1.63-gross acre site",
         "Planner": "Lea Simvoulakis ",
         "DURATION": 503,
         "Year": 2016
      },
      {
         "PERMITID": "T16-017",
         "APN": 25940016,
         "File Number": "T16-017",
         "Address": "70 S ALMADEN AV SAN JOSE",
         "Project Name": "T16-017 Greyhound",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "4/11/16",
         "Status": "Approved ",
         "Description": "Vesting Condominium Tentative Map to consolidate 4 lots into 1 lot, and allow the creation of 708 residential units and 10 commercial units on a 1.63-gross acre site",
         "Planner": "Lea Simvoulakis ",
         "DURATION": 503,
         "Year": 2016
      },
      {
         "PERMITID": "T16-056",
         "APN": 46720087,
         "File Number": "T16-056",
         "Address": "39 N 5TH ST SAN JOSE",
         "Project Name": "T16-056",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "11/14/16",
         "Status": "Approved ",
         "Description": "Vesting Tentative Map to combine nine lots into one lot and to allow 610 residential condominium units and six commercial condominiums on a 1.413 gross acre site",
         "Planner": "Tracy Tam ",
         "DURATION": 122,
         "Year": 2016
      },
      {
         "PERMITID": "T17-022",
         "APN": 46720074,
         "File Number": "T17-022",
         "Address": "117 N 5TH ST SAN JOSE",
         "Project Name": "T17-022",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "5/8/17",
         "Status": "Approved ",
         "Description": "Tentative Map to allow up to 28 condominium units for residential purpose on one lot of 0.24-acre size",
         "Planner": "Leila Hakimizadeh ",
         "DURATION": 471,
         "Year": 2017
      },
      {
         "PERMITID": "T17-052",
         "APN": 46720087,
         "File Number": "T17-052",
         "Address": "33 N 5TH ST SAN JOSE",
         "Project Name": "T17-052",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "11/13/17",
         "Status": "Approved ",
         "Description": "Vesting Tentative Condominium Map to consolidate 9 lots into 1 parcel for 630 residential condominiums and 6 commercial condominiums on a 1.41 gross acre site.",
         "Planner": "Emily Lipoma ",
         "DURATION": 71,
         "Year": 2017
      },
      {
         "PERMITID": "T18-033",
         "APN": 47217024,
         "File Number": "T18-033",
         "Address": "735 S 2ND ST SAN JOSE",
         "Project Name": "T18-033",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "7/11/18 15:10",
         "Status": "Approved ",
         "Description": "Tentative Map to subdivide one parcel into four residential condominium units on a 0.15-gross acre site",
         "Planner": "Rina Shah ",
         "DURATION": 268,
         "Year": 2018
      },
      {
         "PERMITID": "T18-026",
         "APN": 47226002,
         "File Number": "T18-026",
         "Address": "40 E WILLIAM ST SAN JOSE",
         "Project Name": "T18-026",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "6/27/18 11:19",
         "Status": "Review Letter Sent ",
         "Description": "Tentative Condominium Map to combine 10 lots to 1 lot on a 1.632 gross acre site",
         "Planner": "Stefanie Farmer ",
         "DURATION": 30,
         "Year": 2018
      },
      {
         "PERMITID": "T18-026",
         "APN": 47226003,
         "File Number": "T18-026",
         "Address": "40 E WILLIAM ST SAN JOSE",
         "Project Name": "T18-026",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "6/27/18 11:19",
         "Status": "Review Letter Sent ",
         "Description": "Tentative Condominium Map to combine 10 lots to 1 lot on a 1.632 gross acre site",
         "Planner": "Stefanie Farmer ",
         "DURATION": 30,
         "Year": 2018
      },
      {
         "PERMITID": "T18-026",
         "APN": 47226004,
         "File Number": "T18-026",
         "Address": "40 E WILLIAM ST SAN JOSE",
         "Project Name": "T18-026",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "6/27/18 11:19",
         "Status": "Review Letter Sent ",
         "Description": "Tentative Condominium Map to combine 10 lots to 1 lot on a 1.632 gross acre site",
         "Planner": "Stefanie Farmer ",
         "DURATION": 30,
         "Year": 2018
      },
      {
         "PERMITID": "T18-026",
         "APN": 47226007,
         "File Number": "T18-026",
         "Address": "40 E WILLIAM ST SAN JOSE",
         "Project Name": "T18-026",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "6/27/18 11:19",
         "Status": "Review Letter Sent ",
         "Description": "Tentative Condominium Map to combine 10 lots to 1 lot on a 1.632 gross acre site",
         "Planner": "Stefanie Farmer ",
         "DURATION": 30,
         "Year": 2018
      },
      {
         "PERMITID": "T18-026",
         "APN": 47226034,
         "File Number": "T18-026",
         "Address": "40 E WILLIAM ST SAN JOSE",
         "Project Name": "T18-026",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "6/27/18 11:19",
         "Status": "Review Letter Sent ",
         "Description": "Tentative Condominium Map to combine 10 lots to 1 lot on a 1.632 gross acre site",
         "Planner": "Stefanie Farmer ",
         "DURATION": 30,
         "Year": 2018
      },
      {
         "PERMITID": "T18-026",
         "APN": 47226035,
         "File Number": "T18-026",
         "Address": "40 E WILLIAM ST SAN JOSE",
         "Project Name": "T18-026",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "6/27/18 11:19",
         "Status": "Review Letter Sent ",
         "Description": "Tentative Condominium Map to combine 10 lots to 1 lot on a 1.632 gross acre site",
         "Planner": "Stefanie Farmer ",
         "DURATION": 30,
         "Year": 2018
      },
      {
         "PERMITID": "T18-026",
         "APN": 47226085,
         "File Number": "T18-026",
         "Address": "40 E WILLIAM ST SAN JOSE",
         "Project Name": "T18-026",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "6/27/18 11:19",
         "Status": "Review Letter Sent ",
         "Description": "Tentative Condominium Map to combine 10 lots to 1 lot on a 1.632 gross acre site",
         "Planner": "Stefanie Farmer ",
         "DURATION": 30,
         "Year": 2018
      },
      {
         "PERMITID": "T08-054",
         "APN": 25943076,
         "File Number": "T08-054",
         "Address": "200 PARK AV SAN JOSE",
         "Project Name": "T08-054 - 200 Park Ave",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "10/30/08",
         "Status": "Withdrawn ",
         "Description": "Vesting Tentative Condominium Map to reconfigure one parcel into one lot for condominium purposes (239 attached residential uses and an undefined amount of ground floor retail space) on a 0.79 gross acre site.",
         "Planner": "Inactive Planning Projects ",
         "DURATION": 27,
         "Year": 2008
      },
      {
         "PERMITID": "T13-020",
         "APN": 25940091,
         "File Number": "T13-020",
         "Address": "55 S MARKET ST SAN JOSE",
         "Project Name": "T13-020",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "3/19/13",
         "Status": "Withdrawn ",
         "Description": "Tentative Map Application for 11 commercial condominiums",
         "Planner": "John Baty ",
         "DURATION": 144,
         "Year": 2013
      },
      {
         "PERMITID": "T18-005",
         "APN": 25931071,
         "File Number": "T18-005",
         "Address": "255 W JULIAN ST SAN JOSE",
         "Project Name": "T18-005",
         "Application Type": "Tentative Condominium Map ",
         "Application Date": "1/31/18",
         "Status": "Withdrawn ",
         "Description": "Vesting Tentative Map to allow 653 residential condominiums and 5 retail condominiums on a 1.78-gross acre site.",
         "Planner": "Ruth Cueto ",
         "DURATION": 147,
         "Year": 2018
      }
   ],
   "Tentative Map Extension ": [
      {
         "PERMITID": "TE14-029-01",
         "APN": 25932040,
         "File Number": "TE14-029-01",
         "Address": "195 DEVINE ST SAN JOSE",
         "Project Name": "TE14-029-01",
         "Application Type": "Tentative Map Extension ",
         "Application Date": "5/4/17 16:15",
         "Status": "Review Letter Sent ",
         "Description": "Tentative Map Extension Permit to allow up to three year time extension of the previously approved permit T14-029 on a 13.49 gross acre site",
         "Planner": "Emily Lipoma ",
         "DURATION": 55,
         "Year": 2017
      },
      {
         "PERMITID": "TE14-029-01",
         "APN": 25932041,
         "File Number": "TE14-029-01",
         "Address": "195 DEVINE ST SAN JOSE",
         "Project Name": "TE14-029-01",
         "Application Type": "Tentative Map Extension ",
         "Application Date": "5/4/17 16:15",
         "Status": "Review Letter Sent ",
         "Description": "Tentative Map Extension Permit to allow up to three year time extension of the previously approved permit T14-029 on a 13.49 gross acre site",
         "Planner": "Emily Lipoma ",
         "DURATION": 55,
         "Year": 2017
      },
      {
         "PERMITID": "TE14-029-01",
         "APN": 25932073,
         "File Number": "TE14-029-01",
         "Address": "195 DEVINE ST SAN JOSE",
         "Project Name": "TE14-029-01",
         "Application Type": "Tentative Map Extension ",
         "Application Date": "5/4/17 16:15",
         "Status": "Review Letter Sent ",
         "Description": "Tentative Map Extension Permit to allow up to three year time extension of the previously approved permit T14-029 on a 13.49 gross acre site",
         "Planner": "Emily Lipoma ",
         "DURATION": 55,
         "Year": 2017
      },
      {
         "PERMITID": "TE14-029-01",
         "APN": 25932079,
         "File Number": "TE14-029-01",
         "Address": "195 DEVINE ST SAN JOSE",
         "Project Name": "TE14-029-01",
         "Application Type": "Tentative Map Extension ",
         "Application Date": "5/4/17 16:15",
         "Status": "Review Letter Sent ",
         "Description": "Tentative Map Extension Permit to allow up to three year time extension of the previously approved permit T14-029 on a 13.49 gross acre site",
         "Planner": "Emily Lipoma ",
         "DURATION": 55,
         "Year": 2017
      },
      {
         "PERMITID": "TE14-029-01",
         "APN": 25933067,
         "File Number": "TE14-029-01",
         "Address": "195 DEVINE ST SAN JOSE",
         "Project Name": "TE14-029-01",
         "Application Type": "Tentative Map Extension ",
         "Application Date": "5/4/17 16:15",
         "Status": "Review Letter Sent ",
         "Description": "Tentative Map Extension Permit to allow up to three year time extension of the previously approved permit T14-029 on a 13.49 gross acre site",
         "Planner": "Emily Lipoma ",
         "DURATION": 55,
         "Year": 2017
      }
   ],
   "Unsuitable Tree ": [
      {
         "PERMITID": "TR15-280",
         "APN": 47221091,
         "File Number": "TR15-280",
         "Address": "696 MARGARET ST SAN JOSE",
         "Project Name": "TR15-280",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "7/10/15 11:08",
         "Status": "Approved ",
         "Description": "Unsuitable Tree Removal Permit to remove one (1) Monterey Pine approximately 103 inches in circumference on a 0.64 gross acre site",
         "Planner": "Rina Shah ",
         "DURATION": 33,
         "Year": 2015
      },
      {
         "PERMITID": "TR18-517",
         "APN": 47218024,
         "File Number": "TR18-517",
         "Address": "140 E VIRGINIA ST SAN JOSE",
         "Project Name": "140 EAST VIRGINIA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "11/14/18 10:19",
         "Status": "Approved ",
         "Description": "Unsuitable Tree Removal Permit to remove one Tree of Heaven that is approximately 240 inches in circumference, located in the side yard of a single-family lot.",
         "Planner": "Justin Daniels ",
         "DURATION": 0,
         "Year": 2018
      },
      {
         "PERMITID": "TR19-046",
         "APN": 47217079,
         "File Number": "TR19-046",
         "Address": "817 S 3RD ST SAN JOSE",
         "Project Name": "817 SOUTH 3RD STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "2/5/19 13:26",
         "Status": "Approved ",
         "Description": "Unsuitable Tree Removal Permit to allow the removal of one (1) Poplar tree, approximately 68 inches in circumference from the front yard of a single-family residence on a 0.20 gross acre site, in the R-M Multi-Family Residence Zoning District",
         "Planner": "David Fong ",
         "DURATION": 0,
         "Year": 2019
      },
      {
         "PERMITID": "2017 048281 TS",
         "APN": 46723010,
         "File Number": "2017 048281 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/21/17 17:45",
         "Status": "Pending ",
         "Description": "TEST AGAIN  ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 048281 TS",
         "APN": 46723011,
         "File Number": "2017 048281 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/21/17 17:45",
         "Status": "Pending ",
         "Description": "TEST AGAIN  ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 048281 TS",
         "APN": 46723013,
         "File Number": "2017 048281 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/21/17 17:45",
         "Status": "Pending ",
         "Description": "TEST AGAIN  ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 048281 TS",
         "APN": 46723017,
         "File Number": "2017 048281 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/21/17 17:45",
         "Status": "Pending ",
         "Description": "TEST AGAIN  ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 048281 TS",
         "APN": 46723018,
         "File Number": "2017 048281 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/21/17 17:45",
         "Status": "Pending ",
         "Description": "TEST AGAIN  ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 048281 TS",
         "APN": 46723019,
         "File Number": "2017 048281 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/21/17 17:45",
         "Status": "Pending ",
         "Description": "TEST AGAIN  ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 048281 TS",
         "APN": 46723021,
         "File Number": "2017 048281 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/21/17 17:45",
         "Status": "Pending ",
         "Description": "TEST AGAIN  ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 048281 TS",
         "APN": 46723022,
         "File Number": "2017 048281 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/21/17 17:45",
         "Status": "Pending ",
         "Description": "TEST AGAIN  ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 048281 TS",
         "APN": 46723076,
         "File Number": "2017 048281 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/21/17 17:45",
         "Status": "Pending ",
         "Description": "TEST AGAIN  ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 048281 TS",
         "APN": 46724001,
         "File Number": "2017 048281 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/21/17 17:45",
         "Status": "Pending ",
         "Description": "TEST AGAIN  ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 048281 TS",
         "APN": 46724002,
         "File Number": "2017 048281 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/21/17 17:45",
         "Status": "Pending ",
         "Description": "TEST AGAIN  ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 048281 TS",
         "APN": 46724003,
         "File Number": "2017 048281 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/21/17 17:45",
         "Status": "Pending ",
         "Description": "TEST AGAIN  ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 048281 TS",
         "APN": 46724014,
         "File Number": "2017 048281 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/21/17 17:45",
         "Status": "Pending ",
         "Description": "TEST AGAIN  ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 048281 TS",
         "APN": 46724015,
         "File Number": "2017 048281 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/21/17 17:45",
         "Status": "Pending ",
         "Description": "TEST AGAIN  ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 048281 TS",
         "APN": 46724016,
         "File Number": "2017 048281 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/21/17 17:45",
         "Status": "Pending ",
         "Description": "TEST AGAIN  ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 048281 TS",
         "APN": 46724019,
         "File Number": "2017 048281 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/21/17 17:45",
         "Status": "Pending ",
         "Description": "TEST AGAIN  ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 048281 TS",
         "APN": 46724020,
         "File Number": "2017 048281 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/21/17 17:45",
         "Status": "Pending ",
         "Description": "TEST AGAIN  ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 048281 TS",
         "APN": 46724021,
         "File Number": "2017 048281 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/21/17 17:45",
         "Status": "Pending ",
         "Description": "TEST AGAIN  ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 048281 TS",
         "APN": 46724115,
         "File Number": "2017 048281 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/21/17 17:45",
         "Status": "Pending ",
         "Description": "TEST AGAIN  ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 048281 TS",
         "APN": 46724117,
         "File Number": "2017 048281 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/21/17 17:45",
         "Status": "Pending ",
         "Description": "TEST AGAIN  ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "TR17-751",
         "APN": 46723010,
         "File Number": "TR17-751",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/21/17 17:41",
         "Status": "Pending ",
         "Description": "TEST ONLY ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "TR17-751",
         "APN": 46723011,
         "File Number": "TR17-751",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/21/17 17:41",
         "Status": "Pending ",
         "Description": "TEST ONLY ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "TR17-751",
         "APN": 46723013,
         "File Number": "TR17-751",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/21/17 17:41",
         "Status": "Pending ",
         "Description": "TEST ONLY ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "TR17-751",
         "APN": 46723017,
         "File Number": "TR17-751",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/21/17 17:41",
         "Status": "Pending ",
         "Description": "TEST ONLY ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "TR17-751",
         "APN": 46723018,
         "File Number": "TR17-751",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/21/17 17:41",
         "Status": "Pending ",
         "Description": "TEST ONLY ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "TR17-751",
         "APN": 46723019,
         "File Number": "TR17-751",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/21/17 17:41",
         "Status": "Pending ",
         "Description": "TEST ONLY ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "TR17-751",
         "APN": 46723021,
         "File Number": "TR17-751",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/21/17 17:41",
         "Status": "Pending ",
         "Description": "TEST ONLY ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "TR17-751",
         "APN": 46723022,
         "File Number": "TR17-751",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/21/17 17:41",
         "Status": "Pending ",
         "Description": "TEST ONLY ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "TR17-751",
         "APN": 46723076,
         "File Number": "TR17-751",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/21/17 17:41",
         "Status": "Pending ",
         "Description": "TEST ONLY ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "TR17-751",
         "APN": 46724001,
         "File Number": "TR17-751",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/21/17 17:41",
         "Status": "Pending ",
         "Description": "TEST ONLY ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "TR17-751",
         "APN": 46724002,
         "File Number": "TR17-751",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/21/17 17:41",
         "Status": "Pending ",
         "Description": "TEST ONLY ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "TR17-751",
         "APN": 46724003,
         "File Number": "TR17-751",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/21/17 17:41",
         "Status": "Pending ",
         "Description": "TEST ONLY ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "TR17-751",
         "APN": 46724014,
         "File Number": "TR17-751",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/21/17 17:41",
         "Status": "Pending ",
         "Description": "TEST ONLY ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "TR17-751",
         "APN": 46724015,
         "File Number": "TR17-751",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/21/17 17:41",
         "Status": "Pending ",
         "Description": "TEST ONLY ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "TR17-751",
         "APN": 46724016,
         "File Number": "TR17-751",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/21/17 17:41",
         "Status": "Pending ",
         "Description": "TEST ONLY ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "TR17-751",
         "APN": 46724019,
         "File Number": "TR17-751",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/21/17 17:41",
         "Status": "Pending ",
         "Description": "TEST ONLY ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "TR17-751",
         "APN": 46724020,
         "File Number": "TR17-751",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/21/17 17:41",
         "Status": "Pending ",
         "Description": "TEST ONLY ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "TR17-751",
         "APN": 46724021,
         "File Number": "TR17-751",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/21/17 17:41",
         "Status": "Pending ",
         "Description": "TEST ONLY ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "TR17-751",
         "APN": 46724115,
         "File Number": "TR17-751",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/21/17 17:41",
         "Status": "Pending ",
         "Description": "TEST ONLY ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "TR17-751",
         "APN": 46724117,
         "File Number": "TR17-751",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/21/17 17:41",
         "Status": "Pending ",
         "Description": "TEST ONLY ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047405 TS",
         "APN": 46723010,
         "File Number": "2017 047405 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 9:00",
         "Status": "Rejected ",
         "Description": "Test folder created for test only ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047405 TS",
         "APN": 46723011,
         "File Number": "2017 047405 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 9:00",
         "Status": "Rejected ",
         "Description": "Test folder created for test only ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047405 TS",
         "APN": 46723013,
         "File Number": "2017 047405 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 9:00",
         "Status": "Rejected ",
         "Description": "Test folder created for test only ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047405 TS",
         "APN": 46723017,
         "File Number": "2017 047405 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 9:00",
         "Status": "Rejected ",
         "Description": "Test folder created for test only ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047405 TS",
         "APN": 46723018,
         "File Number": "2017 047405 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 9:00",
         "Status": "Rejected ",
         "Description": "Test folder created for test only ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047405 TS",
         "APN": 46723019,
         "File Number": "2017 047405 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 9:00",
         "Status": "Rejected ",
         "Description": "Test folder created for test only ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047405 TS",
         "APN": 46723021,
         "File Number": "2017 047405 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 9:00",
         "Status": "Rejected ",
         "Description": "Test folder created for test only ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047405 TS",
         "APN": 46723022,
         "File Number": "2017 047405 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 9:00",
         "Status": "Rejected ",
         "Description": "Test folder created for test only ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047405 TS",
         "APN": 46723076,
         "File Number": "2017 047405 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 9:00",
         "Status": "Rejected ",
         "Description": "Test folder created for test only ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047405 TS",
         "APN": 46724001,
         "File Number": "2017 047405 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 9:00",
         "Status": "Rejected ",
         "Description": "Test folder created for test only ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047405 TS",
         "APN": 46724002,
         "File Number": "2017 047405 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 9:00",
         "Status": "Rejected ",
         "Description": "Test folder created for test only ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047405 TS",
         "APN": 46724003,
         "File Number": "2017 047405 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 9:00",
         "Status": "Rejected ",
         "Description": "Test folder created for test only ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047405 TS",
         "APN": 46724014,
         "File Number": "2017 047405 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 9:00",
         "Status": "Rejected ",
         "Description": "Test folder created for test only ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047405 TS",
         "APN": 46724015,
         "File Number": "2017 047405 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 9:00",
         "Status": "Rejected ",
         "Description": "Test folder created for test only ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047405 TS",
         "APN": 46724016,
         "File Number": "2017 047405 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 9:00",
         "Status": "Rejected ",
         "Description": "Test folder created for test only ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047405 TS",
         "APN": 46724019,
         "File Number": "2017 047405 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 9:00",
         "Status": "Rejected ",
         "Description": "Test folder created for test only ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047405 TS",
         "APN": 46724020,
         "File Number": "2017 047405 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 9:00",
         "Status": "Rejected ",
         "Description": "Test folder created for test only ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047405 TS",
         "APN": 46724021,
         "File Number": "2017 047405 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 9:00",
         "Status": "Rejected ",
         "Description": "Test folder created for test only ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047405 TS",
         "APN": 46724115,
         "File Number": "2017 047405 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 9:00",
         "Status": "Rejected ",
         "Description": "Test folder created for test only ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047405 TS",
         "APN": 46724117,
         "File Number": "2017 047405 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 9:00",
         "Status": "Rejected ",
         "Description": "Test folder created for test only ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047460 TS",
         "APN": 46723010,
         "File Number": "2017 047460 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 11:29",
         "Status": "Rejected ",
         "Description": "Test only ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047460 TS",
         "APN": 46723011,
         "File Number": "2017 047460 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 11:29",
         "Status": "Rejected ",
         "Description": "Test only ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047460 TS",
         "APN": 46723013,
         "File Number": "2017 047460 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 11:29",
         "Status": "Rejected ",
         "Description": "Test only ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047460 TS",
         "APN": 46723017,
         "File Number": "2017 047460 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 11:29",
         "Status": "Rejected ",
         "Description": "Test only ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047460 TS",
         "APN": 46723018,
         "File Number": "2017 047460 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 11:29",
         "Status": "Rejected ",
         "Description": "Test only ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047460 TS",
         "APN": 46723019,
         "File Number": "2017 047460 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 11:29",
         "Status": "Rejected ",
         "Description": "Test only ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047460 TS",
         "APN": 46723021,
         "File Number": "2017 047460 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 11:29",
         "Status": "Rejected ",
         "Description": "Test only ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047460 TS",
         "APN": 46723022,
         "File Number": "2017 047460 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 11:29",
         "Status": "Rejected ",
         "Description": "Test only ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047460 TS",
         "APN": 46723076,
         "File Number": "2017 047460 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 11:29",
         "Status": "Rejected ",
         "Description": "Test only ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047460 TS",
         "APN": 46724001,
         "File Number": "2017 047460 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 11:29",
         "Status": "Rejected ",
         "Description": "Test only ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047460 TS",
         "APN": 46724002,
         "File Number": "2017 047460 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 11:29",
         "Status": "Rejected ",
         "Description": "Test only ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047460 TS",
         "APN": 46724003,
         "File Number": "2017 047460 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 11:29",
         "Status": "Rejected ",
         "Description": "Test only ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047460 TS",
         "APN": 46724014,
         "File Number": "2017 047460 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 11:29",
         "Status": "Rejected ",
         "Description": "Test only ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047460 TS",
         "APN": 46724015,
         "File Number": "2017 047460 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 11:29",
         "Status": "Rejected ",
         "Description": "Test only ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047460 TS",
         "APN": 46724016,
         "File Number": "2017 047460 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 11:29",
         "Status": "Rejected ",
         "Description": "Test only ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047460 TS",
         "APN": 46724019,
         "File Number": "2017 047460 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 11:29",
         "Status": "Rejected ",
         "Description": "Test only ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047460 TS",
         "APN": 46724020,
         "File Number": "2017 047460 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 11:29",
         "Status": "Rejected ",
         "Description": "Test only ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047460 TS",
         "APN": 46724021,
         "File Number": "2017 047460 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 11:29",
         "Status": "Rejected ",
         "Description": "Test only ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047460 TS",
         "APN": 46724115,
         "File Number": "2017 047460 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 11:29",
         "Status": "Rejected ",
         "Description": "Test only ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047460 TS",
         "APN": 46724117,
         "File Number": "2017 047460 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 11:29",
         "Status": "Rejected ",
         "Description": "Test only ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047462 TS",
         "APN": 46723010,
         "File Number": "2017 047462 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 11:32",
         "Status": "Rejected ",
         "Description": "Test ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047462 TS",
         "APN": 46723011,
         "File Number": "2017 047462 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 11:32",
         "Status": "Rejected ",
         "Description": "Test ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047462 TS",
         "APN": 46723013,
         "File Number": "2017 047462 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 11:32",
         "Status": "Rejected ",
         "Description": "Test ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047462 TS",
         "APN": 46723017,
         "File Number": "2017 047462 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 11:32",
         "Status": "Rejected ",
         "Description": "Test ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047462 TS",
         "APN": 46723018,
         "File Number": "2017 047462 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 11:32",
         "Status": "Rejected ",
         "Description": "Test ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047462 TS",
         "APN": 46723019,
         "File Number": "2017 047462 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 11:32",
         "Status": "Rejected ",
         "Description": "Test ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047462 TS",
         "APN": 46723021,
         "File Number": "2017 047462 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 11:32",
         "Status": "Rejected ",
         "Description": "Test ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047462 TS",
         "APN": 46723022,
         "File Number": "2017 047462 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 11:32",
         "Status": "Rejected ",
         "Description": "Test ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047462 TS",
         "APN": 46723076,
         "File Number": "2017 047462 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 11:32",
         "Status": "Rejected ",
         "Description": "Test ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047462 TS",
         "APN": 46724001,
         "File Number": "2017 047462 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 11:32",
         "Status": "Rejected ",
         "Description": "Test ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047462 TS",
         "APN": 46724002,
         "File Number": "2017 047462 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 11:32",
         "Status": "Rejected ",
         "Description": "Test ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047462 TS",
         "APN": 46724003,
         "File Number": "2017 047462 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 11:32",
         "Status": "Rejected ",
         "Description": "Test ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047462 TS",
         "APN": 46724014,
         "File Number": "2017 047462 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 11:32",
         "Status": "Rejected ",
         "Description": "Test ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047462 TS",
         "APN": 46724015,
         "File Number": "2017 047462 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 11:32",
         "Status": "Rejected ",
         "Description": "Test ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047462 TS",
         "APN": 46724016,
         "File Number": "2017 047462 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 11:32",
         "Status": "Rejected ",
         "Description": "Test ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047462 TS",
         "APN": 46724019,
         "File Number": "2017 047462 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 11:32",
         "Status": "Rejected ",
         "Description": "Test ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047462 TS",
         "APN": 46724020,
         "File Number": "2017 047462 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 11:32",
         "Status": "Rejected ",
         "Description": "Test ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047462 TS",
         "APN": 46724021,
         "File Number": "2017 047462 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 11:32",
         "Status": "Rejected ",
         "Description": "Test ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047462 TS",
         "APN": 46724115,
         "File Number": "2017 047462 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 11:32",
         "Status": "Rejected ",
         "Description": "Test ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "2017 047462 TS",
         "APN": 46724117,
         "File Number": "2017 047462 TS",
         "Address": "200 E SANTA CLARA ST SAN JOSE",
         "Project Name": "200 EAST SANTA CLARA STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "12/15/17 11:32",
         "Status": "Rejected ",
         "Description": "Test ",
         "Planner": "Martina Davis ",
         "DURATION": 1,
         "Year": 2017
      },
      {
         "PERMITID": "TR18-392",
         "APN": 46718041,
         "File Number": "TR18-392",
         "Address": "161 N 9TH ST SAN JOSE",
         "Project Name": "161 NORTH 9TH STREET",
         "Application Type": "Unsuitable Tree ",
         "Application Date": "8/17/18 15:49",
         "Status": "Under Review ",
         "Description": "Unsuitable tree removal permit to allow removal of one Tree of Heaven approximately 60 inches in circumference from the rear yard of a single-family residence lot.",
         "Planner": "Suparna Saha ",
         "DURATION": 0,
         "Year": 2018
      }
   ],
   "Use of EIR ": [
      {
         "PERMITID": "PP03-009",
         "APN": 46723074,
         "File Number": "PP03-009",
         "Address": " ",
         "Project Name": " ",
         "Application Type": "Use of EIR ",
         "Application Date": "1/13/03",
         "Status": "Complete ",
         "Description": "Adoption of a resolution accepting the summary of costs and findings of the Summary 33433 Report and the Estimated Reuse Valuation pursuant to the California Health and Safety Code Section 33433 for the lease of approximately 6,075 gross rentable square f",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "PP03-011",
         "APN": 46746097,
         "File Number": "PP03-011",
         "Address": " ",
         "Project Name": " ",
         "Application Type": "Use of EIR ",
         "Application Date": "1/14/03",
         "Status": "Complete ",
         "Description": "Adoption of a resolution approving a summary 33433 report and lease and related documents between the City of San Jose, the San Jose Redevelopment Agency, and the Camera Cinemas",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "PP03-022",
         "APN": 25940013,
         "File Number": "PP03-022",
         "Address": " ",
         "Project Name": " ",
         "Application Type": "Use of EIR ",
         "Application Date": "1/17/03",
         "Status": "Complete ",
         "Description": "Adoption of a resolution approving a purchase and sale agreement for $550,000 for the acquisition of property located at 152-154 Post Street (APN: 259-40-013) from Florence Tainaka.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "PP03-024",
         "APN": 26429119,
         "File Number": "PP03-024",
         "Address": " ",
         "Project Name": " ",
         "Application Type": "Use of EIR ",
         "Application Date": "1/21/03",
         "Status": "Complete ",
         "Description": "Adoption of a resolution approving an easement agreement related to the Fox California Theatre, between the Redevelopment Agency and Marylou and Mark Cardosa and James Salata, owners of the property located at 347-349 South First Street.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "PP03-100",
         "APN": 25940043,
         "File Number": "PP03-100",
         "Address": " ",
         "Project Name": " ",
         "Application Type": "Use of EIR ",
         "Application Date": "4/1/03",
         "Status": "Complete ",
         "Description": "Adoption of a resolution approving an Exclusive Negotiations Agreement with CIM California Urban Real Estate Fund, L.P., a Delaware Limited Partnership (CIM Group), for the proposed purchase and development of the former Woolworth Building at 27 South Fir",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "PP03-226",
         "APN": 46722007,
         "File Number": "PP03-226",
         "Address": " ",
         "Project Name": " ",
         "Application Type": "Use of EIR ",
         "Application Date": "7/1/03",
         "Status": "Complete ",
         "Description": "To allow a drinking establishment to have after-midnight use and live entertainment until 2:00 AM daily",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "PP03-228",
         "APN": 46746045,
         "File Number": "PP03-228",
         "Address": " ",
         "Project Name": " ",
         "Application Type": "Use of EIR ",
         "Application Date": "7/1/03",
         "Status": "Complete ",
         "Description": "To allow a drinking establishment to have after-midnight use and live entertainment until 2:00 am daily.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "PP03-247",
         "APN": 25940043,
         "File Number": "PP03-247",
         "Address": " ",
         "Project Name": " ",
         "Application Type": "Use of EIR ",
         "Application Date": "7/28/03",
         "Status": "Complete ",
         "Description": "Adoption of a resolution approving an Exclusive Negotiations Agreement with Black Sea Gallery (BSG) for a 45-day term ending September 26, 2003, for the proposed re-use of the Woolworth Building at 27 South First St. as a retail store specializing in impo",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "PP03-263",
         "APN": 46723074,
         "File Number": "PP03-263",
         "Address": " ",
         "Project Name": " ",
         "Application Type": "Use of EIR ",
         "Application Date": "8/18/03",
         "Status": "Complete ",
         "Description": "Adoption of a resolution (a) Accepting the summary of costs and findings of the Summary 33433 Report and the Estimated Reuse Valuation pursuant to the California Health and Safety Code Section 33433 for the lease of approximately 6,400 square feet at 44 S",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "PP03-279",
         "APN": 46723074,
         "File Number": "PP03-279",
         "Address": " ",
         "Project Name": " ",
         "Application Type": "Use of EIR ",
         "Application Date": "9/4/03",
         "Status": "Complete ",
         "Description": "(1) Resolution accepting the summary of costs and findings of the Summary 33433 Report and the Estimated Reuse Valuation for the lease of approx. 5,050 sq ft of retail space to Lee's Sandwiches. (2) Lease between Lee's Sandwiches and the Redevelopment Ag",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "PP03-280",
         "APN": 46723100,
         "File Number": "PP03-280",
         "Address": "88 S 4TH ST SAN JOSE",
         "Project Name": "88 S 4TH ST",
         "Application Type": "Use of EIR ",
         "Application Date": "9/4/03",
         "Status": "Complete ",
         "Description": "Cooperation agreement authorizing the conveyance of the 4th Street Garage to the City, authorizing the City and the Agency to negotiate a master lease for the retail portion of the garage, and to assign the existing lease to the Agency.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "PP03-280",
         "APN": 46723101,
         "File Number": "PP03-280",
         "Address": "88 S 4TH ST SAN JOSE",
         "Project Name": "88 S 4TH ST",
         "Application Type": "Use of EIR ",
         "Application Date": "9/4/03",
         "Status": "Complete ",
         "Description": "Cooperation agreement authorizing the conveyance of the 4th Street Garage to the City, authorizing the City and the Agency to negotiate a master lease for the retail portion of the garage, and to assign the existing lease to the Agency.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "PP03-342",
         "APN": 46723100,
         "File Number": "PP03-342",
         "Address": "88 S 4TH ST SAN JOSE",
         "Project Name": "Delave Lease (Taqueria Fresca) ",
         "Application Type": "Use of EIR ",
         "Application Date": "10/15/03",
         "Status": "Complete ",
         "Description": "Acceptance of the summary of costs and findings of the Summary 33433 Report and Reuse appraisal and approval of a lease with the Delave, Inc (operator of Taqueria Fresca)",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "PP03-342",
         "APN": 46723101,
         "File Number": "PP03-342",
         "Address": "88 S 4TH ST SAN JOSE",
         "Project Name": "Delave Lease (Taqueria Fresca) ",
         "Application Type": "Use of EIR ",
         "Application Date": "10/15/03",
         "Status": "Complete ",
         "Description": "Acceptance of the summary of costs and findings of the Summary 33433 Report and Reuse appraisal and approval of a lease with the Delave, Inc (operator of Taqueria Fresca)",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2003
      },
      {
         "PERMITID": "PP04-059",
         "APN": 25935056,
         "File Number": "PP04-059",
         "Address": " ",
         "Project Name": "DDA for the Storm Property ",
         "Application Type": "Use of EIR ",
         "Application Date": "2/27/04",
         "Status": "Complete ",
         "Description": "A Disposition and Development Agreement between the City of San Jose Redevelopment Agency and Peralta San Pedro, LLC, for the development, ownership, and management of a lease to a restaurant tenant, and acceptance of the 33433 Summary Report.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2004
      },
      {
         "PERMITID": "PP04-143",
         "APN": 25940064,
         "File Number": "PP04-143",
         "Address": "15 W SAN FERNANDO ST Bldg B SAN JOSE",
         "Project Name": "Cresent Site ENA ",
         "Application Type": "Use of EIR ",
         "Application Date": "4/29/04",
         "Status": "Complete ",
         "Description": "Adoption of a resolution approving an Exclusive Negotiations Agreement with Wilcox Block LLC for a 90-day term, for the proposed sale of the Cresent site and its subsequent rehabilitation as retail, office and restaurant space.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2004
      },
      {
         "PERMITID": "PP04-206",
         "APN": 46722121,
         "File Number": "PP04-206",
         "Address": " ",
         "Project Name": "Fountain Alley Parking Lot OPA ",
         "Application Type": "Use of EIR ",
         "Application Date": "6/17/04",
         "Status": "Complete ",
         "Description": "Exclusive negotiation and operating agreement for the development of a mixed use project consisting of retail, parking and commercial space. ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2004
      },
      {
         "PERMITID": "PP04-208",
         "APN": 46721045,
         "File Number": "PP04-208",
         "Address": " ",
         "Project Name": "35-43 East Santa Clara St. OPA",
         "Application Type": "Use of EIR ",
         "Application Date": "6/17/04",
         "Status": "Complete ",
         "Description": "Owner participation agreement for the rehabilitation of the existing buildings located at 35-43 East Santa Clara St, as permitted in File No. RCP03-032, and consistent with the Dept. of Interior Standards.",
         "Planner": " ",
         "DURATION": 0,
         "Year": 2004
      },
      {
         "PERMITID": "PP99-012",
         "APN": 25936069,
         "File Number": "PP99-012",
         "Address": " ",
         "Project Name": " ",
         "Application Type": "Use of EIR ",
         "Application Date": "1/13/99",
         "Status": "Complete ",
         "Description": "construction of 4 tennis courts and a 62 space parking lot",
         "Planner": " ",
         "DURATION": 0,
         "Year": 1999
      },
      {
         "PERMITID": "PP99-021",
         "APN": 25944082,
         "File Number": "PP99-021",
         "Address": " ",
         "Project Name": " ",
         "Application Type": "Use of EIR ",
         "Application Date": "1/26/99",
         "Status": "Complete ",
         "Description": "McEnery Park site improvements ",
         "Planner": " ",
         "DURATION": 0,
         "Year": 1999
      }
   ]
}